/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.12.7.0 (NJsonSchema v9.10.6.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsTenantAvailable(response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>Observable.throw(response_);
        });
    }

    protected processIsTenantAvailable(response: Response): Observable<IsTenantAvailableOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    register(input: RegisterInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegister(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegister(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegister(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendPasswordResetCode(input: SendPasswordResetCodeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendPasswordResetCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendPasswordResetCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendForgotPasswordCode(input: SendForgotPasswordResetCodeInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendForgotPasswordCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendForgotPasswordCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendForgotPasswordCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processSendForgotPasswordCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetPassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetPassword(response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>Observable.throw(response_);
        });
    }

    protected processResetPassword(response: Response): Observable<ResetPasswordOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResetPasswordOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailActivationLink(input: SendEmailActivationLinkInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailActivationLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailActivationLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activateEmail(input: ActivateEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processActivateEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processActivateEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivateEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    impersonate(input: ImpersonateInput): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonate(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processImpersonate(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBackToImpersonator(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processBackToImpersonator(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    switchToLinkedAccount(input: SwitchToLinkedAccountInput): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwitchToLinkedAccount(response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(response_);
        });
    }

    protected processSwitchToLinkedAccount(response: Response): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchToLinkedAccountOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerUserPP(input: RegisterUserPPInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterUserPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterUserPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterUserPP(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterUserPP(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerMember(input: RegisterMemberInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterMember(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterMember(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerCustomer(input: RegisterCustomerInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterCustomer(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterCustomer(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }
}

@Injectable()
export class ActiveDirectoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @usernameOrEmail (optional) 
     * @return Success
     */
    searchUserAD(usernameOrEmail: string): Observable<UserListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ActiveDirectory/SearchUserAD?";
        if (usernameOrEmail !== undefined)
            url_ += "usernameOrEmail=" + encodeURIComponent("" + usernameOrEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSearchUserAD(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSearchUserAD(response_);
                } catch (e) {
                    return <Observable<UserListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UserListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSearchUserAD(response: Response): Observable<UserListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UserListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UserListDto[]>(<any>null);
    }

    /**
     * @usernameOrEmail (optional) 
     * @return Success
     */
    checkUserAD(usernameOrEmail: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActiveDirectory/CheckUserAD?";
        if (usernameOrEmail !== undefined)
            url_ += "usernameOrEmail=" + encodeURIComponent("" + usernameOrEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckUserAD(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckUserAD(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckUserAD(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @usernameOrEmail (optional) 
     * @password (optional) 
     * @return Success
     */
    loginAD(usernameOrEmail: string, password: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActiveDirectory/LoginAD?";
        if (usernameOrEmail !== undefined)
            url_ += "usernameOrEmail=" + encodeURIComponent("" + usernameOrEmail) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLoginAD(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLoginAD(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processLoginAD(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    loginADServices(input: LoginADInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActiveDirectory/LoginADServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLoginADServices(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLoginADServices(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processLoginADServices(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class ADConfigurationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @appName (optional) 
     * @return Success
     */
    getListUserManual(appName: string): Observable<GetListUserManualResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ADConfiguration/GetListUserManual?";
        if (appName !== undefined)
            url_ += "appName=" + encodeURIComponent("" + appName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUserManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUserManual(response_);
                } catch (e) {
                    return <Observable<GetListUserManualResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListUserManualResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListUserManual(response: Response): Observable<GetListUserManualResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListUserManualResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListUserManualResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createADAuth(input: CreateADAuthDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ADConfiguration/CreateADAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateADAuth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateADAuth(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateADAuth(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAdAuth(input: CreateADAuthDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ADConfiguration/UpdateAdAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAdAuth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAdAuth(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAdAuth(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTasklistADAuth(): Observable<GetADAuthListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ADConfiguration/GetTasklistADAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistADAuth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistADAuth(response_);
                } catch (e) {
                    return <Observable<GetADAuthListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetADAuthListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistADAuth(response: Response): Observable<GetADAuthListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetADAuthListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetADAuthListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    testConnection(input: CreateADAuthDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ADConfiguration/TestConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestConnection(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestConnection(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processTestConnection(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class AdminServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getVersionSalesApps(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetVersionSalesApps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVersionSalesApps(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVersionSalesApps(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetVersionSalesApps(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getVersionSalesAppsIOS(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetVersionSalesAppsIOS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVersionSalesAppsIOS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVersionSalesAppsIOS(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetVersionSalesAppsIOS(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListAllProject(): Observable<ListResultDtoOfGetListAllProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetListAllProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListAllProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListAllProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllProject(response: Response): Observable<ListResultDtoOfGetListAllProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListAllProjectResultDto.fromJS(resultData200) : new ListResultDtoOfGetListAllProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListAllProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    createTowerOnDropdownChange(projectId: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateTowerOnDropdownChange?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTowerOnDropdownChange(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTowerOnDropdownChange(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateTowerOnDropdownChange(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateProjectInfo(input: CreateOrUpdateManageProjInfoDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateOrUpdateProjectInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProjectInfo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProjectInfo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getProjectInformationDetail(projectId: number): Observable<GetProjectInformationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetProjectInformationDetail?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectInformationDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectInformationDetail(response_);
                } catch (e) {
                    return <Observable<GetProjectInformationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectInformationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectInformationDetail(response: Response): Observable<GetProjectInformationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProjectInformationResultDto.fromJS(resultData200) : new GetProjectInformationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectInformationResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListTower(projectInfoID: number): Observable<ListResultDtoOfGetDetailTowerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetListTower?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTower(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDetailTowerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDetailTowerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListTower(response: Response): Observable<ListResultDtoOfGetDetailTowerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDetailTowerResultDto.fromJS(resultData200) : new ListResultDtoOfGetDetailTowerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDetailTowerResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTowerDetailEdit(id: number): Observable<GetTowerDetailEditResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetTowerDetailEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTowerDetailEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTowerDetailEdit(response_);
                } catch (e) {
                    return <Observable<GetTowerDetailEditResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTowerDetailEditResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTowerDetailEdit(response: Response): Observable<GetTowerDetailEditResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTowerDetailEditResultDto.fromJS(resultData200) : new GetTowerDetailEditResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTowerDetailEditResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTowerDetailAsync(input: UpdateTowerDetailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateTowerDetailAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTowerDetailAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTowerDetailAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTowerDetailAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createKeyFeature(input: CreateKeyFeatureInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateKeyFeature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateKeyFeature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateKeyFeature(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateKeyFeature(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getKeyFeatures(projectInfoID: number): Observable<ListResultDtoOfGetKeyFeaturesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetKeyFeatures?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKeyFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKeyFeatures(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetKeyFeaturesResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetKeyFeaturesResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKeyFeatures(response: Response): Observable<ListResultDtoOfGetKeyFeaturesResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetKeyFeaturesResultDto.fromJS(resultData200) : new ListResultDtoOfGetKeyFeaturesResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetKeyFeaturesResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editKeyFeature(keyFeatureId: number): Observable<EditKeyFeatureResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/EditKeyFeature?";
        if (keyFeatureId === undefined || keyFeatureId === null)
            throw new Error("The parameter 'keyFeatureId' must be defined and cannot be null.");
        else
            url_ += "keyFeatureId=" + encodeURIComponent("" + keyFeatureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditKeyFeature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditKeyFeature(response_);
                } catch (e) {
                    return <Observable<EditKeyFeatureResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditKeyFeatureResultDto>><any>Observable.throw(response_);
        });
    }

    protected processEditKeyFeature(response: Response): Observable<EditKeyFeatureResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditKeyFeatureResultDto.fromJS(resultData200) : new EditKeyFeatureResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditKeyFeatureResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateKeyFeatures(input: UpdateKeyFeaturesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateKeyFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateKeyFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateKeyFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateKeyFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSocialMediaProject(input: CreateOrUpdateSocialMediaProjectInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateOrUpdateSocialMediaProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSocialMediaProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSocialMediaProject(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSocialMediaProject(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListSocialMediaProject(projectInfoID: number): Observable<ListResultDtoOfGetListSocialMediaProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetListSocialMediaProject?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSocialMediaProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSocialMediaProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListSocialMediaProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListSocialMediaProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListSocialMediaProject(response: Response): Observable<ListResultDtoOfGetListSocialMediaProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListSocialMediaProjectResultDto.fromJS(resultData200) : new ListResultDtoOfGetListSocialMediaProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListSocialMediaProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSocialMediaProject(projectId: number, sosmedId: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteSocialMediaProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (sosmedId === undefined || sosmedId === null)
            throw new Error("The parameter 'sosmedId' must be defined and cannot be null.");
        else
            url_ += "sosmedId=" + encodeURIComponent("" + sosmedId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSocialMediaProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSocialMediaProject(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSocialMediaProject(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createProjectLocation(input: CreateProjectLocationInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateProjectLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateProjectLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateProjectLocation(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateProjectLocation(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProjectLocation(projectId: number): Observable<GetDetailProjectLocationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetDetailProjectLocation?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProjectLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProjectLocation(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectLocationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectLocationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProjectLocation(response: Response): Observable<GetDetailProjectLocationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectLocationResultDto.fromJS(resultData200) : new GetDetailProjectLocationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectLocationResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDetailProjectLocation(input: UpdateDetailProjectLocationInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateDetailProjectLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDetailProjectLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDetailProjectLocation(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDetailProjectLocation(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSitePlan(projectId: number): Observable<GetDetailSitePlanResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetDetailSitePlan?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSitePlan(response_);
                } catch (e) {
                    return <Observable<GetDetailSitePlanResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailSitePlanResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSitePlan(response: Response): Observable<GetDetailSitePlanResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailSitePlanResultDto.fromJS(resultData200) : new GetDetailSitePlanResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailSitePlanResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSitePlan(input: CreateOrUpdateDetailSitePlanInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateOrUpdateSitePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSitePlan(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSitePlan(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getGalleryProjectList(projectInfoID: number): Observable<ListResultDtoOfGetListProjectGalleryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetGalleryProjectList?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGalleryProjectList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGalleryProjectList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListProjectGalleryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListProjectGalleryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGalleryProjectList(response: Response): Observable<ListResultDtoOfGetListProjectGalleryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListProjectGalleryResultDto.fromJS(resultData200) : new ListResultDtoOfGetListProjectGalleryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListProjectGalleryResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProjectImage(id: number): Observable<GetDetailProjectImageResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetDetailProjectImage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProjectImage(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectImageResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectImageResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProjectImage(response: Response): Observable<GetDetailProjectImageResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectImageResultDto.fromJS(resultData200) : new GetDetailProjectImageResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectImageResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProjectImage(input: UpdateProjectImageInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateProjectImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProjectImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProjectImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteProjectImage(id: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteProjectImage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProjectImage(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProjectImage(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSosialMedia(input: AddSocialMediaInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateSosialMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSosialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSosialMedia(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSosialMedia(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSosialMedia(input: UpdateSocialMediaInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateSosialMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSosialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSosialMedia(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSosialMedia(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSosialMedia(socialMediaID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteSosialMedia?";
        if (socialMediaID === undefined || socialMediaID === null)
            throw new Error("The parameter 'socialMediaID' must be defined and cannot be null.");
        else
            url_ += "socialMediaID=" + encodeURIComponent("" + socialMediaID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSosialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSosialMedia(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSosialMedia(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getAllListSocialMedia(): Observable<ListResultDtoOfGetListSocialMediaResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetAllListSocialMedia";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllListSocialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllListSocialMedia(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListSocialMediaResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListSocialMediaResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllListSocialMedia(response: Response): Observable<ListResultDtoOfGetListSocialMediaResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListSocialMediaResultDto.fromJS(resultData200) : new ListResultDtoOfGetListSocialMediaResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListSocialMediaResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListSocialMedia(): Observable<ListResultDtoOfGetListSocialMediaResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetListSocialMedia";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSocialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSocialMedia(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListSocialMediaResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListSocialMediaResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListSocialMedia(response: Response): Observable<ListResultDtoOfGetListSocialMediaResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListSocialMediaResultDto.fromJS(resultData200) : new ListResultDtoOfGetListSocialMediaResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListSocialMediaResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editSocialMedia(id: number): Observable<EditSocialMediaResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/EditSocialMedia?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditSocialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditSocialMedia(response_);
                } catch (e) {
                    return <Observable<EditSocialMediaResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditSocialMediaResultDto>><any>Observable.throw(response_);
        });
    }

    protected processEditSocialMedia(response: Response): Observable<EditSocialMediaResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditSocialMediaResultDto.fromJS(resultData200) : new EditSocialMediaResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditSocialMediaResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSocialMedia(input: UpdateSocialMediaInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateSocialMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSocialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSocialMedia(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSocialMedia(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSocialMedia(id: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteSocialMedia?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSocialMedia(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSocialMedia(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSocialMedia(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListImageMainPage(projectId: number): Observable<ListResultDtoOfGetListMainPageImagesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetListImageMainPage?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListImageMainPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListImageMainPage(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListMainPageImagesResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListMainPageImagesResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListImageMainPage(response: Response): Observable<ListResultDtoOfGetListMainPageImagesResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListMainPageImagesResultDto.fromJS(resultData200) : new ListResultDtoOfGetListMainPageImagesResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListMainPageImagesResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMainPage(input: CreateMainPageDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateMainPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMainPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMainPage(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateMainPage(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMainPage(input: UpdateMainPageDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateMainPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMainPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMainPage(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMainPage(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMainPage(mainPageId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteMainPage?";
        if (mainPageId === undefined || mainPageId === null)
            throw new Error("The parameter 'mainPageId' must be defined and cannot be null.");
        else
            url_ += "MainPageId=" + encodeURIComponent("" + mainPageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMainPage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMainPage(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMainPage(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createManageProject(input: CreateManageProjectDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateManageProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateManageProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateManageProject(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCreateManageProject(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getManageProjectList(): Observable<GetManageProjectListResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetManageProjectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetManageProjectList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetManageProjectList(response_);
                } catch (e) {
                    return <Observable<GetManageProjectListResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetManageProjectListResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetManageProjectList(response: Response): Observable<GetManageProjectListResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetManageProjectListResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetManageProjectListResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProject(manageProjectId: number): Observable<GetDetailProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Admin/GetDetailProject?";
        if (manageProjectId === undefined || manageProjectId === null)
            throw new Error("The parameter 'manageProjectId' must be defined and cannot be null.");
        else
            url_ += "manageProjectId=" + encodeURIComponent("" + manageProjectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProject(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProject(response: Response): Observable<GetDetailProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectResultDto.fromJS(resultData200) : new GetDetailProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateManageProject(input: UpdateManageProjectInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateManageProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateManageProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateManageProject(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateManageProject(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateImageGallery(input: UpdateImageGalleryInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/UpdateImageGallery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateImageGallery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateImageGallery(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateImageGallery(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createGalery(input: CreateGalleryInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Admin/CreateGalery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateGalery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateGalery(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateGalery(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteImageGallery(galleryID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Admin/DeleteImageGallery?";
        if (galleryID === undefined || galleryID === null)
            throw new Error("The parameter 'galleryID' must be defined and cannot be null.");
        else
            url_ += "galleryID=" + encodeURIComponent("" + galleryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteImageGallery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteImageGallery(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processDeleteImageGallery(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class AdminManageProjectServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProjectCodeList(): Observable<ListResultDtoOfGetProjectCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetProjectCodeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectCodeList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectCodeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectCodeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectCodeList(response: Response): Observable<ListResultDtoOfGetProjectCodeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectCodeListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectCodeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectCodeListDto>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getProjectInfo(projectCode: string): Observable<GetProjectInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetProjectInfo?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetProjectInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectInfo(response: Response): Observable<GetProjectInfoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProjectInfoDto.fromJS(resultData200) : new GetProjectInfoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectInfoDto>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getProjectKeyFeatures(projectCode: string): Observable<ListResultDtoOfGetKeyFeaturesListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetProjectKeyFeatures?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectKeyFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectKeyFeatures(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetKeyFeaturesListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetKeyFeaturesListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectKeyFeatures(response: Response): Observable<ListResultDtoOfGetKeyFeaturesListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetKeyFeaturesListResultDto.fromJS(resultData200) : new ListResultDtoOfGetKeyFeaturesListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetKeyFeaturesListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailManageProject(projectInfoID: number): Observable<GetListManageProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetDetailManageProject?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailManageProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailManageProject(response_);
                } catch (e) {
                    return <Observable<GetListManageProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListManageProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailManageProject(response: Response): Observable<GetListManageProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListManageProjectResultDto.fromJS(resultData200) : new GetListManageProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListManageProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProductSitePlan(projectInfoID: number): Observable<GetListManageProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetDetailProductSitePlan?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProductSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProductSitePlan(response_);
                } catch (e) {
                    return <Observable<GetListManageProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListManageProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProductSitePlan(response: Response): Observable<GetListManageProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListManageProjectResultDto.fromJS(resultData200) : new GetListManageProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListManageProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProjectLocationResult(projectId: number): Observable<GetDetailProjectLocationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetDetailProjectLocationResult?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProjectLocationResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProjectLocationResult(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectLocationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectLocationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProjectLocationResult(response: Response): Observable<GetDetailProjectLocationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectLocationResultDto.fromJS(resultData200) : new GetDetailProjectLocationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectLocationResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getClusterListResult(projectId: number): Observable<ListResultDtoOfGetClusterListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetClusterListResult?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterListResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterListResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterListResult(response: Response): Observable<ListResultDtoOfGetClusterListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterListResultDto.fromJS(resultData200) : new ListResultDtoOfGetClusterListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCluster(projectId: number, projectInfoID: number): Observable<ListResultDtoOfGetClusterListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetAllCluster?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCluster(response: Response): Observable<ListResultDtoOfGetClusterListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterListResultDto.fromJS(resultData200) : new ListResultDtoOfGetClusterListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListAllCluster(projectId: number): Observable<ListResultDtoOfGetClusterListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetListAllCluster?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllCluster(response: Response): Observable<ListResultDtoOfGetClusterListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterListResultDto.fromJS(resultData200) : new ListResultDtoOfGetClusterListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProjectClusterList(projectId: number): Observable<ListResultDtoOfGetProjectClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageProject/GetProjectClusterList?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectClusterList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectClusterList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectClusterList(response: Response): Observable<ListResultDtoOfGetProjectClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectClusterListDto>(<any>null);
    }
}

@Injectable()
export class AdminManageUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDropdownProduct(userID: number): Observable<GetDropdownProductResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/GetDropdownProduct?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProduct(response_);
                } catch (e) {
                    return <Observable<GetDropdownProductResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProductResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProduct(response: Response): Observable<GetDropdownProductResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProductResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProductResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProject(projectID: number): Observable<GetProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/GetDetailProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProject(response_);
                } catch (e) {
                    return <Observable<GetProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProject(response: Response): Observable<GetProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProjectResultDto.fromJS(resultData200) : new GetProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownCluster(projectID: number, productID: number): Observable<GetDropdownClusterResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/GetDropdownCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (productID === undefined || productID === null)
            throw new Error("The parameter 'productID' must be defined and cannot be null.");
        else
            url_ += "productID=" + encodeURIComponent("" + productID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCluster(response_);
                } catch (e) {
                    return <Observable<GetDropdownClusterResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownClusterResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCluster(response: Response): Observable<GetDropdownClusterResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownClusterResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownClusterResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTypeManageUnit(projectID: number, clusterID: number, productID: number): Observable<GetTypeManageUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/GetTypeManageUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (productID === undefined || productID === null)
            throw new Error("The parameter 'productID' must be defined and cannot be null.");
        else
            url_ += "productID=" + encodeURIComponent("" + productID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTypeManageUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTypeManageUnit(response_);
                } catch (e) {
                    return <Observable<GetTypeManageUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTypeManageUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTypeManageUnit(response: Response): Observable<GetTypeManageUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTypeManageUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTypeManageUnitResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDiagramaticManageUnit(projectID: number, clusterID: number, productID: number): Observable<GetDiagramaticManageUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/GetDiagramaticManageUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (productID === undefined || productID === null)
            throw new Error("The parameter 'productID' must be defined and cannot be null.");
        else
            url_ += "productID=" + encodeURIComponent("" + productID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiagramaticManageUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiagramaticManageUnit(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticManageUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticManageUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiagramaticManageUnit(response: Response): Observable<GetDiagramaticManageUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticManageUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticManageUnitResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    manageShowUnit(input: ManageShowUnitInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/ManageShowUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processManageShowUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processManageShowUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processManageShowUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleSendEmailListProjectUnit(): Observable<GetListProjectUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/ScheduleSendEmailListProjectUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processScheduleSendEmailListProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processScheduleSendEmailListProjectUnit(response_);
                } catch (e) {
                    return <Observable<GetListProjectUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processScheduleSendEmailListProjectUnit(response: Response): Observable<GetListProjectUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectUnitResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailListProjectUnit(input: GetListProjectUnitResultDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/SendEmailListProjectUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailListProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailListProjectUnit(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailListProjectUnit(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleSendEmailDetailProjectUnit(): Observable<GetDetailProjectUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/ScheduleSendEmailDetailProjectUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processScheduleSendEmailDetailProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processScheduleSendEmailDetailProjectUnit(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processScheduleSendEmailDetailProjectUnit(response: Response): Observable<GetDetailProjectUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailProjectUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectUnitResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailDetailProjectUnit(input: GetDetailProjectUnitResultDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminManageUnit/SendEmailDetailProjectUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailDetailProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailDetailProjectUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailDetailProjectUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class AdminNewProjectServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateProject(input: CreateOrUpdateProjectInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProject(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProject(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @projectLogo (optional) 
     * @locationImage (optional) 
     * @sitePlanImage (optional) 
     * @galleryImage (optional) 
     * @return Success
     */
    getBackImageProjectInfo(projectLogo: string, locationImage: string, sitePlanImage: string, galleryImage: string): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetBackImageProjectInfo?";
        if (projectLogo !== undefined)
            url_ += "projectLogo=" + encodeURIComponent("" + projectLogo) + "&"; 
        if (locationImage !== undefined)
            url_ += "locationImage=" + encodeURIComponent("" + locationImage) + "&"; 
        if (sitePlanImage !== undefined)
            url_ += "sitePlanImage=" + encodeURIComponent("" + sitePlanImage) + "&"; 
        if (galleryImage !== undefined)
            url_ += "galleryImage=" + encodeURIComponent("" + galleryImage) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBackImageProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBackImageProjectInfo(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBackImageProjectInfo(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateProjectInfoUniversal(input: CreateUpdateProjectInfoUniversalInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateUpdateProjectInfoUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateProjectInfoUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateProjectInfoUniversal(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateProjectInfoUniversal(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @keyFeature (optional) 
     * @id (optional) 
     * @return Success
     */
    createKeyFeature(keyFeature: string, keyFetCollectID: number, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateKeyFeature?";
        if (keyFeature !== undefined)
            url_ += "keyFeature=" + encodeURIComponent("" + keyFeature) + "&"; 
        if (keyFetCollectID === undefined || keyFetCollectID === null)
            throw new Error("The parameter 'keyFetCollectID' must be defined and cannot be null.");
        else
            url_ += "keyFetCollectID=" + encodeURIComponent("" + keyFetCollectID) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateKeyFeature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateKeyFeature(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateKeyFeature(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertProjectOLBooking(input: InsertProjectOLBookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/InsertProjectOLBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertProjectOLBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertProjectOLBooking(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertProjectOLBooking(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    insertProjectCluster(clusterID: number, projectInfoID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/InsertProjectCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertProjectCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertProjectCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertProjectCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @projectDesc (optional) 
     * @logo (optional) 
     * @return Success
     */
    updateProjectInfoProjectOL(clusterID: number, projectInfoID: number, projectDesc: string, logo: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/UpdateProjectInfoProjectOL?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (projectDesc !== undefined)
            url_ += "projectDesc=" + encodeURIComponent("" + projectDesc) + "&"; 
        if (logo !== undefined)
            url_ += "logo=" + encodeURIComponent("" + logo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProjectInfoProjectOL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProjectInfoProjectOL(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProjectInfoProjectOL(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertProjectLocation(input: InsertProjectLocationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/InsertProjectLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertProjectLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertProjectLocation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertProjectLocation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateProjectByProjectInfoId(input: CreateOrUpdateProjectInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateProjectByProjectInfoId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProjectByProjectInfoId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProjectByProjectInfoId(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProjectByProjectInfoId(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @url (optional) 
     * @imgStatus (optional) 
     * @return Success
     */
    createOrUpdateProjectLogoImage(olBookingId: number, url: string, imgStatus: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateProjectLogoImage?";
        if (olBookingId === undefined || olBookingId === null)
            throw new Error("The parameter 'olBookingId' must be defined and cannot be null.");
        else
            url_ += "olBookingId=" + encodeURIComponent("" + olBookingId) + "&"; 
        if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        if (imgStatus !== undefined)
            url_ += "imgStatus=" + encodeURIComponent("" + imgStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProjectLogoImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProjectLogoImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProjectLogoImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @imgLogo (optional) 
     * @imgStatus (optional) 
     * @return Success
     */
    createOrUpdateProjectLocationImage(projecLocId: number, imgLogo: string, imgStatus: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateProjectLocationImage?";
        if (projecLocId === undefined || projecLocId === null)
            throw new Error("The parameter 'projecLocId' must be defined and cannot be null.");
        else
            url_ += "projecLocId=" + encodeURIComponent("" + projecLocId) + "&"; 
        if (imgLogo !== undefined)
            url_ += "imgLogo=" + encodeURIComponent("" + imgLogo) + "&"; 
        if (imgStatus !== undefined)
            url_ += "imgStatus=" + encodeURIComponent("" + imgStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProjectLocationImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProjectLocationImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProjectLocationImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @imgLogo (optional) 
     * @imgStatus (optional) 
     * @return Success
     */
    createOrUpdateSiteplanImg(projectInfoId: number, imgLogo: string, imgStatus: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateSiteplanImg?";
        if (projectInfoId === undefined || projectInfoId === null)
            throw new Error("The parameter 'projectInfoId' must be defined and cannot be null.");
        else
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        if (imgLogo !== undefined)
            url_ += "imgLogo=" + encodeURIComponent("" + imgLogo) + "&"; 
        if (imgStatus !== undefined)
            url_ += "imgStatus=" + encodeURIComponent("" + imgStatus) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSiteplanImg(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSiteplanImg(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSiteplanImg(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getKeyFeaturesByProjectCode(projectCode: string): Observable<ListResultDtoOfGetKeyFeaturesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetKeyFeaturesByProjectCode?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKeyFeaturesByProjectCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKeyFeaturesByProjectCode(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetKeyFeaturesResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetKeyFeaturesResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKeyFeaturesByProjectCode(response: Response): Observable<ListResultDtoOfGetKeyFeaturesResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetKeyFeaturesResultDto.fromJS(resultData200) : new ListResultDtoOfGetKeyFeaturesResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetKeyFeaturesResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editKeyFeature(keyFeatureId: number): Observable<EditKeyFeatureResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/EditKeyFeature?";
        if (keyFeatureId === undefined || keyFeatureId === null)
            throw new Error("The parameter 'keyFeatureId' must be defined and cannot be null.");
        else
            url_ += "keyFeatureId=" + encodeURIComponent("" + keyFeatureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditKeyFeature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditKeyFeature(response_);
                } catch (e) {
                    return <Observable<EditKeyFeatureResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditKeyFeatureResultDto>><any>Observable.throw(response_);
        });
    }

    protected processEditKeyFeature(response: Response): Observable<EditKeyFeatureResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditKeyFeatureResultDto.fromJS(resultData200) : new EditKeyFeatureResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditKeyFeatureResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateKeyFeatures(input: UpdateKeyFeaturesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/UpdateKeyFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateKeyFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateKeyFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateKeyFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getListSocialMediaProject(projectId: number): Observable<ListResultDtoOfGetListSocialMediaProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetListSocialMediaProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSocialMediaProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSocialMediaProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListSocialMediaProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListSocialMediaProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListSocialMediaProject(response: Response): Observable<ListResultDtoOfGetListSocialMediaProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListSocialMediaProjectResultDto.fromJS(resultData200) : new ListResultDtoOfGetListSocialMediaProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListSocialMediaProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSocialMediaProject(projectId: number, sosmedId: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/DeleteSocialMediaProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (sosmedId === undefined || sosmedId === null)
            throw new Error("The parameter 'sosmedId' must be defined and cannot be null.");
        else
            url_ += "sosmedId=" + encodeURIComponent("" + sosmedId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSocialMediaProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSocialMediaProject(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSocialMediaProject(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getGalleryProjectList(projectId: number): Observable<ListResultDtoOfGetListProjectGalleryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetGalleryProjectList?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGalleryProjectList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGalleryProjectList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListProjectGalleryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListProjectGalleryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGalleryProjectList(response: Response): Observable<ListResultDtoOfGetListProjectGalleryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListProjectGalleryResultDto.fromJS(resultData200) : new ListResultDtoOfGetListProjectGalleryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListProjectGalleryResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProjectImage(id: number): Observable<GetDetailProjectImageResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetDetailProjectImage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProjectImage(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectImageResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectImageResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProjectImage(response: Response): Observable<GetDetailProjectImageResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectImageResultDto.fromJS(resultData200) : new GetDetailProjectImageResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectImageResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProjectImage(input: UpdateProjectImageInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/UpdateProjectImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProjectImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProjectImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteProjectImage(id: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/DeleteProjectImage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProjectImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProjectImage(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProjectImage(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListUnitType(projectId: number): Observable<ListResultDtoOfGetListUnitTypeResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/GetListUnitType?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListUnitTypeResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListUnitTypeResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitType(response: Response): Observable<ListResultDtoOfGetListUnitTypeResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListUnitTypeResultDto.fromJS(resultData200) : new ListResultDtoOfGetListUnitTypeResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListUnitTypeResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUnitType(input: UpdateUnitTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/UpdateUnitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUnitType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUnitType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateProjectInfo(input: CreateProjectInfoInputDto): Observable<CreateOrUpdateProjectInfoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateOrUpdateProjectInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateProjectInfo(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateProjectInfoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateProjectInfoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateProjectInfo(response: Response): Observable<CreateOrUpdateProjectInfoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateProjectInfoResultDto.fromJS(resultData200) : new CreateOrUpdateProjectInfoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateProjectInfoResultDto>(<any>null);
    }

    /**
     * @img (optional) 
     * @return Success
     */
    moveProjectInfoLogo(img: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/MoveProjectInfoLogo?";
        if (img !== undefined)
            url_ += "img=" + encodeURIComponent("" + img) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveProjectInfoLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveProjectInfoLogo(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveProjectInfoLogo(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createProductPPOnline(input: CreateProductPPOnlineInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/CreateProductPPOnline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateProductPPOnline(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateProductPPOnline(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateProductPPOnline(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSetupProjectProductPPInput(input: UpdateSetupProjectProductPPInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/AdminNewProject/UpdateSetupProjectProductPPInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSetupProjectProductPPInput(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSetupProjectProductPPInput(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSetupProjectProductPPInput(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class AdminProductSetupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListProjectResult(): Observable<ListResultDtoOfGetListProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetup/GetListProjectResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListProjectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListProjectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectResult(response: Response): Observable<ListResultDtoOfGetListProjectDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListProjectDto.fromJS(resultData200) : new ListResultDtoOfGetListProjectDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListProjectDto>(<any>null);
    }

    /**
     * @clusterID (optional) 
     * @return Success
     */
    getProductSetupListResult(projectId: number, clusterID: number[]): Observable<ListResultDtoOfGetProductSetupListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetup/GetProductSetupListResult?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductSetupListResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductSetupListResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductSetupListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductSetupListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductSetupListResult(response: Response): Observable<ListResultDtoOfGetProductSetupListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductSetupListResultDto.fromJS(resultData200) : new ListResultDtoOfGetProductSetupListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductSetupListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editTowerClusterResult(clusterId: number): Observable<EditOlBookingResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetup/EditTowerClusterResult?";
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditTowerClusterResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditTowerClusterResult(response_);
                } catch (e) {
                    return <Observable<EditOlBookingResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditOlBookingResultDto>><any>Observable.throw(response_);
        });
    }

    protected processEditTowerClusterResult(response: Response): Observable<EditOlBookingResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditOlBookingResultDto.fromJS(resultData200) : new EditOlBookingResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditOlBookingResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTowerClusterInputAsync(input: UpdateOlBookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetup/UpdateTowerClusterInputAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTowerClusterInputAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTowerClusterInputAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTowerClusterInputAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class AdminProductSetupPPOLServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPPProjectNameListResult(): Observable<ListResultDtoOfGetProjectNameListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetPPProjectNameListResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPProjectNameListResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPProjectNameListResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectNameListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectNameListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPPProjectNameListResult(response: Response): Observable<ListResultDtoOfGetProjectNameListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectNameListResultDto.fromJS(resultData200) : new ListResultDtoOfGetProjectNameListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectNameListResultDto>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getProductNameResult(projectCode: string): Observable<ListResultDtoOfGetProductNameResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetProductNameResult?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductNameResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductNameResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductNameResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductNameResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductNameResult(response: Response): Observable<ListResultDtoOfGetProductNameResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductNameResultDto.fromJS(resultData200) : new ListResultDtoOfGetProductNameResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductNameResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProductPPDetailListResult(projectId: number, productId: number): Observable<ListResultDtoOfGetProductDetailListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetProductPPDetailListResult?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductPPDetailListResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductPPDetailListResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductDetailListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductDetailListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductPPDetailListResult(response: Response): Observable<ListResultDtoOfGetProductDetailListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductDetailListResultDto.fromJS(resultData200) : new ListResultDtoOfGetProductDetailListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductDetailListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editProductPPSetupResult(productId: number): Observable<EditProjectProductResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/EditProductPPSetupResult?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditProductPPSetupResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditProductPPSetupResult(response_);
                } catch (e) {
                    return <Observable<EditProjectProductResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditProjectProductResultDto>><any>Observable.throw(response_);
        });
    }

    protected processEditProductPPSetupResult(response: Response): Observable<EditProjectProductResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditProjectProductResultDto.fromJS(resultData200) : new EditProjectProductResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditProjectProductResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSetupProductPPOnline(projectInfoID: number): Observable<EditProjectProductResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetDetailSetupProductPPOnline?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSetupProductPPOnline(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSetupProductPPOnline(response_);
                } catch (e) {
                    return <Observable<EditProjectProductResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditProjectProductResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSetupProductPPOnline(response: Response): Observable<EditProjectProductResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditProjectProductResultDto.fromJS(resultData200) : new EditProjectProductResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditProjectProductResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteProductPPSetup(productId: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/DeleteProductPPSetup?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteProductPPSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteProductPPSetup(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteProductPPSetup(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSelectedProductProjectClustersResult(productId: number): Observable<ListResultDtoOfGetProductProjectClustersResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetSelectedProductProjectClustersResult?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSelectedProductProjectClustersResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSelectedProductProjectClustersResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductProjectClustersResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductProjectClustersResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSelectedProductProjectClustersResult(response: Response): Observable<ListResultDtoOfGetProductProjectClustersResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductProjectClustersResultDto.fromJS(resultData200) : new ListResultDtoOfGetProductProjectClustersResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductProjectClustersResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPriorityPassPerUnitListResult(productId: number): Observable<ListResultDtoOfGetPriorityPassPerUnitListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetPriorityPassPerUnitListResult?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPriorityPassPerUnitListResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPriorityPassPerUnitListResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPriorityPassPerUnitListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPriorityPassPerUnitListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPriorityPassPerUnitListResult(response: Response): Observable<ListResultDtoOfGetPriorityPassPerUnitListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPriorityPassPerUnitListResultDto.fromJS(resultData200) : new ListResultDtoOfGetPriorityPassPerUnitListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetPriorityPassPerUnitListResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    editPriorityPassUnitType(prefTypeId: number): Observable<EditPriorityPassUnitTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/EditPriorityPassUnitType?";
        if (prefTypeId === undefined || prefTypeId === null)
            throw new Error("The parameter 'prefTypeId' must be defined and cannot be null.");
        else
            url_ += "prefTypeId=" + encodeURIComponent("" + prefTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditPriorityPassUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditPriorityPassUnitType(response_);
                } catch (e) {
                    return <Observable<EditPriorityPassUnitTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditPriorityPassUnitTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processEditPriorityPassUnitType(response: Response): Observable<EditPriorityPassUnitTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditPriorityPassUnitTypeDto.fromJS(resultData200) : new EditPriorityPassUnitTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditPriorityPassUnitTypeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownCategoryType(): Observable<GetCategoryTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminProductSetupPPOL/GetDropdownCategoryType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCategoryType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCategoryType(response_);
                } catch (e) {
                    return <Observable<GetCategoryTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCategoryTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCategoryType(response: Response): Observable<GetCategoryTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCategoryTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCategoryTypeListDto[]>(<any>null);
    }
}

@Injectable()
export class AdminPromoServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListAllPromoResult(): Observable<ListResultDtoOfGetListAllPromoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/GetListAllPromoResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllPromoResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllPromoResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListAllPromoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListAllPromoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllPromoResult(response: Response): Observable<ListResultDtoOfGetListAllPromoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListAllPromoResultDto.fromJS(resultData200) : new ListResultDtoOfGetListAllPromoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListAllPromoResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPromo(input: CreatePromoInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/CreatePromo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromo(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromo(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailPromoResult(promoId: number): Observable<GetDetailPromoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/GetDetailPromoResult?";
        if (promoId === undefined || promoId === null)
            throw new Error("The parameter 'promoId' must be defined and cannot be null.");
        else
            url_ += "promoId=" + encodeURIComponent("" + promoId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPromoResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPromoResult(response_);
                } catch (e) {
                    return <Observable<GetDetailPromoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPromoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPromoResult(response: Response): Observable<GetDetailPromoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPromoResultDto.fromJS(resultData200) : new GetDetailPromoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPromoResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePromo(input: UpdatePromoInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/UpdatePromo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    deletePromo(promoId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/AdminPromo/DeletePromo?";
        if (promoId === undefined || promoId === null)
            throw new Error("The parameter 'promoId' must be defined and cannot be null.");
        else
            url_ += "promoId=" + encodeURIComponent("" + promoId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePromo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePromo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processDeletePromo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class AdminUnitTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListUnitType(projectId: number): Observable<ListResultDtoOfGetListUnitTypeResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminUnitType/GetListUnitType?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListUnitTypeResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListUnitTypeResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitType(response: Response): Observable<ListResultDtoOfGetListUnitTypeResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListUnitTypeResultDto.fromJS(resultData200) : new ListResultDtoOfGetListUnitTypeResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListUnitTypeResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUnitType(input: UpdateUnitTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminUnitType/UpdateUnitType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUnitType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUnitType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ApprovalDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    dropdownApplicationApproval(): Observable<DropdownAplicationApprovalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/DropdownApplicationApproval";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownApplicationApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownApplicationApproval(response_);
                } catch (e) {
                    return <Observable<DropdownAplicationApprovalDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownAplicationApprovalDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownApplicationApproval(response: Response): Observable<DropdownAplicationApprovalDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownAplicationApprovalDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownAplicationApprovalDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPermissionViewApproval(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/GetPermissionViewApproval";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPermissionViewApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPermissionViewApproval(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetPermissionViewApproval(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    tasklistApproval(input: TasklistApprovalFilterDto): Observable<TasklistApprovalResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/TasklistApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTasklistApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTasklistApproval(response_);
                } catch (e) {
                    return <Observable<TasklistApprovalResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TasklistApprovalResultDto>><any>Observable.throw(response_);
        });
    }

    protected processTasklistApproval(response: Response): Observable<TasklistApprovalResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TasklistApprovalResultDto.fromJS(resultData200) : new TasklistApprovalResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TasklistApprovalResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    detailApprovalMainData(approvalID: number): Observable<DetailApprovalMainDataDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/DetailApprovalMainData?";
        if (approvalID === undefined || approvalID === null)
            throw new Error("The parameter 'approvalID' must be defined and cannot be null.");
        else
            url_ += "approvalID=" + encodeURIComponent("" + approvalID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDetailApprovalMainData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDetailApprovalMainData(response_);
                } catch (e) {
                    return <Observable<DetailApprovalMainDataDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailApprovalMainDataDto>><any>Observable.throw(response_);
        });
    }

    protected processDetailApprovalMainData(response: Response): Observable<DetailApprovalMainDataDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailApprovalMainDataDto.fromJS(resultData200) : new DetailApprovalMainDataDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailApprovalMainDataDto>(<any>null);
    }

    /**
     * @return Success
     */
    detailApprovalDocumentData(approvalID: number): Observable<DetailDocumentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/DetailApprovalDocumentData?";
        if (approvalID === undefined || approvalID === null)
            throw new Error("The parameter 'approvalID' must be defined and cannot be null.");
        else
            url_ += "approvalID=" + encodeURIComponent("" + approvalID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDetailApprovalDocumentData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDetailApprovalDocumentData(response_);
                } catch (e) {
                    return <Observable<DetailDocumentResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailDocumentResultDto>><any>Observable.throw(response_);
        });
    }

    protected processDetailApprovalDocumentData(response: Response): Observable<DetailDocumentResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailDocumentResultDto.fromJS(resultData200) : new DetailDocumentResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailDocumentResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    returnRequestApproval(input: ApprovalProsesDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/ReturnRequestApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReturnRequestApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReturnRequestApproval(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processReturnRequestApproval(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    approveRequestApproval(input: ApprovalProsesDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/ApproveRequestApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processApproveRequestApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processApproveRequestApproval(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processApproveRequestApproval(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerAutoApprove(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/SchedulerAutoApprove";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerAutoApprove(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerAutoApprove(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerAutoApprove(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerDRMSExpired(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/SchedulerDRMSExpired";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerDRMSExpired(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerDRMSExpired(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerDRMSExpired(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    rejectRequestApproval(input: ApprovalProsesDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/RejectRequestApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRejectRequestApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRejectRequestApproval(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRejectRequestApproval(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    requestUnitDRMS(input: RequestUnitDrmsInputDto): Observable<DrmsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/RequestUnitDRMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRequestUnitDRMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRequestUnitDRMS(response_);
                } catch (e) {
                    return <Observable<DrmsResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DrmsResultDto>><any>Observable.throw(response_);
        });
    }

    protected processRequestUnitDRMS(response: Response): Observable<DrmsResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DrmsResultDto.fromJS(resultData200) : new DrmsResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DrmsResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    searchUnitDRMSByBookcode(input: DRMSStatusByBookcodeInputDto): Observable<DetailStatusDRMSByBookcodeDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/SearchUnitDRMSByBookcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSearchUnitDRMSByBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSearchUnitDRMSByBookcode(response_);
                } catch (e) {
                    return <Observable<DetailStatusDRMSByBookcodeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailStatusDRMSByBookcodeDto>><any>Observable.throw(response_);
        });
    }

    protected processSearchUnitDRMSByBookcode(response: Response): Observable<DetailStatusDRMSByBookcodeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailStatusDRMSByBookcodeDto.fromJS(resultData200) : new DetailStatusDRMSByBookcodeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailStatusDRMSByBookcodeDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadDocumentDRMS(input: UploadDocDrmsInputDto): Observable<DrmsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/UploadDocumentDRMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadDocumentDRMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadDocumentDRMS(response_);
                } catch (e) {
                    return <Observable<DrmsResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DrmsResultDto>><any>Observable.throw(response_);
        });
    }

    protected processUploadDocumentDRMS(response: Response): Observable<DrmsResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DrmsResultDto.fromJS(resultData200) : new DrmsResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DrmsResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDRMSStatusApproval(input: DRMSStatusApprovalInputDto): Observable<WrapDRMSStatusApprovalDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalDashboard/GetDRMSStatusApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDRMSStatusApproval(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDRMSStatusApproval(response_);
                } catch (e) {
                    return <Observable<WrapDRMSStatusApprovalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<WrapDRMSStatusApprovalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDRMSStatusApproval(response: Response): Observable<WrapDRMSStatusApprovalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WrapDRMSStatusApprovalDto.fromJS(resultData200) : new WrapDRMSStatusApprovalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<WrapDRMSStatusApprovalDto>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogs(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogs(response: Response): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class AutoDebetPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataCheckUploadAutoDebet(input: GetDataCheckUploadAutoDebetInputDto[]): Observable<GetDataCheckUploadAutoDebetListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoDebetPayment/GetDataCheckUploadAutoDebet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCheckUploadAutoDebet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCheckUploadAutoDebet(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadAutoDebetListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadAutoDebetListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCheckUploadAutoDebet(response: Response): Observable<GetDataCheckUploadAutoDebetListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadAutoDebetListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadAutoDebetListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalAutoDebet(input: CreateUniversalAutoDebetInputDto[]): Observable<GetDataCheckUploadAutoDebetListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoDebetPayment/CreateUniversalAutoDebet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalAutoDebet(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalAutoDebet(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadAutoDebetListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadAutoDebetListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalAutoDebet(response: Response): Observable<GetDataCheckUploadAutoDebetListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadAutoDebetListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadAutoDebetListDto[]>(<any>null);
    }
}

@Injectable()
export class BankReconcileServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCheckBoxDisplayedFieldBankReconcile(): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetCheckBoxDisplayedFieldBankReconcile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckBoxDisplayedFieldBankReconcile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckBoxDisplayedFieldBankReconcile(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckBoxDisplayedFieldBankReconcile(response: Response): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListAllocation(): Observable<GetListAllocResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListAllocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllocation(response_);
                } catch (e) {
                    return <Observable<GetListAllocResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListAllocResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllocation(response: Response): Observable<GetListAllocResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListAllocResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListAllocResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListPayType(): Observable<GetListPayTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListPayType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPayType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPayType(response_);
                } catch (e) {
                    return <Observable<GetListPayTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPayTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPayType(response: Response): Observable<GetListPayTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPayTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPayTypeResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListOthersType(): Observable<GetListOthersTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListOthersType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOthersType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOthersType(response_);
                } catch (e) {
                    return <Observable<GetListOthersTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOthersTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListOthersType(response: Response): Observable<GetListOthersTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListOthersTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOthersTypeResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListAccount(): Observable<GetListAccountResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAccount(response_);
                } catch (e) {
                    return <Observable<GetListAccountResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListAccountResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListAccount(response: Response): Observable<GetListAccountResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListAccountResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListAccountResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportBankReconcilePdf(input: GetBankReconcileReportPdfInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GenerateReportBankReconcilePdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportBankReconcilePdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportBankReconcilePdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportBankReconcilePdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportBankReconcile(input: GetBankReconcileReportPdfInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GenerateExcelReportBankReconcile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportBankReconcile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportBankReconcile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportBankReconcile(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListReportType(): Observable<GetReportTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListReportType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportType(response_);
                } catch (e) {
                    return <Observable<GetReportTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReportTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportType(response: Response): Observable<GetReportTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetReportTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetReportTypeListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListReportPayType(reportTypeID: number): Observable<GetListPayTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListReportPayType?";
        if (reportTypeID === undefined || reportTypeID === null)
            throw new Error("The parameter 'reportTypeID' must be defined and cannot be null.");
        else
            url_ += "reportTypeID=" + encodeURIComponent("" + reportTypeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportPayType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportPayType(response_);
                } catch (e) {
                    return <Observable<GetListPayTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPayTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportPayType(response: Response): Observable<GetListPayTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPayTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPayTypeResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListReportOthersType(reportTypeID: number): Observable<GetListOthersTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetListReportOthersType?";
        if (reportTypeID === undefined || reportTypeID === null)
            throw new Error("The parameter 'reportTypeID' must be defined and cannot be null.");
        else
            url_ += "reportTypeID=" + encodeURIComponent("" + reportTypeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportOthersType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportOthersType(response_);
                } catch (e) {
                    return <Observable<GetListOthersTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOthersTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportOthersType(response: Response): Observable<GetListOthersTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListOthersTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOthersTypeResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataReportBankReconcile(input: GetDataReportBankReconcileInputDto): Observable<GetDataReportBankReconcileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankReconcile/GetDataReportBankReconcile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataReportBankReconcile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataReportBankReconcile(response_);
                } catch (e) {
                    return <Observable<GetDataReportBankReconcileListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataReportBankReconcileListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataReportBankReconcile(response: Response): Observable<GetDataReportBankReconcileListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataReportBankReconcileListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataReportBankReconcileListDto[]>(<any>null);
    }
}

@Injectable()
export class BookingHistoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDetailBookingHistory(orderID: number): Observable<DetailBookingHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetDetailBookingHistory?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingHistory(response_);
                } catch (e) {
                    return <Observable<DetailBookingHistoryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailBookingHistoryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingHistory(response: Response): Observable<DetailBookingHistoryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailBookingHistoryResultDto.fromJS(resultData200) : new DetailBookingHistoryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailBookingHistoryResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailBookingHistoryWeb(orderID: number): Observable<DetailBookingHistoryWebResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetDetailBookingHistoryWeb?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingHistoryWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingHistoryWeb(response_);
                } catch (e) {
                    return <Observable<DetailBookingHistoryWebResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailBookingHistoryWebResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingHistoryWeb(response: Response): Observable<DetailBookingHistoryWebResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailBookingHistoryWebResultDto.fromJS(resultData200) : new DetailBookingHistoryWebResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailBookingHistoryWebResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListBookingHistoryNew(input: GetPagingBookingHistoryInputDto): Observable<PagedListBookingHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetListBookingHistoryNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBookingHistoryNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBookingHistoryNew(response_);
                } catch (e) {
                    return <Observable<PagedListBookingHistoryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedListBookingHistoryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListBookingHistoryNew(response: Response): Observable<PagedListBookingHistoryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedListBookingHistoryResultDto.fromJS(resultData200) : new PagedListBookingHistoryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedListBookingHistoryResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListBookingHistory(input: GetListBookingHistoryInputDto): Observable<ListBookingHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetListBookingHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBookingHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBookingHistory(response_);
                } catch (e) {
                    return <Observable<ListBookingHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListBookingHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBookingHistory(response: Response): Observable<ListBookingHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListBookingHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListBookingHistoryResultDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @orderCustomer (optional) 
     * @orderStatusId (optional) 
     * @starDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getListBookingHistoryApp(memberCode: string, orderCustomer: string, orderStatusId: string, starDate: string, endDate: string): Observable<ListResultDtoOfListBookingHistoryResultAppDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetListBookingHistoryApp?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (orderCustomer !== undefined)
            url_ += "orderCustomer=" + encodeURIComponent("" + orderCustomer) + "&"; 
        if (orderStatusId !== undefined)
            url_ += "orderStatusId=" + encodeURIComponent("" + orderStatusId) + "&"; 
        if (starDate !== undefined)
            url_ += "starDate=" + encodeURIComponent("" + starDate) + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBookingHistoryApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBookingHistoryApp(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListBookingHistoryResultAppDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListBookingHistoryResultAppDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListBookingHistoryApp(response: Response): Observable<ListResultDtoOfListBookingHistoryResultAppDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListBookingHistoryResultAppDto.fromJS(resultData200) : new ListResultDtoOfListBookingHistoryResultAppDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListBookingHistoryResultAppDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    searchingBookingHistoryMobile(input: SearchingBookingHistoryInputDto): Observable<ListBookingHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/SearchingBookingHistoryMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSearchingBookingHistoryMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSearchingBookingHistoryMobile(response_);
                } catch (e) {
                    return <Observable<ListBookingHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListBookingHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSearchingBookingHistoryMobile(response: Response): Observable<ListBookingHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListBookingHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListBookingHistoryResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailBookingHistoryNotaris(orderID: number): Observable<ListBookingHistoryNotarisResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetDetailBookingHistoryNotaris?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingHistoryNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingHistoryNotaris(response_);
                } catch (e) {
                    return <Observable<ListBookingHistoryNotarisResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListBookingHistoryNotarisResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingHistoryNotaris(response: Response): Observable<ListBookingHistoryNotarisResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListBookingHistoryNotarisResultDto.fromJS(resultData200) : new ListBookingHistoryNotarisResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListBookingHistoryNotarisResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownProjectBookingHistory(userID: number): Observable<GetDropdownProjectBookingHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetDropdownProjectBookingHistory?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProjectBookingHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProjectBookingHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownProjectBookingHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProjectBookingHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProjectBookingHistory(response: Response): Observable<GetDropdownProjectBookingHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProjectBookingHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProjectBookingHistoryResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCampaignList(unitOrderHeaderID: number): Observable<GetCampaignListDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingHistory/GetCampaignList?";
        if (unitOrderHeaderID === undefined || unitOrderHeaderID === null)
            throw new Error("The parameter 'unitOrderHeaderID' must be defined and cannot be null.");
        else
            url_ += "unitOrderHeaderID=" + encodeURIComponent("" + unitOrderHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCampaignList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCampaignList(response_);
                } catch (e) {
                    return <Observable<GetCampaignListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCampaignListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCampaignList(response: Response): Observable<GetCampaignListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCampaignListDto.fromJS(resultData200) : new GetCampaignListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCampaignListDto>(<any>null);
    }
}

@Injectable()
export class BulkPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkDataUploadExcelBulk(input: CheckDataUploadExcelBulkInputDto[]): Observable<GetDataCheckUploadExcelListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BulkPayment/CheckDataUploadExcelBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataUploadExcelBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataUploadExcelBulk(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadExcelListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadExcelListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataUploadExcelBulk(response: Response): Observable<GetDataCheckUploadExcelListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadExcelListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadExcelListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentBulk(input: CreateTrPaymentBulkInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BulkPayment/CreateTrPaymentBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentBulk(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentBulk(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @dataInput (optional) 
     * @return Success
     */
    createBulkPayment(dataInput: CreateUniversalBulkPaymentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BulkPayment/CreateBulkPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateBulkPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateBulkPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateBulkPayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalBulkPayment(input: CreateUniversalBulkPaymentInputDto[]): Observable<GetDataCheckUploadExcelListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BulkPayment/CreateUniversalBulkPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalBulkPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalBulkPayment(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadExcelListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadExcelListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalBulkPayment(response: Response): Observable<GetDataCheckUploadExcelListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadExcelListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadExcelListDto[]>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCaches(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCaches(response: Response): Observable<ListResultDtoOfCacheDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    clearCache(input: EntityDtoOfString): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearAllCaches(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearAllCaches(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ChangePPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDropdownPPNo(projectID: number): Observable<GetDropdownPPNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangePP/GetDropdownPPNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownPPNo(response_);
                } catch (e) {
                    return <Observable<GetDropdownPPNoResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownPPNoResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownPPNo(response: Response): Observable<GetDropdownPPNoResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownPPNoResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownPPNoResultDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getSalesAndMember(psCode: string, memberCode: string): Observable<GetSalesAndMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangePP/GetSalesAndMember?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesAndMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesAndMember(response_);
                } catch (e) {
                    return <Observable<GetSalesAndMemberDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSalesAndMemberDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesAndMember(response: Response): Observable<GetSalesAndMemberDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSalesAndMemberDto.fromJS(resultData200) : new GetSalesAndMemberDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSalesAndMemberDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListSalesMember(): Observable<GetListSalesMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangePP/GetListSalesMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSalesMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSalesMember(response_);
                } catch (e) {
                    return <Observable<GetListSalesMemberDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListSalesMemberDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListSalesMember(response: Response): Observable<GetListSalesMemberDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListSalesMemberDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListSalesMemberDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListCustomerMember(): Observable<GetListCustomerMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangePP/GetListCustomerMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCustomerMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCustomerMember(response_);
                } catch (e) {
                    return <Observable<GetListCustomerMemberDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListCustomerMemberDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListCustomerMember(response: Response): Observable<GetListCustomerMemberDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListCustomerMemberDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListCustomerMemberDto[]>(<any>null);
    }

    /**
     * @ppNo (optional) 
     * @psCode (optional) 
     * @memberCode (optional) 
     * @scmCode (optional) 
     * @return Success
     */
    updateCustomerAndSales(ppNo: string, psCode: string, memberCode: string, scmCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangePP/updateCustomerAndSales?";
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCustomerAndSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCustomerAndSales(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCustomerAndSales(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ChangeTermCodeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUnitCodeUnitNo(projectID: number, clusterID: number): Observable<GetUnitCodeUnitNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangeTermCode/GetUnitCodeUnitNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitCodeUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitCodeUnitNo(response_);
                } catch (e) {
                    return <Observable<GetUnitCodeUnitNoResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitCodeUnitNoResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitCodeUnitNo(response: Response): Observable<GetUnitCodeUnitNoResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitCodeUnitNoResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitCodeUnitNoResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTermByUnit(input: UpdateTermCodeByUnitInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeTermCode/UpdateTermByUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTermByUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTermByUnit(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTermByUnit(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class ChangeUnitRegulerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @stateId (optional) 
     * @return Success
     */
    getChangeUnitRegulerRequests(bookCode: string, stateId: number): Observable<ListResultDtoOfGetChangeUnitRegulerListDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetChangeUnitRegulerRequests?";
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChangeUnitRegulerRequests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChangeUnitRegulerRequests(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetChangeUnitRegulerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetChangeUnitRegulerListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetChangeUnitRegulerRequests(response: Response): Observable<ListResultDtoOfGetChangeUnitRegulerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetChangeUnitRegulerListDto.fromJS(resultData200) : new ListResultDtoOfGetChangeUnitRegulerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetChangeUnitRegulerListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDataNotaReturOR(bookingHeaderID: number): Observable<GetDataNotaReturORDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDataNotaReturOR?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataNotaReturOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataNotaReturOR(response_);
                } catch (e) {
                    return <Observable<GetDataNotaReturORDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataNotaReturORDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataNotaReturOR(response: Response): Observable<GetDataNotaReturORDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataNotaReturORDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataNotaReturORDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDataChangeUnitParameter(): Observable<GetDataChangeUnitParamDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDataChangeUnitParameter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataChangeUnitParameter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataChangeUnitParameter(response_);
                } catch (e) {
                    return <Observable<GetDataChangeUnitParamDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataChangeUnitParamDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataChangeUnitParameter(response: Response): Observable<GetDataChangeUnitParamDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataChangeUnitParamDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataChangeUnitParamDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @unitID (optional) 
     * @return Success
     */
    getTermOfPayments(projectID: number, unitID: number): Observable<TermOfPaymentListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetTermOfPayments?";
        if (projectID !== undefined)
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (unitID !== undefined)
            url_ += "UnitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermOfPayments(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermOfPayments(response_);
                } catch (e) {
                    return <Observable<TermOfPaymentListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TermOfPaymentListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTermOfPayments(response: Response): Observable<TermOfPaymentListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TermOfPaymentListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TermOfPaymentListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getBookingFeeCUR(termID: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetBookingFeeCUR?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingFeeCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingFeeCUR(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingFeeCUR(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataCUROldUnit(projectID: number, clusterID: number, unitCode: string, unitNo: string): Observable<GetDataCUROldUnitResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDataCUROldUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCUROldUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCUROldUnit(response_);
                } catch (e) {
                    return <Observable<GetDataCUROldUnitResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCUROldUnitResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCUROldUnit(response: Response): Observable<GetDataCUROldUnitResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataCUROldUnitResultDto.fromJS(resultData200) : new GetDataCUROldUnitResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCUROldUnitResultDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataCURNewUnit(projectID: number, clusterID: number, unitCode: string, unitNo: string, unitIDLama: number, bookingHeaderIDLama: number, handOverDate: moment.Moment): Observable<GetDataCURNewUnitResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDataCURNewUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (unitIDLama === undefined || unitIDLama === null)
            throw new Error("The parameter 'unitIDLama' must be defined and cannot be null.");
        else
            url_ += "unitIDLama=" + encodeURIComponent("" + unitIDLama) + "&"; 
        if (bookingHeaderIDLama === undefined || bookingHeaderIDLama === null)
            throw new Error("The parameter 'bookingHeaderIDLama' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderIDLama=" + encodeURIComponent("" + bookingHeaderIDLama) + "&"; 
        if (handOverDate === undefined || handOverDate === null)
            throw new Error("The parameter 'handOverDate' must be defined and cannot be null.");
        else
            url_ += "handOverDate=" + encodeURIComponent(handOverDate ? "" + handOverDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCURNewUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCURNewUnit(response_);
                } catch (e) {
                    return <Observable<GetDataCURNewUnitResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCURNewUnitResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCURNewUnit(response: Response): Observable<GetDataCURNewUnitResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataCURNewUnitResultDto.fromJS(resultData200) : new GetDataCURNewUnitResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCURNewUnitResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getOldAndNewUnitComparisons(oldUnitBookingId: number, newUnitId: number, newUnitTermId: number): Observable<GetOldAndNewUnitComparisonsResult> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetOldAndNewUnitComparisons?";
        if (oldUnitBookingId === undefined || oldUnitBookingId === null)
            throw new Error("The parameter 'oldUnitBookingId' must be defined and cannot be null.");
        else
            url_ += "OldUnitBookingId=" + encodeURIComponent("" + oldUnitBookingId) + "&"; 
        if (newUnitId === undefined || newUnitId === null)
            throw new Error("The parameter 'newUnitId' must be defined and cannot be null.");
        else
            url_ += "NewUnitId=" + encodeURIComponent("" + newUnitId) + "&"; 
        if (newUnitTermId === undefined || newUnitTermId === null)
            throw new Error("The parameter 'newUnitTermId' must be defined and cannot be null.");
        else
            url_ += "NewUnitTermId=" + encodeURIComponent("" + newUnitTermId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOldAndNewUnitComparisons(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOldAndNewUnitComparisons(response_);
                } catch (e) {
                    return <Observable<GetOldAndNewUnitComparisonsResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOldAndNewUnitComparisonsResult>><any>Observable.throw(response_);
        });
    }

    protected processGetOldAndNewUnitComparisons(response: Response): Observable<GetOldAndNewUnitComparisonsResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetOldAndNewUnitComparisonsResult.fromJS(resultData200) : new GetOldAndNewUnitComparisonsResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOldAndNewUnitComparisonsResult>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    completeRequestAction(input: CompleteChangeUnitRegulerRequestActionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/CompleteRequestAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompleteRequestAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompleteRequestAction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCompleteRequestAction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelChangeUnit(input: ProcessSwitchUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/CancelChangeUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCancelChangeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCancelChangeUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelChangeUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    requestChangeUnit(input: ProcessSwitchUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/RequestChangeUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRequestChangeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRequestChangeUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRequestChangeUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    processChangeUnit(input: ProcessSwitchUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/ProcessChangeUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessChangeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessChangeUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessChangeUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createNotaRetur(bookingHeaderIDLama: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/CreateNotaRetur?";
        if (bookingHeaderIDLama === undefined || bookingHeaderIDLama === null)
            throw new Error("The parameter 'bookingHeaderIDLama' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderIDLama=" + encodeURIComponent("" + bookingHeaderIDLama) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotaRetur(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotaRetur(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotaRetur(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notaRetur (optional) 
     * @return Success
     */
    downloadNotaRetur(notaRetur: string, bookingHeaderIDLama: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/DownloadNotaRetur?";
        if (notaRetur !== undefined)
            url_ += "notaRetur=" + encodeURIComponent("" + notaRetur) + "&"; 
        if (bookingHeaderIDLama === undefined || bookingHeaderIDLama === null)
            throw new Error("The parameter 'bookingHeaderIDLama' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderIDLama=" + encodeURIComponent("" + bookingHeaderIDLama) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadNotaRetur(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadNotaRetur(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadNotaRetur(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPaymentCUR(input: CreatePaymentCURInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/CreatePaymentCUR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentCUR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentCUR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @memberName (optional) 
     * @scmCode (optional) 
     * @return Success
     */
    getDropdownDealCloserCUR(memberCode: string, memberName: string, scmCode: string): Observable<GetDataMemberCURDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDropdownDealCloserCUR?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (memberName !== undefined)
            url_ += "memberName=" + encodeURIComponent("" + memberName) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownDealCloserCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownDealCloserCUR(response_);
                } catch (e) {
                    return <Observable<GetDataMemberCURDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMemberCURDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownDealCloserCUR(response: Response): Observable<GetDataMemberCURDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataMemberCURDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMemberCURDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getStates(): Observable<ListResultDtoOfDropdownDtoOfInt32> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStates(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStates(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDropdownDtoOfInt32>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDropdownDtoOfInt32>><any>Observable.throw(response_);
        });
    }

    protected processGetStates(response: Response): Observable<ListResultDtoOfDropdownDtoOfInt32> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDropdownDtoOfInt32.fromJS(resultData200) : new ListResultDtoOfDropdownDtoOfInt32();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDropdownDtoOfInt32>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generateAmandemenCUR(bookCode: string, projectID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GenerateAmandemenCUR?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateAmandemenCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateAmandemenCUR(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateAmandemenCUR(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @bookCode (optional) 
     * @return Success
     */
    getUrlAmandementPindahUnit(docNo: string, bookCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetUrlAmandementPindahUnit?";
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUrlAmandementPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUrlAmandementPindahUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetUrlAmandementPindahUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    generateKpChangeUnit(bookingHeaderID: number, unitIDBaru: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GenerateKpChangeUnit?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (unitIDBaru === undefined || unitIDBaru === null)
            throw new Error("The parameter 'unitIDBaru' must be defined and cannot be null.");
        else
            url_ += "unitIDBaru=" + encodeURIComponent("" + unitIDBaru) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateKpChangeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateKpChangeUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateKpChangeUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    generateSPUChangeUnit(changeUnitID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GenerateSPUChangeUnit?";
        if (changeUnitID === undefined || changeUnitID === null)
            throw new Error("The parameter 'changeUnitID' must be defined and cannot be null.");
        else
            url_ += "changeUnitID=" + encodeURIComponent("" + changeUnitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateSPUChangeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateSPUChangeUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateSPUChangeUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentCUR(changeUnitID: number): Observable<GetCURDocumentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDocumentCUR?";
        if (changeUnitID === undefined || changeUnitID === null)
            throw new Error("The parameter 'changeUnitID' must be defined and cannot be null.");
        else
            url_ += "changeUnitID=" + encodeURIComponent("" + changeUnitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocumentCUR(response_);
                } catch (e) {
                    return <Observable<GetCURDocumentResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCURDocumentResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentCUR(response: Response): Observable<GetCURDocumentResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCURDocumentResultDto.fromJS(resultData200) : new GetCURDocumentResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCURDocumentResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    toRoman(number: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/ToRoman?";
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processToRoman(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processToRoman(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processToRoman(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getDataSimulasiCUR(changeUnitID: number): Observable<GenerateSimulasiPindahUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnitReguler/GetDataSimulasiCUR?";
        if (changeUnitID === undefined || changeUnitID === null)
            throw new Error("The parameter 'changeUnitID' must be defined and cannot be null.");
        else
            url_ += "changeUnitID=" + encodeURIComponent("" + changeUnitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSimulasiCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSimulasiCUR(response_);
                } catch (e) {
                    return <Observable<GenerateSimulasiPindahUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateSimulasiPindahUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSimulasiCUR(response: Response): Observable<GenerateSimulasiPindahUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateSimulasiPindahUnitDto.fromJS(resultData200) : new GenerateSimulasiPindahUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateSimulasiPindahUnitDto>(<any>null);
    }
}

@Injectable()
export class ChangeUnknownPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @itemID (optional) 
     * @return Success
     */
    getDataOutstandingSchedule(bookingHeaderID: number, payForID: number, itemID: number[]): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnknownPayment/GetDataOutstandingSchedule?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        if (itemID !== undefined)
            itemID && itemID.forEach(item => { url_ += "itemID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataOutstandingSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataOutstandingSchedule(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetDataOutstandingSchedule(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalChangeUnknown(input: CreateUniversalChangeUnknownInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnknownPayment/CreateUniversalChangeUnknown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalChangeUnknown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalChangeUnknown(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalChangeUnknown(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentChangeUnknown(input: CreateTrPaymentChangeUnknownInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChangeUnknownPayment/CreateTrPaymentChangeUnknown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentChangeUnknown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentChangeUnknown(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentChangeUnknown(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatFriendsWithSettings(response: Response): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number, userId: number, minMessageId: number): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatMessages(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatMessages(response: Response): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(input: MarkAllUnreadMessagesOfUserAsReadInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ClosingAccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    closingAccountUniversal(input: ClosingAccountInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/ClosingAccountUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClosingAccountUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClosingAccountUniversal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClosingAccountUniversal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveToCCL(input: LK_GL_INTERFACE): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/SaveToCCL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveToCCL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveToCCL(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSaveToCCL(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    generateGroupID(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/GenerateGroupID";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateGroupID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateGroupID(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGenerateGroupID(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsAccountClosing(cutOffDate: moment.Moment): Observable<ListResultDtoOfGetAllMsAccountClosingListDto> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/GetAllMsAccountClosing?";
        if (cutOffDate === undefined || cutOffDate === null)
            throw new Error("The parameter 'cutOffDate' must be defined and cannot be null.");
        else
            url_ += "cutOffDate=" + encodeURIComponent(cutOffDate ? "" + cutOffDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsAccountClosing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsAccountClosing(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsAccountClosingListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsAccountClosingListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsAccountClosing(response: Response): Observable<ListResultDtoOfGetAllMsAccountClosingListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsAccountClosingListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsAccountClosingListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsAccountClosingListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailClosingAccount(input: GetDataClosingEmailListDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/SendEmailClosingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailClosingAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailClosingAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailClosingAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendEmailClosingAccount(input: ResendClosingAccountDto): Observable<GetDataClosingEmailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/ResendEmailClosingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendEmailClosingAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendEmailClosingAccount(response_);
                } catch (e) {
                    return <Observable<GetDataClosingEmailListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataClosingEmailListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processResendEmailClosingAccount(response: Response): Observable<GetDataClosingEmailListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataClosingEmailListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataClosingEmailListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteSysClosingAccount(input: CreateDeleteSysClosingAccountInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/CreateDeleteSysClosingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteSysClosingAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteSysClosingAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteSysClosingAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTasklistSysClosingAccount(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetSysClosingAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/GetTasklistSysClosingAccount?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistSysClosingAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistSysClosingAccount(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSysClosingAccountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSysClosingAccountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistSysClosingAccount(response: Response): Observable<PagedResultDtoOfGetSysClosingAccountListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSysClosingAccountListDto.fromJS(resultData200) : new PagedResultDtoOfGetSysClosingAccountListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetSysClosingAccountListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSysClosingAccount(userID: number): Observable<GetSysClosingAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/ClosingAccount/GetDetailSysClosingAccount?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSysClosingAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSysClosingAccount(response_);
                } catch (e) {
                    return <Observable<GetSysClosingAccountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSysClosingAccountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSysClosingAccount(response: Response): Observable<GetSysClosingAccountListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSysClosingAccountListDto.fromJS(resultData200) : new GetSysClosingAccountListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSysClosingAccountListDto>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === undefined || onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' must be defined and cannot be null.");
        else
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForCombobox(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForCombobox(response: Response): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDefaultEditionName(response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultEditionName(response: Response): Observable<GetDefaultEditionNameOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CreditAgreementServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUniversalCreditAgreement(input: GetCreditAgreementViewDetail): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/CreateOrUpdateUniversalCreditAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUniversalCreditAgreement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUniversalCreditAgreement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUniversalCreditAgreement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getBankDetail(creditAgreementID: number): Observable<GetBankDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetBankDetail?";
        if (creditAgreementID === undefined || creditAgreementID === null)
            throw new Error("The parameter 'creditAgreementID' must be defined and cannot be null.");
        else
            url_ += "creditAgreementID=" + encodeURIComponent("" + creditAgreementID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankDetail(response_);
                } catch (e) {
                    return <Observable<GetBankDetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBankDetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBankDetail(response: Response): Observable<GetBankDetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetBankDetailDto.fromJS(resultData200) : new GetBankDetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetBankDetailDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getCreditAgreement(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetCreditAgreementListDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetCreditAgreement?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCreditAgreement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCreditAgreement(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCreditAgreementListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCreditAgreementListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCreditAgreement(response: Response): Observable<PagedResultDtoOfGetCreditAgreementListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetCreditAgreementListDto.fromJS(resultData200) : new PagedResultDtoOfGetCreditAgreementListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetCreditAgreementListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProgramDetail(agreementDetailID: number): Observable<GetProgramRateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetProgramDetail?";
        if (agreementDetailID === undefined || agreementDetailID === null)
            throw new Error("The parameter 'agreementDetailID' must be defined and cannot be null.");
        else
            url_ += "agreementDetailID=" + encodeURIComponent("" + agreementDetailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProgramDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProgramDetail(response_);
                } catch (e) {
                    return <Observable<GetProgramRateListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramRateListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProgramDetail(response: Response): Observable<GetProgramRateListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramRateListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramRateListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRetentionDetail(agreementDetailID: number): Observable<GetRetentionDetailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetRetentionDetail?";
        if (agreementDetailID === undefined || agreementDetailID === null)
            throw new Error("The parameter 'agreementDetailID' must be defined and cannot be null.");
        else
            url_ += "agreementDetailID=" + encodeURIComponent("" + agreementDetailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRetentionDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRetentionDetail(response_);
                } catch (e) {
                    return <Observable<GetRetentionDetailListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRetentionDetailListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRetentionDetail(response: Response): Observable<GetRetentionDetailListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRetentionDetailListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRetentionDetailListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSubsidy(agreementDetailID: number): Observable<GetSubsidyDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetSubsidy?";
        if (agreementDetailID === undefined || agreementDetailID === null)
            throw new Error("The parameter 'agreementDetailID' must be defined and cannot be null.");
        else
            url_ += "agreementDetailID=" + encodeURIComponent("" + agreementDetailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSubsidy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSubsidy(response_);
                } catch (e) {
                    return <Observable<GetSubsidyDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSubsidyDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSubsidy(response: Response): Observable<GetSubsidyDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSubsidyDto.fromJS(resultData200) : new GetSubsidyDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSubsidyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAgreementInformation(creditAgreementID: number): Observable<GetAgreementInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetAgreementInformation?";
        if (creditAgreementID === undefined || creditAgreementID === null)
            throw new Error("The parameter 'creditAgreementID' must be defined and cannot be null.");
        else
            url_ += "creditAgreementID=" + encodeURIComponent("" + creditAgreementID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAgreementInformation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAgreementInformation(response_);
                } catch (e) {
                    return <Observable<GetAgreementInformationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAgreementInformationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAgreementInformation(response: Response): Observable<GetAgreementInformationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAgreementInformationDto.fromJS(resultData200) : new GetAgreementInformationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAgreementInformationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFeeType(): Observable<GetFeeTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetFeeType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFeeType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFeeType(response_);
                } catch (e) {
                    return <Observable<GetFeeTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFeeTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFeeType(response: Response): Observable<GetFeeTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetFeeTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFeeTypeListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProgramDetailList(creditAgreementID: number): Observable<GetProgramDetailListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetProgramDetailList?";
        if (creditAgreementID === undefined || creditAgreementID === null)
            throw new Error("The parameter 'creditAgreementID' must be defined and cannot be null.");
        else
            url_ += "creditAgreementID=" + encodeURIComponent("" + creditAgreementID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProgramDetailList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProgramDetailList(response_);
                } catch (e) {
                    return <Observable<GetProgramDetailListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDetailListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProgramDetailList(response: Response): Observable<GetProgramDetailListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDetailListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDetailListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCreditAgreementViewDetail(creditAgreementID: number): Observable<GetCreditAgreementViewDetail> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetCreditAgreementViewDetail?";
        if (creditAgreementID === undefined || creditAgreementID === null)
            throw new Error("The parameter 'creditAgreementID' must be defined and cannot be null.");
        else
            url_ += "creditAgreementID=" + encodeURIComponent("" + creditAgreementID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCreditAgreementViewDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCreditAgreementViewDetail(response_);
                } catch (e) {
                    return <Observable<GetCreditAgreementViewDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCreditAgreementViewDetail>><any>Observable.throw(response_);
        });
    }

    protected processGetCreditAgreementViewDetail(response: Response): Observable<GetCreditAgreementViewDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCreditAgreementViewDetail.fromJS(resultData200) : new GetCreditAgreementViewDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCreditAgreementViewDetail>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankById(bankID: number): Observable<GetMsBankDto> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetMsBankById?";
        if (bankID === undefined || bankID === null)
            throw new Error("The parameter 'bankID' must be defined and cannot be null.");
        else
            url_ += "bankID=" + encodeURIComponent("" + bankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankById(response_);
                } catch (e) {
                    return <Observable<GetMsBankDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsBankDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankById(response: Response): Observable<GetMsBankDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMsBankDto.fromJS(resultData200) : new GetMsBankDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsBankDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankByBankType(bankTypeID: number): Observable<GetBankDropDownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetMsBankByBankType?";
        if (bankTypeID === undefined || bankTypeID === null)
            throw new Error("The parameter 'bankTypeID' must be defined and cannot be null.");
        else
            url_ += "bankTypeID=" + encodeURIComponent("" + bankTypeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankByBankType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankByBankType(response_);
                } catch (e) {
                    return <Observable<GetBankDropDownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBankDropDownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankByBankType(response: Response): Observable<GetBankDropDownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetBankDropDownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetBankDropDownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProgramNo(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetProgramNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProgramNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProgramNo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetProgramNo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getAddendumNo(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetAddendumNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAddendumNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAddendumNo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetAddendumNo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getAgreementDocsNo(projectID: number, bankID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CreditAgreement/GetAgreementDocsNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (bankID === undefined || bankID === null)
            throw new Error("The parameter 'bankID' must be defined and cannot be null.");
        else
            url_ += "bankID=" + encodeURIComponent("" + bankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAgreementDocsNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAgreementDocsNo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetAgreementDocsNo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class CustomerMemberServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    memberActivation(input: SignUpMemberInputDto): Observable<MemberActivationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/MemberActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMemberActivation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMemberActivation(response_);
                } catch (e) {
                    return <Observable<MemberActivationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MemberActivationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processMemberActivation(response: Response): Observable<MemberActivationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberActivationResultDto.fromJS(resultData200) : new MemberActivationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MemberActivationResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    autoMemberActivation(input: NewMemberActivationInputDto): Observable<MemberActivationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/AutoMemberActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAutoMemberActivation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAutoMemberActivation(response_);
                } catch (e) {
                    return <Observable<MemberActivationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MemberActivationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processAutoMemberActivation(response: Response): Observable<MemberActivationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberActivationResultDto.fromJS(resultData200) : new MemberActivationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MemberActivationResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    hash(input: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/Hash?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processHash(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHash(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processHash(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    generatePsCode(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/generatePsCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePsCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePsCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    checkPsCodeUsed(psCode: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/checkPsCodeUsed?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckPsCodeUsed(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckPsCodeUsed(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckPsCodeUsed(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    signUpCustomer(input: SignUpCustomerInputDto): Observable<SignUpCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/SignUpCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSignUpCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSignUpCustomer(response_);
                } catch (e) {
                    return <Observable<SignUpCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignUpCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSignUpCustomer(response: Response): Observable<SignUpCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignUpCustomerResultDto.fromJS(resultData200) : new SignUpCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignUpCustomerResultDto>(<any>null);
    }

    /**
     * @name (optional) 
     * @birthdate (optional) 
     * @idNo (optional) 
     * @return Success
     */
    checkDataCustomer(name: string, birthdate: string, idNo: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CheckDataCustomer?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (birthdate !== undefined)
            url_ += "birthdate=" + encodeURIComponent("" + birthdate) + "&"; 
        if (idNo !== undefined)
            url_ += "idNo=" + encodeURIComponent("" + idNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @name (optional) 
     * @birthdate (optional) 
     * @idNo (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getListCustomer(name: string, birthdate: string, idNo: string, memberCode: string): Observable<ListResultDtoOfListCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetListCustomer?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (birthdate !== undefined)
            url_ += "birthdate=" + encodeURIComponent("" + birthdate) + "&"; 
        if (idNo !== undefined)
            url_ += "idNo=" + encodeURIComponent("" + idNo) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCustomer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListCustomer(response: Response): Observable<ListResultDtoOfListCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListCustomerResultDto.fromJS(resultData200) : new ListResultDtoOfListCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListCustomerResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getOcc(): Observable<ListOccupationsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetOcc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOcc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOcc(response_);
                } catch (e) {
                    return <Observable<ListOccupationsDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListOccupationsDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetOcc(response: Response): Observable<ListOccupationsDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListOccupationsDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListOccupationsDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getJobTitle(): Observable<ListJobTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetJobTitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetJobTitle(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetJobTitle(response_);
                } catch (e) {
                    return <Observable<ListJobTitleDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListJobTitleDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetJobTitle(response: Response): Observable<ListJobTitleDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListJobTitleDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListJobTitleDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getJobSector(): Observable<ListJobSectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetJobSector";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetJobSector(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetJobSector(response_);
                } catch (e) {
                    return <Observable<ListJobSectorDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListJobSectorDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetJobSector(response: Response): Observable<ListJobSectorDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListJobSectorDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListJobSectorDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getIncome(): Observable<ListIncomeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetIncome";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIncome(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIncome(response_);
                } catch (e) {
                    return <Observable<ListIncomeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListIncomeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetIncome(response: Response): Observable<ListIncomeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListIncomeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListIncomeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNation(): Observable<ListNationResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetNation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNation(response_);
                } catch (e) {
                    return <Observable<ListNationResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListNationResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNation(response: Response): Observable<ListNationResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListNationResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListNationResultDto[]>(<any>null);
    }

    /**
     * @city (optional) 
     * @return Success
     */
    getPostCode(city: string): Observable<ListPostCodeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetPostCode?";
        if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPostCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPostCode(response_);
                } catch (e) {
                    return <Observable<ListPostCodeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListPostCodeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPostCode(response: Response): Observable<ListPostCodeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListPostCodeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListPostCodeResultDto[]>(<any>null);
    }

    /**
     * @city (optional) 
     * @return Success
     */
    getPostCodeByCity(city: string): Observable<ListPostCodeResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetPostCodeByCity?";
        if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPostCodeByCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPostCodeByCity(response_);
                } catch (e) {
                    return <Observable<ListPostCodeResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListPostCodeResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPostCodeByCity(response: Response): Observable<ListPostCodeResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListPostCodeResultDto.fromJS(resultData200) : new ListPostCodeResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListPostCodeResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCountry(): Observable<ListCountryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountry(response_);
                } catch (e) {
                    return <Observable<ListCountryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListCountryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountry(response: Response): Observable<ListCountryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListCountryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListCountryResultDto[]>(<any>null);
    }

    /**
     * @provinceCode (optional) 
     * @return Success
     */
    getCity(provinceCode: string): Observable<ListCityResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetCity?";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCity(response_);
                } catch (e) {
                    return <Observable<ListCityResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListCityResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCity(response: Response): Observable<ListCityResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListCityResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListCityResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCity(): Observable<ListCityResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetAllCity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCity(response_);
                } catch (e) {
                    return <Observable<ListCityResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListCityResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCity(response: Response): Observable<ListCityResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListCityResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListCityResultDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDetailCustomer(psCode: string): Observable<DetailCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetDetailCustomer?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailCustomer(response_);
                } catch (e) {
                    return <Observable<DetailCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailCustomer(response: Response): Observable<DetailCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailCustomerResultDto.fromJS(resultData200) : new DetailCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailCustomerResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCustomer(input: UpdateCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/UpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDocumentByPsCode(psCode: string): Observable<ListDocumentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetDocumentByPsCode?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentByPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocumentByPsCode(response_);
                } catch (e) {
                    return <Observable<ListDocumentResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDocumentResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentByPsCode(response: Response): Observable<ListDocumentResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListDocumentResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDocumentResultDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDetailCustomerMobile(psCode: string): Observable<DetailCustomerMobileResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetDetailCustomerMobile?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailCustomerMobile(response_);
                } catch (e) {
                    return <Observable<DetailCustomerMobileResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailCustomerMobileResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailCustomerMobile(response: Response): Observable<DetailCustomerMobileResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailCustomerMobileResultDto.fromJS(resultData200) : new DetailCustomerMobileResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailCustomerMobileResultDto>(<any>null);
    }

    /**
     * @country (optional) 
     * @return Success
     */
    getProvince(country: string): Observable<ListProvinceResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetProvince?";
        if (country !== undefined)
            url_ += "country=" + encodeURIComponent("" + country) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProvince(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProvince(response_);
                } catch (e) {
                    return <Observable<ListProvinceResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListProvinceResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProvince(response: Response): Observable<ListProvinceResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListProvinceResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListProvinceResultDto[]>(<any>null);
    }

    /**
     * @provinceCode (optional) 
     * @return Success
     */
    getProvinceByCity(provinceCode: string): Observable<ListProvinceResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetProvinceByCity?";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProvinceByCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProvinceByCity(response_);
                } catch (e) {
                    return <Observable<ListProvinceResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListProvinceResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProvinceByCity(response: Response): Observable<ListProvinceResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListProvinceResultDto.fromJS(resultData200) : new ListProvinceResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListProvinceResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCustomerMobile(input: UpdateCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/UpdateCustomerMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCustomerMobile(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCustomerMobile(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListMaritalStatus(): Observable<GetListMaritalStatusResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/getListMaritalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMaritalStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMaritalStatus(response_);
                } catch (e) {
                    return <Observable<GetListMaritalStatusResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMaritalStatusResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMaritalStatus(response: Response): Observable<GetListMaritalStatusResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMaritalStatusResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMaritalStatusResultDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @domainLogin (optional) 
     * @return Success
     */
    checkLogin(memberCode: string, domainLogin: string): Observable<CheckLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CheckLogin?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (domainLogin !== undefined)
            url_ += "domainLogin=" + encodeURIComponent("" + domainLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckLogin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckLogin(response_);
                } catch (e) {
                    return <Observable<CheckLoginResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckLoginResultDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckLogin(response: Response): Observable<CheckLoginResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckLoginResultDto.fromJS(resultData200) : new CheckLoginResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckLoginResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkLoginMobile(input: CheckLoginMobileInputDto): Observable<CheckLoginResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CheckLoginMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckLoginMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckLoginMobile(response_);
                } catch (e) {
                    return <Observable<CheckLoginResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckLoginResultDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckLoginMobile(response: Response): Observable<CheckLoginResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckLoginResultDto.fromJS(resultData200) : new CheckLoginResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckLoginResultDto>(<any>null);
    }

    /**
     * @occID (optional) 
     * @return Success
     */
    getDropdownOccupationSelectByOccID(occID: string): Observable<GetDropdownOccupationResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetDropdownOccupationSelectByOccID?";
        if (occID !== undefined)
            url_ += "OccID=" + encodeURIComponent("" + occID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownOccupationSelectByOccID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownOccupationSelectByOccID(response_);
                } catch (e) {
                    return <Observable<GetDropdownOccupationResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownOccupationResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownOccupationSelectByOccID(response: Response): Observable<GetDropdownOccupationResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownOccupationResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownOccupationResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownOccupation(): Observable<GetDropdownOccupationResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetDropdownOccupation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownOccupation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownOccupation(response_);
                } catch (e) {
                    return <Observable<GetDropdownOccupationResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownOccupationResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownOccupation(response: Response): Observable<GetDropdownOccupationResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownOccupationResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownOccupationResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateCustomer(input: CreateUpdateCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CreateUpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getListMemberTree(memberCode: string): Observable<GetListMemberTreeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetListMemberTree?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMemberTree(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMemberTree(response_);
                } catch (e) {
                    return <Observable<GetListMemberTreeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMemberTreeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMemberTree(response: Response): Observable<GetListMemberTreeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMemberTreeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMemberTreeResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    signUpSales(input: SignUpSalesInputDto): Observable<SignUpCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/SignUpSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSignUpSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSignUpSales(response_);
                } catch (e) {
                    return <Observable<SignUpCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignUpCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSignUpSales(response: Response): Observable<SignUpCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignUpCustomerResultDto.fromJS(resultData200) : new SignUpCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignUpCustomerResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMember(input: CreateMemberDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CreateMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMember(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateMember(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @scmCode (optional) 
     * @nIK (optional) 
     * @parentMemberCode (optional) 
     * @statusCode (optional) 
     * @return Success
     */
    generateNewMemberCode(scmCode: string, nIK: string, parentMemberCode: string, statusCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GenerateNewMemberCode?";
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (nIK !== undefined)
            url_ += "NIK=" + encodeURIComponent("" + nIK) + "&"; 
        if (parentMemberCode !== undefined)
            url_ += "parentMemberCode=" + encodeURIComponent("" + parentMemberCode) + "&"; 
        if (statusCode !== undefined)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateNewMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateNewMemberCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateNewMemberCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @parentMemberCode (optional) 
     * @return Success
     */
    memberCodeNewFormat(memberCode: string, parentMemberCode: string, isLevel: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/MemberCodeNewFormat?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (parentMemberCode !== undefined)
            url_ += "parentMemberCode=" + encodeURIComponent("" + parentMemberCode) + "&"; 
        if (isLevel === undefined || isLevel === null)
            throw new Error("The parameter 'isLevel' must be defined and cannot be null.");
        else
            url_ += "isLevel=" + encodeURIComponent("" + isLevel) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMemberCodeNewFormat(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMemberCodeNewFormat(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMemberCodeNewFormat(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @parentMemberCode (optional) 
     * @statusCode (optional) 
     * @return Success
     */
    generateNewFormat(memberCode: string, parentMemberCode: string, isLevel: number, statusCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GenerateNewFormat?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (parentMemberCode !== undefined)
            url_ += "parentMemberCode=" + encodeURIComponent("" + parentMemberCode) + "&"; 
        if (isLevel === undefined || isLevel === null)
            throw new Error("The parameter 'isLevel' must be defined and cannot be null.");
        else
            url_ += "isLevel=" + encodeURIComponent("" + isLevel) + "&"; 
        if (statusCode !== undefined)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateNewFormat(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateNewFormat(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateNewFormat(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    selfRegistration(input: AutoMemberActivationInputDto): Observable<SignUpCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/SelfRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSelfRegistration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSelfRegistration(response_);
                } catch (e) {
                    return <Observable<SignUpCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignUpCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSelfRegistration(response: Response): Observable<SignUpCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignUpCustomerResultDto.fromJS(resultData200) : new SignUpCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignUpCustomerResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @emailMember (optional) 
     * @return Success
     */
    sendEmailAutoActivation(memberCode: string, emailMember: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/SendEmailAutoActivation?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (emailMember !== undefined)
            url_ += "emailMember=" + encodeURIComponent("" + emailMember) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAutoActivation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAutoActivation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAutoActivation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @keyword (optional) 
     * @return Success
     */
    checkScemaCode(keyword: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CheckScemaCode?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckScemaCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckScemaCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckScemaCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @keyword (optional) 
     * @scmCode (optional) 
     * @return Success
     */
    checkParentMemberCode(keyword: string, scmCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CheckParentMemberCode?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckParentMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckParentMemberCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckParentMemberCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUrlTermAndConditionSelfRegistration(): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetUrlTermAndConditionSelfRegistration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUrlTermAndConditionSelfRegistration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUrlTermAndConditionSelfRegistration(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUrlTermAndConditionSelfRegistration(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @keyword (optional) 
     * @return Success
     */
    getListLeadManagement(memberCode: string, keyword: string): Observable<GetListSalesManagementResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetListLeadManagement?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListLeadManagement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListLeadManagement(response_);
                } catch (e) {
                    return <Observable<GetListSalesManagementResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListSalesManagementResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListLeadManagement(response: Response): Observable<GetListSalesManagementResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListSalesManagementResultDto.fromJS(resultData200) : new GetListSalesManagementResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListSalesManagementResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateLeadManagement(input: CreateLeadManagementInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/CreateUpdateLeadManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateLeadManagement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateLeadManagement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateLeadManagement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getListStatusLead(): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/GetListStatusLead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListStatusLead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListStatusLead(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListStatusLead(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @email (optional) 
     * @nUP (optional) 
     * @userName (optional) 
     * @return Success
     */
    verifyCustomerNUP(email: string, nUP: string, userName: string, clusterID: number, flag: number): Observable<ListCustomerResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/VerifyCustomerNUP?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (nUP !== undefined)
            url_ += "NUP=" + encodeURIComponent("" + nUP) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifyCustomerNUP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifyCustomerNUP(response_);
                } catch (e) {
                    return <Observable<ListCustomerResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListCustomerResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processVerifyCustomerNUP(response: Response): Observable<ListCustomerResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListCustomerResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListCustomerResultDto[]>(<any>null);
    }

    /**
     * @scmCode (optional) 
     * @memberCodeParent (optional) 
     * @return Success
     */
    getListLevelDropdown(scmCode: string, memberCodeParent: string): Observable<GetListLevelResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerMember/getListLevelDropdown?";
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (memberCodeParent !== undefined)
            url_ += "memberCodeParent=" + encodeURIComponent("" + memberCodeParent) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListLevelDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListLevelDropdown(response_);
                } catch (e) {
                    return <Observable<GetListLevelResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListLevelResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListLevelDropdown(response: Response): Observable<GetListLevelResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListLevelResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListLevelResultDto[]>(<any>null);
    }
}

@Injectable()
export class CustomerPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerCusttomer(input: SignUpCustomerInputDto): Observable<SignUpCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPP/RegisterCusttomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterCusttomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterCusttomer(response_);
                } catch (e) {
                    return <Observable<SignUpCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignUpCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processRegisterCusttomer(response: Response): Observable<SignUpCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignUpCustomerResultDto.fromJS(resultData200) : new SignUpCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignUpCustomerResultDto>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @customerCode (optional) 
     * @return Success
     */
    getListCustomerPP(customerName: string, customerCode: string): Observable<GetListCustomerResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPP/GetListCustomerPP?";
        if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCustomerPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCustomerPP(response_);
                } catch (e) {
                    return <Observable<GetListCustomerResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListCustomerResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListCustomerPP(response: Response): Observable<GetListCustomerResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListCustomerResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListCustomerResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCustomerPP(input: UpdateCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPP/UpdateCustomerPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCustomerPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCustomerPP(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCustomerPP(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDropdownTerm(projectID: number): Observable<GetDropdownTermListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTerm?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTerm(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTerm(response: Response): Observable<GetDropdownTermListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllHargaUnit(projectID: number): Observable<GetAllHargaUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetAllHargaUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllHargaUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllHargaUnit(response_);
                } catch (e) {
                    return <Observable<GetAllHargaUnitListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllHargaUnitListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllHargaUnit(response: Response): Observable<GetAllHargaUnitListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAllHargaUnitListDto.fromJS(resultData200) : new GetAllHargaUnitListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllHargaUnitListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getHargaByTermList(projectID: number): Observable<GetHargaByTermListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetHargaByTermList?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHargaByTermList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHargaByTermList(response_);
                } catch (e) {
                    return <Observable<GetHargaByTermListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHargaByTermListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHargaByTermList(response: Response): Observable<GetHargaByTermListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetHargaByTermListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHargaByTermListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGrafikByDistrict(projectID: number, termID: number): Observable<GetGrafikListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetGrafikByDistrict?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGrafikByDistrict(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGrafikByDistrict(response_);
                } catch (e) {
                    return <Observable<GetGrafikListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGrafikListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGrafikByDistrict(response: Response): Observable<GetGrafikListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetGrafikListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGrafikListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGrafikByTypeCluster(projectID: number, termID: number): Observable<GetGrafikListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetGrafikByTypeCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGrafikByTypeCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGrafikByTypeCluster(response_);
                } catch (e) {
                    return <Observable<GetGrafikListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGrafikListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGrafikByTypeCluster(response: Response): Observable<GetGrafikListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetGrafikListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGrafikListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGrafikByTower(projectID: number, termID: number): Observable<GetGrafikListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetGrafikByTower?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGrafikByTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGrafikByTower(response_);
                } catch (e) {
                    return <Observable<GetGrafikListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGrafikListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGrafikByTower(response: Response): Observable<GetGrafikListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetGrafikListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGrafikListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @return Success
     */
    getDropdownProject(districtName: string, typeTower: string, tower: string): Observable<GetDropdownProjectDashListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownProject?";
        if (districtName !== undefined)
            url_ += "DistrictName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "TypeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "Tower=" + encodeURIComponent("" + tower) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProject(response_);
                } catch (e) {
                    return <Observable<GetDropdownProjectDashListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProjectDashListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProject(response: Response): Observable<GetDropdownProjectDashListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProjectDashListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProjectDashListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownDistrict(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownDistrictListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownDistrict?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownDistrict(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownDistrict(response_);
                } catch (e) {
                    return <Observable<GetDropdownDistrictListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownDistrictListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownDistrict(response: Response): Observable<GetDropdownDistrictListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownDistrictListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownDistrictListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownBlok(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownBlokListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownBlok?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownBlok(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownBlok(response_);
                } catch (e) {
                    return <Observable<GetDropdownBlokListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownBlokListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownBlok(response: Response): Observable<GetDropdownBlokListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownBlokListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownBlokListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownTypeTower(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownTypeTowerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTypeTower?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTypeTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTypeTower(response_);
                } catch (e) {
                    return <Observable<GetDropdownTypeTowerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTypeTowerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTypeTower(response: Response): Observable<GetDropdownTypeTowerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTypeTowerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTypeTowerListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownTower(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownTowerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTower?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTower(response_);
                } catch (e) {
                    return <Observable<GetDropdownTowerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTowerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTower(response: Response): Observable<GetDropdownTowerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTowerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTowerListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownTermCode(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownTermCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTermCode?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTermCode(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTermCode(response: Response): Observable<GetDropdownTermCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermCodeListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownRemarks(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownRemarksListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownRemarks?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRemarks(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRemarks(response_);
                } catch (e) {
                    return <Observable<GetDropdownRemarksListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRemarksListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRemarks(response: Response): Observable<GetDropdownRemarksListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRemarksListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRemarksListDto[]>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownTypeUnit(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownTypeUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTypeUnit?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTypeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTypeUnit(response_);
                } catch (e) {
                    return <Observable<GetDropdownTypeUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTypeUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTypeUnit(response: Response): Observable<GetDropdownTypeUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTypeUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTypeUnitListDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @clusterID (optional) 
     * @termCode (optional) 
     * @remarks (optional) 
     * @typeUnit (optional) 
     * @return Success
     */
    getTaskListDash(projectID: number[], districtName: string[], blok: string[], typeTower: string[], tower: string[], clusterID: number[], termCode: string[], remarks: string[], typeUnit: string[]): Observable<GetTaskListDashListDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTaskListDash?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (typeTower !== undefined)
            typeTower && typeTower.forEach(item => { url_ += "typeTower=" + encodeURIComponent("" + item) + "&"; });
        if (tower !== undefined)
            tower && tower.forEach(item => { url_ += "tower=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        if (termCode !== undefined)
            termCode && termCode.forEach(item => { url_ += "termCode=" + encodeURIComponent("" + item) + "&"; });
        if (remarks !== undefined)
            remarks && remarks.forEach(item => { url_ += "remarks=" + encodeURIComponent("" + item) + "&"; });
        if (typeUnit !== undefined)
            typeUnit && typeUnit.forEach(item => { url_ += "typeUnit=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListDash(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListDash(response_);
                } catch (e) {
                    return <Observable<GetTaskListDashListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListDashListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListDash(response: Response): Observable<GetTaskListDashListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTaskListDashListDto.fromJS(resultData200) : new GetTaskListDashListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListDashListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownProjectiHistory(): Observable<GetDropdownProjectDashListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownProjectiHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProjectiHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProjectiHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownProjectDashListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProjectDashListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProjectiHistory(response: Response): Observable<GetDropdownProjectDashListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProjectDashListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProjectDashListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownDistrictHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownDistrictListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownDistrictHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownDistrictHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownDistrictHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownDistrictListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownDistrictListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownDistrictHistory(response: Response): Observable<GetDropdownDistrictListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownDistrictListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownDistrictListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownBlokHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownBlokListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownBlokHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownBlokHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownBlokHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownBlokListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownBlokListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownBlokHistory(response: Response): Observable<GetDropdownBlokListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownBlokListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownBlokListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownTowerHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownTowerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTowerHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTowerHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTowerHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownTowerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTowerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTowerHistory(response: Response): Observable<GetDropdownTowerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTowerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTowerListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownTermCodeHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownTermCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTermCodeHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTermCodeHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTermCodeHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTermCodeHistory(response: Response): Observable<GetDropdownTermCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermCodeListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownRemarksHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownRemarksListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownRemarksHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRemarksHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRemarksHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownRemarksListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRemarksListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRemarksHistory(response: Response): Observable<GetDropdownRemarksListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRemarksListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRemarksListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownUnitHistory(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetDropdownUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownUnitHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitHistory(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitHistory(response: Response): Observable<GetDropdownUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitListDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @termID (optional) 
     * @termMainID (optional) 
     * @unitID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getHistoryPricing(projectID: number, termCode: string, termID: number, termMainID: number, unitID: number, districtName: string[], blok: string[], clusterID: string[]): Observable<GetHistoryPricingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetHistoryPricing?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termMainID !== undefined)
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryPricing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryPricing(response_);
                } catch (e) {
                    return <Observable<GetHistoryPricingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHistoryPricingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryPricing(response: Response): Observable<GetHistoryPricingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetHistoryPricingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHistoryPricingDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelHistoryPricing(input: ParamDropdownHistoryInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GenerateExcelHistoryPricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelHistoryPricing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelHistoryPricing(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelHistoryPricing(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTotalUnitByStatus(projectID: number): Observable<GetUnitByStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTotalUnitByStatus?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalUnitByStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalUnitByStatus(response_);
                } catch (e) {
                    return <Observable<GetUnitByStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitByStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalUnitByStatus(response: Response): Observable<GetUnitByStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitByStatusListDto.fromJS(resultData200) : new GetUnitByStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitByStatusListDto>(<any>null);
    }

    /**
     * @districtName (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @termID (optional) 
     * @termCode (optional) 
     * @listProjectID (optional) 
     * @listDistrictName (optional) 
     * @listClusterID (optional) 
     * @listTypeTower (optional) 
     * @listBlok (optional) 
     * @return Success
     */
    getDropdownTypeUnitDetail(districtName: string, typeTower: string, tower: string, termID: number, termCode: string, listProjectID: number[], listDistrictName: string[], listClusterID: string[], listTypeTower: string[], listBlok: string[]): Observable<GetDropdownTypeUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDropdownTypeUnitDetail?";
        if (districtName !== undefined)
            url_ += "districtName=" + encodeURIComponent("" + districtName) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (termID !== undefined)
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (listProjectID !== undefined)
            listProjectID && listProjectID.forEach(item => { url_ += "listProjectID=" + encodeURIComponent("" + item) + "&"; });
        if (listDistrictName !== undefined)
            listDistrictName && listDistrictName.forEach(item => { url_ += "listDistrictName=" + encodeURIComponent("" + item) + "&"; });
        if (listClusterID !== undefined)
            listClusterID && listClusterID.forEach(item => { url_ += "listClusterID=" + encodeURIComponent("" + item) + "&"; });
        if (listTypeTower !== undefined)
            listTypeTower && listTypeTower.forEach(item => { url_ += "listTypeTower=" + encodeURIComponent("" + item) + "&"; });
        if (listBlok !== undefined)
            listBlok && listBlok.forEach(item => { url_ += "listBlok=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTypeUnitDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTypeUnitDetail(response_);
                } catch (e) {
                    return <Observable<GetDropdownTypeUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTypeUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTypeUnitDetail(response: Response): Observable<GetDropdownTypeUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTypeUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTypeUnitListDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @districtName (optional) 
     * @blok (optional) 
     * @typeTower (optional) 
     * @tower (optional) 
     * @clusterID (optional) 
     * @termCode (optional) 
     * @remarks (optional) 
     * @typeUnit (optional) 
     * @return Success
     */
    getTaskListByStatus(projectID: number[], districtName: string[], blok: string[], typeTower: string[], tower: string[], clusterID: number[], termCode: string[], remarks: string[], typeUnit: string[]): Observable<GetUnitByStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTaskListByStatus?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        if (districtName !== undefined)
            districtName && districtName.forEach(item => { url_ += "districtName=" + encodeURIComponent("" + item) + "&"; });
        if (blok !== undefined)
            blok && blok.forEach(item => { url_ += "blok=" + encodeURIComponent("" + item) + "&"; });
        if (typeTower !== undefined)
            typeTower && typeTower.forEach(item => { url_ += "typeTower=" + encodeURIComponent("" + item) + "&"; });
        if (tower !== undefined)
            tower && tower.forEach(item => { url_ += "tower=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        if (termCode !== undefined)
            termCode && termCode.forEach(item => { url_ += "termCode=" + encodeURIComponent("" + item) + "&"; });
        if (remarks !== undefined)
            remarks && remarks.forEach(item => { url_ += "remarks=" + encodeURIComponent("" + item) + "&"; });
        if (typeUnit !== undefined)
            typeUnit && typeUnit.forEach(item => { url_ += "typeUnit=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListByStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListByStatus(response_);
                } catch (e) {
                    return <Observable<GetUnitByStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitByStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListByStatus(response: Response): Observable<GetUnitByStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitByStatusListDto.fromJS(resultData200) : new GetUnitByStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitByStatusListDto>(<any>null);
    }
}

@Injectable()
export class DashboardSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getTotalUnit(inputMemberCode: string): Observable<GetTotalUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalUnit?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalUnit(response_);
                } catch (e) {
                    return <Observable<GetTotalUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalUnit(response: Response): Observable<GetTotalUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalUnitDto.fromJS(resultData200) : new GetTotalUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalUnitDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTotalHotCustomer(inputUN: number): Observable<GetTotalHotCustomersDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalHotCustomer?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalHotCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalHotCustomer(response_);
                } catch (e) {
                    return <Observable<GetTotalHotCustomersDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalHotCustomersDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalHotCustomer(response: Response): Observable<GetTotalHotCustomersDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalHotCustomersDto.fromJS(resultData200) : new GetTotalHotCustomersDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalHotCustomersDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTotalCancelUnit(inputUN: number): Observable<GetTotalCancelUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalCancelUnit?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCancelUnit(response_);
                } catch (e) {
                    return <Observable<GetTotalCancelUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCancelUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCancelUnit(response: Response): Observable<GetTotalCancelUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalCancelUnitDto.fromJS(resultData200) : new GetTotalCancelUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCancelUnitDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @summary (optional) 
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getTotalSales(memberCode: string, summary: number, start: string, end: string): Observable<GetTotalSalesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalSales?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (summary !== undefined)
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalSales(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalSales(response_);
                } catch (e) {
                    return <Observable<GetTotalSalesDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalSalesDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalSales(response: Response): Observable<GetTotalSalesDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalSalesDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalSalesDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @summary (optional) 
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getRevenueAndTax(memberCode: string, summary: number, start: string, end: string): Observable<GetRevenueAndTaxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetRevenueAndTax?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (summary !== undefined)
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRevenueAndTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRevenueAndTax(response_);
                } catch (e) {
                    return <Observable<GetRevenueAndTaxDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRevenueAndTaxDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRevenueAndTax(response: Response): Observable<GetRevenueAndTaxDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRevenueAndTaxDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRevenueAndTaxDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getTotalProfit(memberCode: string): Observable<GetTotalProfitDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalProfit?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalProfit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalProfit(response_);
                } catch (e) {
                    return <Observable<GetTotalProfitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalProfitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalProfit(response: Response): Observable<GetTotalProfitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalProfitDto.fromJS(resultData200) : new GetTotalProfitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalProfitDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListMember(userID: number): Observable<GetListMemberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetListMember?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMember(response_);
                } catch (e) {
                    return <Observable<GetListMemberDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMemberDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMember(response: Response): Observable<GetListMemberDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMemberDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMemberDto[]>(<any>null);
    }

    /**
     * @summary (optional) 
     * @return Success
     */
    getTotalUnitSold(inputUN: number, summary: number): Observable<GetTotalUnitSoldDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalUnitSold?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        if (summary !== undefined)
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalUnitSold(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalUnitSold(response_);
                } catch (e) {
                    return <Observable<GetTotalUnitSoldDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalUnitSoldDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalUnitSold(response: Response): Observable<GetTotalUnitSoldDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalUnitSoldDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalUnitSoldDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitCancelTransaction(inputUN: number): Observable<GetUnitTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetUnitCancelTransaction?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitCancelTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitCancelTransaction(response_);
                } catch (e) {
                    return <Observable<GetUnitTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitCancelTransaction(response: Response): Observable<GetUnitTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitTransactionDto.fromJS(resultData200) : new GetUnitTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPPCancelTransaction(inputUN: number): Observable<GetPPTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetPPCancelTransaction?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPCancelTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPCancelTransaction(response_);
                } catch (e) {
                    return <Observable<GetPPTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPPTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPPCancelTransaction(response: Response): Observable<GetPPTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPPTransactionDto.fromJS(resultData200) : new GetPPTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPPTransactionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDailyPPTransaction(inputUN: number): Observable<GetDailyPPTransaction[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetDailyPPTransaction?";
        if (inputUN === undefined || inputUN === null)
            throw new Error("The parameter 'inputUN' must be defined and cannot be null.");
        else
            url_ += "inputUN=" + encodeURIComponent("" + inputUN) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDailyPPTransaction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDailyPPTransaction(response_);
                } catch (e) {
                    return <Observable<GetDailyPPTransaction[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDailyPPTransaction[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDailyPPTransaction(response: Response): Observable<GetDailyPPTransaction[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDailyPPTransaction.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDailyPPTransaction[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getTotalCustomer(inputMemberCode: string, start: string, end: string, summary: number): Observable<GetTotalCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalCustomer?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCustomer(response_);
                } catch (e) {
                    return <Observable<GetTotalCustomerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCustomerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCustomer(response: Response): Observable<GetTotalCustomerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCustomerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCustomerDto[]>(<any>null);
    }

    /**
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getTotalPotentialCustomer(inputUn: number, start: string, end: string, summary: number): Observable<GetTotalPotentialCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalPotentialCustomer?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalPotentialCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalPotentialCustomer(response_);
                } catch (e) {
                    return <Observable<GetTotalPotentialCustomerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalPotentialCustomerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalPotentialCustomer(response: Response): Observable<GetTotalPotentialCustomerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalPotentialCustomerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalPotentialCustomerDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getTotalCommission(inputMemberCode: string, start: string, end: string, summary: number): Observable<GetTotalCommissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalCommission?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCommission(response_);
                } catch (e) {
                    return <Observable<GetTotalCommissionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCommissionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCommission(response: Response): Observable<GetTotalCommissionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCommissionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCommissionDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @start (optional) 
     * @end (optional) 
     * @return Success
     */
    getTotalCommissionPaid(inputMemberCode: string, start: string, end: string, summary: number): Observable<GetTotalCommissionPaidDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetTotalCommissionPaid?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCommissionPaid(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCommissionPaid(response_);
                } catch (e) {
                    return <Observable<GetTotalCommissionPaidDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCommissionPaidDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCommissionPaid(response: Response): Observable<GetTotalCommissionPaidDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCommissionPaidDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCommissionPaidDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getSchemaCode(memberCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/getSchemaCode?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSchemaCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSchemaCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetSchemaCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @marketingProgram (optional) 
     * @return Success
     */
    getDataMarketingProgram(periodeStartBooking: moment.Moment, periodeEndBooking: moment.Moment, memberCode: string, marketingProgram: string): Observable<GetDataMarketingProgramListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetDataMarketingProgram?";
        if (periodeStartBooking === undefined || periodeStartBooking === null)
            throw new Error("The parameter 'periodeStartBooking' must be defined and cannot be null.");
        else
            url_ += "periodeStartBooking=" + encodeURIComponent(periodeStartBooking ? "" + periodeStartBooking.toJSON() : "") + "&"; 
        if (periodeEndBooking === undefined || periodeEndBooking === null)
            throw new Error("The parameter 'periodeEndBooking' must be defined and cannot be null.");
        else
            url_ += "periodeEndBooking=" + encodeURIComponent(periodeEndBooking ? "" + periodeEndBooking.toJSON() : "") + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (marketingProgram !== undefined)
            url_ += "marketingProgram=" + encodeURIComponent("" + marketingProgram) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMarketingProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMarketingProgram(response_);
                } catch (e) {
                    return <Observable<GetDataMarketingProgramListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMarketingProgramListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMarketingProgram(response: Response): Observable<GetDataMarketingProgramListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataMarketingProgramListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMarketingProgramListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFMarketingProgram(input: GetDataMarketingProgramListDto[]): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GeneratePDFMarketingProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFMarketingProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFMarketingProgram(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFMarketingProgram(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownScmCode(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/getDropdownScmCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownScmCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownScmCode(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownScmCode(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @schemaCode (optional) 
     * @return Success
     */
    getCommisionReport(startDate: moment.Moment, endDate: moment.Moment, schemaCode: string[]): Observable<GetCommisionReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetCommisionReport?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (schemaCode !== undefined)
            schemaCode && schemaCode.forEach(item => { url_ += "schemaCode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommisionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommisionReport(response_);
                } catch (e) {
                    return <Observable<GetCommisionReportDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCommisionReportDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCommisionReport(response: Response): Observable<GetCommisionReportDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCommisionReportDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCommisionReportDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    listMemberParent(memberCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/listMemberParent?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListMemberParent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListMemberParent(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processListMemberParent(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    listMemberParentWithStatus(memberCode: string): Observable<StatusMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/listMemberParentWithStatus?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListMemberParentWithStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListMemberParentWithStatus(response_);
                } catch (e) {
                    return <Observable<StatusMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StatusMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processListMemberParentWithStatus(response: Response): Observable<StatusMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StatusMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StatusMemberCodeDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    listMemberWithStatus(memberCode: string): Observable<StatusMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/listMemberWithStatus?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListMemberWithStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListMemberWithStatus(response_);
                } catch (e) {
                    return <Observable<StatusMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<StatusMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processListMemberWithStatus(response: Response): Observable<StatusMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(StatusMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StatusMemberCodeDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateCommisionReport(input: GenerateCommReportParamInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GenerateCommisionReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateCommisionReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateCommisionReport(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateCommisionReport(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(userID: number): Observable<GetRolesListDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetRoles?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoles(response_);
                } catch (e) {
                    return <Observable<GetRolesListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRolesListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRoles(response: Response): Observable<GetRolesListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRolesListDto.fromJS(resultData200) : new GetRolesListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRolesListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProjectForDashboard(): Observable<ListResultDtoOfProjectDropdown> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetProjectForDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectForDashboard(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectForDashboard(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProjectDropdown>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProjectDropdown>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectForDashboard(response: Response): Observable<ListResultDtoOfProjectDropdown> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProjectDropdown.fromJS(resultData200) : new ListResultDtoOfProjectDropdown();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProjectDropdown>(<any>null);
    }

    /**
     * @return Success
     */
    getProductBasedProject(projectId: number): Observable<ProductDropdown[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetProductBasedProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductBasedProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductBasedProject(response_);
                } catch (e) {
                    return <Observable<ProductDropdown[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProductDropdown[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProductBasedProject(response: Response): Observable<ProductDropdown[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ProductDropdown.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProductDropdown[]>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getAllTotalDataDashboard(projectId: number, productId: number, startDate: string, endDate: string): Observable<GetAllTotalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardSP/GetAllTotalDataDashboard?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTotalDataDashboard(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTotalDataDashboard(response_);
                } catch (e) {
                    return <Observable<GetAllTotalDataDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllTotalDataDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTotalDataDashboard(response: Response): Observable<GetAllTotalDataDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAllTotalDataDto.fromJS(resultData200) : new GetAllTotalDataDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllTotalDataDto>(<any>null);
    }
}

@Injectable()
export class DeleteRenovPerUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListProjectMapping(): Observable<GetListProjectMappingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetListProjectMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectMapping(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectMapping(response_);
                } catch (e) {
                    return <Observable<GetListProjectMappingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectMappingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectMapping(response: Response): Observable<GetListProjectMappingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectMappingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectMappingResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListCluster(projectID: number): Observable<GetListClusterResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetListCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCluster(response_);
                } catch (e) {
                    return <Observable<GetListClusterResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListClusterResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListCluster(response: Response): Observable<GetListClusterResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListClusterResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListClusterResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTerm(projectID: number): Observable<GetListTermResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetListTerm?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTerm(response_);
                } catch (e) {
                    return <Observable<GetListTermResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListTermResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTerm(response: Response): Observable<GetListTermResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListTermResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListTermResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListUnitCodeUnitNo(projectID: number, clusterID: number, termMainID: number, renovID: number): Observable<GetListUnitCodeUnitNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetListUnitCodeUnitNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (termMainID === undefined || termMainID === null)
            throw new Error("The parameter 'termMainID' must be defined and cannot be null.");
        else
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitCodeUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitCodeUnitNo(response_);
                } catch (e) {
                    return <Observable<GetListUnitCodeUnitNoResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListUnitCodeUnitNoResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitCodeUnitNo(response: Response): Observable<GetListUnitCodeUnitNoResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListUnitCodeUnitNoResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListUnitCodeUnitNoResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTaskListRenov(input: GetTaskListInputDto): Observable<GetTaskListRenovResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetTaskListRenov";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListRenov(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListRenov(response_);
                } catch (e) {
                    return <Observable<GetTaskListRenovResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListRenovResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListRenov(response: Response): Observable<GetTaskListRenovResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTaskListRenovResultDto.fromJS(resultData200) : new GetTaskListRenovResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListRenovResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteRenov(input: DeleteRenovInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/DeleteRenov";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRenov(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteRenov(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRenov(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownRenovation(projectID: number, clusterID: number): Observable<GetDropDownRenovResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DeleteRenovPerUnit/GetDropdownRenovation?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRenovation(response_);
                } catch (e) {
                    return <Observable<GetDropDownRenovResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownRenovResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRenovation(response: Response): Observable<GetDropDownRenovResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownRenovResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownRenovResultDto[]>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDate(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDate(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateTime(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateTime(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment, endDate: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateRange(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateRange(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @selectedCountries (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(selectedCountries: NameValueOfString[]): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedCountries);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetSelectedCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetSelectedCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetValue(response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<StringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetValue(response: Response): Observable<StringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StringOutput>(<any>null);
    }
}

@Injectable()
export class DiagramaticServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @psCode (optional) 
     * @userName (optional) 
     * @return Success
     */
    getDropdownPPNo(psCode: string, clusterID: number, userName: string): Observable<ResultDropdownPPno[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDropdownPPNo?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownPPNo(response_);
                } catch (e) {
                    return <Observable<ResultDropdownPPno[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultDropdownPPno[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownPPNo(response: Response): Observable<ResultDropdownPPno[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultDropdownPPno.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultDropdownPPno[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    checkRolesAdmin(memberCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/CheckRolesAdmin?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckRolesAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckRolesAdmin(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckRolesAdmin(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDropdownPPNoMobile(psCode: string, projectID: number): Observable<GetListPPNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDropdownPPNoMobile?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownPPNoMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownPPNoMobile(response_);
                } catch (e) {
                    return <Observable<GetListPPNoResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPPNoResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownPPNoMobile(response: Response): Observable<GetListPPNoResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPPNoResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPPNoResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListPPNo(userID: number): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListPPNo?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPPNo(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPPNo(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListPPNoMobile(userID: number): Observable<GetListPPNoResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListPPNoMobile?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPPNoMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPPNoMobile(response_);
                } catch (e) {
                    return <Observable<GetListPPNoResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPPNoResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPPNoMobile(response: Response): Observable<GetListPPNoResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPPNoResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPPNoResultDto[]>(<any>null);
    }

    /**
     * @bankID (optional) 
     * @return Success
     */
    getListBankKPA(projectID: number, bankID: number): Observable<GetListBankKPADto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListBankKPA?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (bankID !== undefined)
            url_ += "bankID=" + encodeURIComponent("" + bankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBankKPA(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBankKPA(response_);
                } catch (e) {
                    return <Observable<GetListBankKPADto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListBankKPADto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBankKPA(response: Response): Observable<GetListBankKPADto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListBankKPADto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListBankKPADto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitDetailWithTower(unitID: number): Observable<UnitDetailResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetUnitDetailWithTower?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitDetailWithTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitDetailWithTower(response_);
                } catch (e) {
                    return <Observable<UnitDetailResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitDetailResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitDetailWithTower(response: Response): Observable<UnitDetailResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UnitDetailResultDto.fromJS(resultData200) : new UnitDetailResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitDetailResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    listPrice(input: ListPriceInputDto): Observable<ListResultDtoOfListPriceResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/ListPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListPrice(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListPriceResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListPriceResultDto>><any>Observable.throw(response_);
        });
    }

    protected processListPrice(response: Response): Observable<ListResultDtoOfListPriceResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListPriceResultDto.fromJS(resultData200) : new ListResultDtoOfListPriceResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListPriceResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListUnitByUnitCode(unitCodeId: number, projectId: number): Observable<ListResultDtoOfListUnitByUnitCodeResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListUnitByUnitCode?";
        if (unitCodeId === undefined || unitCodeId === null)
            throw new Error("The parameter 'unitCodeId' must be defined and cannot be null.");
        else
            url_ += "unitCodeId=" + encodeURIComponent("" + unitCodeId) + "&"; 
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitByUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitByUnitCode(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListUnitByUnitCodeResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListUnitByUnitCodeResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitByUnitCode(response: Response): Observable<ListResultDtoOfListUnitByUnitCodeResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListUnitByUnitCodeResultDto.fromJS(resultData200) : new ListResultDtoOfListUnitByUnitCodeResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListUnitByUnitCodeResultDto>(<any>null);
    }

    /**
     * @productId (optional) 
     * @searchBox (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getListTowerByProjectID(projectId: number, productId: number, searchBox: string, memberCode: string): Observable<ListResultDtoOfListTowerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListTowerByProjectID?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTowerByProjectID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTowerByProjectID(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListTowerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListTowerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListTowerByProjectID(response: Response): Observable<ListResultDtoOfListTowerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListTowerResultDto.fromJS(resultData200) : new ListResultDtoOfListTowerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListTowerResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    checkMemberCluster(clusterID: number, memberCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/CheckMemberCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckMemberCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckMemberCluster(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckMemberCluster(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @priceMin (optional) 
     * @priceMax (optional) 
     * @bedroomMin (optional) 
     * @bedroomMax (optional) 
     * @areaMin (optional) 
     * @areaMax (optional) 
     * @clusterName (optional) 
     * @memberCode (optional) 
     * @clusterId (optional) 
     * @regionName (optional) 
     * @checkBoxFacing (optional) 
     * @productName (optional) 
     * @searchBox (optional) 
     * @return Success
     */
    getListTowerByAdvancedFilter(projectId: number, priceMin: number, priceMax: number, bedroomMin: number, bedroomMax: number, areaMin: number, areaMax: number, clusterName: string, memberCode: string, clusterId: number, regionName: string, checkBoxFacing: number[], productName: string, searchBox: string): Observable<ListResultDtoOfListTowerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListTowerByAdvancedFilter?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (priceMin !== undefined)
            url_ += "priceMin=" + encodeURIComponent("" + priceMin) + "&"; 
        if (priceMax !== undefined)
            url_ += "priceMax=" + encodeURIComponent("" + priceMax) + "&"; 
        if (bedroomMin !== undefined)
            url_ += "bedroomMin=" + encodeURIComponent("" + bedroomMin) + "&"; 
        if (bedroomMax !== undefined)
            url_ += "bedroomMax=" + encodeURIComponent("" + bedroomMax) + "&"; 
        if (areaMin !== undefined)
            url_ += "areaMin=" + encodeURIComponent("" + areaMin) + "&"; 
        if (areaMax !== undefined)
            url_ += "areaMax=" + encodeURIComponent("" + areaMax) + "&"; 
        if (clusterName !== undefined)
            url_ += "clusterName=" + encodeURIComponent("" + clusterName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (regionName !== undefined)
            url_ += "regionName=" + encodeURIComponent("" + regionName) + "&"; 
        if (checkBoxFacing !== undefined)
            checkBoxFacing && checkBoxFacing.forEach(item => { url_ += "checkBoxFacing=" + encodeURIComponent("" + item) + "&"; });
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTowerByAdvancedFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTowerByAdvancedFilter(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListTowerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListTowerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListTowerByAdvancedFilter(response: Response): Observable<ListResultDtoOfListTowerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListTowerResultDto.fromJS(resultData200) : new ListResultDtoOfListTowerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListTowerResultDto>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @bedroom (optional) 
     * @unitType (optional) 
     * @floor (optional) 
     * @return Success
     */
    getListDiagramatic(projectId: number, clusterId: number, detailID: number, bedroom: string, unitType: string, zoningID: number, floor: string): Observable<GetDiagramaticResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramatic?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        if (bedroom !== undefined)
            url_ += "bedroom=" + encodeURIComponent("" + bedroom) + "&"; 
        if (unitType !== undefined)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&"; 
        if (zoningID === undefined || zoningID === null)
            throw new Error("The parameter 'zoningID' must be defined and cannot be null.");
        else
            url_ += "zoningID=" + encodeURIComponent("" + zoningID) + "&"; 
        if (floor !== undefined)
            url_ += "floor=" + encodeURIComponent("" + floor) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramatic(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramatic(response: Response): Observable<GetDiagramaticResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticResultDto[]>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @priceMin (optional) 
     * @priceMax (optional) 
     * @bedroomMin (optional) 
     * @bedroomMax (optional) 
     * @areaMin (optional) 
     * @areaMax (optional) 
     * @clusterName (optional) 
     * @memberCode (optional) 
     * @clusterId (optional) 
     * @regionName (optional) 
     * @checkBoxFacing (optional) 
     * @productName (optional) 
     * @searchBox (optional) 
     * @return Success
     */
    getListDiagramaticByAdvancedFilter(projectId: number, priceMin: number, priceMax: number, bedroomMin: number, bedroomMax: number, areaMin: number, areaMax: number, clusterName: string, memberCode: string, clusterId: number, regionName: string, checkBoxFacing: number[], productName: string, searchBox: string): Observable<GetDiagramaticResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticByAdvancedFilter?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (priceMin !== undefined)
            url_ += "priceMin=" + encodeURIComponent("" + priceMin) + "&"; 
        if (priceMax !== undefined)
            url_ += "priceMax=" + encodeURIComponent("" + priceMax) + "&"; 
        if (bedroomMin !== undefined)
            url_ += "bedroomMin=" + encodeURIComponent("" + bedroomMin) + "&"; 
        if (bedroomMax !== undefined)
            url_ += "bedroomMax=" + encodeURIComponent("" + bedroomMax) + "&"; 
        if (areaMin !== undefined)
            url_ += "areaMin=" + encodeURIComponent("" + areaMin) + "&"; 
        if (areaMax !== undefined)
            url_ += "areaMax=" + encodeURIComponent("" + areaMax) + "&"; 
        if (clusterName !== undefined)
            url_ += "clusterName=" + encodeURIComponent("" + clusterName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (regionName !== undefined)
            url_ += "regionName=" + encodeURIComponent("" + regionName) + "&"; 
        if (checkBoxFacing !== undefined)
            checkBoxFacing && checkBoxFacing.forEach(item => { url_ += "checkBoxFacing=" + encodeURIComponent("" + item) + "&"; });
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticByAdvancedFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticByAdvancedFilter(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticByAdvancedFilter(response: Response): Observable<GetDiagramaticResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListRenovation(unitID: number): Observable<ListRenovationResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListRenovation?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRenovation(response_);
                } catch (e) {
                    return <Observable<ListRenovationResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListRenovationResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRenovation(response: Response): Observable<ListRenovationResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListRenovationResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListRenovationResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTerm(unitID: number, renovID: number): Observable<ListTermResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListTerm?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTerm(response_);
                } catch (e) {
                    return <Observable<ListTermResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListTermResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTerm(response: Response): Observable<ListTermResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListTermResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListTermResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGrossPrice(unitID: number, renovID: number, termID: number): Observable<GrossPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetGrossPrice?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGrossPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGrossPrice(response_);
                } catch (e) {
                    return <Observable<GrossPriceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GrossPriceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetGrossPrice(response: Response): Observable<GrossPriceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GrossPriceDto.fromJS(resultData200) : new GrossPriceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GrossPriceDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkPriceIncludePPn(projectID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/CheckPriceIncludePPn?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckPriceIncludePPn(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckPriceIncludePPn(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCheckPriceIncludePPn(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getSettingKpr(projectID: number): Observable<GetKprSettingResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetSettingKpr?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSettingKpr(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSettingKpr(response_);
                } catch (e) {
                    return <Observable<GetKprSettingResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKprSettingResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSettingKpr(response: Response): Observable<GetKprSettingResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetKprSettingResultDto.fromJS(resultData200) : new GetKprSettingResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKprSettingResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownDp(): Observable<GetDropDownDpListDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDropdownDp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownDp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownDp(response_);
                } catch (e) {
                    return <Observable<GetDropDownDpListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownDpListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownDp(response: Response): Observable<GetDropDownDpListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDropDownDpListDto.fromJS(resultData200) : new GetDropDownDpListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownDpListDto>(<any>null);
    }

    /**
     * @tenor (optional) 
     * @sukuBunga (optional) 
     * @return Success
     */
    getAngsuranUnitPrice(unitID: number, renovID: number, termID: number, grossPrice: number, downPayment: number, tenor: number, sukuBunga: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetAngsuranUnitPrice?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (grossPrice === undefined || grossPrice === null)
            throw new Error("The parameter 'grossPrice' must be defined and cannot be null.");
        else
            url_ += "grossPrice=" + encodeURIComponent("" + grossPrice) + "&"; 
        if (downPayment === undefined || downPayment === null)
            throw new Error("The parameter 'downPayment' must be defined and cannot be null.");
        else
            url_ += "downPayment=" + encodeURIComponent("" + downPayment) + "&"; 
        if (tenor !== undefined)
            url_ += "tenor=" + encodeURIComponent("" + tenor) + "&"; 
        if (sukuBunga !== undefined)
            url_ += "sukuBunga=" + encodeURIComponent("" + sukuBunga) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAngsuranUnitPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAngsuranUnitPrice(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetAngsuranUnitPrice(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @return Success
     */
    getListDiagramaticFlutter(projectId: number, clusterId: number, detailID: number): Observable<GetListDiagramaticFlutterResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticFlutter?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticFlutter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticFlutter(response_);
                } catch (e) {
                    return <Observable<GetListDiagramaticFlutterResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListDiagramaticFlutterResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticFlutter(response: Response): Observable<GetListDiagramaticFlutterResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListDiagramaticFlutterResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListDiagramaticFlutterResultDto[]>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @bedroom (optional) 
     * @unitType (optional) 
     * @floor (optional) 
     * @return Success
     */
    getListDiagramaticWeb(projectId: number, clusterId: number, detailID: number, bedroom: string, unitType: string, zoningID: number, floor: string): Observable<GetDiagramaticForWebListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticWeb?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        if (bedroom !== undefined)
            url_ += "bedroom=" + encodeURIComponent("" + bedroom) + "&"; 
        if (unitType !== undefined)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&"; 
        if (zoningID === undefined || zoningID === null)
            throw new Error("The parameter 'zoningID' must be defined and cannot be null.");
        else
            url_ += "zoningID=" + encodeURIComponent("" + zoningID) + "&"; 
        if (floor !== undefined)
            url_ += "floor=" + encodeURIComponent("" + floor) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticWeb(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticForWebListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticForWebListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticWeb(response: Response): Observable<GetDiagramaticForWebListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticForWebListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticForWebListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifyPPNo(input: VerifyPPNoInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/VerifyPPNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifyPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifyPPNo(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processVerifyPPNo(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @pPNo (optional) 
     * @clusterID (optional) 
     * @projectInfoID (optional) 
     * @userName (optional) 
     * @return Success
     */
    newVerifyPPNo(pPNo: string, clusterID: number, projectInfoID: number, userName: string): Observable<ResultPPNewMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/NewVerifyPPNo?";
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectInfoID !== undefined)
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processNewVerifyPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processNewVerifyPPNo(response_);
                } catch (e) {
                    return <Observable<ResultPPNewMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultPPNewMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processNewVerifyPPNo(response: Response): Observable<ResultPPNewMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultPPNewMessageDto.fromJS(resultData200) : new ResultPPNewMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultPPNewMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitSelectionDetail(unitID: number): Observable<GetUnitSelectionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetUnitSelectionDetail?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitSelectionDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitSelectionDetail(response_);
                } catch (e) {
                    return <Observable<GetUnitSelectionDetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitSelectionDetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitSelectionDetail(response: Response): Observable<GetUnitSelectionDetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitSelectionDetailDto.fromJS(resultData200) : new GetUnitSelectionDetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitSelectionDetailDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitSelectionDetailMobile(unitID: number): Observable<GetUnitSelectionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetUnitSelectionDetailMobile?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitSelectionDetailMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitSelectionDetailMobile(response_);
                } catch (e) {
                    return <Observable<GetUnitSelectionDetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitSelectionDetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitSelectionDetailMobile(response: Response): Observable<GetUnitSelectionDetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitSelectionDetailDto.fromJS(resultData200) : new GetUnitSelectionDetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitSelectionDetailDto>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @return Success
     */
    getTypeDiagramatic(projectId: number, clusterId: number, detailID: number): Observable<TypeDiagramaticResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetTypeDiagramatic?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTypeDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTypeDiagramatic(response_);
                } catch (e) {
                    return <Observable<TypeDiagramaticResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TypeDiagramaticResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTypeDiagramatic(response: Response): Observable<TypeDiagramaticResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TypeDiagramaticResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TypeDiagramaticResultDto[]>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @return Success
     */
    getTypeDiagramaticWeb(projectId: number, clusterId: number, detailID: number): Observable<TypeDiagramaticResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetTypeDiagramaticWeb?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTypeDiagramaticWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTypeDiagramaticWeb(response_);
                } catch (e) {
                    return <Observable<TypeDiagramaticResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TypeDiagramaticResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTypeDiagramaticWeb(response: Response): Observable<TypeDiagramaticResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TypeDiagramaticResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TypeDiagramaticResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListBedroom(projectID: number, clusterID: number): Observable<ListBedroomResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListBedroom?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBedroom(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBedroom(response_);
                } catch (e) {
                    return <Observable<ListBedroomResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListBedroomResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBedroom(response: Response): Observable<ListBedroomResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListBedroomResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListBedroomResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListZoning(projectID: number, clusterID: number): Observable<ListZoningResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListZoning?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListZoning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListZoning(response_);
                } catch (e) {
                    return <Observable<ListZoningResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListZoningResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListZoning(response: Response): Observable<ListZoningResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListZoningResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListZoningResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListSumberDana(): Observable<ListSumberDanaResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListSumberDana";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSumberDana(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSumberDana(response_);
                } catch (e) {
                    return <Observable<ListSumberDanaResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListSumberDanaResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListSumberDana(response: Response): Observable<ListSumberDanaResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListSumberDanaResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListSumberDanaResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTujuanTransaksi(): Observable<ListTujuanTransaksiResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListTujuanTransaksi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTujuanTransaksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTujuanTransaksi(response_);
                } catch (e) {
                    return <Observable<ListTujuanTransaksiResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListTujuanTransaksiResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTujuanTransaksi(response: Response): Observable<ListTujuanTransaksiResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListTujuanTransaksiResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListTujuanTransaksiResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailDiagramatic(unitID: number): Observable<ListDetailDiagramaticWebResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDetailDiagramatic?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailDiagramatic(response_);
                } catch (e) {
                    return <Observable<ListDetailDiagramaticWebResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDetailDiagramaticWebResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailDiagramatic(response: Response): Observable<ListDetailDiagramaticWebResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListDetailDiagramaticWebResultDto.fromJS(resultData200) : new ListDetailDiagramaticWebResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDetailDiagramaticWebResultDto>(<any>null);
    }

    /**
     * @userName (optional) 
     * @return Success
     */
    getDetailDiagramaticWeb(unitID: number, userName: string): Observable<ListDetailDiagramaticNewResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDetailDiagramaticWeb?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailDiagramaticWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailDiagramaticWeb(response_);
                } catch (e) {
                    return <Observable<ListDetailDiagramaticNewResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDetailDiagramaticNewResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailDiagramaticWeb(response: Response): Observable<ListDetailDiagramaticNewResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListDetailDiagramaticNewResultDto.fromJS(resultData200) : new ListDetailDiagramaticNewResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDetailDiagramaticNewResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPPNUnit(unitID: number, price: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetPPNUnit?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (price === undefined || price === null)
            throw new Error("The parameter 'price' must be defined and cannot be null.");
        else
            url_ += "price=" + encodeURIComponent("" + price) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPNUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPNUnit(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetPPNUnit(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentType(): Observable<ListPaymentTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetPaymentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentType(response_);
                } catch (e) {
                    return <Observable<ListPaymentTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListPaymentTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentType(response: Response): Observable<ListPaymentTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListPaymentTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListPaymentTypeResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListPaymentTypeGateway(projectID: number): Observable<ListPaymentTypeGatewayResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListPaymentTypeGateway?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPaymentTypeGateway(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPaymentTypeGateway(response_);
                } catch (e) {
                    return <Observable<ListPaymentTypeGatewayResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListPaymentTypeGatewayResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListPaymentTypeGateway(response: Response): Observable<ListPaymentTypeGatewayResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListPaymentTypeGatewayResultDto.fromJS(resultData200) : new ListPaymentTypeGatewayResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListPaymentTypeGatewayResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailImage(unitID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDetailImage?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailImage(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailImage(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownUnitCodeMobile(projectID: number, clusterID: number): Observable<GetDropdownUnitCodeMobileResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDropdownUnitCodeMobile?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitCodeMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitCodeMobile(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitCodeMobileResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitCodeMobileResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitCodeMobile(response: Response): Observable<GetDropdownUnitCodeMobileResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitCodeMobileResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitCodeMobileResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownUnitNoMobile(unitCodeID: number): Observable<GetDropdownUnitNoMobileResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDropdownUnitNoMobile?";
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitNoMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitNoMobile(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitNoMobileResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitNoMobileResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitNoMobile(response: Response): Observable<GetDropdownUnitNoMobileResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitNoMobileResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitNoMobileResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserRoles(userID: number): Observable<GetUserRolesDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetUserRoles?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserRoles(response_);
                } catch (e) {
                    return <Observable<GetUserRolesDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserRolesDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserRoles(response: Response): Observable<GetUserRolesDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserRolesDto.fromJS(resultData200) : new GetUserRolesDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserRolesDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkUnitShowDiagramatic(unitID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/CheckUnitShowDiagramatic?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckUnitShowDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckUnitShowDiagramatic(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckUnitShowDiagramatic(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @unitNo (optional) 
     * @return Success
     */
    getUnitFloorAvailable(clusterID: number, unitNo: string): Observable<SitePlanUnitFloorAvailableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetUnitFloorAvailable?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitFloorAvailable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitFloorAvailable(response_);
                } catch (e) {
                    return <Observable<SitePlanUnitFloorAvailableDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SitePlanUnitFloorAvailableDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitFloorAvailable(response: Response): Observable<SitePlanUnitFloorAvailableDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SitePlanUnitFloorAvailableDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SitePlanUnitFloorAvailableDto[]>(<any>null);
    }

    /**
     * @detailID (optional) 
     * @bedroom (optional) 
     * @unitType (optional) 
     * @floor (optional) 
     * @return Success
     */
    getListDiagramaticSVGWeb(projectId: number, clusterId: number, detailID: number, bedroom: string, unitType: string, zoningID: number, floor: string): Observable<DiagramaticSitePlanWebListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticSVGWeb?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (detailID !== undefined)
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        if (bedroom !== undefined)
            url_ += "bedroom=" + encodeURIComponent("" + bedroom) + "&"; 
        if (unitType !== undefined)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&"; 
        if (zoningID === undefined || zoningID === null)
            throw new Error("The parameter 'zoningID' must be defined and cannot be null.");
        else
            url_ += "zoningID=" + encodeURIComponent("" + zoningID) + "&"; 
        if (floor !== undefined)
            url_ += "floor=" + encodeURIComponent("" + floor) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticSVGWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticSVGWeb(response_);
                } catch (e) {
                    return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticSVGWeb(response: Response): Observable<DiagramaticSitePlanWebListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DiagramaticSitePlanWebListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DiagramaticSitePlanWebListDto[]>(<any>null);
    }

    /**
     * @projectInfoId (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getListDiagramaticSitePlanWeb(projectInfoId: number, clusterId: number): Observable<DiagramaticSitePlanWebListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticSitePlanWeb?";
        if (projectInfoId !== undefined)
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticSitePlanWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticSitePlanWeb(response_);
                } catch (e) {
                    return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticSitePlanWeb(response: Response): Observable<DiagramaticSitePlanWebListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DiagramaticSitePlanWebListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DiagramaticSitePlanWebListDto[]>(<any>null);
    }

    /**
     * @projectInfoId (optional) 
     * @clusterId (optional) 
     * @return Success
     */
    getListDiagramaticSitePlanWebAll(projectInfoId: number, clusterId: number): Observable<DiagramaticSitePlanWebListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListDiagramaticSitePlanWebAll?";
        if (projectInfoId !== undefined)
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDiagramaticSitePlanWebAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDiagramaticSitePlanWebAll(response_);
                } catch (e) {
                    return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DiagramaticSitePlanWebListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDiagramaticSitePlanWebAll(response: Response): Observable<DiagramaticSitePlanWebListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DiagramaticSitePlanWebListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DiagramaticSitePlanWebListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailClusterByUnitId(unitID: number): Observable<GetDetailClusterByUnitId> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetDetailClusterByUnitId?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailClusterByUnitId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailClusterByUnitId(response_);
                } catch (e) {
                    return <Observable<GetDetailClusterByUnitId>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailClusterByUnitId>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailClusterByUnitId(response: Response): Observable<GetDetailClusterByUnitId> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailClusterByUnitId.fromJS(resultData200) : new GetDetailClusterByUnitId();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailClusterByUnitId>(<any>null);
    }

    /**
     * @return Success
     */
    getListMarketingProgram(projectID: number): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListMarketingProgram?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMarketingProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMarketingProgram(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMarketingProgram(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListBookingLocation(projectID: number): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListBookingLocation?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBookingLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBookingLocation(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBookingLocation(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListBankProgram(projectID: number): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListBankProgram?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBankProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBankProgram(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBankProgram(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListCloseProgram(projectID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListCloseProgram?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCloseProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCloseProgram(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListCloseProgram(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListSpecialProgram(projectID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListSpecialProgram?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSpecialProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSpecialProgram(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListSpecialProgram(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListMoveInProgram(projectID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListMoveInProgram?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMoveInProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMoveInProgram(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMoveInProgram(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListMarketingProgramNew(projectID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListMarketingProgramNew?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMarketingProgramNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMarketingProgramNew(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMarketingProgramNew(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListMarketingProgramUnit(unitID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListMarketingProgramUnit?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMarketingProgramUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMarketingProgramUnit(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMarketingProgramUnit(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @projectInfoID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getPromoSitePlan(projectID: number, projectInfoID: number, clusterID: number): Observable<GetPromoSitePlanDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetPromoSitePlan?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (projectInfoID !== undefined)
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPromoSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPromoSitePlan(response_);
                } catch (e) {
                    return <Observable<GetPromoSitePlanDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPromoSitePlanDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPromoSitePlan(response: Response): Observable<GetPromoSitePlanDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPromoSitePlanDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPromoSitePlanDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListBankProgramNew(projectID: number): Observable<GetProgramDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetListBankProgramNew?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBankProgramNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBankProgramNew(response_);
                } catch (e) {
                    return <Observable<GetProgramDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBankProgramNew(response: Response): Observable<GetProgramDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProgramDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramDto[]>(<any>null);
    }

    /**
     * @campaignHeaderID (optional) 
     * @return Success
     */
    getRewardPriview(campaignHeaderID: number[]): Observable<GetProgramRewardDto> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetRewardPriview?";
        if (campaignHeaderID !== undefined)
            campaignHeaderID && campaignHeaderID.forEach(item => { url_ += "campaignHeaderID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardPriview(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardPriview(response_);
                } catch (e) {
                    return <Observable<GetProgramRewardDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProgramRewardDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardPriview(response: Response): Observable<GetProgramRewardDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProgramRewardDto.fromJS(resultData200) : new GetProgramRewardDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProgramRewardDto>(<any>null);
    }

    /**
     * @rewardID (optional) 
     * @return Success
     */
    getRewardOnlyPriview(rewardID: number[]): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetRewardOnlyPriview?";
        if (rewardID !== undefined)
            rewardID && rewardID.forEach(item => { url_ += "rewardID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardOnlyPriview(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardOnlyPriview(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardOnlyPriview(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGenerateVoucherFlag(unitID: number): Observable<GetGenerateVoucherFlag> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/GetGenerateVoucherFlag?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGenerateVoucherFlag(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGenerateVoucherFlag(response_);
                } catch (e) {
                    return <Observable<GetGenerateVoucherFlag>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGenerateVoucherFlag>><any>Observable.throw(response_);
        });
    }

    protected processGetGenerateVoucherFlag(response: Response): Observable<GetGenerateVoucherFlag> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGenerateVoucherFlag.fromJS(resultData200) : new GetGenerateVoucherFlag();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGenerateVoucherFlag>(<any>null);
    }

    /**
     * @clusterID (optional) 
     * @projectInfoID (optional) 
     * @return Success
     */
    isRequiredPP(projectID: number, clusterID: number, projectInfoID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Diagramatic/isRequiredPP?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectInfoID !== undefined)
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsRequiredPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsRequiredPP(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsRequiredPP(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditions(response: Response): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionForEdit(response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionForEdit(response: Response): Observable<GetEditionEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEdition(input: CreateOrUpdateEditionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteEdition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @selectedEditionId (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number, addAllItem: boolean, onlyFreeItems: boolean): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem === undefined || addAllItem === null)
            throw new Error("The parameter 'addAllItem' must be defined and cannot be null.");
        else
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems === undefined || onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' must be defined and cannot be null.");
        else
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionComboboxItems(response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionComboboxItems(response: Response): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SubscribableEditionComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class EmailServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bodyAfterReserved(input: AfterReservedInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/bodyAfterReserved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBodyAfterReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBodyAfterReserved(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processBodyAfterReserved(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reminder2Jam(input: Reminder2JamInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/Reminder2Jam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReminder2Jam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReminder2Jam(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processReminder2Jam(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unitExpired(input: UnitExpiredInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/UnitExpired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnitExpired(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnitExpired(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processUnitExpired(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendEmailDoc(input: ResendEmailDocDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/ResendEmailDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendEmailDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendEmailDoc(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processResendEmailDoc(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    formPaymentInstruction(input: SendPaymentInstructionEmailDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/FormPaymentInstruction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFormPaymentInstruction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFormPaymentInstruction(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processFormPaymentInstruction(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bookingSuccess(input: BookingSuccessInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/bookingSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBookingSuccess(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBookingSuccess(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processBookingSuccess(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmail(input: SendEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailProjectUnit(input: SendEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationEmailProjectUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailProjectUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailProjectUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailBankTransfer(input: SendEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationEmailBankTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailBankTransfer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailBankTransfer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailBankTransfer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailMultipleRecipient(input: SendEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationEmailMultipleRecipient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailMultipleRecipient(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailMultipleRecipient(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailMultipleRecipient(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailWithAttachment(input: BlastEmailAttachmentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationEmailWithAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailWithAttachment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailWithAttachment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailWithAttachment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @linkLogin (optional) 
     * @return Success
     */
    sendEmailAutoActivation(memberCode: string, linkLogin: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendEmailAutoActivation?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (linkLogin !== undefined)
            url_ += "linkLogin=" + encodeURIComponent("" + linkLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAutoActivation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAutoActivation(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAutoActivation(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationAutoActivationEmail(input: SendEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/ConfigurationAutoActivationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationAutoActivationEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationAutoActivationEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationAutoActivationEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EmailEngine3ServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmail(input: SendEmailRequestInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blastEmailPromotion(input: BlastEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlastEmailPromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlastEmailPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlastEmailPromotion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlastEmailPromotion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blashEmail(input: BlastEmailDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlashEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmail(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmail(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blashEmailCompen(input: BlastEmailCompenInputDto[], groupId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlashEmailCompen?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmailCompen(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmailCompen(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmailCompen(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blashEmailPeringatanPembatalan(input: BlastEmailCompenInputDto[], groupId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlashEmailPeringatanPembatalan?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmailPeringatanPembatalan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmailPeringatanPembatalan(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmailPeringatanPembatalan(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blashEmailPeringatanCessie(input: BlastEmailCompenInputDto[], groupId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlashEmailPeringatanCessie?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmailPeringatanCessie(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmailPeringatanCessie(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmailPeringatanCessie(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTemplate(projectID: number, typeBlastEmailId: number): Observable<ListResultDtoOfTemplateDropdownDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/GetDropdownTemplate?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (typeBlastEmailId === undefined || typeBlastEmailId === null)
            throw new Error("The parameter 'typeBlastEmailId' must be defined and cannot be null.");
        else
            url_ += "TypeBlastEmailId=" + encodeURIComponent("" + typeBlastEmailId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTemplate(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTemplateDropdownDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTemplateDropdownDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTemplate(response: Response): Observable<ListResultDtoOfTemplateDropdownDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTemplateDropdownDto.fromJS(resultData200) : new ListResultDtoOfTemplateDropdownDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTemplateDropdownDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    taskListEmailCompensation(input: InputRewardDto): Observable<PagedResultDtoOfGetTasklistEmailCompensationDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/TaskListEmailCompensation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTaskListEmailCompensation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTaskListEmailCompensation(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTasklistEmailCompensationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTasklistEmailCompensationDto>><any>Observable.throw(response_);
        });
    }

    protected processTaskListEmailCompensation(response: Response): Observable<PagedResultDtoOfGetTasklistEmailCompensationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetTasklistEmailCompensationDto.fromJS(resultData200) : new PagedResultDtoOfGetTasklistEmailCompensationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetTasklistEmailCompensationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEmailCC(groupId: number): Observable<GetTasklistEmailCompeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/getEmailCC?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEmailCC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEmailCC(response_);
                } catch (e) {
                    return <Observable<GetTasklistEmailCompeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistEmailCompeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEmailCC(response: Response): Observable<GetTasklistEmailCompeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTasklistEmailCompeDto.fromJS(resultData200) : new GetTasklistEmailCompeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistEmailCompeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEmailBCC(groupId: number): Observable<GetTasklistEmailCompeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/getEmailBCC?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEmailBCC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEmailBCC(response_);
                } catch (e) {
                    return <Observable<GetTasklistEmailCompeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistEmailCompeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEmailBCC(response: Response): Observable<GetTasklistEmailCompeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTasklistEmailCompeDto.fromJS(resultData200) : new GetTasklistEmailCompeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistEmailCompeDto>(<any>null);
    }

    /**
     * @return Success
     */
    isEnableSendEmail(groupID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/isEnableSendEmail?";
        if (groupID === undefined || groupID === null)
            throw new Error("The parameter 'groupID' must be defined and cannot be null.");
        else
            url_ += "GroupID=" + encodeURIComponent("" + groupID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsEnableSendEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsEnableSendEmail(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsEnableSendEmail(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailEmailCompensation(groupId: number, projectId: number, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetDetailEmailCompensationDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/GetDetailEmailCompensation?";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined and cannot be null.");
        else
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&"; 
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailEmailCompensation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailEmailCompensation(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDetailEmailCompensationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDetailEmailCompensationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailEmailCompensation(response: Response): Observable<PagedResultDtoOfGetDetailEmailCompensationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDetailEmailCompensationDto.fromJS(resultData200) : new PagedResultDtoOfGetDetailEmailCompensationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetDetailEmailCompensationDto>(<any>null);
    }

    /**
     * @return Success
     */
    taskListPeriodeKompensasi(blasCompenHeaderId: number): Observable<ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/TaskListPeriodeKompensasi?";
        if (blasCompenHeaderId === undefined || blasCompenHeaderId === null)
            throw new Error("The parameter 'blasCompenHeaderId' must be defined and cannot be null.");
        else
            url_ += "blasCompenHeaderId=" + encodeURIComponent("" + blasCompenHeaderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTaskListPeriodeKompensasi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTaskListPeriodeKompensasi(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto>><any>Observable.throw(response_);
        });
    }

    protected processTaskListPeriodeKompensasi(response: Response): Observable<ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto.fromJS(resultData200) : new ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveBlashEmail(input: SaveEmailCompensationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/SaveBlashEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveBlashEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveBlashEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveBlashEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveEmailKompensasi(input: SaveEmailCompensationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/SaveEmailKompensasi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveEmailKompensasi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveEmailKompensasi(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveEmailKompensasi(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveEmailPeringatanPembatalan(input: SaveEmailCompensationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/SaveEmailPeringatanPembatalan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveEmailPeringatanPembatalan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveEmailPeringatanPembatalan(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveEmailPeringatanPembatalan(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveEmailPeringatanCessie(input: SaveEmailCompensationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/SaveEmailPeringatanCessie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveEmailPeringatanCessie(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveEmailPeringatanCessie(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveEmailPeringatanCessie(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTypeBlastEmail(projectID: number): Observable<ListResultDtoOfTypeBlastEmailDropdownDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/GetDropdownTypeBlastEmail?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTypeBlastEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTypeBlastEmail(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTypeBlastEmailDropdownDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTypeBlastEmailDropdownDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTypeBlastEmail(response: Response): Observable<ListResultDtoOfTypeBlastEmailDropdownDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTypeBlastEmailDropdownDto.fromJS(resultData200) : new ListResultDtoOfTypeBlastEmailDropdownDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTypeBlastEmailDropdownDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectForBlast(userID: number): Observable<GetProjectByAccountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/GetListProjectForBlast?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectForBlast(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectForBlast(response_);
                } catch (e) {
                    return <Observable<GetProjectByAccountListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectByAccountListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectForBlast(response: Response): Observable<GetProjectByAccountListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProjectByAccountListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectByAccountListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blashEmailReminderPP(input: BlastEmailReminderPPInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailEngine3/BlashEmailReminderPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmailReminderPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmailReminderPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmailReminderPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EmailLKServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @counterCode (optional) 
     * @return Success
     */
    getEmailID(counterCode: string): Observable<GetEmailIDResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailLK/GetEmailID?";
        if (counterCode !== undefined)
            url_ += "counterCode=" + encodeURIComponent("" + counterCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEmailID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEmailID(response_);
                } catch (e) {
                    return <Observable<GetEmailIDResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEmailIDResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEmailID(response: Response): Observable<GetEmailIDResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEmailIDResultDto.fromJS(resultData200) : new GetEmailIDResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEmailIDResultDto>(<any>null);
    }

    /**
     * @emailID (optional) 
     * @fileName (optional) 
     * @attachment (optional) 
     * @return Success
     */
    insertAttachment(emailID: string, fileName: string, attachment: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailLK/InsertAttachment?";
        if (emailID !== undefined)
            url_ += "emailID=" + encodeURIComponent("" + emailID) + "&"; 
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachment);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertAttachment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertAttachment(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processInsertAttachment(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @emailTo (optional) 
     * @emailCC (optional) 
     * @emailBCC (optional) 
     * @subject (optional) 
     * @message (optional) 
     * @nik (optional) 
     * @counterCode (optional) 
     * @emailFrom (optional) 
     * @emailFromDisplayName (optional) 
     * @emailID (optional) 
     * @return Success
     */
    sendMailAttachment(emailTo: string, emailCC: string, emailBCC: string, subject: string, message: string, nik: string, counterCode: string, emailFrom: string, emailFromDisplayName: string, emailID: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailLK/SendMailAttachment?";
        if (emailTo !== undefined)
            url_ += "emailTo=" + encodeURIComponent("" + emailTo) + "&"; 
        if (emailCC !== undefined)
            url_ += "emailCC=" + encodeURIComponent("" + emailCC) + "&"; 
        if (emailBCC !== undefined)
            url_ += "emailBCC=" + encodeURIComponent("" + emailBCC) + "&"; 
        if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (nik !== undefined)
            url_ += "nik=" + encodeURIComponent("" + nik) + "&"; 
        if (counterCode !== undefined)
            url_ += "counterCode=" + encodeURIComponent("" + counterCode) + "&"; 
        if (emailFrom !== undefined)
            url_ += "emailFrom=" + encodeURIComponent("" + emailFrom) + "&"; 
        if (emailFromDisplayName !== undefined)
            url_ += "emailFromDisplayName=" + encodeURIComponent("" + emailFromDisplayName) + "&"; 
        if (emailID !== undefined)
            url_ += "emailID=" + encodeURIComponent("" + emailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendMailAttachment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendMailAttachment(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendMailAttachment(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailAttachmentUniversal(input: SendEmailAttachmentInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailLK/SendEmailAttachmentUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAttachmentUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAttachmentUniversal(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAttachmentUniversal(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class EmailOutboxServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertOutboxTemp(input: OutboxInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailOutbox/InsertOutboxTemp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertOutboxTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertOutboxTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertOutboxTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertOutbox(input: OutboxInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailOutbox/InsertOutbox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertOutbox(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertOutbox(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertOutbox(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendEmail(input: ResendEmailDto): Observable<SendEmailListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailOutbox/ResendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendEmail(response_);
                } catch (e) {
                    return <Observable<SendEmailListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SendEmailListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processResendEmail(response: Response): Observable<SendEmailListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendEmailListResultDto.fromJS(resultData200) : new SendEmailListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SendEmailListResultDto>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    sendEmailVDIBundle(projectID: number): Observable<SendEmailListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailOutbox/SendEmailVDIBundle?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailVDIBundle(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailVDIBundle(response_);
                } catch (e) {
                    return <Observable<SendEmailListResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SendEmailListResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailVDIBundle(response: Response): Observable<SendEmailListResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendEmailListResultDto.fromJS(resultData200) : new SendEmailListResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SendEmailListResultDto>(<any>null);
    }

    /**
     * @emailID (optional) 
     * @projectID (optional) 
     * @return Success
     */
    sendEmailVDI(emailID: string, projectID: number): Observable<Root> {
        let url_ = this.baseUrl + "/api/services/app/EmailOutbox/SendEmailVDI?";
        if (emailID !== undefined)
            url_ += "emailID=" + encodeURIComponent("" + emailID) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailVDI(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailVDI(response_);
                } catch (e) {
                    return <Observable<Root>><any>Observable.throw(e);
                }
            } else
                return <Observable<Root>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailVDI(response: Response): Observable<Root> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Root.fromJS(resultData200) : new Root();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Root>(<any>null);
    }
}

@Injectable()
export class EmailPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bookingPPSuccess(input: BookingSuccessPPInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailPP/BookingPPSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBookingPPSuccess(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBookingPPSuccess(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processBookingPPSuccess(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailPP(input: SendEmailPPInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailPP/ConfigurationEmailPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    refundPPSuccess(input: SendEmailRefundPPInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EmailPP/RefundPPSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRefundPPSuccess(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRefundPPSuccess(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processRefundPPSuccess(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    configurationEmailRefundPP(input: EmailRefundPPInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailPP/ConfigurationEmailRefundPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConfigurationEmailRefundPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConfigurationEmailRefundPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processConfigurationEmailRefundPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class FaktorialServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDropDownUnitType(projectID: number, clusterID: number): Observable<GetDropDownUnitType[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownUnitType?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownUnitType(response_);
                } catch (e) {
                    return <Observable<GetDropDownUnitType[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownUnitType[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownUnitType(response: Response): Observable<GetDropDownUnitType[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownUnitType.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownUnitType[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSettingFactoringCode(): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetSettingFactoringCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSettingFactoringCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSettingFactoringCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSettingFactoringCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropDownDistrictByProject(projectID: number): Observable<GetDropDownDistrictDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownDistrictByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownDistrictByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownDistrictByProject(response_);
                } catch (e) {
                    return <Observable<GetDropDownDistrictDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownDistrictDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownDistrictByProject(response: Response): Observable<GetDropDownDistrictDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownDistrictDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownDistrictDto[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @return Success
     */
    getDropDownBlokByProject(projectID: number, districtCode: string): Observable<GetDropDownBlokDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownBlokByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownBlokByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownBlokByProject(response_);
                } catch (e) {
                    return <Observable<GetDropDownBlokDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownBlokDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownBlokByProject(response: Response): Observable<GetDropDownBlokDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownBlokDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownBlokDto[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @blok (optional) 
     * @return Success
     */
    getDropDownTypeTowerByProject(projectID: number, districtCode: string, blok: string): Observable<GetDropDownTypeTowerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownTypeTowerByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        if (blok !== undefined)
            url_ += "blok=" + encodeURIComponent("" + blok) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownTypeTowerByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownTypeTowerByProject(response_);
                } catch (e) {
                    return <Observable<GetDropDownTypeTowerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownTypeTowerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownTypeTowerByProject(response: Response): Observable<GetDropDownTypeTowerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownTypeTowerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownTypeTowerDto[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @blok (optional) 
     * @typeTower (optional) 
     * @return Success
     */
    getDropDownTowerByProject(projectID: number, districtCode: string, blok: string, typeTower: string): Observable<GetDropDownTowerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownTowerByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        if (blok !== undefined)
            url_ += "blok=" + encodeURIComponent("" + blok) + "&"; 
        if (typeTower !== undefined)
            url_ += "typeTower=" + encodeURIComponent("" + typeTower) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownTowerByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownTowerByProject(response_);
                } catch (e) {
                    return <Observable<GetDropDownTowerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownTowerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownTowerByProject(response: Response): Observable<GetDropDownTowerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownTowerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownTowerDto[]>(<any>null);
    }

    /**
     * @unitType (optional) 
     * @return Success
     */
    getDropDownUnitByProject(projectID: number, clusterId: number, unitType: string): Observable<GetDropDownUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDropDownUnitByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (unitType !== undefined)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownUnitByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownUnitByProject(response_);
                } catch (e) {
                    return <Observable<GetDropDownUnitDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownUnitDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownUnitByProject(response: Response): Observable<GetDropDownUnitDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownUnitDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownUnitDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTaskListSettingFactoring(projectID: number): Observable<GetTaskListSettingFactoring[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetTaskListSettingFactoring?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListSettingFactoring(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListSettingFactoring(response_);
                } catch (e) {
                    return <Observable<GetTaskListSettingFactoring[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListSettingFactoring[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListSettingFactoring(response: Response): Observable<GetTaskListSettingFactoring[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTaskListSettingFactoring.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListSettingFactoring[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSettingFactoring(input: CreateOrUpdateSettingFactoringDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/CreateOrUpdateSettingFactoring";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSettingFactoring(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSettingFactoring(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSettingFactoring(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSettingFactoring(settingFactoringID: number): Observable<CreateOrUpdateSettingFactoringDto> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/GetDetailSettingFactoring?";
        if (settingFactoringID === undefined || settingFactoringID === null)
            throw new Error("The parameter 'settingFactoringID' must be defined and cannot be null.");
        else
            url_ += "settingFactoringID=" + encodeURIComponent("" + settingFactoringID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSettingFactoring(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSettingFactoring(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateSettingFactoringDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateSettingFactoringDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSettingFactoring(response: Response): Observable<CreateOrUpdateSettingFactoringDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateSettingFactoringDto.fromJS(resultData200) : new CreateOrUpdateSettingFactoringDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateSettingFactoringDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSettingFactoringDetail(settingFactoringDetailID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/DeleteSettingFactoringDetail?";
        if (settingFactoringDetailID === undefined || settingFactoringDetailID === null)
            throw new Error("The parameter 'settingFactoringDetailID' must be defined and cannot be null.");
        else
            url_ += "settingFactoringDetailID=" + encodeURIComponent("" + settingFactoringDetailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSettingFactoringDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSettingFactoringDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSettingFactoringDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSettingFactoring(settingFactoringID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/DeleteSettingFactoring?";
        if (settingFactoringID === undefined || settingFactoringID === null)
            throw new Error("The parameter 'settingFactoringID' must be defined and cannot be null.");
        else
            url_ += "settingFactoringID=" + encodeURIComponent("" + settingFactoringID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSettingFactoring(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSettingFactoring(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSettingFactoring(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    dropdownSettingFactoring(projectID: number): Observable<DropdownSettingFactoringDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Faktorial/DropdownSettingFactoring?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownSettingFactoring(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownSettingFactoring(response_);
                } catch (e) {
                    return <Observable<DropdownSettingFactoringDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownSettingFactoringDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownSettingFactoring(response: Response): Observable<DropdownSettingFactoringDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownSettingFactoringDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownSettingFactoringDto[]>(<any>null);
    }
}

@Injectable()
export class FilesHelperServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @return Success
     */
    moveFiles(filename: string, oldPath: string, newPath: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/MoveFiles?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveFiles(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveFiles(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @return Success
     */
    moveFilesBarcode(filename: string, oldPath: string, newPath: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/MoveFilesBarcode?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveFilesBarcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveFilesBarcode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveFilesBarcode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @orderNumber (optional) 
     * @return Success
     */
    moveFilesLegalDoc(filename: string, oldPath: string, newPath: string, orderNumber: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/MoveFilesLegalDoc?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveFilesLegalDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveFilesLegalDoc(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveFilesLegalDoc(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @oldFilename (optional) 
     * @newFileName (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @return Success
     */
    moveFilesWithRename(oldFilename: string, newFileName: string, oldPath: string, newPath: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/MoveFilesWithRename?";
        if (oldFilename !== undefined)
            url_ += "oldFilename=" + encodeURIComponent("" + oldFilename) + "&"; 
        if (newFileName !== undefined)
            url_ += "newFileName=" + encodeURIComponent("" + newFileName) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveFilesWithRename(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveFilesWithRename(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveFilesWithRename(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @orderNumber (optional) 
     * @return Success
     */
    copyKPFile(filename: string, oldPath: string, newPath: string, orderNumber: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/CopyKPFile?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        if (orderNumber !== undefined)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCopyKPFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCopyKPFile(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCopyKPFile(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @projectName (optional) 
     * @notifCode (optional) 
     * @return Success
     */
    copyFileTemplateNotif(filename: string, oldPath: string, newPath: string, projectName: string, notifCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/CopyFileTemplateNotif?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        if (projectName !== undefined)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&"; 
        if (notifCode !== undefined)
            url_ += "notifCode=" + encodeURIComponent("" + notifCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCopyFileTemplateNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCopyFileTemplateNotif(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCopyFileTemplateNotif(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @filename (optional) 
     * @oldPath (optional) 
     * @newPath (optional) 
     * @projectName (optional) 
     * @notifCode (optional) 
     * @return Success
     */
    moveFilesTemplateNotif(filename: string, oldPath: string, newPath: string, projectName: string, notifCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/MoveFilesTemplateNotif?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (oldPath !== undefined)
            url_ += "oldPath=" + encodeURIComponent("" + oldPath) + "&"; 
        if (newPath !== undefined)
            url_ += "newPath=" + encodeURIComponent("" + newPath) + "&"; 
        if (projectName !== undefined)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&"; 
        if (notifCode !== undefined)
            url_ += "notifCode=" + encodeURIComponent("" + notifCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveFilesTemplateNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveFilesTemplateNotif(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMoveFilesTemplateNotif(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAbsoluteUri(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/getAbsoluteUri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAbsoluteUri(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAbsoluteUri(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAbsoluteUri(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAbsoluteUriHttpHardcode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/getAbsoluteUriHttpHardcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAbsoluteUriHttpHardcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAbsoluteUriHttpHardcode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAbsoluteUriHttpHardcode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    convertIdToCode(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/ConvertIdToCode?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertIdToCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertIdToCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processConvertIdToCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    convertDocIdToDocCode(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/ConvertDocIdToDocCode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processConvertDocIdToDocCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processConvertDocIdToDocCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processConvertDocIdToDocCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @physicalPath (optional) 
     * @return Success
     */
    getBase64FileByPhysicalPath(physicalPath: string): Observable<LinkPathListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/GetBase64FileByPhysicalPath?";
        if (physicalPath !== undefined)
            url_ += "physicalPath=" + encodeURIComponent("" + physicalPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBase64FileByPhysicalPath(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBase64FileByPhysicalPath(response_);
                } catch (e) {
                    return <Observable<LinkPathListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<LinkPathListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBase64FileByPhysicalPath(response: Response): Observable<LinkPathListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LinkPathListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LinkPathListDto[]>(<any>null);
    }

    /**
     * @path (optional) 
     * @return Success
     */
    getURLWithoutHost(path: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/GetURLWithoutHost?";
        if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetURLWithoutHost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetURLWithoutHost(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetURLWithoutHost(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAbsoluteUriWithoutTail(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/GetAbsoluteUriWithoutTail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAbsoluteUriWithoutTail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAbsoluteUriWithoutTail(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAbsoluteUriWithoutTail(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @physicalPath (optional) 
     * @fileName (optional) 
     * @return Success
     */
    getBase64FileByPhysicalPathFilter(physicalPath: string, fileName: string): Observable<LinkPathListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FilesHelper/GetBase64FileByPhysicalPathFilter?";
        if (physicalPath !== undefined)
            url_ += "physicalPath=" + encodeURIComponent("" + physicalPath) + "&"; 
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBase64FileByPhysicalPathFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBase64FileByPhysicalPathFilter(response_);
                } catch (e) {
                    return <Observable<LinkPathListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<LinkPathListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBase64FileByPhysicalPathFilter(response: Response): Observable<LinkPathListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LinkPathListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LinkPathListDto[]>(<any>null);
    }
}

@Injectable()
export class FpLkFpTransCodeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFPTransCodeDropdown(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/FpLkFpTransCode/GetFPTransCodeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFPTransCodeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFPTransCodeDropdown(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFPTransCodeDropdown(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequest(input: CreateFriendshipRequestInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequest(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(input: CreateFriendshipRequestByUserNameInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequestByUserName(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blockUser(input: BlockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unblockUser(input: UnblockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnblockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnblockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnblockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    acceptFriendshipRequest(input: AcceptFriendshipRequestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAcceptFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAcceptFriendshipRequest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class GeneratePriceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMsUnitByProjectCluster(projectID: number, clusterID: number): Observable<GetMsUnitByProjectClusterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetMsUnitByProjectCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsUnitByProjectCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsUnitByProjectCluster(response_);
                } catch (e) {
                    return <Observable<GetMsUnitByProjectClusterDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsUnitByProjectClusterDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsUnitByProjectCluster(response: Response): Observable<GetMsUnitByProjectClusterDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsUnitByProjectClusterDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsUnitByProjectClusterDto[]>(<any>null);
    }

    /**
     * @categoryID (optional) 
     * @productID (optional) 
     * @return Success
     */
    getMsUnitByProjectClusterCategoryProduct(projectID: number, clusterID: number, categoryID: number[], productID: number[], termMainID: number): Observable<GetMsUnitByProjectClusterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetMsUnitByProjectClusterCategoryProduct?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID !== undefined)
            categoryID && categoryID.forEach(item => { url_ += "categoryID=" + encodeURIComponent("" + item) + "&"; });
        if (productID !== undefined)
            productID && productID.forEach(item => { url_ += "productID=" + encodeURIComponent("" + item) + "&"; });
        if (termMainID === undefined || termMainID === null)
            throw new Error("The parameter 'termMainID' must be defined and cannot be null.");
        else
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsUnitByProjectClusterCategoryProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsUnitByProjectClusterCategoryProduct(response_);
                } catch (e) {
                    return <Observable<GetMsUnitByProjectClusterDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsUnitByProjectClusterDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsUnitByProjectClusterCategoryProduct(response: Response): Observable<GetMsUnitByProjectClusterDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsUnitByProjectClusterDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsUnitByProjectClusterDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelUploadPriceList(input: GetMsUnitByProjectIdClusterIdDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GenerateExcelUploadPriceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelUploadPriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelUploadPriceList(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelUploadPriceList(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelUploadGrossPrice(input: GenerateExcelUploadGrossPriceInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GenerateExcelUploadGrossPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelUploadGrossPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelUploadGrossPrice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelUploadGrossPrice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportToExcelUploadGrossPrice(input: ExportToExcelUploadGrossPriceListDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/ExportToExcelUploadGrossPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportToExcelUploadGrossPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportToExcelUploadGrossPrice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportToExcelUploadGrossPrice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    exportToExcelUploadPriceList(input: ExportToExcelUploadPriceListDto[]): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/ExportToExcelUploadPriceList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportToExcelUploadPriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportToExcelUploadPriceList(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportToExcelUploadPriceList(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneratePriceListTermByTermID(termID: number): Observable<GetGeneratePriceListTermListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetGeneratePriceListTermByTermID?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGeneratePriceListTermByTermID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGeneratePriceListTermByTermID(response_);
                } catch (e) {
                    return <Observable<GetGeneratePriceListTermListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGeneratePriceListTermListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGeneratePriceListTermByTermID(response: Response): Observable<GetGeneratePriceListTermListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetGeneratePriceListTermListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGeneratePriceListTermListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPriceTaskList(input: CreatePriceTaskListInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/CreatePriceTaskList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePriceTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePriceTaskList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePriceTaskList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPriceTaskList(projectID: number): Observable<GetPriceTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetPriceTaskList?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPriceTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPriceTaskList(response_);
                } catch (e) {
                    return <Observable<GetPriceTaskListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPriceTaskListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPriceTaskList(response: Response): Observable<GetPriceTaskListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPriceTaskListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPriceTaskListDto[]>(<any>null);
    }

    /**
     * @inputs (optional) 
     * @return Success
     */
    checkDataUploadGrossPrice(inputs: CheckDataUploadGrossPriceInputDto): Observable<GetProductCodeByUnitCodeUnitNoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/CheckDataUploadGrossPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataUploadGrossPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataUploadGrossPrice(response_);
                } catch (e) {
                    return <Observable<GetProductCodeByUnitCodeUnitNoDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductCodeByUnitCodeUnitNoDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataUploadGrossPrice(response: Response): Observable<GetProductCodeByUnitCodeUnitNoDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProductCodeByUnitCodeUnitNoDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductCodeByUnitCodeUnitNoDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkDuplicateDataExcel(input: CheckDuplicateDataInputDto[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/CheckDuplicateDataExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDuplicateDataExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDuplicateDataExcel(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckDuplicateDataExcel(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getDiscountDropdownOnlySalesDisc(): Observable<GetMsDiscountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetDiscountDropdownOnlySalesDisc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountDropdownOnlySalesDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountDropdownOnlySalesDisc(response_);
                } catch (e) {
                    return <Observable<GetMsDiscountDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsDiscountDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountDropdownOnlySalesDisc(response: Response): Observable<GetMsDiscountDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsDiscountDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsDiscountDto[]>(<any>null);
    }

    /**
     * @categoryID (optional) 
     * @productID (optional) 
     * @return Success
     */
    getPctDiscByProjectClusterCategoryProduct(projectID: number, clusterID: number, categoryID: number[], productID: number[], termMainID: number): Observable<GetPctDiscDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetPctDiscByProjectClusterCategoryProduct?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID !== undefined)
            categoryID && categoryID.forEach(item => { url_ += "categoryID=" + encodeURIComponent("" + item) + "&"; });
        if (productID !== undefined)
            productID && productID.forEach(item => { url_ += "productID=" + encodeURIComponent("" + item) + "&"; });
        if (termMainID === undefined || termMainID === null)
            throw new Error("The parameter 'termMainID' must be defined and cannot be null.");
        else
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPctDiscByProjectClusterCategoryProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPctDiscByProjectClusterCategoryProduct(response_);
                } catch (e) {
                    return <Observable<GetPctDiscDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPctDiscDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPctDiscByProjectClusterCategoryProduct(response: Response): Observable<GetPctDiscDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPctDiscDto.fromJS(resultData200) : new GetPctDiscDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPctDiscDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPctDiscByProjectClusterCategory(projectID: number, clusterID: number, categoryID: number, termMainID: number): Observable<GetPctDiscProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePrice/GetPctDiscByProjectClusterCategory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        if (termMainID === undefined || termMainID === null)
            throw new Error("The parameter 'termMainID' must be defined and cannot be null.");
        else
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPctDiscByProjectClusterCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPctDiscByProjectClusterCategory(response_);
                } catch (e) {
                    return <Observable<GetPctDiscProjectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPctDiscProjectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPctDiscByProjectClusterCategory(response: Response): Observable<GetPctDiscProjectDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPctDiscProjectDto.fromJS(resultData200) : new GetPctDiscProjectDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPctDiscProjectDto>(<any>null);
    }
}

@Injectable()
export class GeneratePriceListServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getProjectDropdownForPrice(): Observable<ListResultDtoOfGetDropdownProjectForPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GetProjectDropdownForPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectDropdownForPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectDropdownForPrice(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDropdownProjectForPriceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDropdownProjectForPriceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectDropdownForPrice(response: Response): Observable<ListResultDtoOfGetDropdownProjectForPriceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDropdownProjectForPriceDto.fromJS(resultData200) : new ListResultDtoOfGetDropdownProjectForPriceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDropdownProjectForPriceDto>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getProductDropdownForPrice(projectID: number[]): Observable<ListResultDtoOfGetDropdownProductForPriceDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GetProductDropdownForPrice?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductDropdownForPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductDropdownForPrice(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDropdownProductForPriceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDropdownProductForPriceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductDropdownForPrice(response: Response): Observable<ListResultDtoOfGetDropdownProductForPriceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDropdownProductForPriceDto.fromJS(resultData200) : new ListResultDtoOfGetDropdownProductForPriceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDropdownProductForPriceDto>(<any>null);
    }

    /**
     * @productID (optional) 
     * @return Success
     */
    getClusterDropdownForPrice(productID: number[]): Observable<ListResultDtoOfGetDropdownClusterForPrice> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GetClusterDropdownForPrice?";
        if (productID !== undefined)
            productID && productID.forEach(item => { url_ += "productID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterDropdownForPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterDropdownForPrice(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDropdownClusterForPrice>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDropdownClusterForPrice>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterDropdownForPrice(response: Response): Observable<ListResultDtoOfGetDropdownClusterForPrice> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDropdownClusterForPrice.fromJS(resultData200) : new ListResultDtoOfGetDropdownClusterForPrice();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDropdownClusterForPrice>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printPrice(input: InputPriceListDto): Observable<GetListPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/PrintPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintPrice(response_);
                } catch (e) {
                    return <Observable<GetListPriceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPriceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processPrintPrice(response: Response): Observable<GetListPriceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPriceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPriceDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDisplayedFieldPrice(): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GetDisplayedFieldPrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDisplayedFieldPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDisplayedFieldPrice(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDisplayedFieldPrice(response: Response): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePriceListPdf(input: PrintPriceInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GeneratePriceListPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePriceListPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePriceListPdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePriceListPdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelPrice(input: PrintPriceInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceList/GenerateExcelPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelPrice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelPrice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class GeneratePriceMSUServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @clusterID (optional) 
     * @return Success
     */
    getDropDownUnitTypeMultiple(projectID: number, clusterID: number[]): Observable<GetDropDownUnitType[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetDropDownUnitTypeMultiple?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownUnitTypeMultiple(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownUnitTypeMultiple(response_);
                } catch (e) {
                    return <Observable<GetDropDownUnitType[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownUnitType[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownUnitTypeMultiple(response: Response): Observable<GetDropDownUnitType[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownUnitType.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownUnitType[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @return Success
     */
    getDropDownTypeTower(projectID: number, districtCode: string): Observable<GetDropDownTypeTowerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetDropDownTypeTower?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownTypeTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownTypeTower(response_);
                } catch (e) {
                    return <Observable<GetDropDownTypeTowerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownTypeTowerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownTypeTower(response: Response): Observable<GetDropDownTypeTowerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownTypeTowerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownTypeTowerDto[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @typeTower (optional) 
     * @return Success
     */
    getDropDownTower(projectID: number, districtCode: string, typeTower: string[]): Observable<GetDropDownTowerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetDropDownTower?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        if (typeTower !== undefined)
            typeTower && typeTower.forEach(item => { url_ += "typeTower=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownTower(response_);
                } catch (e) {
                    return <Observable<GetDropDownTowerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownTowerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownTower(response: Response): Observable<GetDropDownTowerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownTowerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownTowerDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTermAddDiscByTermID(termID: number): Observable<AddDiscountPerTermGeneratePriceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetListTermAddDiscByTermID?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTermAddDiscByTermID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTermAddDiscByTermID(response_);
                } catch (e) {
                    return <Observable<AddDiscountPerTermGeneratePriceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<AddDiscountPerTermGeneratePriceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTermAddDiscByTermID(response: Response): Observable<AddDiscountPerTermGeneratePriceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AddDiscountPerTermGeneratePriceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AddDiscountPerTermGeneratePriceDto[]>(<any>null);
    }

    /**
     * @districtCode (optional) 
     * @return Success
     */
    getFactoringGeneratePrice(factoringID: number, districtCode: string): Observable<CreateOrUpdateSettingFactoringDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetFactoringGeneratePrice?";
        if (factoringID === undefined || factoringID === null)
            throw new Error("The parameter 'factoringID' must be defined and cannot be null.");
        else
            url_ += "factoringID=" + encodeURIComponent("" + factoringID) + "&"; 
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFactoringGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFactoringGeneratePrice(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateSettingFactoringDetailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateSettingFactoringDetailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFactoringGeneratePrice(response: Response): Observable<CreateOrUpdateSettingFactoringDetailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateSettingFactoringDetailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateSettingFactoringDetailDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    previewNewGeneratePrice(input: NewGeneratePriceDto): Observable<NewPreviewGeneratePriceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/PreviewNewGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPreviewNewGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPreviewNewGeneratePrice(response_);
                } catch (e) {
                    return <Observable<NewPreviewGeneratePriceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NewPreviewGeneratePriceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processPreviewNewGeneratePrice(response: Response): Observable<NewPreviewGeneratePriceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NewPreviewGeneratePriceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NewPreviewGeneratePriceDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    tasklistNewGeneratePrice(): Observable<GetTasklistNewGeneratePriceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/TasklistNewGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTasklistNewGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTasklistNewGeneratePrice(response_);
                } catch (e) {
                    return <Observable<GetTasklistNewGeneratePriceDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistNewGeneratePriceDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTasklistNewGeneratePrice(response: Response): Observable<GetTasklistNewGeneratePriceDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistNewGeneratePriceDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistNewGeneratePriceDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailNewGeneratePriceAsync(generatePriceHeaderID: number): Observable<SubmitNewGeneratePrice> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/GetDetailNewGeneratePriceAsync?";
        if (generatePriceHeaderID === undefined || generatePriceHeaderID === null)
            throw new Error("The parameter 'generatePriceHeaderID' must be defined and cannot be null.");
        else
            url_ += "generatePriceHeaderID=" + encodeURIComponent("" + generatePriceHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailNewGeneratePriceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailNewGeneratePriceAsync(response_);
                } catch (e) {
                    return <Observable<SubmitNewGeneratePrice>><any>Observable.throw(e);
                }
            } else
                return <Observable<SubmitNewGeneratePrice>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailNewGeneratePriceAsync(response: Response): Observable<SubmitNewGeneratePrice> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SubmitNewGeneratePrice.fromJS(resultData200) : new SubmitNewGeneratePrice();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SubmitNewGeneratePrice>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    rejectGeneratePrice(input: SubmitNewGeneratePrice): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/RejectGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRejectGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRejectGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRejectGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    submitNewGeneratePrice(input: SubmitNewGeneratePrice): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/SubmitNewGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSubmitNewGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSubmitNewGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSubmitNewGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    completeRequestAction(input: CompleteGeneratePriceRequestActionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/CompleteRequestAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompleteRequestAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompleteRequestAction(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCompleteRequestAction(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateStatusApprove(input: UpdateStatusApproveInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/UpdateStatusApprove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateStatusApprove(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateStatusApprove(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateStatusApprove(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    universalProcessGeneratePrice(input: UniversalProcessGeneratePriceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/UniversalProcessGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUniversalProcessGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUniversalProcessGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUniversalProcessGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerProcessNewGeneratePrice(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/SchedulerProcessNewGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerProcessNewGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerProcessNewGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerProcessNewGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    processNewGeneratePrice(input: ProcessNewGeneratePriceDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/ProcessNewGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessNewGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessNewGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessNewGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    processNewTermAddDisc(input: AddDiscountGeneratePriceDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/ProcessNewTermAddDisc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessNewTermAddDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessNewTermAddDisc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessNewTermAddDisc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    validateGeneratePrice(input: NewGeneratePriceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/ValidateGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processValidateGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    downloadGeneratePrice(settingPriceID: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratePriceMSU/DownloadGeneratePrice?";
        if (settingPriceID === undefined || settingPriceID === null)
            throw new Error("The parameter 'settingPriceID' must be defined and cannot be null.");
        else
            url_ += "settingPriceID=" + encodeURIComponent("" + settingPriceID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadGeneratePrice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadGeneratePrice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class GenerateReportSSPExcelExporterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportSSP(input: GetDataSSPReport): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GenerateReportSSPExcelExporter/GenerateExcelReportSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportSSP(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportSSP(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    pixel2MTU(pixels: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GenerateReportSSPExcelExporter/Pixel2MTU?";
        if (pixels === undefined || pixels === null)
            throw new Error("The parameter 'pixels' must be defined and cannot be null.");
        else
            url_ += "pixels=" + encodeURIComponent("" + pixels) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPixel2MTU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPixel2MTU(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processPixel2MTU(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }
}

@Injectable()
export class HealthServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkIfAppIsUnderMaintenance(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Health/CheckIfAppIsUnderMaintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIfAppIsUnderMaintenance(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIfAppIsUnderMaintenance(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckIfAppIsUnderMaintenance(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class HistoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDetailBooking(bookCode: string, unitCode: string, unitNo: string): Observable<GetDetailBookingDto> {
        let url_ = this.baseUrl + "/api/services/app/History/GetDetailBooking?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBooking(response_);
                } catch (e) {
                    return <Observable<GetDetailBookingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailBookingDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBooking(response: Response): Observable<GetDetailBookingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailBookingDto.fromJS(resultData200) : new GetDetailBookingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailBookingDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    getHistoryByBookCodeOrByUnitNoUnitCode(bookCode: string, psCode: string, by: number): Observable<GetHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/History/GetHistoryByBookCodeOrByUnitNoUnitCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (by === undefined || by === null)
            throw new Error("The parameter 'by' must be defined and cannot be null.");
        else
            url_ += "by=" + encodeURIComponent("" + by) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryByBookCodeOrByUnitNoUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryByBookCodeOrByUnitNoUnitCode(response_);
                } catch (e) {
                    return <Observable<GetHistoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHistoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryByBookCodeOrByUnitNoUnitCode(response: Response): Observable<GetHistoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetHistoryDto.fromJS(resultData200) : new GetHistoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHistoryDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createHistoryRemarks(input: CreateHistoryRemarksInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/History/CreateHistoryRemarks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateHistoryRemarks(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateHistoryRemarks(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateHistoryRemarks(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailHistory(notifHistoryId: number): Observable<GetDetailHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/History/GetDetailHistory?";
        if (notifHistoryId === undefined || notifHistoryId === null)
            throw new Error("The parameter 'notifHistoryId' must be defined and cannot be null.");
        else
            url_ += "notifHistoryId=" + encodeURIComponent("" + notifHistoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailHistory(response_);
                } catch (e) {
                    return <Observable<GetDetailHistoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailHistoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailHistory(response: Response): Observable<GetDetailHistoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailHistoryDto.fromJS(resultData200) : new GetDetailHistoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailHistoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownContactBy(): Observable<GetDropdownContactByDto[]> {
        let url_ = this.baseUrl + "/api/services/app/History/GetDropdownContactBy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownContactBy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownContactBy(response_);
                } catch (e) {
                    return <Observable<GetDropdownContactByDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownContactByDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownContactBy(response: Response): Observable<GetDropdownContactByDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownContactByDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownContactByDto[]>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    removeFileFromTemp(filename: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/History/RemoveFileFromTemp?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFileFromTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveFileFromTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFileFromTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: IncomeStatisticsDateInterval, startDate: moment.Moment, endDate: moment.Moment): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardStatisticsData(response_);
                } catch (e) {
                    return <Observable<HostDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardStatisticsData(response: Response): Observable<HostDashboardData> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostDashboardData>(<any>null);
    }

    /**
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: IncomeStatisticsDateInterval2, startDate: moment.Moment, endDate: moment.Moment): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIncomeStatistics(response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIncomeStatistics(response: Response): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment, endDate: moment.Moment): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionTenantStatistics(response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionTenantStatistics(response: Response): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionTenantStatisticsOutput>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<HostSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: HostSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class IDTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllIDTypeList(): Observable<ListResultDtoOfGetAllIDTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/IDType/GetAllIDTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllIDTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllIDTypeList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllIDTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllIDTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllIDTypeList(response: Response): Observable<ListResultDtoOfGetAllIDTypeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllIDTypeListDto.fromJS(resultData200) : new ListResultDtoOfGetAllIDTypeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllIDTypeListDto>(<any>null);
    }
}

@Injectable()
export class InputInventoryPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalInputInventory(input: CreateUniversalInputInventoryDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/CreateUniversalInputInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalInputInventory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalInputInventory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalInputInventory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @paymentDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataTransNoInventory(transNo: string, paymentDate: moment.Moment, bookCode: string, psCode: string, unitCode: string, unitNo: string, accID: number): Observable<GetDataTransNoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/GetDataTransNoInventory?";
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (paymentDate !== undefined)
            url_ += "paymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (accID === undefined || accID === null)
            throw new Error("The parameter 'accID' must be defined and cannot be null.");
        else
            url_ += "accID=" + encodeURIComponent("" + accID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataTransNoInventory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataTransNoInventory(response_);
                } catch (e) {
                    return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataTransNoInventory(response: Response): Observable<GetDataTransNoListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataTransNoListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataTransNoListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTransNoTTBG(input: GenerateTransNoInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/GenerateTransNoTTBG";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTransNoTTBG(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateTransNoTTBG(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTransNoTTBG(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownLkStatus(): Observable<GetDropdownLkStatusListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/GetDropdownLkStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownLkStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownLkStatus(response_);
                } catch (e) {
                    return <Observable<GetDropdownLkStatusListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownLkStatusListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownLkStatus(response: Response): Observable<GetDropdownLkStatusListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownLkStatusListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownLkStatusListDto[]>(<any>null);
    }

    /**
     * @transNoTTBG (optional) 
     * @return Success
     */
    getDataInventoryByTransNo(transNoTTBG: string): Observable<CreateUniversalInputInventoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/GetDataInventoryByTransNo?";
        if (transNoTTBG !== undefined)
            url_ += "transNoTTBG=" + encodeURIComponent("" + transNoTTBG) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataInventoryByTransNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataInventoryByTransNo(response_);
                } catch (e) {
                    return <Observable<CreateUniversalInputInventoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateUniversalInputInventoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataInventoryByTransNo(response: Response): Observable<CreateUniversalInputInventoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateUniversalInputInventoryDto.fromJS(resultData200) : new CreateUniversalInputInventoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateUniversalInputInventoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDataInventoryInputPayment(accID: number, bookingHeaderID: number, payForID: number): Observable<GetDataInventoryInputPaymentListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/GetDataInventoryInputPayment?";
        if (accID === undefined || accID === null)
            throw new Error("The parameter 'accID' must be defined and cannot be null.");
        else
            url_ += "accID=" + encodeURIComponent("" + accID) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataInventoryInputPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataInventoryInputPayment(response_);
                } catch (e) {
                    return <Observable<GetDataInventoryInputPaymentListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataInventoryInputPaymentListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataInventoryInputPayment(response: Response): Observable<GetDataInventoryInputPaymentListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataInventoryInputPaymentListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataInventoryInputPaymentListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrInventoryDetail(input: UpdateTrInventoryDetailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputInventoryPayment/UpdateTrInventoryDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrInventoryDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrInventoryDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrInventoryDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class InputPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getDataLookupPersonals(filter: string): Observable<GetDataPersonalsListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataLookupPersonals?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataLookupPersonals(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataLookupPersonals(response_);
                } catch (e) {
                    return <Observable<GetDataPersonalsListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataPersonalsListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataLookupPersonals(response: Response): Observable<GetDataPersonalsListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataPersonalsListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataPersonalsListDto[]>(<any>null);
    }

    /**
     * @listProject (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    getDataBookCode(listProject: number[], accountID: number, projectID: number, startDate: moment.Moment, endDate: moment.Moment, bookCode: string, psCode: string, unitID: number, unitCodeID: number): Observable<GetDataBookCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataBookCode?";
        if (listProject !== undefined)
            listProject && listProject.forEach(item => { url_ += "listProject=" + encodeURIComponent("" + item) + "&"; });
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataBookCode(response_);
                } catch (e) {
                    return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataBookCode(response: Response): Observable<GetDataBookCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataBookCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataBookCodeListDto[]>(<any>null);
    }

    /**
     * @listProject (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @limit (optional) 
     * @return Success
     */
    getListPSASView(listProject: number[], accountID: number, projectID: number, startDate: moment.Moment, endDate: moment.Moment, bookCode: string, psCode: string, unitID: number, unitCodeID: number, limit: number): Observable<GetListPSASViewResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetListPSASView?";
        if (listProject !== undefined)
            listProject && listProject.forEach(item => { url_ += "listProject=" + encodeURIComponent("" + item) + "&"; });
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPSASView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPSASView(response_);
                } catch (e) {
                    return <Observable<GetListPSASViewResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPSASViewResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPSASView(response: Response): Observable<GetListPSASViewResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPSASViewResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPSASViewResultDto[]>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @paymentDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @status (optional) 
     * @return Success
     */
    getDataLookupTransNo(transNo: string, paymentDate: moment.Moment, bookCode: string, psCode: string, unitCode: string, unitNo: string, status: string, accID: number, payForID: number, flag: number): Observable<GetDataTransNoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataLookupTransNo?";
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (paymentDate !== undefined)
            url_ += "paymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (accID === undefined || accID === null)
            throw new Error("The parameter 'accID' must be defined and cannot be null.");
        else
            url_ += "accID=" + encodeURIComponent("" + accID) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataLookupTransNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataLookupTransNo(response_);
                } catch (e) {
                    return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataLookupTransNo(response: Response): Observable<GetDataTransNoListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataTransNoListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataTransNoListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownUnitNoByUnitCodeID(unitCodeID: number): Observable<GetDropdownUnitNoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDropdownUnitNoByUnitCodeID?";
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitNoByUnitCodeID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitNoByUnitCodeID(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitNoListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitNoListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitNoByUnitCodeID(response: Response): Observable<GetDropdownUnitNoListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitNoListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitNoListDto[]>(<any>null);
    }

    /**
     * @listProject (optional) 
     * @filter (optional) 
     * @return Success
     */
    getDropdownUnitCode(listProject: number[], projectID: number, filter: string): Observable<GetDropdownUnitCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDropdownUnitCode?";
        if (listProject !== undefined)
            listProject && listProject.forEach(item => { url_ += "listProject=" + encodeURIComponent("" + item) + "&"; });
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitCode(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitCode(response: Response): Observable<GetDropdownUnitCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitCodeListDto[]>(<any>null);
    }

    /**
     * @pPNo (optional) 
     * @return Success
     */
    getClientInfo(bookingHeaderID: number, pPNo: string): Observable<GetDataClientInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetClientInfo?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClientInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClientInfo(response_);
                } catch (e) {
                    return <Observable<GetDataClientInfoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataClientInfoListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetClientInfo(response: Response): Observable<GetDataClientInfoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataClientInfoListDto.fromJS(resultData200) : new GetDataClientInfoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataClientInfoListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDataUnitInfo(bookingHeaderID: number): Observable<GetDataUnitInfoListDto> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataUnitInfo?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataUnitInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataUnitInfo(response_);
                } catch (e) {
                    return <Observable<GetDataUnitInfoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataUnitInfoListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataUnitInfo(response: Response): Observable<GetDataUnitInfoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataUnitInfoListDto.fromJS(resultData200) : new GetDataUnitInfoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataUnitInfoListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDataSchedulePayment(payForID: number, bookingHeaderID: number, accountID: number): Observable<GetDataSchedulePaymentListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataSchedulePayment?";
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSchedulePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSchedulePayment(response_);
                } catch (e) {
                    return <Observable<GetDataSchedulePaymentListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSchedulePaymentListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSchedulePayment(response: Response): Observable<GetDataSchedulePaymentListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataSchedulePaymentListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSchedulePaymentListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDataSchedulePaymentAjb(payForID: number, bookingHeaderID: number, accountID: number): Observable<GetDataSchedulePaymentAjbListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataSchedulePaymentAjb?";
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSchedulePaymentAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSchedulePaymentAjb(response_);
                } catch (e) {
                    return <Observable<GetDataSchedulePaymentAjbListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSchedulePaymentAjbListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSchedulePaymentAjb(response: Response): Observable<GetDataSchedulePaymentAjbListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataSchedulePaymentAjbListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSchedulePaymentAjbListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentDetail(input: CreatePaymentDetailInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrPaymentDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentDetail(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentDetail(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentDetailAjb(input: CreatePaymentDetailInputAjbDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrPaymentDetailAjb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentDetailAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentDetailAjb(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentDetailAjb(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentDetailAlloc(input: CreatePaymentDetailAllocInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrPaymentDetailAlloc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentDetailAlloc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentDetailAlloc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentDetailAlloc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownAllocationLkItem(accountID: number, bookingHeaderID: number): Observable<GetDropdownAllocationLkItemListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDropdownAllocationLkItem?";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownAllocationLkItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownAllocationLkItem(response_);
                } catch (e) {
                    return <Observable<GetDropdownAllocationLkItemListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownAllocationLkItemListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownAllocationLkItem(response: Response): Observable<GetDropdownAllocationLkItemListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownAllocationLkItemListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownAllocationLkItemListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentHeader(input: CreatePaymentHeaderInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrPaymentHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentHeader(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentHeader(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentHeaderAjb(input: CreatePaymentHeaderInputAjbDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrPaymentHeaderAjb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentHeaderAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentHeaderAjb(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentHeaderAjb(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @orToAdjust (optional) 
     * @transNo (optional) 
     * @return Success
     */
    updateTrPaymentHeader(orToAdjust: string, transNo: string, isSaveChanges: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/UpdateTrPaymentHeader?";
        if (orToAdjust !== undefined)
            url_ += "orToAdjust=" + encodeURIComponent("" + orToAdjust) + "&"; 
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (isSaveChanges === undefined || isSaveChanges === null)
            throw new Error("The parameter 'isSaveChanges' must be defined and cannot be null.");
        else
            url_ += "isSaveChanges=" + encodeURIComponent("" + isSaveChanges) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrPaymentHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrPaymentHeader(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrPaymentHeader(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInputPaymentUniversal(input: CreateInputPaymentUniversalInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateInputPaymentUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInputPaymentUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInputPaymentUniversal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInputPaymentUniversal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInputPaymentUniversalAjb(input: CreateInputPaymentAjbInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateInputPaymentUniversalAjb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInputPaymentUniversalAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInputPaymentUniversalAjb(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInputPaymentUniversalAjb(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @return Success
     */
    getPaymentForOTP(bookingHeaderId: number, transNo: string): Observable<CreatePaymentAlloc> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetPaymentForOTP?";
        if (bookingHeaderId === undefined || bookingHeaderId === null)
            throw new Error("The parameter 'bookingHeaderId' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderId=" + encodeURIComponent("" + bookingHeaderId) + "&"; 
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentForOTP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentForOTP(response_);
                } catch (e) {
                    return <Observable<CreatePaymentAlloc>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreatePaymentAlloc>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentForOTP(response: Response): Observable<CreatePaymentAlloc> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreatePaymentAlloc.fromJS(resultData200) : new CreatePaymentAlloc();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreatePaymentAlloc>(<any>null);
    }

    /**
     * @coCode (optional) 
     * @yearPeriod (optional) 
     * @bookCode (optional) 
     * @return Success
     */
    getFPNo(coCode: string, yearPeriod: string, bookCode: string, isSync: boolean): Observable<BatchPajakStockDto> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetFPNo?";
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        if (yearPeriod !== undefined)
            url_ += "yearPeriod=" + encodeURIComponent("" + yearPeriod) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (isSync === undefined || isSync === null)
            throw new Error("The parameter 'isSync' must be defined and cannot be null.");
        else
            url_ += "isSync=" + encodeURIComponent("" + isSync) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFPNo(response_);
                } catch (e) {
                    return <Observable<BatchPajakStockDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<BatchPajakStockDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFPNo(response: Response): Observable<BatchPajakStockDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BatchPajakStockDto.fromJS(resultData200) : new BatchPajakStockDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BatchPajakStockDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveBatchPajakToCCL(input: UpdateBatchPajakStockDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SaveBatchPajakToCCL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveBatchPajakToCCL(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveBatchPajakToCCL(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processSaveBatchPajakToCCL(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBatchPajakStock(input: UpdateBatchPajakStockDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/UpdateBatchPajakStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBatchPajakStock(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBatchPajakStock(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBatchPajakStock(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAccountingTrPaymentDetailJournal(input: CreateAccountingTrPaymentDetailJournalInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateAccountingTrPaymentDetailJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateAccountingTrPaymentDetailJournal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateAccountingTrPaymentDetailJournal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateAccountingTrPaymentDetailJournal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTAXTrFPHeader(input: CreateTAXTrFPHeaderInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTAXTrFPHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTAXTrFPHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTAXTrFPHeader(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTAXTrFPHeader(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateJurnalCode(input: GenerateJurnalInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GenerateJurnalCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateJurnalCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateJurnalCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateJurnalCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrJournal(input: CreateTrJournalInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTrJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrJournal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrJournal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrJournal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTAXTrFPDetail(input: CreateTAXTrFPDetailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/CreateTAXTrFPDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTAXTrFPDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTAXTrFPDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTAXTrFPDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTransNoWithoutCheckSys(input: GenerateTransNoInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GenerateTransNoWithoutCheckSys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTransNoWithoutCheckSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateTransNoWithoutCheckSys(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTransNoWithoutCheckSys(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @priorityPassNo (optional) 
     * @projectCode (optional) 
     * @return Success
     */
    getDataPriorityPassNo(priorityPassNo: string, projectCode: string): Observable<GetDataPriorityPassNoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataPriorityPassNo?";
        if (priorityPassNo !== undefined)
            url_ += "priorityPassNo=" + encodeURIComponent("" + priorityPassNo) + "&"; 
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataPriorityPassNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataPriorityPassNo(response_);
                } catch (e) {
                    return <Observable<GetDataPriorityPassNoListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataPriorityPassNoListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataPriorityPassNo(response: Response): Observable<GetDataPriorityPassNoListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataPriorityPassNoListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataPriorityPassNoListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    sendSMSORScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SendSMSORScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMSORScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMSORScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendSMSORScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendSMSOR2(input: SendSMSORInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SendSMSOR2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMSOR2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMSOR2(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendSMSOR2(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendSMSOR(input: SendEmailORInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SendSMSOR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMSOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMSOR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendSMSOR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePenaltySchedulePayment(input: UpdatePenaltySchedulePaymentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/UpdatePenaltySchedulePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePenaltySchedulePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePenaltySchedulePayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePenaltySchedulePayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    editSinglePayment(input: EditPaymentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/EditSinglePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditSinglePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditSinglePayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEditSinglePayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updatePenaltySchedulePaymentScheduller(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/UpdatePenaltySchedulePaymentScheduller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePenaltySchedulePaymentScheduller(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePenaltySchedulePaymentScheduller(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePenaltySchedulePaymentScheduller(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDataPayment(bookingHeaderID: number, payForID: number): Observable<GetPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataPayment?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataPayment(response_);
                } catch (e) {
                    return <Observable<GetPaymentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPaymentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataPayment(response: Response): Observable<GetPaymentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPaymentListDto.fromJS(resultData200) : new GetPaymentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPaymentListDto>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleSendSMSOR(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/ScheduleSendSMSOR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processScheduleSendSMSOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processScheduleSendSMSOR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processScheduleSendSMSOR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleSendSMSReminderPaymentOverdue(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/ScheduleSendSMSReminderPaymentOverdue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processScheduleSendSMSReminderPaymentOverdue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processScheduleSendSMSReminderPaymentOverdue(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processScheduleSendSMSReminderPaymentOverdue(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendSMSReminderPaymentOverdue(input: GetDataSendSMSRPListDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SendSMSReminderPaymentOverdue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMSReminderPaymentOverdue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMSReminderPaymentOverdue(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendSMSReminderPaymentOverdue(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPaymentBF(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SchedulerPaymentBF";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPaymentBF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPaymentBF(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPaymentBF(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @account (optional) 
     * @return Success
     */
    schedulerPaymentBFManual(account: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SchedulerPaymentBFManual?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPaymentBFManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPaymentBFManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPaymentBFManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @account (optional) 
     * @return Success
     */
    schedulerPaymentBFDate(account: string, startDate: moment.Moment, endDate: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/SchedulerPaymentBFDate?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPaymentBFDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPaymentBFDate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPaymentBFDate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @clearDate (optional) 
     * @payForCode (optional) 
     * @return Success
     */
    getDataLookupTransNoForAdj(bookingHeaderID: number, transNo: string, clearDate: moment.Moment, flag: number, payForCode: string): Observable<GetDataTransNoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InputPayment/GetDataLookupTransNoForAdj?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (clearDate !== undefined)
            url_ += "clearDate=" + encodeURIComponent(clearDate ? "" + clearDate.toJSON() : "") + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        if (payForCode !== undefined)
            url_ += "PayForCode=" + encodeURIComponent("" + payForCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataLookupTransNoForAdj(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataLookupTransNoForAdj(response_);
                } catch (e) {
                    return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataTransNoListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataLookupTransNoForAdj(response: Response): Observable<GetDataTransNoListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataTransNoListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataTransNoListDto[]>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setup(input: InstallDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAppSettingsJson(response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAppSettingsJson(response: Response): Observable<AppSettingsJsonDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDatabase(response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>Observable.throw(response_);
        });
    }

    protected processCheckDatabase(response: Response): Observable<CheckDatabaseOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InventoryDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @unitType (optional) 
     * @tower (optional) 
     * @return Success
     */
    getAllTypeTower(districtID: number, unitType: string, tower: string): Observable<GetAllTypeTowerListDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetAllTypeTower?";
        if (districtID === undefined || districtID === null)
            throw new Error("The parameter 'districtID' must be defined and cannot be null.");
        else
            url_ += "districtID=" + encodeURIComponent("" + districtID) + "&"; 
        if (unitType !== undefined)
            url_ += "unitType=" + encodeURIComponent("" + unitType) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTypeTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTypeTower(response_);
                } catch (e) {
                    return <Observable<GetAllTypeTowerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllTypeTowerListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTypeTower(response: Response): Observable<GetAllTypeTowerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAllTypeTowerListDto.fromJS(resultData200) : new GetAllTypeTowerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllTypeTowerListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDiagramaticInventoryDashboard(districtID: number): Observable<GetDiagramaticInventoryDashboardListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetDiagramaticInventoryDashboard?";
        if (districtID === undefined || districtID === null)
            throw new Error("The parameter 'districtID' must be defined and cannot be null.");
        else
            url_ += "districtID=" + encodeURIComponent("" + districtID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiagramaticInventoryDashboard(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiagramaticInventoryDashboard(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticInventoryDashboardListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticInventoryDashboardListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiagramaticInventoryDashboard(response: Response): Observable<GetDiagramaticInventoryDashboardListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticInventoryDashboardListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticInventoryDashboardListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDistrict(): Observable<GetDistrictListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetDistrict";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDistrict(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDistrict(response_);
                } catch (e) {
                    return <Observable<GetDistrictListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDistrictListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDistrict(response: Response): Observable<GetDistrictListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDistrictListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDistrictListDto[]>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @return Success
     */
    getTowerByUnitCodeMappingMap(unitCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetTowerByUnitCodeMappingMap?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTowerByUnitCodeMappingMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTowerByUnitCodeMappingMap(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTowerByUnitCodeMappingMap(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @tower (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUnitByTowerType(districtID: number, tower: string, unitNo: string): Observable<GetUnitByTowerTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetUnitByTowerType?";
        if (districtID === undefined || districtID === null)
            throw new Error("The parameter 'districtID' must be defined and cannot be null.");
        else
            url_ += "districtID=" + encodeURIComponent("" + districtID) + "&"; 
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByTowerType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByTowerType(response_);
                } catch (e) {
                    return <Observable<GetUnitByTowerTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitByTowerTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByTowerType(response: Response): Observable<GetUnitByTowerTypeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitByTowerTypeListDto.fromJS(resultData200) : new GetUnitByTowerTypeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitByTowerTypeListDto>(<any>null);
    }

    /**
     * @tower (optional) 
     * @return Success
     */
    getUnitTypeByTower(tower: string, districtID: number): Observable<GetUnitTypeByTowerListDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetUnitTypeByTower?";
        if (tower !== undefined)
            url_ += "tower=" + encodeURIComponent("" + tower) + "&"; 
        if (districtID === undefined || districtID === null)
            throw new Error("The parameter 'districtID' must be defined and cannot be null.");
        else
            url_ += "districtID=" + encodeURIComponent("" + districtID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByTower(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByTower(response_);
                } catch (e) {
                    return <Observable<GetUnitTypeByTowerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitTypeByTowerListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByTower(response: Response): Observable<GetUnitTypeByTowerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitTypeByTowerListDto.fromJS(resultData200) : new GetUnitTypeByTowerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitTypeByTowerListDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @tower (optional) 
     * @return Success
     */
    getUnitTypeByTowerUnit(unitCode: string, tower: string[], districtID: number): Observable<GetUnitTypeByTowerUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryDashboard/GetUnitTypeByTowerUnit?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (tower !== undefined)
            tower && tower.forEach(item => { url_ += "tower=" + encodeURIComponent("" + item) + "&"; });
        if (districtID === undefined || districtID === null)
            throw new Error("The parameter 'districtID' must be defined and cannot be null.");
        else
            url_ += "districtID=" + encodeURIComponent("" + districtID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByTowerUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByTowerUnit(response_);
                } catch (e) {
                    return <Observable<GetUnitTypeByTowerUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitTypeByTowerUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByTowerUnit(response: Response): Observable<GetUnitTypeByTowerUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitTypeByTowerUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitTypeByTowerUnitListDto[]>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInvoiceInfo(id: number): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceInfo(response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InvoiceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceInfo(response: Response): Observable<InvoiceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InvoiceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvoice(input: CreateInvoiceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class IPay88ServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingIPay88Request(input: CreateTransactionUniversalDto): Observable<DoBookingIPay88RequestResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IPay88/DoBookingIPay88Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingIPay88Request(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingIPay88Request(response_);
                } catch (e) {
                    return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingIPay88Request(response: Response): Observable<DoBookingIPay88RequestResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoBookingIPay88RequestResultDto.fromJS(resultData200) : new DoBookingIPay88RequestResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DoBookingIPay88RequestResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    doBookingCallbackIPay88(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/IPay88/DoBookingCallbackIPay88";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingCallbackIPay88(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingCallbackIPay88(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingCallbackIPay88(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reorderUnitIPay88(input: CreateTransactionUniversalDto): Observable<DoBookingIPay88RequestResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IPay88/ReorderUnitIPay88";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReorderUnitIPay88(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReorderUnitIPay88(response_);
                } catch (e) {
                    return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(response_);
        });
    }

    protected processReorderUnitIPay88(response: Response): Observable<DoBookingIPay88RequestResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoBookingIPay88RequestResultDto.fromJS(resultData200) : new DoBookingIPay88RequestResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DoBookingIPay88RequestResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    buyPPIPay88Request(input: BuyPPMidtransReqInputDto): Observable<DoBookingIPay88RequestResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IPay88/BuyPPIPay88Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBuyPPIPay88Request(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBuyPPIPay88Request(response_);
                } catch (e) {
                    return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(response_);
        });
    }

    protected processBuyPPIPay88Request(response: Response): Observable<DoBookingIPay88RequestResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoBookingIPay88RequestResultDto.fromJS(resultData200) : new DoBookingIPay88RequestResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DoBookingIPay88RequestResultDto>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguages(response: Response): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageForEdit(response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageForEdit(response: Response): Observable<GetLanguageForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLanguage(input: CreateOrUpdateLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteLanguage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDefaultLanguage(input: SetDefaultLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDefaultLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @baseLanguageName (optional) 
     * @targetValueFilter (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number, skipCount: number, sorting: string, sourceName: string, baseLanguageName: string, targetLanguageName: string, targetValueFilter: string, filterText: string): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageTexts(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageTexts(response: Response): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLanguageText(input: UpdateLanguageTextInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLanguageText(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLanguageText(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class LegalDocumentGeneratePdfExporterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @dto (optional) 
     * @return Success
     */
    printP3UGeneratePdf(dto: P32DocumentDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LegalDocumentGeneratePdfExporter/PrintP3UGeneratePdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintP3UGeneratePdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintP3UGeneratePdf(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processPrintP3UGeneratePdf(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    testPDF(input: PDFDataPemenangDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LegalDocumentGeneratePdfExporter/testPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestPDF(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestPDF(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ListProductPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @productName (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getListProduct(productName: string, memberCode: string): Observable<GetListProductPPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ListProductPP/GetListProduct?";
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProduct(response_);
                } catch (e) {
                    return <Observable<GetListProductPPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductPPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProduct(response: Response): Observable<GetListProductPPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductPPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductPPDto[]>(<any>null);
    }
}

@Injectable()
export class LkAddrTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLkAddrTypeDropdown(): Observable<ListResultDtoOfGetLkAddrTypeDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkAddrType/GetLkAddrTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkAddrTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkAddrTypeDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetLkAddrTypeDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetLkAddrTypeDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLkAddrTypeDropdown(response: Response): Observable<ListResultDtoOfGetLkAddrTypeDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetLkAddrTypeDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetLkAddrTypeDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetLkAddrTypeDropdownListDto>(<any>null);
    }
}

@Injectable()
export class LkBankTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkBankTypeList(): Observable<ListResultDtoOfGetAllBankTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkBankType/GetAllLkBankTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkBankTypeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkBankTypeList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllBankTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllBankTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkBankTypeList(response: Response): Observable<ListResultDtoOfGetAllBankTypeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllBankTypeListDto.fromJS(resultData200) : new ListResultDtoOfGetAllBankTypeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllBankTypeListDto>(<any>null);
    }
}

@Injectable()
export class LkBloodServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkBloodList(): Observable<ListResultDtoOfGetAllBloodListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkBlood/GetAllLkBloodList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkBloodList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkBloodList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllBloodListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllBloodListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkBloodList(response: Response): Observable<ListResultDtoOfGetAllBloodListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllBloodListDto.fromJS(resultData200) : new ListResultDtoOfGetAllBloodListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllBloodListDto>(<any>null);
    }
}

@Injectable()
export class LkCountryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkCountryList(): Observable<ListResultDtoOfGetAllCountryListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkCountry/GetAllLkCountryList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkCountryList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkCountryList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllCountryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllCountryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkCountryList(response: Response): Observable<ListResultDtoOfGetAllCountryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllCountryListDto.fromJS(resultData200) : new ListResultDtoOfGetAllCountryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllCountryListDto>(<any>null);
    }
}

@Injectable()
export class LkFacingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsFacing(): Observable<ListResultDtoOfGetAllMsFacingList> {
        let url_ = this.baseUrl + "/api/services/app/LkFacing/GetAllMsFacing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsFacing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsFacing(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsFacingList>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsFacingList>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsFacing(response: Response): Observable<ListResultDtoOfGetAllMsFacingList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsFacingList.fromJS(resultData200) : new ListResultDtoOfGetAllMsFacingList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsFacingList>(<any>null);
    }
}

@Injectable()
export class LkFamilyStatusServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLkFamilyStatusDropdown(): Observable<ListResultDtoOfGetLkFamilyStatusDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkFamilyStatus/GetLkFamilyStatusDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkFamilyStatusDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkFamilyStatusDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetLkFamilyStatusDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetLkFamilyStatusDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLkFamilyStatusDropdown(response: Response): Observable<ListResultDtoOfGetLkFamilyStatusDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetLkFamilyStatusDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetLkFamilyStatusDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetLkFamilyStatusDropdownListDto>(<any>null);
    }
}

@Injectable()
export class LkGradeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLkGradeDropdown(): Observable<ListResultDtoOfGetLkGradeDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkGrade/GetLkGradeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkGradeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkGradeDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetLkGradeDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetLkGradeDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLkGradeDropdown(response: Response): Observable<ListResultDtoOfGetLkGradeDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetLkGradeDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetLkGradeDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetLkGradeDropdownListDto>(<any>null);
    }
}

@Injectable()
export class LkKeyPeopleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkKeyPeopleDropdwon(): Observable<ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkKeyPeople/GetAllLkKeyPeopleDropdwon";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkKeyPeopleDropdwon(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkKeyPeopleDropdwon(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkKeyPeopleDropdwon(response: Response): Observable<ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto.fromJS(resultData200) : new ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto>(<any>null);
    }
}

@Injectable()
export class LkMarStatusServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkMarStatusList(): Observable<ListResultDtoOfGetAllMarStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkMarStatus/GetAllLkMarStatusList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkMarStatusList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkMarStatusList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMarStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMarStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkMarStatusList(response: Response): Observable<ListResultDtoOfGetAllMarStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMarStatusListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMarStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMarStatusListDto>(<any>null);
    }
}

@Injectable()
export class LkPhoneTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLkPhoneTypeDropdown(): Observable<GetLkPhoneTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LkPhoneType/GetLkPhoneTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkPhoneTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkPhoneTypeDropdown(response_);
                } catch (e) {
                    return <Observable<GetLkPhoneTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkPhoneTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkPhoneTypeDropdown(response: Response): Observable<GetLkPhoneTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkPhoneTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkPhoneTypeListDto[]>(<any>null);
    }
}

@Injectable()
export class LkReligionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkReligionList(): Observable<ListResultDtoOfGetAllReligionListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkReligion/GetAllLkReligionList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkReligionList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkReligionList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllReligionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllReligionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkReligionList(response: Response): Observable<ListResultDtoOfGetAllReligionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllReligionListDto.fromJS(resultData200) : new ListResultDtoOfGetAllReligionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllReligionListDto>(<any>null);
    }
}

@Injectable()
export class LkSpecServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkSpecList(): Observable<ListResultDtoOfGetAllSpecListDto> {
        let url_ = this.baseUrl + "/api/services/app/LkSpec/GetAllLkSpecList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkSpecList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkSpecList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllSpecListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllSpecListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkSpecList(response: Response): Observable<ListResultDtoOfGetAllSpecListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllSpecListDto.fromJS(resultData200) : new ListResultDtoOfGetAllSpecListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllSpecListDto>(<any>null);
    }
}

@Injectable()
export class LoginAppsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLinkApps(): Observable<LinkAppsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LoginApps/GetLinkApps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLinkApps(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLinkApps(response_);
                } catch (e) {
                    return <Observable<LinkAppsResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LinkAppsResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLinkApps(response: Response): Observable<LinkAppsResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LinkAppsResultDto.fromJS(resultData200) : new LinkAppsResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LinkAppsResultDto>(<any>null);
    }
}

@Injectable()
export class MappingDocServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTaskListMappingDocument(): Observable<GetTasklistMappingDocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MappingDoc/GetTaskListMappingDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListMappingDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListMappingDocument(response_);
                } catch (e) {
                    return <Observable<GetTasklistMappingDocumentDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMappingDocumentDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListMappingDocument(response: Response): Observable<GetTasklistMappingDocumentDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistMappingDocumentDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMappingDocumentDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingDocList(input: UpdateMappingDocInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MappingDoc/UpdateMappingDocList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingDocList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingDocList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingDocList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MarketingFactorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param (optional) 
     * @return Success
     */
    exportToExcelMarketingFactor(param: ExportMarketingFactorListDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MarketingFactor/ExportToExcelMarketingFactor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExportToExcelMarketingFactor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExportToExcelMarketingFactor(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processExportToExcelMarketingFactor(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class MasterCampaignServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMasterCampaign(input: CreateMasterCampaignInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/CreateOrUpdateMasterCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMasterCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMasterCampaign(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMasterCampaign(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailMasterCampaign(campaignHeaderID: number): Observable<GetDetailMasterCampaignListDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetDetailMasterCampaign?";
        if (campaignHeaderID === undefined || campaignHeaderID === null)
            throw new Error("The parameter 'campaignHeaderID' must be defined and cannot be null.");
        else
            url_ += "campaignHeaderID=" + encodeURIComponent("" + campaignHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMasterCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMasterCampaign(response_);
                } catch (e) {
                    return <Observable<GetDetailMasterCampaignListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMasterCampaignListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMasterCampaign(response: Response): Observable<GetDetailMasterCampaignListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMasterCampaignListDto.fromJS(resultData200) : new GetDetailMasterCampaignListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMasterCampaignListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownProgram(): Observable<GetDropdownProgramListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetDropdownProgram";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProgram(response_);
                } catch (e) {
                    return <Observable<GetDropdownProgramListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProgramListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProgram(response: Response): Observable<GetDropdownProgramListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProgramListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProgramListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTasklistMasterCampaign(projectID: number): Observable<GetTasklistMasterCampaignListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetTasklistMasterCampaign?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMasterCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMasterCampaign(response_);
                } catch (e) {
                    return <Observable<GetTasklistMasterCampaignListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMasterCampaignListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMasterCampaign(response: Response): Observable<GetTasklistMasterCampaignListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistMasterCampaignListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMasterCampaignListDto[]>(<any>null);
    }

    /**
     * @projectInfoId (optional) 
     * @return Success
     */
    tasklistMasterCampaign(projectID: number, projectInfoId: number[]): Observable<GetTasklistMasterCampaignListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/TasklistMasterCampaign?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectInfoId);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTasklistMasterCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTasklistMasterCampaign(response_);
                } catch (e) {
                    return <Observable<GetTasklistMasterCampaignListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMasterCampaignListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processTasklistMasterCampaign(response: Response): Observable<GetTasklistMasterCampaignListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistMasterCampaignListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMasterCampaignListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListProductLaunching(): Observable<GetListProductLaunchingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetListProductLaunching";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProductLaunching(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProductLaunching(response_);
                } catch (e) {
                    return <Observable<GetListProductLaunchingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductLaunchingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProductLaunching(response: Response): Observable<GetListProductLaunchingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductLaunchingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductLaunchingResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListProductPerProject(projectId: number): Observable<GetListProductLaunchingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetListProductPerProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProductPerProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProductPerProject(response_);
                } catch (e) {
                    return <Observable<GetListProductLaunchingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductLaunchingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProductPerProject(response: Response): Observable<GetListProductLaunchingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductLaunchingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductLaunchingResultDto[]>(<any>null);
    }

    /**
     * @projectInfoId (optional) 
     * @return Success
     */
    getListClusterByProjectInfo(projectInfoId: number[]): Observable<GetListClusterLaunchingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetListClusterByProjectInfo?";
        if (projectInfoId !== undefined)
            projectInfoId && projectInfoId.forEach(item => { url_ += "projectInfoId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListClusterByProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListClusterByProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetListClusterLaunchingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListClusterLaunchingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListClusterByProjectInfo(response: Response): Observable<GetListClusterLaunchingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListClusterLaunchingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListClusterLaunchingResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListClusterByProjecId(projectId: number): Observable<GetListClusterLaunchingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetListClusterByProjecId?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListClusterByProjecId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListClusterByProjecId(response_);
                } catch (e) {
                    return <Observable<GetListClusterLaunchingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListClusterLaunchingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListClusterByProjecId(response: Response): Observable<GetListClusterLaunchingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListClusterLaunchingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListClusterLaunchingResultDto[]>(<any>null);
    }

    /**
     * @clusterIds (optional) 
     * @return Success
     */
    getListUnitTypeByCluster(clusterIds: number[]): Observable<GetCampaignUnitType[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetListUnitTypeByCluster?";
        if (clusterIds !== undefined)
            clusterIds && clusterIds.forEach(item => { url_ += "clusterIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitTypeByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitTypeByCluster(response_);
                } catch (e) {
                    return <Observable<GetCampaignUnitType[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCampaignUnitType[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitTypeByCluster(response: Response): Observable<GetCampaignUnitType[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCampaignUnitType.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCampaignUnitType[]>(<any>null);
    }

    /**
     * @return Success
     */
    dropdownCampaign(projectId: number, clusterId: number): Observable<GetDropdownCampaignDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/DropdownCampaign?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "ClusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownCampaign(response_);
                } catch (e) {
                    return <Observable<GetDropdownCampaignDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCampaignDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownCampaign(response: Response): Observable<GetDropdownCampaignDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCampaignDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCampaignDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    dropdownHadiahUndian(campaignId: number): Observable<GetDropdownHadiahDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/DropdownHadiahUndian?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownHadiahUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownHadiahUndian(response_);
                } catch (e) {
                    return <Observable<GetDropdownHadiahDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownHadiahDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownHadiahUndian(response: Response): Observable<GetDropdownHadiahDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownHadiahDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownHadiahDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    totalSisahadiah(campaignId: number, rewardId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/TotalSisahadiah?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        if (rewardId === undefined || rewardId === null)
            throw new Error("The parameter 'rewardId' must be defined and cannot be null.");
        else
            url_ += "RewardId=" + encodeURIComponent("" + rewardId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalSisahadiah(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalSisahadiah(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processTotalSisahadiah(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    dropdownHistoryHadiahUndian(campaignId: number): Observable<GetHadiahDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/DropdownHistoryHadiahUndian?";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownHistoryHadiahUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownHistoryHadiahUndian(response_);
                } catch (e) {
                    return <Observable<GetHadiahDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHadiahDto>><any>Observable.throw(response_);
        });
    }

    protected processDropdownHistoryHadiahUndian(response: Response): Observable<GetHadiahDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetHadiahDto.fromJS(resultData200) : new GetHadiahDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHadiahDto>(<any>null);
    }

    /**
     * @return Success
     */
    historyPemenang(rewardID: number, campaignId: number): Observable<GetDetailUndianShowDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/HistoryPemenang?";
        if (rewardID === undefined || rewardID === null)
            throw new Error("The parameter 'rewardID' must be defined and cannot be null.");
        else
            url_ += "RewardID=" + encodeURIComponent("" + rewardID) + "&"; 
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processHistoryPemenang(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHistoryPemenang(response_);
                } catch (e) {
                    return <Observable<GetDetailUndianShowDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailUndianShowDto[]>><any>Observable.throw(response_);
        });
    }

    protected processHistoryPemenang(response: Response): Observable<GetDetailUndianShowDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailUndianShowDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailUndianShowDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRandomUndian(campaignID: number, rewardID: number): Observable<GetDetailUndianDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetRandomUndian?";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined and cannot be null.");
        else
            url_ += "CampaignID=" + encodeURIComponent("" + campaignID) + "&"; 
        if (rewardID === undefined || rewardID === null)
            throw new Error("The parameter 'rewardID' must be defined and cannot be null.");
        else
            url_ += "RewardID=" + encodeURIComponent("" + rewardID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRandomUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRandomUndian(response_);
                } catch (e) {
                    return <Observable<GetDetailUndianDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailUndianDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRandomUndian(response: Response): Observable<GetDetailUndianDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailUndianDto.fromJS(resultData200) : new GetDetailUndianDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailUndianDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    savePemenangUndian(input: InputPemenangDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/SavePemenangUndian";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSavePemenangUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSavePemenangUndian(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSavePemenangUndian(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    historyUndian(rewardID: number, campaignId: number): Observable<GetListHistoryUndianDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/HistoryUndian?";
        if (rewardID === undefined || rewardID === null)
            throw new Error("The parameter 'rewardID' must be defined and cannot be null.");
        else
            url_ += "RewardID=" + encodeURIComponent("" + rewardID) + "&"; 
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processHistoryUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHistoryUndian(response_);
                } catch (e) {
                    return <Observable<GetListHistoryUndianDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListHistoryUndianDto[]>><any>Observable.throw(response_);
        });
    }

    protected processHistoryUndian(response: Response): Observable<GetListHistoryUndianDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListHistoryUndianDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListHistoryUndianDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendNotificationPemenang(input: SendNotifPemenangDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/SendNotificationPemenang";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendNotificationPemenang(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendNotificationPemenang(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processSendNotificationPemenang(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    totalPoinMobile(input: InputHomeUndianMobileDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/TotalPoinMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTotalPoinMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTotalPoinMobile(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processTotalPoinMobile(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    listAcakUndianMobile(input: InputListUndianMobileDto): Observable<GetListAcakUndianMobileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/ListAcakUndianMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListAcakUndianMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListAcakUndianMobile(response_);
                } catch (e) {
                    return <Observable<GetListAcakUndianMobileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListAcakUndianMobileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processListAcakUndianMobile(response: Response): Observable<GetListAcakUndianMobileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListAcakUndianMobileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListAcakUndianMobileDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    geDetailUndianMobile(input: DetailUndianInputMobileDto): Observable<GetDetailRewardUndianMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GeDetailUndianMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeDetailUndianMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeDetailUndianMobile(response_);
                } catch (e) {
                    return <Observable<GetDetailRewardUndianMobileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailRewardUndianMobileDto>><any>Observable.throw(response_);
        });
    }

    protected processGeDetailUndianMobile(response: Response): Observable<GetDetailRewardUndianMobileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailRewardUndianMobileDto.fromJS(resultData200) : new GetDetailRewardUndianMobileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailRewardUndianMobileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    tukarPoinMobile(input: InsertTukarPoinMobileDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/TukarPoinMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTukarPoinMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTukarPoinMobile(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processTukarPoinMobile(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    listPemenangUndianMobile(siteID: number): Observable<GetListInfoPemenangUndianMobileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/ListPemenangUndianMobile?";
        if (siteID === undefined || siteID === null)
            throw new Error("The parameter 'siteID' must be defined and cannot be null.");
        else
            url_ += "siteID=" + encodeURIComponent("" + siteID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListPemenangUndianMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListPemenangUndianMobile(response_);
                } catch (e) {
                    return <Observable<GetListInfoPemenangUndianMobileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListInfoPemenangUndianMobileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processListPemenangUndianMobile(response: Response): Observable<GetListInfoPemenangUndianMobileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListInfoPemenangUndianMobileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListInfoPemenangUndianMobileDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    detailPemenangUndianMobile(input: DetailPemanangUndianInputMobileDto): Observable<DetailPemenangUndianMobileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/DetailPemenangUndianMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDetailPemenangUndianMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDetailPemenangUndianMobile(response_);
                } catch (e) {
                    return <Observable<DetailPemenangUndianMobileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailPemenangUndianMobileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDetailPemenangUndianMobile(response: Response): Observable<DetailPemenangUndianMobileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DetailPemenangUndianMobileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailPemenangUndianMobileDto[]>(<any>null);
    }

    /**
     * @email (optional) 
     * @return Success
     */
    getDataSubAccount(email: string): Observable<ResultSubAccount> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/getDataSubAccount?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSubAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSubAccount(response_);
                } catch (e) {
                    return <Observable<ResultSubAccount>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultSubAccount>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSubAccount(response: Response): Observable<ResultSubAccount> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultSubAccount.fromJS(resultData200) : new ResultSubAccount();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultSubAccount>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProjectDropdownUndian(): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetMsProjectDropdownUndian";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProjectDropdownUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProjectDropdownUndian(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProjectDropdownUndian(response: Response): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectDropdownListDto>(<any>null);
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @projectInfoID (optional) 
     * @return Success
     */
    getRewardByProjectInfoCampaign(projectInfoID: number[]): Observable<GetReward1DropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetRewardByProjectInfoCampaign?";
        if (projectInfoID !== undefined)
            projectInfoID && projectInfoID.forEach(item => { url_ += "projectInfoID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardByProjectInfoCampaign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardByProjectInfoCampaign(response_);
                } catch (e) {
                    return <Observable<GetReward1DropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReward1DropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardByProjectInfoCampaign(response: Response): Observable<GetReward1DropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetReward1DropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetReward1DropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getIsUndianBySiteID(siteID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MasterCampaign/GetIsUndianBySiteID?";
        if (siteID === undefined || siteID === null)
            throw new Error("The parameter 'siteID' must be defined and cannot be null.");
        else
            url_ += "siteID=" + encodeURIComponent("" + siteID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIsUndianBySiteID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIsUndianBySiteID(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetIsUndianBySiteID(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class MasterNotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTasklistMasterNotification(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetTasklistMasterNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetTasklistMasterNotification?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMasterNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMasterNotification(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTasklistMasterNotificationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTasklistMasterNotificationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMasterNotification(response: Response): Observable<PagedResultDtoOfGetTasklistMasterNotificationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetTasklistMasterNotificationDto.fromJS(resultData200) : new PagedResultDtoOfGetTasklistMasterNotificationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetTasklistMasterNotificationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailProjectNotif(projectId: number): Observable<GetDetailProjectNotifDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetDetailProjectNotif?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailProjectNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailProjectNotif(response_);
                } catch (e) {
                    return <Observable<GetDetailProjectNotifDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailProjectNotifDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailProjectNotif(response: Response): Observable<GetDetailProjectNotifDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailProjectNotifDto.fromJS(resultData200) : new GetDetailProjectNotifDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailProjectNotifDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTaskListHoldNotification(input: HoldNotificationInputDto): Observable<GetTaskListHoldNotificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetTaskListHoldNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListHoldNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListHoldNotification(response_);
                } catch (e) {
                    return <Observable<GetTaskListHoldNotificationDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListHoldNotificationDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListHoldNotification(response: Response): Observable<GetTaskListHoldNotificationDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTaskListHoldNotificationDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListHoldNotificationDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTaskListHoldNotificationOld(input: HoldNotificationInputDto): Observable<GetTaskListHoldNotificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetTaskListHoldNotificationOld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListHoldNotificationOld(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListHoldNotificationOld(response_);
                } catch (e) {
                    return <Observable<GetTaskListHoldNotificationDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListHoldNotificationDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListHoldNotificationOld(response: Response): Observable<GetTaskListHoldNotificationDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTaskListHoldNotificationDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListHoldNotificationDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownHoldByNotif(projectId: number, clusterId: number, flagHoldBy: number): Observable<GetDropdownBookCodeByNotifDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetDropdownHoldByNotif?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (flagHoldBy === undefined || flagHoldBy === null)
            throw new Error("The parameter 'flagHoldBy' must be defined and cannot be null.");
        else
            url_ += "flagHoldBy=" + encodeURIComponent("" + flagHoldBy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownHoldByNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownHoldByNotif(response_);
                } catch (e) {
                    return <Observable<GetDropdownBookCodeByNotifDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownBookCodeByNotifDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownHoldByNotif(response: Response): Observable<GetDropdownBookCodeByNotifDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownBookCodeByNotifDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownBookCodeByNotifDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateHoldNotif(input: CreateHoldNotifInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/CreateOrUpdateHoldNotif";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateHoldNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateHoldNotif(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateHoldNotif(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notifTypeCode (optional) 
     * @return Success
     */
    getDetailNotif(projectId: number, notifTypeCode: string): Observable<GetDetailNotifDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetDetailNotif?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailNotif(response_);
                } catch (e) {
                    return <Observable<GetDetailNotifDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailNotifDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailNotif(response: Response): Observable<GetDetailNotifDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailNotifDto.fromJS(resultData200) : new GetDetailNotifDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailNotifDto>(<any>null);
    }

    /**
     * @notifTypeCode (optional) 
     * @return Success
     */
    createTemplateNotification(projectID: number, notifTypeCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/CreateTemplateNotification?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTemplateNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTemplateNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTemplateNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTemplateNotification(input: UpdateTemplateNotificationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/UpdateTemplateNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTemplateNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTemplateNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTemplateNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getViewTemplateNotification(templateNotifId: number): Observable<GetTemplateViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetViewTemplateNotification?";
        if (templateNotifId === undefined || templateNotifId === null)
            throw new Error("The parameter 'templateNotifId' must be defined and cannot be null.");
        else
            url_ += "templateNotifId=" + encodeURIComponent("" + templateNotifId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetViewTemplateNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetViewTemplateNotification(response_);
                } catch (e) {
                    return <Observable<GetTemplateViewDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTemplateViewDto>><any>Observable.throw(response_);
        });
    }

    protected processGetViewTemplateNotification(response: Response): Observable<GetTemplateViewDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTemplateViewDto.fromJS(resultData200) : new GetTemplateViewDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTemplateViewDto>(<any>null);
    }

    /**
     * @notifTypeCode (optional) 
     * @return Success
     */
    getDropdownVariabel(notifTypeCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/GetDropdownVariabel?";
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownVariabel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownVariabel(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownVariabel(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @notifTypeCode (optional) 
     * @return Success
     */
    deleteTemplateNotif(projectId: number, notifTypeCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/DeleteTemplateNotif?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTemplateNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTemplateNotif(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTemplateNotif(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateNotifTemplateSMS(input: CreateUpdateNotifTemplateInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterNotification/CreateUpdateNotifTemplateSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateNotifTemplateSMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateNotifTemplateSMS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateNotifTemplateSMS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MasterVoucherBulkServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @keywords (optional) 
     * @return Success
     */
    getlistVoucherBulk(maxResultCount: number, skipCount: number, keywords: string, projectID: number): Observable<PagedResultDtoOfGetDataVoucherBulkDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterVoucherBulk/GetlistVoucherBulk?";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (keywords !== undefined)
            url_ += "keywords=" + encodeURIComponent("" + keywords) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetlistVoucherBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetlistVoucherBulk(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDataVoucherBulkDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDataVoucherBulkDto>><any>Observable.throw(response_);
        });
    }

    protected processGetlistVoucherBulk(response: Response): Observable<PagedResultDtoOfGetDataVoucherBulkDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDataVoucherBulkDto.fromJS(resultData200) : new PagedResultDtoOfGetDataVoucherBulkDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetDataVoucherBulkDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateVoucherBySystem(input: GenerateVoucherBySystemDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterVoucherBulk/GenerateVoucherBySystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateVoucherBySystem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateVoucherBySystem(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateVoucherBySystem(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateVoucherByExel(input: GenerateVoucherByExcel): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterVoucherBulk/GenerateVoucherByExel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateVoucherByExel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateVoucherByExel(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateVoucherByExel(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printVoucherBulk(input: InputPrintVoucherBulkDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterVoucherBulk/PrintVoucherBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintVoucherBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintVoucherBulk(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintVoucherBulk(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class MsAccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsAccount(input: CreateMsAccountInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/CreateMsAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsAccount(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/DeleteMsAccount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsAccount(isDefault: boolean): Observable<ListResultDtoOfGetAllAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetAllMsAccount?";
        if (isDefault === undefined || isDefault === null)
            throw new Error("The parameter 'isDefault' must be defined and cannot be null.");
        else
            url_ += "isDefault=" + encodeURIComponent("" + isDefault) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsAccount(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllAccountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllAccountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsAccount(response: Response): Observable<ListResultDtoOfGetAllAccountListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllAccountListDto.fromJS(resultData200) : new ListResultDtoOfGetAllAccountListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllAccountListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveMsBankBranch(bankID: number): Observable<ListResultDtoOfGetActiveMsBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetActiveMsBankBranch?";
        if (bankID === undefined || bankID === null)
            throw new Error("The parameter 'bankID' must be defined and cannot be null.");
        else
            url_ += "bankID=" + encodeURIComponent("" + bankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveMsBankBranch(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetActiveMsBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetActiveMsBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveMsBankBranch(response: Response): Observable<ListResultDtoOfGetActiveMsBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetActiveMsBankBranchListDto.fromJS(resultData200) : new ListResultDtoOfGetActiveMsBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetActiveMsBankBranchListDto>(<any>null);
    }

    /**
     * @coCode (optional) 
     * @return Success
     */
    getMsAccountCheckRoles(userID: number, coCode: string): Observable<GetAllAccountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetMsAccountCheckRoles?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsAccountCheckRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsAccountCheckRoles(response_);
                } catch (e) {
                    return <Observable<GetAllAccountListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllAccountListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsAccountCheckRoles(response: Response): Observable<GetAllAccountListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllAccountListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllAccountListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsAccount(input: CreateMsAccountInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/UpdateMsAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsAccount(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsAccount(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankByAccount(accountID: number): Observable<GetActiveMsBankBranchListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/GetMsBankByAccount?";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankByAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankByAccount(response_);
                } catch (e) {
                    return <Observable<GetActiveMsBankBranchListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetActiveMsBankBranchListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankByAccount(response: Response): Observable<GetActiveMsBankBranchListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetActiveMsBankBranchListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetActiveMsBankBranchListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteRolesAccount(input: CreateDeleteSysRolesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsAccount/CreateDeleteRolesAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteRolesAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteRolesAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteRolesAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsAreaServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsArea(input: CreateMsAreaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsArea/CreateMsArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsArea(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsArea(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsArea(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsArea(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsArea/DeleteMsArea?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsArea(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsArea(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsArea(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsArea(): Observable<ListResultDtoOfGetMsAreaListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsArea/GetAllMsArea";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsArea(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsArea(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsAreaListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsAreaListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsArea(response: Response): Observable<ListResultDtoOfGetMsAreaListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsAreaListDto.fromJS(resultData200) : new ListResultDtoOfGetMsAreaListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsAreaListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsArea(input: UpdateMsAreaInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsArea/UpdateMsArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsArea(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsArea(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsArea(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsAssetDevILustrationsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getDataMasterAssetDevILustration(filter: string, projectID: number, clusterID: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfMasterAssetDevIlustrationDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/GetDataMasterAssetDevILustration?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "ClusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMasterAssetDevILustration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMasterAssetDevILustration(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMasterAssetDevIlustrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfMasterAssetDevIlustrationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMasterAssetDevILustration(response: Response): Observable<PagedResultDtoOfMasterAssetDevIlustrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfMasterAssetDevIlustrationDto.fromJS(resultData200) : new PagedResultDtoOfMasterAssetDevIlustrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfMasterAssetDevIlustrationDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUpdateMasterAssetDevILustration(input: CreateUpdateDeleteMasterAssetDevIlustrationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/InsertUpdateMasterAssetDevILustration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUpdateMasterAssetDevILustration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUpdateMasterAssetDevILustration(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertUpdateMasterAssetDevILustration(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMasterAssetDevILustration(input: number): Observable<MsAssetDevIlustrationResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/DeleteMasterAssetDevILustration?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMasterAssetDevILustration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMasterAssetDevILustration(response_);
                } catch (e) {
                    return <Observable<MsAssetDevIlustrationResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MsAssetDevIlustrationResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMasterAssetDevILustration(response: Response): Observable<MsAssetDevIlustrationResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MsAssetDevIlustrationResultMessageDto.fromJS(resultData200) : new MsAssetDevIlustrationResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MsAssetDevIlustrationResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    setFileName(projectID: number, clusterID: number): Observable<FileNameAssetDevILustrationDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/SetFileName?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetFileName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetFileName(response_);
                } catch (e) {
                    return <Observable<FileNameAssetDevILustrationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileNameAssetDevILustrationDto>><any>Observable.throw(response_);
        });
    }

    protected processSetFileName(response: Response): Observable<FileNameAssetDevILustrationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileNameAssetDevILustrationDto.fromJS(resultData200) : new FileNameAssetDevILustrationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileNameAssetDevILustrationDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getAssetDevIlustration(cluster: number, unitCode: string, unitNo: string): Observable<MasterAssetDevIlustrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/GetAssetDevIlustration?";
        if (cluster === undefined || cluster === null)
            throw new Error("The parameter 'cluster' must be defined and cannot be null.");
        else
            url_ += "cluster=" + encodeURIComponent("" + cluster) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAssetDevIlustration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAssetDevIlustration(response_);
                } catch (e) {
                    return <Observable<MasterAssetDevIlustrationDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MasterAssetDevIlustrationDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAssetDevIlustration(response: Response): Observable<MasterAssetDevIlustrationDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MasterAssetDevIlustrationDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MasterAssetDevIlustrationDto[]>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getAssetDevIlustrationForViewUnitInfo(cluster: number, unitCode: string, unitNo: string): Observable<MasterAssetDevIlustrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/GetAssetDevIlustrationForViewUnitInfo?";
        if (cluster === undefined || cluster === null)
            throw new Error("The parameter 'cluster' must be defined and cannot be null.");
        else
            url_ += "cluster=" + encodeURIComponent("" + cluster) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAssetDevIlustrationForViewUnitInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAssetDevIlustrationForViewUnitInfo(response_);
                } catch (e) {
                    return <Observable<MasterAssetDevIlustrationDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MasterAssetDevIlustrationDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAssetDevIlustrationForViewUnitInfo(response: Response): Observable<MasterAssetDevIlustrationDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MasterAssetDevIlustrationDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MasterAssetDevIlustrationDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cekFileNameAssetDevIll(projectID: number, clusterID: number, input: string): Observable<ValidatedAssetResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsAssetDevILustrations/cekFileNameAssetDevIll?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCekFileNameAssetDevIll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCekFileNameAssetDevIll(response_);
                } catch (e) {
                    return <Observable<ValidatedAssetResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidatedAssetResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCekFileNameAssetDevIll(response: Response): Observable<ValidatedAssetResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidatedAssetResultMessageDto.fromJS(resultData200) : new ValidatedAssetResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValidatedAssetResultMessageDto>(<any>null);
    }
}

@Injectable()
export class MsBankServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsBank(input: CreateMsBankInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/CreateMsBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsBank(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/DeleteMsBank?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsBank(): Observable<ListResultDtoOfGetAllBankListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/GetAllMsBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsBank(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllBankListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllBankListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsBank(response: Response): Observable<ListResultDtoOfGetAllBankListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllBankListDto.fromJS(resultData200) : new ListResultDtoOfGetAllBankListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllBankListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsBankList(): Observable<ListResultDtoOfGetBankListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/GetAllMsBankList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsBankList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsBankList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsBankList(response: Response): Observable<ListResultDtoOfGetBankListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankListDto.fromJS(resultData200) : new ListResultDtoOfGetBankListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankDropDown(): Observable<ListResultDtoOfGetBankDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/GetMsBankDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankDropDown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankDropDown(response: Response): Observable<ListResultDtoOfGetBankDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetBankDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankDropDownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankDropDownByAccount(accountID: number): Observable<ListResultDtoOfGetBankDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/GetMsBankDropDownByAccount?";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankDropDownByAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankDropDownByAccount(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankDropDownByAccount(response: Response): Observable<ListResultDtoOfGetBankDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetBankDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankDropDownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBankTypeDropdown(): Observable<ListResultDtoOfGetTypeBankDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/GetBankTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankTypeDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetTypeBankDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetTypeBankDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBankTypeDropdown(response: Response): Observable<ListResultDtoOfGetTypeBankDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetTypeBankDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetTypeBankDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetTypeBankDropDownListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsBank(input: GetAllBankListDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsBank/UpdateMsBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsBank(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsBank(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class MsBankBranchServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteMsBankBranch(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/DeleteMsBankBranch?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsBankBranch(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsBankBranch(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankBranch(): Observable<ListResultDtoOfGetBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetMsBankBranch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankBranch(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankBranch(response: Response): Observable<ListResultDtoOfGetBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankBranchListDto.fromJS(resultData200) : new ListResultDtoOfGetBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankBranchListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsBankBranch(): Observable<ListResultDtoOfGetAllBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetAllMsBankBranch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsBankBranch(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsBankBranch(response: Response): Observable<ListResultDtoOfGetAllBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllBankBranchListDto.fromJS(resultData200) : new ListResultDtoOfGetAllBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllBankBranchListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveMsBank(): Observable<ListResultDtoOfGetBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetActiveMsBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveMsBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveMsBank(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveMsBank(response: Response): Observable<ListResultDtoOfGetBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankBranchListDto.fromJS(resultData200) : new ListResultDtoOfGetBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankBranchListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankBranchByBank(bankId: number): Observable<ListResultDtoOfGetBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetMsBankBranchByBank?";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined and cannot be null.");
        else
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankBranchByBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankBranchByBank(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankBranchByBank(response: Response): Observable<ListResultDtoOfGetBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankBranchListDto.fromJS(resultData200) : new ListResultDtoOfGetBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankBranchListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailMsBankBranch(id: number): Observable<GetBankBranchListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetDetailMsBankBranch?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMsBankBranch(response_);
                } catch (e) {
                    return <Observable<GetBankBranchListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBankBranchListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMsBankBranch(response: Response): Observable<GetBankBranchListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetBankBranchListDto.fromJS(resultData200) : new GetBankBranchListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetBankBranchListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsBankBranch(input: CreateMsBankBranchInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/CreateMsBankBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsBankBranch(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsBankBranch(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsBankBranch(input: UpdateMsBankBranchInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/UpdateMsBankBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsBankBranch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsBankBranch(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsBankBranch(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getBankBranchTypeDropdown(): Observable<ListResultDtoOfGetBankBranchTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankBranch/GetBankBranchTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankBranchTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankBranchTypeDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankBranchTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankBranchTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBankBranchTypeDropdown(response: Response): Observable<ListResultDtoOfGetBankBranchTypeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankBranchTypeListDto.fromJS(resultData200) : new ListResultDtoOfGetBankBranchTypeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankBranchTypeListDto>(<any>null);
    }
}

@Injectable()
export class MsBankPersonalsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsBankList(): Observable<ListResultDtoOfGetAllBankPersonalsListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsBankPersonals/GetAllMsBankList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsBankList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsBankList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllBankPersonalsListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllBankPersonalsListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsBankList(response: Response): Observable<ListResultDtoOfGetAllBankPersonalsListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllBankPersonalsListDto.fromJS(resultData200) : new ListResultDtoOfGetAllBankPersonalsListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllBankPersonalsListDto>(<any>null);
    }
}

@Injectable()
export class MsCategoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsCategory(): Observable<ListResultDtoOfGetAllCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/GetAllMsCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsCategory(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllCategoryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllCategoryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsCategory(response: Response): Observable<ListResultDtoOfGetAllCategoryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllCategoryListDto.fromJS(resultData200) : new ListResultDtoOfGetAllCategoryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllCategoryListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsCategory(input: CreateCategoryInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/CreateMsCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsCategory(input: GetAllCategoryListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/UpdateMsCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCategoryDropdown(): Observable<ListResultDtoOfGetCategoryDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/GetMsCategoryDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCategoryDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCategoryDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetCategoryDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetCategoryDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCategoryDropdown(response: Response): Observable<ListResultDtoOfGetCategoryDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetCategoryDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetCategoryDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetCategoryDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsCategory(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/DeleteMsCategory?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsCategory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsCategory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCategoryDropdownByProjectCluster(projectID: number, clusterID: number): Observable<ListResultDtoOfGetCategoryDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCategory/GetMsCategoryDropdownByProjectCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCategoryDropdownByProjectCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCategoryDropdownByProjectCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetCategoryDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetCategoryDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCategoryDropdownByProjectCluster(response: Response): Observable<ListResultDtoOfGetCategoryDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetCategoryDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetCategoryDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetCategoryDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsCityServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsCity(input: GetCreateMsCityInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCity/CreateMsCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsCity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsCity(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDropdownMsCity(countyID: number): Observable<ListResultDtoOfGetMsCityListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCity/GetAllDropdownMsCity?";
        if (countyID === undefined || countyID === null)
            throw new Error("The parameter 'countyID' must be defined and cannot be null.");
        else
            url_ += "countyID=" + encodeURIComponent("" + countyID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllDropdownMsCity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllDropdownMsCity(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsCityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsCityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllDropdownMsCity(response: Response): Observable<ListResultDtoOfGetMsCityListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsCityListDto.fromJS(resultData200) : new ListResultDtoOfGetMsCityListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsCityListDto>(<any>null);
    }
}

@Injectable()
export class MsClusterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsCluster(input: CreateOrUpdateMsClusterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/CreateMsCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsCluster(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/DeleteMsCluster?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsCluster(projectID: number): Observable<ListResultDtoOfGetAllMsClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetAllMsCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsCluster(response: Response): Observable<ListResultDtoOfGetAllMsClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsClusterListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsClusterByProjectDropdown(projectID: number): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetMsClusterByProjectDropdown?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsClusterByProjectDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsClusterByProjectDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsClusterByProjectDropdown(response: Response): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetClusterDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterDropdownListDto>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getMsClusterByProjectDropdownUploadBulk(projectID: number[]): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetMsClusterByProjectDropdownUploadBulk?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsClusterByProjectDropdownUploadBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsClusterByProjectDropdownUploadBulk(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsClusterByProjectDropdownUploadBulk(response: Response): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetClusterDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsClusterByProjectOB(projectID: number): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetMsClusterByProjectOB?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsClusterByProjectOB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsClusterByProjectOB(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsClusterByProjectOB(response: Response): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetClusterDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsClusterDropdownPerProject(projectID: number): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetMsClusterDropdownPerProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsClusterDropdownPerProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsClusterDropdownPerProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetClusterDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsClusterDropdownPerProject(response: Response): Observable<ListResultDtoOfGetClusterDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetClusterDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetClusterDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetClusterDropdownListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsCluster(input: CreateOrUpdateMsClusterInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/UpdateMsCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsCluster(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsCluster(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getMsClusterDetail(clusterID: number): Observable<CreateOrUpdateMsClusterInputDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetMsClusterDetail?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsClusterDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsClusterDetail(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateMsClusterInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateMsClusterInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsClusterDetail(response: Response): Observable<CreateOrUpdateMsClusterInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateMsClusterInputDto.fromJS(resultData200) : new CreateOrUpdateMsClusterInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateMsClusterInputDto>(<any>null);
    }

    /**
     * @return Success
     */
    isExistsPICCluser(clusterID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/IsExistsPICCluser?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsPICCluser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsPICCluser(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsPICCluser(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getAvailableMsProjectDropdownForCluster(): Observable<ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCluster/GetAvailableMsProjectDropdownForCluster";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAvailableMsProjectDropdownForCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAvailableMsProjectDropdownForCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAvailableMsProjectDropdownForCluster(response: Response): Observable<ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto.fromJS(resultData200) : new ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto>(<any>null);
    }
}

@Injectable()
export class MsCompanyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsCompany(input: CreateMsCompanyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/CreateMsCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsCompany(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsCompany(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailMsCompany(companyId: number): Observable<GetDetailMsCompanyListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetDetailMsCompany?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMsCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMsCompany(response_);
                } catch (e) {
                    return <Observable<GetDetailMsCompanyListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMsCompanyListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMsCompany(response: Response): Observable<GetDetailMsCompanyListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMsCompanyListDto.fromJS(resultData200) : new GetDetailMsCompanyListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMsCompanyListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCompany(): Observable<ListResultDtoOfGetMsCompanyListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCompany(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsCompanyListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsCompanyListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCompany(response: Response): Observable<ListResultDtoOfGetMsCompanyListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsCompanyListDto.fromJS(resultData200) : new ListResultDtoOfGetMsCompanyListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsCompanyListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCountry(): Observable<ListResultDtoOfGetCountryListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCountry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCountry(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetCountryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetCountryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCountry(response: Response): Observable<ListResultDtoOfGetCountryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetCountryListDto.fromJS(resultData200) : new ListResultDtoOfGetCountryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetCountryListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsTownByCountry(countryId: number): Observable<ListResultDtoOfGetTownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsTownByCountry?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsTownByCountry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsTownByCountry(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetTownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetTownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsTownByCountry(response: Response): Observable<ListResultDtoOfGetTownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetTownListDto.fromJS(resultData200) : new ListResultDtoOfGetTownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetTownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsPostCodeByTown(townId: number): Observable<ListResultDtoOfGetPostCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsPostCodeByTown?";
        if (townId === undefined || townId === null)
            throw new Error("The parameter 'townId' must be defined and cannot be null.");
        else
            url_ += "townId=" + encodeURIComponent("" + townId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsPostCodeByTown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsPostCodeByTown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPostCodeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPostCodeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsPostCodeByTown(response: Response): Observable<ListResultDtoOfGetPostCodeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPostCodeListDto.fromJS(resultData200) : new ListResultDtoOfGetPostCodeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetPostCodeListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsCompany(input: UpdateMsCompanyInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/UpdateMsCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsCompany(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsCompany(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCompanyDropDown(): Observable<ListResultDtoOfGetMsCompanyDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsCompanyDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCompanyDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCompanyDropDown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsCompanyDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsCompanyDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCompanyDropDown(response: Response): Observable<ListResultDtoOfGetMsCompanyDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsCompanyDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsCompanyDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsCompanyDropDownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsCompanyDropDownMapping(): Observable<ListResultDtoOfGetMsCompanyDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMsCompanyDropDownMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsCompanyDropDownMapping(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsCompanyDropDownMapping(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsCompanyDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsCompanyDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsCompanyDropDownMapping(response: Response): Observable<ListResultDtoOfGetMsCompanyDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsCompanyDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsCompanyDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsCompanyDropDownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getCompanyIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetCompanyIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCompanyIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCompanyIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCompanyIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/DeleteMsCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsCompany(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsCompany(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMappingCorsec(): Observable<GetMappingCorsecListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsCompany/GetMappingCorsec";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingCorsec(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingCorsec(response_);
                } catch (e) {
                    return <Observable<GetMappingCorsecListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMappingCorsecListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingCorsec(response: Response): Observable<GetMappingCorsecListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMappingCorsecListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMappingCorsecListDto[]>(<any>null);
    }
}

@Injectable()
export class MsCountyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsCounty(input: GetCreateMsCountyInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsCounty/CreateMsCounty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsCounty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsCounty(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsCounty(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDropdownMsCounty(territoryID: number): Observable<ListResultDtoOfGetMsCountyListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsCounty/GetAllDropdownMsCounty?";
        if (territoryID === undefined || territoryID === null)
            throw new Error("The parameter 'territoryID' must be defined and cannot be null.");
        else
            url_ += "territoryID=" + encodeURIComponent("" + territoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllDropdownMsCounty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllDropdownMsCounty(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsCountyListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsCountyListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllDropdownMsCounty(response: Response): Observable<ListResultDtoOfGetMsCountyListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsCountyListDto.fromJS(resultData200) : new ListResultDtoOfGetMsCountyListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsCountyListDto>(<any>null);
    }
}

@Injectable()
export class MsDepartmentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsDepartment(): Observable<ListResultDtoOfGetAllDepartmentListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/GetAllMsDepartment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsDepartment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsDepartment(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllDepartmentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllDepartmentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsDepartment(response: Response): Observable<ListResultDtoOfGetAllDepartmentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllDepartmentListDto.fromJS(resultData200) : new ListResultDtoOfGetAllDepartmentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllDepartmentListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsDepartmentPICInformation(): Observable<ListResultDtoOfGetMsDepartmentDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/GetMsDepartmentPICInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsDepartmentPICInformation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsDepartmentPICInformation(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsDepartmentDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsDepartmentDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsDepartmentPICInformation(response: Response): Observable<ListResultDtoOfGetMsDepartmentDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsDepartmentDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsDepartmentDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsDepartmentDropdownListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsDepartment(input: CreateOrUpdateMsDepartmentInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/CreateMsDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsDepartment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsDepartment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsDepartment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsDepartment(input: CreateOrUpdateMsDepartmentInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/UpdateMsDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsDepartment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsDepartment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsDepartment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsDepartment(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/DeleteMsDepartment?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsDepartment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsDepartment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsDepartment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsDepartmentDropdown(): Observable<ListResultDtoOfGetMsDepartmentDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDepartment/GetMsDepartmentDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsDepartmentDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsDepartmentDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsDepartmentDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsDepartmentDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsDepartmentDropdown(response: Response): Observable<ListResultDtoOfGetMsDepartmentDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsDepartmentDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsDepartmentDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsDepartmentDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsDetailServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAbsoluteUri(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MsDetail/getAbsoluteUri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAbsoluteUri(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAbsoluteUri(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAbsoluteUri(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsDetail(input: CreateOrUpdateMsDetailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDetail/CreateMsDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsDetail(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDetail/DeleteMsDetail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsDetail(): Observable<ListResultDtoOfGetAllMsDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDetail/GetAllMsDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsDetail(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsDetailListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsDetailListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsDetail(response: Response): Observable<ListResultDtoOfGetAllMsDetailListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsDetailListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsDetailListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsDetailListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsDetail(input: CreateOrUpdateMsDetailInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsDetail/UpdateMsDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsDetail(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsDetail(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class MsDiscountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsDiscount(input: CreateMsDiscountInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsDiscount/CreateMsDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsDiscount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsDiscount(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsDiscount(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsDiscount(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsDiscount/DeleteMsDiscount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsDiscount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsDiscount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsDiscount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsDiscount(): Observable<ListResultDtoOfGetAllMsDiscountListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDiscount/GetAllMsDiscount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsDiscount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsDiscount(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsDiscountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsDiscountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsDiscount(response: Response): Observable<ListResultDtoOfGetAllMsDiscountListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsDiscountListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsDiscountListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsDiscountListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsDiscount(input: CreateMsDiscountInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsDiscount/UpdateMsDiscount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsDiscount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsDiscount(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsDiscount(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class MsDocumentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsDocumentList(): Observable<ListResultDtoOfGetAllDocumentListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsDocument/GetAllMsDocumentList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsDocumentList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsDocumentList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllDocumentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllDocumentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsDocumentList(response: Response): Observable<ListResultDtoOfGetAllDocumentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllDocumentListDto.fromJS(resultData200) : new ListResultDtoOfGetAllDocumentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllDocumentListDto>(<any>null);
    }
}

@Injectable()
export class MsEntityServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsEntity(input: GetAllMsEntityListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsEntity/CreateMsEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsEntity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsEntity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsEntity(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsEntity(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsEntity/DeleteMsEntity?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsEntity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsEntity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsEntity(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsEntity(): Observable<ListResultDtoOfGetAllMsEntityListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsEntity/GetAllMsEntity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsEntity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsEntity(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsEntityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsEntityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsEntity(response: Response): Observable<ListResultDtoOfGetAllMsEntityListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsEntityListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsEntityListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsEntityListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsEntityDropdown(): Observable<ListResultDtoOfGetAllMsEntityListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsEntity/GetMsEntityDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsEntityDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsEntityDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsEntityListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsEntityListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsEntityDropdown(response: Response): Observable<ListResultDtoOfGetAllMsEntityListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsEntityListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsEntityListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsEntityListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsEntity(input: GetAllMsEntityListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsEntity/UpdateMsEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsEntity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsEntity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsEntity(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsFacadeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsFacade(input: CreateMsFacadeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsFacade/CreateMsFacade";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsFacade(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsFacade(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsFacade(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsFacade(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsFacade/DeleteMsFacade?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsFacade(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsFacade(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsFacade(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsFacadeByProject(projectID: number): Observable<ListResultDtoOfGetMsFacadeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsFacade/GetAllMsFacadeByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsFacadeByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsFacadeByProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsFacadeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsFacadeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsFacadeByProject(response: Response): Observable<ListResultDtoOfGetMsFacadeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsFacadeListDto.fromJS(resultData200) : new ListResultDtoOfGetMsFacadeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsFacadeListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitDetailByProjectCluster(projectID: number, clusterID: number): Observable<ListResultDtoOfGetUnitDetailByProjectClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsFacade/GetUnitDetailByProjectCluster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitDetailByProjectCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitDetailByProjectCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitDetailByProjectClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitDetailByProjectClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitDetailByProjectCluster(response: Response): Observable<ListResultDtoOfGetUnitDetailByProjectClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitDetailByProjectClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitDetailByProjectClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitDetailByProjectClusterListDto>(<any>null);
    }
}

@Injectable()
export class MsFinTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsFinType(input: CreateMsFinTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsFinType/CreateMsFinType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsFinType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsFinType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsFinType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsFinType(finTypeID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsFinType/DeleteMsFinType?";
        if (finTypeID === undefined || finTypeID === null)
            throw new Error("The parameter 'finTypeID' must be defined and cannot be null.");
        else
            url_ += "finTypeID=" + encodeURIComponent("" + finTypeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsFinType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsFinType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsFinType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllFinType(): Observable<ListResultDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/MsFinType/GetAllFinType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllFinType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllFinType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfString>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfString>><any>Observable.throw(response_);
        });
    }

    protected processGetAllFinType(response: Response): Observable<ListResultDtoOfString> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfString.fromJS(resultData200) : new ListResultDtoOfString();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfString>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsFinType(): Observable<ListResultDtoOfGetAllMsFinTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsFinType/GetAllMsFinType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsFinType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsFinType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsFinTypeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsFinTypeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsFinType(response: Response): Observable<ListResultDtoOfGetAllMsFinTypeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsFinTypeListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsFinTypeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsFinTypeListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsFinType(input: UpdateMsFinTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsFinType/UpdateMsFinType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsFinType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsFinType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsFinType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsFranchiseGroupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getFranchiseGroupDropdown(): Observable<ListResultDtoOfGetFranchiseGroupDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsFranchiseGroup/GetFranchiseGroupDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFranchiseGroupDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFranchiseGroupDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetFranchiseGroupDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetFranchiseGroupDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFranchiseGroupDropdown(response: Response): Observable<ListResultDtoOfGetFranchiseGroupDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetFranchiseGroupDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetFranchiseGroupDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetFranchiseGroupDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsItemServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsItem(): Observable<ListResultDtoOfGetAllMsItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/GetAllMsItem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsItem(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsItemListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsItemListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsItem(response: Response): Observable<ListResultDtoOfGetAllMsItemListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsItemListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsItemListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsItemListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsItemDropdown(): Observable<ListResultDtoOfGetAllMsItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/GetMsItemDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsItemDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsItemDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsItemListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsItemListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsItemDropdown(response: Response): Observable<ListResultDtoOfGetAllMsItemListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsItemListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsItemListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsItemListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsItem(input: CreateMsItemInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/CreateMsItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsItem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsItem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsItem(input: UpdateMsItemInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/UpdateMsItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsItem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsItem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsItem(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/DeleteMsItem?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsItem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsItem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @unitID (optional) 
     * @return Success
     */
    getMsUnitItemDropdown(unitID: number[]): Observable<ListResultDtoOfGetMsUnitItemDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsItem/GetMsUnitItemDropdown?";
        if (unitID !== undefined)
            unitID && unitID.forEach(item => { url_ += "unitID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsUnitItemDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsUnitItemDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsUnitItemDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsUnitItemDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsUnitItemDropdown(response: Response): Observable<ListResultDtoOfGetMsUnitItemDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsUnitItemDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsUnitItemDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsUnitItemDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsJobTitleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsJobTitleDropdown(): Observable<ListResultDtoOfGetAllMsJobTitleDropdownList> {
        let url_ = this.baseUrl + "/api/services/app/MsJobTitle/GetAllMsJobTitleDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsJobTitleDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsJobTitleDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsJobTitleDropdownList>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsJobTitleDropdownList>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsJobTitleDropdown(response: Response): Observable<ListResultDtoOfGetAllMsJobTitleDropdownList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsJobTitleDropdownList.fromJS(resultData200) : new ListResultDtoOfGetAllMsJobTitleDropdownList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsJobTitleDropdownList>(<any>null);
    }
}

@Injectable()
export class MsNationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMSNationDropdown(): Observable<ListResultDtoOfGetMSNationDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsNation/GetMSNationDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMSNationDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMSNationDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMSNationDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMSNationDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMSNationDropdown(response: Response): Observable<ListResultDtoOfGetMSNationDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMSNationDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetMSNationDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMSNationDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsNotarisNewServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingNotarisBankEmail(input: MS_MappingNotarisBankEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateMappingNotarisBankEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingNotarisBankEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingNotarisBankEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingNotarisBankEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingNotarisBankPhone(input: MS_MappingNotarisBankPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateMappingNotarisBankPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingNotarisBankPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingNotarisBankPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingNotarisBankPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingNotarisBank(input: MS_MappingNotarisBankDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateMappingNotarisBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingNotarisBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingNotarisBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingNotarisBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisStaffEmail(input: MS_NotarisStaffEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisStaffEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisStaffEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisStaffEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisStaffEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisStaffPhone(input: MS_NotarisStaffPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisStaffPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisStaffPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisStaffPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisStaffPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisStaff(input: MS_NotarisStaffDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisStaff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisStaff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisStaff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisEmail(input: MS_NotarisEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisPhone(input: MS_NotarisPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisCluster(input: MS_NotarisClusterDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNotarisNew(input: MasterNotarisInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/CreateNotarisNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNotarisNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNotarisNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNotarisNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteNotaris(notarisID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotaris?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotaris(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotaris(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notarisStaffEmail (optional) 
     * @return Success
     */
    deleteNotarisStaffEmail(notarisStaffID: number, notarisStaffEmail: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisStaffEmail?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        if (notarisStaffEmail !== undefined)
            url_ += "notarisStaffEmail=" + encodeURIComponent("" + notarisStaffEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisStaffEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisStaffEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisStaffEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notarisStaffPhone (optional) 
     * @return Success
     */
    deleteNotarisStaffPhone(notarisStaffID: number, notarisStaffPhone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisStaffPhone?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        if (notarisStaffPhone !== undefined)
            url_ += "notarisStaffPhone=" + encodeURIComponent("" + notarisStaffPhone) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisStaffPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisStaffPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisStaffPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notarisEmail (optional) 
     * @return Success
     */
    deleteNotarisEmail(notarisID: number, notarisEmail: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisEmail?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisEmail !== undefined)
            url_ += "notarisEmail=" + encodeURIComponent("" + notarisEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @notarisPhone (optional) 
     * @return Success
     */
    deleteNotarisPhone(notarisID: number, notarisPhone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisPhone?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisPhone !== undefined)
            url_ += "notarisPhone=" + encodeURIComponent("" + notarisPhone) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteNotarisCluster(notarisID: number, clusterID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisCluster?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteNotarisStaff(notarisID: number, notarisStaffID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteNotarisStaff?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteNotarisStaff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteNotarisStaff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteNotarisStaff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMappingNotarisBank(mappingNotarisBankId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteMappingNotarisBank?";
        if (mappingNotarisBankId === undefined || mappingNotarisBankId === null)
            throw new Error("The parameter 'mappingNotarisBankId' must be defined and cannot be null.");
        else
            url_ += "mappingNotarisBankId=" + encodeURIComponent("" + mappingNotarisBankId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMappingNotarisBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMappingNotarisBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMappingNotarisBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMappingNotarisBankPhone(mappingBankPhoneID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteMappingNotarisBankPhone?";
        if (mappingBankPhoneID === undefined || mappingBankPhoneID === null)
            throw new Error("The parameter 'mappingBankPhoneID' must be defined and cannot be null.");
        else
            url_ += "mappingBankPhoneID=" + encodeURIComponent("" + mappingBankPhoneID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMappingNotarisBankPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMappingNotarisBankPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMappingNotarisBankPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMappingNotarisBankEmail(mappingBankEmailID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/DeleteMappingNotarisBankEmail?";
        if (mappingBankEmailID === undefined || mappingBankEmailID === null)
            throw new Error("The parameter 'mappingBankEmailID' must be defined and cannot be null.");
        else
            url_ += "mappingBankEmailID=" + encodeURIComponent("" + mappingBankEmailID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMappingNotarisBankEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMappingNotarisBankEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMappingNotarisBankEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisDetail(notarisID: number): Observable<FetchNotarisDetail> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisDetail?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisDetail(response_);
                } catch (e) {
                    return <Observable<FetchNotarisDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<FetchNotarisDetail>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisDetail(response: Response): Observable<FetchNotarisDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FetchNotarisDetail.fromJS(resultData200) : new FetchNotarisDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FetchNotarisDetail>(<any>null);
    }

    /**
     * @return Success
     */
    getMappingNotarisBankEmails(mappingNotarisBankID: number): Observable<MappingNotarisBankEmail[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetMappingNotarisBankEmails?";
        if (mappingNotarisBankID === undefined || mappingNotarisBankID === null)
            throw new Error("The parameter 'mappingNotarisBankID' must be defined and cannot be null.");
        else
            url_ += "mappingNotarisBankID=" + encodeURIComponent("" + mappingNotarisBankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingNotarisBankEmails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingNotarisBankEmails(response_);
                } catch (e) {
                    return <Observable<MappingNotarisBankEmail[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MappingNotarisBankEmail[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingNotarisBankEmails(response: Response): Observable<MappingNotarisBankEmail[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MappingNotarisBankEmail.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MappingNotarisBankEmail[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMappingNotarisBankPhones(mappingNotarisBankID: number): Observable<MappingNotarisBankPhone[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetMappingNotarisBankPhones?";
        if (mappingNotarisBankID === undefined || mappingNotarisBankID === null)
            throw new Error("The parameter 'mappingNotarisBankID' must be defined and cannot be null.");
        else
            url_ += "mappingNotarisBankID=" + encodeURIComponent("" + mappingNotarisBankID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingNotarisBankPhones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingNotarisBankPhones(response_);
                } catch (e) {
                    return <Observable<MappingNotarisBankPhone[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MappingNotarisBankPhone[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingNotarisBankPhones(response: Response): Observable<MappingNotarisBankPhone[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MappingNotarisBankPhone.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MappingNotarisBankPhone[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMappingNotarisBankByNotarisID(notarisID: number): Observable<NotarisBank[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetMappingNotarisBankByNotarisID?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingNotarisBankByNotarisID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingNotarisBankByNotarisID(response_);
                } catch (e) {
                    return <Observable<NotarisBank[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisBank[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingNotarisBankByNotarisID(response: Response): Observable<NotarisBank[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisBank.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisBank[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisClusters(notarisID: number): Observable<NotarisCluster[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisClusters?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisClusters(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisClusters(response_);
                } catch (e) {
                    return <Observable<NotarisCluster[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisCluster[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisClusters(response: Response): Observable<NotarisCluster[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisCluster.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisCluster[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisEmails(notarisID: number): Observable<NotarisEmail[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisEmails?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisEmails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisEmails(response_);
                } catch (e) {
                    return <Observable<NotarisEmail[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisEmail[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisEmails(response: Response): Observable<NotarisEmail[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisEmail.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisEmail[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisPhones(notarisID: number): Observable<NotarisPhone[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisPhones?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisPhones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisPhones(response_);
                } catch (e) {
                    return <Observable<NotarisPhone[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisPhone[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisPhones(response: Response): Observable<NotarisPhone[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisPhone.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisPhone[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getFetchNotaris(filter: string, sorting: string, maxResultCount: number, skipCount: number, projectID: number, clusterID: number): Observable<PagedResultDtoOfFetchNotaris> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetFetchNotaris?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFetchNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFetchNotaris(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFetchNotaris>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfFetchNotaris>><any>Observable.throw(response_);
        });
    }

    protected processGetFetchNotaris(response: Response): Observable<PagedResultDtoOfFetchNotaris> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFetchNotaris.fromJS(resultData200) : new PagedResultDtoOfFetchNotaris();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfFetchNotaris>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisStaffEmailByNotarisStaffID(notarisStaffID: number): Observable<NotarisStaffEmail[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisStaffEmailByNotarisStaffID?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisStaffEmailByNotarisStaffID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisStaffEmailByNotarisStaffID(response_);
                } catch (e) {
                    return <Observable<NotarisStaffEmail[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisStaffEmail[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisStaffEmailByNotarisStaffID(response: Response): Observable<NotarisStaffEmail[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisStaffEmail.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisStaffEmail[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisStaffPhoneByNotarisStaffID(notarisStaffID: number): Observable<NotarisStaffPhone[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisStaffPhoneByNotarisStaffID?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisStaffPhoneByNotarisStaffID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisStaffPhoneByNotarisStaffID(response_);
                } catch (e) {
                    return <Observable<NotarisStaffPhone[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisStaffPhone[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisStaffPhoneByNotarisStaffID(response: Response): Observable<NotarisStaffPhone[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisStaffPhone.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisStaffPhone[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNotarisStaffByNotarisID(notarisID: number): Observable<NotarisStaff[]> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/GetNotarisStaffByNotarisID?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotarisStaffByNotarisID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotarisStaffByNotarisID(response_);
                } catch (e) {
                    return <Observable<NotarisStaff[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisStaff[]>><any>Observable.throw(response_);
        });
    }

    protected processGetNotarisStaffByNotarisID(response: Response): Observable<NotarisStaff[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisStaff.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisStaff[]>(<any>null);
    }

    /**
     * @return Success
     */
    isExistsNotarisCluster(notarisID: number, clusterID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisCluster?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisCluster(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisCluster(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @notarisPhone (optional) 
     * @return Success
     */
    isExistsNotarisPhone(notarisID: number, notarisPhone: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisPhone?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisPhone !== undefined)
            url_ += "notarisPhone=" + encodeURIComponent("" + notarisPhone) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisPhone(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisPhone(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @notarisEmail (optional) 
     * @return Success
     */
    isExistsNotarisEmail(notarisID: number, notarisEmail: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisEmail?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisEmail !== undefined)
            url_ += "notarisEmail=" + encodeURIComponent("" + notarisEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisEmail(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisEmail(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @notarisStaffName (optional) 
     * @return Success
     */
    isExistsNotarisStaff(notarisID: number, notarisStaffName: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisStaff?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        if (notarisStaffName !== undefined)
            url_ += "notarisStaffName=" + encodeURIComponent("" + notarisStaffName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisStaff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisStaff(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisStaff(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @notarisStaffPhone (optional) 
     * @return Success
     */
    isExistsNotarisStaffPhone(notarisStaffID: number, notarisStaffPhone: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisStaffPhone?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        if (notarisStaffPhone !== undefined)
            url_ += "notarisStaffPhone=" + encodeURIComponent("" + notarisStaffPhone) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisStaffPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisStaffPhone(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisStaffPhone(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @notarisStaffEmail (optional) 
     * @return Success
     */
    isExistsNotarisStaffEmail(notarisStaffID: number, notarisStaffEmail: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/IsExistsNotarisStaffEmail?";
        if (notarisStaffID === undefined || notarisStaffID === null)
            throw new Error("The parameter 'notarisStaffID' must be defined and cannot be null.");
        else
            url_ += "notarisStaffID=" + encodeURIComponent("" + notarisStaffID) + "&"; 
        if (notarisStaffEmail !== undefined)
            url_ += "notarisStaffEmail=" + encodeURIComponent("" + notarisStaffEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsExistsNotarisStaffEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsExistsNotarisStaffEmail(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsExistsNotarisStaffEmail(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotaris(input: CreateMsNotarisNewInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotaris";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotaris(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotaris(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisCluster(input: MS_NotarisClusterDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisPhone(input: MS_NotarisPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisEmail(input: MS_NotarisEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisStaff(input: MS_NotarisStaffDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisStaff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisStaff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisStaff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisStaffPhone(input: MS_NotarisStaffPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisStaffPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisStaffPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisStaffPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisStaffPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisStaffEmail(input: MS_NotarisStaffEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisStaffEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisStaffEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisStaffEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisStaffEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingNotarisBankEmail(input: MS_MappingNotarisBankEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateMappingNotarisBankEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingNotarisBankEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingNotarisBankEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingNotarisBankEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingNotarisBankPhone(input: MS_MappingNotarisBankPhoneDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateMappingNotarisBankPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingNotarisBankPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingNotarisBankPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingNotarisBankPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingNotarisBank(input: MS_MappingNotarisBankDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateMappingNotarisBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingNotarisBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingNotarisBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingNotarisBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotarisNew(input: MasterNotarisInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsNotarisNew/UpdateNotarisNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotarisNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotarisNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotarisNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsOccupationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMsOccupationDropdown(): Observable<ListResultDtoOfGetMsOccupationDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsOccupation/GetMsOccupationDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsOccupationDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsOccupationDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsOccupationDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsOccupationDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsOccupationDropdown(response: Response): Observable<ListResultDtoOfGetMsOccupationDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsOccupationDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetMsOccupationDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsOccupationDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsOfficerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsOfficer(input: CreateMsOfficerInput): Observable<GetCreateMsOfficerListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/CreateMsOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsOfficer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsOfficer(response_);
                } catch (e) {
                    return <Observable<GetCreateMsOfficerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCreateMsOfficerListDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsOfficer(response: Response): Observable<GetCreateMsOfficerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCreateMsOfficerListDto.fromJS(resultData200) : new GetCreateMsOfficerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCreateMsOfficerListDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsOfficer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/DeleteMsOfficer?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsOfficer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsOfficer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsOfficer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsOfficer(): Observable<ListResultDtoOfGetAllOfficerListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/GetAllMsOfficer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsOfficer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsOfficer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllOfficerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllOfficerListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsOfficer(response: Response): Observable<ListResultDtoOfGetAllOfficerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllOfficerListDto.fromJS(resultData200) : new ListResultDtoOfGetAllOfficerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllOfficerListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsOfficer(input: CreateMsOfficerInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/UpdateMsOfficer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsOfficer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsOfficer(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsOfficer(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getMsOfficerPerDepartmentDropdown(): Observable<GetOfficerDivDto> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/GetMsOfficerPerDepartmentDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsOfficerPerDepartmentDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsOfficerPerDepartmentDropdown(response_);
                } catch (e) {
                    return <Observable<GetOfficerDivDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOfficerDivDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsOfficerPerDepartmentDropdown(response: Response): Observable<GetOfficerDivDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetOfficerDivDto.fromJS(resultData200) : new GetOfficerDivDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOfficerDivDto>(<any>null);
    }

    /**
     * @return Success
     */
    getOfficerPhoneByOfficerId(staffID: number, departmentID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/GetOfficerPhoneByOfficerId?";
        if (staffID === undefined || staffID === null)
            throw new Error("The parameter 'staffID' must be defined and cannot be null.");
        else
            url_ += "staffID=" + encodeURIComponent("" + staffID) + "&"; 
        if (departmentID === undefined || departmentID === null)
            throw new Error("The parameter 'departmentID' must be defined and cannot be null.");
        else
            url_ += "departmentID=" + encodeURIComponent("" + departmentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOfficerPhoneByOfficerId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOfficerPhoneByOfficerId(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetOfficerPhoneByOfficerId(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @name (optional) 
     * @position (optional) 
     * @return Success
     */
    getOfficerByNameOrPosition(name: string, position: string): Observable<GetOfficerByNameOrPositionListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsOfficer/GetOfficerByNameOrPosition?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOfficerByNameOrPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOfficerByNameOrPosition(response_);
                } catch (e) {
                    return <Observable<GetOfficerByNameOrPositionListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOfficerByNameOrPositionListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetOfficerByNameOrPosition(response: Response): Observable<GetOfficerByNameOrPositionListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetOfficerByNameOrPositionListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOfficerByNameOrPositionListDto[]>(<any>null);
    }
}

@Injectable()
export class MsPositionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsPosition(input: MsPositionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsPosition/CreateMsPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsPosition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsPosition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsPosition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsPosition/DeleteMsPosition?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsPosition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsPosition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsPosition(): Observable<ListResultDtoOfGetAllMsPositionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsPosition/GetAllMsPosition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsPosition(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsPositionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsPositionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsPosition(response: Response): Observable<ListResultDtoOfGetAllMsPositionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsPositionListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsPositionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsPositionListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsPositionByDepartment(departmentID: number): Observable<ListResultDtoOfGetMsPositionByDepartmentListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsPosition/GetMsPositionByDepartment?";
        if (departmentID === undefined || departmentID === null)
            throw new Error("The parameter 'departmentID' must be defined and cannot be null.");
        else
            url_ += "departmentID=" + encodeURIComponent("" + departmentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsPositionByDepartment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsPositionByDepartment(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsPositionByDepartmentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsPositionByDepartmentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsPositionByDepartment(response: Response): Observable<ListResultDtoOfGetMsPositionByDepartmentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsPositionByDepartmentListDto.fromJS(resultData200) : new ListResultDtoOfGetMsPositionByDepartmentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsPositionByDepartmentListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsPosition(input: MsPositionInput): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsPosition/UpdateMsPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsPosition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsPosition(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsPosition(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class MsProductServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsProduct(): Observable<ListResultDtoOfGetAllProductListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/GetAllMsProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsProduct(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllProductListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllProductListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsProduct(response: Response): Observable<ListResultDtoOfGetAllProductListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllProductListDto.fromJS(resultData200) : new ListResultDtoOfGetAllProductListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllProductListDto>(<any>null);
    }

    /**
     * @productCode (optional) 
     * @return Success
     */
    getProductListByProductCode(productCode: string): Observable<GetProductListByProductCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/GetProductListByProductCode?";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductListByProductCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductListByProductCode(response_);
                } catch (e) {
                    return <Observable<GetProductListByProductCodeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProductListByProductCodeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductListByProductCode(response: Response): Observable<GetProductListByProductCodeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProductListByProductCodeDto.fromJS(resultData200) : new GetProductListByProductCodeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProductListByProductCodeDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsProduct(input: CreateMsProductDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/CreateMsProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsProduct(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsProduct(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsProduct(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/DeleteMsProduct?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsProduct(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsProduct(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsProduct(input: UpdateMsProductDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/UpdateMsProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsProduct(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsProduct(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProductDropdown(): Observable<ListResultDtoOfGetProductDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/GetMsProductDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProductDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProductDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProductDropdown(response: Response): Observable<ListResultDtoOfGetProductDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProductDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProductDropdownByProjectClusterCategory(projectID: number, clusterID: number, categoryID: number): Observable<ListResultDtoOfGetProductDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/GetMsProductDropdownByProjectClusterCategory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProductDropdownByProjectClusterCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProductDropdownByProjectClusterCategory(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProductDropdownByProjectClusterCategory(response: Response): Observable<ListResultDtoOfGetProductDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProductDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductDropdownListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getMsProductDropdownGeneratePrice(input: GetMsProductDropdownGeneratePriceInputDto): Observable<ListResultDtoOfGetProductDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProduct/GetMsProductDropdownGeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProductDropdownGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProductDropdownGeneratePrice(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProductDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProductDropdownGeneratePrice(response: Response): Observable<ListResultDtoOfGetProductDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProductDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProductDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProductDropdownListDto>(<any>null);
    }
}

@Injectable()
export class MsProjectServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListBusinessGroup(): Observable<GetListBusinessGroupResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetListBusinessGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListBusinessGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListBusinessGroup(response_);
                } catch (e) {
                    return <Observable<GetListBusinessGroupResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListBusinessGroupResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListBusinessGroup(response: Response): Observable<GetListBusinessGroupResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListBusinessGroupResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListBusinessGroupResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListOracleMsProject(): Observable<GetListOracleMsProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetListOracleMsProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOracleMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOracleMsProject(response_);
                } catch (e) {
                    return <Observable<GetListOracleMsProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOracleMsProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListOracleMsProject(response: Response): Observable<GetListOracleMsProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListOracleMsProjectResultDto.fromJS(resultData200) : new GetListOracleMsProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOracleMsProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsProject(): Observable<ListResultDtoOfGetAllProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetAllMsProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllProjectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllProjectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsProject(response: Response): Observable<ListResultDtoOfGetAllProjectListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllProjectListDto.fromJS(resultData200) : new ListResultDtoOfGetAllProjectListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllProjectListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsProjectMapping(): Observable<ListResultDtoOfGetAllProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetAllMsProjectMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsProjectMapping(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsProjectMapping(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllProjectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllProjectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsProjectMapping(response: Response): Observable<ListResultDtoOfGetAllProjectListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllProjectListDto.fromJS(resultData200) : new ListResultDtoOfGetAllProjectListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllProjectListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsProject(input: CreateMsProjectInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/CreateMsProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsProject(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsProject(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsProject(input: CreateMsProjectInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/UpdateMsProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsProject(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsProject(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailMsProject(id: number): Observable<GetDetailMsProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetDetailMsProject?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMsProject(response_);
                } catch (e) {
                    return <Observable<GetDetailMsProjectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMsProjectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMsProject(response: Response): Observable<GetDetailMsProjectListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMsProjectListDto.fromJS(resultData200) : new GetDetailMsProjectListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMsProjectListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    modifyDMT(input: GetUpdateDmtValueInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/ModifyDMT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processModifyDMT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processModifyDMT(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processModifyDMT(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMappingDMT(): Observable<GetMappingDMTListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetMappingDMT";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingDMT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingDMT(response_);
                } catch (e) {
                    return <Observable<GetMappingDMTListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMappingDMTListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingDMT(response: Response): Observable<GetMappingDMTListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMappingDMTListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMappingDMTListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsProject(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/DeleteMsProject?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsProject(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsProject(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getProjectCheckRole(userID: number, accountID: number): Observable<GetProjectByAccountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetProjectCheckRole?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectCheckRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectCheckRole(response_);
                } catch (e) {
                    return <Observable<GetProjectByAccountListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectByAccountListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectCheckRole(response: Response): Observable<GetProjectByAccountListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProjectByAccountListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectByAccountListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListProject(): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetListProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProject(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProductByProject(projectID: number): Observable<GetListProductByProjectResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetProductByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductByProject(response_);
                } catch (e) {
                    return <Observable<GetListProductByProjectResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductByProjectResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProductByProject(response: Response): Observable<GetListProductByProjectResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductByProjectResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductByProjectResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProductSvgByProject(projectID: number): Observable<GetListProductByProjectResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetProductSvgByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductSvgByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductSvgByProject(response_);
                } catch (e) {
                    return <Observable<GetListProductByProjectResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductByProjectResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProductSvgByProject(response: Response): Observable<GetListProductByProjectResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductByProjectResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductByProjectResultDto[]>(<any>null);
    }

    /**
     * @name (optional) 
     * @return Success
     */
    getListRolesProject(name: string): Observable<GetListRolesProjectResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetListRolesProject?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRolesProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRolesProject(response_);
                } catch (e) {
                    return <Observable<GetListRolesProjectResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRolesProjectResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRolesProject(response: Response): Observable<GetListRolesProjectResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRolesProjectResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRolesProjectResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailRolesProject(rolesID: number): Observable<GetListRolesProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/GetDetailRolesProject?";
        if (rolesID === undefined || rolesID === null)
            throw new Error("The parameter 'rolesID' must be defined and cannot be null.");
        else
            url_ += "rolesID=" + encodeURIComponent("" + rolesID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailRolesProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailRolesProject(response_);
                } catch (e) {
                    return <Observable<GetListRolesProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRolesProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailRolesProject(response: Response): Observable<GetListRolesProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListRolesProjectResultDto.fromJS(resultData200) : new GetListRolesProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRolesProjectResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteRolesProject(input: CreateDeleteRolesProjectInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsProject/CreateDeleteRolesProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteRolesProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteRolesProject(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteRolesProject(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsProvinceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMsProvinceDropdown(): Observable<GetMsProvinceListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsProvince/GetMsProvinceDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProvinceDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProvinceDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsProvinceListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsProvinceListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProvinceDropdown(response: Response): Observable<GetMsProvinceListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsProvinceListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsProvinceListDto[]>(<any>null);
    }
}

@Injectable()
export class MsRenovationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @inputs (optional) 
     * @return Success
     */
    createMsRenovation(inputs: CreateMsRenovationInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/CreateMsRenovation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsRenovation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsRenovation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    deleteFileTempRenovation(filename: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/DeleteFileTempRenovation?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileTempRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileTempRenovation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileTempRenovation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsRenovation(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/DeleteMsRenovation?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsRenovation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsRenovation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @renovID (optional) 
     * @return Success
     */
    getAvailableItemDropdownByProject(projectID: number, renovID: number): Observable<ListResultDtoOfGetLkItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/GetAvailableItemDropdownByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (renovID !== undefined)
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAvailableItemDropdownByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAvailableItemDropdownByProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetLkItemListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetLkItemListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAvailableItemDropdownByProject(response: Response): Observable<ListResultDtoOfGetLkItemListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetLkItemListDto.fromJS(resultData200) : new ListResultDtoOfGetLkItemListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetLkItemListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getItemDropdown(projectID: number): Observable<ListResultDtoOfGetLkItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/GetItemDropdown?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetItemDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetItemDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetLkItemListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetLkItemListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetItemDropdown(response: Response): Observable<ListResultDtoOfGetLkItemListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetLkItemListDto.fromJS(resultData200) : new ListResultDtoOfGetLkItemListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetLkItemListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsRenovationByProject(projectID: number): Observable<ListResultDtoOfGetAllMsRenovationListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/GetAllMsRenovationByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsRenovationByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsRenovationByProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsRenovationListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsRenovationListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsRenovationByProject(response: Response): Observable<ListResultDtoOfGetAllMsRenovationListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsRenovationListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsRenovationListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsRenovationListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsRenovation(input: UpdateMsRenovationInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsRenovation/UpdateMsRenovation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsRenovation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsRenovation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsStatusMemberServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @scmCode (optional) 
     * @return Success
     */
    getAllMsStatusMemberDropdown(scmCode: string): Observable<ListResultDtoOfGetAllMsStatusMemberDropdownList> {
        let url_ = this.baseUrl + "/api/services/app/MsStatusMember/GetAllMsStatusMemberDropdown?";
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsStatusMemberDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsStatusMemberDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsStatusMemberDropdownList>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsStatusMemberDropdownList>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsStatusMemberDropdown(response: Response): Observable<ListResultDtoOfGetAllMsStatusMemberDropdownList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsStatusMemberDropdownList.fromJS(resultData200) : new ListResultDtoOfGetAllMsStatusMemberDropdownList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsStatusMemberDropdownList>(<any>null);
    }
}

@Injectable()
export class MsSurroundingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getDataMasterSurrounding(filter: string, projectID: number, clusterID: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfMasterSurroundingDto> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/GetDataMasterSurrounding?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "ClusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMasterSurrounding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMasterSurrounding(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMasterSurroundingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfMasterSurroundingDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMasterSurrounding(response: Response): Observable<PagedResultDtoOfMasterSurroundingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfMasterSurroundingDto.fromJS(resultData200) : new PagedResultDtoOfMasterSurroundingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfMasterSurroundingDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUpdateMasterSurrounding(input: CreateUpdateDeleteMasterSurroundingDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/InsertUpdateMasterSurrounding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUpdateMasterSurrounding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUpdateMasterSurrounding(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertUpdateMasterSurrounding(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMasterSurrounding(input: number): Observable<MsSurroundingResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/DeleteMasterSurrounding?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMasterSurrounding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMasterSurrounding(response_);
                } catch (e) {
                    return <Observable<MsSurroundingResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<MsSurroundingResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMasterSurrounding(response: Response): Observable<MsSurroundingResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MsSurroundingResultMessageDto.fromJS(resultData200) : new MsSurroundingResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MsSurroundingResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    setFileName(projectID: number, clusterID: number): Observable<FileNameSurroundingDto> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/SetFileName?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetFileName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetFileName(response_);
                } catch (e) {
                    return <Observable<FileNameSurroundingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileNameSurroundingDto>><any>Observable.throw(response_);
        });
    }

    protected processSetFileName(response: Response): Observable<FileNameSurroundingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileNameSurroundingDto.fromJS(resultData200) : new FileNameSurroundingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileNameSurroundingDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getMasterSurrounding(cluster: number, unitCode: string, unitNo: string): Observable<MasterSurroundingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/GetMasterSurrounding?";
        if (cluster === undefined || cluster === null)
            throw new Error("The parameter 'cluster' must be defined and cannot be null.");
        else
            url_ += "cluster=" + encodeURIComponent("" + cluster) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMasterSurrounding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMasterSurrounding(response_);
                } catch (e) {
                    return <Observable<MasterSurroundingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MasterSurroundingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMasterSurrounding(response: Response): Observable<MasterSurroundingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MasterSurroundingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MasterSurroundingDto[]>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getMasterSurroundingForViewUnitInfo(cluster: number, unitCode: string, unitNo: string): Observable<MasterSurroundingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/GetMasterSurroundingForViewUnitInfo?";
        if (cluster === undefined || cluster === null)
            throw new Error("The parameter 'cluster' must be defined and cannot be null.");
        else
            url_ += "cluster=" + encodeURIComponent("" + cluster) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMasterSurroundingForViewUnitInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMasterSurroundingForViewUnitInfo(response_);
                } catch (e) {
                    return <Observable<MasterSurroundingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<MasterSurroundingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMasterSurroundingForViewUnitInfo(response: Response): Observable<MasterSurroundingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(MasterSurroundingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MasterSurroundingDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cekFileName(projectID: number, clusterID: number, input: string): Observable<ValidatedResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsSurroundings/cekFileName?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCekFileName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCekFileName(response_);
                } catch (e) {
                    return <Observable<ValidatedResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidatedResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCekFileName(response: Response): Observable<ValidatedResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidatedResultMessageDto.fromJS(resultData200) : new ValidatedResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValidatedResultMessageDto>(<any>null);
    }
}

@Injectable()
export class MsTermServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTermCodeDropdown(): Observable<ListResultDtoOfGetAllMsTermListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermCodeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermCodeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermCodeDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermCodeDropdown(response: Response): Observable<ListResultDtoOfGetAllMsTermListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsTermListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsTermListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsTermListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTermCodeDropdownTaskList(): Observable<ListResultDtoOfGetAllMsTermListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermCodeDropdownTaskList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermCodeDropdownTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermCodeDropdownTaskList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermCodeDropdownTaskList(response: Response): Observable<ListResultDtoOfGetAllMsTermListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsTermListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsTermListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsTermListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTermGeneratePriceDropdown(projectId: number, clusterId: number): Observable<ListResultDtoOfGetAllMsTermListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermGeneratePriceDropdown?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermGeneratePriceDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermGeneratePriceDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermGeneratePriceDropdown(response: Response): Observable<ListResultDtoOfGetAllMsTermListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsTermListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsTermListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsTermListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsTermByTermMainID(id: number): Observable<ListResultDtoOfGetAllMsTermListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetMsTermByTermMainID?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsTermByTermMainID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsTermByTermMainID(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsTermListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsTermByTermMainID(response: Response): Observable<ListResultDtoOfGetAllMsTermListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsTermListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsTermListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsTermListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsTermStatus(input: UpdateMsTermStatusInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateMsTermStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsTermStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsTermStatus(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsTermStatus(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalMsTerm(input: CreateUniversalMsTermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateUniversalMsTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalMsTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalMsTerm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalMsTerm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTermMain(input: CreateMsTermMainInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateMsTermMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTermMain(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTermMain(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTermMain(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTerm(input: CreateMsTermInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateMsTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTerm(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTerm(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTermPmt(input: CreateMsTermPmtInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateMsTermPmt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTermPmt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTermPmt(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTermPmt(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTermDP(input: CreateMsTermDPInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateMsTermDP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTermDP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTermDP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTermDP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTermAddDisc(input: CreateMsTermAddDiscInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateMsTermAddDisc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTermAddDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTermAddDisc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTermAddDisc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @return Success
     */
    getExistingTermByTermCode(termCode: string): Observable<GetExistingTermDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetExistingTermByTermCode?";
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExistingTermByTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExistingTermByTermCode(response_);
                } catch (e) {
                    return <Observable<GetExistingTermDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetExistingTermDto>><any>Observable.throw(response_);
        });
    }

    protected processGetExistingTermByTermCode(response: Response): Observable<GetExistingTermDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetExistingTermDto.fromJS(resultData200) : new GetExistingTermDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetExistingTermDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDiscountDropdown(): Observable<GetMsDiscountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetDiscountDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsDiscountDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsDiscountDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountDropdown(response: Response): Observable<GetMsDiscountDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsDiscountDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsDiscountDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFinTypeDropdown(): Observable<GetMsFinTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetFinTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFinTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFinTypeDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsFinTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsFinTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFinTypeDropdown(response: Response): Observable<GetMsFinTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsFinTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsFinTypeDto[]>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @return Success
     */
    checkAvailableTermCode(termCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CheckAvailableTermCode?";
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckAvailableTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckAvailableTermCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCheckAvailableTermCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDiscountDropdownExcludeSalesDisc(): Observable<GetMsDiscountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetDiscountDropdownExcludeSalesDisc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountDropdownExcludeSalesDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountDropdownExcludeSalesDisc(response_);
                } catch (e) {
                    return <Observable<GetMsDiscountDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsDiscountDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountDropdownExcludeSalesDisc(response: Response): Observable<GetMsDiscountDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsDiscountDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsDiscountDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDpCalc(): Observable<GetDpCalcListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetDpCalc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDpCalc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDpCalc(response_);
                } catch (e) {
                    return <Observable<GetDpCalcListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDpCalcListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDpCalc(response: Response): Observable<GetDpCalcListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDpCalcListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDpCalcListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsTermMain(input: UpdateMsTermMainInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateMsTermMain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsTermMain(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsTermMain(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsTermMain(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @return Success
     */
    getProjectCodeByTermCode(termCode: string): Observable<GetProjectIDByTermIDResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetProjectCodeByTermCode?";
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectCodeByTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectCodeByTermCode(response_);
                } catch (e) {
                    return <Observable<GetProjectIDByTermIDResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectIDByTermIDResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectCodeByTermCode(response: Response): Observable<GetProjectIDByTermIDResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProjectIDByTermIDResultDto.fromJS(resultData200) : new GetProjectIDByTermIDResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectIDByTermIDResultDto>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getTermCodeByProjectCode(projectCode: string): Observable<GetProjectIDByTermIDResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermCodeByProjectCode?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermCodeByProjectCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermCodeByProjectCode(response_);
                } catch (e) {
                    return <Observable<GetProjectIDByTermIDResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectIDByTermIDResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTermCodeByProjectCode(response: Response): Observable<GetProjectIDByTermIDResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProjectIDByTermIDResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectIDByTermIDResultDto[]>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @termCode (optional) 
     * @return Success
     */
    getTermByProjectCode(projectCode: string, termCode: string): Observable<GetTermByProjectCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermByProjectCode?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermByProjectCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermByProjectCode(response_);
                } catch (e) {
                    return <Observable<GetTermByProjectCodeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTermByProjectCodeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermByProjectCode(response: Response): Observable<GetTermByProjectCodeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTermByProjectCodeDto.fromJS(resultData200) : new GetTermByProjectCodeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTermByProjectCodeDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsTerm(termID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/DeleteMsTerm?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsTerm(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsTerm(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsTerm(input: UpdateMsTermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateMsTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsTerm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsTerm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsTermPmt(input: UpdateMsTermPmtInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateMsTermPmt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsTermPmt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsTermPmt(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsTermPmt(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMsTermDP(input: UpdateMsTermDPInput): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateOrUpdateMsTermDP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMsTermDP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMsTermDP(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMsTermDP(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsTermAddDisc(input: UpdateMsTermAddDiscInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateMsTermAddDisc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsTermAddDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsTermAddDisc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsTermAddDisc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUniversalMsTerm(input: UpdateUniversalMsTermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/UpdateUniversalMsTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUniversalMsTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUniversalMsTerm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUniversalMsTerm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTermAddDiscByTermID(termID: number): Observable<GetTermAddDiscByTermID[]> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/GetTermAddDiscByTermID?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermAddDiscByTermID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermAddDiscByTermID(response_);
                } catch (e) {
                    return <Observable<GetTermAddDiscByTermID[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTermAddDiscByTermID[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTermAddDiscByTermID(response: Response): Observable<GetTermAddDiscByTermID[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTermAddDiscByTermID.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTermAddDiscByTermID[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteMsTermAddDisc(termID: number, input: CreateMsTermAddDiscInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerm/CreateDeleteMsTermAddDisc?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteMsTermAddDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteMsTermAddDisc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteMsTermAddDisc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsTerritoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllDropdownMsTerritory(): Observable<ListResultDtoOfGetMsTerritoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsTerritory/GetAllDropdownMsTerritory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllDropdownMsTerritory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllDropdownMsTerritory(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetMsTerritoryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetMsTerritoryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllDropdownMsTerritory(response: Response): Observable<ListResultDtoOfGetMsTerritoryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetMsTerritoryListDto.fromJS(resultData200) : new ListResultDtoOfGetMsTerritoryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetMsTerritoryListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsTerritory(input: GetCreateMsTerritoryInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsTerritory/CreateMsTerritory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsTerritory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsTerritory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsTerritory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalExcel(input: CreateUniversalExcelInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/CreateUniversalExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalExcel(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalExcel(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @unitNo (optional) 
     * @return Success
     */
    getUnitFloorAvailableManageStatus(clusterID: number, unitNo: string): Observable<SitePlanUnitFloorAvailableManageStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitFloorAvailableManageStatus?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitFloorAvailableManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitFloorAvailableManageStatus(response_);
                } catch (e) {
                    return <Observable<SitePlanUnitFloorAvailableManageStatusDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SitePlanUnitFloorAvailableManageStatusDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitFloorAvailableManageStatus(response: Response): Observable<SitePlanUnitFloorAvailableManageStatusDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SitePlanUnitFloorAvailableManageStatusDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SitePlanUnitFloorAvailableManageStatusDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListHistoryChageUnitStatus(unitID: number): Observable<ListResultDtoOfGetListHistoryUnitStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetListHistoryChageUnitStatus?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListHistoryChageUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListHistoryChageUnitStatus(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListHistoryUnitStatusDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListHistoryUnitStatusDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListHistoryChageUnitStatus(response: Response): Observable<ListResultDtoOfGetListHistoryUnitStatusDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListHistoryUnitStatusDto.fromJS(resultData200) : new ListResultDtoOfGetListHistoryUnitStatusDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListHistoryUnitStatusDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    manageStatusMsUnit(input: ManageStatusMsUnitInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/ManageStatusMsUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processManageStatusMsUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processManageStatusMsUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processManageStatusMsUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitTaskList(projectID: number, clusterID: number): Observable<GetUnitTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitTaskList?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTaskList(response_);
                } catch (e) {
                    return <Observable<GetUnitTaskListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitTaskListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTaskList(response: Response): Observable<GetUnitTaskListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitTaskListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitTaskListDto[]>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getAreaMsUnitItemByUnitCodeUnitNoProjectCluster(unitCode: string, unitNo: string, projectID: number, clusterID: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetAreaMsUnitItemByUnitCodeUnitNoProjectCluster?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAreaMsUnitItemByUnitCodeUnitNoProjectCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAreaMsUnitItemByUnitCodeUnitNoProjectCluster(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetAreaMsUnitItemByUnitCodeUnitNoProjectCluster(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProjectDropdown(): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsProjectDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProjectDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProjectDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProjectDropdown(response: Response): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProjectDropdownMapping(): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsProjectDropdownMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProjectDropdownMapping(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProjectDropdownMapping(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProjectDropdownMapping(response: Response): Observable<ListResultDtoOfGetProjectDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsProjectWithCategory(): Observable<ListResultDtoOfGetProjectDropdownWithCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsProjectWithCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsProjectWithCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsProjectWithCategory(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectDropdownWithCategoryDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectDropdownWithCategoryDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsProjectWithCategory(response: Response): Observable<ListResultDtoOfGetProjectDropdownWithCategoryDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectDropdownWithCategoryDto.fromJS(resultData200) : new ListResultDtoOfGetProjectDropdownWithCategoryDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectDropdownWithCategoryDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsFacingDropdown(): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsFacingDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsFacingDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsFacingDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsFacingDropdown(response: Response): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetFacingDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetFacingDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetFacingDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsFacingDropdownApp(): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsFacingDropdownApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsFacingDropdownApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsFacingDropdownApp(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsFacingDropdownApp(response: Response): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetFacingDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetFacingDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetFacingDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsZoningDropdown(): Observable<ListResultDtoOfGetZoningDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetMsZoningDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsZoningDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsZoningDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetZoningDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetZoningDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsZoningDropdown(response: Response): Observable<ListResultDtoOfGetZoningDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetZoningDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetZoningDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetZoningDropdownListDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @return Success
     */
    createMsUnitCodeForExcel(unitCode: string): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/CreateMsUnitCodeForExcel?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsUnitCodeForExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsUnitCodeForExcel(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsUnitCodeForExcel(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @inputs (optional) 
     * @return Success
     */
    getUnavailableUnitNo(inputs: any[]): Observable<ListResultDtoOfGetUnavailableUnitNoListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnavailableUnitNo?";
        if (inputs !== undefined)
            inputs && inputs.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "inputs[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnavailableUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnavailableUnitNo(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnavailableUnitNoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnavailableUnitNoListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnavailableUnitNo(response: Response): Observable<ListResultDtoOfGetUnavailableUnitNoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnavailableUnitNoListDto.fromJS(resultData200) : new ListResultDtoOfGetUnavailableUnitNoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnavailableUnitNoListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByFloor(unitCodeID: number): Observable<ListResultDtoOfGetUnitByFloorListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitByFloor?";
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByFloor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByFloor(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitByFloorListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitByFloorListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByFloor(response: Response): Observable<ListResultDtoOfGetUnitByFloorListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitByFloorListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitByFloorListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitByFloorListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getProductCodeByUnitCodeUnitNo(input: GetProductCodeByUnitCodeUnitNoDto[]): Observable<ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetProductCodeByUnitCodeUnitNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProductCodeByUnitCodeUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProductCodeByUnitCodeUnitNo(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProductCodeByUnitCodeUnitNo(response: Response): Observable<ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto.fromJS(resultData200) : new ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByProjectClusterCategory(projectID: number, clusterID: number, categoryID: number, userID: number): Observable<ListResultDtoOfGetUnitByProjectClusterCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitByProjectClusterCategory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByProjectClusterCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByProjectClusterCategory(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitByProjectClusterCategoryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitByProjectClusterCategoryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByProjectClusterCategory(response: Response): Observable<ListResultDtoOfGetUnitByProjectClusterCategoryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitByProjectClusterCategoryListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitByProjectClusterCategoryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitByProjectClusterCategoryListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitCodeByProject(projectId: number): Observable<ListResultDtoOfGetUnitCodeByProjectListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitCodeByProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitCodeByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitCodeByProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitCodeByProjectListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitCodeByProjectListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitCodeByProject(response: Response): Observable<ListResultDtoOfGetUnitCodeByProjectListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitCodeByProjectListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitCodeByProjectListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitCodeByProjectListDto>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @return Success
     */
    getUnitNoByUnitCode(unitCode: string): Observable<ListResultDtoOfGetUnitNoByUnitCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitNoByUnitCode?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitNoByUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitNoByUnitCode(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitNoByUnitCodeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitNoByUnitCodeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitNoByUnitCode(response: Response): Observable<ListResultDtoOfGetUnitNoByUnitCodeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitNoByUnitCodeListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitNoByUnitCodeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitNoByUnitCodeListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFloorByCluster(clusterID: number): Observable<ListResultDtoOfGetFloorByClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetFloorByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFloorByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFloorByCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetFloorByClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetFloorByClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFloorByCluster(response: Response): Observable<ListResultDtoOfGetFloorByClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetFloorByClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetFloorByClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetFloorByClusterListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitTypeByClusterID(clusterID: number): Observable<GetUnitTypeByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitTypeByClusterID?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByClusterID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByClusterID(response_);
                } catch (e) {
                    return <Observable<GetUnitTypeByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitTypeByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByClusterID(response: Response): Observable<GetUnitTypeByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitTypeByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitTypeByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitTypeByCluster(clusterID: number): Observable<ListResultDtoOfGetUnitTypeByClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitTypeByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitTypeByClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitTypeByClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByCluster(response: Response): Observable<ListResultDtoOfGetUnitTypeByClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitTypeByClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitTypeByClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitTypeByClusterListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByCluster(clusterID: number): Observable<ListResultDtoOfGetUnitByClusterListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitByClusterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitByClusterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByCluster(response: Response): Observable<ListResultDtoOfGetUnitByClusterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitByClusterListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitByClusterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitByClusterListDto>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @return Success
     */
    getUnitByProjectClusterTermCodeTermNo(projectID: number, clusterID: number, termCode: string, termNo: number): Observable<ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitByProjectClusterTermCodeTermNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        if (termNo === undefined || termNo === null)
            throw new Error("The parameter 'termNo' must be defined and cannot be null.");
        else
            url_ += "termNo=" + encodeURIComponent("" + termNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByProjectClusterTermCodeTermNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByProjectClusterTermCodeTermNo(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByProjectClusterTermCodeTermNo(response: Response): Observable<ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto.fromJS(resultData200) : new ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto>(<any>null);
    }

    /**
     * @clusterID (optional) 
     * @return Success
     */
    getUnitByClusterProjectDropdown(clusterID: number[]): Observable<ListResultDtoOfGetUnitDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetUnitByClusterProjectDropdown?";
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByClusterProjectDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByClusterProjectDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByClusterProjectDropdown(response: Response): Observable<ListResultDtoOfGetUnitDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitDropdownListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDisplayedFieldManageStatus(): Observable<GetCheckBoxDisplayedFieldResultManageUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetDisplayedFieldManageStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDisplayedFieldManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDisplayedFieldManageStatus(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultManageUnitDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultManageUnitDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDisplayedFieldManageStatus(response: Response): Observable<GetCheckBoxDisplayedFieldResultManageUnitDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultManageUnitDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultManageUnitDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printHistoryManageStatus(input: InputManageStatusListDto): Observable<GetListManageStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/PrintHistoryManageStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintHistoryManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintHistoryManageStatus(response_);
                } catch (e) {
                    return <Observable<GetListManageStatusDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListManageStatusDto[]>><any>Observable.throw(response_);
        });
    }

    protected processPrintHistoryManageStatus(response: Response): Observable<GetListManageStatusDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListManageStatusDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListManageStatusDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getClusterDropdownManageStatus(projectID: number[]): Observable<ListResultDtoOfGetDropdownClusterManageStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetClusterDropdownManageStatus?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterDropdownManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterDropdownManageStatus(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDropdownClusterManageStatusDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDropdownClusterManageStatusDto>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterDropdownManageStatus(response: Response): Observable<ListResultDtoOfGetDropdownClusterManageStatusDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDropdownClusterManageStatusDto.fromJS(resultData200) : new ListResultDtoOfGetDropdownClusterManageStatusDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDropdownClusterManageStatusDto>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getDropdownCategoryManageStatus(projectID: number[], clusterID: number[]): Observable<ListResultDtoOfGetDropdownCategoryManageStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GetDropdownCategoryManageStatus?";
        if (projectID !== undefined)
            projectID && projectID.forEach(item => { url_ += "projectID=" + encodeURIComponent("" + item) + "&"; });
        if (clusterID !== undefined)
            clusterID && clusterID.forEach(item => { url_ += "clusterID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCategoryManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCategoryManageStatus(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDropdownCategoryManageStatusDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDropdownCategoryManageStatusDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCategoryManageStatus(response: Response): Observable<ListResultDtoOfGetDropdownCategoryManageStatusDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDropdownCategoryManageStatusDto.fromJS(resultData200) : new ListResultDtoOfGetDropdownCategoryManageStatusDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDropdownCategoryManageStatusDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelManageUnit(input: PrintManageStatusInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnit/GenerateExcelManageUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelManageUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelManageUnit(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelManageUnit(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class MsUnitCodeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsUnitCode(input: CreateOrUpdateMsUnitCodeInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitCode/CreateMsUnitCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsUnitCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsUnitCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsUnitCode(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitCode/DeleteMsUnitCode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsUnitCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsUnitCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMsUnitCodeByProject(projectID: number): Observable<ListResultDtoOfGetAllMsUnitCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitCode/GetMsUnitCodeByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsUnitCodeByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsUnitCodeByProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsUnitCodeListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsUnitCodeListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsUnitCodeByProject(response: Response): Observable<ListResultDtoOfGetAllMsUnitCodeListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsUnitCodeListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsUnitCodeListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsUnitCodeListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsUnitCode(input: CreateOrUpdateMsUnitCodeInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitCode/UpdateMsUnitCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsUnitCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsUnitCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class MsUnitItemServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataMsUnitItem(input: GetUnitItemInputDto): Observable<ListResultDtoOfGetUnitItemListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitItem/GetDataMsUnitItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMsUnitItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMsUnitItem(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitItemListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitItemListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMsUnitItem(response: Response): Observable<ListResultDtoOfGetUnitItemListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitItemListDto.fromJS(resultData200) : new ListResultDtoOfGetUnitItemListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitItemListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCompanyMsUnitItem(input: UpdateCompanyMsUnitItemInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitItem/UpdateCompanyMsUnitItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCompanyMsUnitItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCompanyMsUnitItem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCompanyMsUnitItem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsUnitStatusServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsUnitStatus(): Observable<ListResultDtoOfGetAllMsUnitStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetAllMsUnitStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsUnitStatus(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsUnitStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsUnitStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsUnitStatus(response: Response): Observable<ListResultDtoOfGetAllMsUnitStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsUnitStatusListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsUnitStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsUnitStatusListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsUnitStatusDropdown(): Observable<ListResultDtoOfGetAllMsUnitStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetMsUnitStatusDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsUnitStatusDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsUnitStatusDropdown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsUnitStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsUnitStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsUnitStatusDropdown(response: Response): Observable<ListResultDtoOfGetAllMsUnitStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsUnitStatusListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsUnitStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsUnitStatusListDto>(<any>null);
    }

    /**
     * @name (optional) 
     * @return Success
     */
    getListRolesUnitStatus(name: string): Observable<GetListRolesUnitStatusResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetListRolesUnitStatus?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRolesUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRolesUnitStatus(response_);
                } catch (e) {
                    return <Observable<GetListRolesUnitStatusResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRolesUnitStatusResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRolesUnitStatus(response: Response): Observable<GetListRolesUnitStatusResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRolesUnitStatusResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRolesUnitStatusResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailRolesUnitStatus(rolesID: number): Observable<GetDetailRolesUnitStatusResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetDetailRolesUnitStatus?";
        if (rolesID === undefined || rolesID === null)
            throw new Error("The parameter 'rolesID' must be defined and cannot be null.");
        else
            url_ += "rolesID=" + encodeURIComponent("" + rolesID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailRolesUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailRolesUnitStatus(response_);
                } catch (e) {
                    return <Observable<GetDetailRolesUnitStatusResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailRolesUnitStatusResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailRolesUnitStatus(response: Response): Observable<GetDetailRolesUnitStatusResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailRolesUnitStatusResultDto.fromJS(resultData200) : new GetDetailRolesUnitStatusResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailRolesUnitStatusResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateRolesUnitStatus(input: UpdateRolesUnitStatusInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/CreateUpdateRolesUnitStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateRolesUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateRolesUnitStatus(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateRolesUnitStatus(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListUnitStatusAfter(userID: number): Observable<GetAllMsUnitStatusListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetListUnitStatusAfter?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitStatusAfter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitStatusAfter(response_);
                } catch (e) {
                    return <Observable<GetAllMsUnitStatusListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllMsUnitStatusListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitStatusAfter(response: Response): Observable<GetAllMsUnitStatusListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllMsUnitStatusListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllMsUnitStatusListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDiagramaticManageStatus(input: GetDiagramaticManageStatusInputDto): Observable<GetDiagramaticManageStatusResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetDiagramaticManageStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiagramaticManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiagramaticManageStatus(response_);
                } catch (e) {
                    return <Observable<GetDiagramaticManageStatusResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDiagramaticManageStatusResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiagramaticManageStatus(response: Response): Observable<GetDiagramaticManageStatusResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDiagramaticManageStatusResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDiagramaticManageStatusResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTypeManageStatus(projectId: number, clusterId: number, categoryId: number): Observable<GetTypeManageStatusResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetTypeManageStatus?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTypeManageStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTypeManageStatus(response_);
                } catch (e) {
                    return <Observable<GetTypeManageStatusResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTypeManageStatusResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTypeManageStatus(response: Response): Observable<GetTypeManageStatusResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTypeManageStatusResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTypeManageStatusResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkUnitStatus(input: CheckUnitStatusInputDto): Observable<ListUnitStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/CheckUnitStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckUnitStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckUnitStatus(response_);
                } catch (e) {
                    return <Observable<ListUnitStatus[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListUnitStatus[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckUnitStatus(response: Response): Observable<ListUnitStatus[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListUnitStatus.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListUnitStatus[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getListAllUsers(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetListAllUsersResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetListAllUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListAllUsersResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListAllUsersResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllUsers(response: Response): Observable<PagedResultDtoOfGetListAllUsersResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetListAllUsersResultDto.fromJS(resultData200) : new PagedResultDtoOfGetListAllUsersResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetListAllUsersResultDto>(<any>null);
    }

    /**
     * @keyword (optional) 
     * @return Success
     */
    getListUnitStatusByUser(userID: number, keyword: string): Observable<GetListUnitStatusByUserResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/GetListUnitStatusByUser?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListUnitStatusByUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListUnitStatusByUser(response_);
                } catch (e) {
                    return <Observable<GetListUnitStatusByUserResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListUnitStatusByUserResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListUnitStatusByUser(response: Response): Observable<GetListUnitStatusByUserResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListUnitStatusByUserResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListUnitStatusByUserResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUserStatus(input: CreateOrUpdateUserStatusInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitStatus/CreateOrUpdateUserStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUserStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUserStatus(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUserStatus(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MsUnitVAServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUnitVirtualAccountTaskList(): Observable<ListResultDtoOfGetUnitVirtualAccount> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/GetUnitVirtualAccountTaskList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitVirtualAccountTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitVirtualAccountTaskList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetUnitVirtualAccount>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetUnitVirtualAccount>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitVirtualAccountTaskList(response: Response): Observable<ListResultDtoOfGetUnitVirtualAccount> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetUnitVirtualAccount.fromJS(resultData200) : new ListResultDtoOfGetUnitVirtualAccount();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetUnitVirtualAccount>(<any>null);
    }

    /**
     * @return Success
     */
    getBankBasedonProjectId(projectId: number): Observable<DropdownBank[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/GetBankBasedonProjectId?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankBasedonProjectId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankBasedonProjectId(response_);
                } catch (e) {
                    return <Observable<DropdownBank[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownBank[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBankBasedonProjectId(response: Response): Observable<DropdownBank[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownBank.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownBank[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsUnitVA(input: CreateMsUnitVirtualAccount): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/CreateMsUnitVA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsUnitVA(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsUnitVA(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsUnitVA(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    msAccountBasedonBankIdDropdown(bankId: number, projectId: number): Observable<DropdownMsAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/MsAccountBasedonBankIdDropdown?";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined and cannot be null.");
        else
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&"; 
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMsAccountBasedonBankIdDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMsAccountBasedonBankIdDropdown(response_);
                } catch (e) {
                    return <Observable<DropdownMsAccountDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownMsAccountDto[]>><any>Observable.throw(response_);
        });
    }

    protected processMsAccountBasedonBankIdDropdown(response: Response): Observable<DropdownMsAccountDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownMsAccountDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownMsAccountDto[]>(<any>null);
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    checkAvailabilityUnit(unitCode: string, unitNo: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/CheckAvailabilityUnit?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckAvailabilityUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckAvailabilityUnit(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckAvailabilityUnit(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getDisplayFieldUnitVirtualAccount(): Observable<GenerateExcel[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/GetDisplayFieldUnitVirtualAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDisplayFieldUnitVirtualAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDisplayFieldUnitVirtualAccount(response_);
                } catch (e) {
                    return <Observable<GenerateExcel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateExcel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDisplayFieldUnitVirtualAccount(response: Response): Observable<GenerateExcel[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GenerateExcel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateExcel[]>(<any>null);
    }

    /**
     * @return Success
     */
    generateMsUnitVA(projectId: number, clusterId: number): Observable<ExcelData[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/GenerateMsUnitVA?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateMsUnitVA(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateMsUnitVA(response_);
                } catch (e) {
                    return <Observable<ExcelData[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExcelData[]>><any>Observable.throw(response_);
        });
    }

    protected processGenerateMsUnitVA(response: Response): Observable<ExcelData[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ExcelData.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExcelData[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelMsUnitVA(input: OutputGenerateExcel): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/GenerateExcelMsUnitVA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelMsUnitVA(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelMsUnitVA(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelMsUnitVA(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadVirtualAccount(input: ListVirtualAcc[]): Observable<ListVirtualAcc[]> {
        let url_ = this.baseUrl + "/api/services/app/MsUnitVA/UploadVirtualAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadVirtualAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadVirtualAccount(response_);
                } catch (e) {
                    return <Observable<ListVirtualAcc[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListVirtualAcc[]>><any>Observable.throw(response_);
        });
    }

    protected processUploadVirtualAccount(response: Response): Observable<ListVirtualAcc[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListVirtualAcc.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListVirtualAcc[]>(<any>null);
    }
}

@Injectable()
export class MsZoningServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsZoning(input: CreateMsZoningInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsZoning/CreateMsZoning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsZoning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsZoning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsZoning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsZoning(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsZoning/DeleteMsZoning?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsZoning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsZoning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsZoning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsZoning(): Observable<ListResultDtoOfGetAllMsZoningListDto> {
        let url_ = this.baseUrl + "/api/services/app/MsZoning/GetAllMsZoning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsZoning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsZoning(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllMsZoningListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllMsZoningListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsZoning(response: Response): Observable<ListResultDtoOfGetAllMsZoningListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAllMsZoningListDto.fromJS(resultData200) : new ListResultDtoOfGetAllMsZoningListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAllMsZoningListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsZoning(input: UpdateMsZoningInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MsZoning/UpdateMsZoning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsZoning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsZoning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsZoning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MyCommissionSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListProjectResultAll(): Observable<GetListProjectNameResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListProjectResultAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectResultAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectResultAll(response_);
                } catch (e) {
                    return <Observable<GetListProjectNameResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectNameResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectResultAll(response: Response): Observable<GetListProjectNameResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectNameResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectNameResultDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getListMemberCode(projectID: number): Observable<GetListMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListMemberCode?";
        if (projectID !== undefined)
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMemberCode(response_);
                } catch (e) {
                    return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMemberCode(response: Response): Observable<GetListMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMemberCodeDto[]>(<any>null);
    }

    /**
     * @scmCode (optional) 
     * @return Success
     */
    getListProjectResult(scmCode: string): Observable<GetListProjectNameResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListProjectResult?";
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectResult(response_);
                } catch (e) {
                    return <Observable<GetListProjectNameResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectNameResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectResult(response: Response): Observable<GetListProjectNameResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectNameResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectNameResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTermOfPaymentResult(projectId: number): Observable<GetListTermOfPaymentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListTermOfPaymentResult?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTermOfPaymentResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTermOfPaymentResult(response_);
                } catch (e) {
                    return <Observable<GetListTermOfPaymentResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListTermOfPaymentResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTermOfPaymentResult(response: Response): Observable<GetListTermOfPaymentResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListTermOfPaymentResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListTermOfPaymentResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListStatusOLBooking(): Observable<GetListStatusOLBookingResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListStatusOLBooking";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListStatusOLBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListStatusOLBooking(response_);
                } catch (e) {
                    return <Observable<GetListStatusOLBookingResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListStatusOLBookingResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListStatusOLBooking(response: Response): Observable<GetListStatusOLBookingResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListStatusOLBookingResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListStatusOLBookingResultDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getTotalExpectedCommission(inputMemberCode: string): Observable<GetTotalExpectedCommissionDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTotalExpectedCommission?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalExpectedCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalExpectedCommission(response_);
                } catch (e) {
                    return <Observable<GetTotalExpectedCommissionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalExpectedCommissionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalExpectedCommission(response: Response): Observable<GetTotalExpectedCommissionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalExpectedCommissionDto.fromJS(resultData200) : new GetTotalExpectedCommissionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalExpectedCommissionDto>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getTotalPaidCommission(inputMemberCode: string): Observable<GetTotalPaidCommissionDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTotalPaidCommission?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalPaidCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalPaidCommission(response_);
                } catch (e) {
                    return <Observable<GetTotalPaidCommissionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalPaidCommissionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalPaidCommission(response: Response): Observable<GetTotalPaidCommissionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalPaidCommissionDto.fromJS(resultData200) : new GetTotalPaidCommissionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalPaidCommissionDto>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getTotalProcessedCommission(inputMemberCode: string): Observable<GetTotalProcessedCommissionDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTotalProcessedCommission?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalProcessedCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalProcessedCommission(response_);
                } catch (e) {
                    return <Observable<GetTotalProcessedCommissionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalProcessedCommissionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalProcessedCommission(response: Response): Observable<GetTotalProcessedCommissionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTotalProcessedCommissionDto.fromJS(resultData200) : new GetTotalProcessedCommissionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalProcessedCommissionDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @statusId (optional) 
     * @termId (optional) 
     * @projectId (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getAllInformation(memberCode: string, statusId: number, termId: number, projectId: number, startDate: moment.Moment, endDate: moment.Moment): Observable<GetAllInformationResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetAllInformation?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllInformation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllInformation(response_);
                } catch (e) {
                    return <Observable<GetAllInformationResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllInformationResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllInformation(response: Response): Observable<GetAllInformationResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllInformationResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllInformationResultDto[]>(<any>null);
    }

    /**
     * @inputBookCode (optional) 
     * @return Success
     */
    getDetailCommission(inputBookCode: string): Observable<GetDetailCommissionDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetDetailCommission?";
        if (inputBookCode !== undefined)
            url_ += "inputBookCode=" + encodeURIComponent("" + inputBookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailCommission(response_);
                } catch (e) {
                    return <Observable<GetDetailCommissionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailCommissionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailCommission(response: Response): Observable<GetDetailCommissionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailCommissionDto.fromJS(resultData200) : new GetDetailCommissionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailCommissionDto>(<any>null);
    }

    /**
     * @orderCode (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getDetailCommissionMobile(orderCode: string, memberCode: string): Observable<GetDetailCommissionMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetDetailCommissionMobile?";
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailCommissionMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailCommissionMobile(response_);
                } catch (e) {
                    return <Observable<GetDetailCommissionMobileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailCommissionMobileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailCommissionMobile(response: Response): Observable<GetDetailCommissionMobileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailCommissionMobileDto.fromJS(resultData200) : new GetDetailCommissionMobileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailCommissionMobileDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getCommissionTransactionApp(bookCode: string): Observable<GetCommissionTransactionAppDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetCommissionTransactionApp?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommissionTransactionApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommissionTransactionApp(response_);
                } catch (e) {
                    return <Observable<GetCommissionTransactionAppDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCommissionTransactionAppDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCommissionTransactionApp(response: Response): Observable<GetCommissionTransactionAppDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCommissionTransactionAppDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCommissionTransactionAppDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @start (optional) 
     * @end (optional) 
     * @orderCustomer (optional) 
     * @return Success
     */
    getListCommissionMobile(memberCode: string, start: string, end: string, orderCustomer: string): Observable<GetListCommissionMobileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetListCommissionMobile?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&"; 
        if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&"; 
        if (orderCustomer !== undefined)
            url_ += "orderCustomer=" + encodeURIComponent("" + orderCustomer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListCommissionMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListCommissionMobile(response_);
                } catch (e) {
                    return <Observable<GetListCommissionMobileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListCommissionMobileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListCommissionMobile(response: Response): Observable<GetListCommissionMobileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListCommissionMobileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListCommissionMobileDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getTaskListMyCommission(memberCode: string): Observable<GetTaskListMyCommissionListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTaskListMyCommission?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListMyCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListMyCommission(response_);
                } catch (e) {
                    return <Observable<GetTaskListMyCommissionListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListMyCommissionListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListMyCommission(response: Response): Observable<GetTaskListMyCommissionListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTaskListMyCommissionListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListMyCommissionListDto[]>(<any>null);
    }

    /**
     * @membercode (optional) 
     * @ppNo (optional) 
     * @return Success
     */
    getProsesCommissionList(membercode: string, eligibleCommision: number, eligibleCommisionPaid: number, ppNo: string): Observable<GetProsesCommissionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetProsesCommissionList?";
        if (membercode !== undefined)
            url_ += "membercode=" + encodeURIComponent("" + membercode) + "&"; 
        if (eligibleCommision === undefined || eligibleCommision === null)
            throw new Error("The parameter 'eligibleCommision' must be defined and cannot be null.");
        else
            url_ += "eligibleCommision=" + encodeURIComponent("" + eligibleCommision) + "&"; 
        if (eligibleCommisionPaid === undefined || eligibleCommisionPaid === null)
            throw new Error("The parameter 'eligibleCommisionPaid' must be defined and cannot be null.");
        else
            url_ += "eligibleCommisionPaid=" + encodeURIComponent("" + eligibleCommisionPaid) + "&"; 
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProsesCommissionList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProsesCommissionList(response_);
                } catch (e) {
                    return <Observable<GetProsesCommissionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProsesCommissionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProsesCommissionList(response: Response): Observable<GetProsesCommissionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProsesCommissionListDto.fromJS(resultData200) : new GetProsesCommissionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProsesCommissionListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createCommPPDetail(input: CreateCommPPDetailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/CreateCommPPDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateCommPPDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateCommPPDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateCommPPDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDetailMyCommission(bookCode: string): Observable<GetDetailMyCommissionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetDetailMyCommission?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMyCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMyCommission(response_);
                } catch (e) {
                    return <Observable<GetDetailMyCommissionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMyCommissionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMyCommission(response: Response): Observable<GetDetailMyCommissionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMyCommissionListDto.fromJS(resultData200) : new GetDetailMyCommissionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMyCommissionListDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getStatusMember(memberCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetStatusMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStatusMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStatusMember(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetStatusMember(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    listMember(memberCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/listMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListMember(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processListMember(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @memberCode (optional) 
     * @filter (optional) 
     * @startPeriode (optional) 
     * @endPeriode (optional) 
     * @return Success
     */
    getTasklistMyCommision2(projectId: number, memberCode: string, filter: string, startPeriode: moment.Moment, endPeriode: moment.Moment): Observable<GetTasklistMyCommisionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTasklistMyCommision2?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (startPeriode !== undefined)
            url_ += "startPeriode=" + encodeURIComponent(startPeriode ? "" + startPeriode.toJSON() : "") + "&"; 
        if (endPeriode !== undefined)
            url_ += "endPeriode=" + encodeURIComponent(endPeriode ? "" + endPeriode.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMyCommision2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMyCommision2(response_);
                } catch (e) {
                    return <Observable<GetTasklistMyCommisionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMyCommisionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMyCommision2(response: Response): Observable<GetTasklistMyCommisionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTasklistMyCommisionListDto.fromJS(resultData200) : new GetTasklistMyCommisionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMyCommisionListDto>(<any>null);
    }

    /**
     * @userID (optional) 
     * @return Success
     */
    cekRoles(userID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/CekRoles?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCekRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCekRoles(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCekRoles(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @memberCode (optional) 
     * @filter (optional) 
     * @startPeriode (optional) 
     * @endPeriode (optional) 
     * @return Success
     */
    getTasklistMyCommision(projectId: number, memberCode: string, filter: string, startPeriode: moment.Moment, endPeriode: moment.Moment): Observable<GetTasklistMyCommisionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetTasklistMyCommision?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (startPeriode !== undefined)
            url_ += "startPeriode=" + encodeURIComponent(startPeriode ? "" + startPeriode.toJSON() : "") + "&"; 
        if (endPeriode !== undefined)
            url_ += "endPeriode=" + encodeURIComponent(endPeriode ? "" + endPeriode.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMyCommision(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMyCommision(response_);
                } catch (e) {
                    return <Observable<GetTasklistMyCommisionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMyCommisionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMyCommision(response: Response): Observable<GetTasklistMyCommisionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTasklistMyCommisionListDto.fromJS(resultData200) : new GetTasklistMyCommisionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMyCommisionListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @memberCode (optional) 
     * @memberCodeLogin (optional) 
     * @return Success
     */
    getDetailTaskListMyCommision(bookingHeaderID: number, bookCode: string, memberCode: string, memberCodeLogin: string): Observable<GetDetailTaskListMyCommisionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetDetailTaskListMyCommision?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (memberCodeLogin !== undefined)
            url_ += "memberCodeLogin=" + encodeURIComponent("" + memberCodeLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailTaskListMyCommision(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailTaskListMyCommision(response_);
                } catch (e) {
                    return <Observable<GetDetailTaskListMyCommisionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailTaskListMyCommisionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailTaskListMyCommision(response: Response): Observable<GetDetailTaskListMyCommisionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailTaskListMyCommisionListDto.fromJS(resultData200) : new GetDetailTaskListMyCommisionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailTaskListMyCommisionListDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getChartMyCommision(memberCode: string, startDate: moment.Moment, endDate: moment.Moment): Observable<GetChartMyCommisionListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetChartMyCommision?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChartMyCommision(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChartMyCommision(response_);
                } catch (e) {
                    return <Observable<GetChartMyCommisionListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetChartMyCommisionListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetChartMyCommision(response: Response): Observable<GetChartMyCommisionListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetChartMyCommisionListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetChartMyCommisionListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFMyCommission(input: GetDetailTaskListMyCommisionListDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GeneratePDFMyCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFMyCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFMyCommission(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFMyCommission(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFImageUndian(input: PDFDataPemenangDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GeneratePDFImageUndian";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFImageUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFImageUndian(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFImageUndian(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFMyCommissionApps(input: GetDetailTasklistMyCommisionInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GeneratePDFMyCommissionApps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFMyCommissionApps(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFMyCommissionApps(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFMyCommissionApps(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @memberCode (optional) 
     * @memberCodeLogin (optional) 
     * @return Success
     */
    getDetailTaskListMyCommisionBF(bookingHeaderID: number, bookCode: string, memberCode: string, memberCodeLogin: string): Observable<GetDetailTaskListMyCommisionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCommissionSP/GetDetailTaskListMyCommisionBF?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (memberCodeLogin !== undefined)
            url_ += "memberCodeLogin=" + encodeURIComponent("" + memberCodeLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailTaskListMyCommisionBF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailTaskListMyCommisionBF(response_);
                } catch (e) {
                    return <Observable<GetDetailTaskListMyCommisionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailTaskListMyCommisionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailTaskListMyCommisionBF(response: Response): Observable<GetDetailTaskListMyCommisionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailTaskListMyCommisionListDto.fromJS(resultData200) : new GetDetailTaskListMyCommisionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailTaskListMyCommisionListDto>(<any>null);
    }
}

@Injectable()
export class MyCustomerSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListEvent(): Observable<GetListEventResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetListEvent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListEvent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListEvent(response_);
                } catch (e) {
                    return <Observable<GetListEventResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListEventResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListEvent(response: Response): Observable<GetListEventResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListEventResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListEventResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMsSalesLeadTypeDropdown(): Observable<GetMsSalesLeadTypeDropdownResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetMsSalesLeadTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsSalesLeadTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsSalesLeadTypeDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsSalesLeadTypeDropdownResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsSalesLeadTypeDropdownResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsSalesLeadTypeDropdown(response: Response): Observable<GetMsSalesLeadTypeDropdownResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsSalesLeadTypeDropdownResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsSalesLeadTypeDropdownResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownDokument(): Observable<GetDropdownDokumentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetDropdownDokument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownDokument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownDokument(response_);
                } catch (e) {
                    return <Observable<GetDropdownDokumentTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownDokumentTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownDokument(response: Response): Observable<GetDropdownDokumentTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownDokumentTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownDokumentTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMsPotentialCustomerPriceRangeDropdown(): Observable<GetPriceRangeDropdownResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetMsPotentialCustomerPriceRangeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsPotentialCustomerPriceRangeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsPotentialCustomerPriceRangeDropdown(response_);
                } catch (e) {
                    return <Observable<GetPriceRangeDropdownResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPriceRangeDropdownResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsPotentialCustomerPriceRangeDropdown(response: Response): Observable<GetPriceRangeDropdownResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPriceRangeDropdownResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPriceRangeDropdownResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addPotentialCustomer(input: AddPotentialCustomerDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/AddPotentialCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddPotentialCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddPotentialCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processAddPotentialCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePotentialCustomer(input: UpdatePotentialCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/updatePotentialCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePotentialCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePotentialCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePotentialCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePotentialCustomerMobile(input: UpdatePotentialCustomerMobileInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/UpdatePotentialCustomerMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePotentialCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePotentialCustomerMobile(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePotentialCustomerMobile(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMyCustomerList(userID: number): Observable<GetMyCustomerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetMyCustomerList?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyCustomerList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyCustomerList(response_);
                } catch (e) {
                    return <Observable<GetMyCustomerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMyCustomerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMyCustomerList(response: Response): Observable<GetMyCustomerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMyCustomerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMyCustomerListDto[]>(<any>null);
    }

    /**
     * @timePeriodID (optional) 
     * @return Success
     */
    getPotentialCustomerList(inputUn: number, timePeriodID: number): Observable<GetPotentialCustomerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetPotentialCustomerList?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (timePeriodID !== undefined)
            url_ += "timePeriodID=" + encodeURIComponent("" + timePeriodID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPotentialCustomerList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPotentialCustomerList(response_);
                } catch (e) {
                    return <Observable<GetPotentialCustomerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPotentialCustomerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPotentialCustomerList(response: Response): Observable<GetPotentialCustomerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPotentialCustomerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPotentialCustomerListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailPotentialCustomer(potentialcustomerID: number): Observable<GetDetailPotentialCustomerResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetDetailPotentialCustomer?";
        if (potentialcustomerID === undefined || potentialcustomerID === null)
            throw new Error("The parameter 'potentialcustomerID' must be defined and cannot be null.");
        else
            url_ += "potentialcustomerID=" + encodeURIComponent("" + potentialcustomerID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPotentialCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPotentialCustomer(response_);
                } catch (e) {
                    return <Observable<GetDetailPotentialCustomerResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPotentialCustomerResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPotentialCustomer(response: Response): Observable<GetDetailPotentialCustomerResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPotentialCustomerResultDto.fromJS(resultData200) : new GetDetailPotentialCustomerResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPotentialCustomerResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMyCustomerMobile(input: UpdateCustomerMobileInputDto): Observable<ResultMessageMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/UpdateMyCustomerMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMyCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMyCustomerMobile(response_);
                } catch (e) {
                    return <Observable<ResultMessageMobileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageMobileDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMyCustomerMobile(response: Response): Observable<ResultMessageMobileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageMobileDto.fromJS(resultData200) : new ResultMessageMobileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageMobileDto>(<any>null);
    }

    /**
     * @name (optional) 
     * @return Success
     */
    getMyCustomerMobile(inputUn: number, name: string): Observable<GetMyCustomerMobileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetMyCustomerMobile?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetMyCustomerMobileListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMyCustomerMobileListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMyCustomerMobile(response: Response): Observable<GetMyCustomerMobileListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMyCustomerMobileListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMyCustomerMobileListDto[]>(<any>null);
    }

    /**
     * @name (optional) 
     * @timePeriodID (optional) 
     * @return Success
     */
    getPotentialCustomerMobile(inputUn: number, name: string, timePeriodID: number): Observable<GetPotentialCustomerMobileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetPotentialCustomerMobile?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (timePeriodID !== undefined)
            url_ += "timePeriodID=" + encodeURIComponent("" + timePeriodID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPotentialCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPotentialCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetPotentialCustomerMobileListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPotentialCustomerMobileListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPotentialCustomerMobile(response: Response): Observable<GetPotentialCustomerMobileListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPotentialCustomerMobileListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPotentialCustomerMobileListDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDetailMyCustomerMobile(psCode: string): Observable<GetDetailMyCustomerMobileListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetDetailMyCustomerMobile?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMyCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMyCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetDetailMyCustomerMobileListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMyCustomerMobileListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMyCustomerMobile(response: Response): Observable<GetDetailMyCustomerMobileListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMyCustomerMobileListDto.fromJS(resultData200) : new GetDetailMyCustomerMobileListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMyCustomerMobileListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailPotentialCustomerMobile(inputUn: number, id: number): Observable<GetDetailPotentialCustomerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetDetailPotentialCustomerMobile?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPotentialCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPotentialCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetDetailPotentialCustomerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPotentialCustomerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPotentialCustomerMobile(response: Response): Observable<GetDetailPotentialCustomerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailPotentialCustomerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPotentialCustomerListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTimePeriod(): Observable<GetDropdownTimePeriodResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyCustomerSP/GetDropdownTimePeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTimePeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTimePeriod(response_);
                } catch (e) {
                    return <Observable<GetDropdownTimePeriodResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTimePeriodResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTimePeriod(response: Response): Observable<GetDropdownTimePeriodResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTimePeriodResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTimePeriodResultDto[]>(<any>null);
    }
}

@Injectable()
export class MyProfileSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getMyProductList(inputMemberCode: string): Observable<GetMyProductDto> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetMyProductList?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyProductList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyProductList(response_);
                } catch (e) {
                    return <Observable<GetMyProductDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMyProductDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMyProductList(response: Response): Observable<GetMyProductDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMyProductDto.fromJS(resultData200) : new GetMyProductDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMyProductDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getParentList(memberCode: string): Observable<GetParentListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetParentList?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParentList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParentList(response_);
                } catch (e) {
                    return <Observable<GetParentListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetParentListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetParentList(response: Response): Observable<GetParentListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetParentListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetParentListDto[]>(<any>null);
    }

    /**
     * @parentMemberCode (optional) 
     * @return Success
     */
    getChildList(parentMemberCode: string): Observable<GetChildListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetChildList?";
        if (parentMemberCode !== undefined)
            url_ += "parentMemberCode=" + encodeURIComponent("" + parentMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChildList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChildList(response_);
                } catch (e) {
                    return <Observable<GetChildListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetChildListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetChildList(response: Response): Observable<GetChildListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetChildListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetChildListDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getParentAndChildList(memberCode: string): Observable<GetParentAndChildListDto> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetParentAndChildList?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParentAndChildList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParentAndChildList(response_);
                } catch (e) {
                    return <Observable<GetParentAndChildListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetParentAndChildListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetParentAndChildList(response: Response): Observable<GetParentAndChildListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetParentAndChildListDto.fromJS(resultData200) : new GetParentAndChildListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetParentAndChildListDto>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getTotalUnitMobile(inputMemberCode: string, startDate: moment.Moment, endDate: moment.Moment, summary: number): Observable<GetTotalUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetTotalUnitMobile?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalUnitMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalUnitMobile(response_);
                } catch (e) {
                    return <Observable<GetTotalUnitDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalUnitDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalUnitMobile(response: Response): Observable<GetTotalUnitDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalUnitDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalUnitDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getTotalCustomerMobile(inputMemberCode: string, startDate: moment.Moment, endDate: moment.Moment, summary: number): Observable<GetTotalCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetTotalCustomerMobile?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetTotalCustomerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCustomerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCustomerMobile(response: Response): Observable<GetTotalCustomerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCustomerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCustomerDto[]>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getTotalPotentialCustomerMobile(inputUn: number, startDate: moment.Moment, endDate: moment.Moment, summary: number): Observable<GetTotalPotentialCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetTotalPotentialCustomerMobile?";
        if (inputUn === undefined || inputUn === null)
            throw new Error("The parameter 'inputUn' must be defined and cannot be null.");
        else
            url_ += "inputUn=" + encodeURIComponent("" + inputUn) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalPotentialCustomerMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalPotentialCustomerMobile(response_);
                } catch (e) {
                    return <Observable<GetTotalPotentialCustomerDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalPotentialCustomerDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalPotentialCustomerMobile(response: Response): Observable<GetTotalPotentialCustomerDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalPotentialCustomerDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalPotentialCustomerDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getTotalCommissionMobile(inputMemberCode: string, startDate: moment.Moment, endDate: moment.Moment, summary: number): Observable<GetTotalCommissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetTotalCommissionMobile?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCommissionMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCommissionMobile(response_);
                } catch (e) {
                    return <Observable<GetTotalCommissionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCommissionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCommissionMobile(response: Response): Observable<GetTotalCommissionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCommissionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCommissionDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getTotalCommissionPaidMobile(inputMemberCode: string, startDate: moment.Moment, endDate: moment.Moment, summary: number): Observable<GetTotalCommissionPaidDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetTotalCommissionPaidMobile?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (summary === undefined || summary === null)
            throw new Error("The parameter 'summary' must be defined and cannot be null.");
        else
            url_ += "summary=" + encodeURIComponent("" + summary) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalCommissionPaidMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalCommissionPaidMobile(response_);
                } catch (e) {
                    return <Observable<GetTotalCommissionPaidDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTotalCommissionPaidDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalCommissionPaidMobile(response: Response): Observable<GetTotalCommissionPaidDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTotalCommissionPaidDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTotalCommissionPaidDto[]>(<any>null);
    }

    /**
     * @inputMemberCode (optional) 
     * @return Success
     */
    getMyProductMobile(inputMemberCode: string): Observable<GetMyProductMobileListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MyProfileSP/GetMyProductMobile?";
        if (inputMemberCode !== undefined)
            url_ += "inputMemberCode=" + encodeURIComponent("" + inputMemberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMyProductMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMyProductMobile(response_);
                } catch (e) {
                    return <Observable<GetMyProductMobileListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMyProductMobileListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMyProductMobile(response: Response): Observable<GetMyProductMobileListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMyProductMobileListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMyProductMobileListDto[]>(<any>null);
    }
}

@Injectable()
export class NotarisServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDropdownNotaris(bookCode: string): Observable<NotarisDropdownDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notaris/GetDropdownNotaris?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownNotaris(response_);
                } catch (e) {
                    return <Observable<NotarisDropdownDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisDropdownDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownNotaris(response: Response): Observable<NotarisDropdownDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisDropdownDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisDropdownDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownNotarisEmail(notarisID: number): Observable<NotarisEmailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notaris/GetDropdownNotarisEmail?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownNotarisEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownNotarisEmail(response_);
                } catch (e) {
                    return <Observable<NotarisEmailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisEmailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownNotarisEmail(response: Response): Observable<NotarisEmailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisEmailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisEmailDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownNotarisPhone(notarisID: number): Observable<NotarisPhoneDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notaris/GetDropdownNotarisPhone?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownNotarisPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownNotarisPhone(response_);
                } catch (e) {
                    return <Observable<NotarisPhoneDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisPhoneDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownNotarisPhone(response: Response): Observable<NotarisPhoneDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisPhoneDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisPhoneDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownStaffNotaris(notarisID: number): Observable<NotarisStaffDropdownDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notaris/GetDropdownStaffNotaris?";
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownStaffNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownStaffNotaris(response_);
                } catch (e) {
                    return <Observable<NotarisStaffDropdownDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NotarisStaffDropdownDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownStaffNotaris(response: Response): Observable<NotarisStaffDropdownDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NotarisStaffDropdownDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NotarisStaffDropdownDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getPICBankEmail(bookCode: string, notarisID: number): Observable<PicBankEmailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notaris/GetPICBankEmail?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (notarisID === undefined || notarisID === null)
            throw new Error("The parameter 'notarisID' must be defined and cannot be null.");
        else
            url_ += "notarisID=" + encodeURIComponent("" + notarisID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPICBankEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPICBankEmail(response_);
                } catch (e) {
                    return <Observable<PicBankEmailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PicBankEmailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPICBankEmail(response: Response): Observable<PicBankEmailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PicBankEmailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PicBankEmailDto[]>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @state (optional) 
     * @return Success
     */
    getUserNotifications(state: State, maxResultCount: number, skipCount: number): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserNotifications(response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNotifications(response: Response): Observable<GetNotificationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetAllNotificationsAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetAllNotificationsAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setNotificationAsRead(input: EntityDtoOfGuid): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetNotificationAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetNotificationAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotificationSettings(response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetNotificationSettings(response: Response): Observable<GetNotificationSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotificationSettings(input: UpdateNotificationSettingsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotificationSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotificationSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class OfficialReceiptPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @psCode (optional) 
     * @paymentStart (optional) 
     * @paymentEnd (optional) 
     * @return Success
     */
    getDataPaymentSearchingOfficialReceipt(projectID: number, clusterID: number, unitID: number, psCode: string, payForID: number, paymentStart: moment.Moment, paymentEnd: moment.Moment): Observable<GetDataPaymentListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/GetDataPaymentSearchingOfficialReceipt?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        if (paymentStart !== undefined)
            url_ += "paymentStart=" + encodeURIComponent(paymentStart ? "" + paymentStart.toJSON() : "") + "&"; 
        if (paymentEnd !== undefined)
            url_ += "paymentEnd=" + encodeURIComponent(paymentEnd ? "" + paymentEnd.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataPaymentSearchingOfficialReceipt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataPaymentSearchingOfficialReceipt(response_);
                } catch (e) {
                    return <Observable<GetDataPaymentListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataPaymentListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataPaymentSearchingOfficialReceipt(response: Response): Observable<GetDataPaymentListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataPaymentListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataPaymentListDto[]>(<any>null);
    }

    /**
     * @fileName (optional) 
     * @return Success
     */
    deleteORFile(fileName: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/DeleteORFile?";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteORFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteORFile(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteORFile(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    officialReceiptPrint(input: SearchPdfORInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/OfficialReceiptPrint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOfficialReceiptPrint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOfficialReceiptPrint(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processOfficialReceiptPrint(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerSendEmailOR(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/SchedulerSendEmailOR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSendEmailOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSendEmailOR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSendEmailOR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @transNoList (optional) 
     * @return Success
     */
    schedulerSendEmailORManual(transNoList: string[]): Observable<GetReportORList[]> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/SchedulerSendEmailORManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transNoList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSendEmailORManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSendEmailORManual(response_);
                } catch (e) {
                    return <Observable<GetReportORList[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReportORList[]>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSendEmailORManual(response: Response): Observable<GetReportORList[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetReportORList.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetReportORList[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailOR(input: SendEmailORInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/SendEmailOR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailOR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailOR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    searchPdf(input: SearchPdfORInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/SearchPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSearchPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSearchPdf(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processSearchPdf(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataToPrintOR(input: PrintORDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/GetDataToPrintOR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataToPrintOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataToPrintOR(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetDataToPrintOR(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @paymentStart (optional) 
     * @paymentEnd (optional) 
     * @listTransNo (optional) 
     * @return Success
     */
    getDataGeneratePDFOR(transNo: string, accountID: number, paymentStart: moment.Moment, paymentEnd: moment.Moment, listTransNo: string[], flag: number): Observable<GetDataGeneratePDFORManualListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/GetDataGeneratePDFOR?";
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (paymentStart !== undefined)
            url_ += "paymentStart=" + encodeURIComponent(paymentStart ? "" + paymentStart.toJSON() : "") + "&"; 
        if (paymentEnd !== undefined)
            url_ += "paymentEnd=" + encodeURIComponent(paymentEnd ? "" + paymentEnd.toJSON() : "") + "&"; 
        if (listTransNo !== undefined)
            listTransNo && listTransNo.forEach(item => { url_ += "listTransNo=" + encodeURIComponent("" + item) + "&"; });
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataGeneratePDFOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataGeneratePDFOR(response_);
                } catch (e) {
                    return <Observable<GetDataGeneratePDFORManualListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataGeneratePDFORManualListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataGeneratePDFOR(response: Response): Observable<GetDataGeneratePDFORManualListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataGeneratePDFORManualListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataGeneratePDFORManualListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFORManual(input: GeneratePDFORManualDto): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/GeneratePDFORManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFORManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFORManual(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFORManual(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @transNo (optional) 
     * @return Success
     */
    getDataPrintORByTransNo(transNo: string, payForID: number): Observable<GetDataPrintORByTransNoListDto> {
        let url_ = this.baseUrl + "/api/services/app/OfficialReceiptPayment/GetDataPrintORByTransNo?";
        if (transNo !== undefined)
            url_ += "transNo=" + encodeURIComponent("" + transNo) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataPrintORByTransNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataPrintORByTransNo(response_);
                } catch (e) {
                    return <Observable<GetDataPrintORByTransNoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataPrintORByTransNoListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataPrintORByTransNo(response: Response): Observable<GetDataPrintORByTransNoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataPrintORByTransNoListDto.fromJS(resultData200) : new GetDataPrintORByTransNoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataPrintORByTransNoListDto>(<any>null);
    }
}

@Injectable()
export class OneSignalServiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    pushNotif(input: GetDataOneSignalResultDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OneSignalService/PushNotif";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPushNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPushNotif(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPushNotif(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class OrderPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListOrderHistory(input: GetListOrderHistoryInputDto): Observable<GetListOrderHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetListOrderHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOrderHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOrderHistory(response_);
                } catch (e) {
                    return <Observable<GetListOrderHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOrderHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListOrderHistory(response: Response): Observable<GetListOrderHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListOrderHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOrderHistoryResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListOrderHistoryNew(input: GetPagedOrderHistoryInputDto): Observable<GetPagedOrderHistoryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetListOrderHistoryNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOrderHistoryNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOrderHistoryNew(response_);
                } catch (e) {
                    return <Observable<GetPagedOrderHistoryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPagedOrderHistoryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListOrderHistoryNew(response: Response): Observable<GetPagedOrderHistoryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPagedOrderHistoryResultDto.fromJS(resultData200) : new GetPagedOrderHistoryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPagedOrderHistoryResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @orderCustomer (optional) 
     * @orderStatusId (optional) 
     * @starDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getListOrderHistoryApp(memberCode: string, orderCustomer: string, orderStatusId: string, starDate: string, endDate: string): Observable<GetListOrderHistoryAppDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetListOrderHistoryApp?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (orderCustomer !== undefined)
            url_ += "orderCustomer=" + encodeURIComponent("" + orderCustomer) + "&"; 
        if (orderStatusId !== undefined)
            url_ += "orderStatusId=" + encodeURIComponent("" + orderStatusId) + "&"; 
        if (starDate !== undefined)
            url_ += "starDate=" + encodeURIComponent("" + starDate) + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOrderHistoryApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOrderHistoryApp(response_);
                } catch (e) {
                    return <Observable<GetListOrderHistoryAppDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOrderHistoryAppDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListOrderHistoryApp(response: Response): Observable<GetListOrderHistoryAppDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListOrderHistoryAppDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOrderHistoryAppDto[]>(<any>null);
    }

    /**
     * @orderCode (optional) 
     * @return Success
     */
    getDetailOrderApp(orderCode: string): Observable<GetDetailOrderAppDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDetailOrderApp?";
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailOrderApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailOrderApp(response_);
                } catch (e) {
                    return <Observable<GetDetailOrderAppDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailOrderAppDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailOrderApp(response: Response): Observable<GetDetailOrderAppDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailOrderAppDto.fromJS(resultData200) : new GetDetailOrderAppDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailOrderAppDto>(<any>null);
    }

    /**
     * @return Success
     */
    resendEmail(pPOrderID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/ResendEmail?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendEmail(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processResendEmail(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownSort(): Observable<GetDropdownSortResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDropdownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownSort(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownSort(response_);
                } catch (e) {
                    return <Observable<GetDropdownSortResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownSortResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownSort(response: Response): Observable<GetDropdownSortResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownSortResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownSortResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownSortBy(): Observable<GetDropdownSortResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDropdownSortBy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownSortBy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownSortBy(response_);
                } catch (e) {
                    return <Observable<GetDropdownSortResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownSortResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownSortBy(response: Response): Observable<GetDropdownSortResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownSortResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownSortResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTerm(): Observable<GetDropdownTermResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDropdownTerm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTerm(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTerm(response: Response): Observable<GetDropdownTermResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCheckboxDisplayedField(): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetCheckboxDisplayedField";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckboxDisplayedField(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckboxDisplayedField(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckboxDisplayedField(response: Response): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPreferredType(projectProductID: number): Observable<GetPreferredTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetPreferredType?";
        if (projectProductID === undefined || projectProductID === null)
            throw new Error("The parameter 'projectProductID' must be defined and cannot be null.");
        else
            url_ += "projectProductID=" + encodeURIComponent("" + projectProductID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreferredType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreferredType(response_);
                } catch (e) {
                    return <Observable<GetPreferredTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPreferredTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPreferredType(response: Response): Observable<GetPreferredTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPreferredTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPreferredTypeResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPreferredUnitType(projectID: number): Observable<GetPreferredTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetPreferredUnitType?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreferredUnitType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreferredUnitType(response_);
                } catch (e) {
                    return <Observable<GetPreferredTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPreferredTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPreferredUnitType(response: Response): Observable<GetPreferredTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPreferredTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPreferredTypeResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListReportOrder(input: GetListReportOrderInputDto): Observable<GetListReportOrderResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetListReportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportOrder(response_);
                } catch (e) {
                    return <Observable<GetListReportOrderResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListReportOrderResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportOrder(response: Response): Observable<GetListReportOrderResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListReportOrderResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListReportOrderResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportPdf(input: GetReportOrderPdfInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GenerateReportPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportPdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportPdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportOrder(input: GetReportOrderPdfInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GenerateExcelReportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportOrder(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportOrder(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailOrder(pPOrderID: number): Observable<GetDetailOrderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDetailOrder?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailOrder(response_);
                } catch (e) {
                    return <Observable<GetDetailOrderResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailOrderResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailOrder(response: Response): Observable<GetDetailOrderResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailOrderResultDto.fromJS(resultData200) : new GetDetailOrderResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailOrderResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListPrintTTBF(input: GetListGenerateTTBFInputDto): Observable<GetListOrderHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetListPrintTTBF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPrintTTBF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPrintTTBF(response_);
                } catch (e) {
                    return <Observable<GetListOrderHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListOrderHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPrintTTBF(response: Response): Observable<GetListOrderHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListOrderHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListOrderHistoryResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailOrderUnit(pPOrderID: number): Observable<GetDetailOrderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPP/GetDetailOrderUnit?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailOrderUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailOrderUnit(response_);
                } catch (e) {
                    return <Observable<GetDetailOrderResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailOrderResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailOrderUnit(response: Response): Observable<GetDetailOrderResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailOrderResultDto.fromJS(resultData200) : new GetDetailOrderResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailOrderResultDto>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnits(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnits(response: Response): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnitUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnitUsers(response: Response): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrganizationUnit(input: CreateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateOrganizationUnit(input: UpdateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    moveOrganizationUnit(input: MoveOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processMoveOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteOrganizationUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number, organizationUnitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId === undefined || organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' must be defined and cannot be null.");
        else
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveUserFromOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(input: UsersToOrganizationUnitInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddUsersToOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindOrganizationUnitUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class P4ServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListP4Header(userID: number): Observable<GetListRequestP4ResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/P4/GetListP4Header?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListP4Header(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListP4Header(response_);
                } catch (e) {
                    return <Observable<GetListRequestP4ResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRequestP4ResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListP4Header(response: Response): Observable<GetListRequestP4ResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRequestP4ResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRequestP4ResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    checkIsManager(userID: number): Observable<CheckIsManager> {
        let url_ = this.baseUrl + "/api/services/app/P4/CheckIsManager?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIsManager(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIsManager(response_);
                } catch (e) {
                    return <Observable<CheckIsManager>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckIsManager>><any>Observable.throw(response_);
        });
    }

    protected processCheckIsManager(response: Response): Observable<CheckIsManager> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckIsManager.fromJS(resultData200) : new CheckIsManager();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckIsManager>(<any>null);
    }

    /**
     * @return Success
     */
    getListHistoryApprover(userID: number): Observable<GetListHistoryApproverResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/P4/GetListHistoryApprover?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListHistoryApprover(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListHistoryApprover(response_);
                } catch (e) {
                    return <Observable<GetListHistoryApproverResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListHistoryApproverResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListHistoryApprover(response: Response): Observable<GetListHistoryApproverResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListHistoryApproverResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListHistoryApproverResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserNamesInUserGroups(userGroupId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/P4/GetUserNamesInUserGroups?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined and cannot be null.");
        else
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNamesInUserGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserNamesInUserGroups(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNamesInUserGroups(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertP4Request(input: InsertP4RequestInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/P4/InsertP4Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertP4Request(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertP4Request(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertP4Request(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailRequestP4(headerID: number): Observable<GetDetailRequestP4ResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/P4/GetDetailRequestP4?";
        if (headerID === undefined || headerID === null)
            throw new Error("The parameter 'headerID' must be defined and cannot be null.");
        else
            url_ += "headerID=" + encodeURIComponent("" + headerID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailRequestP4(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailRequestP4(response_);
                } catch (e) {
                    return <Observable<GetDetailRequestP4ResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailRequestP4ResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailRequestP4(response: Response): Observable<GetDetailRequestP4ResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailRequestP4ResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailRequestP4ResultDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @startBookingDate (optional) 
     * @endBookingDate (optional) 
     * @bookCode (optional) 
     * @return Success
     */
    getListDataP4bySearch(projectID: number, startBookingDate: moment.Moment, endBookingDate: moment.Moment, bookCode: string): Observable<GetListDataP4bySearchResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/P4/GetListDataP4bySearch?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (startBookingDate !== undefined)
            url_ += "startBookingDate=" + encodeURIComponent(startBookingDate ? "" + startBookingDate.toJSON() : "") + "&"; 
        if (endBookingDate !== undefined)
            url_ += "endBookingDate=" + encodeURIComponent(endBookingDate ? "" + endBookingDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDataP4bySearch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDataP4bySearch(response_);
                } catch (e) {
                    return <Observable<GetListDataP4bySearchResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListDataP4bySearchResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDataP4bySearch(response: Response): Observable<GetListDataP4bySearchResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListDataP4bySearchResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListDataP4bySearchResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDataP4Submit(input: CreateDataP4SubmitInputDto[]): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/P4/CreateDataP4Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDataP4Submit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDataP4Submit(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateDataP4Submit(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDataP4Save(input: CreateDataP4SubmitInputDto[]): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/P4/CreateDataP4Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDataP4Save(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDataP4Save(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateDataP4Save(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDataP4(input: UpdateDataP4InputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/P4/UpdateDataP4";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataP4(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataP4(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataP4(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateDataApprover1(headerID: number, isRejected: boolean, userID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/P4/UpdateDataApprover1?";
        if (headerID === undefined || headerID === null)
            throw new Error("The parameter 'headerID' must be defined and cannot be null.");
        else
            url_ += "headerID=" + encodeURIComponent("" + headerID) + "&"; 
        if (isRejected === undefined || isRejected === null)
            throw new Error("The parameter 'isRejected' must be defined and cannot be null.");
        else
            url_ += "isRejected=" + encodeURIComponent("" + isRejected) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataApprover1(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataApprover1(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataApprover1(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateDataApprover2(headerID: number, isRejected: boolean, userID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/P4/UpdateDataApprover2?";
        if (headerID === undefined || headerID === null)
            throw new Error("The parameter 'headerID' must be defined and cannot be null.");
        else
            url_ += "headerID=" + encodeURIComponent("" + headerID) + "&"; 
        if (isRejected === undefined || isRejected === null)
            throw new Error("The parameter 'isRejected' must be defined and cannot be null.");
        else
            url_ += "isRejected=" + encodeURIComponent("" + isRejected) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataApprover2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataApprover2(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataApprover2(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateDataFastApprover(headerID: number, isRejected: boolean, userID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/P4/UpdateDataFastApprover?";
        if (headerID === undefined || headerID === null)
            throw new Error("The parameter 'headerID' must be defined and cannot be null.");
        else
            url_ += "headerID=" + encodeURIComponent("" + headerID) + "&"; 
        if (isRejected === undefined || isRejected === null)
            throw new Error("The parameter 'isRejected' must be defined and cannot be null.");
        else
            url_ += "isRejected=" + encodeURIComponent("" + isRejected) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataFastApprover(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataFastApprover(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataFastApprover(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentInfo(response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentInfo(response: Response): Observable<PaymentInfoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentInfoDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPayment(input: CreatePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreatePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    executePayment(input: ExecutePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExecutePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExecutePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processExecutePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentHistory(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentHistory(response: Response): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }
}

@Injectable()
export class PaymentBookingFeeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @customerName (optional) 
     * @projectID (optional) 
     * @orderCode (optional) 
     * @return Success
     */
    getOrderCodeDataTasklist(customerName: string, projectID: number, orderCode: string): Observable<GetOrderCodeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentBookingFee/GetOrderCodeDataTasklist?";
        if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrderCodeDataTasklist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrderCodeDataTasklist(response_);
                } catch (e) {
                    return <Observable<GetOrderCodeDataDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrderCodeDataDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetOrderCodeDataTasklist(response: Response): Observable<GetOrderCodeDataDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetOrderCodeDataDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOrderCodeDataDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    processSinglePayment(input: GetPaymentBookingFeeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentBookingFee/ProcessSinglePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessSinglePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessSinglePayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessSinglePayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUnitOrderHeader(input: GetPaymentBookingFeeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentBookingFee/UpdateUnitOrderHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUnitOrderHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUnitOrderHeader(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUnitOrderHeader(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownAccount(projectID: number): Observable<GetAccountByProject[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentBookingFee/GetDropdownAccount?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownAccount(response_);
                } catch (e) {
                    return <Observable<GetAccountByProject[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAccountByProject[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownAccount(response: Response): Observable<GetAccountByProject[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAccountByProject.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAccountByProject[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertTrBookingPayment(input: InsertTrBookingPaymentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentBookingFee/InsertTrBookingPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTrBookingPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTrBookingPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTrBookingPayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentLkAllocServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLkAlloc(input: CreateOrUpdateLkAllocInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkAlloc/CreateOrUpdateLkAlloc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLkAlloc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLkAlloc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLkAlloc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLkAlloc(): Observable<GetLkAllocListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkAlloc/GetAllLkAlloc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkAlloc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkAlloc(response_);
                } catch (e) {
                    return <Observable<GetLkAllocListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkAllocListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkAlloc(response: Response): Observable<GetLkAllocListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkAllocListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkAllocListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkAllocDropdown(): Observable<GetLkAllocDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkAlloc/GetLkAllocDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkAllocDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkAllocDropdown(response_);
                } catch (e) {
                    return <Observable<GetLkAllocDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkAllocDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkAllocDropdown(response: Response): Observable<GetLkAllocDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkAllocDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkAllocDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkAllocAJBDropdown(): Observable<GetLkAllocDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkAlloc/GetLkAllocAJBDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkAllocAJBDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkAllocAJBDropdown(response_);
                } catch (e) {
                    return <Observable<GetLkAllocDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkAllocDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkAllocAJBDropdown(response: Response): Observable<GetLkAllocDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkAllocDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkAllocDropdownListDto[]>(<any>null);
    }
}

@Injectable()
export class PaymentLkMappingTaxServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLkMappingTax(): Observable<CreateOrUpdateLkMappingTaxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkMappingTax/GetAllLkMappingTax";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkMappingTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkMappingTax(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateLkMappingTaxDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateLkMappingTaxDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkMappingTax(response: Response): Observable<CreateOrUpdateLkMappingTaxDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateLkMappingTaxDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateLkMappingTaxDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createLkMappingTax(input: CreateOrUpdateLkMappingTaxDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkMappingTax/CreateLkMappingTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateLkMappingTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateLkMappingTax(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateLkMappingTax(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLkMappingTax(input: CreateOrUpdateLkMappingTaxDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkMappingTax/UpdateLkMappingTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLkMappingTax(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLkMappingTax(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLkMappingTax(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentLkOthersTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLkOthersType(input: CreateOrUpdateLkOthersTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkOthersType/CreateOrUpdateLkOthersType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLkOthersType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLkOthersType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLkOthersType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLkOthersType(): Observable<CreateOrUpdateLkOthersTypeInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkOthersType/GetAllLkOthersType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkOthersType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkOthersType(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateLkOthersTypeInputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateLkOthersTypeInputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkOthersType(response: Response): Observable<CreateOrUpdateLkOthersTypeInputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateLkOthersTypeInputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateLkOthersTypeInputDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkOthersTypeDropdownCheckRole(userID: number, payForID: number): Observable<DropdownLkOthersTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkOthersType/GetLkOthersTypeDropdownCheckRole?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (payForID === undefined || payForID === null)
            throw new Error("The parameter 'payForID' must be defined and cannot be null.");
        else
            url_ += "payForID=" + encodeURIComponent("" + payForID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkOthersTypeDropdownCheckRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkOthersTypeDropdownCheckRole(response_);
                } catch (e) {
                    return <Observable<DropdownLkOthersTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownLkOthersTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkOthersTypeDropdownCheckRole(response: Response): Observable<DropdownLkOthersTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownLkOthersTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownLkOthersTypeDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteRolesOthersType(input: CreateDeleteSysRolesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkOthersType/CreateDeleteRolesOthersType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteRolesOthersType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteRolesOthersType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteRolesOthersType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentLkPayForServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLkPayFor(input: CreateOrUpdateLkPayForInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/CreateOrUpdateLkPayFor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLkPayFor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLkPayFor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLkPayFor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLkPayFor(): Observable<CreateOrUpdateLkPayForInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/GetAllLkPayFor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkPayFor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkPayFor(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateLkPayForInputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateLkPayForInputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkPayFor(response: Response): Observable<CreateOrUpdateLkPayForInputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateLkPayForInputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateLkPayForInputDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    lkPayForDropdown(): Observable<DropdownLkPayForDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/LkPayForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLkPayForDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLkPayForDropdown(response_);
                } catch (e) {
                    return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(response_);
        });
    }

    protected processLkPayForDropdown(response: Response): Observable<DropdownLkPayForDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownLkPayForDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownLkPayForDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    lkPayForDropdownCheckRole(userID: number, flag: boolean): Observable<DropdownLkPayForDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/LkPayForDropdownCheckRole?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLkPayForDropdownCheckRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLkPayForDropdownCheckRole(response_);
                } catch (e) {
                    return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(response_);
        });
    }

    protected processLkPayForDropdownCheckRole(response: Response): Observable<DropdownLkPayForDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownLkPayForDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownLkPayForDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    lkPayForDropdownUnknown(): Observable<DropdownLkPayForDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/LkPayForDropdownUnknown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLkPayForDropdownUnknown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLkPayForDropdownUnknown(response_);
                } catch (e) {
                    return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownLkPayForDto[]>><any>Observable.throw(response_);
        });
    }

    protected processLkPayForDropdownUnknown(response: Response): Observable<DropdownLkPayForDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownLkPayForDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownLkPayForDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteRolesPayFor(input: CreateDeleteSysRolesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayFor/CreateDeleteRolesPayFor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteRolesPayFor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteRolesPayFor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteRolesPayFor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentLkPayTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLkPayType(input: CreateOrUpdateLkPayTypeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayType/CreateOrUpdateLkPayType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLkPayType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLkPayType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLkPayType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLkPayType(): Observable<CreateOrUpdateLkPayTypeInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayType/GetAllLkPayType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllLkPayType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllLkPayType(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateLkPayTypeInputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateLkPayTypeInputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllLkPayType(response: Response): Observable<CreateOrUpdateLkPayTypeInputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateLkPayTypeInputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateLkPayTypeInputDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkPayTypeDropdown(): Observable<DropdownPayTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayType/GetLkPayTypeDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkPayTypeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkPayTypeDropdown(response_);
                } catch (e) {
                    return <Observable<DropdownPayTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownPayTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkPayTypeDropdown(response: Response): Observable<DropdownPayTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownPayTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownPayTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkPayTypeDropdownCheckRole(userID: number, flag: boolean): Observable<DropdownPayTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayType/GetLkPayTypeDropdownCheckRole?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkPayTypeDropdownCheckRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkPayTypeDropdownCheckRole(response_);
                } catch (e) {
                    return <Observable<DropdownPayTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownPayTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkPayTypeDropdownCheckRole(response: Response): Observable<DropdownPayTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownPayTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownPayTypeDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDeleteRolesPayType(input: CreateDeleteSysRolesInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentLkPayType/CreateDeleteRolesPayType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDeleteRolesPayType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDeleteRolesPayType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDeleteRolesPayType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentMidtransHelperServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    validateResponseStatus(input: PaymentOnlineBookingResponse): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMidtransHelper/ValidateResponseStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateResponseStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateResponseStatus(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processValidateResponseStatus(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    validateResponseToken(input: RequestTokenResultDto): Observable<RequestTokenResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMidtransHelper/ValidateResponseToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateResponseToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateResponseToken(response_);
                } catch (e) {
                    return <Observable<RequestTokenResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RequestTokenResultDto>><any>Observable.throw(response_);
        });
    }

    protected processValidateResponseToken(response: Response): Observable<RequestTokenResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestTokenResultDto.fromJS(resultData200) : new RequestTokenResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RequestTokenResultDto>(<any>null);
    }
}

@Injectable()
export class PaymentMsAccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMsAccount(): Observable<GetMsAccountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMsAccount/GetAllMsAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsAccount(response_);
                } catch (e) {
                    return <Observable<GetMsAccountListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsAccountListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsAccount(response: Response): Observable<GetMsAccountListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsAccountListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsAccountListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMsAccountDetail(id: number): Observable<GetDetailMsAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMsAccount/GetMsAccountDetail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsAccountDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsAccountDetail(response_);
                } catch (e) {
                    return <Observable<GetDetailMsAccountListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailMsAccountListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsAccountDetail(response: Response): Observable<GetDetailMsAccountListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailMsAccountListDto.fromJS(resultData200) : new GetDetailMsAccountListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailMsAccountListDto>(<any>null);
    }

    /**
     * @return Success
     */
    msAccountDropdown(): Observable<DropdownMsAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMsAccount/MsAccountDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMsAccountDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMsAccountDropdown(response_);
                } catch (e) {
                    return <Observable<DropdownMsAccountDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownMsAccountDto[]>><any>Observable.throw(response_);
        });
    }

    protected processMsAccountDropdown(response: Response): Observable<DropdownMsAccountDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownMsAccountDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownMsAccountDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsAccount(input: UpdateMsAccountInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMsAccount/UpdateMsAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentOBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @projectID (optional) 
     * @return Success
     */
    createPayment(input: PaymentOnlineBookingRequest, projectID: number): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/CreatePayment?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePayment(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processCreatePayment(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @projectID (optional) 
     * @return Success
     */
    createPaymentLite(input: PaymentOnlineBookingRequest, projectID: number): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/CreatePaymentLite?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentLite(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentLite(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentLite(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    requestToken(input: RequestTokenInputDto): Observable<RequestTokenResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/RequestToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRequestToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRequestToken(response_);
                } catch (e) {
                    return <Observable<RequestTokenResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<RequestTokenResultDto>><any>Observable.throw(response_);
        });
    }

    protected processRequestToken(response: Response): Observable<RequestTokenResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestTokenResultDto.fromJS(resultData200) : new RequestTokenResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RequestTokenResultDto>(<any>null);
    }

    /**
     * @orderCode (optional) 
     * @return Success
     */
    checkPaymentStatus(orderCode: string): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/CheckPaymentStatus?";
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckPaymentStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckPaymentStatus(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processCheckPaymentStatus(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkPaymentStatusMobile(input: CheckPaymentStatusInputDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/CheckPaymentStatusMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckPaymentStatusMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckPaymentStatusMobile(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processCheckPaymentStatusMobile(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @data (optional) 
     * @return Success
     */
    paymentNotification(data: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/PaymentNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPaymentNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @data (optional) 
     * @return Success
     */
    paymentError(data: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOB/PaymentError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPaymentError(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPaymentError(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPaymentError(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentOnlineServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    orderPaymentIpay88(input: OrderPaymentMidInputDto): Observable<DoBookingIPay88RequestResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOnline/OrderPaymentIpay88";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOrderPaymentIpay88(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOrderPaymentIpay88(response_);
                } catch (e) {
                    return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DoBookingIPay88RequestResultDto>><any>Observable.throw(response_);
        });
    }

    protected processOrderPaymentIpay88(response: Response): Observable<DoBookingIPay88RequestResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoBookingIPay88RequestResultDto.fromJS(resultData200) : new DoBookingIPay88RequestResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DoBookingIPay88RequestResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    orderPaymentMidtrans(input: OrderPaymentMidInputDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOnline/OrderPaymentMidtrans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processOrderPaymentMidtrans(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processOrderPaymentMidtrans(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processOrderPaymentMidtrans(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @return Success
     */
    generateOrderCodePayment(projectID: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOnline/GenerateOrderCodePayment?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateOrderCodePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateOrderCodePayment(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateOrderCodePayment(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    processPayment(input: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentOnline/ProcessPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessPayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PaymentPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListPaymentType(): Observable<GetListPaymentTypeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListPaymentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPaymentType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPaymentType(response_);
                } catch (e) {
                    return <Observable<GetListPaymentTypeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPaymentTypeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPaymentType(response: Response): Observable<GetListPaymentTypeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPaymentTypeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPaymentTypeResultDto[]>(<any>null);
    }

    /**
     * @userName (optional) 
     * @return Success
     */
    getListProject(userName: string): Observable<GetListProjectResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListProject?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProject(response_);
                } catch (e) {
                    return <Observable<GetListProjectResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProject(response: Response): Observable<GetListProjectResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectMapping(): Observable<GetListProjectResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListProjectMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectMapping(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectMapping(response_);
                } catch (e) {
                    return <Observable<GetListProjectResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProjectResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectMapping(response: Response): Observable<GetListProjectResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProjectResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProjectResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getListPaymentHistory(input: GetListPaymentHistoryInputDto): Observable<GetListHistoryPaymentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListPaymentHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPaymentHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPaymentHistory(response_);
                } catch (e) {
                    return <Observable<GetListHistoryPaymentResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListHistoryPaymentResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPaymentHistory(response: Response): Observable<GetListHistoryPaymentResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListHistoryPaymentResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListHistoryPaymentResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListOrderStatus(): Observable<GetLIstOrderStatusResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListOrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListOrderStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListOrderStatus(response_);
                } catch (e) {
                    return <Observable<GetLIstOrderStatusResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLIstOrderStatusResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListOrderStatus(response: Response): Observable<GetLIstOrderStatusResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLIstOrderStatusResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLIstOrderStatusResultDto[]>(<any>null);
    }

    /**
     * @customerName (optional) 
     * @qty (optional) 
     * @return Success
     */
    getDetailPaymentInfo(customerName: string, qty: string, paymentID: number, pPOrderID: number): Observable<GetDetailPaymentInfoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetDetailPaymentInfo?";
        if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (qty !== undefined)
            url_ += "qty=" + encodeURIComponent("" + qty) + "&"; 
        if (paymentID === undefined || paymentID === null)
            throw new Error("The parameter 'paymentID' must be defined and cannot be null.");
        else
            url_ += "paymentID=" + encodeURIComponent("" + paymentID) + "&"; 
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPaymentInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPaymentInfo(response_);
                } catch (e) {
                    return <Observable<GetDetailPaymentInfoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPaymentInfoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPaymentInfo(response: Response): Observable<GetDetailPaymentInfoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPaymentInfoResultDto.fromJS(resultData200) : new GetDetailPaymentInfoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPaymentInfoResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTTBFPP(input: ListTTBFInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GenerateTTBFPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTTBFPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateTTBFPP(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTTBFPP(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getListDropdownBank(): Observable<GetListDropdownBankResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListDropdownBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDropdownBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDropdownBank(response_);
                } catch (e) {
                    return <Observable<GetListDropdownBankResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListDropdownBankResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDropdownBank(response: Response): Observable<GetListDropdownBankResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListDropdownBankResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListDropdownBankResultDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @orderCode (optional) 
     * @customerName (optional) 
     * @return Success
     */
    getListPaymentCheck(projectID: number, orderCode: string, customerName: string): Observable<GetListPaymentCheckResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetListPaymentCheck?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPaymentCheck(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPaymentCheck(response_);
                } catch (e) {
                    return <Observable<GetListPaymentCheckResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListPaymentCheckResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListPaymentCheck(response: Response): Observable<GetListPaymentCheckResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListPaymentCheckResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListPaymentCheckResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateBarcode(input: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GenerateBarcode?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateBarcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateBarcode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateBarcode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getReportPayment(input: GetReportPaymentInputDto): Observable<GetReportPaymentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetReportPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReportPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReportPayment(response_);
                } catch (e) {
                    return <Observable<GetReportPaymentResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetReportPaymentResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetReportPayment(response: Response): Observable<GetReportPaymentResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetReportPaymentResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetReportPaymentResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportPaymentPdf(input: GetPaymentReportPdfInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GenerateReportPaymentPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportPaymentPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportPaymentPdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportPaymentPdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportOrder(input: GetPaymentReportPdfInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GenerateExcelReportOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportOrder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportOrder(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportOrder(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCheckboxDisplayedFieldPayment(): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentPP/GetCheckboxDisplayedFieldPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckboxDisplayedFieldPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckboxDisplayedFieldPayment(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckboxDisplayedFieldPayment(response: Response): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultDto[]>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllPermissions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPermissions(response: Response): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class PindahUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataUnitLama(unitCode: string, unitNo: string): Observable<GetDataUnitLamaListDto> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetDataUnitLama?";
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataUnitLama(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataUnitLama(response_);
                } catch (e) {
                    return <Observable<GetDataUnitLamaListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataUnitLamaListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataUnitLama(response: Response): Observable<GetDataUnitLamaListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataUnitLamaListDto.fromJS(resultData200) : new GetDataUnitLamaListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataUnitLamaListDto>(<any>null);
    }

    /**
     * @unitCodeLama (optional) 
     * @unitNoLama (optional) 
     * @bookCode (optional) 
     * @customer (optional) 
     * @unitCodeBaru (optional) 
     * @unitNoBaru (optional) 
     * @return Success
     */
    getDataKonfirmasiPindahUnit(clusterID: number, unitIDBaru: number, unitIDLama: number, unitCodeLama: string, unitNoLama: string, bookCode: string, customer: string, unitCodeBaru: string, unitNoBaru: string, bookingHeaderID: number, projectID: number): Observable<GetDataUnitBaruListDto> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetDataKonfirmasiPindahUnit?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (unitIDBaru === undefined || unitIDBaru === null)
            throw new Error("The parameter 'unitIDBaru' must be defined and cannot be null.");
        else
            url_ += "unitIDBaru=" + encodeURIComponent("" + unitIDBaru) + "&"; 
        if (unitIDLama === undefined || unitIDLama === null)
            throw new Error("The parameter 'unitIDLama' must be defined and cannot be null.");
        else
            url_ += "unitIDLama=" + encodeURIComponent("" + unitIDLama) + "&"; 
        if (unitCodeLama !== undefined)
            url_ += "unitCodeLama=" + encodeURIComponent("" + unitCodeLama) + "&"; 
        if (unitNoLama !== undefined)
            url_ += "unitNoLama=" + encodeURIComponent("" + unitNoLama) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (customer !== undefined)
            url_ += "customer=" + encodeURIComponent("" + customer) + "&"; 
        if (unitCodeBaru !== undefined)
            url_ += "unitCodeBaru=" + encodeURIComponent("" + unitCodeBaru) + "&"; 
        if (unitNoBaru !== undefined)
            url_ += "unitNoBaru=" + encodeURIComponent("" + unitNoBaru) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataKonfirmasiPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataKonfirmasiPindahUnit(response_);
                } catch (e) {
                    return <Observable<GetDataUnitBaruListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataUnitBaruListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataKonfirmasiPindahUnit(response: Response): Observable<GetDataUnitBaruListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataUnitBaruListDto.fromJS(resultData200) : new GetDataUnitBaruListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataUnitBaruListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getClusterDropdownPindahUnit(): Observable<GetClusterDropdownPindahUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetClusterDropdownPindahUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterDropdownPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterDropdownPindahUnit(response_);
                } catch (e) {
                    return <Observable<GetClusterDropdownPindahUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetClusterDropdownPindahUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterDropdownPindahUnit(response: Response): Observable<GetClusterDropdownPindahUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetClusterDropdownPindahUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetClusterDropdownPindahUnitListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitCodePindahUnit(clusterID: number): Observable<GetUnitCodeDropdownPindahUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetUnitCodePindahUnit?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitCodePindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitCodePindahUnit(response_);
                } catch (e) {
                    return <Observable<GetUnitCodeDropdownPindahUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitCodeDropdownPindahUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitCodePindahUnit(response: Response): Observable<GetUnitCodeDropdownPindahUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitCodeDropdownPindahUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitCodeDropdownPindahUnitListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitNoPindahUnit(unitCodeID: number, clusterID: number): Observable<GetUnitNoPindahUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetUnitNoPindahUnit?";
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitNoPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitNoPindahUnit(response_);
                } catch (e) {
                    return <Observable<GetUnitNoPindahUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitNoPindahUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitNoPindahUnit(response: Response): Observable<GetUnitNoPindahUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetUnitNoPindahUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitNoPindahUnitListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    pindahUnitSave(input: PindahUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/PindahUnitSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPindahUnitSave(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPindahUnitSave(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPindahUnitSave(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateKpPindahUnit(input: PindahUnitInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GenerateKpPindahUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateKpPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateKpPindahUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateKpPindahUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateAmandementPindahUnit(input: GenerateAmandementInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GenerateAmandementPindahUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateAmandementPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateAmandementPindahUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateAmandementPindahUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @bookCode (optional) 
     * @return Success
     */
    getUrlAmandementPindahUnit(docNo: string, bookCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PindahUnit/GetUrlAmandementPindahUnit?";
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUrlAmandementPindahUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUrlAmandementPindahUnit(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetUrlAmandementPindahUnit(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class PreviewUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTypePreviewUnit(projectId: number, clusterId: number): Observable<TypePreviewUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PreviewUnit/GetTypePreviewUnit?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTypePreviewUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTypePreviewUnit(response_);
                } catch (e) {
                    return <Observable<TypePreviewUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TypePreviewUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTypePreviewUnit(response: Response): Observable<TypePreviewUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TypePreviewUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TypePreviewUnitResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPreviewUnit(projectId: number, clusterId: number): Observable<GetPreviewUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PreviewUnit/GetPreviewUnit?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreviewUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreviewUnit(response_);
                } catch (e) {
                    return <Observable<GetPreviewUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPreviewUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPreviewUnit(response: Response): Observable<GetPreviewUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPreviewUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPreviewUnitResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailPreviewUnit(unitID: number): Observable<ListDetailPreviewUnitResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PreviewUnit/GetDetailPreviewUnit?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPreviewUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPreviewUnit(response_);
                } catch (e) {
                    return <Observable<ListDetailPreviewUnitResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDetailPreviewUnitResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPreviewUnit(response: Response): Observable<ListDetailPreviewUnitResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListDetailPreviewUnitResultDto.fromJS(resultData200) : new ListDetailPreviewUnitResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDetailPreviewUnitResultDto>(<any>null);
    }
}

@Injectable()
export class PricePerClusterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePricingManual(input: UpdatePricePerClusterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PricePerCluster/UpdatePricingManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePricingManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePricingManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePricingManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePricingBySystem(input: UpdatePricePerClusterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PricePerCluster/UpdatePricingBySystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePricingBySystem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePricingBySystem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePricingBySystem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePricingPerCluster(input: UpdatePricePerClusterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PricePerCluster/UpdatePricingPerCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePricingPerCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePricingPerCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePricingPerCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PricePerUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTotalDataReturned(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PricePerUnit/GetTotalDataReturned";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTotalDataReturned(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTotalDataReturned(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetTotalDataReturned(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDataTaskList(projectId: number, clusterId: number, termMainId: number): Observable<GetDataTaskListResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PricePerUnit/GetDataTaskList?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (termMainId === undefined || termMainId === null)
            throw new Error("The parameter 'termMainId' must be defined and cannot be null.");
        else
            url_ += "termMainId=" + encodeURIComponent("" + termMainId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataTaskList(response_);
                } catch (e) {
                    return <Observable<GetDataTaskListResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataTaskListResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataTaskList(response: Response): Observable<GetDataTaskListResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataTaskListResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataTaskListResultDto[]>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getDataToUpdate(unitId: number, renovId: number, termId: number[]): Observable<GetDataToUpdateResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PricePerUnit/GetDataToUpdate?";
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined and cannot be null.");
        else
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        if (renovId === undefined || renovId === null)
            throw new Error("The parameter 'renovId' must be defined and cannot be null.");
        else
            url_ += "renovId=" + encodeURIComponent("" + renovId) + "&"; 
        if (termId !== undefined)
            termId && termId.forEach(item => { url_ += "termId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataToUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataToUpdate(response_);
                } catch (e) {
                    return <Observable<GetDataToUpdateResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataToUpdateResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataToUpdate(response: Response): Observable<GetDataToUpdateResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataToUpdateResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataToUpdateResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateGrossPricePerUnit(input: UpdatePricePerUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PricePerUnit/UpdateGrossPricePerUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGrossPricePerUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateGrossPricePerUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGrossPricePerUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRenovDropDown(projectId: number): Observable<GetRenovationDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PricePerUnit/GetRenovDropDown?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRenovDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRenovDropDown(response_);
                } catch (e) {
                    return <Observable<GetRenovationDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRenovationDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRenovDropDown(response: Response): Observable<GetRenovationDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRenovationDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRenovationDropdownListDto[]>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentUserProfileForEdit(response: Response): Observable<CurrentUserProfileEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGoogleAuthenticatorKey(response: Response): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendVerificationSms(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendVerificationSms(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifySmsCode(input: VerifySmsCodeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifySmsCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processVerifySmsCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCurrentUserProfile(input: CurrentUserProfileEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCurrentUserProfile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCurrentUserProfile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangePassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangePassword(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangePassword(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProfilePicture(input: UpdateProfilePictureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProfilePicture(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProfilePicture(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPasswordComplexitySetting(response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPasswordComplexitySetting(response: Response): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePicture(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePicture(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string, userId: number, tenantId: number): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFriendProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFriendProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePictureById(profilePictureId: string): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === undefined || profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' must be defined and cannot be null.");
        else
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ProjectServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getListPromotion(projectID: number): Observable<ListResultDtoOfGetListPromotionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListPromotion?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListPromotion(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListPromotionResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListPromotionResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListPromotion(response: Response): Observable<ListResultDtoOfGetListPromotionResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListPromotionResultDto.fromJS(resultData200) : new ListResultDtoOfGetListPromotionResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListPromotionResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllListPromotion(): Observable<GetAllListPromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetAllListPromotion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllListPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllListPromotion(response_);
                } catch (e) {
                    return <Observable<GetAllListPromotionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllListPromotionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllListPromotion(response: Response): Observable<GetAllListPromotionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllListPromotionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllListPromotionDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailListProject(projectId: number): Observable<DetailProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetDetailListProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailListProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailListProject(response_);
                } catch (e) {
                    return <Observable<DetailProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailListProject(response: Response): Observable<DetailProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DetailProjectResultDto.fromJS(resultData200) : new DetailProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAbsoluteUri(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Project/getAbsoluteUri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAbsoluteUri(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAbsoluteUri(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAbsoluteUri(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getListProject(memberCode: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProject?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProject(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProject(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @priceMin (optional) 
     * @priceMax (optional) 
     * @bedroomMin (optional) 
     * @bedroomMax (optional) 
     * @areaMin (optional) 
     * @areaMax (optional) 
     * @clusterName (optional) 
     * @memberCode (optional) 
     * @clusterId (optional) 
     * @regionName (optional) 
     * @checkBoxFacing (optional) 
     * @productName (optional) 
     * @searchBox (optional) 
     * @return Success
     */
    getListProjectByAdvancedFilter(projectId: number, priceMin: number, priceMax: number, bedroomMin: number, bedroomMax: number, areaMin: number, areaMax: number, clusterName: string, memberCode: string, clusterId: number, regionName: string, checkBoxFacing: number[], productName: string, searchBox: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectByAdvancedFilter?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (priceMin !== undefined)
            url_ += "priceMin=" + encodeURIComponent("" + priceMin) + "&"; 
        if (priceMax !== undefined)
            url_ += "priceMax=" + encodeURIComponent("" + priceMax) + "&"; 
        if (bedroomMin !== undefined)
            url_ += "bedroomMin=" + encodeURIComponent("" + bedroomMin) + "&"; 
        if (bedroomMax !== undefined)
            url_ += "bedroomMax=" + encodeURIComponent("" + bedroomMax) + "&"; 
        if (areaMin !== undefined)
            url_ += "areaMin=" + encodeURIComponent("" + areaMin) + "&"; 
        if (areaMax !== undefined)
            url_ += "areaMax=" + encodeURIComponent("" + areaMax) + "&"; 
        if (clusterName !== undefined)
            url_ += "clusterName=" + encodeURIComponent("" + clusterName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (regionName !== undefined)
            url_ += "regionName=" + encodeURIComponent("" + regionName) + "&"; 
        if (checkBoxFacing !== undefined)
            checkBoxFacing && checkBoxFacing.forEach(item => { url_ += "checkBoxFacing=" + encodeURIComponent("" + item) + "&"; });
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectByAdvancedFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectByAdvancedFilter(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectByAdvancedFilter(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsFacingDropdownProjectApp(): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetMsFacingDropdownProjectApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsFacingDropdownProjectApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsFacingDropdownProjectApp(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetFacingDropdownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsFacingDropdownProjectApp(response: Response): Observable<ListResultDtoOfGetFacingDropdownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetFacingDropdownListDto.fromJS(resultData200) : new ListResultDtoOfGetFacingDropdownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetFacingDropdownListDto>(<any>null);
    }

    /**
     * @membercode (optional) 
     * @return Success
     */
    getChildMemberCode(membercode: string): Observable<GetChildMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetChildMemberCode?";
        if (membercode !== undefined)
            url_ += "membercode=" + encodeURIComponent("" + membercode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChildMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChildMemberCode(response_);
                } catch (e) {
                    return <Observable<GetChildMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetChildMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetChildMemberCode(response: Response): Observable<GetChildMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetChildMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetChildMemberCodeDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @membercode (optional) 
     * @return Success
     */
    getListMemberCode(projectID: number, membercode: string): Observable<GetListMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListMemberCode?";
        if (projectID !== undefined)
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (membercode !== undefined)
            url_ += "Membercode=" + encodeURIComponent("" + membercode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListMemberCode(response_);
                } catch (e) {
                    return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListMemberCode(response: Response): Observable<GetListMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMemberCodeDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @currentUser (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getMemberCodeDropdown(projectID: number, currentUser: string, memberCode: string): Observable<GetListMemberCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetMemberCodeDropdown?";
        if (projectID !== undefined)
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (currentUser !== undefined)
            url_ += "currentUser=" + encodeURIComponent("" + currentUser) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberCodeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMemberCodeDropdown(response_);
                } catch (e) {
                    return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListMemberCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberCodeDropdown(response: Response): Observable<GetListMemberCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListMemberCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListMemberCodeDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getListProjectDiagramatic(memberCode: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectDiagramatic?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectDiagramatic(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectDiagramatic(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @parentProjectName (optional) 
     * @return Success
     */
    getListProjectDevCityDiagramatic(memberCode: string, parentProjectName: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectDevCityDiagramatic?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (parentProjectName !== undefined)
            url_ += "parentProjectName=" + encodeURIComponent("" + parentProjectName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectDevCityDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectDevCityDiagramatic(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectDevCityDiagramatic(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getListDevelopmentCityDiagramatic(memberCode: string): Observable<ListResultDtoOfListDevelopmentCityResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListDevelopmentCityDiagramatic?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDevelopmentCityDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDevelopmentCityDiagramatic(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListDevelopmentCityResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListDevelopmentCityResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListDevelopmentCityDiagramatic(response: Response): Observable<ListResultDtoOfListDevelopmentCityResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListDevelopmentCityResultDto.fromJS(resultData200) : new ListResultDtoOfListDevelopmentCityResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListDevelopmentCityResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getListProjectBySchema(memberCode: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectBySchema?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectBySchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectBySchema(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectBySchema(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @searchBox (optional) 
     * @return Success
     */
    getListAllProduct(memberCode: string, searchBox: string): Observable<GetListProductResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListAllProduct?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAllProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAllProduct(response_);
                } catch (e) {
                    return <Observable<GetListProductResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListProductResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListAllProduct(response: Response): Observable<GetListProductResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListProductResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListProductResultDto[]>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @priceMin (optional) 
     * @priceMax (optional) 
     * @bedroomMin (optional) 
     * @bedroomMax (optional) 
     * @areaMin (optional) 
     * @areaMax (optional) 
     * @clusterName (optional) 
     * @memberCode (optional) 
     * @clusterId (optional) 
     * @regionName (optional) 
     * @checkBoxFacing (optional) 
     * @productName (optional) 
     * @searchBox (optional) 
     * @return Success
     */
    getListProductByAdvancedFilter(projectId: number, priceMin: number, priceMax: number, bedroomMin: number, bedroomMax: number, areaMin: number, areaMax: number, clusterName: string, memberCode: string, clusterId: number, regionName: string, checkBoxFacing: number[], productName: string, searchBox: string): Observable<ListResultDtoOfListProductResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProductByAdvancedFilter?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (priceMin !== undefined)
            url_ += "priceMin=" + encodeURIComponent("" + priceMin) + "&"; 
        if (priceMax !== undefined)
            url_ += "priceMax=" + encodeURIComponent("" + priceMax) + "&"; 
        if (bedroomMin !== undefined)
            url_ += "bedroomMin=" + encodeURIComponent("" + bedroomMin) + "&"; 
        if (bedroomMax !== undefined)
            url_ += "bedroomMax=" + encodeURIComponent("" + bedroomMax) + "&"; 
        if (areaMin !== undefined)
            url_ += "areaMin=" + encodeURIComponent("" + areaMin) + "&"; 
        if (areaMax !== undefined)
            url_ += "areaMax=" + encodeURIComponent("" + areaMax) + "&"; 
        if (clusterName !== undefined)
            url_ += "clusterName=" + encodeURIComponent("" + clusterName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (regionName !== undefined)
            url_ += "regionName=" + encodeURIComponent("" + regionName) + "&"; 
        if (checkBoxFacing !== undefined)
            checkBoxFacing && checkBoxFacing.forEach(item => { url_ += "checkBoxFacing=" + encodeURIComponent("" + item) + "&"; });
        if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&"; 
        if (searchBox !== undefined)
            url_ += "searchBox=" + encodeURIComponent("" + searchBox) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProductByAdvancedFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProductByAdvancedFilter(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProductResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProductResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProductByAdvancedFilter(response: Response): Observable<ListResultDtoOfListProductResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProductResultDto.fromJS(resultData200) : new ListResultDtoOfListProductResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProductResultDto>(<any>null);
    }

    /**
     * @projectName (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getListProjectByName(projectName: string, memberCode: string): Observable<ListResultDtoOfListProjectResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectByName?";
        if (projectName !== undefined)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectByName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectByName(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectByName(response: Response): Observable<ListResultDtoOfListProjectResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectInfo(projectId: number): Observable<ListResultDtoOfListProjectInfoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectInfo?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectInfo(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectInfoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectInfoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectInfo(response: Response): Observable<ListResultDtoOfListProjectInfoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectInfoResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectInfoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectInfoResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectKeyFeatures(projectId: number): Observable<ListResultDtoOfListProjectKeyFeaturesResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectKeyFeatures?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectKeyFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectKeyFeatures(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectKeyFeaturesResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectKeyFeaturesResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectKeyFeatures(response: Response): Observable<ListResultDtoOfListProjectKeyFeaturesResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectKeyFeaturesResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectKeyFeaturesResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectKeyFeaturesResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectLocation(projectId: number): Observable<ListResultDtoOfListProjectLocationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectLocation?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectLocation(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectLocationResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectLocationResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectLocation(response: Response): Observable<ListResultDtoOfListProjectLocationResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectLocationResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectLocationResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectLocationResultDto>(<any>null);
    }

    /**
     * @clusterId (optional) 
     * @return Success
     */
    getUnitTypeByCluster(projectInfoId: number, clusterId: number): Observable<ListResultDtoOfListUnitTypeByClusterResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetUnitTypeByCluster?";
        if (projectInfoId === undefined || projectInfoId === null)
            throw new Error("The parameter 'projectInfoId' must be defined and cannot be null.");
        else
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        if (clusterId !== undefined)
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByCluster(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListUnitTypeByClusterResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListUnitTypeByClusterResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByCluster(response: Response): Observable<ListResultDtoOfListUnitTypeByClusterResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListUnitTypeByClusterResultDto.fromJS(resultData200) : new ListResultDtoOfListUnitTypeByClusterResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListUnitTypeByClusterResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitTypeByProjectId(projectId: number): Observable<ListResultDtoOfListUnitTypeByProjectIdResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetUnitTypeByProjectId?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitTypeByProjectId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitTypeByProjectId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListUnitTypeByProjectIdResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListUnitTypeByProjectIdResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitTypeByProjectId(response: Response): Observable<ListResultDtoOfListUnitTypeByProjectIdResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListUnitTypeByProjectIdResultDto.fromJS(resultData200) : new ListResultDtoOfListUnitTypeByProjectIdResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListUnitTypeByProjectIdResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListProjectImageGallery(projectID: number): Observable<ListResultDtoOfListProjectImageGalleryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetListProjectImageGallery?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListProjectImageGallery(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListProjectImageGallery(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfListProjectImageGalleryResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfListProjectImageGalleryResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetListProjectImageGallery(response: Response): Observable<ListResultDtoOfListProjectImageGalleryResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfListProjectImageGalleryResultDto.fromJS(resultData200) : new ListResultDtoOfListProjectImageGalleryResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfListProjectImageGalleryResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownClusterByProduct(projectInfoID: number): Observable<GetClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetDropdownClusterByProduct?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownClusterByProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownClusterByProduct(response_);
                } catch (e) {
                    return <Observable<GetClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownClusterByProduct(response: Response): Observable<GetClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetClusterListDto[]>(<any>null);
    }
}

@Injectable()
export class ProjectSchedulerSetupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @module (optional) 
     * @return Success
     */
    getDataSetup(module: string): Observable<ProjectSchedulerSetupDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectSchedulerSetup/GetDataSetup?";
        if (module !== undefined)
            url_ += "module=" + encodeURIComponent("" + module) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSetup(response_);
                } catch (e) {
                    return <Observable<ProjectSchedulerSetupDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProjectSchedulerSetupDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSetup(response: Response): Observable<ProjectSchedulerSetupDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectSchedulerSetupDto.fromJS(resultData200) : new ProjectSchedulerSetupDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProjectSchedulerSetupDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveOrUpdate(input: ProjectSchedulerSetupDto): Observable<ProjectSchedulerSetupResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProjectSchedulerSetup/SaveOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveOrUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveOrUpdate(response_);
                } catch (e) {
                    return <Observable<ProjectSchedulerSetupResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProjectSchedulerSetupResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSaveOrUpdate(response: Response): Observable<ProjectSchedulerSetupResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProjectSchedulerSetupResultDto.fromJS(resultData200) : new ProjectSchedulerSetupResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProjectSchedulerSetupResultDto>(<any>null);
    }
}

@Injectable()
export class PromotionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTasklistPromotion(): Observable<GetTasklistPromotionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetTasklistPromotion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistPromotion(response_);
                } catch (e) {
                    return <Observable<GetTasklistPromotionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistPromotionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistPromotion(response: Response): Observable<GetTasklistPromotionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistPromotionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistPromotionDto[]>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @notifTypeCode (optional) 
     * @return Success
     */
    getDetailPromotion(projectId: number[], notifTypeCode: string): Observable<GetDetailPromotionDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetDetailPromotion?";
        if (projectId !== undefined)
            projectId && projectId.forEach(item => { url_ += "projectId=" + encodeURIComponent("" + item) + "&"; });
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPromotion(response_);
                } catch (e) {
                    return <Observable<GetDetailPromotionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPromotionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPromotion(response: Response): Observable<GetDetailPromotionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPromotionDto.fromJS(resultData200) : new GetDetailPromotionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPromotionDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPromotion(input: CreatePromotionInputDto): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/CreatePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePromotion(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processCreatePromotion(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @update (optional) 
     * @return Success
     */
    updatePromotion(update: UpdatePromotionInputDto): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdatePromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotion(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotion(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @projectId (optional) 
     * @notifTypeCode (optional) 
     * @return Success
     */
    updateIsActivePromotion(projectId: number[], notifTypeCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdateIsActivePromotion?";
        if (notifTypeCode !== undefined)
            url_ += "notifTypeCode=" + encodeURIComponent("" + notifTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectId);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActivePromotion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActivePromotion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActivePromotion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropDownNotifType(): Observable<GetDropDownNotifTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/GetDropDownNotifType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownNotifType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownNotifType(response_);
                } catch (e) {
                    return <Observable<GetDropDownNotifTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownNotifTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownNotifType(response: Response): Observable<GetDropDownNotifTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDropDownNotifTypeDto.fromJS(resultData200) : new GetDropDownNotifTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownNotifTypeDto>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    removeFileFromTemp(filename: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/RemoveFileFromTemp?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFileFromTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveFileFromTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFileFromTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateIsActiveExpiredPromotionScheduller(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdateIsActiveExpiredPromotionScheduller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActiveExpiredPromotionScheduller(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActiveExpiredPromotionScheduller(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActiveExpiredPromotionScheduller(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updatePromotionImage(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Promotion/UpdatePromotionImage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePromotionImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePromotionImage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePromotionImage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASAccountStatementServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @value (optional) 
     * @flag (optional) 
     * @return Success
     */
    getAccountStatementToExportListOneAll(value: string, flag: string, projectID: number): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASAccountStatement/GetAccountStatementToExportListOneAll?";
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAccountStatementToExportListOneAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAccountStatementToExportListOneAll(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAccountStatementToExportListOneAll(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailAccountStatementScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAccountStatement/SendEmailAccountStatementScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAccountStatementScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAccountStatementScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAccountStatementScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    sendEmailAccountStatementByBookCode(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAccountStatement/SendEmailAccountStatementByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAccountStatementByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAccountStatementByBookCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAccountStatementByBookCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    sendEmailAccountStatementByPsCode(psCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAccountStatement/SendEmailAccountStatementByPsCode?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAccountStatementByPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAccountStatementByPsCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAccountStatementByPsCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCodeList (optional) 
     * @return Success
     */
    sendEmailAccountStatementByPsCodeList(psCodeList: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAccountStatement/SendEmailAccountStatementByPsCodeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(psCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAccountStatementByPsCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAccountStatementByPsCodeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAccountStatementByPsCodeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASAddjustmentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDropdownItem(bookCode: string): Observable<GetDropdownItemResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASAddjustment/GetDropdownItem?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownItem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownItem(response_);
                } catch (e) {
                    return <Observable<GetDropdownItemResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownItemResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownItem(response: Response): Observable<GetDropdownItemResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownItemResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownItemResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateAddjustment(input: CreateUpdateAddjustmentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAddjustment/CreateUpdateAddjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateAddjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateAddjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateAddjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailUpdateAddjustmentArea(input: GetPSASParamsSendEamailAdjAreaDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAddjustment/SendEmailUpdateAddjustmentArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailUpdateAddjustmentArea(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailUpdateAddjustmentArea(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailUpdateAddjustmentArea(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getListAddjustment(bookCode: string): Observable<GetListAddjustmentResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASAddjustment/GetListAddjustment?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListAddjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListAddjustment(response_);
                } catch (e) {
                    return <Observable<GetListAddjustmentResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListAddjustmentResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListAddjustment(response: Response): Observable<GetListAddjustmentResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListAddjustmentResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListAddjustmentResultDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    deleteAddjustment(addjustmentId: number, bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASAddjustment/DeleteAddjustment?";
        if (addjustmentId === undefined || addjustmentId === null)
            throw new Error("The parameter 'addjustmentId' must be defined and cannot be null.");
        else
            url_ += "addjustmentId=" + encodeURIComponent("" + addjustmentId) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAddjustment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAddjustment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAddjustment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASBookingDocumentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFilePPPULampiranID(bookingDocumentID: number, bookCode: string, addendumDocumentID: number, lampiranID: number): Observable<GetFilePPPUListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFilePPPULampiranID?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (addendumDocumentID === undefined || addendumDocumentID === null)
            throw new Error("The parameter 'addendumDocumentID' must be defined and cannot be null.");
        else
            url_ += "addendumDocumentID=" + encodeURIComponent("" + addendumDocumentID) + "&"; 
        if (lampiranID === undefined || lampiranID === null)
            throw new Error("The parameter 'lampiranID' must be defined and cannot be null.");
        else
            url_ += "lampiranID=" + encodeURIComponent("" + lampiranID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFilePPPULampiranID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFilePPPULampiranID(response_);
                } catch (e) {
                    return <Observable<GetFilePPPUListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFilePPPUListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFilePPPULampiranID(response: Response): Observable<GetFilePPPUListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFilePPPUListDto.fromJS(resultData200) : new GetFilePPPUListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFilePPPUListDto>(<any>null);
    }

    /**
     * @paramList (optional) 
     * @return Success
     */
    sendEmailAJBList(paramList: SendEmailAJBParamList[]): Observable<SendEmailAJBResult> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendEmailAJBList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paramList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAJBList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAJBList(response_);
                } catch (e) {
                    return <Observable<SendEmailAJBResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<SendEmailAJBResult>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAJBList(response: Response): Observable<SendEmailAJBResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendEmailAJBResult.fromJS(resultData200) : new SendEmailAJBResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SendEmailAJBResult>(<any>null);
    }

    /**
     * @generatedData (optional) 
     * @return Success
     */
    sendEmailPPPU(generatedData: P32DocumentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendEmailPPPU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generatedData);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailPPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailPPPU(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailPPPU(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @docCode (optional) 
     * @return Success
     */
    sendEmailAJB(bookingDocID: number, docCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendEmailAJB?";
        if (bookingDocID === undefined || bookingDocID === null)
            throw new Error("The parameter 'bookingDocID' must be defined and cannot be null.");
        else
            url_ += "bookingDocID=" + encodeURIComponent("" + bookingDocID) + "&"; 
        if (docCode !== undefined)
            url_ += "docCode=" + encodeURIComponent("" + docCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailAJB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailAJB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getBookingDocument(bookCode: string, unitCode: string, unitNo: string): Observable<GetBookingDocumentListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetBookingDocument?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingDocument(response_);
                } catch (e) {
                    return <Observable<GetBookingDocumentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBookingDocumentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingDocument(response: Response): Observable<GetBookingDocumentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetBookingDocumentListDto.fromJS(resultData200) : new GetBookingDocumentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetBookingDocumentListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPlafondBookingDocument(bookCode: string, unitCode: string, unitNo: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetPlafondBookingDocument?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPlafondBookingDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPlafondBookingDocument(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetPlafondBookingDocument(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createBookingDocument(input: CreateBookingDocumentInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CreateBookingDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateBookingDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateBookingDocument(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateBookingDocument(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDocumentAMD(input: CreateBookingDocumentInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CreateDocumentAMD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDocumentAMD(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDocumentAMD(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreateDocumentAMD(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDocumentBAST(input: CreateBookingDocumentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CreateDocumentBAST";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDocumentBAST(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDocumentBAST(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDocumentBAST(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @docCode (optional) 
     * @return Success
     */
    sendEmailUNST(bookingDocID: number, docCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendEmailUNST?";
        if (bookingDocID === undefined || bookingDocID === null)
            throw new Error("The parameter 'bookingDocID' must be defined and cannot be null.");
        else
            url_ += "bookingDocID=" + encodeURIComponent("" + bookingDocID) + "&"; 
        if (docCode !== undefined)
            url_ += "docCode=" + encodeURIComponent("" + docCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailUNST(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailUNST(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailUNST(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadTandaTerima(input: UpdateBookingDocumentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/UploadTandaTerima";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadTandaTerima(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadTandaTerima(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadTandaTerima(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @return Success
     */
    counterDocNo(projectID: number, docID: number, coID: number, docNo: string): Observable<CounterDocNoListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CounterDocNo?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        if (coID === undefined || coID === null)
            throw new Error("The parameter 'coID' must be defined and cannot be null.");
        else
            url_ += "coID=" + encodeURIComponent("" + coID) + "&"; 
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCounterDocNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCounterDocNo(response_);
                } catch (e) {
                    return <Observable<CounterDocNoListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CounterDocNoListDto>><any>Observable.throw(response_);
        });
    }

    protected processCounterDocNo(response: Response): Observable<CounterDocNoListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CounterDocNoListDto.fromJS(resultData200) : new CounterDocNoListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CounterDocNoListDto>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @atasNama (optional) 
     * @docNoPPPU (optional) 
     * @isTypeUnit (optional) 
     * @return Success
     */
    getDataGenerate(docNo: string, bookingHeaderID: number, atasNama: string, procurationType: number, docNoPPPU: string, isTypeUnit: boolean): Observable<P32DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetDataGenerate?";
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (atasNama !== undefined)
            url_ += "atasNama=" + encodeURIComponent("" + atasNama) + "&"; 
        if (procurationType === undefined || procurationType === null)
            throw new Error("The parameter 'procurationType' must be defined and cannot be null.");
        else
            url_ += "procurationType=" + encodeURIComponent("" + procurationType) + "&"; 
        if (docNoPPPU !== undefined)
            url_ += "docNoPPPU=" + encodeURIComponent("" + docNoPPPU) + "&"; 
        if (isTypeUnit !== undefined)
            url_ += "isTypeUnit=" + encodeURIComponent("" + isTypeUnit) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataGenerate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataGenerate(response_);
                } catch (e) {
                    return <Observable<P32DocumentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<P32DocumentDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataGenerate(response: Response): Observable<P32DocumentDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? P32DocumentDto.fromJS(resultData200) : new P32DocumentDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<P32DocumentDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generateDocumentParameter(bookCode: string): Observable<P32DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateDocumentParameter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateDocumentParameter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateDocumentParameter(response_);
                } catch (e) {
                    return <Observable<P32DocumentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<P32DocumentDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateDocumentParameter(response: Response): Observable<P32DocumentDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? P32DocumentDto.fromJS(resultData200) : new P32DocumentDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<P32DocumentDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFilePPPUNew(bookingDocumentID: number, bookCode: string, addendumDocumentID: number): Observable<GetFilePPPUListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFilePPPUNew?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (addendumDocumentID === undefined || addendumDocumentID === null)
            throw new Error("The parameter 'addendumDocumentID' must be defined and cannot be null.");
        else
            url_ += "addendumDocumentID=" + encodeURIComponent("" + addendumDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFilePPPUNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFilePPPUNew(response_);
                } catch (e) {
                    return <Observable<GetFilePPPUListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFilePPPUListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFilePPPUNew(response: Response): Observable<GetFilePPPUListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetFilePPPUListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFilePPPUListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFilePPPU(bookingDocumentID: number, bookCode: string, addendumDocumentID: number): Observable<GetFilePPPUListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFilePPPU?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (addendumDocumentID === undefined || addendumDocumentID === null)
            throw new Error("The parameter 'addendumDocumentID' must be defined and cannot be null.");
        else
            url_ += "addendumDocumentID=" + encodeURIComponent("" + addendumDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFilePPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFilePPPU(response_);
                } catch (e) {
                    return <Observable<GetFilePPPUListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFilePPPUListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFilePPPU(response: Response): Observable<GetFilePPPUListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFilePPPUListDto.fromJS(resultData200) : new GetFilePPPUListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFilePPPUListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFileForPrivy(bookingDocumentID: number, bookCode: string, addendumDocumentID: number): Observable<GetFilePPPUListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFileForPrivy?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (addendumDocumentID === undefined || addendumDocumentID === null)
            throw new Error("The parameter 'addendumDocumentID' must be defined and cannot be null.");
        else
            url_ += "addendumDocumentID=" + encodeURIComponent("" + addendumDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFileForPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFileForPrivy(response_);
                } catch (e) {
                    return <Observable<GetFilePPPUListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFilePPPUListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFileForPrivy(response: Response): Observable<GetFilePPPUListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFilePPPUListDto.fromJS(resultData200) : new GetFilePPPUListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFilePPPUListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFileUNST(bookingDocumentID: number, bookCode: string): Observable<GetFileLegalDocListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFileUNST?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFileUNST(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFileUNST(response_);
                } catch (e) {
                    return <Observable<GetFileLegalDocListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFileLegalDocListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFileUNST(response: Response): Observable<GetFileLegalDocListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFileLegalDocListDto.fromJS(resultData200) : new GetFileLegalDocListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFileLegalDocListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFileSignDoc(bookingDocumentID: number, bookCode: string): Observable<GetFileLegalDocListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFileSignDoc?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFileSignDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFileSignDoc(response_);
                } catch (e) {
                    return <Observable<GetFileLegalDocListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFileLegalDocListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFileSignDoc(response: Response): Observable<GetFileLegalDocListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFileLegalDocListDto.fromJS(resultData200) : new GetFileLegalDocListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFileLegalDocListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getFileAMD(bookingDocumentID: number, bookCode: string): Observable<GetFileLegalDocListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetFileAMD?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFileAMD(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFileAMD(response_);
                } catch (e) {
                    return <Observable<GetFileLegalDocListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFileLegalDocListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFileAMD(response: Response): Observable<GetFileLegalDocListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFileLegalDocListDto.fromJS(resultData200) : new GetFileLegalDocListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFileLegalDocListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDocCodeDropDown(bookCode: string): Observable<DocCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetDocCodeDropDown?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocCodeDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocCodeDropDown(response_);
                } catch (e) {
                    return <Observable<DocCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DocCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocCodeDropDown(response: Response): Observable<DocCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DocCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DocCodeDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bookingHeaderID (optional) 
     * @return Success
     */
    formUploadedDocument(psCode: string, bookingHeaderID: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/FormUploadedDocument?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFormUploadedDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFormUploadedDocument(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processFormUploadedDocument(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    createQrCodeInBase64(bookCode: string, psCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CreateQrCodeInBase64?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateQrCodeInBase64(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateQrCodeInBase64(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCreateQrCodeInBase64(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @orderCode (optional) 
     * @bookCode (optional) 
     * @return Success
     */
    manualInsertOrderCode(orderCode: string, orderDate: moment.Moment, bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/ManualInsertOrderCode?";
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        if (orderDate === undefined || orderDate === null)
            throw new Error("The parameter 'orderDate' must be defined and cannot be null.");
        else
            url_ += "orderDate=" + encodeURIComponent(orderDate ? "" + orderDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processManualInsertOrderCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processManualInsertOrderCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processManualInsertOrderCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @nama (optional) 
     * @return Success
     */
    generateAgent(nama: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateAgent?";
        if (nama !== undefined)
            url_ += "nama=" + encodeURIComponent("" + nama) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateAgent(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateAgent(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateAgent(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @projectId (optional) 
     * @return Success
     */
    getMappingOfferingLetter(bookCode: string, projectId: number): Observable<GetMappingOfferingLetterListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetMappingOfferingLetter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingOfferingLetter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingOfferingLetter(response_);
                } catch (e) {
                    return <Observable<GetMappingOfferingLetterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMappingOfferingLetterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingOfferingLetter(response: Response): Observable<GetMappingOfferingLetterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMappingOfferingLetterListDto.fromJS(resultData200) : new GetMappingOfferingLetterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMappingOfferingLetterListDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @link (optional) 
     * @return Success
     */
    sendEmailCustomerSign(psCode: string, link: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendEmailCustomerSign?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailCustomerSign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailCustomerSign(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailCustomerSign(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDataCustomerSign(bookingDocumentID: number): Observable<GetSendCustomerSignListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetDataCustomerSign?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCustomerSign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCustomerSign(response_);
                } catch (e) {
                    return <Observable<GetSendCustomerSignListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSendCustomerSignListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCustomerSign(response: Response): Observable<GetSendCustomerSignListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSendCustomerSignListDto.fromJS(resultData200) : new GetSendCustomerSignListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSendCustomerSignListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateDigitalSignedDoc(input: CreateBookingDocumentInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateDigitalSignedDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateDigitalSignedDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateDigitalSignedDoc(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateDigitalSignedDoc(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    sendDocumentPrivy(bookingDocumentID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SendDocumentPrivy?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendDocumentPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendDocumentPrivy(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendDocumentPrivy(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @username (optional) 
     * @password (optional) 
     * @token (optional) 
     * @merchantKey (optional) 
     * @urlPrivyIDKuasaDir (optional) 
     * @return Success
     */
    getKuasaDireksiPrivyID(username: string, password: string, token: string, merchantKey: string, urlPrivyIDKuasaDir: string): Observable<GetKuasaDirPrivyResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetKuasaDireksiPrivyID?";
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        if (merchantKey !== undefined)
            url_ += "merchantKey=" + encodeURIComponent("" + merchantKey) + "&"; 
        if (urlPrivyIDKuasaDir !== undefined)
            url_ += "UrlPrivyIDKuasaDir=" + encodeURIComponent("" + urlPrivyIDKuasaDir) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKuasaDireksiPrivyID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKuasaDireksiPrivyID(response_);
                } catch (e) {
                    return <Observable<GetKuasaDirPrivyResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKuasaDirPrivyResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKuasaDireksiPrivyID(response: Response): Observable<GetKuasaDirPrivyResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetKuasaDirPrivyResultDto.fromJS(resultData200) : new GetKuasaDirPrivyResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKuasaDirPrivyResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkStatusDocumentPrivy(bookingDocumentID: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/CheckStatusDocumentPrivy?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckStatusDocumentPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckStatusDocumentPrivy(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCheckStatusDocumentPrivy(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    downloadDocumentPrivy(bookingDocumentID: number): Observable<DownloadDocPrivyResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/DownloadDocumentPrivy?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadDocumentPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadDocumentPrivy(response_);
                } catch (e) {
                    return <Observable<DownloadDocPrivyResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DownloadDocPrivyResultDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadDocumentPrivy(response: Response): Observable<DownloadDocPrivyResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DownloadDocPrivyResultDto.fromJS(resultData200) : new DownloadDocPrivyResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DownloadDocPrivyResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    downloadDocumentPrivyV2(bookingDocumentID: number): Observable<DownloadDocPrivyResultV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/DownloadDocumentPrivyV2?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadDocumentPrivyV2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadDocumentPrivyV2(response_);
                } catch (e) {
                    return <Observable<DownloadDocPrivyResultV2Dto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DownloadDocPrivyResultV2Dto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadDocumentPrivyV2(response: Response): Observable<DownloadDocPrivyResultV2Dto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DownloadDocPrivyResultV2Dto.fromJS(resultData200) : new DownloadDocPrivyResultV2Dto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DownloadDocPrivyResultV2Dto>(<any>null);
    }

    /**
     * @return Success
     */
    getBookingDetailForPrivy(bookingDocumentID: number): Observable<InputPrivyDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetBookingDetailForPrivy?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingDetailForPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingDetailForPrivy(response_);
                } catch (e) {
                    return <Observable<InputPrivyDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InputPrivyDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingDetailForPrivy(response: Response): Observable<InputPrivyDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InputPrivyDto.fromJS(resultData200) : new InputPrivyDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InputPrivyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSignCoordinates(bookingHeaderID: number, projectID: number, docID: number, termID: number): Observable<SignCoordinatesType[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/getSignCoordinates?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSignCoordinates(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSignCoordinates(response_);
                } catch (e) {
                    return <Observable<SignCoordinatesType[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignCoordinatesType[]>><any>Observable.throw(response_);
        });
    }

    protected processGetSignCoordinates(response: Response): Observable<SignCoordinatesType[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SignCoordinatesType.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignCoordinatesType[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSettingPrivy(projectID: number): Observable<GetSettingPrivy> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetSettingPrivy?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSettingPrivy(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSettingPrivy(response_);
                } catch (e) {
                    return <Observable<GetSettingPrivy>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSettingPrivy>><any>Observable.throw(response_);
        });
    }

    protected processGetSettingPrivy(response: Response): Observable<GetSettingPrivy> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSettingPrivy.fromJS(resultData200) : new GetSettingPrivy();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSettingPrivy>(<any>null);
    }

    /**
     * @return Success
     */
    signedDocumentReminderScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SignedDocumentReminderScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSignedDocumentReminderScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSignedDocumentReminderScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSignedDocumentReminderScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    signedDocumentReminderByBookCode(listBookCode: string[]): Observable<SignedDocEmailResult[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/SignedDocumentReminderByBookCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSignedDocumentReminderByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSignedDocumentReminderByBookCode(response_);
                } catch (e) {
                    return <Observable<SignedDocEmailResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignedDocEmailResult[]>><any>Observable.throw(response_);
        });
    }

    protected processSignedDocumentReminderByBookCode(response: Response): Observable<SignedDocEmailResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SignedDocEmailResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignedDocEmailResult[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportPPPU(input: GenerateReportPPPUInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateReportPPPU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportPPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportPPPU(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportPPPU(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportAJB(input: GenerateReportAJBInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateReportAJB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportAJB(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportAJB(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @startBookDate (optional) 
     * @endBookDate (optional) 
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataReportPPPU(projectID: number, clusterID: number, startBookDate: moment.Moment, endBookDate: moment.Moment, bookCode: string, unitCode: string, unitNo: string): Observable<GenerateReportPPPUExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetDataReportPPPU?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (startBookDate !== undefined)
            url_ += "startBookDate=" + encodeURIComponent(startBookDate ? "" + startBookDate.toJSON() : "") + "&"; 
        if (endBookDate !== undefined)
            url_ += "endBookDate=" + encodeURIComponent(endBookDate ? "" + endBookDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataReportPPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataReportPPPU(response_);
                } catch (e) {
                    return <Observable<GenerateReportPPPUExcelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateReportPPPUExcelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataReportPPPU(response: Response): Observable<GenerateReportPPPUExcelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateReportPPPUExcelDto.fromJS(resultData200) : new GenerateReportPPPUExcelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateReportPPPUExcelDto>(<any>null);
    }

    /**
     * @startBookDate (optional) 
     * @endBookDate (optional) 
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataReportAjb(projectID: number, clusterID: number, startBookDate: moment.Moment, endBookDate: moment.Moment, bookCode: string, unitCode: string, unitNo: string): Observable<GenerateReportAJBExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GetDataReportAjb?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (startBookDate !== undefined)
            url_ += "startBookDate=" + encodeURIComponent(startBookDate ? "" + startBookDate.toJSON() : "") + "&"; 
        if (endBookDate !== undefined)
            url_ += "endBookDate=" + encodeURIComponent(endBookDate ? "" + endBookDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataReportAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataReportAjb(response_);
                } catch (e) {
                    return <Observable<GenerateReportAJBExcelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateReportAJBExcelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataReportAjb(response: Response): Observable<GenerateReportAJBExcelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateReportAJBExcelDto.fromJS(resultData200) : new GenerateReportAJBExcelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateReportAJBExcelDto>(<any>null);
    }

    /**
     * @return Success
     */
    listDataReprint(bookingDocumentID: number): Observable<ListResultDtoOfLinkPathListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/ListDataReprint?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListDataReprint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListDataReprint(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkPathListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkPathListDto>><any>Observable.throw(response_);
        });
    }

    protected processListDataReprint(response: Response): Observable<ListResultDtoOfLinkPathListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLinkPathListDto.fromJS(resultData200) : new ListResultDtoOfLinkPathListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLinkPathListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReprint(input: DataParamReprintDTO): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateReprint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReprint(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReprint(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReprint(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @return Success
     */
    deleteLegalDocument(docNo: string, userID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/DeleteLegalDocument?";
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLegalDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLegalDocument(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLegalDocument(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateLampiranUndanganAJB(input: P32DocumentDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASBookingDocument/GenerateLampiranUndanganAJB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateLampiranUndanganAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateLampiranUndanganAJB(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateLampiranUndanganAJB(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class PSASCancelUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    autoCancelUnit(): Observable<ReturnBookCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/AutoCancelUnit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAutoCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAutoCancelUnit(response_);
                } catch (e) {
                    return <Observable<ReturnBookCodeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReturnBookCodeDto>><any>Observable.throw(response_);
        });
    }

    protected processAutoCancelUnit(response: Response): Observable<ReturnBookCodeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReturnBookCodeDto.fromJS(resultData200) : new ReturnBookCodeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReturnBookCodeDto>(<any>null);
    }

    /**
     * @listReminderUnit (optional) 
     * @listDataReportCancelUnit (optional) 
     * @return Success
     */
    getReminderEmailUnitData(listReminderUnit: any[], listDataReportCancelUnit: any[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetReminderEmailUnitData?";
        if (listReminderUnit !== undefined)
            listReminderUnit && listReminderUnit.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "ListReminderUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        if (listDataReportCancelUnit !== undefined)
            listDataReportCancelUnit && listDataReportCancelUnit.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "ListDataReportCancelUnit[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReminderEmailUnitData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReminderEmailUnitData(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGetReminderEmailUnitData(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listDataEmail (optional) 
     * @return Success
     */
    sendEmailReminderCancelUnit(listDataEmail: DataEmailReminderUnitDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/SendEmailReminderCancelUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDataEmail);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReminderCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReminderCancelUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReminderCancelUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listCancelUnit (optional) 
     * @return Success
     */
    cancelUnitBySystem(listCancelUnit: CancelUnitInputDto[]): Observable<ResultCancelUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CancelUnitBySystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listCancelUnit);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCancelUnitBySystem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCancelUnitBySystem(response_);
                } catch (e) {
                    return <Observable<ResultCancelUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultCancelUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processCancelUnitBySystem(response: Response): Observable<ResultCancelUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultCancelUnitDto.fromJS(resultData200) : new ResultCancelUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultCancelUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBookingCancelBySystem(input: CreateTrBookingCancelInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CreateTrBookingCancelBySystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBookingCancelBySystem(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBookingCancelBySystem(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBookingCancelBySystem(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getTransactionData(bookCode: string): Observable<ResultGetTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetTransactionData?";
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransactionData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransactionData(response_);
                } catch (e) {
                    return <Observable<ResultGetTransactionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultGetTransactionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTransactionData(response: Response): Observable<ResultGetTransactionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultGetTransactionDto.fromJS(resultData200) : new ResultGetTransactionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultGetTransactionDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    cancelUnitDRMS(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CancelUnitDRMS?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCancelUnitDRMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCancelUnitDRMS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelUnitDRMS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @newBookCode (optional) 
     * @return Success
     */
    tRBookingCancelSaveDRMS(bookingHeaderID: number, newBookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/TRBookingCancelSaveDRMS?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (newBookCode !== undefined)
            url_ += "newBookCode=" + encodeURIComponent("" + newBookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTRBookingCancelSaveDRMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTRBookingCancelSaveDRMS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTRBookingCancelSaveDRMS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    cancelUnitSave(input: CancelUnitInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CancelUnitSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCancelUnitSave(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCancelUnitSave(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelUnitSave(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    cancelUnitOutstanding(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CancelUnitOutstanding?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCancelUnitOutstanding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCancelUnitOutstanding(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCancelUnitOutstanding(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBookingCancel(input: CreateTrBookingCancelInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/CreateTrBookingCancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBookingCancel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBookingCancel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBookingCancel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataCancelUnit(bookCode: string, unitCode: string, unitNo: string): Observable<GetDataCancelUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetDataCancelUnit?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCancelUnit(response_);
                } catch (e) {
                    return <Observable<GetDataCancelUnitListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCancelUnitListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCancelUnit(response: Response): Observable<GetDataCancelUnitListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataCancelUnitListDto.fromJS(resultData200) : new GetDataCancelUnitListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCancelUnitListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataCancelUnitDRMS(bookCode: string, unitCode: string, unitNo: string): Observable<GetDataCancelUnitListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetDataCancelUnitDRMS?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataCancelUnitDRMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataCancelUnitDRMS(response_);
                } catch (e) {
                    return <Observable<GetDataCancelUnitListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCancelUnitListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataCancelUnitDRMS(response: Response): Observable<GetDataCancelUnitListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataCancelUnitListDto.fromJS(resultData200) : new GetDataCancelUnitListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCancelUnitListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLkReasonDropdown(): Observable<GetLkReasonDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetLkReasonDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkReasonDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkReasonDropdown(response_);
                } catch (e) {
                    return <Observable<GetLkReasonDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkReasonDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkReasonDropdown(response: Response): Observable<GetLkReasonDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkReasonDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkReasonDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLkReasonDropdownNew(): Observable<GetLkReasonDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetLkReasonDropdownNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLkReasonDropdownNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLkReasonDropdownNew(response_);
                } catch (e) {
                    return <Observable<GetLkReasonDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLkReasonDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLkReasonDropdownNew(response: Response): Observable<GetLkReasonDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetLkReasonDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLkReasonDropdownListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataVerifyCancelUnit(input: VerifyUploadCancelUnitInputDto[]): Observable<GetDataVerifyCancelUnitResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/GetDataVerifyCancelUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataVerifyCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataVerifyCancelUnit(response_);
                } catch (e) {
                    return <Observable<GetDataVerifyCancelUnitResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataVerifyCancelUnitResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataVerifyCancelUnit(response: Response): Observable<GetDataVerifyCancelUnitResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataVerifyCancelUnitResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataVerifyCancelUnitResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadCancelUnitSave(input: CancelUnitInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/UploadCancelUnitSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadCancelUnitSave(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadCancelUnitSave(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadCancelUnitSave(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCancelUnit(input: UpdateCancelUnitDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASCancelUnit/UpdateCancelUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCancelUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCancelUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCancelUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASChangeOwnershipServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeOwnershipSave(input: ChangeOwnershipInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/ChangeOwnershipSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeOwnershipSave(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeOwnershipSave(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeOwnershipSave(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailChangeOwnership(input: SendEmailChangeOwnershipDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/SendEmailChangeOwnership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailChangeOwnership(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailChangeOwnership(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailChangeOwnership(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBookingChangeOwner(input: ChangeOwnershipInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/CreateTrBookingChangeOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBookingChangeOwner(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBookingChangeOwner(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBookingChangeOwner(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getBankDropdown(): Observable<GetMsBankDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/GetBankDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsBankDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsBankDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBankDropdown(response: Response): Observable<GetMsBankDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsBankDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsBankDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getChangeOwnerType(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/GetChangeOwnerType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetChangeOwnerType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetChangeOwnerType(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetChangeOwnerType(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataUnitChangeOwnership(bookCode: string, unitCode: string, unitNo: string): Observable<GetDataUnitChangeOwnerListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/GetDataUnitChangeOwnership?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataUnitChangeOwnership(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataUnitChangeOwnership(response_);
                } catch (e) {
                    return <Observable<GetDataUnitChangeOwnerListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataUnitChangeOwnerListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataUnitChangeOwnership(response: Response): Observable<GetDataUnitChangeOwnerListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataUnitChangeOwnerListDto.fromJS(resultData200) : new GetDataUnitChangeOwnerListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataUnitChangeOwnerListDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    checkDataPSCode(psCode: string): Observable<GetResultPsCodecheckDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/CheckDataPSCode?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataPSCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataPSCode(response_);
                } catch (e) {
                    return <Observable<GetResultPsCodecheckDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetResultPsCodecheckDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataPSCode(response: Response): Observable<GetResultPsCodecheckDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetResultPsCodecheckDto.fromJS(resultData200) : new GetResultPsCodecheckDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetResultPsCodecheckDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getHistoryOwnership(bookCode: string, unitCode: string, unitNo: string): Observable<GetHistoryOwnerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/GetHistoryOwnership?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryOwnership(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryOwnership(response_);
                } catch (e) {
                    return <Observable<GetHistoryOwnerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHistoryOwnerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryOwnership(response: Response): Observable<GetHistoryOwnerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetHistoryOwnerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHistoryOwnerListDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    searchPersonal(filter: string): Observable<GetSearchPersonalListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/SearchPersonal?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSearchPersonal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSearchPersonal(response_);
                } catch (e) {
                    return <Observable<GetSearchPersonalListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSearchPersonalListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processSearchPersonal(response: Response): Observable<GetSearchPersonalListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetSearchPersonalListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSearchPersonalListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailOwner(id: number): Observable<GetDetailChangeOwnerDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/GetDetailOwner?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailOwner(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailOwner(response_);
                } catch (e) {
                    return <Observable<GetDetailChangeOwnerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailChangeOwnerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailOwner(response: Response): Observable<GetDetailChangeOwnerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailChangeOwnerDto.fromJS(resultData200) : new GetDetailChangeOwnerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailChangeOwnerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateChangeOwnership(input: ChangeOwnershipInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeOwnership/UpdateChangeOwnership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateChangeOwnership(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateChangeOwnership(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateChangeOwnership(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASChangeRenovServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    calculationChangeRenov(input: ChangeRenovInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeRenov/CalculationChangeRenov";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculationChangeRenov(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculationChangeRenov(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCalculationChangeRenov(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataChangeRenov(bookCode: string, unitCode: string, unitNo: string): Observable<GetRenovListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeRenov/GetDataChangeRenov?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataChangeRenov(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataChangeRenov(response_);
                } catch (e) {
                    return <Observable<GetRenovListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRenovListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataChangeRenov(response: Response): Observable<GetRenovListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRenovListDto.fromJS(resultData200) : new GetRenovListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRenovListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRenovDropdown(bookingHeaderID: number, termID: number): Observable<GetRenovDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASChangeRenov/GetRenovDropdown?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRenovDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRenovDropdown(response_);
                } catch (e) {
                    return <Observable<GetRenovDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRenovDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRenovDropdown(response: Response): Observable<GetRenovDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRenovDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRenovDropdownListDto[]>(<any>null);
    }
}

@Injectable()
export class PSASDocTemplateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDocTemplate(): Observable<GetDocTemplateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/GetDocTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocTemplate(response_);
                } catch (e) {
                    return <Observable<GetDocTemplateListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocTemplateListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocTemplate(response: Response): Observable<GetDocTemplateListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDocTemplateListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocTemplateListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDocTemplateByDocID(docID: number): Observable<GetDocTemplateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/GetDocTemplateByDocID?";
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocTemplateByDocID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocTemplateByDocID(response_);
                } catch (e) {
                    return <Observable<GetDocTemplateListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocTemplateListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocTemplateByDocID(response: Response): Observable<GetDocTemplateListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDocTemplateListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocTemplateListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDocTemplateByDocTemplateID(docTemplateID: number): Observable<GetDocTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/GetDocTemplateByDocTemplateID?";
        if (docTemplateID === undefined || docTemplateID === null)
            throw new Error("The parameter 'docTemplateID' must be defined and cannot be null.");
        else
            url_ += "docTemplateID=" + encodeURIComponent("" + docTemplateID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocTemplateByDocTemplateID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocTemplateByDocTemplateID(response_);
                } catch (e) {
                    return <Observable<GetDocTemplateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocTemplateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDocTemplateByDocTemplateID(response: Response): Observable<GetDocTemplateListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDocTemplateListDto.fromJS(resultData200) : new GetDocTemplateListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocTemplateListDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateIsActiveDocTemplate(docTemplateID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/UpdateIsActiveDocTemplate?";
        if (docTemplateID === undefined || docTemplateID === null)
            throw new Error("The parameter 'docTemplateID' must be defined and cannot be null.");
        else
            url_ += "docTemplateID=" + encodeURIComponent("" + docTemplateID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActiveDocTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActiveDocTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActiveDocTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDocTemplate(input: CreateDocTemplateInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/CreateDocTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDocTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDocTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDocTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkIsMasterDocID(docID: number, isMaster: boolean): Observable<CheckIsMasterDocIdListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/CheckIsMasterDocID?";
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        if (isMaster === undefined || isMaster === null)
            throw new Error("The parameter 'isMaster' must be defined and cannot be null.");
        else
            url_ += "isMaster=" + encodeURIComponent("" + isMaster) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIsMasterDocID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIsMasterDocID(response_);
                } catch (e) {
                    return <Observable<CheckIsMasterDocIdListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckIsMasterDocIdListDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckIsMasterDocID(response: Response): Observable<CheckIsMasterDocIdListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckIsMasterDocIdListDto.fromJS(resultData200) : new CheckIsMasterDocIdListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckIsMasterDocIdListDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkIsMaster(docID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/CheckIsMaster?";
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIsMaster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIsMaster(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckIsMaster(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    removeFileFromTemp(filename: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocTemplate/RemoveFileFromTemp?";
        if (filename !== undefined)
            filename && filename.forEach(item => { url_ += "filename=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFileFromTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveFileFromTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFileFromTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASDocumentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDocumentDropdown(): Observable<GetDocumentDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASDocument/GetDocumentDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocumentDropdown(response_);
                } catch (e) {
                    return <Observable<GetDocumentDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocumentDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentDropdown(response: Response): Observable<GetDocumentDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDocumentDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocumentDropdownListDto[]>(<any>null);
    }
}

@Injectable()
export class PSASHistoryCreditBankServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getHistoryCreditBank(bookCode: string): Observable<HistoryCreditBankInputDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryCreditBank/GetHistoryCreditBank?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryCreditBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryCreditBank(response_);
                } catch (e) {
                    return <Observable<HistoryCreditBankInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryCreditBankInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryCreditBank(response: Response): Observable<HistoryCreditBankInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HistoryCreditBankInputDto.fromJS(resultData200) : new HistoryCreditBankInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryCreditBankInputDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getCreditBankDropdown(bookCode: string): Observable<GetDropdownCreditBankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryCreditBank/GetCreditBankDropdown?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCreditBankDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCreditBankDropdown(response_);
                } catch (e) {
                    return <Observable<GetDropdownCreditBankDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCreditBankDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCreditBankDropdown(response: Response): Observable<GetDropdownCreditBankDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCreditBankDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCreditBankDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUpdateProgressDropdown(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryCreditBank/GetUpdateProgressDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUpdateProgressDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUpdateProgressDropdown(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUpdateProgressDropdown(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateHistoryCreditBank(input: HistoryCreditBankInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryCreditBank/UpdateHistoryCreditBank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateHistoryCreditBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateHistoryCreditBank(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateHistoryCreditBank(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PsasHistoryRefundServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getNetNetPrice(bookCode: string): Observable<NetPriceHistoryRefund> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/GetNetNetPrice?";
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNetNetPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNetNetPrice(response_);
                } catch (e) {
                    return <Observable<NetPriceHistoryRefund>><any>Observable.throw(e);
                }
            } else
                return <Observable<NetPriceHistoryRefund>><any>Observable.throw(response_);
        });
    }

    protected processGetNetNetPrice(response: Response): Observable<NetPriceHistoryRefund> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NetPriceHistoryRefund.fromJS(resultData200) : new NetPriceHistoryRefund();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NetPriceHistoryRefund>(<any>null);
    }

    /**
     * @return Success
     */
    getCategoryRefundDropDown(): Observable<CategoryRefundDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/getCategoryRefundDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCategoryRefundDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCategoryRefundDropDown(response_);
                } catch (e) {
                    return <Observable<CategoryRefundDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CategoryRefundDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCategoryRefundDropDown(response: Response): Observable<CategoryRefundDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CategoryRefundDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CategoryRefundDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getHistoryRefund(bookCode: string): Observable<HistoryRefundDto> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/GetHistoryRefund?";
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryRefund(response_);
                } catch (e) {
                    return <Observable<HistoryRefundDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryRefundDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryRefund(response: Response): Observable<HistoryRefundDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HistoryRefundDto.fromJS(resultData200) : new HistoryRefundDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryRefundDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentRefundDetail(input: number): Observable<PaymentRefundDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/GetPaymentRefundDetail?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentRefundDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentRefundDetail(response_);
                } catch (e) {
                    return <Observable<PaymentRefundDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentRefundDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentRefundDetail(response: Response): Observable<PaymentRefundDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PaymentRefundDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentRefundDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownSK(): Observable<SKDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/getDropdownSK";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownSK(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownSK(response_);
                } catch (e) {
                    return <Observable<SKDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SKDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownSK(response: Response): Observable<SKDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SKDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SKDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUpdate(input: InsertAndUpdateHistoryRefundDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/InsertUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertHeader(input: HistoryRefundDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/InsertHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertHeader(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processInsertHeader(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertDetail(input: HistoryRefundDetailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/InsertDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertDetail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertDetail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteHisRefundDetail(input: number): Observable<HisRefundResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/PsasHistoryRefund/deleteHisRefundDetail?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHisRefundDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHisRefundDetail(response_);
                } catch (e) {
                    return <Observable<HisRefundResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HisRefundResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHisRefundDetail(response: Response): Observable<HisRefundResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HisRefundResultMessageDto.fromJS(resultData200) : new HisRefundResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HisRefundResultMessageDto>(<any>null);
    }
}

@Injectable()
export class PSASHistoryStatusAjbServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDataHistoryStatusAjb(bookCode: string): Observable<HistoryStatusAjbDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusAjb/GetDataHistoryStatusAjb?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataHistoryStatusAjb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataHistoryStatusAjb(response_);
                } catch (e) {
                    return <Observable<HistoryStatusAjbDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryStatusAjbDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataHistoryStatusAjb(response: Response): Observable<HistoryStatusAjbDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryStatusAjbDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryStatusAjbDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUpdate(input: HistoryStatusAjbDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusAjb/InsertUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASHistoryStatusCollectionServiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDataHistoryStatusCollectionsByID(input: number): Observable<HistoryStatusCollectioninputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusCollectionService/GetDataHistoryStatusCollectionsByID?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataHistoryStatusCollectionsByID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataHistoryStatusCollectionsByID(response_);
                } catch (e) {
                    return <Observable<HistoryStatusCollectioninputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryStatusCollectioninputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataHistoryStatusCollectionsByID(response: Response): Observable<HistoryStatusCollectioninputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryStatusCollectioninputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryStatusCollectioninputDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDataHistoryStatusCollections(): Observable<HistoryStatusCollectioninputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusCollectionService/GetAllDataHistoryStatusCollections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllDataHistoryStatusCollections(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllDataHistoryStatusCollections(response_);
                } catch (e) {
                    return <Observable<HistoryStatusCollectioninputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryStatusCollectioninputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllDataHistoryStatusCollections(response: Response): Observable<HistoryStatusCollectioninputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryStatusCollectioninputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryStatusCollectioninputDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @bookCode (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getDataHistoryStatusCollections(filter: string, bookCode: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfHistoryStatusCollectioninputDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusCollectionService/GetDataHistoryStatusCollections?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataHistoryStatusCollections(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataHistoryStatusCollections(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfHistoryStatusCollectioninputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfHistoryStatusCollectioninputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataHistoryStatusCollections(response: Response): Observable<PagedResultDtoOfHistoryStatusCollectioninputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfHistoryStatusCollectioninputDto.fromJS(resultData200) : new PagedResultDtoOfHistoryStatusCollectioninputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfHistoryStatusCollectioninputDto>(<any>null);
    }

    /**
     * @return Success
     */
    getStatusCollectionDropdown(): Observable<GetDropdownStatusCollectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusCollectionService/GetStatusCollectionDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStatusCollectionDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStatusCollectionDropdown(response_);
                } catch (e) {
                    return <Observable<GetDropdownStatusCollectionDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownStatusCollectionDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStatusCollectionDropdown(response: Response): Observable<GetDropdownStatusCollectionDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownStatusCollectionDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownStatusCollectionDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createHistoryStatusCollection(input: HistoryStatusCollectioninputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusCollectionService/CreateHistoryStatusCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateHistoryStatusCollection(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateHistoryStatusCollection(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateHistoryStatusCollection(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASHistoryStatusHandoverServiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDataHistoryStatusHandoversByID(input: number): Observable<HistoryStatusHandoverInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusHandoverService/GetDataHistoryStatusHandoversByID?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataHistoryStatusHandoversByID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataHistoryStatusHandoversByID(response_);
                } catch (e) {
                    return <Observable<HistoryStatusHandoverInputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryStatusHandoverInputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataHistoryStatusHandoversByID(response: Response): Observable<HistoryStatusHandoverInputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryStatusHandoverInputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryStatusHandoverInputDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDataHistoryStatusHandovers(): Observable<HistoryStatusHandoverInputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusHandoverService/GetAllDataHistoryStatusHandovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllDataHistoryStatusHandovers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllDataHistoryStatusHandovers(response_);
                } catch (e) {
                    return <Observable<HistoryStatusHandoverInputDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryStatusHandoverInputDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllDataHistoryStatusHandovers(response: Response): Observable<HistoryStatusHandoverInputDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryStatusHandoverInputDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryStatusHandoverInputDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @bookCode (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getDataHistoryStatusHandovers(filter: string, bookCode: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfHistoryStatusHandoverInputDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusHandoverService/GetDataHistoryStatusHandovers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataHistoryStatusHandovers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataHistoryStatusHandovers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfHistoryStatusHandoverInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfHistoryStatusHandoverInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataHistoryStatusHandovers(response: Response): Observable<PagedResultDtoOfHistoryStatusHandoverInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfHistoryStatusHandoverInputDto.fromJS(resultData200) : new PagedResultDtoOfHistoryStatusHandoverInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfHistoryStatusHandoverInputDto>(<any>null);
    }

    /**
     * @return Success
     */
    getStatusHandoverDropdown(): Observable<GetDropdownStatusHandoverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusHandoverService/GetStatusHandoverDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStatusHandoverDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStatusHandoverDropdown(response_);
                } catch (e) {
                    return <Observable<GetDropdownStatusHandoverDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownStatusHandoverDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetStatusHandoverDropdown(response: Response): Observable<GetDropdownStatusHandoverDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownStatusHandoverDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownStatusHandoverDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createHistoryStatusHandover(input: HistoryStatusHandoverInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryStatusHandoverService/CreateHistoryStatusHandover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateHistoryStatusHandover(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateHistoryStatusHandover(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateHistoryStatusHandover(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASHistoryUploadBulkRefundServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getHistoryUploadBulkRefundDetail(input: number): Observable<HistoryRefundDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/getHistoryUploadBulkRefundDetail?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryUploadBulkRefundDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryUploadBulkRefundDetail(response_);
                } catch (e) {
                    return <Observable<HistoryRefundDetailDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HistoryRefundDetailDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryUploadBulkRefundDetail(response: Response): Observable<HistoryRefundDetailDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HistoryRefundDetailDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HistoryRefundDetailDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUpdate(input: InsertAndUpdateHistoryUploadBulkRefund): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/InsertUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUpdate(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processInsertUpdate(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertHistoryUploadBulkRefundHeader(input: HistoryUploadBulkRefundDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/InsertHistoryUploadBulkRefundHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertHistoryUploadBulkRefundHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertHistoryUploadBulkRefundHeader(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertHistoryUploadBulkRefundHeader(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertDetailHistoryUpload(input: InsertAndDeletePaymentDetail): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/InsertDetailHistoryUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertDetailHistoryUpload(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertDetailHistoryUpload(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertDetailHistoryUpload(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteHisRefundDetail(input: number): Observable<HisRefundResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/deleteHisRefundDetail?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHisRefundDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHisRefundDetail(response_);
                } catch (e) {
                    return <Observable<HisRefundResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HisRefundResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHisRefundDetail(response: Response): Observable<HisRefundResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HisRefundResultMessageDto.fromJS(resultData200) : new HisRefundResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HisRefundResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getHistoryUploadBulkRefund(input: PSASListOfHistoryUploadBulkRefundInputDto): Observable<PagedResultDtoOfHistoryRefundDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/GetHistoryUploadBulkRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryUploadBulkRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryUploadBulkRefund(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfHistoryRefundDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfHistoryRefundDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryUploadBulkRefund(response: Response): Observable<PagedResultDtoOfHistoryRefundDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfHistoryRefundDto.fromJS(resultData200) : new PagedResultDtoOfHistoryRefundDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfHistoryRefundDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateHistoryRefundToExcel(input: GenerateHistoryRefundToExcelInput): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASHistoryUploadBulkRefund/GenerateHistoryRefundToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateHistoryRefundToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateHistoryRefundToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateHistoryRefundToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class PSASKuasaDireksiServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalKuasaDireksi(input: CreateKuasaDireksiInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/CreateUniversalKuasaDireksi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalKuasaDireksi(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @dataKuasaDireksiPeople (optional) 
     * @return Success
     */
    createKuasaDireksiPeople(dataKuasaDireksiPeople: CreateKuasaDireksiPeopleInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/CreateKuasaDireksiPeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataKuasaDireksiPeople);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateKuasaDireksiPeople(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateKuasaDireksiPeople(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateKuasaDireksiPeople(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateIsActiveKuasaDireksi(kuasaDireksiID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/UpdateIsActiveKuasaDireksi?";
        if (kuasaDireksiID === undefined || kuasaDireksiID === null)
            throw new Error("The parameter 'kuasaDireksiID' must be defined and cannot be null.");
        else
            url_ += "kuasaDireksiID=" + encodeURIComponent("" + kuasaDireksiID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActiveKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActiveKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActiveKuasaDireksi(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteKuasaDireksiPeople(kuasaDireksiPeopleID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/DeleteKuasaDireksiPeople?";
        if (kuasaDireksiPeopleID === undefined || kuasaDireksiPeopleID === null)
            throw new Error("The parameter 'kuasaDireksiPeopleID' must be defined and cannot be null.");
        else
            url_ += "kuasaDireksiPeopleID=" + encodeURIComponent("" + kuasaDireksiPeopleID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteKuasaDireksiPeople(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteKuasaDireksiPeople(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteKuasaDireksiPeople(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getPSASListOfKuasaDireksi(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetPSASListOfKuasaDireksiListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetPSASListOfKuasaDireksi?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASListOfKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASListOfKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPSASListOfKuasaDireksiListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPSASListOfKuasaDireksiListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASListOfKuasaDireksi(response: Response): Observable<PagedResultDtoOfGetPSASListOfKuasaDireksiListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetPSASListOfKuasaDireksiListDto.fromJS(resultData200) : new PagedResultDtoOfGetPSASListOfKuasaDireksiListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetPSASListOfKuasaDireksiListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPSASKuasaDireksiAndPeople(id: number): Observable<GetPSASKuasaDireksiAndPeopleListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetPSASKuasaDireksiAndPeople?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASKuasaDireksiAndPeople(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASKuasaDireksiAndPeople(response_);
                } catch (e) {
                    return <Observable<GetPSASKuasaDireksiAndPeopleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASKuasaDireksiAndPeopleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASKuasaDireksiAndPeople(response: Response): Observable<GetPSASKuasaDireksiAndPeopleListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASKuasaDireksiAndPeopleListDto.fromJS(resultData200) : new GetPSASKuasaDireksiAndPeopleListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASKuasaDireksiAndPeopleListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPSASListOfKuasaDireksiByDireksiID(id: number): Observable<GetDetailPSASListOfKuasaDireksiListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetPSASListOfKuasaDireksiByDireksiID?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASListOfKuasaDireksiByDireksiID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASListOfKuasaDireksiByDireksiID(response_);
                } catch (e) {
                    return <Observable<GetDetailPSASListOfKuasaDireksiListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPSASListOfKuasaDireksiListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASListOfKuasaDireksiByDireksiID(response: Response): Observable<GetDetailPSASListOfKuasaDireksiListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPSASListOfKuasaDireksiListDto.fromJS(resultData200) : new GetDetailPSASListOfKuasaDireksiListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPSASListOfKuasaDireksiListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPSASKuasaDireksiPeopleByKuasaDireksiID(kuasaDireksiID: number): Observable<GetPSASListOfKuasaDireksiPeopleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetPSASKuasaDireksiPeopleByKuasaDireksiID?";
        if (kuasaDireksiID === undefined || kuasaDireksiID === null)
            throw new Error("The parameter 'kuasaDireksiID' must be defined and cannot be null.");
        else
            url_ += "kuasaDireksiID=" + encodeURIComponent("" + kuasaDireksiID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASKuasaDireksiPeopleByKuasaDireksiID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASKuasaDireksiPeopleByKuasaDireksiID(response_);
                } catch (e) {
                    return <Observable<GetPSASListOfKuasaDireksiPeopleListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASListOfKuasaDireksiPeopleListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASKuasaDireksiPeopleByKuasaDireksiID(response: Response): Observable<GetPSASListOfKuasaDireksiPeopleListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPSASListOfKuasaDireksiPeopleListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASListOfKuasaDireksiPeopleListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getDropdownPSASListOfKuasaDireksi(bookCode: string, docID: number): Observable<GetDetailPSASListOfKuasaDireksiListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetDropdownPSASListOfKuasaDireksi?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownPSASListOfKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownPSASListOfKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<GetDetailPSASListOfKuasaDireksiListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPSASListOfKuasaDireksiListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownPSASListOfKuasaDireksi(response: Response): Observable<GetDetailPSASListOfKuasaDireksiListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailPSASListOfKuasaDireksiListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPSASListOfKuasaDireksiListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPSASListOfKuasaDireksi(): Observable<GetPSASListOfKuasaDireksiListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/GetAllPSASListOfKuasaDireksi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPSASListOfKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllPSASListOfKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<GetPSASListOfKuasaDireksiListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASListOfKuasaDireksiListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPSASListOfKuasaDireksi(response: Response): Observable<GetPSASListOfKuasaDireksiListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPSASListOfKuasaDireksiListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASListOfKuasaDireksiListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUniversalKuasaDireksi(input: CreateKuasaDireksiInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/UpdateUniversalKuasaDireksi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUniversalKuasaDireksi(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUniversalKuasaDireksi(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUniversalKuasaDireksi(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateKuasaDireksiSignature(input: UpdateKuasaDireksiSignatureDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/UpdateKuasaDireksiSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateKuasaDireksiSignature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateKuasaDireksiSignature(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateKuasaDireksiSignature(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @link (optional) 
     * @return Success
     */
    sendEmailKuasaDireksiSign(kuasaDireksiPeopleID: number, link: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASKuasaDireksi/SendEmailKuasaDireksiSign?";
        if (kuasaDireksiPeopleID === undefined || kuasaDireksiPeopleID === null)
            throw new Error("The parameter 'kuasaDireksiPeopleID' must be defined and cannot be null.");
        else
            url_ += "kuasaDireksiPeopleID=" + encodeURIComponent("" + kuasaDireksiPeopleID) + "&"; 
        if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailKuasaDireksiSign(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailKuasaDireksiSign(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailKuasaDireksiSign(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASLandDocServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitNo (optional) 
     * @unitCode (optional) 
     * @return Success
     */
    getUniversalLandDoc(bookCode: string, unitNo: string, unitCode: string): Observable<GetUniversalLandDocDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/GetUniversalLandDoc?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalLandDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalLandDoc(response_);
                } catch (e) {
                    return <Observable<GetUniversalLandDocDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalLandDocDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalLandDoc(response: Response): Observable<GetUniversalLandDocDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalLandDocDto.fromJS(resultData200) : new GetUniversalLandDocDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalLandDocDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingDB(input: CreateMappingDBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/CreateMappingDB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingDB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingDB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingDB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMappingDB(idMappingDB: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/DeleteMappingDB?";
        if (idMappingDB === undefined || idMappingDB === null)
            throw new Error("The parameter 'idMappingDB' must be defined and cannot be null.");
        else
            url_ += "idMappingDB=" + encodeURIComponent("" + idMappingDB) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMappingDB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMappingDB(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMappingDB(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMapppingDB(input: UpdateMappingDBDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/UpdateMapppingDB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMapppingDB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMapppingDB(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMapppingDB(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getMsMappingDB(): Observable<GetDataMsMappingDBResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/GetMsMappingDB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsMappingDB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsMappingDB(response_);
                } catch (e) {
                    return <Observable<GetDataMsMappingDBResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMsMappingDBResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetMsMappingDB(response: Response): Observable<GetDataMsMappingDBResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataMsMappingDBResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMsMappingDBResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailMappingDB(id: number): Observable<GetDataMsMappingDBResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASLandDoc/GetDetailMappingDB?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailMappingDB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailMappingDB(response_);
                } catch (e) {
                    return <Observable<GetDataMsMappingDBResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMsMappingDBResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailMappingDB(response: Response): Observable<GetDataMsMappingDBResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataMsMappingDBResultDto.fromJS(resultData200) : new GetDataMsMappingDBResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMsMappingDBResultDto>(<any>null);
    }
}

@Injectable()
export class PSASMainServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPSASMainOld(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalMainListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetPSASMainOld?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASMainOld(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASMainOld(response_);
                } catch (e) {
                    return <Observable<GetUniversalMainListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalMainListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASMainOld(response: Response): Observable<GetUniversalMainListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalMainListDto.fromJS(resultData200) : new GetUniversalMainListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalMainListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPSASMain(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalMainListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetPSASMain?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASMain(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASMain(response_);
                } catch (e) {
                    return <Observable<GetUniversalMainListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalMainListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASMain(response: Response): Observable<GetUniversalMainListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalMainListDto.fromJS(resultData200) : new GetUniversalMainListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalMainListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPSASToExport(bookCode: string, unitCode: string, unitNo: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUniversalPSASToExport?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPSASToExport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPSASToExport(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPSASToExport(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPSASToExportSqlString(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalPsasDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUniversalPSASToExportSqlString?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPSASToExportSqlString(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPSASToExportSqlString(response_);
                } catch (e) {
                    return <Observable<GetUniversalPsasDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalPsasDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPSASToExportSqlString(response: Response): Observable<GetUniversalPsasDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalPsasDto.fromJS(resultData200) : new GetUniversalPsasDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalPsasDto>(<any>null);
    }

    /**
     * @listProject (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    getDataBookCodeWithCluster(listProject: number[], accountID: number, projectID: number, startDate: moment.Moment, endDate: moment.Moment, bookCode: string, psCode: string, unitID: number, unitCodeID: number, clusterID: number): Observable<GetDataBookCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetDataBookCodeWithCluster?";
        if (listProject !== undefined)
            listProject && listProject.forEach(item => { url_ += "listProject=" + encodeURIComponent("" + item) + "&"; });
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataBookCodeWithCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataBookCodeWithCluster(response_);
                } catch (e) {
                    return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataBookCodeWithCluster(response: Response): Observable<GetDataBookCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataBookCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataBookCodeListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPSASToExportSqlStringGenerate(bookCode: string, unitCode: string, unitNo: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUniversalPSASToExportSqlStringGenerate?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPSASToExportSqlStringGenerate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPSASToExportSqlStringGenerate(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPSASToExportSqlStringGenerate(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPSASToExportNoGenerate(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalPsasDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUniversalPSASToExportNoGenerate?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPSASToExportNoGenerate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPSASToExportNoGenerate(response_);
                } catch (e) {
                    return <Observable<GetUniversalPsasDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalPsasDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPSASToExportNoGenerate(response: Response): Observable<GetUniversalPsasDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalPsasDto.fromJS(resultData200) : new GetUniversalPsasDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalPsasDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getBookingProfilePdfDocument(bookCode: string, unitCode: string, unitNo: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetBookingProfilePdfDocument?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingProfilePdfDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingProfilePdfDocument(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingProfilePdfDocument(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    multipleBookingProfilePDF(listBookCode: string[]): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/MultipleBookingProfilePDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMultipleBookingProfilePDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMultipleBookingProfilePDF(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processMultipleBookingProfilePDF(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    multipleBookingProfileExcel(listBookCode: string[]): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/MultipleBookingProfileExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMultipleBookingProfileExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMultipleBookingProfileExcel(response_);
                } catch (e) {
                    return <Observable<FileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processMultipleBookingProfileExcel(response: Response): Observable<FileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @note (optional) 
     * @return Success
     */
    updateNotePSAS(bookCode: string, note: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/UpdateNotePSAS?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotePSAS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotePSAS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotePSAS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getUnitcodeUnitnoAJB(bookCode: string): Observable<GetUnitcodeUnitnoAJBResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUnitcodeUnitnoAJB?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitcodeUnitnoAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitcodeUnitnoAJB(response_);
                } catch (e) {
                    return <Observable<GetUnitcodeUnitnoAJBResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitcodeUnitnoAJBResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitcodeUnitnoAJB(response: Response): Observable<GetUnitcodeUnitnoAJBResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitcodeUnitnoAJBResultDto.fromJS(resultData200) : new GetUnitcodeUnitnoAJBResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitcodeUnitnoAJBResultDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getUnitcodeUnitno(bookCode: string): Observable<GetUnitcodeUnitnoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetUnitcodeUnitno?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitcodeUnitno(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitcodeUnitno(response_);
                } catch (e) {
                    return <Observable<GetUnitcodeUnitnoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUnitcodeUnitnoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitcodeUnitno(response: Response): Observable<GetUnitcodeUnitnoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUnitcodeUnitnoResultDto.fromJS(resultData200) : new GetUnitcodeUnitnoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUnitcodeUnitnoResultDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDetailBookingHeaderInfo(bookCode: string, unitCode: string, unitNo: string): Observable<GetDetailBookingHeaderInfoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetDetailBookingHeaderInfo?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<GetDetailBookingHeaderInfoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailBookingHeaderInfoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingHeaderInfo(response: Response): Observable<GetDetailBookingHeaderInfoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailBookingHeaderInfoResultDto.fromJS(resultData200) : new GetDetailBookingHeaderInfoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailBookingHeaderInfoResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePenaltyBookingHeaderInfo(input: UpdateBookingHeaderInfoInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/UpdatePenaltyBookingHeaderInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePenaltyBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePenaltyBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePenaltyBookingHeaderInfo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateHandOverBookingHeaderInfo(input: UpdateHandOverBookingHeaderInfoInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/UpdateHandOverBookingHeaderInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateHandOverBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateHandOverBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateHandOverBookingHeaderInfo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    markAsPaidOff(bookCode: string): Observable<GetDataBookingResult> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/MarkAsPaidOff?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMarkAsPaidOff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMarkAsPaidOff(response_);
                } catch (e) {
                    return <Observable<GetDataBookingResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataBookingResult>><any>Observable.throw(response_);
        });
    }

    protected processMarkAsPaidOff(response: Response): Observable<GetDataBookingResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataBookingResult.fromJS(resultData200) : new GetDataBookingResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataBookingResult>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownFlagStatus(): Observable<GetDataFlagstatusDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/GetDropdownFlagStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownFlagStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownFlagStatus(response_);
                } catch (e) {
                    return <Observable<GetDataFlagstatusDTO[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataFlagstatusDTO[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownFlagStatus(response: Response): Observable<GetDataFlagstatusDTO[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataFlagstatusDTO.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataFlagstatusDTO[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    listDataFlagStatus(bookCode: string): Observable<DataListTRFlagStatusDTO> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/ListDataFlagStatus?";
        if (bookCode !== undefined)
            url_ += "BookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListDataFlagStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListDataFlagStatus(response_);
                } catch (e) {
                    return <Observable<DataListTRFlagStatusDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<DataListTRFlagStatusDTO>><any>Observable.throw(response_);
        });
    }

    protected processListDataFlagStatus(response: Response): Observable<DataListTRFlagStatusDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DataListTRFlagStatusDTO.fromJS(resultData200) : new DataListTRFlagStatusDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DataListTRFlagStatusDTO>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertOrUpdateTRFlagStatus(input: DataTRFlagStatusDTO[]): Observable<ResponseSaveDTO> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/InsertOrUpdateTRFlagStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertOrUpdateTRFlagStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertOrUpdateTRFlagStatus(response_);
                } catch (e) {
                    return <Observable<ResponseSaveDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseSaveDTO>><any>Observable.throw(response_);
        });
    }

    protected processInsertOrUpdateTRFlagStatus(response: Response): Observable<ResponseSaveDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseSaveDTO.fromJS(resultData200) : new ResponseSaveDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseSaveDTO>(<any>null);
    }

    /**
     * @return Success
     */
    deleteTRFlagStatus(id: number): Observable<ResponseSaveDTO> {
        let url_ = this.baseUrl + "/api/services/app/PSASMain/DeleteTRFlagStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTRFlagStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTRFlagStatus(response_);
                } catch (e) {
                    return <Observable<ResponseSaveDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseSaveDTO>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTRFlagStatus(response: Response): Observable<ResponseSaveDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseSaveDTO.fromJS(resultData200) : new ResponseSaveDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseSaveDTO>(<any>null);
    }
}

@Injectable()
export class PSASMappingKadasterServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkCategoryIsExist(projectID: number, categoryID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/CheckCategoryIsExist?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckCategoryIsExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckCategoryIsExist(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckCategoryIsExist(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingKadasterByCode(input: CreateMappingKadasterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/UpdateMappingKadasterByCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingKadasterByCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingKadasterByCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingKadasterByCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingKadaster(input: CreateMappingKadasterInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/CreateMappingKadaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingKadaster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingKadaster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingKadaster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownCategoryByProjectUnit(projectID: number): Observable<GetDropdownCategoryByUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetDropdownCategoryByProjectUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCategoryByProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCategoryByProjectUnit(response_);
                } catch (e) {
                    return <Observable<GetDropdownCategoryByUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCategoryByUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCategoryByProjectUnit(response: Response): Observable<GetDropdownCategoryByUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCategoryByUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCategoryByUnitListDto[]>(<any>null);
    }

    /**
     * @unitID (optional) 
     * @url (optional) 
     * @clusterid (optional) 
     * @message (optional) 
     * @success (optional) 
     * @return Success
     */
    getKadasterDiagramatic(unitID: number, url: string, clusterid: number, projectid: number, renoveID: number, message: string, success: boolean): Observable<GetKadasterDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetKadasterDiagramatic?";
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        if (clusterid !== undefined)
            url_ += "clusterid=" + encodeURIComponent("" + clusterid) + "&"; 
        if (projectid === undefined || projectid === null)
            throw new Error("The parameter 'projectid' must be defined and cannot be null.");
        else
            url_ += "projectid=" + encodeURIComponent("" + projectid) + "&"; 
        if (renoveID === undefined || renoveID === null)
            throw new Error("The parameter 'renoveID' must be defined and cannot be null.");
        else
            url_ += "renoveID=" + encodeURIComponent("" + renoveID) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (success !== undefined)
            url_ += "success=" + encodeURIComponent("" + success) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKadasterDiagramatic(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKadasterDiagramatic(response_);
                } catch (e) {
                    return <Observable<GetKadasterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKadasterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetKadasterDiagramatic(response: Response): Observable<GetKadasterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetKadasterDto.fromJS(resultData200) : new GetKadasterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKadasterDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListKadasterType(unitID: number, projectid: number): Observable<GetKadasterTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetListKadasterType?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (projectid === undefined || projectid === null)
            throw new Error("The parameter 'projectid' must be defined and cannot be null.");
        else
            url_ += "projectid=" + encodeURIComponent("" + projectid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListKadasterType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListKadasterType(response_);
                } catch (e) {
                    return <Observable<GetKadasterTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKadasterTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListKadasterType(response: Response): Observable<GetKadasterTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetKadasterTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKadasterTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListmarketingLayoutType(unitID: number, projectid: number): Observable<GetKadasterTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetListmarketingLayoutType?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (projectid === undefined || projectid === null)
            throw new Error("The parameter 'projectid' must be defined and cannot be null.");
        else
            url_ += "projectid=" + encodeURIComponent("" + projectid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListmarketingLayoutType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListmarketingLayoutType(response_);
                } catch (e) {
                    return <Observable<GetKadasterTypeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKadasterTypeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListmarketingLayoutType(response: Response): Observable<GetKadasterTypeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetKadasterTypeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKadasterTypeDto[]>(<any>null);
    }

    /**
     * @unitID (optional) 
     * @url (optional) 
     * @clusterid (optional) 
     * @message (optional) 
     * @success (optional) 
     * @return Success
     */
    getMarketingLayoutImage(unitID: number, url: string, clusterid: number, projectid: number, renoveID: number, message: string, success: boolean): Observable<GetKadasterDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetMarketingLayoutImage?";
        if (unitID !== undefined)
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        if (clusterid !== undefined)
            url_ += "clusterid=" + encodeURIComponent("" + clusterid) + "&"; 
        if (projectid === undefined || projectid === null)
            throw new Error("The parameter 'projectid' must be defined and cannot be null.");
        else
            url_ += "projectid=" + encodeURIComponent("" + projectid) + "&"; 
        if (renoveID === undefined || renoveID === null)
            throw new Error("The parameter 'renoveID' must be defined and cannot be null.");
        else
            url_ += "renoveID=" + encodeURIComponent("" + renoveID) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (success !== undefined)
            url_ += "success=" + encodeURIComponent("" + success) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMarketingLayoutImage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMarketingLayoutImage(response_);
                } catch (e) {
                    return <Observable<GetKadasterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetKadasterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMarketingLayoutImage(response: Response): Observable<GetKadasterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetKadasterDto.fromJS(resultData200) : new GetKadasterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetKadasterDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getMappingKadaster2(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetMappingKadasterListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetMappingKadaster2?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingKadaster2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingKadaster2(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMappingKadasterListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMappingKadasterListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingKadaster2(response: Response): Observable<PagedResultDtoOfGetMappingKadasterListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetMappingKadasterListDto.fromJS(resultData200) : new PagedResultDtoOfGetMappingKadasterListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetMappingKadasterListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByCluster(clusterID: number, projectID: number, categoryID: number): Observable<UnitByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetUnitByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByCluster(response_);
                } catch (e) {
                    return <Observable<UnitByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByCluster(response: Response): Observable<UnitByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateIsActiveMappingKadaster(projectID: number, categoryID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/UpdateIsActiveMappingKadaster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActiveMappingKadaster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActiveMappingKadaster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActiveMappingKadaster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByClusterForEdit(clusterID: number, projectID: number, categoryID: number): Observable<UnitByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetUnitByClusterForEdit?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByClusterForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByClusterForEdit(response_);
                } catch (e) {
                    return <Observable<UnitByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByClusterForEdit(response: Response): Observable<UnitByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultMappingKadasterLocation(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetDefaultMappingKadasterLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultMappingKadasterLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDefaultMappingKadasterLocation(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultMappingKadasterLocation(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownClusterByProjectCategory(projectId: number, categoryId: number): Observable<GetClusterDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetDropdownClusterByProjectCategory?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownClusterByProjectCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownClusterByProjectCategory(response_);
                } catch (e) {
                    return <Observable<GetClusterDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetClusterDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownClusterByProjectCategory(response: Response): Observable<GetClusterDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetClusterDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetClusterDropdownListDto[]>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    removeFileFromTemp(filename: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/RemoveFileFromTemp?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFileFromTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveFileFromTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFileFromTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getClusterType(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetClusterType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterType(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterType(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getTasklistMappingKadaster(projectID: number, clusterID: number, categoryID: number, renovID: number): Observable<GetTasklistMappingKadasterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetTasklistMappingKadaster?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMappingKadaster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMappingKadaster(response_);
                } catch (e) {
                    return <Observable<GetTasklistMappingKadasterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMappingKadasterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMappingKadaster(response: Response): Observable<GetTasklistMappingKadasterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistMappingKadasterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMappingKadasterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownRenovation(projectID: number): Observable<GetDropdownRenovationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/GetDropdownRenovation?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRenovation(response_);
                } catch (e) {
                    return <Observable<GetDropdownRenovationListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRenovationListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRenovation(response: Response): Observable<GetDropdownRenovationListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRenovationListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRenovationListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNewMappingKadaster(input: CreateNewMappingKadasterInputDto): Observable<CreateNewMappingKadasterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingKadaster/CreateNewMappingKadaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNewMappingKadaster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNewMappingKadaster(response_);
                } catch (e) {
                    return <Observable<CreateNewMappingKadasterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateNewMappingKadasterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateNewMappingKadaster(response: Response): Observable<CreateNewMappingKadasterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateNewMappingKadasterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateNewMappingKadasterListDto[]>(<any>null);
    }
}

@Injectable()
export class PSASMappingTemplateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMappingTemplate(input: CreateMappingTemplateInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/CreateMappingTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMappingTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMappingTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMappingTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @activeTo (optional) 
     * @htmlText (optional) 
     * @return Success
     */
    checkDataInsertIsExist(projectID: number, clusterID: number, detailID: number, docID: number, docTemplateID: number, activeFrom: moment.Moment, activeTo: moment.Moment, htmlText: string): Observable<CheckDataUpdateIsExistListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/CheckDataInsertIsExist?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (detailID === undefined || detailID === null)
            throw new Error("The parameter 'detailID' must be defined and cannot be null.");
        else
            url_ += "detailID=" + encodeURIComponent("" + detailID) + "&"; 
        if (docID === undefined || docID === null)
            throw new Error("The parameter 'docID' must be defined and cannot be null.");
        else
            url_ += "docID=" + encodeURIComponent("" + docID) + "&"; 
        if (docTemplateID === undefined || docTemplateID === null)
            throw new Error("The parameter 'docTemplateID' must be defined and cannot be null.");
        else
            url_ += "docTemplateID=" + encodeURIComponent("" + docTemplateID) + "&"; 
        if (activeFrom === undefined || activeFrom === null)
            throw new Error("The parameter 'activeFrom' must be defined and cannot be null.");
        else
            url_ += "activeFrom=" + encodeURIComponent(activeFrom ? "" + activeFrom.toJSON() : "") + "&"; 
        if (activeTo !== undefined)
            url_ += "activeTo=" + encodeURIComponent(activeTo ? "" + activeTo.toJSON() : "") + "&"; 
        if (htmlText !== undefined)
            url_ += "htmlText=" + encodeURIComponent("" + htmlText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataInsertIsExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataInsertIsExist(response_);
                } catch (e) {
                    return <Observable<CheckDataUpdateIsExistListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckDataUpdateIsExistListDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataInsertIsExist(response: Response): Observable<CheckDataUpdateIsExistListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckDataUpdateIsExistListDto.fromJS(resultData200) : new CheckDataUpdateIsExistListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckDataUpdateIsExistListDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateDataIsExist(mappingTemplateID: number, activeTo: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/UpdateDataIsExist?";
        if (mappingTemplateID === undefined || mappingTemplateID === null)
            throw new Error("The parameter 'mappingTemplateID' must be defined and cannot be null.");
        else
            url_ += "mappingTemplateID=" + encodeURIComponent("" + mappingTemplateID) + "&"; 
        if (activeTo === undefined || activeTo === null)
            throw new Error("The parameter 'activeTo' must be defined and cannot be null.");
        else
            url_ += "activeTo=" + encodeURIComponent(activeTo ? "" + activeTo.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataIsExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataIsExist(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataIsExist(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMappingTemplate(mappingTemplateID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/DeleteMappingTemplate?";
        if (mappingTemplateID === undefined || mappingTemplateID === null)
            throw new Error("The parameter 'mappingTemplateID' must be defined and cannot be null.");
        else
            url_ += "mappingTemplateID=" + encodeURIComponent("" + mappingTemplateID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMappingTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMappingTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMappingTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getMappingTemplateNew(filter: string, projectID: number, clusterID: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetMappingTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/GetMappingTemplateNew?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingTemplateNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingTemplateNew(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMappingTemplateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMappingTemplateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingTemplateNew(response: Response): Observable<PagedResultDtoOfGetMappingTemplateListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetMappingTemplateListDto.fromJS(resultData200) : new PagedResultDtoOfGetMappingTemplateListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetMappingTemplateListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getMappingTemplate(filter: string, projectID: number, clusterID: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetMappingTemplateListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/GetMappingTemplate?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingTemplate(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMappingTemplateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMappingTemplateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingTemplate(response: Response): Observable<PagedResultDtoOfGetMappingTemplateListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetMappingTemplateListDto.fromJS(resultData200) : new PagedResultDtoOfGetMappingTemplateListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetMappingTemplateListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMappingTemplate(input: CreateMappingTemplateInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/UpdateMappingTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMappingTemplate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMappingTemplate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMappingTemplate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerUpdateDataExpired(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMappingTemplate/SchedulerUpdateDataExpired";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerUpdateDataExpired(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerUpdateDataExpired(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerUpdateDataExpired(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASMarketingLayoutServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkCategoryIsExist(projectID: number, categoryID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/CheckCategoryIsExist?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckCategoryIsExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckCategoryIsExist(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckCategoryIsExist(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMarketingLayoutByCode(input: CreateMarketingLayoutInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/UpdateMarketingLayoutByCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMarketingLayoutByCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMarketingLayoutByCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMarketingLayoutByCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMarketingLayout(input: CreateMarketingLayoutInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/CreateMarketingLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMarketingLayout(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMarketingLayout(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMarketingLayout(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownCategoryByProjectUnit(projectID: number): Observable<GetDropdownCategoryByUnitListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetDropdownCategoryByProjectUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCategoryByProjectUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCategoryByProjectUnit(response_);
                } catch (e) {
                    return <Observable<GetDropdownCategoryByUnitListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCategoryByUnitListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCategoryByProjectUnit(response: Response): Observable<GetDropdownCategoryByUnitListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCategoryByUnitListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCategoryByUnitListDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getMarketingLayout2(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetMarketingLayoutListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetMarketingLayout2?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMarketingLayout2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMarketingLayout2(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMarketingLayoutListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMarketingLayoutListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMarketingLayout2(response: Response): Observable<PagedResultDtoOfGetMarketingLayoutListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetMarketingLayoutListDto.fromJS(resultData200) : new PagedResultDtoOfGetMarketingLayoutListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetMarketingLayoutListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByCluster(clusterID: number, projectID: number, categoryID: number): Observable<UnitByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetUnitByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByCluster(response_);
                } catch (e) {
                    return <Observable<UnitByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByCluster(response: Response): Observable<UnitByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateIsActiveMarketingLayout(projectID: number, categoryID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/UpdateIsActiveMarketingLayout?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIsActiveMarketingLayout(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIsActiveMarketingLayout(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIsActiveMarketingLayout(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUnitByClusterForEdit(clusterID: number, projectID: number, categoryID: number): Observable<UnitByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetUnitByClusterForEdit?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnitByClusterForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnitByClusterForEdit(response_);
                } catch (e) {
                    return <Observable<UnitByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UnitByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetUnitByClusterForEdit(response: Response): Observable<UnitByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UnitByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UnitByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultMarketingLayoutLocation(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetDefaultMarketingLayoutLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultMarketingLayoutLocation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDefaultMarketingLayoutLocation(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultMarketingLayoutLocation(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownClusterByProjectCategory(projectId: number, categoryId: number): Observable<GetClusterDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetDropdownClusterByProjectCategory?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownClusterByProjectCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownClusterByProjectCategory(response_);
                } catch (e) {
                    return <Observable<GetClusterDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetClusterDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownClusterByProjectCategory(response: Response): Observable<GetClusterDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetClusterDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetClusterDropdownListDto[]>(<any>null);
    }

    /**
     * @filename (optional) 
     * @return Success
     */
    removeFileFromTemp(filename: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/RemoveFileFromTemp?";
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveFileFromTemp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveFileFromTemp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveFileFromTemp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getClusterType(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetClusterType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterType(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterType(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getTasklistMarketingLayout(projectID: number, clusterID: number, categoryID: number, renovID: number): Observable<GetTasklistMarketingLayoutListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetTasklistMarketingLayout?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (categoryID === undefined || categoryID === null)
            throw new Error("The parameter 'categoryID' must be defined and cannot be null.");
        else
            url_ += "categoryID=" + encodeURIComponent("" + categoryID) + "&"; 
        if (renovID === undefined || renovID === null)
            throw new Error("The parameter 'renovID' must be defined and cannot be null.");
        else
            url_ += "renovID=" + encodeURIComponent("" + renovID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistMarketingLayout(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistMarketingLayout(response_);
                } catch (e) {
                    return <Observable<GetTasklistMarketingLayoutListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistMarketingLayoutListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistMarketingLayout(response: Response): Observable<GetTasklistMarketingLayoutListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistMarketingLayoutListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistMarketingLayoutListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownRenovation(projectID: number): Observable<GetDropdownRenovationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/GetDropdownRenovation?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRenovation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRenovation(response_);
                } catch (e) {
                    return <Observable<GetDropdownRenovationListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRenovationListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRenovation(response: Response): Observable<GetDropdownRenovationListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRenovationListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRenovationListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNewMarketingLayout(input: CreateNewMarketingLayoutInputDto): Observable<CreateNewMarketingLayoutListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMarketingLayout/CreateNewMarketingLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNewMarketingLayout(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNewMarketingLayout(response_);
                } catch (e) {
                    return <Observable<CreateNewMarketingLayoutListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateNewMarketingLayoutListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateNewMarketingLayout(response: Response): Observable<CreateNewMarketingLayoutListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateNewMarketingLayoutListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateNewMarketingLayoutListDto[]>(<any>null);
    }
}

@Injectable()
export class PSASMasterOLNServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTaskListMappingOfferingLetter(): Observable<GetMappingOfferingLetterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASMasterOLN/GetTaskListMappingOfferingLetter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListMappingOfferingLetter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListMappingOfferingLetter(response_);
                } catch (e) {
                    return <Observable<GetMappingOfferingLetterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMappingOfferingLetterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListMappingOfferingLetter(response: Response): Observable<GetMappingOfferingLetterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMappingOfferingLetterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMappingOfferingLetterListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMasterOLN(input: GetMappingOfferingLetterListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASMasterOLN/CreateOrUpdateMasterOLN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMasterOLN(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMasterOLN(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMasterOLN(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getOtherPaymentByBookCode(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASPaymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPayment/GetOtherPaymentByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOtherPaymentByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOtherPaymentByBookCode(response_);
                } catch (e) {
                    return <Observable<GetPSASPaymentDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPaymentDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetOtherPaymentByBookCode(response: Response): Observable<GetPSASPaymentDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPSASPaymentDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPaymentDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPaymentByBookCode(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASPaymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPayment/GetPaymentByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentByBookCode(response_);
                } catch (e) {
                    return <Observable<GetPSASPaymentDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPaymentDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentByBookCode(response: Response): Observable<GetPSASPaymentDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPSASPaymentDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPaymentDto[]>(<any>null);
    }
}

@Injectable()
export class PSASPenaltyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    createPaymentPenaltyWaive(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaive(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaive(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaive(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPaymentPenaltyWaiveForMKT(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveForMKT";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveForMKT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveForMKT(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveForMKT(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPaymentPenaltyWaiveForOCR(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveForOCR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveForOCR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveForOCR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveForOCR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createPaymentPenaltyWaiveByBookcode(bookCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveByBookcode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveByBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveByBookcode(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveByBookcode(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createPaymentPenaltyWaiveByBookcodeManual(bookCode: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveByBookcodeManual?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveByBookcodeManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveByBookcodeManual(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveByBookcodeManual(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    createPaymentPenaltyWaiveByBookcodeList(listBookCode: string[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveByBookcodeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveByBookcodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveByBookcodeList(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveByBookcodeList(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPaymentPenaltyWaiveManual(input: CreatePaymentPenaltyWaiveManualInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePaymentPenaltyWaiveManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePaymentPenaltyWaiveManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePaymentPenaltyWaiveManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePaymentPenaltyWaiveManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPenaltySchedulerSebelumTuning(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerSebelumTuning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerSebelumTuning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerSebelumTuning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerSebelumTuning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPenaltyScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltyScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltyScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltyScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltyScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPenaltySchedulerForMKT(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerForMKT";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerForMKT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerForMKT(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerForMKT(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPenaltySchedulerForOCR(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerForOCR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerForOCR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerForOCR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerForOCR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createPenaltySchedulerForWFE(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerForWFE";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerForWFE(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerForWFE(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerForWFE(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPenaltySchedulerManual(input: CreatePenaltySchedulerManualParam): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    createPenaltySchedulerManualByBookCodeList(listBookCode: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManualByBookCodeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManualByBookCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManualByBookCodeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManualByBookCodeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @cluster1 (optional) 
     * @cluster2 (optional) 
     * @cluster3 (optional) 
     * @cluster4 (optional) 
     * @return Success
     */
    schedulerPenaltyNewMKTPerCluster(cluster1: string, cluster2: string, cluster3: string, cluster4: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewMKTPerCluster?";
        if (cluster1 !== undefined)
            url_ += "cluster1=" + encodeURIComponent("" + cluster1) + "&"; 
        if (cluster2 !== undefined)
            url_ += "cluster2=" + encodeURIComponent("" + cluster2) + "&"; 
        if (cluster3 !== undefined)
            url_ += "cluster3=" + encodeURIComponent("" + cluster3) + "&"; 
        if (cluster4 !== undefined)
            url_ += "cluster4=" + encodeURIComponent("" + cluster4) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewMKTPerCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewMKTPerCluster(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewMKTPerCluster(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewMKT(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewMKT";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewMKT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewMKT(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewMKT(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewWFE(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewWFE";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewWFE(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewWFE(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewWFE(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewOCR(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewOCR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewOCR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewOCR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewOCR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewMSO(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewMSO";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewMSO(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewMSO(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewMSO(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewRHK(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewRHK";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewRHK(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewRHK(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewRHK(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewRHM(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewRHM";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewRHM(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewRHM(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewRHM(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewDST(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewDST";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewDST(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewDST(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewDST(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewFAV(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewFAV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewFAV(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewFAV(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewFAV(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewWFERest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewWFERest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewWFERest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewWFERest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewWFERest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewOCRRest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewOCRRest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewOCRRest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewOCRRest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewOCRRest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewMKTRest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewMKTRest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewMKTRest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewMKTRest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewMKTRest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerPenaltyNewMKTRestD2(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SchedulerPenaltyNewMKTRestD2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerPenaltyNewMKTRestD2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerPenaltyNewMKTRestD2(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerPenaltyNewMKTRestD2(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    createPenaltySchedulerManualByBookCodeListNew(listBookCode: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManualByBookCodeListNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManualByBookCodeListNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManualByBookCodeListNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManualByBookCodeListNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    recalculatePenaltyNew(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenaltyNew?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenaltyNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenaltyNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenaltyNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    createPenaltySchedulerManualByBookCodeListTunning(listBookCode: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManualByBookCodeListTunning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManualByBookCodeListTunning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManualByBookCodeListTunning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManualByBookCodeListTunning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailReport(input: GetDataForReportWaive[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/SendEmailReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReport(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReport(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataPenaltyView(bookCode: string, unitCode: string, unitNo: string): Observable<GetDataPenaltyViewListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/GetDataPenaltyView?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataPenaltyView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataPenaltyView(response_);
                } catch (e) {
                    return <Observable<GetDataPenaltyViewListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataPenaltyViewListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataPenaltyView(response: Response): Observable<GetDataPenaltyViewListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataPenaltyViewListDto.fromJS(resultData200) : new GetDataPenaltyViewListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataPenaltyViewListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    holdUnholdPenaltyByBookcode(bookCode: string, flag: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/HoldUnholdPenaltyByBookcode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processHoldUnholdPenaltyByBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processHoldUnholdPenaltyByBookcode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processHoldUnholdPenaltyByBookcode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    recalculatePenalty2(bookCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenalty2?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenalty2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenalty2(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenalty2(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    recalculatePenalty(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenalty?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenalty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenalty(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenalty(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCodeList (optional) 
     * @return Success
     */
    recalculatePenaltyByBookCodeList(bookCodeList: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenaltyByBookCodeList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenaltyByBookCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenaltyByBookCodeList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenaltyByBookCodeList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCodeList (optional) 
     * @projectCode (optional) 
     * @return Success
     */
    recalculatePenaltyDelete(bookCodeList: string[], projectCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenaltyDelete?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenaltyDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenaltyDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenaltyDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCodeList (optional) 
     * @return Success
     */
    recalculatePenaltyDelete2(bookCodeList: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenaltyDelete2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenaltyDelete2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenaltyDelete2(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenaltyDelete2(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    recalculatePenaltyDeleteByBookCode(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/RecalculatePenaltyDeleteByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculatePenaltyDeleteByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculatePenaltyDeleteByBookCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculatePenaltyDeleteByBookCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createPenaltySchedulerManualByBookCode(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManualByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManualByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManualByBookCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManualByBookCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createPenaltySchedulerManualByBookCodeTunning(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/CreatePenaltySchedulerManualByBookCodeTunning?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePenaltySchedulerManualByBookCodeTunning(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePenaltySchedulerManualByBookCodeTunning(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePenaltySchedulerManualByBookCodeTunning(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCodeList (optional) 
     * @return Success
     */
    prosesPenaltySP(bookCodeList: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/ProsesPenaltySP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProsesPenaltySP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProsesPenaltySP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProsesPenaltySP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkAdj(input: CheckAdjPenaltyInputDto): Observable<GetPaymentsListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPenalty/checkAdj";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckAdj(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckAdj(response_);
                } catch (e) {
                    return <Observable<GetPaymentsListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPaymentsListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckAdj(response: Response): Observable<GetPaymentsListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPaymentsListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPaymentsListDto[]>(<any>null);
    }
}

@Injectable()
export class PSASPersonalDocServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPersonalDoc(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalPersonalDocDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPersonalDoc/GetUniversalPersonalDoc?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPersonalDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPersonalDoc(response_);
                } catch (e) {
                    return <Observable<GetUniversalPersonalDocDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalPersonalDocDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPersonalDoc(response: Response): Observable<GetUniversalPersonalDocDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalPersonalDocDto.fromJS(resultData200) : new GetUniversalPersonalDocDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalPersonalDocDto>(<any>null);
    }
}

@Injectable()
export class PSASPriceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateDiscountPrice(input: CreateUpdatePriceParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/CreateUpdateDiscountPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateDiscountPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateDiscountPrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateDiscountPrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getCommisionPrice(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASPriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetCommisionPrice?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommisionPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommisionPrice(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCommisionPrice(response: Response): Observable<GetPSASPriceListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceListDto.fromJS(resultData200) : new GetPSASPriceListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getMarketingPrice(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASPriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetMarketingPrice?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMarketingPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMarketingPrice(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMarketingPrice(response: Response): Observable<GetPSASPriceListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceListDto.fromJS(resultData200) : new GetPSASPriceListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getParameter(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetParameter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParameter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParameter(response_);
                } catch (e) {
                    return <Observable<GetPSASResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetParameter(response: Response): Observable<GetPSASResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASResultDto.fromJS(resultData200) : new GetPSASResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASResultDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPSASPrice(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASPriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetPSASPrice?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASPrice(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASPrice(response: Response): Observable<GetPSASPriceListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceListDto.fromJS(resultData200) : new GetPSASPriceListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getUniversalPrice(bookCode: string, unitCode: string, unitNo: string): Observable<GetUniversalListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetUniversalPrice?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversalPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversalPrice(response_);
                } catch (e) {
                    return <Observable<GetUniversalListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUniversalListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversalPrice(response: Response): Observable<GetUniversalListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUniversalListDto.fromJS(resultData200) : new GetUniversalListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUniversalListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDiscountPrice(bookCode: string, unitCode: string, unitNo: string): Observable<GetAddDiscListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetDiscountPrice?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountPrice(response_);
                } catch (e) {
                    return <Observable<GetAddDiscListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAddDiscListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountPrice(response: Response): Observable<GetAddDiscListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAddDiscListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAddDiscListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCommisionPrice(input: UpdatePSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdateCommisionPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCommisionPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCommisionPrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCommisionPrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMarketingPrice(input: UpdatePSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdateMarketingPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMarketingPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMarketingPrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMarketingPrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePSASPrice(input: UpdatePSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdatePSASPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePSASPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePSASPrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePSASPrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailUpdateDiscountPrice(input: GetPSASParamsSendEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/SendEmailUpdateDiscountPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailUpdateDiscountPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailUpdateDiscountPrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailUpdateDiscountPrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePrice(input: UpdateTermInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GeneratePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePriceChangeTerm(input: UpdateTermInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GeneratePriceChangeTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePriceChangeTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePriceChangeTerm(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePriceChangeTerm(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeCommTermOfPayment(input: ChangeTOPCommInputDto): Observable<ChangeTermCommResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/ChangeCommTermOfPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeCommTermOfPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeCommTermOfPayment(response_);
                } catch (e) {
                    return <Observable<ChangeTermCommResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ChangeTermCommResultDto>><any>Observable.throw(response_);
        });
    }

    protected processChangeCommTermOfPayment(response: Response): Observable<ChangeTermCommResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangeTermCommResultDto.fromJS(resultData200) : new ChangeTermCommResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ChangeTermCommResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePriceUniversal(input: UpdatePSASParamsDto): Observable<GetPSASPriceUniversalListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdatePriceUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePriceUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePriceUniversal(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePriceUniversal(response: Response): Observable<GetPSASPriceUniversalListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceUniversalListDto.fromJS(resultData200) : new GetPSASPriceUniversalListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceUniversalListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePriceUniversalComm(input: UpdatePSASParamsDto): Observable<GetPSASPriceUniversalListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdatePriceUniversalComm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePriceUniversalComm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePriceUniversalComm(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePriceUniversalComm(response: Response): Observable<GetPSASPriceUniversalListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceUniversalListDto.fromJS(resultData200) : new GetPSASPriceUniversalListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceUniversalListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePriceUniversalMkt(input: UpdatePSASParamsDto): Observable<GetPSASPriceUniversalListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/UpdatePriceUniversalMkt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePriceUniversalMkt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePriceUniversalMkt(response_);
                } catch (e) {
                    return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASPriceUniversalListDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePriceUniversalMkt(response: Response): Observable<GetPSASPriceUniversalListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASPriceUniversalListDto.fromJS(resultData200) : new GetPSASPriceUniversalListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASPriceUniversalListDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDiscountPriceMKT(bookCode: string, unitCode: string, unitNo: string): Observable<GetAddDiscListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetDiscountPriceMKT?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountPriceMKT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountPriceMKT(response_);
                } catch (e) {
                    return <Observable<GetAddDiscListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAddDiscListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountPriceMKT(response: Response): Observable<GetAddDiscListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAddDiscListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAddDiscListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDiscountPriceComm(bookCode: string, unitCode: string, unitNo: string): Observable<GetAddDiscListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/GetDiscountPriceComm?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDiscountPriceComm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDiscountPriceComm(response_);
                } catch (e) {
                    return <Observable<GetAddDiscListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAddDiscListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDiscountPriceComm(response: Response): Observable<GetAddDiscListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAddDiscListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAddDiscListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateDiscountPriceMKT(input: CreateUpdatePriceParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/CreateUpdateDiscountPriceMKT";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateDiscountPriceMKT(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateDiscountPriceMKT(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateDiscountPriceMKT(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUpdateDiscountPriceComm(input: CreateUpdatePriceParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASPrice/CreateUpdateDiscountPriceComm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUpdateDiscountPriceComm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUpdateDiscountPriceComm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUpdateDiscountPriceComm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASReferralServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    checkDataReferralActive(bookCode: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/checkDataReferralActive?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataReferralActive(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataReferralActive(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataReferralActive(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    checkReferralBookingHeader(bookCode: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/checkReferralBookingHeader?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckReferralBookingHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckReferralBookingHeader(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckReferralBookingHeader(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getBeforeReferralData(bookCode: string): Observable<ReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetBeforeReferralData?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBeforeReferralData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBeforeReferralData(response_);
                } catch (e) {
                    return <Observable<ReferralDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReferralDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBeforeReferralData(response: Response): Observable<ReferralDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReferralDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReferralDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @referralMember (optional) 
     * @return Success
     */
    getReferralDataExist(bookCode: string, referralMember: string): Observable<GetOverridingReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetReferralDataExist?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (referralMember !== undefined)
            url_ += "referralMember=" + encodeURIComponent("" + referralMember) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReferralDataExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReferralDataExist(response_);
                } catch (e) {
                    return <Observable<GetOverridingReferralDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOverridingReferralDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetReferralDataExist(response: Response): Observable<GetOverridingReferralDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetOverridingReferralDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOverridingReferralDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @referralMember (optional) 
     * @return Success
     */
    getReferralData(bookCode: string, referralMember: string): Observable<ReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetReferralData?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (referralMember !== undefined)
            url_ += "referralMember=" + encodeURIComponent("" + referralMember) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReferralData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReferralData(response_);
                } catch (e) {
                    return <Observable<ReferralDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReferralDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetReferralData(response: Response): Observable<ReferralDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReferralDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReferralDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateReferal(input: ReferralMemberDto): Observable<GetDataBookingListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/UpdateReferal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateReferal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateReferal(response_);
                } catch (e) {
                    return <Observable<GetDataBookingListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataBookingListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processUpdateReferal(response: Response): Observable<GetDataBookingListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataBookingListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataBookingListDto[]>(<any>null);
    }

    /**
     * @bookno (optional) 
     * @scmCode (optional) 
     * @return Success
     */
    detailCommPaymentReferral(bookno: string, scmCode: string): Observable<GetDetailCommPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/DetailCommPaymentReferral?";
        if (bookno !== undefined)
            url_ += "bookno=" + encodeURIComponent("" + bookno) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDetailCommPaymentReferral(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDetailCommPaymentReferral(response_);
                } catch (e) {
                    return <Observable<GetDetailCommPaymentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailCommPaymentDto>><any>Observable.throw(response_);
        });
    }

    protected processDetailCommPaymentReferral(response: Response): Observable<GetDetailCommPaymentDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailCommPaymentDto.fromJS(resultData200) : new GetDetailCommPaymentDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailCommPaymentDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addMember(input: AddMemberInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/AddMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddMember(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processAddMember(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    adjustNewCommission(input: InsertOverridingReferralDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/AdjustNewCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAdjustNewCommission(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAdjustNewCommission(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAdjustNewCommission(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    calculatePPH(input: InputCalculatePPHDto): Observable<PphSimulateDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/CalculatePPH";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculatePPH(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculatePPH(response_);
                } catch (e) {
                    return <Observable<PphSimulateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PphSimulateDto>><any>Observable.throw(response_);
        });
    }

    protected processCalculatePPH(response: Response): Observable<PphSimulateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PphSimulateDto.fromJS(resultData200) : new PphSimulateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PphSimulateDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @scmCode (optional) 
     * @projectCode (optional) 
     * @clusterCode (optional) 
     * @return Success
     */
    getCommMemberOverriding(memberCode: string, scmCode: string, allowThrow: boolean, projectCode: string, clusterCode: string): Observable<GetCommMemberListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetCommMemberOverriding?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (allowThrow === undefined || allowThrow === null)
            throw new Error("The parameter 'allowThrow' must be defined and cannot be null.");
        else
            url_ += "allowThrow=" + encodeURIComponent("" + allowThrow) + "&"; 
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (clusterCode !== undefined)
            url_ += "clusterCode=" + encodeURIComponent("" + clusterCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommMemberOverriding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommMemberOverriding(response_);
                } catch (e) {
                    return <Observable<GetCommMemberListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCommMemberListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCommMemberOverriding(response: Response): Observable<GetCommMemberListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCommMemberListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCommMemberListDto[]>(<any>null);
    }

    /**
     * @bookNo (optional) 
     * @return Success
     */
    deleteExistsOverridingReferral(bookNo: string): Observable<DeleteExistsOverridingReferralResponose> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/DeleteExistsOverridingReferral?";
        if (bookNo !== undefined)
            url_ += "bookNo=" + encodeURIComponent("" + bookNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteExistsOverridingReferral(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteExistsOverridingReferral(response_);
                } catch (e) {
                    return <Observable<DeleteExistsOverridingReferralResponose>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeleteExistsOverridingReferralResponose>><any>Observable.throw(response_);
        });
    }

    protected processDeleteExistsOverridingReferral(response: Response): Observable<DeleteExistsOverridingReferralResponose> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeleteExistsOverridingReferralResponose.fromJS(resultData200) : new DeleteExistsOverridingReferralResponose();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeleteExistsOverridingReferralResponose>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getCheckReferralByBookCode(bookCode: string): Observable<GetCheckReferralResDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetCheckReferralByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckReferralByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckReferralByBookCode(response_);
                } catch (e) {
                    return <Observable<GetCheckReferralResDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckReferralResDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckReferralByBookCode(response: Response): Observable<GetCheckReferralResDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCheckReferralResDto.fromJS(resultData200) : new GetCheckReferralResDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckReferralResDto>(<any>null);
    }

    /**
     * @scmCode (optional) 
     * @referralCode (optional) 
     * @return Success
     */
    getCheckReferralCode(scmCode: string, referralCode: string): Observable<GetCheckReferralCodeResDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/GetCheckReferralCode?";
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (referralCode !== undefined)
            url_ += "referralCode=" + encodeURIComponent("" + referralCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckReferralCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckReferralCode(response_);
                } catch (e) {
                    return <Observable<GetCheckReferralCodeResDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckReferralCodeResDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckReferralCode(response: Response): Observable<GetCheckReferralCodeResDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckReferralCodeResDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckReferralCodeResDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveReferral(input: SaveReferralReqDto): Observable<SaveReferralResDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASReferral/SaveReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveReferral(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveReferral(response_);
                } catch (e) {
                    return <Observable<SaveReferralResDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaveReferralResDto>><any>Observable.throw(response_);
        });
    }

    protected processSaveReferral(response: Response): Observable<SaveReferralResDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaveReferralResDto.fromJS(resultData200) : new SaveReferralResDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaveReferralResDto>(<any>null);
    }
}

@Injectable()
export class PSASScheduleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTRBookingDetailScheduleAJB(input: CreateTRBookingDetailScheduleAJBDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/CreateTRBookingDetailScheduleAJB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTRBookingDetailScheduleAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTRBookingDetailScheduleAJB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTRBookingDetailScheduleAJB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBookingDetailSchedule(input: CreateTrBookingDetailScheduleParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/CreateTrBookingDetailSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBookingDetailSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBookingDetailSchedule(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBookingDetailSchedule(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllocationDropdown(): Observable<GetAllocationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetAllocationDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllocationDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllocationDropdown(response_);
                } catch (e) {
                    return <Observable<GetAllocationListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllocationListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllocationDropdown(response: Response): Observable<GetAllocationListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllocationListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllocationListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllocationAjbDropdown(): Observable<GetAllocationAjbListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetAllocationAjbDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllocationAjbDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllocationAjbDropdown(response_);
                } catch (e) {
                    return <Observable<GetAllocationAjbListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllocationAjbListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllocationAjbDropdown(response: Response): Observable<GetAllocationAjbListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllocationAjbListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllocationAjbListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getCompanyCodeList(bookCode: string, unitCode: string, unitNo: string): Observable<GetCompanyCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetCompanyCodeList?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCompanyCodeList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCompanyCodeList(response_);
                } catch (e) {
                    return <Observable<GetCompanyCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCompanyCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCompanyCodeList(response: Response): Observable<GetCompanyCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCompanyCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCompanyCodeListDto[]>(<any>null);
    }

    /**
     * @bookingHeaderID (optional) 
     * @return Success
     */
    getOriginalSchedule(bookingHeaderID: number): Observable<GetScheduleUniversalDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetOriginalSchedule?";
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOriginalSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOriginalSchedule(response_);
                } catch (e) {
                    return <Observable<GetScheduleUniversalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetScheduleUniversalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOriginalSchedule(response: Response): Observable<GetScheduleUniversalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetScheduleUniversalDto.fromJS(resultData200) : new GetScheduleUniversalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetScheduleUniversalDto>(<any>null);
    }

    /**
     * @bookingHeaderID (optional) 
     * @return Success
     */
    getHybridSchedule(bookingHeaderID: number): Observable<GetScheduleUniversalDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetHybridSchedule?";
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHybridSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHybridSchedule(response_);
                } catch (e) {
                    return <Observable<GetScheduleUniversalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetScheduleUniversalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHybridSchedule(response: Response): Observable<GetScheduleUniversalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetScheduleUniversalDto.fromJS(resultData200) : new GetScheduleUniversalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetScheduleUniversalDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPSASScheduleHeader(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASScheduleHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetPSASScheduleHeader?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASScheduleHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASScheduleHeader(response_);
                } catch (e) {
                    return <Observable<GetPSASScheduleHeaderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASScheduleHeaderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASScheduleHeader(response: Response): Observable<GetPSASScheduleHeaderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASScheduleHeaderDto.fromJS(resultData200) : new GetPSASScheduleHeaderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASScheduleHeaderDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getPSASScheduleAjbHeader(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASScheduleAjbHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetPSASScheduleAjbHeader?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASScheduleAjbHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASScheduleAjbHeader(response_);
                } catch (e) {
                    return <Observable<GetPSASScheduleAjbHeaderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASScheduleAjbHeaderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASScheduleAjbHeader(response: Response): Observable<GetPSASScheduleAjbHeaderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASScheduleAjbHeaderDto.fromJS(resultData200) : new GetPSASScheduleAjbHeaderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASScheduleAjbHeaderDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @coCode (optional) 
     * @return Success
     */
    getPSASScheduleDetail(bookCode: string, unitCode: string, unitNo: string, coCode: string): Observable<GetScheduleUniversalDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetPSASScheduleDetail?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASScheduleDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASScheduleDetail(response_);
                } catch (e) {
                    return <Observable<GetScheduleUniversalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetScheduleUniversalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASScheduleDetail(response: Response): Observable<GetScheduleUniversalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetScheduleUniversalDto.fromJS(resultData200) : new GetScheduleUniversalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetScheduleUniversalDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    regenerateSchedule(input: GetPSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/RegenerateSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegenerateSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegenerateSchedule(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRegenerateSchedule(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    regenerateScheduleFlat(input: GetPSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/RegenerateScheduleFlat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegenerateScheduleFlat(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegenerateScheduleFlat(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRegenerateScheduleFlat(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    recalculateBalanceNew(input: GetPSASParamsDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/RecalculateBalanceNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculateBalanceNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculateBalanceNew(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processRecalculateBalanceNew(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    recalculateBalanceListNewPEN(listBookCode: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/RecalculateBalanceListNewPEN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculateBalanceListNewPEN(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculateBalanceListNewPEN(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculateBalanceListNewPEN(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listBookCode (optional) 
     * @return Success
     */
    recalculateBalanceListNew(listBookCode: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/RecalculateBalanceListNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listBookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecalculateBalanceListNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecalculateBalanceListNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecalculateBalanceListNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentHeader(input: CreateTrPaymentHeaderInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/CreateTrPaymentHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentHeader(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentHeader(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentDetail(input: CreateTrPaymentDetailInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/CreateTrPaymentDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentDetail(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentDetail(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrPaymentDetailAlloc(input: CreateTrPaymentDetailAllocInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/CreateTrPaymentDetailAlloc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrPaymentDetailAlloc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrPaymentDetailAlloc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrPaymentDetailAlloc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateTransNo(input: GenerateTransNoInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GenerateTransNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateTransNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateTransNo(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateTransNo(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerWriteOff(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SchedulerWriteOff";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerWriteOff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerWriteOff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerWriteOff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    writeOff(input: GetPSASParamsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/WriteOff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processWriteOff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processWriteOff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processWriteOff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookingHeaderID (optional) 
     * @return Success
     */
    functionWriteOff(bookingHeaderID: number, allowThrow: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/FunctionWriteOff?";
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (allowThrow === undefined || allowThrow === null)
            throw new Error("The parameter 'allowThrow' must be defined and cannot be null.");
        else
            url_ += "allowThrow=" + encodeURIComponent("" + allowThrow) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFunctionWriteOff(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFunctionWriteOff(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processFunctionWriteOff(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDP(input: SetDPScheduleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SetDP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDPSchedule(bookCode: string, unitCode: string, unitNo: string): Observable<SetDPScheduleInputDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetDPSchedule?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDPSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDPSchedule(response_);
                } catch (e) {
                    return <Observable<SetDPScheduleInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SetDPScheduleInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDPSchedule(response: Response): Observable<SetDPScheduleInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SetDPScheduleInputDto.fromJS(resultData200) : new SetDPScheduleInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SetDPScheduleInputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setINS(input: SetINSScheduleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SetINS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetINS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetINS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetINS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getINSSchedule(bookCode: string, unitCode: string, unitNo: string): Observable<SetINSScheduleInputDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetINSSchedule?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetINSSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetINSSchedule(response_);
                } catch (e) {
                    return <Observable<SetINSScheduleInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SetINSScheduleInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetINSSchedule(response: Response): Observable<SetINSScheduleInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SetINSScheduleInputDto.fromJS(resultData200) : new SetINSScheduleInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SetINSScheduleInputDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFormulaDropdown(): Observable<GetFormulaListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetFormulaDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFormulaDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFormulaDropdown(response_);
                } catch (e) {
                    return <Observable<GetFormulaListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFormulaListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFormulaDropdown(response: Response): Observable<GetFormulaListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetFormulaListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFormulaListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerGetPoinUndian(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SchedulerGetPoinUndian";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGetPoinUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGetPoinUndian(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGetPoinUndian(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    schedulerGetPoinUndianByPsCode(input: ResultGetPSCode[]): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SchedulerGetPoinUndianByPsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGetPoinUndianByPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGetPoinUndianByPsCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGetPoinUndianByPsCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataBillingLK(siteID: number, psCode: string, unitCode: string, unitNo: string): Observable<ResultOutstandingBillingDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetDataBillingLK?";
        if (siteID === undefined || siteID === null)
            throw new Error("The parameter 'siteID' must be defined and cannot be null.");
        else
            url_ += "siteID=" + encodeURIComponent("" + siteID) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataBillingLK(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataBillingLK(response_);
                } catch (e) {
                    return <Observable<ResultOutstandingBillingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultOutstandingBillingDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataBillingLK(response: Response): Observable<ResultOutstandingBillingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultOutstandingBillingDto.fromJS(resultData200) : new ResultOutstandingBillingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultOutstandingBillingDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getValidateLoginLK(input: any[]): Observable<GetListCustomerDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/GetValidateLoginLK?";
        if (input !== undefined)
            input && input.forEach((item, index) => { 
                for (let attr in item)
                    url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetValidateLoginLK(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetValidateLoginLK(response_);
                } catch (e) {
                    return <Observable<GetListCustomerDataDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListCustomerDataDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetValidateLoginLK(response: Response): Observable<GetListCustomerDataDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListCustomerDataDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListCustomerDataDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerBackupPoinUndian(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSchedule/SchedulerBackupPoinUndian";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerBackupPoinUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerBackupPoinUndian(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerBackupPoinUndian(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class PSASScheduleAJBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @coCode (optional) 
     * @return Success
     */
    getPSASScheduleDetailAJB(bookCode: string, unitCode: string, unitNo: string, coCode: string): Observable<GetScheduleAJBUniversalDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASScheduleAJB/GetPSASScheduleDetailAJB?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPSASScheduleDetailAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPSASScheduleDetailAJB(response_);
                } catch (e) {
                    return <Observable<GetScheduleAJBUniversalDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetScheduleAJBUniversalDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPSASScheduleDetailAJB(response: Response): Observable<GetScheduleAJBUniversalDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetScheduleAJBUniversalDto.fromJS(resultData200) : new GetScheduleAJBUniversalDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetScheduleAJBUniversalDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getIsPaidParameter(bookCode: string): Observable<GetPSASIsPaidParameterDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASScheduleAJB/GetIsPaidParameter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIsPaidParameter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIsPaidParameter(response_);
                } catch (e) {
                    return <Observable<GetPSASIsPaidParameterDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASIsPaidParameterDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIsPaidParameter(response: Response): Observable<GetPSASIsPaidParameterDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASIsPaidParameterDto.fromJS(resultData200) : new GetPSASIsPaidParameterDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASIsPaidParameterDto>(<any>null);
    }
}

@Injectable()
export class PSASSignedDocumentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSignedDocumentKP(input: UploadSignedDocumentKPInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/UploadSignedDocumentKP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSignedDocumentKP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSignedDocumentKP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSignedDocumentKP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSignedDocumentIMB(input: UploadSignedDocumentIMBInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/UploadSignedDocumentIMB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSignedDocumentIMB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSignedDocumentIMB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSignedDocumentIMB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadSignedDocument(input: UploadSignedDocumentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/UploadSignedDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadSignedDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadSignedDocument(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadSignedDocument(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    syncPersonal(psCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/SyncPersonal?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncPersonal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncPersonal(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processSyncPersonal(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @docCode (optional) 
     * @return Success
     */
    generateDataHandOver(bookingHeaderID: number, docCode: string): Observable<InsertHandOverDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GenerateDataHandOver?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (docCode !== undefined)
            url_ += "docCode=" + encodeURIComponent("" + docCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateDataHandOver(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateDataHandOver(response_);
                } catch (e) {
                    return <Observable<InsertHandOverDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InsertHandOverDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateDataHandOver(response: Response): Observable<InsertHandOverDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InsertHandOverDto.fromJS(resultData200) : new InsertHandOverDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InsertHandOverDto>(<any>null);
    }

    /**
     * @handOver (optional) 
     * @return Success
     */
    syncHandOverData(handOver: InsertHandOverDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/SyncHandOverData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(handOver);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncHandOverData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncHandOverData(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSyncHandOverData(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @docNo (optional) 
     * @return Success
     */
    getDocNoDropdown(docNo: string): Observable<GetDocNoDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetDocNoDropdown?";
        if (docNo !== undefined)
            url_ += "docNo=" + encodeURIComponent("" + docNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocNoDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocNoDropdown(response_);
                } catch (e) {
                    return <Observable<GetDocNoDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocNoDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDocNoDropdown(response: Response): Observable<GetDocNoDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDocNoDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocNoDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailBookingDocument(bookingDocumentID: number): Observable<GetDetailBookingDocumentListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetDetailBookingDocument?";
        if (bookingDocumentID === undefined || bookingDocumentID === null)
            throw new Error("The parameter 'bookingDocumentID' must be defined and cannot be null.");
        else
            url_ += "bookingDocumentID=" + encodeURIComponent("" + bookingDocumentID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingDocument(response_);
                } catch (e) {
                    return <Observable<GetDetailBookingDocumentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailBookingDocumentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingDocument(response: Response): Observable<GetDetailBookingDocumentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailBookingDocumentListDto.fromJS(resultData200) : new GetDetailBookingDocumentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailBookingDocumentListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getBookingDocumentWithSignature(filter: string, sorting: string, maxResultCount: number, skipCount: number, projectID: number, clusterID: number): Observable<PagedResultDtoOfGetDetailBookingDocumentListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetBookingDocumentWithSignature?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingDocumentWithSignature(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingDocumentWithSignature(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDetailBookingDocumentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDetailBookingDocumentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingDocumentWithSignature(response: Response): Observable<PagedResultDtoOfGetDetailBookingDocumentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDetailBookingDocumentListDto.fromJS(resultData200) : new PagedResultDtoOfGetDetailBookingDocumentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetDetailBookingDocumentListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getBookingDocumentWithSignatureOld(filter: string, sorting: string, maxResultCount: number, skipCount: number, projectID: number, clusterID: number): Observable<PagedResultDtoOfGetDetailBookingDocumentListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetBookingDocumentWithSignatureOld?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookingDocumentWithSignatureOld(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookingDocumentWithSignatureOld(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDetailBookingDocumentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDetailBookingDocumentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetBookingDocumentWithSignatureOld(response: Response): Observable<PagedResultDtoOfGetDetailBookingDocumentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDetailBookingDocumentListDto.fromJS(resultData200) : new PagedResultDtoOfGetDetailBookingDocumentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetDetailBookingDocumentListDto>(<any>null);
    }

    /**
     * @listProject (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    getLookUpBookingDoc(listProject: number[], accountID: number, projectID: number, startDate: moment.Moment, endDate: moment.Moment, bookCode: string, psCode: string, unitID: number, unitCodeID: number): Observable<GetDataBookCodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetLookUpBookingDoc?";
        if (listProject !== undefined)
            listProject && listProject.forEach(item => { url_ += "listProject=" + encodeURIComponent("" + item) + "&"; });
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined and cannot be null.");
        else
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLookUpBookingDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLookUpBookingDoc(response_);
                } catch (e) {
                    return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataBookCodeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetLookUpBookingDoc(response: Response): Observable<GetDataBookCodeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataBookCodeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataBookCodeListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropDownDocAdd(): Observable<GetDropDownDocAdd[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetDropDownDocAdd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropDownDocAdd(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropDownDocAdd(response_);
                } catch (e) {
                    return <Observable<GetDropDownDocAdd[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropDownDocAdd[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropDownDocAdd(response: Response): Observable<GetDropDownDocAdd[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropDownDocAdd.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropDownDocAdd[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadAddendumDoc(input: UploadAddendumDocInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/UploadAddendumDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadAddendumDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadAddendumDoc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadAddendumDoc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    sizeUploadAddendum(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/SizeUploadAddendum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSizeUploadAddendum(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSizeUploadAddendum(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processSizeUploadAddendum(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @return Success
     */
    getDropdownBookingDoc(bookcode: string, generateBySystem: boolean): Observable<GetDetailDocDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSignedDocument/GetDropdownBookingDoc?";
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        if (generateBySystem === undefined || generateBySystem === null)
            throw new Error("The parameter 'generateBySystem' must be defined and cannot be null.");
        else
            url_ += "generateBySystem=" + encodeURIComponent("" + generateBySystem) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownBookingDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownBookingDoc(response_);
                } catch (e) {
                    return <Observable<GetDetailDocDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailDocDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownBookingDoc(response: Response): Observable<GetDetailDocDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailDocDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailDocDto[]>(<any>null);
    }
}

@Injectable()
export class PSASSSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    generateSSPScheduller(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GenerateSSPScheduller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateSSPScheduller(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateSSPScheduller(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateSSPScheduller(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    calculateSSP(month: number, year: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/CalculateSSP?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculateSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculateSSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCalculateSSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @return Success
     */
    calculateSSPPerBookcode(month: number, year: number, bookcode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/CalculateSSPPerBookcode?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculateSSPPerBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculateSSPPerBookcode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCalculateSSPPerBookcode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownMonth(): Observable<GetDropdownMonth[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDropdownMonth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownMonth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownMonth(response_);
                } catch (e) {
                    return <Observable<GetDropdownMonth[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownMonth[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownMonth(response: Response): Observable<GetDropdownMonth[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownMonth.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownMonth[]>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @return Success
     */
    getDropdownYear(bookcode: string, month: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDropdownYear?";
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownYear(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownYear(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownYear(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @month (optional) 
     * @year (optional) 
     * @return Success
     */
    getDropdownCocode(month: number, year: number): Observable<GetDropdownCocodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDropdownCocode?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCocode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCocode(response_);
                } catch (e) {
                    return <Observable<GetDropdownCocodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCocodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCocode(response: Response): Observable<GetDropdownCocodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCocodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCocodeDto[]>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @month (optional) 
     * @year (optional) 
     * @return Success
     */
    getDataSSPDetailPerBookcode(bookcode: string, month: number, year: number): Observable<GetDataSSPDetail> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDataSSPDetailPerBookcode?";
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSSPDetailPerBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSSPDetailPerBookcode(response_);
                } catch (e) {
                    return <Observable<GetDataSSPDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSSPDetail>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSSPDetailPerBookcode(response: Response): Observable<GetDataSSPDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataSSPDetail.fromJS(resultData200) : new GetDataSSPDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSSPDetail>(<any>null);
    }

    /**
     * @coCode (optional) 
     * @month (optional) 
     * @year (optional) 
     * @return Success
     */
    getDataSSPDetailPerMonth(coCode: string, month: number, year: number): Observable<GetDataSSPDetail> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDataSSPDetailPerMonth?";
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSSPDetailPerMonth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSSPDetailPerMonth(response_);
                } catch (e) {
                    return <Observable<GetDataSSPDetail>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSSPDetail>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSSPDetailPerMonth(response: Response): Observable<GetDataSSPDetail> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataSSPDetail.fromJS(resultData200) : new GetDataSSPDetail();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSSPDetail>(<any>null);
    }

    /**
     * @month (optional) 
     * @year (optional) 
     * @coCode (optional) 
     * @return Success
     */
    getDataSSPReportPerMonth(month: number, year: number, coCode: string): Observable<GetDataSSPReport> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDataSSPReportPerMonth?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSSPReportPerMonth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSSPReportPerMonth(response_);
                } catch (e) {
                    return <Observable<GetDataSSPReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSSPReport>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSSPReportPerMonth(response: Response): Observable<GetDataSSPReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataSSPReport.fromJS(resultData200) : new GetDataSSPReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSSPReport>(<any>null);
    }

    /**
     * @month (optional) 
     * @year (optional) 
     * @bookcode (optional) 
     * @return Success
     */
    getDataSSPReportPerBookcode(month: number, year: number, bookcode: string): Observable<GetDataSSPReport> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetDataSSPReportPerBookcode?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSSPReportPerBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSSPReportPerBookcode(response_);
                } catch (e) {
                    return <Observable<GetDataSSPReport>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSSPReport>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSSPReportPerBookcode(response: Response): Observable<GetDataSSPReport> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataSSPReport.fromJS(resultData200) : new GetDataSSPReport();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSSPReport>(<any>null);
    }

    /**
     * @month (optional) 
     * @year (optional) 
     * @coCode (optional) 
     * @return Success
     */
    generateReportSSPPerMonth(month: number, year: number, coCode: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GenerateReportSSPPerMonth?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (coCode !== undefined)
            url_ += "coCode=" + encodeURIComponent("" + coCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportSSPPerMonth(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportSSPPerMonth(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportSSPPerMonth(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @month (optional) 
     * @year (optional) 
     * @bookcode (optional) 
     * @return Success
     */
    generateReportSSPPerBookcode(month: number, year: number, bookcode: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GenerateReportSSPPerBookcode?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportSSPPerBookcode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportSSPPerBookcode(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportSSPPerBookcode(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getListSSP(bookCode: string): Observable<GetListSSPResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSP/GetListSSP?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListSSP(response_);
                } catch (e) {
                    return <Observable<GetListSSPResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListSSPResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListSSP(response: Response): Observable<GetListSSPResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListSSPResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListSSPResultDto[]>(<any>null);
    }
}

@Injectable()
export class PSASSSPNewServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerGenerateNewSSP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/SchedulerGenerateNewSSP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateNewSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateNewSSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateNewSSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    generateNewSSPManual(month: number, year: number, projectID: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/GenerateNewSSPManual?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&"; 
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateNewSSPManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateNewSSPManual(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateNewSSPManual(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    tasklistSSP(input: TasklistNewSSPInputDto): Observable<PagedResultDtoOfTasklistNewSSPDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/TasklistSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTasklistSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTasklistSSP(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTasklistNewSSPDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTasklistNewSSPDto>><any>Observable.throw(response_);
        });
    }

    protected processTasklistSSP(response: Response): Observable<PagedResultDtoOfTasklistNewSSPDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTasklistNewSSPDto.fromJS(resultData200) : new PagedResultDtoOfTasklistNewSSPDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTasklistNewSSPDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSSP(sspMainID: number): Observable<DetailNewSSPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/GetDetailSSP?";
        if (sspMainID === undefined || sspMainID === null)
            throw new Error("The parameter 'sspMainID' must be defined and cannot be null.");
        else
            url_ += "sspMainID=" + encodeURIComponent("" + sspMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSSP(response_);
                } catch (e) {
                    return <Observable<DetailNewSSPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DetailNewSSPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSSP(response: Response): Observable<DetailNewSSPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DetailNewSSPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DetailNewSSPDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFileSSP(sspMainID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/GetFileSSP?";
        if (sspMainID === undefined || sspMainID === null)
            throw new Error("The parameter 'sspMainID' must be defined and cannot be null.");
        else
            url_ += "sspMainID=" + encodeURIComponent("" + sspMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFileSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFileSSP(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetFileSSP(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadFileSSP(input: UploadSSPNewDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/UploadFileSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadFileSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadFileSSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadFileSSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    listDataSSP(input: GetListSSPDto): Observable<PagedResultDtoOfListSSPDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/ListDataSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListDataSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListDataSSP(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfListSSPDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfListSSPDto>><any>Observable.throw(response_);
        });
    }

    protected processListDataSSP(response: Response): Observable<PagedResultDtoOfListSSPDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfListSSPDto.fromJS(resultData200) : new PagedResultDtoOfListSSPDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfListSSPDto>(<any>null);
    }

    /**
     * @fileName (optional) 
     * @return Success
     */
    uploadZipFile(fileName: string): Observable<FileNameZipUpload[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/uploadZipFile?";
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadZipFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadZipFile(response_);
                } catch (e) {
                    return <Observable<FileNameZipUpload[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileNameZipUpload[]>><any>Observable.throw(response_);
        });
    }

    protected processUploadZipFile(response: Response): Observable<FileNameZipUpload[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FileNameZipUpload.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileNameZipUpload[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertBulkSSP(input: GenerateNewBulkSSPDataHeader[]): Observable<ResponseUploadBulkSSPDTO> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/insertBulkSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertBulkSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertBulkSSP(response_);
                } catch (e) {
                    return <Observable<ResponseUploadBulkSSPDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseUploadBulkSSPDTO>><any>Observable.throw(response_);
        });
    }

    protected processInsertBulkSSP(response: Response): Observable<ResponseUploadBulkSSPDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseUploadBulkSSPDTO.fromJS(resultData200) : new ResponseUploadBulkSSPDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseUploadBulkSSPDTO>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDetailBulkSSP(input: ListSSPDto): Observable<ListSSPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/getDetailBulkSSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBulkSSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBulkSSP(response_);
                } catch (e) {
                    return <Observable<ListSSPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListSSPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBulkSSP(response: Response): Observable<ListSSPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ListSSPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListSSPDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadCSV(input: ListSSPDto[]): Observable<ResponseUploadBulkSSPDTO> {
        let url_ = this.baseUrl + "/api/services/app/PSASSSPNew/uploadCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadCSV(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadCSV(response_);
                } catch (e) {
                    return <Observable<ResponseUploadBulkSSPDTO>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponseUploadBulkSSPDTO>><any>Observable.throw(response_);
        });
    }

    protected processUploadCSV(response: Response): Observable<ResponseUploadBulkSSPDTO> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponseUploadBulkSSPDTO.fromJS(resultData200) : new ResponseUploadBulkSSPDTO();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponseUploadBulkSSPDTO>(<any>null);
    }
}

@Injectable()
export class PSASSuratPeringatanServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBookCodeSP(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/GetBookCodeSP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBookCodeSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBookCodeSP(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBookCodeSP(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createSuratPeringatanPenaltySchedulerLCBookCode(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/CreateSuratPeringatanPenaltySchedulerLCBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSuratPeringatanPenaltySchedulerLCBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSuratPeringatanPenaltySchedulerLCBookCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSuratPeringatanPenaltySchedulerLCBookCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createSuratPeringatanPenaltySchedulerLC(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/CreateSuratPeringatanPenaltySchedulerLC";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSuratPeringatanPenaltySchedulerLC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSuratPeringatanPenaltySchedulerLC(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSuratPeringatanPenaltySchedulerLC(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    createSuratPeringatanPenaltySchedulerNew(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/CreateSuratPeringatanPenaltySchedulerNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSuratPeringatanPenaltySchedulerNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSuratPeringatanPenaltySchedulerNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSuratPeringatanPenaltySchedulerNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    createSuratPeringatanPenaltyManual(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/CreateSuratPeringatanPenaltyManual?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSuratPeringatanPenaltyManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSuratPeringatanPenaltyManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSuratPeringatanPenaltyManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerUpdateFullyPaid(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/schedulerUpdateFullyPaid?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerUpdateFullyPaid(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerUpdateFullyPaid(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerUpdateFullyPaid(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @dataPenaltySchedule (optional) 
     * @return Success
     */
    schedulerSP(dataPenaltySchedule: GetDataSuratPeringatanListDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/schedulerSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataPenaltySchedule);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getDataSuratPeringatanPenaltyView(bookCode: string, unitCode: string, unitNo: string): Observable<GetDataSuratPeringatanPenaltyViewListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/GetDataSuratPeringatanPenaltyView?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataSuratPeringatanPenaltyView(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataSuratPeringatanPenaltyView(response_);
                } catch (e) {
                    return <Observable<GetDataSuratPeringatanPenaltyViewListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataSuratPeringatanPenaltyViewListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataSuratPeringatanPenaltyView(response: Response): Observable<GetDataSuratPeringatanPenaltyViewListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataSuratPeringatanPenaltyViewListDto.fromJS(resultData200) : new GetDataSuratPeringatanPenaltyViewListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataSuratPeringatanPenaltyViewListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailSPLC(input: GetDataSendEmailSPDto[]): Observable<GetDataForReportSP> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSPLC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSPLC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSPLC(response_);
                } catch (e) {
                    return <Observable<GetDataForReportSP>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataForReportSP>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSPLC(response: Response): Observable<GetDataForReportSP> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataForReportSP.fromJS(resultData200) : new GetDataForReportSP();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataForReportSP>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateBarcodeBlashEmail(input: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/GenerateBarcodeBlashEmail?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateBarcodeBlashEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateBarcodeBlashEmail(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateBarcodeBlashEmail(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @subject (optional) 
     * @return Success
     */
    blashEmailNatalMSU(projectID: number, subject: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/BlashEmailNatalMSU?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlashEmailNatalMSU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlashEmailNatalMSU(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlashEmailNatalMSU(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailTiketPP(input: TiketPPOnline): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailTiketPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailTiketPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailTiketPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailTiketPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailSP(input: GetDataSendEmailSPDto[]): Observable<GetDataForReportSP> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSP(response_);
                } catch (e) {
                    return <Observable<GetDataForReportSP>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataForReportSP>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSP(response: Response): Observable<GetDataForReportSP> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataForReportSP.fromJS(resultData200) : new GetDataForReportSP();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataForReportSP>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailSPSchedulerLC(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSPSchedulerLC";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSPSchedulerLC(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSPSchedulerLC(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSPSchedulerLC(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailSPScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSPScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSPScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSPScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSPScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailSPSchedulerDate(date: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSPSchedulerDate?";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSPSchedulerDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSPSchedulerDate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSPSchedulerDate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerSendEmailSPLetterNo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SchedulerSendEmailSPLetterNo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSendEmailSPLetterNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSendEmailSPLetterNo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSendEmailSPLetterNo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @letterNo (optional) 
     * @return Success
     */
    sendEmailSPSchedulerLetterNo(letterNo: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailSPSchedulerLetterNo?";
        if (letterNo !== undefined)
            url_ += "letterNo=" + encodeURIComponent("" + letterNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSPSchedulerLetterNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSPSchedulerLetterNo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSPSchedulerLetterNo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    pemutihanScheduller(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/PemutihanScheduller";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPemutihanScheduller(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPemutihanScheduller(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPemutihanScheduller(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailReminderPaymentScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailReminderPaymentScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReminderPaymentScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReminderPaymentScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReminderPaymentScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @inputEmail (optional) 
     * @return Success
     */
    sendEmailReminderPaymentManual(bookCode: string, inputEmail: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailReminderPaymentManual?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (inputEmail !== undefined)
            url_ += "inputEmail=" + encodeURIComponent("" + inputEmail) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReminderPaymentManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReminderPaymentManual(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReminderPaymentManual(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendWhatsAppReminderPaymentScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendWhatsAppReminderPaymentScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendWhatsAppReminderPaymentScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendWhatsAppReminderPaymentScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendWhatsAppReminderPaymentScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    sendWhatsAppReminderPaymentManual(bookCode: string[]): Observable<WhatsAppSendResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendWhatsAppReminderPaymentManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCode);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendWhatsAppReminderPaymentManual(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendWhatsAppReminderPaymentManual(response_);
                } catch (e) {
                    return <Observable<WhatsAppSendResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<WhatsAppSendResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSendWhatsAppReminderPaymentManual(response: Response): Observable<WhatsAppSendResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? WhatsAppSendResultDto.fromJS(resultData200) : new WhatsAppSendResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<WhatsAppSendResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendWAonWoowa(input: WhatsAppInputDto): Observable<RootResponseWoowa> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendWAonWoowa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendWAonWoowa(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendWAonWoowa(response_);
                } catch (e) {
                    return <Observable<RootResponseWoowa>><any>Observable.throw(e);
                }
            } else
                return <Observable<RootResponseWoowa>><any>Observable.throw(response_);
        });
    }

    protected processSendWAonWoowa(response: Response): Observable<RootResponseWoowa> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RootResponseWoowa.fromJS(resultData200) : new RootResponseWoowa();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RootResponseWoowa>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendWhatsApp(input: WhatsAppInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendWhatsApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendWhatsApp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendWhatsApp(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processSendWhatsApp(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    sendSMSReminderPaymentScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendSMSReminderPaymentScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMSReminderPaymentScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMSReminderPaymentScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendSMSReminderPaymentScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailReportRP(input: GetDataForReportRP): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailReportRP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReportRP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReportRP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReportRP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailReportSP(input: GetDataForReportSP): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SendEmailReportSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailReportSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailReportSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailReportSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerEmailBAST(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SchedulerEmailBAST";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerEmailBAST(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerEmailBAST(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerEmailBAST(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    schedulerEmailBASTParam(input: InputParamBalstBAST): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASSuratPeringatan/SchedulerEmailBASTParam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerEmailBASTParam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerEmailBASTParam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerEmailBASTParam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PSASTermServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getTermByBookCode(bookCode: string, unitCode: string, unitNo: string): Observable<GetPSASTermDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/GetTermByBookCode?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermByBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermByBookCode(response_);
                } catch (e) {
                    return <Observable<GetPSASTermDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPSASTermDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermByBookCode(response: Response): Observable<GetPSASTermDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPSASTermDto.fromJS(resultData200) : new GetPSASTermDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPSASTermDto>(<any>null);
    }

    /**
     * @return Success
     */
    getMsBankCodeDropDown(): Observable<ListResultDtoOfGetBankCodeDropDownListDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/GetMsBankCodeDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMsBankCodeDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMsBankCodeDropDown(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetBankCodeDropDownListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetBankCodeDropDownListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMsBankCodeDropDown(response: Response): Observable<ListResultDtoOfGetBankCodeDropDownListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetBankCodeDropDownListDto.fromJS(resultData200) : new ListResultDtoOfGetBankCodeDropDownListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetBankCodeDropDownListDto>(<any>null);
    }

    /**
     * @termCode (optional) 
     * @return Success
     */
    getTermByCodeDropdown(termCode: string): Observable<GetMsTermByTermCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/GetTermByCodeDropdown?";
        if (termCode !== undefined)
            url_ += "termCode=" + encodeURIComponent("" + termCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermByCodeDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermByCodeDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsTermByTermCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsTermByTermCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTermByCodeDropdown(response: Response): Observable<GetMsTermByTermCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsTermByTermCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsTermByTermCodeDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @unitCode (optional) 
     * @unitNo (optional) 
     * @return Success
     */
    getTermBookingItemPriceDropdown(bookCode: string, unitCode: string, unitNo: string): Observable<GetMsTermByTermCodeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/GetTermBookingItemPriceDropdown?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (unitCode !== undefined)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&"; 
        if (unitNo !== undefined)
            url_ += "unitNo=" + encodeURIComponent("" + unitNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermBookingItemPriceDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermBookingItemPriceDropdown(response_);
                } catch (e) {
                    return <Observable<GetMsTermByTermCodeDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMsTermByTermCodeDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTermBookingItemPriceDropdown(response: Response): Observable<GetMsTermByTermCodeDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetMsTermByTermCodeDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMsTermByTermCodeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTermPmt(termID: number): Observable<GetTermPmtByTermIdDto> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/GetTermPmt?";
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermPmt(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermPmt(response_);
                } catch (e) {
                    return <Observable<GetTermPmtByTermIdDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTermPmtByTermIdDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTermPmt(response: Response): Observable<GetTermPmtByTermIdDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTermPmtByTermIdDto.fromJS(resultData200) : new GetTermPmtByTermIdDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTermPmtByTermIdDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTerm(input: UpdateTermInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/UpdateTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTerm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTerm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertSlikChecking(input: Step19InsertSlikCheckingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/InsertSlikChecking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertSlikChecking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertSlikChecking(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertSlikChecking(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateBookingDetailAddDisc(unitID: number, termID: number): Observable<AddDisc[]> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/UpdateBookingDetailAddDisc?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBookingDetailAddDisc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBookingDetailAddDisc(response_);
                } catch (e) {
                    return <Observable<AddDisc[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<AddDisc[]>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBookingDetailAddDisc(response: Response): Observable<AddDisc[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AddDisc.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AddDisc[]>(<any>null);
    }

    /**
     * @return Success
     */
    updateBookingDetailDP(unitID: number, termID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PSASTerm/UpdateBookingDetailDP?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBookingDetailDP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBookingDetailDP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBookingDetailDP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class RefundPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @pPNo (optional) 
     * @return Success
     */
    getDetailPPNo(pPNo: string): Observable<GetDetailPPNoResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetDetailPPNo?";
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailPPNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailPPNo(response_);
                } catch (e) {
                    return <Observable<GetDetailPPNoResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailPPNoResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailPPNo(response: Response): Observable<GetDetailPPNoResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailPPNoResultDto.fromJS(resultData200) : new GetDetailPPNoResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailPPNoResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListRefundReason(): Observable<GetListRefundReasonResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetListRefundReason";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRefundReason(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRefundReason(response_);
                } catch (e) {
                    return <Observable<GetListRefundReasonResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRefundReasonResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRefundReason(response: Response): Observable<GetListRefundReasonResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRefundReasonResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRefundReasonResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createRefundPP(input: CreateRefundPPInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/CreateRefundPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateRefundPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateRefundPP(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateRefundPP(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailRefund(input: SendEmailRefundPPInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/SendEmailRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailRefund(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailRefund(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    updateRefund(pPNoID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/UpdateRefund?";
        if (pPNoID === undefined || pPNoID === null)
            throw new Error("The parameter 'pPNoID' must be defined and cannot be null.");
        else
            url_ += "PPNoID=" + encodeURIComponent("" + pPNoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRefund(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRefund(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePreviewRefund(input: GeneratePreviewRefundInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GeneratePreviewRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePreviewRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePreviewRefund(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePreviewRefund(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getListRefundHistory(): Observable<GetListRefundHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetListRefundHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRefundHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRefundHistory(response_);
                } catch (e) {
                    return <Observable<GetListRefundHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRefundHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRefundHistory(response: Response): Observable<GetListRefundHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRefundHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRefundHistoryResultDto[]>(<any>null);
    }

    /**
     * @psOrPP (optional) 
     * @return Success
     */
    getListRefundHistoryBySearch(psOrPP: string): Observable<GetListRefundHistoryResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetListRefundHistoryBySearch?";
        if (psOrPP !== undefined)
            url_ += "psOrPP=" + encodeURIComponent("" + psOrPP) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListRefundHistoryBySearch(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListRefundHistoryBySearch(response_);
                } catch (e) {
                    return <Observable<GetListRefundHistoryResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRefundHistoryResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListRefundHistoryBySearch(response: Response): Observable<GetListRefundHistoryResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListRefundHistoryResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRefundHistoryResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    printFormPembatalan(pPRefundID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/PrintFormPembatalan?";
        if (pPRefundID === undefined || pPRefundID === null)
            throw new Error("The parameter 'pPRefundID' must be defined and cannot be null.");
        else
            url_ += "PPRefundID=" + encodeURIComponent("" + pPRefundID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintFormPembatalan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintFormPembatalan(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintFormPembatalan(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @refundDateFrom (optional) 
     * @refundDateEnd (optional) 
     * @schema (optional) 
     * @customerName (optional) 
     * @return Success
     */
    getReportRefund(refundDateFrom: string, refundDateEnd: string, schema: string, customerName: string, userID: number): Observable<ReportRefundResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetReportRefund?";
        if (refundDateFrom !== undefined)
            url_ += "refundDateFrom=" + encodeURIComponent("" + refundDateFrom) + "&"; 
        if (refundDateEnd !== undefined)
            url_ += "refundDateEnd=" + encodeURIComponent("" + refundDateEnd) + "&"; 
        if (schema !== undefined)
            url_ += "schema=" + encodeURIComponent("" + schema) + "&"; 
        if (customerName !== undefined)
            url_ += "customerName=" + encodeURIComponent("" + customerName) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReportRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReportRefund(response_);
                } catch (e) {
                    return <Observable<ReportRefundResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReportRefundResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetReportRefund(response: Response): Observable<ReportRefundResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReportRefundResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReportRefundResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCheckboxDisplayedFieldRefund(): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GetCheckboxDisplayedFieldRefund";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCheckboxDisplayedFieldRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCheckboxDisplayedFieldRefund(response_);
                } catch (e) {
                    return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCheckBoxDisplayedFieldResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCheckboxDisplayedFieldRefund(response: Response): Observable<GetCheckBoxDisplayedFieldResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCheckBoxDisplayedFieldResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportRefundPdf(input: GetReportRefundPdfInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GenerateReportRefundPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportRefundPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportRefundPdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportRefundPdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportRefund(input: GetReportRefundPdfInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundPP/GenerateExcelReportRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportRefund(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportRefund(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportRefund(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class ReminderPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    reminderPaymentTermCashScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/ReminderPaymentTermCashScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReminderPaymentTermCashScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReminderPaymentTermCashScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processReminderPaymentTermCashScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    autoChangeTermScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/AutoChangeTermScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAutoChangeTermScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAutoChangeTermScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAutoChangeTermScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    autoChangeTermReportScheduler(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/AutoChangeTermReportScheduler";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAutoChangeTermReportScheduler(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAutoChangeTermReportScheduler(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAutoChangeTermReportScheduler(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDocAmandement(input: CreateBookingDocumentInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/CreateDocAmandement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDocAmandement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDocAmandement(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateDocAmandement(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generateDocumentParameter(bookCode: string): Observable<P32DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/GenerateDocumentParameter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateDocumentParameter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateDocumentParameter(response_);
                } catch (e) {
                    return <Observable<P32DocumentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<P32DocumentDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateDocumentParameter(response: Response): Observable<P32DocumentDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? P32DocumentDto.fromJS(resultData200) : new P32DocumentDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<P32DocumentDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getAmandementNumber(bookCode: string): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/GetAmandementNumber?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAmandementNumber(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAmandementNumber(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetAmandementNumber(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    generateKP(orderID: number, unitID: number): Observable<GenerateKPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/GenerateKP?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateKP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateKP(response_);
                } catch (e) {
                    return <Observable<GenerateKPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateKPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateKP(response: Response): Observable<GenerateKPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateKPResultDto.fromJS(resultData200) : new GenerateKPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateKPResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailSummary(projectID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/ReminderPayment/SendEmailSummary?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailSummary(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailSummary(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class ReportBookingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getListReportBooking(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportBooking/GetListReportBooking";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportBooking(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportBooking(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bookingReport(input: GetBookingReportInputDto): Observable<GetListReportBookingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportBooking/BookingReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBookingReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBookingReport(response_);
                } catch (e) {
                    return <Observable<GetListReportBookingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListReportBookingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processBookingReport(response: Response): Observable<GetListReportBookingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListReportBookingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListReportBookingDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFieldName(): Observable<GetListHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportBooking/GetFieldName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFieldName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFieldName(response_);
                } catch (e) {
                    return <Observable<GetListHeaderDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListHeaderDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetFieldName(response: Response): Observable<GetListHeaderDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListHeaderDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListHeaderDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportBooking(input: GetBookingReportPdfInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportBooking/GenerateExcelReportBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportBooking(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportBooking(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateReportBookingPdf(input: GetBookingReportPdfInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportBooking/GenerateReportBookingPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportBookingPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportBookingPdf(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportBookingPdf(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class ReportGenevaServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    listReportGeneva(): Observable<ListResultDtoOfResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ListReportGeneva";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListReportGeneva(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListReportGeneva(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processListReportGeneva(response: Response): Observable<ListResultDtoOfResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfResponUrlGenevaDto.fromJS(resultData200) : new ListResultDtoOfResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaSalesPerProjectAllSchema(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaSalesPerProjectAllSchema";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaSalesPerProjectAllSchema(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaSalesPerProjectAllSchema(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaSalesPerProjectAllSchema(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaDetailBookingE3(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaDetailBookingE3";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaDetailBookingE3(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaDetailBookingE3(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaDetailBookingE3(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaListofCancelations(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaListofCancelations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaListofCancelations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaListofCancelations(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaListofCancelations(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaCollectionAnalysis(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaCollectionAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaCollectionAnalysis(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaCollectionAnalysis(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaCollectionAnalysis(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaDetailUnitInventoryReport(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaDetailUnitInventoryReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaDetailUnitInventoryReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaDetailUnitInventoryReport(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaDetailUnitInventoryReport(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportGenevaAll(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportGenevaAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportGenevaAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportGenevaAll(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportGenevaAll(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportRedashHandover(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportRedashHandover";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportRedashHandover(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportRedashHandover(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportRedashHandover(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportRedashCustomerByProject(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportRedashCustomerByProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportRedashCustomerByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportRedashCustomerByProject(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportRedashCustomerByProject(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }

    /**
     * @return Success
     */
    reportRedashSummaryreportKPR(): Observable<ResponUrlGenevaDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportGeneva/ReportRedashSummaryreportKPR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReportRedashSummaryreportKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReportRedashSummaryreportKPR(response_);
                } catch (e) {
                    return <Observable<ResponUrlGenevaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResponUrlGenevaDto>><any>Observable.throw(response_);
        });
    }

    protected processReportRedashSummaryreportKPR(response: Response): Observable<ResponUrlGenevaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResponUrlGenevaDto.fromJS(resultData200) : new ResponUrlGenevaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResponUrlGenevaDto>(<any>null);
    }
}

@Injectable()
export class ReportPriceListServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @renovId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getDataReportPriceList(projectId: number, clusterId: number, termMainId: number, renovId: number[], termId: number[]): Observable<GetDataReportPriceListResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReportPriceList/GetDataReportPriceList?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        if (termMainId === undefined || termMainId === null)
            throw new Error("The parameter 'termMainId' must be defined and cannot be null.");
        else
            url_ += "termMainId=" + encodeURIComponent("" + termMainId) + "&"; 
        if (renovId !== undefined)
            renovId && renovId.forEach(item => { url_ += "renovId=" + encodeURIComponent("" + item) + "&"; });
        if (termId !== undefined)
            termId && termId.forEach(item => { url_ += "termId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataReportPriceList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataReportPriceList(response_);
                } catch (e) {
                    return <Observable<GetDataReportPriceListResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataReportPriceListResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataReportPriceList(response: Response): Observable<GetDataReportPriceListResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataReportPriceListResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataReportPriceListResultDto[]>(<any>null);
    }
}

@Injectable()
export class ReportReadyToAJBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getAssetByUnitCodeAndUnitNo(input: GetAssetParameters): Observable<GetAssetResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportReadyToAJB/GetAssetByUnitCodeAndUnitNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAssetByUnitCodeAndUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAssetByUnitCodeAndUnitNo(response_);
                } catch (e) {
                    return <Observable<GetAssetResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAssetResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAssetByUnitCodeAndUnitNo(response: Response): Observable<GetAssetResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAssetResultDto.fromJS(resultData200) : new GetAssetResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAssetResultDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @projectID (optional) 
     * @clusterID (optional) 
     * @return Success
     */
    getReportReadyToAJB(filter: string, sorting: string, maxResultCount: number, skipCount: number, projectID: number, clusterID: number): Observable<PagedResultDtoOfGetReportReadyToAJB> {
        let url_ = this.baseUrl + "/api/services/app/ReportReadyToAJB/GetReportReadyToAJB?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID !== undefined)
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReportReadyToAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReportReadyToAJB(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReportReadyToAJB>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReportReadyToAJB>><any>Observable.throw(response_);
        });
    }

    protected processGetReportReadyToAJB(response: Response): Observable<PagedResultDtoOfGetReportReadyToAJB> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetReportReadyToAJB.fromJS(resultData200) : new PagedResultDtoOfGetReportReadyToAJB();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetReportReadyToAJB>(<any>null);
    }

    /**
     * @filter (optional) 
     * @printBy (optional) 
     * @return Success
     */
    generateReportReadyToAJBExcel(projectID: number, clusterID: number, filter: string, printBy: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportReadyToAJB/GenerateReportReadyToAJBExcel?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (printBy !== undefined)
            url_ += "printBy=" + encodeURIComponent("" + printBy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateReportReadyToAJBExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateReportReadyToAJBExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateReportReadyToAJBExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class RequirementDetailSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @projectCode (optional) 
     * @clusterCode (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getRequirementDetail(projectCode: string, clusterCode: string, memberCode: string): Observable<GetRequirementDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/RequirementDetailSP/GetRequirementDetail?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (clusterCode !== undefined)
            url_ += "clusterCode=" + encodeURIComponent("" + clusterCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRequirementDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRequirementDetail(response_);
                } catch (e) {
                    return <Observable<GetRequirementDetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRequirementDetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRequirementDetail(response: Response): Observable<GetRequirementDetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRequirementDetailDto.fromJS(resultData200) : new GetRequirementDetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRequirementDetailDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getDropdownProjectByMemberCode(memberCode: string): Observable<GetDropdownProjectByMemberCode[]> {
        let url_ = this.baseUrl + "/api/services/app/RequirementDetailSP/GetDropdownProjectByMemberCode?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProjectByMemberCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProjectByMemberCode(response_);
                } catch (e) {
                    return <Observable<GetDropdownProjectByMemberCode[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProjectByMemberCode[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProjectByMemberCode(response: Response): Observable<GetDropdownProjectByMemberCode[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProjectByMemberCode.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProjectByMemberCode[]>(<any>null);
    }
}

@Injectable()
export class RewardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createReward(input: CreateRewardInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reward/CreateReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateReward(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateReward(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    taskListReward(input: TasklistRewardInputDto): Observable<ListResultDtoOfGetListRewardDto> {
        let url_ = this.baseUrl + "/api/services/app/Reward/TaskListReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTaskListReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTaskListReward(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListRewardDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListRewardDto>><any>Observable.throw(response_);
        });
    }

    protected processTaskListReward(response: Response): Observable<ListResultDtoOfGetListRewardDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListRewardDto.fromJS(resultData200) : new ListResultDtoOfGetListRewardDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListRewardDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailReward(id: number): Observable<GetListRewardDto> {
        let url_ = this.baseUrl + "/api/services/app/Reward/getDetailReward?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailReward(response_);
                } catch (e) {
                    return <Observable<GetListRewardDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListRewardDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailReward(response: Response): Observable<GetListRewardDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetListRewardDto.fromJS(resultData200) : new GetListRewardDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListRewardDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateReward(input: GetListRewardDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Reward/UpdateReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateReward(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateReward(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownRewardPP(projectId: number): Observable<GetDropdownRewardPPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetDropdownRewardPP?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRewardPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRewardPP(response_);
                } catch (e) {
                    return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRewardPP(response: Response): Observable<GetDropdownRewardPPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRewardPPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRewardPPDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownRewardPPByProjectInfo(projectInfoId: number): Observable<GetDropdownRewardPPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetDropdownRewardPPByProjectInfo?";
        if (projectInfoId === undefined || projectInfoId === null)
            throw new Error("The parameter 'projectInfoId' must be defined and cannot be null.");
        else
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRewardPPByProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRewardPPByProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRewardPPByProjectInfo(response: Response): Observable<GetDropdownRewardPPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRewardPPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRewardPPDto[]>(<any>null);
    }

    /**
     * @idProject (optional) 
     * @return Success
     */
    getDropdownProductReportVoucherByProject(idProject: number[]): Observable<GetRewardProduct[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetDropdownProductReportVoucherByProject?";
        if (idProject !== undefined)
            idProject && idProject.forEach(item => { url_ += "IdProject=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProductReportVoucherByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProductReportVoucherByProject(response_);
                } catch (e) {
                    return <Observable<GetRewardProduct[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardProduct[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProductReportVoucherByProject(response: Response): Observable<GetRewardProduct[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardProduct.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardProduct[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownProductByProject(projectId: number): Observable<GetRewardProduct[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetDropdownProductByProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProductByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProductByProject(response_);
                } catch (e) {
                    return <Observable<GetRewardProduct[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardProduct[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProductByProject(response: Response): Observable<GetRewardProduct[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardProduct.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardProduct[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRewardDropdownByProjectInfo(projectInfoID: number): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetRewardDropdownByProjectInfo?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdownByProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdownByProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdownByProjectInfo(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRewardDropdownByProject(projectID: number): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetRewardDropdownByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdownByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdownByProject(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdownByProject(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRewardByProjectInfo(projectInfoID: number): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetRewardByProjectInfo?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardByProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardByProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardByProjectInfo(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @isBF (optional) 
     * @isParking (optional) 
     * @isBilling (optional) 
     * @isPP (optional) 
     * @isNewCustomer (optional) 
     * @return Success
     */
    getRewardByProjectInfoPerCategory(projectInfoID: number, isBF: boolean, isParking: boolean, isBilling: boolean, isPP: boolean, isNewCustomer: boolean): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetRewardByProjectInfoPerCategory?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (isBF !== undefined)
            url_ += "isBF=" + encodeURIComponent("" + isBF) + "&"; 
        if (isParking !== undefined)
            url_ += "isParking=" + encodeURIComponent("" + isParking) + "&"; 
        if (isBilling !== undefined)
            url_ += "isBilling=" + encodeURIComponent("" + isBilling) + "&"; 
        if (isPP !== undefined)
            url_ += "isPP=" + encodeURIComponent("" + isPP) + "&"; 
        if (isNewCustomer !== undefined)
            url_ += "isNewCustomer=" + encodeURIComponent("" + isNewCustomer) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardByProjectInfoPerCategory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardByProjectInfoPerCategory(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardByProjectInfoPerCategory(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListTypeUndian(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reward/GetListTypeUndian";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListTypeUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListTypeUndian(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListTypeUndian(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }
}

@Injectable()
export class RewardHistoryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateRewardPdf(input: GenerateRewardHistoryPdfInputDto): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/GenerateRewardPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateRewardPdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateRewardPdf(response_);
                } catch (e) {
                    return <Observable<string[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<string[]>><any>Observable.throw(response_);
        });
    }

    protected processGenerateRewardPdf(response: Response): Observable<string[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailTasklistRewardHistory(unitOrderHeaderID: number): Observable<GetDetailTasklistRewardHistoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/GetDetailTasklistRewardHistory?";
        if (unitOrderHeaderID === undefined || unitOrderHeaderID === null)
            throw new Error("The parameter 'unitOrderHeaderID' must be defined and cannot be null.");
        else
            url_ += "unitOrderHeaderID=" + encodeURIComponent("" + unitOrderHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailTasklistRewardHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailTasklistRewardHistory(response_);
                } catch (e) {
                    return <Observable<GetDetailTasklistRewardHistoryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailTasklistRewardHistoryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailTasklistRewardHistory(response: Response): Observable<GetDetailTasklistRewardHistoryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailTasklistRewardHistoryListDto.fromJS(resultData200) : new GetDetailTasklistRewardHistoryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailTasklistRewardHistoryListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRewardDropdown(projectID: number): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/GetRewardDropdown?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdown(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdown(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @keyword (optional) 
     * @return Success
     */
    getTasklistRewardHistory(projectID: number, keyword: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfGetTasklistRewardHistoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/GetTasklistRewardHistory?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistRewardHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistRewardHistory(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTasklistRewardHistoryListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTasklistRewardHistoryListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistRewardHistory(response: Response): Observable<PagedResultDtoOfGetTasklistRewardHistoryListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetTasklistRewardHistoryListDto.fromJS(resultData200) : new PagedResultDtoOfGetTasklistRewardHistoryListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetTasklistRewardHistoryListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    redeemReward(input: RedeemRewardInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/RedeemReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRedeemReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRedeemReward(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processRedeemReward(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    dropdownCampaignByOrderID(input: DropdownCampaignInputDto): Observable<DropdownCampaignResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/DropdownCampaignByOrderID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownCampaignByOrderID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownCampaignByOrderID(response_);
                } catch (e) {
                    return <Observable<DropdownCampaignResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownCampaignResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownCampaignByOrderID(response: Response): Observable<DropdownCampaignResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownCampaignResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownCampaignResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    dropdownRewardByOrderID(unitOrderHeaderID: number): Observable<GetDropdownRewardPPDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/DropdownRewardByOrderID?";
        if (unitOrderHeaderID === undefined || unitOrderHeaderID === null)
            throw new Error("The parameter 'unitOrderHeaderID' must be defined and cannot be null.");
        else
            url_ += "unitOrderHeaderID=" + encodeURIComponent("" + unitOrderHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropdownRewardByOrderID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropdownRewardByOrderID(response_);
                } catch (e) {
                    return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownRewardPPDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDropdownRewardByOrderID(response: Response): Observable<GetDropdownRewardPPDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownRewardPPDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownRewardPPDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addBookingProgramReward(input: AddBookingProgramRewardInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/AddBookingProgramReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddBookingProgramReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddBookingProgramReward(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddBookingProgramReward(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteBookingReward(bookingRewardID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/DeleteBookingReward?";
        if (bookingRewardID === undefined || bookingRewardID === null)
            throw new Error("The parameter 'bookingRewardID' must be defined and cannot be null.");
        else
            url_ += "bookingRewardID=" + encodeURIComponent("" + bookingRewardID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteBookingReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteBookingReward(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteBookingReward(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    printVoucherRewardHistory(bookingRewardID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardHistory/PrintVoucherRewardHistory?";
        if (bookingRewardID === undefined || bookingRewardID === null)
            throw new Error("The parameter 'bookingRewardID' must be defined and cannot be null.");
        else
            url_ += "bookingRewardID=" + encodeURIComponent("" + bookingRewardID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintVoucherRewardHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintVoucherRewardHistory(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintVoucherRewardHistory(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @permission (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getRoles(permission: string, filterText: string): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (filterText !== undefined)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRoles(response: Response): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoleForEdit(response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRoleForEdit(response: Response): Observable<GetRoleForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateRole(input: CreateOrUpdateRoleInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    combineString(input: string[]): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Role/CombineString";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCombineString(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCombineString(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCombineString(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class SalesTrackingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @userID (optional) 
     * @return Success
     */
    cekRoles(userID: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/CekRoles?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCekRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCekRoles(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCekRoles(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    cekDownline(memberCode: string): Observable<ValidasiMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/CekDownline?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCekDownline(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCekDownline(response_);
                } catch (e) {
                    return <Observable<ValidasiMemberDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ValidasiMemberDto>><any>Observable.throw(response_);
        });
    }

    protected processCekDownline(response: Response): Observable<ValidasiMemberDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidasiMemberDto.fromJS(resultData200) : new ValidasiMemberDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ValidasiMemberDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    membercodeShow(memberCode: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/MembercodeShow?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMembercodeShow(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMembercodeShow(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processMembercodeShow(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    inquiryDataSalesTracking(input: GetSalesTrackingInputDto): Observable<PagedResultDtoOfGetSalesTrackingResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/InquiryDataSalesTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInquiryDataSalesTracking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInquiryDataSalesTracking(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesTrackingResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesTrackingResultDto>><any>Observable.throw(response_);
        });
    }

    protected processInquiryDataSalesTracking(response: Response): Observable<PagedResultDtoOfGetSalesTrackingResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetSalesTrackingResultDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesTrackingResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetSalesTrackingResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTerm(projectID: number, isAdminBank: boolean): Observable<GetSalesTrackingTermPaymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetDropdownTerm?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (isAdminBank === undefined || isAdminBank === null)
            throw new Error("The parameter 'isAdminBank' must be defined and cannot be null.");
        else
            url_ += "isAdminBank=" + encodeURIComponent("" + isAdminBank) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTerm(response_);
                } catch (e) {
                    return <Observable<GetSalesTrackingTermPaymentDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSalesTrackingTermPaymentDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTerm(response: Response): Observable<GetSalesTrackingTermPaymentDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetSalesTrackingTermPaymentDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSalesTrackingTermPaymentDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeEmailSalesTracking(input: ChangeEmailInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/ChangeEmailSalesTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeEmailSalesTracking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeEmailSalesTracking(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeEmailSalesTracking(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    printPPPU(bookCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/PrintPPPU?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintPPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintPPPU(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processPrintPPPU(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    printConfirmationLetter(bookCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/PrintConfirmationLetter?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintConfirmationLetter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintConfirmationLetter(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processPrintConfirmationLetter(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @return Success
     */
    getStatusDocument(bookcode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetStatusDocument?";
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStatusDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStatusDocument(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetStatusDocument(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printOLN(input: PrintOLNInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/PrintOLN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintOLN(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintOLN(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processPrintOLN(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @docCode (optional) 
     * @return Success
     */
    printSignedDoc(bookCode: string, docCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/PrintSignedDoc?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (docCode !== undefined)
            url_ += "docCode=" + encodeURIComponent("" + docCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintSignedDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintSignedDoc(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processPrintSignedDoc(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendEmailDoc(input: ResendEmailByBookCodeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/ResendEmailDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendEmailDoc(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendEmailDoc(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResendEmailDoc(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @docCode (optional) 
     * @return Success
     */
    getDetailDocument(bookCode: string, docCode: string): Observable<GetDetailDocDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetDetailDocument?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (docCode !== undefined)
            url_ += "docCode=" + encodeURIComponent("" + docCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailDocument(response_);
                } catch (e) {
                    return <Observable<GetDetailDocDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailDocDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailDocument(response: Response): Observable<GetDetailDocDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailDocDto.fromJS(resultData200) : new GetDetailDocDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailDocDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendLayoutPlan(input: ResendEmailLayoutPlanDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/ResendLayoutPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendLayoutPlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendLayoutPlan(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResendLayoutPlan(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getMappingOfferingLetterNobu(bookCode: string): Observable<GetMappingOfferingLetterNobuDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetMappingOfferingLetterNobu?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMappingOfferingLetterNobu(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMappingOfferingLetterNobu(response_);
                } catch (e) {
                    return <Observable<GetMappingOfferingLetterNobuDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMappingOfferingLetterNobuDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMappingOfferingLetterNobu(response: Response): Observable<GetMappingOfferingLetterNobuDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMappingOfferingLetterNobuDto.fromJS(resultData200) : new GetMappingOfferingLetterNobuDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMappingOfferingLetterNobuDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendPaymentInstructions(input: SendPaymentInstructionsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/SendPaymentInstructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendPaymentInstructions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendPaymentInstructions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendPaymentInstructions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailDP(input: SendEmailDpDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/SendEmailDP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailDP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailDP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailDP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailConfirmation(input: SendEmailDpDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/SendEmailConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailConfirmation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailConfirmation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailConfirmation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bookingHeaderID (optional) 
     * @ppNo (optional) 
     * @return Success
     */
    getLatestDateDocumentKPR(psCode: string, bookingHeaderID: number, ppNo: string): Observable<DocumentKPRListHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetLatestDateDocumentKPR?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestDateDocumentKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestDateDocumentKPR(response_);
                } catch (e) {
                    return <Observable<DocumentKPRListHeaderDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DocumentKPRListHeaderDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestDateDocumentKPR(response: Response): Observable<DocumentKPRListHeaderDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentKPRListHeaderDto.fromJS(resultData200) : new DocumentKPRListHeaderDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DocumentKPRListHeaderDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bookingHeaderID (optional) 
     * @ppNo (optional) 
     * @return Success
     */
    getListDocumentKPR(psCode: string, bookingHeaderID: number, ppNo: string): Observable<DocumentKPRListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetListDocumentKPR?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListDocumentKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListDocumentKPR(response_);
                } catch (e) {
                    return <Observable<DocumentKPRListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DocumentKPRListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListDocumentKPR(response: Response): Observable<DocumentKPRListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DocumentKPRListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DocumentKPRListDto[]>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bookingHeaderID (optional) 
     * @ppNo (optional) 
     * @return Success
     */
    getStatusDocumentKPR(psCode: string, bookingHeaderID: number, ppNo: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetStatusDocumentKPR?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetStatusDocumentKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetStatusDocumentKPR(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetStatusDocumentKPR(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @connection (optional) 
     * @return Success
     */
    getConnString(connection: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetConnString?";
        if (connection !== undefined)
            url_ += "connection=" + encodeURIComponent("" + connection) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetConnString(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetConnString(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetConnString(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bookingHeaderID (optional) 
     * @documentType (optional) 
     * @priorityPassId (optional) 
     * @return Success
     */
    getDocumentKPRFile(psCode: string, bookingHeaderID: number, documentType: string, priorityPassId: number): Observable<DocumentKPRFileResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetDocumentKPRFile?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (bookingHeaderID !== undefined)
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&"; 
        if (priorityPassId !== undefined)
            url_ += "PriorityPassId=" + encodeURIComponent("" + priorityPassId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentKPRFile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocumentKPRFile(response_);
                } catch (e) {
                    return <Observable<DocumentKPRFileResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DocumentKPRFileResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentKPRFile(response: Response): Observable<DocumentKPRFileResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentKPRFileResultDto.fromJS(resultData200) : new DocumentKPRFileResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DocumentKPRFileResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    moveDocumentToKPRDocument(input: Step23InsertDocumentKPRInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/MoveDocumentToKPRDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveDocumentToKPRDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveDocumentToKPRDocument(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMoveDocumentToKPRDocument(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadDocumentKPR(input: DocumentKPRInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/UploadDocumentKPR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadDocumentKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadDocumentKPR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadDocumentKPR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    updateDocumentStatus(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/UpdateDocumentStatus?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDocumentStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDocumentStatus(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDocumentStatus(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookcode (optional) 
     * @return Success
     */
    getOutstandingDownPayment(bookcode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/getOutstandingDownPayment?";
        if (bookcode !== undefined)
            url_ += "bookcode=" + encodeURIComponent("" + bookcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOutstandingDownPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOutstandingDownPayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetOutstandingDownPayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createHistoryViewDocument(input: CreateHistoryViewDocumentDbo): Observable<CreateHistoryViewDocumentResponse> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/CreateHistoryViewDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateHistoryViewDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateHistoryViewDocument(response_);
                } catch (e) {
                    return <Observable<CreateHistoryViewDocumentResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateHistoryViewDocumentResponse>><any>Observable.throw(response_);
        });
    }

    protected processCreateHistoryViewDocument(response: Response): Observable<CreateHistoryViewDocumentResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateHistoryViewDocumentResponse.fromJS(resultData200) : new CreateHistoryViewDocumentResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateHistoryViewDocumentResponse>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @ppNo (optional) 
     * @return Success
     */
    getHistoryViewDocument(bookingHeaderId: number, psCode: string, ppNo: string): Observable<GetHistoryViewDocumentDbo[]> {
        let url_ = this.baseUrl + "/api/services/app/SalesTracking/GetHistoryViewDocument?";
        if (bookingHeaderId === undefined || bookingHeaderId === null)
            throw new Error("The parameter 'bookingHeaderId' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderId=" + encodeURIComponent("" + bookingHeaderId) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHistoryViewDocument(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHistoryViewDocument(response_);
                } catch (e) {
                    return <Observable<GetHistoryViewDocumentDbo[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetHistoryViewDocumentDbo[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHistoryViewDocument(response: Response): Observable<GetHistoryViewDocumentDbo[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetHistoryViewDocumentDbo.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetHistoryViewDocumentDbo[]>(<any>null);
    }
}

@Injectable()
export class SchedulerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerSendEmailReminderUnitSudahLunas(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerSendEmailReminderUnitSudahLunas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSendEmailReminderUnitSudahLunas(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSendEmailReminderUnitSudahLunas(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSendEmailReminderUnitSudahLunas(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerCekLogin(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerCekLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerCekLogin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerCekLogin(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerCekLogin(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @userID (optional) 
     * @return Success
     */
    schedulerCekLoginParam(userID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerCekLoginParam?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerCekLoginParam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerCekLoginParam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerCekLoginParam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerExecMSU001V2(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerExecMSU001V2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerExecMSU001V2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerExecMSU001V2(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerExecMSU001V2(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tanggal (optional) 
     * @return Success
     */
    listLogExecMSU001V2(tanggal: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/ListLogExecMSU001V2?";
        if (tanggal !== undefined)
            url_ += "tanggal=" + encodeURIComponent("" + tanggal) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processListLogExecMSU001V2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processListLogExecMSU001V2(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processListLogExecMSU001V2(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerExecSPRUNMB(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerExecSPRUNMB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerExecSPRUNMB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerExecSPRUNMB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerExecSPRUNMB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerBookingMemberHistory(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Scheduler/SchedulerBookingMemberHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerBookingMemberHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerBookingMemberHistory(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerBookingMemberHistory(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerGenerateSentEmailAJBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerGenerateEmailAJB(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerGenerateSentEmailAJB/SchedulerGenerateEmailAJB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateEmailAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateEmailAJB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateEmailAJB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerGenerateSummaryServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerGenerateSummaryYangBelumUploadAJB(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerGenerateSummary/SchedulerGenerateSummaryYangBelumUploadAJB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateSummaryYangBelumUploadAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateSummaryYangBelumUploadAJB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateSummaryYangBelumUploadAJB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerGetDocumentFromSIMAServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    createLocalDocumentFromSima(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerGetDocumentFromSIMA/CreateLocalDocumentFromSima";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateLocalDocumentFromSima(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateLocalDocumentFromSima(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateLocalDocumentFromSima(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerHistoryDocumentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    reminderemailhistorystatusAJBPSAS(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerHistoryDocument/ReminderemailhistorystatusAJBPSAS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReminderemailhistorystatusAJBPSAS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReminderemailhistorystatusAJBPSAS(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processReminderemailhistorystatusAJBPSAS(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    reminderemailhistorystatusAJBLegal(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerHistoryDocument/ReminderemailhistorystatusAJBLegal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReminderemailhistorystatusAJBLegal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReminderemailhistorystatusAJBLegal(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processReminderemailhistorystatusAJBLegal(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerPPBookingFeeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerSinglePaymentUOP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerPPBookingFee/SchedulerSinglePaymentUOP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerSinglePaymentUOP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerSinglePaymentUOP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerSinglePaymentUOP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerChangeUnknownPaymentUOP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerPPBookingFee/SchedulerChangeUnknownPaymentUOP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerChangeUnknownPaymentUOP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerChangeUnknownPaymentUOP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerChangeUnknownPaymentUOP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerChangeUnknownOTH_OPR_ForUOP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerPPBookingFee/SchedulerChangeUnknownOTH_OPR_ForUOP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerChangeUnknownOTH_OPR_ForUOP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerChangeUnknownOTH_OPR_ForUOP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerChangeUnknownOTH_OPR_ForUOP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerPPPUServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerGenerateSummaryYangBelumPPPU(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerPPPU/SchedulerGenerateSummaryYangBelumPPPU";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateSummaryYangBelumPPPU(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateSummaryYangBelumPPPU(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateSummaryYangBelumPPPU(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SchedulerReadyToAJBServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulerGenerateReadyToAJB_FixSP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerReadyToAJB/SchedulerGenerateReadyToAJB_FixSP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateReadyToAJB_FixSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateReadyToAJB_FixSP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateReadyToAJB_FixSP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerGenerateReadyToAJB(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchedulerReadyToAJB/SchedulerGenerateReadyToAJB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerGenerateReadyToAJB(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerGenerateReadyToAJB(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerGenerateReadyToAJB(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SendSmsLKServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendSMS(input: SendSMSWithAttachmentInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SendSmsLK/SendSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendSMS(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendSMS(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendSMS(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @key (optional) 
     * @value (optional) 
     * @return Success
     */
    setSessionData(key: string, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Session/SetSessionData?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSessionData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSessionData(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSessionData(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @key (optional) 
     * @return Success
     */
    getSessionData(key: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetSessionData?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSessionData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSessionData(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSessionData(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @fileName (optional) 
     * @data (optional) 
     * @return Success
     */
    getOnlinePdf(fileName: string, data: GetOnlinePdfDto[]): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetOnlinePdf?";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOnlinePdf(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOnlinePdf(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOnlinePdf(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentLoginInformations(response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentLoginInformations(response: Response): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserSignInToken(response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserSignInToken(response: Response): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class SettingPenaltyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMSClusterPenalty(input: GetDataMSClusterPenaltyByIDListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPenalty/CreateOrUpdateMSClusterPenalty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMSClusterPenalty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMSClusterPenalty(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMSClusterPenalty(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDataMSClusterPenalty(clusterID: number): Observable<GetDataMSClusterPenaltyListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPenalty/GetDataMSClusterPenalty?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMSClusterPenalty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMSClusterPenalty(response_);
                } catch (e) {
                    return <Observable<GetDataMSClusterPenaltyListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMSClusterPenaltyListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMSClusterPenalty(response: Response): Observable<GetDataMSClusterPenaltyListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataMSClusterPenaltyListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMSClusterPenaltyListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDataMSClusterPenaltyByID(clusterPenaltyID: number): Observable<GetDataMSClusterPenaltyByIDListDto> {
        let url_ = this.baseUrl + "/api/services/app/SettingPenalty/GetDataMSClusterPenaltyByID?";
        if (clusterPenaltyID === undefined || clusterPenaltyID === null)
            throw new Error("The parameter 'clusterPenaltyID' must be defined and cannot be null.");
        else
            url_ += "clusterPenaltyID=" + encodeURIComponent("" + clusterPenaltyID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataMSClusterPenaltyByID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataMSClusterPenaltyByID(response_);
                } catch (e) {
                    return <Observable<GetDataMSClusterPenaltyByIDListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataMSClusterPenaltyByIDListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataMSClusterPenaltyByID(response: Response): Observable<GetDataMSClusterPenaltyByIDListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataMSClusterPenaltyByIDListDto.fromJS(resultData200) : new GetDataMSClusterPenaltyByIDListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataMSClusterPenaltyByIDListDto>(<any>null);
    }
}

@Injectable()
export class SettingPeriodSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createMsSPPeriod(input: CreateOrUpdateMsSPPeriodInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/CreateMsSPPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateMsSPPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateMsSPPeriod(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateMsSPPeriod(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @listInput (optional) 
     * @return Success
     */
    createListMsSPPeriod(listInput: CreateOrUpdateMsSPPeriodInputDto[], projectId: number, clusterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/CreateListMsSPPeriod?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined and cannot be null.");
        else
            url_ += "clusterId=" + encodeURIComponent("" + clusterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listInput);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateListMsSPPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateListMsSPPeriod(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateListMsSPPeriod(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteMsSPPeriod(letterTypeID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/DeleteMsSPPeriod?";
        if (letterTypeID === undefined || letterTypeID === null)
            throw new Error("The parameter 'letterTypeID' must be defined and cannot be null.");
        else
            url_ += "letterTypeID=" + encodeURIComponent("" + letterTypeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMsSPPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMsSPPeriod(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMsSPPeriod(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsSPPeriodByCluster(clusterID: number): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetAllMsSPPeriodByCluster?";
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "clusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsSPPeriodByCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsSPPeriodByCluster(response_);
                } catch (e) {
                    return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsSPPeriodByCluster(response: Response): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllMsSPPeriodByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllMsSPPeriodByClusterListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getAllMsSPPeriodByMultipleCluster(input: ListClusterIdInputDto[]): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetAllMsSPPeriodByMultipleCluster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsSPPeriodByMultipleCluster(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsSPPeriodByMultipleCluster(response_);
                } catch (e) {
                    return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsSPPeriodByMultipleCluster(response: Response): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllMsSPPeriodByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllMsSPPeriodByClusterListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAvailableDropdownLKLetterType(flag: boolean): Observable<GetDropdownLKLetterTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetAvailableDropdownLKLetterType?";
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAvailableDropdownLKLetterType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAvailableDropdownLKLetterType(response_);
                } catch (e) {
                    return <Observable<GetDropdownLKLetterTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownLKLetterTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAvailableDropdownLKLetterType(response: Response): Observable<GetDropdownLKLetterTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownLKLetterTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownLKLetterTypeListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownLKSPGenerate(): Observable<GetDropdownLKSPGenerateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetDropdownLKSPGenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownLKSPGenerate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownLKSPGenerate(response_);
                } catch (e) {
                    return <Observable<GetDropdownLKSPGenerateListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownLKSPGenerateListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownLKSPGenerate(response: Response): Observable<GetDropdownLKSPGenerateListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownLKSPGenerateListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownLKSPGenerateListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownKuasaDireksiManagerPenalty(): Observable<GetDropdownKuasaDireksiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetDropdownKuasaDireksiManagerPenalty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownKuasaDireksiManagerPenalty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownKuasaDireksiManagerPenalty(response_);
                } catch (e) {
                    return <Observable<GetDropdownKuasaDireksiDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownKuasaDireksiDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownKuasaDireksiManagerPenalty(response: Response): Observable<GetDropdownKuasaDireksiDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownKuasaDireksiDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownKuasaDireksiDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownKuasaDireksiStaffPenalty(): Observable<GetDropdownKuasaDireksiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetDropdownKuasaDireksiStaffPenalty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownKuasaDireksiStaffPenalty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownKuasaDireksiStaffPenalty(response_);
                } catch (e) {
                    return <Observable<GetDropdownKuasaDireksiDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownKuasaDireksiDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownKuasaDireksiStaffPenalty(response: Response): Observable<GetDropdownKuasaDireksiDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownKuasaDireksiDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownKuasaDireksiDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateMsSPPeriod(input: CreateOrUpdateMsSPPeriodInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/UpdateMsSPPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateMsSPPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateMsSPPeriod(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateMsSPPeriod(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bulkUpdateMsSPPeriod(input: CreateOrUpdateMsSPPeriodInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/BulkUpdateMsSPPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBulkUpdateMsSPPeriod(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBulkUpdateMsSPPeriod(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBulkUpdateMsSPPeriod(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSettingDefaultSP(): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingPeriodSP/GetAllSettingDefaultSP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettingDefaultSP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettingDefaultSP(response_);
                } catch (e) {
                    return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllMsSPPeriodByClusterListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettingDefaultSP(response: Response): Observable<GetAllMsSPPeriodByClusterListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllMsSPPeriodByClusterListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllMsSPPeriodByClusterListDto[]>(<any>null);
    }
}

@Injectable()
export class SettingRetentionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createRetention(input: CreateRetentionInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingRetention/CreateRetention";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateRetention(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateRetention(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateRetention(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRetentionCode(): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/SettingRetention/GetRetentionCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRetentionCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRetentionCode(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetRetentionCode(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllSettingRetention(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetAllSettingRetentionListDto> {
        let url_ = this.baseUrl + "/api/services/app/SettingRetention/GetAllSettingRetention?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettingRetention(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettingRetention(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSettingRetentionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSettingRetentionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettingRetention(response: Response): Observable<PagedResultDtoOfGetAllSettingRetentionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSettingRetentionListDto.fromJS(resultData200) : new PagedResultDtoOfGetAllSettingRetentionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetAllSettingRetentionListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateRetention(input: UpdateRetentionInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingRetention/UpdateRetention";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateRetention(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateRetention(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateRetention(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMsRetentionDropdown(): Observable<GetAllSettingRetentionListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SettingRetention/GetAllMsRetentionDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMsRetentionDropdown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMsRetentionDropdown(response_);
                } catch (e) {
                    return <Observable<GetAllSettingRetentionListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllSettingRetentionListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMsRetentionDropdown(response: Response): Observable<GetAllSettingRetentionListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllSettingRetentionListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllSettingRetentionListDto[]>(<any>null);
    }
}

@Injectable()
export class SetupPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @rolesID (optional) 
     * @return Success
     */
    getProjectIDSys(rolesID: number[]): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetProjectIDSys?";
        if (rolesID !== undefined)
            rolesID && rolesID.forEach(item => { url_ += "rolesID=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectIDSys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectIDSys(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectIDSys(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertDataBatchentry(input: CerateDataInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/insertDataBatchentry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertDataBatchentry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertDataBatchentry(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processInsertDataBatchentry(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertDataPPFlag(input: CerateDataFastInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/insertDataPPFlag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertDataPPFlag(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertDataPPFlag(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processInsertDataPPFlag(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getListReportDetail(): Observable<BookDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetListReportDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListReportDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListReportDetail(response_);
                } catch (e) {
                    return <Observable<BookDataDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<BookDataDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListReportDetail(response: Response): Observable<BookDataDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BookDataDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BookDataDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getListFastLaneName(): Observable<BookDataFlagDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetListFastLaneName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListFastLaneName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListFastLaneName(response_);
                } catch (e) {
                    return <Observable<BookDataFlagDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<BookDataFlagDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListFastLaneName(response: Response): Observable<BookDataFlagDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BookDataFlagDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<BookDataFlagDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRolesPerUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetRolesPerUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRolesPerUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRolesPerUser(response_);
                } catch (e) {
                    return <Observable<number[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<number[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRolesPerUser(response: Response): Observable<number[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number[]>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @productCode (optional) 
     * @return Success
     */
    getPriorityPassPrice(projectCode: string, productCode: string): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetPriorityPassPrice?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPriorityPassPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPriorityPassPrice(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetPriorityPassPrice(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSetupPP(input: CreateOrUpdateSetupPPDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/UpdateSetupPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSetupPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSetupPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSetupPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getClusterByProduct(projectInfoID: number): Observable<ClusterOnProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetClusterByProduct?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetClusterByProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetClusterByProduct(response_);
                } catch (e) {
                    return <Observable<ClusterOnProductDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ClusterOnProductDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetClusterByProduct(response: Response): Observable<ClusterOnProductDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ClusterOnProductDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ClusterOnProductDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSetupPP(input: CreateOrUpdateSetupPPDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/CreateSetupPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSetupPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSetupPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSetupPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownProject(): Observable<GetProjectsListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetDropdownProject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProject(response_);
                } catch (e) {
                    return <Observable<GetProjectsListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectsListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProject(response: Response): Observable<GetProjectsListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProjectsListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectsListDto[]>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getDropdownProjectProduct(projectCode: string): Observable<GetProjectProductListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetDropdownProjectProduct?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProjectProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProjectProduct(response_);
                } catch (e) {
                    return <Observable<GetProjectProductListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProjectProductListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProjectProduct(response: Response): Observable<GetProjectProductListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetProjectProductListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProjectProductListDto[]>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @productCode (optional) 
     * @return Success
     */
    getSetupPP(projectCode: string, productCode: string): Observable<GetSetupPPListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetSetupPP?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSetupPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSetupPP(response_);
                } catch (e) {
                    return <Observable<GetSetupPPListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSetupPPListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetSetupPP(response: Response): Observable<GetSetupPPListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetSetupPPListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSetupPPListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLatestBatchSequence(entryBatchID: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetLatestBatchSequence?";
        if (entryBatchID === undefined || entryBatchID === null)
            throw new Error("The parameter 'entryBatchID' must be defined and cannot be null.");
        else
            url_ += "entryBatchID=" + encodeURIComponent("" + entryBatchID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestBatchSequence(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestBatchSequence(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestBatchSequence(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSetupPP(batchID: number): Observable<GetDetailSetupPPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SetupPP/GetDetailSetupPP?";
        if (batchID === undefined || batchID === null)
            throw new Error("The parameter 'batchID' must be defined and cannot be null.");
        else
            url_ += "batchID=" + encodeURIComponent("" + batchID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSetupPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSetupPP(response_);
                } catch (e) {
                    return <Observable<GetDetailSetupPPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailSetupPPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSetupPP(response: Response): Observable<GetDetailSetupPPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailSetupPPResultDto.fromJS(resultData200) : new GetDetailSetupPPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailSetupPPResultDto>(<any>null);
    }
}

@Injectable()
export class SignificantFinancingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getSignificantFinancingTaskList(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSignificantFinancingTaskListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/GetSignificantFinancingTaskList?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSignificantFinancingTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSignificantFinancingTaskList(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSignificantFinancingTaskListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSignificantFinancingTaskListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSignificantFinancingTaskList(response: Response): Observable<PagedResultDtoOfSignificantFinancingTaskListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSignificantFinancingTaskListDto.fromJS(resultData200) : new PagedResultDtoOfSignificantFinancingTaskListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSignificantFinancingTaskListDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getSignificantFinancingDetail(filter: string, sorting: string, maxResultCount: number, skipCount: number, projectID: number, clusterID: number, interest: number): Observable<PagedResultDtoOfSignificantFinancingDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/GetSignificantFinancingDetail?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (clusterID === undefined || clusterID === null)
            throw new Error("The parameter 'clusterID' must be defined and cannot be null.");
        else
            url_ += "ClusterID=" + encodeURIComponent("" + clusterID) + "&"; 
        if (interest === undefined || interest === null)
            throw new Error("The parameter 'interest' must be defined and cannot be null.");
        else
            url_ += "Interest=" + encodeURIComponent("" + interest) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSignificantFinancingDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSignificantFinancingDetail(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSignificantFinancingDetailListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSignificantFinancingDetailListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSignificantFinancingDetail(response: Response): Observable<PagedResultDtoOfSignificantFinancingDetailListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSignificantFinancingDetailListDto.fromJS(resultData200) : new PagedResultDtoOfSignificantFinancingDetailListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSignificantFinancingDetailListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSignificantFinancing(input: SignificantFinancingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/CreateSignificantFinancing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSignificantFinancing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSignificantFinancing(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSignificantFinancing(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSignificantFinancingHeader(financingHeaderID: number): Observable<SignificantFinancingInputDto> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/GetSignificantFinancingHeader?";
        if (financingHeaderID === undefined || financingHeaderID === null)
            throw new Error("The parameter 'financingHeaderID' must be defined and cannot be null.");
        else
            url_ += "FinancingHeaderID=" + encodeURIComponent("" + financingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSignificantFinancingHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSignificantFinancingHeader(response_);
                } catch (e) {
                    return <Observable<SignificantFinancingInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SignificantFinancingInputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSignificantFinancingHeader(response: Response): Observable<SignificantFinancingInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SignificantFinancingInputDto.fromJS(resultData200) : new SignificantFinancingInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SignificantFinancingInputDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getSignificantFinancingDetailList(filter: string, sorting: string, maxResultCount: number, skipCount: number, financingHeaderID: number): Observable<PagedResultDtoOfSignificantFinancingDetailListDto> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/GetSignificantFinancingDetailList?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (financingHeaderID === undefined || financingHeaderID === null)
            throw new Error("The parameter 'financingHeaderID' must be defined and cannot be null.");
        else
            url_ += "FinancingHeaderID=" + encodeURIComponent("" + financingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSignificantFinancingDetailList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSignificantFinancingDetailList(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSignificantFinancingDetailListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSignificantFinancingDetailListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSignificantFinancingDetailList(response: Response): Observable<PagedResultDtoOfSignificantFinancingDetailListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSignificantFinancingDetailListDto.fromJS(resultData200) : new PagedResultDtoOfSignificantFinancingDetailListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSignificantFinancingDetailListDto>(<any>null);
    }

    /**
     * @return Success
     */
    downloadSignificantFinancingExcel(financingHeaderID: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SignificantFinancing/DownloadSignificantFinancingExcel?";
        if (financingHeaderID === undefined || financingHeaderID === null)
            throw new Error("The parameter 'financingHeaderID' must be defined and cannot be null.");
        else
            url_ += "FinancingHeaderID=" + encodeURIComponent("" + financingHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadSignificantFinancingExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadSignificantFinancingExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadSignificantFinancingExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class SiteMapServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkExistingSiteMap(input: SiteMapInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SiteMap/CheckExistingSiteMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckExistingSiteMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckExistingSiteMap(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckExistingSiteMap(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSiteMap(input: SiteMapInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SiteMap/CreateOrUpdateSiteMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSiteMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSiteMap(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSiteMap(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSiteMap(input: SiteMapInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SiteMap/CreateSiteMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSiteMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSiteMap(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSiteMap(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getSiteMap(projectID: number): Observable<SiteMapViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SiteMap/GetSiteMap?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSiteMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSiteMap(response_);
                } catch (e) {
                    return <Observable<SiteMapViewDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SiteMapViewDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetSiteMap(response: Response): Observable<SiteMapViewDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SiteMapViewDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SiteMapViewDto[]>(<any>null);
    }

    /**
     * @projectID (optional) 
     * @return Success
     */
    getSiteMapNew(projectID: number): Observable<SiteMapViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SiteMap/GetSiteMapNew?";
        if (projectID !== undefined)
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSiteMapNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSiteMapNew(response_);
                } catch (e) {
                    return <Observable<SiteMapViewDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SiteMapViewDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetSiteMapNew(response: Response): Observable<SiteMapViewDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SiteMapViewDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SiteMapViewDto[]>(<any>null);
    }
}

@Injectable()
export class SitePlanServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkExistingSitePlan(input: SitePlanInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SitePlan/CheckExistingSitePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckExistingSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckExistingSitePlan(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processCheckExistingSitePlan(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSitePlan(input: SitePlanInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SitePlan/CreateOrUpdateSitePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSitePlan(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSitePlan(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    test(input: SitePlanInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SitePlan/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTest(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processTest(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSitePlan(input: SitePlanInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SitePlan/CreateSitePlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSitePlan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSitePlan(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSitePlan(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId === undefined || upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' must be defined and cannot be null.");
        else
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpgradeTenantToEquivalentEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SwingPaymentTermServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDataTaskListSwing(projectID: number): Observable<CreateOrUpdateMainSwingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetDataTaskListSwing?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataTaskListSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataTaskListSwing(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateMainSwingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateMainSwingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDataTaskListSwing(response: Response): Observable<CreateOrUpdateMainSwingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CreateOrUpdateMainSwingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateMainSwingDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownMainSwing(projectID: number): Observable<DropdownMainSwingDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetDropdownMainSwing?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownMainSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownMainSwing(response_);
                } catch (e) {
                    return <Observable<DropdownMainSwingDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropdownMainSwingDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownMainSwing(response: Response): Observable<DropdownMainSwingDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DropdownMainSwingDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropdownMainSwingDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMainSwingCode(projectID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetMainSwingCode?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMainSwingCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMainSwingCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMainSwingCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTerm(termMainID: number): Observable<GetDropdownTermResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetDropdownTerm?";
        if (termMainID === undefined || termMainID === null)
            throw new Error("The parameter 'termMainID' must be defined and cannot be null.");
        else
            url_ += "termMainID=" + encodeURIComponent("" + termMainID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTerm(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTerm(response: Response): Observable<GetDropdownTermResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownTermCode(projectID: number): Observable<GetAllMsTermListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetDropdownTermCode?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTermCode(response_);
                } catch (e) {
                    return <Observable<GetAllMsTermListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetAllMsTermListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTermCode(response: Response): Observable<GetAllMsTermListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetAllMsTermListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetAllMsTermListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMainSwing(input: CreateOrUpdateMainSwingDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/CreateOrUpdateMainSwing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMainSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMainSwing(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMainSwing(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateSwing(input: CreateOrUpdateSwingDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/CreateOrUpdateSwing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateSwing(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateSwing(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getDetailSwing(mainSwingID: number): Observable<GetDetailSwingDto> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/GetDetailSwing?";
        if (mainSwingID === undefined || mainSwingID === null)
            throw new Error("The parameter 'mainSwingID' must be defined and cannot be null.");
        else
            url_ += "mainSwingID=" + encodeURIComponent("" + mainSwingID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailSwing(response_);
                } catch (e) {
                    return <Observable<GetDetailSwingDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailSwingDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailSwing(response: Response): Observable<GetDetailSwingDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDetailSwingDto.fromJS(resultData200) : new GetDetailSwingDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailSwingDto>(<any>null);
    }

    /**
     * @return Success
     */
    deleteSwing(swingID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SwingPaymentTerm/DeleteSwing?";
        if (swingID === undefined || swingID === null)
            throw new Error("The parameter 'swingID' must be defined and cannot be null.");
        else
            url_ += "swingID=" + encodeURIComponent("" + swingID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSwing(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSwing(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSwing(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SyncCustomerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestCounterPsCode(): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/GetLatestCounterPsCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestCounterPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestCounterPsCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestCounterPsCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkIsUsedPsCode(input: SyncCustomerDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/CheckIsUsedPsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckIsUsedPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckIsUsedPsCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckIsUsedPsCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @data (optional) 
     * @return Success
     */
    updateCounterPsCode(data: SyncCustomerDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/UpdateCounterPsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCounterPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCounterPsCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCounterPsCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    syncCounterPsCode(): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/SyncCounterPsCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCounterPsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCounterPsCode(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncCounterPsCode(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    processSyncCustomer(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/ProcessSyncCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processProcessSyncCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processProcessSyncCustomer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processProcessSyncCustomer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @dbName (optional) 
     * @return Success
     */
    formattingQueryMerge(dbName: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/FormattingQueryMerge?";
        if (dbName !== undefined)
            url_ += "dbName=" + encodeURIComponent("" + dbName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFormattingQueryMerge(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFormattingQueryMerge(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processFormattingQueryMerge(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    syncCreateUpdateCustomer(input: SignUpCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/SyncCreateUpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncCreateUpdateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncCreateUpdateCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncCreateUpdateCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    syncUpdateCustomer(input: UpdateCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/SyncUpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncUpdateCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncUpdateCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncUpdateCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    syncSignUpCustomer(input: SignUpCustomerInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SyncCustomer/SyncSignUpCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSyncSignUpCustomer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSyncSignUpCustomer(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processSyncSignUpCustomer(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }
}

@Injectable()
export class TaskListSPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    pushNotif(input: GetDataOneSignalResultDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskListSP/PushNotif";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPushNotif(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPushNotif(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processPushNotif(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerTaskList(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskListSP/SchedulerTaskList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerTaskList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerTaskList(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerTaskList(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getTaskListSalesPortal(memberCode: string): Observable<GetTaskListResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TaskListSP/GetTaskListSalesPortal?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListSalesPortal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListSalesPortal(response_);
                } catch (e) {
                    return <Observable<GetTaskListResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTaskListResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListSalesPortal(response: Response): Observable<GetTaskListResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTaskListResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTaskListResultDto[]>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @subscriptionEndDateStart (optional) 
     * @subscriptionEndDateEnd (optional) 
     * @creationDateStart (optional) 
     * @creationDateEnd (optional) 
     * @editionId (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTenants(filter: string, subscriptionEndDateStart: moment.Moment, subscriptionEndDateEnd: moment.Moment, creationDateStart: moment.Moment, creationDateEnd: moment.Moment, editionId: number, editionIdSpecified: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified === undefined || editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' must be defined and cannot be null.");
        else
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenants(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenants(response: Response): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenant(input: CreateTenantInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantForEdit(id: number): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantForEdit(response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantForEdit(response: Response): Observable<TenantEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenant(input: TenantEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantFeaturesForEdit(id: number): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantFeaturesForEdit(response: Response): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantFeatures(input: UpdateTenantFeaturesInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetTenantSpecificFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetTenantSpecificFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockTenantAdmin(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockTenantAdmin(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockTenantAdmin(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMemberActivity(response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberActivity(response: Response): Observable<GetMemberActivityOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardData(response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardData(response: Response): Observable<GetDashboardDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod2): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesSummary(response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesSummary(response: Response): Observable<GetSalesSummaryOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getWorldMap(input: any): Observable<GetWorldMapOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetWorldMap?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorldMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorldMap(response_);
                } catch (e) {
                    return <Observable<GetWorldMapOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorldMapOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorldMap(response: Response): Observable<GetWorldMapOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorldMapOutput.fromJS(resultData200) : new GetWorldMapOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetWorldMapOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getGeneralStats(input: any): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGeneralStats(response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetGeneralStats(response: Response): Observable<GetGeneralStatsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGeneralStatsOutput>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerTenant(input: RegisterTenantInput): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterTenant(response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterTenant(response: Response): Observable<RegisterTenantOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForSelect(response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForSelect(response: Response): Observable<EditionsSelectOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionsSelectOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEdition(editionId: number): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === undefined || editionId === null)
            throw new Error("The parameter 'editionId' must be defined and cannot be null.");
        else
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEdition(response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEdition(response: Response): Observable<EditionSelectDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<TenantSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: TenantSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearLogo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearLogo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCustomCss(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCustomCss(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: DefaultTimezoneScope): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezones(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezones(response: Response): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezoneComboboxItems(response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezoneComboboxItems(response: Response): Observable<ComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticateLoginSalesWab(model: AuthenticateModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateLoginSalesWab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticateLoginSalesWab(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticateLoginSalesWab(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticateLoginSalesWab(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticate(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticate(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    loginMemberWeb(model: LoginMemberInputModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LoginMemberWeb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLoginMemberWeb(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLoginMemberWeb(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processLoginMemberWeb(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    loginMemberMobile(model: LoginMemberInputModel): Observable<LoginMemberMobileDto> {
        let url_ = this.baseUrl + "/api/TokenAuth/LoginMemberMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLoginMemberMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLoginMemberMobile(response_);
                } catch (e) {
                    return <Observable<LoginMemberMobileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<LoginMemberMobileDto>><any>Observable.throw(response_);
        });
    }

    protected processLoginMemberMobile(response: Response): Observable<LoginMemberMobileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginMemberMobileDto.fromJS(resultData200) : new LoginMemberMobileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<LoginMemberMobileDto>(<any>null);
    }

    /**
     * @domainLogin (optional) 
     * @return Success
     */
    updateDomain(userID: number, domainLogin: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/TokenAuth/UpdateDomain?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (domainLogin !== undefined)
            url_ += "domainLogin=" + encodeURIComponent("" + domainLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDomain(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDomain(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDomain(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    logoutMember(memberCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogoutMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLogoutMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLogoutMember(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processLogoutMember(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    logoutMemberMobile(model: LogoutMemberInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogoutMemberMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLogoutMemberMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLogoutMemberMobile(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processLogoutMemberMobile(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(model: SendTwoFactorAuthCodeModel): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTwoFactorAuthCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTwoFactorAuthCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonatedAuthenticate(response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processImpersonatedAuthenticate(response: Response): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkedAccountAuthenticate(response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processLinkedAccountAuthenticate(response: Response): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalAuthenticationProviders(response: Response): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExternalAuthenticate(response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processExternalAuthenticate(response: Response): Observable<ExternalAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @message (optional) 
     * @severity (optional) 
     * @return Success
     */
    testNotification(message: string, severity: string): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrAddressServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAddress(input: GetUpdateAddressInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrAddress/UpdateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAddress(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAddress(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @addrType (optional) 
     * @return Success
     */
    deleteAddress(psCode: string, refID: number, addrType: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrAddress/DeleteAddress?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        if (addrType !== undefined)
            url_ += "addrType=" + encodeURIComponent("" + addrType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAddress(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAddress(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAddress(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TransactionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    step23InsertDocumentKPR(input: Step23InsertDocumentKPRInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Step23InsertDocumentKPR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStep23InsertDocumentKPR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStep23InsertDocumentKPR(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStep23InsertDocumentKPR(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateTimeTrUnitReserved(userID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/UpdateTimeTrUnitReserved?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTimeTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTimeTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTimeTrUnitReserved(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @pPNo (optional) 
     * @return Success
     */
    printTTBFRename(pPOrderID: number, pPNo: string): Observable<GenerateTTBFResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/PrintTTBFRename?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintTTBFRename(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintTTBFRename(response_);
                } catch (e) {
                    return <Observable<GenerateTTBFResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateTTBFResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintTTBFRename(response: Response): Observable<GenerateTTBFResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateTTBFResultDto.fromJS(resultData200) : new GenerateTTBFResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateTTBFResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    insertSinglePayment(bookingHeaderID: number, amount: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertSinglePayment?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertSinglePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertSinglePayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertSinglePayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoundDetailSchedule(unitID: number, termID: number, sellingPrice: number): Observable<GetSchedulerListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetRoundDetailSchedule?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (termID === undefined || termID === null)
            throw new Error("The parameter 'termID' must be defined and cannot be null.");
        else
            url_ += "termID=" + encodeURIComponent("" + termID) + "&"; 
        if (sellingPrice === undefined || sellingPrice === null)
            throw new Error("The parameter 'sellingPrice' must be defined and cannot be null.");
        else
            url_ += "sellingPrice=" + encodeURIComponent("" + sellingPrice) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoundDetailSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoundDetailSchedule(response_);
                } catch (e) {
                    return <Observable<GetSchedulerListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSchedulerListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRoundDetailSchedule(response: Response): Observable<GetSchedulerListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetSchedulerListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSchedulerListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    roundingAmountSchedule(bookCode: string): Observable<GetRoundingScheduleResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/RoundingAmountSchedule?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRoundingAmountSchedule(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRoundingAmountSchedule(response_);
                } catch (e) {
                    return <Observable<GetRoundingScheduleResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRoundingScheduleResultDto>><any>Observable.throw(response_);
        });
    }

    protected processRoundingAmountSchedule(response: Response): Observable<GetRoundingScheduleResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoundingScheduleResultDto.fromJS(resultData200) : new GetRoundingScheduleResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRoundingScheduleResultDto>(<any>null);
    }

    /**
     * @bookCodeList (optional) 
     * @return Success
     */
    roundingScheduleMultiple(bookCodeList: string[]): Observable<RoundingScheduleResult[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/RoundingScheduleMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookCodeList);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRoundingScheduleMultiple(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRoundingScheduleMultiple(response_);
                } catch (e) {
                    return <Observable<RoundingScheduleResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<RoundingScheduleResult[]>><any>Observable.throw(response_);
        });
    }

    protected processRoundingScheduleMultiple(response: Response): Observable<RoundingScheduleResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RoundingScheduleResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RoundingScheduleResult[]>(<any>null);
    }

    /**
     * @orderCode (optional) 
     * @return Success
     */
    checkPayment(orderCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/CheckPayment?";
        if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckPayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCheckPayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingCekPayment(input: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBookingCekPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingCekPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingCekPayment(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingCekPayment(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reorderUnitMobey(input: CreateTransactionUniversalDto): Observable<TrUnitOrderHeaderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ReorderUnitMobey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReorderUnitMobey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReorderUnitMobey(response_);
                } catch (e) {
                    return <Observable<TrUnitOrderHeaderResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrUnitOrderHeaderResultDto>><any>Observable.throw(response_);
        });
    }

    protected processReorderUnitMobey(response: Response): Observable<TrUnitOrderHeaderResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrUnitOrderHeaderResultDto.fromJS(resultData200) : new TrUnitOrderHeaderResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrUnitOrderHeaderResultDto>(<any>null);
    }

    /**
     * @unitID (optional) 
     * @return Success
     */
    insertTrBookingHeaderInfo(unitID: number[], bookingHeaderID: number, bookDate: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertTrBookingHeaderInfo?";
        if (bookingHeaderID === undefined || bookingHeaderID === null)
            throw new Error("The parameter 'bookingHeaderID' must be defined and cannot be null.");
        else
            url_ += "bookingHeaderID=" + encodeURIComponent("" + bookingHeaderID) + "&"; 
        if (bookDate === undefined || bookDate === null)
            throw new Error("The parameter 'bookDate' must be defined and cannot be null.");
        else
            url_ += "bookDate=" + encodeURIComponent(bookDate ? "" + bookDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitID);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTrBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTrBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertTrBookingHeaderInfo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createLogMobey(input: CreateLogMobeyInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/CreateLogMobey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateLogMobey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateLogMobey(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateLogMobey(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListNotaris(): Observable<ListResultDtoOfGetListNotaris> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetListNotaris";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListNotaris(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListNotaris(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetListNotaris>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetListNotaris>><any>Observable.throw(response_);
        });
    }

    protected processGetListNotaris(response: Response): Observable<ListResultDtoOfGetListNotaris> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetListNotaris.fromJS(resultData200) : new ListResultDtoOfGetListNotaris();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetListNotaris>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertTrUnitReserved(input: InsertTRUnitReservedInputDto): Observable<InsertTrUnitReservedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertTrUnitReserved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<InsertTrUnitReservedResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InsertTrUnitReservedResultDto>><any>Observable.throw(response_);
        });
    }

    protected processInsertTrUnitReserved(response: Response): Observable<InsertTrUnitReservedResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InsertTrUnitReservedResultDto.fromJS(resultData200) : new InsertTrUnitReservedResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InsertTrUnitReservedResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePsCodeTrUnitReserved(input: UpdateTRUnitReserved): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/UpdatePsCodeTrUnitReserved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePsCodeTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePsCodeTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePsCodeTrUnitReserved(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    deleteTrUnitReserved(unitReservedID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DeleteTrUnitReserved?";
        if (unitReservedID === undefined || unitReservedID === null)
            throw new Error("The parameter 'unitReservedID' must be defined and cannot be null.");
        else
            url_ += "unitReservedID=" + encodeURIComponent("" + unitReservedID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrUnitReserved(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDetailBookingUnit(userID: number, psCode: string): Observable<ListDetailBookingUnitResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetDetailBookingUnit?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingUnit(response_);
                } catch (e) {
                    return <Observable<ListDetailBookingUnitResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDetailBookingUnitResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingUnit(response: Response): Observable<ListDetailBookingUnitResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListDetailBookingUnitResultDto.fromJS(resultData200) : new ListDetailBookingUnitResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDetailBookingUnitResultDto>(<any>null);
    }

    /**
     * @waktuOrder (optional) 
     * @return Success
     */
    checkFullyPaidUnit(unitID: number, waktuOrder: string): Observable<CheckFullyPaidResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/CheckFullyPaidUnit?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (waktuOrder !== undefined)
            url_ += "waktuOrder=" + encodeURIComponent("" + waktuOrder) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckFullyPaidUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckFullyPaidUnit(response_);
                } catch (e) {
                    return <Observable<CheckFullyPaidResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckFullyPaidResultDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckFullyPaidUnit(response: Response): Observable<CheckFullyPaidResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckFullyPaidResultDto.fromJS(resultData200) : new CheckFullyPaidResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckFullyPaidResultDto>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    getDetailBookingUnitApps(userID: number, psCode: string): Observable<ListDetailBookingUnitAppsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetDetailBookingUnitApps?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailBookingUnitApps(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailBookingUnitApps(response_);
                } catch (e) {
                    return <Observable<ListDetailBookingUnitAppsResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListDetailBookingUnitAppsResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailBookingUnitApps(response: Response): Observable<ListDetailBookingUnitAppsResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListDetailBookingUnitAppsResultDto.fromJS(resultData200) : new ListDetailBookingUnitAppsResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListDetailBookingUnitAppsResultDto>(<any>null);
    }

    /**
     * @orderDate (optional) 
     * @return Success
     */
    generateOrderCodeUnit(projectID: number, orderDate: moment.Moment): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GenerateOrderCodeUnit?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (orderDate !== undefined)
            url_ += "orderDate=" + encodeURIComponent(orderDate ? "" + orderDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateOrderCodeUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateOrderCodeUnit(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGenerateOrderCodeUnit(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertTrUnitOrderHeader(input: CreateTransactionUniversalDto): Observable<TrUnitOrderHeaderResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertTrUnitOrderHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTrUnitOrderHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTrUnitOrderHeader(response_);
                } catch (e) {
                    return <Observable<TrUnitOrderHeaderResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrUnitOrderHeaderResultDto>><any>Observable.throw(response_);
        });
    }

    protected processInsertTrUnitOrderHeader(response: Response): Observable<TrUnitOrderHeaderResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrUnitOrderHeaderResultDto.fromJS(resultData200) : new TrUnitOrderHeaderResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrUnitOrderHeaderResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    step8UpdateBFAmount(input: UpdateBFAmountInputDto): Observable<UpdateBfAmoutResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Step8UpdateBFAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStep8UpdateBFAmount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStep8UpdateBFAmount(response_);
                } catch (e) {
                    return <Observable<UpdateBfAmoutResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateBfAmoutResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processStep8UpdateBFAmount(response: Response): Observable<UpdateBfAmoutResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UpdateBfAmoutResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateBfAmoutResultDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    stepNewInsertTrBookingHeaderInfo(bookCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/StepNewInsertTrBookingHeaderInfo?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStepNewInsertTrBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStepNewInsertTrBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processStepNewInsertTrBookingHeaderInfo(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    testTime(creationTime: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/testTime?";
        if (creationTime === undefined || creationTime === null)
            throw new Error("The parameter 'creationTime' must be defined and cannot be null.");
        else
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestTime(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestTime(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerStatusOrderExpired(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SchedulerStatusOrderExpired";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerStatusOrderExpired(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerStatusOrderExpired(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerStatusOrderExpired(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerTRUnitReserved(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SchedulerTRUnitReserved";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerTRUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerTRUnitReserved(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerTRUnitReserved(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTimeTrUnitReserved(userID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetTimeTrUnitReserved?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimeTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimeTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTimeTrUnitReserved(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTrUnitReserved(userID: number): Observable<GetTrUnitReservedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetTrUnitReserved?";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTrUnitReserved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTrUnitReserved(response_);
                } catch (e) {
                    return <Observable<GetTrUnitReservedDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTrUnitReservedDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTrUnitReserved(response: Response): Observable<GetTrUnitReservedDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTrUnitReservedDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTrUnitReservedDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPPNUnit(unitID: number, price: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetPPNUnit?";
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (price === undefined || price === null)
            throw new Error("The parameter 'price' must be defined and cannot be null.");
        else
            url_ += "price=" + encodeURIComponent("" + price) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPNUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPNUnit(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processGetPPNUnit(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @return Success
     */
    getGetListBank(): Observable<GetListBankResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetGetListBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGetListBank(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGetListBank(response_);
                } catch (e) {
                    return <Observable<GetListBankResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListBankResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetGetListBank(response: Response): Observable<GetListBankResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListBankResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListBankResultDto[]>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    bookCode(projectCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/BookCode?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBookCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBookCode(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processBookCode(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reorderUnit(input: CreateTransactionUniversalDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ReorderUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReorderUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReorderUnit(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processReorderUnit(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertTransactionUniversal(input: CreateTransactionUniversalDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertTransactionUniversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertTransactionUniversal(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertTransactionUniversal(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processInsertTransactionUniversal(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    checkAndInsertTrBookingHeaderInfo(bookCode: string): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/checkAndInsertTrBookingHeaderInfo?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckAndInsertTrBookingHeaderInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckAndInsertTrBookingHeaderInfo(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCheckAndInsertTrBookingHeaderInfo(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingVaNobuReq(input: CreateTransactionUniversalDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBookingVaNobuReq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingVaNobuReq(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingVaNobuReq(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingVaNobuReq(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingMidransReq(input: CreateTransactionUniversalDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBookingMidransReq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingMidransReq(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingMidransReq(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingMidransReq(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingPriorityPass(input: NewCreateTransactionUniversalDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBookingPriorityPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingPriorityPass(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingPriorityPass(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingPriorityPass(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBooking(input: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBooking(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBooking(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDoBooking(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUniversalBuyPP(input: PaymentOnlineBookingResponse): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertUniversalBuyPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUniversalBuyPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUniversalBuyPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertUniversalBuyPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @ppNo (optional) 
     * @return Success
     */
    manualInsertCommPP(ppNo: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ManualInsertCommPP?";
        if (ppNo !== undefined)
            url_ += "ppNo=" + encodeURIComponent("" + ppNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processManualInsertCommPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processManualInsertCommPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processManualInsertCommPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertCommPP(input: InsertCommPPDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertCommPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertCommPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertCommPP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertCommPP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @scmCode (optional) 
     * @projectCode (optional) 
     * @clusterCode (optional) 
     * @return Success
     */
    getCommMemberOverriding(memberCode: string, scmCode: string, allowThrow: boolean, projectCode: string, clusterCode: string): Observable<GetCommMemberListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetCommMemberOverriding?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (allowThrow === undefined || allowThrow === null)
            throw new Error("The parameter 'allowThrow' must be defined and cannot be null.");
        else
            url_ += "allowThrow=" + encodeURIComponent("" + allowThrow) + "&"; 
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (clusterCode !== undefined)
            url_ += "clusterCode=" + encodeURIComponent("" + clusterCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommMemberOverriding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommMemberOverriding(response_);
                } catch (e) {
                    return <Observable<GetCommMemberListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCommMemberListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCommMemberOverriding(response: Response): Observable<GetCommMemberListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCommMemberListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCommMemberListDto[]>(<any>null);
    }

    /**
     * @memberCode (optional) 
     * @scmCode (optional) 
     * @return Success
     */
    getCommMember(memberCode: string, scmCode: string, allowThrow: boolean): Observable<GetCommMemberListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetCommMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (allowThrow === undefined || allowThrow === null)
            throw new Error("The parameter 'allowThrow' must be defined and cannot be null.");
        else
            url_ += "allowThrow=" + encodeURIComponent("" + allowThrow) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCommMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCommMember(response_);
                } catch (e) {
                    return <Observable<GetCommMemberListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCommMemberListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCommMember(response: Response): Observable<GetCommMemberListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetCommMemberListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCommMemberListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    doBookingMobey(input: CreateTransactionUniversalDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/DoBookingMobey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDoBookingMobey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDoBookingMobey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDoBookingMobey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerBookingReminder(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SchedulerBookingReminder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerBookingReminder(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerBookingReminder(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerBookingReminder(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    createQrCodeInBase64(bookCode: string, psCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/CreateQrCodeInBase64?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateQrCodeInBase64(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateQrCodeInBase64(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processCreateQrCodeInBase64(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generateDocumentParameter2(bookCode: string): Observable<P32DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GenerateDocumentParameter2?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateDocumentParameter2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateDocumentParameter2(response_);
                } catch (e) {
                    return <Observable<P32DocumentDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<P32DocumentDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateDocumentParameter2(response: Response): Observable<P32DocumentDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? P32DocumentDto.fromJS(resultData200) : new P32DocumentDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<P32DocumentDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generatePJPKK(bookCode: string): Observable<GenerateKPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GeneratePJPKK?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePJPKK(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePJPKK(response_);
                } catch (e) {
                    return <Observable<GenerateKPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateKPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePJPKK(response: Response): Observable<GenerateKPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateKPResultDto.fromJS(resultData200) : new GenerateKPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateKPResultDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    generatePJPKKBackup(bookCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GeneratePJPKKBackup?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePJPKKBackup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePJPKKBackup(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePJPKKBackup(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    generateKP(orderID: number, unitID: number): Observable<GenerateKPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GenerateKP?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateKP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateKP(response_);
                } catch (e) {
                    return <Observable<GenerateKPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateKPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateKP(response: Response): Observable<GenerateKPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateKPResultDto.fromJS(resultData200) : new GenerateKPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateKPResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    generateKPCheckExist(orderID: number, unitID: number): Observable<GenerateKPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GenerateKPCheckExist?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateKPCheckExist(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateKPCheckExist(response_);
                } catch (e) {
                    return <Observable<GenerateKPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateKPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateKPCheckExist(response: Response): Observable<GenerateKPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateKPResultDto.fromJS(resultData200) : new GenerateKPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateKPResultDto>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @isResend (optional) 
     * @return Success
     */
    sendEmailKP(orderID: number, unitID: number, bookCode: string, isResend: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SendEmailKP?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined and cannot be null.");
        else
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        if (unitID === undefined || unitID === null)
            throw new Error("The parameter 'unitID' must be defined and cannot be null.");
        else
            url_ += "unitID=" + encodeURIComponent("" + unitID) + "&"; 
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        if (isResend !== undefined)
            url_ += "isResend=" + encodeURIComponent("" + isResend) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailKP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailKP(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailKP(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    sendEmailTTBF(pPOrderID: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SendEmailTTBF?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailTTBF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailTTBF(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailTTBF(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailTTBFMobile(input: SendEmailTTBFInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SendEmailTTBFMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailTTBFMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailTTBFMobile(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailTTBFMobile(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    resendKP(orderHeaderID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ResendKP?";
        if (orderHeaderID === undefined || orderHeaderID === null)
            throw new Error("The parameter 'orderHeaderID' must be defined and cannot be null.");
        else
            url_ += "orderHeaderID=" + encodeURIComponent("" + orderHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendKP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendKP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResendKP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resendKPMobile(input: ResendKPInputMobile): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ResendKPMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResendKPMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResendKPMobile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResendKPMobile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    inputPaymentOffline(input: InsertPaymentOfflineInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InputPaymentOffline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInputPaymentOffline(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInputPaymentOffline(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processInputPaymentOffline(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @pPNo (optional) 
     * @return Success
     */
    printTTBF(pPOrderID: number, pPNo: string): Observable<GenerateTTBFResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/PrintTTBF?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintTTBF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintTTBF(response_);
                } catch (e) {
                    return <Observable<GenerateTTBFResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateTTBFResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintTTBF(response: Response): Observable<GenerateTTBFResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateTTBFResultDto.fromJS(resultData200) : new GenerateTTBFResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateTTBFResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printTTBFMobile(input: PrintTTBFInputDto): Observable<GenerateTTBFResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/PrintTTBFMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintTTBFMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintTTBFMobile(response_);
                } catch (e) {
                    return <Observable<GenerateTTBFResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GenerateTTBFResultDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintTTBFMobile(response: Response): Observable<GenerateTTBFResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GenerateTTBFResultDto.fromJS(resultData200) : new GenerateTTBFResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GenerateTTBFResultDto>(<any>null);
    }

    /**
     * @pPNo (optional) 
     * @return Success
     */
    getPPPrice(pPNo: string): Observable<GetPPPriceResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetPPPrice?";
        if (pPNo !== undefined)
            url_ += "PPNo=" + encodeURIComponent("" + pPNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPPrice(response_);
                } catch (e) {
                    return <Observable<GetPPPriceResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPPPriceResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPPPrice(response: Response): Observable<GetPPPriceResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPPPriceResultDto.fromJS(resultData200) : new GetPPPriceResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPPPriceResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerOutstanding(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/SchedulerOutstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerOutstanding(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerOutstanding(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerOutstanding(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    viewKonfirmasiPesanan(input: ViewKonfirmasiPesananDto): Observable<ResultMessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ViewKonfirmasiPesanan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processViewKonfirmasiPesanan(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processViewKonfirmasiPesanan(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto[]>><any>Observable.throw(response_);
        });
    }

    protected processViewKonfirmasiPesanan(response: Response): Observable<ResultMessageDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ResultMessageDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    insertSoldUnitAndSoldUnitRequirement(bookCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/InsertSoldUnitAndSoldUnitRequirement?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertSoldUnitAndSoldUnitRequirement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertSoldUnitAndSoldUnitRequirement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processInsertSoldUnitAndSoldUnitRequirement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    bookingUniversalForCUR(input: GetDataBookingToProcessDto): Observable<CURBookingResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/bookingUniversalForCUR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBookingUniversalForCUR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBookingUniversalForCUR(response_);
                } catch (e) {
                    return <Observable<CURBookingResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CURBookingResultDto>><any>Observable.throw(response_);
        });
    }

    protected processBookingUniversalForCUR(response: Response): Observable<CURBookingResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CURBookingResultDto.fromJS(resultData200) : new CURBookingResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CURBookingResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    step13AUpdateBFAmountToZero(input: GetOriginalScheduleCURInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Step13AUpdateBFAmountToZero";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStep13AUpdateBFAmountToZero(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStep13AUpdateBFAmountToZero(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStep13AUpdateBFAmountToZero(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    step22TRBookingReward(input: InsertTrBookingRewardDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Step22TRBookingReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStep22TRBookingReward(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStep22TRBookingReward(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processStep22TRBookingReward(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TransactionPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @memberCode (optional) 
     * @return Success
     */
    getDropdownProjectPP(memberCode: string): Observable<GetDropdownProjectListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetDropdownProjectPP?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProjectPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProjectPP(response_);
                } catch (e) {
                    return <Observable<GetDropdownProjectListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProjectListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProjectPP(response: Response): Observable<GetDropdownProjectListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProjectListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProjectListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLogoProject(projectId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetLogoProject?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLogoProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLogoProject(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetLogoProject(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getLogoProduct(projectInfoID: number): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetLogoProduct?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLogoProduct(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLogoProduct(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetLogoProduct(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @memberCode (optional) 
     * @return Success
     */
    getDropdownProductByProjectPP(projectCode: string, memberCode: string): Observable<GetDropdownProductListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetDropdownProductByProjectPP?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownProductByProjectPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownProductByProjectPP(response_);
                } catch (e) {
                    return <Observable<GetDropdownProductListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownProductListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownProductByProjectPP(response: Response): Observable<GetDropdownProductListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownProductListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownProductListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    trBuyPPOnline(input: TrBuyPPOnlineInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/TrBuyPPOnline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTrBuyPPOnline(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTrBuyPPOnline(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processTrBuyPPOnline(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @voucher (optional) 
     * @projectCode (optional) 
     * @username (optional) 
     * @psCode (optional) 
     * @return Success
     */
    verifyVoucher(voucher: string, projectCode: string, username: string, psCode: string): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/VerifyVoucher?";
        if (voucher !== undefined)
            url_ += "voucher=" + encodeURIComponent("" + voucher) + "&"; 
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifyVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifyVoucher(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processVerifyVoucher(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkFullyPaidPP(pPOrderID: number): Observable<CheckFullyPaidPPResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/CheckFullyPaidPP?";
        if (pPOrderID === undefined || pPOrderID === null)
            throw new Error("The parameter 'pPOrderID' must be defined and cannot be null.");
        else
            url_ += "PPOrderID=" + encodeURIComponent("" + pPOrderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckFullyPaidPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckFullyPaidPP(response_);
                } catch (e) {
                    return <Observable<CheckFullyPaidPPResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckFullyPaidPPResultDto>><any>Observable.throw(response_);
        });
    }

    protected processCheckFullyPaidPP(response: Response): Observable<CheckFullyPaidPPResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckFullyPaidPPResultDto.fromJS(resultData200) : new CheckFullyPaidPPResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckFullyPaidPPResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifyVoucherMobile(input: VerifyVoucherInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/VerifyVoucherMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifyVoucherMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifyVoucherMobile(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processVerifyVoucherMobile(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    buyPPVaNobuReq(input: BuyPPMidtransReqInputDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/BuyPPVaNobuReq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBuyPPVaNobuReq(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBuyPPVaNobuReq(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processBuyPPVaNobuReq(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    buyPPMidtransReq(input: BuyPPMidtransReqInputDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/BuyPPMidtransReq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBuyPPMidtransReq(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBuyPPMidtransReq(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processBuyPPMidtransReq(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    buyPPNotMidtrans(input: BuyPPMidtransReqInputDto): Observable<PaymentOnlineBookingResponse> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/BuyPPNotMidtrans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBuyPPNotMidtrans(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBuyPPNotMidtrans(response_);
                } catch (e) {
                    return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentOnlineBookingResponse>><any>Observable.throw(response_);
        });
    }

    protected processBuyPPNotMidtrans(response: Response): Observable<PaymentOnlineBookingResponse> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentOnlineBookingResponse.fromJS(resultData200) : new PaymentOnlineBookingResponse();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentOnlineBookingResponse>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @productCode (optional) 
     * @return Success
     */
    generateOrderCodePP(projectCode: string, productCode: string): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GenerateOrderCodePP?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateOrderCodePP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateOrderCodePP(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateOrderCodePP(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateOrderCodePPMobile(input: GenerateOrderCodePPInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GenerateOrderCodePPMobile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateOrderCodePPMobile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateOrderCodePPMobile(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGenerateOrderCodePPMobile(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @return Success
     */
    getPPPrice(projectInfoID: number, priorityLine: boolean): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetPPPrice?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (priorityLine === undefined || priorityLine === null)
            throw new Error("The parameter 'priorityLine' must be defined and cannot be null.");
        else
            url_ += "priorityLine=" + encodeURIComponent("" + priorityLine) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPPPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPPPrice(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processGetPPPrice(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @return Success
     */
    getBankListKPAPP(projectCode: string): Observable<GetBankKPAPPListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetBankListKPAPP?";
        if (projectCode !== undefined)
            url_ += "projectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetBankListKPAPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetBankListKPAPP(response_);
                } catch (e) {
                    return <Observable<GetBankKPAPPListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetBankKPAPPListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetBankListKPAPP(response: Response): Observable<GetBankKPAPPListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetBankKPAPPListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetBankKPAPPListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUrlBuyNUP(projectInfoID: number): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetUrlBuyNUP?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUrlBuyNUP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUrlBuyNUP(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUrlBuyNUP(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFlekStatus(projectId: number, projectInfoId: number): Observable<GetFlekStatusListDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetFlekStatus?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (projectInfoId === undefined || projectInfoId === null)
            throw new Error("The parameter 'projectInfoId' must be defined and cannot be null.");
        else
            url_ += "projectInfoId=" + encodeURIComponent("" + projectInfoId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFlekStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFlekStatus(response_);
                } catch (e) {
                    return <Observable<GetFlekStatusListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFlekStatusListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFlekStatus(response: Response): Observable<GetFlekStatusListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFlekStatusListDto.fromJS(resultData200) : new GetFlekStatusListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFlekStatusListDto>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerExpirePP(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/SchedulerExpirePP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerExpirePP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerExpirePP(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerExpirePP(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @productCode (optional) 
     * @return Success
     */
    getDropdownUnitCode(projectId: number, productCode: string): Observable<GetDropdownUnitCodeListDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetDropdownUnitCode?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitCode(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitCodeListDTO[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitCodeListDTO[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitCode(response: Response): Observable<GetDropdownUnitCodeListDTO[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitCodeListDTO.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitCodeListDTO[]>(<any>null);
    }

    /**
     * @productCode (optional) 
     * @return Success
     */
    getDropdownUnitNo(projectId: number, productCode: string, unitCodeID: number): Observable<GetDropdownUnitNoListDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPP/GetDropdownUnitNo?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&"; 
        if (unitCodeID === undefined || unitCodeID === null)
            throw new Error("The parameter 'unitCodeID' must be defined and cannot be null.");
        else
            url_ += "unitCodeID=" + encodeURIComponent("" + unitCodeID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownUnitNo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownUnitNo(response_);
                } catch (e) {
                    return <Observable<GetDropdownUnitNoListDTO[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownUnitNoListDTO[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownUnitNo(response: Response): Observable<GetDropdownUnitNoListDTO[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownUnitNoListDTO.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownUnitNoListDTO[]>(<any>null);
    }
}

@Injectable()
export class TrBankAccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateBankAccount(input: GetUpdateBankAccountInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrBankAccount/UpdateBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateBankAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateBankAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateBankAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @psCode (optional) 
     * @bankCode (optional) 
     * @return Success
     */
    deleteBankAccount(psCode: string, refID: number, bankCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrBankAccount/DeleteBankAccount?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        if (bankCode !== undefined)
            url_ += "bankCode=" + encodeURIComponent("" + bankCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteBankAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteBankAccount(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteBankAccount(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrBasePriceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    uploadBasePrice(input: UploadBasePriceInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrBasePrice/UploadBasePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUploadBasePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUploadBasePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUploadBasePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @projectCode (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getAllTrBasePrice(projectCode: string, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfGetAllBasePriceListDto> {
        let url_ = this.baseUrl + "/api/services/app/TrBasePrice/GetAllTrBasePrice?";
        if (projectCode !== undefined)
            url_ += "ProjectCode=" + encodeURIComponent("" + projectCode) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTrBasePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTrBasePrice(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllBasePriceListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllBasePriceListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTrBasePrice(response: Response): Observable<PagedResultDtoOfGetAllBasePriceListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllBasePriceListDto.fromJS(resultData200) : new PagedResultDtoOfGetAllBasePriceListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetAllBasePriceListDto>(<any>null);
    }
}

@Injectable()
export class TrCompanyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    deleteTrCompany(psCode: string, refID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrCompany/DeleteTrCompany?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrCompany(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrCompany(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrCompany(input: CreateOrUpdateTrCompanyListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrCompany/UpdateTrCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrCompany(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrCompany(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrCompany(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrEmailServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @inputs (optional) 
     * @return Success
     */
    updateEmail(inputs: GetUpdateEmailInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrEmail/UpdateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @entityCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    deleteEmail(entityCode: string, psCode: string, refID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrEmail/DeleteEmail?";
        if (entityCode !== undefined)
            url_ += "entityCode=" + encodeURIComponent("" + entityCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrFamilyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    deleteTrFamily(psCode: string, refID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrFamily/DeleteTrFamily?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrFamily(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrFamily(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrFamily(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrFamily(input: UpdateTrFamilyListDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrFamily/UpdateTrFamily";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrFamily(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrFamily(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrFamily(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrIDServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @psCode (optional) 
     * @return Success
     */
    deleteTrID(psCode: string, refID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrID/DeleteTrID?";
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrID(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrID(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrID(input: UpdateTrIDInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrID/UpdateTrID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrID(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrID(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrKeyPeopleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteTrKeyPeople(trKeyPeopleID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrKeyPeople/DeleteTrKeyPeople?";
        if (trKeyPeopleID === undefined || trKeyPeopleID === null)
            throw new Error("The parameter 'trKeyPeopleID' must be defined and cannot be null.");
        else
            url_ += "trKeyPeopleID=" + encodeURIComponent("" + trKeyPeopleID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrKeyPeople(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrKeyPeople(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrKeyPeople(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrJKeyPeople(input: UpdateTrJKeyPeopleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrKeyPeople/UpdateTrJKeyPeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrJKeyPeople(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrJKeyPeople(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrJKeyPeople(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrPhoneServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @inputs (optional) 
     * @return Success
     */
    updateTrPhone(inputs: GetUpdateTrPhoneInputDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrPhone/UpdateTrPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @entityCode (optional) 
     * @psCode (optional) 
     * @return Success
     */
    deleteTrPhone(entityCode: string, psCode: string, refID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrPhone/DeleteTrPhone?";
        if (entityCode !== undefined)
            url_ += "entityCode=" + encodeURIComponent("" + entityCode) + "&"; 
        if (psCode !== undefined)
            url_ += "psCode=" + encodeURIComponent("" + psCode) + "&"; 
        if (refID === undefined || refID === null)
            throw new Error("The parameter 'refID' must be defined and cannot be null.");
        else
            url_ += "refID=" + encodeURIComponent("" + refID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrPhone(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrPhone(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrPhone(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TTORServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBookingCorres(input: CreateTrBookingCorresInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/CreateTrBookingCorres";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBookingCorres(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBookingCorres(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBookingCorres(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDropdownCorresType(flag: number): Observable<GetDropdownCorresTypeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/GetDropdownCorresType?";
        if (flag === undefined || flag === null)
            throw new Error("The parameter 'flag' must be defined and cannot be null.");
        else
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownCorresType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownCorresType(response_);
                } catch (e) {
                    return <Observable<GetDropdownCorresTypeListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownCorresTypeListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownCorresType(response: Response): Observable<GetDropdownCorresTypeListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownCorresTypeListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownCorresTypeListDto[]>(<any>null);
    }

    /**
     * @bookCode (optional) 
     * @return Success
     */
    getTasklistTTOR(bookCode: string): Observable<GetTasklistTTORListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/GetTasklistTTOR?";
        if (bookCode !== undefined)
            url_ += "bookCode=" + encodeURIComponent("" + bookCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTasklistTTOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTasklistTTOR(response_);
                } catch (e) {
                    return <Observable<GetTasklistTTORListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTasklistTTORListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTasklistTTOR(response: Response): Observable<GetTasklistTTORListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetTasklistTTORListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTasklistTTORListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDocumentAttribute(): Observable<GetDocumentAttributeResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/GetDocumentAttribute";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDocumentAttribute(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDocumentAttribute(response_);
                } catch (e) {
                    return <Observable<GetDocumentAttributeResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDocumentAttributeResultDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDocumentAttribute(response: Response): Observable<GetDocumentAttributeResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDocumentAttributeResultDto.fromJS(resultData200) : new GetDocumentAttributeResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDocumentAttributeResultDto>(<any>null);
    }

    /**
     * @docId (optional) 
     * @return Success
     */
    viewDocumentManagement(docId: string): Observable<ViewDocumentResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/ViewDocumentManagement?";
        if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processViewDocumentManagement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processViewDocumentManagement(response_);
                } catch (e) {
                    return <Observable<ViewDocumentResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ViewDocumentResultDto>><any>Observable.throw(response_);
        });
    }

    protected processViewDocumentManagement(response: Response): Observable<ViewDocumentResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ViewDocumentResultDto.fromJS(resultData200) : new ViewDocumentResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ViewDocumentResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveDirectStore(input: SaveDirectStoreInputDto): Observable<SaveDirectStoreResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/SaveDirectStore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveDirectStore(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveDirectStore(response_);
                } catch (e) {
                    return <Observable<SaveDirectStoreResultDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SaveDirectStoreResultDto>><any>Observable.throw(response_);
        });
    }

    protected processSaveDirectStore(response: Response): Observable<SaveDirectStoreResultDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SaveDirectStoreResultDto.fromJS(resultData200) : new SaveDirectStoreResultDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SaveDirectStoreResultDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    viewTTOR(input: ViewTTORInputDto): Observable<ViewTTORResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TTOR/ViewTTOR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processViewTTOR(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processViewTTOR(response_);
                } catch (e) {
                    return <Observable<ViewTTORResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ViewTTORResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processViewTTOR(response: Response): Observable<ViewTTORResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ViewTTORResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ViewTTORResultDto[]>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUiManagementSettings(response: Response): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UiCustomizationSettingsEditDto>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDefaultUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUseSystemDefaultSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUseSystemDefaultSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UpdatePriceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelUpdateGrossPrice(input: GenerateExcelUpdateGrossPriceInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/GenerateExcelUpdateGrossPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelUpdateGrossPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelUpdateGrossPrice(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelUpdateGrossPrice(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifyStgUnitItemPrice(input: CreateStgUnitItemPriceInputDto): Observable<CreateStgUnitItemPriceInputDto> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/VerifyStgUnitItemPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifyStgUnitItemPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifyStgUnitItemPrice(response_);
                } catch (e) {
                    return <Observable<CreateStgUnitItemPriceInputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateStgUnitItemPriceInputDto>><any>Observable.throw(response_);
        });
    }

    protected processVerifyStgUnitItemPrice(response: Response): Observable<CreateStgUnitItemPriceInputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateStgUnitItemPriceInputDto.fromJS(resultData200) : new CreateStgUnitItemPriceInputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateStgUnitItemPriceInputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createStgUnitItemPrice(input: CreateStgUnitItemPriceInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/CreateStgUnitItemPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateStgUnitItemPrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateStgUnitItemPrice(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateStgUnitItemPrice(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    getListFileUpdatePrice(projectID: number, userID: number): Observable<GetListFileUpdatePriceResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/GetListFileUpdatePrice?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined and cannot be null.");
        else
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetListFileUpdatePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetListFileUpdatePrice(response_);
                } catch (e) {
                    return <Observable<GetListFileUpdatePriceResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetListFileUpdatePriceResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetListFileUpdatePrice(response: Response): Observable<GetListFileUpdatePriceResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetListFileUpdatePriceResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetListFileUpdatePriceResultDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    schedulerUpdatePrice(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/SchedulerUpdatePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSchedulerUpdatePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSchedulerUpdatePrice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSchedulerUpdatePrice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDropdownRenov(input: GetDropdownTermCodeInputDto): Observable<GetRenovationDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/GetDropdownRenov";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownRenov(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownRenov(response_);
                } catch (e) {
                    return <Observable<GetRenovationDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRenovationDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownRenov(response: Response): Observable<GetRenovationDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRenovationDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRenovationDropdownListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDropdownTermCode(input: GetDropdownTermCodeInputDto): Observable<GetDropdownTermCodeResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/GetDropdownTermCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDropdownTermCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDropdownTermCode(response_);
                } catch (e) {
                    return <Observable<GetDropdownTermCodeResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownTermCodeResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDropdownTermCode(response: Response): Observable<GetDropdownTermCodeResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownTermCodeResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownTermCodeResultDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTaskListSchedulerUpdatePrice(input: GenerateExcelUpdateGrossPriceInputDto): Observable<GetDataReportUpdatePriceResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UpdatePrice/GetTaskListSchedulerUpdatePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTaskListSchedulerUpdatePrice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTaskListSchedulerUpdatePrice(response_);
                } catch (e) {
                    return <Observable<GetDataReportUpdatePriceResultDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataReportUpdatePriceResultDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTaskListSchedulerUpdatePrice(response: Response): Observable<GetDataReportUpdatePriceResultDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataReportUpdatePriceResultDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataReportUpdatePriceResultDto[]>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getUsers(filter: string, permission: string, role: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsers(response: Response): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUsersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForEdit(id: number): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForEdit(response: Response): Observable<GetUserForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getUserPermissionsForEdit(id: number): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserPermissionsForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserPermissionsForEdit(response: Response): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetUserSpecificPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetUserSpecificPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUser(input: CreateOrUpdateUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockUser(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    linkToUser(input: LinkToUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkToUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkToUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processLinkToUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number, skipCount: number, sorting: string): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLinkedUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLinkedUsers(response: Response): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentlyUsedLinkedUsers(response: Response): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlinkUser(input: UnlinkUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlinkUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlinkUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentUserLoginAttempts(response: Response): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class UserPPServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @ipServer (optional) 
     * @credentialUser (optional) 
     * @credentialPass (optional) 
     * @databaseName (optional) 
     * @tableName (optional) 
     * @linkServer (optional) 
     * @scmCode (optional) 
     * @query (optional) 
     * @return Success
     */
    getDataUser(ipServer: string, credentialUser: string, credentialPass: string, databaseName: string, tableName: string, linkServer: string, scmCode: string, query: string): Observable<ListResultDtoOfGetDataPPUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPP/GetDataUser?";
        if (ipServer !== undefined)
            url_ += "IpServer=" + encodeURIComponent("" + ipServer) + "&"; 
        if (credentialUser !== undefined)
            url_ += "credentialUser=" + encodeURIComponent("" + credentialUser) + "&"; 
        if (credentialPass !== undefined)
            url_ += "credentialPass=" + encodeURIComponent("" + credentialPass) + "&"; 
        if (databaseName !== undefined)
            url_ += "databaseName=" + encodeURIComponent("" + databaseName) + "&"; 
        if (tableName !== undefined)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&"; 
        if (linkServer !== undefined)
            url_ += "linkServer=" + encodeURIComponent("" + linkServer) + "&"; 
        if (scmCode !== undefined)
            url_ += "scmCode=" + encodeURIComponent("" + scmCode) + "&"; 
        if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataUser(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDataPPUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDataPPUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataUser(response: Response): Observable<ListResultDtoOfGetDataPPUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDataPPUserListDto.fromJS(resultData200) : new ListResultDtoOfGetDataPPUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDataPPUserListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    insertUserPP(input: ConnStringUserInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/UserPP/InsertUserPP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInsertUserPP(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInsertUserPP(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processInsertUserPP(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @flag (optional) 
     * @return Success
     */
    getDetailResultUpload(flag: string): Observable<GetDetailUploadListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPP/GetDetailResultUpload?";
        if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDetailResultUpload(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDetailResultUpload(response_);
                } catch (e) {
                    return <Observable<GetDetailUploadListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDetailUploadListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDetailResultUpload(response: Response): Observable<GetDetailUploadListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDetailUploadListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDetailUploadListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    userLoginMigration(input: ConnStringUserInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/UserPP/UserLoginMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUserLoginMigration(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUserLoginMigration(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processUserLoginMigration(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class VaBulkPaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    checkDataUploadVaBulk(input: CheckDataVaBulkInputDto[]): Observable<GetDataCheckUploadVaBulkListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VaBulkPayment/CheckDataUploadVaBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDataUploadVaBulk(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDataUploadVaBulk(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadVaBulkListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadVaBulkListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckDataUploadVaBulk(response: Response): Observable<GetDataCheckUploadVaBulkListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadVaBulkListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadVaBulkListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversalBulkPayment(input: CreateUniversalVaBulkPaymentInputDto[]): Observable<GetDataCheckUploadVaBulkListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VaBulkPayment/CreateUniversalBulkPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversalBulkPayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversalBulkPayment(response_);
                } catch (e) {
                    return <Observable<GetDataCheckUploadVaBulkListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataCheckUploadVaBulkListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversalBulkPayment(response: Response): Observable<GetDataCheckUploadVaBulkListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDataCheckUploadVaBulkListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataCheckUploadVaBulkListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrBulkPaymentVa(input: CreateUniversalVaBulkPaymentInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VaBulkPayment/CreateTrBulkPaymentVa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrBulkPaymentVa(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrBulkPaymentVa(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrBulkPaymentVa(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class VoucherServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @voucherTypeCode (optional) 
     * @return Success
     */
    getRewardDropdownByProject(projectID: number, voucherTypeCode: string): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetRewardDropdownByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (voucherTypeCode !== undefined)
            url_ += "voucherTypeCode=" + encodeURIComponent("" + voucherTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdownByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdownByProject(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdownByProject(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @projectInfoID (optional) 
     * @voucherTypeCode (optional) 
     * @return Success
     */
    getRewardDropdownReportVoucher(projectInfoID: number[], voucherTypeCode: string): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetRewardDropdownReportVoucher?";
        if (projectInfoID !== undefined)
            projectInfoID && projectInfoID.forEach(item => { url_ += "projectInfoID=" + encodeURIComponent("" + item) + "&"; });
        if (voucherTypeCode !== undefined)
            url_ += "voucherTypeCode=" + encodeURIComponent("" + voucherTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdownReportVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdownReportVoucher(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdownReportVoucher(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @voucherTypeCode (optional) 
     * @return Success
     */
    getRewardDropdownByProjectInfo(projectInfoID: number, voucherTypeCode: string): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetRewardDropdownByProjectInfo?";
        if (projectInfoID === undefined || projectInfoID === null)
            throw new Error("The parameter 'projectInfoID' must be defined and cannot be null.");
        else
            url_ += "projectInfoID=" + encodeURIComponent("" + projectInfoID) + "&"; 
        if (voucherTypeCode !== undefined)
            url_ += "voucherTypeCode=" + encodeURIComponent("" + voucherTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardDropdownByProjectInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardDropdownByProjectInfo(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardDropdownByProjectInfo(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getRewardsDropdownByProject(projectID: number): Observable<GetRewardDropdownListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetRewardsDropdownByProject?";
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "projectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRewardsDropdownByProject(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRewardsDropdownByProject(response_);
                } catch (e) {
                    return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRewardDropdownListDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetRewardsDropdownByProject(response: Response): Observable<GetRewardDropdownListDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetRewardDropdownListDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRewardDropdownListDto[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    tasklistVoucher(input: VoucherInputPagingDto): Observable<PagedResultDtoOfGetDataVoucherListDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/TasklistVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTasklistVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTasklistVoucher(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDataVoucherListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDataVoucherListDto>><any>Observable.throw(response_);
        });
    }

    protected processTasklistVoucher(response: Response): Observable<PagedResultDtoOfGetDataVoucherListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetDataVoucherListDto.fromJS(resultData200) : new PagedResultDtoOfGetDataVoucherListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetDataVoucherListDto>(<any>null);
    }

    /**
     * @receiptCode (optional) 
     * @voucherTypeCode (optional) 
     * @return Success
     */
    getVoucherResult(receiptCode: string, receiptDate: moment.Moment, receiptAmt: number, idLocation: number, projectID: number, voucherTypeCode: string): Observable<GetOrCreateVoucherResult> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetVoucherResult?";
        if (receiptCode !== undefined)
            url_ += "ReceiptCode=" + encodeURIComponent("" + receiptCode) + "&"; 
        if (receiptDate === undefined || receiptDate === null)
            throw new Error("The parameter 'receiptDate' must be defined and cannot be null.");
        else
            url_ += "ReceiptDate=" + encodeURIComponent(receiptDate ? "" + receiptDate.toJSON() : "") + "&"; 
        if (receiptAmt === undefined || receiptAmt === null)
            throw new Error("The parameter 'receiptAmt' must be defined and cannot be null.");
        else
            url_ += "ReceiptAmt=" + encodeURIComponent("" + receiptAmt) + "&"; 
        if (idLocation === undefined || idLocation === null)
            throw new Error("The parameter 'idLocation' must be defined and cannot be null.");
        else
            url_ += "IdLocation=" + encodeURIComponent("" + idLocation) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (voucherTypeCode !== undefined)
            url_ += "VoucherTypeCode=" + encodeURIComponent("" + voucherTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVoucherResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVoucherResult(response_);
                } catch (e) {
                    return <Observable<GetOrCreateVoucherResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrCreateVoucherResult>><any>Observable.throw(response_);
        });
    }

    protected processGetVoucherResult(response: Response): Observable<GetOrCreateVoucherResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetOrCreateVoucherResult.fromJS(resultData200) : new GetOrCreateVoucherResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOrCreateVoucherResult>(<any>null);
    }

    /**
     * @return Success
     */
    getLocationDropDown(): Observable<DropDownDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetLocationDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLocationDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLocationDropDown(response_);
                } catch (e) {
                    return <Observable<DropDownDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropDownDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLocationDropDown(response: Response): Observable<DropDownDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DropDownDto.fromJS(resultData200) : new DropDownDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropDownDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProjectDropDown(idLocation: number): Observable<DropDownDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetProjectDropDown?";
        if (idLocation === undefined || idLocation === null)
            throw new Error("The parameter 'idLocation' must be defined and cannot be null.");
        else
            url_ += "IdLocation=" + encodeURIComponent("" + idLocation) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProjectDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProjectDropDown(response_);
                } catch (e) {
                    return <Observable<DropDownDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropDownDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProjectDropDown(response: Response): Observable<DropDownDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DropDownDto.fromJS(resultData200) : new DropDownDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropDownDto>(<any>null);
    }

    /**
     * @return Success
     */
    dropDownVoucherType(): Observable<GetDropdownVoucherType[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/DropDownVoucherType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDropDownVoucherType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDropDownVoucherType(response_);
                } catch (e) {
                    return <Observable<GetDropdownVoucherType[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDropdownVoucherType[]>><any>Observable.throw(response_);
        });
    }

    protected processDropDownVoucherType(response: Response): Observable<GetDropdownVoucherType[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetDropdownVoucherType.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDropdownVoucherType[]>(<any>null);
    }

    /**
     * @return Success
     */
    getVoucherTypeDropDown(idLocation: number, projectID: number): Observable<DropDownDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetVoucherTypeDropDown?";
        if (idLocation === undefined || idLocation === null)
            throw new Error("The parameter 'idLocation' must be defined and cannot be null.");
        else
            url_ += "IdLocation=" + encodeURIComponent("" + idLocation) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetVoucherTypeDropDown(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetVoucherTypeDropDown(response_);
                } catch (e) {
                    return <Observable<DropDownDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<DropDownDto>><any>Observable.throw(response_);
        });
    }

    protected processGetVoucherTypeDropDown(response: Response): Observable<DropDownDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DropDownDto.fromJS(resultData200) : new DropDownDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DropDownDto>(<any>null);
    }

    /**
     * @receiptCode (optional) 
     * @voucherTypeCode (optional) 
     * @return Success
     */
    getOrCreateVoucher(receiptCode: string, receiptDate: moment.Moment, receiptAmt: number, idLocation: number, projectID: number, voucherTypeCode: string): Observable<GetOrCreateVoucherResult> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetOrCreateVoucher?";
        if (receiptCode !== undefined)
            url_ += "ReceiptCode=" + encodeURIComponent("" + receiptCode) + "&"; 
        if (receiptDate === undefined || receiptDate === null)
            throw new Error("The parameter 'receiptDate' must be defined and cannot be null.");
        else
            url_ += "ReceiptDate=" + encodeURIComponent(receiptDate ? "" + receiptDate.toJSON() : "") + "&"; 
        if (receiptAmt === undefined || receiptAmt === null)
            throw new Error("The parameter 'receiptAmt' must be defined and cannot be null.");
        else
            url_ += "ReceiptAmt=" + encodeURIComponent("" + receiptAmt) + "&"; 
        if (idLocation === undefined || idLocation === null)
            throw new Error("The parameter 'idLocation' must be defined and cannot be null.");
        else
            url_ += "IdLocation=" + encodeURIComponent("" + idLocation) + "&"; 
        if (projectID === undefined || projectID === null)
            throw new Error("The parameter 'projectID' must be defined and cannot be null.");
        else
            url_ += "ProjectID=" + encodeURIComponent("" + projectID) + "&"; 
        if (voucherTypeCode !== undefined)
            url_ += "VoucherTypeCode=" + encodeURIComponent("" + voucherTypeCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrCreateVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrCreateVoucher(response_);
                } catch (e) {
                    return <Observable<GetOrCreateVoucherResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrCreateVoucherResult>><any>Observable.throw(response_);
        });
    }

    protected processGetOrCreateVoucher(response: Response): Observable<GetOrCreateVoucherResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetOrCreateVoucherResult.fromJS(resultData200) : new GetOrCreateVoucherResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOrCreateVoucherResult>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVoucherV2(input: GetOrCreateVoucherV2Input): Observable<GetOrCreateVoucherResult[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/CreateVoucherV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateVoucherV2(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateVoucherV2(response_);
                } catch (e) {
                    return <Observable<GetOrCreateVoucherResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrCreateVoucherResult[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateVoucherV2(response: Response): Observable<GetOrCreateVoucherResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetOrCreateVoucherResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOrCreateVoucherResult[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createVoucherV2WithoutPDF(input: GetOrCreateVoucherV2Input): Observable<GetOrCreateVoucherResult[]> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/CreateVoucherV2WithoutPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateVoucherV2WithoutPDF(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateVoucherV2WithoutPDF(response_);
                } catch (e) {
                    return <Observable<GetOrCreateVoucherResult[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetOrCreateVoucherResult[]>><any>Observable.throw(response_);
        });
    }

    protected processCreateVoucherV2WithoutPDF(response: Response): Observable<GetOrCreateVoucherResult[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetOrCreateVoucherResult.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetOrCreateVoucherResult[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printVoucher(input: GenerateVoucherInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/PrintVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintVoucher(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintVoucher(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    printNewVoucher(input: GenerateVoucherInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/PrintNewVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrintNewVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrintNewVoucher(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processPrintNewVoucher(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generateExcelReportVoucher(input: ReportVoucherInputDto): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GenerateExcelReportVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportVoucher(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportVoucher(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    generateExcelReportHistoryUndian(rewardID: number, campaignId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GenerateExcelReportHistoryUndian?";
        if (rewardID === undefined || rewardID === null)
            throw new Error("The parameter 'rewardID' must be defined and cannot be null.");
        else
            url_ += "RewardID=" + encodeURIComponent("" + rewardID) + "&"; 
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateExcelReportHistoryUndian(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateExcelReportHistoryUndian(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGenerateExcelReportHistoryUndian(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    generatePDFReportVoucher(input: ReportVoucherInputDto): Observable<ResultMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GeneratePDFReportVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGeneratePDFReportVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGeneratePDFReportVoucher(response_);
                } catch (e) {
                    return <Observable<ResultMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGeneratePDFReportVoucher(response: Response): Observable<ResultMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultMessageDto.fromJS(resultData200) : new ResultMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    countDataReportVoucher(input: ReportVoucherInputDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/CountDataReportVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCountDataReportVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCountDataReportVoucher(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCountDataReportVoucher(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getDataReportVoucher(input: ReportVoucherInputDto): Observable<ReportVoucherResultPublishDto> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GetDataReportVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataReportVoucher(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataReportVoucher(response_);
                } catch (e) {
                    return <Observable<ReportVoucherResultPublishDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReportVoucherResultPublishDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataReportVoucher(response: Response): Observable<ReportVoucherResultPublishDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReportVoucherResultPublishDto.fromJS(resultData200) : new ReportVoucherResultPublishDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReportVoucherResultPublishDto>(<any>null);
    }

    /**
     * @return Success
     */
    generateVoucherByCampaignHeader(unitReservedID: number, campaignHeaderID: number): Observable<GetVoucherByCampaignHeaderResult> {
        let url_ = this.baseUrl + "/api/services/app/Voucher/GenerateVoucherByCampaignHeader?";
        if (unitReservedID === undefined || unitReservedID === null)
            throw new Error("The parameter 'unitReservedID' must be defined and cannot be null.");
        else
            url_ += "unitReservedID=" + encodeURIComponent("" + unitReservedID) + "&"; 
        if (campaignHeaderID === undefined || campaignHeaderID === null)
            throw new Error("The parameter 'campaignHeaderID' must be defined and cannot be null.");
        else
            url_ += "campaignHeaderID=" + encodeURIComponent("" + campaignHeaderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGenerateVoucherByCampaignHeader(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGenerateVoucherByCampaignHeader(response_);
                } catch (e) {
                    return <Observable<GetVoucherByCampaignHeaderResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetVoucherByCampaignHeaderResult>><any>Observable.throw(response_);
        });
    }

    protected processGenerateVoucherByCampaignHeader(response: Response): Observable<GetVoucherByCampaignHeaderResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetVoucherByCampaignHeaderResult.fromJS(resultData200) : new GetVoucherByCampaignHeaderResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetVoucherByCampaignHeaderResult>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestWebLogs(response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestWebLogs(response: Response): Observable<GetLatestWebLogsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadWebLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadWebLogs(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class WorkflowServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @userId (optional) 
     * @workflowId (optional) 
     * @stateId (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @requestIds (optional) 
     * @return Success
     */
    getRequests(userId: number, workflowId: number, stateId: number, skipCount: number, maxResultCount: number, requestIds: number[]): Observable<PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetRequests?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (workflowId !== undefined)
            url_ += "WorkflowId=" + encodeURIComponent("" + workflowId) + "&"; 
        if (stateId !== undefined)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRequests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRequests(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRequests(response: Response): Observable<PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto.fromJS(resultData200) : new PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    recreateRequestActions(input: RecreateRequestActionsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/RecreateRequestActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRecreateRequestActions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRecreateRequestActions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRecreateRequestActions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @name (optional) 
     * @version (optional) 
     * @isActive (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getWorkflows(name: string, version: number, isActive: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfWorkflowListDto> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetWorkflows?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkflows(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorkflows(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWorkflowListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfWorkflowListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkflows(response: Response): Observable<PagedResultDtoOfWorkflowListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfWorkflowListDto.fromJS(resultData200) : new PagedResultDtoOfWorkflowListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfWorkflowListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getWorkflowForEdit(id: number): Observable<GetWorkflowForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetWorkflowForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorkflowForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorkflowForEdit(response_);
                } catch (e) {
                    return <Observable<GetWorkflowForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorkflowForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorkflowForEdit(response: Response): Observable<GetWorkflowForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorkflowForEditOutput.fromJS(resultData200) : new GetWorkflowForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetWorkflowForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateWorkflow(input: GetWorkflowForEditOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/CreateOrUpdateWorkflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateWorkflow(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateWorkflow(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateWorkflow(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @userGroupName (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getUserGroups(userGroupName: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserGroupListDto> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetUserGroups?";
        if (userGroupName !== undefined)
            url_ += "UserGroupName=" + encodeURIComponent("" + userGroupName) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === undefined || maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' must be defined and cannot be null.");
        else
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === undefined || skipCount === null)
            throw new Error("The parameter 'skipCount' must be defined and cannot be null.");
        else
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserGroups(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserGroups(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserGroupListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserGroupListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserGroups(response: Response): Observable<PagedResultDtoOfUserGroupListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserGroupListDto.fromJS(resultData200) : new PagedResultDtoOfUserGroupListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfUserGroupListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserGroupForEdit(id: number): Observable<GetUserGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/GetUserGroupForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserGroupForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserGroupForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserGroupForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserGroupForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserGroupForEdit(response: Response): Observable<GetUserGroupForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserGroupForEditOutput.fromJS(resultData200) : new GetUserGroupForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserGroupForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUserGroup(input: GetUserGroupForEditOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Workflow/CreateOrUpdateUserGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUserGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUserGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUserGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;
    userName: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
    userName: string;
}

export class SendForgotPasswordResetCodeInput implements ISendForgotPasswordResetCodeInput {
    userName: string;

    constructor(data?: ISendForgotPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): SendForgotPasswordResetCodeInput {
        let result = new SendForgotPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ISendForgotPasswordResetCodeInput {
    userName: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    encryptedParam: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.encryptedParam = data["encryptedParam"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encryptedParam"] = this.encryptedParam;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IResetPasswordInput {
    encryptedParam: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean;
    userName: string;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number;
    userId: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;
}

export class RegisterUserPPInput implements IRegisterUserPPInput {
    userName: string;
    password: string;
    name: string;
    email: string;

    constructor(data?: IRegisterUserPPInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.name = data["name"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): RegisterUserPPInput {
        let result = new RegisterUserPPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["name"] = this.name;
        data["email"] = this.email;
        return data; 
    }
}

export interface IRegisterUserPPInput {
    userName: string;
    password: string;
    name: string;
    email: string;
}

export class RegisterMemberInput implements IRegisterMemberInput {
    membercode: string;
    password: string;

    constructor(data?: IRegisterMemberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.membercode = data["membercode"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): RegisterMemberInput {
        let result = new RegisterMemberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membercode"] = this.membercode;
        data["password"] = this.password;
        return data; 
    }
}

export interface IRegisterMemberInput {
    membercode: string;
    password: string;
}

export class RegisterCustomerInput implements IRegisterCustomerInput {
    email: string;
    name: string;
    password: string;

    constructor(data?: IRegisterCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.name = data["name"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): RegisterCustomerInput {
        let result = new RegisterCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["password"] = this.password;
        return data; 
    }
}

export interface IRegisterCustomerInput {
    email: string;
    name: string;
    password: string;
}

export class UserListDto implements IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string;
}

export class LoginADInputDto implements ILoginADInputDto {
    userName: string;
    password: string;

    constructor(data?: ILoginADInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LoginADInputDto {
        let result = new LoginADInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginADInputDto {
    userName: string;
    password: string;
}

export class GetListUserManualResultDto implements IGetListUserManualResultDto {
    userManualID: number;
    appName: string;
    manualName: string;
    manualLink: string;
    isActive: boolean;

    constructor(data?: IGetListUserManualResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userManualID = data["userManualID"];
            this.appName = data["appName"];
            this.manualName = data["manualName"];
            this.manualLink = data["manualLink"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetListUserManualResultDto {
        let result = new GetListUserManualResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userManualID"] = this.userManualID;
        data["appName"] = this.appName;
        data["manualName"] = this.manualName;
        data["manualLink"] = this.manualLink;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetListUserManualResultDto {
    userManualID: number;
    appName: string;
    manualName: string;
    manualLink: string;
    isActive: boolean;
}

export class CreateADAuthDto implements ICreateADAuthDto {
    id: number;
    domain: string;
    ip: string;
    username: string;
    password: string;

    constructor(data?: ICreateADAuthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.domain = data["domain"];
            this.ip = data["ip"];
            this.username = data["username"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): CreateADAuthDto {
        let result = new CreateADAuthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain;
        data["ip"] = this.ip;
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }
}

export interface ICreateADAuthDto {
    id: number;
    domain: string;
    ip: string;
    username: string;
    password: string;
}

export class GetADAuthListDto implements IGetADAuthListDto {
    id: number;
    domain: string;
    ip: string;
    password: string;
    username: string;

    constructor(data?: IGetADAuthListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.domain = data["domain"];
            this.ip = data["ip"];
            this.password = data["password"];
            this.username = data["username"];
        }
    }

    static fromJS(data: any): GetADAuthListDto {
        let result = new GetADAuthListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain;
        data["ip"] = this.ip;
        data["password"] = this.password;
        data["username"] = this.username;
        return data; 
    }
}

export interface IGetADAuthListDto {
    id: number;
    domain: string;
    ip: string;
    password: string;
    username: string;
}

export class ListResultDtoOfGetListAllProjectResultDto implements IListResultDtoOfGetListAllProjectResultDto {
    items: GetListAllProjectResultDto[];

    constructor(data?: IListResultDtoOfGetListAllProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListAllProjectResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListAllProjectResultDto {
        let result = new ListResultDtoOfGetListAllProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListAllProjectResultDto {
    items: GetListAllProjectResultDto[];
}

export class GetListAllProjectResultDto implements IGetListAllProjectResultDto {
    projectId: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IGetListAllProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetListAllProjectResultDto {
        let result = new GetListAllProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetListAllProjectResultDto {
    projectId: number;
    projectCode: string;
    projectName: string;
}

export class ResultMessageDto implements IResultMessageDto {
    message: string;
    path: string;
    fileName: string;
    result: boolean;
    bookingDataUnitPP: BookingDataUnitPP[];

    constructor(data?: IResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.path = data["path"];
            this.fileName = data["fileName"];
            this.result = data["result"];
            if (data["bookingDataUnitPP"] && data["bookingDataUnitPP"].constructor === Array) {
                this.bookingDataUnitPP = [];
                for (let item of data["bookingDataUnitPP"])
                    this.bookingDataUnitPP.push(BookingDataUnitPP.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultMessageDto {
        let result = new ResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["path"] = this.path;
        data["fileName"] = this.fileName;
        data["result"] = this.result;
        if (this.bookingDataUnitPP && this.bookingDataUnitPP.constructor === Array) {
            data["bookingDataUnitPP"] = [];
            for (let item of this.bookingDataUnitPP)
                data["bookingDataUnitPP"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IResultMessageDto {
    message: string;
    path: string;
    fileName: string;
    result: boolean;
    bookingDataUnitPP: BookingDataUnitPP[];
}

export class BookingDataUnitPP implements IBookingDataUnitPP {
    bookCode: string;
    unitNo: string;
    unitCode: string;
    unitID: number;

    constructor(data?: IBookingDataUnitPP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.unitID = data["unitID"];
        }
    }

    static fromJS(data: any): BookingDataUnitPP {
        let result = new BookingDataUnitPP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["unitID"] = this.unitID;
        return data; 
    }
}

export interface IBookingDataUnitPP {
    bookCode: string;
    unitNo: string;
    unitCode: string;
    unitID: number;
}

export class CreateOrUpdateManageProjInfoDto implements ICreateOrUpdateManageProjInfoDto {
    projectID: number;
    projectDesc: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;

    constructor(data?: ICreateOrUpdateManageProjInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectDesc = data["projectDesc"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
        }
    }

    static fromJS(data: any): CreateOrUpdateManageProjInfoDto {
        let result = new CreateOrUpdateManageProjInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectDesc"] = this.projectDesc;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        return data; 
    }
}

export interface ICreateOrUpdateManageProjInfoDto {
    projectID: number;
    projectDesc: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
}

export class GetProjectInformationResultDto implements IGetProjectInformationResultDto {
    projectInfoID: number;
    projectId: number;
    projectDesc: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;

    constructor(data?: IGetProjectInformationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.projectId = data["projectId"];
            this.projectDesc = data["projectDesc"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
        }
    }

    static fromJS(data: any): GetProjectInformationResultDto {
        let result = new GetProjectInformationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["projectId"] = this.projectId;
        data["projectDesc"] = this.projectDesc;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        return data; 
    }
}

export interface IGetProjectInformationResultDto {
    projectInfoID: number;
    projectId: number;
    projectDesc: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
}

export class ListResultDtoOfGetDetailTowerResultDto implements IListResultDtoOfGetDetailTowerResultDto {
    items: GetDetailTowerResultDto[];

    constructor(data?: IListResultDtoOfGetDetailTowerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDetailTowerResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDetailTowerResultDto {
        let result = new ListResultDtoOfGetDetailTowerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDetailTowerResultDto {
    items: GetDetailTowerResultDto[];
}

export class GetDetailTowerResultDto implements IGetDetailTowerResultDto {
    unitType: string;
    unitTypeDesc: string;
    unitTypeImage: string;
    projectInfoID: number;
    detailID: number;

    constructor(data?: IGetDetailTowerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitType = data["unitType"];
            this.unitTypeDesc = data["unitTypeDesc"];
            this.unitTypeImage = data["unitTypeImage"];
            this.projectInfoID = data["projectInfoID"];
            this.detailID = data["detailID"];
        }
    }

    static fromJS(data: any): GetDetailTowerResultDto {
        let result = new GetDetailTowerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["unitTypeDesc"] = this.unitTypeDesc;
        data["unitTypeImage"] = this.unitTypeImage;
        data["projectInfoID"] = this.projectInfoID;
        data["detailID"] = this.detailID;
        return data; 
    }
}

export interface IGetDetailTowerResultDto {
    unitType: string;
    unitTypeDesc: string;
    unitTypeImage: string;
    projectInfoID: number;
    detailID: number;
}

export class GetTowerDetailEditResultDto implements IGetTowerDetailEditResultDto {
    towerId: number;
    clusterCode: string;
    clusterName: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    isRequiredRP: boolean;
    isActive: boolean;

    constructor(data?: IGetTowerDetailEditResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.towerId = data["towerId"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.activeFrom = data["activeFrom"] ? moment(data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = data["activeTo"] ? moment(data["activeTo"].toString()) : <any>undefined;
            this.isRequiredRP = data["isRequiredRP"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetTowerDetailEditResultDto {
        let result = new GetTowerDetailEditResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["towerId"] = this.towerId;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["isRequiredRP"] = this.isRequiredRP;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetTowerDetailEditResultDto {
    towerId: number;
    clusterCode: string;
    clusterName: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    isRequiredRP: boolean;
    isActive: boolean;
}

export class UpdateTowerDetailInputDto implements IUpdateTowerDetailInputDto {
    towerId: number;
    isActive: boolean;
    activeFrom: string;
    activeTo: string;
    isRequiredPP: boolean;

    constructor(data?: IUpdateTowerDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.towerId = data["towerId"];
            this.isActive = data["isActive"];
            this.activeFrom = data["activeFrom"];
            this.activeTo = data["activeTo"];
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): UpdateTowerDetailInputDto {
        let result = new UpdateTowerDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["towerId"] = this.towerId;
        data["isActive"] = this.isActive;
        data["activeFrom"] = this.activeFrom;
        data["activeTo"] = this.activeTo;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IUpdateTowerDetailInputDto {
    towerId: number;
    isActive: boolean;
    activeFrom: string;
    activeTo: string;
    isRequiredPP: boolean;
}

export class CreateKeyFeatureInputDto implements ICreateKeyFeatureInputDto {
    projectId: number;
    keyFeatures: string;
    status: number;

    constructor(data?: ICreateKeyFeatureInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.keyFeatures = data["keyFeatures"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CreateKeyFeatureInputDto {
        let result = new CreateKeyFeatureInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["keyFeatures"] = this.keyFeatures;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreateKeyFeatureInputDto {
    projectId: number;
    keyFeatures: string;
    status: number;
}

export class ListResultDtoOfGetKeyFeaturesResultDto implements IListResultDtoOfGetKeyFeaturesResultDto {
    items: GetKeyFeaturesResultDto[];

    constructor(data?: IListResultDtoOfGetKeyFeaturesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetKeyFeaturesResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetKeyFeaturesResultDto {
        let result = new ListResultDtoOfGetKeyFeaturesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetKeyFeaturesResultDto {
    items: GetKeyFeaturesResultDto[];
}

export class GetKeyFeaturesResultDto implements IGetKeyFeaturesResultDto {
    projectInfoID: number;
    id: number;
    keyFeaturesCollectionID: number;
    keyFeatures: string;
    status: number;

    constructor(data?: IGetKeyFeaturesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.id = data["id"];
            this.keyFeaturesCollectionID = data["keyFeaturesCollectionID"];
            this.keyFeatures = data["keyFeatures"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetKeyFeaturesResultDto {
        let result = new GetKeyFeaturesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["id"] = this.id;
        data["keyFeaturesCollectionID"] = this.keyFeaturesCollectionID;
        data["keyFeatures"] = this.keyFeatures;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetKeyFeaturesResultDto {
    projectInfoID: number;
    id: number;
    keyFeaturesCollectionID: number;
    keyFeatures: string;
    status: number;
}

export class EditKeyFeatureResultDto implements IEditKeyFeatureResultDto {
    id: number;
    keyFeatures: string;
    keyFeaturesCollectionID: number;
    status: number;

    constructor(data?: IEditKeyFeatureResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.keyFeatures = data["keyFeatures"];
            this.keyFeaturesCollectionID = data["keyFeaturesCollectionID"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): EditKeyFeatureResultDto {
        let result = new EditKeyFeatureResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyFeatures"] = this.keyFeatures;
        data["keyFeaturesCollectionID"] = this.keyFeaturesCollectionID;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEditKeyFeatureResultDto {
    id: number;
    keyFeatures: string;
    keyFeaturesCollectionID: number;
    status: number;
}

export class UpdateKeyFeaturesInputDto implements IUpdateKeyFeaturesInputDto {
    id: number;
    keyFeatures: string;
    status: number;

    constructor(data?: IUpdateKeyFeaturesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.keyFeatures = data["keyFeatures"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateKeyFeaturesInputDto {
        let result = new UpdateKeyFeaturesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyFeatures"] = this.keyFeatures;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateKeyFeaturesInputDto {
    id: number;
    keyFeatures: string;
    status: number;
}

export class CreateOrUpdateSocialMediaProjectInputDto implements ICreateOrUpdateSocialMediaProjectInputDto {
    projectInfoID: number;
    sosialMediaID: number;
    socialMediaLink: string;
    socialMediaLinkID: number;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateSocialMediaProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.sosialMediaID = data["sosialMediaID"];
            this.socialMediaLink = data["socialMediaLink"];
            this.socialMediaLinkID = data["socialMediaLinkID"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSocialMediaProjectInputDto {
        let result = new CreateOrUpdateSocialMediaProjectInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["sosialMediaID"] = this.sosialMediaID;
        data["socialMediaLink"] = this.socialMediaLink;
        data["socialMediaLinkID"] = this.socialMediaLinkID;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateSocialMediaProjectInputDto {
    projectInfoID: number;
    sosialMediaID: number;
    socialMediaLink: string;
    socialMediaLinkID: number;
    isActive: boolean;
}

export class ListResultDtoOfGetListSocialMediaProjectResultDto implements IListResultDtoOfGetListSocialMediaProjectResultDto {
    items: GetListSocialMediaProjectResultDto[];

    constructor(data?: IListResultDtoOfGetListSocialMediaProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListSocialMediaProjectResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListSocialMediaProjectResultDto {
        let result = new ListResultDtoOfGetListSocialMediaProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListSocialMediaProjectResultDto {
    items: GetListSocialMediaProjectResultDto[];
}

export class GetListSocialMediaProjectResultDto implements IGetListSocialMediaProjectResultDto {
    projectInfoID: number;
    socialMediaId: number;
    socialMediaName: string;
    socialMediaLinkID: number;
    socialMediaLink: string;
    isActive: boolean;
    socialMediaIcon: string;

    constructor(data?: IGetListSocialMediaProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.socialMediaId = data["socialMediaId"];
            this.socialMediaName = data["socialMediaName"];
            this.socialMediaLinkID = data["socialMediaLinkID"];
            this.socialMediaLink = data["socialMediaLink"];
            this.isActive = data["isActive"];
            this.socialMediaIcon = data["socialMediaIcon"];
        }
    }

    static fromJS(data: any): GetListSocialMediaProjectResultDto {
        let result = new GetListSocialMediaProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["socialMediaId"] = this.socialMediaId;
        data["socialMediaName"] = this.socialMediaName;
        data["socialMediaLinkID"] = this.socialMediaLinkID;
        data["socialMediaLink"] = this.socialMediaLink;
        data["isActive"] = this.isActive;
        data["socialMediaIcon"] = this.socialMediaIcon;
        return data; 
    }
}

export interface IGetListSocialMediaProjectResultDto {
    projectInfoID: number;
    socialMediaId: number;
    socialMediaName: string;
    socialMediaLinkID: number;
    socialMediaLink: string;
    isActive: boolean;
    socialMediaIcon: string;
}

export class CreateProjectLocationInputDto implements ICreateProjectLocationInputDto {
    projectID: number;
    projectInfoID: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;

    constructor(data?: ICreateProjectLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.projectAddress = data["projectAddress"];
            this.locationImageURL = data["locationImageURL"];
        }
    }

    static fromJS(data: any): CreateProjectLocationInputDto {
        let result = new CreateProjectLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["projectAddress"] = this.projectAddress;
        data["locationImageURL"] = this.locationImageURL;
        return data; 
    }
}

export interface ICreateProjectLocationInputDto {
    projectID: number;
    projectInfoID: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
}

export class GetDetailProjectLocationResultDto implements IGetDetailProjectLocationResultDto {
    id: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    projectDesc: string;

    constructor(data?: IGetDetailProjectLocationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.projectAddress = data["projectAddress"];
            this.locationImageURL = data["locationImageURL"];
            this.projectDesc = data["projectDesc"];
        }
    }

    static fromJS(data: any): GetDetailProjectLocationResultDto {
        let result = new GetDetailProjectLocationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["projectAddress"] = this.projectAddress;
        data["locationImageURL"] = this.locationImageURL;
        data["projectDesc"] = this.projectDesc;
        return data; 
    }
}

export interface IGetDetailProjectLocationResultDto {
    id: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    projectDesc: string;
}

export class UpdateDetailProjectLocationInputDto implements IUpdateDetailProjectLocationInputDto {
    projectId: number;
    id: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    projectDesc: string;
    imageStatus: string;

    constructor(data?: IUpdateDetailProjectLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.id = data["id"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.projectAddress = data["projectAddress"];
            this.locationImageURL = data["locationImageURL"];
            this.projectDesc = data["projectDesc"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): UpdateDetailProjectLocationInputDto {
        let result = new UpdateDetailProjectLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["id"] = this.id;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["projectAddress"] = this.projectAddress;
        data["locationImageURL"] = this.locationImageURL;
        data["projectDesc"] = this.projectDesc;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface IUpdateDetailProjectLocationInputDto {
    projectId: number;
    id: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    projectDesc: string;
    imageStatus: string;
}

export class GetDetailSitePlanResultDto implements IGetDetailSitePlanResultDto {
    projectId: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;

    constructor(data?: IGetDetailSitePlanResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.sitePlansLegend = data["sitePlansLegend"];
        }
    }

    static fromJS(data: any): GetDetailSitePlanResultDto {
        let result = new GetDetailSitePlanResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["sitePlansLegend"] = this.sitePlansLegend;
        return data; 
    }
}

export interface IGetDetailSitePlanResultDto {
    projectId: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
}

export class CreateOrUpdateDetailSitePlanInputDto implements ICreateOrUpdateDetailSitePlanInputDto {
    projectId: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    imageStatus: string;

    constructor(data?: ICreateOrUpdateDetailSitePlanInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.sitePlansLegend = data["sitePlansLegend"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): CreateOrUpdateDetailSitePlanInputDto {
        let result = new CreateOrUpdateDetailSitePlanInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["sitePlansLegend"] = this.sitePlansLegend;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface ICreateOrUpdateDetailSitePlanInputDto {
    projectId: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    imageStatus: string;
}

export class ListResultDtoOfGetListProjectGalleryResultDto implements IListResultDtoOfGetListProjectGalleryResultDto {
    items: GetListProjectGalleryResultDto[];

    constructor(data?: IListResultDtoOfGetListProjectGalleryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListProjectGalleryResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListProjectGalleryResultDto {
        let result = new ListResultDtoOfGetListProjectGalleryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListProjectGalleryResultDto {
    items: GetListProjectGalleryResultDto[];
}

export class GetListProjectGalleryResultDto implements IGetListProjectGalleryResultDto {
    projectInfoID: number;
    galleryId: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    fileTypeId: number;
    sortNo: number;

    constructor(data?: IGetListProjectGalleryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.galleryId = data["galleryId"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
            this.fileTypeId = data["fileTypeId"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): GetListProjectGalleryResultDto {
        let result = new GetListProjectGalleryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["galleryId"] = this.galleryId;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        data["fileTypeId"] = this.fileTypeId;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IGetListProjectGalleryResultDto {
    projectInfoID: number;
    galleryId: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    fileTypeId: number;
    sortNo: number;
}

export class GetDetailProjectImageResultDto implements IGetDetailProjectImageResultDto {
    id: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    projectInfoID: number;
    fileTypeId: number;

    constructor(data?: IGetDetailProjectImageResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
            this.projectInfoID = data["projectInfoID"];
            this.fileTypeId = data["fileTypeId"];
        }
    }

    static fromJS(data: any): GetDetailProjectImageResultDto {
        let result = new GetDetailProjectImageResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        data["projectInfoID"] = this.projectInfoID;
        data["fileTypeId"] = this.fileTypeId;
        return data; 
    }
}

export interface IGetDetailProjectImageResultDto {
    id: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    projectInfoID: number;
    fileTypeId: number;
}

export class UpdateProjectImageInputDto implements IUpdateProjectImageInputDto {
    id: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;

    constructor(data?: IUpdateProjectImageInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): UpdateProjectImageInputDto {
        let result = new UpdateProjectImageInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface IUpdateProjectImageInputDto {
    id: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
}

export class AddSocialMediaInputDto implements IAddSocialMediaInputDto {
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;

    constructor(data?: IAddSocialMediaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.socialMediaName = data["socialMediaName"];
            this.socialMediaIcon = data["socialMediaIcon"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AddSocialMediaInputDto {
        let result = new AddSocialMediaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialMediaName"] = this.socialMediaName;
        data["socialMediaIcon"] = this.socialMediaIcon;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAddSocialMediaInputDto {
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;
}

export class UpdateSocialMediaInputDto implements IUpdateSocialMediaInputDto {
    id: number;
    socialMediaName: string;
    socialMediaIcon: string;
    iconStatus: string;
    isActive: boolean;

    constructor(data?: IUpdateSocialMediaInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.socialMediaName = data["socialMediaName"];
            this.socialMediaIcon = data["socialMediaIcon"];
            this.iconStatus = data["iconStatus"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateSocialMediaInputDto {
        let result = new UpdateSocialMediaInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialMediaName"] = this.socialMediaName;
        data["socialMediaIcon"] = this.socialMediaIcon;
        data["iconStatus"] = this.iconStatus;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateSocialMediaInputDto {
    id: number;
    socialMediaName: string;
    socialMediaIcon: string;
    iconStatus: string;
    isActive: boolean;
}

export class ListResultDtoOfGetListSocialMediaResultDto implements IListResultDtoOfGetListSocialMediaResultDto {
    items: GetListSocialMediaResultDto[];

    constructor(data?: IListResultDtoOfGetListSocialMediaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListSocialMediaResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListSocialMediaResultDto {
        let result = new ListResultDtoOfGetListSocialMediaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListSocialMediaResultDto {
    items: GetListSocialMediaResultDto[];
}

export class GetListSocialMediaResultDto implements IGetListSocialMediaResultDto {
    socialMediaID: number;
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;

    constructor(data?: IGetListSocialMediaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.socialMediaID = data["socialMediaID"];
            this.socialMediaName = data["socialMediaName"];
            this.socialMediaIcon = data["socialMediaIcon"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetListSocialMediaResultDto {
        let result = new GetListSocialMediaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialMediaID"] = this.socialMediaID;
        data["socialMediaName"] = this.socialMediaName;
        data["socialMediaIcon"] = this.socialMediaIcon;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetListSocialMediaResultDto {
    socialMediaID: number;
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;
}

export class EditSocialMediaResultDto implements IEditSocialMediaResultDto {
    id: number;
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;

    constructor(data?: IEditSocialMediaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.socialMediaName = data["socialMediaName"];
            this.socialMediaIcon = data["socialMediaIcon"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): EditSocialMediaResultDto {
        let result = new EditSocialMediaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialMediaName"] = this.socialMediaName;
        data["socialMediaIcon"] = this.socialMediaIcon;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IEditSocialMediaResultDto {
    id: number;
    socialMediaName: string;
    socialMediaIcon: string;
    isActive: boolean;
}

export class ListResultDtoOfGetListMainPageImagesResultDto implements IListResultDtoOfGetListMainPageImagesResultDto {
    items: GetListMainPageImagesResultDto[];

    constructor(data?: IListResultDtoOfGetListMainPageImagesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListMainPageImagesResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListMainPageImagesResultDto {
        let result = new ListResultDtoOfGetListMainPageImagesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListMainPageImagesResultDto {
    items: GetListMainPageImagesResultDto[];
}

export class GetListMainPageImagesResultDto implements IGetListMainPageImagesResultDto {
    id: number;
    projectId: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    fileTypeId: number;

    constructor(data?: IGetListMainPageImagesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectId = data["projectId"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
            this.fileTypeId = data["fileTypeId"];
        }
    }

    static fromJS(data: any): GetListMainPageImagesResultDto {
        let result = new GetListMainPageImagesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        data["fileTypeId"] = this.fileTypeId;
        return data; 
    }
}

export interface IGetListMainPageImagesResultDto {
    id: number;
    projectId: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    fileTypeId: number;
}

export class CreateMainPageDto implements ICreateMainPageDto {
    projectId: number;
    imageURL: string;
    imageAlt: string;
    fileTypeId: number;

    constructor(data?: ICreateMainPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.fileTypeId = data["fileTypeId"];
        }
    }

    static fromJS(data: any): CreateMainPageDto {
        let result = new CreateMainPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["fileTypeId"] = this.fileTypeId;
        return data; 
    }
}

export interface ICreateMainPageDto {
    projectId: number;
    imageURL: string;
    imageAlt: string;
    fileTypeId: number;
}

export class UpdateMainPageDto implements IUpdateMainPageDto {
    mainPageId: number;
    imageURL: string;
    altName: string;
    fileTypeId: number;
    imageStatus: string;

    constructor(data?: IUpdateMainPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainPageId = data["mainPageId"];
            this.imageURL = data["imageURL"];
            this.altName = data["altName"];
            this.fileTypeId = data["fileTypeId"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): UpdateMainPageDto {
        let result = new UpdateMainPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainPageId"] = this.mainPageId;
        data["imageURL"] = this.imageURL;
        data["altName"] = this.altName;
        data["fileTypeId"] = this.fileTypeId;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface IUpdateMainPageDto {
    mainPageId: number;
    imageURL: string;
    altName: string;
    fileTypeId: number;
    imageStatus: string;
}

export class CreateManageProjectDto implements ICreateManageProjectDto {
    projectID: number;
    projectImageLogo: string;
    projectName: string;
    projectStatus: boolean;
    activeFrom: string;
    activeTo: string;

    constructor(data?: ICreateManageProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectImageLogo = data["projectImageLogo"];
            this.projectName = data["projectName"];
            this.projectStatus = data["projectStatus"];
            this.activeFrom = data["activeFrom"];
            this.activeTo = data["activeTo"];
        }
    }

    static fromJS(data: any): CreateManageProjectDto {
        let result = new CreateManageProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectImageLogo"] = this.projectImageLogo;
        data["projectName"] = this.projectName;
        data["projectStatus"] = this.projectStatus;
        data["activeFrom"] = this.activeFrom;
        data["activeTo"] = this.activeTo;
        return data; 
    }
}

export interface ICreateManageProjectDto {
    projectID: number;
    projectImageLogo: string;
    projectName: string;
    projectStatus: boolean;
    activeFrom: string;
    activeTo: string;
}

export class GetManageProjectListResultDto implements IGetManageProjectListResultDto {
    projectInfoId: number;
    isOBActive: boolean;
    isPPOlActive: boolean;
    imgLogo: string;
    isActive: boolean;
    productName: string;

    constructor(data?: IGetManageProjectListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoId = data["projectInfoId"];
            this.isOBActive = data["isOBActive"];
            this.isPPOlActive = data["isPPOlActive"];
            this.imgLogo = data["imgLogo"];
            this.isActive = data["isActive"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetManageProjectListResultDto {
        let result = new GetManageProjectListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoId"] = this.projectInfoId;
        data["isOBActive"] = this.isOBActive;
        data["isPPOlActive"] = this.isPPOlActive;
        data["imgLogo"] = this.imgLogo;
        data["isActive"] = this.isActive;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetManageProjectListResultDto {
    projectInfoId: number;
    isOBActive: boolean;
    isPPOlActive: boolean;
    imgLogo: string;
    isActive: boolean;
    productName: string;
}

export class GetDetailProjectResultDto implements IGetDetailProjectResultDto {
    projectID: number;
    id: number;
    projectCode: string;
    projectName: string;
    projectStatus: boolean;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;

    constructor(data?: IGetDetailProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.id = data["id"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.projectStatus = data["projectStatus"];
            this.activeFrom = data["activeFrom"] ? moment(data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = data["activeTo"] ? moment(data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailProjectResultDto {
        let result = new GetDetailProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["id"] = this.id;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["projectStatus"] = this.projectStatus;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailProjectResultDto {
    projectID: number;
    id: number;
    projectCode: string;
    projectName: string;
    projectStatus: boolean;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
}

export class UpdateManageProjectInputDto implements IUpdateManageProjectInputDto {
    projectId: number;
    manageId: number;
    projectStatus: boolean;
    activeFrom: string;
    activeTo: string;

    constructor(data?: IUpdateManageProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.manageId = data["manageId"];
            this.projectStatus = data["projectStatus"];
            this.activeFrom = data["activeFrom"];
            this.activeTo = data["activeTo"];
        }
    }

    static fromJS(data: any): UpdateManageProjectInputDto {
        let result = new UpdateManageProjectInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["manageId"] = this.manageId;
        data["projectStatus"] = this.projectStatus;
        data["activeFrom"] = this.activeFrom;
        data["activeTo"] = this.activeTo;
        return data; 
    }
}

export interface IUpdateManageProjectInputDto {
    projectId: number;
    manageId: number;
    projectStatus: boolean;
    activeFrom: string;
    activeTo: string;
}

export class UpdateImageGalleryInputDto implements IUpdateImageGalleryInputDto {
    imageUrl: string;
    imageAlt: string;
    imageStatus: string;
    galleryID: number;
    sortNo: number;
    projectInfoID: number;

    constructor(data?: IUpdateImageGalleryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageUrl = data["imageUrl"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
            this.galleryID = data["galleryID"];
            this.sortNo = data["sortNo"];
            this.projectInfoID = data["projectInfoID"];
        }
    }

    static fromJS(data: any): UpdateImageGalleryInputDto {
        let result = new UpdateImageGalleryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        data["galleryID"] = this.galleryID;
        data["sortNo"] = this.sortNo;
        data["projectInfoID"] = this.projectInfoID;
        return data; 
    }
}

export interface IUpdateImageGalleryInputDto {
    imageUrl: string;
    imageAlt: string;
    imageStatus: string;
    galleryID: number;
    sortNo: number;
    projectInfoID: number;
}

export class CreateGalleryInputDto implements ICreateGalleryInputDto {
    projectInfoID: number;
    imageURL: string;
    imageAlt: string;
    sortNo: number;
    galleryID: number;
    imageStatus: string;

    constructor(data?: ICreateGalleryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.sortNo = data["sortNo"];
            this.galleryID = data["galleryID"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): CreateGalleryInputDto {
        let result = new CreateGalleryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["sortNo"] = this.sortNo;
        data["galleryID"] = this.galleryID;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface ICreateGalleryInputDto {
    projectInfoID: number;
    imageURL: string;
    imageAlt: string;
    sortNo: number;
    galleryID: number;
    imageStatus: string;
}

export class ListResultDtoOfGetProjectCodeListDto implements IListResultDtoOfGetProjectCodeListDto {
    items: GetProjectCodeListDto[];

    constructor(data?: IListResultDtoOfGetProjectCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectCodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectCodeListDto {
        let result = new ListResultDtoOfGetProjectCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectCodeListDto {
    items: GetProjectCodeListDto[];
}

export class GetProjectCodeListDto implements IGetProjectCodeListDto {
    projectCode: string;

    constructor(data?: IGetProjectCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetProjectCodeListDto {
        let result = new GetProjectCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetProjectCodeListDto {
    projectCode: string;
}

export class GetProjectInfoDto implements IGetProjectInfoDto {
    projectInfoId: number;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    displayName: string;
    projectLogo: string;
    isActive: boolean;

    constructor(data?: IGetProjectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoId = data["projectInfoId"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.clusterCode = data["clusterCode"];
            this.displayName = data["displayName"];
            this.projectLogo = data["projectLogo"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetProjectInfoDto {
        let result = new GetProjectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoId"] = this.projectInfoId;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["clusterCode"] = this.clusterCode;
        data["displayName"] = this.displayName;
        data["projectLogo"] = this.projectLogo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetProjectInfoDto {
    projectInfoId: number;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    displayName: string;
    projectLogo: string;
    isActive: boolean;
}

export class ListResultDtoOfGetKeyFeaturesListResultDto implements IListResultDtoOfGetKeyFeaturesListResultDto {
    items: GetKeyFeaturesListResultDto[];

    constructor(data?: IListResultDtoOfGetKeyFeaturesListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetKeyFeaturesListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetKeyFeaturesListResultDto {
        let result = new ListResultDtoOfGetKeyFeaturesListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetKeyFeaturesListResultDto {
    items: GetKeyFeaturesListResultDto[];
}

export class GetKeyFeaturesListResultDto implements IGetKeyFeaturesListResultDto {
    projectCode: string;
    keyFetColdId: number;
    keyFetId: number;
    keyFet: string;

    constructor(data?: IGetKeyFeaturesListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.keyFetColdId = data["keyFetColdId"];
            this.keyFetId = data["keyFetId"];
            this.keyFet = data["keyFet"];
        }
    }

    static fromJS(data: any): GetKeyFeaturesListResultDto {
        let result = new GetKeyFeaturesListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["keyFetColdId"] = this.keyFetColdId;
        data["keyFetId"] = this.keyFetId;
        data["keyFet"] = this.keyFet;
        return data; 
    }
}

export interface IGetKeyFeaturesListResultDto {
    projectCode: string;
    keyFetColdId: number;
    keyFetId: number;
    keyFet: string;
}

export class GetListManageProjectResultDto implements IGetListManageProjectResultDto {
    projectInfoID: number;
    projectID: number;
    listCluster: GetClusterByProjectInfo[];
    displayName: string;
    projectLogo: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDescription: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    latitude: number;
    longitude: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    locationImageUrl: string;
    projectCode: string;
    projectName: string;
    productCode: string;
    productPPID: number;
    projectAddress: string;
    status: boolean;
    message: string;

    constructor(data?: IGetListManageProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.projectID = data["projectID"];
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(GetClusterByProjectInfo.fromJS(item));
            }
            this.displayName = data["displayName"];
            this.projectLogo = data["projectLogo"];
            this.isOBActive = data["isOBActive"];
            this.isPPOlActive = data["isPPOlActive"];
            this.displaySetting = data["displaySetting"];
            this.projectDescription = data["projectDescription"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.sitePlansLegend = data["sitePlansLegend"];
            this.locationImageUrl = data["locationImageUrl"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.productCode = data["productCode"];
            this.productPPID = data["productPPID"];
            this.projectAddress = data["projectAddress"];
            this.status = data["status"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetListManageProjectResultDto {
        let result = new GetListManageProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["projectID"] = this.projectID;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item.toJSON());
        }
        data["displayName"] = this.displayName;
        data["projectLogo"] = this.projectLogo;
        data["isOBActive"] = this.isOBActive;
        data["isPPOlActive"] = this.isPPOlActive;
        data["displaySetting"] = this.displaySetting;
        data["projectDescription"] = this.projectDescription;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["sitePlansLegend"] = this.sitePlansLegend;
        data["locationImageUrl"] = this.locationImageUrl;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["productCode"] = this.productCode;
        data["productPPID"] = this.productPPID;
        data["projectAddress"] = this.projectAddress;
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetListManageProjectResultDto {
    projectInfoID: number;
    projectID: number;
    listCluster: GetClusterByProjectInfo[];
    displayName: string;
    projectLogo: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDescription: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    latitude: number;
    longitude: number;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    locationImageUrl: string;
    projectCode: string;
    projectName: string;
    productCode: string;
    productPPID: number;
    projectAddress: string;
    status: boolean;
    message: string;
}

export class GetClusterByProjectInfo implements IGetClusterByProjectInfo {
    clusterName: string;
    clusterCode: string;
    projectClusterID: number;
    clusterID: number;

    constructor(data?: IGetClusterByProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterName = data["clusterName"];
            this.clusterCode = data["clusterCode"];
            this.projectClusterID = data["projectClusterID"];
            this.clusterID = data["clusterID"];
        }
    }

    static fromJS(data: any): GetClusterByProjectInfo {
        let result = new GetClusterByProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterName"] = this.clusterName;
        data["clusterCode"] = this.clusterCode;
        data["projectClusterID"] = this.projectClusterID;
        data["clusterID"] = this.clusterID;
        return data; 
    }
}

export interface IGetClusterByProjectInfo {
    clusterName: string;
    clusterCode: string;
    projectClusterID: number;
    clusterID: number;
}

export class ListResultDtoOfGetClusterListResultDto implements IListResultDtoOfGetClusterListResultDto {
    items: GetClusterListResultDto[];

    constructor(data?: IListResultDtoOfGetClusterListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetClusterListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetClusterListResultDto {
        let result = new ListResultDtoOfGetClusterListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetClusterListResultDto {
    items: GetClusterListResultDto[];
}

export class GetClusterListResultDto implements IGetClusterListResultDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetClusterListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetClusterListResultDto {
        let result = new GetClusterListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetClusterListResultDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;
}

export class ListResultDtoOfGetProjectClusterListDto implements IListResultDtoOfGetProjectClusterListDto {
    items: GetProjectClusterListDto[];

    constructor(data?: IListResultDtoOfGetProjectClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectClusterListDto {
        let result = new ListResultDtoOfGetProjectClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectClusterListDto {
    items: GetProjectClusterListDto[];
}

export class GetProjectClusterListDto implements IGetProjectClusterListDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetProjectClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetProjectClusterListDto {
        let result = new GetProjectClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetProjectClusterListDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;
}

export class GetDropdownProductResultDto implements IGetDropdownProductResultDto {
    productID: number;
    projectID: number;
    productName: string;

    constructor(data?: IGetDropdownProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productID = data["productID"];
            this.projectID = data["projectID"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetDropdownProductResultDto {
        let result = new GetDropdownProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["projectID"] = this.projectID;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetDropdownProductResultDto {
    productID: number;
    projectID: number;
    productName: string;
}

export class GetProjectResultDto implements IGetProjectResultDto {
    projectId: number;
    projectName: string;

    constructor(data?: IGetProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectResultDto {
        let result = new GetProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetProjectResultDto {
    projectId: number;
    projectName: string;
}

export class GetDropdownClusterResultDto implements IGetDropdownClusterResultDto {
    clusterID: number;
    clusterName: string;

    constructor(data?: IGetDropdownClusterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetDropdownClusterResultDto {
        let result = new GetDropdownClusterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetDropdownClusterResultDto {
    clusterID: number;
    clusterName: string;
}

export class GetTypeManageUnitResultDto implements IGetTypeManageUnitResultDto {
    category: string;
    typeCode: string;
    detailCode: string;
    detailName: string;

    constructor(data?: IGetTypeManageUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.typeCode = data["typeCode"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
        }
    }

    static fromJS(data: any): GetTypeManageUnitResultDto {
        let result = new GetTypeManageUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["typeCode"] = this.typeCode;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        return data; 
    }
}

export interface IGetTypeManageUnitResultDto {
    category: string;
    typeCode: string;
    detailCode: string;
    detailName: string;
}

export class GetDiagramaticManageUnitResultDto implements IGetDiagramaticManageUnitResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: DetailUnitDto[];
    message: string;

    constructor(data?: IGetDiagramaticManageUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.floor = data["floor"];
            this.unitCodeId = data["unitCodeId"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(DetailUnitDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetDiagramaticManageUnitResultDto {
        let result = new GetDiagramaticManageUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["floor"] = this.floor;
        data["unitCodeId"] = this.unitCodeId;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetDiagramaticManageUnitResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: DetailUnitDto[];
    message: string;
}

export class DetailUnitDto implements IDetailUnitDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    floor: string;
    detailCode: string;
    isShow: boolean;

    constructor(data?: IDetailUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.floor = data["floor"];
            this.detailCode = data["detailCode"];
            this.isShow = data["isShow"];
        }
    }

    static fromJS(data: any): DetailUnitDto {
        let result = new DetailUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["floor"] = this.floor;
        data["detailCode"] = this.detailCode;
        data["isShow"] = this.isShow;
        return data; 
    }
}

export interface IDetailUnitDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    floor: string;
    detailCode: string;
    isShow: boolean;
}

export class ManageShowUnitInputDto implements IManageShowUnitInputDto {
    unitID: number;
    isShow: boolean;

    constructor(data?: IManageShowUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.isShow = data["isShow"];
        }
    }

    static fromJS(data: any): ManageShowUnitInputDto {
        let result = new ManageShowUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["isShow"] = this.isShow;
        return data; 
    }
}

export interface IManageShowUnitInputDto {
    unitID: number;
    isShow: boolean;
}

export class GetListProjectUnitResultDto implements IGetListProjectUnitResultDto {
    projectID: number;
    projectName: string;
    pgEmail: string;
    totalUnit: number;
    totalUnitHide: number;
    totalUnitShow: number;
    listCluster: ClusterDto[];

    constructor(data?: IGetListProjectUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.pgEmail = data["pgEmail"];
            this.totalUnit = data["totalUnit"];
            this.totalUnitHide = data["totalUnitHide"];
            this.totalUnitShow = data["totalUnitShow"];
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(ClusterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListProjectUnitResultDto {
        let result = new GetListProjectUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["pgEmail"] = this.pgEmail;
        data["totalUnit"] = this.totalUnit;
        data["totalUnitHide"] = this.totalUnitHide;
        data["totalUnitShow"] = this.totalUnitShow;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListProjectUnitResultDto {
    projectID: number;
    projectName: string;
    pgEmail: string;
    totalUnit: number;
    totalUnitHide: number;
    totalUnitShow: number;
    listCluster: ClusterDto[];
}

export class ClusterDto implements IClusterDto {
    clusterID: number;
    clusterName: string;
    listUnit: ListUnitDto[];

    constructor(data?: IClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(ListUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClusterDto {
        let result = new ClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IClusterDto {
    clusterID: number;
    clusterName: string;
    listUnit: ListUnitDto[];
}

export class ListUnitDto implements IListUnitDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    holdSince: moment.Moment;

    constructor(data?: IListUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.holdSince = data["holdSince"] ? moment(data["holdSince"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListUnitDto {
        let result = new ListUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["holdSince"] = this.holdSince ? this.holdSince.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IListUnitDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    holdSince: moment.Moment;
}

export class GetDetailProjectUnitResultDto implements IGetDetailProjectUnitResultDto {
    projectID: number;
    projectName: string;
    totalShowUnit: number;
    totalHideUnit: number;

    constructor(data?: IGetDetailProjectUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.totalShowUnit = data["totalShowUnit"];
            this.totalHideUnit = data["totalHideUnit"];
        }
    }

    static fromJS(data: any): GetDetailProjectUnitResultDto {
        let result = new GetDetailProjectUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["totalShowUnit"] = this.totalShowUnit;
        data["totalHideUnit"] = this.totalHideUnit;
        return data; 
    }
}

export interface IGetDetailProjectUnitResultDto {
    projectID: number;
    projectName: string;
    totalShowUnit: number;
    totalHideUnit: number;
}

export class CreateOrUpdateProjectInputDto implements ICreateOrUpdateProjectInputDto {
    projectCode: string;
    projectId: number;
    projectInfoId: number;
    msProjectClusters: Project_clusters[];
    displayName: string;
    projectStatus: boolean;
    sitePlansImageUrl: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    projectName: string;
    imgLogo: string;
    status: boolean;
    projectDesc: string;
    trKeyFeatures: Key_features[];
    latitude: number;
    longitude: number;
    locationImageURL: string;
    projectAddress: string;

    constructor(data?: ICreateOrUpdateProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.projectId = data["projectId"];
            this.projectInfoId = data["projectInfoId"];
            if (data["msProjectClusters"] && data["msProjectClusters"].constructor === Array) {
                this.msProjectClusters = [];
                for (let item of data["msProjectClusters"])
                    this.msProjectClusters.push(Project_clusters.fromJS(item));
            }
            this.displayName = data["displayName"];
            this.projectStatus = data["projectStatus"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.isOBActive = data["isOBActive"];
            this.isPPOlActive = data["isPPOlActive"];
            this.displaySetting = data["displaySetting"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
            this.projectName = data["projectName"];
            this.imgLogo = data["imgLogo"];
            this.status = data["status"];
            this.projectDesc = data["projectDesc"];
            if (data["trKeyFeatures"] && data["trKeyFeatures"].constructor === Array) {
                this.trKeyFeatures = [];
                for (let item of data["trKeyFeatures"])
                    this.trKeyFeatures.push(Key_features.fromJS(item));
            }
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.locationImageURL = data["locationImageURL"];
            this.projectAddress = data["projectAddress"];
        }
    }

    static fromJS(data: any): CreateOrUpdateProjectInputDto {
        let result = new CreateOrUpdateProjectInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["projectId"] = this.projectId;
        data["projectInfoId"] = this.projectInfoId;
        if (this.msProjectClusters && this.msProjectClusters.constructor === Array) {
            data["msProjectClusters"] = [];
            for (let item of this.msProjectClusters)
                data["msProjectClusters"].push(item.toJSON());
        }
        data["displayName"] = this.displayName;
        data["projectStatus"] = this.projectStatus;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["isOBActive"] = this.isOBActive;
        data["isPPOlActive"] = this.isPPOlActive;
        data["displaySetting"] = this.displaySetting;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        data["projectName"] = this.projectName;
        data["imgLogo"] = this.imgLogo;
        data["status"] = this.status;
        data["projectDesc"] = this.projectDesc;
        if (this.trKeyFeatures && this.trKeyFeatures.constructor === Array) {
            data["trKeyFeatures"] = [];
            for (let item of this.trKeyFeatures)
                data["trKeyFeatures"].push(item.toJSON());
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationImageURL"] = this.locationImageURL;
        data["projectAddress"] = this.projectAddress;
        return data; 
    }
}

export interface ICreateOrUpdateProjectInputDto {
    projectCode: string;
    projectId: number;
    projectInfoId: number;
    msProjectClusters: Project_clusters[];
    displayName: string;
    projectStatus: boolean;
    sitePlansImageUrl: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    projectName: string;
    imgLogo: string;
    status: boolean;
    projectDesc: string;
    trKeyFeatures: Key_features[];
    latitude: number;
    longitude: number;
    locationImageURL: string;
    projectAddress: string;
}

export class Project_clusters implements IProject_clusters {
    clusterId: number;

    constructor(data?: IProject_clusters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
        }
    }

    static fromJS(data: any): Project_clusters {
        let result = new Project_clusters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        return data; 
    }
}

export interface IProject_clusters {
    clusterId: number;
}

export class Key_features implements IKey_features {
    keyFeatures: string;

    constructor(data?: IKey_features) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyFeatures = data["keyFeatures"];
        }
    }

    static fromJS(data: any): Key_features {
        let result = new Key_features();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyFeatures"] = this.keyFeatures;
        return data; 
    }
}

export interface IKey_features {
    keyFeatures: string;
}

export class CreateUpdateProjectInfoUniversalInputDto implements ICreateUpdateProjectInfoUniversalInputDto {
    msProjectClusters: ProjectClustersDto[];
    projectInfoID: number;
    displayName: string;
    projectStatus: boolean;
    sitePlansImageUrl: string;
    imageSitePlanStatus: string;
    imgLogo: string;
    imageLogoStatus: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    productCode: string;
    projectID: number;
    status: boolean;
    projectDesc: string;
    trKeyFeatures: KeyFeaturesDto[];
    latitude: number;
    longitude: number;
    locationImageURL: string;
    locationImageStatus: string;
    projectAddress: string;
    ppSetup: CreateProductPPOnlineInputDto;
    sosialMedia: CreateOrUpdateSocialMediaProjectInputDto[];
    gallery: CreateGalleryInputDto[];

    constructor(data?: ICreateUpdateProjectInfoUniversalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["msProjectClusters"] && data["msProjectClusters"].constructor === Array) {
                this.msProjectClusters = [];
                for (let item of data["msProjectClusters"])
                    this.msProjectClusters.push(ProjectClustersDto.fromJS(item));
            }
            this.projectInfoID = data["projectInfoID"];
            this.displayName = data["displayName"];
            this.projectStatus = data["projectStatus"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.imageSitePlanStatus = data["imageSitePlanStatus"];
            this.imgLogo = data["imgLogo"];
            this.imageLogoStatus = data["imageLogoStatus"];
            this.isOBActive = data["isOBActive"];
            this.isPPOlActive = data["isPPOlActive"];
            this.displaySetting = data["displaySetting"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
            this.productCode = data["productCode"];
            this.projectID = data["projectID"];
            this.status = data["status"];
            this.projectDesc = data["projectDesc"];
            if (data["trKeyFeatures"] && data["trKeyFeatures"].constructor === Array) {
                this.trKeyFeatures = [];
                for (let item of data["trKeyFeatures"])
                    this.trKeyFeatures.push(KeyFeaturesDto.fromJS(item));
            }
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.locationImageURL = data["locationImageURL"];
            this.locationImageStatus = data["locationImageStatus"];
            this.projectAddress = data["projectAddress"];
            this.ppSetup = data["ppSetup"] ? CreateProductPPOnlineInputDto.fromJS(data["ppSetup"]) : <any>undefined;
            if (data["sosialMedia"] && data["sosialMedia"].constructor === Array) {
                this.sosialMedia = [];
                for (let item of data["sosialMedia"])
                    this.sosialMedia.push(CreateOrUpdateSocialMediaProjectInputDto.fromJS(item));
            }
            if (data["gallery"] && data["gallery"].constructor === Array) {
                this.gallery = [];
                for (let item of data["gallery"])
                    this.gallery.push(CreateGalleryInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateProjectInfoUniversalInputDto {
        let result = new CreateUpdateProjectInfoUniversalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.msProjectClusters && this.msProjectClusters.constructor === Array) {
            data["msProjectClusters"] = [];
            for (let item of this.msProjectClusters)
                data["msProjectClusters"].push(item.toJSON());
        }
        data["projectInfoID"] = this.projectInfoID;
        data["displayName"] = this.displayName;
        data["projectStatus"] = this.projectStatus;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["imageSitePlanStatus"] = this.imageSitePlanStatus;
        data["imgLogo"] = this.imgLogo;
        data["imageLogoStatus"] = this.imageLogoStatus;
        data["isOBActive"] = this.isOBActive;
        data["isPPOlActive"] = this.isPPOlActive;
        data["displaySetting"] = this.displaySetting;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        data["productCode"] = this.productCode;
        data["projectID"] = this.projectID;
        data["status"] = this.status;
        data["projectDesc"] = this.projectDesc;
        if (this.trKeyFeatures && this.trKeyFeatures.constructor === Array) {
            data["trKeyFeatures"] = [];
            for (let item of this.trKeyFeatures)
                data["trKeyFeatures"].push(item.toJSON());
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationImageURL"] = this.locationImageURL;
        data["locationImageStatus"] = this.locationImageStatus;
        data["projectAddress"] = this.projectAddress;
        data["ppSetup"] = this.ppSetup ? this.ppSetup.toJSON() : <any>undefined;
        if (this.sosialMedia && this.sosialMedia.constructor === Array) {
            data["sosialMedia"] = [];
            for (let item of this.sosialMedia)
                data["sosialMedia"].push(item.toJSON());
        }
        if (this.gallery && this.gallery.constructor === Array) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUpdateProjectInfoUniversalInputDto {
    msProjectClusters: ProjectClustersDto[];
    projectInfoID: number;
    displayName: string;
    projectStatus: boolean;
    sitePlansImageUrl: string;
    imageSitePlanStatus: string;
    imgLogo: string;
    imageLogoStatus: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    displaySetting: string;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    productCode: string;
    projectID: number;
    status: boolean;
    projectDesc: string;
    trKeyFeatures: KeyFeaturesDto[];
    latitude: number;
    longitude: number;
    locationImageURL: string;
    locationImageStatus: string;
    projectAddress: string;
    ppSetup: CreateProductPPOnlineInputDto;
    sosialMedia: CreateOrUpdateSocialMediaProjectInputDto[];
    gallery: CreateGalleryInputDto[];
}

export class ProjectClustersDto implements IProjectClustersDto {
    clusterId: number;

    constructor(data?: IProjectClustersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
        }
    }

    static fromJS(data: any): ProjectClustersDto {
        let result = new ProjectClustersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        return data; 
    }
}

export interface IProjectClustersDto {
    clusterId: number;
}

export class KeyFeaturesDto implements IKeyFeaturesDto {
    id: number;
    keyFeatures: string;

    constructor(data?: IKeyFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.keyFeatures = data["keyFeatures"];
        }
    }

    static fromJS(data: any): KeyFeaturesDto {
        let result = new KeyFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyFeatures"] = this.keyFeatures;
        return data; 
    }
}

export interface IKeyFeaturesDto {
    id: number;
    keyFeatures: string;
}

export class CreateProductPPOnlineInputDto implements ICreateProductPPOnlineInputDto {
    projectPPID: number;
    categoryTypeId: number;
    banner: string;
    termAndCondition: string;
    logo: string;
    startDate: string;
    endDate: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    isActive: boolean;
    ppAmt: number;
    imageStatusLogo: string;
    imageStatusBanner: string;
    imageStatusTerm: string;
    projectInfoID: number;
    isByUnitType: boolean;
    detailID: number;

    constructor(data?: ICreateProductPPOnlineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectPPID = data["projectPPID"];
            this.categoryTypeId = data["categoryTypeId"];
            this.banner = data["banner"];
            this.termAndCondition = data["termAndCondition"];
            this.logo = data["logo"];
            this.startDate = data["startDate"];
            this.endDate = data["endDate"];
            this.isBuyPPCust = data["isBuyPPCust"];
            this.isBuyPPSales = data["isBuyPPSales"];
            this.isActive = data["isActive"];
            this.ppAmt = data["ppAmt"];
            this.imageStatusLogo = data["imageStatusLogo"];
            this.imageStatusBanner = data["imageStatusBanner"];
            this.imageStatusTerm = data["imageStatusTerm"];
            this.projectInfoID = data["projectInfoID"];
            this.isByUnitType = data["isByUnitType"];
            this.detailID = data["detailID"];
        }
    }

    static fromJS(data: any): CreateProductPPOnlineInputDto {
        let result = new CreateProductPPOnlineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPPID"] = this.projectPPID;
        data["categoryTypeId"] = this.categoryTypeId;
        data["banner"] = this.banner;
        data["termAndCondition"] = this.termAndCondition;
        data["logo"] = this.logo;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isBuyPPCust"] = this.isBuyPPCust;
        data["isBuyPPSales"] = this.isBuyPPSales;
        data["isActive"] = this.isActive;
        data["ppAmt"] = this.ppAmt;
        data["imageStatusLogo"] = this.imageStatusLogo;
        data["imageStatusBanner"] = this.imageStatusBanner;
        data["imageStatusTerm"] = this.imageStatusTerm;
        data["projectInfoID"] = this.projectInfoID;
        data["isByUnitType"] = this.isByUnitType;
        data["detailID"] = this.detailID;
        return data; 
    }
}

export interface ICreateProductPPOnlineInputDto {
    projectPPID: number;
    categoryTypeId: number;
    banner: string;
    termAndCondition: string;
    logo: string;
    startDate: string;
    endDate: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    isActive: boolean;
    ppAmt: number;
    imageStatusLogo: string;
    imageStatusBanner: string;
    imageStatusTerm: string;
    projectInfoID: number;
    isByUnitType: boolean;
    detailID: number;
}

export class InsertProjectOLBookingInputDto implements IInsertProjectOLBookingInputDto {
    projectInfoID: number;
    projectID: number;
    imgLogo: string;
    status: boolean;
    projectDesc: string;
    clusterID: number[];
    imageLogoStatus: string;

    constructor(data?: IInsertProjectOLBookingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.projectID = data["projectID"];
            this.imgLogo = data["imgLogo"];
            this.status = data["status"];
            this.projectDesc = data["projectDesc"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            this.imageLogoStatus = data["imageLogoStatus"];
        }
    }

    static fromJS(data: any): InsertProjectOLBookingInputDto {
        let result = new InsertProjectOLBookingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["projectID"] = this.projectID;
        data["imgLogo"] = this.imgLogo;
        data["status"] = this.status;
        data["projectDesc"] = this.projectDesc;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        data["imageLogoStatus"] = this.imageLogoStatus;
        return data; 
    }
}

export interface IInsertProjectOLBookingInputDto {
    projectInfoID: number;
    projectID: number;
    imgLogo: string;
    status: boolean;
    projectDesc: string;
    clusterID: number[];
    imageLogoStatus: string;
}

export class InsertProjectLocationInputDto implements IInsertProjectLocationInputDto {
    projectInfoID: number;
    latitude: number;
    longitude: number;
    locationImageURL: string;
    projectAddress: string;
    locationImageStatus: string;

    constructor(data?: IInsertProjectLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.locationImageURL = data["locationImageURL"];
            this.projectAddress = data["projectAddress"];
            this.locationImageStatus = data["locationImageStatus"];
        }
    }

    static fromJS(data: any): InsertProjectLocationInputDto {
        let result = new InsertProjectLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationImageURL"] = this.locationImageURL;
        data["projectAddress"] = this.projectAddress;
        data["locationImageStatus"] = this.locationImageStatus;
        return data; 
    }
}

export interface IInsertProjectLocationInputDto {
    projectInfoID: number;
    latitude: number;
    longitude: number;
    locationImageURL: string;
    projectAddress: string;
    locationImageStatus: string;
}

export class ListResultDtoOfGetListUnitTypeResultDto implements IListResultDtoOfGetListUnitTypeResultDto {
    items: GetListUnitTypeResultDto[];

    constructor(data?: IListResultDtoOfGetListUnitTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListUnitTypeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListUnitTypeResultDto {
        let result = new ListResultDtoOfGetListUnitTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListUnitTypeResultDto {
    items: GetListUnitTypeResultDto[];
}

export class GetListUnitTypeResultDto implements IGetListUnitTypeResultDto {
    projectID: number;
    detailID: number;
    clusterName: string;
    detailImage: string;
    detailCode: string;
    detailName: string;

    constructor(data?: IGetListUnitTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.detailID = data["detailID"];
            this.clusterName = data["clusterName"];
            this.detailImage = data["detailImage"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
        }
    }

    static fromJS(data: any): GetListUnitTypeResultDto {
        let result = new GetListUnitTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["detailID"] = this.detailID;
        data["clusterName"] = this.clusterName;
        data["detailImage"] = this.detailImage;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        return data; 
    }
}

export interface IGetListUnitTypeResultDto {
    projectID: number;
    detailID: number;
    clusterName: string;
    detailImage: string;
    detailCode: string;
    detailName: string;
}

export class UpdateUnitTypeInputDto implements IUpdateUnitTypeInputDto {
    detailID: number;
    detailImage: string;
    imageStatus: string;

    constructor(data?: IUpdateUnitTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailID = data["detailID"];
            this.detailImage = data["detailImage"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): UpdateUnitTypeInputDto {
        let result = new UpdateUnitTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailID"] = this.detailID;
        data["detailImage"] = this.detailImage;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface IUpdateUnitTypeInputDto {
    detailID: number;
    detailImage: string;
    imageStatus: string;
}

export class CreateProjectInfoInputDto implements ICreateProjectInfoInputDto {
    projectInfoID: number;
    projectID: number;
    projectDesc: string;
    keyFeaturesCollectionID: number;
    projectDeveloper: string;
    imageLogo: string;
    imageSitePlan: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    imageLogoStatus: string;
    imageSitePlanStatus: string;
    displayName: string;
    displaySetting: string;
    isActive: boolean;
    productCode: string;
    projectAddress: string;

    constructor(data?: ICreateProjectInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.projectID = data["projectID"];
            this.projectDesc = data["projectDesc"];
            this.keyFeaturesCollectionID = data["keyFeaturesCollectionID"];
            this.projectDeveloper = data["projectDeveloper"];
            this.imageLogo = data["imageLogo"];
            this.imageSitePlan = data["imageSitePlan"];
            this.isOBActive = data["isOBActive"];
            this.isPPOlActive = data["isPPOlActive"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
            this.imageLogoStatus = data["imageLogoStatus"];
            this.imageSitePlanStatus = data["imageSitePlanStatus"];
            this.displayName = data["displayName"];
            this.displaySetting = data["displaySetting"];
            this.isActive = data["isActive"];
            this.productCode = data["productCode"];
            this.projectAddress = data["projectAddress"];
        }
    }

    static fromJS(data: any): CreateProjectInfoInputDto {
        let result = new CreateProjectInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["projectID"] = this.projectID;
        data["projectDesc"] = this.projectDesc;
        data["keyFeaturesCollectionID"] = this.keyFeaturesCollectionID;
        data["projectDeveloper"] = this.projectDeveloper;
        data["imageLogo"] = this.imageLogo;
        data["imageSitePlan"] = this.imageSitePlan;
        data["isOBActive"] = this.isOBActive;
        data["isPPOlActive"] = this.isPPOlActive;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        data["imageLogoStatus"] = this.imageLogoStatus;
        data["imageSitePlanStatus"] = this.imageSitePlanStatus;
        data["displayName"] = this.displayName;
        data["displaySetting"] = this.displaySetting;
        data["isActive"] = this.isActive;
        data["productCode"] = this.productCode;
        data["projectAddress"] = this.projectAddress;
        return data; 
    }
}

export interface ICreateProjectInfoInputDto {
    projectInfoID: number;
    projectID: number;
    projectDesc: string;
    keyFeaturesCollectionID: number;
    projectDeveloper: string;
    imageLogo: string;
    imageSitePlan: string;
    isOBActive: boolean;
    isPPOlActive: boolean;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    imageLogoStatus: string;
    imageSitePlanStatus: string;
    displayName: string;
    displaySetting: string;
    isActive: boolean;
    productCode: string;
    projectAddress: string;
}

export class CreateOrUpdateProjectInfoResultDto implements ICreateOrUpdateProjectInfoResultDto {
    projectInfoID: number;
    imgLogo: string;

    constructor(data?: ICreateOrUpdateProjectInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.imgLogo = data["imgLogo"];
        }
    }

    static fromJS(data: any): CreateOrUpdateProjectInfoResultDto {
        let result = new CreateOrUpdateProjectInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["imgLogo"] = this.imgLogo;
        return data; 
    }
}

export interface ICreateOrUpdateProjectInfoResultDto {
    projectInfoID: number;
    imgLogo: string;
}

export class UpdateSetupProjectProductPPInputDto implements IUpdateSetupProjectProductPPInputDto {
    productId: number;
    projectId: number;
    projectCode: string;
    productCode: string;
    productName: string;
    categoryId: number;
    productDesc: string;
    startDate: string;
    endDate: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    clusterID: number[];
    imageStatusLogo: string;
    imageStatusBanner: string;
    imageStatusTerm: string;
    logo: string;
    banner: string;
    term: string;
    isActive: boolean;
    isByUnitType: boolean;
    detailID: number;
    ppAmt: number;

    constructor(data?: IUpdateSetupProjectProductPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.projectId = data["projectId"];
            this.projectCode = data["projectCode"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.categoryId = data["categoryId"];
            this.productDesc = data["productDesc"];
            this.startDate = data["startDate"];
            this.endDate = data["endDate"];
            this.isBuyPPCust = data["isBuyPPCust"];
            this.isBuyPPSales = data["isBuyPPSales"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            this.imageStatusLogo = data["imageStatusLogo"];
            this.imageStatusBanner = data["imageStatusBanner"];
            this.imageStatusTerm = data["imageStatusTerm"];
            this.logo = data["logo"];
            this.banner = data["banner"];
            this.term = data["term"];
            this.isActive = data["isActive"];
            this.isByUnitType = data["isByUnitType"];
            this.detailID = data["detailID"];
            this.ppAmt = data["ppAmt"];
        }
    }

    static fromJS(data: any): UpdateSetupProjectProductPPInputDto {
        let result = new UpdateSetupProjectProductPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["categoryId"] = this.categoryId;
        data["productDesc"] = this.productDesc;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isBuyPPCust"] = this.isBuyPPCust;
        data["isBuyPPSales"] = this.isBuyPPSales;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        data["imageStatusLogo"] = this.imageStatusLogo;
        data["imageStatusBanner"] = this.imageStatusBanner;
        data["imageStatusTerm"] = this.imageStatusTerm;
        data["logo"] = this.logo;
        data["banner"] = this.banner;
        data["term"] = this.term;
        data["isActive"] = this.isActive;
        data["isByUnitType"] = this.isByUnitType;
        data["detailID"] = this.detailID;
        data["ppAmt"] = this.ppAmt;
        return data; 
    }
}

export interface IUpdateSetupProjectProductPPInputDto {
    productId: number;
    projectId: number;
    projectCode: string;
    productCode: string;
    productName: string;
    categoryId: number;
    productDesc: string;
    startDate: string;
    endDate: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    clusterID: number[];
    imageStatusLogo: string;
    imageStatusBanner: string;
    imageStatusTerm: string;
    logo: string;
    banner: string;
    term: string;
    isActive: boolean;
    isByUnitType: boolean;
    detailID: number;
    ppAmt: number;
}

export class ListResultDtoOfGetListProjectDto implements IListResultDtoOfGetListProjectDto {
    items: GetListProjectDto[];

    constructor(data?: IListResultDtoOfGetListProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListProjectDto {
        let result = new ListResultDtoOfGetListProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListProjectDto {
    items: GetListProjectDto[];
}

export class GetListProjectDto implements IGetListProjectDto {
    projectId: number;
    projectName: string;
    projectCode: string;

    constructor(data?: IGetListProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetListProjectDto {
        let result = new GetListProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetListProjectDto {
    projectId: number;
    projectName: string;
    projectCode: string;
}

export class ListResultDtoOfGetProductSetupListResultDto implements IListResultDtoOfGetProductSetupListResultDto {
    items: GetProductSetupListResultDto[];

    constructor(data?: IListResultDtoOfGetProductSetupListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductSetupListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductSetupListResultDto {
        let result = new ListResultDtoOfGetProductSetupListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductSetupListResultDto {
    items: GetProductSetupListResultDto[];
}

export class GetProductSetupListResultDto implements IGetProductSetupListResultDto {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterCode: string;
    towerClusterName: string;
    isActive: boolean;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isRequiredPP: boolean;

    constructor(data?: IGetProductSetupListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.clusterId = data["clusterId"];
            this.clusterCode = data["clusterCode"];
            this.towerClusterName = data["towerClusterName"];
            this.isActive = data["isActive"];
            this.periodStart = data["periodStart"] ? moment(data["periodStart"].toString()) : <any>undefined;
            this.periodEnd = data["periodEnd"] ? moment(data["periodEnd"].toString()) : <any>undefined;
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): GetProductSetupListResultDto {
        let result = new GetProductSetupListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clusterId"] = this.clusterId;
        data["clusterCode"] = this.clusterCode;
        data["towerClusterName"] = this.towerClusterName;
        data["isActive"] = this.isActive;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : <any>undefined;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : <any>undefined;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IGetProductSetupListResultDto {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterCode: string;
    towerClusterName: string;
    isActive: boolean;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isRequiredPP: boolean;
}

export class EditOlBookingResultDto implements IEditOlBookingResultDto {
    olBookingId: number;
    clusterId: number;
    projectName: string;
    towerClusterCode: string;
    towerClusterName: string;
    activeStart: moment.Moment;
    activeEnd: moment.Moment;
    isRequirePP: boolean;

    constructor(data?: IEditOlBookingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.olBookingId = data["olBookingId"];
            this.clusterId = data["clusterId"];
            this.projectName = data["projectName"];
            this.towerClusterCode = data["towerClusterCode"];
            this.towerClusterName = data["towerClusterName"];
            this.activeStart = data["activeStart"] ? moment(data["activeStart"].toString()) : <any>undefined;
            this.activeEnd = data["activeEnd"] ? moment(data["activeEnd"].toString()) : <any>undefined;
            this.isRequirePP = data["isRequirePP"];
        }
    }

    static fromJS(data: any): EditOlBookingResultDto {
        let result = new EditOlBookingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["olBookingId"] = this.olBookingId;
        data["clusterId"] = this.clusterId;
        data["projectName"] = this.projectName;
        data["towerClusterCode"] = this.towerClusterCode;
        data["towerClusterName"] = this.towerClusterName;
        data["activeStart"] = this.activeStart ? this.activeStart.toISOString() : <any>undefined;
        data["activeEnd"] = this.activeEnd ? this.activeEnd.toISOString() : <any>undefined;
        data["isRequirePP"] = this.isRequirePP;
        return data; 
    }
}

export interface IEditOlBookingResultDto {
    olBookingId: number;
    clusterId: number;
    projectName: string;
    towerClusterCode: string;
    towerClusterName: string;
    activeStart: moment.Moment;
    activeEnd: moment.Moment;
    isRequirePP: boolean;
}

export class UpdateOlBookingInputDto implements IUpdateOlBookingInputDto {
    olBookingId: number;
    activeStart: string;
    activeEnd: string;
    isRequirePP: boolean;

    constructor(data?: IUpdateOlBookingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.olBookingId = data["olBookingId"];
            this.activeStart = data["activeStart"];
            this.activeEnd = data["activeEnd"];
            this.isRequirePP = data["isRequirePP"];
        }
    }

    static fromJS(data: any): UpdateOlBookingInputDto {
        let result = new UpdateOlBookingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["olBookingId"] = this.olBookingId;
        data["activeStart"] = this.activeStart;
        data["activeEnd"] = this.activeEnd;
        data["isRequirePP"] = this.isRequirePP;
        return data; 
    }
}

export interface IUpdateOlBookingInputDto {
    olBookingId: number;
    activeStart: string;
    activeEnd: string;
    isRequirePP: boolean;
}

export class ListResultDtoOfGetProjectNameListResultDto implements IListResultDtoOfGetProjectNameListResultDto {
    items: GetProjectNameListResultDto[];

    constructor(data?: IListResultDtoOfGetProjectNameListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectNameListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectNameListResultDto {
        let result = new ListResultDtoOfGetProjectNameListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectNameListResultDto {
    items: GetProjectNameListResultDto[];
}

export class GetProjectNameListResultDto implements IGetProjectNameListResultDto {
    projectId: number;
    projectName: string;
    projectCode: string;

    constructor(data?: IGetProjectNameListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetProjectNameListResultDto {
        let result = new GetProjectNameListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetProjectNameListResultDto {
    projectId: number;
    projectName: string;
    projectCode: string;
}

export class ListResultDtoOfGetProductNameResultDto implements IListResultDtoOfGetProductNameResultDto {
    items: GetProductNameResultDto[];

    constructor(data?: IListResultDtoOfGetProductNameResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductNameResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductNameResultDto {
        let result = new ListResultDtoOfGetProductNameResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductNameResultDto {
    items: GetProductNameResultDto[];
}

export class GetProductNameResultDto implements IGetProductNameResultDto {
    projectId: number;
    productProjectId: number;
    productName: string;

    constructor(data?: IGetProductNameResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.productProjectId = data["productProjectId"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetProductNameResultDto {
        let result = new GetProductNameResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["productProjectId"] = this.productProjectId;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetProductNameResultDto {
    projectId: number;
    productProjectId: number;
    productName: string;
}

export class ListResultDtoOfGetProductDetailListResultDto implements IListResultDtoOfGetProductDetailListResultDto {
    items: GetProductDetailListResultDto[];

    constructor(data?: IListResultDtoOfGetProductDetailListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductDetailListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductDetailListResultDto {
        let result = new ListResultDtoOfGetProductDetailListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductDetailListResultDto {
    items: GetProductDetailListResultDto[];
}

export class GetProductDetailListResultDto implements IGetProductDetailListResultDto {
    projectId: number;
    productId: number;
    projectName: string;
    productName: string;
    productCode: string;
    status: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor(data?: IGetProductDetailListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.productId = data["productId"];
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.status = data["status"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductDetailListResultDto {
        let result = new GetProductDetailListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["productId"] = this.productId;
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetProductDetailListResultDto {
    projectId: number;
    productId: number;
    projectName: string;
    productName: string;
    productCode: string;
    status: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class EditProjectProductResultDto implements IEditProjectProductResultDto {
    projectPPOlId: number;
    projectName: string;
    projectCode: string;
    productCode: string;
    productName: string;
    categoryID: number;
    categoryName: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
    ppAmt: number;
    logo: string;
    banner: string;
    termAndCondition: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    productDesc: string;
    productPPOlId: number;
    dataCluster: GetClusterListResultDto[];

    constructor(data?: IEditProjectProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectPPOlId = data["projectPPOlId"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.ppAmt = data["ppAmt"];
            this.logo = data["logo"];
            this.banner = data["banner"];
            this.termAndCondition = data["termAndCondition"];
            this.isBuyPPCust = data["isBuyPPCust"];
            this.isBuyPPSales = data["isBuyPPSales"];
            this.productDesc = data["productDesc"];
            this.productPPOlId = data["productPPOlId"];
            if (data["dataCluster"] && data["dataCluster"].constructor === Array) {
                this.dataCluster = [];
                for (let item of data["dataCluster"])
                    this.dataCluster.push(GetClusterListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditProjectProductResultDto {
        let result = new EditProjectProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPPOlId"] = this.projectPPOlId;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["ppAmt"] = this.ppAmt;
        data["logo"] = this.logo;
        data["banner"] = this.banner;
        data["termAndCondition"] = this.termAndCondition;
        data["isBuyPPCust"] = this.isBuyPPCust;
        data["isBuyPPSales"] = this.isBuyPPSales;
        data["productDesc"] = this.productDesc;
        data["productPPOlId"] = this.productPPOlId;
        if (this.dataCluster && this.dataCluster.constructor === Array) {
            data["dataCluster"] = [];
            for (let item of this.dataCluster)
                data["dataCluster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditProjectProductResultDto {
    projectPPOlId: number;
    projectName: string;
    projectCode: string;
    productCode: string;
    productName: string;
    categoryID: number;
    categoryName: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
    ppAmt: number;
    logo: string;
    banner: string;
    termAndCondition: string;
    isBuyPPCust: boolean;
    isBuyPPSales: boolean;
    productDesc: string;
    productPPOlId: number;
    dataCluster: GetClusterListResultDto[];
}

export class ListResultDtoOfGetProductProjectClustersResultDto implements IListResultDtoOfGetProductProjectClustersResultDto {
    items: GetProductProjectClustersResultDto[];

    constructor(data?: IListResultDtoOfGetProductProjectClustersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductProjectClustersResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductProjectClustersResultDto {
        let result = new ListResultDtoOfGetProductProjectClustersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductProjectClustersResultDto {
    items: GetProductProjectClustersResultDto[];
}

export class GetProductProjectClustersResultDto implements IGetProductProjectClustersResultDto {
    clusterId: number;

    constructor(data?: IGetProductProjectClustersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
        }
    }

    static fromJS(data: any): GetProductProjectClustersResultDto {
        let result = new GetProductProjectClustersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        return data; 
    }
}

export interface IGetProductProjectClustersResultDto {
    clusterId: number;
}

export class ListResultDtoOfGetPriorityPassPerUnitListResultDto implements IListResultDtoOfGetPriorityPassPerUnitListResultDto {
    items: GetPriorityPassPerUnitListResultDto[];

    constructor(data?: IListResultDtoOfGetPriorityPassPerUnitListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPriorityPassPerUnitListResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetPriorityPassPerUnitListResultDto {
        let result = new ListResultDtoOfGetPriorityPassPerUnitListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetPriorityPassPerUnitListResultDto {
    items: GetPriorityPassPerUnitListResultDto[];
}

export class GetPriorityPassPerUnitListResultDto implements IGetPriorityPassPerUnitListResultDto {
    projectPPOnlineId: number;
    projectProductId: number;
    preferredTypeId: number;
    categoryTypePreferredId: number;
    price: number;

    constructor(data?: IGetPriorityPassPerUnitListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectPPOnlineId = data["projectPPOnlineId"];
            this.projectProductId = data["projectProductId"];
            this.preferredTypeId = data["preferredTypeId"];
            this.categoryTypePreferredId = data["categoryTypePreferredId"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): GetPriorityPassPerUnitListResultDto {
        let result = new GetPriorityPassPerUnitListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPPOnlineId"] = this.projectPPOnlineId;
        data["projectProductId"] = this.projectProductId;
        data["preferredTypeId"] = this.preferredTypeId;
        data["categoryTypePreferredId"] = this.categoryTypePreferredId;
        data["price"] = this.price;
        return data; 
    }
}

export interface IGetPriorityPassPerUnitListResultDto {
    projectPPOnlineId: number;
    projectProductId: number;
    preferredTypeId: number;
    categoryTypePreferredId: number;
    price: number;
}

export class EditPriorityPassUnitTypeDto implements IEditPriorityPassUnitTypeDto {
    lkPrefTypeId: number;
    unitType: string;
    price: number;

    constructor(data?: IEditPriorityPassUnitTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lkPrefTypeId = data["lkPrefTypeId"];
            this.unitType = data["unitType"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): EditPriorityPassUnitTypeDto {
        let result = new EditPriorityPassUnitTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lkPrefTypeId"] = this.lkPrefTypeId;
        data["unitType"] = this.unitType;
        data["price"] = this.price;
        return data; 
    }
}

export interface IEditPriorityPassUnitTypeDto {
    lkPrefTypeId: number;
    unitType: string;
    price: number;
}

export class GetCategoryTypeListDto implements IGetCategoryTypeListDto {
    categoryTypeID: number;
    categoryName: string;

    constructor(data?: IGetCategoryTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryTypeID = data["categoryTypeID"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): GetCategoryTypeListDto {
        let result = new GetCategoryTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryTypeID"] = this.categoryTypeID;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface IGetCategoryTypeListDto {
    categoryTypeID: number;
    categoryName: string;
}

export class ListResultDtoOfGetListAllPromoResultDto implements IListResultDtoOfGetListAllPromoResultDto {
    items: GetListAllPromoResultDto[];

    constructor(data?: IListResultDtoOfGetListAllPromoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListAllPromoResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListAllPromoResultDto {
        let result = new ListResultDtoOfGetListAllPromoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListAllPromoResultDto {
    items: GetListAllPromoResultDto[];
}

export class GetListAllPromoResultDto implements IGetListAllPromoResultDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    targetURL: string;
    projectID: number;
    projectName: string;
    sortNo: number;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isActive: boolean;
    status: string;

    constructor(data?: IGetListAllPromoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promoId = data["promoId"];
            this.promoFileWeb = data["promoFileWeb"];
            this.promoFileApp = data["promoFileApp"];
            this.targetURL = data["targetURL"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.sortNo = data["sortNo"];
            this.periodStart = data["periodStart"] ? moment(data["periodStart"].toString()) : <any>undefined;
            this.periodEnd = data["periodEnd"] ? moment(data["periodEnd"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetListAllPromoResultDto {
        let result = new GetListAllPromoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoId"] = this.promoId;
        data["promoFileWeb"] = this.promoFileWeb;
        data["promoFileApp"] = this.promoFileApp;
        data["targetURL"] = this.targetURL;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["sortNo"] = this.sortNo;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : <any>undefined;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetListAllPromoResultDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    targetURL: string;
    projectID: number;
    projectName: string;
    sortNo: number;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isActive: boolean;
    status: string;
}

export class CreatePromoInputDto implements ICreatePromoInputDto {
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    sortNo: number;
    periodStart: string;
    periodEnd: string;
    isActive: boolean;

    constructor(data?: ICreatePromoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promoFileWeb = data["promoFileWeb"];
            this.promoFileApp = data["promoFileApp"];
            this.promoDataType = data["promoDataType"];
            this.targetURL = data["targetURL"];
            this.projectID = data["projectID"];
            this.sortNo = data["sortNo"];
            this.periodStart = data["periodStart"];
            this.periodEnd = data["periodEnd"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreatePromoInputDto {
        let result = new CreatePromoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoFileWeb"] = this.promoFileWeb;
        data["promoFileApp"] = this.promoFileApp;
        data["promoDataType"] = this.promoDataType;
        data["targetURL"] = this.targetURL;
        data["projectID"] = this.projectID;
        data["sortNo"] = this.sortNo;
        data["periodStart"] = this.periodStart;
        data["periodEnd"] = this.periodEnd;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreatePromoInputDto {
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    sortNo: number;
    periodStart: string;
    periodEnd: string;
    isActive: boolean;
}

export class GetDetailPromoResultDto implements IGetDetailPromoResultDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    projectName: string;
    sortNo: number;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isActive: boolean;

    constructor(data?: IGetDetailPromoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promoId = data["promoId"];
            this.promoFileWeb = data["promoFileWeb"];
            this.promoFileApp = data["promoFileApp"];
            this.promoDataType = data["promoDataType"];
            this.targetURL = data["targetURL"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.sortNo = data["sortNo"];
            this.periodStart = data["periodStart"] ? moment(data["periodStart"].toString()) : <any>undefined;
            this.periodEnd = data["periodEnd"] ? moment(data["periodEnd"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetDetailPromoResultDto {
        let result = new GetDetailPromoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoId"] = this.promoId;
        data["promoFileWeb"] = this.promoFileWeb;
        data["promoFileApp"] = this.promoFileApp;
        data["promoDataType"] = this.promoDataType;
        data["targetURL"] = this.targetURL;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["sortNo"] = this.sortNo;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : <any>undefined;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetDetailPromoResultDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    projectName: string;
    sortNo: number;
    periodStart: moment.Moment;
    periodEnd: moment.Moment;
    isActive: boolean;
}

export class UpdatePromoInputDto implements IUpdatePromoInputDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    sortNo: number;
    periodStart: string;
    periodEnd: string;
    isActive: boolean;
    imageStatusFileWeb: string;
    imageStatusFileApp: string;

    constructor(data?: IUpdatePromoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promoId = data["promoId"];
            this.promoFileWeb = data["promoFileWeb"];
            this.promoFileApp = data["promoFileApp"];
            this.promoDataType = data["promoDataType"];
            this.targetURL = data["targetURL"];
            this.projectID = data["projectID"];
            this.sortNo = data["sortNo"];
            this.periodStart = data["periodStart"];
            this.periodEnd = data["periodEnd"];
            this.isActive = data["isActive"];
            this.imageStatusFileWeb = data["imageStatusFileWeb"];
            this.imageStatusFileApp = data["imageStatusFileApp"];
        }
    }

    static fromJS(data: any): UpdatePromoInputDto {
        let result = new UpdatePromoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoId"] = this.promoId;
        data["promoFileWeb"] = this.promoFileWeb;
        data["promoFileApp"] = this.promoFileApp;
        data["promoDataType"] = this.promoDataType;
        data["targetURL"] = this.targetURL;
        data["projectID"] = this.projectID;
        data["sortNo"] = this.sortNo;
        data["periodStart"] = this.periodStart;
        data["periodEnd"] = this.periodEnd;
        data["isActive"] = this.isActive;
        data["imageStatusFileWeb"] = this.imageStatusFileWeb;
        data["imageStatusFileApp"] = this.imageStatusFileApp;
        return data; 
    }
}

export interface IUpdatePromoInputDto {
    promoId: number;
    promoFileWeb: string;
    promoFileApp: string;
    promoDataType: string;
    targetURL: string;
    projectID: number;
    sortNo: number;
    periodStart: string;
    periodEnd: string;
    isActive: boolean;
    imageStatusFileWeb: string;
    imageStatusFileApp: string;
}

export class DropdownAplicationApprovalDto implements IDropdownAplicationApprovalDto {
    applicationID: number;
    applicationName: string;

    constructor(data?: IDropdownAplicationApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationID = data["applicationID"];
            this.applicationName = data["applicationName"];
        }
    }

    static fromJS(data: any): DropdownAplicationApprovalDto {
        let result = new DropdownAplicationApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationID"] = this.applicationID;
        data["applicationName"] = this.applicationName;
        return data; 
    }
}

export interface IDropdownAplicationApprovalDto {
    applicationID: number;
    applicationName: string;
}

export class TasklistApprovalFilterDto implements ITasklistApprovalFilterDto {
    applicationID: number;
    projectID: number;
    searchFilter: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: ITasklistApprovalFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationID = data["applicationID"];
            this.projectID = data["projectID"];
            this.searchFilter = data["searchFilter"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): TasklistApprovalFilterDto {
        let result = new TasklistApprovalFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationID"] = this.applicationID;
        data["projectID"] = this.projectID;
        data["searchFilter"] = this.searchFilter;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface ITasklistApprovalFilterDto {
    applicationID: number;
    projectID: number;
    searchFilter: string;
    skipCount: number;
    maxResultCount: number;
}

export class TasklistApprovalResultDto implements ITasklistApprovalResultDto {
    totalData: number;
    data: TasklistApprovalDataDto[];

    constructor(data?: ITasklistApprovalResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalData = data["totalData"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(TasklistApprovalDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TasklistApprovalResultDto {
        let result = new TasklistApprovalResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalData"] = this.totalData;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITasklistApprovalResultDto {
    totalData: number;
    data: TasklistApprovalDataDto[];
}

export class TasklistApprovalDataDto implements ITasklistApprovalDataDto {
    approvalID: number;
    applicationName: string;
    requestorName: string;
    bookcode: string;
    unit: string;
    customerName: string;
    status: string;
    creationTime: moment.Moment;
    isFirstApproval: boolean;
    canApprove: boolean;
    category: string;

    constructor(data?: ITasklistApprovalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approvalID = data["approvalID"];
            this.applicationName = data["applicationName"];
            this.requestorName = data["requestorName"];
            this.bookcode = data["bookcode"];
            this.unit = data["unit"];
            this.customerName = data["customerName"];
            this.status = data["status"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.isFirstApproval = data["isFirstApproval"];
            this.canApprove = data["canApprove"];
            this.category = data["category"];
        }
    }

    static fromJS(data: any): TasklistApprovalDataDto {
        let result = new TasklistApprovalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalID"] = this.approvalID;
        data["applicationName"] = this.applicationName;
        data["requestorName"] = this.requestorName;
        data["bookcode"] = this.bookcode;
        data["unit"] = this.unit;
        data["customerName"] = this.customerName;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isFirstApproval"] = this.isFirstApproval;
        data["canApprove"] = this.canApprove;
        data["category"] = this.category;
        return data; 
    }
}

export interface ITasklistApprovalDataDto {
    approvalID: number;
    applicationName: string;
    requestorName: string;
    bookcode: string;
    unit: string;
    customerName: string;
    status: string;
    creationTime: moment.Moment;
    isFirstApproval: boolean;
    canApprove: boolean;
    category: string;
}

export class DetailApprovalMainDataDto implements IDetailApprovalMainDataDto {
    approvalID: number;
    customerName: string;
    statusName: string;
    applicationName: string;
    unitCode: string;
    unitNo: string;
    bookcode: string;
    hargaPengajuan: number;
    canEdit: boolean;
    isRequest: boolean;
    projectID: number;
    listCommercialPrice: DetailDrmsCommercialPrice[];
    listHistory: DetailApprovalHistoryDto[];

    constructor(data?: IDetailApprovalMainDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approvalID = data["approvalID"];
            this.customerName = data["customerName"];
            this.statusName = data["statusName"];
            this.applicationName = data["applicationName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookcode = data["bookcode"];
            this.hargaPengajuan = data["hargaPengajuan"];
            this.canEdit = data["canEdit"];
            this.isRequest = data["isRequest"];
            this.projectID = data["projectID"];
            if (data["listCommercialPrice"] && data["listCommercialPrice"].constructor === Array) {
                this.listCommercialPrice = [];
                for (let item of data["listCommercialPrice"])
                    this.listCommercialPrice.push(DetailDrmsCommercialPrice.fromJS(item));
            }
            if (data["listHistory"] && data["listHistory"].constructor === Array) {
                this.listHistory = [];
                for (let item of data["listHistory"])
                    this.listHistory.push(DetailApprovalHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailApprovalMainDataDto {
        let result = new DetailApprovalMainDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalID"] = this.approvalID;
        data["customerName"] = this.customerName;
        data["statusName"] = this.statusName;
        data["applicationName"] = this.applicationName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookcode"] = this.bookcode;
        data["hargaPengajuan"] = this.hargaPengajuan;
        data["canEdit"] = this.canEdit;
        data["isRequest"] = this.isRequest;
        data["projectID"] = this.projectID;
        if (this.listCommercialPrice && this.listCommercialPrice.constructor === Array) {
            data["listCommercialPrice"] = [];
            for (let item of this.listCommercialPrice)
                data["listCommercialPrice"].push(item.toJSON());
        }
        if (this.listHistory && this.listHistory.constructor === Array) {
            data["listHistory"] = [];
            for (let item of this.listHistory)
                data["listHistory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDetailApprovalMainDataDto {
    approvalID: number;
    customerName: string;
    statusName: string;
    applicationName: string;
    unitCode: string;
    unitNo: string;
    bookcode: string;
    hargaPengajuan: number;
    canEdit: boolean;
    isRequest: boolean;
    projectID: number;
    listCommercialPrice: DetailDrmsCommercialPrice[];
    listHistory: DetailApprovalHistoryDto[];
}

export class DetailDrmsCommercialPrice implements IDetailDrmsCommercialPrice {
    termID: number;
    termRemarks: string;
    landPrice: number;
    buildPrice: number;
    renovPrice: number;

    constructor(data?: IDetailDrmsCommercialPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termRemarks = data["termRemarks"];
            this.landPrice = data["landPrice"];
            this.buildPrice = data["buildPrice"];
            this.renovPrice = data["renovPrice"];
        }
    }

    static fromJS(data: any): DetailDrmsCommercialPrice {
        let result = new DetailDrmsCommercialPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termRemarks"] = this.termRemarks;
        data["landPrice"] = this.landPrice;
        data["buildPrice"] = this.buildPrice;
        data["renovPrice"] = this.renovPrice;
        return data; 
    }
}

export interface IDetailDrmsCommercialPrice {
    termID: number;
    termRemarks: string;
    landPrice: number;
    buildPrice: number;
    renovPrice: number;
}

export class DetailApprovalHistoryDto implements IDetailApprovalHistoryDto {
    creationTime: moment.Moment;
    name: string;
    actionUser: string;
    remarks: string;

    constructor(data?: IDetailApprovalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.actionUser = data["actionUser"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): DetailApprovalHistoryDto {
        let result = new DetailApprovalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["actionUser"] = this.actionUser;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IDetailApprovalHistoryDto {
    creationTime: moment.Moment;
    name: string;
    actionUser: string;
    remarks: string;
}

export class DetailDocumentResultDto implements IDetailDocumentResultDto {
    listDocument: DocumentDrmsDto[];
    listIdNumber: IdDrmsDto[];

    constructor(data?: IDetailDocumentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listDocument"] && data["listDocument"].constructor === Array) {
                this.listDocument = [];
                for (let item of data["listDocument"])
                    this.listDocument.push(DocumentDrmsDto.fromJS(item));
            }
            if (data["listIdNumber"] && data["listIdNumber"].constructor === Array) {
                this.listIdNumber = [];
                for (let item of data["listIdNumber"])
                    this.listIdNumber.push(IdDrmsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailDocumentResultDto {
        let result = new DetailDocumentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listDocument && this.listDocument.constructor === Array) {
            data["listDocument"] = [];
            for (let item of this.listDocument)
                data["listDocument"].push(item.toJSON());
        }
        if (this.listIdNumber && this.listIdNumber.constructor === Array) {
            data["listIdNumber"] = [];
            for (let item of this.listIdNumber)
                data["listIdNumber"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDetailDocumentResultDto {
    listDocument: DocumentDrmsDto[];
    listIdNumber: IdDrmsDto[];
}

export class DocumentDrmsDto implements IDocumentDrmsDto {
    documentType: string;
    documentPicType: string;
    documentBase64: string;

    constructor(data?: IDocumentDrmsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentPicType = data["documentPicType"];
            this.documentBase64 = data["documentBase64"];
        }
    }

    static fromJS(data: any): DocumentDrmsDto {
        let result = new DocumentDrmsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentPicType"] = this.documentPicType;
        data["documentBase64"] = this.documentBase64;
        return data; 
    }
}

export interface IDocumentDrmsDto {
    documentType: string;
    documentPicType: string;
    documentBase64: string;
}

export class IdDrmsDto implements IIdDrmsDto {
    idType: string;
    idName: string;
    idNumber: string;

    constructor(data?: IIdDrmsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.idType = data["idType"];
            this.idName = data["idName"];
            this.idNumber = data["idNumber"];
        }
    }

    static fromJS(data: any): IdDrmsDto {
        let result = new IdDrmsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idType"] = this.idType;
        data["idName"] = this.idName;
        data["idNumber"] = this.idNumber;
        return data; 
    }
}

export interface IIdDrmsDto {
    idType: string;
    idName: string;
    idNumber: string;
}

export class ApprovalProsesDto implements IApprovalProsesDto {
    approvalID: number;
    remarks: string;
    isFirstApproval: boolean;
    listCommercialPrice: DetailDrmsCommercialPrice[];

    constructor(data?: IApprovalProsesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approvalID = data["approvalID"];
            this.remarks = data["remarks"];
            this.isFirstApproval = data["isFirstApproval"];
            if (data["listCommercialPrice"] && data["listCommercialPrice"].constructor === Array) {
                this.listCommercialPrice = [];
                for (let item of data["listCommercialPrice"])
                    this.listCommercialPrice.push(DetailDrmsCommercialPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalProsesDto {
        let result = new ApprovalProsesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalID"] = this.approvalID;
        data["remarks"] = this.remarks;
        data["isFirstApproval"] = this.isFirstApproval;
        if (this.listCommercialPrice && this.listCommercialPrice.constructor === Array) {
            data["listCommercialPrice"] = [];
            for (let item of this.listCommercialPrice)
                data["listCommercialPrice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApprovalProsesDto {
    approvalID: number;
    remarks: string;
    isFirstApproval: boolean;
    listCommercialPrice: DetailDrmsCommercialPrice[];
}

export class RequestUnitDrmsInputDto implements IRequestUnitDrmsInputDto {
    psCode: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    price: number;
    isPengajuan: boolean;
    remarks: string;
    listDocument: UploadDocDrmsInputDto[];

    constructor(data?: IRequestUnitDrmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.price = data["price"];
            this.isPengajuan = data["isPengajuan"];
            this.remarks = data["remarks"];
            if (data["listDocument"] && data["listDocument"].constructor === Array) {
                this.listDocument = [];
                for (let item of data["listDocument"])
                    this.listDocument.push(UploadDocDrmsInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestUnitDrmsInputDto {
        let result = new RequestUnitDrmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["price"] = this.price;
        data["isPengajuan"] = this.isPengajuan;
        data["remarks"] = this.remarks;
        if (this.listDocument && this.listDocument.constructor === Array) {
            data["listDocument"] = [];
            for (let item of this.listDocument)
                data["listDocument"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRequestUnitDrmsInputDto {
    psCode: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    price: number;
    isPengajuan: boolean;
    remarks: string;
    listDocument: UploadDocDrmsInputDto[];
}

export class UploadDocDrmsInputDto implements IUploadDocDrmsInputDto {
    psCode: string;
    documentType: string;
    documentPicType: string;
    documentFile: string;

    constructor(data?: IUploadDocDrmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.documentType = data["documentType"];
            this.documentPicType = data["documentPicType"];
            this.documentFile = data["documentFile"];
        }
    }

    static fromJS(data: any): UploadDocDrmsInputDto {
        let result = new UploadDocDrmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["documentType"] = this.documentType;
        data["documentPicType"] = this.documentPicType;
        data["documentFile"] = this.documentFile;
        return data; 
    }
}

export interface IUploadDocDrmsInputDto {
    psCode: string;
    documentType: string;
    documentPicType: string;
    documentFile: string;
}

export class DrmsResultDto implements IDrmsResultDto {
    code: number;
    message: string;
    unitExist: boolean;

    constructor(data?: IDrmsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.unitExist = data["unitExist"];
        }
    }

    static fromJS(data: any): DrmsResultDto {
        let result = new DrmsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["unitExist"] = this.unitExist;
        return data; 
    }
}

export interface IDrmsResultDto {
    code: number;
    message: string;
    unitExist: boolean;
}

export class DRMSStatusByBookcodeInputDto implements IDRMSStatusByBookcodeInputDto {
    bookCode: string;

    constructor(data?: IDRMSStatusByBookcodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): DRMSStatusByBookcodeInputDto {
        let result = new DRMSStatusByBookcodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IDRMSStatusByBookcodeInputDto {
    bookCode: string;
}

export class DetailStatusDRMSByBookcodeDto implements IDetailStatusDRMSByBookcodeDto {
    code: number;
    message: string;
    data: DRMSStatusByBookcodeDataDto;

    constructor(data?: IDetailStatusDRMSByBookcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.data = data["data"] ? DRMSStatusByBookcodeDataDto.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DetailStatusDRMSByBookcodeDto {
        let result = new DetailStatusDRMSByBookcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDetailStatusDRMSByBookcodeDto {
    code: number;
    message: string;
    data: DRMSStatusByBookcodeDataDto;
}

export class DRMSStatusByBookcodeDataDto implements IDRMSStatusByBookcodeDataDto {
    bookCode: string;
    psCode: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    unitStatusID: number;

    constructor(data?: IDRMSStatusByBookcodeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatusID = data["unitStatusID"];
        }
    }

    static fromJS(data: any): DRMSStatusByBookcodeDataDto {
        let result = new DRMSStatusByBookcodeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatusID"] = this.unitStatusID;
        return data; 
    }
}

export interface IDRMSStatusByBookcodeDataDto {
    bookCode: string;
    psCode: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    unitStatusID: number;
}

export class DRMSStatusApprovalInputDto implements IDRMSStatusApprovalInputDto {
    bookCode: string;

    constructor(data?: IDRMSStatusApprovalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): DRMSStatusApprovalInputDto {
        let result = new DRMSStatusApprovalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IDRMSStatusApprovalInputDto {
    bookCode: string;
}

export class WrapDRMSStatusApprovalDto implements IWrapDRMSStatusApprovalDto {
    code: number;
    message: string;
    data: DRMSStatusBookingDataDto;

    constructor(data?: IWrapDRMSStatusApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.data = data["data"] ? DRMSStatusBookingDataDto.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WrapDRMSStatusApprovalDto {
        let result = new WrapDRMSStatusApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWrapDRMSStatusApprovalDto {
    code: number;
    message: string;
    data: DRMSStatusBookingDataDto;
}

export class DRMSStatusBookingDataDto implements IDRMSStatusBookingDataDto {
    bookCode: string;
    psCode: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    unitStatus: string;
    approvalRequest: DRMSStatusApprovalHeaderDto[];

    constructor(data?: IDRMSStatusBookingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatus = data["unitStatus"];
            if (data["approvalRequest"] && data["approvalRequest"].constructor === Array) {
                this.approvalRequest = [];
                for (let item of data["approvalRequest"])
                    this.approvalRequest.push(DRMSStatusApprovalHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DRMSStatusBookingDataDto {
        let result = new DRMSStatusBookingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatus"] = this.unitStatus;
        if (this.approvalRequest && this.approvalRequest.constructor === Array) {
            data["approvalRequest"] = [];
            for (let item of this.approvalRequest)
                data["approvalRequest"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDRMSStatusBookingDataDto {
    bookCode: string;
    psCode: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    unitStatus: string;
    approvalRequest: DRMSStatusApprovalHeaderDto[];
}

export class DRMSStatusApprovalHeaderDto implements IDRMSStatusApprovalHeaderDto {
    approvalID: number;
    requestorName: string;
    isRequest: boolean;
    requestType: string;
    approvalStatus: string;
    requestTime: moment.Moment;
    historyApproval: DRMSStatusApprovalHistoryDto[];

    constructor(data?: IDRMSStatusApprovalHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approvalID = data["approvalID"];
            this.requestorName = data["requestorName"];
            this.isRequest = data["isRequest"];
            this.requestType = data["requestType"];
            this.approvalStatus = data["approvalStatus"];
            this.requestTime = data["requestTime"] ? moment(data["requestTime"].toString()) : <any>undefined;
            if (data["historyApproval"] && data["historyApproval"].constructor === Array) {
                this.historyApproval = [];
                for (let item of data["historyApproval"])
                    this.historyApproval.push(DRMSStatusApprovalHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DRMSStatusApprovalHeaderDto {
        let result = new DRMSStatusApprovalHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalID"] = this.approvalID;
        data["requestorName"] = this.requestorName;
        data["isRequest"] = this.isRequest;
        data["requestType"] = this.requestType;
        data["approvalStatus"] = this.approvalStatus;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        if (this.historyApproval && this.historyApproval.constructor === Array) {
            data["historyApproval"] = [];
            for (let item of this.historyApproval)
                data["historyApproval"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDRMSStatusApprovalHeaderDto {
    approvalID: number;
    requestorName: string;
    isRequest: boolean;
    requestType: string;
    approvalStatus: string;
    requestTime: moment.Moment;
    historyApproval: DRMSStatusApprovalHistoryDto[];
}

export class DRMSStatusApprovalHistoryDto implements IDRMSStatusApprovalHistoryDto {
    actionTime: moment.Moment;
    actionUser: string;
    actionRemark: string;
    sequenceApproval: number;
    approvalStatusHistory: string;

    constructor(data?: IDRMSStatusApprovalHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionTime = data["actionTime"] ? moment(data["actionTime"].toString()) : <any>undefined;
            this.actionUser = data["actionUser"];
            this.actionRemark = data["actionRemark"];
            this.sequenceApproval = data["sequenceApproval"];
            this.approvalStatusHistory = data["approvalStatusHistory"];
        }
    }

    static fromJS(data: any): DRMSStatusApprovalHistoryDto {
        let result = new DRMSStatusApprovalHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["actionUser"] = this.actionUser;
        data["actionRemark"] = this.actionRemark;
        data["sequenceApproval"] = this.sequenceApproval;
        data["approvalStatusHistory"] = this.approvalStatusHistory;
        return data; 
    }
}

export interface IDRMSStatusApprovalHistoryDto {
    actionTime: moment.Moment;
    actionUser: string;
    actionRemark: string;
    sequenceApproval: number;
    approvalStatusHistory: string;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];
}

export class AuditLogListDto implements IAuditLogListDto {
    userId: number;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class GetDataCheckUploadAutoDebetInputDto implements IGetDataCheckUploadAutoDebetInputDto {
    entityID: number;
    accNo: string;
    bookCode: string;
    uniqueNo: string;

    constructor(data?: IGetDataCheckUploadAutoDebetInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.accNo = data["accNo"];
            this.bookCode = data["bookCode"];
            this.uniqueNo = data["uniqueNo"];
        }
    }

    static fromJS(data: any): GetDataCheckUploadAutoDebetInputDto {
        let result = new GetDataCheckUploadAutoDebetInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["accNo"] = this.accNo;
        data["bookCode"] = this.bookCode;
        data["uniqueNo"] = this.uniqueNo;
        return data; 
    }
}

export interface IGetDataCheckUploadAutoDebetInputDto {
    entityID: number;
    accNo: string;
    bookCode: string;
    uniqueNo: string;
}

export class GetDataCheckUploadAutoDebetListDto implements IGetDataCheckUploadAutoDebetListDto {
    accID: number;
    accNo: string;
    bookingHeaderID: number;
    bookCode: string;
    uniqueNo: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    bankName: string;
    dataSchedule: GetDataSchedule[];

    constructor(data?: IGetDataCheckUploadAutoDebetListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.accNo = data["accNo"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.uniqueNo = data["uniqueNo"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.address = data["address"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitID = data["unitID"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeCode = data["othersTypeCode"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.pctTax = data["pctTax"];
            this.message = data["message"];
            this.bankName = data["bankName"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(GetDataSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataCheckUploadAutoDebetListDto {
        let result = new GetDataCheckUploadAutoDebetListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["accNo"] = this.accNo;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["uniqueNo"] = this.uniqueNo;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["address"] = this.address;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitID"] = this.unitID;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeCode"] = this.othersTypeCode;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["pctTax"] = this.pctTax;
        data["message"] = this.message;
        data["bankName"] = this.bankName;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataCheckUploadAutoDebetListDto {
    accID: number;
    accNo: string;
    bookingHeaderID: number;
    bookCode: string;
    uniqueNo: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    bankName: string;
    dataSchedule: GetDataSchedule[];
}

export class GetDataSchedule implements IGetDataSchedule {
    schedNo: number;
    allocID: number;
    allocDesc: string;
    amount: number;
    dueDate: moment.Moment;

    constructor(data?: IGetDataSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schedNo = data["schedNo"];
            this.allocID = data["allocID"];
            this.allocDesc = data["allocDesc"];
            this.amount = data["amount"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataSchedule {
        let result = new GetDataSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schedNo"] = this.schedNo;
        data["allocID"] = this.allocID;
        data["allocDesc"] = this.allocDesc;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDataSchedule {
    schedNo: number;
    allocID: number;
    allocDesc: string;
    amount: number;
    dueDate: moment.Moment;
}

export class CreateUniversalAutoDebetInputDto implements ICreateUniversalAutoDebetInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    unitID: number;
    adbKey: string;
    custName: string;
    amount: number;
    curr: string;
    transDate: moment.Moment;
    accountNo: string;
    npwp: string;
    name: string;
    address: string;
    psCode: string;
    unitCode: string;
    unitNo: string;
    bankName: string;
    pctTax: number;
    amountOver: number;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];

    constructor(data?: ICreateUniversalAutoDebetInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.unitID = data["unitID"];
            this.adbKey = data["adbKey"];
            this.custName = data["custName"];
            this.amount = data["amount"];
            this.curr = data["curr"];
            this.transDate = data["transDate"] ? moment(data["transDate"].toString()) : <any>undefined;
            this.accountNo = data["accountNo"];
            this.npwp = data["npwp"];
            this.name = data["name"];
            this.address = data["address"];
            this.psCode = data["psCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bankName = data["bankName"];
            this.pctTax = data["pctTax"];
            this.amountOver = data["amountOver"];
            if (data["dataScheduleList"] && data["dataScheduleList"].constructor === Array) {
                this.dataScheduleList = [];
                for (let item of data["dataScheduleList"])
                    this.dataScheduleList.push(DataAlloc.fromJS(item));
            }
            if (data["dataForPayment"] && data["dataForPayment"].constructor === Array) {
                this.dataForPayment = [];
                for (let item of data["dataForPayment"])
                    this.dataForPayment.push(DataPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalAutoDebetInputDto {
        let result = new CreateUniversalAutoDebetInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["unitID"] = this.unitID;
        data["adbKey"] = this.adbKey;
        data["custName"] = this.custName;
        data["amount"] = this.amount;
        data["curr"] = this.curr;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["accountNo"] = this.accountNo;
        data["npwp"] = this.npwp;
        data["name"] = this.name;
        data["address"] = this.address;
        data["psCode"] = this.psCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bankName"] = this.bankName;
        data["pctTax"] = this.pctTax;
        data["amountOver"] = this.amountOver;
        if (this.dataScheduleList && this.dataScheduleList.constructor === Array) {
            data["dataScheduleList"] = [];
            for (let item of this.dataScheduleList)
                data["dataScheduleList"].push(item.toJSON());
        }
        if (this.dataForPayment && this.dataForPayment.constructor === Array) {
            data["dataForPayment"] = [];
            for (let item of this.dataForPayment)
                data["dataForPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalAutoDebetInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    unitID: number;
    adbKey: string;
    custName: string;
    amount: number;
    curr: string;
    transDate: moment.Moment;
    accountNo: string;
    npwp: string;
    name: string;
    address: string;
    psCode: string;
    unitCode: string;
    unitNo: string;
    bankName: string;
    pctTax: number;
    amountOver: number;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];
}

export class DataAlloc implements IDataAlloc {
    allocID: number;
    schedNo: number;
    amount: number;
    amountPerSchedNo: number;
    amountBayar: number;

    constructor(data?: IDataAlloc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.schedNo = data["schedNo"];
            this.amount = data["amount"];
            this.amountPerSchedNo = data["amountPerSchedNo"];
            this.amountBayar = data["amountBayar"];
        }
    }

    static fromJS(data: any): DataAlloc {
        let result = new DataAlloc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["schedNo"] = this.schedNo;
        data["amount"] = this.amount;
        data["amountPerSchedNo"] = this.amountPerSchedNo;
        data["amountBayar"] = this.amountBayar;
        return data; 
    }
}

export interface IDataAlloc {
    allocID: number;
    schedNo: number;
    amount: number;
    amountPerSchedNo: number;
    amountBayar: number;
}

export class DataPayment implements IDataPayment {
    amount: number;
    payTypeID: number;
    othersTypeID: number;
    othersTypeCode: string;
    dataAllocList: DataAlloc[];

    constructor(data?: IDataPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.othersTypeCode = data["othersTypeCode"];
            if (data["dataAllocList"] && data["dataAllocList"].constructor === Array) {
                this.dataAllocList = [];
                for (let item of data["dataAllocList"])
                    this.dataAllocList.push(DataAlloc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataPayment {
        let result = new DataPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["othersTypeCode"] = this.othersTypeCode;
        if (this.dataAllocList && this.dataAllocList.constructor === Array) {
            data["dataAllocList"] = [];
            for (let item of this.dataAllocList)
                data["dataAllocList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDataPayment {
    amount: number;
    payTypeID: number;
    othersTypeID: number;
    othersTypeCode: string;
    dataAllocList: DataAlloc[];
}

export class GetCheckBoxDisplayedFieldResultDto implements IGetCheckBoxDisplayedFieldResultDto {
    displayedID: number;
    displayedName: string;
    displayDto: string;
    displayDefault: string;

    constructor(data?: IGetCheckBoxDisplayedFieldResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayedID = data["displayedID"];
            this.displayedName = data["displayedName"];
            this.displayDto = data["displayDto"];
            this.displayDefault = data["displayDefault"];
        }
    }

    static fromJS(data: any): GetCheckBoxDisplayedFieldResultDto {
        let result = new GetCheckBoxDisplayedFieldResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayedID"] = this.displayedID;
        data["displayedName"] = this.displayedName;
        data["displayDto"] = this.displayDto;
        data["displayDefault"] = this.displayDefault;
        return data; 
    }
}

export interface IGetCheckBoxDisplayedFieldResultDto {
    displayedID: number;
    displayedName: string;
    displayDto: string;
    displayDefault: string;
}

export class GetListAllocResultDto implements IGetListAllocResultDto {
    id: number;
    payForCode: string;

    constructor(data?: IGetListAllocResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payForCode = data["payForCode"];
        }
    }

    static fromJS(data: any): GetListAllocResultDto {
        let result = new GetListAllocResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payForCode"] = this.payForCode;
        return data; 
    }
}

export interface IGetListAllocResultDto {
    id: number;
    payForCode: string;
}

export class GetListPayTypeResultDto implements IGetListPayTypeResultDto {
    id: number;
    payTypeCode: string;
    isDefault: boolean;

    constructor(data?: IGetListPayTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payTypeCode = data["payTypeCode"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetListPayTypeResultDto {
        let result = new GetListPayTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payTypeCode"] = this.payTypeCode;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetListPayTypeResultDto {
    id: number;
    payTypeCode: string;
    isDefault: boolean;
}

export class GetListOthersTypeResultDto implements IGetListOthersTypeResultDto {
    id: number;
    othersTypeCode: string;
    isDefault: boolean;

    constructor(data?: IGetListOthersTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.othersTypeCode = data["othersTypeCode"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetListOthersTypeResultDto {
        let result = new GetListOthersTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["othersTypeCode"] = this.othersTypeCode;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetListOthersTypeResultDto {
    id: number;
    othersTypeCode: string;
    isDefault: boolean;
}

export class GetListAccountResultDto implements IGetListAccountResultDto {
    id: number;
    accCode: string;

    constructor(data?: IGetListAccountResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.accCode = data["accCode"];
        }
    }

    static fromJS(data: any): GetListAccountResultDto {
        let result = new GetListAccountResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accCode"] = this.accCode;
        return data; 
    }
}

export interface IGetListAccountResultDto {
    id: number;
    accCode: string;
}

export class GetBankReconcileReportPdfInputDto implements IGetBankReconcileReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataBankReconcileDto;

    constructor(data?: IGetBankReconcileReportPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataBankReconcileDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankReconcileReportPdfInputDto {
        let result = new GetBankReconcileReportPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBankReconcileReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataBankReconcileDto;
}

export class ListDataBankReconcileDto implements IListDataBankReconcileDto {
    listHeader: GetCheckBoxDisplayedFieldResultDto[];
    listBody: GetDataReportBankReconcileListDto[];
    paymentDate: string;
    clearDate: string;
    accounts: string;
    allocs: string;
    payTypes: string;
    othersTypes: string;
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    sumNetAmount: string;
    sumVatAmount: string;
    sumTotalAmount: string;
    printedBy: string;

    constructor(data?: IListDataBankReconcileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(GetCheckBoxDisplayedFieldResultDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(GetDataReportBankReconcileListDto.fromJS(item));
            }
            this.paymentDate = data["paymentDate"];
            this.clearDate = data["clearDate"];
            this.accounts = data["accounts"];
            this.allocs = data["allocs"];
            this.payTypes = data["payTypes"];
            this.othersTypes = data["othersTypes"];
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.colspanTbl = data["colspanTbl"];
            this.sumNetAmount = data["sumNetAmount"];
            this.sumVatAmount = data["sumVatAmount"];
            this.sumTotalAmount = data["sumTotalAmount"];
            this.printedBy = data["printedBy"];
        }
    }

    static fromJS(data: any): ListDataBankReconcileDto {
        let result = new ListDataBankReconcileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["paymentDate"] = this.paymentDate;
        data["clearDate"] = this.clearDate;
        data["accounts"] = this.accounts;
        data["allocs"] = this.allocs;
        data["payTypes"] = this.payTypes;
        data["othersTypes"] = this.othersTypes;
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["colspanTbl"] = this.colspanTbl;
        data["sumNetAmount"] = this.sumNetAmount;
        data["sumVatAmount"] = this.sumVatAmount;
        data["sumTotalAmount"] = this.sumTotalAmount;
        data["printedBy"] = this.printedBy;
        return data; 
    }
}

export interface IListDataBankReconcileDto {
    listHeader: GetCheckBoxDisplayedFieldResultDto[];
    listBody: GetDataReportBankReconcileListDto[];
    paymentDate: string;
    clearDate: string;
    accounts: string;
    allocs: string;
    payTypes: string;
    othersTypes: string;
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    sumNetAmount: string;
    sumVatAmount: string;
    sumTotalAmount: string;
    printedBy: string;
}

export class GetDataReportBankReconcileListDto implements IGetDataReportBankReconcileListDto {
    transNo: string;
    paymentDate: moment.Moment;
    paymentDateFormat: string;
    clearDate: moment.Moment;
    clearDateFormat: string;
    unitCode: string;
    unitNo: string;
    psName: string;
    payForCode: string;
    payTypeCode: string;
    detailRemarks: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    accCode: string;
    bookCode: string;
    netNetPrice: number;
    combineCode: string;
    headerRemarks: string;
    payNo: number;
    bankName: string;
    chequeNo: string;
    status: string;
    dueDate: moment.Moment;
    dueDateFormat: string;
    bookDate: moment.Moment;
    bookDateFormat: string;
    psCode: string;
    scmCode: string;
    memberCode: string;
    memberName: string;
    areaName: string;
    clusterCode: string;
    clusterName: string;
    projectName: string;
    categoryName: string;
    productName: string;
    detailName: string;
    unitName: string;
    memberShipType: string;
    npwp: string;
    allocationCode: string;
    allocationName: string;
    entityID: number;
    coName: string;
    devNPWP: string;
    devPKP: string;
    devPKPDate: moment.Moment;
    devPKPDateFormat: string;
    controlNo: string;
    coCode: string;
    corressAddress: string;
    corresCity: string;
    corresPostCode: string;
    nup: string;
    fpCode: string;

    constructor(data?: IGetDataReportBankReconcileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transNo = data["transNo"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentDateFormat = data["paymentDateFormat"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.clearDateFormat = data["clearDateFormat"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psName = data["psName"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.detailRemarks = data["detailRemarks"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.totalAmount = data["totalAmount"];
            this.accCode = data["accCode"];
            this.bookCode = data["bookCode"];
            this.netNetPrice = data["netNetPrice"];
            this.combineCode = data["combineCode"];
            this.headerRemarks = data["headerRemarks"];
            this.payNo = data["payNo"];
            this.bankName = data["bankName"];
            this.chequeNo = data["chequeNo"];
            this.status = data["status"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.dueDateFormat = data["dueDateFormat"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.bookDateFormat = data["bookDateFormat"];
            this.psCode = data["psCode"];
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.areaName = data["areaName"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.projectName = data["projectName"];
            this.categoryName = data["categoryName"];
            this.productName = data["productName"];
            this.detailName = data["detailName"];
            this.unitName = data["unitName"];
            this.memberShipType = data["memberShipType"];
            this.npwp = data["npwp"];
            this.allocationCode = data["allocationCode"];
            this.allocationName = data["allocationName"];
            this.entityID = data["entityID"];
            this.coName = data["coName"];
            this.devNPWP = data["devNPWP"];
            this.devPKP = data["devPKP"];
            this.devPKPDate = data["devPKPDate"] ? moment(data["devPKPDate"].toString()) : <any>undefined;
            this.devPKPDateFormat = data["devPKPDateFormat"];
            this.controlNo = data["controlNo"];
            this.coCode = data["coCode"];
            this.corressAddress = data["corressAddress"];
            this.corresCity = data["corresCity"];
            this.corresPostCode = data["corresPostCode"];
            this.nup = data["nup"];
            this.fpCode = data["fpCode"];
        }
    }

    static fromJS(data: any): GetDataReportBankReconcileListDto {
        let result = new GetDataReportBankReconcileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transNo"] = this.transNo;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentDateFormat"] = this.paymentDateFormat;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["clearDateFormat"] = this.clearDateFormat;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psName"] = this.psName;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["detailRemarks"] = this.detailRemarks;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["accCode"] = this.accCode;
        data["bookCode"] = this.bookCode;
        data["netNetPrice"] = this.netNetPrice;
        data["combineCode"] = this.combineCode;
        data["headerRemarks"] = this.headerRemarks;
        data["payNo"] = this.payNo;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueDateFormat"] = this.dueDateFormat;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["bookDateFormat"] = this.bookDateFormat;
        data["psCode"] = this.psCode;
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["areaName"] = this.areaName;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["projectName"] = this.projectName;
        data["categoryName"] = this.categoryName;
        data["productName"] = this.productName;
        data["detailName"] = this.detailName;
        data["unitName"] = this.unitName;
        data["memberShipType"] = this.memberShipType;
        data["npwp"] = this.npwp;
        data["allocationCode"] = this.allocationCode;
        data["allocationName"] = this.allocationName;
        data["entityID"] = this.entityID;
        data["coName"] = this.coName;
        data["devNPWP"] = this.devNPWP;
        data["devPKP"] = this.devPKP;
        data["devPKPDate"] = this.devPKPDate ? this.devPKPDate.toISOString() : <any>undefined;
        data["devPKPDateFormat"] = this.devPKPDateFormat;
        data["controlNo"] = this.controlNo;
        data["coCode"] = this.coCode;
        data["corressAddress"] = this.corressAddress;
        data["corresCity"] = this.corresCity;
        data["corresPostCode"] = this.corresPostCode;
        data["nup"] = this.nup;
        data["fpCode"] = this.fpCode;
        return data; 
    }
}

export interface IGetDataReportBankReconcileListDto {
    transNo: string;
    paymentDate: moment.Moment;
    paymentDateFormat: string;
    clearDate: moment.Moment;
    clearDateFormat: string;
    unitCode: string;
    unitNo: string;
    psName: string;
    payForCode: string;
    payTypeCode: string;
    detailRemarks: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    accCode: string;
    bookCode: string;
    netNetPrice: number;
    combineCode: string;
    headerRemarks: string;
    payNo: number;
    bankName: string;
    chequeNo: string;
    status: string;
    dueDate: moment.Moment;
    dueDateFormat: string;
    bookDate: moment.Moment;
    bookDateFormat: string;
    psCode: string;
    scmCode: string;
    memberCode: string;
    memberName: string;
    areaName: string;
    clusterCode: string;
    clusterName: string;
    projectName: string;
    categoryName: string;
    productName: string;
    detailName: string;
    unitName: string;
    memberShipType: string;
    npwp: string;
    allocationCode: string;
    allocationName: string;
    entityID: number;
    coName: string;
    devNPWP: string;
    devPKP: string;
    devPKPDate: moment.Moment;
    devPKPDateFormat: string;
    controlNo: string;
    coCode: string;
    corressAddress: string;
    corresCity: string;
    corresPostCode: string;
    nup: string;
    fpCode: string;
}

export class GetReportTypeListDto implements IGetReportTypeListDto {
    reportTypeID: number;
    reportType: string;
    reportName: string;
    isDefault: boolean;

    constructor(data?: IGetReportTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportTypeID = data["reportTypeID"];
            this.reportType = data["reportType"];
            this.reportName = data["reportName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetReportTypeListDto {
        let result = new GetReportTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTypeID"] = this.reportTypeID;
        data["reportType"] = this.reportType;
        data["reportName"] = this.reportName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetReportTypeListDto {
    reportTypeID: number;
    reportType: string;
    reportName: string;
    isDefault: boolean;
}

export class GetDataReportBankReconcileInputDto implements IGetDataReportBankReconcileInputDto {
    paymentDate1: moment.Moment;
    paymentDate2: moment.Moment;
    clearDate1: moment.Moment;
    clearDate2: moment.Moment;
    accCodeList: string[];
    payTypeList: string[];
    othersTypeList: string[];
    allocList: string[];
    statusList: string[];

    constructor(data?: IGetDataReportBankReconcileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDate1 = data["paymentDate1"] ? moment(data["paymentDate1"].toString()) : <any>undefined;
            this.paymentDate2 = data["paymentDate2"] ? moment(data["paymentDate2"].toString()) : <any>undefined;
            this.clearDate1 = data["clearDate1"] ? moment(data["clearDate1"].toString()) : <any>undefined;
            this.clearDate2 = data["clearDate2"] ? moment(data["clearDate2"].toString()) : <any>undefined;
            if (data["accCodeList"] && data["accCodeList"].constructor === Array) {
                this.accCodeList = [];
                for (let item of data["accCodeList"])
                    this.accCodeList.push(item);
            }
            if (data["payTypeList"] && data["payTypeList"].constructor === Array) {
                this.payTypeList = [];
                for (let item of data["payTypeList"])
                    this.payTypeList.push(item);
            }
            if (data["othersTypeList"] && data["othersTypeList"].constructor === Array) {
                this.othersTypeList = [];
                for (let item of data["othersTypeList"])
                    this.othersTypeList.push(item);
            }
            if (data["allocList"] && data["allocList"].constructor === Array) {
                this.allocList = [];
                for (let item of data["allocList"])
                    this.allocList.push(item);
            }
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [];
                for (let item of data["statusList"])
                    this.statusList.push(item);
            }
        }
    }

    static fromJS(data: any): GetDataReportBankReconcileInputDto {
        let result = new GetDataReportBankReconcileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate1"] = this.paymentDate1 ? this.paymentDate1.toISOString() : <any>undefined;
        data["paymentDate2"] = this.paymentDate2 ? this.paymentDate2.toISOString() : <any>undefined;
        data["clearDate1"] = this.clearDate1 ? this.clearDate1.toISOString() : <any>undefined;
        data["clearDate2"] = this.clearDate2 ? this.clearDate2.toISOString() : <any>undefined;
        if (this.accCodeList && this.accCodeList.constructor === Array) {
            data["accCodeList"] = [];
            for (let item of this.accCodeList)
                data["accCodeList"].push(item);
        }
        if (this.payTypeList && this.payTypeList.constructor === Array) {
            data["payTypeList"] = [];
            for (let item of this.payTypeList)
                data["payTypeList"].push(item);
        }
        if (this.othersTypeList && this.othersTypeList.constructor === Array) {
            data["othersTypeList"] = [];
            for (let item of this.othersTypeList)
                data["othersTypeList"].push(item);
        }
        if (this.allocList && this.allocList.constructor === Array) {
            data["allocList"] = [];
            for (let item of this.allocList)
                data["allocList"].push(item);
        }
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface IGetDataReportBankReconcileInputDto {
    paymentDate1: moment.Moment;
    paymentDate2: moment.Moment;
    clearDate1: moment.Moment;
    clearDate2: moment.Moment;
    accCodeList: string[];
    payTypeList: string[];
    othersTypeList: string[];
    allocList: string[];
    statusList: string[];
}

export class DetailBookingHistoryResultDto implements IDetailBookingHistoryResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    idNo: string;
    address: string;
    orderDate: moment.Moment;
    projectImage: string;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: UnitResultDto[];
    arrPP: PPNResultDto[];
    username: string;
    message: string;

    constructor(data?: IDetailBookingHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.oldOrderCode = data["oldOrderCode"];
            this.payTypeID = data["payTypeID"];
            this.payType = data["payType"];
            this.membercode = data["membercode"];
            this.membername = data["membername"];
            this.pscode = data["pscode"];
            this.psname = data["psname"];
            this.custemail = data["custemail"];
            this.custphone = data["custphone"];
            this.scmcode = data["scmcode"];
            this.statusID = data["statusID"];
            this.status = data["status"];
            this.idNo = data["idNo"];
            this.address = data["address"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.projectImage = data["projectImage"];
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.sumberDanaID = data["sumberDanaID"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.totalAmount = data["totalAmount"];
            if (data["arrUnit"] && data["arrUnit"].constructor === Array) {
                this.arrUnit = [];
                for (let item of data["arrUnit"])
                    this.arrUnit.push(UnitResultDto.fromJS(item));
            }
            if (data["arrPP"] && data["arrPP"].constructor === Array) {
                this.arrPP = [];
                for (let item of data["arrPP"])
                    this.arrPP.push(PPNResultDto.fromJS(item));
            }
            this.username = data["username"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): DetailBookingHistoryResultDto {
        let result = new DetailBookingHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["oldOrderCode"] = this.oldOrderCode;
        data["payTypeID"] = this.payTypeID;
        data["payType"] = this.payType;
        data["membercode"] = this.membercode;
        data["membername"] = this.membername;
        data["pscode"] = this.pscode;
        data["psname"] = this.psname;
        data["custemail"] = this.custemail;
        data["custphone"] = this.custphone;
        data["scmcode"] = this.scmcode;
        data["statusID"] = this.statusID;
        data["status"] = this.status;
        data["idNo"] = this.idNo;
        data["address"] = this.address;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["projectImage"] = this.projectImage;
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["sumberDanaID"] = this.sumberDanaID;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["totalAmount"] = this.totalAmount;
        if (this.arrUnit && this.arrUnit.constructor === Array) {
            data["arrUnit"] = [];
            for (let item of this.arrUnit)
                data["arrUnit"].push(item.toJSON());
        }
        if (this.arrPP && this.arrPP.constructor === Array) {
            data["arrPP"] = [];
            for (let item of this.arrPP)
                data["arrPP"].push(item.toJSON());
        }
        data["username"] = this.username;
        data["message"] = this.message;
        return data; 
    }
}

export interface IDetailBookingHistoryResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    idNo: string;
    address: string;
    orderDate: moment.Moment;
    projectImage: string;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: UnitResultDto[];
    arrPP: PPNResultDto[];
    username: string;
    message: string;
}

export class UnitResultDto implements IUnitResultDto {
    unitcode: string;
    unitno: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    renovName: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    bfamount: number;
    remarks: string;
    disc1: number;
    disc2: number;
    projectID: number;
    urlKP: string;
    projectLogo: string;
    clusterName: string;
    bankID1: number;
    bankID2: number;
    ppno: string;

    constructor(data?: IUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitcode = data["unitcode"];
            this.unitno = data["unitno"];
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.renovcode = data["renovcode"];
            this.renovName = data["renovName"];
            this.termID = data["termID"];
            this.termno = data["termno"];
            this.termName = data["termName"];
            this.sellingprice = data["sellingprice"];
            this.bfamount = data["bfamount"];
            this.remarks = data["remarks"];
            this.disc1 = data["disc1"];
            this.disc2 = data["disc2"];
            this.projectID = data["projectID"];
            this.urlKP = data["urlKP"];
            this.projectLogo = data["projectLogo"];
            this.clusterName = data["clusterName"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppno = data["ppno"];
        }
    }

    static fromJS(data: any): UnitResultDto {
        let result = new UnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitcode"] = this.unitcode;
        data["unitno"] = this.unitno;
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["renovcode"] = this.renovcode;
        data["renovName"] = this.renovName;
        data["termID"] = this.termID;
        data["termno"] = this.termno;
        data["termName"] = this.termName;
        data["sellingprice"] = this.sellingprice;
        data["bfamount"] = this.bfamount;
        data["remarks"] = this.remarks;
        data["disc1"] = this.disc1;
        data["disc2"] = this.disc2;
        data["projectID"] = this.projectID;
        data["urlKP"] = this.urlKP;
        data["projectLogo"] = this.projectLogo;
        data["clusterName"] = this.clusterName;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppno"] = this.ppno;
        return data; 
    }
}

export interface IUnitResultDto {
    unitcode: string;
    unitno: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    renovName: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    bfamount: number;
    remarks: string;
    disc1: number;
    disc2: number;
    projectID: number;
    urlKP: string;
    projectLogo: string;
    clusterName: string;
    bankID1: number;
    bankID2: number;
    ppno: string;
}

export class PPNResultDto implements IPPNResultDto {
    ppNo: string;

    constructor(data?: IPPNResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): PPNResultDto {
        let result = new PPNResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IPPNResultDto {
    ppNo: string;
}

export class DetailBookingHistoryWebResultDto implements IDetailBookingHistoryWebResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    idNo: string;
    address: string;
    bankProgram: string[];
    marketingProgram: string[];
    location: string[];
    rewards: ListRewardsDto[];
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: ListUnitResultDto[];
    message: string;

    constructor(data?: IDetailBookingHistoryWebResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.oldOrderCode = data["oldOrderCode"];
            this.payTypeID = data["payTypeID"];
            this.payType = data["payType"];
            this.membercode = data["membercode"];
            this.membername = data["membername"];
            this.pscode = data["pscode"];
            this.psname = data["psname"];
            this.custemail = data["custemail"];
            this.custphone = data["custphone"];
            this.scmcode = data["scmcode"];
            this.statusID = data["statusID"];
            this.status = data["status"];
            this.idNo = data["idNo"];
            this.address = data["address"];
            if (data["bankProgram"] && data["bankProgram"].constructor === Array) {
                this.bankProgram = [];
                for (let item of data["bankProgram"])
                    this.bankProgram.push(item);
            }
            if (data["marketingProgram"] && data["marketingProgram"].constructor === Array) {
                this.marketingProgram = [];
                for (let item of data["marketingProgram"])
                    this.marketingProgram.push(item);
            }
            if (data["location"] && data["location"].constructor === Array) {
                this.location = [];
                for (let item of data["location"])
                    this.location.push(item);
            }
            if (data["rewards"] && data["rewards"].constructor === Array) {
                this.rewards = [];
                for (let item of data["rewards"])
                    this.rewards.push(ListRewardsDto.fromJS(item));
            }
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.sumberDanaID = data["sumberDanaID"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.totalAmount = data["totalAmount"];
            if (data["arrUnit"] && data["arrUnit"].constructor === Array) {
                this.arrUnit = [];
                for (let item of data["arrUnit"])
                    this.arrUnit.push(ListUnitResultDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): DetailBookingHistoryWebResultDto {
        let result = new DetailBookingHistoryWebResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["oldOrderCode"] = this.oldOrderCode;
        data["payTypeID"] = this.payTypeID;
        data["payType"] = this.payType;
        data["membercode"] = this.membercode;
        data["membername"] = this.membername;
        data["pscode"] = this.pscode;
        data["psname"] = this.psname;
        data["custemail"] = this.custemail;
        data["custphone"] = this.custphone;
        data["scmcode"] = this.scmcode;
        data["statusID"] = this.statusID;
        data["status"] = this.status;
        data["idNo"] = this.idNo;
        data["address"] = this.address;
        if (this.bankProgram && this.bankProgram.constructor === Array) {
            data["bankProgram"] = [];
            for (let item of this.bankProgram)
                data["bankProgram"].push(item);
        }
        if (this.marketingProgram && this.marketingProgram.constructor === Array) {
            data["marketingProgram"] = [];
            for (let item of this.marketingProgram)
                data["marketingProgram"].push(item);
        }
        if (this.location && this.location.constructor === Array) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        if (this.rewards && this.rewards.constructor === Array) {
            data["rewards"] = [];
            for (let item of this.rewards)
                data["rewards"].push(item.toJSON());
        }
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["sumberDanaID"] = this.sumberDanaID;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["totalAmount"] = this.totalAmount;
        if (this.arrUnit && this.arrUnit.constructor === Array) {
            data["arrUnit"] = [];
            for (let item of this.arrUnit)
                data["arrUnit"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IDetailBookingHistoryWebResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    idNo: string;
    address: string;
    bankProgram: string[];
    marketingProgram: string[];
    location: string[];
    rewards: ListRewardsDto[];
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: ListUnitResultDto[];
    message: string;
}

export class ListRewardsDto implements IListRewardsDto {
    rewardsID: number;
    rewardsName: string;

    constructor(data?: IListRewardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardsID = data["rewardsID"];
            this.rewardsName = data["rewardsName"];
        }
    }

    static fromJS(data: any): ListRewardsDto {
        let result = new ListRewardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardsID"] = this.rewardsID;
        data["rewardsName"] = this.rewardsName;
        return data; 
    }
}

export interface IListRewardsDto {
    rewardsID: number;
    rewardsName: string;
}

export class ListUnitResultDto implements IListUnitResultDto {
    unitcode: string;
    unitno: string;
    cluster: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    netNetPrice: number;
    bfamount: number;
    projectID: number;
    urlKP: string;
    bankID1: number;
    bankID2: number;
    ppno: string;
    projectCode: string;

    constructor(data?: IListUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitcode = data["unitcode"];
            this.unitno = data["unitno"];
            this.cluster = data["cluster"];
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.renovcode = data["renovcode"];
            this.termID = data["termID"];
            this.termno = data["termno"];
            this.termName = data["termName"];
            this.sellingprice = data["sellingprice"];
            this.netNetPrice = data["netNetPrice"];
            this.bfamount = data["bfamount"];
            this.projectID = data["projectID"];
            this.urlKP = data["urlKP"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppno = data["ppno"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): ListUnitResultDto {
        let result = new ListUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitcode"] = this.unitcode;
        data["unitno"] = this.unitno;
        data["cluster"] = this.cluster;
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["renovcode"] = this.renovcode;
        data["termID"] = this.termID;
        data["termno"] = this.termno;
        data["termName"] = this.termName;
        data["sellingprice"] = this.sellingprice;
        data["netNetPrice"] = this.netNetPrice;
        data["bfamount"] = this.bfamount;
        data["projectID"] = this.projectID;
        data["urlKP"] = this.urlKP;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppno"] = this.ppno;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IListUnitResultDto {
    unitcode: string;
    unitno: string;
    cluster: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    netNetPrice: number;
    bfamount: number;
    projectID: number;
    urlKP: string;
    bankID1: number;
    bankID2: number;
    ppno: string;
    projectCode: string;
}

export class GetPagingBookingHistoryInputDto implements IGetPagingBookingHistoryInputDto {
    memberCode: string;
    projectID: number[];
    keyword: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetPagingBookingHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.keyword = data["keyword"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPagingBookingHistoryInputDto {
        let result = new GetPagingBookingHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["keyword"] = this.keyword;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IGetPagingBookingHistoryInputDto {
    memberCode: string;
    projectID: number[];
    keyword: string;
    skipCount: number;
    maxResultCount: number;
}

export class PagedListBookingHistoryResultDto implements IPagedListBookingHistoryResultDto {
    totalData: number;
    listData: ListBookingHistoryResultDto[];

    constructor(data?: IPagedListBookingHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalData = data["totalData"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(ListBookingHistoryResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedListBookingHistoryResultDto {
        let result = new PagedListBookingHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalData"] = this.totalData;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedListBookingHistoryResultDto {
    totalData: number;
    listData: ListBookingHistoryResultDto[];
}

export class ListBookingHistoryResultDto implements IListBookingHistoryResultDto {
    statusID: number;
    orderID: number;
    orderCode: string;
    orderDate: moment.Moment;
    psName: string;
    status: string;
    unitCode: string;
    clusterName: string;
    unitNo: string;
    projectName: string;
    flagGateway: number;

    constructor(data?: IListBookingHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusID = data["statusID"];
            this.orderID = data["orderID"];
            this.orderCode = data["orderCode"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.psName = data["psName"];
            this.status = data["status"];
            this.unitCode = data["unitCode"];
            this.clusterName = data["clusterName"];
            this.unitNo = data["unitNo"];
            this.projectName = data["projectName"];
            this.flagGateway = data["flagGateway"];
        }
    }

    static fromJS(data: any): ListBookingHistoryResultDto {
        let result = new ListBookingHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusID"] = this.statusID;
        data["orderID"] = this.orderID;
        data["orderCode"] = this.orderCode;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["psName"] = this.psName;
        data["status"] = this.status;
        data["unitCode"] = this.unitCode;
        data["clusterName"] = this.clusterName;
        data["unitNo"] = this.unitNo;
        data["projectName"] = this.projectName;
        data["flagGateway"] = this.flagGateway;
        return data; 
    }
}

export interface IListBookingHistoryResultDto {
    statusID: number;
    orderID: number;
    orderCode: string;
    orderDate: moment.Moment;
    psName: string;
    status: string;
    unitCode: string;
    clusterName: string;
    unitNo: string;
    projectName: string;
    flagGateway: number;
}

export class GetListBookingHistoryInputDto implements IGetListBookingHistoryInputDto {
    memberCode: string;
    projectID: number[];
    keyword: string;

    constructor(data?: IGetListBookingHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.keyword = data["keyword"];
        }
    }

    static fromJS(data: any): GetListBookingHistoryInputDto {
        let result = new GetListBookingHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["keyword"] = this.keyword;
        return data; 
    }
}

export interface IGetListBookingHistoryInputDto {
    memberCode: string;
    projectID: number[];
    keyword: string;
}

export class ListResultDtoOfListBookingHistoryResultAppDto implements IListResultDtoOfListBookingHistoryResultAppDto {
    items: ListBookingHistoryResultAppDto[];

    constructor(data?: IListResultDtoOfListBookingHistoryResultAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListBookingHistoryResultAppDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListBookingHistoryResultAppDto {
        let result = new ListResultDtoOfListBookingHistoryResultAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListBookingHistoryResultAppDto {
    items: ListBookingHistoryResultAppDto[];
}

export class ListBookingHistoryResultAppDto implements IListBookingHistoryResultAppDto {
    month: number;
    year: number;
    monthString: string;
    bookingHistory: ListDataBooking[];

    constructor(data?: IListBookingHistoryResultAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.year = data["year"];
            this.monthString = data["monthString"];
            if (data["bookingHistory"] && data["bookingHistory"].constructor === Array) {
                this.bookingHistory = [];
                for (let item of data["bookingHistory"])
                    this.bookingHistory.push(ListDataBooking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListBookingHistoryResultAppDto {
        let result = new ListBookingHistoryResultAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["monthString"] = this.monthString;
        if (this.bookingHistory && this.bookingHistory.constructor === Array) {
            data["bookingHistory"] = [];
            for (let item of this.bookingHistory)
                data["bookingHistory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListBookingHistoryResultAppDto {
    month: number;
    year: number;
    monthString: string;
    bookingHistory: ListDataBooking[];
}

export class ListDataBooking implements IListDataBooking {
    statusID: number;
    orderID: number;
    orderCode: string;
    orderDate: moment.Moment;
    psName: string;
    status: string;
    projectName: string;
    projectLogo: string;

    constructor(data?: IListDataBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusID = data["statusID"];
            this.orderID = data["orderID"];
            this.orderCode = data["orderCode"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.psName = data["psName"];
            this.status = data["status"];
            this.projectName = data["projectName"];
            this.projectLogo = data["projectLogo"];
        }
    }

    static fromJS(data: any): ListDataBooking {
        let result = new ListDataBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusID"] = this.statusID;
        data["orderID"] = this.orderID;
        data["orderCode"] = this.orderCode;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["psName"] = this.psName;
        data["status"] = this.status;
        data["projectName"] = this.projectName;
        data["projectLogo"] = this.projectLogo;
        return data; 
    }
}

export interface IListDataBooking {
    statusID: number;
    orderID: number;
    orderCode: string;
    orderDate: moment.Moment;
    psName: string;
    status: string;
    projectName: string;
    projectLogo: string;
}

export class SearchingBookingHistoryInputDto implements ISearchingBookingHistoryInputDto {
    memberCode: string;
    filter: string;

    constructor(data?: ISearchingBookingHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): SearchingBookingHistoryInputDto {
        let result = new SearchingBookingHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface ISearchingBookingHistoryInputDto {
    memberCode: string;
    filter: string;
}

export class ListBookingHistoryNotarisResultDto implements IListBookingHistoryNotarisResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    orderDate: moment.Moment;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: UnitNotarisResultDto[];
    message: string;

    constructor(data?: IListBookingHistoryNotarisResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.oldOrderCode = data["oldOrderCode"];
            this.payTypeID = data["payTypeID"];
            this.payType = data["payType"];
            this.membercode = data["membercode"];
            this.membername = data["membername"];
            this.pscode = data["pscode"];
            this.psname = data["psname"];
            this.custemail = data["custemail"];
            this.custphone = data["custphone"];
            this.scmcode = data["scmcode"];
            this.statusID = data["statusID"];
            this.status = data["status"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.sumberDanaID = data["sumberDanaID"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.totalAmount = data["totalAmount"];
            if (data["arrUnit"] && data["arrUnit"].constructor === Array) {
                this.arrUnit = [];
                for (let item of data["arrUnit"])
                    this.arrUnit.push(UnitNotarisResultDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListBookingHistoryNotarisResultDto {
        let result = new ListBookingHistoryNotarisResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["oldOrderCode"] = this.oldOrderCode;
        data["payTypeID"] = this.payTypeID;
        data["payType"] = this.payType;
        data["membercode"] = this.membercode;
        data["membername"] = this.membername;
        data["pscode"] = this.pscode;
        data["psname"] = this.psname;
        data["custemail"] = this.custemail;
        data["custphone"] = this.custphone;
        data["scmcode"] = this.scmcode;
        data["statusID"] = this.statusID;
        data["status"] = this.status;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["sumberDanaID"] = this.sumberDanaID;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["totalAmount"] = this.totalAmount;
        if (this.arrUnit && this.arrUnit.constructor === Array) {
            data["arrUnit"] = [];
            for (let item of this.arrUnit)
                data["arrUnit"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IListBookingHistoryNotarisResultDto {
    orderHeaderID: number;
    orderCode: string;
    oldOrderCode: string;
    payTypeID: number;
    payType: string;
    membercode: string;
    membername: string;
    pscode: string;
    psname: string;
    custemail: string;
    custphone: string;
    scmcode: string;
    statusID: number;
    status: string;
    orderDate: moment.Moment;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    totalAmount: number;
    arrUnit: UnitNotarisResultDto[];
    message: string;
}

export class UnitNotarisResultDto implements IUnitNotarisResultDto {
    unitcode: string;
    unitno: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    bfamount: number;
    remarks: string;
    disc1: number;
    disc2: number;
    projectID: number;
    projectName: string;
    unitName: string;
    detail: string;
    facingName: string;
    ppNo: string;
    pathKP: string;

    constructor(data?: IUnitNotarisResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitcode = data["unitcode"];
            this.unitno = data["unitno"];
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.renovcode = data["renovcode"];
            this.termID = data["termID"];
            this.termno = data["termno"];
            this.termName = data["termName"];
            this.sellingprice = data["sellingprice"];
            this.bfamount = data["bfamount"];
            this.remarks = data["remarks"];
            this.disc1 = data["disc1"];
            this.disc2 = data["disc2"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.unitName = data["unitName"];
            this.detail = data["detail"];
            this.facingName = data["facingName"];
            this.ppNo = data["ppNo"];
            this.pathKP = data["pathKP"];
        }
    }

    static fromJS(data: any): UnitNotarisResultDto {
        let result = new UnitNotarisResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitcode"] = this.unitcode;
        data["unitno"] = this.unitno;
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["renovcode"] = this.renovcode;
        data["termID"] = this.termID;
        data["termno"] = this.termno;
        data["termName"] = this.termName;
        data["sellingprice"] = this.sellingprice;
        data["bfamount"] = this.bfamount;
        data["remarks"] = this.remarks;
        data["disc1"] = this.disc1;
        data["disc2"] = this.disc2;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["unitName"] = this.unitName;
        data["detail"] = this.detail;
        data["facingName"] = this.facingName;
        data["ppNo"] = this.ppNo;
        data["pathKP"] = this.pathKP;
        return data; 
    }
}

export interface IUnitNotarisResultDto {
    unitcode: string;
    unitno: string;
    unitID: number;
    renovID: number;
    renovcode: string;
    termID: number;
    termno: number;
    termName: string;
    sellingprice: number;
    bfamount: number;
    remarks: string;
    disc1: number;
    disc2: number;
    projectID: number;
    projectName: string;
    unitName: string;
    detail: string;
    facingName: string;
    ppNo: string;
    pathKP: string;
}

export class GetDropdownProjectBookingHistoryResultDto implements IGetDropdownProjectBookingHistoryResultDto {
    projectID: number;
    projectName: string;
    isMember: boolean;

    constructor(data?: IGetDropdownProjectBookingHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.isMember = data["isMember"];
        }
    }

    static fromJS(data: any): GetDropdownProjectBookingHistoryResultDto {
        let result = new GetDropdownProjectBookingHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["isMember"] = this.isMember;
        return data; 
    }
}

export interface IGetDropdownProjectBookingHistoryResultDto {
    projectID: number;
    projectName: string;
    isMember: boolean;
}

export class GetCampaignListDto implements IGetCampaignListDto {
    listMarketing: GetRewardListDto[];
    listSpecial: GetRewardListDto[];
    listBank: GetRewardListDto[];
    listMoveIn: GetRewardListDto[];
    listClosing: GetRewardListDto[];
    listReward: GetRewardListDto[];

    constructor(data?: IGetCampaignListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listMarketing"] && data["listMarketing"].constructor === Array) {
                this.listMarketing = [];
                for (let item of data["listMarketing"])
                    this.listMarketing.push(GetRewardListDto.fromJS(item));
            }
            if (data["listSpecial"] && data["listSpecial"].constructor === Array) {
                this.listSpecial = [];
                for (let item of data["listSpecial"])
                    this.listSpecial.push(GetRewardListDto.fromJS(item));
            }
            if (data["listBank"] && data["listBank"].constructor === Array) {
                this.listBank = [];
                for (let item of data["listBank"])
                    this.listBank.push(GetRewardListDto.fromJS(item));
            }
            if (data["listMoveIn"] && data["listMoveIn"].constructor === Array) {
                this.listMoveIn = [];
                for (let item of data["listMoveIn"])
                    this.listMoveIn.push(GetRewardListDto.fromJS(item));
            }
            if (data["listClosing"] && data["listClosing"].constructor === Array) {
                this.listClosing = [];
                for (let item of data["listClosing"])
                    this.listClosing.push(GetRewardListDto.fromJS(item));
            }
            if (data["listReward"] && data["listReward"].constructor === Array) {
                this.listReward = [];
                for (let item of data["listReward"])
                    this.listReward.push(GetRewardListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCampaignListDto {
        let result = new GetCampaignListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listMarketing && this.listMarketing.constructor === Array) {
            data["listMarketing"] = [];
            for (let item of this.listMarketing)
                data["listMarketing"].push(item.toJSON());
        }
        if (this.listSpecial && this.listSpecial.constructor === Array) {
            data["listSpecial"] = [];
            for (let item of this.listSpecial)
                data["listSpecial"].push(item.toJSON());
        }
        if (this.listBank && this.listBank.constructor === Array) {
            data["listBank"] = [];
            for (let item of this.listBank)
                data["listBank"].push(item.toJSON());
        }
        if (this.listMoveIn && this.listMoveIn.constructor === Array) {
            data["listMoveIn"] = [];
            for (let item of this.listMoveIn)
                data["listMoveIn"].push(item.toJSON());
        }
        if (this.listClosing && this.listClosing.constructor === Array) {
            data["listClosing"] = [];
            for (let item of this.listClosing)
                data["listClosing"].push(item.toJSON());
        }
        if (this.listReward && this.listReward.constructor === Array) {
            data["listReward"] = [];
            for (let item of this.listReward)
                data["listReward"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCampaignListDto {
    listMarketing: GetRewardListDto[];
    listSpecial: GetRewardListDto[];
    listBank: GetRewardListDto[];
    listMoveIn: GetRewardListDto[];
    listClosing: GetRewardListDto[];
    listReward: GetRewardListDto[];
}

export class GetRewardListDto implements IGetRewardListDto {
    creationTime: moment.Moment;
    campaignName: string;
    rewardName: string;
    status: string;
    voucherCode: string;

    constructor(data?: IGetRewardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.campaignName = data["campaignName"];
            this.rewardName = data["rewardName"];
            this.status = data["status"];
            this.voucherCode = data["voucherCode"];
        }
    }

    static fromJS(data: any): GetRewardListDto {
        let result = new GetRewardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["campaignName"] = this.campaignName;
        data["rewardName"] = this.rewardName;
        data["status"] = this.status;
        data["voucherCode"] = this.voucherCode;
        return data; 
    }
}

export interface IGetRewardListDto {
    creationTime: moment.Moment;
    campaignName: string;
    rewardName: string;
    status: string;
    voucherCode: string;
}

export class CheckDataUploadExcelBulkInputDto implements ICheckDataUploadExcelBulkInputDto {
    accID: number;
    userID: number;
    bookCode: string;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    clearDate: moment.Moment;
    amount: number;

    constructor(data?: ICheckDataUploadExcelBulkInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.userID = data["userID"];
            this.bookCode = data["bookCode"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeCode = data["othersTypeCode"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): CheckDataUploadExcelBulkInputDto {
        let result = new CheckDataUploadExcelBulkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["userID"] = this.userID;
        data["bookCode"] = this.bookCode;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeCode"] = this.othersTypeCode;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ICheckDataUploadExcelBulkInputDto {
    accID: number;
    userID: number;
    bookCode: string;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    clearDate: moment.Moment;
    amount: number;
}

export class GetDataCheckUploadExcelListDto implements IGetDataCheckUploadExcelListDto {
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    dataSchedule: GetDataSchedule[];

    constructor(data?: IGetDataCheckUploadExcelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.address = data["address"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitID = data["unitID"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeCode = data["othersTypeCode"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.pctTax = data["pctTax"];
            this.message = data["message"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(GetDataSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataCheckUploadExcelListDto {
        let result = new GetDataCheckUploadExcelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["address"] = this.address;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitID"] = this.unitID;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeCode"] = this.othersTypeCode;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["pctTax"] = this.pctTax;
        data["message"] = this.message;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataCheckUploadExcelListDto {
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    dataSchedule: GetDataSchedule[];
}

export class CreateTrPaymentBulkInputDto implements ICreateTrPaymentBulkInputDto {
    bulkPaymentKey: string;
    bookingHeaderID: number;
    unitID: number;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    psCode: string;
    name: string;
    clearDate: moment.Moment;
    amount: number;

    constructor(data?: ICreateTrPaymentBulkInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bulkPaymentKey = data["bulkPaymentKey"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.unitID = data["unitID"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): CreateTrPaymentBulkInputDto {
        let result = new CreateTrPaymentBulkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkPaymentKey"] = this.bulkPaymentKey;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["unitID"] = this.unitID;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ICreateTrPaymentBulkInputDto {
    bulkPaymentKey: string;
    bookingHeaderID: number;
    unitID: number;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    psCode: string;
    name: string;
    clearDate: moment.Moment;
    amount: number;
}

export class CreateUniversalBulkPaymentInputDto implements ICreateUniversalBulkPaymentInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    payForCode: string;
    bookCode: string;
    psCode: string;
    name: string;
    bankName: string;
    keterangan: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    address: string;
    npwp: string;
    journalCode: string;
    runningJournal: number;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    pctTax: number;
    payTypeID: number;
    othersTypeID: number;
    othersTypeCode: string;
    amount: number;
    amountOver: number;
    flag: number;
    noReferensi: string;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];

    constructor(data?: ICreateUniversalBulkPaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.payForCode = data["payForCode"];
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.bankName = data["bankName"];
            this.keterangan = data["keterangan"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.address = data["address"];
            this.npwp = data["npwp"];
            this.journalCode = data["journalCode"];
            this.runningJournal = data["runningJournal"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.pctTax = data["pctTax"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.othersTypeCode = data["othersTypeCode"];
            this.amount = data["amount"];
            this.amountOver = data["amountOver"];
            this.flag = data["flag"];
            this.noReferensi = data["noReferensi"];
            if (data["dataScheduleList"] && data["dataScheduleList"].constructor === Array) {
                this.dataScheduleList = [];
                for (let item of data["dataScheduleList"])
                    this.dataScheduleList.push(DataAlloc.fromJS(item));
            }
            if (data["dataForPayment"] && data["dataForPayment"].constructor === Array) {
                this.dataForPayment = [];
                for (let item of data["dataForPayment"])
                    this.dataForPayment.push(DataPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalBulkPaymentInputDto {
        let result = new CreateUniversalBulkPaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["payForCode"] = this.payForCode;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["bankName"] = this.bankName;
        data["keterangan"] = this.keterangan;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["address"] = this.address;
        data["npwp"] = this.npwp;
        data["journalCode"] = this.journalCode;
        data["runningJournal"] = this.runningJournal;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["pctTax"] = this.pctTax;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["othersTypeCode"] = this.othersTypeCode;
        data["amount"] = this.amount;
        data["amountOver"] = this.amountOver;
        data["flag"] = this.flag;
        data["noReferensi"] = this.noReferensi;
        if (this.dataScheduleList && this.dataScheduleList.constructor === Array) {
            data["dataScheduleList"] = [];
            for (let item of this.dataScheduleList)
                data["dataScheduleList"].push(item.toJSON());
        }
        if (this.dataForPayment && this.dataForPayment.constructor === Array) {
            data["dataForPayment"] = [];
            for (let item of this.dataForPayment)
                data["dataForPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalBulkPaymentInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    payForCode: string;
    bookCode: string;
    psCode: string;
    name: string;
    bankName: string;
    keterangan: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    address: string;
    npwp: string;
    journalCode: string;
    runningJournal: number;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    pctTax: number;
    payTypeID: number;
    othersTypeID: number;
    othersTypeCode: string;
    amount: number;
    amountOver: number;
    flag: number;
    noReferensi: string;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items: CacheDto[];

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[];
}

export class CacheDto implements ICacheDto {
    name: string;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id: string;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string;
}

export class GetDropdownPPNoResultDto implements IGetDropdownPPNoResultDto {
    ppNoID: number;
    ppNo: string;
    psCode: string;
    memberCode: string;

    constructor(data?: IGetDropdownPPNoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNoID = data["ppNoID"];
            this.ppNo = data["ppNo"];
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): GetDropdownPPNoResultDto {
        let result = new GetDropdownPPNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNoID"] = this.ppNoID;
        data["ppNo"] = this.ppNo;
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IGetDropdownPPNoResultDto {
    ppNoID: number;
    ppNo: string;
    psCode: string;
    memberCode: string;
}

export class GetSalesAndMemberDto implements IGetSalesAndMemberDto {
    psCode: string;
    psName: string;
    memberCode: string;
    memberName: string;
    scmCode: string;

    constructor(data?: IGetSalesAndMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.psName = data["psName"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
        }
    }

    static fromJS(data: any): GetSalesAndMemberDto {
        let result = new GetSalesAndMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["psName"] = this.psName;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        return data; 
    }
}

export interface IGetSalesAndMemberDto {
    psCode: string;
    psName: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
}

export class GetListSalesMemberDto implements IGetListSalesMemberDto {
    memberCode: string;
    memberName: string;
    scmCode: string;
    parentMemberCode: string;

    constructor(data?: IGetListSalesMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.parentMemberCode = data["parentMemberCode"];
        }
    }

    static fromJS(data: any): GetListSalesMemberDto {
        let result = new GetListSalesMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["parentMemberCode"] = this.parentMemberCode;
        return data; 
    }
}

export interface IGetListSalesMemberDto {
    memberCode: string;
    memberName: string;
    scmCode: string;
    parentMemberCode: string;
}

export class GetListCustomerMemberDto implements IGetListCustomerMemberDto {
    psCode: string;
    name: string;
    no_telp: string;
    email: string;

    constructor(data?: IGetListCustomerMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.no_telp = data["no_telp"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetListCustomerMemberDto {
        let result = new GetListCustomerMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["no_telp"] = this.no_telp;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetListCustomerMemberDto {
    psCode: string;
    name: string;
    no_telp: string;
    email: string;
}

export class GetUnitCodeUnitNoResultDto implements IGetUnitCodeUnitNoResultDto {
    unitID: number;
    unit: string;

    constructor(data?: IGetUnitCodeUnitNoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): GetUnitCodeUnitNoResultDto {
        let result = new GetUnitCodeUnitNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IGetUnitCodeUnitNoResultDto {
    unitID: number;
    unit: string;
}

export class UpdateTermCodeByUnitInputDto implements IUpdateTermCodeByUnitInputDto {
    termMainID: number;
    unitID: number[];

    constructor(data?: IUpdateTermCodeByUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainID = data["termMainID"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTermCodeByUnitInputDto {
        let result = new UpdateTermCodeByUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainID"] = this.termMainID;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        return data; 
    }
}

export interface IUpdateTermCodeByUnitInputDto {
    termMainID: number;
    unitID: number[];
}

export class ListResultDtoOfGetChangeUnitRegulerListDto implements IListResultDtoOfGetChangeUnitRegulerListDto {
    items: GetChangeUnitRegulerListDto[];

    constructor(data?: IListResultDtoOfGetChangeUnitRegulerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetChangeUnitRegulerListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetChangeUnitRegulerListDto {
        let result = new ListResultDtoOfGetChangeUnitRegulerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetChangeUnitRegulerListDto {
    items: GetChangeUnitRegulerListDto[];
}

export class GetChangeUnitRegulerListDto implements IGetChangeUnitRegulerListDto {
    requestActions: RequestActionDto[];
    stateName: string;
    requestUserName: string;
    oldUnit: CUROldUnitDto;
    newUnit: CURNewUnitDto;
    biayaAdmin: number;
    totalBawa: number;
    changeUnitID: number;
    documentBinary: string;
    fileName: string;
    status: string;

    constructor(data?: IGetChangeUnitRegulerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["requestActions"] && data["requestActions"].constructor === Array) {
                this.requestActions = [];
                for (let item of data["requestActions"])
                    this.requestActions.push(RequestActionDto.fromJS(item));
            }
            this.stateName = data["stateName"];
            this.requestUserName = data["requestUserName"];
            this.oldUnit = data["oldUnit"] ? CUROldUnitDto.fromJS(data["oldUnit"]) : <any>undefined;
            this.newUnit = data["newUnit"] ? CURNewUnitDto.fromJS(data["newUnit"]) : <any>undefined;
            this.biayaAdmin = data["biayaAdmin"];
            this.totalBawa = data["totalBawa"];
            this.changeUnitID = data["changeUnitID"];
            this.documentBinary = data["documentBinary"];
            this.fileName = data["fileName"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetChangeUnitRegulerListDto {
        let result = new GetChangeUnitRegulerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.requestActions && this.requestActions.constructor === Array) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        data["stateName"] = this.stateName;
        data["requestUserName"] = this.requestUserName;
        data["oldUnit"] = this.oldUnit ? this.oldUnit.toJSON() : <any>undefined;
        data["newUnit"] = this.newUnit ? this.newUnit.toJSON() : <any>undefined;
        data["biayaAdmin"] = this.biayaAdmin;
        data["totalBawa"] = this.totalBawa;
        data["changeUnitID"] = this.changeUnitID;
        data["documentBinary"] = this.documentBinary;
        data["fileName"] = this.fileName;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetChangeUnitRegulerListDto {
    requestActions: RequestActionDto[];
    stateName: string;
    requestUserName: string;
    oldUnit: CUROldUnitDto;
    newUnit: CURNewUnitDto;
    biayaAdmin: number;
    totalBawa: number;
    changeUnitID: number;
    documentBinary: string;
    fileName: string;
    status: string;
}

export class RequestActionDto implements IRequestActionDto {
    requestActionId: number;
    actionName: string;
    canChangeRequestData: boolean;

    constructor(data?: IRequestActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestActionId = data["requestActionId"];
            this.actionName = data["actionName"];
            this.canChangeRequestData = data["canChangeRequestData"];
        }
    }

    static fromJS(data: any): RequestActionDto {
        let result = new RequestActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionId"] = this.requestActionId;
        data["actionName"] = this.actionName;
        data["canChangeRequestData"] = this.canChangeRequestData;
        return data; 
    }
}

export interface IRequestActionDto {
    requestActionId: number;
    actionName: string;
    canChangeRequestData: boolean;
}

export class CUROldUnitDto implements ICUROldUnitDto {
    id: number;
    projectID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    bookingHeaderID: number;
    bookCode: string;
    handOverDate: moment.Moment;
    price: number;
    unitID: number;
    renovID: number;
    bookingFee: number;
    creationTime: moment.Moment;

    constructor(data?: ICUROldUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.handOverDate = data["handOverDate"] ? moment(data["handOverDate"].toString()) : <any>undefined;
            this.price = data["price"];
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.bookingFee = data["bookingFee"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CUROldUnitDto {
        let result = new CUROldUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["bookingFee"] = this.bookingFee;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICUROldUnitDto {
    id: number;
    projectID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    bookingHeaderID: number;
    bookCode: string;
    handOverDate: moment.Moment;
    price: number;
    unitID: number;
    renovID: number;
    bookingFee: number;
    creationTime: moment.Moment;
}

export class CURNewUnitDto implements ICURNewUnitDto {
    id: number;
    projectID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    sumberDanaID: number;
    price: number;
    handOverDate: moment.Moment;
    unitID: number;
    orderID: number;
    bookingHeaderID: number;
    bookCode: string;
    customerName: string;
    termID: number;
    renovID: number;
    creationTime: moment.Moment;

    constructor(data?: ICURNewUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.sumberDanaID = data["sumberDanaID"];
            this.price = data["price"];
            this.handOverDate = data["handOverDate"] ? moment(data["handOverDate"].toString()) : <any>undefined;
            this.unitID = data["unitID"];
            this.orderID = data["orderID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.customerName = data["customerName"];
            this.termID = data["termID"];
            this.renovID = data["renovID"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CURNewUnitDto {
        let result = new CURNewUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["sumberDanaID"] = this.sumberDanaID;
        data["price"] = this.price;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["unitID"] = this.unitID;
        data["orderID"] = this.orderID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["customerName"] = this.customerName;
        data["termID"] = this.termID;
        data["renovID"] = this.renovID;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICURNewUnitDto {
    id: number;
    projectID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    sumberDanaID: number;
    price: number;
    handOverDate: moment.Moment;
    unitID: number;
    orderID: number;
    bookingHeaderID: number;
    bookCode: string;
    customerName: string;
    termID: number;
    renovID: number;
    creationTime: moment.Moment;
}

export class GetDataNotaReturORDto implements IGetDataNotaReturORDto {
    fpCode: string;
    transNo: string;
    notaRetur: string;

    constructor(data?: IGetDataNotaReturORDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fpCode = data["fpCode"];
            this.transNo = data["transNo"];
            this.notaRetur = data["notaRetur"];
        }
    }

    static fromJS(data: any): GetDataNotaReturORDto {
        let result = new GetDataNotaReturORDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fpCode"] = this.fpCode;
        data["transNo"] = this.transNo;
        data["notaRetur"] = this.notaRetur;
        return data; 
    }
}

export interface IGetDataNotaReturORDto {
    fpCode: string;
    transNo: string;
    notaRetur: string;
}

export class GetDataChangeUnitParamDto implements IGetDataChangeUnitParamDto {
    changeUnitParamId: number;
    description: string;

    constructor(data?: IGetDataChangeUnitParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeUnitParamId = data["changeUnitParamId"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): GetDataChangeUnitParamDto {
        let result = new GetDataChangeUnitParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeUnitParamId"] = this.changeUnitParamId;
        data["description"] = this.description;
        return data; 
    }
}

export interface IGetDataChangeUnitParamDto {
    changeUnitParamId: number;
    description: string;
}

export class TermOfPaymentListDto implements ITermOfPaymentListDto {
    id: number;
    remarks: string;

    constructor(data?: ITermOfPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): TermOfPaymentListDto {
        let result = new TermOfPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface ITermOfPaymentListDto {
    id: number;
    remarks: string;
}

export class GetDataCUROldUnitResultDto implements IGetDataCUROldUnitResultDto {
    bookingHeaderID: number;
    bookCode: string;
    customerName: string;
    unitLama: string;
    unitCodeLama: string;
    unitNoLama: string;
    unitID: number;
    handoverDate: moment.Moment;
    totalPayment: number;
    totalPaymentExcludeVAT: number;
    termCodeUnitLama: string;
    termNoUnitLama: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    bookingFee: number;

    constructor(data?: IGetDataCUROldUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.customerName = data["customerName"];
            this.unitLama = data["unitLama"];
            this.unitCodeLama = data["unitCodeLama"];
            this.unitNoLama = data["unitNoLama"];
            this.unitID = data["unitID"];
            this.handoverDate = data["handoverDate"] ? moment(data["handoverDate"].toString()) : <any>undefined;
            this.totalPayment = data["totalPayment"];
            this.totalPaymentExcludeVAT = data["totalPaymentExcludeVAT"];
            this.termCodeUnitLama = data["termCodeUnitLama"];
            this.termNoUnitLama = data["termNoUnitLama"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.bookingFee = data["bookingFee"];
        }
    }

    static fromJS(data: any): GetDataCUROldUnitResultDto {
        let result = new GetDataCUROldUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["customerName"] = this.customerName;
        data["unitLama"] = this.unitLama;
        data["unitCodeLama"] = this.unitCodeLama;
        data["unitNoLama"] = this.unitNoLama;
        data["unitID"] = this.unitID;
        data["handoverDate"] = this.handoverDate ? this.handoverDate.toISOString() : <any>undefined;
        data["totalPayment"] = this.totalPayment;
        data["totalPaymentExcludeVAT"] = this.totalPaymentExcludeVAT;
        data["termCodeUnitLama"] = this.termCodeUnitLama;
        data["termNoUnitLama"] = this.termNoUnitLama;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["bookingFee"] = this.bookingFee;
        return data; 
    }
}

export interface IGetDataCUROldUnitResultDto {
    bookingHeaderID: number;
    bookCode: string;
    customerName: string;
    unitLama: string;
    unitCodeLama: string;
    unitNoLama: string;
    unitID: number;
    handoverDate: moment.Moment;
    totalPayment: number;
    totalPaymentExcludeVAT: number;
    termCodeUnitLama: string;
    termNoUnitLama: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    bookingFee: number;
}

export class GetDataCURNewUnitResultDto implements IGetDataCURNewUnitResultDto {
    unitBaru: string;
    unitCodeBaru: string;
    unitNoBaru: string;
    handOverDate: moment.Moment;
    unitIDBaru: number;
    bookingFee: number;

    constructor(data?: IGetDataCURNewUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitBaru = data["unitBaru"];
            this.unitCodeBaru = data["unitCodeBaru"];
            this.unitNoBaru = data["unitNoBaru"];
            this.handOverDate = data["handOverDate"] ? moment(data["handOverDate"].toString()) : <any>undefined;
            this.unitIDBaru = data["unitIDBaru"];
            this.bookingFee = data["bookingFee"];
        }
    }

    static fromJS(data: any): GetDataCURNewUnitResultDto {
        let result = new GetDataCURNewUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitBaru"] = this.unitBaru;
        data["unitCodeBaru"] = this.unitCodeBaru;
        data["unitNoBaru"] = this.unitNoBaru;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["unitIDBaru"] = this.unitIDBaru;
        data["bookingFee"] = this.bookingFee;
        return data; 
    }
}

export interface IGetDataCURNewUnitResultDto {
    unitBaru: string;
    unitCodeBaru: string;
    unitNoBaru: string;
    handOverDate: moment.Moment;
    unitIDBaru: number;
    bookingFee: number;
}

export class GetOldAndNewUnitComparisonsResult implements IGetOldAndNewUnitComparisonsResult {
    oldAndNewUnitComparisons: OldAndNewUnitComparisonListDto[];
    unitComparisonSellingPriceDifference: number;

    constructor(data?: IGetOldAndNewUnitComparisonsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["oldAndNewUnitComparisons"] && data["oldAndNewUnitComparisons"].constructor === Array) {
                this.oldAndNewUnitComparisons = [];
                for (let item of data["oldAndNewUnitComparisons"])
                    this.oldAndNewUnitComparisons.push(OldAndNewUnitComparisonListDto.fromJS(item));
            }
            this.unitComparisonSellingPriceDifference = data["unitComparisonSellingPriceDifference"];
        }
    }

    static fromJS(data: any): GetOldAndNewUnitComparisonsResult {
        let result = new GetOldAndNewUnitComparisonsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.oldAndNewUnitComparisons && this.oldAndNewUnitComparisons.constructor === Array) {
            data["oldAndNewUnitComparisons"] = [];
            for (let item of this.oldAndNewUnitComparisons)
                data["oldAndNewUnitComparisons"].push(item.toJSON());
        }
        data["unitComparisonSellingPriceDifference"] = this.unitComparisonSellingPriceDifference;
        return data; 
    }
}

export interface IGetOldAndNewUnitComparisonsResult {
    oldAndNewUnitComparisons: OldAndNewUnitComparisonListDto[];
    unitComparisonSellingPriceDifference: number;
}

export class OldAndNewUnitComparisonListDto implements IOldAndNewUnitComparisonListDto {
    name: string;
    oldUnitValue: string;
    newUnitValue: string;
    valueComparison: string;

    constructor(data?: IOldAndNewUnitComparisonListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.oldUnitValue = data["oldUnitValue"];
            this.newUnitValue = data["newUnitValue"];
            this.valueComparison = data["valueComparison"];
        }
    }

    static fromJS(data: any): OldAndNewUnitComparisonListDto {
        let result = new OldAndNewUnitComparisonListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["oldUnitValue"] = this.oldUnitValue;
        data["newUnitValue"] = this.newUnitValue;
        data["valueComparison"] = this.valueComparison;
        return data; 
    }
}

export interface IOldAndNewUnitComparisonListDto {
    name: string;
    oldUnitValue: string;
    newUnitValue: string;
    valueComparison: string;
}

export class CompleteChangeUnitRegulerRequestActionInput implements ICompleteChangeUnitRegulerRequestActionInput {
    requestActionId: number;
    changeUnitRequestData: ChangeUnitRequestData;

    constructor(data?: ICompleteChangeUnitRegulerRequestActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestActionId = data["requestActionId"];
            this.changeUnitRequestData = data["changeUnitRequestData"] ? ChangeUnitRequestData.fromJS(data["changeUnitRequestData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteChangeUnitRegulerRequestActionInput {
        let result = new CompleteChangeUnitRegulerRequestActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionId"] = this.requestActionId;
        data["changeUnitRequestData"] = this.changeUnitRequestData ? this.changeUnitRequestData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompleteChangeUnitRegulerRequestActionInput {
    requestActionId: number;
    changeUnitRequestData: ChangeUnitRequestData;
}

export class ChangeUnitRequestData implements IChangeUnitRequestData {
    changeUnitId: number;
    inputOnWorkflowFinish: ProcessSwitchUnitInputDto;

    constructor(data?: IChangeUnitRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeUnitId = data["changeUnitId"];
            this.inputOnWorkflowFinish = data["inputOnWorkflowFinish"] ? ProcessSwitchUnitInputDto.fromJS(data["inputOnWorkflowFinish"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeUnitRequestData {
        let result = new ChangeUnitRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeUnitId"] = this.changeUnitId;
        data["inputOnWorkflowFinish"] = this.inputOnWorkflowFinish ? this.inputOnWorkflowFinish.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IChangeUnitRequestData {
    changeUnitId: number;
    inputOnWorkflowFinish: ProcessSwitchUnitInputDto;
}

export class ProcessSwitchUnitInputDto implements IProcessSwitchUnitInputDto {
    changeUnitID: number;
    bookingHeaderIDLama: number;
    bookCodeLama: string;
    unitIDLama: number;
    unitIDBaru: number;
    projectIDUnitBaru: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    sumberDanaID: number;
    biayaAdmin: number;
    totalYgDibawa: number;
    totalTanpaBF: number;
    totalPayment: number;
    termId: number;
    bookingFeeUnitBaru: number;
    fileUpload: string;
    fileName: string;
    unitCodeBaru: string;
    unitCodeLama: string;
    unitNoBaru: string;
    unitNoLama: string;
    changeUnitParam: number[];

    constructor(data?: IProcessSwitchUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeUnitID = data["changeUnitID"];
            this.bookingHeaderIDLama = data["bookingHeaderIDLama"];
            this.bookCodeLama = data["bookCodeLama"];
            this.unitIDLama = data["unitIDLama"];
            this.unitIDBaru = data["unitIDBaru"];
            this.projectIDUnitBaru = data["projectIDUnitBaru"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.sumberDanaID = data["sumberDanaID"];
            this.biayaAdmin = data["biayaAdmin"];
            this.totalYgDibawa = data["totalYgDibawa"];
            this.totalTanpaBF = data["totalTanpaBF"];
            this.totalPayment = data["totalPayment"];
            this.termId = data["termId"];
            this.bookingFeeUnitBaru = data["bookingFeeUnitBaru"];
            this.fileUpload = data["fileUpload"];
            this.fileName = data["fileName"];
            this.unitCodeBaru = data["unitCodeBaru"];
            this.unitCodeLama = data["unitCodeLama"];
            this.unitNoBaru = data["unitNoBaru"];
            this.unitNoLama = data["unitNoLama"];
            if (data["changeUnitParam"] && data["changeUnitParam"].constructor === Array) {
                this.changeUnitParam = [];
                for (let item of data["changeUnitParam"])
                    this.changeUnitParam.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessSwitchUnitInputDto {
        let result = new ProcessSwitchUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeUnitID"] = this.changeUnitID;
        data["bookingHeaderIDLama"] = this.bookingHeaderIDLama;
        data["bookCodeLama"] = this.bookCodeLama;
        data["unitIDLama"] = this.unitIDLama;
        data["unitIDBaru"] = this.unitIDBaru;
        data["projectIDUnitBaru"] = this.projectIDUnitBaru;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["sumberDanaID"] = this.sumberDanaID;
        data["biayaAdmin"] = this.biayaAdmin;
        data["totalYgDibawa"] = this.totalYgDibawa;
        data["totalTanpaBF"] = this.totalTanpaBF;
        data["totalPayment"] = this.totalPayment;
        data["termId"] = this.termId;
        data["bookingFeeUnitBaru"] = this.bookingFeeUnitBaru;
        data["fileUpload"] = this.fileUpload;
        data["fileName"] = this.fileName;
        data["unitCodeBaru"] = this.unitCodeBaru;
        data["unitCodeLama"] = this.unitCodeLama;
        data["unitNoBaru"] = this.unitNoBaru;
        data["unitNoLama"] = this.unitNoLama;
        if (this.changeUnitParam && this.changeUnitParam.constructor === Array) {
            data["changeUnitParam"] = [];
            for (let item of this.changeUnitParam)
                data["changeUnitParam"].push(item);
        }
        return data; 
    }
}

export interface IProcessSwitchUnitInputDto {
    changeUnitID: number;
    bookingHeaderIDLama: number;
    bookCodeLama: string;
    unitIDLama: number;
    unitIDBaru: number;
    projectIDUnitBaru: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    sumberDanaID: number;
    biayaAdmin: number;
    totalYgDibawa: number;
    totalTanpaBF: number;
    totalPayment: number;
    termId: number;
    bookingFeeUnitBaru: number;
    fileUpload: string;
    fileName: string;
    unitCodeBaru: string;
    unitCodeLama: string;
    unitNoBaru: string;
    unitNoLama: string;
    changeUnitParam: number[];
}

export class CreatePaymentCURInputDto implements ICreatePaymentCURInputDto {
    bookingHeaderID: number;
    accountID: number;
    amount: number;
    psCode: string;
    npwp: string;
    psName: string;
    psAddress: string;
    unitCode: string;
    unitNo: string;
    accCode: string;
    coCode: string;

    constructor(data?: ICreatePaymentCURInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.accountID = data["accountID"];
            this.amount = data["amount"];
            this.psCode = data["psCode"];
            this.npwp = data["npwp"];
            this.psName = data["psName"];
            this.psAddress = data["psAddress"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.accCode = data["accCode"];
            this.coCode = data["coCode"];
        }
    }

    static fromJS(data: any): CreatePaymentCURInputDto {
        let result = new CreatePaymentCURInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["accountID"] = this.accountID;
        data["amount"] = this.amount;
        data["psCode"] = this.psCode;
        data["npwp"] = this.npwp;
        data["psName"] = this.psName;
        data["psAddress"] = this.psAddress;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["accCode"] = this.accCode;
        data["coCode"] = this.coCode;
        return data; 
    }
}

export interface ICreatePaymentCURInputDto {
    bookingHeaderID: number;
    accountID: number;
    amount: number;
    psCode: string;
    npwp: string;
    psName: string;
    psAddress: string;
    unitCode: string;
    unitNo: string;
    accCode: string;
    coCode: string;
}

export class GetDataMemberCURDto implements IGetDataMemberCURDto {
    memberCode: string;
    memberName: string;
    scmCode: string;

    constructor(data?: IGetDataMemberCURDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
        }
    }

    static fromJS(data: any): GetDataMemberCURDto {
        let result = new GetDataMemberCURDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        return data; 
    }
}

export interface IGetDataMemberCURDto {
    memberCode: string;
    memberName: string;
    scmCode: string;
}

export class ListResultDtoOfDropdownDtoOfInt32 implements IListResultDtoOfDropdownDtoOfInt32 {
    items: DropdownDtoOfInt32[];

    constructor(data?: IListResultDtoOfDropdownDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DropdownDtoOfInt32.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDropdownDtoOfInt32 {
        let result = new ListResultDtoOfDropdownDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDropdownDtoOfInt32 {
    items: DropdownDtoOfInt32[];
}

export class DropdownDtoOfInt32 implements IDropdownDtoOfInt32 {
    value: number;
    displayText: string;

    constructor(data?: IDropdownDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): DropdownDtoOfInt32 {
        let result = new DropdownDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface IDropdownDtoOfInt32 {
    value: number;
    displayText: string;
}

export class GetCURDocumentResultDto implements IGetCURDocumentResultDto {
    document: string;
    fileName: string;

    constructor(data?: IGetCURDocumentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.document = data["document"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): GetCURDocumentResultDto {
        let result = new GetCURDocumentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IGetCURDocumentResultDto {
    document: string;
    fileName: string;
}

export class GenerateSimulasiPindahUnitDto implements IGenerateSimulasiPindahUnitDto {
    tanggalPembuatan: string;
    namaCustomer: string;
    emailCustomer: string;
    noTelp: string;
    unitLama: string;
    luasUnitLama: string;
    caraBayarUnitLama: string;
    hargaUnitLama: string;
    unitBaru: string;
    luasUnitBaru: string;
    projectImage: string;
    uangMasukUnitLama: number;
    potongBF: boolean;
    bookingFeeUnitLama: number;
    potongPPH: boolean;
    potongPPHUnitLama: number;
    bfOffline: boolean;
    uangBFOffline: number;
    totalUangMasuk: number;
    showBFOffline: boolean;
    bookingFeeUnitBaru: number;
    downPayment: number[];
    simulasiCaraBayar: SimulasiCaraBayar[];

    constructor(data?: IGenerateSimulasiPindahUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tanggalPembuatan = data["tanggalPembuatan"];
            this.namaCustomer = data["namaCustomer"];
            this.emailCustomer = data["emailCustomer"];
            this.noTelp = data["noTelp"];
            this.unitLama = data["unitLama"];
            this.luasUnitLama = data["luasUnitLama"];
            this.caraBayarUnitLama = data["caraBayarUnitLama"];
            this.hargaUnitLama = data["hargaUnitLama"];
            this.unitBaru = data["unitBaru"];
            this.luasUnitBaru = data["luasUnitBaru"];
            this.projectImage = data["projectImage"];
            this.uangMasukUnitLama = data["uangMasukUnitLama"];
            this.potongBF = data["potongBF"];
            this.bookingFeeUnitLama = data["bookingFeeUnitLama"];
            this.potongPPH = data["potongPPH"];
            this.potongPPHUnitLama = data["potongPPHUnitLama"];
            this.bfOffline = data["bfOffline"];
            this.uangBFOffline = data["uangBFOffline"];
            this.totalUangMasuk = data["totalUangMasuk"];
            this.showBFOffline = data["showBFOffline"];
            this.bookingFeeUnitBaru = data["bookingFeeUnitBaru"];
            if (data["downPayment"] && data["downPayment"].constructor === Array) {
                this.downPayment = [];
                for (let item of data["downPayment"])
                    this.downPayment.push(item);
            }
            if (data["simulasiCaraBayar"] && data["simulasiCaraBayar"].constructor === Array) {
                this.simulasiCaraBayar = [];
                for (let item of data["simulasiCaraBayar"])
                    this.simulasiCaraBayar.push(SimulasiCaraBayar.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateSimulasiPindahUnitDto {
        let result = new GenerateSimulasiPindahUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tanggalPembuatan"] = this.tanggalPembuatan;
        data["namaCustomer"] = this.namaCustomer;
        data["emailCustomer"] = this.emailCustomer;
        data["noTelp"] = this.noTelp;
        data["unitLama"] = this.unitLama;
        data["luasUnitLama"] = this.luasUnitLama;
        data["caraBayarUnitLama"] = this.caraBayarUnitLama;
        data["hargaUnitLama"] = this.hargaUnitLama;
        data["unitBaru"] = this.unitBaru;
        data["luasUnitBaru"] = this.luasUnitBaru;
        data["projectImage"] = this.projectImage;
        data["uangMasukUnitLama"] = this.uangMasukUnitLama;
        data["potongBF"] = this.potongBF;
        data["bookingFeeUnitLama"] = this.bookingFeeUnitLama;
        data["potongPPH"] = this.potongPPH;
        data["potongPPHUnitLama"] = this.potongPPHUnitLama;
        data["bfOffline"] = this.bfOffline;
        data["uangBFOffline"] = this.uangBFOffline;
        data["totalUangMasuk"] = this.totalUangMasuk;
        data["showBFOffline"] = this.showBFOffline;
        data["bookingFeeUnitBaru"] = this.bookingFeeUnitBaru;
        if (this.downPayment && this.downPayment.constructor === Array) {
            data["downPayment"] = [];
            for (let item of this.downPayment)
                data["downPayment"].push(item);
        }
        if (this.simulasiCaraBayar && this.simulasiCaraBayar.constructor === Array) {
            data["simulasiCaraBayar"] = [];
            for (let item of this.simulasiCaraBayar)
                data["simulasiCaraBayar"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGenerateSimulasiPindahUnitDto {
    tanggalPembuatan: string;
    namaCustomer: string;
    emailCustomer: string;
    noTelp: string;
    unitLama: string;
    luasUnitLama: string;
    caraBayarUnitLama: string;
    hargaUnitLama: string;
    unitBaru: string;
    luasUnitBaru: string;
    projectImage: string;
    uangMasukUnitLama: number;
    potongBF: boolean;
    bookingFeeUnitLama: number;
    potongPPH: boolean;
    potongPPHUnitLama: number;
    bfOffline: boolean;
    uangBFOffline: number;
    totalUangMasuk: number;
    showBFOffline: boolean;
    bookingFeeUnitBaru: number;
    downPayment: number[];
    simulasiCaraBayar: SimulasiCaraBayar[];
}

export class SimulasiCaraBayar implements ISimulasiCaraBayar {
    caraBayar: string;
    hargaSebelumPPN: number;
    hargaSetelahPPN: number;
    selisih: number;
    diskon: number;
    sisaPembayaran: number[];

    constructor(data?: ISimulasiCaraBayar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.caraBayar = data["caraBayar"];
            this.hargaSebelumPPN = data["hargaSebelumPPN"];
            this.hargaSetelahPPN = data["hargaSetelahPPN"];
            this.selisih = data["selisih"];
            this.diskon = data["diskon"];
            if (data["sisaPembayaran"] && data["sisaPembayaran"].constructor === Array) {
                this.sisaPembayaran = [];
                for (let item of data["sisaPembayaran"])
                    this.sisaPembayaran.push(item);
            }
        }
    }

    static fromJS(data: any): SimulasiCaraBayar {
        let result = new SimulasiCaraBayar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caraBayar"] = this.caraBayar;
        data["hargaSebelumPPN"] = this.hargaSebelumPPN;
        data["hargaSetelahPPN"] = this.hargaSetelahPPN;
        data["selisih"] = this.selisih;
        data["diskon"] = this.diskon;
        if (this.sisaPembayaran && this.sisaPembayaran.constructor === Array) {
            data["sisaPembayaran"] = [];
            for (let item of this.sisaPembayaran)
                data["sisaPembayaran"].push(item);
        }
        return data; 
    }
}

export interface ISimulasiCaraBayar {
    caraBayar: string;
    hargaSebelumPPN: number;
    hargaSetelahPPN: number;
    selisih: number;
    diskon: number;
    sisaPembayaran: number[];
}

export class CreateUniversalChangeUnknownInputDto implements ICreateUniversalChangeUnknownInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    clearDate: moment.Moment;
    description: string;
    paymentDate: moment.Moment;
    controlNo: string;
    ppNo: string;
    pctTax: number;
    unitCode: string;
    unitNo: string;
    address: string;
    name: string;
    psCode: string;
    npwp: string;
    itemID: number[];
    amountTotal: number;
    maxAmount: number;
    changeDate: moment.Moment;
    reason: string;
    dataPaymentDetail: PaymentDetail[];

    constructor(data?: ICreateUniversalChangeUnknownInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.controlNo = data["controlNo"];
            this.ppNo = data["ppNo"];
            this.pctTax = data["pctTax"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.address = data["address"];
            this.name = data["name"];
            this.psCode = data["psCode"];
            this.npwp = data["npwp"];
            if (data["itemID"] && data["itemID"].constructor === Array) {
                this.itemID = [];
                for (let item of data["itemID"])
                    this.itemID.push(item);
            }
            this.amountTotal = data["amountTotal"];
            this.maxAmount = data["maxAmount"];
            this.changeDate = data["changeDate"] ? moment(data["changeDate"].toString()) : <any>undefined;
            this.reason = data["reason"];
            if (data["dataPaymentDetail"] && data["dataPaymentDetail"].constructor === Array) {
                this.dataPaymentDetail = [];
                for (let item of data["dataPaymentDetail"])
                    this.dataPaymentDetail.push(PaymentDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalChangeUnknownInputDto {
        let result = new CreateUniversalChangeUnknownInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["controlNo"] = this.controlNo;
        data["ppNo"] = this.ppNo;
        data["pctTax"] = this.pctTax;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["address"] = this.address;
        data["name"] = this.name;
        data["psCode"] = this.psCode;
        data["npwp"] = this.npwp;
        if (this.itemID && this.itemID.constructor === Array) {
            data["itemID"] = [];
            for (let item of this.itemID)
                data["itemID"].push(item);
        }
        data["amountTotal"] = this.amountTotal;
        data["maxAmount"] = this.maxAmount;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        if (this.dataPaymentDetail && this.dataPaymentDetail.constructor === Array) {
            data["dataPaymentDetail"] = [];
            for (let item of this.dataPaymentDetail)
                data["dataPaymentDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalChangeUnknownInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    clearDate: moment.Moment;
    description: string;
    paymentDate: moment.Moment;
    controlNo: string;
    ppNo: string;
    pctTax: number;
    unitCode: string;
    unitNo: string;
    address: string;
    name: string;
    psCode: string;
    npwp: string;
    itemID: number[];
    amountTotal: number;
    maxAmount: number;
    changeDate: moment.Moment;
    reason: string;
    dataPaymentDetail: PaymentDetail[];
}

export class PaymentDetail implements IPaymentDetail {
    chequeNo: string;
    payNo: number;
    othersTypeCode: string;
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalAmountDetail: number;

    constructor(data?: IPaymentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chequeNo = data["chequeNo"];
            this.payNo = data["payNo"];
            this.othersTypeCode = data["othersTypeCode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.payTypeID = data["payTypeID"];
            this.bankName = data["bankName"];
            this.ket = data["ket"];
            this.totalAmountDetail = data["totalAmountDetail"];
        }
    }

    static fromJS(data: any): PaymentDetail {
        let result = new PaymentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chequeNo"] = this.chequeNo;
        data["payNo"] = this.payNo;
        data["othersTypeCode"] = this.othersTypeCode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["payTypeID"] = this.payTypeID;
        data["bankName"] = this.bankName;
        data["ket"] = this.ket;
        data["totalAmountDetail"] = this.totalAmountDetail;
        return data; 
    }
}

export interface IPaymentDetail {
    chequeNo: string;
    payNo: number;
    othersTypeCode: string;
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalAmountDetail: number;
}

export class CreateTrPaymentChangeUnknownInputDto implements ICreateTrPaymentChangeUnknownInputDto {
    entityID: number;
    paymentHeaderID: number;
    changeNo: string;
    changeDate: moment.Moment;
    reason: string;

    constructor(data?: ICreateTrPaymentChangeUnknownInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.paymentHeaderID = data["paymentHeaderID"];
            this.changeNo = data["changeNo"];
            this.changeDate = data["changeDate"] ? moment(data["changeDate"].toString()) : <any>undefined;
            this.reason = data["reason"];
        }
    }

    static fromJS(data: any): CreateTrPaymentChangeUnknownInputDto {
        let result = new CreateTrPaymentChangeUnknownInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["changeNo"] = this.changeNo;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface ICreateTrPaymentChangeUnknownInputDto {
    entityID: number;
    paymentHeaderID: number;
    changeNo: string;
    changeDate: moment.Moment;
    reason: string;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (let item of data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];
}

export class FriendDto implements IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];
}

export class ChatMessageDto implements IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;
}

export class ClosingAccountInputDto implements IClosingAccountInputDto {
    userID: number;
    transactionCutOffDate: moment.Moment;
    isCheckAll: boolean;
    accountData: AccountDto[];

    constructor(data?: IClosingAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.transactionCutOffDate = data["transactionCutOffDate"] ? moment(data["transactionCutOffDate"].toString()) : <any>undefined;
            this.isCheckAll = data["isCheckAll"];
            if (data["accountData"] && data["accountData"].constructor === Array) {
                this.accountData = [];
                for (let item of data["accountData"])
                    this.accountData.push(AccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClosingAccountInputDto {
        let result = new ClosingAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["transactionCutOffDate"] = this.transactionCutOffDate ? this.transactionCutOffDate.toISOString() : <any>undefined;
        data["isCheckAll"] = this.isCheckAll;
        if (this.accountData && this.accountData.constructor === Array) {
            data["accountData"] = [];
            for (let item of this.accountData)
                data["accountData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IClosingAccountInputDto {
    userID: number;
    transactionCutOffDate: moment.Moment;
    isCheckAll: boolean;
    accountData: AccountDto[];
}

export class AccountDto implements IAccountDto {
    accountID: number;
    accountCode: string;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.accountCode = data["accountCode"];
        }
    }

    static fromJS(data: any): AccountDto {
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["accountCode"] = this.accountCode;
        return data; 
    }
}

export interface IAccountDto {
    accountID: number;
    accountCode: string;
}

export class LK_GL_INTERFACE implements ILK_GL_INTERFACE {
    id: string;
    status: string;
    seT_OF_BOOKS_ID: number;
    accountinG_DATE: string;
    currencY_CODE: string;
    datE_CREATED: string;
    createD_BY: number;
    actuaL_FLAG: string;
    useR_JE_CATEGORY_NAME: string;
    useR_JE_SOURCE_NAME: string;
    segmenT1: string;
    segmenT2: string;
    segmenT3: string;
    segmenT4: string;
    segmenT5: string;
    segmenT6: string;
    segmenT7: string;
    entereD_DR: number;
    entereD_CR: number;
    transactioN_DATE: string;
    grouP_ID: string;
    lK_ATTRIBUTE1: string;
    lK_ATTRIBUTE2: string;
    lK_ATTRIBUTE3: string;
    lK_ATTRIBUTE4: string;
    lK_ATTRIBUTE5: string;
    lK_ATTRIBUTE6: string;
    acC_CODE: string;
    inpuT_TIME: moment.Moment;
    inpuT_UN: string;
    modiF_TIME: moment.Moment;
    modiF_UN: string;

    constructor(data?: ILK_GL_INTERFACE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
            this.seT_OF_BOOKS_ID = data["seT_OF_BOOKS_ID"];
            this.accountinG_DATE = data["accountinG_DATE"];
            this.currencY_CODE = data["currencY_CODE"];
            this.datE_CREATED = data["datE_CREATED"];
            this.createD_BY = data["createD_BY"];
            this.actuaL_FLAG = data["actuaL_FLAG"];
            this.useR_JE_CATEGORY_NAME = data["useR_JE_CATEGORY_NAME"];
            this.useR_JE_SOURCE_NAME = data["useR_JE_SOURCE_NAME"];
            this.segmenT1 = data["segmenT1"];
            this.segmenT2 = data["segmenT2"];
            this.segmenT3 = data["segmenT3"];
            this.segmenT4 = data["segmenT4"];
            this.segmenT5 = data["segmenT5"];
            this.segmenT6 = data["segmenT6"];
            this.segmenT7 = data["segmenT7"];
            this.entereD_DR = data["entereD_DR"];
            this.entereD_CR = data["entereD_CR"];
            this.transactioN_DATE = data["transactioN_DATE"];
            this.grouP_ID = data["grouP_ID"];
            this.lK_ATTRIBUTE1 = data["lK_ATTRIBUTE1"];
            this.lK_ATTRIBUTE2 = data["lK_ATTRIBUTE2"];
            this.lK_ATTRIBUTE3 = data["lK_ATTRIBUTE3"];
            this.lK_ATTRIBUTE4 = data["lK_ATTRIBUTE4"];
            this.lK_ATTRIBUTE5 = data["lK_ATTRIBUTE5"];
            this.lK_ATTRIBUTE6 = data["lK_ATTRIBUTE6"];
            this.acC_CODE = data["acC_CODE"];
            this.inpuT_TIME = data["inpuT_TIME"] ? moment(data["inpuT_TIME"].toString()) : <any>undefined;
            this.inpuT_UN = data["inpuT_UN"];
            this.modiF_TIME = data["modiF_TIME"] ? moment(data["modiF_TIME"].toString()) : <any>undefined;
            this.modiF_UN = data["modiF_UN"];
        }
    }

    static fromJS(data: any): LK_GL_INTERFACE {
        let result = new LK_GL_INTERFACE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["seT_OF_BOOKS_ID"] = this.seT_OF_BOOKS_ID;
        data["accountinG_DATE"] = this.accountinG_DATE;
        data["currencY_CODE"] = this.currencY_CODE;
        data["datE_CREATED"] = this.datE_CREATED;
        data["createD_BY"] = this.createD_BY;
        data["actuaL_FLAG"] = this.actuaL_FLAG;
        data["useR_JE_CATEGORY_NAME"] = this.useR_JE_CATEGORY_NAME;
        data["useR_JE_SOURCE_NAME"] = this.useR_JE_SOURCE_NAME;
        data["segmenT1"] = this.segmenT1;
        data["segmenT2"] = this.segmenT2;
        data["segmenT3"] = this.segmenT3;
        data["segmenT4"] = this.segmenT4;
        data["segmenT5"] = this.segmenT5;
        data["segmenT6"] = this.segmenT6;
        data["segmenT7"] = this.segmenT7;
        data["entereD_DR"] = this.entereD_DR;
        data["entereD_CR"] = this.entereD_CR;
        data["transactioN_DATE"] = this.transactioN_DATE;
        data["grouP_ID"] = this.grouP_ID;
        data["lK_ATTRIBUTE1"] = this.lK_ATTRIBUTE1;
        data["lK_ATTRIBUTE2"] = this.lK_ATTRIBUTE2;
        data["lK_ATTRIBUTE3"] = this.lK_ATTRIBUTE3;
        data["lK_ATTRIBUTE4"] = this.lK_ATTRIBUTE4;
        data["lK_ATTRIBUTE5"] = this.lK_ATTRIBUTE5;
        data["lK_ATTRIBUTE6"] = this.lK_ATTRIBUTE6;
        data["acC_CODE"] = this.acC_CODE;
        data["inpuT_TIME"] = this.inpuT_TIME ? this.inpuT_TIME.toISOString() : <any>undefined;
        data["inpuT_UN"] = this.inpuT_UN;
        data["modiF_TIME"] = this.modiF_TIME ? this.modiF_TIME.toISOString() : <any>undefined;
        data["modiF_UN"] = this.modiF_UN;
        return data; 
    }
}

export interface ILK_GL_INTERFACE {
    id: string;
    status: string;
    seT_OF_BOOKS_ID: number;
    accountinG_DATE: string;
    currencY_CODE: string;
    datE_CREATED: string;
    createD_BY: number;
    actuaL_FLAG: string;
    useR_JE_CATEGORY_NAME: string;
    useR_JE_SOURCE_NAME: string;
    segmenT1: string;
    segmenT2: string;
    segmenT3: string;
    segmenT4: string;
    segmenT5: string;
    segmenT6: string;
    segmenT7: string;
    entereD_DR: number;
    entereD_CR: number;
    transactioN_DATE: string;
    grouP_ID: string;
    lK_ATTRIBUTE1: string;
    lK_ATTRIBUTE2: string;
    lK_ATTRIBUTE3: string;
    lK_ATTRIBUTE4: string;
    lK_ATTRIBUTE5: string;
    lK_ATTRIBUTE6: string;
    acC_CODE: string;
    inpuT_TIME: moment.Moment;
    inpuT_UN: string;
    modiF_TIME: moment.Moment;
    modiF_UN: string;
}

export class ListResultDtoOfGetAllMsAccountClosingListDto implements IListResultDtoOfGetAllMsAccountClosingListDto {
    items: GetAllMsAccountClosingListDto[];

    constructor(data?: IListResultDtoOfGetAllMsAccountClosingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsAccountClosingListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsAccountClosingListDto {
        let result = new ListResultDtoOfGetAllMsAccountClosingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsAccountClosingListDto {
    items: GetAllMsAccountClosingListDto[];
}

export class GetAllMsAccountClosingListDto implements IGetAllMsAccountClosingListDto {
    accountID: number;
    accountCode: string;
    companyCode: string;
    accountName: string;
    closeDate: moment.Moment;
    closeBy: string;
    userName: string;
    isSystemClosing: boolean;

    constructor(data?: IGetAllMsAccountClosingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.accountCode = data["accountCode"];
            this.companyCode = data["companyCode"];
            this.accountName = data["accountName"];
            this.closeDate = data["closeDate"] ? moment(data["closeDate"].toString()) : <any>undefined;
            this.closeBy = data["closeBy"];
            this.userName = data["userName"];
            this.isSystemClosing = data["isSystemClosing"];
        }
    }

    static fromJS(data: any): GetAllMsAccountClosingListDto {
        let result = new GetAllMsAccountClosingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["accountCode"] = this.accountCode;
        data["companyCode"] = this.companyCode;
        data["accountName"] = this.accountName;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["closeBy"] = this.closeBy;
        data["userName"] = this.userName;
        data["isSystemClosing"] = this.isSystemClosing;
        return data; 
    }
}

export interface IGetAllMsAccountClosingListDto {
    accountID: number;
    accountCode: string;
    companyCode: string;
    accountName: string;
    closeDate: moment.Moment;
    closeBy: string;
    userName: string;
    isSystemClosing: boolean;
}

export class GetDataClosingEmailListDto implements IGetDataClosingEmailListDto {
    accountingDate: string;
    groupID: string;
    accCode: string;
    projectID: number;

    constructor(data?: IGetDataClosingEmailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountingDate = data["accountingDate"];
            this.groupID = data["groupID"];
            this.accCode = data["accCode"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetDataClosingEmailListDto {
        let result = new GetDataClosingEmailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingDate"] = this.accountingDate;
        data["groupID"] = this.groupID;
        data["accCode"] = this.accCode;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetDataClosingEmailListDto {
    accountingDate: string;
    groupID: string;
    accCode: string;
    projectID: number;
}

export class ResendClosingAccountDto implements IResendClosingAccountDto {
    projectCode: string;
    transactionCutOffDate: moment.Moment;

    constructor(data?: IResendClosingAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.transactionCutOffDate = data["transactionCutOffDate"] ? moment(data["transactionCutOffDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResendClosingAccountDto {
        let result = new ResendClosingAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["transactionCutOffDate"] = this.transactionCutOffDate ? this.transactionCutOffDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IResendClosingAccountDto {
    projectCode: string;
    transactionCutOffDate: moment.Moment;
}

export class CreateDeleteSysClosingAccountInputDto implements ICreateDeleteSysClosingAccountInputDto {
    userID: number;
    listSysClosingAccount: number[];

    constructor(data?: ICreateDeleteSysClosingAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            if (data["listSysClosingAccount"] && data["listSysClosingAccount"].constructor === Array) {
                this.listSysClosingAccount = [];
                for (let item of data["listSysClosingAccount"])
                    this.listSysClosingAccount.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeleteSysClosingAccountInputDto {
        let result = new CreateDeleteSysClosingAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        if (this.listSysClosingAccount && this.listSysClosingAccount.constructor === Array) {
            data["listSysClosingAccount"] = [];
            for (let item of this.listSysClosingAccount)
                data["listSysClosingAccount"].push(item);
        }
        return data; 
    }
}

export interface ICreateDeleteSysClosingAccountInputDto {
    userID: number;
    listSysClosingAccount: number[];
}

export class PagedResultDtoOfGetSysClosingAccountListDto implements IPagedResultDtoOfGetSysClosingAccountListDto {
    totalCount: number;
    items: GetSysClosingAccountListDto[];

    constructor(data?: IPagedResultDtoOfGetSysClosingAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSysClosingAccountListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSysClosingAccountListDto {
        let result = new PagedResultDtoOfGetSysClosingAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSysClosingAccountListDto {
    totalCount: number;
    items: GetSysClosingAccountListDto[];
}

export class GetSysClosingAccountListDto implements IGetSysClosingAccountListDto {
    userID: number;
    userName: string;
    listSysClosingAccount: DataSysClosingAccount[];

    constructor(data?: IGetSysClosingAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.userName = data["userName"];
            if (data["listSysClosingAccount"] && data["listSysClosingAccount"].constructor === Array) {
                this.listSysClosingAccount = [];
                for (let item of data["listSysClosingAccount"])
                    this.listSysClosingAccount.push(DataSysClosingAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSysClosingAccountListDto {
        let result = new GetSysClosingAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        if (this.listSysClosingAccount && this.listSysClosingAccount.constructor === Array) {
            data["listSysClosingAccount"] = [];
            for (let item of this.listSysClosingAccount)
                data["listSysClosingAccount"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSysClosingAccountListDto {
    userID: number;
    userName: string;
    listSysClosingAccount: DataSysClosingAccount[];
}

export class DataSysClosingAccount implements IDataSysClosingAccount {
    userID: number;
    accountID: number;
    accountCode: string;
    accountName: string;
    isChecked: boolean;

    constructor(data?: IDataSysClosingAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.accountID = data["accountID"];
            this.accountCode = data["accountCode"];
            this.accountName = data["accountName"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): DataSysClosingAccount {
        let result = new DataSysClosingAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["accountID"] = this.accountID;
        data["accountCode"] = this.accountCode;
        data["accountName"] = this.accountName;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IDataSysClosingAccount {
    userID: number;
    accountID: number;
    accountCode: string;
    accountName: string;
    isChecked: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];
}

export class NameValueDto implements INameValueDto {
    name: string;
    value: string;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string;
    value: string;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string;
}

export class GetCreditAgreementViewDetail implements IGetCreditAgreementViewDetail {
    agreementInformation: GetAgreementInformationDto;
    programDetail: GetProgramDetailListDto[];

    constructor(data?: IGetCreditAgreementViewDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.agreementInformation = data["agreementInformation"] ? GetAgreementInformationDto.fromJS(data["agreementInformation"]) : <any>undefined;
            if (data["programDetail"] && data["programDetail"].constructor === Array) {
                this.programDetail = [];
                for (let item of data["programDetail"])
                    this.programDetail.push(GetProgramDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreditAgreementViewDetail {
        let result = new GetCreditAgreementViewDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementInformation"] = this.agreementInformation ? this.agreementInformation.toJSON() : <any>undefined;
        if (this.programDetail && this.programDetail.constructor === Array) {
            data["programDetail"] = [];
            for (let item of this.programDetail)
                data["programDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCreditAgreementViewDetail {
    agreementInformation: GetAgreementInformationDto;
    programDetail: GetProgramDetailListDto[];
}

export class GetAgreementInformationDto implements IGetAgreementInformationDto {
    creditAgreementID: number;
    projectID: number;
    projectName: string;
    typeID: number;
    typeName: string;
    bankID: number;
    bankDetail: GetBankDetailDto;
    agreementDocsNo: string;
    agreementDocsName: string;
    agreementDocsUrl: string;
    agreementDocsStatus: string;
    agreementDate: moment.Moment;
    agreementStartDate: moment.Moment;
    agreementEndDate: moment.Moment;
    agreementRate: number;
    isActive: boolean;

    constructor(data?: IGetAgreementInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creditAgreementID = data["creditAgreementID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.typeID = data["typeID"];
            this.typeName = data["typeName"];
            this.bankID = data["bankID"];
            this.bankDetail = data["bankDetail"] ? GetBankDetailDto.fromJS(data["bankDetail"]) : <any>undefined;
            this.agreementDocsNo = data["agreementDocsNo"];
            this.agreementDocsName = data["agreementDocsName"];
            this.agreementDocsUrl = data["agreementDocsUrl"];
            this.agreementDocsStatus = data["agreementDocsStatus"];
            this.agreementDate = data["agreementDate"] ? moment(data["agreementDate"].toString()) : <any>undefined;
            this.agreementStartDate = data["agreementStartDate"] ? moment(data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = data["agreementEndDate"] ? moment(data["agreementEndDate"].toString()) : <any>undefined;
            this.agreementRate = data["agreementRate"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAgreementInformationDto {
        let result = new GetAgreementInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditAgreementID"] = this.creditAgreementID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["typeID"] = this.typeID;
        data["typeName"] = this.typeName;
        data["bankID"] = this.bankID;
        data["bankDetail"] = this.bankDetail ? this.bankDetail.toJSON() : <any>undefined;
        data["agreementDocsNo"] = this.agreementDocsNo;
        data["agreementDocsName"] = this.agreementDocsName;
        data["agreementDocsUrl"] = this.agreementDocsUrl;
        data["agreementDocsStatus"] = this.agreementDocsStatus;
        data["agreementDate"] = this.agreementDate ? this.agreementDate.toISOString() : <any>undefined;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["agreementRate"] = this.agreementRate;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAgreementInformationDto {
    creditAgreementID: number;
    projectID: number;
    projectName: string;
    typeID: number;
    typeName: string;
    bankID: number;
    bankDetail: GetBankDetailDto;
    agreementDocsNo: string;
    agreementDocsName: string;
    agreementDocsUrl: string;
    agreementDocsStatus: string;
    agreementDate: moment.Moment;
    agreementStartDate: moment.Moment;
    agreementEndDate: moment.Moment;
    agreementRate: number;
    isActive: boolean;
}

export class GetProgramDetailListDto implements IGetProgramDetailListDto {
    agreementDetailID: number;
    clusterID: number;
    clusterName: string;
    programNo: string;
    programName: string;
    programStartDate: moment.Moment;
    programEndDate: moment.Moment;
    bankRate: number;
    provisiTypeID: number;
    provisiTypeName: string;
    provisiFee: number;
    adminTypeID: number;
    adminTypeName: string;
    adminFee: number;
    addendumNo: string;
    addendumDocs: string;
    addendumDocsUrl: string;
    addendumDocsStatus: string;
    status: boolean;
    programRate: GetProgramRateListDto[];
    retentionDetail: GetRetentionDetailListDto[];
    subsidy: GetSubsidyDto;

    constructor(data?: IGetProgramDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.agreementDetailID = data["agreementDetailID"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.programNo = data["programNo"];
            this.programName = data["programName"];
            this.programStartDate = data["programStartDate"] ? moment(data["programStartDate"].toString()) : <any>undefined;
            this.programEndDate = data["programEndDate"] ? moment(data["programEndDate"].toString()) : <any>undefined;
            this.bankRate = data["bankRate"];
            this.provisiTypeID = data["provisiTypeID"];
            this.provisiTypeName = data["provisiTypeName"];
            this.provisiFee = data["provisiFee"];
            this.adminTypeID = data["adminTypeID"];
            this.adminTypeName = data["adminTypeName"];
            this.adminFee = data["adminFee"];
            this.addendumNo = data["addendumNo"];
            this.addendumDocs = data["addendumDocs"];
            this.addendumDocsUrl = data["addendumDocsUrl"];
            this.addendumDocsStatus = data["addendumDocsStatus"];
            this.status = data["status"];
            if (data["programRate"] && data["programRate"].constructor === Array) {
                this.programRate = [];
                for (let item of data["programRate"])
                    this.programRate.push(GetProgramRateListDto.fromJS(item));
            }
            if (data["retentionDetail"] && data["retentionDetail"].constructor === Array) {
                this.retentionDetail = [];
                for (let item of data["retentionDetail"])
                    this.retentionDetail.push(GetRetentionDetailListDto.fromJS(item));
            }
            this.subsidy = data["subsidy"] ? GetSubsidyDto.fromJS(data["subsidy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramDetailListDto {
        let result = new GetProgramDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementDetailID"] = this.agreementDetailID;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["programNo"] = this.programNo;
        data["programName"] = this.programName;
        data["programStartDate"] = this.programStartDate ? this.programStartDate.toISOString() : <any>undefined;
        data["programEndDate"] = this.programEndDate ? this.programEndDate.toISOString() : <any>undefined;
        data["bankRate"] = this.bankRate;
        data["provisiTypeID"] = this.provisiTypeID;
        data["provisiTypeName"] = this.provisiTypeName;
        data["provisiFee"] = this.provisiFee;
        data["adminTypeID"] = this.adminTypeID;
        data["adminTypeName"] = this.adminTypeName;
        data["adminFee"] = this.adminFee;
        data["addendumNo"] = this.addendumNo;
        data["addendumDocs"] = this.addendumDocs;
        data["addendumDocsUrl"] = this.addendumDocsUrl;
        data["addendumDocsStatus"] = this.addendumDocsStatus;
        data["status"] = this.status;
        if (this.programRate && this.programRate.constructor === Array) {
            data["programRate"] = [];
            for (let item of this.programRate)
                data["programRate"].push(item.toJSON());
        }
        if (this.retentionDetail && this.retentionDetail.constructor === Array) {
            data["retentionDetail"] = [];
            for (let item of this.retentionDetail)
                data["retentionDetail"].push(item.toJSON());
        }
        data["subsidy"] = this.subsidy ? this.subsidy.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetProgramDetailListDto {
    agreementDetailID: number;
    clusterID: number;
    clusterName: string;
    programNo: string;
    programName: string;
    programStartDate: moment.Moment;
    programEndDate: moment.Moment;
    bankRate: number;
    provisiTypeID: number;
    provisiTypeName: string;
    provisiFee: number;
    adminTypeID: number;
    adminTypeName: string;
    adminFee: number;
    addendumNo: string;
    addendumDocs: string;
    addendumDocsUrl: string;
    addendumDocsStatus: string;
    status: boolean;
    programRate: GetProgramRateListDto[];
    retentionDetail: GetRetentionDetailListDto[];
    subsidy: GetSubsidyDto;
}

export class GetBankDetailDto implements IGetBankDetailDto {
    bankDetailID: number;
    bankName: string;
    address: string;
    pic: string;
    phone: string;
    email: string;
    officePhone: string;
    isPriority: boolean;
    isPPOnline: boolean;
    isOB: boolean;

    constructor(data?: IGetBankDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankDetailID = data["bankDetailID"];
            this.bankName = data["bankName"];
            this.address = data["address"];
            this.pic = data["pic"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.officePhone = data["officePhone"];
            this.isPriority = data["isPriority"];
            this.isPPOnline = data["isPPOnline"];
            this.isOB = data["isOB"];
        }
    }

    static fromJS(data: any): GetBankDetailDto {
        let result = new GetBankDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankDetailID"] = this.bankDetailID;
        data["bankName"] = this.bankName;
        data["address"] = this.address;
        data["pic"] = this.pic;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["officePhone"] = this.officePhone;
        data["isPriority"] = this.isPriority;
        data["isPPOnline"] = this.isPPOnline;
        data["isOB"] = this.isOB;
        return data; 
    }
}

export interface IGetBankDetailDto {
    bankDetailID: number;
    bankName: string;
    address: string;
    pic: string;
    phone: string;
    email: string;
    officePhone: string;
    isPriority: boolean;
    isPPOnline: boolean;
    isOB: boolean;
}

export class GetProgramRateListDto implements IGetProgramRateListDto {
    programDetailID: number;
    tenor: number;
    bankRate: number;
    fix: number;

    constructor(data?: IGetProgramRateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programDetailID = data["programDetailID"];
            this.tenor = data["tenor"];
            this.bankRate = data["bankRate"];
            this.fix = data["fix"];
        }
    }

    static fromJS(data: any): GetProgramRateListDto {
        let result = new GetProgramRateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programDetailID"] = this.programDetailID;
        data["tenor"] = this.tenor;
        data["bankRate"] = this.bankRate;
        data["fix"] = this.fix;
        return data; 
    }
}

export interface IGetProgramRateListDto {
    programDetailID: number;
    tenor: number;
    bankRate: number;
    fix: number;
}

export class GetRetentionDetailListDto implements IGetRetentionDetailListDto {
    retentionDetailID: number;
    sortNo: number;
    retentionID: number;
    retentionName: string;
    percentage: number;

    constructor(data?: IGetRetentionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retentionDetailID = data["retentionDetailID"];
            this.sortNo = data["sortNo"];
            this.retentionID = data["retentionID"];
            this.retentionName = data["retentionName"];
            this.percentage = data["percentage"];
        }
    }

    static fromJS(data: any): GetRetentionDetailListDto {
        let result = new GetRetentionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionDetailID"] = this.retentionDetailID;
        data["sortNo"] = this.sortNo;
        data["retentionID"] = this.retentionID;
        data["retentionName"] = this.retentionName;
        data["percentage"] = this.percentage;
        return data; 
    }
}

export interface IGetRetentionDetailListDto {
    retentionDetailID: number;
    sortNo: number;
    retentionID: number;
    retentionName: string;
    percentage: number;
}

export class GetSubsidyDto implements IGetSubsidyDto {
    subsidyID: number;
    value: number;
    typeID: number;
    typeName: string;
    remarks: string;
    isCalculateSI: boolean;

    constructor(data?: IGetSubsidyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subsidyID = data["subsidyID"];
            this.value = data["value"];
            this.typeID = data["typeID"];
            this.typeName = data["typeName"];
            this.remarks = data["remarks"];
            this.isCalculateSI = data["isCalculateSI"];
        }
    }

    static fromJS(data: any): GetSubsidyDto {
        let result = new GetSubsidyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subsidyID"] = this.subsidyID;
        data["value"] = this.value;
        data["typeID"] = this.typeID;
        data["typeName"] = this.typeName;
        data["remarks"] = this.remarks;
        data["isCalculateSI"] = this.isCalculateSI;
        return data; 
    }
}

export interface IGetSubsidyDto {
    subsidyID: number;
    value: number;
    typeID: number;
    typeName: string;
    remarks: string;
    isCalculateSI: boolean;
}

export class PagedResultDtoOfGetCreditAgreementListDto implements IPagedResultDtoOfGetCreditAgreementListDto {
    totalCount: number;
    items: GetCreditAgreementListDto[];

    constructor(data?: IPagedResultDtoOfGetCreditAgreementListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCreditAgreementListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCreditAgreementListDto {
        let result = new PagedResultDtoOfGetCreditAgreementListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCreditAgreementListDto {
    totalCount: number;
    items: GetCreditAgreementListDto[];
}

export class GetCreditAgreementListDto implements IGetCreditAgreementListDto {
    creditAgreementID: number;
    projectID: number;
    projectName: string;
    typeID: number;
    typeName: string;
    bankID: number;
    bankName: string;
    agreementRate: number;
    agreementDocs: string;
    agreementDate: moment.Moment;
    agreementStartDate: moment.Moment;
    agreementEndDate: moment.Moment;
    status: boolean;

    constructor(data?: IGetCreditAgreementListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creditAgreementID = data["creditAgreementID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.typeID = data["typeID"];
            this.typeName = data["typeName"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.agreementRate = data["agreementRate"];
            this.agreementDocs = data["agreementDocs"];
            this.agreementDate = data["agreementDate"] ? moment(data["agreementDate"].toString()) : <any>undefined;
            this.agreementStartDate = data["agreementStartDate"] ? moment(data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = data["agreementEndDate"] ? moment(data["agreementEndDate"].toString()) : <any>undefined;
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetCreditAgreementListDto {
        let result = new GetCreditAgreementListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditAgreementID"] = this.creditAgreementID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["typeID"] = this.typeID;
        data["typeName"] = this.typeName;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["agreementRate"] = this.agreementRate;
        data["agreementDocs"] = this.agreementDocs;
        data["agreementDate"] = this.agreementDate ? this.agreementDate.toISOString() : <any>undefined;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetCreditAgreementListDto {
    creditAgreementID: number;
    projectID: number;
    projectName: string;
    typeID: number;
    typeName: string;
    bankID: number;
    bankName: string;
    agreementRate: number;
    agreementDocs: string;
    agreementDate: moment.Moment;
    agreementStartDate: moment.Moment;
    agreementEndDate: moment.Moment;
    status: boolean;
}

export class GetFeeTypeListDto implements IGetFeeTypeListDto {
    feeTypeID: number;
    feeTypeName: string;
    isActive: boolean;

    constructor(data?: IGetFeeTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.feeTypeID = data["feeTypeID"];
            this.feeTypeName = data["feeTypeName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetFeeTypeListDto {
        let result = new GetFeeTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeTypeID"] = this.feeTypeID;
        data["feeTypeName"] = this.feeTypeName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetFeeTypeListDto {
    feeTypeID: number;
    feeTypeName: string;
    isActive: boolean;
}

export class GetMsBankDto implements IGetMsBankDto {
    bankID: number;
    bankName: string;
    picName: string;
    email: string;
    phone: string;
    address: string;

    constructor(data?: IGetMsBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.picName = data["picName"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): GetMsBankDto {
        let result = new GetMsBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["picName"] = this.picName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        return data; 
    }
}

export interface IGetMsBankDto {
    bankID: number;
    bankName: string;
    picName: string;
    email: string;
    phone: string;
    address: string;
}

export class GetBankDropDownListDto implements IGetBankDropDownListDto {
    bankID: number;
    bankName: string;
    isDefault: boolean;

    constructor(data?: IGetBankDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetBankDropDownListDto {
        let result = new GetBankDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetBankDropDownListDto {
    bankID: number;
    bankName: string;
    isDefault: boolean;
}

export class SignUpMemberInputDto implements ISignUpMemberInputDto {
    memberCode: string;
    email: string;
    birthDate: string;
    password: string;
    confirmPassword: string;

    constructor(data?: ISignUpMemberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.email = data["email"];
            this.birthDate = data["birthDate"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
        }
    }

    static fromJS(data: any): SignUpMemberInputDto {
        let result = new SignUpMemberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data; 
    }
}

export interface ISignUpMemberInputDto {
    memberCode: string;
    email: string;
    birthDate: string;
    password: string;
    confirmPassword: string;
}

export class MemberActivationResultDto implements IMemberActivationResultDto {
    message: string;

    constructor(data?: IMemberActivationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MemberActivationResultDto {
        let result = new MemberActivationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IMemberActivationResultDto {
    message: string;
}

export class NewMemberActivationInputDto implements INewMemberActivationInputDto {
    memberCode: string;
    email: string;
    psCode: string;

    constructor(data?: INewMemberActivationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.email = data["email"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): NewMemberActivationInputDto {
        let result = new NewMemberActivationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["email"] = this.email;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface INewMemberActivationInputDto {
    memberCode: string;
    email: string;
    psCode: string;
}

export class SignUpCustomerInputDto implements ISignUpCustomerInputDto {
    potentialCustID: number;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    psCode: string;
    keypass: string;
    document: DocumentUpload[];

    constructor(data?: ISignUpCustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustID = data["potentialCustID"];
            this.memberCode = data["memberCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"];
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.number = data["number"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.occID = data["occID"];
            this.occDesc = data["occDesc"];
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleDesc = data["jobTitleDesc"];
            this.jobSectorID = data["jobSectorID"];
            this.jobSectorDesc = data["jobSectorDesc"];
            this.univ = data["univ"];
            this.income = data["income"];
            this.psCode = data["psCode"];
            this.keypass = data["keypass"];
            if (data["document"] && data["document"].constructor === Array) {
                this.document = [];
                for (let item of data["document"])
                    this.document.push(DocumentUpload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignUpCustomerInputDto {
        let result = new SignUpCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustID"] = this.potentialCustID;
        data["memberCode"] = this.memberCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["number"] = this.number;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["occID"] = this.occID;
        data["occDesc"] = this.occDesc;
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleDesc"] = this.jobTitleDesc;
        data["jobSectorID"] = this.jobSectorID;
        data["jobSectorDesc"] = this.jobSectorDesc;
        data["univ"] = this.univ;
        data["income"] = this.income;
        data["psCode"] = this.psCode;
        data["keypass"] = this.keypass;
        if (this.document && this.document.constructor === Array) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISignUpCustomerInputDto {
    potentialCustID: number;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    psCode: string;
    keypass: string;
    document: DocumentUpload[];
}

export class DocumentUpload implements IDocumentUpload {
    documentType: string;
    documentBinary: string;

    constructor(data?: IDocumentUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentBinary = data["documentBinary"];
        }
    }

    static fromJS(data: any): DocumentUpload {
        let result = new DocumentUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentBinary"] = this.documentBinary;
        return data; 
    }
}

export interface IDocumentUpload {
    documentType: string;
    documentBinary: string;
}

export class SignUpCustomerResultDto implements ISignUpCustomerResultDto {
    psCode: string;
    message: string;

    constructor(data?: ISignUpCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): SignUpCustomerResultDto {
        let result = new SignUpCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["message"] = this.message;
        return data; 
    }
}

export interface ISignUpCustomerResultDto {
    psCode: string;
    message: string;
}

export class ListResultDtoOfListCustomerResultDto implements IListResultDtoOfListCustomerResultDto {
    items: ListCustomerResultDto[];

    constructor(data?: IListResultDtoOfListCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListCustomerResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListCustomerResultDto {
        let result = new ListResultDtoOfListCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListCustomerResultDto {
    items: ListCustomerResultDto[];
}

export class ListCustomerResultDto implements IListCustomerResultDto {
    potentialCustID: number;
    psCode: string;
    name: string;
    birthDate: moment.Moment;
    ktp: string;
    ktP4: string;
    email: string;
    phone: string;
    isPersonals: boolean;
    result: boolean;
    message: string;
    phoneTime: moment.Moment;
    ktpTime: moment.Moment;
    creatorUserId: number;
    creationTime: moment.Moment;

    constructor(data?: IListCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustID = data["potentialCustID"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.ktp = data["ktp"];
            this.ktP4 = data["ktP4"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.isPersonals = data["isPersonals"];
            this.result = data["result"];
            this.message = data["message"];
            this.phoneTime = data["phoneTime"] ? moment(data["phoneTime"].toString()) : <any>undefined;
            this.ktpTime = data["ktpTime"] ? moment(data["ktpTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListCustomerResultDto {
        let result = new ListCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustID"] = this.potentialCustID;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["ktp"] = this.ktp;
        data["ktP4"] = this.ktP4;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isPersonals"] = this.isPersonals;
        data["result"] = this.result;
        data["message"] = this.message;
        data["phoneTime"] = this.phoneTime ? this.phoneTime.toISOString() : <any>undefined;
        data["ktpTime"] = this.ktpTime ? this.ktpTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IListCustomerResultDto {
    potentialCustID: number;
    psCode: string;
    name: string;
    birthDate: moment.Moment;
    ktp: string;
    ktP4: string;
    email: string;
    phone: string;
    isPersonals: boolean;
    result: boolean;
    message: string;
    phoneTime: moment.Moment;
    ktpTime: moment.Moment;
    creatorUserId: number;
    creationTime: moment.Moment;
}

export class ListOccupationsDto implements IListOccupationsDto {
    occID: string;
    occDesc: string;

    constructor(data?: IListOccupationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.occID = data["occID"];
            this.occDesc = data["occDesc"];
        }
    }

    static fromJS(data: any): ListOccupationsDto {
        let result = new ListOccupationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occID"] = this.occID;
        data["occDesc"] = this.occDesc;
        return data; 
    }
}

export interface IListOccupationsDto {
    occID: string;
    occDesc: string;
}

export class ListJobTitleDto implements IListJobTitleDto {
    jobTitleID: string;
    jobTitleDesc: string;

    constructor(data?: IListJobTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleDesc = data["jobTitleDesc"];
        }
    }

    static fromJS(data: any): ListJobTitleDto {
        let result = new ListJobTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleDesc"] = this.jobTitleDesc;
        return data; 
    }
}

export interface IListJobTitleDto {
    jobTitleID: string;
    jobTitleDesc: string;
}

export class ListJobSectorDto implements IListJobSectorDto {
    jobSectorID: number;
    jobSectorDesc: string;

    constructor(data?: IListJobSectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobSectorID = data["jobSectorID"];
            this.jobSectorDesc = data["jobSectorDesc"];
        }
    }

    static fromJS(data: any): ListJobSectorDto {
        let result = new ListJobSectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSectorID"] = this.jobSectorID;
        data["jobSectorDesc"] = this.jobSectorDesc;
        return data; 
    }
}

export interface IListJobSectorDto {
    jobSectorID: number;
    jobSectorDesc: string;
}

export class ListIncomeDto implements IListIncomeDto {
    incomeID: number;
    incomeDesc: string;

    constructor(data?: IListIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.incomeID = data["incomeID"];
            this.incomeDesc = data["incomeDesc"];
        }
    }

    static fromJS(data: any): ListIncomeDto {
        let result = new ListIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeID"] = this.incomeID;
        data["incomeDesc"] = this.incomeDesc;
        return data; 
    }
}

export interface IListIncomeDto {
    incomeID: number;
    incomeDesc: string;
}

export class ListNationResultDto implements IListNationResultDto {
    nationID: string;
    nationality: string;

    constructor(data?: IListNationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nationID = data["nationID"];
            this.nationality = data["nationality"];
        }
    }

    static fromJS(data: any): ListNationResultDto {
        let result = new ListNationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationID"] = this.nationID;
        data["nationality"] = this.nationality;
        return data; 
    }
}

export interface IListNationResultDto {
    nationID: string;
    nationality: string;
}

export class ListPostCodeResultDto implements IListPostCodeResultDto {
    postCode: string;

    constructor(data?: IListPostCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postCode = data["postCode"];
        }
    }

    static fromJS(data: any): ListPostCodeResultDto {
        let result = new ListPostCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        return data; 
    }
}

export interface IListPostCodeResultDto {
    postCode: string;
}

export class ListCountryResultDto implements IListCountryResultDto {
    country: string;
    urut: number;

    constructor(data?: IListCountryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.urut = data["urut"];
        }
    }

    static fromJS(data: any): ListCountryResultDto {
        let result = new ListCountryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["urut"] = this.urut;
        return data; 
    }
}

export interface IListCountryResultDto {
    country: string;
    urut: number;
}

export class ListCityResultDto implements IListCityResultDto {
    cityCode: string;
    cityName: string;
    provinceCode: string;

    constructor(data?: IListCityResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cityCode = data["cityCode"];
            this.cityName = data["cityName"];
            this.provinceCode = data["provinceCode"];
        }
    }

    static fromJS(data: any): ListCityResultDto {
        let result = new ListCityResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityCode"] = this.cityCode;
        data["cityName"] = this.cityName;
        data["provinceCode"] = this.provinceCode;
        return data; 
    }
}

export interface IListCityResultDto {
    cityCode: string;
    cityName: string;
    provinceCode: string;
}

export class DetailCustomerResultDto implements IDetailCustomerResultDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    city: string;
    postCode: string;
    phone: string;
    email: string;
    marCode: string;
    province: string;
    cityCode: string;
    provinceCode: string;
    occID: string;
    univDesc: string;
    occDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    incomeID: number;
    message: string;
    documentImages: DocumentImage[];

    constructor(data?: IDetailCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.province = data["province"];
            this.cityCode = data["cityCode"];
            this.provinceCode = data["provinceCode"];
            this.occID = data["occID"];
            this.univDesc = data["univDesc"];
            this.occDesc = data["occDesc"];
            this.jobSectorID = data["jobSectorID"];
            this.jobSectorDesc = data["jobSectorDesc"];
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleDesc = data["jobTitleDesc"];
            this.incomeID = data["incomeID"];
            this.message = data["message"];
            if (data["documentImages"] && data["documentImages"].constructor === Array) {
                this.documentImages = [];
                for (let item of data["documentImages"])
                    this.documentImages.push(DocumentImage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DetailCustomerResultDto {
        let result = new DetailCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["province"] = this.province;
        data["cityCode"] = this.cityCode;
        data["provinceCode"] = this.provinceCode;
        data["occID"] = this.occID;
        data["univDesc"] = this.univDesc;
        data["occDesc"] = this.occDesc;
        data["jobSectorID"] = this.jobSectorID;
        data["jobSectorDesc"] = this.jobSectorDesc;
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleDesc"] = this.jobTitleDesc;
        data["incomeID"] = this.incomeID;
        data["message"] = this.message;
        if (this.documentImages && this.documentImages.constructor === Array) {
            data["documentImages"] = [];
            for (let item of this.documentImages)
                data["documentImages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDetailCustomerResultDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    city: string;
    postCode: string;
    phone: string;
    email: string;
    marCode: string;
    province: string;
    cityCode: string;
    provinceCode: string;
    occID: string;
    univDesc: string;
    occDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    incomeID: number;
    message: string;
    documentImages: DocumentImage[];
}

export class DocumentImage implements IDocumentImage {
    documentType: string;
    documentImage: string;

    constructor(data?: IDocumentImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentImage = data["documentImage"];
        }
    }

    static fromJS(data: any): DocumentImage {
        let result = new DocumentImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentImage"] = this.documentImage;
        return data; 
    }
}

export interface IDocumentImage {
    documentType: string;
    documentImage: string;
}

export class UpdateCustomerInputDto implements IUpdateCustomerInputDto {
    psCode: string;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    document: DocumentUpload[];

    constructor(data?: IUpdateCustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"];
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.number = data["number"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.occID = data["occID"];
            this.occDesc = data["occDesc"];
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleDesc = data["jobTitleDesc"];
            this.jobSectorID = data["jobSectorID"];
            this.jobSectorDesc = data["jobSectorDesc"];
            this.univ = data["univ"];
            this.income = data["income"];
            if (data["document"] && data["document"].constructor === Array) {
                this.document = [];
                for (let item of data["document"])
                    this.document.push(DocumentUpload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomerInputDto {
        let result = new UpdateCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["number"] = this.number;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["occID"] = this.occID;
        data["occDesc"] = this.occDesc;
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleDesc"] = this.jobTitleDesc;
        data["jobSectorID"] = this.jobSectorID;
        data["jobSectorDesc"] = this.jobSectorDesc;
        data["univ"] = this.univ;
        data["income"] = this.income;
        if (this.document && this.document.constructor === Array) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateCustomerInputDto {
    psCode: string;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    document: DocumentUpload[];
}

export class ListDocumentResultDto implements IListDocumentResultDto {
    documentType: string;
    document: string;
    message: string;

    constructor(data?: IListDocumentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.document = data["document"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListDocumentResultDto {
        let result = new ListDocumentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["document"] = this.document;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListDocumentResultDto {
    documentType: string;
    document: string;
    message: string;
}

export class DetailCustomerMobileResultDto implements IDetailCustomerMobileResultDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    documentTypeKTP: string;
    documentBinaryKTP: string;
    documentTypeNPWP: string;
    documentBinaryNPWP: string;
    documentTypeKK: string;
    documentBinaryKK: string;
    documentTypeKTPPasangan: string;
    documentBinaryKTPPasangan: string;
    documentTypePassport: string;
    documentBinaryPassport: string;
    documentTypeAkte: string;
    documentBinaryAkte: string;
    documentTypeNPWPPerusahaan: string;
    documentBinaryNPWPPerusahaan: string;
    documentTypeKTPDireksi: string;
    documentBinaryKTPDireksi: string;
    documentTypeTDP: string;
    documentBinaryTDP: string;
    message: string;

    constructor(data?: IDetailCustomerMobileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.number = data["number"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.documentTypeKTP = data["documentTypeKTP"];
            this.documentBinaryKTP = data["documentBinaryKTP"];
            this.documentTypeNPWP = data["documentTypeNPWP"];
            this.documentBinaryNPWP = data["documentBinaryNPWP"];
            this.documentTypeKK = data["documentTypeKK"];
            this.documentBinaryKK = data["documentBinaryKK"];
            this.documentTypeKTPPasangan = data["documentTypeKTPPasangan"];
            this.documentBinaryKTPPasangan = data["documentBinaryKTPPasangan"];
            this.documentTypePassport = data["documentTypePassport"];
            this.documentBinaryPassport = data["documentBinaryPassport"];
            this.documentTypeAkte = data["documentTypeAkte"];
            this.documentBinaryAkte = data["documentBinaryAkte"];
            this.documentTypeNPWPPerusahaan = data["documentTypeNPWPPerusahaan"];
            this.documentBinaryNPWPPerusahaan = data["documentBinaryNPWPPerusahaan"];
            this.documentTypeKTPDireksi = data["documentTypeKTPDireksi"];
            this.documentBinaryKTPDireksi = data["documentBinaryKTPDireksi"];
            this.documentTypeTDP = data["documentTypeTDP"];
            this.documentBinaryTDP = data["documentBinaryTDP"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): DetailCustomerMobileResultDto {
        let result = new DetailCustomerMobileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["number"] = this.number;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["documentTypeKTP"] = this.documentTypeKTP;
        data["documentBinaryKTP"] = this.documentBinaryKTP;
        data["documentTypeNPWP"] = this.documentTypeNPWP;
        data["documentBinaryNPWP"] = this.documentBinaryNPWP;
        data["documentTypeKK"] = this.documentTypeKK;
        data["documentBinaryKK"] = this.documentBinaryKK;
        data["documentTypeKTPPasangan"] = this.documentTypeKTPPasangan;
        data["documentBinaryKTPPasangan"] = this.documentBinaryKTPPasangan;
        data["documentTypePassport"] = this.documentTypePassport;
        data["documentBinaryPassport"] = this.documentBinaryPassport;
        data["documentTypeAkte"] = this.documentTypeAkte;
        data["documentBinaryAkte"] = this.documentBinaryAkte;
        data["documentTypeNPWPPerusahaan"] = this.documentTypeNPWPPerusahaan;
        data["documentBinaryNPWPPerusahaan"] = this.documentBinaryNPWPPerusahaan;
        data["documentTypeKTPDireksi"] = this.documentTypeKTPDireksi;
        data["documentBinaryKTPDireksi"] = this.documentBinaryKTPDireksi;
        data["documentTypeTDP"] = this.documentTypeTDP;
        data["documentBinaryTDP"] = this.documentBinaryTDP;
        data["message"] = this.message;
        return data; 
    }
}

export interface IDetailCustomerMobileResultDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    documentTypeKTP: string;
    documentBinaryKTP: string;
    documentTypeNPWP: string;
    documentBinaryNPWP: string;
    documentTypeKK: string;
    documentBinaryKK: string;
    documentTypeKTPPasangan: string;
    documentBinaryKTPPasangan: string;
    documentTypePassport: string;
    documentBinaryPassport: string;
    documentTypeAkte: string;
    documentBinaryAkte: string;
    documentTypeNPWPPerusahaan: string;
    documentBinaryNPWPPerusahaan: string;
    documentTypeKTPDireksi: string;
    documentBinaryKTPDireksi: string;
    documentTypeTDP: string;
    documentBinaryTDP: string;
    message: string;
}

export class ListProvinceResultDto implements IListProvinceResultDto {
    provinceCode: string;
    provinceName: string;

    constructor(data?: IListProvinceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): ListProvinceResultDto {
        let result = new ListProvinceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface IListProvinceResultDto {
    provinceCode: string;
    provinceName: string;
}

export class GetListMaritalStatusResultDto implements IGetListMaritalStatusResultDto {
    marStatus: string;
    marStatusName: string;

    constructor(data?: IGetListMaritalStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.marStatus = data["marStatus"];
            this.marStatusName = data["marStatusName"];
        }
    }

    static fromJS(data: any): GetListMaritalStatusResultDto {
        let result = new GetListMaritalStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marStatus"] = this.marStatus;
        data["marStatusName"] = this.marStatusName;
        return data; 
    }
}

export interface IGetListMaritalStatusResultDto {
    marStatus: string;
    marStatusName: string;
}

export class CheckLoginResultDto implements ICheckLoginResultDto {
    result: boolean;

    constructor(data?: ICheckLoginResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
        }
    }

    static fromJS(data: any): CheckLoginResultDto {
        let result = new CheckLoginResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data; 
    }
}

export interface ICheckLoginResultDto {
    result: boolean;
}

export class CheckLoginMobileInputDto implements ICheckLoginMobileInputDto {
    memberCode: string;
    domainLogin: string;

    constructor(data?: ICheckLoginMobileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.domainLogin = data["domainLogin"];
        }
    }

    static fromJS(data: any): CheckLoginMobileInputDto {
        let result = new CheckLoginMobileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["domainLogin"] = this.domainLogin;
        return data; 
    }
}

export interface ICheckLoginMobileInputDto {
    memberCode: string;
    domainLogin: string;
}

export class GetDropdownOccupationResultDto implements IGetDropdownOccupationResultDto {
    occupationDesc: string;
    occupationID: string;

    constructor(data?: IGetDropdownOccupationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.occupationDesc = data["occupationDesc"];
            this.occupationID = data["occupationID"];
        }
    }

    static fromJS(data: any): GetDropdownOccupationResultDto {
        let result = new GetDropdownOccupationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupationDesc"] = this.occupationDesc;
        data["occupationID"] = this.occupationID;
        return data; 
    }
}

export interface IGetDropdownOccupationResultDto {
    occupationDesc: string;
    occupationID: string;
}

export class CreateUpdateCustomerInputDto implements ICreateUpdateCustomerInputDto {
    potentialCustID: number;
    psCode: string;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    document: DocumentUpload[];

    constructor(data?: ICreateUpdateCustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustID = data["potentialCustID"];
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"];
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.number = data["number"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.occID = data["occID"];
            this.occDesc = data["occDesc"];
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleDesc = data["jobTitleDesc"];
            this.jobSectorID = data["jobSectorID"];
            this.jobSectorDesc = data["jobSectorDesc"];
            this.univ = data["univ"];
            this.income = data["income"];
            if (data["document"] && data["document"].constructor === Array) {
                this.document = [];
                for (let item of data["document"])
                    this.document.push(DocumentUpload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateCustomerInputDto {
        let result = new CreateUpdateCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustID"] = this.potentialCustID;
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["number"] = this.number;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["occID"] = this.occID;
        data["occDesc"] = this.occDesc;
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleDesc"] = this.jobTitleDesc;
        data["jobSectorID"] = this.jobSectorID;
        data["jobSectorDesc"] = this.jobSectorDesc;
        data["univ"] = this.univ;
        data["income"] = this.income;
        if (this.document && this.document.constructor === Array) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUpdateCustomerInputDto {
    potentialCustID: number;
    psCode: string;
    memberCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: string;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    occID: string;
    occDesc: string;
    jobTitleID: string;
    jobTitleDesc: string;
    jobSectorID: number;
    jobSectorDesc: string;
    univ: string;
    income: number;
    document: DocumentUpload[];
}

export class GetListMemberTreeResultDto implements IGetListMemberTreeResultDto {
    memberCode: string;
    memberName: string;
    memberStatusCode: string;
    memberStatusName: string;
    totalBooking: number;
    parentMember1: string;
    statusMember1: string;
    memberName1: string;
    statusName1: string;
    parentMember2: string;
    statusMember2: string;
    memberName2: string;
    statusName2: string;
    parentMember3: string;
    statusMember3: string;
    memberName3: string;
    statusName3: string;
    parentMember4: string;
    statusMember4: string;
    memberName4: string;
    statusName4: string;
    childMember1: ChildMember1Dto[];

    constructor(data?: IGetListMemberTreeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.memberStatusCode = data["memberStatusCode"];
            this.memberStatusName = data["memberStatusName"];
            this.totalBooking = data["totalBooking"];
            this.parentMember1 = data["parentMember1"];
            this.statusMember1 = data["statusMember1"];
            this.memberName1 = data["memberName1"];
            this.statusName1 = data["statusName1"];
            this.parentMember2 = data["parentMember2"];
            this.statusMember2 = data["statusMember2"];
            this.memberName2 = data["memberName2"];
            this.statusName2 = data["statusName2"];
            this.parentMember3 = data["parentMember3"];
            this.statusMember3 = data["statusMember3"];
            this.memberName3 = data["memberName3"];
            this.statusName3 = data["statusName3"];
            this.parentMember4 = data["parentMember4"];
            this.statusMember4 = data["statusMember4"];
            this.memberName4 = data["memberName4"];
            this.statusName4 = data["statusName4"];
            if (data["childMember1"] && data["childMember1"].constructor === Array) {
                this.childMember1 = [];
                for (let item of data["childMember1"])
                    this.childMember1.push(ChildMember1Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListMemberTreeResultDto {
        let result = new GetListMemberTreeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["memberStatusCode"] = this.memberStatusCode;
        data["memberStatusName"] = this.memberStatusName;
        data["totalBooking"] = this.totalBooking;
        data["parentMember1"] = this.parentMember1;
        data["statusMember1"] = this.statusMember1;
        data["memberName1"] = this.memberName1;
        data["statusName1"] = this.statusName1;
        data["parentMember2"] = this.parentMember2;
        data["statusMember2"] = this.statusMember2;
        data["memberName2"] = this.memberName2;
        data["statusName2"] = this.statusName2;
        data["parentMember3"] = this.parentMember3;
        data["statusMember3"] = this.statusMember3;
        data["memberName3"] = this.memberName3;
        data["statusName3"] = this.statusName3;
        data["parentMember4"] = this.parentMember4;
        data["statusMember4"] = this.statusMember4;
        data["memberName4"] = this.memberName4;
        data["statusName4"] = this.statusName4;
        if (this.childMember1 && this.childMember1.constructor === Array) {
            data["childMember1"] = [];
            for (let item of this.childMember1)
                data["childMember1"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListMemberTreeResultDto {
    memberCode: string;
    memberName: string;
    memberStatusCode: string;
    memberStatusName: string;
    totalBooking: number;
    parentMember1: string;
    statusMember1: string;
    memberName1: string;
    statusName1: string;
    parentMember2: string;
    statusMember2: string;
    memberName2: string;
    statusName2: string;
    parentMember3: string;
    statusMember3: string;
    memberName3: string;
    statusName3: string;
    parentMember4: string;
    statusMember4: string;
    memberName4: string;
    statusName4: string;
    childMember1: ChildMember1Dto[];
}

export class ChildMember1Dto implements IChildMember1Dto {
    childMember1: string;
    statusMember1: string;
    memberName1: string;
    statusName1: string;
    scmCode1: string;
    totalBooking: number;
    childMember2: ChildMember2Dto[];

    constructor(data?: IChildMember1Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childMember1 = data["childMember1"];
            this.statusMember1 = data["statusMember1"];
            this.memberName1 = data["memberName1"];
            this.statusName1 = data["statusName1"];
            this.scmCode1 = data["scmCode1"];
            this.totalBooking = data["totalBooking"];
            if (data["childMember2"] && data["childMember2"].constructor === Array) {
                this.childMember2 = [];
                for (let item of data["childMember2"])
                    this.childMember2.push(ChildMember2Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChildMember1Dto {
        let result = new ChildMember1Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childMember1"] = this.childMember1;
        data["statusMember1"] = this.statusMember1;
        data["memberName1"] = this.memberName1;
        data["statusName1"] = this.statusName1;
        data["scmCode1"] = this.scmCode1;
        data["totalBooking"] = this.totalBooking;
        if (this.childMember2 && this.childMember2.constructor === Array) {
            data["childMember2"] = [];
            for (let item of this.childMember2)
                data["childMember2"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChildMember1Dto {
    childMember1: string;
    statusMember1: string;
    memberName1: string;
    statusName1: string;
    scmCode1: string;
    totalBooking: number;
    childMember2: ChildMember2Dto[];
}

export class ChildMember2Dto implements IChildMember2Dto {
    childMember2: string;
    statusMember2: string;
    memberName2: string;
    statusName2: string;
    scmCode2: string;
    totalBooking: number;
    childMember3: ChildMember3Dto[];

    constructor(data?: IChildMember2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childMember2 = data["childMember2"];
            this.statusMember2 = data["statusMember2"];
            this.memberName2 = data["memberName2"];
            this.statusName2 = data["statusName2"];
            this.scmCode2 = data["scmCode2"];
            this.totalBooking = data["totalBooking"];
            if (data["childMember3"] && data["childMember3"].constructor === Array) {
                this.childMember3 = [];
                for (let item of data["childMember3"])
                    this.childMember3.push(ChildMember3Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChildMember2Dto {
        let result = new ChildMember2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childMember2"] = this.childMember2;
        data["statusMember2"] = this.statusMember2;
        data["memberName2"] = this.memberName2;
        data["statusName2"] = this.statusName2;
        data["scmCode2"] = this.scmCode2;
        data["totalBooking"] = this.totalBooking;
        if (this.childMember3 && this.childMember3.constructor === Array) {
            data["childMember3"] = [];
            for (let item of this.childMember3)
                data["childMember3"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChildMember2Dto {
    childMember2: string;
    statusMember2: string;
    memberName2: string;
    statusName2: string;
    scmCode2: string;
    totalBooking: number;
    childMember3: ChildMember3Dto[];
}

export class ChildMember3Dto implements IChildMember3Dto {
    childMember3: string;
    statusMember3: string;
    memberName3: string;
    statusName3: string;
    scmCode3: string;
    totalBooking: number;
    childMember4: ChildMember4Dto[];

    constructor(data?: IChildMember3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childMember3 = data["childMember3"];
            this.statusMember3 = data["statusMember3"];
            this.memberName3 = data["memberName3"];
            this.statusName3 = data["statusName3"];
            this.scmCode3 = data["scmCode3"];
            this.totalBooking = data["totalBooking"];
            if (data["childMember4"] && data["childMember4"].constructor === Array) {
                this.childMember4 = [];
                for (let item of data["childMember4"])
                    this.childMember4.push(ChildMember4Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChildMember3Dto {
        let result = new ChildMember3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childMember3"] = this.childMember3;
        data["statusMember3"] = this.statusMember3;
        data["memberName3"] = this.memberName3;
        data["statusName3"] = this.statusName3;
        data["scmCode3"] = this.scmCode3;
        data["totalBooking"] = this.totalBooking;
        if (this.childMember4 && this.childMember4.constructor === Array) {
            data["childMember4"] = [];
            for (let item of this.childMember4)
                data["childMember4"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChildMember3Dto {
    childMember3: string;
    statusMember3: string;
    memberName3: string;
    statusName3: string;
    scmCode3: string;
    totalBooking: number;
    childMember4: ChildMember4Dto[];
}

export class ChildMember4Dto implements IChildMember4Dto {
    childMember4: string;
    statusMember4: string;
    memberName4: string;
    statusName4: string;
    scmCode4: string;
    totalBooking: number;

    constructor(data?: IChildMember4Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childMember4 = data["childMember4"];
            this.statusMember4 = data["statusMember4"];
            this.memberName4 = data["memberName4"];
            this.statusName4 = data["statusName4"];
            this.scmCode4 = data["scmCode4"];
            this.totalBooking = data["totalBooking"];
        }
    }

    static fromJS(data: any): ChildMember4Dto {
        let result = new ChildMember4Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childMember4"] = this.childMember4;
        data["statusMember4"] = this.statusMember4;
        data["memberName4"] = this.memberName4;
        data["statusName4"] = this.statusName4;
        data["scmCode4"] = this.scmCode4;
        data["totalBooking"] = this.totalBooking;
        return data; 
    }
}

export interface IChildMember4Dto {
    childMember4: string;
    statusMember4: string;
    memberName4: string;
    statusName4: string;
    scmCode4: string;
    totalBooking: number;
}

export class SignUpSalesInputDto implements ISignUpSalesInputDto {
    name: string;
    npwp: string;
    address: string;
    birthPlace: string;
    nationID: string;
    number: string;
    email: string;
    birthDate: string;
    idNo: string;

    constructor(data?: ISignUpSalesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.address = data["address"];
            this.birthPlace = data["birthPlace"];
            this.nationID = data["nationID"];
            this.number = data["number"];
            this.email = data["email"];
            this.birthDate = data["birthDate"];
            this.idNo = data["idNo"];
        }
    }

    static fromJS(data: any): SignUpSalesInputDto {
        let result = new SignUpSalesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["address"] = this.address;
        data["birthPlace"] = this.birthPlace;
        data["nationID"] = this.nationID;
        data["number"] = this.number;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate;
        data["idNo"] = this.idNo;
        return data; 
    }
}

export interface ISignUpSalesInputDto {
    name: string;
    npwp: string;
    address: string;
    birthPlace: string;
    nationID: string;
    number: string;
    email: string;
    birthDate: string;
    idNo: string;
}

export class CreateMemberDto implements ICreateMemberDto {
    psCode: string;
    scmCode: string;
    memberCode: string;
    levelCode: string;
    parentMemberCode: string;
    memberBankData: CreateMemberBankDataDto;

    constructor(data?: ICreateMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.levelCode = data["levelCode"];
            this.parentMemberCode = data["parentMemberCode"];
            this.memberBankData = data["memberBankData"] ? CreateMemberBankDataDto.fromJS(data["memberBankData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMemberDto {
        let result = new CreateMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["levelCode"] = this.levelCode;
        data["parentMemberCode"] = this.parentMemberCode;
        data["memberBankData"] = this.memberBankData ? this.memberBankData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateMemberDto {
    psCode: string;
    scmCode: string;
    memberCode: string;
    levelCode: string;
    parentMemberCode: string;
    memberBankData: CreateMemberBankDataDto;
}

export class CreateMemberBankDataDto implements ICreateMemberBankDataDto {
    bankType: string;
    bankCode: string;
    bankAccNo: string;
    bankAccName: string;
    bankBranchName: string;
    bankAccountRefID: number;

    constructor(data?: ICreateMemberBankDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankType = data["bankType"];
            this.bankCode = data["bankCode"];
            this.bankAccNo = data["bankAccNo"];
            this.bankAccName = data["bankAccName"];
            this.bankBranchName = data["bankBranchName"];
            this.bankAccountRefID = data["bankAccountRefID"];
        }
    }

    static fromJS(data: any): CreateMemberBankDataDto {
        let result = new CreateMemberBankDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankType"] = this.bankType;
        data["bankCode"] = this.bankCode;
        data["bankAccNo"] = this.bankAccNo;
        data["bankAccName"] = this.bankAccName;
        data["bankBranchName"] = this.bankBranchName;
        data["bankAccountRefID"] = this.bankAccountRefID;
        return data; 
    }
}

export interface ICreateMemberBankDataDto {
    bankType: string;
    bankCode: string;
    bankAccNo: string;
    bankAccName: string;
    bankBranchName: string;
    bankAccountRefID: number;
}

export class AutoMemberActivationInputDto implements IAutoMemberActivationInputDto {
    name: string;
    adress: string;
    phoneNumber: string;
    email: string;
    agentOffice: string;
    branch: string;
    idNumber: string;
    levelCode: string;

    constructor(data?: IAutoMemberActivationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.adress = data["adress"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.agentOffice = data["agentOffice"];
            this.branch = data["branch"];
            this.idNumber = data["idNumber"];
            this.levelCode = data["levelCode"];
        }
    }

    static fromJS(data: any): AutoMemberActivationInputDto {
        let result = new AutoMemberActivationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["adress"] = this.adress;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["agentOffice"] = this.agentOffice;
        data["branch"] = this.branch;
        data["idNumber"] = this.idNumber;
        data["levelCode"] = this.levelCode;
        return data; 
    }
}

export interface IAutoMemberActivationInputDto {
    name: string;
    adress: string;
    phoneNumber: string;
    email: string;
    agentOffice: string;
    branch: string;
    idNumber: string;
    levelCode: string;
}

export class GetListSalesManagementResultDto implements IGetListSalesManagementResultDto {
    listPotentialCustomer: ListPotentialCustomerDto[];
    listCustomer: ListCustomerDto[];

    constructor(data?: IGetListSalesManagementResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listPotentialCustomer"] && data["listPotentialCustomer"].constructor === Array) {
                this.listPotentialCustomer = [];
                for (let item of data["listPotentialCustomer"])
                    this.listPotentialCustomer.push(ListPotentialCustomerDto.fromJS(item));
            }
            if (data["listCustomer"] && data["listCustomer"].constructor === Array) {
                this.listCustomer = [];
                for (let item of data["listCustomer"])
                    this.listCustomer.push(ListCustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListSalesManagementResultDto {
        let result = new GetListSalesManagementResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listPotentialCustomer && this.listPotentialCustomer.constructor === Array) {
            data["listPotentialCustomer"] = [];
            for (let item of this.listPotentialCustomer)
                data["listPotentialCustomer"].push(item.toJSON());
        }
        if (this.listCustomer && this.listCustomer.constructor === Array) {
            data["listCustomer"] = [];
            for (let item of this.listCustomer)
                data["listCustomer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListSalesManagementResultDto {
    listPotentialCustomer: ListPotentialCustomerDto[];
    listCustomer: ListCustomerDto[];
}

export class ListPotentialCustomerDto implements IListPotentialCustomerDto {
    potentialCustID: number;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;
    referredBy: string;
    remarks: string;
    status: string;

    constructor(data?: IListPotentialCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustID = data["potentialCustID"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.referredBy = data["referredBy"];
            this.remarks = data["remarks"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ListPotentialCustomerDto {
        let result = new ListPotentialCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustID"] = this.potentialCustID;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["referredBy"] = this.referredBy;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        return data; 
    }
}

export interface IListPotentialCustomerDto {
    potentialCustID: number;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;
    referredBy: string;
    remarks: string;
    status: string;
}

export class ListCustomerDto implements IListCustomerDto {
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;

    constructor(data?: IListCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListCustomerDto {
        let result = new ListCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IListCustomerDto {
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;
}

export class CreateLeadManagementInputDto implements ICreateLeadManagementInputDto {
    potentialCustID: number;
    name: string;
    birthDate: moment.Moment;
    phoneNumber: string;
    email: string;
    referredBy: string;
    remarks: string;
    status: string;
    memberCode: string;

    constructor(data?: ICreateLeadManagementInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustID = data["potentialCustID"];
            this.name = data["name"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.referredBy = data["referredBy"];
            this.remarks = data["remarks"];
            this.status = data["status"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): CreateLeadManagementInputDto {
        let result = new CreateLeadManagementInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustID"] = this.potentialCustID;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["referredBy"] = this.referredBy;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface ICreateLeadManagementInputDto {
    potentialCustID: number;
    name: string;
    birthDate: moment.Moment;
    phoneNumber: string;
    email: string;
    referredBy: string;
    remarks: string;
    status: string;
    memberCode: string;
}

export class GetListLevelResultDto implements IGetListLevelResultDto {
    levelName: string;
    levelCode: string;

    constructor(data?: IGetListLevelResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.levelName = data["levelName"];
            this.levelCode = data["levelCode"];
        }
    }

    static fromJS(data: any): GetListLevelResultDto {
        let result = new GetListLevelResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["levelCode"] = this.levelCode;
        return data; 
    }
}

export interface IGetListLevelResultDto {
    levelName: string;
    levelCode: string;
}

export class GetListCustomerResultDto implements IGetListCustomerResultDto {
    customerCode: string;
    accountStatus: string;
    customerName: string;
    birthInfo: string;
    city: string;
    address: string;
    phoneNumber: string;
    email: string;
    npwp: string;
    regDate: string;

    constructor(data?: IGetListCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerCode = data["customerCode"];
            this.accountStatus = data["accountStatus"];
            this.customerName = data["customerName"];
            this.birthInfo = data["birthInfo"];
            this.city = data["city"];
            this.address = data["address"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.npwp = data["npwp"];
            this.regDate = data["regDate"];
        }
    }

    static fromJS(data: any): GetListCustomerResultDto {
        let result = new GetListCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["accountStatus"] = this.accountStatus;
        data["customerName"] = this.customerName;
        data["birthInfo"] = this.birthInfo;
        data["city"] = this.city;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["npwp"] = this.npwp;
        data["regDate"] = this.regDate;
        return data; 
    }
}

export interface IGetListCustomerResultDto {
    customerCode: string;
    accountStatus: string;
    customerName: string;
    birthInfo: string;
    city: string;
    address: string;
    phoneNumber: string;
    email: string;
    npwp: string;
    regDate: string;
}

export class GetDropdownTermListDto implements IGetDropdownTermListDto {
    termID: number;
    termCode: string;
    remarks: string;

    constructor(data?: IGetDropdownTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termCode = data["termCode"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetDropdownTermListDto {
        let result = new GetDropdownTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termCode"] = this.termCode;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetDropdownTermListDto {
    termID: number;
    termCode: string;
    remarks: string;
}

export class GetAllHargaUnitListDto implements IGetAllHargaUnitListDto {
    projectName: string;
    remarks: string;
    hargaTotal: number;
    hargaTotalAvailable: number;
    hargaTotalSold: number;
    rataRataHarga: number;
    hargaTermurah: number;
    hargaTermahal: number;
    projectID: number;
    termID: number;

    constructor(data?: IGetAllHargaUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.remarks = data["remarks"];
            this.hargaTotal = data["hargaTotal"];
            this.hargaTotalAvailable = data["hargaTotalAvailable"];
            this.hargaTotalSold = data["hargaTotalSold"];
            this.rataRataHarga = data["rataRataHarga"];
            this.hargaTermurah = data["hargaTermurah"];
            this.hargaTermahal = data["hargaTermahal"];
            this.projectID = data["projectID"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): GetAllHargaUnitListDto {
        let result = new GetAllHargaUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["remarks"] = this.remarks;
        data["hargaTotal"] = this.hargaTotal;
        data["hargaTotalAvailable"] = this.hargaTotalAvailable;
        data["hargaTotalSold"] = this.hargaTotalSold;
        data["rataRataHarga"] = this.rataRataHarga;
        data["hargaTermurah"] = this.hargaTermurah;
        data["hargaTermahal"] = this.hargaTermahal;
        data["projectID"] = this.projectID;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface IGetAllHargaUnitListDto {
    projectName: string;
    remarks: string;
    hargaTotal: number;
    hargaTotalAvailable: number;
    hargaTotalSold: number;
    rataRataHarga: number;
    hargaTermurah: number;
    hargaTermahal: number;
    projectID: number;
    termID: number;
}

export class GetHargaByTermListDto implements IGetHargaByTermListDto {
    termID: number;
    termCode: string;
    remarks: GetRemarksListDto[];

    constructor(data?: IGetHargaByTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termCode = data["termCode"];
            if (data["remarks"] && data["remarks"].constructor === Array) {
                this.remarks = [];
                for (let item of data["remarks"])
                    this.remarks.push(GetRemarksListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetHargaByTermListDto {
        let result = new GetHargaByTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termCode"] = this.termCode;
        if (this.remarks && this.remarks.constructor === Array) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetHargaByTermListDto {
    termID: number;
    termCode: string;
    remarks: GetRemarksListDto[];
}

export class GetRemarksListDto implements IGetRemarksListDto {
    remarks: string;
    hargaTotal: number;
    rataRataHarga: number;
    hargaMinUnit: GetHargaListDto;
    hargaMaxUnit: GetHargaListDto;

    constructor(data?: IGetRemarksListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remarks = data["remarks"];
            this.hargaTotal = data["hargaTotal"];
            this.rataRataHarga = data["rataRataHarga"];
            this.hargaMinUnit = data["hargaMinUnit"] ? GetHargaListDto.fromJS(data["hargaMinUnit"]) : <any>undefined;
            this.hargaMaxUnit = data["hargaMaxUnit"] ? GetHargaListDto.fromJS(data["hargaMaxUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRemarksListDto {
        let result = new GetRemarksListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        data["hargaTotal"] = this.hargaTotal;
        data["rataRataHarga"] = this.rataRataHarga;
        data["hargaMinUnit"] = this.hargaMinUnit ? this.hargaMinUnit.toJSON() : <any>undefined;
        data["hargaMaxUnit"] = this.hargaMaxUnit ? this.hargaMaxUnit.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetRemarksListDto {
    remarks: string;
    hargaTotal: number;
    rataRataHarga: number;
    hargaMinUnit: GetHargaListDto;
    hargaMaxUnit: GetHargaListDto;
}

export class GetHargaListDto implements IGetHargaListDto {
    harga: number;
    detailUnit: GetDetailUnitDto[];

    constructor(data?: IGetHargaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.harga = data["harga"];
            if (data["detailUnit"] && data["detailUnit"].constructor === Array) {
                this.detailUnit = [];
                for (let item of data["detailUnit"])
                    this.detailUnit.push(GetDetailUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetHargaListDto {
        let result = new GetHargaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["harga"] = this.harga;
        if (this.detailUnit && this.detailUnit.constructor === Array) {
            data["detailUnit"] = [];
            for (let item of this.detailUnit)
                data["detailUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetHargaListDto {
    harga: number;
    detailUnit: GetDetailUnitDto[];
}

export class GetDetailUnitDto implements IGetDetailUnitDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    status: string;

    constructor(data?: IGetDetailUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetDetailUnitDto {
        let result = new GetDetailUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetDetailUnitDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    status: string;
}

export class GetGrafikListDto implements IGetGrafikListDto {
    name: string;
    hargaTotal: number;
    rataRataHarga: number;
    hargaMin: number;
    hargaMax: number;

    constructor(data?: IGetGrafikListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.hargaTotal = data["hargaTotal"];
            this.rataRataHarga = data["rataRataHarga"];
            this.hargaMin = data["hargaMin"];
            this.hargaMax = data["hargaMax"];
        }
    }

    static fromJS(data: any): GetGrafikListDto {
        let result = new GetGrafikListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hargaTotal"] = this.hargaTotal;
        data["rataRataHarga"] = this.rataRataHarga;
        data["hargaMin"] = this.hargaMin;
        data["hargaMax"] = this.hargaMax;
        return data; 
    }
}

export interface IGetGrafikListDto {
    name: string;
    hargaTotal: number;
    rataRataHarga: number;
    hargaMin: number;
    hargaMax: number;
}

export class GetDropdownProjectDashListDto implements IGetDropdownProjectDashListDto {
    projectID: number;
    projectName: string;
    isChecked: boolean;

    constructor(data?: IGetDropdownProjectDashListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownProjectDashListDto {
        let result = new GetDropdownProjectDashListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownProjectDashListDto {
    projectID: number;
    projectName: string;
    isChecked: boolean;
}

export class GetDropdownDistrictListDto implements IGetDropdownDistrictListDto {
    districtCode: string;
    districtName: string;
    isChecked: boolean;

    constructor(data?: IGetDropdownDistrictListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.districtCode = data["districtCode"];
            this.districtName = data["districtName"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownDistrictListDto {
        let result = new GetDropdownDistrictListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtCode"] = this.districtCode;
        data["districtName"] = this.districtName;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownDistrictListDto {
    districtCode: string;
    districtName: string;
    isChecked: boolean;
}

export class GetDropdownBlokListDto implements IGetDropdownBlokListDto {
    blok: string;
    isChecked: boolean;

    constructor(data?: IGetDropdownBlokListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.blok = data["blok"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownBlokListDto {
        let result = new GetDropdownBlokListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blok"] = this.blok;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownBlokListDto {
    blok: string;
    isChecked: boolean;
}

export class GetDropdownTypeTowerListDto implements IGetDropdownTypeTowerListDto {
    typeTower: string;
    isChecked: boolean;

    constructor(data?: IGetDropdownTypeTowerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeTower = data["typeTower"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownTypeTowerListDto {
        let result = new GetDropdownTypeTowerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeTower"] = this.typeTower;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownTypeTowerListDto {
    typeTower: string;
    isChecked: boolean;
}

export class GetDropdownTowerListDto implements IGetDropdownTowerListDto {
    clusterName: string;
    clusterID: number;
    isChecked: boolean;

    constructor(data?: IGetDropdownTowerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterName = data["clusterName"];
            this.clusterID = data["clusterID"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownTowerListDto {
        let result = new GetDropdownTowerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterName"] = this.clusterName;
        data["clusterID"] = this.clusterID;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownTowerListDto {
    clusterName: string;
    clusterID: number;
    isChecked: boolean;
}

export class GetDropdownTermCodeListDto implements IGetDropdownTermCodeListDto {
    termCode: string;
    termMainID: number;
    isChecked: boolean;

    constructor(data?: IGetDropdownTermCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termCode = data["termCode"];
            this.termMainID = data["termMainID"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownTermCodeListDto {
        let result = new GetDropdownTermCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["termMainID"] = this.termMainID;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownTermCodeListDto {
    termCode: string;
    termMainID: number;
    isChecked: boolean;
}

export class GetDropdownRemarksListDto implements IGetDropdownRemarksListDto {
    remarks: string;
    termID: number;
    isChecked: boolean;

    constructor(data?: IGetDropdownRemarksListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remarks = data["remarks"];
            this.termID = data["termID"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): GetDropdownRemarksListDto {
        let result = new GetDropdownRemarksListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        data["termID"] = this.termID;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IGetDropdownRemarksListDto {
    remarks: string;
    termID: number;
    isChecked: boolean;
}

export class GetDropdownTypeUnitListDto implements IGetDropdownTypeUnitListDto {
    typeUnit: string;

    constructor(data?: IGetDropdownTypeUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeUnit = data["typeUnit"];
        }
    }

    static fromJS(data: any): GetDropdownTypeUnitListDto {
        let result = new GetDropdownTypeUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeUnit"] = this.typeUnit;
        return data; 
    }
}

export interface IGetDropdownTypeUnitListDto {
    typeUnit: string;
}

export class GetTaskListDashListDto implements IGetTaskListDashListDto {
    totalUnit: number;
    totalPrice: number;
    hargaMin: number;
    hargaMax: number;
    getTaskList: GetTaskListAllDto[];

    constructor(data?: IGetTaskListDashListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalUnit = data["totalUnit"];
            this.totalPrice = data["totalPrice"];
            this.hargaMin = data["hargaMin"];
            this.hargaMax = data["hargaMax"];
            if (data["getTaskList"] && data["getTaskList"].constructor === Array) {
                this.getTaskList = [];
                for (let item of data["getTaskList"])
                    this.getTaskList.push(GetTaskListAllDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskListDashListDto {
        let result = new GetTaskListDashListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUnit"] = this.totalUnit;
        data["totalPrice"] = this.totalPrice;
        data["hargaMin"] = this.hargaMin;
        data["hargaMax"] = this.hargaMax;
        if (this.getTaskList && this.getTaskList.constructor === Array) {
            data["getTaskList"] = [];
            for (let item of this.getTaskList)
                data["getTaskList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTaskListDashListDto {
    totalUnit: number;
    totalPrice: number;
    hargaMin: number;
    hargaMax: number;
    getTaskList: GetTaskListAllDto[];
}

export class GetTaskListAllDto implements IGetTaskListAllDto {
    projectID: number;
    projectName: string;
    districtName: string;
    blok: string;
    typeTower: string;
    cluster: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    typeUnit: string;
    termCode: string;
    remarks: string;
    price: number;
    status: string;

    constructor(data?: IGetTaskListAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.districtName = data["districtName"];
            this.blok = data["blok"];
            this.typeTower = data["typeTower"];
            this.cluster = data["cluster"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitID = data["unitID"];
            this.typeUnit = data["typeUnit"];
            this.termCode = data["termCode"];
            this.remarks = data["remarks"];
            this.price = data["price"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetTaskListAllDto {
        let result = new GetTaskListAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["districtName"] = this.districtName;
        data["blok"] = this.blok;
        data["typeTower"] = this.typeTower;
        data["cluster"] = this.cluster;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitID"] = this.unitID;
        data["typeUnit"] = this.typeUnit;
        data["termCode"] = this.termCode;
        data["remarks"] = this.remarks;
        data["price"] = this.price;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetTaskListAllDto {
    projectID: number;
    projectName: string;
    districtName: string;
    blok: string;
    typeTower: string;
    cluster: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    typeUnit: string;
    termCode: string;
    remarks: string;
    price: number;
    status: string;
}

export class GetDropdownUnitListDto implements IGetDropdownUnitListDto {
    unit: string;
    unitID: number;

    constructor(data?: IGetDropdownUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unit = data["unit"];
            this.unitID = data["unitID"];
        }
    }

    static fromJS(data: any): GetDropdownUnitListDto {
        let result = new GetDropdownUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["unitID"] = this.unitID;
        return data; 
    }
}

export interface IGetDropdownUnitListDto {
    unit: string;
    unitID: number;
}

export class GetHistoryPricingDto implements IGetHistoryPricingDto {
    projectID: number;
    projectName: string;
    districtName: string;
    cluster: string;
    termCode: string;
    remarks: string;
    typeUnit: string;
    unitNo: string;
    unitCode: string;
    unitID: number;
    tanggal: moment.Moment;
    price: number;
    presentase: number;

    constructor(data?: IGetHistoryPricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.districtName = data["districtName"];
            this.cluster = data["cluster"];
            this.termCode = data["termCode"];
            this.remarks = data["remarks"];
            this.typeUnit = data["typeUnit"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.unitID = data["unitID"];
            this.tanggal = data["tanggal"] ? moment(data["tanggal"].toString()) : <any>undefined;
            this.price = data["price"];
            this.presentase = data["presentase"];
        }
    }

    static fromJS(data: any): GetHistoryPricingDto {
        let result = new GetHistoryPricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["districtName"] = this.districtName;
        data["cluster"] = this.cluster;
        data["termCode"] = this.termCode;
        data["remarks"] = this.remarks;
        data["typeUnit"] = this.typeUnit;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["unitID"] = this.unitID;
        data["tanggal"] = this.tanggal ? this.tanggal.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["presentase"] = this.presentase;
        return data; 
    }
}

export interface IGetHistoryPricingDto {
    projectID: number;
    projectName: string;
    districtName: string;
    cluster: string;
    termCode: string;
    remarks: string;
    typeUnit: string;
    unitNo: string;
    unitCode: string;
    unitID: number;
    tanggal: moment.Moment;
    price: number;
    presentase: number;
}

export class ParamDropdownHistoryInputDto implements IParamDropdownHistoryInputDto {
    projectID: number;
    termCode: string;
    termID: number;
    termMainID: number;
    unitID: number;
    districtName: string[];
    blok: string[];
    clusterID: string[];

    constructor(data?: IParamDropdownHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.termCode = data["termCode"];
            this.termID = data["termID"];
            this.termMainID = data["termMainID"];
            this.unitID = data["unitID"];
            if (data["districtName"] && data["districtName"].constructor === Array) {
                this.districtName = [];
                for (let item of data["districtName"])
                    this.districtName.push(item);
            }
            if (data["blok"] && data["blok"].constructor === Array) {
                this.blok = [];
                for (let item of data["blok"])
                    this.blok.push(item);
            }
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
        }
    }

    static fromJS(data: any): ParamDropdownHistoryInputDto {
        let result = new ParamDropdownHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["termCode"] = this.termCode;
        data["termID"] = this.termID;
        data["termMainID"] = this.termMainID;
        data["unitID"] = this.unitID;
        if (this.districtName && this.districtName.constructor === Array) {
            data["districtName"] = [];
            for (let item of this.districtName)
                data["districtName"].push(item);
        }
        if (this.blok && this.blok.constructor === Array) {
            data["blok"] = [];
            for (let item of this.blok)
                data["blok"].push(item);
        }
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        return data; 
    }
}

export interface IParamDropdownHistoryInputDto {
    projectID: number;
    termCode: string;
    termID: number;
    termMainID: number;
    unitID: number;
    districtName: string[];
    blok: string[];
    clusterID: string[];
}

export class GetUnitByStatusListDto implements IGetUnitByStatusListDto {
    availableUnit: number;
    soldUnit: number;
    availableHoldUnit: number;
    deleteKavlingsUnit: number;
    holdSingleUnit: number;
    launchingUnit: number;
    notForSaleUnit: number;
    pendingAvailableUnit: number;
    bookInProccessUnit: number;
    usedUnit: number;
    reservedUnit: number;
    rentalUnit: number;

    constructor(data?: IGetUnitByStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.availableUnit = data["availableUnit"];
            this.soldUnit = data["soldUnit"];
            this.availableHoldUnit = data["availableHoldUnit"];
            this.deleteKavlingsUnit = data["deleteKavlingsUnit"];
            this.holdSingleUnit = data["holdSingleUnit"];
            this.launchingUnit = data["launchingUnit"];
            this.notForSaleUnit = data["notForSaleUnit"];
            this.pendingAvailableUnit = data["pendingAvailableUnit"];
            this.bookInProccessUnit = data["bookInProccessUnit"];
            this.usedUnit = data["usedUnit"];
            this.reservedUnit = data["reservedUnit"];
            this.rentalUnit = data["rentalUnit"];
        }
    }

    static fromJS(data: any): GetUnitByStatusListDto {
        let result = new GetUnitByStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableUnit"] = this.availableUnit;
        data["soldUnit"] = this.soldUnit;
        data["availableHoldUnit"] = this.availableHoldUnit;
        data["deleteKavlingsUnit"] = this.deleteKavlingsUnit;
        data["holdSingleUnit"] = this.holdSingleUnit;
        data["launchingUnit"] = this.launchingUnit;
        data["notForSaleUnit"] = this.notForSaleUnit;
        data["pendingAvailableUnit"] = this.pendingAvailableUnit;
        data["bookInProccessUnit"] = this.bookInProccessUnit;
        data["usedUnit"] = this.usedUnit;
        data["reservedUnit"] = this.reservedUnit;
        data["rentalUnit"] = this.rentalUnit;
        return data; 
    }
}

export interface IGetUnitByStatusListDto {
    availableUnit: number;
    soldUnit: number;
    availableHoldUnit: number;
    deleteKavlingsUnit: number;
    holdSingleUnit: number;
    launchingUnit: number;
    notForSaleUnit: number;
    pendingAvailableUnit: number;
    bookInProccessUnit: number;
    usedUnit: number;
    reservedUnit: number;
    rentalUnit: number;
}

export class GetTotalUnitDto implements IGetTotalUnitDto {
    totalUnit: number;
    memberCode: string;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;

    constructor(data?: IGetTotalUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalUnit = data["totalUnit"];
            this.memberCode = data["memberCode"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.monthInputTime = data["monthInputTime"];
            this.yearInputTime = data["yearInputTime"];
        }
    }

    static fromJS(data: any): GetTotalUnitDto {
        let result = new GetTotalUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUnit"] = this.totalUnit;
        data["memberCode"] = this.memberCode;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["monthInputTime"] = this.monthInputTime;
        data["yearInputTime"] = this.yearInputTime;
        return data; 
    }
}

export interface IGetTotalUnitDto {
    totalUnit: number;
    memberCode: string;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;
}

export class GetTotalHotCustomersDto implements IGetTotalHotCustomersDto {
    totalCustomer: number;
    inputUN: number;

    constructor(data?: IGetTotalHotCustomersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCustomer = data["totalCustomer"];
            this.inputUN = data["inputUN"];
        }
    }

    static fromJS(data: any): GetTotalHotCustomersDto {
        let result = new GetTotalHotCustomersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCustomer"] = this.totalCustomer;
        data["inputUN"] = this.inputUN;
        return data; 
    }
}

export interface IGetTotalHotCustomersDto {
    totalCustomer: number;
    inputUN: number;
}

export class GetTotalCancelUnitDto implements IGetTotalCancelUnitDto {
    inputUN: number;
    totalCancel: number;

    constructor(data?: IGetTotalCancelUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputUN = data["inputUN"];
            this.totalCancel = data["totalCancel"];
        }
    }

    static fromJS(data: any): GetTotalCancelUnitDto {
        let result = new GetTotalCancelUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputUN"] = this.inputUN;
        data["totalCancel"] = this.totalCancel;
        return data; 
    }
}

export interface IGetTotalCancelUnitDto {
    inputUN: number;
    totalCancel: number;
}

export class GetTotalSalesDto implements IGetTotalSalesDto {
    dateString: string;
    date: moment.Moment;
    year: number;
    memberCode: string;
    total: number;

    constructor(data?: IGetTotalSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.year = data["year"];
            this.memberCode = data["memberCode"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetTotalSalesDto {
        let result = new GetTotalSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["year"] = this.year;
        data["memberCode"] = this.memberCode;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetTotalSalesDto {
    dateString: string;
    date: moment.Moment;
    year: number;
    memberCode: string;
    total: number;
}

export class GetRevenueAndTaxDto implements IGetRevenueAndTaxDto {
    memberCode: string;
    dateString: string;
    date: moment.Moment;
    year: number;
    revenue: number;
    tax: number;

    constructor(data?: IGetRevenueAndTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.dateString = data["dateString"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.year = data["year"];
            this.revenue = data["revenue"];
            this.tax = data["tax"];
        }
    }

    static fromJS(data: any): GetRevenueAndTaxDto {
        let result = new GetRevenueAndTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["dateString"] = this.dateString;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["year"] = this.year;
        data["revenue"] = this.revenue;
        data["tax"] = this.tax;
        return data; 
    }
}

export interface IGetRevenueAndTaxDto {
    memberCode: string;
    dateString: string;
    date: moment.Moment;
    year: number;
    revenue: number;
    tax: number;
}

export class GetTotalProfitDto implements IGetTotalProfitDto {
    memberCode: string;
    totalProfit: number;

    constructor(data?: IGetTotalProfitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalProfit = data["totalProfit"];
        }
    }

    static fromJS(data: any): GetTotalProfitDto {
        let result = new GetTotalProfitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalProfit"] = this.totalProfit;
        return data; 
    }
}

export interface IGetTotalProfitDto {
    memberCode: string;
    totalProfit: number;
}

export class GetListMemberDto implements IGetListMemberDto {
    memberCode: string;
    memberName: string;
    position: string;
    earning: number;
    myCommission: number;
    myCommissionPaid: number;
    paidDate: moment.Moment;
    tax: number;
    totalSales: number;

    constructor(data?: IGetListMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.position = data["position"];
            this.earning = data["earning"];
            this.myCommission = data["myCommission"];
            this.myCommissionPaid = data["myCommissionPaid"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.tax = data["tax"];
            this.totalSales = data["totalSales"];
        }
    }

    static fromJS(data: any): GetListMemberDto {
        let result = new GetListMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["position"] = this.position;
        data["earning"] = this.earning;
        data["myCommission"] = this.myCommission;
        data["myCommissionPaid"] = this.myCommissionPaid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["tax"] = this.tax;
        data["totalSales"] = this.totalSales;
        return data; 
    }
}

export interface IGetListMemberDto {
    memberCode: string;
    memberName: string;
    position: string;
    earning: number;
    myCommission: number;
    myCommissionPaid: number;
    paidDate: moment.Moment;
    tax: number;
    totalSales: number;
}

export class GetTotalUnitSoldDto implements IGetTotalUnitSoldDto {
    date: moment.Moment;
    inputUN: number;
    totalUnit: number;

    constructor(data?: IGetTotalUnitSoldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.totalUnit = data["totalUnit"];
        }
    }

    static fromJS(data: any): GetTotalUnitSoldDto {
        let result = new GetTotalUnitSoldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["totalUnit"] = this.totalUnit;
        return data; 
    }
}

export interface IGetTotalUnitSoldDto {
    date: moment.Moment;
    inputUN: number;
    totalUnit: number;
}

export class GetUnitTransactionDto implements IGetUnitTransactionDto {
    inputUN: number;
    totalTransaction: number;
    percent: number;

    constructor(data?: IGetUnitTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputUN = data["inputUN"];
            this.totalTransaction = data["totalTransaction"];
            this.percent = data["percent"];
        }
    }

    static fromJS(data: any): GetUnitTransactionDto {
        let result = new GetUnitTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputUN"] = this.inputUN;
        data["totalTransaction"] = this.totalTransaction;
        data["percent"] = this.percent;
        return data; 
    }
}

export interface IGetUnitTransactionDto {
    inputUN: number;
    totalTransaction: number;
    percent: number;
}

export class GetPPTransactionDto implements IGetPPTransactionDto {
    inputUN: number;
    total: number;
    percent: number;

    constructor(data?: IGetPPTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputUN = data["inputUN"];
            this.total = data["total"];
            this.percent = data["percent"];
        }
    }

    static fromJS(data: any): GetPPTransactionDto {
        let result = new GetPPTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputUN"] = this.inputUN;
        data["total"] = this.total;
        data["percent"] = this.percent;
        return data; 
    }
}

export interface IGetPPTransactionDto {
    inputUN: number;
    total: number;
    percent: number;
}

export class GetDailyPPTransaction implements IGetDailyPPTransaction {
    date: moment.Moment;
    inputUN: number;
    total: number;

    constructor(data?: IGetDailyPPTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetDailyPPTransaction {
        let result = new GetDailyPPTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetDailyPPTransaction {
    date: moment.Moment;
    inputUN: number;
    total: number;
}

export class GetTotalCustomerDto implements IGetTotalCustomerDto {
    memberCode: string;
    totalCustomer: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;

    constructor(data?: IGetTotalCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalCustomer = data["totalCustomer"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.monthInputTime = data["monthInputTime"];
            this.yearInputTime = data["yearInputTime"];
        }
    }

    static fromJS(data: any): GetTotalCustomerDto {
        let result = new GetTotalCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalCustomer"] = this.totalCustomer;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["monthInputTime"] = this.monthInputTime;
        data["yearInputTime"] = this.yearInputTime;
        return data; 
    }
}

export interface IGetTotalCustomerDto {
    memberCode: string;
    totalCustomer: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;
}

export class GetTotalPotentialCustomerDto implements IGetTotalPotentialCustomerDto {
    inputUn: number;
    total: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;

    constructor(data?: IGetTotalPotentialCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputUn = data["inputUn"];
            this.total = data["total"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.monthInputTime = data["monthInputTime"];
            this.yearInputTime = data["yearInputTime"];
        }
    }

    static fromJS(data: any): GetTotalPotentialCustomerDto {
        let result = new GetTotalPotentialCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputUn"] = this.inputUn;
        data["total"] = this.total;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["monthInputTime"] = this.monthInputTime;
        data["yearInputTime"] = this.yearInputTime;
        return data; 
    }
}

export interface IGetTotalPotentialCustomerDto {
    inputUn: number;
    total: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;
}

export class GetTotalCommissionDto implements IGetTotalCommissionDto {
    memberCode: string;
    totalCommision: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;

    constructor(data?: IGetTotalCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalCommision = data["totalCommision"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.monthInputTime = data["monthInputTime"];
            this.yearInputTime = data["yearInputTime"];
        }
    }

    static fromJS(data: any): GetTotalCommissionDto {
        let result = new GetTotalCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalCommision"] = this.totalCommision;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["monthInputTime"] = this.monthInputTime;
        data["yearInputTime"] = this.yearInputTime;
        return data; 
    }
}

export interface IGetTotalCommissionDto {
    memberCode: string;
    totalCommision: number;
    inputTime: moment.Moment;
    monthInputTime: number;
    yearInputTime: number;
}

export class GetTotalCommissionPaidDto implements IGetTotalCommissionPaidDto {
    memberCode: string;
    totalCommissionPaid: number;
    paidDate: moment.Moment;
    monthPaidDate: number;
    yearPaidDate: number;

    constructor(data?: IGetTotalCommissionPaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalCommissionPaid = data["totalCommissionPaid"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.monthPaidDate = data["monthPaidDate"];
            this.yearPaidDate = data["yearPaidDate"];
        }
    }

    static fromJS(data: any): GetTotalCommissionPaidDto {
        let result = new GetTotalCommissionPaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalCommissionPaid"] = this.totalCommissionPaid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["monthPaidDate"] = this.monthPaidDate;
        data["yearPaidDate"] = this.yearPaidDate;
        return data; 
    }
}

export interface IGetTotalCommissionPaidDto {
    memberCode: string;
    totalCommissionPaid: number;
    paidDate: moment.Moment;
    monthPaidDate: number;
    yearPaidDate: number;
}

export class GetDataMarketingProgramListDto implements IGetDataMarketingProgramListDto {
    bookingHeaderID: number;
    bookCode: string;
    termID: number;
    unitID: number;
    marketingProgram: string;
    periodeStartBooking: string;
    periodeEndBooking: string;
    bookingDate: string;
    downPayment: string;
    unitCode: string;
    unitNo: string;
    psCode: string;
    name: string;
    salesPrice: string;
    discount: string;
    discountPrice: string;
    nettSales: string;

    constructor(data?: IGetDataMarketingProgramListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.termID = data["termID"];
            this.unitID = data["unitID"];
            this.marketingProgram = data["marketingProgram"];
            this.periodeStartBooking = data["periodeStartBooking"];
            this.periodeEndBooking = data["periodeEndBooking"];
            this.bookingDate = data["bookingDate"];
            this.downPayment = data["downPayment"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.salesPrice = data["salesPrice"];
            this.discount = data["discount"];
            this.discountPrice = data["discountPrice"];
            this.nettSales = data["nettSales"];
        }
    }

    static fromJS(data: any): GetDataMarketingProgramListDto {
        let result = new GetDataMarketingProgramListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["termID"] = this.termID;
        data["unitID"] = this.unitID;
        data["marketingProgram"] = this.marketingProgram;
        data["periodeStartBooking"] = this.periodeStartBooking;
        data["periodeEndBooking"] = this.periodeEndBooking;
        data["bookingDate"] = this.bookingDate;
        data["downPayment"] = this.downPayment;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["salesPrice"] = this.salesPrice;
        data["discount"] = this.discount;
        data["discountPrice"] = this.discountPrice;
        data["nettSales"] = this.nettSales;
        return data; 
    }
}

export interface IGetDataMarketingProgramListDto {
    bookingHeaderID: number;
    bookCode: string;
    termID: number;
    unitID: number;
    marketingProgram: string;
    periodeStartBooking: string;
    periodeEndBooking: string;
    bookingDate: string;
    downPayment: string;
    unitCode: string;
    unitNo: string;
    psCode: string;
    name: string;
    salesPrice: string;
    discount: string;
    discountPrice: string;
    nettSales: string;
}

export class GetCommisionReportDto implements IGetCommisionReportDto {
    schemaCode: string;
    grandTotalPaid: number;
    grandTotalDue: number;
    listUnitComm: GetUnitCommListDto[];
    listHeaderLevel: string[];
    dataTotal: GetDataTotalListDto[];

    constructor(data?: IGetCommisionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schemaCode = data["schemaCode"];
            this.grandTotalPaid = data["grandTotalPaid"];
            this.grandTotalDue = data["grandTotalDue"];
            if (data["listUnitComm"] && data["listUnitComm"].constructor === Array) {
                this.listUnitComm = [];
                for (let item of data["listUnitComm"])
                    this.listUnitComm.push(GetUnitCommListDto.fromJS(item));
            }
            if (data["listHeaderLevel"] && data["listHeaderLevel"].constructor === Array) {
                this.listHeaderLevel = [];
                for (let item of data["listHeaderLevel"])
                    this.listHeaderLevel.push(item);
            }
            if (data["dataTotal"] && data["dataTotal"].constructor === Array) {
                this.dataTotal = [];
                for (let item of data["dataTotal"])
                    this.dataTotal.push(GetDataTotalListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCommisionReportDto {
        let result = new GetCommisionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaCode"] = this.schemaCode;
        data["grandTotalPaid"] = this.grandTotalPaid;
        data["grandTotalDue"] = this.grandTotalDue;
        if (this.listUnitComm && this.listUnitComm.constructor === Array) {
            data["listUnitComm"] = [];
            for (let item of this.listUnitComm)
                data["listUnitComm"].push(item.toJSON());
        }
        if (this.listHeaderLevel && this.listHeaderLevel.constructor === Array) {
            data["listHeaderLevel"] = [];
            for (let item of this.listHeaderLevel)
                data["listHeaderLevel"].push(item);
        }
        if (this.dataTotal && this.dataTotal.constructor === Array) {
            data["dataTotal"] = [];
            for (let item of this.dataTotal)
                data["dataTotal"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCommisionReportDto {
    schemaCode: string;
    grandTotalPaid: number;
    grandTotalDue: number;
    listUnitComm: GetUnitCommListDto[];
    listHeaderLevel: string[];
    dataTotal: GetDataTotalListDto[];
}

export class GetUnitCommListDto implements IGetUnitCommListDto {
    unitCode: string;
    psCode: string;
    bookCode: string;
    bookingHeaderID: number;
    term: string;
    sellingPrice: string;
    custPayment: string;
    eligibilityComm: string;
    commision: string;
    isBookingFee: boolean;
    listCommLevel: GetCommLevelListDto[];

    constructor(data?: IGetUnitCommListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            this.bookCode = data["bookCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.term = data["term"];
            this.sellingPrice = data["sellingPrice"];
            this.custPayment = data["custPayment"];
            this.eligibilityComm = data["eligibilityComm"];
            this.commision = data["commision"];
            this.isBookingFee = data["isBookingFee"];
            if (data["listCommLevel"] && data["listCommLevel"].constructor === Array) {
                this.listCommLevel = [];
                for (let item of data["listCommLevel"])
                    this.listCommLevel.push(GetCommLevelListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUnitCommListDto {
        let result = new GetUnitCommListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        data["bookCode"] = this.bookCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["term"] = this.term;
        data["sellingPrice"] = this.sellingPrice;
        data["custPayment"] = this.custPayment;
        data["eligibilityComm"] = this.eligibilityComm;
        data["commision"] = this.commision;
        data["isBookingFee"] = this.isBookingFee;
        if (this.listCommLevel && this.listCommLevel.constructor === Array) {
            data["listCommLevel"] = [];
            for (let item of this.listCommLevel)
                data["listCommLevel"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUnitCommListDto {
    unitCode: string;
    psCode: string;
    bookCode: string;
    bookingHeaderID: number;
    term: string;
    sellingPrice: string;
    custPayment: string;
    eligibilityComm: string;
    commision: string;
    isBookingFee: boolean;
    listCommLevel: GetCommLevelListDto[];
}

export class GetDataTotalListDto implements IGetDataTotalListDto {
    memberStatus: string;
    totalPaid: number;
    totalDue: number;

    constructor(data?: IGetDataTotalListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberStatus = data["memberStatus"];
            this.totalPaid = data["totalPaid"];
            this.totalDue = data["totalDue"];
        }
    }

    static fromJS(data: any): GetDataTotalListDto {
        let result = new GetDataTotalListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberStatus"] = this.memberStatus;
        data["totalPaid"] = this.totalPaid;
        data["totalDue"] = this.totalDue;
        return data; 
    }
}

export interface IGetDataTotalListDto {
    memberStatus: string;
    totalPaid: number;
    totalDue: number;
}

export class GetCommLevelListDto implements IGetCommLevelListDto {
    reqNo: number;
    headerName: string;
    paid: number;
    due: number;
    bookingFee: number;
    bookingFeeString: string;
    paidString: string;
    dueString: string;

    constructor(data?: IGetCommLevelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reqNo = data["reqNo"];
            this.headerName = data["headerName"];
            this.paid = data["paid"];
            this.due = data["due"];
            this.bookingFee = data["bookingFee"];
            this.bookingFeeString = data["bookingFeeString"];
            this.paidString = data["paidString"];
            this.dueString = data["dueString"];
        }
    }

    static fromJS(data: any): GetCommLevelListDto {
        let result = new GetCommLevelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqNo"] = this.reqNo;
        data["headerName"] = this.headerName;
        data["paid"] = this.paid;
        data["due"] = this.due;
        data["bookingFee"] = this.bookingFee;
        data["bookingFeeString"] = this.bookingFeeString;
        data["paidString"] = this.paidString;
        data["dueString"] = this.dueString;
        return data; 
    }
}

export interface IGetCommLevelListDto {
    reqNo: number;
    headerName: string;
    paid: number;
    due: number;
    bookingFee: number;
    bookingFeeString: string;
    paidString: string;
    dueString: string;
}

export class StatusMemberCodeDto implements IStatusMemberCodeDto {
    scmCode: string;
    memberCode: string;
    memberStatusCode: string;

    constructor(data?: IStatusMemberCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.memberStatusCode = data["memberStatusCode"];
        }
    }

    static fromJS(data: any): StatusMemberCodeDto {
        let result = new StatusMemberCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["memberStatusCode"] = this.memberStatusCode;
        return data; 
    }
}

export interface IStatusMemberCodeDto {
    scmCode: string;
    memberCode: string;
    memberStatusCode: string;
}

export class GenerateCommReportParamInputDto implements IGenerateCommReportParamInputDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    schemaCode: string[];

    constructor(data?: IGenerateCommReportParamInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            if (data["schemaCode"] && data["schemaCode"].constructor === Array) {
                this.schemaCode = [];
                for (let item of data["schemaCode"])
                    this.schemaCode.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateCommReportParamInputDto {
        let result = new GenerateCommReportParamInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (this.schemaCode && this.schemaCode.constructor === Array) {
            data["schemaCode"] = [];
            for (let item of this.schemaCode)
                data["schemaCode"].push(item);
        }
        return data; 
    }
}

export interface IGenerateCommReportParamInputDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    schemaCode: string[];
}

export class GetRolesListDto implements IGetRolesListDto {
    userID: number;
    userName: string;
    roles: string;
    roleId: number;

    constructor(data?: IGetRolesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.userName = data["userName"];
            this.roles = data["roles"];
            this.roleId = data["roleId"];
        }
    }

    static fromJS(data: any): GetRolesListDto {
        let result = new GetRolesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        data["roles"] = this.roles;
        data["roleId"] = this.roleId;
        return data; 
    }
}

export interface IGetRolesListDto {
    userID: number;
    userName: string;
    roles: string;
    roleId: number;
}

export class ListResultDtoOfProjectDropdown implements IListResultDtoOfProjectDropdown {
    items: ProjectDropdown[];

    constructor(data?: IListResultDtoOfProjectDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProjectDropdown.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProjectDropdown {
        let result = new ListResultDtoOfProjectDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProjectDropdown {
    items: ProjectDropdown[];
}

export class ProjectDropdown implements IProjectDropdown {
    projectId: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IProjectDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): ProjectDropdown {
        let result = new ProjectDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IProjectDropdown {
    projectId: number;
    projectCode: string;
    projectName: string;
}

export class ProductDropdown implements IProductDropdown {
    productId: number;
    productName: string;

    constructor(data?: IProductDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): ProductDropdown {
        let result = new ProductDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IProductDropdown {
    productId: number;
    productName: string;
}

export class GetAllTotalDataDto implements IGetAllTotalDataDto {
    totalSales: number;
    totalSoldUnit: number;
    availableUnit: number;
    totalCancelUnit: number;
    totalSalesUnitValue: number;
    totalSalesUnitArea: number;
    totalHoldUnit: number;
    nupSold: number;
    nupCancel: number;
    kadasterType: string;

    constructor(data?: IGetAllTotalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalSoldUnit = data["totalSoldUnit"];
            this.availableUnit = data["availableUnit"];
            this.totalCancelUnit = data["totalCancelUnit"];
            this.totalSalesUnitValue = data["totalSalesUnitValue"];
            this.totalSalesUnitArea = data["totalSalesUnitArea"];
            this.totalHoldUnit = data["totalHoldUnit"];
            this.nupSold = data["nupSold"];
            this.nupCancel = data["nupCancel"];
            this.kadasterType = data["kadasterType"];
        }
    }

    static fromJS(data: any): GetAllTotalDataDto {
        let result = new GetAllTotalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalSoldUnit"] = this.totalSoldUnit;
        data["availableUnit"] = this.availableUnit;
        data["totalCancelUnit"] = this.totalCancelUnit;
        data["totalSalesUnitValue"] = this.totalSalesUnitValue;
        data["totalSalesUnitArea"] = this.totalSalesUnitArea;
        data["totalHoldUnit"] = this.totalHoldUnit;
        data["nupSold"] = this.nupSold;
        data["nupCancel"] = this.nupCancel;
        data["kadasterType"] = this.kadasterType;
        return data; 
    }
}

export interface IGetAllTotalDataDto {
    totalSales: number;
    totalSoldUnit: number;
    availableUnit: number;
    totalCancelUnit: number;
    totalSalesUnitValue: number;
    totalSalesUnitArea: number;
    totalHoldUnit: number;
    nupSold: number;
    nupCancel: number;
    kadasterType: string;
}

export class GetListProjectMappingResultDto implements IGetListProjectMappingResultDto {
    projectID: number;
    projectName: string;

    constructor(data?: IGetListProjectMappingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetListProjectMappingResultDto {
        let result = new GetListProjectMappingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetListProjectMappingResultDto {
    projectID: number;
    projectName: string;
}

export class GetListClusterResultDto implements IGetListClusterResultDto {
    clusterId: number;
    clusterName: string;

    constructor(data?: IGetListClusterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetListClusterResultDto {
        let result = new GetListClusterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetListClusterResultDto {
    clusterId: number;
    clusterName: string;
}

export class GetListTermResultDto implements IGetListTermResultDto {
    termMainId: number;
    termCode: string;

    constructor(data?: IGetListTermResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainId = data["termMainId"];
            this.termCode = data["termCode"];
        }
    }

    static fromJS(data: any): GetListTermResultDto {
        let result = new GetListTermResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainId"] = this.termMainId;
        data["termCode"] = this.termCode;
        return data; 
    }
}

export interface IGetListTermResultDto {
    termMainId: number;
    termCode: string;
}

export class GetListUnitCodeUnitNoResultDto implements IGetListUnitCodeUnitNoResultDto {
    unitId: number;
    unit: string;

    constructor(data?: IGetListUnitCodeUnitNoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): GetListUnitCodeUnitNoResultDto {
        let result = new GetListUnitCodeUnitNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IGetListUnitCodeUnitNoResultDto {
    unitId: number;
    unit: string;
}

export class GetTaskListInputDto implements IGetTaskListInputDto {
    listUnitID: number[];
    termMainID: number;
    renovID: number;

    constructor(data?: IGetTaskListInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listUnitID"] && data["listUnitID"].constructor === Array) {
                this.listUnitID = [];
                for (let item of data["listUnitID"])
                    this.listUnitID.push(item);
            }
            this.termMainID = data["termMainID"];
            this.renovID = data["renovID"];
        }
    }

    static fromJS(data: any): GetTaskListInputDto {
        let result = new GetTaskListInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listUnitID && this.listUnitID.constructor === Array) {
            data["listUnitID"] = [];
            for (let item of this.listUnitID)
                data["listUnitID"].push(item);
        }
        data["termMainID"] = this.termMainID;
        data["renovID"] = this.renovID;
        return data; 
    }
}

export interface IGetTaskListInputDto {
    listUnitID: number[];
    termMainID: number;
    renovID: number;
}

export class GetTaskListRenovResultDto implements IGetTaskListRenovResultDto {
    renovCode: string;
    renovName: string;
    renovId: number;
    listUnitItem: ListUnitItem[];
    listUnit: ListUnitCodeUnitNo[];

    constructor(data?: IGetTaskListRenovResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
            this.renovId = data["renovId"];
            if (data["listUnitItem"] && data["listUnitItem"].constructor === Array) {
                this.listUnitItem = [];
                for (let item of data["listUnitItem"])
                    this.listUnitItem.push(ListUnitItem.fromJS(item));
            }
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(ListUnitCodeUnitNo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskListRenovResultDto {
        let result = new GetTaskListRenovResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        data["renovId"] = this.renovId;
        if (this.listUnitItem && this.listUnitItem.constructor === Array) {
            data["listUnitItem"] = [];
            for (let item of this.listUnitItem)
                data["listUnitItem"].push(item.toJSON());
        }
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTaskListRenovResultDto {
    renovCode: string;
    renovName: string;
    renovId: number;
    listUnitItem: ListUnitItem[];
    listUnit: ListUnitCodeUnitNo[];
}

export class ListUnitItem implements IListUnitItem {
    unitItemId: number;

    constructor(data?: IListUnitItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitItemId = data["unitItemId"];
        }
    }

    static fromJS(data: any): ListUnitItem {
        let result = new ListUnitItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitItemId"] = this.unitItemId;
        return data; 
    }
}

export interface IListUnitItem {
    unitItemId: number;
}

export class ListUnitCodeUnitNo implements IListUnitCodeUnitNo {
    unit: string;

    constructor(data?: IListUnitCodeUnitNo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ListUnitCodeUnitNo {
        let result = new ListUnitCodeUnitNo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IListUnitCodeUnitNo {
    unit: string;
}

export class DeleteRenovInputDto implements IDeleteRenovInputDto {
    unitItemPriceID: number[];
    renovID: number;

    constructor(data?: IDeleteRenovInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["unitItemPriceID"] && data["unitItemPriceID"].constructor === Array) {
                this.unitItemPriceID = [];
                for (let item of data["unitItemPriceID"])
                    this.unitItemPriceID.push(item);
            }
            this.renovID = data["renovID"];
        }
    }

    static fromJS(data: any): DeleteRenovInputDto {
        let result = new DeleteRenovInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.unitItemPriceID && this.unitItemPriceID.constructor === Array) {
            data["unitItemPriceID"] = [];
            for (let item of this.unitItemPriceID)
                data["unitItemPriceID"].push(item);
        }
        data["renovID"] = this.renovID;
        return data; 
    }
}

export interface IDeleteRenovInputDto {
    unitItemPriceID: number[];
    renovID: number;
}

export class GetDropDownRenovResultDto implements IGetDropDownRenovResultDto {
    renovCode: string;
    renovID: number;

    constructor(data?: IGetDropDownRenovResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovCode = data["renovCode"];
            this.renovID = data["renovID"];
        }
    }

    static fromJS(data: any): GetDropDownRenovResultDto {
        let result = new GetDropDownRenovResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovCode"] = this.renovCode;
        data["renovID"] = this.renovID;
        return data; 
    }
}

export interface IGetDropDownRenovResultDto {
    renovCode: string;
    renovID: number;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString: string;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string;
}

export class NameValueOfString implements INameValueOfString {
    name: string;
    value: string;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string;
    value: string;
}

export class StringOutput implements IStringOutput {
    output: string;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string;
}

export class ResultDropdownPPno implements IResultDropdownPPno {
    membercode: string;
    ppNo: string;
    result: boolean;
    memberName: string;

    constructor(data?: IResultDropdownPPno) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.membercode = data["membercode"];
            this.ppNo = data["ppNo"];
            this.result = data["result"];
            this.memberName = data["memberName"];
        }
    }

    static fromJS(data: any): ResultDropdownPPno {
        let result = new ResultDropdownPPno();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membercode"] = this.membercode;
        data["ppNo"] = this.ppNo;
        data["result"] = this.result;
        data["memberName"] = this.memberName;
        return data; 
    }
}

export interface IResultDropdownPPno {
    membercode: string;
    ppNo: string;
    result: boolean;
    memberName: string;
}

export class GetListPPNoResultDto implements IGetListPPNoResultDto {
    ppno: string;
    result: boolean;
    psCode: string;
    ppPrice: number;

    constructor(data?: IGetListPPNoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppno = data["ppno"];
            this.result = data["result"];
            this.psCode = data["psCode"];
            this.ppPrice = data["ppPrice"];
        }
    }

    static fromJS(data: any): GetListPPNoResultDto {
        let result = new GetListPPNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppno"] = this.ppno;
        data["result"] = this.result;
        data["psCode"] = this.psCode;
        data["ppPrice"] = this.ppPrice;
        return data; 
    }
}

export interface IGetListPPNoResultDto {
    ppno: string;
    result: boolean;
    psCode: string;
    ppPrice: number;
}

export class GetListBankKPADto implements IGetListBankKPADto {
    bankID: number;
    bankCode: string;
    bankName: string;

    constructor(data?: IGetListBankKPADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetListBankKPADto {
        let result = new GetListBankKPADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetListBankKPADto {
    bankID: number;
    bankCode: string;
    bankName: string;
}

export class UnitDetailResultDto implements IUnitDetailResultDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    bookingFee: number;
    listRenov: ListRenovResultDto[];

    constructor(data?: IUnitDetailResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookingFee = data["bookingFee"];
            if (data["listRenov"] && data["listRenov"].constructor === Array) {
                this.listRenov = [];
                for (let item of data["listRenov"])
                    this.listRenov.push(ListRenovResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitDetailResultDto {
        let result = new UnitDetailResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookingFee"] = this.bookingFee;
        if (this.listRenov && this.listRenov.constructor === Array) {
            data["listRenov"] = [];
            for (let item of this.listRenov)
                data["listRenov"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitDetailResultDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    bookingFee: number;
    listRenov: ListRenovResultDto[];
}

export class ListRenovResultDto implements IListRenovResultDto {
    renovID: number;
    renovName: string;

    constructor(data?: IListRenovResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
        }
    }

    static fromJS(data: any): ListRenovResultDto {
        let result = new ListRenovResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        return data; 
    }
}

export interface IListRenovResultDto {
    renovID: number;
    renovName: string;
}

export class ListPriceInputDto implements IListPriceInputDto {
    unitID: number;
    renovID: number;

    constructor(data?: IListPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
        }
    }

    static fromJS(data: any): ListPriceInputDto {
        let result = new ListPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        return data; 
    }
}

export interface IListPriceInputDto {
    unitID: number;
    renovID: number;
}

export class ListResultDtoOfListPriceResultDto implements IListResultDtoOfListPriceResultDto {
    items: ListPriceResultDto[];

    constructor(data?: IListResultDtoOfListPriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListPriceResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListPriceResultDto {
        let result = new ListResultDtoOfListPriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListPriceResultDto {
    items: ListPriceResultDto[];
}

export class ListPriceResultDto implements IListPriceResultDto {
    termID: number;
    termName: string;
    sortNo: number;
    unitID: number;
    grossPrice: number;
    bookingFee: number;

    constructor(data?: IListPriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.sortNo = data["sortNo"];
            this.unitID = data["unitID"];
            this.grossPrice = data["grossPrice"];
            this.bookingFee = data["bookingFee"];
        }
    }

    static fromJS(data: any): ListPriceResultDto {
        let result = new ListPriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["sortNo"] = this.sortNo;
        data["unitID"] = this.unitID;
        data["grossPrice"] = this.grossPrice;
        data["bookingFee"] = this.bookingFee;
        return data; 
    }
}

export interface IListPriceResultDto {
    termID: number;
    termName: string;
    sortNo: number;
    unitID: number;
    grossPrice: number;
    bookingFee: number;
}

export class ListResultDtoOfListUnitByUnitCodeResultDto implements IListResultDtoOfListUnitByUnitCodeResultDto {
    items: ListUnitByUnitCodeResultDto[];

    constructor(data?: IListResultDtoOfListUnitByUnitCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListUnitByUnitCodeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListUnitByUnitCodeResultDto {
        let result = new ListResultDtoOfListUnitByUnitCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListUnitByUnitCodeResultDto {
    items: ListUnitByUnitCodeResultDto[];
}

export class ListUnitByUnitCodeResultDto implements IListUnitByUnitCodeResultDto {
    unit: string;
    unitStatus: number;

    constructor(data?: IListUnitByUnitCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unit = data["unit"];
            this.unitStatus = data["unitStatus"];
        }
    }

    static fromJS(data: any): ListUnitByUnitCodeResultDto {
        let result = new ListUnitByUnitCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["unitStatus"] = this.unitStatus;
        return data; 
    }
}

export interface IListUnitByUnitCodeResultDto {
    unit: string;
    unitStatus: number;
}

export class ListResultDtoOfListTowerResultDto implements IListResultDtoOfListTowerResultDto {
    items: ListTowerResultDto[];

    constructor(data?: IListResultDtoOfListTowerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListTowerResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListTowerResultDto {
        let result = new ListResultDtoOfListTowerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListTowerResultDto {
    items: ListTowerResultDto[];
}

export class ListTowerResultDto implements IListTowerResultDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    isRequiredPP: boolean;
    message: string;

    constructor(data?: IListTowerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.isRequiredPP = data["isRequiredPP"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListTowerResultDto {
        let result = new ListTowerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["isRequiredPP"] = this.isRequiredPP;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListTowerResultDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    isRequiredPP: boolean;
    message: string;
}

export class GetDiagramaticResultDto implements IGetDiagramaticResultDto {
    diagramaticType: string;
    unitCodeId: number;
    unitCode: string;
    floor: string;
    unitName: string;
    units: UnitMobileDto[];
    message: string;

    constructor(data?: IGetDiagramaticResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.unitCodeId = data["unitCodeId"];
            this.unitCode = data["unitCode"];
            this.floor = data["floor"];
            this.unitName = data["unitName"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitMobileDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetDiagramaticResultDto {
        let result = new GetDiagramaticResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["unitCodeId"] = this.unitCodeId;
        data["unitCode"] = this.unitCode;
        data["floor"] = this.floor;
        data["unitName"] = this.unitName;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetDiagramaticResultDto {
    diagramaticType: string;
    unitCodeId: number;
    unitCode: string;
    floor: string;
    unitName: string;
    units: UnitMobileDto[];
    message: string;
}

export class UnitMobileDto implements IUnitMobileDto {
    floorType: string;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    unitID: number;
    bedroom: string;
    zoningID: number;
    zoningName: string;
    detailCode: string;
    detailImage: string;
    detailID: number;
    isRequiredPP: boolean;
    floor: string;
    typeName: string;
    area: number;
    detailName: string;
    facingId: number;

    constructor(data?: IUnitMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.floorType = data["floorType"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.unitID = data["unitID"];
            this.bedroom = data["bedroom"];
            this.zoningID = data["zoningID"];
            this.zoningName = data["zoningName"];
            this.detailCode = data["detailCode"];
            this.detailImage = data["detailImage"];
            this.detailID = data["detailID"];
            this.isRequiredPP = data["isRequiredPP"];
            this.floor = data["floor"];
            this.typeName = data["typeName"];
            this.area = data["area"];
            this.detailName = data["detailName"];
            this.facingId = data["facingId"];
        }
    }

    static fromJS(data: any): UnitMobileDto {
        let result = new UnitMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorType"] = this.floorType;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["unitID"] = this.unitID;
        data["bedroom"] = this.bedroom;
        data["zoningID"] = this.zoningID;
        data["zoningName"] = this.zoningName;
        data["detailCode"] = this.detailCode;
        data["detailImage"] = this.detailImage;
        data["detailID"] = this.detailID;
        data["isRequiredPP"] = this.isRequiredPP;
        data["floor"] = this.floor;
        data["typeName"] = this.typeName;
        data["area"] = this.area;
        data["detailName"] = this.detailName;
        data["facingId"] = this.facingId;
        return data; 
    }
}

export interface IUnitMobileDto {
    floorType: string;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    unitID: number;
    bedroom: string;
    zoningID: number;
    zoningName: string;
    detailCode: string;
    detailImage: string;
    detailID: number;
    isRequiredPP: boolean;
    floor: string;
    typeName: string;
    area: number;
    detailName: string;
    facingId: number;
}

export class ListRenovationResultDto implements IListRenovationResultDto {
    renovationID: number;
    renovationCode: string;
    renovationName: string;
    creationTime: moment.Moment;

    constructor(data?: IListRenovationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovationID = data["renovationID"];
            this.renovationCode = data["renovationCode"];
            this.renovationName = data["renovationName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ListRenovationResultDto {
        let result = new ListRenovationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovationID"] = this.renovationID;
        data["renovationCode"] = this.renovationCode;
        data["renovationName"] = this.renovationName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IListRenovationResultDto {
    renovationID: number;
    renovationCode: string;
    renovationName: string;
    creationTime: moment.Moment;
}

export class ListTermResultDto implements IListTermResultDto {
    termID: number;
    termName: string;
    sortNo: number;

    constructor(data?: IListTermResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): ListTermResultDto {
        let result = new ListTermResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IListTermResultDto {
    termID: number;
    termName: string;
    sortNo: number;
}

export class GrossPriceDto implements IGrossPriceDto {
    grossPrice: number;
    bookingFee: number;
    includeVat: boolean;
    percentPPN: number;
    sellingPrice: number;

    constructor(data?: IGrossPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.grossPrice = data["grossPrice"];
            this.bookingFee = data["bookingFee"];
            this.includeVat = data["includeVat"];
            this.percentPPN = data["percentPPN"];
            this.sellingPrice = data["sellingPrice"];
        }
    }

    static fromJS(data: any): GrossPriceDto {
        let result = new GrossPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossPrice"] = this.grossPrice;
        data["bookingFee"] = this.bookingFee;
        data["includeVat"] = this.includeVat;
        data["percentPPN"] = this.percentPPN;
        data["sellingPrice"] = this.sellingPrice;
        return data; 
    }
}

export interface IGrossPriceDto {
    grossPrice: number;
    bookingFee: number;
    includeVat: boolean;
    percentPPN: number;
    sellingPrice: number;
}

export class GetKprSettingResultDto implements IGetKprSettingResultDto {
    tenor: number;
    sukuBunga: number;

    constructor(data?: IGetKprSettingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
        }
    }

    static fromJS(data: any): GetKprSettingResultDto {
        let result = new GetKprSettingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        return data; 
    }
}

export interface IGetKprSettingResultDto {
    tenor: number;
    sukuBunga: number;
}

export class GetDropDownDpListDto implements IGetDropDownDpListDto {
    dpPct: number[];

    constructor(data?: IGetDropDownDpListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dpPct"] && data["dpPct"].constructor === Array) {
                this.dpPct = [];
                for (let item of data["dpPct"])
                    this.dpPct.push(item);
            }
        }
    }

    static fromJS(data: any): GetDropDownDpListDto {
        let result = new GetDropDownDpListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dpPct && this.dpPct.constructor === Array) {
            data["dpPct"] = [];
            for (let item of this.dpPct)
                data["dpPct"].push(item);
        }
        return data; 
    }
}

export interface IGetDropDownDpListDto {
    dpPct: number[];
}

export class GetListDiagramaticFlutterResultDto implements IGetListDiagramaticFlutterResultDto {
    diagramaticType: string;
    unitType: string;
    floor: string;
    units: UnitsFlutterDto[];
    message: string;

    constructor(data?: IGetListDiagramaticFlutterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.unitType = data["unitType"];
            this.floor = data["floor"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitsFlutterDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetListDiagramaticFlutterResultDto {
        let result = new GetListDiagramaticFlutterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["unitType"] = this.unitType;
        data["floor"] = this.floor;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetListDiagramaticFlutterResultDto {
    diagramaticType: string;
    unitType: string;
    floor: string;
    units: UnitsFlutterDto[];
    message: string;
}

export class UnitsFlutterDto implements IUnitsFlutterDto {
    floor: string;
    unitID: number;
    unitNo: string;
    unitStatusCode: string;
    detailName: string;
    unitType: string;

    constructor(data?: IUnitsFlutterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.floor = data["floor"];
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.detailName = data["detailName"];
            this.unitType = data["unitType"];
        }
    }

    static fromJS(data: any): UnitsFlutterDto {
        let result = new UnitsFlutterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floor"] = this.floor;
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["detailName"] = this.detailName;
        data["unitType"] = this.unitType;
        return data; 
    }
}

export interface IUnitsFlutterDto {
    floor: string;
    unitID: number;
    unitNo: string;
    unitStatusCode: string;
    detailName: string;
    unitType: string;
}

export class GetDiagramaticForWebListDto implements IGetDiagramaticForWebListDto {
    diagramaticType: string;
    unitCodeId: number;
    unitCode: string;
    unitName: string;
    floor: string;
    units: UnitsDto[];
    message: string;
    unitID: number[];

    constructor(data?: IGetDiagramaticForWebListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.unitCodeId = data["unitCodeId"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.floor = data["floor"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitsDto.fromJS(item));
            }
            this.message = data["message"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
        }
    }

    static fromJS(data: any): GetDiagramaticForWebListDto {
        let result = new GetDiagramaticForWebListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["unitCodeId"] = this.unitCodeId;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["floor"] = this.floor;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        return data; 
    }
}

export interface IGetDiagramaticForWebListDto {
    diagramaticType: string;
    unitCodeId: number;
    unitCode: string;
    unitName: string;
    floor: string;
    units: UnitsDto[];
    message: string;
    unitID: number[];
}

export class UnitsDto implements IUnitsDto {
    floor: string;
    typeName: string;
    unitID: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    bedroom: string;
    zoningName: string;
    detailCode: string;
    detailImage: string;
    detailID: number;
    zoningID: number;
    isRequiredPP: boolean;
    area: number;
    detailName: string;
    unitCode: string;
    unitType: string;

    constructor(data?: IUnitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.floor = data["floor"];
            this.typeName = data["typeName"];
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.bedroom = data["bedroom"];
            this.zoningName = data["zoningName"];
            this.detailCode = data["detailCode"];
            this.detailImage = data["detailImage"];
            this.detailID = data["detailID"];
            this.zoningID = data["zoningID"];
            this.isRequiredPP = data["isRequiredPP"];
            this.area = data["area"];
            this.detailName = data["detailName"];
            this.unitCode = data["unitCode"];
            this.unitType = data["unitType"];
        }
    }

    static fromJS(data: any): UnitsDto {
        let result = new UnitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floor"] = this.floor;
        data["typeName"] = this.typeName;
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["bedroom"] = this.bedroom;
        data["zoningName"] = this.zoningName;
        data["detailCode"] = this.detailCode;
        data["detailImage"] = this.detailImage;
        data["detailID"] = this.detailID;
        data["zoningID"] = this.zoningID;
        data["isRequiredPP"] = this.isRequiredPP;
        data["area"] = this.area;
        data["detailName"] = this.detailName;
        data["unitCode"] = this.unitCode;
        data["unitType"] = this.unitType;
        return data; 
    }
}

export interface IUnitsDto {
    floor: string;
    typeName: string;
    unitID: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    bedroom: string;
    zoningName: string;
    detailCode: string;
    detailImage: string;
    detailID: number;
    zoningID: number;
    isRequiredPP: boolean;
    area: number;
    detailName: string;
    unitCode: string;
    unitType: string;
}

export class VerifyPPNoInputDto implements IVerifyPPNoInputDto {
    birthDate: string;
    ppNo: string;

    constructor(data?: IVerifyPPNoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.birthDate = data["birthDate"];
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): VerifyPPNoInputDto {
        let result = new VerifyPPNoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate;
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IVerifyPPNoInputDto {
    birthDate: string;
    ppNo: string;
}

export class ResultPPNewMessageDto implements IResultPPNewMessageDto {
    customerName: string;
    pscode: string;
    listPP: ListPPDtoNew[];

    constructor(data?: IResultPPNewMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.pscode = data["pscode"];
            if (data["listPP"] && data["listPP"].constructor === Array) {
                this.listPP = [];
                for (let item of data["listPP"])
                    this.listPP.push(ListPPDtoNew.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultPPNewMessageDto {
        let result = new ResultPPNewMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["pscode"] = this.pscode;
        if (this.listPP && this.listPP.constructor === Array) {
            data["listPP"] = [];
            for (let item of this.listPP)
                data["listPP"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IResultPPNewMessageDto {
    customerName: string;
    pscode: string;
    listPP: ListPPDtoNew[];
}

export class ListPPDtoNew implements IListPPDtoNew {
    ppNo: string;
    keteranganPP: string;
    typePP: string;
    status: string;

    constructor(data?: IListPPDtoNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNo = data["ppNo"];
            this.keteranganPP = data["keteranganPP"];
            this.typePP = data["typePP"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ListPPDtoNew {
        let result = new ListPPDtoNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNo"] = this.ppNo;
        data["keteranganPP"] = this.keteranganPP;
        data["typePP"] = this.typePP;
        data["status"] = this.status;
        return data; 
    }
}

export interface IListPPDtoNew {
    ppNo: string;
    keteranganPP: string;
    typePP: string;
    status: string;
}

export class GetUnitSelectionDetailDto implements IGetUnitSelectionDetailDto {
    projectName: string;
    tower: string;
    unitCode: string;
    unitNo: string;
    bfAmount: number;
    projectID: number;
    projectInfoID: number;
    clusterID: number;
    showAlihdana: boolean;

    constructor(data?: IGetUnitSelectionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.tower = data["tower"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bfAmount = data["bfAmount"];
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.clusterID = data["clusterID"];
            this.showAlihdana = data["showAlihdana"];
        }
    }

    static fromJS(data: any): GetUnitSelectionDetailDto {
        let result = new GetUnitSelectionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["tower"] = this.tower;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bfAmount"] = this.bfAmount;
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["clusterID"] = this.clusterID;
        data["showAlihdana"] = this.showAlihdana;
        return data; 
    }
}

export interface IGetUnitSelectionDetailDto {
    projectName: string;
    tower: string;
    unitCode: string;
    unitNo: string;
    bfAmount: number;
    projectID: number;
    projectInfoID: number;
    clusterID: number;
    showAlihdana: boolean;
}

export class TypeDiagramaticResultDto implements ITypeDiagramaticResultDto {
    category: string;
    type: string;
    typeCode: string;
    detailCode: string;
    detailName: string;
    luas: number;

    constructor(data?: ITypeDiagramaticResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.type = data["type"];
            this.typeCode = data["typeCode"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.luas = data["luas"];
        }
    }

    static fromJS(data: any): TypeDiagramaticResultDto {
        let result = new TypeDiagramaticResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["type"] = this.type;
        data["typeCode"] = this.typeCode;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["luas"] = this.luas;
        return data; 
    }
}

export interface ITypeDiagramaticResultDto {
    category: string;
    type: string;
    typeCode: string;
    detailCode: string;
    detailName: string;
    luas: number;
}

export class ListBedroomResultDto implements IListBedroomResultDto {
    bedroomId: number;
    bedroom: string;

    constructor(data?: IListBedroomResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bedroomId = data["bedroomId"];
            this.bedroom = data["bedroom"];
        }
    }

    static fromJS(data: any): ListBedroomResultDto {
        let result = new ListBedroomResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bedroomId"] = this.bedroomId;
        data["bedroom"] = this.bedroom;
        return data; 
    }
}

export interface IListBedroomResultDto {
    bedroomId: number;
    bedroom: string;
}

export class ListZoningResultDto implements IListZoningResultDto {
    zoningId: number;
    zoningName: string;
    zoningCode: string;

    constructor(data?: IListZoningResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zoningId = data["zoningId"];
            this.zoningName = data["zoningName"];
            this.zoningCode = data["zoningCode"];
        }
    }

    static fromJS(data: any): ListZoningResultDto {
        let result = new ListZoningResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoningId"] = this.zoningId;
        data["zoningName"] = this.zoningName;
        data["zoningCode"] = this.zoningCode;
        return data; 
    }
}

export interface IListZoningResultDto {
    zoningId: number;
    zoningName: string;
    zoningCode: string;
}

export class ListSumberDanaResultDto implements IListSumberDanaResultDto {
    sumberDanaId: number;
    sumberDanaCode: string;
    sumberDanaName: string;

    constructor(data?: IListSumberDanaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sumberDanaId = data["sumberDanaId"];
            this.sumberDanaCode = data["sumberDanaCode"];
            this.sumberDanaName = data["sumberDanaName"];
        }
    }

    static fromJS(data: any): ListSumberDanaResultDto {
        let result = new ListSumberDanaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sumberDanaId"] = this.sumberDanaId;
        data["sumberDanaCode"] = this.sumberDanaCode;
        data["sumberDanaName"] = this.sumberDanaName;
        return data; 
    }
}

export interface IListSumberDanaResultDto {
    sumberDanaId: number;
    sumberDanaCode: string;
    sumberDanaName: string;
}

export class ListTujuanTransaksiResultDto implements IListTujuanTransaksiResultDto {
    tujuanTransaksiId: number;
    tujuanTransaksiCode: string;
    tujuanTransaksiName: string;

    constructor(data?: IListTujuanTransaksiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tujuanTransaksiId = data["tujuanTransaksiId"];
            this.tujuanTransaksiCode = data["tujuanTransaksiCode"];
            this.tujuanTransaksiName = data["tujuanTransaksiName"];
        }
    }

    static fromJS(data: any): ListTujuanTransaksiResultDto {
        let result = new ListTujuanTransaksiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tujuanTransaksiId"] = this.tujuanTransaksiId;
        data["tujuanTransaksiCode"] = this.tujuanTransaksiCode;
        data["tujuanTransaksiName"] = this.tujuanTransaksiName;
        return data; 
    }
}

export interface IListTujuanTransaksiResultDto {
    tujuanTransaksiId: number;
    tujuanTransaksiCode: string;
    tujuanTransaksiName: string;
}

export class ListDetailDiagramaticWebResultDto implements IListDetailDiagramaticWebResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    buildSize: number;
    landSize: number;
    bedroom: string;
    category: string;
    pricePerBuildArea: number;
    pricePerLandArea: number;
    term: ListTerm[];
    floor: string;
    bathroom: string;
    detailName: string;

    constructor(data?: IListDetailDiagramaticWebResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitItemID = data["unitItemID"];
            this.itemID = data["itemID"];
            this.unitCode = data["unitCode"];
            this.unitStatus = data["unitStatus"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.unitNo = data["unitNo"];
            this.buildSize = data["buildSize"];
            this.landSize = data["landSize"];
            this.bedroom = data["bedroom"];
            this.category = data["category"];
            this.pricePerBuildArea = data["pricePerBuildArea"];
            this.pricePerLandArea = data["pricePerLandArea"];
            if (data["term"] && data["term"].constructor === Array) {
                this.term = [];
                for (let item of data["term"])
                    this.term.push(ListTerm.fromJS(item));
            }
            this.floor = data["floor"];
            this.bathroom = data["bathroom"];
            this.detailName = data["detailName"];
        }
    }

    static fromJS(data: any): ListDetailDiagramaticWebResultDto {
        let result = new ListDetailDiagramaticWebResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitItemID"] = this.unitItemID;
        data["itemID"] = this.itemID;
        data["unitCode"] = this.unitCode;
        data["unitStatus"] = this.unitStatus;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["unitNo"] = this.unitNo;
        data["buildSize"] = this.buildSize;
        data["landSize"] = this.landSize;
        data["bedroom"] = this.bedroom;
        data["category"] = this.category;
        data["pricePerBuildArea"] = this.pricePerBuildArea;
        data["pricePerLandArea"] = this.pricePerLandArea;
        if (this.term && this.term.constructor === Array) {
            data["term"] = [];
            for (let item of this.term)
                data["term"].push(item.toJSON());
        }
        data["floor"] = this.floor;
        data["bathroom"] = this.bathroom;
        data["detailName"] = this.detailName;
        return data; 
    }
}

export interface IListDetailDiagramaticWebResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    buildSize: number;
    landSize: number;
    bedroom: string;
    category: string;
    pricePerBuildArea: number;
    pricePerLandArea: number;
    term: ListTerm[];
    floor: string;
    bathroom: string;
    detailName: string;
}

export class ListTerm implements IListTerm {
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;

    constructor(data?: IListTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.listPrice = data["listPrice"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): ListTerm {
        let result = new ListTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["listPrice"] = this.listPrice;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IListTerm {
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;
}

export class ListDetailDiagramaticNewResultDto implements IListDetailDiagramaticNewResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    unitStatusCode: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    buildSize: number;
    landSize: number;
    bedroom: string;
    category: string;
    pricePerBuildArea: number;
    pricePerLandArea: number;
    includeVat: boolean;
    term: ListTermWebDto[];
    floor: string;
    bathroom: string;
    detailName: string;
    isOpenForOrder: boolean;

    constructor(data?: IListDetailDiagramaticNewResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitItemID = data["unitItemID"];
            this.itemID = data["itemID"];
            this.unitCode = data["unitCode"];
            this.unitStatus = data["unitStatus"];
            this.unitStatusCode = data["unitStatusCode"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.unitNo = data["unitNo"];
            this.buildSize = data["buildSize"];
            this.landSize = data["landSize"];
            this.bedroom = data["bedroom"];
            this.category = data["category"];
            this.pricePerBuildArea = data["pricePerBuildArea"];
            this.pricePerLandArea = data["pricePerLandArea"];
            this.includeVat = data["includeVat"];
            if (data["term"] && data["term"].constructor === Array) {
                this.term = [];
                for (let item of data["term"])
                    this.term.push(ListTermWebDto.fromJS(item));
            }
            this.floor = data["floor"];
            this.bathroom = data["bathroom"];
            this.detailName = data["detailName"];
            this.isOpenForOrder = data["isOpenForOrder"];
        }
    }

    static fromJS(data: any): ListDetailDiagramaticNewResultDto {
        let result = new ListDetailDiagramaticNewResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitItemID"] = this.unitItemID;
        data["itemID"] = this.itemID;
        data["unitCode"] = this.unitCode;
        data["unitStatus"] = this.unitStatus;
        data["unitStatusCode"] = this.unitStatusCode;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["unitNo"] = this.unitNo;
        data["buildSize"] = this.buildSize;
        data["landSize"] = this.landSize;
        data["bedroom"] = this.bedroom;
        data["category"] = this.category;
        data["pricePerBuildArea"] = this.pricePerBuildArea;
        data["pricePerLandArea"] = this.pricePerLandArea;
        data["includeVat"] = this.includeVat;
        if (this.term && this.term.constructor === Array) {
            data["term"] = [];
            for (let item of this.term)
                data["term"].push(item.toJSON());
        }
        data["floor"] = this.floor;
        data["bathroom"] = this.bathroom;
        data["detailName"] = this.detailName;
        data["isOpenForOrder"] = this.isOpenForOrder;
        return data; 
    }
}

export interface IListDetailDiagramaticNewResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    unitStatusCode: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    buildSize: number;
    landSize: number;
    bedroom: string;
    category: string;
    pricePerBuildArea: number;
    pricePerLandArea: number;
    includeVat: boolean;
    term: ListTermWebDto[];
    floor: string;
    bathroom: string;
    detailName: string;
    isOpenForOrder: boolean;
}

export class ListTermWebDto implements IListTermWebDto {
    termID: number;
    termName: string;
    dataTerm: ListPriceWebDto[];
    sortNo: number;

    constructor(data?: IListTermWebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
            if (data["dataTerm"] && data["dataTerm"].constructor === Array) {
                this.dataTerm = [];
                for (let item of data["dataTerm"])
                    this.dataTerm.push(ListPriceWebDto.fromJS(item));
            }
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): ListTermWebDto {
        let result = new ListTermWebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        if (this.dataTerm && this.dataTerm.constructor === Array) {
            data["dataTerm"] = [];
            for (let item of this.dataTerm)
                data["dataTerm"].push(item.toJSON());
        }
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IListTermWebDto {
    termID: number;
    termName: string;
    dataTerm: ListPriceWebDto[];
    sortNo: number;
}

export class ListPriceWebDto implements IListPriceWebDto {
    termID: number;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;

    constructor(data?: IListPriceWebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.listPrice = data["listPrice"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): ListPriceWebDto {
        let result = new ListPriceWebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["listPrice"] = this.listPrice;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IListPriceWebDto {
    termID: number;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;
}

export class ListPaymentTypeResultDto implements IListPaymentTypeResultDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;

    constructor(data?: IListPaymentTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTypeID = data["paymentTypeID"];
            this.paymentType = data["paymentType"];
            this.paymentTypeName = data["paymentTypeName"];
        }
    }

    static fromJS(data: any): ListPaymentTypeResultDto {
        let result = new ListPaymentTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTypeID"] = this.paymentTypeID;
        data["paymentType"] = this.paymentType;
        data["paymentTypeName"] = this.paymentTypeName;
        return data; 
    }
}

export interface IListPaymentTypeResultDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;
}

export class ListPaymentTypeGatewayResultDto implements IListPaymentTypeGatewayResultDto {
    ipay88: ListPaymentIpayDto[];
    midtrans: ListPaymentMidtransDto[];
    vaNobu: ListPaymentMidtransDto[];

    constructor(data?: IListPaymentTypeGatewayResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ipay88"] && data["ipay88"].constructor === Array) {
                this.ipay88 = [];
                for (let item of data["ipay88"])
                    this.ipay88.push(ListPaymentIpayDto.fromJS(item));
            }
            if (data["midtrans"] && data["midtrans"].constructor === Array) {
                this.midtrans = [];
                for (let item of data["midtrans"])
                    this.midtrans.push(ListPaymentMidtransDto.fromJS(item));
            }
            if (data["vaNobu"] && data["vaNobu"].constructor === Array) {
                this.vaNobu = [];
                for (let item of data["vaNobu"])
                    this.vaNobu.push(ListPaymentMidtransDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListPaymentTypeGatewayResultDto {
        let result = new ListPaymentTypeGatewayResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ipay88 && this.ipay88.constructor === Array) {
            data["ipay88"] = [];
            for (let item of this.ipay88)
                data["ipay88"].push(item.toJSON());
        }
        if (this.midtrans && this.midtrans.constructor === Array) {
            data["midtrans"] = [];
            for (let item of this.midtrans)
                data["midtrans"].push(item.toJSON());
        }
        if (this.vaNobu && this.vaNobu.constructor === Array) {
            data["vaNobu"] = [];
            for (let item of this.vaNobu)
                data["vaNobu"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListPaymentTypeGatewayResultDto {
    ipay88: ListPaymentIpayDto[];
    midtrans: ListPaymentMidtransDto[];
    vaNobu: ListPaymentMidtransDto[];
}

export class ListPaymentIpayDto implements IListPaymentIpayDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;

    constructor(data?: IListPaymentIpayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTypeID = data["paymentTypeID"];
            this.paymentType = data["paymentType"];
            this.paymentTypeName = data["paymentTypeName"];
        }
    }

    static fromJS(data: any): ListPaymentIpayDto {
        let result = new ListPaymentIpayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTypeID"] = this.paymentTypeID;
        data["paymentType"] = this.paymentType;
        data["paymentTypeName"] = this.paymentTypeName;
        return data; 
    }
}

export interface IListPaymentIpayDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;
}

export class ListPaymentMidtransDto implements IListPaymentMidtransDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;

    constructor(data?: IListPaymentMidtransDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTypeID = data["paymentTypeID"];
            this.paymentType = data["paymentType"];
            this.paymentTypeName = data["paymentTypeName"];
        }
    }

    static fromJS(data: any): ListPaymentMidtransDto {
        let result = new ListPaymentMidtransDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTypeID"] = this.paymentTypeID;
        data["paymentType"] = this.paymentType;
        data["paymentTypeName"] = this.paymentTypeName;
        return data; 
    }
}

export interface IListPaymentMidtransDto {
    paymentTypeID: number;
    paymentType: number;
    paymentTypeName: string;
}

export class GetDropdownUnitCodeMobileResultDto implements IGetDropdownUnitCodeMobileResultDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;

    constructor(data?: IGetDropdownUnitCodeMobileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeID = data["unitCodeID"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
        }
    }

    static fromJS(data: any): GetDropdownUnitCodeMobileResultDto {
        let result = new GetDropdownUnitCodeMobileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeID"] = this.unitCodeID;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        return data; 
    }
}

export interface IGetDropdownUnitCodeMobileResultDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;
}

export class GetDropdownUnitNoMobileResultDto implements IGetDropdownUnitNoMobileResultDto {
    unitID: number;
    unitNo: string;
    unitStatus: string;

    constructor(data?: IGetDropdownUnitNoMobileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.unitStatus = data["unitStatus"];
        }
    }

    static fromJS(data: any): GetDropdownUnitNoMobileResultDto {
        let result = new GetDropdownUnitNoMobileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["unitStatus"] = this.unitStatus;
        return data; 
    }
}

export interface IGetDropdownUnitNoMobileResultDto {
    unitID: number;
    unitNo: string;
    unitStatus: string;
}

export class GetUserRolesDto implements IGetUserRolesDto {
    roleId: number;
    roleName: string;

    constructor(data?: IGetUserRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): GetUserRolesDto {
        let result = new GetUserRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IGetUserRolesDto {
    roleId: number;
    roleName: string;
}

export class SitePlanUnitFloorAvailableDto implements ISitePlanUnitFloorAvailableDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    unitTypeCode: string;
    unitTypeName: string;
    floor: string;
    unitStatusCode: string;
    unitStatusName: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;

    constructor(data?: ISitePlanUnitFloorAvailableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitTypeCode = data["unitTypeCode"];
            this.unitTypeName = data["unitTypeName"];
            this.floor = data["floor"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.diagramaticType = data["diagramaticType"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): SitePlanUnitFloorAvailableDto {
        let result = new SitePlanUnitFloorAvailableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitTypeCode"] = this.unitTypeCode;
        data["unitTypeName"] = this.unitTypeName;
        data["floor"] = this.floor;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["diagramaticType"] = this.diagramaticType;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface ISitePlanUnitFloorAvailableDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    unitTypeCode: string;
    unitTypeName: string;
    floor: string;
    unitStatusCode: string;
    unitStatusName: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;
}

export class DiagramaticSitePlanWebListDto implements IDiagramaticSitePlanWebListDto {
    diagramaticType: string;
    units: UnitSitePlanDto[];
    unitCodeId: number;
    unitCode: string;
    unitName: string;
    floor: string;
    message: string;
    sitePlanID: number;
    sitePlanDir: string;
    viewBox: string[];
    projectInfoId: number;
    clusterId: number;
    productName: string;
    projectID: number;
    totalAvailable: number;
    totalAvailableDRMS: number;
    totalReserved: number;
    totalSold: number;
    totalSoldDRMS: number;
    unitID: number[];
    countUnitDetail: CountDetailSitePlan[];

    constructor(data?: IDiagramaticSitePlanWebListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitSitePlanDto.fromJS(item));
            }
            this.unitCodeId = data["unitCodeId"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.floor = data["floor"];
            this.message = data["message"];
            this.sitePlanID = data["sitePlanID"];
            this.sitePlanDir = data["sitePlanDir"];
            if (data["viewBox"] && data["viewBox"].constructor === Array) {
                this.viewBox = [];
                for (let item of data["viewBox"])
                    this.viewBox.push(item);
            }
            this.projectInfoId = data["projectInfoId"];
            this.clusterId = data["clusterId"];
            this.productName = data["productName"];
            this.projectID = data["projectID"];
            this.totalAvailable = data["totalAvailable"];
            this.totalAvailableDRMS = data["totalAvailableDRMS"];
            this.totalReserved = data["totalReserved"];
            this.totalSold = data["totalSold"];
            this.totalSoldDRMS = data["totalSoldDRMS"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
            if (data["countUnitDetail"] && data["countUnitDetail"].constructor === Array) {
                this.countUnitDetail = [];
                for (let item of data["countUnitDetail"])
                    this.countUnitDetail.push(CountDetailSitePlan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiagramaticSitePlanWebListDto {
        let result = new DiagramaticSitePlanWebListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["unitCodeId"] = this.unitCodeId;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["floor"] = this.floor;
        data["message"] = this.message;
        data["sitePlanID"] = this.sitePlanID;
        data["sitePlanDir"] = this.sitePlanDir;
        if (this.viewBox && this.viewBox.constructor === Array) {
            data["viewBox"] = [];
            for (let item of this.viewBox)
                data["viewBox"].push(item);
        }
        data["projectInfoId"] = this.projectInfoId;
        data["clusterId"] = this.clusterId;
        data["productName"] = this.productName;
        data["projectID"] = this.projectID;
        data["totalAvailable"] = this.totalAvailable;
        data["totalAvailableDRMS"] = this.totalAvailableDRMS;
        data["totalReserved"] = this.totalReserved;
        data["totalSold"] = this.totalSold;
        data["totalSoldDRMS"] = this.totalSoldDRMS;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        if (this.countUnitDetail && this.countUnitDetail.constructor === Array) {
            data["countUnitDetail"] = [];
            for (let item of this.countUnitDetail)
                data["countUnitDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDiagramaticSitePlanWebListDto {
    diagramaticType: string;
    units: UnitSitePlanDto[];
    unitCodeId: number;
    unitCode: string;
    unitName: string;
    floor: string;
    message: string;
    sitePlanID: number;
    sitePlanDir: string;
    viewBox: string[];
    projectInfoId: number;
    clusterId: number;
    productName: string;
    projectID: number;
    totalAvailable: number;
    totalAvailableDRMS: number;
    totalReserved: number;
    totalSold: number;
    totalSoldDRMS: number;
    unitID: number[];
    countUnitDetail: CountDetailSitePlan[];
}

export class UnitSitePlanDto implements IUnitSitePlanDto {
    unitCodeId: number;
    unitName: string;
    floor: string;
    typeName: string;
    unitID: number;
    unitNo: string;
    unitNoFloor: string;
    unitStatusCode: string;
    unitStatusName: string;
    bedroom: string;
    zoningName: string;
    zoningID: number;
    detailCode: string;
    detailImage: string;
    detailID: number;
    isRequiredPP: boolean;
    area: number;
    detailName: string;
    unitCode: string;
    unitType: string;
    svgID: string;
    projectInfoId: number;
    projectId: number;
    clusterId: number;
    clusterCode: string;
    isAvailableOnOtherFloor: boolean;

    constructor(data?: IUnitSitePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeId = data["unitCodeId"];
            this.unitName = data["unitName"];
            this.floor = data["floor"];
            this.typeName = data["typeName"];
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.unitNoFloor = data["unitNoFloor"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.bedroom = data["bedroom"];
            this.zoningName = data["zoningName"];
            this.zoningID = data["zoningID"];
            this.detailCode = data["detailCode"];
            this.detailImage = data["detailImage"];
            this.detailID = data["detailID"];
            this.isRequiredPP = data["isRequiredPP"];
            this.area = data["area"];
            this.detailName = data["detailName"];
            this.unitCode = data["unitCode"];
            this.unitType = data["unitType"];
            this.svgID = data["svgID"];
            this.projectInfoId = data["projectInfoId"];
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            this.clusterCode = data["clusterCode"];
            this.isAvailableOnOtherFloor = data["isAvailableOnOtherFloor"];
        }
    }

    static fromJS(data: any): UnitSitePlanDto {
        let result = new UnitSitePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeId"] = this.unitCodeId;
        data["unitName"] = this.unitName;
        data["floor"] = this.floor;
        data["typeName"] = this.typeName;
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["unitNoFloor"] = this.unitNoFloor;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["bedroom"] = this.bedroom;
        data["zoningName"] = this.zoningName;
        data["zoningID"] = this.zoningID;
        data["detailCode"] = this.detailCode;
        data["detailImage"] = this.detailImage;
        data["detailID"] = this.detailID;
        data["isRequiredPP"] = this.isRequiredPP;
        data["area"] = this.area;
        data["detailName"] = this.detailName;
        data["unitCode"] = this.unitCode;
        data["unitType"] = this.unitType;
        data["svgID"] = this.svgID;
        data["projectInfoId"] = this.projectInfoId;
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        data["clusterCode"] = this.clusterCode;
        data["isAvailableOnOtherFloor"] = this.isAvailableOnOtherFloor;
        return data; 
    }
}

export interface IUnitSitePlanDto {
    unitCodeId: number;
    unitName: string;
    floor: string;
    typeName: string;
    unitID: number;
    unitNo: string;
    unitNoFloor: string;
    unitStatusCode: string;
    unitStatusName: string;
    bedroom: string;
    zoningName: string;
    zoningID: number;
    detailCode: string;
    detailImage: string;
    detailID: number;
    isRequiredPP: boolean;
    area: number;
    detailName: string;
    unitCode: string;
    unitType: string;
    svgID: string;
    projectInfoId: number;
    projectId: number;
    clusterId: number;
    clusterCode: string;
    isAvailableOnOtherFloor: boolean;
}

export class CountDetailSitePlan implements ICountDetailSitePlan {
    detailName: string;
    countUnitAvailable: number;

    constructor(data?: ICountDetailSitePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailName = data["detailName"];
            this.countUnitAvailable = data["countUnitAvailable"];
        }
    }

    static fromJS(data: any): CountDetailSitePlan {
        let result = new CountDetailSitePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailName"] = this.detailName;
        data["countUnitAvailable"] = this.countUnitAvailable;
        return data; 
    }
}

export interface ICountDetailSitePlan {
    detailName: string;
    countUnitAvailable: number;
}

export class GetDetailClusterByUnitId implements IGetDetailClusterByUnitId {
    unitID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetDetailClusterByUnitId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetDetailClusterByUnitId {
        let result = new GetDetailClusterByUnitId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetDetailClusterByUnitId {
    unitID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class GetProgramDto implements IGetProgramDto {
    id: number;
    programId: number;
    campaignName: string;
    isdefault: boolean;

    constructor(data?: IGetProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.programId = data["programId"];
            this.campaignName = data["campaignName"];
            this.isdefault = data["isdefault"];
        }
    }

    static fromJS(data: any): GetProgramDto {
        let result = new GetProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programId"] = this.programId;
        data["campaignName"] = this.campaignName;
        data["isdefault"] = this.isdefault;
        return data; 
    }
}

export interface IGetProgramDto {
    id: number;
    programId: number;
    campaignName: string;
    isdefault: boolean;
}

export class GetPromoSitePlanDto implements IGetPromoSitePlanDto {
    campaignHeaderID: number;
    projectID: number;
    projectInfoID: number;
    previewPromoImage: string;
    detailPromoImage: string;
    previewPromoLink: string;
    detailPromoLink: string;
    previewPromoLinkHttps: string;
    detailPromoLinkHttps: string;

    constructor(data?: IGetPromoSitePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.previewPromoImage = data["previewPromoImage"];
            this.detailPromoImage = data["detailPromoImage"];
            this.previewPromoLink = data["previewPromoLink"];
            this.detailPromoLink = data["detailPromoLink"];
            this.previewPromoLinkHttps = data["previewPromoLinkHttps"];
            this.detailPromoLinkHttps = data["detailPromoLinkHttps"];
        }
    }

    static fromJS(data: any): GetPromoSitePlanDto {
        let result = new GetPromoSitePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["previewPromoImage"] = this.previewPromoImage;
        data["detailPromoImage"] = this.detailPromoImage;
        data["previewPromoLink"] = this.previewPromoLink;
        data["detailPromoLink"] = this.detailPromoLink;
        data["previewPromoLinkHttps"] = this.previewPromoLinkHttps;
        data["detailPromoLinkHttps"] = this.detailPromoLinkHttps;
        return data; 
    }
}

export interface IGetPromoSitePlanDto {
    campaignHeaderID: number;
    projectID: number;
    projectInfoID: number;
    previewPromoImage: string;
    detailPromoImage: string;
    previewPromoLink: string;
    detailPromoLink: string;
    previewPromoLinkHttps: string;
    detailPromoLinkHttps: string;
}

export class GetProgramRewardDto implements IGetProgramRewardDto {
    programId: number;
    rewardName: RewardName[];

    constructor(data?: IGetProgramRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programId = data["programId"];
            if (data["rewardName"] && data["rewardName"].constructor === Array) {
                this.rewardName = [];
                for (let item of data["rewardName"])
                    this.rewardName.push(RewardName.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProgramRewardDto {
        let result = new GetProgramRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        if (this.rewardName && this.rewardName.constructor === Array) {
            data["rewardName"] = [];
            for (let item of this.rewardName)
                data["rewardName"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetProgramRewardDto {
    programId: number;
    rewardName: RewardName[];
}

export class RewardName implements IRewardName {
    rewardID: number;
    rewardName: string;

    constructor(data?: IRewardName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
        }
    }

    static fromJS(data: any): RewardName {
        let result = new RewardName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        return data; 
    }
}

export interface IRewardName {
    rewardID: number;
    rewardName: string;
}

export class GetGenerateVoucherFlag implements IGetGenerateVoucherFlag {
    isGenerateVoucher: boolean;

    constructor(data?: IGetGenerateVoucherFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isGenerateVoucher = data["isGenerateVoucher"];
        }
    }

    static fromJS(data: any): GetGenerateVoucherFlag {
        let result = new GetGenerateVoucherFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGenerateVoucher"] = this.isGenerateVoucher;
        return data; 
    }
}

export interface IGetGenerateVoucherFlag {
    isGenerateVoucher: boolean;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items: EditionListDto[];

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[];
}

export class EditionListDto implements IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class EditionEditDto implements IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class IValueValidator implements IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string;
    displayText: string;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string;
    displayText: string;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto = new EditionEditDto();
    featureValues: NameValueDto[] = [];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class AfterReservedInputDto implements IAfterReservedInputDto {
    customerName: string;
    orderCode: string;
    unitCode: string;
    unitNo: string;
    orderDate: moment.Moment;
    projectName: string;
    clusterName: string;
    bfAmount: number;
    bankName: string;
    vaNumber: string;
    expiredDate: moment.Moment;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectImage: string;

    constructor(data?: IAfterReservedInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.orderCode = data["orderCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.bfAmount = data["bfAmount"];
            this.bankName = data["bankName"];
            this.vaNumber = data["vaNumber"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.memberName = data["memberName"];
            this.memberPhone = data["memberPhone"];
            this.devPhone = data["devPhone"];
            this.marketingOffice = data["marketingOffice"];
            this.projectImage = data["projectImage"];
        }
    }

    static fromJS(data: any): AfterReservedInputDto {
        let result = new AfterReservedInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["orderCode"] = this.orderCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["bfAmount"] = this.bfAmount;
        data["bankName"] = this.bankName;
        data["vaNumber"] = this.vaNumber;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["memberName"] = this.memberName;
        data["memberPhone"] = this.memberPhone;
        data["devPhone"] = this.devPhone;
        data["marketingOffice"] = this.marketingOffice;
        data["projectImage"] = this.projectImage;
        return data; 
    }
}

export interface IAfterReservedInputDto {
    customerName: string;
    orderCode: string;
    unitCode: string;
    unitNo: string;
    orderDate: moment.Moment;
    projectName: string;
    clusterName: string;
    bfAmount: number;
    bankName: string;
    vaNumber: string;
    expiredDate: moment.Moment;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectImage: string;
}

export class Reminder2JamInputDto implements IReminder2JamInputDto {
    projectImage: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    orderDate: moment.Moment;
    bookingFee: number;
    bankName: string;
    vaNumber: string;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectName: string;

    constructor(data?: IReminder2JamInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectImage = data["projectImage"];
            this.customerName = data["customerName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.bookingFee = data["bookingFee"];
            this.bankName = data["bankName"];
            this.vaNumber = data["vaNumber"];
            this.memberName = data["memberName"];
            this.memberPhone = data["memberPhone"];
            this.devPhone = data["devPhone"];
            this.marketingOffice = data["marketingOffice"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): Reminder2JamInputDto {
        let result = new Reminder2JamInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectImage"] = this.projectImage;
        data["customerName"] = this.customerName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["bookingFee"] = this.bookingFee;
        data["bankName"] = this.bankName;
        data["vaNumber"] = this.vaNumber;
        data["memberName"] = this.memberName;
        data["memberPhone"] = this.memberPhone;
        data["devPhone"] = this.devPhone;
        data["marketingOffice"] = this.marketingOffice;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IReminder2JamInputDto {
    projectImage: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    orderDate: moment.Moment;
    bookingFee: number;
    bankName: string;
    vaNumber: string;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectName: string;
}

export class UnitExpiredInputDto implements IUnitExpiredInputDto {
    projectImage: string;
    customerName: string;
    orderCode: string;
    unitCode: string;
    unitNo: string;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectName: string;

    constructor(data?: IUnitExpiredInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectImage = data["projectImage"];
            this.customerName = data["customerName"];
            this.orderCode = data["orderCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.memberName = data["memberName"];
            this.memberPhone = data["memberPhone"];
            this.devPhone = data["devPhone"];
            this.marketingOffice = data["marketingOffice"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): UnitExpiredInputDto {
        let result = new UnitExpiredInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectImage"] = this.projectImage;
        data["customerName"] = this.customerName;
        data["orderCode"] = this.orderCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["memberName"] = this.memberName;
        data["memberPhone"] = this.memberPhone;
        data["devPhone"] = this.devPhone;
        data["marketingOffice"] = this.marketingOffice;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IUnitExpiredInputDto {
    projectImage: string;
    customerName: string;
    orderCode: string;
    unitCode: string;
    unitNo: string;
    memberName: string;
    memberPhone: string;
    devPhone: string;
    marketingOffice: string;
    projectName: string;
}

export class ResendEmailDocDto implements IResendEmailDocDto {
    customerName: string;
    documentType: string;
    templateName: string;
    linkFile: string;

    constructor(data?: IResendEmailDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.documentType = data["documentType"];
            this.templateName = data["templateName"];
            this.linkFile = data["linkFile"];
        }
    }

    static fromJS(data: any): ResendEmailDocDto {
        let result = new ResendEmailDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["documentType"] = this.documentType;
        data["templateName"] = this.templateName;
        data["linkFile"] = this.linkFile;
        return data; 
    }
}

export interface IResendEmailDocDto {
    customerName: string;
    documentType: string;
    templateName: string;
    linkFile: string;
}

export class SendPaymentInstructionEmailDto implements ISendPaymentInstructionEmailDto {
    customerName: string;
    virtualAccount: string;
    totalDP: string;
    templateName: string;
    titlePayment: string;
    typePayment: string;

    constructor(data?: ISendPaymentInstructionEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.virtualAccount = data["virtualAccount"];
            this.totalDP = data["totalDP"];
            this.templateName = data["templateName"];
            this.titlePayment = data["titlePayment"];
            this.typePayment = data["typePayment"];
        }
    }

    static fromJS(data: any): SendPaymentInstructionEmailDto {
        let result = new SendPaymentInstructionEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["virtualAccount"] = this.virtualAccount;
        data["totalDP"] = this.totalDP;
        data["templateName"] = this.templateName;
        data["titlePayment"] = this.titlePayment;
        data["typePayment"] = this.typePayment;
        return data; 
    }
}

export interface ISendPaymentInstructionEmailDto {
    customerName: string;
    virtualAccount: string;
    totalDP: string;
    templateName: string;
    titlePayment: string;
    typePayment: string;
}

export class BookingSuccessInputDto implements IBookingSuccessInputDto {
    projectImage: string;
    customerName: string;
    bookDate: string;
    devPhone: string;
    memberName: string;
    memberPhone: string;
    projectName: string;
    email: string;
    urlNotaris: string;
    listDataOrder: KonfirmasiPesananDto;
    listDataUnit: ListunitDto;
    fileHtml: string;

    constructor(data?: IBookingSuccessInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectImage = data["projectImage"];
            this.customerName = data["customerName"];
            this.bookDate = data["bookDate"];
            this.devPhone = data["devPhone"];
            this.memberName = data["memberName"];
            this.memberPhone = data["memberPhone"];
            this.projectName = data["projectName"];
            this.email = data["email"];
            this.urlNotaris = data["urlNotaris"];
            this.listDataOrder = data["listDataOrder"] ? KonfirmasiPesananDto.fromJS(data["listDataOrder"]) : <any>undefined;
            this.listDataUnit = data["listDataUnit"] ? ListunitDto.fromJS(data["listDataUnit"]) : <any>undefined;
            this.fileHtml = data["fileHtml"];
        }
    }

    static fromJS(data: any): BookingSuccessInputDto {
        let result = new BookingSuccessInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectImage"] = this.projectImage;
        data["customerName"] = this.customerName;
        data["bookDate"] = this.bookDate;
        data["devPhone"] = this.devPhone;
        data["memberName"] = this.memberName;
        data["memberPhone"] = this.memberPhone;
        data["projectName"] = this.projectName;
        data["email"] = this.email;
        data["urlNotaris"] = this.urlNotaris;
        data["listDataOrder"] = this.listDataOrder ? this.listDataOrder.toJSON() : <any>undefined;
        data["listDataUnit"] = this.listDataUnit ? this.listDataUnit.toJSON() : <any>undefined;
        data["fileHtml"] = this.fileHtml;
        return data; 
    }
}

export interface IBookingSuccessInputDto {
    projectImage: string;
    customerName: string;
    bookDate: string;
    devPhone: string;
    memberName: string;
    memberPhone: string;
    projectName: string;
    email: string;
    urlNotaris: string;
    listDataOrder: KonfirmasiPesananDto;
    listDataUnit: ListunitDto;
    fileHtml: string;
}

export class KonfirmasiPesananDto implements IKonfirmasiPesananDto {
    orderCode: string;
    psCode: string;
    tglBooking: string;
    bookDate: moment.Moment;
    projectImage: string;
    psName: string;
    psNoHp: string;
    psEmail: string;
    psAddress: string;
    psJob: string;
    psIdNo: string;
    psNPWP: string;
    psBirthday: string;
    psSumberDana: string;
    psTujuanTransaksi: string;
    membername: string;
    membercode: string;
    memberphone: string;
    unitCode: string;
    unitNo: string;
    unitName: string;
    luas: string;
    tipe: string;
    cluster: string;
    categoryCode: string;
    tglSerahTerima: string;
    tglSerahTerima2: string;
    netPrice: string;
    termDiscAmt: string;
    netNetPrice: string;
    ppn: string;
    sellingPrices: number;
    termNo: string;
    termName: string;
    bookingFee: string;
    listDP: ListDownPayment[];
    listCicilan: ListCicilanDto[];
    bankName: string;
    noVA: string;
    companyName: string;
    companyAddress: string;
    companyPhone: string;
    companyWebAddress: string;
    companyEmail: string;
    subKomplek: string;
    komplekAddress: string;
    luasKavling: number;
    luasBangunan: number;
    parameterCode: string;
    headerTemplate: string;
    footerTemplate: string;
    bodyTemplate: string;
    totalDP: string;
    totalDPAmt: string;
    totalDPVat: string;
    bfAmount: number;
    bfAmt: number;
    bfVat: number;
    listPathTnc: string[];
    kadasterPath: string;
    dpPersen: number;
    sellingPrice: string;
    vat: number;
    netNetPrices: number;
    clusterField: string;
    roadField: string;
    kavNoField: string;
    areaField: string;
    diagramaticType: string;
    landArea: string;
    renovation: string;
    priceLandBuild: string;
    priceRenov: string;
    pelunasan: string;
    gracePeriod: string;
    handOver: string;
    noKtp: string;
    noNpwp: string;
    noKk: string;
    corressAddress: string;
    domisiliAddress: string;
    paymentType: string;
    bankRekening: string;
    pemilikRekening: string;
    noRekening: string;
    namaKeluarga: string;
    dpDue: string;
    kelebihanTanah: string;
    fintimes: string;
    noTelpKeluarga: string;
    tglBookingFee: string;
    adddiscdesc1: string;
    adddiscdesc2: string;
    adddiscdesc3: string;
    adddiscdesc4: string;
    adddiscdesc5: string;
    adddiscno1: string;
    adddiscno2: string;
    adddiscno3: string;
    adddiscno4: string;
    adddiscno5: string;
    pctdisc1: string;
    pctdisc2: string;
    pctdisc3: string;
    pctdisc4: string;
    pctdisc5: string;
    netprice: string;
    grossprice: string;
    sellingdisc: string;
    amtsellingdisc: string;
    amtAddPct1: string;
    amtAddPct2: string;
    amtAddPct3: string;
    amtAddPct4: string;
    amtAddPct5: string;
    discwft: string;
    addDiscText: string;
    totalOutBookingFee: string;
    paymentTypeBF: string;
    clearDateBF: string;
    nup: string;
    luasExt: number;
    totalPaid: string;
    totalUnpaid: string;
    isGenerateVoucher: boolean;
    marketingProgramName: string;
    voucherTNC: string;
    voucherCodeOtomatis: string;
    isBookingFeeReward: boolean;
    newSectionEHtml: string;
    subsidiPPN: number;
    amountSubsidiPPN: string;
    projectID: number;
    projectName: string;
    ppn10Percent: string;
    amountPpn10Percent: number;
    amountHargaPpn10Percent: number;
    hargaPpn10Percent: string;
    hargaPPNSubsidi: string;
    amountHargaPPNSubsidi: number;
    nominalSubsidiPPN: number;
    biayaSertifikat: string;
    totalDenganSertifikat: string;
    amountBiayaSertifikat: number;
    flagBiayaSertifikat: boolean;
    totalScheduleSubsidi: string;
    scheduleSubsidi: ListCicilanDto;
    flagScheduleSubsidi: boolean;
    percentPPN: number;

    constructor(data?: IKonfirmasiPesananDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.psCode = data["psCode"];
            this.tglBooking = data["tglBooking"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.projectImage = data["projectImage"];
            this.psName = data["psName"];
            this.psNoHp = data["psNoHp"];
            this.psEmail = data["psEmail"];
            this.psAddress = data["psAddress"];
            this.psJob = data["psJob"];
            this.psIdNo = data["psIdNo"];
            this.psNPWP = data["psNPWP"];
            this.psBirthday = data["psBirthday"];
            this.psSumberDana = data["psSumberDana"];
            this.psTujuanTransaksi = data["psTujuanTransaksi"];
            this.membername = data["membername"];
            this.membercode = data["membercode"];
            this.memberphone = data["memberphone"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitName = data["unitName"];
            this.luas = data["luas"];
            this.tipe = data["tipe"];
            this.cluster = data["cluster"];
            this.categoryCode = data["categoryCode"];
            this.tglSerahTerima = data["tglSerahTerima"];
            this.tglSerahTerima2 = data["tglSerahTerima2"];
            this.netPrice = data["netPrice"];
            this.termDiscAmt = data["termDiscAmt"];
            this.netNetPrice = data["netNetPrice"];
            this.ppn = data["ppn"];
            this.sellingPrices = data["sellingPrices"];
            this.termNo = data["termNo"];
            this.termName = data["termName"];
            this.bookingFee = data["bookingFee"];
            if (data["listDP"] && data["listDP"].constructor === Array) {
                this.listDP = [];
                for (let item of data["listDP"])
                    this.listDP.push(ListDownPayment.fromJS(item));
            }
            if (data["listCicilan"] && data["listCicilan"].constructor === Array) {
                this.listCicilan = [];
                for (let item of data["listCicilan"])
                    this.listCicilan.push(ListCicilanDto.fromJS(item));
            }
            this.bankName = data["bankName"];
            this.noVA = data["noVA"];
            this.companyName = data["companyName"];
            this.companyAddress = data["companyAddress"];
            this.companyPhone = data["companyPhone"];
            this.companyWebAddress = data["companyWebAddress"];
            this.companyEmail = data["companyEmail"];
            this.subKomplek = data["subKomplek"];
            this.komplekAddress = data["komplekAddress"];
            this.luasKavling = data["luasKavling"];
            this.luasBangunan = data["luasBangunan"];
            this.parameterCode = data["parameterCode"];
            this.headerTemplate = data["headerTemplate"];
            this.footerTemplate = data["footerTemplate"];
            this.bodyTemplate = data["bodyTemplate"];
            this.totalDP = data["totalDP"];
            this.totalDPAmt = data["totalDPAmt"];
            this.totalDPVat = data["totalDPVat"];
            this.bfAmount = data["bfAmount"];
            this.bfAmt = data["bfAmt"];
            this.bfVat = data["bfVat"];
            if (data["listPathTnc"] && data["listPathTnc"].constructor === Array) {
                this.listPathTnc = [];
                for (let item of data["listPathTnc"])
                    this.listPathTnc.push(item);
            }
            this.kadasterPath = data["kadasterPath"];
            this.dpPersen = data["dpPersen"];
            this.sellingPrice = data["sellingPrice"];
            this.vat = data["vat"];
            this.netNetPrices = data["netNetPrices"];
            this.clusterField = data["clusterField"];
            this.roadField = data["roadField"];
            this.kavNoField = data["kavNoField"];
            this.areaField = data["areaField"];
            this.diagramaticType = data["diagramaticType"];
            this.landArea = data["landArea"];
            this.renovation = data["renovation"];
            this.priceLandBuild = data["priceLandBuild"];
            this.priceRenov = data["priceRenov"];
            this.pelunasan = data["pelunasan"];
            this.gracePeriod = data["gracePeriod"];
            this.handOver = data["handOver"];
            this.noKtp = data["noKtp"];
            this.noNpwp = data["noNpwp"];
            this.noKk = data["noKk"];
            this.corressAddress = data["corressAddress"];
            this.domisiliAddress = data["domisiliAddress"];
            this.paymentType = data["paymentType"];
            this.bankRekening = data["bankRekening"];
            this.pemilikRekening = data["pemilikRekening"];
            this.noRekening = data["noRekening"];
            this.namaKeluarga = data["namaKeluarga"];
            this.dpDue = data["dpDue"];
            this.kelebihanTanah = data["kelebihanTanah"];
            this.fintimes = data["fintimes"];
            this.noTelpKeluarga = data["noTelpKeluarga"];
            this.tglBookingFee = data["tglBookingFee"];
            this.adddiscdesc1 = data["adddiscdesc1"];
            this.adddiscdesc2 = data["adddiscdesc2"];
            this.adddiscdesc3 = data["adddiscdesc3"];
            this.adddiscdesc4 = data["adddiscdesc4"];
            this.adddiscdesc5 = data["adddiscdesc5"];
            this.adddiscno1 = data["adddiscno1"];
            this.adddiscno2 = data["adddiscno2"];
            this.adddiscno3 = data["adddiscno3"];
            this.adddiscno4 = data["adddiscno4"];
            this.adddiscno5 = data["adddiscno5"];
            this.pctdisc1 = data["pctdisc1"];
            this.pctdisc2 = data["pctdisc2"];
            this.pctdisc3 = data["pctdisc3"];
            this.pctdisc4 = data["pctdisc4"];
            this.pctdisc5 = data["pctdisc5"];
            this.netprice = data["netprice"];
            this.grossprice = data["grossprice"];
            this.sellingdisc = data["sellingdisc"];
            this.amtsellingdisc = data["amtsellingdisc"];
            this.amtAddPct1 = data["amtAddPct1"];
            this.amtAddPct2 = data["amtAddPct2"];
            this.amtAddPct3 = data["amtAddPct3"];
            this.amtAddPct4 = data["amtAddPct4"];
            this.amtAddPct5 = data["amtAddPct5"];
            this.discwft = data["discwft"];
            this.addDiscText = data["addDiscText"];
            this.totalOutBookingFee = data["totalOutBookingFee"];
            this.paymentTypeBF = data["paymentTypeBF"];
            this.clearDateBF = data["clearDateBF"];
            this.nup = data["nup"];
            this.luasExt = data["luasExt"];
            this.totalPaid = data["totalPaid"];
            this.totalUnpaid = data["totalUnpaid"];
            this.isGenerateVoucher = data["isGenerateVoucher"];
            this.marketingProgramName = data["marketingProgramName"];
            this.voucherTNC = data["voucherTNC"];
            this.voucherCodeOtomatis = data["voucherCodeOtomatis"];
            this.isBookingFeeReward = data["isBookingFeeReward"];
            this.newSectionEHtml = data["newSectionEHtml"];
            this.subsidiPPN = data["subsidiPPN"];
            this.amountSubsidiPPN = data["amountSubsidiPPN"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.ppn10Percent = data["ppn10Percent"];
            this.amountPpn10Percent = data["amountPpn10Percent"];
            this.amountHargaPpn10Percent = data["amountHargaPpn10Percent"];
            this.hargaPpn10Percent = data["hargaPpn10Percent"];
            this.hargaPPNSubsidi = data["hargaPPNSubsidi"];
            this.amountHargaPPNSubsidi = data["amountHargaPPNSubsidi"];
            this.nominalSubsidiPPN = data["nominalSubsidiPPN"];
            this.biayaSertifikat = data["biayaSertifikat"];
            this.totalDenganSertifikat = data["totalDenganSertifikat"];
            this.amountBiayaSertifikat = data["amountBiayaSertifikat"];
            this.flagBiayaSertifikat = data["flagBiayaSertifikat"];
            this.totalScheduleSubsidi = data["totalScheduleSubsidi"];
            this.scheduleSubsidi = data["scheduleSubsidi"] ? ListCicilanDto.fromJS(data["scheduleSubsidi"]) : <any>undefined;
            this.flagScheduleSubsidi = data["flagScheduleSubsidi"];
            this.percentPPN = data["percentPPN"];
        }
    }

    static fromJS(data: any): KonfirmasiPesananDto {
        let result = new KonfirmasiPesananDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["psCode"] = this.psCode;
        data["tglBooking"] = this.tglBooking;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["projectImage"] = this.projectImage;
        data["psName"] = this.psName;
        data["psNoHp"] = this.psNoHp;
        data["psEmail"] = this.psEmail;
        data["psAddress"] = this.psAddress;
        data["psJob"] = this.psJob;
        data["psIdNo"] = this.psIdNo;
        data["psNPWP"] = this.psNPWP;
        data["psBirthday"] = this.psBirthday;
        data["psSumberDana"] = this.psSumberDana;
        data["psTujuanTransaksi"] = this.psTujuanTransaksi;
        data["membername"] = this.membername;
        data["membercode"] = this.membercode;
        data["memberphone"] = this.memberphone;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitName"] = this.unitName;
        data["luas"] = this.luas;
        data["tipe"] = this.tipe;
        data["cluster"] = this.cluster;
        data["categoryCode"] = this.categoryCode;
        data["tglSerahTerima"] = this.tglSerahTerima;
        data["tglSerahTerima2"] = this.tglSerahTerima2;
        data["netPrice"] = this.netPrice;
        data["termDiscAmt"] = this.termDiscAmt;
        data["netNetPrice"] = this.netNetPrice;
        data["ppn"] = this.ppn;
        data["sellingPrices"] = this.sellingPrices;
        data["termNo"] = this.termNo;
        data["termName"] = this.termName;
        data["bookingFee"] = this.bookingFee;
        if (this.listDP && this.listDP.constructor === Array) {
            data["listDP"] = [];
            for (let item of this.listDP)
                data["listDP"].push(item.toJSON());
        }
        if (this.listCicilan && this.listCicilan.constructor === Array) {
            data["listCicilan"] = [];
            for (let item of this.listCicilan)
                data["listCicilan"].push(item.toJSON());
        }
        data["bankName"] = this.bankName;
        data["noVA"] = this.noVA;
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress;
        data["companyPhone"] = this.companyPhone;
        data["companyWebAddress"] = this.companyWebAddress;
        data["companyEmail"] = this.companyEmail;
        data["subKomplek"] = this.subKomplek;
        data["komplekAddress"] = this.komplekAddress;
        data["luasKavling"] = this.luasKavling;
        data["luasBangunan"] = this.luasBangunan;
        data["parameterCode"] = this.parameterCode;
        data["headerTemplate"] = this.headerTemplate;
        data["footerTemplate"] = this.footerTemplate;
        data["bodyTemplate"] = this.bodyTemplate;
        data["totalDP"] = this.totalDP;
        data["totalDPAmt"] = this.totalDPAmt;
        data["totalDPVat"] = this.totalDPVat;
        data["bfAmount"] = this.bfAmount;
        data["bfAmt"] = this.bfAmt;
        data["bfVat"] = this.bfVat;
        if (this.listPathTnc && this.listPathTnc.constructor === Array) {
            data["listPathTnc"] = [];
            for (let item of this.listPathTnc)
                data["listPathTnc"].push(item);
        }
        data["kadasterPath"] = this.kadasterPath;
        data["dpPersen"] = this.dpPersen;
        data["sellingPrice"] = this.sellingPrice;
        data["vat"] = this.vat;
        data["netNetPrices"] = this.netNetPrices;
        data["clusterField"] = this.clusterField;
        data["roadField"] = this.roadField;
        data["kavNoField"] = this.kavNoField;
        data["areaField"] = this.areaField;
        data["diagramaticType"] = this.diagramaticType;
        data["landArea"] = this.landArea;
        data["renovation"] = this.renovation;
        data["priceLandBuild"] = this.priceLandBuild;
        data["priceRenov"] = this.priceRenov;
        data["pelunasan"] = this.pelunasan;
        data["gracePeriod"] = this.gracePeriod;
        data["handOver"] = this.handOver;
        data["noKtp"] = this.noKtp;
        data["noNpwp"] = this.noNpwp;
        data["noKk"] = this.noKk;
        data["corressAddress"] = this.corressAddress;
        data["domisiliAddress"] = this.domisiliAddress;
        data["paymentType"] = this.paymentType;
        data["bankRekening"] = this.bankRekening;
        data["pemilikRekening"] = this.pemilikRekening;
        data["noRekening"] = this.noRekening;
        data["namaKeluarga"] = this.namaKeluarga;
        data["dpDue"] = this.dpDue;
        data["kelebihanTanah"] = this.kelebihanTanah;
        data["fintimes"] = this.fintimes;
        data["noTelpKeluarga"] = this.noTelpKeluarga;
        data["tglBookingFee"] = this.tglBookingFee;
        data["adddiscdesc1"] = this.adddiscdesc1;
        data["adddiscdesc2"] = this.adddiscdesc2;
        data["adddiscdesc3"] = this.adddiscdesc3;
        data["adddiscdesc4"] = this.adddiscdesc4;
        data["adddiscdesc5"] = this.adddiscdesc5;
        data["adddiscno1"] = this.adddiscno1;
        data["adddiscno2"] = this.adddiscno2;
        data["adddiscno3"] = this.adddiscno3;
        data["adddiscno4"] = this.adddiscno4;
        data["adddiscno5"] = this.adddiscno5;
        data["pctdisc1"] = this.pctdisc1;
        data["pctdisc2"] = this.pctdisc2;
        data["pctdisc3"] = this.pctdisc3;
        data["pctdisc4"] = this.pctdisc4;
        data["pctdisc5"] = this.pctdisc5;
        data["netprice"] = this.netprice;
        data["grossprice"] = this.grossprice;
        data["sellingdisc"] = this.sellingdisc;
        data["amtsellingdisc"] = this.amtsellingdisc;
        data["amtAddPct1"] = this.amtAddPct1;
        data["amtAddPct2"] = this.amtAddPct2;
        data["amtAddPct3"] = this.amtAddPct3;
        data["amtAddPct4"] = this.amtAddPct4;
        data["amtAddPct5"] = this.amtAddPct5;
        data["discwft"] = this.discwft;
        data["addDiscText"] = this.addDiscText;
        data["totalOutBookingFee"] = this.totalOutBookingFee;
        data["paymentTypeBF"] = this.paymentTypeBF;
        data["clearDateBF"] = this.clearDateBF;
        data["nup"] = this.nup;
        data["luasExt"] = this.luasExt;
        data["totalPaid"] = this.totalPaid;
        data["totalUnpaid"] = this.totalUnpaid;
        data["isGenerateVoucher"] = this.isGenerateVoucher;
        data["marketingProgramName"] = this.marketingProgramName;
        data["voucherTNC"] = this.voucherTNC;
        data["voucherCodeOtomatis"] = this.voucherCodeOtomatis;
        data["isBookingFeeReward"] = this.isBookingFeeReward;
        data["newSectionEHtml"] = this.newSectionEHtml;
        data["subsidiPPN"] = this.subsidiPPN;
        data["amountSubsidiPPN"] = this.amountSubsidiPPN;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["ppn10Percent"] = this.ppn10Percent;
        data["amountPpn10Percent"] = this.amountPpn10Percent;
        data["amountHargaPpn10Percent"] = this.amountHargaPpn10Percent;
        data["hargaPpn10Percent"] = this.hargaPpn10Percent;
        data["hargaPPNSubsidi"] = this.hargaPPNSubsidi;
        data["amountHargaPPNSubsidi"] = this.amountHargaPPNSubsidi;
        data["nominalSubsidiPPN"] = this.nominalSubsidiPPN;
        data["biayaSertifikat"] = this.biayaSertifikat;
        data["totalDenganSertifikat"] = this.totalDenganSertifikat;
        data["amountBiayaSertifikat"] = this.amountBiayaSertifikat;
        data["flagBiayaSertifikat"] = this.flagBiayaSertifikat;
        data["totalScheduleSubsidi"] = this.totalScheduleSubsidi;
        data["scheduleSubsidi"] = this.scheduleSubsidi ? this.scheduleSubsidi.toJSON() : <any>undefined;
        data["flagScheduleSubsidi"] = this.flagScheduleSubsidi;
        data["percentPPN"] = this.percentPPN;
        return data; 
    }
}

export interface IKonfirmasiPesananDto {
    orderCode: string;
    psCode: string;
    tglBooking: string;
    bookDate: moment.Moment;
    projectImage: string;
    psName: string;
    psNoHp: string;
    psEmail: string;
    psAddress: string;
    psJob: string;
    psIdNo: string;
    psNPWP: string;
    psBirthday: string;
    psSumberDana: string;
    psTujuanTransaksi: string;
    membername: string;
    membercode: string;
    memberphone: string;
    unitCode: string;
    unitNo: string;
    unitName: string;
    luas: string;
    tipe: string;
    cluster: string;
    categoryCode: string;
    tglSerahTerima: string;
    tglSerahTerima2: string;
    netPrice: string;
    termDiscAmt: string;
    netNetPrice: string;
    ppn: string;
    sellingPrices: number;
    termNo: string;
    termName: string;
    bookingFee: string;
    listDP: ListDownPayment[];
    listCicilan: ListCicilanDto[];
    bankName: string;
    noVA: string;
    companyName: string;
    companyAddress: string;
    companyPhone: string;
    companyWebAddress: string;
    companyEmail: string;
    subKomplek: string;
    komplekAddress: string;
    luasKavling: number;
    luasBangunan: number;
    parameterCode: string;
    headerTemplate: string;
    footerTemplate: string;
    bodyTemplate: string;
    totalDP: string;
    totalDPAmt: string;
    totalDPVat: string;
    bfAmount: number;
    bfAmt: number;
    bfVat: number;
    listPathTnc: string[];
    kadasterPath: string;
    dpPersen: number;
    sellingPrice: string;
    vat: number;
    netNetPrices: number;
    clusterField: string;
    roadField: string;
    kavNoField: string;
    areaField: string;
    diagramaticType: string;
    landArea: string;
    renovation: string;
    priceLandBuild: string;
    priceRenov: string;
    pelunasan: string;
    gracePeriod: string;
    handOver: string;
    noKtp: string;
    noNpwp: string;
    noKk: string;
    corressAddress: string;
    domisiliAddress: string;
    paymentType: string;
    bankRekening: string;
    pemilikRekening: string;
    noRekening: string;
    namaKeluarga: string;
    dpDue: string;
    kelebihanTanah: string;
    fintimes: string;
    noTelpKeluarga: string;
    tglBookingFee: string;
    adddiscdesc1: string;
    adddiscdesc2: string;
    adddiscdesc3: string;
    adddiscdesc4: string;
    adddiscdesc5: string;
    adddiscno1: string;
    adddiscno2: string;
    adddiscno3: string;
    adddiscno4: string;
    adddiscno5: string;
    pctdisc1: string;
    pctdisc2: string;
    pctdisc3: string;
    pctdisc4: string;
    pctdisc5: string;
    netprice: string;
    grossprice: string;
    sellingdisc: string;
    amtsellingdisc: string;
    amtAddPct1: string;
    amtAddPct2: string;
    amtAddPct3: string;
    amtAddPct4: string;
    amtAddPct5: string;
    discwft: string;
    addDiscText: string;
    totalOutBookingFee: string;
    paymentTypeBF: string;
    clearDateBF: string;
    nup: string;
    luasExt: number;
    totalPaid: string;
    totalUnpaid: string;
    isGenerateVoucher: boolean;
    marketingProgramName: string;
    voucherTNC: string;
    voucherCodeOtomatis: string;
    isBookingFeeReward: boolean;
    newSectionEHtml: string;
    subsidiPPN: number;
    amountSubsidiPPN: string;
    projectID: number;
    projectName: string;
    ppn10Percent: string;
    amountPpn10Percent: number;
    amountHargaPpn10Percent: number;
    hargaPpn10Percent: string;
    hargaPPNSubsidi: string;
    amountHargaPPNSubsidi: number;
    nominalSubsidiPPN: number;
    biayaSertifikat: string;
    totalDenganSertifikat: string;
    amountBiayaSertifikat: number;
    flagBiayaSertifikat: boolean;
    totalScheduleSubsidi: string;
    scheduleSubsidi: ListCicilanDto;
    flagScheduleSubsidi: boolean;
    percentPPN: number;
}

export class ListunitDto implements IListunitDto {
    unitCode: string;
    unitNo: string;
    luas: string;
    tipe: string;
    cluster: string;
    category: string;

    constructor(data?: IListunitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.luas = data["luas"];
            this.tipe = data["tipe"];
            this.cluster = data["cluster"];
            this.category = data["category"];
        }
    }

    static fromJS(data: any): ListunitDto {
        let result = new ListunitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["luas"] = this.luas;
        data["tipe"] = this.tipe;
        data["cluster"] = this.cluster;
        data["category"] = this.category;
        return data; 
    }
}

export interface IListunitDto {
    unitCode: string;
    unitNo: string;
    luas: string;
    tipe: string;
    cluster: string;
    category: string;
}

export class ListDownPayment implements IListDownPayment {
    dpAmount: string;
    dpAmountDec: number;
    dpDueDate: string;
    totalDP: number;
    akhirDP: moment.Moment;
    dpAmt: number;
    dpVat: number;
    totalOutDec: number;
    totalOut: string;
    schedNo: number;
    paymentType: string;
    clearDate: string;

    constructor(data?: IListDownPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dpAmount = data["dpAmount"];
            this.dpAmountDec = data["dpAmountDec"];
            this.dpDueDate = data["dpDueDate"];
            this.totalDP = data["totalDP"];
            this.akhirDP = data["akhirDP"] ? moment(data["akhirDP"].toString()) : <any>undefined;
            this.dpAmt = data["dpAmt"];
            this.dpVat = data["dpVat"];
            this.totalOutDec = data["totalOutDec"];
            this.totalOut = data["totalOut"];
            this.schedNo = data["schedNo"];
            this.paymentType = data["paymentType"];
            this.clearDate = data["clearDate"];
        }
    }

    static fromJS(data: any): ListDownPayment {
        let result = new ListDownPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dpAmount"] = this.dpAmount;
        data["dpAmountDec"] = this.dpAmountDec;
        data["dpDueDate"] = this.dpDueDate;
        data["totalDP"] = this.totalDP;
        data["akhirDP"] = this.akhirDP ? this.akhirDP.toISOString() : <any>undefined;
        data["dpAmt"] = this.dpAmt;
        data["dpVat"] = this.dpVat;
        data["totalOutDec"] = this.totalOutDec;
        data["totalOut"] = this.totalOut;
        data["schedNo"] = this.schedNo;
        data["paymentType"] = this.paymentType;
        data["clearDate"] = this.clearDate;
        return data; 
    }
}

export interface IListDownPayment {
    dpAmount: string;
    dpAmountDec: number;
    dpDueDate: string;
    totalDP: number;
    akhirDP: moment.Moment;
    dpAmt: number;
    dpVat: number;
    totalOutDec: number;
    totalOut: string;
    schedNo: number;
    paymentType: string;
    clearDate: string;
}

export class ListCicilanDto implements IListCicilanDto {
    cicilanNo: number;
    cicilanAmt: number;
    cicilanDueDate: string;
    pelunasanAmt: number;
    tglLunas: moment.Moment;
    insAmt: number;
    insVat: number;
    totalOutDec: number;
    totalOut: string;
    schedNo: number;
    paymentType: string;
    clearDate: string;

    constructor(data?: IListCicilanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cicilanNo = data["cicilanNo"];
            this.cicilanAmt = data["cicilanAmt"];
            this.cicilanDueDate = data["cicilanDueDate"];
            this.pelunasanAmt = data["pelunasanAmt"];
            this.tglLunas = data["tglLunas"] ? moment(data["tglLunas"].toString()) : <any>undefined;
            this.insAmt = data["insAmt"];
            this.insVat = data["insVat"];
            this.totalOutDec = data["totalOutDec"];
            this.totalOut = data["totalOut"];
            this.schedNo = data["schedNo"];
            this.paymentType = data["paymentType"];
            this.clearDate = data["clearDate"];
        }
    }

    static fromJS(data: any): ListCicilanDto {
        let result = new ListCicilanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cicilanNo"] = this.cicilanNo;
        data["cicilanAmt"] = this.cicilanAmt;
        data["cicilanDueDate"] = this.cicilanDueDate;
        data["pelunasanAmt"] = this.pelunasanAmt;
        data["tglLunas"] = this.tglLunas ? this.tglLunas.toISOString() : <any>undefined;
        data["insAmt"] = this.insAmt;
        data["insVat"] = this.insVat;
        data["totalOutDec"] = this.totalOutDec;
        data["totalOut"] = this.totalOut;
        data["schedNo"] = this.schedNo;
        data["paymentType"] = this.paymentType;
        data["clearDate"] = this.clearDate;
        return data; 
    }
}

export interface IListCicilanDto {
    cicilanNo: number;
    cicilanAmt: number;
    cicilanDueDate: string;
    pelunasanAmt: number;
    tglLunas: moment.Moment;
    insAmt: number;
    insVat: number;
    totalOutDec: number;
    totalOut: string;
    schedNo: number;
    paymentType: string;
    clearDate: string;
}

export class SendEmailInputDto implements ISendEmailInputDto {
    toAddress: string;
    subject: string;
    ccAddress: string;
    body: string;
    pathKP: string;
    multipleToAddress: string;

    constructor(data?: ISendEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.toAddress = data["toAddress"];
            this.subject = data["subject"];
            this.ccAddress = data["ccAddress"];
            this.body = data["body"];
            this.pathKP = data["pathKP"];
            this.multipleToAddress = data["multipleToAddress"];
        }
    }

    static fromJS(data: any): SendEmailInputDto {
        let result = new SendEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAddress"] = this.toAddress;
        data["subject"] = this.subject;
        data["ccAddress"] = this.ccAddress;
        data["body"] = this.body;
        data["pathKP"] = this.pathKP;
        data["multipleToAddress"] = this.multipleToAddress;
        return data; 
    }
}

export interface ISendEmailInputDto {
    toAddress: string;
    subject: string;
    ccAddress: string;
    body: string;
    pathKP: string;
    multipleToAddress: string;
}

export class BlastEmailAttachmentInputDto implements IBlastEmailAttachmentInputDto {
    counterCode: string;
    listAttachment: EmailListAttachment[];
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    subject: string;
    message: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;

    constructor(data?: IBlastEmailAttachmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.counterCode = data["counterCode"];
            if (data["listAttachment"] && data["listAttachment"].constructor === Array) {
                this.listAttachment = [];
                for (let item of data["listAttachment"])
                    this.listAttachment.push(EmailListAttachment.fromJS(item));
            }
            this.emailTo = data["emailTo"];
            this.emailCC = data["emailCC"];
            this.emailBCC = data["emailBCC"];
            this.subject = data["subject"];
            this.message = data["message"];
            this.nik = data["nik"];
            this.emailFrom = data["emailFrom"];
            this.emailFromDisplayName = data["emailFromDisplayName"];
        }
    }

    static fromJS(data: any): BlastEmailAttachmentInputDto {
        let result = new BlastEmailAttachmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counterCode"] = this.counterCode;
        if (this.listAttachment && this.listAttachment.constructor === Array) {
            data["listAttachment"] = [];
            for (let item of this.listAttachment)
                data["listAttachment"].push(item.toJSON());
        }
        data["emailTo"] = this.emailTo;
        data["emailCC"] = this.emailCC;
        data["emailBCC"] = this.emailBCC;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["nik"] = this.nik;
        data["emailFrom"] = this.emailFrom;
        data["emailFromDisplayName"] = this.emailFromDisplayName;
        return data; 
    }
}

export interface IBlastEmailAttachmentInputDto {
    counterCode: string;
    listAttachment: EmailListAttachment[];
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    subject: string;
    message: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;
}

export class EmailListAttachment implements IEmailListAttachment {
    attachment: string;
    fileName: string;

    constructor(data?: IEmailListAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachment = data["attachment"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): EmailListAttachment {
        let result = new EmailListAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IEmailListAttachment {
    attachment: string;
    fileName: string;
}

export class SendEmailRequestInputDto implements ISendEmailRequestInputDto {
    isBulk: boolean;
    projectID: number;
    counterCode: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;
    listAttachments: ListAttachments[];
    notifTypeCode: string;
    message: string;
    customSubject: boolean;
    subject: string;

    constructor(data?: ISendEmailRequestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isBulk = data["isBulk"];
            this.projectID = data["projectID"];
            this.counterCode = data["counterCode"];
            this.emailTo = data["emailTo"];
            this.emailCC = data["emailCC"];
            this.emailBCC = data["emailBCC"];
            this.nik = data["nik"];
            this.emailFrom = data["emailFrom"];
            this.emailFromDisplayName = data["emailFromDisplayName"];
            if (data["listAttachments"] && data["listAttachments"].constructor === Array) {
                this.listAttachments = [];
                for (let item of data["listAttachments"])
                    this.listAttachments.push(ListAttachments.fromJS(item));
            }
            this.notifTypeCode = data["notifTypeCode"];
            this.message = data["message"];
            this.customSubject = data["customSubject"];
            this.subject = data["subject"];
        }
    }

    static fromJS(data: any): SendEmailRequestInputDto {
        let result = new SendEmailRequestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBulk"] = this.isBulk;
        data["projectID"] = this.projectID;
        data["counterCode"] = this.counterCode;
        data["emailTo"] = this.emailTo;
        data["emailCC"] = this.emailCC;
        data["emailBCC"] = this.emailBCC;
        data["nik"] = this.nik;
        data["emailFrom"] = this.emailFrom;
        data["emailFromDisplayName"] = this.emailFromDisplayName;
        if (this.listAttachments && this.listAttachments.constructor === Array) {
            data["listAttachments"] = [];
            for (let item of this.listAttachments)
                data["listAttachments"].push(item.toJSON());
        }
        data["notifTypeCode"] = this.notifTypeCode;
        data["message"] = this.message;
        data["customSubject"] = this.customSubject;
        data["subject"] = this.subject;
        return data; 
    }
}

export interface ISendEmailRequestInputDto {
    isBulk: boolean;
    projectID: number;
    counterCode: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;
    listAttachments: ListAttachments[];
    notifTypeCode: string;
    message: string;
    customSubject: boolean;
    subject: string;
}

export class ListAttachments implements IListAttachments {
    filePath: string;
    base64File: string;
    fileName: string;

    constructor(data?: IListAttachments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filePath = data["filePath"];
            this.base64File = data["base64File"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): ListAttachments {
        let result = new ListAttachments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["base64File"] = this.base64File;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IListAttachments {
    filePath: string;
    base64File: string;
    fileName: string;
}

export class BlastEmailInputDto implements IBlastEmailInputDto {
    sender: string;
    projectCode: string[];
    notifTypeCode: string;
    templateID: number;
    sendToType: string;
    spesificEmail: string[];
    ccEmail: string[];
    bccEmail: string[];
    attachment: string[];
    keyCodeConfirmation: string;
    isTest: boolean;
    testRecipient: string;

    constructor(data?: IBlastEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sender = data["sender"];
            if (data["projectCode"] && data["projectCode"].constructor === Array) {
                this.projectCode = [];
                for (let item of data["projectCode"])
                    this.projectCode.push(item);
            }
            this.notifTypeCode = data["notifTypeCode"];
            this.templateID = data["templateID"];
            this.sendToType = data["sendToType"];
            if (data["spesificEmail"] && data["spesificEmail"].constructor === Array) {
                this.spesificEmail = [];
                for (let item of data["spesificEmail"])
                    this.spesificEmail.push(item);
            }
            if (data["ccEmail"] && data["ccEmail"].constructor === Array) {
                this.ccEmail = [];
                for (let item of data["ccEmail"])
                    this.ccEmail.push(item);
            }
            if (data["bccEmail"] && data["bccEmail"].constructor === Array) {
                this.bccEmail = [];
                for (let item of data["bccEmail"])
                    this.bccEmail.push(item);
            }
            if (data["attachment"] && data["attachment"].constructor === Array) {
                this.attachment = [];
                for (let item of data["attachment"])
                    this.attachment.push(item);
            }
            this.keyCodeConfirmation = data["keyCodeConfirmation"];
            this.isTest = data["isTest"];
            this.testRecipient = data["testRecipient"];
        }
    }

    static fromJS(data: any): BlastEmailInputDto {
        let result = new BlastEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        if (this.projectCode && this.projectCode.constructor === Array) {
            data["projectCode"] = [];
            for (let item of this.projectCode)
                data["projectCode"].push(item);
        }
        data["notifTypeCode"] = this.notifTypeCode;
        data["templateID"] = this.templateID;
        data["sendToType"] = this.sendToType;
        if (this.spesificEmail && this.spesificEmail.constructor === Array) {
            data["spesificEmail"] = [];
            for (let item of this.spesificEmail)
                data["spesificEmail"].push(item);
        }
        if (this.ccEmail && this.ccEmail.constructor === Array) {
            data["ccEmail"] = [];
            for (let item of this.ccEmail)
                data["ccEmail"].push(item);
        }
        if (this.bccEmail && this.bccEmail.constructor === Array) {
            data["bccEmail"] = [];
            for (let item of this.bccEmail)
                data["bccEmail"].push(item);
        }
        if (this.attachment && this.attachment.constructor === Array) {
            data["attachment"] = [];
            for (let item of this.attachment)
                data["attachment"].push(item);
        }
        data["keyCodeConfirmation"] = this.keyCodeConfirmation;
        data["isTest"] = this.isTest;
        data["testRecipient"] = this.testRecipient;
        return data; 
    }
}

export interface IBlastEmailInputDto {
    sender: string;
    projectCode: string[];
    notifTypeCode: string;
    templateID: number;
    sendToType: string;
    spesificEmail: string[];
    ccEmail: string[];
    bccEmail: string[];
    attachment: string[];
    keyCodeConfirmation: string;
    isTest: boolean;
    testRecipient: string;
}

export class BlastEmailDto implements IBlastEmailDto {
    typeBlastEmailId: number;
    groupId: number;
    blastEmailCompenInputDto: BlastEmailCompenInputDto[];

    constructor(data?: IBlastEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeBlastEmailId = data["typeBlastEmailId"];
            this.groupId = data["groupId"];
            if (data["blastEmailCompenInputDto"] && data["blastEmailCompenInputDto"].constructor === Array) {
                this.blastEmailCompenInputDto = [];
                for (let item of data["blastEmailCompenInputDto"])
                    this.blastEmailCompenInputDto.push(BlastEmailCompenInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlastEmailDto {
        let result = new BlastEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeBlastEmailId"] = this.typeBlastEmailId;
        data["groupId"] = this.groupId;
        if (this.blastEmailCompenInputDto && this.blastEmailCompenInputDto.constructor === Array) {
            data["blastEmailCompenInputDto"] = [];
            for (let item of this.blastEmailCompenInputDto)
                data["blastEmailCompenInputDto"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBlastEmailDto {
    typeBlastEmailId: number;
    groupId: number;
    blastEmailCompenInputDto: BlastEmailCompenInputDto[];
}

export class BlastEmailCompenInputDto implements IBlastEmailCompenInputDto {
    projectID: number;
    emailTo: string;
    bookCode: string;

    constructor(data?: IBlastEmailCompenInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.emailTo = data["emailTo"];
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): BlastEmailCompenInputDto {
        let result = new BlastEmailCompenInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["emailTo"] = this.emailTo;
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IBlastEmailCompenInputDto {
    projectID: number;
    emailTo: string;
    bookCode: string;
}

export class ListResultDtoOfTemplateDropdownDto implements IListResultDtoOfTemplateDropdownDto {
    items: TemplateDropdownDto[];

    constructor(data?: IListResultDtoOfTemplateDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TemplateDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTemplateDropdownDto {
        let result = new ListResultDtoOfTemplateDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTemplateDropdownDto {
    items: TemplateDropdownDto[];
}

export class TemplateDropdownDto implements ITemplateDropdownDto {
    templateName: string;
    mappingTemplateId: number;
    projectID: number;
    docCode: string;

    constructor(data?: ITemplateDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateName = data["templateName"];
            this.mappingTemplateId = data["mappingTemplateId"];
            this.projectID = data["projectID"];
            this.docCode = data["docCode"];
        }
    }

    static fromJS(data: any): TemplateDropdownDto {
        let result = new TemplateDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["mappingTemplateId"] = this.mappingTemplateId;
        data["projectID"] = this.projectID;
        data["docCode"] = this.docCode;
        return data; 
    }
}

export interface ITemplateDropdownDto {
    templateName: string;
    mappingTemplateId: number;
    projectID: number;
    docCode: string;
}

export class InputRewardDto implements IInputRewardDto {
    projectID: number;
    keyword: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IInputRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.keyword = data["keyword"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): InputRewardDto {
        let result = new InputRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["keyword"] = this.keyword;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IInputRewardDto {
    projectID: number;
    keyword: string;
    skipCount: number;
    maxResultCount: number;
}

export class PagedResultDtoOfGetTasklistEmailCompensationDto implements IPagedResultDtoOfGetTasklistEmailCompensationDto {
    totalCount: number;
    items: GetTasklistEmailCompensationDto[];

    constructor(data?: IPagedResultDtoOfGetTasklistEmailCompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTasklistEmailCompensationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTasklistEmailCompensationDto {
        let result = new PagedResultDtoOfGetTasklistEmailCompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTasklistEmailCompensationDto {
    totalCount: number;
    items: GetTasklistEmailCompensationDto[];
}

export class GetTasklistEmailCompensationDto implements IGetTasklistEmailCompensationDto {
    projectId: number;
    projectName: string;
    templateName: string;
    creationDate: string;
    emailSendDate: string;
    groupId: number;
    typeBlastEmailId: number;
    type: string;

    constructor(data?: IGetTasklistEmailCompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.templateName = data["templateName"];
            this.creationDate = data["creationDate"];
            this.emailSendDate = data["emailSendDate"];
            this.groupId = data["groupId"];
            this.typeBlastEmailId = data["typeBlastEmailId"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): GetTasklistEmailCompensationDto {
        let result = new GetTasklistEmailCompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["templateName"] = this.templateName;
        data["creationDate"] = this.creationDate;
        data["emailSendDate"] = this.emailSendDate;
        data["groupId"] = this.groupId;
        data["typeBlastEmailId"] = this.typeBlastEmailId;
        data["type"] = this.type;
        return data; 
    }
}

export interface IGetTasklistEmailCompensationDto {
    projectId: number;
    projectName: string;
    templateName: string;
    creationDate: string;
    emailSendDate: string;
    groupId: number;
    typeBlastEmailId: number;
    type: string;
}

export class GetTasklistEmailCompeDto implements IGetTasklistEmailCompeDto {
    email: string[];
    groupId: number;

    constructor(data?: IGetTasklistEmailCompeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["email"] && data["email"].constructor === Array) {
                this.email = [];
                for (let item of data["email"])
                    this.email.push(item);
            }
            this.groupId = data["groupId"];
        }
    }

    static fromJS(data: any): GetTasklistEmailCompeDto {
        let result = new GetTasklistEmailCompeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.email && this.email.constructor === Array) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item);
        }
        data["groupId"] = this.groupId;
        return data; 
    }
}

export interface IGetTasklistEmailCompeDto {
    email: string[];
    groupId: number;
}

export class PagedResultDtoOfGetDetailEmailCompensationDto implements IPagedResultDtoOfGetDetailEmailCompensationDto {
    totalCount: number;
    items: GetDetailEmailCompensationDto[];

    constructor(data?: IPagedResultDtoOfGetDetailEmailCompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDetailEmailCompensationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDetailEmailCompensationDto {
        let result = new PagedResultDtoOfGetDetailEmailCompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDetailEmailCompensationDto {
    totalCount: number;
    items: GetDetailEmailCompensationDto[];
}

export class GetDetailEmailCompensationDto implements IGetDetailEmailCompensationDto {
    bookCode: string;
    unitCode: string;
    psCode: string;
    customerName: string;
    email: string;
    phone: string;
    periodeKeterlambatan: string;
    totalKeterlamabatan: number;
    totalKompensasi: number;
    periodeKompensasi: string;
    periodeUnit: string;
    groupId: number;
    projectId: number;
    blasCompenHeaderId: number;
    address: string;
    sisaPokok: number;
    hargaUnit: number;
    typeBlastEmailId: number;
    outstanding: number;
    noRekening: string;
    namaBank: string;

    constructor(data?: IGetDetailEmailCompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.periodeKeterlambatan = data["periodeKeterlambatan"];
            this.totalKeterlamabatan = data["totalKeterlamabatan"];
            this.totalKompensasi = data["totalKompensasi"];
            this.periodeKompensasi = data["periodeKompensasi"];
            this.periodeUnit = data["periodeUnit"];
            this.groupId = data["groupId"];
            this.projectId = data["projectId"];
            this.blasCompenHeaderId = data["blasCompenHeaderId"];
            this.address = data["address"];
            this.sisaPokok = data["sisaPokok"];
            this.hargaUnit = data["hargaUnit"];
            this.typeBlastEmailId = data["typeBlastEmailId"];
            this.outstanding = data["outstanding"];
            this.noRekening = data["noRekening"];
            this.namaBank = data["namaBank"];
        }
    }

    static fromJS(data: any): GetDetailEmailCompensationDto {
        let result = new GetDetailEmailCompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["periodeKeterlambatan"] = this.periodeKeterlambatan;
        data["totalKeterlamabatan"] = this.totalKeterlamabatan;
        data["totalKompensasi"] = this.totalKompensasi;
        data["periodeKompensasi"] = this.periodeKompensasi;
        data["periodeUnit"] = this.periodeUnit;
        data["groupId"] = this.groupId;
        data["projectId"] = this.projectId;
        data["blasCompenHeaderId"] = this.blasCompenHeaderId;
        data["address"] = this.address;
        data["sisaPokok"] = this.sisaPokok;
        data["hargaUnit"] = this.hargaUnit;
        data["typeBlastEmailId"] = this.typeBlastEmailId;
        data["outstanding"] = this.outstanding;
        data["noRekening"] = this.noRekening;
        data["namaBank"] = this.namaBank;
        return data; 
    }
}

export interface IGetDetailEmailCompensationDto {
    bookCode: string;
    unitCode: string;
    psCode: string;
    customerName: string;
    email: string;
    phone: string;
    periodeKeterlambatan: string;
    totalKeterlamabatan: number;
    totalKompensasi: number;
    periodeKompensasi: string;
    periodeUnit: string;
    groupId: number;
    projectId: number;
    blasCompenHeaderId: number;
    address: string;
    sisaPokok: number;
    hargaUnit: number;
    typeBlastEmailId: number;
    outstanding: number;
    noRekening: string;
    namaBank: string;
}

export class ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto implements IListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto {
    items: GetPeriodeCompensationByblasCompenHeaderIdDto[];

    constructor(data?: IListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPeriodeCompensationByblasCompenHeaderIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto {
        let result = new ListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetPeriodeCompensationByblasCompenHeaderIdDto {
    items: GetPeriodeCompensationByblasCompenHeaderIdDto[];
}

export class GetPeriodeCompensationByblasCompenHeaderIdDto implements IGetPeriodeCompensationByblasCompenHeaderIdDto {
    periode: string;
    persenSisaPekerjaan: string;
    nilaiSisaPekerjaan: number;
    nilaiKompensasi: number;
    blasCompenHeaderId: number;

    constructor(data?: IGetPeriodeCompensationByblasCompenHeaderIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periode = data["periode"];
            this.persenSisaPekerjaan = data["persenSisaPekerjaan"];
            this.nilaiSisaPekerjaan = data["nilaiSisaPekerjaan"];
            this.nilaiKompensasi = data["nilaiKompensasi"];
            this.blasCompenHeaderId = data["blasCompenHeaderId"];
        }
    }

    static fromJS(data: any): GetPeriodeCompensationByblasCompenHeaderIdDto {
        let result = new GetPeriodeCompensationByblasCompenHeaderIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periode"] = this.periode;
        data["persenSisaPekerjaan"] = this.persenSisaPekerjaan;
        data["nilaiSisaPekerjaan"] = this.nilaiSisaPekerjaan;
        data["nilaiKompensasi"] = this.nilaiKompensasi;
        data["blasCompenHeaderId"] = this.blasCompenHeaderId;
        return data; 
    }
}

export interface IGetPeriodeCompensationByblasCompenHeaderIdDto {
    periode: string;
    persenSisaPekerjaan: string;
    nilaiSisaPekerjaan: number;
    nilaiKompensasi: number;
    blasCompenHeaderId: number;
}

export class SaveEmailCompensationDto implements ISaveEmailCompensationDto {
    projectName: string;
    typeBlastEmailId: number;
    projectId: number;
    templateId: number;
    emailCC: string;
    emailBcc: string;
    headerListCompen: HeaderListCompen[];

    constructor(data?: ISaveEmailCompensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.typeBlastEmailId = data["typeBlastEmailId"];
            this.projectId = data["projectId"];
            this.templateId = data["templateId"];
            this.emailCC = data["emailCC"];
            this.emailBcc = data["emailBcc"];
            if (data["headerListCompen"] && data["headerListCompen"].constructor === Array) {
                this.headerListCompen = [];
                for (let item of data["headerListCompen"])
                    this.headerListCompen.push(HeaderListCompen.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveEmailCompensationDto {
        let result = new SaveEmailCompensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["typeBlastEmailId"] = this.typeBlastEmailId;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["emailCC"] = this.emailCC;
        data["emailBcc"] = this.emailBcc;
        if (this.headerListCompen && this.headerListCompen.constructor === Array) {
            data["headerListCompen"] = [];
            for (let item of this.headerListCompen)
                data["headerListCompen"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveEmailCompensationDto {
    projectName: string;
    typeBlastEmailId: number;
    projectId: number;
    templateId: number;
    emailCC: string;
    emailBcc: string;
    headerListCompen: HeaderListCompen[];
}

export class HeaderListCompen implements IHeaderListCompen {
    bookcode: string;
    unit: string;
    pscode: string;
    customerName: string;
    email: string;
    phone: string;
    periodeKeterlambatan: string;
    totalKeterlambatan: number;
    periodeKompensasi: string;
    totalKompensasi: number;
    periodeUnit: string;
    address: string;
    sisaPokok: number;
    docNo: string;
    tower: string;
    hargaUnit: number;
    outstanding: number;
    noRekening: string;
    namaBank: string;
    spNo: number;
    detailCompenListDto: DetailCompenListDto[];

    constructor(data?: IHeaderListCompen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookcode = data["bookcode"];
            this.unit = data["unit"];
            this.pscode = data["pscode"];
            this.customerName = data["customerName"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.periodeKeterlambatan = data["periodeKeterlambatan"];
            this.totalKeterlambatan = data["totalKeterlambatan"];
            this.periodeKompensasi = data["periodeKompensasi"];
            this.totalKompensasi = data["totalKompensasi"];
            this.periodeUnit = data["periodeUnit"];
            this.address = data["address"];
            this.sisaPokok = data["sisaPokok"];
            this.docNo = data["docNo"];
            this.tower = data["tower"];
            this.hargaUnit = data["hargaUnit"];
            this.outstanding = data["outstanding"];
            this.noRekening = data["noRekening"];
            this.namaBank = data["namaBank"];
            this.spNo = data["spNo"];
            if (data["detailCompenListDto"] && data["detailCompenListDto"].constructor === Array) {
                this.detailCompenListDto = [];
                for (let item of data["detailCompenListDto"])
                    this.detailCompenListDto.push(DetailCompenListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HeaderListCompen {
        let result = new HeaderListCompen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookcode"] = this.bookcode;
        data["unit"] = this.unit;
        data["pscode"] = this.pscode;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["periodeKeterlambatan"] = this.periodeKeterlambatan;
        data["totalKeterlambatan"] = this.totalKeterlambatan;
        data["periodeKompensasi"] = this.periodeKompensasi;
        data["totalKompensasi"] = this.totalKompensasi;
        data["periodeUnit"] = this.periodeUnit;
        data["address"] = this.address;
        data["sisaPokok"] = this.sisaPokok;
        data["docNo"] = this.docNo;
        data["tower"] = this.tower;
        data["hargaUnit"] = this.hargaUnit;
        data["outstanding"] = this.outstanding;
        data["noRekening"] = this.noRekening;
        data["namaBank"] = this.namaBank;
        data["spNo"] = this.spNo;
        if (this.detailCompenListDto && this.detailCompenListDto.constructor === Array) {
            data["detailCompenListDto"] = [];
            for (let item of this.detailCompenListDto)
                data["detailCompenListDto"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IHeaderListCompen {
    bookcode: string;
    unit: string;
    pscode: string;
    customerName: string;
    email: string;
    phone: string;
    periodeKeterlambatan: string;
    totalKeterlambatan: number;
    periodeKompensasi: string;
    totalKompensasi: number;
    periodeUnit: string;
    address: string;
    sisaPokok: number;
    docNo: string;
    tower: string;
    hargaUnit: number;
    outstanding: number;
    noRekening: string;
    namaBank: string;
    spNo: number;
    detailCompenListDto: DetailCompenListDto[];
}

export class DetailCompenListDto implements IDetailCompenListDto {
    periodeBulan: string;
    sisaPekerjaan: string;
    nilaiSisaPekerjaan: number;
    nilaiKompensasi: number;

    constructor(data?: IDetailCompenListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periodeBulan = data["periodeBulan"];
            this.sisaPekerjaan = data["sisaPekerjaan"];
            this.nilaiSisaPekerjaan = data["nilaiSisaPekerjaan"];
            this.nilaiKompensasi = data["nilaiKompensasi"];
        }
    }

    static fromJS(data: any): DetailCompenListDto {
        let result = new DetailCompenListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodeBulan"] = this.periodeBulan;
        data["sisaPekerjaan"] = this.sisaPekerjaan;
        data["nilaiSisaPekerjaan"] = this.nilaiSisaPekerjaan;
        data["nilaiKompensasi"] = this.nilaiKompensasi;
        return data; 
    }
}

export interface IDetailCompenListDto {
    periodeBulan: string;
    sisaPekerjaan: string;
    nilaiSisaPekerjaan: number;
    nilaiKompensasi: number;
}

export class ListResultDtoOfTypeBlastEmailDropdownDto implements IListResultDtoOfTypeBlastEmailDropdownDto {
    items: TypeBlastEmailDropdownDto[];

    constructor(data?: IListResultDtoOfTypeBlastEmailDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TypeBlastEmailDropdownDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTypeBlastEmailDropdownDto {
        let result = new ListResultDtoOfTypeBlastEmailDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTypeBlastEmailDropdownDto {
    items: TypeBlastEmailDropdownDto[];
}

export class TypeBlastEmailDropdownDto implements ITypeBlastEmailDropdownDto {
    typeBlastEmailId: number;
    typeName: string;

    constructor(data?: ITypeBlastEmailDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeBlastEmailId = data["typeBlastEmailId"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): TypeBlastEmailDropdownDto {
        let result = new TypeBlastEmailDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeBlastEmailId"] = this.typeBlastEmailId;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface ITypeBlastEmailDropdownDto {
    typeBlastEmailId: number;
    typeName: string;
}

export class GetProjectByAccountListDto implements IGetProjectByAccountListDto {
    id: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IGetProjectByAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectByAccountListDto {
        let result = new GetProjectByAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetProjectByAccountListDto {
    id: number;
    projectCode: string;
    projectName: string;
}

export class BlastEmailReminderPPInputDto implements IBlastEmailReminderPPInputDto {
    projectID: number;
    clusterID: number;
    hariTanggal: string;
    ppno: string[];

    constructor(data?: IBlastEmailReminderPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.hariTanggal = data["hariTanggal"];
            if (data["ppno"] && data["ppno"].constructor === Array) {
                this.ppno = [];
                for (let item of data["ppno"])
                    this.ppno.push(item);
            }
        }
    }

    static fromJS(data: any): BlastEmailReminderPPInputDto {
        let result = new BlastEmailReminderPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["hariTanggal"] = this.hariTanggal;
        if (this.ppno && this.ppno.constructor === Array) {
            data["ppno"] = [];
            for (let item of this.ppno)
                data["ppno"].push(item);
        }
        return data; 
    }
}

export interface IBlastEmailReminderPPInputDto {
    projectID: number;
    clusterID: number;
    hariTanggal: string;
    ppno: string[];
}

export class GetEmailIDResultDto implements IGetEmailIDResultDto {
    emailID: string;
    counterCode: string;

    constructor(data?: IGetEmailIDResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailID = data["emailID"];
            this.counterCode = data["counterCode"];
        }
    }

    static fromJS(data: any): GetEmailIDResultDto {
        let result = new GetEmailIDResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailID"] = this.emailID;
        data["counterCode"] = this.counterCode;
        return data; 
    }
}

export interface IGetEmailIDResultDto {
    emailID: string;
    counterCode: string;
}

export class SendEmailAttachmentInputDto implements ISendEmailAttachmentInputDto {
    counterCode: string;
    attachment: string;
    fileName: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    subject: string;
    message: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;
    attachmentAJB: AttachmentDto[];

    constructor(data?: ISendEmailAttachmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.counterCode = data["counterCode"];
            this.attachment = data["attachment"];
            this.fileName = data["fileName"];
            this.emailTo = data["emailTo"];
            this.emailCC = data["emailCC"];
            this.emailBCC = data["emailBCC"];
            this.subject = data["subject"];
            this.message = data["message"];
            this.nik = data["nik"];
            this.emailFrom = data["emailFrom"];
            this.emailFromDisplayName = data["emailFromDisplayName"];
            if (data["attachmentAJB"] && data["attachmentAJB"].constructor === Array) {
                this.attachmentAJB = [];
                for (let item of data["attachmentAJB"])
                    this.attachmentAJB.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendEmailAttachmentInputDto {
        let result = new SendEmailAttachmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["counterCode"] = this.counterCode;
        data["attachment"] = this.attachment;
        data["fileName"] = this.fileName;
        data["emailTo"] = this.emailTo;
        data["emailCC"] = this.emailCC;
        data["emailBCC"] = this.emailBCC;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["nik"] = this.nik;
        data["emailFrom"] = this.emailFrom;
        data["emailFromDisplayName"] = this.emailFromDisplayName;
        if (this.attachmentAJB && this.attachmentAJB.constructor === Array) {
            data["attachmentAJB"] = [];
            for (let item of this.attachmentAJB)
                data["attachmentAJB"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISendEmailAttachmentInputDto {
    counterCode: string;
    attachment: string;
    fileName: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    subject: string;
    message: string;
    nik: string;
    emailFrom: string;
    emailFromDisplayName: string;
    attachmentAJB: AttachmentDto[];
}

export class AttachmentDto implements IAttachmentDto {
    fileName: string;
    base64File: string;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.base64File = data["base64File"];
        }
    }

    static fromJS(data: any): AttachmentDto {
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["base64File"] = this.base64File;
        return data; 
    }
}

export interface IAttachmentDto {
    fileName: string;
    base64File: string;
}

export class OutboxInputDto implements IOutboxInputDto {
    projectID: number;
    counterCode: string;
    emailCategory: string;
    emailID: string;
    emailFrom: string;
    emailFromDisplayName: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    emailSubject: string;
    emailMessage: string;
    isSent: boolean;
    sentDate: moment.Moment;
    retrySend: number;
    errMessage: string;
    isAttachment: boolean;
    inputTime: moment.Moment;
    inputUN: string;
    modifTime: moment.Moment;
    modifUN: string;
    readDate: moment.Moment;
    schedDate: moment.Moment;
    functionName: string;
    isInvitation: number;
    attachments: AttachmentDto[];

    constructor(data?: IOutboxInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.counterCode = data["counterCode"];
            this.emailCategory = data["emailCategory"];
            this.emailID = data["emailID"];
            this.emailFrom = data["emailFrom"];
            this.emailFromDisplayName = data["emailFromDisplayName"];
            this.emailTo = data["emailTo"];
            this.emailCC = data["emailCC"];
            this.emailBCC = data["emailBCC"];
            this.emailSubject = data["emailSubject"];
            this.emailMessage = data["emailMessage"];
            this.isSent = data["isSent"];
            this.sentDate = data["sentDate"] ? moment(data["sentDate"].toString()) : <any>undefined;
            this.retrySend = data["retrySend"];
            this.errMessage = data["errMessage"];
            this.isAttachment = data["isAttachment"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.readDate = data["readDate"] ? moment(data["readDate"].toString()) : <any>undefined;
            this.schedDate = data["schedDate"] ? moment(data["schedDate"].toString()) : <any>undefined;
            this.functionName = data["functionName"];
            this.isInvitation = data["isInvitation"];
            if (data["attachments"] && data["attachments"].constructor === Array) {
                this.attachments = [];
                for (let item of data["attachments"])
                    this.attachments.push(AttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutboxInputDto {
        let result = new OutboxInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["counterCode"] = this.counterCode;
        data["emailCategory"] = this.emailCategory;
        data["emailID"] = this.emailID;
        data["emailFrom"] = this.emailFrom;
        data["emailFromDisplayName"] = this.emailFromDisplayName;
        data["emailTo"] = this.emailTo;
        data["emailCC"] = this.emailCC;
        data["emailBCC"] = this.emailBCC;
        data["emailSubject"] = this.emailSubject;
        data["emailMessage"] = this.emailMessage;
        data["isSent"] = this.isSent;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["retrySend"] = this.retrySend;
        data["errMessage"] = this.errMessage;
        data["isAttachment"] = this.isAttachment;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["readDate"] = this.readDate ? this.readDate.toISOString() : <any>undefined;
        data["schedDate"] = this.schedDate ? this.schedDate.toISOString() : <any>undefined;
        data["functionName"] = this.functionName;
        data["isInvitation"] = this.isInvitation;
        if (this.attachments && this.attachments.constructor === Array) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOutboxInputDto {
    projectID: number;
    counterCode: string;
    emailCategory: string;
    emailID: string;
    emailFrom: string;
    emailFromDisplayName: string;
    emailTo: string;
    emailCC: string;
    emailBCC: string;
    emailSubject: string;
    emailMessage: string;
    isSent: boolean;
    sentDate: moment.Moment;
    retrySend: number;
    errMessage: string;
    isAttachment: boolean;
    inputTime: moment.Moment;
    inputUN: string;
    modifTime: moment.Moment;
    modifUN: string;
    readDate: moment.Moment;
    schedDate: moment.Moment;
    functionName: string;
    isInvitation: number;
    attachments: AttachmentDto[];
}

export class ResendEmailDto implements IResendEmailDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    emailSubject: string;

    constructor(data?: IResendEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.emailSubject = data["emailSubject"];
        }
    }

    static fromJS(data: any): ResendEmailDto {
        let result = new ResendEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["emailSubject"] = this.emailSubject;
        return data; 
    }
}

export interface IResendEmailDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    emailSubject: string;
}

export class SendEmailListResultDto implements ISendEmailListResultDto {
    messageSent: string;
    messageSentFailed: string;

    constructor(data?: ISendEmailListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.messageSent = data["messageSent"];
            this.messageSentFailed = data["messageSentFailed"];
        }
    }

    static fromJS(data: any): SendEmailListResultDto {
        let result = new SendEmailListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSent"] = this.messageSent;
        data["messageSentFailed"] = this.messageSentFailed;
        return data; 
    }
}

export interface ISendEmailListResultDto {
    messageSent: string;
    messageSentFailed: string;
}

export class Root implements IRoot {
    message: string;
    result: boolean;

    constructor(data?: IRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): Root {
        let result = new Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IRoot {
    message: string;
    result: boolean;
}

export class BookingSuccessPPInputDto implements IBookingSuccessPPInputDto {
    projectName: string;
    projectImage: string;
    customerName: string;
    bfPaymentDate: string;
    ppNo: string;
    qty: string;
    totalPaymentAmount: string;
    emailDealCloser: string;
    emailCustomer: string;
    developerName: string;
    productName: string;
    terbilang: string;
    flagPP: string;

    constructor(data?: IBookingSuccessPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.projectImage = data["projectImage"];
            this.customerName = data["customerName"];
            this.bfPaymentDate = data["bfPaymentDate"];
            this.ppNo = data["ppNo"];
            this.qty = data["qty"];
            this.totalPaymentAmount = data["totalPaymentAmount"];
            this.emailDealCloser = data["emailDealCloser"];
            this.emailCustomer = data["emailCustomer"];
            this.developerName = data["developerName"];
            this.productName = data["productName"];
            this.terbilang = data["terbilang"];
            this.flagPP = data["flagPP"];
        }
    }

    static fromJS(data: any): BookingSuccessPPInputDto {
        let result = new BookingSuccessPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["customerName"] = this.customerName;
        data["bfPaymentDate"] = this.bfPaymentDate;
        data["ppNo"] = this.ppNo;
        data["qty"] = this.qty;
        data["totalPaymentAmount"] = this.totalPaymentAmount;
        data["emailDealCloser"] = this.emailDealCloser;
        data["emailCustomer"] = this.emailCustomer;
        data["developerName"] = this.developerName;
        data["productName"] = this.productName;
        data["terbilang"] = this.terbilang;
        data["flagPP"] = this.flagPP;
        return data; 
    }
}

export interface IBookingSuccessPPInputDto {
    projectName: string;
    projectImage: string;
    customerName: string;
    bfPaymentDate: string;
    ppNo: string;
    qty: string;
    totalPaymentAmount: string;
    emailDealCloser: string;
    emailCustomer: string;
    developerName: string;
    productName: string;
    terbilang: string;
    flagPP: string;
}

export class SendEmailPPInputDto implements ISendEmailPPInputDto {
    toAddress: string;
    ccAddress: string;
    bccAddress: string;
    subject: string;
    body: string;
    pathTTBF: string;

    constructor(data?: ISendEmailPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.toAddress = data["toAddress"];
            this.ccAddress = data["ccAddress"];
            this.bccAddress = data["bccAddress"];
            this.subject = data["subject"];
            this.body = data["body"];
            this.pathTTBF = data["pathTTBF"];
        }
    }

    static fromJS(data: any): SendEmailPPInputDto {
        let result = new SendEmailPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAddress"] = this.toAddress;
        data["ccAddress"] = this.ccAddress;
        data["bccAddress"] = this.bccAddress;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["pathTTBF"] = this.pathTTBF;
        return data; 
    }
}

export interface ISendEmailPPInputDto {
    toAddress: string;
    ccAddress: string;
    bccAddress: string;
    subject: string;
    body: string;
    pathTTBF: string;
}

export class SendEmailRefundPPInputDto implements ISendEmailRefundPPInputDto {
    customerName: string;
    projectName: string;
    tanggal: string;
    productName: string;
    ttbfNo: string;
    alasan: string;
    norek: string;
    atasNama: string;
    bank: string;
    emailCust: string;
    emailDealCloser: string;
    pathPdfRefund: string;
    emailSender: string;

    constructor(data?: ISendEmailRefundPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.projectName = data["projectName"];
            this.tanggal = data["tanggal"];
            this.productName = data["productName"];
            this.ttbfNo = data["ttbfNo"];
            this.alasan = data["alasan"];
            this.norek = data["norek"];
            this.atasNama = data["atasNama"];
            this.bank = data["bank"];
            this.emailCust = data["emailCust"];
            this.emailDealCloser = data["emailDealCloser"];
            this.pathPdfRefund = data["pathPdfRefund"];
            this.emailSender = data["emailSender"];
        }
    }

    static fromJS(data: any): SendEmailRefundPPInputDto {
        let result = new SendEmailRefundPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["projectName"] = this.projectName;
        data["tanggal"] = this.tanggal;
        data["productName"] = this.productName;
        data["ttbfNo"] = this.ttbfNo;
        data["alasan"] = this.alasan;
        data["norek"] = this.norek;
        data["atasNama"] = this.atasNama;
        data["bank"] = this.bank;
        data["emailCust"] = this.emailCust;
        data["emailDealCloser"] = this.emailDealCloser;
        data["pathPdfRefund"] = this.pathPdfRefund;
        data["emailSender"] = this.emailSender;
        return data; 
    }
}

export interface ISendEmailRefundPPInputDto {
    customerName: string;
    projectName: string;
    tanggal: string;
    productName: string;
    ttbfNo: string;
    alasan: string;
    norek: string;
    atasNama: string;
    bank: string;
    emailCust: string;
    emailDealCloser: string;
    pathPdfRefund: string;
    emailSender: string;
}

export class EmailRefundPPInputDto implements IEmailRefundPPInputDto {
    toAddress: string;
    ccAddress: string;
    subject: string;
    body: string;
    pathTTBF: string;

    constructor(data?: IEmailRefundPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.toAddress = data["toAddress"];
            this.ccAddress = data["ccAddress"];
            this.subject = data["subject"];
            this.body = data["body"];
            this.pathTTBF = data["pathTTBF"];
        }
    }

    static fromJS(data: any): EmailRefundPPInputDto {
        let result = new EmailRefundPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAddress"] = this.toAddress;
        data["ccAddress"] = this.ccAddress;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["pathTTBF"] = this.pathTTBF;
        return data; 
    }
}

export interface IEmailRefundPPInputDto {
    toAddress: string;
    ccAddress: string;
    subject: string;
    body: string;
    pathTTBF: string;
}

export class GetDropDownUnitType implements IGetDropDownUnitType {
    unitType: string;

    constructor(data?: IGetDropDownUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitType = data["unitType"];
        }
    }

    static fromJS(data: any): GetDropDownUnitType {
        let result = new GetDropDownUnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        return data; 
    }
}

export interface IGetDropDownUnitType {
    unitType: string;
}

export class GetDropDownDistrictDto implements IGetDropDownDistrictDto {
    districtID: number;
    districtCode: string;
    districtName: string;

    constructor(data?: IGetDropDownDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.districtID = data["districtID"];
            this.districtCode = data["districtCode"];
            this.districtName = data["districtName"];
        }
    }

    static fromJS(data: any): GetDropDownDistrictDto {
        let result = new GetDropDownDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtID"] = this.districtID;
        data["districtCode"] = this.districtCode;
        data["districtName"] = this.districtName;
        return data; 
    }
}

export interface IGetDropDownDistrictDto {
    districtID: number;
    districtCode: string;
    districtName: string;
}

export class GetDropDownBlokDto implements IGetDropDownBlokDto {
    blok: string;

    constructor(data?: IGetDropDownBlokDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.blok = data["blok"];
        }
    }

    static fromJS(data: any): GetDropDownBlokDto {
        let result = new GetDropDownBlokDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blok"] = this.blok;
        return data; 
    }
}

export interface IGetDropDownBlokDto {
    blok: string;
}

export class GetDropDownTypeTowerDto implements IGetDropDownTypeTowerDto {
    typeTower: string;

    constructor(data?: IGetDropDownTypeTowerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeTower = data["typeTower"];
        }
    }

    static fromJS(data: any): GetDropDownTypeTowerDto {
        let result = new GetDropDownTypeTowerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeTower"] = this.typeTower;
        return data; 
    }
}

export interface IGetDropDownTypeTowerDto {
    typeTower: string;
}

export class GetDropDownTowerDto implements IGetDropDownTowerDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetDropDownTowerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetDropDownTowerDto {
        let result = new GetDropDownTowerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetDropDownTowerDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class GetDropDownUnitDto implements IGetDropDownUnitDto {
    unitID: number;
    unitcode: string;
    unitno: string;

    constructor(data?: IGetDropDownUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitcode = data["unitcode"];
            this.unitno = data["unitno"];
        }
    }

    static fromJS(data: any): GetDropDownUnitDto {
        let result = new GetDropDownUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitcode"] = this.unitcode;
        data["unitno"] = this.unitno;
        return data; 
    }
}

export interface IGetDropDownUnitDto {
    unitID: number;
    unitcode: string;
    unitno: string;
}

export class GetTaskListSettingFactoring implements IGetTaskListSettingFactoring {
    settingFactoringID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    factoringCode: string;
    factoringName: string;
    remarks: string;

    constructor(data?: IGetTaskListSettingFactoring) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingFactoringID = data["settingFactoringID"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.factoringCode = data["factoringCode"];
            this.factoringName = data["factoringName"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetTaskListSettingFactoring {
        let result = new GetTaskListSettingFactoring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingFactoringID"] = this.settingFactoringID;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["factoringCode"] = this.factoringCode;
        data["factoringName"] = this.factoringName;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetTaskListSettingFactoring {
    settingFactoringID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    factoringCode: string;
    factoringName: string;
    remarks: string;
}

export class CreateOrUpdateSettingFactoringDto implements ICreateOrUpdateSettingFactoringDto {
    settingFactoringID: number;
    factoringCode: string;
    factoringName: string;
    remarks: string;
    projectID: number;
    projectCode: string;
    projectName: string;
    settingFactoringDetail: CreateOrUpdateSettingFactoringDetailDto[];

    constructor(data?: ICreateOrUpdateSettingFactoringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingFactoringID = data["settingFactoringID"];
            this.factoringCode = data["factoringCode"];
            this.factoringName = data["factoringName"];
            this.remarks = data["remarks"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            if (data["settingFactoringDetail"] && data["settingFactoringDetail"].constructor === Array) {
                this.settingFactoringDetail = [];
                for (let item of data["settingFactoringDetail"])
                    this.settingFactoringDetail.push(CreateOrUpdateSettingFactoringDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSettingFactoringDto {
        let result = new CreateOrUpdateSettingFactoringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingFactoringID"] = this.settingFactoringID;
        data["factoringCode"] = this.factoringCode;
        data["factoringName"] = this.factoringName;
        data["remarks"] = this.remarks;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        if (this.settingFactoringDetail && this.settingFactoringDetail.constructor === Array) {
            data["settingFactoringDetail"] = [];
            for (let item of this.settingFactoringDetail)
                data["settingFactoringDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateSettingFactoringDto {
    settingFactoringID: number;
    factoringCode: string;
    factoringName: string;
    remarks: string;
    projectID: number;
    projectCode: string;
    projectName: string;
    settingFactoringDetail: CreateOrUpdateSettingFactoringDetailDto[];
}

export class CreateOrUpdateSettingFactoringDetailDto implements ICreateOrUpdateSettingFactoringDetailDto {
    settingFactoringDetailID: number;
    district: string;
    blok: string;
    clusterType: string;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitType: string;
    unitID: number[];
    percentage: number;
    isDeleted: boolean;

    constructor(data?: ICreateOrUpdateSettingFactoringDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingFactoringDetailID = data["settingFactoringDetailID"];
            this.district = data["district"];
            this.blok = data["blok"];
            this.clusterType = data["clusterType"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.unitType = data["unitType"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
            this.percentage = data["percentage"];
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSettingFactoringDetailDto {
        let result = new CreateOrUpdateSettingFactoringDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingFactoringDetailID"] = this.settingFactoringDetailID;
        data["district"] = this.district;
        data["blok"] = this.blok;
        data["clusterType"] = this.clusterType;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["unitType"] = this.unitType;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        data["percentage"] = this.percentage;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }
}

export interface ICreateOrUpdateSettingFactoringDetailDto {
    settingFactoringDetailID: number;
    district: string;
    blok: string;
    clusterType: string;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitType: string;
    unitID: number[];
    percentage: number;
    isDeleted: boolean;
}

export class DropdownSettingFactoringDto implements IDropdownSettingFactoringDto {
    factoringID: number;
    factoringCode: string;
    factoringName: string;

    constructor(data?: IDropdownSettingFactoringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.factoringID = data["factoringID"];
            this.factoringCode = data["factoringCode"];
            this.factoringName = data["factoringName"];
        }
    }

    static fromJS(data: any): DropdownSettingFactoringDto {
        let result = new DropdownSettingFactoringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factoringID"] = this.factoringID;
        data["factoringCode"] = this.factoringCode;
        data["factoringName"] = this.factoringName;
        return data; 
    }
}

export interface IDropdownSettingFactoringDto {
    factoringID: number;
    factoringCode: string;
    factoringName: string;
}

export class LinkPathListDto implements ILinkPathListDto {
    filename: string;
    linkFile: string;
    linkServerFile: string;
    filePhysicalPath: string;

    constructor(data?: ILinkPathListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filename = data["filename"];
            this.linkFile = data["linkFile"];
            this.linkServerFile = data["linkServerFile"];
            this.filePhysicalPath = data["filePhysicalPath"];
        }
    }

    static fromJS(data: any): LinkPathListDto {
        let result = new LinkPathListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["linkFile"] = this.linkFile;
        data["linkServerFile"] = this.linkServerFile;
        data["filePhysicalPath"] = this.filePhysicalPath;
        return data; 
    }
}

export interface ILinkPathListDto {
    filename: string;
    linkFile: string;
    linkServerFile: string;
    filePhysicalPath: string;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class GetMsUnitByProjectClusterDto implements IGetMsUnitByProjectClusterDto {
    unitNo: string;
    combinedUnitNo: string;
    unitCertCode: string;
    remarks: string;
    prevUnitNo: string;
    entityID: number;
    unitCodeID: number;
    unitCode: string;
    areaID: number;
    projectID: number;
    categoryID: number;
    clusterID: number;
    productID: number;
    detailID: number;
    zoningID: number;
    facingID: number;
    unitStatusID: number;
    rentalStatusID: number;
    termMainID: number;
    tokenNo: number;

    constructor(data?: IGetMsUnitByProjectClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.combinedUnitNo = data["combinedUnitNo"];
            this.unitCertCode = data["unitCertCode"];
            this.remarks = data["remarks"];
            this.prevUnitNo = data["prevUnitNo"];
            this.entityID = data["entityID"];
            this.unitCodeID = data["unitCodeID"];
            this.unitCode = data["unitCode"];
            this.areaID = data["areaID"];
            this.projectID = data["projectID"];
            this.categoryID = data["categoryID"];
            this.clusterID = data["clusterID"];
            this.productID = data["productID"];
            this.detailID = data["detailID"];
            this.zoningID = data["zoningID"];
            this.facingID = data["facingID"];
            this.unitStatusID = data["unitStatusID"];
            this.rentalStatusID = data["rentalStatusID"];
            this.termMainID = data["termMainID"];
            this.tokenNo = data["tokenNo"];
        }
    }

    static fromJS(data: any): GetMsUnitByProjectClusterDto {
        let result = new GetMsUnitByProjectClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["combinedUnitNo"] = this.combinedUnitNo;
        data["unitCertCode"] = this.unitCertCode;
        data["remarks"] = this.remarks;
        data["prevUnitNo"] = this.prevUnitNo;
        data["entityID"] = this.entityID;
        data["unitCodeID"] = this.unitCodeID;
        data["unitCode"] = this.unitCode;
        data["areaID"] = this.areaID;
        data["projectID"] = this.projectID;
        data["categoryID"] = this.categoryID;
        data["clusterID"] = this.clusterID;
        data["productID"] = this.productID;
        data["detailID"] = this.detailID;
        data["zoningID"] = this.zoningID;
        data["facingID"] = this.facingID;
        data["unitStatusID"] = this.unitStatusID;
        data["rentalStatusID"] = this.rentalStatusID;
        data["termMainID"] = this.termMainID;
        data["tokenNo"] = this.tokenNo;
        return data; 
    }
}

export interface IGetMsUnitByProjectClusterDto {
    unitNo: string;
    combinedUnitNo: string;
    unitCertCode: string;
    remarks: string;
    prevUnitNo: string;
    entityID: number;
    unitCodeID: number;
    unitCode: string;
    areaID: number;
    projectID: number;
    categoryID: number;
    clusterID: number;
    productID: number;
    detailID: number;
    zoningID: number;
    facingID: number;
    unitStatusID: number;
    rentalStatusID: number;
    termMainID: number;
    tokenNo: number;
}

export class GetMsUnitByProjectIdClusterIdDto implements IGetMsUnitByProjectIdClusterIdDto {
    projectID: number;
    clusterID: number;

    constructor(data?: IGetMsUnitByProjectIdClusterIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
        }
    }

    static fromJS(data: any): GetMsUnitByProjectIdClusterIdDto {
        let result = new GetMsUnitByProjectIdClusterIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        return data; 
    }
}

export interface IGetMsUnitByProjectIdClusterIdDto {
    projectID: number;
    clusterID: number;
}

export class GenerateExcelUploadGrossPriceInputDto implements IGenerateExcelUploadGrossPriceInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    termMainID: number;

    constructor(data?: IGenerateExcelUploadGrossPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            if (data["categoryID"] && data["categoryID"].constructor === Array) {
                this.categoryID = [];
                for (let item of data["categoryID"])
                    this.categoryID.push(item);
            }
            if (data["productID"] && data["productID"].constructor === Array) {
                this.productID = [];
                for (let item of data["productID"])
                    this.productID.push(item);
            }
            this.termMainID = data["termMainID"];
        }
    }

    static fromJS(data: any): GenerateExcelUploadGrossPriceInputDto {
        let result = new GenerateExcelUploadGrossPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        if (this.categoryID && this.categoryID.constructor === Array) {
            data["categoryID"] = [];
            for (let item of this.categoryID)
                data["categoryID"].push(item);
        }
        if (this.productID && this.productID.constructor === Array) {
            data["productID"] = [];
            for (let item of this.productID)
                data["productID"].push(item);
        }
        data["termMainID"] = this.termMainID;
        return data; 
    }
}

export interface IGenerateExcelUploadGrossPriceInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    termMainID: number;
}

export class ExportToExcelUploadGrossPriceListDto implements IExportToExcelUploadGrossPriceListDto {
    priceList: ExportToExcelUploadPriceListDto[];
    unitItemPrice: CreateUnitItemPriceInputDto;
    updateUnit: GetMsUnitByProjectClusterCategoryProduct;

    constructor(data?: IExportToExcelUploadGrossPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["priceList"] && data["priceList"].constructor === Array) {
                this.priceList = [];
                for (let item of data["priceList"])
                    this.priceList.push(ExportToExcelUploadPriceListDto.fromJS(item));
            }
            this.unitItemPrice = data["unitItemPrice"] ? CreateUnitItemPriceInputDto.fromJS(data["unitItemPrice"]) : <any>undefined;
            this.updateUnit = data["updateUnit"] ? GetMsUnitByProjectClusterCategoryProduct.fromJS(data["updateUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportToExcelUploadGrossPriceListDto {
        let result = new ExportToExcelUploadGrossPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.priceList && this.priceList.constructor === Array) {
            data["priceList"] = [];
            for (let item of this.priceList)
                data["priceList"].push(item.toJSON());
        }
        data["unitItemPrice"] = this.unitItemPrice ? this.unitItemPrice.toJSON() : <any>undefined;
        data["updateUnit"] = this.updateUnit ? this.updateUnit.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExportToExcelUploadGrossPriceListDto {
    priceList: ExportToExcelUploadPriceListDto[];
    unitItemPrice: CreateUnitItemPriceInputDto;
    updateUnit: GetMsUnitByProjectClusterCategoryProduct;
}

export class ExportToExcelUploadPriceListDto implements IExportToExcelUploadPriceListDto {
    arrayTerm: string;
    productName: string;
    unitCode: string;
    unitNo: string;
    price: number;
    termName: string;
    bookingFee: number;
    termMainID: number;
    termID: number;
    renovCode: string;
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    grossPrice: number;
    listTermDisc: ListTermDisc[];
    salesDisc: number;

    constructor(data?: IExportToExcelUploadPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.arrayTerm = data["arrayTerm"];
            this.productName = data["productName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.price = data["price"];
            this.termName = data["termName"];
            this.bookingFee = data["bookingFee"];
            this.termMainID = data["termMainID"];
            this.termID = data["termID"];
            this.renovCode = data["renovCode"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            if (data["categoryID"] && data["categoryID"].constructor === Array) {
                this.categoryID = [];
                for (let item of data["categoryID"])
                    this.categoryID.push(item);
            }
            if (data["productID"] && data["productID"].constructor === Array) {
                this.productID = [];
                for (let item of data["productID"])
                    this.productID.push(item);
            }
            this.grossPrice = data["grossPrice"];
            if (data["listTermDisc"] && data["listTermDisc"].constructor === Array) {
                this.listTermDisc = [];
                for (let item of data["listTermDisc"])
                    this.listTermDisc.push(ListTermDisc.fromJS(item));
            }
            this.salesDisc = data["salesDisc"];
        }
    }

    static fromJS(data: any): ExportToExcelUploadPriceListDto {
        let result = new ExportToExcelUploadPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrayTerm"] = this.arrayTerm;
        data["productName"] = this.productName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["price"] = this.price;
        data["termName"] = this.termName;
        data["bookingFee"] = this.bookingFee;
        data["termMainID"] = this.termMainID;
        data["termID"] = this.termID;
        data["renovCode"] = this.renovCode;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        if (this.categoryID && this.categoryID.constructor === Array) {
            data["categoryID"] = [];
            for (let item of this.categoryID)
                data["categoryID"].push(item);
        }
        if (this.productID && this.productID.constructor === Array) {
            data["productID"] = [];
            for (let item of this.productID)
                data["productID"].push(item);
        }
        data["grossPrice"] = this.grossPrice;
        if (this.listTermDisc && this.listTermDisc.constructor === Array) {
            data["listTermDisc"] = [];
            for (let item of this.listTermDisc)
                data["listTermDisc"].push(item.toJSON());
        }
        data["salesDisc"] = this.salesDisc;
        return data; 
    }
}

export interface IExportToExcelUploadPriceListDto {
    arrayTerm: string;
    productName: string;
    unitCode: string;
    unitNo: string;
    price: number;
    termName: string;
    bookingFee: number;
    termMainID: number;
    termID: number;
    renovCode: string;
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    grossPrice: number;
    listTermDisc: ListTermDisc[];
    salesDisc: number;
}

export class CreateUnitItemPriceInputDto implements ICreateUnitItemPriceInputDto {
    projectId: number;
    termId: number;
    clusterId: number;
    pctDisc: number;
    inputUnitItemPrice: CreateUnitItemEtcInputDto[];

    constructor(data?: ICreateUnitItemPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.termId = data["termId"];
            this.clusterId = data["clusterId"];
            this.pctDisc = data["pctDisc"];
            if (data["inputUnitItemPrice"] && data["inputUnitItemPrice"].constructor === Array) {
                this.inputUnitItemPrice = [];
                for (let item of data["inputUnitItemPrice"])
                    this.inputUnitItemPrice.push(CreateUnitItemEtcInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUnitItemPriceInputDto {
        let result = new CreateUnitItemPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["termId"] = this.termId;
        data["clusterId"] = this.clusterId;
        data["pctDisc"] = this.pctDisc;
        if (this.inputUnitItemPrice && this.inputUnitItemPrice.constructor === Array) {
            data["inputUnitItemPrice"] = [];
            for (let item of this.inputUnitItemPrice)
                data["inputUnitItemPrice"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUnitItemPriceInputDto {
    projectId: number;
    termId: number;
    clusterId: number;
    pctDisc: number;
    inputUnitItemPrice: CreateUnitItemEtcInputDto[];
}

export class GetMsUnitByProjectClusterCategoryProduct implements IGetMsUnitByProjectClusterCategoryProduct {
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    termMainID: number;

    constructor(data?: IGetMsUnitByProjectClusterCategoryProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            if (data["categoryID"] && data["categoryID"].constructor === Array) {
                this.categoryID = [];
                for (let item of data["categoryID"])
                    this.categoryID.push(item);
            }
            if (data["productID"] && data["productID"].constructor === Array) {
                this.productID = [];
                for (let item of data["productID"])
                    this.productID.push(item);
            }
            this.termMainID = data["termMainID"];
        }
    }

    static fromJS(data: any): GetMsUnitByProjectClusterCategoryProduct {
        let result = new GetMsUnitByProjectClusterCategoryProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        if (this.categoryID && this.categoryID.constructor === Array) {
            data["categoryID"] = [];
            for (let item of this.categoryID)
                data["categoryID"].push(item);
        }
        if (this.productID && this.productID.constructor === Array) {
            data["productID"] = [];
            for (let item of this.productID)
                data["productID"].push(item);
        }
        data["termMainID"] = this.termMainID;
        return data; 
    }
}

export interface IGetMsUnitByProjectClusterCategoryProduct {
    projectID: number;
    clusterID: number;
    categoryID: number[];
    productID: number[];
    termMainID: number;
}

export class ListTermDisc implements IListTermDisc {
    termDiscNo: number;
    termDIsc: number;

    constructor(data?: IListTermDisc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termDiscNo = data["termDiscNo"];
            this.termDIsc = data["termDIsc"];
        }
    }

    static fromJS(data: any): ListTermDisc {
        let result = new ListTermDisc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termDiscNo"] = this.termDiscNo;
        data["termDIsc"] = this.termDIsc;
        return data; 
    }
}

export interface IListTermDisc {
    termDiscNo: number;
    termDIsc: number;
}

export class CreateUnitItemEtcInputDto implements ICreateUnitItemEtcInputDto {
    unitCode: string;
    unitNo: string;
    renovCode: string;
    itemCode: string;
    grossPrice: number;

    constructor(data?: ICreateUnitItemEtcInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.renovCode = data["renovCode"];
            this.itemCode = data["itemCode"];
            this.grossPrice = data["grossPrice"];
        }
    }

    static fromJS(data: any): CreateUnitItemEtcInputDto {
        let result = new CreateUnitItemEtcInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["renovCode"] = this.renovCode;
        data["itemCode"] = this.itemCode;
        data["grossPrice"] = this.grossPrice;
        return data; 
    }
}

export interface ICreateUnitItemEtcInputDto {
    unitCode: string;
    unitNo: string;
    renovCode: string;
    itemCode: string;
    grossPrice: number;
}

export class GetGeneratePriceListTermListDto implements IGetGeneratePriceListTermListDto {
    termRemarks: string;
    discPct: number;
    discAmt: number;

    constructor(data?: IGetGeneratePriceListTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termRemarks = data["termRemarks"];
            this.discPct = data["discPct"];
            this.discAmt = data["discAmt"];
        }
    }

    static fromJS(data: any): GetGeneratePriceListTermListDto {
        let result = new GetGeneratePriceListTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termRemarks"] = this.termRemarks;
        data["discPct"] = this.discPct;
        data["discAmt"] = this.discAmt;
        return data; 
    }
}

export interface IGetGeneratePriceListTermListDto {
    termRemarks: string;
    discPct: number;
    discAmt: number;
}

export class CreatePriceTaskListInputDto implements ICreatePriceTaskListInputDto {
    projectID: number;
    priceListFile: string;

    constructor(data?: ICreatePriceTaskListInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.priceListFile = data["priceListFile"];
        }
    }

    static fromJS(data: any): CreatePriceTaskListInputDto {
        let result = new CreatePriceTaskListInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["priceListFile"] = this.priceListFile;
        return data; 
    }
}

export interface ICreatePriceTaskListInputDto {
    projectID: number;
    priceListFile: string;
}

export class GetPriceTaskListDto implements IGetPriceTaskListDto {
    id: number;
    priceListFile: string;
    creationTime: moment.Moment;

    constructor(data?: IGetPriceTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.priceListFile = data["priceListFile"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPriceTaskListDto {
        let result = new GetPriceTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priceListFile"] = this.priceListFile;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetPriceTaskListDto {
    id: number;
    priceListFile: string;
    creationTime: moment.Moment;
}

export class CheckDataUploadGrossPriceInputDto implements ICheckDataUploadGrossPriceInputDto {
    projectId: number;
    clusterId: number;
    productId: number[];
    categoryId: number[];
    dataUnit: UnitInput[];

    constructor(data?: ICheckDataUploadGrossPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            if (data["productId"] && data["productId"].constructor === Array) {
                this.productId = [];
                for (let item of data["productId"])
                    this.productId.push(item);
            }
            if (data["categoryId"] && data["categoryId"].constructor === Array) {
                this.categoryId = [];
                for (let item of data["categoryId"])
                    this.categoryId.push(item);
            }
            if (data["dataUnit"] && data["dataUnit"].constructor === Array) {
                this.dataUnit = [];
                for (let item of data["dataUnit"])
                    this.dataUnit.push(UnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckDataUploadGrossPriceInputDto {
        let result = new CheckDataUploadGrossPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        if (this.productId && this.productId.constructor === Array) {
            data["productId"] = [];
            for (let item of this.productId)
                data["productId"].push(item);
        }
        if (this.categoryId && this.categoryId.constructor === Array) {
            data["categoryId"] = [];
            for (let item of this.categoryId)
                data["categoryId"].push(item);
        }
        if (this.dataUnit && this.dataUnit.constructor === Array) {
            data["dataUnit"] = [];
            for (let item of this.dataUnit)
                data["dataUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICheckDataUploadGrossPriceInputDto {
    projectId: number;
    clusterId: number;
    productId: number[];
    categoryId: number[];
    dataUnit: UnitInput[];
}

export class UnitInput implements IUnitInput {
    unitCode: string;
    unitNo: string;
    itemCode: string;
    renovCode: string;

    constructor(data?: IUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.itemCode = data["itemCode"];
            this.renovCode = data["renovCode"];
        }
    }

    static fromJS(data: any): UnitInput {
        let result = new UnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["itemCode"] = this.itemCode;
        data["renovCode"] = this.renovCode;
        return data; 
    }
}

export interface IUnitInput {
    unitCode: string;
    unitNo: string;
    itemCode: string;
    renovCode: string;
}

export class GetProductCodeByUnitCodeUnitNoDto implements IGetProductCodeByUnitCodeUnitNoDto {
    no: number;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetProductCodeByUnitCodeUnitNoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetProductCodeByUnitCodeUnitNoDto {
        let result = new GetProductCodeByUnitCodeUnitNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetProductCodeByUnitCodeUnitNoDto {
    no: number;
    unitCode: string;
    unitNo: string;
}

export class CheckDuplicateDataInputDto implements ICheckDuplicateDataInputDto {
    unitCode: string;
    unitNo: string;
    renovCode: string;

    constructor(data?: ICheckDuplicateDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.renovCode = data["renovCode"];
        }
    }

    static fromJS(data: any): CheckDuplicateDataInputDto {
        let result = new CheckDuplicateDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["renovCode"] = this.renovCode;
        return data; 
    }
}

export interface ICheckDuplicateDataInputDto {
    unitCode: string;
    unitNo: string;
    renovCode: string;
}

export class GetMsDiscountDto implements IGetMsDiscountDto {
    discountID: number;
    discountCode: string;
    discountName: string;

    constructor(data?: IGetMsDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.discountCode = data["discountCode"];
            this.discountName = data["discountName"];
        }
    }

    static fromJS(data: any): GetMsDiscountDto {
        let result = new GetMsDiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["discountCode"] = this.discountCode;
        data["discountName"] = this.discountName;
        return data; 
    }
}

export interface IGetMsDiscountDto {
    discountID: number;
    discountCode: string;
    discountName: string;
}

export class GetPctDiscDto implements IGetPctDiscDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    pctDisc: number;

    constructor(data?: IGetPctDiscDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.discountCode = data["discountCode"];
            this.discountName = data["discountName"];
            this.pctDisc = data["pctDisc"];
        }
    }

    static fromJS(data: any): GetPctDiscDto {
        let result = new GetPctDiscDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["discountCode"] = this.discountCode;
        data["discountName"] = this.discountName;
        data["pctDisc"] = this.pctDisc;
        return data; 
    }
}

export interface IGetPctDiscDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    pctDisc: number;
}

export class GetPctDiscProjectDto implements IGetPctDiscProjectDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    pctDisc: number;

    constructor(data?: IGetPctDiscProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.discountCode = data["discountCode"];
            this.discountName = data["discountName"];
            this.pctDisc = data["pctDisc"];
        }
    }

    static fromJS(data: any): GetPctDiscProjectDto {
        let result = new GetPctDiscProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["discountCode"] = this.discountCode;
        data["discountName"] = this.discountName;
        data["pctDisc"] = this.pctDisc;
        return data; 
    }
}

export interface IGetPctDiscProjectDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    pctDisc: number;
}

export class ListResultDtoOfGetDropdownProjectForPriceDto implements IListResultDtoOfGetDropdownProjectForPriceDto {
    items: GetDropdownProjectForPriceDto[];

    constructor(data?: IListResultDtoOfGetDropdownProjectForPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDropdownProjectForPriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDropdownProjectForPriceDto {
        let result = new ListResultDtoOfGetDropdownProjectForPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDropdownProjectForPriceDto {
    items: GetDropdownProjectForPriceDto[];
}

export class GetDropdownProjectForPriceDto implements IGetDropdownProjectForPriceDto {
    projectID: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IGetDropdownProjectForPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetDropdownProjectForPriceDto {
        let result = new GetDropdownProjectForPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetDropdownProjectForPriceDto {
    projectID: number;
    projectCode: string;
    projectName: string;
}

export class ListResultDtoOfGetDropdownProductForPriceDto implements IListResultDtoOfGetDropdownProductForPriceDto {
    items: GetDropdownProductForPriceDto[];

    constructor(data?: IListResultDtoOfGetDropdownProductForPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDropdownProductForPriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDropdownProductForPriceDto {
        let result = new ListResultDtoOfGetDropdownProductForPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDropdownProductForPriceDto {
    items: GetDropdownProductForPriceDto[];
}

export class GetDropdownProductForPriceDto implements IGetDropdownProductForPriceDto {
    productId: number;
    productCode: string;
    productName: string;

    constructor(data?: IGetDropdownProductForPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetDropdownProductForPriceDto {
        let result = new GetDropdownProductForPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetDropdownProductForPriceDto {
    productId: number;
    productCode: string;
    productName: string;
}

export class ListResultDtoOfGetDropdownClusterForPrice implements IListResultDtoOfGetDropdownClusterForPrice {
    items: GetDropdownClusterForPrice[];

    constructor(data?: IListResultDtoOfGetDropdownClusterForPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDropdownClusterForPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDropdownClusterForPrice {
        let result = new ListResultDtoOfGetDropdownClusterForPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDropdownClusterForPrice {
    items: GetDropdownClusterForPrice[];
}

export class GetDropdownClusterForPrice implements IGetDropdownClusterForPrice {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetDropdownClusterForPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetDropdownClusterForPrice {
        let result = new GetDropdownClusterForPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetDropdownClusterForPrice {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class InputPriceListDto implements IInputPriceListDto {
    projectCode: string[];
    productCode: string[];
    clusterCode: string[];

    constructor(data?: IInputPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectCode"] && data["projectCode"].constructor === Array) {
                this.projectCode = [];
                for (let item of data["projectCode"])
                    this.projectCode.push(item);
            }
            if (data["productCode"] && data["productCode"].constructor === Array) {
                this.productCode = [];
                for (let item of data["productCode"])
                    this.productCode.push(item);
            }
            if (data["clusterCode"] && data["clusterCode"].constructor === Array) {
                this.clusterCode = [];
                for (let item of data["clusterCode"])
                    this.clusterCode.push(item);
            }
        }
    }

    static fromJS(data: any): InputPriceListDto {
        let result = new InputPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectCode && this.projectCode.constructor === Array) {
            data["projectCode"] = [];
            for (let item of this.projectCode)
                data["projectCode"].push(item);
        }
        if (this.productCode && this.productCode.constructor === Array) {
            data["productCode"] = [];
            for (let item of this.productCode)
                data["productCode"].push(item);
        }
        if (this.clusterCode && this.clusterCode.constructor === Array) {
            data["clusterCode"] = [];
            for (let item of this.clusterCode)
                data["clusterCode"].push(item);
        }
        return data; 
    }
}

export interface IInputPriceListDto {
    projectCode: string[];
    productCode: string[];
    clusterCode: string[];
}

export class GetListPriceDto implements IGetListPriceDto {
    projectName: string;
    productName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    termCode: string;
    renovationName: string;
    termOfPayment: string;
    grossPrice: string;
    pctDisc: number;
    netPrice: string;
    disc: number;
    netNetPrice: string;
    pctTax: number;
    sellingPrice: string;
    discList: string;

    constructor(data?: IGetListPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatusName = data["unitStatusName"];
            this.termCode = data["termCode"];
            this.renovationName = data["renovationName"];
            this.termOfPayment = data["termOfPayment"];
            this.grossPrice = data["grossPrice"];
            this.pctDisc = data["pctDisc"];
            this.netPrice = data["netPrice"];
            this.disc = data["disc"];
            this.netNetPrice = data["netNetPrice"];
            this.pctTax = data["pctTax"];
            this.sellingPrice = data["sellingPrice"];
            this.discList = data["discList"];
        }
    }

    static fromJS(data: any): GetListPriceDto {
        let result = new GetListPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatusName"] = this.unitStatusName;
        data["termCode"] = this.termCode;
        data["renovationName"] = this.renovationName;
        data["termOfPayment"] = this.termOfPayment;
        data["grossPrice"] = this.grossPrice;
        data["pctDisc"] = this.pctDisc;
        data["netPrice"] = this.netPrice;
        data["disc"] = this.disc;
        data["netNetPrice"] = this.netNetPrice;
        data["pctTax"] = this.pctTax;
        data["sellingPrice"] = this.sellingPrice;
        data["discList"] = this.discList;
        return data; 
    }
}

export interface IGetListPriceDto {
    projectName: string;
    productName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    termCode: string;
    renovationName: string;
    termOfPayment: string;
    grossPrice: string;
    pctDisc: number;
    netPrice: string;
    disc: number;
    netNetPrice: string;
    pctTax: number;
    sellingPrice: string;
    discList: string;
}

export class PrintPriceInputDto implements IPrintPriceInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataPriceDto;

    constructor(data?: IPrintPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataPriceDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrintPriceInputDto {
        let result = new PrintPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPrintPriceInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataPriceDto;
}

export class ListDataPriceDto implements IListDataPriceDto {
    listHeader: ListHeaderPriceDto[];
    listBody: ListBodyPriceDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;

    constructor(data?: IListDataPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderPriceDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyPriceDto.fromJS(item));
            }
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.colspanTbl = data["colspanTbl"];
            this.grandTotal = data["grandTotal"];
        }
    }

    static fromJS(data: any): ListDataPriceDto {
        let result = new ListDataPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["colspanTbl"] = this.colspanTbl;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IListDataPriceDto {
    listHeader: ListHeaderPriceDto[];
    listBody: ListBodyPriceDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;
}

export class ListHeaderPriceDto implements IListHeaderPriceDto {
    headerID: number;
    header: string;

    constructor(data?: IListHeaderPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.header = data["header"];
        }
    }

    static fromJS(data: any): ListHeaderPriceDto {
        let result = new ListHeaderPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["header"] = this.header;
        return data; 
    }
}

export interface IListHeaderPriceDto {
    headerID: number;
    header: string;
}

export class ListBodyPriceDto implements IListBodyPriceDto {
    projectName: string;
    productName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    termCode: string;
    renovationName: string;
    termOfPayment: string;
    grossPrice: string;
    pctDisc: number;
    netPrice: string;
    disc: number;
    netNetPrice: string;
    pctTax: number;
    sellingPrice: string;
    discList: string;

    constructor(data?: IListBodyPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatusName = data["unitStatusName"];
            this.termCode = data["termCode"];
            this.renovationName = data["renovationName"];
            this.termOfPayment = data["termOfPayment"];
            this.grossPrice = data["grossPrice"];
            this.pctDisc = data["pctDisc"];
            this.netPrice = data["netPrice"];
            this.disc = data["disc"];
            this.netNetPrice = data["netNetPrice"];
            this.pctTax = data["pctTax"];
            this.sellingPrice = data["sellingPrice"];
            this.discList = data["discList"];
        }
    }

    static fromJS(data: any): ListBodyPriceDto {
        let result = new ListBodyPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatusName"] = this.unitStatusName;
        data["termCode"] = this.termCode;
        data["renovationName"] = this.renovationName;
        data["termOfPayment"] = this.termOfPayment;
        data["grossPrice"] = this.grossPrice;
        data["pctDisc"] = this.pctDisc;
        data["netPrice"] = this.netPrice;
        data["disc"] = this.disc;
        data["netNetPrice"] = this.netNetPrice;
        data["pctTax"] = this.pctTax;
        data["sellingPrice"] = this.sellingPrice;
        data["discList"] = this.discList;
        return data; 
    }
}

export interface IListBodyPriceDto {
    projectName: string;
    productName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    termCode: string;
    renovationName: string;
    termOfPayment: string;
    grossPrice: string;
    pctDisc: number;
    netPrice: string;
    disc: number;
    netNetPrice: string;
    pctTax: number;
    sellingPrice: string;
    discList: string;
}

export class AddDiscountPerTermGeneratePriceDto implements IAddDiscountPerTermGeneratePriceDto {
    termAddDiscID: number;
    discountID: number;
    addDiscPct: number;
    discountName: string;
    addDiscAmt: number;
    addDiscNo: string;

    constructor(data?: IAddDiscountPerTermGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termAddDiscID = data["termAddDiscID"];
            this.discountID = data["discountID"];
            this.addDiscPct = data["addDiscPct"];
            this.discountName = data["discountName"];
            this.addDiscAmt = data["addDiscAmt"];
            this.addDiscNo = data["addDiscNo"];
        }
    }

    static fromJS(data: any): AddDiscountPerTermGeneratePriceDto {
        let result = new AddDiscountPerTermGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termAddDiscID"] = this.termAddDiscID;
        data["discountID"] = this.discountID;
        data["addDiscPct"] = this.addDiscPct;
        data["discountName"] = this.discountName;
        data["addDiscAmt"] = this.addDiscAmt;
        data["addDiscNo"] = this.addDiscNo;
        return data; 
    }
}

export interface IAddDiscountPerTermGeneratePriceDto {
    termAddDiscID: number;
    discountID: number;
    addDiscPct: number;
    discountName: string;
    addDiscAmt: number;
    addDiscNo: string;
}

export class NewGeneratePriceDto implements INewGeneratePriceDto {
    headerID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    districtCode: string;
    listDistrictCluster: NewGeneratePriceSlusterDto[];
    listFactoring: GetSettingFactoringDetailDto[];
    typeTower: string[];
    unitType: string[];
    cost: number;
    margin: number;
    factoringID: number;
    factoringCode: string;
    startValidFrom: moment.Moment;
    eventName: string;
    discount: number;
    vat: number;
    termMainID: number;
    termCode: string;
    renovID: number;
    renovCode: string;
    workFlowID: number;
    listTerm: AddDiscountGeneratePriceDto[];

    constructor(data?: INewGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.districtCode = data["districtCode"];
            if (data["listDistrictCluster"] && data["listDistrictCluster"].constructor === Array) {
                this.listDistrictCluster = [];
                for (let item of data["listDistrictCluster"])
                    this.listDistrictCluster.push(NewGeneratePriceSlusterDto.fromJS(item));
            }
            if (data["listFactoring"] && data["listFactoring"].constructor === Array) {
                this.listFactoring = [];
                for (let item of data["listFactoring"])
                    this.listFactoring.push(GetSettingFactoringDetailDto.fromJS(item));
            }
            if (data["typeTower"] && data["typeTower"].constructor === Array) {
                this.typeTower = [];
                for (let item of data["typeTower"])
                    this.typeTower.push(item);
            }
            if (data["unitType"] && data["unitType"].constructor === Array) {
                this.unitType = [];
                for (let item of data["unitType"])
                    this.unitType.push(item);
            }
            this.cost = data["cost"];
            this.margin = data["margin"];
            this.factoringID = data["factoringID"];
            this.factoringCode = data["factoringCode"];
            this.startValidFrom = data["startValidFrom"] ? moment(data["startValidFrom"].toString()) : <any>undefined;
            this.eventName = data["eventName"];
            this.discount = data["discount"];
            this.vat = data["vat"];
            this.termMainID = data["termMainID"];
            this.termCode = data["termCode"];
            this.renovID = data["renovID"];
            this.renovCode = data["renovCode"];
            this.workFlowID = data["workFlowID"];
            if (data["listTerm"] && data["listTerm"].constructor === Array) {
                this.listTerm = [];
                for (let item of data["listTerm"])
                    this.listTerm.push(AddDiscountGeneratePriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewGeneratePriceDto {
        let result = new NewGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["districtCode"] = this.districtCode;
        if (this.listDistrictCluster && this.listDistrictCluster.constructor === Array) {
            data["listDistrictCluster"] = [];
            for (let item of this.listDistrictCluster)
                data["listDistrictCluster"].push(item.toJSON());
        }
        if (this.listFactoring && this.listFactoring.constructor === Array) {
            data["listFactoring"] = [];
            for (let item of this.listFactoring)
                data["listFactoring"].push(item.toJSON());
        }
        if (this.typeTower && this.typeTower.constructor === Array) {
            data["typeTower"] = [];
            for (let item of this.typeTower)
                data["typeTower"].push(item);
        }
        if (this.unitType && this.unitType.constructor === Array) {
            data["unitType"] = [];
            for (let item of this.unitType)
                data["unitType"].push(item);
        }
        data["cost"] = this.cost;
        data["margin"] = this.margin;
        data["factoringID"] = this.factoringID;
        data["factoringCode"] = this.factoringCode;
        data["startValidFrom"] = this.startValidFrom ? this.startValidFrom.toISOString() : <any>undefined;
        data["eventName"] = this.eventName;
        data["discount"] = this.discount;
        data["vat"] = this.vat;
        data["termMainID"] = this.termMainID;
        data["termCode"] = this.termCode;
        data["renovID"] = this.renovID;
        data["renovCode"] = this.renovCode;
        data["workFlowID"] = this.workFlowID;
        if (this.listTerm && this.listTerm.constructor === Array) {
            data["listTerm"] = [];
            for (let item of this.listTerm)
                data["listTerm"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INewGeneratePriceDto {
    headerID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    districtCode: string;
    listDistrictCluster: NewGeneratePriceSlusterDto[];
    listFactoring: GetSettingFactoringDetailDto[];
    typeTower: string[];
    unitType: string[];
    cost: number;
    margin: number;
    factoringID: number;
    factoringCode: string;
    startValidFrom: moment.Moment;
    eventName: string;
    discount: number;
    vat: number;
    termMainID: number;
    termCode: string;
    renovID: number;
    renovCode: string;
    workFlowID: number;
    listTerm: AddDiscountGeneratePriceDto[];
}

export class NewGeneratePriceSlusterDto implements INewGeneratePriceSlusterDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    districtCode: string;

    constructor(data?: INewGeneratePriceSlusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.districtCode = data["districtCode"];
        }
    }

    static fromJS(data: any): NewGeneratePriceSlusterDto {
        let result = new NewGeneratePriceSlusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["districtCode"] = this.districtCode;
        return data; 
    }
}

export interface INewGeneratePriceSlusterDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    districtCode: string;
}

export class GetSettingFactoringDetailDto implements IGetSettingFactoringDetailDto {
    settingFactoringDetailID: number;
    district: string;
    blok: string;
    clusterType: string;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitType: string;
    unitID: number[];
    percentage: number;
    isDeleted: boolean;
    singleUnitID: number;

    constructor(data?: IGetSettingFactoringDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingFactoringDetailID = data["settingFactoringDetailID"];
            this.district = data["district"];
            this.blok = data["blok"];
            this.clusterType = data["clusterType"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.unitType = data["unitType"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
            this.percentage = data["percentage"];
            this.isDeleted = data["isDeleted"];
            this.singleUnitID = data["singleUnitID"];
        }
    }

    static fromJS(data: any): GetSettingFactoringDetailDto {
        let result = new GetSettingFactoringDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingFactoringDetailID"] = this.settingFactoringDetailID;
        data["district"] = this.district;
        data["blok"] = this.blok;
        data["clusterType"] = this.clusterType;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["unitType"] = this.unitType;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        data["percentage"] = this.percentage;
        data["isDeleted"] = this.isDeleted;
        data["singleUnitID"] = this.singleUnitID;
        return data; 
    }
}

export interface IGetSettingFactoringDetailDto {
    settingFactoringDetailID: number;
    district: string;
    blok: string;
    clusterType: string;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    unitType: string;
    unitID: number[];
    percentage: number;
    isDeleted: boolean;
    singleUnitID: number;
}

export class AddDiscountGeneratePriceDto implements IAddDiscountGeneratePriceDto {
    termGenPriceID: number;
    termID: number;
    termName: string;
    termPct: number;
    listDiscount: AddDiscountPerTermGeneratePriceDto[];

    constructor(data?: IAddDiscountGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termGenPriceID = data["termGenPriceID"];
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.termPct = data["termPct"];
            if (data["listDiscount"] && data["listDiscount"].constructor === Array) {
                this.listDiscount = [];
                for (let item of data["listDiscount"])
                    this.listDiscount.push(AddDiscountPerTermGeneratePriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddDiscountGeneratePriceDto {
        let result = new AddDiscountGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termGenPriceID"] = this.termGenPriceID;
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["termPct"] = this.termPct;
        if (this.listDiscount && this.listDiscount.constructor === Array) {
            data["listDiscount"] = [];
            for (let item of this.listDiscount)
                data["listDiscount"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddDiscountGeneratePriceDto {
    termGenPriceID: number;
    termID: number;
    termName: string;
    termPct: number;
    listDiscount: AddDiscountPerTermGeneratePriceDto[];
}

export class NewPreviewGeneratePriceDto implements INewPreviewGeneratePriceDto {
    districtCode: string;
    blok: string;
    typeCluster: string;
    typeUnit: string;
    detailID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    cost: number;
    margin: number;
    factoring: number;
    discount: number;
    vat: number;
    renovID: number;
    renovCode: string;
    termID: number;
    termRemarks: string;
    unitID: number;
    unitCode: string;
    termPct: number;
    unitNo: string;
    basePrice: number;
    netPrice: number;
    netNetPrice: number;
    sellingPrice: number;
    luas: number;
    pctTanah: number;
    pctBangunan: number;
    pctRenov: number;
    priceTanah: number;
    priceBangunan: number;
    priceRenov: number;
    totalPrice: number;
    renovationName: string;
    listTermAddDisc: AddDiscountPerTermGeneratePriceDto[];

    constructor(data?: INewPreviewGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.districtCode = data["districtCode"];
            this.blok = data["blok"];
            this.typeCluster = data["typeCluster"];
            this.typeUnit = data["typeUnit"];
            this.detailID = data["detailID"];
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.cost = data["cost"];
            this.margin = data["margin"];
            this.factoring = data["factoring"];
            this.discount = data["discount"];
            this.vat = data["vat"];
            this.renovID = data["renovID"];
            this.renovCode = data["renovCode"];
            this.termID = data["termID"];
            this.termRemarks = data["termRemarks"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.termPct = data["termPct"];
            this.unitNo = data["unitNo"];
            this.basePrice = data["basePrice"];
            this.netPrice = data["netPrice"];
            this.netNetPrice = data["netNetPrice"];
            this.sellingPrice = data["sellingPrice"];
            this.luas = data["luas"];
            this.pctTanah = data["pctTanah"];
            this.pctBangunan = data["pctBangunan"];
            this.pctRenov = data["pctRenov"];
            this.priceTanah = data["priceTanah"];
            this.priceBangunan = data["priceBangunan"];
            this.priceRenov = data["priceRenov"];
            this.totalPrice = data["totalPrice"];
            this.renovationName = data["renovationName"];
            if (data["listTermAddDisc"] && data["listTermAddDisc"].constructor === Array) {
                this.listTermAddDisc = [];
                for (let item of data["listTermAddDisc"])
                    this.listTermAddDisc.push(AddDiscountPerTermGeneratePriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewPreviewGeneratePriceDto {
        let result = new NewPreviewGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtCode"] = this.districtCode;
        data["blok"] = this.blok;
        data["typeCluster"] = this.typeCluster;
        data["typeUnit"] = this.typeUnit;
        data["detailID"] = this.detailID;
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["cost"] = this.cost;
        data["margin"] = this.margin;
        data["factoring"] = this.factoring;
        data["discount"] = this.discount;
        data["vat"] = this.vat;
        data["renovID"] = this.renovID;
        data["renovCode"] = this.renovCode;
        data["termID"] = this.termID;
        data["termRemarks"] = this.termRemarks;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["termPct"] = this.termPct;
        data["unitNo"] = this.unitNo;
        data["basePrice"] = this.basePrice;
        data["netPrice"] = this.netPrice;
        data["netNetPrice"] = this.netNetPrice;
        data["sellingPrice"] = this.sellingPrice;
        data["luas"] = this.luas;
        data["pctTanah"] = this.pctTanah;
        data["pctBangunan"] = this.pctBangunan;
        data["pctRenov"] = this.pctRenov;
        data["priceTanah"] = this.priceTanah;
        data["priceBangunan"] = this.priceBangunan;
        data["priceRenov"] = this.priceRenov;
        data["totalPrice"] = this.totalPrice;
        data["renovationName"] = this.renovationName;
        if (this.listTermAddDisc && this.listTermAddDisc.constructor === Array) {
            data["listTermAddDisc"] = [];
            for (let item of this.listTermAddDisc)
                data["listTermAddDisc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface INewPreviewGeneratePriceDto {
    districtCode: string;
    blok: string;
    typeCluster: string;
    typeUnit: string;
    detailID: number;
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    cost: number;
    margin: number;
    factoring: number;
    discount: number;
    vat: number;
    renovID: number;
    renovCode: string;
    termID: number;
    termRemarks: string;
    unitID: number;
    unitCode: string;
    termPct: number;
    unitNo: string;
    basePrice: number;
    netPrice: number;
    netNetPrice: number;
    sellingPrice: number;
    luas: number;
    pctTanah: number;
    pctBangunan: number;
    pctRenov: number;
    priceTanah: number;
    priceBangunan: number;
    priceRenov: number;
    totalPrice: number;
    renovationName: string;
    listTermAddDisc: AddDiscountPerTermGeneratePriceDto[];
}

export class GetTasklistNewGeneratePriceDto implements IGetTasklistNewGeneratePriceDto {
    newGeneratePriceHeaderID: number;
    eventName: string;
    startValidFrom: moment.Moment;
    statusWorkFlow: string;
    statusScheduler: boolean;
    status: string;
    creationTime: moment.Moment;

    constructor(data?: IGetTasklistNewGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newGeneratePriceHeaderID = data["newGeneratePriceHeaderID"];
            this.eventName = data["eventName"];
            this.startValidFrom = data["startValidFrom"] ? moment(data["startValidFrom"].toString()) : <any>undefined;
            this.statusWorkFlow = data["statusWorkFlow"];
            this.statusScheduler = data["statusScheduler"];
            this.status = data["status"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTasklistNewGeneratePriceDto {
        let result = new GetTasklistNewGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newGeneratePriceHeaderID"] = this.newGeneratePriceHeaderID;
        data["eventName"] = this.eventName;
        data["startValidFrom"] = this.startValidFrom ? this.startValidFrom.toISOString() : <any>undefined;
        data["statusWorkFlow"] = this.statusWorkFlow;
        data["statusScheduler"] = this.statusScheduler;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetTasklistNewGeneratePriceDto {
    newGeneratePriceHeaderID: number;
    eventName: string;
    startValidFrom: moment.Moment;
    statusWorkFlow: string;
    statusScheduler: boolean;
    status: string;
    creationTime: moment.Moment;
}

export class SubmitNewGeneratePrice implements ISubmitNewGeneratePrice {
    requestActions: RequestActionDto[];
    generatePriceHeader: NewGeneratePriceDto;
    generatePriceDetail: NewPreviewGeneratePriceDto[];
    isEdit: boolean;
    isCompleted: boolean;
    statusGeneratePrice: string;
    identifierNumber: number;
    remarks: string;
    approvalLog: string[];

    constructor(data?: ISubmitNewGeneratePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["requestActions"] && data["requestActions"].constructor === Array) {
                this.requestActions = [];
                for (let item of data["requestActions"])
                    this.requestActions.push(RequestActionDto.fromJS(item));
            }
            this.generatePriceHeader = data["generatePriceHeader"] ? NewGeneratePriceDto.fromJS(data["generatePriceHeader"]) : <any>undefined;
            if (data["generatePriceDetail"] && data["generatePriceDetail"].constructor === Array) {
                this.generatePriceDetail = [];
                for (let item of data["generatePriceDetail"])
                    this.generatePriceDetail.push(NewPreviewGeneratePriceDto.fromJS(item));
            }
            this.isEdit = data["isEdit"];
            this.isCompleted = data["isCompleted"];
            this.statusGeneratePrice = data["statusGeneratePrice"];
            this.identifierNumber = data["identifierNumber"];
            this.remarks = data["remarks"];
            if (data["approvalLog"] && data["approvalLog"].constructor === Array) {
                this.approvalLog = [];
                for (let item of data["approvalLog"])
                    this.approvalLog.push(item);
            }
        }
    }

    static fromJS(data: any): SubmitNewGeneratePrice {
        let result = new SubmitNewGeneratePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.requestActions && this.requestActions.constructor === Array) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        data["generatePriceHeader"] = this.generatePriceHeader ? this.generatePriceHeader.toJSON() : <any>undefined;
        if (this.generatePriceDetail && this.generatePriceDetail.constructor === Array) {
            data["generatePriceDetail"] = [];
            for (let item of this.generatePriceDetail)
                data["generatePriceDetail"].push(item.toJSON());
        }
        data["isEdit"] = this.isEdit;
        data["isCompleted"] = this.isCompleted;
        data["statusGeneratePrice"] = this.statusGeneratePrice;
        data["identifierNumber"] = this.identifierNumber;
        data["remarks"] = this.remarks;
        if (this.approvalLog && this.approvalLog.constructor === Array) {
            data["approvalLog"] = [];
            for (let item of this.approvalLog)
                data["approvalLog"].push(item);
        }
        return data; 
    }
}

export interface ISubmitNewGeneratePrice {
    requestActions: RequestActionDto[];
    generatePriceHeader: NewGeneratePriceDto;
    generatePriceDetail: NewPreviewGeneratePriceDto[];
    isEdit: boolean;
    isCompleted: boolean;
    statusGeneratePrice: string;
    identifierNumber: number;
    remarks: string;
    approvalLog: string[];
}

export class CompleteGeneratePriceRequestActionInput implements ICompleteGeneratePriceRequestActionInput {
    requestActionId: number;
    generatePriceRequestData: GeneratePriceRequestData;

    constructor(data?: ICompleteGeneratePriceRequestActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestActionId = data["requestActionId"];
            this.generatePriceRequestData = data["generatePriceRequestData"] ? GeneratePriceRequestData.fromJS(data["generatePriceRequestData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteGeneratePriceRequestActionInput {
        let result = new CompleteGeneratePriceRequestActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionId"] = this.requestActionId;
        data["generatePriceRequestData"] = this.generatePriceRequestData ? this.generatePriceRequestData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompleteGeneratePriceRequestActionInput {
    requestActionId: number;
    generatePriceRequestData: GeneratePriceRequestData;
}

export class GeneratePriceRequestData implements IGeneratePriceRequestData {
    remarks: string;

    constructor(data?: IGeneratePriceRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GeneratePriceRequestData {
        let result = new GeneratePriceRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGeneratePriceRequestData {
    remarks: string;
}

export class UpdateStatusApproveInput implements IUpdateStatusApproveInput {
    requestActionId: number;
    remarks: string;

    constructor(data?: IUpdateStatusApproveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestActionId = data["requestActionId"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): UpdateStatusApproveInput {
        let result = new UpdateStatusApproveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionId"] = this.requestActionId;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IUpdateStatusApproveInput {
    requestActionId: number;
    remarks: string;
}

export class UniversalProcessGeneratePriceInput implements IUniversalProcessGeneratePriceInput {
    requestId: number;

    constructor(data?: IUniversalProcessGeneratePriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestId = data["requestId"];
        }
    }

    static fromJS(data: any): UniversalProcessGeneratePriceInput {
        let result = new UniversalProcessGeneratePriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data; 
    }
}

export interface IUniversalProcessGeneratePriceInput {
    requestId: number;
}

export class ProcessNewGeneratePriceDto implements IProcessNewGeneratePriceDto {
    generatePriceHeaderID: number;
    workFlowID: number;
    termMainID: number;
    renovID: number;
    unitID: number;
    cost: number;
    margin: number;
    basePrice: number;
    luasUnit: number;
    factoring: number;
    pctTanah: number;
    priceTanah: number;
    pctBangunan: number;
    priceBangunan: number;
    pctRenov: number;
    priceRenov: number;
    totalPrice: number;
    discount: number;
    netPrice: number;
    netNetPrice: number;
    vat: number;
    sellingPrice: number;
    termID: number;
    termPct: number;

    constructor(data?: IProcessNewGeneratePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatePriceHeaderID = data["generatePriceHeaderID"];
            this.workFlowID = data["workFlowID"];
            this.termMainID = data["termMainID"];
            this.renovID = data["renovID"];
            this.unitID = data["unitID"];
            this.cost = data["cost"];
            this.margin = data["margin"];
            this.basePrice = data["basePrice"];
            this.luasUnit = data["luasUnit"];
            this.factoring = data["factoring"];
            this.pctTanah = data["pctTanah"];
            this.priceTanah = data["priceTanah"];
            this.pctBangunan = data["pctBangunan"];
            this.priceBangunan = data["priceBangunan"];
            this.pctRenov = data["pctRenov"];
            this.priceRenov = data["priceRenov"];
            this.totalPrice = data["totalPrice"];
            this.discount = data["discount"];
            this.netPrice = data["netPrice"];
            this.netNetPrice = data["netNetPrice"];
            this.vat = data["vat"];
            this.sellingPrice = data["sellingPrice"];
            this.termID = data["termID"];
            this.termPct = data["termPct"];
        }
    }

    static fromJS(data: any): ProcessNewGeneratePriceDto {
        let result = new ProcessNewGeneratePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatePriceHeaderID"] = this.generatePriceHeaderID;
        data["workFlowID"] = this.workFlowID;
        data["termMainID"] = this.termMainID;
        data["renovID"] = this.renovID;
        data["unitID"] = this.unitID;
        data["cost"] = this.cost;
        data["margin"] = this.margin;
        data["basePrice"] = this.basePrice;
        data["luasUnit"] = this.luasUnit;
        data["factoring"] = this.factoring;
        data["pctTanah"] = this.pctTanah;
        data["priceTanah"] = this.priceTanah;
        data["pctBangunan"] = this.pctBangunan;
        data["priceBangunan"] = this.priceBangunan;
        data["pctRenov"] = this.pctRenov;
        data["priceRenov"] = this.priceRenov;
        data["totalPrice"] = this.totalPrice;
        data["discount"] = this.discount;
        data["netPrice"] = this.netPrice;
        data["netNetPrice"] = this.netNetPrice;
        data["vat"] = this.vat;
        data["sellingPrice"] = this.sellingPrice;
        data["termID"] = this.termID;
        data["termPct"] = this.termPct;
        return data; 
    }
}

export interface IProcessNewGeneratePriceDto {
    generatePriceHeaderID: number;
    workFlowID: number;
    termMainID: number;
    renovID: number;
    unitID: number;
    cost: number;
    margin: number;
    basePrice: number;
    luasUnit: number;
    factoring: number;
    pctTanah: number;
    priceTanah: number;
    pctBangunan: number;
    priceBangunan: number;
    pctRenov: number;
    priceRenov: number;
    totalPrice: number;
    discount: number;
    netPrice: number;
    netNetPrice: number;
    vat: number;
    sellingPrice: number;
    termID: number;
    termPct: number;
}

export class GetDataSSPReport implements IGetDataSSPReport {
    periodeMonthStart: number;
    periodeMonthEnd: number;
    periodeYearStart: number;
    periodeYearEnd: number;
    coCode: string;
    bookcode: string;
    sspDetail: SSPDetail[];

    constructor(data?: IGetDataSSPReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periodeMonthStart = data["periodeMonthStart"];
            this.periodeMonthEnd = data["periodeMonthEnd"];
            this.periodeYearStart = data["periodeYearStart"];
            this.periodeYearEnd = data["periodeYearEnd"];
            this.coCode = data["coCode"];
            this.bookcode = data["bookcode"];
            if (data["sspDetail"] && data["sspDetail"].constructor === Array) {
                this.sspDetail = [];
                for (let item of data["sspDetail"])
                    this.sspDetail.push(SSPDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataSSPReport {
        let result = new GetDataSSPReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodeMonthStart"] = this.periodeMonthStart;
        data["periodeMonthEnd"] = this.periodeMonthEnd;
        data["periodeYearStart"] = this.periodeYearStart;
        data["periodeYearEnd"] = this.periodeYearEnd;
        data["coCode"] = this.coCode;
        data["bookcode"] = this.bookcode;
        if (this.sspDetail && this.sspDetail.constructor === Array) {
            data["sspDetail"] = [];
            for (let item of this.sspDetail)
                data["sspDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataSSPReport {
    periodeMonthStart: number;
    periodeMonthEnd: number;
    periodeYearStart: number;
    periodeYearEnd: number;
    coCode: string;
    bookcode: string;
    sspDetail: SSPDetail[];
}

export class SSPDetail implements ISSPDetail {
    month: number;
    year: number;
    creationTime: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    unitID: number;
    unitCode: string;
    unitName: string;
    unitNo: string;
    areaLand: number;
    areaBuild: number;
    companyCode: string;
    psCode: string;
    customerName: string;
    categoryName: string;
    npwp: string;
    ppjbNo: string;
    ppjbDate: moment.Moment;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    lastCancelDate: moment.Moment;
    netNetPrice: number;
    payType: string;
    payment: number;
    ppn: number;
    pphPaidPeriod: number;
    totalPPhPaid: number;
    cadanganPph: number;
    totalPayment: number;
    sourcePayment: string[];

    constructor(data?: ISSPDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.year = data["year"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.areaLand = data["areaLand"];
            this.areaBuild = data["areaBuild"];
            this.companyCode = data["companyCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.categoryName = data["categoryName"];
            this.npwp = data["npwp"];
            this.ppjbNo = data["ppjbNo"];
            this.ppjbDate = data["ppjbDate"] ? moment(data["ppjbDate"].toString()) : <any>undefined;
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.lastCancelDate = data["lastCancelDate"] ? moment(data["lastCancelDate"].toString()) : <any>undefined;
            this.netNetPrice = data["netNetPrice"];
            this.payType = data["payType"];
            this.payment = data["payment"];
            this.ppn = data["ppn"];
            this.pphPaidPeriod = data["pphPaidPeriod"];
            this.totalPPhPaid = data["totalPPhPaid"];
            this.cadanganPph = data["cadanganPph"];
            this.totalPayment = data["totalPayment"];
            if (data["sourcePayment"] && data["sourcePayment"].constructor === Array) {
                this.sourcePayment = [];
                for (let item of data["sourcePayment"])
                    this.sourcePayment.push(item);
            }
        }
    }

    static fromJS(data: any): SSPDetail {
        let result = new SSPDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["areaLand"] = this.areaLand;
        data["areaBuild"] = this.areaBuild;
        data["companyCode"] = this.companyCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["categoryName"] = this.categoryName;
        data["npwp"] = this.npwp;
        data["ppjbNo"] = this.ppjbNo;
        data["ppjbDate"] = this.ppjbDate ? this.ppjbDate.toISOString() : <any>undefined;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["lastCancelDate"] = this.lastCancelDate ? this.lastCancelDate.toISOString() : <any>undefined;
        data["netNetPrice"] = this.netNetPrice;
        data["payType"] = this.payType;
        data["payment"] = this.payment;
        data["ppn"] = this.ppn;
        data["pphPaidPeriod"] = this.pphPaidPeriod;
        data["totalPPhPaid"] = this.totalPPhPaid;
        data["cadanganPph"] = this.cadanganPph;
        data["totalPayment"] = this.totalPayment;
        if (this.sourcePayment && this.sourcePayment.constructor === Array) {
            data["sourcePayment"] = [];
            for (let item of this.sourcePayment)
                data["sourcePayment"].push(item);
        }
        return data; 
    }
}

export interface ISSPDetail {
    month: number;
    year: number;
    creationTime: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    unitID: number;
    unitCode: string;
    unitName: string;
    unitNo: string;
    areaLand: number;
    areaBuild: number;
    companyCode: string;
    psCode: string;
    customerName: string;
    categoryName: string;
    npwp: string;
    ppjbNo: string;
    ppjbDate: moment.Moment;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    lastCancelDate: moment.Moment;
    netNetPrice: number;
    payType: string;
    payment: number;
    ppn: number;
    pphPaidPeriod: number;
    totalPPhPaid: number;
    cadanganPph: number;
    totalPayment: number;
    sourcePayment: string[];
}

export class GetDetailBookingDto implements IGetDetailBookingDto {
    bookCode: string;
    psCode: string;

    constructor(data?: IGetDetailBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): GetDetailBookingDto {
        let result = new GetDetailBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IGetDetailBookingDto {
    bookCode: string;
    psCode: string;
}

export class GetHistoryDto implements IGetHistoryDto {
    customerName: string;
    bookCode: string;
    unitNo: string;
    unitCode: string;
    psCode: string;
    bookcodeList: string[];
    history: HistoryListDto[];

    constructor(data?: IGetHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.bookCode = data["bookCode"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            if (data["bookcodeList"] && data["bookcodeList"].constructor === Array) {
                this.bookcodeList = [];
                for (let item of data["bookcodeList"])
                    this.bookcodeList.push(item);
            }
            if (data["history"] && data["history"].constructor === Array) {
                this.history = [];
                for (let item of data["history"])
                    this.history.push(HistoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetHistoryDto {
        let result = new GetHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["bookCode"] = this.bookCode;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        if (this.bookcodeList && this.bookcodeList.constructor === Array) {
            data["bookcodeList"] = [];
            for (let item of this.bookcodeList)
                data["bookcodeList"].push(item);
        }
        if (this.history && this.history.constructor === Array) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetHistoryDto {
    customerName: string;
    bookCode: string;
    unitNo: string;
    unitCode: string;
    psCode: string;
    bookcodeList: string[];
    history: HistoryListDto[];
}

export class HistoryListDto implements IHistoryListDto {
    notifHistoryId: number;
    subject: string;
    user: string;
    sentTime: moment.Moment;
    notifType: string;
    creationTime: moment.Moment;
    unitCode: string;
    unitNo: string;
    bookcode: string;

    constructor(data?: IHistoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifHistoryId = data["notifHistoryId"];
            this.subject = data["subject"];
            this.user = data["user"];
            this.sentTime = data["sentTime"] ? moment(data["sentTime"].toString()) : <any>undefined;
            this.notifType = data["notifType"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookcode = data["bookcode"];
        }
    }

    static fromJS(data: any): HistoryListDto {
        let result = new HistoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifHistoryId"] = this.notifHistoryId;
        data["subject"] = this.subject;
        data["user"] = this.user;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : <any>undefined;
        data["notifType"] = this.notifType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookcode"] = this.bookcode;
        return data; 
    }
}

export interface IHistoryListDto {
    notifHistoryId: number;
    subject: string;
    user: string;
    sentTime: moment.Moment;
    notifType: string;
    creationTime: moment.Moment;
    unitCode: string;
    unitNo: string;
    bookcode: string;
}

export class CreateHistoryRemarksInputDto implements ICreateHistoryRemarksInputDto {
    bookCode: string[];
    subject: string;
    contactById: number;
    destinationContact: string;
    remarks: string;
    attachmentFiles: AttachmentFileListDto[];

    constructor(data?: ICreateHistoryRemarksInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["bookCode"] && data["bookCode"].constructor === Array) {
                this.bookCode = [];
                for (let item of data["bookCode"])
                    this.bookCode.push(item);
            }
            this.subject = data["subject"];
            this.contactById = data["contactById"];
            this.destinationContact = data["destinationContact"];
            this.remarks = data["remarks"];
            if (data["attachmentFiles"] && data["attachmentFiles"].constructor === Array) {
                this.attachmentFiles = [];
                for (let item of data["attachmentFiles"])
                    this.attachmentFiles.push(AttachmentFileListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateHistoryRemarksInputDto {
        let result = new CreateHistoryRemarksInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.bookCode && this.bookCode.constructor === Array) {
            data["bookCode"] = [];
            for (let item of this.bookCode)
                data["bookCode"].push(item);
        }
        data["subject"] = this.subject;
        data["contactById"] = this.contactById;
        data["destinationContact"] = this.destinationContact;
        data["remarks"] = this.remarks;
        if (this.attachmentFiles && this.attachmentFiles.constructor === Array) {
            data["attachmentFiles"] = [];
            for (let item of this.attachmentFiles)
                data["attachmentFiles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateHistoryRemarksInputDto {
    bookCode: string[];
    subject: string;
    contactById: number;
    destinationContact: string;
    remarks: string;
    attachmentFiles: AttachmentFileListDto[];
}

export class AttachmentFileListDto implements IAttachmentFileListDto {
    orderNumber: number;
    attachmentFile: string;
    typeFile: string;

    constructor(data?: IAttachmentFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderNumber = data["orderNumber"];
            this.attachmentFile = data["attachmentFile"];
            this.typeFile = data["typeFile"];
        }
    }

    static fromJS(data: any): AttachmentFileListDto {
        let result = new AttachmentFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["attachmentFile"] = this.attachmentFile;
        data["typeFile"] = this.typeFile;
        return data; 
    }
}

export interface IAttachmentFileListDto {
    orderNumber: number;
    attachmentFile: string;
    typeFile: string;
}

export class GetDetailHistoryDto implements IGetDetailHistoryDto {
    notifType: string;
    sentTime: moment.Moment;
    subject: string;
    destinationContact: string;
    message: string;
    attachmentFile: string;
    attachmentFileDetail: LinkPathListDto[];
    notifTypeCode: string;
    code: string;

    constructor(data?: IGetDetailHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifType = data["notifType"];
            this.sentTime = data["sentTime"] ? moment(data["sentTime"].toString()) : <any>undefined;
            this.subject = data["subject"];
            this.destinationContact = data["destinationContact"];
            this.message = data["message"];
            this.attachmentFile = data["attachmentFile"];
            if (data["attachmentFileDetail"] && data["attachmentFileDetail"].constructor === Array) {
                this.attachmentFileDetail = [];
                for (let item of data["attachmentFileDetail"])
                    this.attachmentFileDetail.push(LinkPathListDto.fromJS(item));
            }
            this.notifTypeCode = data["notifTypeCode"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): GetDetailHistoryDto {
        let result = new GetDetailHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifType"] = this.notifType;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["destinationContact"] = this.destinationContact;
        data["message"] = this.message;
        data["attachmentFile"] = this.attachmentFile;
        if (this.attachmentFileDetail && this.attachmentFileDetail.constructor === Array) {
            data["attachmentFileDetail"] = [];
            for (let item of this.attachmentFileDetail)
                data["attachmentFileDetail"].push(item.toJSON());
        }
        data["notifTypeCode"] = this.notifTypeCode;
        data["code"] = this.code;
        return data; 
    }
}

export interface IGetDetailHistoryDto {
    notifType: string;
    sentTime: moment.Moment;
    subject: string;
    destinationContact: string;
    message: string;
    attachmentFile: string;
    attachmentFileDetail: LinkPathListDto[];
    notifTypeCode: string;
    code: string;
}

export class GetDropdownContactByDto implements IGetDropdownContactByDto {
    contactTypeId: number;
    contactType: string;

    constructor(data?: IGetDropdownContactByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactTypeId = data["contactTypeId"];
            this.contactType = data["contactType"];
        }
    }

    static fromJS(data: any): GetDropdownContactByDto {
        let result = new GetDropdownContactByDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactTypeId"] = this.contactTypeId;
        data["contactType"] = this.contactType;
        return data; 
    }
}

export interface IGetDropdownContactByDto {
    contactTypeId: number;
    contactType: string;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (let item of data["expiringTenants"])
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (let item of data["recentTenants"])
                    this.recentTenants.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;
}

export class IncomeStastistic implements IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;
}

export class TenantEdition implements ITenantEdition {
    label: string;
    value: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string;
    value: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;
}

export class RecentTenant implements IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto = new GeneralSettingsEditDto();
    userManagement: HostUserManagementSettingsEditDto = new HostUserManagementSettingsEditDto();
    email: EmailSettingsEditDto = new EmailSettingsEditDto();
    tenantManagement: TenantManagementSettingsEditDto = new TenantManagementSettingsEditDto();
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: HostBillingSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string;
    address: string;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string;
    address: string;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class ListResultDtoOfGetAllIDTypeListDto implements IListResultDtoOfGetAllIDTypeListDto {
    items: GetAllIDTypeListDto[];

    constructor(data?: IListResultDtoOfGetAllIDTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllIDTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllIDTypeListDto {
        let result = new ListResultDtoOfGetAllIDTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllIDTypeListDto {
    items: GetAllIDTypeListDto[];
}

export class GetAllIDTypeListDto implements IGetAllIDTypeListDto {
    idType: string;
    idTypeName: string;

    constructor(data?: IGetAllIDTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.idType = data["idType"];
            this.idTypeName = data["idTypeName"];
        }
    }

    static fromJS(data: any): GetAllIDTypeListDto {
        let result = new GetAllIDTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idType"] = this.idType;
        data["idTypeName"] = this.idTypeName;
        return data; 
    }
}

export interface IGetAllIDTypeListDto {
    idType: string;
    idTypeName: string;
}

export class CreateUniversalInputInventoryDto implements ICreateUniversalInputInventoryDto {
    inventoryHeader: CreateTrInventoryHeaderInputDto;
    dataInventoryDetail: CreateTrInventoryDetailInputDto[];

    constructor(data?: ICreateUniversalInputInventoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventoryHeader = data["inventoryHeader"] ? CreateTrInventoryHeaderInputDto.fromJS(data["inventoryHeader"]) : <any>undefined;
            if (data["dataInventoryDetail"] && data["dataInventoryDetail"].constructor === Array) {
                this.dataInventoryDetail = [];
                for (let item of data["dataInventoryDetail"])
                    this.dataInventoryDetail.push(CreateTrInventoryDetailInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalInputInventoryDto {
        let result = new CreateUniversalInputInventoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryHeader"] = this.inventoryHeader ? this.inventoryHeader.toJSON() : <any>undefined;
        if (this.dataInventoryDetail && this.dataInventoryDetail.constructor === Array) {
            data["dataInventoryDetail"] = [];
            for (let item of this.dataInventoryDetail)
                data["dataInventoryDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalInputInventoryDto {
    inventoryHeader: CreateTrInventoryHeaderInputDto;
    dataInventoryDetail: CreateTrInventoryDetailInputDto[];
}

export class CreateTrInventoryHeaderInputDto implements ICreateTrInventoryHeaderInputDto {
    entityID: number;
    accID: number;
    bookingHeaderID: number;
    bookCode: string;
    transNo: string;
    ket: string;
    ttbgDate: moment.Moment;

    constructor(data?: ICreateTrInventoryHeaderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.accID = data["accID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.transNo = data["transNo"];
            this.ket = data["ket"];
            this.ttbgDate = data["ttbgDate"] ? moment(data["ttbgDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTrInventoryHeaderInputDto {
        let result = new CreateTrInventoryHeaderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["accID"] = this.accID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["transNo"] = this.transNo;
        data["ket"] = this.ket;
        data["ttbgDate"] = this.ttbgDate ? this.ttbgDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreateTrInventoryHeaderInputDto {
    entityID: number;
    accID: number;
    bookingHeaderID: number;
    bookCode: string;
    transNo: string;
    ket: string;
    ttbgDate: moment.Moment;
}

export class CreateTrInventoryDetailInputDto implements ICreateTrInventoryDetailInputDto {
    entityID: number;
    inventoryHeaderID: number;
    payNo: number;
    payForID: number;
    payTypeID: number;
    bankID: number;
    statusID: number;
    chequeNo: string;
    ket: string;
    dueDate: moment.Moment;
    clearDate: moment.Moment;
    transNoPayment: string;
    amount: number;
    bankName: string;
    statusCode: string;
    statusDesc: string;
    payTypeCode: string;
    payTypeDesc: string;

    constructor(data?: ICreateTrInventoryDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.inventoryHeaderID = data["inventoryHeaderID"];
            this.payNo = data["payNo"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.bankID = data["bankID"];
            this.statusID = data["statusID"];
            this.chequeNo = data["chequeNo"];
            this.ket = data["ket"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.transNoPayment = data["transNoPayment"];
            this.amount = data["amount"];
            this.bankName = data["bankName"];
            this.statusCode = data["statusCode"];
            this.statusDesc = data["statusDesc"];
            this.payTypeCode = data["payTypeCode"];
            this.payTypeDesc = data["payTypeDesc"];
        }
    }

    static fromJS(data: any): CreateTrInventoryDetailInputDto {
        let result = new CreateTrInventoryDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["inventoryHeaderID"] = this.inventoryHeaderID;
        data["payNo"] = this.payNo;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["bankID"] = this.bankID;
        data["statusID"] = this.statusID;
        data["chequeNo"] = this.chequeNo;
        data["ket"] = this.ket;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["transNoPayment"] = this.transNoPayment;
        data["amount"] = this.amount;
        data["bankName"] = this.bankName;
        data["statusCode"] = this.statusCode;
        data["statusDesc"] = this.statusDesc;
        data["payTypeCode"] = this.payTypeCode;
        data["payTypeDesc"] = this.payTypeDesc;
        return data; 
    }
}

export interface ICreateTrInventoryDetailInputDto {
    entityID: number;
    inventoryHeaderID: number;
    payNo: number;
    payForID: number;
    payTypeID: number;
    bankID: number;
    statusID: number;
    chequeNo: string;
    ket: string;
    dueDate: moment.Moment;
    clearDate: moment.Moment;
    transNoPayment: string;
    amount: number;
    bankName: string;
    statusCode: string;
    statusDesc: string;
    payTypeCode: string;
    payTypeDesc: string;
}

export class GetDataTransNoListDto implements IGetDataTransNoListDto {
    paymentHeaderID: number;
    accountID: number;
    transNo: string;
    payForID: number;
    payFor: string;
    payDate: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    unitID: number;
    unitCodeID: number;
    unitNo: string;
    unitCode: string;
    clientName: string;
    amount: number;
    remarks: string;
    psCode: string;
    clearDate: moment.Moment;
    fpNo: string;

    constructor(data?: IGetDataTransNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentHeaderID = data["paymentHeaderID"];
            this.accountID = data["accountID"];
            this.transNo = data["transNo"];
            this.payForID = data["payForID"];
            this.payFor = data["payFor"];
            this.payDate = data["payDate"] ? moment(data["payDate"].toString()) : <any>undefined;
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.unitID = data["unitID"];
            this.unitCodeID = data["unitCodeID"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.clientName = data["clientName"];
            this.amount = data["amount"];
            this.remarks = data["remarks"];
            this.psCode = data["psCode"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.fpNo = data["fpNo"];
        }
    }

    static fromJS(data: any): GetDataTransNoListDto {
        let result = new GetDataTransNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["accountID"] = this.accountID;
        data["transNo"] = this.transNo;
        data["payForID"] = this.payForID;
        data["payFor"] = this.payFor;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["unitID"] = this.unitID;
        data["unitCodeID"] = this.unitCodeID;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["clientName"] = this.clientName;
        data["amount"] = this.amount;
        data["remarks"] = this.remarks;
        data["psCode"] = this.psCode;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["fpNo"] = this.fpNo;
        return data; 
    }
}

export interface IGetDataTransNoListDto {
    paymentHeaderID: number;
    accountID: number;
    transNo: string;
    payForID: number;
    payFor: string;
    payDate: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    unitID: number;
    unitCodeID: number;
    unitNo: string;
    unitCode: string;
    clientName: string;
    amount: number;
    remarks: string;
    psCode: string;
    clearDate: moment.Moment;
    fpNo: string;
}

export class GenerateTransNoInputDto implements IGenerateTransNoInputDto {
    accID: number;
    entityID: number;

    constructor(data?: IGenerateTransNoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.entityID = data["entityID"];
        }
    }

    static fromJS(data: any): GenerateTransNoInputDto {
        let result = new GenerateTransNoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["entityID"] = this.entityID;
        return data; 
    }
}

export interface IGenerateTransNoInputDto {
    accID: number;
    entityID: number;
}

export class GetDropdownLkStatusListDto implements IGetDropdownLkStatusListDto {
    id: number;
    statusCode: string;
    statusName: string;

    constructor(data?: IGetDropdownLkStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.statusCode = data["statusCode"];
            this.statusName = data["statusName"];
        }
    }

    static fromJS(data: any): GetDropdownLkStatusListDto {
        let result = new GetDropdownLkStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        return data; 
    }
}

export interface IGetDropdownLkStatusListDto {
    id: number;
    statusCode: string;
    statusName: string;
}

export class GetDataInventoryInputPaymentListDto implements IGetDataInventoryInputPaymentListDto {
    inventoryHeaderID: number;
    transNo: string;
    tanggalTransNo: moment.Moment;
    dataInventory: GetInventory[];

    constructor(data?: IGetDataInventoryInputPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventoryHeaderID = data["inventoryHeaderID"];
            this.transNo = data["transNo"];
            this.tanggalTransNo = data["tanggalTransNo"] ? moment(data["tanggalTransNo"].toString()) : <any>undefined;
            if (data["dataInventory"] && data["dataInventory"].constructor === Array) {
                this.dataInventory = [];
                for (let item of data["dataInventory"])
                    this.dataInventory.push(GetInventory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataInventoryInputPaymentListDto {
        let result = new GetDataInventoryInputPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryHeaderID"] = this.inventoryHeaderID;
        data["transNo"] = this.transNo;
        data["tanggalTransNo"] = this.tanggalTransNo ? this.tanggalTransNo.toISOString() : <any>undefined;
        if (this.dataInventory && this.dataInventory.constructor === Array) {
            data["dataInventory"] = [];
            for (let item of this.dataInventory)
                data["dataInventory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataInventoryInputPaymentListDto {
    inventoryHeaderID: number;
    transNo: string;
    tanggalTransNo: moment.Moment;
    dataInventory: GetInventory[];
}

export class GetInventory implements IGetInventory {
    payNo: number;
    payTypeID: number;
    payTypeCode: string;
    payTypeName: string;
    bankID: number;
    bankCode: string;
    bankName: string;
    chequeNo: string;
    amount: number;
    keterangan: string;
    dueDate: moment.Moment;

    constructor(data?: IGetInventory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payNo = data["payNo"];
            this.payTypeID = data["payTypeID"];
            this.payTypeCode = data["payTypeCode"];
            this.payTypeName = data["payTypeName"];
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.chequeNo = data["chequeNo"];
            this.amount = data["amount"];
            this.keterangan = data["keterangan"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInventory {
        let result = new GetInventory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payNo"] = this.payNo;
        data["payTypeID"] = this.payTypeID;
        data["payTypeCode"] = this.payTypeCode;
        data["payTypeName"] = this.payTypeName;
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["amount"] = this.amount;
        data["keterangan"] = this.keterangan;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetInventory {
    payNo: number;
    payTypeID: number;
    payTypeCode: string;
    payTypeName: string;
    bankID: number;
    bankCode: string;
    bankName: string;
    chequeNo: string;
    amount: number;
    keterangan: string;
    dueDate: moment.Moment;
}

export class UpdateTrInventoryDetailInputDto implements IUpdateTrInventoryDetailInputDto {
    inventoryHeaderID: number;
    payNoInventory: number;
    clearDate: moment.Moment;
    status: string;
    transNo: string;

    constructor(data?: IUpdateTrInventoryDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventoryHeaderID = data["inventoryHeaderID"];
            this.payNoInventory = data["payNoInventory"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.transNo = data["transNo"];
        }
    }

    static fromJS(data: any): UpdateTrInventoryDetailInputDto {
        let result = new UpdateTrInventoryDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryHeaderID"] = this.inventoryHeaderID;
        data["payNoInventory"] = this.payNoInventory;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["transNo"] = this.transNo;
        return data; 
    }
}

export interface IUpdateTrInventoryDetailInputDto {
    inventoryHeaderID: number;
    payNoInventory: number;
    clearDate: moment.Moment;
    status: string;
    transNo: string;
}

export class GetDataPersonalsListDto implements IGetDataPersonalsListDto {
    psCode: string;
    name: string;
    birthDate: moment.Moment;
    age: number;
    phoneNo: string[];

    constructor(data?: IGetDataPersonalsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.age = data["age"];
            if (data["phoneNo"] && data["phoneNo"].constructor === Array) {
                this.phoneNo = [];
                for (let item of data["phoneNo"])
                    this.phoneNo.push(item);
            }
        }
    }

    static fromJS(data: any): GetDataPersonalsListDto {
        let result = new GetDataPersonalsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        if (this.phoneNo && this.phoneNo.constructor === Array) {
            data["phoneNo"] = [];
            for (let item of this.phoneNo)
                data["phoneNo"].push(item);
        }
        return data; 
    }
}

export interface IGetDataPersonalsListDto {
    psCode: string;
    name: string;
    birthDate: moment.Moment;
    age: number;
    phoneNo: string[];
}

export class GetDataBookCodeListDto implements IGetDataBookCodeListDto {
    bookingHeaderID: number;
    projectID: number;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    pctTax: number;

    constructor(data?: IGetDataBookCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.projectID = data["projectID"];
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.pctTax = data["pctTax"];
        }
    }

    static fromJS(data: any): GetDataBookCodeListDto {
        let result = new GetDataBookCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["projectID"] = this.projectID;
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["pctTax"] = this.pctTax;
        return data; 
    }
}

export interface IGetDataBookCodeListDto {
    bookingHeaderID: number;
    projectID: number;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    pctTax: number;
}

export class GetListPSASViewResultDto implements IGetListPSASViewResultDto {
    bookingHeaderID: number;
    projectID: number;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    pctTax: number;
    unitOrderHeaderID: number;
    unitID: number;
    memberCode: string;
    custName: string;
    psCode: string;
    orderCode: string;

    constructor(data?: IGetListPSASViewResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.projectID = data["projectID"];
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.pctTax = data["pctTax"];
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.unitID = data["unitID"];
            this.memberCode = data["memberCode"];
            this.custName = data["custName"];
            this.psCode = data["psCode"];
            this.orderCode = data["orderCode"];
        }
    }

    static fromJS(data: any): GetListPSASViewResultDto {
        let result = new GetListPSASViewResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["projectID"] = this.projectID;
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["pctTax"] = this.pctTax;
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["unitID"] = this.unitID;
        data["memberCode"] = this.memberCode;
        data["custName"] = this.custName;
        data["psCode"] = this.psCode;
        data["orderCode"] = this.orderCode;
        return data; 
    }
}

export interface IGetListPSASViewResultDto {
    bookingHeaderID: number;
    projectID: number;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    pctTax: number;
    unitOrderHeaderID: number;
    unitID: number;
    memberCode: string;
    custName: string;
    psCode: string;
    orderCode: string;
}

export class GetDropdownUnitNoListDto implements IGetDropdownUnitNoListDto {
    unitID: number;
    unitNo: string;

    constructor(data?: IGetDropdownUnitNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetDropdownUnitNoListDto {
        let result = new GetDropdownUnitNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetDropdownUnitNoListDto {
    unitID: number;
    unitNo: string;
}

export class GetDropdownUnitCodeListDto implements IGetDropdownUnitCodeListDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;

    constructor(data?: IGetDropdownUnitCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeID = data["unitCodeID"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
        }
    }

    static fromJS(data: any): GetDropdownUnitCodeListDto {
        let result = new GetDropdownUnitCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeID"] = this.unitCodeID;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        return data; 
    }
}

export interface IGetDropdownUnitCodeListDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;
}

export class GetDataClientInfoListDto implements IGetDataClientInfoListDto {
    psCode: string;
    name: string;
    address: string;
    npwp: string;
    email: string;
    listPhone: GetPhone[];

    constructor(data?: IGetDataClientInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.address = data["address"];
            this.npwp = data["npwp"];
            this.email = data["email"];
            if (data["listPhone"] && data["listPhone"].constructor === Array) {
                this.listPhone = [];
                for (let item of data["listPhone"])
                    this.listPhone.push(GetPhone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataClientInfoListDto {
        let result = new GetDataClientInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["address"] = this.address;
        data["npwp"] = this.npwp;
        data["email"] = this.email;
        if (this.listPhone && this.listPhone.constructor === Array) {
            data["listPhone"] = [];
            for (let item of this.listPhone)
                data["listPhone"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataClientInfoListDto {
    psCode: string;
    name: string;
    address: string;
    npwp: string;
    email: string;
    listPhone: GetPhone[];
}

export class GetPhone implements IGetPhone {
    phone: string;

    constructor(data?: IGetPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): GetPhone {
        let result = new GetPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data; 
    }
}

export interface IGetPhone {
    phone: string;
}

export class GetDataUnitInfoListDto implements IGetDataUnitInfoListDto {
    project: string;
    category: string;
    unitCode: string;
    unitNo: string;
    termRemarks: string;
    categoryField: string;

    constructor(data?: IGetDataUnitInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.project = data["project"];
            this.category = data["category"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.termRemarks = data["termRemarks"];
            this.categoryField = data["categoryField"];
        }
    }

    static fromJS(data: any): GetDataUnitInfoListDto {
        let result = new GetDataUnitInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project;
        data["category"] = this.category;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["termRemarks"] = this.termRemarks;
        data["categoryField"] = this.categoryField;
        return data; 
    }
}

export interface IGetDataUnitInfoListDto {
    project: string;
    category: string;
    unitCode: string;
    unitNo: string;
    termRemarks: string;
    categoryField: string;
}

export class GetDataSchedulePaymentListDto implements IGetDataSchedulePaymentListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    netAmt: number;
    vatAmt: number;
    netOutstanding: number;
    vatOutstanding: number;
    totalOutstanding: number;
    schedNo: number;
    pctTax: number;

    constructor(data?: IGetDataSchedulePaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.netAmt = data["netAmt"];
            this.vatAmt = data["vatAmt"];
            this.netOutstanding = data["netOutstanding"];
            this.vatOutstanding = data["vatOutstanding"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
            this.pctTax = data["pctTax"];
        }
    }

    static fromJS(data: any): GetDataSchedulePaymentListDto {
        let result = new GetDataSchedulePaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["netAmt"] = this.netAmt;
        data["vatAmt"] = this.vatAmt;
        data["netOutstanding"] = this.netOutstanding;
        data["vatOutstanding"] = this.vatOutstanding;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        data["pctTax"] = this.pctTax;
        return data; 
    }
}

export interface IGetDataSchedulePaymentListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    netAmt: number;
    vatAmt: number;
    netOutstanding: number;
    vatOutstanding: number;
    totalOutstanding: number;
    schedNo: number;
    pctTax: number;
}

export class GetDataSchedulePaymentAjbListDto implements IGetDataSchedulePaymentAjbListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    remarks: string;
    amount: number;
    totalPayment: number;
    totalOutstanding: number;
    schedNo: number;

    constructor(data?: IGetDataSchedulePaymentAjbListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.remarks = data["remarks"];
            this.amount = data["amount"];
            this.totalPayment = data["totalPayment"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
        }
    }

    static fromJS(data: any): GetDataSchedulePaymentAjbListDto {
        let result = new GetDataSchedulePaymentAjbListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["remarks"] = this.remarks;
        data["amount"] = this.amount;
        data["totalPayment"] = this.totalPayment;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        return data; 
    }
}

export interface IGetDataSchedulePaymentAjbListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    remarks: string;
    amount: number;
    totalPayment: number;
    totalOutstanding: number;
    schedNo: number;
}

export class CreatePaymentDetailInputDto implements ICreatePaymentDetailInputDto {
    entityID: number;
    bankName: string;
    chequeNo: string;
    dueDate: moment.Moment;
    ket: string;
    othersTypeCode: string;
    payNo: number;
    payTypeID: number;
    paymentHeaderID: number;
    status: string;

    constructor(data?: ICreatePaymentDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.bankName = data["bankName"];
            this.chequeNo = data["chequeNo"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.ket = data["ket"];
            this.othersTypeCode = data["othersTypeCode"];
            this.payNo = data["payNo"];
            this.payTypeID = data["payTypeID"];
            this.paymentHeaderID = data["paymentHeaderID"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CreatePaymentDetailInputDto {
        let result = new CreatePaymentDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["ket"] = this.ket;
        data["othersTypeCode"] = this.othersTypeCode;
        data["payNo"] = this.payNo;
        data["payTypeID"] = this.payTypeID;
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreatePaymentDetailInputDto {
    entityID: number;
    bankName: string;
    chequeNo: string;
    dueDate: moment.Moment;
    ket: string;
    othersTypeCode: string;
    payNo: number;
    payTypeID: number;
    paymentHeaderID: number;
    status: string;
}

export class CreatePaymentDetailInputAjbDto implements ICreatePaymentDetailInputAjbDto {
    entityID: number;
    bankName: string;
    dueDate: moment.Moment;
    ket: string;
    payTypeID: number;
    paymentHeaderID: number;
    schedNo: number;
    totalPayment: number;

    constructor(data?: ICreatePaymentDetailInputAjbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.bankName = data["bankName"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.ket = data["ket"];
            this.payTypeID = data["payTypeID"];
            this.paymentHeaderID = data["paymentHeaderID"];
            this.schedNo = data["schedNo"];
            this.totalPayment = data["totalPayment"];
        }
    }

    static fromJS(data: any): CreatePaymentDetailInputAjbDto {
        let result = new CreatePaymentDetailInputAjbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["bankName"] = this.bankName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["ket"] = this.ket;
        data["payTypeID"] = this.payTypeID;
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["schedNo"] = this.schedNo;
        data["totalPayment"] = this.totalPayment;
        return data; 
    }
}

export interface ICreatePaymentDetailInputAjbDto {
    entityID: number;
    bankName: string;
    dueDate: moment.Moment;
    ket: string;
    payTypeID: number;
    paymentHeaderID: number;
    schedNo: number;
    totalPayment: number;
}

export class CreatePaymentDetailAllocInputDto implements ICreatePaymentDetailAllocInputDto {
    entityID: number;
    netAmt: number;
    paymentDetailID: number;
    schedNo: number;
    vatAmt: number;

    constructor(data?: ICreatePaymentDetailAllocInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.netAmt = data["netAmt"];
            this.paymentDetailID = data["paymentDetailID"];
            this.schedNo = data["schedNo"];
            this.vatAmt = data["vatAmt"];
        }
    }

    static fromJS(data: any): CreatePaymentDetailAllocInputDto {
        let result = new CreatePaymentDetailAllocInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["netAmt"] = this.netAmt;
        data["paymentDetailID"] = this.paymentDetailID;
        data["schedNo"] = this.schedNo;
        data["vatAmt"] = this.vatAmt;
        return data; 
    }
}

export interface ICreatePaymentDetailAllocInputDto {
    entityID: number;
    netAmt: number;
    paymentDetailID: number;
    schedNo: number;
    vatAmt: number;
}

export class GetDropdownAllocationLkItemListDto implements IGetDropdownAllocationLkItemListDto {
    itemID: number;
    itemCode: string;

    constructor(data?: IGetDropdownAllocationLkItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemID = data["itemID"];
            this.itemCode = data["itemCode"];
        }
    }

    static fromJS(data: any): GetDropdownAllocationLkItemListDto {
        let result = new GetDropdownAllocationLkItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["itemCode"] = this.itemCode;
        return data; 
    }
}

export interface IGetDropdownAllocationLkItemListDto {
    itemID: number;
    itemCode: string;
}

export class CreatePaymentHeaderInputDto implements ICreatePaymentHeaderInputDto {
    entityID: number;
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    apvTime: moment.Moment;
    apvUn: string;
    clearDate: moment.Moment;
    combineCode: string;
    controlNo: string;
    hadMail: boolean;
    isSms: boolean;
    isFP: string;
    ket: string;
    ppNo: string;
    mailTime: moment.Moment;
    paymentDate: moment.Moment;
    transNo: string;
    amount: number;
    smsSentTime: moment.Moment;

    constructor(data?: ICreatePaymentHeaderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.apvTime = data["apvTime"] ? moment(data["apvTime"].toString()) : <any>undefined;
            this.apvUn = data["apvUn"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.combineCode = data["combineCode"];
            this.controlNo = data["controlNo"];
            this.hadMail = data["hadMail"];
            this.isSms = data["isSms"];
            this.isFP = data["isFP"];
            this.ket = data["ket"];
            this.ppNo = data["ppNo"];
            this.mailTime = data["mailTime"] ? moment(data["mailTime"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.amount = data["amount"];
            this.smsSentTime = data["smsSentTime"] ? moment(data["smsSentTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePaymentHeaderInputDto {
        let result = new CreatePaymentHeaderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["apvTime"] = this.apvTime ? this.apvTime.toISOString() : <any>undefined;
        data["apvUn"] = this.apvUn;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["combineCode"] = this.combineCode;
        data["controlNo"] = this.controlNo;
        data["hadMail"] = this.hadMail;
        data["isSms"] = this.isSms;
        data["isFP"] = this.isFP;
        data["ket"] = this.ket;
        data["ppNo"] = this.ppNo;
        data["mailTime"] = this.mailTime ? this.mailTime.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["amount"] = this.amount;
        data["smsSentTime"] = this.smsSentTime ? this.smsSentTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreatePaymentHeaderInputDto {
    entityID: number;
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    apvTime: moment.Moment;
    apvUn: string;
    clearDate: moment.Moment;
    combineCode: string;
    controlNo: string;
    hadMail: boolean;
    isSms: boolean;
    isFP: string;
    ket: string;
    ppNo: string;
    mailTime: moment.Moment;
    paymentDate: moment.Moment;
    transNo: string;
    amount: number;
    smsSentTime: moment.Moment;
}

export class CreatePaymentHeaderInputAjbDto implements ICreatePaymentHeaderInputAjbDto {
    entityID: number;
    accountID: number;
    bookingHeaderID: number;
    clearDate: moment.Moment;
    ket: string;
    paymentDate: moment.Moment;
    transNo: string;
    payForID: number;

    constructor(data?: ICreatePaymentHeaderInputAjbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.ket = data["ket"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payForID = data["payForID"];
        }
    }

    static fromJS(data: any): CreatePaymentHeaderInputAjbDto {
        let result = new CreatePaymentHeaderInputAjbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["ket"] = this.ket;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payForID"] = this.payForID;
        return data; 
    }
}

export interface ICreatePaymentHeaderInputAjbDto {
    entityID: number;
    accountID: number;
    bookingHeaderID: number;
    clearDate: moment.Moment;
    ket: string;
    paymentDate: moment.Moment;
    transNo: string;
    payForID: number;
}

export class CreateInputPaymentUniversalInputDto implements ICreateInputPaymentUniversalInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    clearDate: moment.Moment;
    description: string;
    paymentDate: moment.Moment;
    transNo: string;
    ppNo: string;
    pctTax: number;
    unitCode: string;
    unitNo: string;
    address: string;
    name: string;
    psCode: string;
    npwp: string;
    isSaveChanges: boolean;
    flag: boolean;
    flagOVT: boolean;
    journalCode: string;
    dataSchedule: CreatePaymentSchedule[];
    dataPaymentDetail: CreatePaymentDetail[];
    dataInventory: GetDataInventory[];

    constructor(data?: ICreateInputPaymentUniversalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.ppNo = data["ppNo"];
            this.pctTax = data["pctTax"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.address = data["address"];
            this.name = data["name"];
            this.psCode = data["psCode"];
            this.npwp = data["npwp"];
            this.isSaveChanges = data["isSaveChanges"];
            this.flag = data["flag"];
            this.flagOVT = data["flagOVT"];
            this.journalCode = data["journalCode"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(CreatePaymentSchedule.fromJS(item));
            }
            if (data["dataPaymentDetail"] && data["dataPaymentDetail"].constructor === Array) {
                this.dataPaymentDetail = [];
                for (let item of data["dataPaymentDetail"])
                    this.dataPaymentDetail.push(CreatePaymentDetail.fromJS(item));
            }
            if (data["dataInventory"] && data["dataInventory"].constructor === Array) {
                this.dataInventory = [];
                for (let item of data["dataInventory"])
                    this.dataInventory.push(GetDataInventory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInputPaymentUniversalInputDto {
        let result = new CreateInputPaymentUniversalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["ppNo"] = this.ppNo;
        data["pctTax"] = this.pctTax;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["address"] = this.address;
        data["name"] = this.name;
        data["psCode"] = this.psCode;
        data["npwp"] = this.npwp;
        data["isSaveChanges"] = this.isSaveChanges;
        data["flag"] = this.flag;
        data["flagOVT"] = this.flagOVT;
        data["journalCode"] = this.journalCode;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        if (this.dataPaymentDetail && this.dataPaymentDetail.constructor === Array) {
            data["dataPaymentDetail"] = [];
            for (let item of this.dataPaymentDetail)
                data["dataPaymentDetail"].push(item.toJSON());
        }
        if (this.dataInventory && this.dataInventory.constructor === Array) {
            data["dataInventory"] = [];
            for (let item of this.dataInventory)
                data["dataInventory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateInputPaymentUniversalInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
    clearDate: moment.Moment;
    description: string;
    paymentDate: moment.Moment;
    transNo: string;
    ppNo: string;
    pctTax: number;
    unitCode: string;
    unitNo: string;
    address: string;
    name: string;
    psCode: string;
    npwp: string;
    isSaveChanges: boolean;
    flag: boolean;
    flagOVT: boolean;
    journalCode: string;
    dataSchedule: CreatePaymentSchedule[];
    dataPaymentDetail: CreatePaymentDetail[];
    dataInventory: GetDataInventory[];
}

export class CreatePaymentSchedule implements ICreatePaymentSchedule {
    netAmtSchedule: number;
    vatAmtSchedule: number;
    netOutSchedule: number;
    vatOutSchedule: number;
    schedNoSchedule: number;

    constructor(data?: ICreatePaymentSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.netAmtSchedule = data["netAmtSchedule"];
            this.vatAmtSchedule = data["vatAmtSchedule"];
            this.netOutSchedule = data["netOutSchedule"];
            this.vatOutSchedule = data["vatOutSchedule"];
            this.schedNoSchedule = data["schedNoSchedule"];
        }
    }

    static fromJS(data: any): CreatePaymentSchedule {
        let result = new CreatePaymentSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netAmtSchedule"] = this.netAmtSchedule;
        data["vatAmtSchedule"] = this.vatAmtSchedule;
        data["netOutSchedule"] = this.netOutSchedule;
        data["vatOutSchedule"] = this.vatOutSchedule;
        data["schedNoSchedule"] = this.schedNoSchedule;
        return data; 
    }
}

export interface ICreatePaymentSchedule {
    netAmtSchedule: number;
    vatAmtSchedule: number;
    netOutSchedule: number;
    vatOutSchedule: number;
    schedNoSchedule: number;
}

export class CreatePaymentDetail implements ICreatePaymentDetail {
    chequeNo: string;
    payNo: number;
    othersTypeCode: string;
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalAmountDetail: number;
    amountOver: number;
    orToAdjust: string;
    transNoIsAdj: string;
    dataAlloc: CreatePaymentAlloc[];

    constructor(data?: ICreatePaymentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chequeNo = data["chequeNo"];
            this.payNo = data["payNo"];
            this.othersTypeCode = data["othersTypeCode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.payTypeID = data["payTypeID"];
            this.bankName = data["bankName"];
            this.ket = data["ket"];
            this.totalAmountDetail = data["totalAmountDetail"];
            this.amountOver = data["amountOver"];
            this.orToAdjust = data["orToAdjust"];
            this.transNoIsAdj = data["transNoIsAdj"];
            if (data["dataAlloc"] && data["dataAlloc"].constructor === Array) {
                this.dataAlloc = [];
                for (let item of data["dataAlloc"])
                    this.dataAlloc.push(CreatePaymentAlloc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePaymentDetail {
        let result = new CreatePaymentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chequeNo"] = this.chequeNo;
        data["payNo"] = this.payNo;
        data["othersTypeCode"] = this.othersTypeCode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["payTypeID"] = this.payTypeID;
        data["bankName"] = this.bankName;
        data["ket"] = this.ket;
        data["totalAmountDetail"] = this.totalAmountDetail;
        data["amountOver"] = this.amountOver;
        data["orToAdjust"] = this.orToAdjust;
        data["transNoIsAdj"] = this.transNoIsAdj;
        if (this.dataAlloc && this.dataAlloc.constructor === Array) {
            data["dataAlloc"] = [];
            for (let item of this.dataAlloc)
                data["dataAlloc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePaymentDetail {
    chequeNo: string;
    payNo: number;
    othersTypeCode: string;
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalAmountDetail: number;
    amountOver: number;
    orToAdjust: string;
    transNoIsAdj: string;
    dataAlloc: CreatePaymentAlloc[];
}

export class GetDataInventory implements IGetDataInventory {
    inventoryHeaderID: number;
    payNoInventory: number;

    constructor(data?: IGetDataInventory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventoryHeaderID = data["inventoryHeaderID"];
            this.payNoInventory = data["payNoInventory"];
        }
    }

    static fromJS(data: any): GetDataInventory {
        let result = new GetDataInventory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryHeaderID"] = this.inventoryHeaderID;
        data["payNoInventory"] = this.payNoInventory;
        return data; 
    }
}

export interface IGetDataInventory {
    inventoryHeaderID: number;
    payNoInventory: number;
}

export class CreatePaymentAlloc implements ICreatePaymentAlloc {
    netAmt: number;
    vatAmt: number;
    netOut: number;
    vatOut: number;
    schedNo: number;

    constructor(data?: ICreatePaymentAlloc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.netAmt = data["netAmt"];
            this.vatAmt = data["vatAmt"];
            this.netOut = data["netOut"];
            this.vatOut = data["vatOut"];
            this.schedNo = data["schedNo"];
        }
    }

    static fromJS(data: any): CreatePaymentAlloc {
        let result = new CreatePaymentAlloc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netAmt"] = this.netAmt;
        data["vatAmt"] = this.vatAmt;
        data["netOut"] = this.netOut;
        data["vatOut"] = this.vatOut;
        data["schedNo"] = this.schedNo;
        return data; 
    }
}

export interface ICreatePaymentAlloc {
    netAmt: number;
    vatAmt: number;
    netOut: number;
    vatOut: number;
    schedNo: number;
}

export class CreateInputPaymentAjbInputDto implements ICreateInputPaymentAjbInputDto {
    accountID: number;
    bookingHeaderID: number;
    clearDate: moment.Moment;
    ket: string;
    paymentDate: moment.Moment;
    transNo: string;
    payForID: number;
    dataSchedule: CreatePaymentScheduleAjb[];
    dataPaymentDetail: CreatePaymentDetailAjb[];

    constructor(data?: ICreateInputPaymentAjbInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.ket = data["ket"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payForID = data["payForID"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(CreatePaymentScheduleAjb.fromJS(item));
            }
            if (data["dataPaymentDetail"] && data["dataPaymentDetail"].constructor === Array) {
                this.dataPaymentDetail = [];
                for (let item of data["dataPaymentDetail"])
                    this.dataPaymentDetail.push(CreatePaymentDetailAjb.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInputPaymentAjbInputDto {
        let result = new CreateInputPaymentAjbInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["ket"] = this.ket;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payForID"] = this.payForID;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        if (this.dataPaymentDetail && this.dataPaymentDetail.constructor === Array) {
            data["dataPaymentDetail"] = [];
            for (let item of this.dataPaymentDetail)
                data["dataPaymentDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateInputPaymentAjbInputDto {
    accountID: number;
    bookingHeaderID: number;
    clearDate: moment.Moment;
    ket: string;
    paymentDate: moment.Moment;
    transNo: string;
    payForID: number;
    dataSchedule: CreatePaymentScheduleAjb[];
    dataPaymentDetail: CreatePaymentDetailAjb[];
}

export class CreatePaymentScheduleAjb implements ICreatePaymentScheduleAjb {
    totalPaymentSchedule: number;
    totalOutstandingSchedule: number;
    schedNoSchedule: number;

    constructor(data?: ICreatePaymentScheduleAjb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPaymentSchedule = data["totalPaymentSchedule"];
            this.totalOutstandingSchedule = data["totalOutstandingSchedule"];
            this.schedNoSchedule = data["schedNoSchedule"];
        }
    }

    static fromJS(data: any): CreatePaymentScheduleAjb {
        let result = new CreatePaymentScheduleAjb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPaymentSchedule"] = this.totalPaymentSchedule;
        data["totalOutstandingSchedule"] = this.totalOutstandingSchedule;
        data["schedNoSchedule"] = this.schedNoSchedule;
        return data; 
    }
}

export interface ICreatePaymentScheduleAjb {
    totalPaymentSchedule: number;
    totalOutstandingSchedule: number;
    schedNoSchedule: number;
}

export class CreatePaymentDetailAjb implements ICreatePaymentDetailAjb {
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalPaymentDetail: number;
    dataAlloc: CreatePaymentAllocAjb[];

    constructor(data?: ICreatePaymentDetailAjb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.payTypeID = data["payTypeID"];
            this.bankName = data["bankName"];
            this.ket = data["ket"];
            this.totalPaymentDetail = data["totalPaymentDetail"];
            if (data["dataAlloc"] && data["dataAlloc"].constructor === Array) {
                this.dataAlloc = [];
                for (let item of data["dataAlloc"])
                    this.dataAlloc.push(CreatePaymentAllocAjb.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePaymentDetailAjb {
        let result = new CreatePaymentDetailAjb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["payTypeID"] = this.payTypeID;
        data["bankName"] = this.bankName;
        data["ket"] = this.ket;
        data["totalPaymentDetail"] = this.totalPaymentDetail;
        if (this.dataAlloc && this.dataAlloc.constructor === Array) {
            data["dataAlloc"] = [];
            for (let item of this.dataAlloc)
                data["dataAlloc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePaymentDetailAjb {
    dueDate: moment.Moment;
    payTypeID: number;
    bankName: string;
    ket: string;
    totalPaymentDetail: number;
    dataAlloc: CreatePaymentAllocAjb[];
}

export class CreatePaymentAllocAjb implements ICreatePaymentAllocAjb {
    totalPayment: number;
    totalOutstanding: number;
    schedNo: number;

    constructor(data?: ICreatePaymentAllocAjb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPayment = data["totalPayment"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
        }
    }

    static fromJS(data: any): CreatePaymentAllocAjb {
        let result = new CreatePaymentAllocAjb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPayment"] = this.totalPayment;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        return data; 
    }
}

export interface ICreatePaymentAllocAjb {
    totalPayment: number;
    totalOutstanding: number;
    schedNo: number;
}

export class BatchPajakStockDto implements IBatchPajakStockDto {
    id: string;
    batchID: number;
    coCode: string;
    fpBranchCode: string;
    fpYear: string;
    fpNo: string;
    isAvailable: boolean;
    yearPeriod: string;
    createdBy: string;
    createdOn: moment.Moment;
    modifiedBy: string;
    modifiedOn: moment.Moment;
    fpTransCode: string;
    fpStatCode: string;

    constructor(data?: IBatchPajakStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.batchID = data["batchID"];
            this.coCode = data["coCode"];
            this.fpBranchCode = data["fpBranchCode"];
            this.fpYear = data["fpYear"];
            this.fpNo = data["fpNo"];
            this.isAvailable = data["isAvailable"];
            this.yearPeriod = data["yearPeriod"];
            this.createdBy = data["createdBy"];
            this.createdOn = data["createdOn"] ? moment(data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.modifiedOn = data["modifiedOn"] ? moment(data["modifiedOn"].toString()) : <any>undefined;
            this.fpTransCode = data["fpTransCode"];
            this.fpStatCode = data["fpStatCode"];
        }
    }

    static fromJS(data: any): BatchPajakStockDto {
        let result = new BatchPajakStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchID"] = this.batchID;
        data["coCode"] = this.coCode;
        data["fpBranchCode"] = this.fpBranchCode;
        data["fpYear"] = this.fpYear;
        data["fpNo"] = this.fpNo;
        data["isAvailable"] = this.isAvailable;
        data["yearPeriod"] = this.yearPeriod;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["fpTransCode"] = this.fpTransCode;
        data["fpStatCode"] = this.fpStatCode;
        return data; 
    }
}

export interface IBatchPajakStockDto {
    id: string;
    batchID: number;
    coCode: string;
    fpBranchCode: string;
    fpYear: string;
    fpNo: string;
    isAvailable: boolean;
    yearPeriod: string;
    createdBy: string;
    createdOn: moment.Moment;
    modifiedBy: string;
    modifiedOn: moment.Moment;
    fpTransCode: string;
    fpStatCode: string;
}

export class UpdateBatchPajakStockDto implements IUpdateBatchPajakStockDto {
    fpNo: string;
    coCode: string;
    modifiedOn: moment.Moment;
    modifiedBy: string;

    constructor(data?: IUpdateBatchPajakStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fpNo = data["fpNo"];
            this.coCode = data["coCode"];
            this.modifiedOn = data["modifiedOn"] ? moment(data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
        }
    }

    static fromJS(data: any): UpdateBatchPajakStockDto {
        let result = new UpdateBatchPajakStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fpNo"] = this.fpNo;
        data["coCode"] = this.coCode;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        return data; 
    }
}

export interface IUpdateBatchPajakStockDto {
    fpNo: string;
    coCode: string;
    modifiedOn: moment.Moment;
    modifiedBy: string;
}

export class CreateAccountingTrPaymentDetailJournalInputDto implements ICreateAccountingTrPaymentDetailJournalInputDto {
    entityCode: string;
    accCode: string;
    transNo: string;
    payNo: number;
    bookCode: string;
    journalCode: string;

    constructor(data?: ICreateAccountingTrPaymentDetailJournalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.accCode = data["accCode"];
            this.transNo = data["transNo"];
            this.payNo = data["payNo"];
            this.bookCode = data["bookCode"];
            this.journalCode = data["journalCode"];
        }
    }

    static fromJS(data: any): CreateAccountingTrPaymentDetailJournalInputDto {
        let result = new CreateAccountingTrPaymentDetailJournalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["accCode"] = this.accCode;
        data["transNo"] = this.transNo;
        data["payNo"] = this.payNo;
        data["bookCode"] = this.bookCode;
        data["journalCode"] = this.journalCode;
        return data; 
    }
}

export interface ICreateAccountingTrPaymentDetailJournalInputDto {
    entityCode: string;
    accCode: string;
    transNo: string;
    payNo: number;
    bookCode: string;
    journalCode: string;
}

export class CreateTAXTrFPHeaderInputDto implements ICreateTAXTrFPHeaderInputDto {
    entityCode: string;
    coCode: string;
    fpCode: string;
    dpAmount: number;
    fpBranchCode: string;
    fpNo: string;
    fpStatCode: string;
    fpTransCode: string;
    fpType: string;
    fpYear: string;
    npwp: string;
    accCode: string;
    discAmount: number;
    name: string;
    payNo: number;
    paymentCode: string;
    pmtBatchNo: string;
    priceType: string;
    psCode: string;
    rentalCode: string;
    sourceCode: string;
    transDate: moment.Moment;
    transNo: string;
    unitCode: string;
    unitNo: string;
    unitPriceAmt: number;
    unitPriceVat: number;
    userAddress: string;
    vatAmt: number;
    bookCode: string;
    isSync: boolean;

    constructor(data?: ICreateTAXTrFPHeaderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.coCode = data["coCode"];
            this.fpCode = data["fpCode"];
            this.dpAmount = data["dpAmount"];
            this.fpBranchCode = data["fpBranchCode"];
            this.fpNo = data["fpNo"];
            this.fpStatCode = data["fpStatCode"];
            this.fpTransCode = data["fpTransCode"];
            this.fpType = data["fpType"];
            this.fpYear = data["fpYear"];
            this.npwp = data["npwp"];
            this.accCode = data["accCode"];
            this.discAmount = data["discAmount"];
            this.name = data["name"];
            this.payNo = data["payNo"];
            this.paymentCode = data["paymentCode"];
            this.pmtBatchNo = data["pmtBatchNo"];
            this.priceType = data["priceType"];
            this.psCode = data["psCode"];
            this.rentalCode = data["rentalCode"];
            this.sourceCode = data["sourceCode"];
            this.transDate = data["transDate"] ? moment(data["transDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitPriceAmt = data["unitPriceAmt"];
            this.unitPriceVat = data["unitPriceVat"];
            this.userAddress = data["userAddress"];
            this.vatAmt = data["vatAmt"];
            this.bookCode = data["bookCode"];
            this.isSync = data["isSync"];
        }
    }

    static fromJS(data: any): CreateTAXTrFPHeaderInputDto {
        let result = new CreateTAXTrFPHeaderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["coCode"] = this.coCode;
        data["fpCode"] = this.fpCode;
        data["dpAmount"] = this.dpAmount;
        data["fpBranchCode"] = this.fpBranchCode;
        data["fpNo"] = this.fpNo;
        data["fpStatCode"] = this.fpStatCode;
        data["fpTransCode"] = this.fpTransCode;
        data["fpType"] = this.fpType;
        data["fpYear"] = this.fpYear;
        data["npwp"] = this.npwp;
        data["accCode"] = this.accCode;
        data["discAmount"] = this.discAmount;
        data["name"] = this.name;
        data["payNo"] = this.payNo;
        data["paymentCode"] = this.paymentCode;
        data["pmtBatchNo"] = this.pmtBatchNo;
        data["priceType"] = this.priceType;
        data["psCode"] = this.psCode;
        data["rentalCode"] = this.rentalCode;
        data["sourceCode"] = this.sourceCode;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitPriceAmt"] = this.unitPriceAmt;
        data["unitPriceVat"] = this.unitPriceVat;
        data["userAddress"] = this.userAddress;
        data["vatAmt"] = this.vatAmt;
        data["bookCode"] = this.bookCode;
        data["isSync"] = this.isSync;
        return data; 
    }
}

export interface ICreateTAXTrFPHeaderInputDto {
    entityCode: string;
    coCode: string;
    fpCode: string;
    dpAmount: number;
    fpBranchCode: string;
    fpNo: string;
    fpStatCode: string;
    fpTransCode: string;
    fpType: string;
    fpYear: string;
    npwp: string;
    accCode: string;
    discAmount: number;
    name: string;
    payNo: number;
    paymentCode: string;
    pmtBatchNo: string;
    priceType: string;
    psCode: string;
    rentalCode: string;
    sourceCode: string;
    transDate: moment.Moment;
    transNo: string;
    unitCode: string;
    unitNo: string;
    unitPriceAmt: number;
    unitPriceVat: number;
    userAddress: string;
    vatAmt: number;
    bookCode: string;
    isSync: boolean;
}

export class GenerateJurnalInputDto implements IGenerateJurnalInputDto {
    coCode: string;
    accCode: string;
    bookCode: string;
    transNo: string;
    totalPaymentDetail: number;

    constructor(data?: IGenerateJurnalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coCode = data["coCode"];
            this.accCode = data["accCode"];
            this.bookCode = data["bookCode"];
            this.transNo = data["transNo"];
            this.totalPaymentDetail = data["totalPaymentDetail"];
        }
    }

    static fromJS(data: any): GenerateJurnalInputDto {
        let result = new GenerateJurnalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coCode"] = this.coCode;
        data["accCode"] = this.accCode;
        data["bookCode"] = this.bookCode;
        data["transNo"] = this.transNo;
        data["totalPaymentDetail"] = this.totalPaymentDetail;
        return data; 
    }
}

export interface IGenerateJurnalInputDto {
    coCode: string;
    accCode: string;
    bookCode: string;
    transNo: string;
    totalPaymentDetail: number;
}

export class CreateTrJournalInputDto implements ICreateTrJournalInputDto {
    entityCode: string;
    journalCode: string;
    coaCodeFIN: string;
    coaCodeAcc: string;
    journalDate: moment.Moment;
    debit: number;
    kredit: number;
    remarks: string;

    constructor(data?: ICreateTrJournalInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.journalCode = data["journalCode"];
            this.coaCodeFIN = data["coaCodeFIN"];
            this.coaCodeAcc = data["coaCodeAcc"];
            this.journalDate = data["journalDate"] ? moment(data["journalDate"].toString()) : <any>undefined;
            this.debit = data["debit"];
            this.kredit = data["kredit"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): CreateTrJournalInputDto {
        let result = new CreateTrJournalInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["journalCode"] = this.journalCode;
        data["coaCodeFIN"] = this.coaCodeFIN;
        data["coaCodeAcc"] = this.coaCodeAcc;
        data["journalDate"] = this.journalDate ? this.journalDate.toISOString() : <any>undefined;
        data["debit"] = this.debit;
        data["kredit"] = this.kredit;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface ICreateTrJournalInputDto {
    entityCode: string;
    journalCode: string;
    coaCodeFIN: string;
    coaCodeAcc: string;
    journalDate: moment.Moment;
    debit: number;
    kredit: number;
    remarks: string;
}

export class CreateTAXTrFPDetailInputDto implements ICreateTAXTrFPDetailInputDto {
    entityCode: string;
    coCode: string;
    fpCode: string;
    transNo: number;
    currencyCode: string;
    currencyRate: number;
    transAmount: number;
    transDesc: string;
    bookCode: string;
    isSync: boolean;

    constructor(data?: ICreateTAXTrFPDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.coCode = data["coCode"];
            this.fpCode = data["fpCode"];
            this.transNo = data["transNo"];
            this.currencyCode = data["currencyCode"];
            this.currencyRate = data["currencyRate"];
            this.transAmount = data["transAmount"];
            this.transDesc = data["transDesc"];
            this.bookCode = data["bookCode"];
            this.isSync = data["isSync"];
        }
    }

    static fromJS(data: any): CreateTAXTrFPDetailInputDto {
        let result = new CreateTAXTrFPDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["coCode"] = this.coCode;
        data["fpCode"] = this.fpCode;
        data["transNo"] = this.transNo;
        data["currencyCode"] = this.currencyCode;
        data["currencyRate"] = this.currencyRate;
        data["transAmount"] = this.transAmount;
        data["transDesc"] = this.transDesc;
        data["bookCode"] = this.bookCode;
        data["isSync"] = this.isSync;
        return data; 
    }
}

export interface ICreateTAXTrFPDetailInputDto {
    entityCode: string;
    coCode: string;
    fpCode: string;
    transNo: number;
    currencyCode: string;
    currencyRate: number;
    transAmount: number;
    transDesc: string;
    bookCode: string;
    isSync: boolean;
}

export class GetDataPriorityPassNoListDto implements IGetDataPriorityPassNoListDto {
    priorityPassNo: string;
    psCode: string;
    clientName: string;
    amount: number;

    constructor(data?: IGetDataPriorityPassNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priorityPassNo = data["priorityPassNo"];
            this.psCode = data["psCode"];
            this.clientName = data["clientName"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetDataPriorityPassNoListDto {
        let result = new GetDataPriorityPassNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorityPassNo"] = this.priorityPassNo;
        data["psCode"] = this.psCode;
        data["clientName"] = this.clientName;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IGetDataPriorityPassNoListDto {
    priorityPassNo: string;
    psCode: string;
    clientName: string;
    amount: number;
}

export class SendSMSORInputDto implements ISendSMSORInputDto {
    projectID: number;
    phone: string;
    bookCode: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    clearDate: moment.Moment;
    amount: number;

    constructor(data?: ISendSMSORInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.phone = data["phone"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): SendSMSORInputDto {
        let result = new SendSMSORInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["phone"] = this.phone;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface ISendSMSORInputDto {
    projectID: number;
    phone: string;
    bookCode: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    clearDate: moment.Moment;
    amount: number;
}

export class SendEmailORInputDto implements ISendEmailORInputDto {
    projectID: number;
    accID: number;
    custName: string;
    email: string;
    phone: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    transNo: string;
    clearDate: moment.Moment;
    paymentDate: moment.Moment;
    fileName: string;
    flag: number;
    templatePdf: string;
    templateBodyEmail: string;
    generateDto: PrintORDto;
    totalAmount: number;

    constructor(data?: ISendEmailORInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.accID = data["accID"];
            this.custName = data["custName"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.transNo = data["transNo"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.fileName = data["fileName"];
            this.flag = data["flag"];
            this.templatePdf = data["templatePdf"];
            this.templateBodyEmail = data["templateBodyEmail"];
            this.generateDto = data["generateDto"] ? PrintORDto.fromJS(data["generateDto"]) : <any>undefined;
            this.totalAmount = data["totalAmount"];
        }
    }

    static fromJS(data: any): SendEmailORInputDto {
        let result = new SendEmailORInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["accID"] = this.accID;
        data["custName"] = this.custName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["transNo"] = this.transNo;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["flag"] = this.flag;
        data["templatePdf"] = this.templatePdf;
        data["templateBodyEmail"] = this.templateBodyEmail;
        data["generateDto"] = this.generateDto ? this.generateDto.toJSON() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        return data; 
    }
}

export interface ISendEmailORInputDto {
    projectID: number;
    accID: number;
    custName: string;
    email: string;
    phone: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    transNo: string;
    clearDate: moment.Moment;
    paymentDate: moment.Moment;
    fileName: string;
    flag: number;
    templatePdf: string;
    templateBodyEmail: string;
    generateDto: PrintORDto;
    totalAmount: number;
}

export class PrintORDto implements IPrintORDto {
    bookingHeaderID: number;
    projectID: number;
    projectName: string;
    projectImage: string;
    accountID: number;
    accountName: string;
    accountAddress: string;
    accountPhone: string;
    accountNPWP: string;
    accountPKP: string;
    accountPKPDate: string;
    transNo: string;
    paymentDate: moment.Moment;
    paymentDateFormat: string;
    psCode: string;
    email: string;
    custName: string;
    custAddress: string;
    custNPWP: string;
    lantai: string;
    unitCode: string;
    unitNo: string;
    clusterName: string;
    payForID: number;
    paymentFor: string;
    kpNo: string;
    tanggalKP: string;
    userLogin: string;
    totalNET: number;
    totalVAT: number;
    totalAmount: number;
    totalAmountFormat: string;
    ppn: string;
    totalAll: string;
    terbilang: string;
    flag: number;
    templatePdf: string;
    listDataAlloc: GetDataAlloc[];

    constructor(data?: IPrintORDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.projectImage = data["projectImage"];
            this.accountID = data["accountID"];
            this.accountName = data["accountName"];
            this.accountAddress = data["accountAddress"];
            this.accountPhone = data["accountPhone"];
            this.accountNPWP = data["accountNPWP"];
            this.accountPKP = data["accountPKP"];
            this.accountPKPDate = data["accountPKPDate"];
            this.transNo = data["transNo"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentDateFormat = data["paymentDateFormat"];
            this.psCode = data["psCode"];
            this.email = data["email"];
            this.custName = data["custName"];
            this.custAddress = data["custAddress"];
            this.custNPWP = data["custNPWP"];
            this.lantai = data["lantai"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.clusterName = data["clusterName"];
            this.payForID = data["payForID"];
            this.paymentFor = data["paymentFor"];
            this.kpNo = data["kpNo"];
            this.tanggalKP = data["tanggalKP"];
            this.userLogin = data["userLogin"];
            this.totalNET = data["totalNET"];
            this.totalVAT = data["totalVAT"];
            this.totalAmount = data["totalAmount"];
            this.totalAmountFormat = data["totalAmountFormat"];
            this.ppn = data["ppn"];
            this.totalAll = data["totalAll"];
            this.terbilang = data["terbilang"];
            this.flag = data["flag"];
            this.templatePdf = data["templatePdf"];
            if (data["listDataAlloc"] && data["listDataAlloc"].constructor === Array) {
                this.listDataAlloc = [];
                for (let item of data["listDataAlloc"])
                    this.listDataAlloc.push(GetDataAlloc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrintORDto {
        let result = new PrintORDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["accountID"] = this.accountID;
        data["accountName"] = this.accountName;
        data["accountAddress"] = this.accountAddress;
        data["accountPhone"] = this.accountPhone;
        data["accountNPWP"] = this.accountNPWP;
        data["accountPKP"] = this.accountPKP;
        data["accountPKPDate"] = this.accountPKPDate;
        data["transNo"] = this.transNo;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentDateFormat"] = this.paymentDateFormat;
        data["psCode"] = this.psCode;
        data["email"] = this.email;
        data["custName"] = this.custName;
        data["custAddress"] = this.custAddress;
        data["custNPWP"] = this.custNPWP;
        data["lantai"] = this.lantai;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["clusterName"] = this.clusterName;
        data["payForID"] = this.payForID;
        data["paymentFor"] = this.paymentFor;
        data["kpNo"] = this.kpNo;
        data["tanggalKP"] = this.tanggalKP;
        data["userLogin"] = this.userLogin;
        data["totalNET"] = this.totalNET;
        data["totalVAT"] = this.totalVAT;
        data["totalAmount"] = this.totalAmount;
        data["totalAmountFormat"] = this.totalAmountFormat;
        data["ppn"] = this.ppn;
        data["totalAll"] = this.totalAll;
        data["terbilang"] = this.terbilang;
        data["flag"] = this.flag;
        data["templatePdf"] = this.templatePdf;
        if (this.listDataAlloc && this.listDataAlloc.constructor === Array) {
            data["listDataAlloc"] = [];
            for (let item of this.listDataAlloc)
                data["listDataAlloc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPrintORDto {
    bookingHeaderID: number;
    projectID: number;
    projectName: string;
    projectImage: string;
    accountID: number;
    accountName: string;
    accountAddress: string;
    accountPhone: string;
    accountNPWP: string;
    accountPKP: string;
    accountPKPDate: string;
    transNo: string;
    paymentDate: moment.Moment;
    paymentDateFormat: string;
    psCode: string;
    email: string;
    custName: string;
    custAddress: string;
    custNPWP: string;
    lantai: string;
    unitCode: string;
    unitNo: string;
    clusterName: string;
    payForID: number;
    paymentFor: string;
    kpNo: string;
    tanggalKP: string;
    userLogin: string;
    totalNET: number;
    totalVAT: number;
    totalAmount: number;
    totalAmountFormat: string;
    ppn: string;
    totalAll: string;
    terbilang: string;
    flag: number;
    templatePdf: string;
    listDataAlloc: GetDataAlloc[];
}

export class GetDataAlloc implements IGetDataAlloc {
    payType: string;
    othersType: string;
    property: string;
    netAlloc: number;
    netAllocFormat: string;

    constructor(data?: IGetDataAlloc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payType = data["payType"];
            this.othersType = data["othersType"];
            this.property = data["property"];
            this.netAlloc = data["netAlloc"];
            this.netAllocFormat = data["netAllocFormat"];
        }
    }

    static fromJS(data: any): GetDataAlloc {
        let result = new GetDataAlloc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payType"] = this.payType;
        data["othersType"] = this.othersType;
        data["property"] = this.property;
        data["netAlloc"] = this.netAlloc;
        data["netAllocFormat"] = this.netAllocFormat;
        return data; 
    }
}

export interface IGetDataAlloc {
    payType: string;
    othersType: string;
    property: string;
    netAlloc: number;
    netAllocFormat: string;
}

export class UpdatePenaltySchedulePaymentInputDto implements IUpdatePenaltySchedulePaymentInputDto {
    bookingHeaderID: number;
    getSchedNo: GetSchedNo[];
    payForCode: string;

    constructor(data?: IUpdatePenaltySchedulePaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            if (data["getSchedNo"] && data["getSchedNo"].constructor === Array) {
                this.getSchedNo = [];
                for (let item of data["getSchedNo"])
                    this.getSchedNo.push(GetSchedNo.fromJS(item));
            }
            this.payForCode = data["payForCode"];
        }
    }

    static fromJS(data: any): UpdatePenaltySchedulePaymentInputDto {
        let result = new UpdatePenaltySchedulePaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        if (this.getSchedNo && this.getSchedNo.constructor === Array) {
            data["getSchedNo"] = [];
            for (let item of this.getSchedNo)
                data["getSchedNo"].push(item.toJSON());
        }
        data["payForCode"] = this.payForCode;
        return data; 
    }
}

export interface IUpdatePenaltySchedulePaymentInputDto {
    bookingHeaderID: number;
    getSchedNo: GetSchedNo[];
    payForCode: string;
}

export class GetSchedNo implements IGetSchedNo {
    schedNo: number;
    sisaAmountNet: number;
    sisaAmountVat: number;

    constructor(data?: IGetSchedNo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schedNo = data["schedNo"];
            this.sisaAmountNet = data["sisaAmountNet"];
            this.sisaAmountVat = data["sisaAmountVat"];
        }
    }

    static fromJS(data: any): GetSchedNo {
        let result = new GetSchedNo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schedNo"] = this.schedNo;
        data["sisaAmountNet"] = this.sisaAmountNet;
        data["sisaAmountVat"] = this.sisaAmountVat;
        return data; 
    }
}

export interface IGetSchedNo {
    schedNo: number;
    sisaAmountNet: number;
    sisaAmountVat: number;
}

export class EditPaymentInputDto implements IEditPaymentInputDto {
    paymentHeaderID: number;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    descHeader: string;
    dataPaymentDetail: EditDetailPayment[];

    constructor(data?: IEditPaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentHeaderID = data["paymentHeaderID"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.descHeader = data["descHeader"];
            if (data["dataPaymentDetail"] && data["dataPaymentDetail"].constructor === Array) {
                this.dataPaymentDetail = [];
                for (let item of data["dataPaymentDetail"])
                    this.dataPaymentDetail.push(EditDetailPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditPaymentInputDto {
        let result = new EditPaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["descHeader"] = this.descHeader;
        if (this.dataPaymentDetail && this.dataPaymentDetail.constructor === Array) {
            data["dataPaymentDetail"] = [];
            for (let item of this.dataPaymentDetail)
                data["dataPaymentDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditPaymentInputDto {
    paymentHeaderID: number;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    descHeader: string;
    dataPaymentDetail: EditDetailPayment[];
}

export class EditDetailPayment implements IEditDetailPayment {
    paymentDetailID: number;
    payTypeID: number;
    bankName: string;
    othersType: string;
    descDetail: string;

    constructor(data?: IEditDetailPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDetailID = data["paymentDetailID"];
            this.payTypeID = data["payTypeID"];
            this.bankName = data["bankName"];
            this.othersType = data["othersType"];
            this.descDetail = data["descDetail"];
        }
    }

    static fromJS(data: any): EditDetailPayment {
        let result = new EditDetailPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDetailID"] = this.paymentDetailID;
        data["payTypeID"] = this.payTypeID;
        data["bankName"] = this.bankName;
        data["othersType"] = this.othersType;
        data["descDetail"] = this.descDetail;
        return data; 
    }
}

export interface IEditDetailPayment {
    paymentDetailID: number;
    payTypeID: number;
    bankName: string;
    othersType: string;
    descDetail: string;
}

export class GetPaymentListDto implements IGetPaymentListDto {
    amount: number;

    constructor(data?: IGetPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetPaymentListDto {
        let result = new GetPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IGetPaymentListDto {
    amount: number;
}

export class GetDataSendSMSRPListDto implements IGetDataSendSMSRPListDto {
    psCode: string;
    unitNo: string;
    unitName: string;
    unitCode: string;
    dueDate: moment.Moment;
    projectID: number;
    letterType: string;
    totalAmt: number;
    sadPhone: string;
    phone: string;
    bookCode: string;

    constructor(data?: IGetDataSendSMSRPListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.unitNo = data["unitNo"];
            this.unitName = data["unitName"];
            this.unitCode = data["unitCode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.projectID = data["projectID"];
            this.letterType = data["letterType"];
            this.totalAmt = data["totalAmt"];
            this.sadPhone = data["sadPhone"];
            this.phone = data["phone"];
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): GetDataSendSMSRPListDto {
        let result = new GetDataSendSMSRPListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["unitNo"] = this.unitNo;
        data["unitName"] = this.unitName;
        data["unitCode"] = this.unitCode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["projectID"] = this.projectID;
        data["letterType"] = this.letterType;
        data["totalAmt"] = this.totalAmt;
        data["sadPhone"] = this.sadPhone;
        data["phone"] = this.phone;
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IGetDataSendSMSRPListDto {
    psCode: string;
    unitNo: string;
    unitName: string;
    unitCode: string;
    dueDate: moment.Moment;
    projectID: number;
    letterType: string;
    totalAmt: number;
    sadPhone: string;
    phone: string;
    bookCode: string;
}

export class InstallDto implements IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    connectionString: string;
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    connectionString: string;
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];
}

export class NameValue implements INameValue {
    name: string;
    value: string;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string;
    value: string;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class GetAllTypeTowerListDto implements IGetAllTypeTowerListDto {
    listTower: GetTypeTower[];
    grandTotal: GetTypeTower[];

    constructor(data?: IGetAllTypeTowerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listTower"] && data["listTower"].constructor === Array) {
                this.listTower = [];
                for (let item of data["listTower"])
                    this.listTower.push(GetTypeTower.fromJS(item));
            }
            if (data["grandTotal"] && data["grandTotal"].constructor === Array) {
                this.grandTotal = [];
                for (let item of data["grandTotal"])
                    this.grandTotal.push(GetTypeTower.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllTypeTowerListDto {
        let result = new GetAllTypeTowerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listTower && this.listTower.constructor === Array) {
            data["listTower"] = [];
            for (let item of this.listTower)
                data["listTower"].push(item.toJSON());
        }
        if (this.grandTotal && this.grandTotal.constructor === Array) {
            data["grandTotal"] = [];
            for (let item of this.grandTotal)
                data["grandTotal"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAllTypeTowerListDto {
    listTower: GetTypeTower[];
    grandTotal: GetTypeTower[];
}

export class GetTypeTower implements IGetTypeTower {
    typeTower: string;
    available: number;
    other: number;
    soldLess: number;
    soldMore: number;
    totalUnit: number;
    totalIdr: number;
    totalIdrString: string;
    flag: boolean;

    constructor(data?: IGetTypeTower) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.typeTower = data["typeTower"];
            this.available = data["available"];
            this.other = data["other"];
            this.soldLess = data["soldLess"];
            this.soldMore = data["soldMore"];
            this.totalUnit = data["totalUnit"];
            this.totalIdr = data["totalIdr"];
            this.totalIdrString = data["totalIdrString"];
            this.flag = data["flag"];
        }
    }

    static fromJS(data: any): GetTypeTower {
        let result = new GetTypeTower();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeTower"] = this.typeTower;
        data["available"] = this.available;
        data["other"] = this.other;
        data["soldLess"] = this.soldLess;
        data["soldMore"] = this.soldMore;
        data["totalUnit"] = this.totalUnit;
        data["totalIdr"] = this.totalIdr;
        data["totalIdrString"] = this.totalIdrString;
        data["flag"] = this.flag;
        return data; 
    }
}

export interface IGetTypeTower {
    typeTower: string;
    available: number;
    other: number;
    soldLess: number;
    soldMore: number;
    totalUnit: number;
    totalIdr: number;
    totalIdrString: string;
    flag: boolean;
}

export class GetDiagramaticInventoryDashboardListDto implements IGetDiagramaticInventoryDashboardListDto {
    unitCode: string;
    tower: string;
    towers: string[];
    districtID: number;
    districtName: string;
    position: string;
    inventory: number;
    available: number;
    sold: number;
    booked: number;
    occup: number;

    constructor(data?: IGetDiagramaticInventoryDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.tower = data["tower"];
            if (data["towers"] && data["towers"].constructor === Array) {
                this.towers = [];
                for (let item of data["towers"])
                    this.towers.push(item);
            }
            this.districtID = data["districtID"];
            this.districtName = data["districtName"];
            this.position = data["position"];
            this.inventory = data["inventory"];
            this.available = data["available"];
            this.sold = data["sold"];
            this.booked = data["booked"];
            this.occup = data["occup"];
        }
    }

    static fromJS(data: any): GetDiagramaticInventoryDashboardListDto {
        let result = new GetDiagramaticInventoryDashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["tower"] = this.tower;
        if (this.towers && this.towers.constructor === Array) {
            data["towers"] = [];
            for (let item of this.towers)
                data["towers"].push(item);
        }
        data["districtID"] = this.districtID;
        data["districtName"] = this.districtName;
        data["position"] = this.position;
        data["inventory"] = this.inventory;
        data["available"] = this.available;
        data["sold"] = this.sold;
        data["booked"] = this.booked;
        data["occup"] = this.occup;
        return data; 
    }
}

export interface IGetDiagramaticInventoryDashboardListDto {
    unitCode: string;
    tower: string;
    towers: string[];
    districtID: number;
    districtName: string;
    position: string;
    inventory: number;
    available: number;
    sold: number;
    booked: number;
    occup: number;
}

export class GetDistrictListDto implements IGetDistrictListDto {
    districtID: number;
    districtName: string;

    constructor(data?: IGetDistrictListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.districtID = data["districtID"];
            this.districtName = data["districtName"];
        }
    }

    static fromJS(data: any): GetDistrictListDto {
        let result = new GetDistrictListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtID"] = this.districtID;
        data["districtName"] = this.districtName;
        return data; 
    }
}

export interface IGetDistrictListDto {
    districtID: number;
    districtName: string;
}

export class GetUnitByTowerTypeListDto implements IGetUnitByTowerTypeListDto {
    listUnit: GetUnit[];
    grandTotal: GetUnit;

    constructor(data?: IGetUnitByTowerTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(GetUnit.fromJS(item));
            }
            this.grandTotal = data["grandTotal"] ? GetUnit.fromJS(data["grandTotal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnitByTowerTypeListDto {
        let result = new GetUnitByTowerTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal ? this.grandTotal.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUnitByTowerTypeListDto {
    listUnit: GetUnit[];
    grandTotal: GetUnit;
}

export class GetUnit implements IGetUnit {
    unitCode: string;
    floor: string;
    basePrice: number;
    basePriceString: string;

    constructor(data?: IGetUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.floor = data["floor"];
            this.basePrice = data["basePrice"];
            this.basePriceString = data["basePriceString"];
        }
    }

    static fromJS(data: any): GetUnit {
        let result = new GetUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["floor"] = this.floor;
        data["basePrice"] = this.basePrice;
        data["basePriceString"] = this.basePriceString;
        return data; 
    }
}

export interface IGetUnit {
    unitCode: string;
    floor: string;
    basePrice: number;
    basePriceString: string;
}

export class GetUnitTypeByTowerListDto implements IGetUnitTypeByTowerListDto {
    listUnitType: GetUnitType[];
    grandTotal: GetUnitType;

    constructor(data?: IGetUnitTypeByTowerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listUnitType"] && data["listUnitType"].constructor === Array) {
                this.listUnitType = [];
                for (let item of data["listUnitType"])
                    this.listUnitType.push(GetUnitType.fromJS(item));
            }
            this.grandTotal = data["grandTotal"] ? GetUnitType.fromJS(data["grandTotal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnitTypeByTowerListDto {
        let result = new GetUnitTypeByTowerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listUnitType && this.listUnitType.constructor === Array) {
            data["listUnitType"] = [];
            for (let item of this.listUnitType)
                data["listUnitType"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal ? this.grandTotal.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUnitTypeByTowerListDto {
    listUnitType: GetUnitType[];
    grandTotal: GetUnitType;
}

export class GetUnitType implements IGetUnitType {
    unitType: string;
    size: number;
    totalUnit: number;

    constructor(data?: IGetUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitType = data["unitType"];
            this.size = data["size"];
            this.totalUnit = data["totalUnit"];
        }
    }

    static fromJS(data: any): GetUnitType {
        let result = new GetUnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["size"] = this.size;
        data["totalUnit"] = this.totalUnit;
        return data; 
    }
}

export interface IGetUnitType {
    unitType: string;
    size: number;
    totalUnit: number;
}

export class GetUnitTypeByTowerUnitListDto implements IGetUnitTypeByTowerUnitListDto {
    tower: string;
    listUnitType: GetUnitTypeByUnit[];
    grandTotal: GetUnitTypeByUnit;

    constructor(data?: IGetUnitTypeByTowerUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tower = data["tower"];
            if (data["listUnitType"] && data["listUnitType"].constructor === Array) {
                this.listUnitType = [];
                for (let item of data["listUnitType"])
                    this.listUnitType.push(GetUnitTypeByUnit.fromJS(item));
            }
            this.grandTotal = data["grandTotal"] ? GetUnitTypeByUnit.fromJS(data["grandTotal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnitTypeByTowerUnitListDto {
        let result = new GetUnitTypeByTowerUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tower"] = this.tower;
        if (this.listUnitType && this.listUnitType.constructor === Array) {
            data["listUnitType"] = [];
            for (let item of this.listUnitType)
                data["listUnitType"].push(item.toJSON());
        }
        data["grandTotal"] = this.grandTotal ? this.grandTotal.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUnitTypeByTowerUnitListDto {
    tower: string;
    listUnitType: GetUnitTypeByUnit[];
    grandTotal: GetUnitTypeByUnit;
}

export class GetUnitTypeByUnit implements IGetUnitTypeByUnit {
    unitType: string;
    bedroom: string;
    size: number;
    inventory: number;
    available: number;
    other: number;
    soldLess: number;
    soldMore: number;
    totalUnit: number;
    totalIdr: number;
    totalIdrString: string;
    lastDateSales: moment.Moment;
    idrUnit: number;
    idrUnitString: string;
    idrSqm: number;
    idrSqmString: string;
    sqmUnit: number;

    constructor(data?: IGetUnitTypeByUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitType = data["unitType"];
            this.bedroom = data["bedroom"];
            this.size = data["size"];
            this.inventory = data["inventory"];
            this.available = data["available"];
            this.other = data["other"];
            this.soldLess = data["soldLess"];
            this.soldMore = data["soldMore"];
            this.totalUnit = data["totalUnit"];
            this.totalIdr = data["totalIdr"];
            this.totalIdrString = data["totalIdrString"];
            this.lastDateSales = data["lastDateSales"] ? moment(data["lastDateSales"].toString()) : <any>undefined;
            this.idrUnit = data["idrUnit"];
            this.idrUnitString = data["idrUnitString"];
            this.idrSqm = data["idrSqm"];
            this.idrSqmString = data["idrSqmString"];
            this.sqmUnit = data["sqmUnit"];
        }
    }

    static fromJS(data: any): GetUnitTypeByUnit {
        let result = new GetUnitTypeByUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitType"] = this.unitType;
        data["bedroom"] = this.bedroom;
        data["size"] = this.size;
        data["inventory"] = this.inventory;
        data["available"] = this.available;
        data["other"] = this.other;
        data["soldLess"] = this.soldLess;
        data["soldMore"] = this.soldMore;
        data["totalUnit"] = this.totalUnit;
        data["totalIdr"] = this.totalIdr;
        data["totalIdrString"] = this.totalIdrString;
        data["lastDateSales"] = this.lastDateSales ? this.lastDateSales.toISOString() : <any>undefined;
        data["idrUnit"] = this.idrUnit;
        data["idrUnitString"] = this.idrUnitString;
        data["idrSqm"] = this.idrSqm;
        data["idrSqmString"] = this.idrSqmString;
        data["sqmUnit"] = this.sqmUnit;
        return data; 
    }
}

export interface IGetUnitTypeByUnit {
    unitType: string;
    bedroom: string;
    size: number;
    inventory: number;
    available: number;
    other: number;
    soldLess: number;
    soldMore: number;
    totalUnit: number;
    totalIdr: number;
    totalIdrString: string;
    lastDateSales: moment.Moment;
    idrUnit: number;
    idrUnitString: string;
    idrSqm: number;
    idrSqmString: string;
    sqmUnit: number;
}

export class InvoiceDto implements IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (let item of data["tenantAddress"])
                    this.tenantAddress.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (let item of data["hostAddress"])
                    this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateTransactionUniversalDto implements ICreateTransactionUniversalDto {
    payTypeID: number;
    pscode: string;
    totalAmt: number;
    orderHeaderID: number;
    orderCode: string;
    banktansfer: string;
    alihdana: boolean;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    marketingProgram: string;
    location: string;
    bankProgram: string;
    closeProgram: string;
    specialProgram: string;
    moveInProgram: string;
    rewards: number[];
    rewardsProgram: number[];
    programID: number[];
    otherPaymentType: string[];
    arrUnit: UnitUniversalResultDto[];
    userID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    isDRMS: boolean;

    constructor(data?: ICreateTransactionUniversalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payTypeID = data["payTypeID"];
            this.pscode = data["pscode"];
            this.totalAmt = data["totalAmt"];
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.banktansfer = data["banktansfer"];
            this.alihdana = data["alihdana"];
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.sumberDanaID = data["sumberDanaID"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.marketingProgram = data["marketingProgram"];
            this.location = data["location"];
            this.bankProgram = data["bankProgram"];
            this.closeProgram = data["closeProgram"];
            this.specialProgram = data["specialProgram"];
            this.moveInProgram = data["moveInProgram"];
            if (data["rewards"] && data["rewards"].constructor === Array) {
                this.rewards = [];
                for (let item of data["rewards"])
                    this.rewards.push(item);
            }
            if (data["rewardsProgram"] && data["rewardsProgram"].constructor === Array) {
                this.rewardsProgram = [];
                for (let item of data["rewardsProgram"])
                    this.rewardsProgram.push(item);
            }
            if (data["programID"] && data["programID"].constructor === Array) {
                this.programID = [];
                for (let item of data["programID"])
                    this.programID.push(item);
            }
            if (data["otherPaymentType"] && data["otherPaymentType"].constructor === Array) {
                this.otherPaymentType = [];
                for (let item of data["otherPaymentType"])
                    this.otherPaymentType.push(item);
            }
            if (data["arrUnit"] && data["arrUnit"].constructor === Array) {
                this.arrUnit = [];
                for (let item of data["arrUnit"])
                    this.arrUnit.push(UnitUniversalResultDto.fromJS(item));
            }
            this.userID = data["userID"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.isDRMS = data["isDRMS"];
        }
    }

    static fromJS(data: any): CreateTransactionUniversalDto {
        let result = new CreateTransactionUniversalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payTypeID"] = this.payTypeID;
        data["pscode"] = this.pscode;
        data["totalAmt"] = this.totalAmt;
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["banktansfer"] = this.banktansfer;
        data["alihdana"] = this.alihdana;
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["sumberDanaID"] = this.sumberDanaID;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["marketingProgram"] = this.marketingProgram;
        data["location"] = this.location;
        data["bankProgram"] = this.bankProgram;
        data["closeProgram"] = this.closeProgram;
        data["specialProgram"] = this.specialProgram;
        data["moveInProgram"] = this.moveInProgram;
        if (this.rewards && this.rewards.constructor === Array) {
            data["rewards"] = [];
            for (let item of this.rewards)
                data["rewards"].push(item);
        }
        if (this.rewardsProgram && this.rewardsProgram.constructor === Array) {
            data["rewardsProgram"] = [];
            for (let item of this.rewardsProgram)
                data["rewardsProgram"].push(item);
        }
        if (this.programID && this.programID.constructor === Array) {
            data["programID"] = [];
            for (let item of this.programID)
                data["programID"].push(item);
        }
        if (this.otherPaymentType && this.otherPaymentType.constructor === Array) {
            data["otherPaymentType"] = [];
            for (let item of this.otherPaymentType)
                data["otherPaymentType"].push(item);
        }
        if (this.arrUnit && this.arrUnit.constructor === Array) {
            data["arrUnit"] = [];
            for (let item of this.arrUnit)
                data["arrUnit"].push(item.toJSON());
        }
        data["userID"] = this.userID;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["isDRMS"] = this.isDRMS;
        return data; 
    }
}

export interface ICreateTransactionUniversalDto {
    payTypeID: number;
    pscode: string;
    totalAmt: number;
    orderHeaderID: number;
    orderCode: string;
    banktansfer: string;
    alihdana: boolean;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    marketingProgram: string;
    location: string;
    bankProgram: string;
    closeProgram: string;
    specialProgram: string;
    moveInProgram: string;
    rewards: number[];
    rewardsProgram: number[];
    programID: number[];
    otherPaymentType: string[];
    arrUnit: UnitUniversalResultDto[];
    userID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    isDRMS: boolean;
}

export class UnitUniversalResultDto implements IUnitUniversalResultDto {
    unitID: number;
    termID: number;
    renovID: number;
    projectID: number;
    sellingprice: number;
    bfAmount: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isDRMS: boolean;
    rewardsProgram: number[];
    programID: number[];
    location: string;
    rewards: number[];

    constructor(data?: IUnitUniversalResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.termID = data["termID"];
            this.renovID = data["renovID"];
            this.projectID = data["projectID"];
            this.sellingprice = data["sellingprice"];
            this.bfAmount = data["bfAmount"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppNo = data["ppNo"];
            this.isDRMS = data["isDRMS"];
            if (data["rewardsProgram"] && data["rewardsProgram"].constructor === Array) {
                this.rewardsProgram = [];
                for (let item of data["rewardsProgram"])
                    this.rewardsProgram.push(item);
            }
            if (data["programID"] && data["programID"].constructor === Array) {
                this.programID = [];
                for (let item of data["programID"])
                    this.programID.push(item);
            }
            this.location = data["location"];
            if (data["rewards"] && data["rewards"].constructor === Array) {
                this.rewards = [];
                for (let item of data["rewards"])
                    this.rewards.push(item);
            }
        }
    }

    static fromJS(data: any): UnitUniversalResultDto {
        let result = new UnitUniversalResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["termID"] = this.termID;
        data["renovID"] = this.renovID;
        data["projectID"] = this.projectID;
        data["sellingprice"] = this.sellingprice;
        data["bfAmount"] = this.bfAmount;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppNo"] = this.ppNo;
        data["isDRMS"] = this.isDRMS;
        if (this.rewardsProgram && this.rewardsProgram.constructor === Array) {
            data["rewardsProgram"] = [];
            for (let item of this.rewardsProgram)
                data["rewardsProgram"].push(item);
        }
        if (this.programID && this.programID.constructor === Array) {
            data["programID"] = [];
            for (let item of this.programID)
                data["programID"].push(item);
        }
        data["location"] = this.location;
        if (this.rewards && this.rewards.constructor === Array) {
            data["rewards"] = [];
            for (let item of this.rewards)
                data["rewards"].push(item);
        }
        return data; 
    }
}

export interface IUnitUniversalResultDto {
    unitID: number;
    termID: number;
    renovID: number;
    projectID: number;
    sellingprice: number;
    bfAmount: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isDRMS: boolean;
    rewardsProgram: number[];
    programID: number[];
    location: string;
    rewards: number[];
}

export class DoBookingIPay88RequestResultDto implements IDoBookingIPay88RequestResultDto {
    htmlRequest: string;
    isFullyPaid: boolean;

    constructor(data?: IDoBookingIPay88RequestResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.htmlRequest = data["htmlRequest"];
            this.isFullyPaid = data["isFullyPaid"];
        }
    }

    static fromJS(data: any): DoBookingIPay88RequestResultDto {
        let result = new DoBookingIPay88RequestResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlRequest"] = this.htmlRequest;
        data["isFullyPaid"] = this.isFullyPaid;
        return data; 
    }
}

export interface IDoBookingIPay88RequestResultDto {
    htmlRequest: string;
    isFullyPaid: boolean;
}

export class BuyPPMidtransReqInputDto implements IBuyPPMidtransReqInputDto {
    ppOrderID: number;
    paymentTypeID: number;
    orderCode: string;
    psCode: string;
    totalOrder: number;
    voucher: string;
    banktansfer: string;

    constructor(data?: IBuyPPMidtransReqInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
            this.paymentTypeID = data["paymentTypeID"];
            this.orderCode = data["orderCode"];
            this.psCode = data["psCode"];
            this.totalOrder = data["totalOrder"];
            this.voucher = data["voucher"];
            this.banktansfer = data["banktansfer"];
        }
    }

    static fromJS(data: any): BuyPPMidtransReqInputDto {
        let result = new BuyPPMidtransReqInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        data["paymentTypeID"] = this.paymentTypeID;
        data["orderCode"] = this.orderCode;
        data["psCode"] = this.psCode;
        data["totalOrder"] = this.totalOrder;
        data["voucher"] = this.voucher;
        data["banktansfer"] = this.banktansfer;
        return data; 
    }
}

export interface IBuyPPMidtransReqInputDto {
    ppOrderID: number;
    paymentTypeID: number;
    orderCode: string;
    psCode: string;
    totalOrder: number;
    voucher: string;
    banktansfer: string;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName: string;
    items: ApplicationLanguageListDto[];

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string;
    items: ApplicationLanguageListDto[];
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (let item of data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (let item of data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto = new ApplicationLanguageEditDto();

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class P32DocumentDto implements IP32DocumentDto {
    bookingDocumentID: number;
    sendDateUndangan: moment.Moment;
    nextDatePeringatan: moment.Moment;
    lastDatePeringatan: moment.Moment;
    block: string;
    tower: string;
    clusterNameLama: string;
    clusterNameBaru: string;
    clusterName: string;
    tglSerahTerima2: string;
    terbilangGracePeriod: string;
    unitCodeLama: string;
    unitCodeBaru: string;
    unitNoLama: string;
    unitNoBaru: string;
    docNoPPPU: string;
    kpLama: string;
    kpBaru: string;
    tanggalKPLama: string;
    tanggalKPBaru: string;
    unitNo: string;
    handphone: string;
    noTelp: string;
    email: string;
    psCode: string;
    noKTP: string;
    alamatKTP: string;
    alamatCorrespondence: string;
    nama: string;
    noNPWP: string;
    pekerjaan: string;
    unitName: string;
    downPayment: string;
    dueDate: string;
    memberCode: string;
    memberName: string;
    noHPSales: string;
    emailSales: string;
    cluster: string;
    road: string;
    lampiran: string;
    pembeli: string;
    pengembang: string;
    orderID: number;
    unitID: number;
    unitCode: string;
    documentType: string;
    handOverPeriod: string;
    gracePeriod: string;
    gracePeriod2: string;
    specialCicilan: string;
    specialCicilanAmount: string;
    virtualAccountNumber: string;
    company: CompanyDto;
    bookCode: string;
    bookingHeaderID: number;
    cancelDate: moment.Moment;
    bookDate: moment.Moment;
    categoryID: number;
    categoryName: string;
    companyID: number;
    typeOfProcuration: string;
    nameOfProcuration: string;
    ppNo: string;
    ppDate: string;
    orderCode: string;
    orderDate: string;
    docNo: string;
    docDate: string;
    printDay: string;
    printDate: string;
    printTanggal: string;
    printBulan: string;
    printTahun: string;
    kadasterErrorMessage: string;
    tandaTerimaNo: string;
    emailPesanan: string;
    logoProject: string;
    docDatePPPU: string;
    isTandaTerima: boolean;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    bankName: string;
    virtualAccount: string;
    linkP3U: string;
    signCustImage: string;
    parafCustImage: string;
    signCustByteImage: string;
    parafCustByteImage: string;
    signByteImage1: string;
    signByteImage2: string;
    parafByteImage1: string;
    parafByteImage2: string;
    kp: KonfirmasiPesananDto;
    kadasterType: string;
    blockName: string;
    towerName: string;
    isGenerateBySystem: boolean;
    imageKadaster: string;
    imageSpesifikasiUnit: string;
    kadasterCode: string;
    termBookingHeaderID: number;
    komplek: string;
    marketingFloor: string;
    luas: string;
    luasrenov: string;
    luastanah: string;
    luasbangunan: string;
    renovName: string;
    tipe: string;
    qrCodeBase64: string;
    physicalPath: string[];
    singlePath: string;
    htmlText: string;
    peruntukan: string;
    plafond: string;
    hargaUnit: string;
    dp: string;
    tenor: string;
    sukuBunga: string;
    angsuran1: string;
    luasTB: string;
    jaminan: string;
    pemilikJaminan: string;
    status: string;
    namaPasangan: string;
    namaDebitor: string;
    alamat: string;
    spouse: string;
    terbilangPLD: string;
    terbilangTenor: string;
    terbilangBunga: string;
    provisi: string;
    denda: string;
    tanggalOL: string;
    docCode: string;
    plafond2: string;
    tenor2: string;
    sukuBunga2: string;
    terbilangSukuBunga2: string;
    terbilangTenor2: string;
    terbilangPlafond2: string;
    angsuran2: string;
    sukuBungaTahun: string;
    pppuDocNo: string;
    pppuDate: string;
    unitType: string;
    dpPaid: string;
    dpPaymentDate: string;
    clPrintDate: string;
    htmlDocument: string;
    invitationDate: string;
    invitationTime: string;
    projectID: number;
    projectCode: string;
    clusterID: number;
    city: string;
    place: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    emailUNST1: string;
    emailDate1: string;
    docNoBAST: string;
    docDateBAST: string;
    docNoUNST1: string;
    docDateUNST1: string;
    emailUNST2: string;
    emailDate2: string;
    docNoUNST2: string;
    docDateUNST2: string;
    emailUNST3: string;
    emailDate3: string;
    docNoUNST3: string;
    docDateUNST3: string;
    signatureDate: string;
    expiredDate: string;
    procurationDate: string;
    penaltyRate: string;
    penaltyAmount: string;
    floor: string;
    prevUnitNo: string;
    detailCode: string;
    printDayString: string;
    printMonthString: string;
    printYearString: string;
    legalOffice: string;
    areaName: string;
    permitLocation: string;
    projectName: string;
    occupation: string;
    docNoKontatib: string;
    detailName: string;
    noHPBilling: string;
    noHP: string;
    noKantor: string;
    noRumah: string;
    termRemarks: string;
    docNoPTT: string;
    projectAddress: string;
    tujuanTransaksi: string;
    tglSerahTerimaNew: string;
    cicilanHtml: string;
    termID: number;
    renovID: number;
    grossprice: string;
    discwft: string;
    netNetPrice: string;
    netNetPrices: number;
    ppn: string;
    sellingPrice: string;
    sellingPrices: number;
    biayaSertifikat: string;
    totalDenganSertifikat: string;
    vat: number;
    vatBF: number;
    netBF: number;
    amtBF: number;
    bookingFee: string;
    bookingFeeDate: string;
    persenDP: number;
    totalAmtDP: string;
    totalNetDP: string;
    totalVatDP: string;
    listDP: ListDownPayment[];
    listCicilan: ListCicilanDto[];
    scheduleSubsidi: ListCicilanDto;
    luastanahTerbilang: string;
    luasbangunanTerbilang: string;
    sellingPriceTerbilang: string;
    totalPayment: string;
    totalPaymentTerbilang: string;
    persenPayment: string;
    outstandingAmount: string;
    outstandingTerbilang: string;
    outstandingSchedule: number;
    lastDueDate: string;
    image: string;
    sadEmail: string;
    sadContact: string;
    sadPhone: string;
    coCode: string;
    coName: string;
    coAddress: string;
    coPhone: string;
    website: string;
    legaloffice: string;
    termRemarksOld: string;
    namaOld: string;
    occupationOld: string;
    handphoneOld: string;
    emailOld: string;
    noKTPOld: string;
    alamatKTPOld: string;
    alamatCorrespondenceOld: string;
    adminFee: string;
    adminFeeString: string;
    adminFeeNet: string;
    adminFeeNetString: string;
    adminFeeVat: string;
    adminFeeVatString: string;
    adminFeeAmt: string;
    adminFeeAmtString: string;
    clusterCode: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    alamatNotaris: string;
    checklistBiayaPenitipan: boolean;
    biayaPenitipanSertifikat: string;
    footer: string;
    ajbkprWord: string;
    docDateIndoFormat: string;
    bookingBankName: string;
    docNoAjb1: string;
    docDateAjb1: string;
    docNoAjb2: string;
    docDateAjb2: string;
    emailAjb1Date: string;
    emailAjb2Date: string;
    emailAjb3Date: string;
    ajbMaxSignDate: string;
    bphtb: number;
    balikNama: number;
    ajbNotaris: number;
    pnpb: number;
    pajakAtasBangunan: number;
    cekSertipikat: number;
    validasiPajak: number;
    total: number;
    biayaPenyimpananSertifikat: number;
    str_bphtb: string;
    str_balikNama: string;
    str_ajbNotaris: string;
    str_pnpb: string;
    str_pajakAtasBangunan: string;
    str_cekSertipikat: string;
    str_validasiPajak: string;
    str_total: string;
    str_biayaPenyimpananSertipikat: string;
    printDayAJB: string;
    printDateAJB: string;
    picClusterAJB: string;
    picClusterEmailAJB: string;
    tglUndanganPPPU: string;
    lampPPPU: string;
    userID: number;
    fileLampiranPPPU: string;
    logoCompany: string;
    bodyTemplatePJPKK: string;
    termRemarksHal2: string;
    netNetPriceHal2: string;
    ppnHal2: string;
    dpHal2: string;
    sellingPriceHal2: string;
    cicilanHtmlHal2: string;
    ppjbNoOld: string;
    ppjbDateOLD: string;

    constructor(data?: IP32DocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentID = data["bookingDocumentID"];
            this.sendDateUndangan = data["sendDateUndangan"] ? moment(data["sendDateUndangan"].toString()) : <any>undefined;
            this.nextDatePeringatan = data["nextDatePeringatan"] ? moment(data["nextDatePeringatan"].toString()) : <any>undefined;
            this.lastDatePeringatan = data["lastDatePeringatan"] ? moment(data["lastDatePeringatan"].toString()) : <any>undefined;
            this.block = data["block"];
            this.tower = data["tower"];
            this.clusterNameLama = data["clusterNameLama"];
            this.clusterNameBaru = data["clusterNameBaru"];
            this.clusterName = data["clusterName"];
            this.tglSerahTerima2 = data["tglSerahTerima2"];
            this.terbilangGracePeriod = data["terbilangGracePeriod"];
            this.unitCodeLama = data["unitCodeLama"];
            this.unitCodeBaru = data["unitCodeBaru"];
            this.unitNoLama = data["unitNoLama"];
            this.unitNoBaru = data["unitNoBaru"];
            this.docNoPPPU = data["docNoPPPU"];
            this.kpLama = data["kpLama"];
            this.kpBaru = data["kpBaru"];
            this.tanggalKPLama = data["tanggalKPLama"];
            this.tanggalKPBaru = data["tanggalKPBaru"];
            this.unitNo = data["unitNo"];
            this.handphone = data["handphone"];
            this.noTelp = data["noTelp"];
            this.email = data["email"];
            this.psCode = data["psCode"];
            this.noKTP = data["noKTP"];
            this.alamatKTP = data["alamatKTP"];
            this.alamatCorrespondence = data["alamatCorrespondence"];
            this.nama = data["nama"];
            this.noNPWP = data["noNPWP"];
            this.pekerjaan = data["pekerjaan"];
            this.unitName = data["unitName"];
            this.downPayment = data["downPayment"];
            this.dueDate = data["dueDate"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.noHPSales = data["noHPSales"];
            this.emailSales = data["emailSales"];
            this.cluster = data["cluster"];
            this.road = data["road"];
            this.lampiran = data["lampiran"];
            this.pembeli = data["pembeli"];
            this.pengembang = data["pengembang"];
            this.orderID = data["orderID"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.documentType = data["documentType"];
            this.handOverPeriod = data["handOverPeriod"];
            this.gracePeriod = data["gracePeriod"];
            this.gracePeriod2 = data["gracePeriod2"];
            this.specialCicilan = data["specialCicilan"];
            this.specialCicilanAmount = data["specialCicilanAmount"];
            this.virtualAccountNumber = data["virtualAccountNumber"];
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
            this.companyID = data["companyID"];
            this.typeOfProcuration = data["typeOfProcuration"];
            this.nameOfProcuration = data["nameOfProcuration"];
            this.ppNo = data["ppNo"];
            this.ppDate = data["ppDate"];
            this.orderCode = data["orderCode"];
            this.orderDate = data["orderDate"];
            this.docNo = data["docNo"];
            this.docDate = data["docDate"];
            this.printDay = data["printDay"];
            this.printDate = data["printDate"];
            this.printTanggal = data["printTanggal"];
            this.printBulan = data["printBulan"];
            this.printTahun = data["printTahun"];
            this.kadasterErrorMessage = data["kadasterErrorMessage"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.emailPesanan = data["emailPesanan"];
            this.logoProject = data["logoProject"];
            this.docDatePPPU = data["docDatePPPU"];
            this.isTandaTerima = data["isTandaTerima"];
            this.kuasaDireksiPeopleName1 = data["kuasaDireksiPeopleName1"];
            this.kuasaDireksiPeopleName2 = data["kuasaDireksiPeopleName2"];
            this.signatureImage1 = data["signatureImage1"];
            this.signatureImage2 = data["signatureImage2"];
            this.parafImage1 = data["parafImage1"];
            this.parafImage2 = data["parafImage2"];
            this.position1 = data["position1"];
            this.position2 = data["position2"];
            this.bankName = data["bankName"];
            this.virtualAccount = data["virtualAccount"];
            this.linkP3U = data["linkP3U"];
            this.signCustImage = data["signCustImage"];
            this.parafCustImage = data["parafCustImage"];
            this.signCustByteImage = data["signCustByteImage"];
            this.parafCustByteImage = data["parafCustByteImage"];
            this.signByteImage1 = data["signByteImage1"];
            this.signByteImage2 = data["signByteImage2"];
            this.parafByteImage1 = data["parafByteImage1"];
            this.parafByteImage2 = data["parafByteImage2"];
            this.kp = data["kp"] ? KonfirmasiPesananDto.fromJS(data["kp"]) : <any>undefined;
            this.kadasterType = data["kadasterType"];
            this.blockName = data["blockName"];
            this.towerName = data["towerName"];
            this.isGenerateBySystem = data["isGenerateBySystem"];
            this.imageKadaster = data["imageKadaster"];
            this.imageSpesifikasiUnit = data["imageSpesifikasiUnit"];
            this.kadasterCode = data["kadasterCode"];
            this.termBookingHeaderID = data["termBookingHeaderID"];
            this.komplek = data["komplek"];
            this.marketingFloor = data["marketingFloor"];
            this.luas = data["luas"];
            this.luasrenov = data["luasrenov"];
            this.luastanah = data["luastanah"];
            this.luasbangunan = data["luasbangunan"];
            this.renovName = data["renovName"];
            this.tipe = data["tipe"];
            this.qrCodeBase64 = data["qrCodeBase64"];
            if (data["physicalPath"] && data["physicalPath"].constructor === Array) {
                this.physicalPath = [];
                for (let item of data["physicalPath"])
                    this.physicalPath.push(item);
            }
            this.singlePath = data["singlePath"];
            this.htmlText = data["htmlText"];
            this.peruntukan = data["peruntukan"];
            this.plafond = data["plafond"];
            this.hargaUnit = data["hargaUnit"];
            this.dp = data["dp"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.angsuran1 = data["angsuran1"];
            this.luasTB = data["luasTB"];
            this.jaminan = data["jaminan"];
            this.pemilikJaminan = data["pemilikJaminan"];
            this.status = data["status"];
            this.namaPasangan = data["namaPasangan"];
            this.namaDebitor = data["namaDebitor"];
            this.alamat = data["alamat"];
            this.spouse = data["spouse"];
            this.terbilangPLD = data["terbilangPLD"];
            this.terbilangTenor = data["terbilangTenor"];
            this.terbilangBunga = data["terbilangBunga"];
            this.provisi = data["provisi"];
            this.denda = data["denda"];
            this.tanggalOL = data["tanggalOL"];
            this.docCode = data["docCode"];
            this.plafond2 = data["plafond2"];
            this.tenor2 = data["tenor2"];
            this.sukuBunga2 = data["sukuBunga2"];
            this.terbilangSukuBunga2 = data["terbilangSukuBunga2"];
            this.terbilangTenor2 = data["terbilangTenor2"];
            this.terbilangPlafond2 = data["terbilangPlafond2"];
            this.angsuran2 = data["angsuran2"];
            this.sukuBungaTahun = data["sukuBungaTahun"];
            this.pppuDocNo = data["pppuDocNo"];
            this.pppuDate = data["pppuDate"];
            this.unitType = data["unitType"];
            this.dpPaid = data["dpPaid"];
            this.dpPaymentDate = data["dpPaymentDate"];
            this.clPrintDate = data["clPrintDate"];
            this.htmlDocument = data["htmlDocument"];
            this.invitationDate = data["invitationDate"];
            this.invitationTime = data["invitationTime"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.clusterID = data["clusterID"];
            this.city = data["city"];
            this.place = data["place"];
            this.picName = data["picName"];
            this.picPhone = data["picPhone"];
            this.picEmail = data["picEmail"];
            this.emailUNST1 = data["emailUNST1"];
            this.emailDate1 = data["emailDate1"];
            this.docNoBAST = data["docNoBAST"];
            this.docDateBAST = data["docDateBAST"];
            this.docNoUNST1 = data["docNoUNST1"];
            this.docDateUNST1 = data["docDateUNST1"];
            this.emailUNST2 = data["emailUNST2"];
            this.emailDate2 = data["emailDate2"];
            this.docNoUNST2 = data["docNoUNST2"];
            this.docDateUNST2 = data["docDateUNST2"];
            this.emailUNST3 = data["emailUNST3"];
            this.emailDate3 = data["emailDate3"];
            this.docNoUNST3 = data["docNoUNST3"];
            this.docDateUNST3 = data["docDateUNST3"];
            this.signatureDate = data["signatureDate"];
            this.expiredDate = data["expiredDate"];
            this.procurationDate = data["procurationDate"];
            this.penaltyRate = data["penaltyRate"];
            this.penaltyAmount = data["penaltyAmount"];
            this.floor = data["floor"];
            this.prevUnitNo = data["prevUnitNo"];
            this.detailCode = data["detailCode"];
            this.printDayString = data["printDayString"];
            this.printMonthString = data["printMonthString"];
            this.printYearString = data["printYearString"];
            this.legalOffice = data["legalOffice"];
            this.areaName = data["areaName"];
            this.permitLocation = data["permitLocation"];
            this.projectName = data["projectName"];
            this.occupation = data["occupation"];
            this.docNoKontatib = data["docNoKontatib"];
            this.detailName = data["detailName"];
            this.noHPBilling = data["noHPBilling"];
            this.noHP = data["noHP"];
            this.noKantor = data["noKantor"];
            this.noRumah = data["noRumah"];
            this.termRemarks = data["termRemarks"];
            this.docNoPTT = data["docNoPTT"];
            this.projectAddress = data["projectAddress"];
            this.tujuanTransaksi = data["tujuanTransaksi"];
            this.tglSerahTerimaNew = data["tglSerahTerimaNew"];
            this.cicilanHtml = data["cicilanHtml"];
            this.termID = data["termID"];
            this.renovID = data["renovID"];
            this.grossprice = data["grossprice"];
            this.discwft = data["discwft"];
            this.netNetPrice = data["netNetPrice"];
            this.netNetPrices = data["netNetPrices"];
            this.ppn = data["ppn"];
            this.sellingPrice = data["sellingPrice"];
            this.sellingPrices = data["sellingPrices"];
            this.biayaSertifikat = data["biayaSertifikat"];
            this.totalDenganSertifikat = data["totalDenganSertifikat"];
            this.vat = data["vat"];
            this.vatBF = data["vatBF"];
            this.netBF = data["netBF"];
            this.amtBF = data["amtBF"];
            this.bookingFee = data["bookingFee"];
            this.bookingFeeDate = data["bookingFeeDate"];
            this.persenDP = data["persenDP"];
            this.totalAmtDP = data["totalAmtDP"];
            this.totalNetDP = data["totalNetDP"];
            this.totalVatDP = data["totalVatDP"];
            if (data["listDP"] && data["listDP"].constructor === Array) {
                this.listDP = [];
                for (let item of data["listDP"])
                    this.listDP.push(ListDownPayment.fromJS(item));
            }
            if (data["listCicilan"] && data["listCicilan"].constructor === Array) {
                this.listCicilan = [];
                for (let item of data["listCicilan"])
                    this.listCicilan.push(ListCicilanDto.fromJS(item));
            }
            this.scheduleSubsidi = data["scheduleSubsidi"] ? ListCicilanDto.fromJS(data["scheduleSubsidi"]) : <any>undefined;
            this.luastanahTerbilang = data["luastanahTerbilang"];
            this.luasbangunanTerbilang = data["luasbangunanTerbilang"];
            this.sellingPriceTerbilang = data["sellingPriceTerbilang"];
            this.totalPayment = data["totalPayment"];
            this.totalPaymentTerbilang = data["totalPaymentTerbilang"];
            this.persenPayment = data["persenPayment"];
            this.outstandingAmount = data["outstandingAmount"];
            this.outstandingTerbilang = data["outstandingTerbilang"];
            this.outstandingSchedule = data["outstandingSchedule"];
            this.lastDueDate = data["lastDueDate"];
            this.image = data["image"];
            this.sadEmail = data["sadEmail"];
            this.sadContact = data["sadContact"];
            this.sadPhone = data["sadPhone"];
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.coAddress = data["coAddress"];
            this.coPhone = data["coPhone"];
            this.website = data["website"];
            this.legaloffice = data["legaloffice"];
            this.termRemarksOld = data["termRemarksOld"];
            this.namaOld = data["namaOld"];
            this.occupationOld = data["occupationOld"];
            this.handphoneOld = data["handphoneOld"];
            this.emailOld = data["emailOld"];
            this.noKTPOld = data["noKTPOld"];
            this.alamatKTPOld = data["alamatKTPOld"];
            this.alamatCorrespondenceOld = data["alamatCorrespondenceOld"];
            this.adminFee = data["adminFee"];
            this.adminFeeString = data["adminFeeString"];
            this.adminFeeNet = data["adminFeeNet"];
            this.adminFeeNetString = data["adminFeeNetString"];
            this.adminFeeVat = data["adminFeeVat"];
            this.adminFeeVatString = data["adminFeeVatString"];
            this.adminFeeAmt = data["adminFeeAmt"];
            this.adminFeeAmtString = data["adminFeeAmtString"];
            this.clusterCode = data["clusterCode"];
            this.notarisID = data["notarisID"];
            this.namaNotaris = data["namaNotaris"];
            this.telpNotaris = data["telpNotaris"];
            this.staffNotaris = data["staffNotaris"];
            this.emailNotaris = data["emailNotaris"];
            this.emailPICBank = data["emailPICBank"];
            this.alamatNotaris = data["alamatNotaris"];
            this.checklistBiayaPenitipan = data["checklistBiayaPenitipan"];
            this.biayaPenitipanSertifikat = data["biayaPenitipanSertifikat"];
            this.footer = data["footer"];
            this.ajbkprWord = data["ajbkprWord"];
            this.docDateIndoFormat = data["docDateIndoFormat"];
            this.bookingBankName = data["bookingBankName"];
            this.docNoAjb1 = data["docNoAjb1"];
            this.docDateAjb1 = data["docDateAjb1"];
            this.docNoAjb2 = data["docNoAjb2"];
            this.docDateAjb2 = data["docDateAjb2"];
            this.emailAjb1Date = data["emailAjb1Date"];
            this.emailAjb2Date = data["emailAjb2Date"];
            this.emailAjb3Date = data["emailAjb3Date"];
            this.ajbMaxSignDate = data["ajbMaxSignDate"];
            this.bphtb = data["bphtb"];
            this.balikNama = data["balikNama"];
            this.ajbNotaris = data["ajbNotaris"];
            this.pnpb = data["pnpb"];
            this.pajakAtasBangunan = data["pajakAtasBangunan"];
            this.cekSertipikat = data["cekSertipikat"];
            this.validasiPajak = data["validasiPajak"];
            this.total = data["total"];
            this.biayaPenyimpananSertifikat = data["biayaPenyimpananSertifikat"];
            this.str_bphtb = data["str_bphtb"];
            this.str_balikNama = data["str_balikNama"];
            this.str_ajbNotaris = data["str_ajbNotaris"];
            this.str_pnpb = data["str_pnpb"];
            this.str_pajakAtasBangunan = data["str_pajakAtasBangunan"];
            this.str_cekSertipikat = data["str_cekSertipikat"];
            this.str_validasiPajak = data["str_validasiPajak"];
            this.str_total = data["str_total"];
            this.str_biayaPenyimpananSertipikat = data["str_biayaPenyimpananSertipikat"];
            this.printDayAJB = data["printDayAJB"];
            this.printDateAJB = data["printDateAJB"];
            this.picClusterAJB = data["picClusterAJB"];
            this.picClusterEmailAJB = data["picClusterEmailAJB"];
            this.tglUndanganPPPU = data["tglUndanganPPPU"];
            this.lampPPPU = data["lampPPPU"];
            this.userID = data["userID"];
            this.fileLampiranPPPU = data["fileLampiranPPPU"];
            this.logoCompany = data["logoCompany"];
            this.bodyTemplatePJPKK = data["bodyTemplatePJPKK"];
            this.termRemarksHal2 = data["termRemarksHal2"];
            this.netNetPriceHal2 = data["netNetPriceHal2"];
            this.ppnHal2 = data["ppnHal2"];
            this.dpHal2 = data["dpHal2"];
            this.sellingPriceHal2 = data["sellingPriceHal2"];
            this.cicilanHtmlHal2 = data["cicilanHtmlHal2"];
            this.ppjbNoOld = data["ppjbNoOld"];
            this.ppjbDateOLD = data["ppjbDateOLD"];
        }
    }

    static fromJS(data: any): P32DocumentDto {
        let result = new P32DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["sendDateUndangan"] = this.sendDateUndangan ? this.sendDateUndangan.toISOString() : <any>undefined;
        data["nextDatePeringatan"] = this.nextDatePeringatan ? this.nextDatePeringatan.toISOString() : <any>undefined;
        data["lastDatePeringatan"] = this.lastDatePeringatan ? this.lastDatePeringatan.toISOString() : <any>undefined;
        data["block"] = this.block;
        data["tower"] = this.tower;
        data["clusterNameLama"] = this.clusterNameLama;
        data["clusterNameBaru"] = this.clusterNameBaru;
        data["clusterName"] = this.clusterName;
        data["tglSerahTerima2"] = this.tglSerahTerima2;
        data["terbilangGracePeriod"] = this.terbilangGracePeriod;
        data["unitCodeLama"] = this.unitCodeLama;
        data["unitCodeBaru"] = this.unitCodeBaru;
        data["unitNoLama"] = this.unitNoLama;
        data["unitNoBaru"] = this.unitNoBaru;
        data["docNoPPPU"] = this.docNoPPPU;
        data["kpLama"] = this.kpLama;
        data["kpBaru"] = this.kpBaru;
        data["tanggalKPLama"] = this.tanggalKPLama;
        data["tanggalKPBaru"] = this.tanggalKPBaru;
        data["unitNo"] = this.unitNo;
        data["handphone"] = this.handphone;
        data["noTelp"] = this.noTelp;
        data["email"] = this.email;
        data["psCode"] = this.psCode;
        data["noKTP"] = this.noKTP;
        data["alamatKTP"] = this.alamatKTP;
        data["alamatCorrespondence"] = this.alamatCorrespondence;
        data["nama"] = this.nama;
        data["noNPWP"] = this.noNPWP;
        data["pekerjaan"] = this.pekerjaan;
        data["unitName"] = this.unitName;
        data["downPayment"] = this.downPayment;
        data["dueDate"] = this.dueDate;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["noHPSales"] = this.noHPSales;
        data["emailSales"] = this.emailSales;
        data["cluster"] = this.cluster;
        data["road"] = this.road;
        data["lampiran"] = this.lampiran;
        data["pembeli"] = this.pembeli;
        data["pengembang"] = this.pengembang;
        data["orderID"] = this.orderID;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["documentType"] = this.documentType;
        data["handOverPeriod"] = this.handOverPeriod;
        data["gracePeriod"] = this.gracePeriod;
        data["gracePeriod2"] = this.gracePeriod2;
        data["specialCicilan"] = this.specialCicilan;
        data["specialCicilanAmount"] = this.specialCicilanAmount;
        data["virtualAccountNumber"] = this.virtualAccountNumber;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        data["companyID"] = this.companyID;
        data["typeOfProcuration"] = this.typeOfProcuration;
        data["nameOfProcuration"] = this.nameOfProcuration;
        data["ppNo"] = this.ppNo;
        data["ppDate"] = this.ppDate;
        data["orderCode"] = this.orderCode;
        data["orderDate"] = this.orderDate;
        data["docNo"] = this.docNo;
        data["docDate"] = this.docDate;
        data["printDay"] = this.printDay;
        data["printDate"] = this.printDate;
        data["printTanggal"] = this.printTanggal;
        data["printBulan"] = this.printBulan;
        data["printTahun"] = this.printTahun;
        data["kadasterErrorMessage"] = this.kadasterErrorMessage;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["emailPesanan"] = this.emailPesanan;
        data["logoProject"] = this.logoProject;
        data["docDatePPPU"] = this.docDatePPPU;
        data["isTandaTerima"] = this.isTandaTerima;
        data["kuasaDireksiPeopleName1"] = this.kuasaDireksiPeopleName1;
        data["kuasaDireksiPeopleName2"] = this.kuasaDireksiPeopleName2;
        data["signatureImage1"] = this.signatureImage1;
        data["signatureImage2"] = this.signatureImage2;
        data["parafImage1"] = this.parafImage1;
        data["parafImage2"] = this.parafImage2;
        data["position1"] = this.position1;
        data["position2"] = this.position2;
        data["bankName"] = this.bankName;
        data["virtualAccount"] = this.virtualAccount;
        data["linkP3U"] = this.linkP3U;
        data["signCustImage"] = this.signCustImage;
        data["parafCustImage"] = this.parafCustImage;
        data["signCustByteImage"] = this.signCustByteImage;
        data["parafCustByteImage"] = this.parafCustByteImage;
        data["signByteImage1"] = this.signByteImage1;
        data["signByteImage2"] = this.signByteImage2;
        data["parafByteImage1"] = this.parafByteImage1;
        data["parafByteImage2"] = this.parafByteImage2;
        data["kp"] = this.kp ? this.kp.toJSON() : <any>undefined;
        data["kadasterType"] = this.kadasterType;
        data["blockName"] = this.blockName;
        data["towerName"] = this.towerName;
        data["isGenerateBySystem"] = this.isGenerateBySystem;
        data["imageKadaster"] = this.imageKadaster;
        data["imageSpesifikasiUnit"] = this.imageSpesifikasiUnit;
        data["kadasterCode"] = this.kadasterCode;
        data["termBookingHeaderID"] = this.termBookingHeaderID;
        data["komplek"] = this.komplek;
        data["marketingFloor"] = this.marketingFloor;
        data["luas"] = this.luas;
        data["luasrenov"] = this.luasrenov;
        data["luastanah"] = this.luastanah;
        data["luasbangunan"] = this.luasbangunan;
        data["renovName"] = this.renovName;
        data["tipe"] = this.tipe;
        data["qrCodeBase64"] = this.qrCodeBase64;
        if (this.physicalPath && this.physicalPath.constructor === Array) {
            data["physicalPath"] = [];
            for (let item of this.physicalPath)
                data["physicalPath"].push(item);
        }
        data["singlePath"] = this.singlePath;
        data["htmlText"] = this.htmlText;
        data["peruntukan"] = this.peruntukan;
        data["plafond"] = this.plafond;
        data["hargaUnit"] = this.hargaUnit;
        data["dp"] = this.dp;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["angsuran1"] = this.angsuran1;
        data["luasTB"] = this.luasTB;
        data["jaminan"] = this.jaminan;
        data["pemilikJaminan"] = this.pemilikJaminan;
        data["status"] = this.status;
        data["namaPasangan"] = this.namaPasangan;
        data["namaDebitor"] = this.namaDebitor;
        data["alamat"] = this.alamat;
        data["spouse"] = this.spouse;
        data["terbilangPLD"] = this.terbilangPLD;
        data["terbilangTenor"] = this.terbilangTenor;
        data["terbilangBunga"] = this.terbilangBunga;
        data["provisi"] = this.provisi;
        data["denda"] = this.denda;
        data["tanggalOL"] = this.tanggalOL;
        data["docCode"] = this.docCode;
        data["plafond2"] = this.plafond2;
        data["tenor2"] = this.tenor2;
        data["sukuBunga2"] = this.sukuBunga2;
        data["terbilangSukuBunga2"] = this.terbilangSukuBunga2;
        data["terbilangTenor2"] = this.terbilangTenor2;
        data["terbilangPlafond2"] = this.terbilangPlafond2;
        data["angsuran2"] = this.angsuran2;
        data["sukuBungaTahun"] = this.sukuBungaTahun;
        data["pppuDocNo"] = this.pppuDocNo;
        data["pppuDate"] = this.pppuDate;
        data["unitType"] = this.unitType;
        data["dpPaid"] = this.dpPaid;
        data["dpPaymentDate"] = this.dpPaymentDate;
        data["clPrintDate"] = this.clPrintDate;
        data["htmlDocument"] = this.htmlDocument;
        data["invitationDate"] = this.invitationDate;
        data["invitationTime"] = this.invitationTime;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["clusterID"] = this.clusterID;
        data["city"] = this.city;
        data["place"] = this.place;
        data["picName"] = this.picName;
        data["picPhone"] = this.picPhone;
        data["picEmail"] = this.picEmail;
        data["emailUNST1"] = this.emailUNST1;
        data["emailDate1"] = this.emailDate1;
        data["docNoBAST"] = this.docNoBAST;
        data["docDateBAST"] = this.docDateBAST;
        data["docNoUNST1"] = this.docNoUNST1;
        data["docDateUNST1"] = this.docDateUNST1;
        data["emailUNST2"] = this.emailUNST2;
        data["emailDate2"] = this.emailDate2;
        data["docNoUNST2"] = this.docNoUNST2;
        data["docDateUNST2"] = this.docDateUNST2;
        data["emailUNST3"] = this.emailUNST3;
        data["emailDate3"] = this.emailDate3;
        data["docNoUNST3"] = this.docNoUNST3;
        data["docDateUNST3"] = this.docDateUNST3;
        data["signatureDate"] = this.signatureDate;
        data["expiredDate"] = this.expiredDate;
        data["procurationDate"] = this.procurationDate;
        data["penaltyRate"] = this.penaltyRate;
        data["penaltyAmount"] = this.penaltyAmount;
        data["floor"] = this.floor;
        data["prevUnitNo"] = this.prevUnitNo;
        data["detailCode"] = this.detailCode;
        data["printDayString"] = this.printDayString;
        data["printMonthString"] = this.printMonthString;
        data["printYearString"] = this.printYearString;
        data["legalOffice"] = this.legalOffice;
        data["areaName"] = this.areaName;
        data["permitLocation"] = this.permitLocation;
        data["projectName"] = this.projectName;
        data["occupation"] = this.occupation;
        data["docNoKontatib"] = this.docNoKontatib;
        data["detailName"] = this.detailName;
        data["noHPBilling"] = this.noHPBilling;
        data["noHP"] = this.noHP;
        data["noKantor"] = this.noKantor;
        data["noRumah"] = this.noRumah;
        data["termRemarks"] = this.termRemarks;
        data["docNoPTT"] = this.docNoPTT;
        data["projectAddress"] = this.projectAddress;
        data["tujuanTransaksi"] = this.tujuanTransaksi;
        data["tglSerahTerimaNew"] = this.tglSerahTerimaNew;
        data["cicilanHtml"] = this.cicilanHtml;
        data["termID"] = this.termID;
        data["renovID"] = this.renovID;
        data["grossprice"] = this.grossprice;
        data["discwft"] = this.discwft;
        data["netNetPrice"] = this.netNetPrice;
        data["netNetPrices"] = this.netNetPrices;
        data["ppn"] = this.ppn;
        data["sellingPrice"] = this.sellingPrice;
        data["sellingPrices"] = this.sellingPrices;
        data["biayaSertifikat"] = this.biayaSertifikat;
        data["totalDenganSertifikat"] = this.totalDenganSertifikat;
        data["vat"] = this.vat;
        data["vatBF"] = this.vatBF;
        data["netBF"] = this.netBF;
        data["amtBF"] = this.amtBF;
        data["bookingFee"] = this.bookingFee;
        data["bookingFeeDate"] = this.bookingFeeDate;
        data["persenDP"] = this.persenDP;
        data["totalAmtDP"] = this.totalAmtDP;
        data["totalNetDP"] = this.totalNetDP;
        data["totalVatDP"] = this.totalVatDP;
        if (this.listDP && this.listDP.constructor === Array) {
            data["listDP"] = [];
            for (let item of this.listDP)
                data["listDP"].push(item.toJSON());
        }
        if (this.listCicilan && this.listCicilan.constructor === Array) {
            data["listCicilan"] = [];
            for (let item of this.listCicilan)
                data["listCicilan"].push(item.toJSON());
        }
        data["scheduleSubsidi"] = this.scheduleSubsidi ? this.scheduleSubsidi.toJSON() : <any>undefined;
        data["luastanahTerbilang"] = this.luastanahTerbilang;
        data["luasbangunanTerbilang"] = this.luasbangunanTerbilang;
        data["sellingPriceTerbilang"] = this.sellingPriceTerbilang;
        data["totalPayment"] = this.totalPayment;
        data["totalPaymentTerbilang"] = this.totalPaymentTerbilang;
        data["persenPayment"] = this.persenPayment;
        data["outstandingAmount"] = this.outstandingAmount;
        data["outstandingTerbilang"] = this.outstandingTerbilang;
        data["outstandingSchedule"] = this.outstandingSchedule;
        data["lastDueDate"] = this.lastDueDate;
        data["image"] = this.image;
        data["sadEmail"] = this.sadEmail;
        data["sadContact"] = this.sadContact;
        data["sadPhone"] = this.sadPhone;
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["coAddress"] = this.coAddress;
        data["coPhone"] = this.coPhone;
        data["website"] = this.website;
        data["legaloffice"] = this.legaloffice;
        data["termRemarksOld"] = this.termRemarksOld;
        data["namaOld"] = this.namaOld;
        data["occupationOld"] = this.occupationOld;
        data["handphoneOld"] = this.handphoneOld;
        data["emailOld"] = this.emailOld;
        data["noKTPOld"] = this.noKTPOld;
        data["alamatKTPOld"] = this.alamatKTPOld;
        data["alamatCorrespondenceOld"] = this.alamatCorrespondenceOld;
        data["adminFee"] = this.adminFee;
        data["adminFeeString"] = this.adminFeeString;
        data["adminFeeNet"] = this.adminFeeNet;
        data["adminFeeNetString"] = this.adminFeeNetString;
        data["adminFeeVat"] = this.adminFeeVat;
        data["adminFeeVatString"] = this.adminFeeVatString;
        data["adminFeeAmt"] = this.adminFeeAmt;
        data["adminFeeAmtString"] = this.adminFeeAmtString;
        data["clusterCode"] = this.clusterCode;
        data["notarisID"] = this.notarisID;
        data["namaNotaris"] = this.namaNotaris;
        data["telpNotaris"] = this.telpNotaris;
        data["staffNotaris"] = this.staffNotaris;
        data["emailNotaris"] = this.emailNotaris;
        data["emailPICBank"] = this.emailPICBank;
        data["alamatNotaris"] = this.alamatNotaris;
        data["checklistBiayaPenitipan"] = this.checklistBiayaPenitipan;
        data["biayaPenitipanSertifikat"] = this.biayaPenitipanSertifikat;
        data["footer"] = this.footer;
        data["ajbkprWord"] = this.ajbkprWord;
        data["docDateIndoFormat"] = this.docDateIndoFormat;
        data["bookingBankName"] = this.bookingBankName;
        data["docNoAjb1"] = this.docNoAjb1;
        data["docDateAjb1"] = this.docDateAjb1;
        data["docNoAjb2"] = this.docNoAjb2;
        data["docDateAjb2"] = this.docDateAjb2;
        data["emailAjb1Date"] = this.emailAjb1Date;
        data["emailAjb2Date"] = this.emailAjb2Date;
        data["emailAjb3Date"] = this.emailAjb3Date;
        data["ajbMaxSignDate"] = this.ajbMaxSignDate;
        data["bphtb"] = this.bphtb;
        data["balikNama"] = this.balikNama;
        data["ajbNotaris"] = this.ajbNotaris;
        data["pnpb"] = this.pnpb;
        data["pajakAtasBangunan"] = this.pajakAtasBangunan;
        data["cekSertipikat"] = this.cekSertipikat;
        data["validasiPajak"] = this.validasiPajak;
        data["total"] = this.total;
        data["biayaPenyimpananSertifikat"] = this.biayaPenyimpananSertifikat;
        data["str_bphtb"] = this.str_bphtb;
        data["str_balikNama"] = this.str_balikNama;
        data["str_ajbNotaris"] = this.str_ajbNotaris;
        data["str_pnpb"] = this.str_pnpb;
        data["str_pajakAtasBangunan"] = this.str_pajakAtasBangunan;
        data["str_cekSertipikat"] = this.str_cekSertipikat;
        data["str_validasiPajak"] = this.str_validasiPajak;
        data["str_total"] = this.str_total;
        data["str_biayaPenyimpananSertipikat"] = this.str_biayaPenyimpananSertipikat;
        data["printDayAJB"] = this.printDayAJB;
        data["printDateAJB"] = this.printDateAJB;
        data["picClusterAJB"] = this.picClusterAJB;
        data["picClusterEmailAJB"] = this.picClusterEmailAJB;
        data["tglUndanganPPPU"] = this.tglUndanganPPPU;
        data["lampPPPU"] = this.lampPPPU;
        data["userID"] = this.userID;
        data["fileLampiranPPPU"] = this.fileLampiranPPPU;
        data["logoCompany"] = this.logoCompany;
        data["bodyTemplatePJPKK"] = this.bodyTemplatePJPKK;
        data["termRemarksHal2"] = this.termRemarksHal2;
        data["netNetPriceHal2"] = this.netNetPriceHal2;
        data["ppnHal2"] = this.ppnHal2;
        data["dpHal2"] = this.dpHal2;
        data["sellingPriceHal2"] = this.sellingPriceHal2;
        data["cicilanHtmlHal2"] = this.cicilanHtmlHal2;
        data["ppjbNoOld"] = this.ppjbNoOld;
        data["ppjbDateOLD"] = this.ppjbDateOLD;
        return data; 
    }
}

export interface IP32DocumentDto {
    bookingDocumentID: number;
    sendDateUndangan: moment.Moment;
    nextDatePeringatan: moment.Moment;
    lastDatePeringatan: moment.Moment;
    block: string;
    tower: string;
    clusterNameLama: string;
    clusterNameBaru: string;
    clusterName: string;
    tglSerahTerima2: string;
    terbilangGracePeriod: string;
    unitCodeLama: string;
    unitCodeBaru: string;
    unitNoLama: string;
    unitNoBaru: string;
    docNoPPPU: string;
    kpLama: string;
    kpBaru: string;
    tanggalKPLama: string;
    tanggalKPBaru: string;
    unitNo: string;
    handphone: string;
    noTelp: string;
    email: string;
    psCode: string;
    noKTP: string;
    alamatKTP: string;
    alamatCorrespondence: string;
    nama: string;
    noNPWP: string;
    pekerjaan: string;
    unitName: string;
    downPayment: string;
    dueDate: string;
    memberCode: string;
    memberName: string;
    noHPSales: string;
    emailSales: string;
    cluster: string;
    road: string;
    lampiran: string;
    pembeli: string;
    pengembang: string;
    orderID: number;
    unitID: number;
    unitCode: string;
    documentType: string;
    handOverPeriod: string;
    gracePeriod: string;
    gracePeriod2: string;
    specialCicilan: string;
    specialCicilanAmount: string;
    virtualAccountNumber: string;
    company: CompanyDto;
    bookCode: string;
    bookingHeaderID: number;
    cancelDate: moment.Moment;
    bookDate: moment.Moment;
    categoryID: number;
    categoryName: string;
    companyID: number;
    typeOfProcuration: string;
    nameOfProcuration: string;
    ppNo: string;
    ppDate: string;
    orderCode: string;
    orderDate: string;
    docNo: string;
    docDate: string;
    printDay: string;
    printDate: string;
    printTanggal: string;
    printBulan: string;
    printTahun: string;
    kadasterErrorMessage: string;
    tandaTerimaNo: string;
    emailPesanan: string;
    logoProject: string;
    docDatePPPU: string;
    isTandaTerima: boolean;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    bankName: string;
    virtualAccount: string;
    linkP3U: string;
    signCustImage: string;
    parafCustImage: string;
    signCustByteImage: string;
    parafCustByteImage: string;
    signByteImage1: string;
    signByteImage2: string;
    parafByteImage1: string;
    parafByteImage2: string;
    kp: KonfirmasiPesananDto;
    kadasterType: string;
    blockName: string;
    towerName: string;
    isGenerateBySystem: boolean;
    imageKadaster: string;
    imageSpesifikasiUnit: string;
    kadasterCode: string;
    termBookingHeaderID: number;
    komplek: string;
    marketingFloor: string;
    luas: string;
    luasrenov: string;
    luastanah: string;
    luasbangunan: string;
    renovName: string;
    tipe: string;
    qrCodeBase64: string;
    physicalPath: string[];
    singlePath: string;
    htmlText: string;
    peruntukan: string;
    plafond: string;
    hargaUnit: string;
    dp: string;
    tenor: string;
    sukuBunga: string;
    angsuran1: string;
    luasTB: string;
    jaminan: string;
    pemilikJaminan: string;
    status: string;
    namaPasangan: string;
    namaDebitor: string;
    alamat: string;
    spouse: string;
    terbilangPLD: string;
    terbilangTenor: string;
    terbilangBunga: string;
    provisi: string;
    denda: string;
    tanggalOL: string;
    docCode: string;
    plafond2: string;
    tenor2: string;
    sukuBunga2: string;
    terbilangSukuBunga2: string;
    terbilangTenor2: string;
    terbilangPlafond2: string;
    angsuran2: string;
    sukuBungaTahun: string;
    pppuDocNo: string;
    pppuDate: string;
    unitType: string;
    dpPaid: string;
    dpPaymentDate: string;
    clPrintDate: string;
    htmlDocument: string;
    invitationDate: string;
    invitationTime: string;
    projectID: number;
    projectCode: string;
    clusterID: number;
    city: string;
    place: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    emailUNST1: string;
    emailDate1: string;
    docNoBAST: string;
    docDateBAST: string;
    docNoUNST1: string;
    docDateUNST1: string;
    emailUNST2: string;
    emailDate2: string;
    docNoUNST2: string;
    docDateUNST2: string;
    emailUNST3: string;
    emailDate3: string;
    docNoUNST3: string;
    docDateUNST3: string;
    signatureDate: string;
    expiredDate: string;
    procurationDate: string;
    penaltyRate: string;
    penaltyAmount: string;
    floor: string;
    prevUnitNo: string;
    detailCode: string;
    printDayString: string;
    printMonthString: string;
    printYearString: string;
    legalOffice: string;
    areaName: string;
    permitLocation: string;
    projectName: string;
    occupation: string;
    docNoKontatib: string;
    detailName: string;
    noHPBilling: string;
    noHP: string;
    noKantor: string;
    noRumah: string;
    termRemarks: string;
    docNoPTT: string;
    projectAddress: string;
    tujuanTransaksi: string;
    tglSerahTerimaNew: string;
    cicilanHtml: string;
    termID: number;
    renovID: number;
    grossprice: string;
    discwft: string;
    netNetPrice: string;
    netNetPrices: number;
    ppn: string;
    sellingPrice: string;
    sellingPrices: number;
    biayaSertifikat: string;
    totalDenganSertifikat: string;
    vat: number;
    vatBF: number;
    netBF: number;
    amtBF: number;
    bookingFee: string;
    bookingFeeDate: string;
    persenDP: number;
    totalAmtDP: string;
    totalNetDP: string;
    totalVatDP: string;
    listDP: ListDownPayment[];
    listCicilan: ListCicilanDto[];
    scheduleSubsidi: ListCicilanDto;
    luastanahTerbilang: string;
    luasbangunanTerbilang: string;
    sellingPriceTerbilang: string;
    totalPayment: string;
    totalPaymentTerbilang: string;
    persenPayment: string;
    outstandingAmount: string;
    outstandingTerbilang: string;
    outstandingSchedule: number;
    lastDueDate: string;
    image: string;
    sadEmail: string;
    sadContact: string;
    sadPhone: string;
    coCode: string;
    coName: string;
    coAddress: string;
    coPhone: string;
    website: string;
    legaloffice: string;
    termRemarksOld: string;
    namaOld: string;
    occupationOld: string;
    handphoneOld: string;
    emailOld: string;
    noKTPOld: string;
    alamatKTPOld: string;
    alamatCorrespondenceOld: string;
    adminFee: string;
    adminFeeString: string;
    adminFeeNet: string;
    adminFeeNetString: string;
    adminFeeVat: string;
    adminFeeVatString: string;
    adminFeeAmt: string;
    adminFeeAmtString: string;
    clusterCode: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    alamatNotaris: string;
    checklistBiayaPenitipan: boolean;
    biayaPenitipanSertifikat: string;
    footer: string;
    ajbkprWord: string;
    docDateIndoFormat: string;
    bookingBankName: string;
    docNoAjb1: string;
    docDateAjb1: string;
    docNoAjb2: string;
    docDateAjb2: string;
    emailAjb1Date: string;
    emailAjb2Date: string;
    emailAjb3Date: string;
    ajbMaxSignDate: string;
    bphtb: number;
    balikNama: number;
    ajbNotaris: number;
    pnpb: number;
    pajakAtasBangunan: number;
    cekSertipikat: number;
    validasiPajak: number;
    total: number;
    biayaPenyimpananSertifikat: number;
    str_bphtb: string;
    str_balikNama: string;
    str_ajbNotaris: string;
    str_pnpb: string;
    str_pajakAtasBangunan: string;
    str_cekSertipikat: string;
    str_validasiPajak: string;
    str_total: string;
    str_biayaPenyimpananSertipikat: string;
    printDayAJB: string;
    printDateAJB: string;
    picClusterAJB: string;
    picClusterEmailAJB: string;
    tglUndanganPPPU: string;
    lampPPPU: string;
    userID: number;
    fileLampiranPPPU: string;
    logoCompany: string;
    bodyTemplatePJPKK: string;
    termRemarksHal2: string;
    netNetPriceHal2: string;
    ppnHal2: string;
    dpHal2: string;
    sellingPriceHal2: string;
    cicilanHtmlHal2: string;
    ppjbNoOld: string;
    ppjbDateOLD: string;
}

export class CompanyDto implements ICompanyDto {
    companyName: string;
    sadEmail: string;
    companyAddress: string;
    companyPhone: string;
    companyWebsite: string;
    sadContact: string;
    sadPhone: string;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.sadEmail = data["sadEmail"];
            this.companyAddress = data["companyAddress"];
            this.companyPhone = data["companyPhone"];
            this.companyWebsite = data["companyWebsite"];
            this.sadContact = data["sadContact"];
            this.sadPhone = data["sadPhone"];
        }
    }

    static fromJS(data: any): CompanyDto {
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["sadEmail"] = this.sadEmail;
        data["companyAddress"] = this.companyAddress;
        data["companyPhone"] = this.companyPhone;
        data["companyWebsite"] = this.companyWebsite;
        data["sadContact"] = this.sadContact;
        data["sadPhone"] = this.sadPhone;
        return data; 
    }
}

export interface ICompanyDto {
    companyName: string;
    sadEmail: string;
    companyAddress: string;
    companyPhone: string;
    companyWebsite: string;
    sadContact: string;
    sadPhone: string;
}

export class PDFDataPemenangDto implements IPDFDataPemenangDto {
    startperiode: string;
    endperiode: string;
    rewardName: string;
    namaPemenang: string;
    imageReward: string;
    campaignID: string;
    rewardID: string;
    pscode: string;

    constructor(data?: IPDFDataPemenangDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startperiode = data["startperiode"];
            this.endperiode = data["endperiode"];
            this.rewardName = data["rewardName"];
            this.namaPemenang = data["namaPemenang"];
            this.imageReward = data["imageReward"];
            this.campaignID = data["campaignID"];
            this.rewardID = data["rewardID"];
            this.pscode = data["pscode"];
        }
    }

    static fromJS(data: any): PDFDataPemenangDto {
        let result = new PDFDataPemenangDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startperiode"] = this.startperiode;
        data["endperiode"] = this.endperiode;
        data["rewardName"] = this.rewardName;
        data["namaPemenang"] = this.namaPemenang;
        data["imageReward"] = this.imageReward;
        data["campaignID"] = this.campaignID;
        data["rewardID"] = this.rewardID;
        data["pscode"] = this.pscode;
        return data; 
    }
}

export interface IPDFDataPemenangDto {
    startperiode: string;
    endperiode: string;
    rewardName: string;
    namaPemenang: string;
    imageReward: string;
    campaignID: string;
    rewardID: string;
    pscode: string;
}

export class GetListProductPPDto implements IGetListProductPPDto {
    projectID: number;
    projectInfoId: number;
    productName: string;
    ppAmt: number;
    projectProductID: number;
    projectLogo: string;
    productCode: string;
    projectName: string;
    projectCode: string;

    constructor(data?: IGetListProductPPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectInfoId = data["projectInfoId"];
            this.productName = data["productName"];
            this.ppAmt = data["ppAmt"];
            this.projectProductID = data["projectProductID"];
            this.projectLogo = data["projectLogo"];
            this.productCode = data["productCode"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetListProductPPDto {
        let result = new GetListProductPPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectInfoId"] = this.projectInfoId;
        data["productName"] = this.productName;
        data["ppAmt"] = this.ppAmt;
        data["projectProductID"] = this.projectProductID;
        data["projectLogo"] = this.projectLogo;
        data["productCode"] = this.productCode;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetListProductPPDto {
    projectID: number;
    projectInfoId: number;
    productName: string;
    ppAmt: number;
    projectProductID: number;
    projectLogo: string;
    productCode: string;
    projectName: string;
    projectCode: string;
}

export class ListResultDtoOfGetLkAddrTypeDropdownListDto implements IListResultDtoOfGetLkAddrTypeDropdownListDto {
    items: GetLkAddrTypeDropdownListDto[];

    constructor(data?: IListResultDtoOfGetLkAddrTypeDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetLkAddrTypeDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetLkAddrTypeDropdownListDto {
        let result = new ListResultDtoOfGetLkAddrTypeDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetLkAddrTypeDropdownListDto {
    items: GetLkAddrTypeDropdownListDto[];
}

export class GetLkAddrTypeDropdownListDto implements IGetLkAddrTypeDropdownListDto {
    addrType: string;
    addrTypeName: string;

    constructor(data?: IGetLkAddrTypeDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addrType = data["addrType"];
            this.addrTypeName = data["addrTypeName"];
        }
    }

    static fromJS(data: any): GetLkAddrTypeDropdownListDto {
        let result = new GetLkAddrTypeDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addrType"] = this.addrType;
        data["addrTypeName"] = this.addrTypeName;
        return data; 
    }
}

export interface IGetLkAddrTypeDropdownListDto {
    addrType: string;
    addrTypeName: string;
}

export class ListResultDtoOfGetAllBankTypeListDto implements IListResultDtoOfGetAllBankTypeListDto {
    items: GetAllBankTypeListDto[];

    constructor(data?: IListResultDtoOfGetAllBankTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBankTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllBankTypeListDto {
        let result = new ListResultDtoOfGetAllBankTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllBankTypeListDto {
    items: GetAllBankTypeListDto[];
}

export class GetAllBankTypeListDto implements IGetAllBankTypeListDto {
    bankType: string;
    bankTypeName: string;

    constructor(data?: IGetAllBankTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankType = data["bankType"];
            this.bankTypeName = data["bankTypeName"];
        }
    }

    static fromJS(data: any): GetAllBankTypeListDto {
        let result = new GetAllBankTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankType"] = this.bankType;
        data["bankTypeName"] = this.bankTypeName;
        return data; 
    }
}

export interface IGetAllBankTypeListDto {
    bankType: string;
    bankTypeName: string;
}

export class ListResultDtoOfGetAllBloodListDto implements IListResultDtoOfGetAllBloodListDto {
    items: GetAllBloodListDto[];

    constructor(data?: IListResultDtoOfGetAllBloodListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBloodListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllBloodListDto {
        let result = new ListResultDtoOfGetAllBloodListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllBloodListDto {
    items: GetAllBloodListDto[];
}

export class GetAllBloodListDto implements IGetAllBloodListDto {
    bloodCode: string;
    bloodName: string;

    constructor(data?: IGetAllBloodListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bloodCode = data["bloodCode"];
            this.bloodName = data["bloodName"];
        }
    }

    static fromJS(data: any): GetAllBloodListDto {
        let result = new GetAllBloodListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloodCode"] = this.bloodCode;
        data["bloodName"] = this.bloodName;
        return data; 
    }
}

export interface IGetAllBloodListDto {
    bloodCode: string;
    bloodName: string;
}

export class ListResultDtoOfGetAllCountryListDto implements IListResultDtoOfGetAllCountryListDto {
    items: GetAllCountryListDto[];

    constructor(data?: IListResultDtoOfGetAllCountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllCountryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllCountryListDto {
        let result = new ListResultDtoOfGetAllCountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllCountryListDto {
    items: GetAllCountryListDto[];
}

export class GetAllCountryListDto implements IGetAllCountryListDto {
    country: string;
    urut: number;
    ppatkCountryCode: string;

    constructor(data?: IGetAllCountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.urut = data["urut"];
            this.ppatkCountryCode = data["ppatkCountryCode"];
        }
    }

    static fromJS(data: any): GetAllCountryListDto {
        let result = new GetAllCountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["urut"] = this.urut;
        data["ppatkCountryCode"] = this.ppatkCountryCode;
        return data; 
    }
}

export interface IGetAllCountryListDto {
    country: string;
    urut: number;
    ppatkCountryCode: string;
}

export class ListResultDtoOfGetAllMsFacingList implements IListResultDtoOfGetAllMsFacingList {
    items: GetAllMsFacingList[];

    constructor(data?: IListResultDtoOfGetAllMsFacingList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsFacingList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsFacingList {
        let result = new ListResultDtoOfGetAllMsFacingList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsFacingList {
    items: GetAllMsFacingList[];
}

export class GetAllMsFacingList implements IGetAllMsFacingList {
    id: number;
    facingCode: string;
    facingName: string;

    constructor(data?: IGetAllMsFacingList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.facingCode = data["facingCode"];
            this.facingName = data["facingName"];
        }
    }

    static fromJS(data: any): GetAllMsFacingList {
        let result = new GetAllMsFacingList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facingCode"] = this.facingCode;
        data["facingName"] = this.facingName;
        return data; 
    }
}

export interface IGetAllMsFacingList {
    id: number;
    facingCode: string;
    facingName: string;
}

export class ListResultDtoOfGetLkFamilyStatusDropdownListDto implements IListResultDtoOfGetLkFamilyStatusDropdownListDto {
    items: GetLkFamilyStatusDropdownListDto[];

    constructor(data?: IListResultDtoOfGetLkFamilyStatusDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetLkFamilyStatusDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetLkFamilyStatusDropdownListDto {
        let result = new ListResultDtoOfGetLkFamilyStatusDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetLkFamilyStatusDropdownListDto {
    items: GetLkFamilyStatusDropdownListDto[];
}

export class GetLkFamilyStatusDropdownListDto implements IGetLkFamilyStatusDropdownListDto {
    famStatus: string;
    famStatusName: string;

    constructor(data?: IGetLkFamilyStatusDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.famStatus = data["famStatus"];
            this.famStatusName = data["famStatusName"];
        }
    }

    static fromJS(data: any): GetLkFamilyStatusDropdownListDto {
        let result = new GetLkFamilyStatusDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["famStatus"] = this.famStatus;
        data["famStatusName"] = this.famStatusName;
        return data; 
    }
}

export interface IGetLkFamilyStatusDropdownListDto {
    famStatus: string;
    famStatusName: string;
}

export class ListResultDtoOfGetLkGradeDropdownListDto implements IListResultDtoOfGetLkGradeDropdownListDto {
    items: GetLkGradeDropdownListDto[];

    constructor(data?: IListResultDtoOfGetLkGradeDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetLkGradeDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetLkGradeDropdownListDto {
        let result = new ListResultDtoOfGetLkGradeDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetLkGradeDropdownListDto {
    items: GetLkGradeDropdownListDto[];
}

export class GetLkGradeDropdownListDto implements IGetLkGradeDropdownListDto {
    gradeCode: string;
    gradeName: string;

    constructor(data?: IGetLkGradeDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gradeCode = data["gradeCode"];
            this.gradeName = data["gradeName"];
        }
    }

    static fromJS(data: any): GetLkGradeDropdownListDto {
        let result = new GetLkGradeDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeCode"] = this.gradeCode;
        data["gradeName"] = this.gradeName;
        return data; 
    }
}

export interface IGetLkGradeDropdownListDto {
    gradeCode: string;
    gradeName: string;
}

export class ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto implements IListResultDtoOfGetAllLkKeyPeopleDropdwonListDto {
    items: GetAllLkKeyPeopleDropdwonListDto[];

    constructor(data?: IListResultDtoOfGetAllLkKeyPeopleDropdwonListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllLkKeyPeopleDropdwonListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto {
        let result = new ListResultDtoOfGetAllLkKeyPeopleDropdwonListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllLkKeyPeopleDropdwonListDto {
    items: GetAllLkKeyPeopleDropdwonListDto[];
}

export class GetAllLkKeyPeopleDropdwonListDto implements IGetAllLkKeyPeopleDropdwonListDto {
    id: number;
    keyPeopleDesc: string;

    constructor(data?: IGetAllLkKeyPeopleDropdwonListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.keyPeopleDesc = data["keyPeopleDesc"];
        }
    }

    static fromJS(data: any): GetAllLkKeyPeopleDropdwonListDto {
        let result = new GetAllLkKeyPeopleDropdwonListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keyPeopleDesc"] = this.keyPeopleDesc;
        return data; 
    }
}

export interface IGetAllLkKeyPeopleDropdwonListDto {
    id: number;
    keyPeopleDesc: string;
}

export class ListResultDtoOfGetAllMarStatusListDto implements IListResultDtoOfGetAllMarStatusListDto {
    items: GetAllMarStatusListDto[];

    constructor(data?: IListResultDtoOfGetAllMarStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMarStatusListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMarStatusListDto {
        let result = new ListResultDtoOfGetAllMarStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMarStatusListDto {
    items: GetAllMarStatusListDto[];
}

export class GetAllMarStatusListDto implements IGetAllMarStatusListDto {
    marStatus: string;
    marStatusName: string;

    constructor(data?: IGetAllMarStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.marStatus = data["marStatus"];
            this.marStatusName = data["marStatusName"];
        }
    }

    static fromJS(data: any): GetAllMarStatusListDto {
        let result = new GetAllMarStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marStatus"] = this.marStatus;
        data["marStatusName"] = this.marStatusName;
        return data; 
    }
}

export interface IGetAllMarStatusListDto {
    marStatus: string;
    marStatusName: string;
}

export class GetLkPhoneTypeListDto implements IGetLkPhoneTypeListDto {
    phoneType: string;
    phoneTypeName: string;

    constructor(data?: IGetLkPhoneTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneType = data["phoneType"];
            this.phoneTypeName = data["phoneTypeName"];
        }
    }

    static fromJS(data: any): GetLkPhoneTypeListDto {
        let result = new GetLkPhoneTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneType"] = this.phoneType;
        data["phoneTypeName"] = this.phoneTypeName;
        return data; 
    }
}

export interface IGetLkPhoneTypeListDto {
    phoneType: string;
    phoneTypeName: string;
}

export class ListResultDtoOfGetAllReligionListDto implements IListResultDtoOfGetAllReligionListDto {
    items: GetAllReligionListDto[];

    constructor(data?: IListResultDtoOfGetAllReligionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllReligionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllReligionListDto {
        let result = new ListResultDtoOfGetAllReligionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllReligionListDto {
    items: GetAllReligionListDto[];
}

export class GetAllReligionListDto implements IGetAllReligionListDto {
    relCode: string;
    relName: string;

    constructor(data?: IGetAllReligionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.relCode = data["relCode"];
            this.relName = data["relName"];
        }
    }

    static fromJS(data: any): GetAllReligionListDto {
        let result = new GetAllReligionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relCode"] = this.relCode;
        data["relName"] = this.relName;
        return data; 
    }
}

export interface IGetAllReligionListDto {
    relCode: string;
    relName: string;
}

export class ListResultDtoOfGetAllSpecListDto implements IListResultDtoOfGetAllSpecListDto {
    items: GetAllSpecListDto[];

    constructor(data?: IListResultDtoOfGetAllSpecListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllSpecListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSpecListDto {
        let result = new ListResultDtoOfGetAllSpecListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllSpecListDto {
    items: GetAllSpecListDto[];
}

export class GetAllSpecListDto implements IGetAllSpecListDto {
    specCode: string;
    specName: string;

    constructor(data?: IGetAllSpecListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specCode = data["specCode"];
            this.specName = data["specName"];
        }
    }

    static fromJS(data: any): GetAllSpecListDto {
        let result = new GetAllSpecListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specCode"] = this.specCode;
        data["specName"] = this.specName;
        return data; 
    }
}

export interface IGetAllSpecListDto {
    specCode: string;
    specName: string;
}

export class LinkAppsResultDto implements ILinkAppsResultDto {
    propertySystemApps: string;
    bankPortalApps: string;
    personalsApps: string;
    salesWebApps: string;
    commisionApps: string;
    creditManagementApps: string;

    constructor(data?: ILinkAppsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertySystemApps = data["propertySystemApps"];
            this.bankPortalApps = data["bankPortalApps"];
            this.personalsApps = data["personalsApps"];
            this.salesWebApps = data["salesWebApps"];
            this.commisionApps = data["commisionApps"];
            this.creditManagementApps = data["creditManagementApps"];
        }
    }

    static fromJS(data: any): LinkAppsResultDto {
        let result = new LinkAppsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySystemApps"] = this.propertySystemApps;
        data["bankPortalApps"] = this.bankPortalApps;
        data["personalsApps"] = this.personalsApps;
        data["salesWebApps"] = this.salesWebApps;
        data["commisionApps"] = this.commisionApps;
        data["creditManagementApps"] = this.creditManagementApps;
        return data; 
    }
}

export interface ILinkAppsResultDto {
    propertySystemApps: string;
    bankPortalApps: string;
    personalsApps: string;
    salesWebApps: string;
    commisionApps: string;
    creditManagementApps: string;
}

export class GetTasklistMappingDocumentDto implements IGetTasklistMappingDocumentDto {
    docType: string;
    docName: string;
    kpr: boolean;
    nonKPR: boolean;

    constructor(data?: IGetTasklistMappingDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docType = data["docType"];
            this.docName = data["docName"];
            this.kpr = data["kpr"];
            this.nonKPR = data["nonKPR"];
        }
    }

    static fromJS(data: any): GetTasklistMappingDocumentDto {
        let result = new GetTasklistMappingDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docType"] = this.docType;
        data["docName"] = this.docName;
        data["kpr"] = this.kpr;
        data["nonKPR"] = this.nonKPR;
        return data; 
    }
}

export interface IGetTasklistMappingDocumentDto {
    docType: string;
    docName: string;
    kpr: boolean;
    nonKPR: boolean;
}

export class UpdateMappingDocInputDto implements IUpdateMappingDocInputDto {
    docType: string;
    kpr: boolean;
    nonKPR: boolean;

    constructor(data?: IUpdateMappingDocInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docType = data["docType"];
            this.kpr = data["kpr"];
            this.nonKPR = data["nonKPR"];
        }
    }

    static fromJS(data: any): UpdateMappingDocInputDto {
        let result = new UpdateMappingDocInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docType"] = this.docType;
        data["kpr"] = this.kpr;
        data["nonKPR"] = this.nonKPR;
        return data; 
    }
}

export interface IUpdateMappingDocInputDto {
    docType: string;
    kpr: boolean;
    nonKPR: boolean;
}

export class ExportMarketingFactorListDto implements IExportMarketingFactorListDto {
    schemeName: string;
    unit: DataUnitDto[];

    constructor(data?: IExportMarketingFactorListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schemeName = data["schemeName"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(DataUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportMarketingFactorListDto {
        let result = new ExportMarketingFactorListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemeName"] = this.schemeName;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExportMarketingFactorListDto {
    schemeName: string;
    unit: DataUnitDto[];
}

export class DataUnitDto implements IDataUnitDto {
    unitCode: string;
    unitNo: string;
    priceM2: string;

    constructor(data?: IDataUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.priceM2 = data["priceM2"];
        }
    }

    static fromJS(data: any): DataUnitDto {
        let result = new DataUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["priceM2"] = this.priceM2;
        return data; 
    }
}

export interface IDataUnitDto {
    unitCode: string;
    unitNo: string;
    priceM2: string;
}

export class CreateMasterCampaignInputDto implements ICreateMasterCampaignInputDto {
    campaignHeaderID: number;
    projectID: number;
    projectInfoID: number[];
    programID: number;
    isDefault: boolean;
    campaignName: string;
    typeUndian: string;
    startPeriod: moment.Moment;
    expiredShowUndian: moment.Moment;
    endPeriod: moment.Moment;
    listCluster: number[];
    listUnitType: number[];
    campaignDetails: CreateCampaignDetail[];
    previewPromo: string;
    detailPromo: string;
    isPreviewUpload: boolean;
    isDetailUpload: boolean;

    constructor(data?: ICreateMasterCampaignInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.projectID = data["projectID"];
            if (data["projectInfoID"] && data["projectInfoID"].constructor === Array) {
                this.projectInfoID = [];
                for (let item of data["projectInfoID"])
                    this.projectInfoID.push(item);
            }
            this.programID = data["programID"];
            this.isDefault = data["isDefault"];
            this.campaignName = data["campaignName"];
            this.typeUndian = data["typeUndian"];
            this.startPeriod = data["startPeriod"] ? moment(data["startPeriod"].toString()) : <any>undefined;
            this.expiredShowUndian = data["expiredShowUndian"] ? moment(data["expiredShowUndian"].toString()) : <any>undefined;
            this.endPeriod = data["endPeriod"] ? moment(data["endPeriod"].toString()) : <any>undefined;
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(item);
            }
            if (data["listUnitType"] && data["listUnitType"].constructor === Array) {
                this.listUnitType = [];
                for (let item of data["listUnitType"])
                    this.listUnitType.push(item);
            }
            if (data["campaignDetails"] && data["campaignDetails"].constructor === Array) {
                this.campaignDetails = [];
                for (let item of data["campaignDetails"])
                    this.campaignDetails.push(CreateCampaignDetail.fromJS(item));
            }
            this.previewPromo = data["previewPromo"];
            this.detailPromo = data["detailPromo"];
            this.isPreviewUpload = data["isPreviewUpload"];
            this.isDetailUpload = data["isDetailUpload"];
        }
    }

    static fromJS(data: any): CreateMasterCampaignInputDto {
        let result = new CreateMasterCampaignInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["projectID"] = this.projectID;
        if (this.projectInfoID && this.projectInfoID.constructor === Array) {
            data["projectInfoID"] = [];
            for (let item of this.projectInfoID)
                data["projectInfoID"].push(item);
        }
        data["programID"] = this.programID;
        data["isDefault"] = this.isDefault;
        data["campaignName"] = this.campaignName;
        data["typeUndian"] = this.typeUndian;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["expiredShowUndian"] = this.expiredShowUndian ? this.expiredShowUndian.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item);
        }
        if (this.listUnitType && this.listUnitType.constructor === Array) {
            data["listUnitType"] = [];
            for (let item of this.listUnitType)
                data["listUnitType"].push(item);
        }
        if (this.campaignDetails && this.campaignDetails.constructor === Array) {
            data["campaignDetails"] = [];
            for (let item of this.campaignDetails)
                data["campaignDetails"].push(item.toJSON());
        }
        data["previewPromo"] = this.previewPromo;
        data["detailPromo"] = this.detailPromo;
        data["isPreviewUpload"] = this.isPreviewUpload;
        data["isDetailUpload"] = this.isDetailUpload;
        return data; 
    }
}

export interface ICreateMasterCampaignInputDto {
    campaignHeaderID: number;
    projectID: number;
    projectInfoID: number[];
    programID: number;
    isDefault: boolean;
    campaignName: string;
    typeUndian: string;
    startPeriod: moment.Moment;
    expiredShowUndian: moment.Moment;
    endPeriod: moment.Moment;
    listCluster: number[];
    listUnitType: number[];
    campaignDetails: CreateCampaignDetail[];
    previewPromo: string;
    detailPromo: string;
    isPreviewUpload: boolean;
    isDetailUpload: boolean;
}

export class CreateCampaignDetail implements ICreateCampaignDetail {
    campaignDetailId: number;
    rewardID: number;
    idrValue: number;
    discount: number;
    costToMSU: number;
    paymentThreshold: number;
    beforeAfterHO: string;
    status: boolean;
    tnc: string;
    qty: number;

    constructor(data?: ICreateCampaignDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignDetailId = data["campaignDetailId"];
            this.rewardID = data["rewardID"];
            this.idrValue = data["idrValue"];
            this.discount = data["discount"];
            this.costToMSU = data["costToMSU"];
            this.paymentThreshold = data["paymentThreshold"];
            this.beforeAfterHO = data["beforeAfterHO"];
            this.status = data["status"];
            this.tnc = data["tnc"];
            this.qty = data["qty"];
        }
    }

    static fromJS(data: any): CreateCampaignDetail {
        let result = new CreateCampaignDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignDetailId"] = this.campaignDetailId;
        data["rewardID"] = this.rewardID;
        data["idrValue"] = this.idrValue;
        data["discount"] = this.discount;
        data["costToMSU"] = this.costToMSU;
        data["paymentThreshold"] = this.paymentThreshold;
        data["beforeAfterHO"] = this.beforeAfterHO;
        data["status"] = this.status;
        data["tnc"] = this.tnc;
        data["qty"] = this.qty;
        return data; 
    }
}

export interface ICreateCampaignDetail {
    campaignDetailId: number;
    rewardID: number;
    idrValue: number;
    discount: number;
    costToMSU: number;
    paymentThreshold: number;
    beforeAfterHO: string;
    status: boolean;
    tnc: string;
    qty: number;
}

export class GetDetailMasterCampaignListDto implements IGetDetailMasterCampaignListDto {
    campaignHeaderID: number;
    projectID: number;
    projectName: string;
    programID: number;
    isDefault: boolean;
    programName: string;
    campaignName: string;
    startPeriod: moment.Moment;
    endPeriod: moment.Moment;
    expiredShowUndian: moment.Moment;
    typeUndian: string;
    previewPromoLink: string;
    detailPromoLink: string;
    detailCampaign: GetDetailCampaign[];
    campaignProduct: GetCampaignProduct[];
    campaignCluster: GetCampaignCluster[];
    campaignUnitType: GetCampaignUnitType[];

    constructor(data?: IGetDetailMasterCampaignListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.programID = data["programID"];
            this.isDefault = data["isDefault"];
            this.programName = data["programName"];
            this.campaignName = data["campaignName"];
            this.startPeriod = data["startPeriod"] ? moment(data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = data["endPeriod"] ? moment(data["endPeriod"].toString()) : <any>undefined;
            this.expiredShowUndian = data["expiredShowUndian"] ? moment(data["expiredShowUndian"].toString()) : <any>undefined;
            this.typeUndian = data["typeUndian"];
            this.previewPromoLink = data["previewPromoLink"];
            this.detailPromoLink = data["detailPromoLink"];
            if (data["detailCampaign"] && data["detailCampaign"].constructor === Array) {
                this.detailCampaign = [];
                for (let item of data["detailCampaign"])
                    this.detailCampaign.push(GetDetailCampaign.fromJS(item));
            }
            if (data["campaignProduct"] && data["campaignProduct"].constructor === Array) {
                this.campaignProduct = [];
                for (let item of data["campaignProduct"])
                    this.campaignProduct.push(GetCampaignProduct.fromJS(item));
            }
            if (data["campaignCluster"] && data["campaignCluster"].constructor === Array) {
                this.campaignCluster = [];
                for (let item of data["campaignCluster"])
                    this.campaignCluster.push(GetCampaignCluster.fromJS(item));
            }
            if (data["campaignUnitType"] && data["campaignUnitType"].constructor === Array) {
                this.campaignUnitType = [];
                for (let item of data["campaignUnitType"])
                    this.campaignUnitType.push(GetCampaignUnitType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailMasterCampaignListDto {
        let result = new GetDetailMasterCampaignListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["programID"] = this.programID;
        data["isDefault"] = this.isDefault;
        data["programName"] = this.programName;
        data["campaignName"] = this.campaignName;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["expiredShowUndian"] = this.expiredShowUndian ? this.expiredShowUndian.toISOString() : <any>undefined;
        data["typeUndian"] = this.typeUndian;
        data["previewPromoLink"] = this.previewPromoLink;
        data["detailPromoLink"] = this.detailPromoLink;
        if (this.detailCampaign && this.detailCampaign.constructor === Array) {
            data["detailCampaign"] = [];
            for (let item of this.detailCampaign)
                data["detailCampaign"].push(item.toJSON());
        }
        if (this.campaignProduct && this.campaignProduct.constructor === Array) {
            data["campaignProduct"] = [];
            for (let item of this.campaignProduct)
                data["campaignProduct"].push(item.toJSON());
        }
        if (this.campaignCluster && this.campaignCluster.constructor === Array) {
            data["campaignCluster"] = [];
            for (let item of this.campaignCluster)
                data["campaignCluster"].push(item.toJSON());
        }
        if (this.campaignUnitType && this.campaignUnitType.constructor === Array) {
            data["campaignUnitType"] = [];
            for (let item of this.campaignUnitType)
                data["campaignUnitType"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailMasterCampaignListDto {
    campaignHeaderID: number;
    projectID: number;
    projectName: string;
    programID: number;
    isDefault: boolean;
    programName: string;
    campaignName: string;
    startPeriod: moment.Moment;
    endPeriod: moment.Moment;
    expiredShowUndian: moment.Moment;
    typeUndian: string;
    previewPromoLink: string;
    detailPromoLink: string;
    detailCampaign: GetDetailCampaign[];
    campaignProduct: GetCampaignProduct[];
    campaignCluster: GetCampaignCluster[];
    campaignUnitType: GetCampaignUnitType[];
}

export class GetDetailCampaign implements IGetDetailCampaign {
    campaignDetailID: number;
    rewardID: number;
    rewardName: string;
    idrValue: string;
    discount: string;
    costToMSU: string;
    paymentThreshold: string;
    beforeAfterHO: string;
    status: boolean;
    tnc: string;
    qty: number;

    constructor(data?: IGetDetailCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignDetailID = data["campaignDetailID"];
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
            this.idrValue = data["idrValue"];
            this.discount = data["discount"];
            this.costToMSU = data["costToMSU"];
            this.paymentThreshold = data["paymentThreshold"];
            this.beforeAfterHO = data["beforeAfterHO"];
            this.status = data["status"];
            this.tnc = data["tnc"];
            this.qty = data["qty"];
        }
    }

    static fromJS(data: any): GetDetailCampaign {
        let result = new GetDetailCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignDetailID"] = this.campaignDetailID;
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        data["idrValue"] = this.idrValue;
        data["discount"] = this.discount;
        data["costToMSU"] = this.costToMSU;
        data["paymentThreshold"] = this.paymentThreshold;
        data["beforeAfterHO"] = this.beforeAfterHO;
        data["status"] = this.status;
        data["tnc"] = this.tnc;
        data["qty"] = this.qty;
        return data; 
    }
}

export interface IGetDetailCampaign {
    campaignDetailID: number;
    rewardID: number;
    rewardName: string;
    idrValue: string;
    discount: string;
    costToMSU: string;
    paymentThreshold: string;
    beforeAfterHO: string;
    status: boolean;
    tnc: string;
    qty: number;
}

export class GetCampaignProduct implements IGetCampaignProduct {
    projectInfoId: number;
    productName: string;

    constructor(data?: IGetCampaignProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoId = data["projectInfoId"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetCampaignProduct {
        let result = new GetCampaignProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoId"] = this.projectInfoId;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetCampaignProduct {
    projectInfoId: number;
    productName: string;
}

export class GetCampaignCluster implements IGetCampaignCluster {
    clusterId: number;
    clusterName: string;

    constructor(data?: IGetCampaignCluster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetCampaignCluster {
        let result = new GetCampaignCluster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetCampaignCluster {
    clusterId: number;
    clusterName: string;
}

export class GetCampaignUnitType implements IGetCampaignUnitType {
    detailId: number;
    detailCode: string;
    detailName: string;
    bedroom: string;
    itemName: string;

    constructor(data?: IGetCampaignUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailId = data["detailId"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.bedroom = data["bedroom"];
            this.itemName = data["itemName"];
        }
    }

    static fromJS(data: any): GetCampaignUnitType {
        let result = new GetCampaignUnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailId"] = this.detailId;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["bedroom"] = this.bedroom;
        data["itemName"] = this.itemName;
        return data; 
    }
}

export interface IGetCampaignUnitType {
    detailId: number;
    detailCode: string;
    detailName: string;
    bedroom: string;
    itemName: string;
}

export class GetDropdownProgramListDto implements IGetDropdownProgramListDto {
    programID: number;
    programName: string;

    constructor(data?: IGetDropdownProgramListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programID = data["programID"];
            this.programName = data["programName"];
        }
    }

    static fromJS(data: any): GetDropdownProgramListDto {
        let result = new GetDropdownProgramListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programID"] = this.programID;
        data["programName"] = this.programName;
        return data; 
    }
}

export interface IGetDropdownProgramListDto {
    programID: number;
    programName: string;
}

export class GetTasklistMasterCampaignListDto implements IGetTasklistMasterCampaignListDto {
    campaignHeaderID: number;
    projectID: number;
    projectName: string;
    programID: number;
    programName: string;
    campaignName: string;
    periode: string;
    status: boolean;

    constructor(data?: IGetTasklistMasterCampaignListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.programID = data["programID"];
            this.programName = data["programName"];
            this.campaignName = data["campaignName"];
            this.periode = data["periode"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetTasklistMasterCampaignListDto {
        let result = new GetTasklistMasterCampaignListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["programID"] = this.programID;
        data["programName"] = this.programName;
        data["campaignName"] = this.campaignName;
        data["periode"] = this.periode;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetTasklistMasterCampaignListDto {
    campaignHeaderID: number;
    projectID: number;
    projectName: string;
    programID: number;
    programName: string;
    campaignName: string;
    periode: string;
    status: boolean;
}

export class GetListProductLaunchingResultDto implements IGetListProductLaunchingResultDto {
    projectInfoID: number;
    productName: string;

    constructor(data?: IGetListProductLaunchingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetListProductLaunchingResultDto {
        let result = new GetListProductLaunchingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetListProductLaunchingResultDto {
    projectInfoID: number;
    productName: string;
}

export class GetListClusterLaunchingResultDto implements IGetListClusterLaunchingResultDto {
    clusterId: number;
    clusterName: string;

    constructor(data?: IGetListClusterLaunchingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetListClusterLaunchingResultDto {
        let result = new GetListClusterLaunchingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetListClusterLaunchingResultDto {
    clusterId: number;
    clusterName: string;
}

export class GetDropdownCampaignDto implements IGetDropdownCampaignDto {
    campaignId: number;
    campaignName: string;

    constructor(data?: IGetDropdownCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignId = data["campaignId"];
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetDropdownCampaignDto {
        let result = new GetDropdownCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        return data; 
    }
}

export interface IGetDropdownCampaignDto {
    campaignId: number;
    campaignName: string;
}

export class GetDropdownHadiahDto implements IGetDropdownHadiahDto {
    rewardId: number;
    rewardName: string;
    imageHadiah: string;
    totalHadiah: number;

    constructor(data?: IGetDropdownHadiahDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardId = data["rewardId"];
            this.rewardName = data["rewardName"];
            this.imageHadiah = data["imageHadiah"];
            this.totalHadiah = data["totalHadiah"];
        }
    }

    static fromJS(data: any): GetDropdownHadiahDto {
        let result = new GetDropdownHadiahDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["rewardName"] = this.rewardName;
        data["imageHadiah"] = this.imageHadiah;
        data["totalHadiah"] = this.totalHadiah;
        return data; 
    }
}

export interface IGetDropdownHadiahDto {
    rewardId: number;
    rewardName: string;
    imageHadiah: string;
    totalHadiah: number;
}

export class GetHadiahDto implements IGetHadiahDto {
    dropdownHadiah: GetDropdownHadiahDto[];
    totalHadiah: number;
    imageHadiah: string;

    constructor(data?: IGetHadiahDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dropdownHadiah"] && data["dropdownHadiah"].constructor === Array) {
                this.dropdownHadiah = [];
                for (let item of data["dropdownHadiah"])
                    this.dropdownHadiah.push(GetDropdownHadiahDto.fromJS(item));
            }
            this.totalHadiah = data["totalHadiah"];
            this.imageHadiah = data["imageHadiah"];
        }
    }

    static fromJS(data: any): GetHadiahDto {
        let result = new GetHadiahDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dropdownHadiah && this.dropdownHadiah.constructor === Array) {
            data["dropdownHadiah"] = [];
            for (let item of this.dropdownHadiah)
                data["dropdownHadiah"].push(item.toJSON());
        }
        data["totalHadiah"] = this.totalHadiah;
        data["imageHadiah"] = this.imageHadiah;
        return data; 
    }
}

export interface IGetHadiahDto {
    dropdownHadiah: GetDropdownHadiahDto[];
    totalHadiah: number;
    imageHadiah: string;
}

export class GetDetailUndianShowDto implements IGetDetailUndianShowDto {
    redeempointid: number;
    psCode: string;
    unitID: number;
    unitName: string;
    name: string;
    phoneNumber: string;
    email: string;
    isSendNotif: boolean;

    constructor(data?: IGetDetailUndianShowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.redeempointid = data["redeempointid"];
            this.psCode = data["psCode"];
            this.unitID = data["unitID"];
            this.unitName = data["unitName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.isSendNotif = data["isSendNotif"];
        }
    }

    static fromJS(data: any): GetDetailUndianShowDto {
        let result = new GetDetailUndianShowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redeempointid"] = this.redeempointid;
        data["psCode"] = this.psCode;
        data["unitID"] = this.unitID;
        data["unitName"] = this.unitName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["isSendNotif"] = this.isSendNotif;
        return data; 
    }
}

export interface IGetDetailUndianShowDto {
    redeempointid: number;
    psCode: string;
    unitID: number;
    unitName: string;
    name: string;
    phoneNumber: string;
    email: string;
    isSendNotif: boolean;
}

export class GetDetailUndianDto implements IGetDetailUndianDto {
    showData: GetDetailUndianShowDto;
    hideData: GetDetailUndianHideDto;

    constructor(data?: IGetDetailUndianDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.showData = data["showData"] ? GetDetailUndianShowDto.fromJS(data["showData"]) : <any>undefined;
            this.hideData = data["hideData"] ? GetDetailUndianHideDto.fromJS(data["hideData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailUndianDto {
        let result = new GetDetailUndianDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showData"] = this.showData ? this.showData.toJSON() : <any>undefined;
        data["hideData"] = this.hideData ? this.hideData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailUndianDto {
    showData: GetDetailUndianShowDto;
    hideData: GetDetailUndianHideDto;
}

export class GetDetailUndianHideDto implements IGetDetailUndianHideDto {
    unitName: string;
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;

    constructor(data?: IGetDetailUndianHideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitName = data["unitName"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetDetailUndianHideDto {
        let result = new GetDetailUndianHideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitName"] = this.unitName;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetDetailUndianHideDto {
    unitName: string;
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;
}

export class InputPemenangDto implements IInputPemenangDto {
    psCode: string;
    name: string;
    phoneNumber: string;
    campaignID: number;
    email: string;
    rewardID: number;
    redeempointid: number;

    constructor(data?: IInputPemenangDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.campaignID = data["campaignID"];
            this.email = data["email"];
            this.rewardID = data["rewardID"];
            this.redeempointid = data["redeempointid"];
        }
    }

    static fromJS(data: any): InputPemenangDto {
        let result = new InputPemenangDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["campaignID"] = this.campaignID;
        data["email"] = this.email;
        data["rewardID"] = this.rewardID;
        data["redeempointid"] = this.redeempointid;
        return data; 
    }
}

export interface IInputPemenangDto {
    psCode: string;
    name: string;
    phoneNumber: string;
    campaignID: number;
    email: string;
    rewardID: number;
    redeempointid: number;
}

export class GetListHistoryUndianDto implements IGetListHistoryUndianDto {
    unitName: string;
    projectName: string;
    clusterName: string;
    campaignName: string;
    undian: string;
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;

    constructor(data?: IGetListHistoryUndianDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitName = data["unitName"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.campaignName = data["campaignName"];
            this.undian = data["undian"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetListHistoryUndianDto {
        let result = new GetListHistoryUndianDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitName"] = this.unitName;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["campaignName"] = this.campaignName;
        data["undian"] = this.undian;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetListHistoryUndianDto {
    unitName: string;
    projectName: string;
    clusterName: string;
    campaignName: string;
    undian: string;
    psCode: string;
    name: string;
    phoneNumber: string;
    email: string;
}

export class SendNotifPemenangDto implements ISendNotifPemenangDto {
    campaignID: number;
    rewardID: number;

    constructor(data?: ISendNotifPemenangDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.rewardID = data["rewardID"];
        }
    }

    static fromJS(data: any): SendNotifPemenangDto {
        let result = new SendNotifPemenangDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["rewardID"] = this.rewardID;
        return data; 
    }
}

export interface ISendNotifPemenangDto {
    campaignID: number;
    rewardID: number;
}

export class InputHomeUndianMobileDto implements IInputHomeUndianMobileDto {
    siteID: number;
    listUnitCodeNo: ListUnitCodeNoMobileDto[];

    constructor(data?: IInputHomeUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            if (data["listUnitCodeNo"] && data["listUnitCodeNo"].constructor === Array) {
                this.listUnitCodeNo = [];
                for (let item of data["listUnitCodeNo"])
                    this.listUnitCodeNo.push(ListUnitCodeNoMobileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputHomeUndianMobileDto {
        let result = new InputHomeUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        if (this.listUnitCodeNo && this.listUnitCodeNo.constructor === Array) {
            data["listUnitCodeNo"] = [];
            for (let item of this.listUnitCodeNo)
                data["listUnitCodeNo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInputHomeUndianMobileDto {
    siteID: number;
    listUnitCodeNo: ListUnitCodeNoMobileDto[];
}

export class ListUnitCodeNoMobileDto implements IListUnitCodeNoMobileDto {
    unitCode: string;
    unitNo: string;

    constructor(data?: IListUnitCodeNoMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): ListUnitCodeNoMobileDto {
        let result = new ListUnitCodeNoMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IListUnitCodeNoMobileDto {
    unitCode: string;
    unitNo: string;
}

export class InputListUndianMobileDto implements IInputListUndianMobileDto {
    siteID: number;
    listUnit: UnitHadiahDto[];

    constructor(data?: IInputListUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(UnitHadiahDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputListUndianMobileDto {
        let result = new InputListUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInputListUndianMobileDto {
    siteID: number;
    listUnit: UnitHadiahDto[];
}

export class UnitHadiahDto implements IUnitHadiahDto {
    unitCode: string;
    unitNo: string;
    unitName: string;

    constructor(data?: IUnitHadiahDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitName = data["unitName"];
        }
    }

    static fromJS(data: any): UnitHadiahDto {
        let result = new UnitHadiahDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitName"] = this.unitName;
        return data; 
    }
}

export interface IUnitHadiahDto {
    unitCode: string;
    unitNo: string;
    unitName: string;
}

export class GetListAcakUndianMobileDto implements IGetListAcakUndianMobileDto {
    unitID: number;
    unitName: string;
    poinTerpakai: number;
    totalPoinByUnit: number;
    listReward: ListAcakUndianDto[];

    constructor(data?: IGetListAcakUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitName = data["unitName"];
            this.poinTerpakai = data["poinTerpakai"];
            this.totalPoinByUnit = data["totalPoinByUnit"];
            if (data["listReward"] && data["listReward"].constructor === Array) {
                this.listReward = [];
                for (let item of data["listReward"])
                    this.listReward.push(ListAcakUndianDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListAcakUndianMobileDto {
        let result = new GetListAcakUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitName"] = this.unitName;
        data["poinTerpakai"] = this.poinTerpakai;
        data["totalPoinByUnit"] = this.totalPoinByUnit;
        if (this.listReward && this.listReward.constructor === Array) {
            data["listReward"] = [];
            for (let item of this.listReward)
                data["listReward"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListAcakUndianMobileDto {
    unitID: number;
    unitName: string;
    poinTerpakai: number;
    totalPoinByUnit: number;
    listReward: ListAcakUndianDto[];
}

export class ListAcakUndianDto implements IListAcakUndianDto {
    rewardName: string;
    campaignName: string;
    urlImage: string;
    rewardId: number;
    campaignID: number;
    redemByReward: number;

    constructor(data?: IListAcakUndianDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardName = data["rewardName"];
            this.campaignName = data["campaignName"];
            this.urlImage = data["urlImage"];
            this.rewardId = data["rewardId"];
            this.campaignID = data["campaignID"];
            this.redemByReward = data["redemByReward"];
        }
    }

    static fromJS(data: any): ListAcakUndianDto {
        let result = new ListAcakUndianDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardName"] = this.rewardName;
        data["campaignName"] = this.campaignName;
        data["urlImage"] = this.urlImage;
        data["rewardId"] = this.rewardId;
        data["campaignID"] = this.campaignID;
        data["redemByReward"] = this.redemByReward;
        return data; 
    }
}

export interface IListAcakUndianDto {
    rewardName: string;
    campaignName: string;
    urlImage: string;
    rewardId: number;
    campaignID: number;
    redemByReward: number;
}

export class DetailUndianInputMobileDto implements IDetailUndianInputMobileDto {
    siteID: number;
    unitID: number;
    campaignID: number;
    rewardID: number;

    constructor(data?: IDetailUndianInputMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            this.unitID = data["unitID"];
            this.campaignID = data["campaignID"];
            this.rewardID = data["rewardID"];
        }
    }

    static fromJS(data: any): DetailUndianInputMobileDto {
        let result = new DetailUndianInputMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        data["unitID"] = this.unitID;
        data["campaignID"] = this.campaignID;
        data["rewardID"] = this.rewardID;
        return data; 
    }
}

export interface IDetailUndianInputMobileDto {
    siteID: number;
    unitID: number;
    campaignID: number;
    rewardID: number;
}

export class GetDetailRewardUndianMobileDto implements IGetDetailRewardUndianMobileDto {
    imageReward: string;
    rewardName: string;
    periodeStart: string;
    periodeEnd: string;
    poinTerpakai: number;
    sisaPoin: number;
    tnc: string;

    constructor(data?: IGetDetailRewardUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageReward = data["imageReward"];
            this.rewardName = data["rewardName"];
            this.periodeStart = data["periodeStart"];
            this.periodeEnd = data["periodeEnd"];
            this.poinTerpakai = data["poinTerpakai"];
            this.sisaPoin = data["sisaPoin"];
            this.tnc = data["tnc"];
        }
    }

    static fromJS(data: any): GetDetailRewardUndianMobileDto {
        let result = new GetDetailRewardUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageReward"] = this.imageReward;
        data["rewardName"] = this.rewardName;
        data["periodeStart"] = this.periodeStart;
        data["periodeEnd"] = this.periodeEnd;
        data["poinTerpakai"] = this.poinTerpakai;
        data["sisaPoin"] = this.sisaPoin;
        data["tnc"] = this.tnc;
        return data; 
    }
}

export interface IGetDetailRewardUndianMobileDto {
    imageReward: string;
    rewardName: string;
    periodeStart: string;
    periodeEnd: string;
    poinTerpakai: number;
    sisaPoin: number;
    tnc: string;
}

export class InsertTukarPoinMobileDto implements IInsertTukarPoinMobileDto {
    phoneoremail: string;
    campaignID: number;
    rewardID: number;
    psCode: string;
    unitID: number;
    poinRedem: number;

    constructor(data?: IInsertTukarPoinMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneoremail = data["phoneoremail"];
            this.campaignID = data["campaignID"];
            this.rewardID = data["rewardID"];
            this.psCode = data["psCode"];
            this.unitID = data["unitID"];
            this.poinRedem = data["poinRedem"];
        }
    }

    static fromJS(data: any): InsertTukarPoinMobileDto {
        let result = new InsertTukarPoinMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneoremail"] = this.phoneoremail;
        data["campaignID"] = this.campaignID;
        data["rewardID"] = this.rewardID;
        data["psCode"] = this.psCode;
        data["unitID"] = this.unitID;
        data["poinRedem"] = this.poinRedem;
        return data; 
    }
}

export interface IInsertTukarPoinMobileDto {
    phoneoremail: string;
    campaignID: number;
    rewardID: number;
    psCode: string;
    unitID: number;
    poinRedem: number;
}

export class GetListInfoPemenangUndianMobileDto implements IGetListInfoPemenangUndianMobileDto {
    rewardID: number;
    campaignID: number;
    urlImage: string;
    campaignName: string;
    rewardName: string;
    periode: string;

    constructor(data?: IGetListInfoPemenangUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardID = data["rewardID"];
            this.campaignID = data["campaignID"];
            this.urlImage = data["urlImage"];
            this.campaignName = data["campaignName"];
            this.rewardName = data["rewardName"];
            this.periode = data["periode"];
        }
    }

    static fromJS(data: any): GetListInfoPemenangUndianMobileDto {
        let result = new GetListInfoPemenangUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardID"] = this.rewardID;
        data["campaignID"] = this.campaignID;
        data["urlImage"] = this.urlImage;
        data["campaignName"] = this.campaignName;
        data["rewardName"] = this.rewardName;
        data["periode"] = this.periode;
        return data; 
    }
}

export interface IGetListInfoPemenangUndianMobileDto {
    rewardID: number;
    campaignID: number;
    urlImage: string;
    campaignName: string;
    rewardName: string;
    periode: string;
}

export class DetailPemanangUndianInputMobileDto implements IDetailPemanangUndianInputMobileDto {
    siteID: number;
    campaignID: number;
    rewardID: number;

    constructor(data?: IDetailPemanangUndianInputMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            this.campaignID = data["campaignID"];
            this.rewardID = data["rewardID"];
        }
    }

    static fromJS(data: any): DetailPemanangUndianInputMobileDto {
        let result = new DetailPemanangUndianInputMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        data["campaignID"] = this.campaignID;
        data["rewardID"] = this.rewardID;
        return data; 
    }
}

export interface IDetailPemanangUndianInputMobileDto {
    siteID: number;
    campaignID: number;
    rewardID: number;
}

export class DetailPemenangUndianMobileDto implements IDetailPemenangUndianMobileDto {
    psCode: string;
    name: string;

    constructor(data?: IDetailPemenangUndianMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): DetailPemenangUndianMobileDto {
        let result = new DetailPemenangUndianMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        return data; 
    }
}

export interface IDetailPemenangUndianMobileDto {
    psCode: string;
    name: string;
}

export class ResultSubAccount implements IResultSubAccount {
    name: string;
    phoneNumber: string;
    emailNumber: string;

    constructor(data?: IResultSubAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.emailNumber = data["emailNumber"];
        }
    }

    static fromJS(data: any): ResultSubAccount {
        let result = new ResultSubAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["emailNumber"] = this.emailNumber;
        return data; 
    }
}

export interface IResultSubAccount {
    name: string;
    phoneNumber: string;
    emailNumber: string;
}

export class ListResultDtoOfGetProjectDropdownListDto implements IListResultDtoOfGetProjectDropdownListDto {
    items: GetProjectDropdownListDto[];

    constructor(data?: IListResultDtoOfGetProjectDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectDropdownListDto {
        let result = new ListResultDtoOfGetProjectDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectDropdownListDto {
    items: GetProjectDropdownListDto[];
}

export class GetProjectDropdownListDto implements IGetProjectDropdownListDto {
    projectID: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IGetProjectDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectDropdownListDto {
        let result = new GetProjectDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetProjectDropdownListDto {
    projectID: number;
    projectCode: string;
    projectName: string;
}

export class GetReward1DropdownListDto implements IGetReward1DropdownListDto {
    rewardID: number;
    rewardName: string;
    isBookingFee: boolean;
    isPP: boolean;
    isParking: boolean;
    isNewCustomer: boolean;
    isBilling: boolean;
    durationExpired: number;
    projectInfoID: number[];

    constructor(data?: IGetReward1DropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
            this.isBookingFee = data["isBookingFee"];
            this.isPP = data["isPP"];
            this.isParking = data["isParking"];
            this.isNewCustomer = data["isNewCustomer"];
            this.isBilling = data["isBilling"];
            this.durationExpired = data["durationExpired"];
            if (data["projectInfoID"] && data["projectInfoID"].constructor === Array) {
                this.projectInfoID = [];
                for (let item of data["projectInfoID"])
                    this.projectInfoID.push(item);
            }
        }
    }

    static fromJS(data: any): GetReward1DropdownListDto {
        let result = new GetReward1DropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        data["isBookingFee"] = this.isBookingFee;
        data["isPP"] = this.isPP;
        data["isParking"] = this.isParking;
        data["isNewCustomer"] = this.isNewCustomer;
        data["isBilling"] = this.isBilling;
        data["durationExpired"] = this.durationExpired;
        if (this.projectInfoID && this.projectInfoID.constructor === Array) {
            data["projectInfoID"] = [];
            for (let item of this.projectInfoID)
                data["projectInfoID"].push(item);
        }
        return data; 
    }
}

export interface IGetReward1DropdownListDto {
    rewardID: number;
    rewardName: string;
    isBookingFee: boolean;
    isPP: boolean;
    isParking: boolean;
    isNewCustomer: boolean;
    isBilling: boolean;
    durationExpired: number;
    projectInfoID: number[];
}

export class PagedResultDtoOfGetTasklistMasterNotificationDto implements IPagedResultDtoOfGetTasklistMasterNotificationDto {
    totalCount: number;
    items: GetTasklistMasterNotificationDto[];

    constructor(data?: IPagedResultDtoOfGetTasklistMasterNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTasklistMasterNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTasklistMasterNotificationDto {
        let result = new PagedResultDtoOfGetTasklistMasterNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTasklistMasterNotificationDto {
    totalCount: number;
    items: GetTasklistMasterNotificationDto[];
}

export class GetTasklistMasterNotificationDto implements IGetTasklistMasterNotificationDto {
    projectName: string;
    projectId: number;
    user: string;

    constructor(data?: IGetTasklistMasterNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.projectId = data["projectId"];
            this.user = data["user"];
        }
    }

    static fromJS(data: any): GetTasklistMasterNotificationDto {
        let result = new GetTasklistMasterNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["user"] = this.user;
        return data; 
    }
}

export interface IGetTasklistMasterNotificationDto {
    projectName: string;
    projectId: number;
    user: string;
}

export class GetDetailProjectNotifDto implements IGetDetailProjectNotifDto {
    projectName: string;
    projectId: number;
    templateNotifDetail: GetDetailTemplateNotifDto[];
    parentType: string[];

    constructor(data?: IGetDetailProjectNotifDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.projectId = data["projectId"];
            if (data["templateNotifDetail"] && data["templateNotifDetail"].constructor === Array) {
                this.templateNotifDetail = [];
                for (let item of data["templateNotifDetail"])
                    this.templateNotifDetail.push(GetDetailTemplateNotifDto.fromJS(item));
            }
            if (data["parentType"] && data["parentType"].constructor === Array) {
                this.parentType = [];
                for (let item of data["parentType"])
                    this.parentType.push(item);
            }
        }
    }

    static fromJS(data: any): GetDetailProjectNotifDto {
        let result = new GetDetailProjectNotifDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        if (this.templateNotifDetail && this.templateNotifDetail.constructor === Array) {
            data["templateNotifDetail"] = [];
            for (let item of this.templateNotifDetail)
                data["templateNotifDetail"].push(item.toJSON());
        }
        if (this.parentType && this.parentType.constructor === Array) {
            data["parentType"] = [];
            for (let item of this.parentType)
                data["parentType"].push(item);
        }
        return data; 
    }
}

export interface IGetDetailProjectNotifDto {
    projectName: string;
    projectId: number;
    templateNotifDetail: GetDetailTemplateNotifDto[];
    parentType: string[];
}

export class GetDetailTemplateNotifDto implements IGetDetailTemplateNotifDto {
    templateNotifId: number;
    notifTypeCode: string;
    notifTypeDesc: string;
    parentType: string;
    status: boolean;
    isModified: boolean;
    canNotEdit: boolean;
    isSMS: boolean;

    constructor(data?: IGetDetailTemplateNotifDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateNotifId = data["templateNotifId"];
            this.notifTypeCode = data["notifTypeCode"];
            this.notifTypeDesc = data["notifTypeDesc"];
            this.parentType = data["parentType"];
            this.status = data["status"];
            this.isModified = data["isModified"];
            this.canNotEdit = data["canNotEdit"];
            this.isSMS = data["isSMS"];
        }
    }

    static fromJS(data: any): GetDetailTemplateNotifDto {
        let result = new GetDetailTemplateNotifDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateNotifId"] = this.templateNotifId;
        data["notifTypeCode"] = this.notifTypeCode;
        data["notifTypeDesc"] = this.notifTypeDesc;
        data["parentType"] = this.parentType;
        data["status"] = this.status;
        data["isModified"] = this.isModified;
        data["canNotEdit"] = this.canNotEdit;
        data["isSMS"] = this.isSMS;
        return data; 
    }
}

export interface IGetDetailTemplateNotifDto {
    templateNotifId: number;
    notifTypeCode: string;
    notifTypeDesc: string;
    parentType: string;
    status: boolean;
    isModified: boolean;
    canNotEdit: boolean;
    isSMS: boolean;
}

export class HoldNotificationInputDto implements IHoldNotificationInputDto {
    projectId: number;
    clusterId: number;
    listBookCodePsCode: ListBookCodePsCodeDto[];

    constructor(data?: IHoldNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            if (data["listBookCodePsCode"] && data["listBookCodePsCode"].constructor === Array) {
                this.listBookCodePsCode = [];
                for (let item of data["listBookCodePsCode"])
                    this.listBookCodePsCode.push(ListBookCodePsCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HoldNotificationInputDto {
        let result = new HoldNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        if (this.listBookCodePsCode && this.listBookCodePsCode.constructor === Array) {
            data["listBookCodePsCode"] = [];
            for (let item of this.listBookCodePsCode)
                data["listBookCodePsCode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IHoldNotificationInputDto {
    projectId: number;
    clusterId: number;
    listBookCodePsCode: ListBookCodePsCodeDto[];
}

export class ListBookCodePsCodeDto implements IListBookCodePsCodeDto {
    bookCode: string;
    psCode: string;

    constructor(data?: IListBookCodePsCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): ListBookCodePsCodeDto {
        let result = new ListBookCodePsCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IListBookCodePsCodeDto {
    bookCode: string;
    psCode: string;
}

export class GetTaskListHoldNotificationDto implements IGetTaskListHoldNotificationDto {
    id: number;
    isHold: boolean;
    isSave: boolean;
    notifTypeCode: string;
    notifTypeName: string;
    notifTypeID: number;
    bookcode: string;
    psCode: string;

    constructor(data?: IGetTaskListHoldNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isHold = data["isHold"];
            this.isSave = data["isSave"];
            this.notifTypeCode = data["notifTypeCode"];
            this.notifTypeName = data["notifTypeName"];
            this.notifTypeID = data["notifTypeID"];
            this.bookcode = data["bookcode"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): GetTaskListHoldNotificationDto {
        let result = new GetTaskListHoldNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isHold"] = this.isHold;
        data["isSave"] = this.isSave;
        data["notifTypeCode"] = this.notifTypeCode;
        data["notifTypeName"] = this.notifTypeName;
        data["notifTypeID"] = this.notifTypeID;
        data["bookcode"] = this.bookcode;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IGetTaskListHoldNotificationDto {
    id: number;
    isHold: boolean;
    isSave: boolean;
    notifTypeCode: string;
    notifTypeName: string;
    notifTypeID: number;
    bookcode: string;
    psCode: string;
}

export class GetDropdownBookCodeByNotifDto implements IGetDropdownBookCodeByNotifDto {
    bookCode: string;
    psCode: string;

    constructor(data?: IGetDropdownBookCodeByNotifDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): GetDropdownBookCodeByNotifDto {
        let result = new GetDropdownBookCodeByNotifDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IGetDropdownBookCodeByNotifDto {
    bookCode: string;
    psCode: string;
}

export class CreateHoldNotifInputDto implements ICreateHoldNotifInputDto {
    listBookCodePsCode: ListBookCodePsCodeDto[];
    isHold: boolean;
    isSave: boolean;
    projectId: number;
    clusterId: number;
    notifTypeId: number;
    messageName: string;

    constructor(data?: ICreateHoldNotifInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listBookCodePsCode"] && data["listBookCodePsCode"].constructor === Array) {
                this.listBookCodePsCode = [];
                for (let item of data["listBookCodePsCode"])
                    this.listBookCodePsCode.push(ListBookCodePsCodeDto.fromJS(item));
            }
            this.isHold = data["isHold"];
            this.isSave = data["isSave"];
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            this.notifTypeId = data["notifTypeId"];
            this.messageName = data["messageName"];
        }
    }

    static fromJS(data: any): CreateHoldNotifInputDto {
        let result = new CreateHoldNotifInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listBookCodePsCode && this.listBookCodePsCode.constructor === Array) {
            data["listBookCodePsCode"] = [];
            for (let item of this.listBookCodePsCode)
                data["listBookCodePsCode"].push(item.toJSON());
        }
        data["isHold"] = this.isHold;
        data["isSave"] = this.isSave;
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        data["notifTypeId"] = this.notifTypeId;
        data["messageName"] = this.messageName;
        return data; 
    }
}

export interface ICreateHoldNotifInputDto {
    listBookCodePsCode: ListBookCodePsCodeDto[];
    isHold: boolean;
    isSave: boolean;
    projectId: number;
    clusterId: number;
    notifTypeId: number;
    messageName: string;
}

export class GetDetailNotifDto implements IGetDetailNotifDto {
    projectId: number;
    templateNotificationId: number;
    notifTypeCode: string;
    projectLogo: string;
    messageFileName: string;
    messageFileUrl: string;
    subject: string;
    defaultSubject: string;
    viewName: string;
    v1: string;
    v2: string;
    v3: string;
    v4: string;
    v5: string;
    v6: string;
    v7: string;
    v8: string;
    v9: string;
    v10: string;
    v11: string;
    v12: string;
    v13: string;
    v14: string;
    v15: string;
    v16: string;
    v17: string;
    v18: string;
    v19: string;
    v20: string;
    v21: string;
    v22: string;
    v23: string;
    v24: string;
    v25: string;
    v26: string;
    v27: string;
    v28: string;
    v29: string;
    v30: string;

    constructor(data?: IGetDetailNotifDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.templateNotificationId = data["templateNotificationId"];
            this.notifTypeCode = data["notifTypeCode"];
            this.projectLogo = data["projectLogo"];
            this.messageFileName = data["messageFileName"];
            this.messageFileUrl = data["messageFileUrl"];
            this.subject = data["subject"];
            this.defaultSubject = data["defaultSubject"];
            this.viewName = data["viewName"];
            this.v1 = data["v1"];
            this.v2 = data["v2"];
            this.v3 = data["v3"];
            this.v4 = data["v4"];
            this.v5 = data["v5"];
            this.v6 = data["v6"];
            this.v7 = data["v7"];
            this.v8 = data["v8"];
            this.v9 = data["v9"];
            this.v10 = data["v10"];
            this.v11 = data["v11"];
            this.v12 = data["v12"];
            this.v13 = data["v13"];
            this.v14 = data["v14"];
            this.v15 = data["v15"];
            this.v16 = data["v16"];
            this.v17 = data["v17"];
            this.v18 = data["v18"];
            this.v19 = data["v19"];
            this.v20 = data["v20"];
            this.v21 = data["v21"];
            this.v22 = data["v22"];
            this.v23 = data["v23"];
            this.v24 = data["v24"];
            this.v25 = data["v25"];
            this.v26 = data["v26"];
            this.v27 = data["v27"];
            this.v28 = data["v28"];
            this.v29 = data["v29"];
            this.v30 = data["v30"];
        }
    }

    static fromJS(data: any): GetDetailNotifDto {
        let result = new GetDetailNotifDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["templateNotificationId"] = this.templateNotificationId;
        data["notifTypeCode"] = this.notifTypeCode;
        data["projectLogo"] = this.projectLogo;
        data["messageFileName"] = this.messageFileName;
        data["messageFileUrl"] = this.messageFileUrl;
        data["subject"] = this.subject;
        data["defaultSubject"] = this.defaultSubject;
        data["viewName"] = this.viewName;
        data["v1"] = this.v1;
        data["v2"] = this.v2;
        data["v3"] = this.v3;
        data["v4"] = this.v4;
        data["v5"] = this.v5;
        data["v6"] = this.v6;
        data["v7"] = this.v7;
        data["v8"] = this.v8;
        data["v9"] = this.v9;
        data["v10"] = this.v10;
        data["v11"] = this.v11;
        data["v12"] = this.v12;
        data["v13"] = this.v13;
        data["v14"] = this.v14;
        data["v15"] = this.v15;
        data["v16"] = this.v16;
        data["v17"] = this.v17;
        data["v18"] = this.v18;
        data["v19"] = this.v19;
        data["v20"] = this.v20;
        data["v21"] = this.v21;
        data["v22"] = this.v22;
        data["v23"] = this.v23;
        data["v24"] = this.v24;
        data["v25"] = this.v25;
        data["v26"] = this.v26;
        data["v27"] = this.v27;
        data["v28"] = this.v28;
        data["v29"] = this.v29;
        data["v30"] = this.v30;
        return data; 
    }
}

export interface IGetDetailNotifDto {
    projectId: number;
    templateNotificationId: number;
    notifTypeCode: string;
    projectLogo: string;
    messageFileName: string;
    messageFileUrl: string;
    subject: string;
    defaultSubject: string;
    viewName: string;
    v1: string;
    v2: string;
    v3: string;
    v4: string;
    v5: string;
    v6: string;
    v7: string;
    v8: string;
    v9: string;
    v10: string;
    v11: string;
    v12: string;
    v13: string;
    v14: string;
    v15: string;
    v16: string;
    v17: string;
    v18: string;
    v19: string;
    v20: string;
    v21: string;
    v22: string;
    v23: string;
    v24: string;
    v25: string;
    v26: string;
    v27: string;
    v28: string;
    v29: string;
    v30: string;
}

export class UpdateTemplateNotificationInputDto implements IUpdateTemplateNotificationInputDto {
    projectId: number;
    notifTypeCode: string;
    subject: string;
    newMessageFileName: string;
    currentMessageFileName: string;
    viewName: string;
    v1: string;
    v2: string;
    v3: string;
    v4: string;
    v5: string;
    v6: string;
    v7: string;
    v8: string;
    v9: string;
    v10: string;
    v11: string;
    v12: string;
    v13: string;
    v14: string;
    v15: string;
    v16: string;
    v17: string;
    v18: string;
    v19: string;
    v20: string;
    v21: string;
    v22: string;
    v23: string;
    v24: string;
    v25: string;
    v26: string;
    v27: string;
    v28: string;
    v29: string;
    v30: string;

    constructor(data?: IUpdateTemplateNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.notifTypeCode = data["notifTypeCode"];
            this.subject = data["subject"];
            this.newMessageFileName = data["newMessageFileName"];
            this.currentMessageFileName = data["currentMessageFileName"];
            this.viewName = data["viewName"];
            this.v1 = data["v1"];
            this.v2 = data["v2"];
            this.v3 = data["v3"];
            this.v4 = data["v4"];
            this.v5 = data["v5"];
            this.v6 = data["v6"];
            this.v7 = data["v7"];
            this.v8 = data["v8"];
            this.v9 = data["v9"];
            this.v10 = data["v10"];
            this.v11 = data["v11"];
            this.v12 = data["v12"];
            this.v13 = data["v13"];
            this.v14 = data["v14"];
            this.v15 = data["v15"];
            this.v16 = data["v16"];
            this.v17 = data["v17"];
            this.v18 = data["v18"];
            this.v19 = data["v19"];
            this.v20 = data["v20"];
            this.v21 = data["v21"];
            this.v22 = data["v22"];
            this.v23 = data["v23"];
            this.v24 = data["v24"];
            this.v25 = data["v25"];
            this.v26 = data["v26"];
            this.v27 = data["v27"];
            this.v28 = data["v28"];
            this.v29 = data["v29"];
            this.v30 = data["v30"];
        }
    }

    static fromJS(data: any): UpdateTemplateNotificationInputDto {
        let result = new UpdateTemplateNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["notifTypeCode"] = this.notifTypeCode;
        data["subject"] = this.subject;
        data["newMessageFileName"] = this.newMessageFileName;
        data["currentMessageFileName"] = this.currentMessageFileName;
        data["viewName"] = this.viewName;
        data["v1"] = this.v1;
        data["v2"] = this.v2;
        data["v3"] = this.v3;
        data["v4"] = this.v4;
        data["v5"] = this.v5;
        data["v6"] = this.v6;
        data["v7"] = this.v7;
        data["v8"] = this.v8;
        data["v9"] = this.v9;
        data["v10"] = this.v10;
        data["v11"] = this.v11;
        data["v12"] = this.v12;
        data["v13"] = this.v13;
        data["v14"] = this.v14;
        data["v15"] = this.v15;
        data["v16"] = this.v16;
        data["v17"] = this.v17;
        data["v18"] = this.v18;
        data["v19"] = this.v19;
        data["v20"] = this.v20;
        data["v21"] = this.v21;
        data["v22"] = this.v22;
        data["v23"] = this.v23;
        data["v24"] = this.v24;
        data["v25"] = this.v25;
        data["v26"] = this.v26;
        data["v27"] = this.v27;
        data["v28"] = this.v28;
        data["v29"] = this.v29;
        data["v30"] = this.v30;
        return data; 
    }
}

export interface IUpdateTemplateNotificationInputDto {
    projectId: number;
    notifTypeCode: string;
    subject: string;
    newMessageFileName: string;
    currentMessageFileName: string;
    viewName: string;
    v1: string;
    v2: string;
    v3: string;
    v4: string;
    v5: string;
    v6: string;
    v7: string;
    v8: string;
    v9: string;
    v10: string;
    v11: string;
    v12: string;
    v13: string;
    v14: string;
    v15: string;
    v16: string;
    v17: string;
    v18: string;
    v19: string;
    v20: string;
    v21: string;
    v22: string;
    v23: string;
    v24: string;
    v25: string;
    v26: string;
    v27: string;
    v28: string;
    v29: string;
    v30: string;
}

export class GetTemplateViewDto implements IGetTemplateViewDto {
    messageFileUrl: string;
    imagePromo1: string;
    imagePromo2: string;
    imagePromo3: string;

    constructor(data?: IGetTemplateViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.messageFileUrl = data["messageFileUrl"];
            this.imagePromo1 = data["imagePromo1"];
            this.imagePromo2 = data["imagePromo2"];
            this.imagePromo3 = data["imagePromo3"];
        }
    }

    static fromJS(data: any): GetTemplateViewDto {
        let result = new GetTemplateViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageFileUrl"] = this.messageFileUrl;
        data["imagePromo1"] = this.imagePromo1;
        data["imagePromo2"] = this.imagePromo2;
        data["imagePromo3"] = this.imagePromo3;
        return data; 
    }
}

export interface IGetTemplateViewDto {
    messageFileUrl: string;
    imagePromo1: string;
    imagePromo2: string;
    imagePromo3: string;
}

export class CreateUpdateNotifTemplateInputDto implements ICreateUpdateNotifTemplateInputDto {
    projectId: number;
    notifTypeCode: string;
    subject: string;
    message: string;

    constructor(data?: ICreateUpdateNotifTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.notifTypeCode = data["notifTypeCode"];
            this.subject = data["subject"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): CreateUpdateNotifTemplateInputDto {
        let result = new CreateUpdateNotifTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["notifTypeCode"] = this.notifTypeCode;
        data["subject"] = this.subject;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICreateUpdateNotifTemplateInputDto {
    projectId: number;
    notifTypeCode: string;
    subject: string;
    message: string;
}

export class PagedResultDtoOfGetDataVoucherBulkDto implements IPagedResultDtoOfGetDataVoucherBulkDto {
    totalCount: number;
    items: GetDataVoucherBulkDto[];

    constructor(data?: IPagedResultDtoOfGetDataVoucherBulkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDataVoucherBulkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDataVoucherBulkDto {
        let result = new PagedResultDtoOfGetDataVoucherBulkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDataVoucherBulkDto {
    totalCount: number;
    items: GetDataVoucherBulkDto[];
}

export class GetDataVoucherBulkDto implements IGetDataVoucherBulkDto {
    receiptDate: moment.Moment;
    expirationDate: moment.Moment;
    projectID: number;
    projectInfoID: number;
    projectName: string;
    rewardName: string;
    rewardID: string;
    voucherTypeCode: string;
    voucherTypeName: string;
    jumlahData: number;

    constructor(data?: IGetDataVoucherBulkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.projectName = data["projectName"];
            this.rewardName = data["rewardName"];
            this.rewardID = data["rewardID"];
            this.voucherTypeCode = data["voucherTypeCode"];
            this.voucherTypeName = data["voucherTypeName"];
            this.jumlahData = data["jumlahData"];
        }
    }

    static fromJS(data: any): GetDataVoucherBulkDto {
        let result = new GetDataVoucherBulkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["projectName"] = this.projectName;
        data["rewardName"] = this.rewardName;
        data["rewardID"] = this.rewardID;
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["voucherTypeName"] = this.voucherTypeName;
        data["jumlahData"] = this.jumlahData;
        return data; 
    }
}

export interface IGetDataVoucherBulkDto {
    receiptDate: moment.Moment;
    expirationDate: moment.Moment;
    projectID: number;
    projectInfoID: number;
    projectName: string;
    rewardName: string;
    rewardID: string;
    voucherTypeCode: string;
    voucherTypeName: string;
    jumlahData: number;
}

export class GenerateVoucherBySystemDto implements IGenerateVoucherBySystemDto {
    projectId: number;
    projectInfoId: number;
    voucherTypeCode: string;
    rewardId: number;
    expiredDate: moment.Moment;
    qty: number;
    attachment: string;

    constructor(data?: IGenerateVoucherBySystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectInfoId = data["projectInfoId"];
            this.voucherTypeCode = data["voucherTypeCode"];
            this.rewardId = data["rewardId"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.qty = data["qty"];
            this.attachment = data["attachment"];
        }
    }

    static fromJS(data: any): GenerateVoucherBySystemDto {
        let result = new GenerateVoucherBySystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectInfoId"] = this.projectInfoId;
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["rewardId"] = this.rewardId;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["qty"] = this.qty;
        data["attachment"] = this.attachment;
        return data; 
    }
}

export interface IGenerateVoucherBySystemDto {
    projectId: number;
    projectInfoId: number;
    voucherTypeCode: string;
    rewardId: number;
    expiredDate: moment.Moment;
    qty: number;
    attachment: string;
}

export class GenerateVoucherByExcel implements IGenerateVoucherByExcel {
    projectId: number;
    projectInfoId: number;
    voucherTypeCode: string;
    rewardId: number;
    expiredDate: moment.Moment;
    attachment: string;
    listDataExcel: string[];

    constructor(data?: IGenerateVoucherByExcel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectInfoId = data["projectInfoId"];
            this.voucherTypeCode = data["voucherTypeCode"];
            this.rewardId = data["rewardId"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.attachment = data["attachment"];
            if (data["listDataExcel"] && data["listDataExcel"].constructor === Array) {
                this.listDataExcel = [];
                for (let item of data["listDataExcel"])
                    this.listDataExcel.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateVoucherByExcel {
        let result = new GenerateVoucherByExcel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectInfoId"] = this.projectInfoId;
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["rewardId"] = this.rewardId;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["attachment"] = this.attachment;
        if (this.listDataExcel && this.listDataExcel.constructor === Array) {
            data["listDataExcel"] = [];
            for (let item of this.listDataExcel)
                data["listDataExcel"].push(item);
        }
        return data; 
    }
}

export interface IGenerateVoucherByExcel {
    projectId: number;
    projectInfoId: number;
    voucherTypeCode: string;
    rewardId: number;
    expiredDate: moment.Moment;
    attachment: string;
    listDataExcel: string[];
}

export class InputPrintVoucherBulkDto implements IInputPrintVoucherBulkDto {
    receiptDate: moment.Moment;
    expirationDate: moment.Moment;
    projectID: number;
    projectInfoId: number;
    productName: string;
    projectName: string;
    rewardName: string;
    rewardID: number;
    voucherTypeCode: string;
    voucherTypeName: string;

    constructor(data?: IInputPrintVoucherBulkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.projectID = data["projectID"];
            this.projectInfoId = data["projectInfoId"];
            this.productName = data["productName"];
            this.projectName = data["projectName"];
            this.rewardName = data["rewardName"];
            this.rewardID = data["rewardID"];
            this.voucherTypeCode = data["voucherTypeCode"];
            this.voucherTypeName = data["voucherTypeName"];
        }
    }

    static fromJS(data: any): InputPrintVoucherBulkDto {
        let result = new InputPrintVoucherBulkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["projectID"] = this.projectID;
        data["projectInfoId"] = this.projectInfoId;
        data["productName"] = this.productName;
        data["projectName"] = this.projectName;
        data["rewardName"] = this.rewardName;
        data["rewardID"] = this.rewardID;
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["voucherTypeName"] = this.voucherTypeName;
        return data; 
    }
}

export interface IInputPrintVoucherBulkDto {
    receiptDate: moment.Moment;
    expirationDate: moment.Moment;
    projectID: number;
    projectInfoId: number;
    productName: string;
    projectName: string;
    rewardName: string;
    rewardID: number;
    voucherTypeCode: string;
    voucherTypeName: string;
}

export class CreateMsAccountInput implements ICreateMsAccountInput {
    id: number;
    entityID: number;
    projectID: number;
    accName: string;
    accCode: string;
    accNo: string;
    companyID: number;
    bankBranchID: number;
    bankID: number;
    projectName: string;
    isActive: boolean;
    isDefault: boolean;

    constructor(data?: ICreateMsAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entityID = data["entityID"];
            this.projectID = data["projectID"];
            this.accName = data["accName"];
            this.accCode = data["accCode"];
            this.accNo = data["accNo"];
            this.companyID = data["companyID"];
            this.bankBranchID = data["bankBranchID"];
            this.bankID = data["bankID"];
            this.projectName = data["projectName"];
            this.isActive = data["isActive"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): CreateMsAccountInput {
        let result = new CreateMsAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityID"] = this.entityID;
        data["projectID"] = this.projectID;
        data["accName"] = this.accName;
        data["accCode"] = this.accCode;
        data["accNo"] = this.accNo;
        data["companyID"] = this.companyID;
        data["bankBranchID"] = this.bankBranchID;
        data["bankID"] = this.bankID;
        data["projectName"] = this.projectName;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface ICreateMsAccountInput {
    id: number;
    entityID: number;
    projectID: number;
    accName: string;
    accCode: string;
    accNo: string;
    companyID: number;
    bankBranchID: number;
    bankID: number;
    projectName: string;
    isActive: boolean;
    isDefault: boolean;
}

export class ListResultDtoOfGetAllAccountListDto implements IListResultDtoOfGetAllAccountListDto {
    items: GetAllAccountListDto[];

    constructor(data?: IListResultDtoOfGetAllAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllAccountListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllAccountListDto {
        let result = new ListResultDtoOfGetAllAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllAccountListDto {
    items: GetAllAccountListDto[];
}

export class GetAllAccountListDto implements IGetAllAccountListDto {
    accountID: number;
    projectName: string;
    projectID: number;
    accName: string;
    accNo: string;
    companyID: number;
    companyName: string;
    bankBranchID: number;
    bankBranchName: string;
    bankID: number;
    bankName: string;
    isActive: boolean;
    accCode: string;
    isDefault: boolean;

    constructor(data?: IGetAllAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.projectName = data["projectName"];
            this.projectID = data["projectID"];
            this.accName = data["accName"];
            this.accNo = data["accNo"];
            this.companyID = data["companyID"];
            this.companyName = data["companyName"];
            this.bankBranchID = data["bankBranchID"];
            this.bankBranchName = data["bankBranchName"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.isActive = data["isActive"];
            this.accCode = data["accCode"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetAllAccountListDto {
        let result = new GetAllAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["projectName"] = this.projectName;
        data["projectID"] = this.projectID;
        data["accName"] = this.accName;
        data["accNo"] = this.accNo;
        data["companyID"] = this.companyID;
        data["companyName"] = this.companyName;
        data["bankBranchID"] = this.bankBranchID;
        data["bankBranchName"] = this.bankBranchName;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["isActive"] = this.isActive;
        data["accCode"] = this.accCode;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetAllAccountListDto {
    accountID: number;
    projectName: string;
    projectID: number;
    accName: string;
    accNo: string;
    companyID: number;
    companyName: string;
    bankBranchID: number;
    bankBranchName: string;
    bankID: number;
    bankName: string;
    isActive: boolean;
    accCode: string;
    isDefault: boolean;
}

export class ListResultDtoOfGetActiveMsBankBranchListDto implements IListResultDtoOfGetActiveMsBankBranchListDto {
    items: GetActiveMsBankBranchListDto[];

    constructor(data?: IListResultDtoOfGetActiveMsBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActiveMsBankBranchListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetActiveMsBankBranchListDto {
        let result = new ListResultDtoOfGetActiveMsBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetActiveMsBankBranchListDto {
    items: GetActiveMsBankBranchListDto[];
}

export class GetActiveMsBankBranchListDto implements IGetActiveMsBankBranchListDto {
    bankID: number;
    bankName: string;
    bankBranchID: number;
    bankBranchName: string;

    constructor(data?: IGetActiveMsBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.bankBranchID = data["bankBranchID"];
            this.bankBranchName = data["bankBranchName"];
        }
    }

    static fromJS(data: any): GetActiveMsBankBranchListDto {
        let result = new GetActiveMsBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["bankBranchID"] = this.bankBranchID;
        data["bankBranchName"] = this.bankBranchName;
        return data; 
    }
}

export interface IGetActiveMsBankBranchListDto {
    bankID: number;
    bankName: string;
    bankBranchID: number;
    bankBranchName: string;
}

export class CreateDeleteSysRolesInputDto implements ICreateDeleteSysRolesInputDto {
    rolesID: number;
    listSysRoles: number[];

    constructor(data?: ICreateDeleteSysRolesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rolesID = data["rolesID"];
            if (data["listSysRoles"] && data["listSysRoles"].constructor === Array) {
                this.listSysRoles = [];
                for (let item of data["listSysRoles"])
                    this.listSysRoles.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeleteSysRolesInputDto {
        let result = new CreateDeleteSysRolesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesID"] = this.rolesID;
        if (this.listSysRoles && this.listSysRoles.constructor === Array) {
            data["listSysRoles"] = [];
            for (let item of this.listSysRoles)
                data["listSysRoles"].push(item);
        }
        return data; 
    }
}

export interface ICreateDeleteSysRolesInputDto {
    rolesID: number;
    listSysRoles: number[];
}

export class CreateMsAreaInput implements ICreateMsAreaInput {
    entityCode: string;
    areaCode: string;
    cityID: number;
    regionName: string;

    constructor(data?: ICreateMsAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.areaCode = data["areaCode"];
            this.cityID = data["cityID"];
            this.regionName = data["regionName"];
        }
    }

    static fromJS(data: any): CreateMsAreaInput {
        let result = new CreateMsAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["areaCode"] = this.areaCode;
        data["cityID"] = this.cityID;
        data["regionName"] = this.regionName;
        return data; 
    }
}

export interface ICreateMsAreaInput {
    entityCode: string;
    areaCode: string;
    cityID: number;
    regionName: string;
}

export class ListResultDtoOfGetMsAreaListDto implements IListResultDtoOfGetMsAreaListDto {
    items: GetMsAreaListDto[];

    constructor(data?: IListResultDtoOfGetMsAreaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsAreaListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsAreaListDto {
        let result = new ListResultDtoOfGetMsAreaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsAreaListDto {
    items: GetMsAreaListDto[];
}

export class GetMsAreaListDto implements IGetMsAreaListDto {
    id: number;
    areaCode: string;
    territoryID: number;
    territoryName: string;
    countyID: number;
    countyName: string;
    cityID: number;
    cityName: string;
    regionName: string;

    constructor(data?: IGetMsAreaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.areaCode = data["areaCode"];
            this.territoryID = data["territoryID"];
            this.territoryName = data["territoryName"];
            this.countyID = data["countyID"];
            this.countyName = data["countyName"];
            this.cityID = data["cityID"];
            this.cityName = data["cityName"];
            this.regionName = data["regionName"];
        }
    }

    static fromJS(data: any): GetMsAreaListDto {
        let result = new GetMsAreaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaCode"] = this.areaCode;
        data["territoryID"] = this.territoryID;
        data["territoryName"] = this.territoryName;
        data["countyID"] = this.countyID;
        data["countyName"] = this.countyName;
        data["cityID"] = this.cityID;
        data["cityName"] = this.cityName;
        data["regionName"] = this.regionName;
        return data; 
    }
}

export interface IGetMsAreaListDto {
    id: number;
    areaCode: string;
    territoryID: number;
    territoryName: string;
    countyID: number;
    countyName: string;
    cityID: number;
    cityName: string;
    regionName: string;
}

export class UpdateMsAreaInput implements IUpdateMsAreaInput {
    id: number;
    areaCode: string;
    cityID: number;
    regionName: string;

    constructor(data?: IUpdateMsAreaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.areaCode = data["areaCode"];
            this.cityID = data["cityID"];
            this.regionName = data["regionName"];
        }
    }

    static fromJS(data: any): UpdateMsAreaInput {
        let result = new UpdateMsAreaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaCode"] = this.areaCode;
        data["cityID"] = this.cityID;
        data["regionName"] = this.regionName;
        return data; 
    }
}

export interface IUpdateMsAreaInput {
    id: number;
    areaCode: string;
    cityID: number;
    regionName: string;
}

export class PagedResultDtoOfMasterAssetDevIlustrationDto implements IPagedResultDtoOfMasterAssetDevIlustrationDto {
    totalCount: number;
    items: MasterAssetDevIlustrationDto[];

    constructor(data?: IPagedResultDtoOfMasterAssetDevIlustrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MasterAssetDevIlustrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMasterAssetDevIlustrationDto {
        let result = new PagedResultDtoOfMasterAssetDevIlustrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMasterAssetDevIlustrationDto {
    totalCount: number;
    items: MasterAssetDevIlustrationDto[];
}

export class MasterAssetDevIlustrationDto implements IMasterAssetDevIlustrationDto {
    id: number;
    projectID: number;
    clusterID: number;
    unitCode: string;
    unitNo: string;
    assetDevIlustrationCode: string;
    imageFileName: string;
    imageFileLocation: string;
    clusterName: string;
    creationTime: moment.Moment;

    constructor(data?: IMasterAssetDevIlustrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.assetDevIlustrationCode = data["assetDevIlustrationCode"];
            this.imageFileName = data["imageFileName"];
            this.imageFileLocation = data["imageFileLocation"];
            this.clusterName = data["clusterName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterAssetDevIlustrationDto {
        let result = new MasterAssetDevIlustrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["assetDevIlustrationCode"] = this.assetDevIlustrationCode;
        data["imageFileName"] = this.imageFileName;
        data["imageFileLocation"] = this.imageFileLocation;
        data["clusterName"] = this.clusterName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMasterAssetDevIlustrationDto {
    id: number;
    projectID: number;
    clusterID: number;
    unitCode: string;
    unitNo: string;
    assetDevIlustrationCode: string;
    imageFileName: string;
    imageFileLocation: string;
    clusterName: string;
    creationTime: moment.Moment;
}

export class CreateUpdateDeleteMasterAssetDevIlustrationDto implements ICreateUpdateDeleteMasterAssetDevIlustrationDto {
    createUpdate: MasterAssetDevIlustrationDto[];
    deleteMasterData: DeleteMasterAssetDevIlustrationDto[];

    constructor(data?: ICreateUpdateDeleteMasterAssetDevIlustrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["createUpdate"] && data["createUpdate"].constructor === Array) {
                this.createUpdate = [];
                for (let item of data["createUpdate"])
                    this.createUpdate.push(MasterAssetDevIlustrationDto.fromJS(item));
            }
            if (data["deleteMasterData"] && data["deleteMasterData"].constructor === Array) {
                this.deleteMasterData = [];
                for (let item of data["deleteMasterData"])
                    this.deleteMasterData.push(DeleteMasterAssetDevIlustrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateDeleteMasterAssetDevIlustrationDto {
        let result = new CreateUpdateDeleteMasterAssetDevIlustrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.createUpdate && this.createUpdate.constructor === Array) {
            data["createUpdate"] = [];
            for (let item of this.createUpdate)
                data["createUpdate"].push(item.toJSON());
        }
        if (this.deleteMasterData && this.deleteMasterData.constructor === Array) {
            data["deleteMasterData"] = [];
            for (let item of this.deleteMasterData)
                data["deleteMasterData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUpdateDeleteMasterAssetDevIlustrationDto {
    createUpdate: MasterAssetDevIlustrationDto[];
    deleteMasterData: DeleteMasterAssetDevIlustrationDto[];
}

export class DeleteMasterAssetDevIlustrationDto implements IDeleteMasterAssetDevIlustrationDto {
    deleteID: number;
    assetDevIlustrationCode: string;

    constructor(data?: IDeleteMasterAssetDevIlustrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteID = data["deleteID"];
            this.assetDevIlustrationCode = data["assetDevIlustrationCode"];
        }
    }

    static fromJS(data: any): DeleteMasterAssetDevIlustrationDto {
        let result = new DeleteMasterAssetDevIlustrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteID"] = this.deleteID;
        data["assetDevIlustrationCode"] = this.assetDevIlustrationCode;
        return data; 
    }
}

export interface IDeleteMasterAssetDevIlustrationDto {
    deleteID: number;
    assetDevIlustrationCode: string;
}

export class MsAssetDevIlustrationResultMessageDto implements IMsAssetDevIlustrationResultMessageDto {
    message: string;
    result: boolean;

    constructor(data?: IMsAssetDevIlustrationResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): MsAssetDevIlustrationResultMessageDto {
        let result = new MsAssetDevIlustrationResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IMsAssetDevIlustrationResultMessageDto {
    message: string;
    result: boolean;
}

export class FileNameAssetDevILustrationDto implements IFileNameAssetDevILustrationDto {
    fileNameTemp: string;

    constructor(data?: IFileNameAssetDevILustrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileNameTemp = data["fileNameTemp"];
        }
    }

    static fromJS(data: any): FileNameAssetDevILustrationDto {
        let result = new FileNameAssetDevILustrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileNameTemp"] = this.fileNameTemp;
        return data; 
    }
}

export interface IFileNameAssetDevILustrationDto {
    fileNameTemp: string;
}

export class ValidatedAssetResultMessageDto implements IValidatedAssetResultMessageDto {
    validUnitNoUnitCode: boolean;
    validAssetCode: boolean;
    result: string;

    constructor(data?: IValidatedAssetResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.validUnitNoUnitCode = data["validUnitNoUnitCode"];
            this.validAssetCode = data["validAssetCode"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): ValidatedAssetResultMessageDto {
        let result = new ValidatedAssetResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validUnitNoUnitCode"] = this.validUnitNoUnitCode;
        data["validAssetCode"] = this.validAssetCode;
        data["result"] = this.result;
        return data; 
    }
}

export interface IValidatedAssetResultMessageDto {
    validUnitNoUnitCode: boolean;
    validAssetCode: boolean;
    result: string;
}

export class CreateMsBankInput implements ICreateMsBankInput {
    entityID: number;
    bankName: string;
    bankCode: string;
    bankLevelCode: string;
    parentBankCode: string;
    divertToRO: boolean;
    address: string;
    phone: string;
    phoneCodeArea: string;
    fax: string;
    headName: string;
    deputyName1: string;
    deputyName2: string;
    att: string;
    groupBankCode: string;
    relationOfficerEmail: string;
    isActive: boolean;
    bankTypeID: number;
    swiftCode: string;
    picName: string;
    picPosition: string;
    email: string;

    constructor(data?: ICreateMsBankInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.bankName = data["bankName"];
            this.bankCode = data["bankCode"];
            this.bankLevelCode = data["bankLevelCode"];
            this.parentBankCode = data["parentBankCode"];
            this.divertToRO = data["divertToRO"];
            this.address = data["address"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
            this.fax = data["fax"];
            this.headName = data["headName"];
            this.deputyName1 = data["deputyName1"];
            this.deputyName2 = data["deputyName2"];
            this.att = data["att"];
            this.groupBankCode = data["groupBankCode"];
            this.relationOfficerEmail = data["relationOfficerEmail"];
            this.isActive = data["isActive"];
            this.bankTypeID = data["bankTypeID"];
            this.swiftCode = data["swiftCode"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): CreateMsBankInput {
        let result = new CreateMsBankInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["bankLevelCode"] = this.bankLevelCode;
        data["parentBankCode"] = this.parentBankCode;
        data["divertToRO"] = this.divertToRO;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        data["fax"] = this.fax;
        data["headName"] = this.headName;
        data["deputyName1"] = this.deputyName1;
        data["deputyName2"] = this.deputyName2;
        data["att"] = this.att;
        data["groupBankCode"] = this.groupBankCode;
        data["relationOfficerEmail"] = this.relationOfficerEmail;
        data["isActive"] = this.isActive;
        data["bankTypeID"] = this.bankTypeID;
        data["swiftCode"] = this.swiftCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["email"] = this.email;
        return data; 
    }
}

export interface ICreateMsBankInput {
    entityID: number;
    bankName: string;
    bankCode: string;
    bankLevelCode: string;
    parentBankCode: string;
    divertToRO: boolean;
    address: string;
    phone: string;
    phoneCodeArea: string;
    fax: string;
    headName: string;
    deputyName1: string;
    deputyName2: string;
    att: string;
    groupBankCode: string;
    relationOfficerEmail: string;
    isActive: boolean;
    bankTypeID: number;
    swiftCode: string;
    picName: string;
    picPosition: string;
    email: string;
}

export class ListResultDtoOfGetAllBankListDto implements IListResultDtoOfGetAllBankListDto {
    items: GetAllBankListDto[];

    constructor(data?: IListResultDtoOfGetAllBankListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBankListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllBankListDto {
        let result = new ListResultDtoOfGetAllBankListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllBankListDto {
    items: GetAllBankListDto[];
}

export class GetAllBankListDto implements IGetAllBankListDto {
    bankID: number;
    bankName: string;
    bankCode: string;
    bankTypeID: number;
    bankTypeName: string;
    swiftCode: string;
    isActive: boolean;
    picName: string;
    picPosition: string;
    email: string;
    phone: string;
    phoneCodeArea: string;

    constructor(data?: IGetAllBankListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.bankCode = data["bankCode"];
            this.bankTypeID = data["bankTypeID"];
            this.bankTypeName = data["bankTypeName"];
            this.swiftCode = data["swiftCode"];
            this.isActive = data["isActive"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
        }
    }

    static fromJS(data: any): GetAllBankListDto {
        let result = new GetAllBankListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["bankTypeID"] = this.bankTypeID;
        data["bankTypeName"] = this.bankTypeName;
        data["swiftCode"] = this.swiftCode;
        data["isActive"] = this.isActive;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        return data; 
    }
}

export interface IGetAllBankListDto {
    bankID: number;
    bankName: string;
    bankCode: string;
    bankTypeID: number;
    bankTypeName: string;
    swiftCode: string;
    isActive: boolean;
    picName: string;
    picPosition: string;
    email: string;
    phone: string;
    phoneCodeArea: string;
}

export class ListResultDtoOfGetBankListDto implements IListResultDtoOfGetBankListDto {
    items: GetBankListDto[];

    constructor(data?: IListResultDtoOfGetBankListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetBankListDto {
        let result = new ListResultDtoOfGetBankListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetBankListDto {
    items: GetBankListDto[];
}

export class GetBankListDto implements IGetBankListDto {
    id: number;
    bankName: string;
    bankCode: string;

    constructor(data?: IGetBankListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bankName = data["bankName"];
            this.bankCode = data["bankCode"];
        }
    }

    static fromJS(data: any): GetBankListDto {
        let result = new GetBankListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        return data; 
    }
}

export interface IGetBankListDto {
    id: number;
    bankName: string;
    bankCode: string;
}

export class ListResultDtoOfGetBankDropDownListDto implements IListResultDtoOfGetBankDropDownListDto {
    items: GetBankDropDownListDto[];

    constructor(data?: IListResultDtoOfGetBankDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankDropDownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetBankDropDownListDto {
        let result = new ListResultDtoOfGetBankDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetBankDropDownListDto {
    items: GetBankDropDownListDto[];
}

export class ListResultDtoOfGetTypeBankDropDownListDto implements IListResultDtoOfGetTypeBankDropDownListDto {
    items: GetTypeBankDropDownListDto[];

    constructor(data?: IListResultDtoOfGetTypeBankDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTypeBankDropDownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetTypeBankDropDownListDto {
        let result = new ListResultDtoOfGetTypeBankDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetTypeBankDropDownListDto {
    items: GetTypeBankDropDownListDto[];
}

export class GetTypeBankDropDownListDto implements IGetTypeBankDropDownListDto {
    bankTypeID: number;
    typeName: string;

    constructor(data?: IGetTypeBankDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankTypeID = data["bankTypeID"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): GetTypeBankDropDownListDto {
        let result = new GetTypeBankDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankTypeID"] = this.bankTypeID;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface IGetTypeBankDropDownListDto {
    bankTypeID: number;
    typeName: string;
}

export class ListResultDtoOfGetBankBranchListDto implements IListResultDtoOfGetBankBranchListDto {
    items: GetBankBranchListDto[];

    constructor(data?: IListResultDtoOfGetBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankBranchListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetBankBranchListDto {
        let result = new ListResultDtoOfGetBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetBankBranchListDto {
    items: GetBankBranchListDto[];
}

export class GetBankBranchListDto implements IGetBankBranchListDto {
    id: number;
    entityID: number;
    bankBranchCode: string;
    bankBranchName: string;
    bankBranchType: string;
    bankBranchTypeID: number;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    jenisKantorBank: string;
    bankCode: string;
    swiftCode: string;

    constructor(data?: IGetBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entityID = data["entityID"];
            this.bankBranchCode = data["bankBranchCode"];
            this.bankBranchName = data["bankBranchName"];
            this.bankBranchType = data["bankBranchType"];
            this.bankBranchTypeID = data["bankBranchTypeID"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
            this.email = data["email"];
            this.isActive = data["isActive"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.jenisKantorBank = data["jenisKantorBank"];
            this.bankCode = data["bankCode"];
            this.swiftCode = data["swiftCode"];
        }
    }

    static fromJS(data: any): GetBankBranchListDto {
        let result = new GetBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityID"] = this.entityID;
        data["bankBranchCode"] = this.bankBranchCode;
        data["bankBranchName"] = this.bankBranchName;
        data["bankBranchType"] = this.bankBranchType;
        data["bankBranchTypeID"] = this.bankBranchTypeID;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["jenisKantorBank"] = this.jenisKantorBank;
        data["bankCode"] = this.bankCode;
        data["swiftCode"] = this.swiftCode;
        return data; 
    }
}

export interface IGetBankBranchListDto {
    id: number;
    entityID: number;
    bankBranchCode: string;
    bankBranchName: string;
    bankBranchType: string;
    bankBranchTypeID: number;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    jenisKantorBank: string;
    bankCode: string;
    swiftCode: string;
}

export class ListResultDtoOfGetAllBankBranchListDto implements IListResultDtoOfGetAllBankBranchListDto {
    items: GetAllBankBranchListDto[];

    constructor(data?: IListResultDtoOfGetAllBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBankBranchListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllBankBranchListDto {
        let result = new ListResultDtoOfGetAllBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllBankBranchListDto {
    items: GetAllBankBranchListDto[];
}

export class GetAllBankBranchListDto implements IGetAllBankBranchListDto {
    id: number;
    entityID: number;
    bankBranchCode: string;
    bankBranchName: string;
    bankBranchType: string;
    bankBranchTypeID: number;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    jenisKantorBank: string;
    bankCode: string;
    swiftCode: string;

    constructor(data?: IGetAllBankBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entityID = data["entityID"];
            this.bankBranchCode = data["bankBranchCode"];
            this.bankBranchName = data["bankBranchName"];
            this.bankBranchType = data["bankBranchType"];
            this.bankBranchTypeID = data["bankBranchTypeID"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
            this.email = data["email"];
            this.isActive = data["isActive"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.jenisKantorBank = data["jenisKantorBank"];
            this.bankCode = data["bankCode"];
            this.swiftCode = data["swiftCode"];
        }
    }

    static fromJS(data: any): GetAllBankBranchListDto {
        let result = new GetAllBankBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityID"] = this.entityID;
        data["bankBranchCode"] = this.bankBranchCode;
        data["bankBranchName"] = this.bankBranchName;
        data["bankBranchType"] = this.bankBranchType;
        data["bankBranchTypeID"] = this.bankBranchTypeID;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["jenisKantorBank"] = this.jenisKantorBank;
        data["bankCode"] = this.bankCode;
        data["swiftCode"] = this.swiftCode;
        return data; 
    }
}

export interface IGetAllBankBranchListDto {
    id: number;
    entityID: number;
    bankBranchCode: string;
    bankBranchName: string;
    bankBranchType: string;
    bankBranchTypeID: number;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    jenisKantorBank: string;
    bankCode: string;
    swiftCode: string;
}

export class CreateMsBankBranchInputDto implements ICreateMsBankBranchInputDto {
    bankBranchCode: string;
    bankBranchName: string;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankBranchTypeID: number;

    constructor(data?: ICreateMsBankBranchInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankBranchCode = data["bankBranchCode"];
            this.bankBranchName = data["bankBranchName"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
            this.email = data["email"];
            this.isActive = data["isActive"];
            this.bankID = data["bankID"];
            this.bankBranchTypeID = data["bankBranchTypeID"];
        }
    }

    static fromJS(data: any): CreateMsBankBranchInputDto {
        let result = new CreateMsBankBranchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranchCode"] = this.bankBranchCode;
        data["bankBranchName"] = this.bankBranchName;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["bankID"] = this.bankID;
        data["bankBranchTypeID"] = this.bankBranchTypeID;
        return data; 
    }
}

export interface ICreateMsBankBranchInputDto {
    bankBranchCode: string;
    bankBranchName: string;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankBranchTypeID: number;
}

export class UpdateMsBankBranchInputDto implements IUpdateMsBankBranchInputDto {
    id: number;
    bankBranchCode: string;
    bankBranchName: string;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankBranchTypeID: number;

    constructor(data?: IUpdateMsBankBranchInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bankBranchCode = data["bankBranchCode"];
            this.bankBranchName = data["bankBranchName"];
            this.picName = data["picName"];
            this.picPosition = data["picPosition"];
            this.phone = data["phone"];
            this.phoneCodeArea = data["phoneCodeArea"];
            this.email = data["email"];
            this.isActive = data["isActive"];
            this.bankID = data["bankID"];
            this.bankBranchTypeID = data["bankBranchTypeID"];
        }
    }

    static fromJS(data: any): UpdateMsBankBranchInputDto {
        let result = new UpdateMsBankBranchInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankBranchCode"] = this.bankBranchCode;
        data["bankBranchName"] = this.bankBranchName;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["phone"] = this.phone;
        data["phoneCodeArea"] = this.phoneCodeArea;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["bankID"] = this.bankID;
        data["bankBranchTypeID"] = this.bankBranchTypeID;
        return data; 
    }
}

export interface IUpdateMsBankBranchInputDto {
    id: number;
    bankBranchCode: string;
    bankBranchName: string;
    picName: string;
    picPosition: string;
    phone: string;
    phoneCodeArea: string;
    email: string;
    isActive: boolean;
    bankID: number;
    bankBranchTypeID: number;
}

export class ListResultDtoOfGetBankBranchTypeListDto implements IListResultDtoOfGetBankBranchTypeListDto {
    items: GetBankBranchTypeListDto[];

    constructor(data?: IListResultDtoOfGetBankBranchTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankBranchTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetBankBranchTypeListDto {
        let result = new ListResultDtoOfGetBankBranchTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetBankBranchTypeListDto {
    items: GetBankBranchTypeListDto[];
}

export class GetBankBranchTypeListDto implements IGetBankBranchTypeListDto {
    bankBranchTypeID: number;
    typeName: string;

    constructor(data?: IGetBankBranchTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankBranchTypeID = data["bankBranchTypeID"];
            this.typeName = data["typeName"];
        }
    }

    static fromJS(data: any): GetBankBranchTypeListDto {
        let result = new GetBankBranchTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankBranchTypeID"] = this.bankBranchTypeID;
        data["typeName"] = this.typeName;
        return data; 
    }
}

export interface IGetBankBranchTypeListDto {
    bankBranchTypeID: number;
    typeName: string;
}

export class ListResultDtoOfGetAllBankPersonalsListDto implements IListResultDtoOfGetAllBankPersonalsListDto {
    items: GetAllBankPersonalsListDto[];

    constructor(data?: IListResultDtoOfGetAllBankPersonalsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBankPersonalsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllBankPersonalsListDto {
        let result = new ListResultDtoOfGetAllBankPersonalsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllBankPersonalsListDto {
    items: GetAllBankPersonalsListDto[];
}

export class GetAllBankPersonalsListDto implements IGetAllBankPersonalsListDto {
    bankCode: string;
    bankName: string;

    constructor(data?: IGetAllBankPersonalsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetAllBankPersonalsListDto {
        let result = new GetAllBankPersonalsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetAllBankPersonalsListDto {
    bankCode: string;
    bankName: string;
}

export class ListResultDtoOfGetAllCategoryListDto implements IListResultDtoOfGetAllCategoryListDto {
    items: GetAllCategoryListDto[];

    constructor(data?: IListResultDtoOfGetAllCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllCategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllCategoryListDto {
        let result = new ListResultDtoOfGetAllCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllCategoryListDto {
    items: GetAllCategoryListDto[];
}

export class GetAllCategoryListDto implements IGetAllCategoryListDto {
    categoryID: number;
    categoryName: string;
    categoryCode: string;
    isActive: boolean;

    constructor(data?: IGetAllCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
            this.categoryCode = data["categoryCode"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllCategoryListDto {
        let result = new GetAllCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        data["categoryCode"] = this.categoryCode;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllCategoryListDto {
    categoryID: number;
    categoryName: string;
    categoryCode: string;
    isActive: boolean;
}

export class CreateCategoryInputDto implements ICreateCategoryInputDto {
    categoryName: string;
    categoryCode: string;
    isActive: boolean;

    constructor(data?: ICreateCategoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryName = data["categoryName"];
            this.categoryCode = data["categoryCode"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateCategoryInputDto {
        let result = new CreateCategoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["categoryCode"] = this.categoryCode;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateCategoryInputDto {
    categoryName: string;
    categoryCode: string;
    isActive: boolean;
}

export class ListResultDtoOfGetCategoryDropdownListDto implements IListResultDtoOfGetCategoryDropdownListDto {
    items: GetCategoryDropdownListDto[];

    constructor(data?: IListResultDtoOfGetCategoryDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCategoryDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetCategoryDropdownListDto {
        let result = new ListResultDtoOfGetCategoryDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetCategoryDropdownListDto {
    items: GetCategoryDropdownListDto[];
}

export class GetCategoryDropdownListDto implements IGetCategoryDropdownListDto {
    categoryID: number;
    categoryName: string;

    constructor(data?: IGetCategoryDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): GetCategoryDropdownListDto {
        let result = new GetCategoryDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface IGetCategoryDropdownListDto {
    categoryID: number;
    categoryName: string;
}

export class GetCreateMsCityInputDto implements IGetCreateMsCityInputDto {
    cityName: string;
    countyID: number;

    constructor(data?: IGetCreateMsCityInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cityName = data["cityName"];
            this.countyID = data["countyID"];
        }
    }

    static fromJS(data: any): GetCreateMsCityInputDto {
        let result = new GetCreateMsCityInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityName"] = this.cityName;
        data["countyID"] = this.countyID;
        return data; 
    }
}

export interface IGetCreateMsCityInputDto {
    cityName: string;
    countyID: number;
}

export class ListResultDtoOfGetMsCityListDto implements IListResultDtoOfGetMsCityListDto {
    items: GetMsCityListDto[];

    constructor(data?: IListResultDtoOfGetMsCityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsCityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsCityListDto {
        let result = new ListResultDtoOfGetMsCityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsCityListDto {
    items: GetMsCityListDto[];
}

export class GetMsCityListDto implements IGetMsCityListDto {
    cityID: number;
    cityName: string;
    countyID: number;

    constructor(data?: IGetMsCityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cityID = data["cityID"];
            this.cityName = data["cityName"];
            this.countyID = data["countyID"];
        }
    }

    static fromJS(data: any): GetMsCityListDto {
        let result = new GetMsCityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityID"] = this.cityID;
        data["cityName"] = this.cityName;
        data["countyID"] = this.countyID;
        return data; 
    }
}

export interface IGetMsCityListDto {
    cityID: number;
    cityName: string;
    countyID: number;
}

export class CreateOrUpdateMsClusterInputDto implements ICreateOrUpdateMsClusterInputDto {
    id: number;
    projectID: number;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    website: string;
    docCode: string;
    termConditionFile: string;
    termConditionFileStatus: string;
    spesfikasiUnitFile: string;
    spesfikasiUnitFileStatus: string;
    createOrUpdateHandOverPeriodeDto: CreateOrUpdateHandOverPeriodeDto[];
    createOrUpdateClusterPICDto: CreateOrUpdateClusterPICDto[];
    bankName: string;
    accNo: string;
    accName: string;

    constructor(data?: ICreateOrUpdateMsClusterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.website = data["website"];
            this.docCode = data["docCode"];
            this.termConditionFile = data["termConditionFile"];
            this.termConditionFileStatus = data["termConditionFileStatus"];
            this.spesfikasiUnitFile = data["spesfikasiUnitFile"];
            this.spesfikasiUnitFileStatus = data["spesfikasiUnitFileStatus"];
            if (data["createOrUpdateHandOverPeriodeDto"] && data["createOrUpdateHandOverPeriodeDto"].constructor === Array) {
                this.createOrUpdateHandOverPeriodeDto = [];
                for (let item of data["createOrUpdateHandOverPeriodeDto"])
                    this.createOrUpdateHandOverPeriodeDto.push(CreateOrUpdateHandOverPeriodeDto.fromJS(item));
            }
            if (data["createOrUpdateClusterPICDto"] && data["createOrUpdateClusterPICDto"].constructor === Array) {
                this.createOrUpdateClusterPICDto = [];
                for (let item of data["createOrUpdateClusterPICDto"])
                    this.createOrUpdateClusterPICDto.push(CreateOrUpdateClusterPICDto.fromJS(item));
            }
            this.bankName = data["bankName"];
            this.accNo = data["accNo"];
            this.accName = data["accName"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMsClusterInputDto {
        let result = new CreateOrUpdateMsClusterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["website"] = this.website;
        data["docCode"] = this.docCode;
        data["termConditionFile"] = this.termConditionFile;
        data["termConditionFileStatus"] = this.termConditionFileStatus;
        data["spesfikasiUnitFile"] = this.spesfikasiUnitFile;
        data["spesfikasiUnitFileStatus"] = this.spesfikasiUnitFileStatus;
        if (this.createOrUpdateHandOverPeriodeDto && this.createOrUpdateHandOverPeriodeDto.constructor === Array) {
            data["createOrUpdateHandOverPeriodeDto"] = [];
            for (let item of this.createOrUpdateHandOverPeriodeDto)
                data["createOrUpdateHandOverPeriodeDto"].push(item.toJSON());
        }
        if (this.createOrUpdateClusterPICDto && this.createOrUpdateClusterPICDto.constructor === Array) {
            data["createOrUpdateClusterPICDto"] = [];
            for (let item of this.createOrUpdateClusterPICDto)
                data["createOrUpdateClusterPICDto"].push(item.toJSON());
        }
        data["bankName"] = this.bankName;
        data["accNo"] = this.accNo;
        data["accName"] = this.accName;
        return data; 
    }
}

export interface ICreateOrUpdateMsClusterInputDto {
    id: number;
    projectID: number;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    website: string;
    docCode: string;
    termConditionFile: string;
    termConditionFileStatus: string;
    spesfikasiUnitFile: string;
    spesfikasiUnitFileStatus: string;
    createOrUpdateHandOverPeriodeDto: CreateOrUpdateHandOverPeriodeDto[];
    createOrUpdateClusterPICDto: CreateOrUpdateClusterPICDto[];
    bankName: string;
    accNo: string;
    accName: string;
}

export class CreateOrUpdateHandOverPeriodeDto implements ICreateOrUpdateHandOverPeriodeDto {
    handOverStart: moment.Moment;
    handOverEnd: moment.Moment;
    handOverDue: string;
    graceDue: string;
    handOverCity: string;
    handOverPlace: string;

    constructor(data?: ICreateOrUpdateHandOverPeriodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.handOverStart = data["handOverStart"] ? moment(data["handOverStart"].toString()) : <any>undefined;
            this.handOverEnd = data["handOverEnd"] ? moment(data["handOverEnd"].toString()) : <any>undefined;
            this.handOverDue = data["handOverDue"];
            this.graceDue = data["graceDue"];
            this.handOverCity = data["handOverCity"];
            this.handOverPlace = data["handOverPlace"];
        }
    }

    static fromJS(data: any): CreateOrUpdateHandOverPeriodeDto {
        let result = new CreateOrUpdateHandOverPeriodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handOverStart"] = this.handOverStart ? this.handOverStart.toISOString() : <any>undefined;
        data["handOverEnd"] = this.handOverEnd ? this.handOverEnd.toISOString() : <any>undefined;
        data["handOverDue"] = this.handOverDue;
        data["graceDue"] = this.graceDue;
        data["handOverCity"] = this.handOverCity;
        data["handOverPlace"] = this.handOverPlace;
        return data; 
    }
}

export interface ICreateOrUpdateHandOverPeriodeDto {
    handOverStart: moment.Moment;
    handOverEnd: moment.Moment;
    handOverDue: string;
    graceDue: string;
    handOverCity: string;
    handOverPlace: string;
}

export class CreateOrUpdateClusterPICDto implements ICreateOrUpdateClusterPICDto {
    picClusterName: string;
    officePhoneNo: string;
    handphoneNo: string;
    picEmail: string;
    setDefault: boolean;
    clusterID: number;

    constructor(data?: ICreateOrUpdateClusterPICDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.picClusterName = data["picClusterName"];
            this.officePhoneNo = data["officePhoneNo"];
            this.handphoneNo = data["handphoneNo"];
            this.picEmail = data["picEmail"];
            this.setDefault = data["setDefault"];
            this.clusterID = data["clusterID"];
        }
    }

    static fromJS(data: any): CreateOrUpdateClusterPICDto {
        let result = new CreateOrUpdateClusterPICDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["picClusterName"] = this.picClusterName;
        data["officePhoneNo"] = this.officePhoneNo;
        data["handphoneNo"] = this.handphoneNo;
        data["picEmail"] = this.picEmail;
        data["setDefault"] = this.setDefault;
        data["clusterID"] = this.clusterID;
        return data; 
    }
}

export interface ICreateOrUpdateClusterPICDto {
    picClusterName: string;
    officePhoneNo: string;
    handphoneNo: string;
    picEmail: string;
    setDefault: boolean;
    clusterID: number;
}

export class ListResultDtoOfGetAllMsClusterListDto implements IListResultDtoOfGetAllMsClusterListDto {
    items: GetAllMsClusterListDto[];

    constructor(data?: IListResultDtoOfGetAllMsClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsClusterListDto {
        let result = new ListResultDtoOfGetAllMsClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsClusterListDto {
    items: GetAllMsClusterListDto[];
}

export class GetAllMsClusterListDto implements IGetAllMsClusterListDto {
    id: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetAllMsClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetAllMsClusterListDto {
        let result = new GetAllMsClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetAllMsClusterListDto {
    id: number;
    clusterCode: string;
    clusterName: string;
}

export class ListResultDtoOfGetClusterDropdownListDto implements IListResultDtoOfGetClusterDropdownListDto {
    items: GetClusterDropdownListDto[];

    constructor(data?: IListResultDtoOfGetClusterDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetClusterDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetClusterDropdownListDto {
        let result = new ListResultDtoOfGetClusterDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetClusterDropdownListDto {
    items: GetClusterDropdownListDto[];
}

export class GetClusterDropdownListDto implements IGetClusterDropdownListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetClusterDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetClusterDropdownListDto {
        let result = new GetClusterDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetClusterDropdownListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto implements IListResultDtoOfGetAvailableMsProjectDropdownForClusterDto {
    items: GetAvailableMsProjectDropdownForClusterDto[];

    constructor(data?: IListResultDtoOfGetAvailableMsProjectDropdownForClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAvailableMsProjectDropdownForClusterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto {
        let result = new ListResultDtoOfGetAvailableMsProjectDropdownForClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAvailableMsProjectDropdownForClusterDto {
    items: GetAvailableMsProjectDropdownForClusterDto[];
}

export class GetAvailableMsProjectDropdownForClusterDto implements IGetAvailableMsProjectDropdownForClusterDto {
    projectID: number;
    projectName: string;
    projectCode: string;

    constructor(data?: IGetAvailableMsProjectDropdownForClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetAvailableMsProjectDropdownForClusterDto {
        let result = new GetAvailableMsProjectDropdownForClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetAvailableMsProjectDropdownForClusterDto {
    projectID: number;
    projectName: string;
    projectCode: string;
}

export class CreateMsCompanyInput implements ICreateMsCompanyInput {
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;
    image: string;
    isActive: boolean;
    postCodeID: number;
    fileName: string;

    constructor(data?: ICreateMsCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.address = data["address"];
            this.email = data["email"];
            this.phoneNo = data["phoneNo"];
            this.faxNo = data["faxNo"];
            this.npwp = data["npwp"];
            this.npwpAddress = data["npwpAddress"];
            this.kppName = data["kppName"];
            this.kppTTD = data["kppTTD"];
            this.pkp = data["pkp"];
            this.pkpDate = data["pkpDate"] ? moment(data["pkpDate"].toString()) : <any>undefined;
            this.image = data["image"];
            this.isActive = data["isActive"];
            this.postCodeID = data["postCodeID"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): CreateMsCompanyInput {
        let result = new CreateMsCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["faxNo"] = this.faxNo;
        data["npwp"] = this.npwp;
        data["npwpAddress"] = this.npwpAddress;
        data["kppName"] = this.kppName;
        data["kppTTD"] = this.kppTTD;
        data["pkp"] = this.pkp;
        data["pkpDate"] = this.pkpDate ? this.pkpDate.toISOString() : <any>undefined;
        data["image"] = this.image;
        data["isActive"] = this.isActive;
        data["postCodeID"] = this.postCodeID;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface ICreateMsCompanyInput {
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;
    image: string;
    isActive: boolean;
    postCodeID: number;
    fileName: string;
}

export class GetDetailMsCompanyListDto implements IGetDetailMsCompanyListDto {
    companyInformationDto: CompanyInformationDto;
    documentInformationDto: DocumentInformationDto;

    constructor(data?: IGetDetailMsCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyInformationDto = data["companyInformationDto"] ? CompanyInformationDto.fromJS(data["companyInformationDto"]) : <any>undefined;
            this.documentInformationDto = data["documentInformationDto"] ? DocumentInformationDto.fromJS(data["documentInformationDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailMsCompanyListDto {
        let result = new GetDetailMsCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyInformationDto"] = this.companyInformationDto ? this.companyInformationDto.toJSON() : <any>undefined;
        data["documentInformationDto"] = this.documentInformationDto ? this.documentInformationDto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailMsCompanyListDto {
    companyInformationDto: CompanyInformationDto;
    documentInformationDto: DocumentInformationDto;
}

export class CompanyInformationDto implements ICompanyInformationDto {
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    isActive: boolean;
    image: string;
    countryID: number;
    townID: number;
    postCodeID: number;
    countryName: string;
    townName: string;
    postCode: string;

    constructor(data?: ICompanyInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.address = data["address"];
            this.email = data["email"];
            this.phoneNo = data["phoneNo"];
            this.faxNo = data["faxNo"];
            this.isActive = data["isActive"];
            this.image = data["image"];
            this.countryID = data["countryID"];
            this.townID = data["townID"];
            this.postCodeID = data["postCodeID"];
            this.countryName = data["countryName"];
            this.townName = data["townName"];
            this.postCode = data["postCode"];
        }
    }

    static fromJS(data: any): CompanyInformationDto {
        let result = new CompanyInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["faxNo"] = this.faxNo;
        data["isActive"] = this.isActive;
        data["image"] = this.image;
        data["countryID"] = this.countryID;
        data["townID"] = this.townID;
        data["postCodeID"] = this.postCodeID;
        data["countryName"] = this.countryName;
        data["townName"] = this.townName;
        data["postCode"] = this.postCode;
        return data; 
    }
}

export interface ICompanyInformationDto {
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    isActive: boolean;
    image: string;
    countryID: number;
    townID: number;
    postCodeID: number;
    countryName: string;
    townName: string;
    postCode: string;
}

export class DocumentInformationDto implements IDocumentInformationDto {
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;

    constructor(data?: IDocumentInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.npwp = data["npwp"];
            this.npwpAddress = data["npwpAddress"];
            this.kppName = data["kppName"];
            this.kppTTD = data["kppTTD"];
            this.pkp = data["pkp"];
            this.pkpDate = data["pkpDate"] ? moment(data["pkpDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentInformationDto {
        let result = new DocumentInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["npwp"] = this.npwp;
        data["npwpAddress"] = this.npwpAddress;
        data["kppName"] = this.kppName;
        data["kppTTD"] = this.kppTTD;
        data["pkp"] = this.pkp;
        data["pkpDate"] = this.pkpDate ? this.pkpDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDocumentInformationDto {
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;
}

export class ListResultDtoOfGetMsCompanyListDto implements IListResultDtoOfGetMsCompanyListDto {
    items: GetMsCompanyListDto[];

    constructor(data?: IListResultDtoOfGetMsCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsCompanyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsCompanyListDto {
        let result = new ListResultDtoOfGetMsCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsCompanyListDto {
    items: GetMsCompanyListDto[];
}

export class GetMsCompanyListDto implements IGetMsCompanyListDto {
    id: number;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    isActive: boolean;

    constructor(data?: IGetMsCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.coName = data["coName"];
            this.address = data["address"];
            this.email = data["email"];
            this.phoneNo = data["phoneNo"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetMsCompanyListDto {
        let result = new GetMsCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coName"] = this.coName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetMsCompanyListDto {
    id: number;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    isActive: boolean;
}

export class ListResultDtoOfGetCountryListDto implements IListResultDtoOfGetCountryListDto {
    items: GetCountryListDto[];

    constructor(data?: IListResultDtoOfGetCountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCountryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetCountryListDto {
        let result = new ListResultDtoOfGetCountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetCountryListDto {
    items: GetCountryListDto[];
}

export class GetCountryListDto implements IGetCountryListDto {
    id: number;
    countryName: string;
    countryCode: string;

    constructor(data?: IGetCountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.countryName = data["countryName"];
            this.countryCode = data["countryCode"];
        }
    }

    static fromJS(data: any): GetCountryListDto {
        let result = new GetCountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        return data; 
    }
}

export interface IGetCountryListDto {
    id: number;
    countryName: string;
    countryCode: string;
}

export class ListResultDtoOfGetTownListDto implements IListResultDtoOfGetTownListDto {
    items: GetTownListDto[];

    constructor(data?: IListResultDtoOfGetTownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetTownListDto {
        let result = new ListResultDtoOfGetTownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetTownListDto {
    items: GetTownListDto[];
}

export class GetTownListDto implements IGetTownListDto {
    id: number;
    countryID: number;
    townName: string;
    townCode: string;

    constructor(data?: IGetTownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.countryID = data["countryID"];
            this.townName = data["townName"];
            this.townCode = data["townCode"];
        }
    }

    static fromJS(data: any): GetTownListDto {
        let result = new GetTownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryID"] = this.countryID;
        data["townName"] = this.townName;
        data["townCode"] = this.townCode;
        return data; 
    }
}

export interface IGetTownListDto {
    id: number;
    countryID: number;
    townName: string;
    townCode: string;
}

export class ListResultDtoOfGetPostCodeListDto implements IListResultDtoOfGetPostCodeListDto {
    items: GetPostCodeListDto[];

    constructor(data?: IListResultDtoOfGetPostCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPostCodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetPostCodeListDto {
        let result = new ListResultDtoOfGetPostCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetPostCodeListDto {
    items: GetPostCodeListDto[];
}

export class GetPostCodeListDto implements IGetPostCodeListDto {
    id: number;
    postCode: string;
    regency: string;
    village: string;

    constructor(data?: IGetPostCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.postCode = data["postCode"];
            this.regency = data["regency"];
            this.village = data["village"];
        }
    }

    static fromJS(data: any): GetPostCodeListDto {
        let result = new GetPostCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postCode"] = this.postCode;
        data["regency"] = this.regency;
        data["village"] = this.village;
        return data; 
    }
}

export interface IGetPostCodeListDto {
    id: number;
    postCode: string;
    regency: string;
    village: string;
}

export class UpdateMsCompanyInput implements IUpdateMsCompanyInput {
    id: number;
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;
    isActive: boolean;
    countryID: number;
    townID: number;
    postCodeID: number;
    fileName: string;
    fileNameNew: string;
    image: string;

    constructor(data?: IUpdateMsCompanyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.address = data["address"];
            this.email = data["email"];
            this.phoneNo = data["phoneNo"];
            this.faxNo = data["faxNo"];
            this.npwp = data["npwp"];
            this.npwpAddress = data["npwpAddress"];
            this.kppName = data["kppName"];
            this.kppTTD = data["kppTTD"];
            this.pkp = data["pkp"];
            this.pkpDate = data["pkpDate"] ? moment(data["pkpDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.countryID = data["countryID"];
            this.townID = data["townID"];
            this.postCodeID = data["postCodeID"];
            this.fileName = data["fileName"];
            this.fileNameNew = data["fileNameNew"];
            this.image = data["image"];
        }
    }

    static fromJS(data: any): UpdateMsCompanyInput {
        let result = new UpdateMsCompanyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phoneNo"] = this.phoneNo;
        data["faxNo"] = this.faxNo;
        data["npwp"] = this.npwp;
        data["npwpAddress"] = this.npwpAddress;
        data["kppName"] = this.kppName;
        data["kppTTD"] = this.kppTTD;
        data["pkp"] = this.pkp;
        data["pkpDate"] = this.pkpDate ? this.pkpDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["countryID"] = this.countryID;
        data["townID"] = this.townID;
        data["postCodeID"] = this.postCodeID;
        data["fileName"] = this.fileName;
        data["fileNameNew"] = this.fileNameNew;
        data["image"] = this.image;
        return data; 
    }
}

export interface IUpdateMsCompanyInput {
    id: number;
    coCode: string;
    coName: string;
    address: string;
    email: string;
    phoneNo: string;
    faxNo: string;
    npwp: string;
    npwpAddress: string;
    kppName: string;
    kppTTD: string;
    pkp: string;
    pkpDate: moment.Moment;
    isActive: boolean;
    countryID: number;
    townID: number;
    postCodeID: number;
    fileName: string;
    fileNameNew: string;
    image: string;
}

export class ListResultDtoOfGetMsCompanyDropDownListDto implements IListResultDtoOfGetMsCompanyDropDownListDto {
    items: GetMsCompanyDropDownListDto[];

    constructor(data?: IListResultDtoOfGetMsCompanyDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsCompanyDropDownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsCompanyDropDownListDto {
        let result = new ListResultDtoOfGetMsCompanyDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsCompanyDropDownListDto {
    items: GetMsCompanyDropDownListDto[];
}

export class GetMsCompanyDropDownListDto implements IGetMsCompanyDropDownListDto {
    id: number;
    coCode: string;
    coName: string;
    address: string;

    constructor(data?: IGetMsCompanyDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): GetMsCompanyDropDownListDto {
        let result = new GetMsCompanyDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IGetMsCompanyDropDownListDto {
    id: number;
    coCode: string;
    coName: string;
    address: string;
}

export class GetMappingCorsecListDto implements IGetMappingCorsecListDto {
    companycode: string;
    namaperusahaan: string;
    alamatperusahaan: string;
    tempatkedudukan: string;

    constructor(data?: IGetMappingCorsecListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companycode = data["companycode"];
            this.namaperusahaan = data["namaperusahaan"];
            this.alamatperusahaan = data["alamatperusahaan"];
            this.tempatkedudukan = data["tempatkedudukan"];
        }
    }

    static fromJS(data: any): GetMappingCorsecListDto {
        let result = new GetMappingCorsecListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companycode"] = this.companycode;
        data["namaperusahaan"] = this.namaperusahaan;
        data["alamatperusahaan"] = this.alamatperusahaan;
        data["tempatkedudukan"] = this.tempatkedudukan;
        return data; 
    }
}

export interface IGetMappingCorsecListDto {
    companycode: string;
    namaperusahaan: string;
    alamatperusahaan: string;
    tempatkedudukan: string;
}

export class GetCreateMsCountyInputDto implements IGetCreateMsCountyInputDto {
    territoryID: number;
    countyName: string;

    constructor(data?: IGetCreateMsCountyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.territoryID = data["territoryID"];
            this.countyName = data["countyName"];
        }
    }

    static fromJS(data: any): GetCreateMsCountyInputDto {
        let result = new GetCreateMsCountyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["territoryID"] = this.territoryID;
        data["countyName"] = this.countyName;
        return data; 
    }
}

export interface IGetCreateMsCountyInputDto {
    territoryID: number;
    countyName: string;
}

export class ListResultDtoOfGetMsCountyListDto implements IListResultDtoOfGetMsCountyListDto {
    items: GetMsCountyListDto[];

    constructor(data?: IListResultDtoOfGetMsCountyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsCountyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsCountyListDto {
        let result = new ListResultDtoOfGetMsCountyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsCountyListDto {
    items: GetMsCountyListDto[];
}

export class GetMsCountyListDto implements IGetMsCountyListDto {
    countyID: number;
    countyName: string;
    territoryID: number;

    constructor(data?: IGetMsCountyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countyID = data["countyID"];
            this.countyName = data["countyName"];
            this.territoryID = data["territoryID"];
        }
    }

    static fromJS(data: any): GetMsCountyListDto {
        let result = new GetMsCountyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countyID"] = this.countyID;
        data["countyName"] = this.countyName;
        data["territoryID"] = this.territoryID;
        return data; 
    }
}

export interface IGetMsCountyListDto {
    countyID: number;
    countyName: string;
    territoryID: number;
}

export class ListResultDtoOfGetAllDepartmentListDto implements IListResultDtoOfGetAllDepartmentListDto {
    items: GetAllDepartmentListDto[];

    constructor(data?: IListResultDtoOfGetAllDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllDepartmentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllDepartmentListDto {
        let result = new ListResultDtoOfGetAllDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllDepartmentListDto {
    items: GetAllDepartmentListDto[];
}

export class GetAllDepartmentListDto implements IGetAllDepartmentListDto {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentWhatsapp: string;
    departmentEmail: string;
    isActive: boolean;

    constructor(data?: IGetAllDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departmentID = data["departmentID"];
            this.departmentName = data["departmentName"];
            this.departmentCode = data["departmentCode"];
            this.departmentWhatsapp = data["departmentWhatsapp"];
            this.departmentEmail = data["departmentEmail"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllDepartmentListDto {
        let result = new GetAllDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        data["departmentCode"] = this.departmentCode;
        data["departmentWhatsapp"] = this.departmentWhatsapp;
        data["departmentEmail"] = this.departmentEmail;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllDepartmentListDto {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentWhatsapp: string;
    departmentEmail: string;
    isActive: boolean;
}

export class ListResultDtoOfGetMsDepartmentDropdownListDto implements IListResultDtoOfGetMsDepartmentDropdownListDto {
    items: GetMsDepartmentDropdownListDto[];

    constructor(data?: IListResultDtoOfGetMsDepartmentDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsDepartmentDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsDepartmentDropdownListDto {
        let result = new ListResultDtoOfGetMsDepartmentDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsDepartmentDropdownListDto {
    items: GetMsDepartmentDropdownListDto[];
}

export class GetMsDepartmentDropdownListDto implements IGetMsDepartmentDropdownListDto {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentEmail: string;
    departmentWhatsapp: string;

    constructor(data?: IGetMsDepartmentDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departmentID = data["departmentID"];
            this.departmentName = data["departmentName"];
            this.departmentCode = data["departmentCode"];
            this.departmentEmail = data["departmentEmail"];
            this.departmentWhatsapp = data["departmentWhatsapp"];
        }
    }

    static fromJS(data: any): GetMsDepartmentDropdownListDto {
        let result = new GetMsDepartmentDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        data["departmentCode"] = this.departmentCode;
        data["departmentEmail"] = this.departmentEmail;
        data["departmentWhatsapp"] = this.departmentWhatsapp;
        return data; 
    }
}

export interface IGetMsDepartmentDropdownListDto {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentEmail: string;
    departmentWhatsapp: string;
}

export class CreateOrUpdateMsDepartmentInput implements ICreateOrUpdateMsDepartmentInput {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentWhatsapp: string;
    departmentEmail: string;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateMsDepartmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departmentID = data["departmentID"];
            this.departmentName = data["departmentName"];
            this.departmentCode = data["departmentCode"];
            this.departmentWhatsapp = data["departmentWhatsapp"];
            this.departmentEmail = data["departmentEmail"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMsDepartmentInput {
        let result = new CreateOrUpdateMsDepartmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        data["departmentCode"] = this.departmentCode;
        data["departmentWhatsapp"] = this.departmentWhatsapp;
        data["departmentEmail"] = this.departmentEmail;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateMsDepartmentInput {
    departmentID: number;
    departmentName: string;
    departmentCode: string;
    departmentWhatsapp: string;
    departmentEmail: string;
    isActive: boolean;
}

export class CreateOrUpdateMsDetailInputDto implements ICreateOrUpdateMsDetailInputDto {
    id: number;
    detailCode: string;
    detailName: string;
    detailImage: string;
    imageStatus: string;

    constructor(data?: ICreateOrUpdateMsDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.detailImage = data["detailImage"];
            this.imageStatus = data["imageStatus"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMsDetailInputDto {
        let result = new CreateOrUpdateMsDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["detailImage"] = this.detailImage;
        data["imageStatus"] = this.imageStatus;
        return data; 
    }
}

export interface ICreateOrUpdateMsDetailInputDto {
    id: number;
    detailCode: string;
    detailName: string;
    detailImage: string;
    imageStatus: string;
}

export class ListResultDtoOfGetAllMsDetailListDto implements IListResultDtoOfGetAllMsDetailListDto {
    items: GetAllMsDetailListDto[];

    constructor(data?: IListResultDtoOfGetAllMsDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsDetailListDto {
        let result = new ListResultDtoOfGetAllMsDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsDetailListDto {
    items: GetAllMsDetailListDto[];
}

export class GetAllMsDetailListDto implements IGetAllMsDetailListDto {
    id: number;
    detailCode: string;
    detailName: string;
    detailImage: string;

    constructor(data?: IGetAllMsDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.detailImage = data["detailImage"];
        }
    }

    static fromJS(data: any): GetAllMsDetailListDto {
        let result = new GetAllMsDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["detailImage"] = this.detailImage;
        return data; 
    }
}

export interface IGetAllMsDetailListDto {
    id: number;
    detailCode: string;
    detailName: string;
    detailImage: string;
}

export class CreateMsDiscountInput implements ICreateMsDiscountInput {
    discountID: number;
    discountCode: string;
    discountName: string;
    isActive: boolean;

    constructor(data?: ICreateMsDiscountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.discountCode = data["discountCode"];
            this.discountName = data["discountName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsDiscountInput {
        let result = new CreateMsDiscountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["discountCode"] = this.discountCode;
        data["discountName"] = this.discountName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsDiscountInput {
    discountID: number;
    discountCode: string;
    discountName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetAllMsDiscountListDto implements IListResultDtoOfGetAllMsDiscountListDto {
    items: GetAllMsDiscountListDto[];

    constructor(data?: IListResultDtoOfGetAllMsDiscountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsDiscountListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsDiscountListDto {
        let result = new ListResultDtoOfGetAllMsDiscountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsDiscountListDto {
    items: GetAllMsDiscountListDto[];
}

export class GetAllMsDiscountListDto implements IGetAllMsDiscountListDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    isActive: boolean;

    constructor(data?: IGetAllMsDiscountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.discountCode = data["discountCode"];
            this.discountName = data["discountName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllMsDiscountListDto {
        let result = new GetAllMsDiscountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["discountCode"] = this.discountCode;
        data["discountName"] = this.discountName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllMsDiscountListDto {
    discountID: number;
    discountCode: string;
    discountName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetAllDocumentListDto implements IListResultDtoOfGetAllDocumentListDto {
    items: GetAllDocumentListDto[];

    constructor(data?: IListResultDtoOfGetAllDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllDocumentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllDocumentListDto {
        let result = new ListResultDtoOfGetAllDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllDocumentListDto {
    items: GetAllDocumentListDto[];
}

export class GetAllDocumentListDto implements IGetAllDocumentListDto {
    documentType: string;
    documentName: string;

    constructor(data?: IGetAllDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentName = data["documentName"];
        }
    }

    static fromJS(data: any): GetAllDocumentListDto {
        let result = new GetAllDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentName"] = this.documentName;
        return data; 
    }
}

export interface IGetAllDocumentListDto {
    documentType: string;
    documentName: string;
}

export class GetAllMsEntityListDto implements IGetAllMsEntityListDto {
    id: number;
    entityName: string;
    entityCode: string;

    constructor(data?: IGetAllMsEntityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entityName = data["entityName"];
            this.entityCode = data["entityCode"];
        }
    }

    static fromJS(data: any): GetAllMsEntityListDto {
        let result = new GetAllMsEntityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["entityCode"] = this.entityCode;
        return data; 
    }
}

export interface IGetAllMsEntityListDto {
    id: number;
    entityName: string;
    entityCode: string;
}

export class ListResultDtoOfGetAllMsEntityListDto implements IListResultDtoOfGetAllMsEntityListDto {
    items: GetAllMsEntityListDto[];

    constructor(data?: IListResultDtoOfGetAllMsEntityListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsEntityListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsEntityListDto {
        let result = new ListResultDtoOfGetAllMsEntityListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsEntityListDto {
    items: GetAllMsEntityListDto[];
}

export class CreateMsFacadeInput implements ICreateMsFacadeInput {
    facadeCode: string;
    facadeName: string;
    projectID: number;
    clusterID: number;
    detailID: number;

    constructor(data?: ICreateMsFacadeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.facadeCode = data["facadeCode"];
            this.facadeName = data["facadeName"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.detailID = data["detailID"];
        }
    }

    static fromJS(data: any): CreateMsFacadeInput {
        let result = new CreateMsFacadeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facadeCode"] = this.facadeCode;
        data["facadeName"] = this.facadeName;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["detailID"] = this.detailID;
        return data; 
    }
}

export interface ICreateMsFacadeInput {
    facadeCode: string;
    facadeName: string;
    projectID: number;
    clusterID: number;
    detailID: number;
}

export class ListResultDtoOfGetMsFacadeListDto implements IListResultDtoOfGetMsFacadeListDto {
    items: GetMsFacadeListDto[];

    constructor(data?: IListResultDtoOfGetMsFacadeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsFacadeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsFacadeListDto {
        let result = new ListResultDtoOfGetMsFacadeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsFacadeListDto {
    items: GetMsFacadeListDto[];
}

export class GetMsFacadeListDto implements IGetMsFacadeListDto {
    id: number;
    facadeCode: string;
    facadeName: string;
    projectID: number;
    clusterID: number;
    detailID: number;
    detailCode: string;
    detailName: string;

    constructor(data?: IGetMsFacadeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.facadeCode = data["facadeCode"];
            this.facadeName = data["facadeName"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.detailID = data["detailID"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
        }
    }

    static fromJS(data: any): GetMsFacadeListDto {
        let result = new GetMsFacadeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["facadeCode"] = this.facadeCode;
        data["facadeName"] = this.facadeName;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["detailID"] = this.detailID;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        return data; 
    }
}

export interface IGetMsFacadeListDto {
    id: number;
    facadeCode: string;
    facadeName: string;
    projectID: number;
    clusterID: number;
    detailID: number;
    detailCode: string;
    detailName: string;
}

export class ListResultDtoOfGetUnitDetailByProjectClusterListDto implements IListResultDtoOfGetUnitDetailByProjectClusterListDto {
    items: GetUnitDetailByProjectClusterListDto[];

    constructor(data?: IListResultDtoOfGetUnitDetailByProjectClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitDetailByProjectClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitDetailByProjectClusterListDto {
        let result = new ListResultDtoOfGetUnitDetailByProjectClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitDetailByProjectClusterListDto {
    items: GetUnitDetailByProjectClusterListDto[];
}

export class GetUnitDetailByProjectClusterListDto implements IGetUnitDetailByProjectClusterListDto {
    detailID: number;
    detailName: string;
    detailCode: string;

    constructor(data?: IGetUnitDetailByProjectClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailID = data["detailID"];
            this.detailName = data["detailName"];
            this.detailCode = data["detailCode"];
        }
    }

    static fromJS(data: any): GetUnitDetailByProjectClusterListDto {
        let result = new GetUnitDetailByProjectClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailID"] = this.detailID;
        data["detailName"] = this.detailName;
        data["detailCode"] = this.detailCode;
        return data; 
    }
}

export interface IGetUnitDetailByProjectClusterListDto {
    detailID: number;
    detailName: string;
    detailCode: string;
}

export class CreateMsFinTypeInputDto implements ICreateMsFinTypeInputDto {
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;

    constructor(data?: ICreateMsFinTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.finTypeCode = data["finTypeCode"];
            this.finTypeDesc = data["finTypeDesc"];
            this.finTimes = data["finTimes"];
            this.pctComm = data["pctComm"];
        }
    }

    static fromJS(data: any): CreateMsFinTypeInputDto {
        let result = new CreateMsFinTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finTypeCode"] = this.finTypeCode;
        data["finTypeDesc"] = this.finTypeDesc;
        data["finTimes"] = this.finTimes;
        data["pctComm"] = this.pctComm;
        return data; 
    }
}

export interface ICreateMsFinTypeInputDto {
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;
}

export class ListResultDtoOfString implements IListResultDtoOfString {
    items: string[];

    constructor(data?: IListResultDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(item);
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfString {
        let result = new ListResultDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data; 
    }
}

export interface IListResultDtoOfString {
    items: string[];
}

export class ListResultDtoOfGetAllMsFinTypeListDto implements IListResultDtoOfGetAllMsFinTypeListDto {
    items: GetAllMsFinTypeListDto[];

    constructor(data?: IListResultDtoOfGetAllMsFinTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsFinTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsFinTypeListDto {
        let result = new ListResultDtoOfGetAllMsFinTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsFinTypeListDto {
    items: GetAllMsFinTypeListDto[];
}

export class GetAllMsFinTypeListDto implements IGetAllMsFinTypeListDto {
    id: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;
    inputTime: moment.Moment;

    constructor(data?: IGetAllMsFinTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.finTypeCode = data["finTypeCode"];
            this.finTypeDesc = data["finTypeDesc"];
            this.finTimes = data["finTimes"];
            this.pctComm = data["pctComm"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllMsFinTypeListDto {
        let result = new GetAllMsFinTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["finTypeCode"] = this.finTypeCode;
        data["finTypeDesc"] = this.finTypeDesc;
        data["finTimes"] = this.finTimes;
        data["pctComm"] = this.pctComm;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetAllMsFinTypeListDto {
    id: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;
    inputTime: moment.Moment;
}

export class UpdateMsFinTypeInputDto implements IUpdateMsFinTypeInputDto {
    fintypeID: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;

    constructor(data?: IUpdateMsFinTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fintypeID = data["fintypeID"];
            this.finTypeCode = data["finTypeCode"];
            this.finTypeDesc = data["finTypeDesc"];
            this.finTimes = data["finTimes"];
            this.pctComm = data["pctComm"];
        }
    }

    static fromJS(data: any): UpdateMsFinTypeInputDto {
        let result = new UpdateMsFinTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fintypeID"] = this.fintypeID;
        data["finTypeCode"] = this.finTypeCode;
        data["finTypeDesc"] = this.finTypeDesc;
        data["finTimes"] = this.finTimes;
        data["pctComm"] = this.pctComm;
        return data; 
    }
}

export interface IUpdateMsFinTypeInputDto {
    fintypeID: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
    pctComm: number;
}

export class ListResultDtoOfGetFranchiseGroupDropdownListDto implements IListResultDtoOfGetFranchiseGroupDropdownListDto {
    items: GetFranchiseGroupDropdownListDto[];

    constructor(data?: IListResultDtoOfGetFranchiseGroupDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFranchiseGroupDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetFranchiseGroupDropdownListDto {
        let result = new ListResultDtoOfGetFranchiseGroupDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetFranchiseGroupDropdownListDto {
    items: GetFranchiseGroupDropdownListDto[];
}

export class GetFranchiseGroupDropdownListDto implements IGetFranchiseGroupDropdownListDto {
    franchiseGroupName: string;

    constructor(data?: IGetFranchiseGroupDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.franchiseGroupName = data["franchiseGroupName"];
        }
    }

    static fromJS(data: any): GetFranchiseGroupDropdownListDto {
        let result = new GetFranchiseGroupDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["franchiseGroupName"] = this.franchiseGroupName;
        return data; 
    }
}

export interface IGetFranchiseGroupDropdownListDto {
    franchiseGroupName: string;
}

export class ListResultDtoOfGetAllMsItemListDto implements IListResultDtoOfGetAllMsItemListDto {
    items: GetAllMsItemListDto[];

    constructor(data?: IListResultDtoOfGetAllMsItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsItemListDto {
        let result = new ListResultDtoOfGetAllMsItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsItemListDto {
    items: GetAllMsItemListDto[];
}

export class GetAllMsItemListDto implements IGetAllMsItemListDto {
    id: number;
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;

    constructor(data?: IGetAllMsItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllMsItemListDto {
        let result = new GetAllMsItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllMsItemListDto {
    id: number;
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;
}

export class CreateMsItemInput implements ICreateMsItemInput {
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;

    constructor(data?: ICreateMsItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsItemInput {
        let result = new CreateMsItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsItemInput {
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;
}

export class UpdateMsItemInput implements IUpdateMsItemInput {
    id: number;
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;

    constructor(data?: IUpdateMsItemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsItemInput {
        let result = new UpdateMsItemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsItemInput {
    id: number;
    itemCode: string;
    itemName: string;
    shortName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetMsUnitItemDropdownListDto implements IListResultDtoOfGetMsUnitItemDropdownListDto {
    items: GetMsUnitItemDropdownListDto[];

    constructor(data?: IListResultDtoOfGetMsUnitItemDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsUnitItemDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsUnitItemDropdownListDto {
        let result = new ListResultDtoOfGetMsUnitItemDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsUnitItemDropdownListDto {
    items: GetMsUnitItemDropdownListDto[];
}

export class GetMsUnitItemDropdownListDto implements IGetMsUnitItemDropdownListDto {
    unitItemId: number;
    itemID: number;
    itemCode: string;
    itemName: string;

    constructor(data?: IGetMsUnitItemDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitItemId = data["unitItemId"];
            this.itemID = data["itemID"];
            this.itemCode = data["itemCode"];
            this.itemName = data["itemName"];
        }
    }

    static fromJS(data: any): GetMsUnitItemDropdownListDto {
        let result = new GetMsUnitItemDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitItemId"] = this.unitItemId;
        data["itemID"] = this.itemID;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        return data; 
    }
}

export interface IGetMsUnitItemDropdownListDto {
    unitItemId: number;
    itemID: number;
    itemCode: string;
    itemName: string;
}

export class ListResultDtoOfGetAllMsJobTitleDropdownList implements IListResultDtoOfGetAllMsJobTitleDropdownList {
    items: GetAllMsJobTitleDropdownList[];

    constructor(data?: IListResultDtoOfGetAllMsJobTitleDropdownList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsJobTitleDropdownList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsJobTitleDropdownList {
        let result = new ListResultDtoOfGetAllMsJobTitleDropdownList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsJobTitleDropdownList {
    items: GetAllMsJobTitleDropdownList[];
}

export class GetAllMsJobTitleDropdownList implements IGetAllMsJobTitleDropdownList {
    jobTitleID: string;
    jobTitleName: string;

    constructor(data?: IGetAllMsJobTitleDropdownList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobTitleID = data["jobTitleID"];
            this.jobTitleName = data["jobTitleName"];
        }
    }

    static fromJS(data: any): GetAllMsJobTitleDropdownList {
        let result = new GetAllMsJobTitleDropdownList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobTitleID"] = this.jobTitleID;
        data["jobTitleName"] = this.jobTitleName;
        return data; 
    }
}

export interface IGetAllMsJobTitleDropdownList {
    jobTitleID: string;
    jobTitleName: string;
}

export class ListResultDtoOfGetMSNationDropdownListDto implements IListResultDtoOfGetMSNationDropdownListDto {
    items: GetMSNationDropdownListDto[];

    constructor(data?: IListResultDtoOfGetMSNationDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMSNationDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMSNationDropdownListDto {
        let result = new ListResultDtoOfGetMSNationDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMSNationDropdownListDto {
    items: GetMSNationDropdownListDto[];
}

export class GetMSNationDropdownListDto implements IGetMSNationDropdownListDto {
    entityCode: string;
    nationID: string;
    nationality: string;
    ppatkNationCode: string;

    constructor(data?: IGetMSNationDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.nationID = data["nationID"];
            this.nationality = data["nationality"];
            this.ppatkNationCode = data["ppatkNationCode"];
        }
    }

    static fromJS(data: any): GetMSNationDropdownListDto {
        let result = new GetMSNationDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["nationID"] = this.nationID;
        data["nationality"] = this.nationality;
        data["ppatkNationCode"] = this.ppatkNationCode;
        return data; 
    }
}

export interface IGetMSNationDropdownListDto {
    entityCode: string;
    nationID: string;
    nationality: string;
    ppatkNationCode: string;
}

export class MS_MappingNotarisBankEmailDto implements IMS_MappingNotarisBankEmailDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankEmail: string;
    refID: number;
    mappingNotarisBankID: number;
    mappingNotarisBankEmailId: number;
    sourceRefID: number;

    constructor(data?: IMS_MappingNotarisBankEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.picBankEmail = data["picBankEmail"];
            this.refID = data["refID"];
            this.mappingNotarisBankID = data["mappingNotarisBankID"];
            this.mappingNotarisBankEmailId = data["mappingNotarisBankEmailId"];
            this.sourceRefID = data["sourceRefID"];
        }
    }

    static fromJS(data: any): MS_MappingNotarisBankEmailDto {
        let result = new MS_MappingNotarisBankEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["picBankEmail"] = this.picBankEmail;
        data["refID"] = this.refID;
        data["mappingNotarisBankID"] = this.mappingNotarisBankID;
        data["mappingNotarisBankEmailId"] = this.mappingNotarisBankEmailId;
        data["sourceRefID"] = this.sourceRefID;
        return data; 
    }
}

export interface IMS_MappingNotarisBankEmailDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankEmail: string;
    refID: number;
    mappingNotarisBankID: number;
    mappingNotarisBankEmailId: number;
    sourceRefID: number;
}

export class MS_MappingNotarisBankPhoneDto implements IMS_MappingNotarisBankPhoneDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankPhone: string;
    refID: number;
    mappingNotarisBankID: number;
    mappingNotarisBankPhoneId: number;
    sourceRefID: number;

    constructor(data?: IMS_MappingNotarisBankPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.picBankPhone = data["picBankPhone"];
            this.refID = data["refID"];
            this.mappingNotarisBankID = data["mappingNotarisBankID"];
            this.mappingNotarisBankPhoneId = data["mappingNotarisBankPhoneId"];
            this.sourceRefID = data["sourceRefID"];
        }
    }

    static fromJS(data: any): MS_MappingNotarisBankPhoneDto {
        let result = new MS_MappingNotarisBankPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["picBankPhone"] = this.picBankPhone;
        data["refID"] = this.refID;
        data["mappingNotarisBankID"] = this.mappingNotarisBankID;
        data["mappingNotarisBankPhoneId"] = this.mappingNotarisBankPhoneId;
        data["sourceRefID"] = this.sourceRefID;
        return data; 
    }
}

export interface IMS_MappingNotarisBankPhoneDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankPhone: string;
    refID: number;
    mappingNotarisBankID: number;
    mappingNotarisBankPhoneId: number;
    sourceRefID: number;
}

export class MS_MappingNotarisBankDto implements IMS_MappingNotarisBankDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankName: string;
    bankID: number;
    notarisID: number;
    mappingNotarisBankId: number;
    refID: number;

    constructor(data?: IMS_MappingNotarisBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.picBankName = data["picBankName"];
            this.bankID = data["bankID"];
            this.notarisID = data["notarisID"];
            this.mappingNotarisBankId = data["mappingNotarisBankId"];
            this.refID = data["refID"];
        }
    }

    static fromJS(data: any): MS_MappingNotarisBankDto {
        let result = new MS_MappingNotarisBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["picBankName"] = this.picBankName;
        data["bankID"] = this.bankID;
        data["notarisID"] = this.notarisID;
        data["mappingNotarisBankId"] = this.mappingNotarisBankId;
        data["refID"] = this.refID;
        return data; 
    }
}

export interface IMS_MappingNotarisBankDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    picBankName: string;
    bankID: number;
    notarisID: number;
    mappingNotarisBankId: number;
    refID: number;
}

export class MS_NotarisStaffEmailDto implements IMS_NotarisStaffEmailDto {
    notarisStaffID: number;
    notarisStaffEmailID: number;
    notarisStaffEmail: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    sourceRefID: number;

    constructor(data?: IMS_NotarisStaffEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffEmailID = data["notarisStaffEmailID"];
            this.notarisStaffEmail = data["notarisStaffEmail"];
            this.refID = data["refID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.sourceRefID = data["sourceRefID"];
        }
    }

    static fromJS(data: any): MS_NotarisStaffEmailDto {
        let result = new MS_NotarisStaffEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffEmailID"] = this.notarisStaffEmailID;
        data["notarisStaffEmail"] = this.notarisStaffEmail;
        data["refID"] = this.refID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["sourceRefID"] = this.sourceRefID;
        return data; 
    }
}

export interface IMS_NotarisStaffEmailDto {
    notarisStaffID: number;
    notarisStaffEmailID: number;
    notarisStaffEmail: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    sourceRefID: number;
}

export class MS_NotarisStaffPhoneDto implements IMS_NotarisStaffPhoneDto {
    notarisStaffID: number;
    notarisStaffPhoneID: number;
    notarisStaffPhone: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    sourceRefID: number;

    constructor(data?: IMS_NotarisStaffPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffPhoneID = data["notarisStaffPhoneID"];
            this.notarisStaffPhone = data["notarisStaffPhone"];
            this.refID = data["refID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.sourceRefID = data["sourceRefID"];
        }
    }

    static fromJS(data: any): MS_NotarisStaffPhoneDto {
        let result = new MS_NotarisStaffPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffPhoneID"] = this.notarisStaffPhoneID;
        data["notarisStaffPhone"] = this.notarisStaffPhone;
        data["refID"] = this.refID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["sourceRefID"] = this.sourceRefID;
        return data; 
    }
}

export interface IMS_NotarisStaffPhoneDto {
    notarisStaffID: number;
    notarisStaffPhoneID: number;
    notarisStaffPhone: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    sourceRefID: number;
}

export class MS_NotarisStaffDto implements IMS_NotarisStaffDto {
    notarisID: number;
    notarisStaffID: number;
    notarisStaffName: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    isDefault: boolean;

    constructor(data?: IMS_NotarisStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffName = data["notarisStaffName"];
            this.refID = data["refID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): MS_NotarisStaffDto {
        let result = new MS_NotarisStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffName"] = this.notarisStaffName;
        data["refID"] = this.refID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IMS_NotarisStaffDto {
    notarisID: number;
    notarisStaffID: number;
    notarisStaffName: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    isDefault: boolean;
}

export class MS_NotarisEmailDto implements IMS_NotarisEmailDto {
    notarisID: number;
    notarisEmailID: number;
    notarisEmail: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;

    constructor(data?: IMS_NotarisEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisEmailID = data["notarisEmailID"];
            this.notarisEmail = data["notarisEmail"];
            this.refID = data["refID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
        }
    }

    static fromJS(data: any): MS_NotarisEmailDto {
        let result = new MS_NotarisEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisEmailID"] = this.notarisEmailID;
        data["notarisEmail"] = this.notarisEmail;
        data["refID"] = this.refID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        return data; 
    }
}

export interface IMS_NotarisEmailDto {
    notarisID: number;
    notarisEmailID: number;
    notarisEmail: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
}

export class MS_NotarisPhoneDto implements IMS_NotarisPhoneDto {
    notarisID: number;
    notarisPhoneID: number;
    notarisPhone: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;

    constructor(data?: IMS_NotarisPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisPhoneID = data["notarisPhoneID"];
            this.notarisPhone = data["notarisPhone"];
            this.refID = data["refID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
        }
    }

    static fromJS(data: any): MS_NotarisPhoneDto {
        let result = new MS_NotarisPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisPhoneID"] = this.notarisPhoneID;
        data["notarisPhone"] = this.notarisPhone;
        data["refID"] = this.refID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        return data; 
    }
}

export interface IMS_NotarisPhoneDto {
    notarisID: number;
    notarisPhoneID: number;
    notarisPhone: string;
    refID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
}

export class MS_NotarisClusterDto implements IMS_NotarisClusterDto {
    notarisID: number;
    notarisClusterID: number;
    clusterID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;

    constructor(data?: IMS_NotarisClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisClusterID = data["notarisClusterID"];
            this.clusterID = data["clusterID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
        }
    }

    static fromJS(data: any): MS_NotarisClusterDto {
        let result = new MS_NotarisClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisClusterID"] = this.notarisClusterID;
        data["clusterID"] = this.clusterID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        return data; 
    }
}

export interface IMS_NotarisClusterDto {
    notarisID: number;
    notarisClusterID: number;
    clusterID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
}

export class MasterNotarisInput implements IMasterNotarisInput {
    msNotarisNew: CreateMsNotarisNewInput;
    msNotarisCluster: MS_NotarisClusterDto[];
    msNotarisPhone: MS_NotarisPhoneDto[];
    msNotarisEmail: MS_NotarisEmailDto[];
    msNotarisStaff: MS_NotarisStaffDto[];
    msNotarisStaffPhone: MS_NotarisStaffPhoneDto[];
    msNotarisStaffEmail: MS_NotarisStaffEmailDto[];
    msMappingNotarisBank: MS_MappingNotarisBankDto[];
    msMappingNotarisBankPhone: MS_MappingNotarisBankPhoneDto[];
    msMappingNotarisBankEmail: MS_MappingNotarisBankEmailDto[];

    constructor(data?: IMasterNotarisInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.msNotarisNew = data["msNotarisNew"] ? CreateMsNotarisNewInput.fromJS(data["msNotarisNew"]) : <any>undefined;
            if (data["msNotarisCluster"] && data["msNotarisCluster"].constructor === Array) {
                this.msNotarisCluster = [];
                for (let item of data["msNotarisCluster"])
                    this.msNotarisCluster.push(MS_NotarisClusterDto.fromJS(item));
            }
            if (data["msNotarisPhone"] && data["msNotarisPhone"].constructor === Array) {
                this.msNotarisPhone = [];
                for (let item of data["msNotarisPhone"])
                    this.msNotarisPhone.push(MS_NotarisPhoneDto.fromJS(item));
            }
            if (data["msNotarisEmail"] && data["msNotarisEmail"].constructor === Array) {
                this.msNotarisEmail = [];
                for (let item of data["msNotarisEmail"])
                    this.msNotarisEmail.push(MS_NotarisEmailDto.fromJS(item));
            }
            if (data["msNotarisStaff"] && data["msNotarisStaff"].constructor === Array) {
                this.msNotarisStaff = [];
                for (let item of data["msNotarisStaff"])
                    this.msNotarisStaff.push(MS_NotarisStaffDto.fromJS(item));
            }
            if (data["msNotarisStaffPhone"] && data["msNotarisStaffPhone"].constructor === Array) {
                this.msNotarisStaffPhone = [];
                for (let item of data["msNotarisStaffPhone"])
                    this.msNotarisStaffPhone.push(MS_NotarisStaffPhoneDto.fromJS(item));
            }
            if (data["msNotarisStaffEmail"] && data["msNotarisStaffEmail"].constructor === Array) {
                this.msNotarisStaffEmail = [];
                for (let item of data["msNotarisStaffEmail"])
                    this.msNotarisStaffEmail.push(MS_NotarisStaffEmailDto.fromJS(item));
            }
            if (data["msMappingNotarisBank"] && data["msMappingNotarisBank"].constructor === Array) {
                this.msMappingNotarisBank = [];
                for (let item of data["msMappingNotarisBank"])
                    this.msMappingNotarisBank.push(MS_MappingNotarisBankDto.fromJS(item));
            }
            if (data["msMappingNotarisBankPhone"] && data["msMappingNotarisBankPhone"].constructor === Array) {
                this.msMappingNotarisBankPhone = [];
                for (let item of data["msMappingNotarisBankPhone"])
                    this.msMappingNotarisBankPhone.push(MS_MappingNotarisBankPhoneDto.fromJS(item));
            }
            if (data["msMappingNotarisBankEmail"] && data["msMappingNotarisBankEmail"].constructor === Array) {
                this.msMappingNotarisBankEmail = [];
                for (let item of data["msMappingNotarisBankEmail"])
                    this.msMappingNotarisBankEmail.push(MS_MappingNotarisBankEmailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterNotarisInput {
        let result = new MasterNotarisInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msNotarisNew"] = this.msNotarisNew ? this.msNotarisNew.toJSON() : <any>undefined;
        if (this.msNotarisCluster && this.msNotarisCluster.constructor === Array) {
            data["msNotarisCluster"] = [];
            for (let item of this.msNotarisCluster)
                data["msNotarisCluster"].push(item.toJSON());
        }
        if (this.msNotarisPhone && this.msNotarisPhone.constructor === Array) {
            data["msNotarisPhone"] = [];
            for (let item of this.msNotarisPhone)
                data["msNotarisPhone"].push(item.toJSON());
        }
        if (this.msNotarisEmail && this.msNotarisEmail.constructor === Array) {
            data["msNotarisEmail"] = [];
            for (let item of this.msNotarisEmail)
                data["msNotarisEmail"].push(item.toJSON());
        }
        if (this.msNotarisStaff && this.msNotarisStaff.constructor === Array) {
            data["msNotarisStaff"] = [];
            for (let item of this.msNotarisStaff)
                data["msNotarisStaff"].push(item.toJSON());
        }
        if (this.msNotarisStaffPhone && this.msNotarisStaffPhone.constructor === Array) {
            data["msNotarisStaffPhone"] = [];
            for (let item of this.msNotarisStaffPhone)
                data["msNotarisStaffPhone"].push(item.toJSON());
        }
        if (this.msNotarisStaffEmail && this.msNotarisStaffEmail.constructor === Array) {
            data["msNotarisStaffEmail"] = [];
            for (let item of this.msNotarisStaffEmail)
                data["msNotarisStaffEmail"].push(item.toJSON());
        }
        if (this.msMappingNotarisBank && this.msMappingNotarisBank.constructor === Array) {
            data["msMappingNotarisBank"] = [];
            for (let item of this.msMappingNotarisBank)
                data["msMappingNotarisBank"].push(item.toJSON());
        }
        if (this.msMappingNotarisBankPhone && this.msMappingNotarisBankPhone.constructor === Array) {
            data["msMappingNotarisBankPhone"] = [];
            for (let item of this.msMappingNotarisBankPhone)
                data["msMappingNotarisBankPhone"].push(item.toJSON());
        }
        if (this.msMappingNotarisBankEmail && this.msMappingNotarisBankEmail.constructor === Array) {
            data["msMappingNotarisBankEmail"] = [];
            for (let item of this.msMappingNotarisBankEmail)
                data["msMappingNotarisBankEmail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMasterNotarisInput {
    msNotarisNew: CreateMsNotarisNewInput;
    msNotarisCluster: MS_NotarisClusterDto[];
    msNotarisPhone: MS_NotarisPhoneDto[];
    msNotarisEmail: MS_NotarisEmailDto[];
    msNotarisStaff: MS_NotarisStaffDto[];
    msNotarisStaffPhone: MS_NotarisStaffPhoneDto[];
    msNotarisStaffEmail: MS_NotarisStaffEmailDto[];
    msMappingNotarisBank: MS_MappingNotarisBankDto[];
    msMappingNotarisBankPhone: MS_MappingNotarisBankPhoneDto[];
    msMappingNotarisBankEmail: MS_MappingNotarisBankEmailDto[];
}

export class CreateMsNotarisNewInput implements ICreateMsNotarisNewInput {
    notarisID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    notarisName: string;
    isActive: boolean;
    alamat: string;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;

    constructor(data?: ICreateMsNotarisNewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.notarisName = data["notarisName"];
            this.isActive = data["isActive"];
            this.alamat = data["alamat"];
            this.notarisNPWP = data["notarisNPWP"];
            this.notarisRegNo = data["notarisRegNo"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): CreateMsNotarisNewInput {
        let result = new CreateMsNotarisNewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["notarisName"] = this.notarisName;
        data["isActive"] = this.isActive;
        data["alamat"] = this.alamat;
        data["notarisNPWP"] = this.notarisNPWP;
        data["notarisRegNo"] = this.notarisRegNo;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface ICreateMsNotarisNewInput {
    notarisID: number;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    notarisName: string;
    isActive: boolean;
    alamat: string;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;
}

export class FetchNotarisDetail implements IFetchNotarisDetail {
    projectID: number;
    notarisId: number;
    notarisName: string;
    alamat: string;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;
    isActive: boolean;

    constructor(data?: IFetchNotarisDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.notarisId = data["notarisId"];
            this.notarisName = data["notarisName"];
            this.alamat = data["alamat"];
            this.notarisNPWP = data["notarisNPWP"];
            this.notarisRegNo = data["notarisRegNo"];
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): FetchNotarisDetail {
        let result = new FetchNotarisDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["notarisId"] = this.notarisId;
        data["notarisName"] = this.notarisName;
        data["alamat"] = this.alamat;
        data["notarisNPWP"] = this.notarisNPWP;
        data["notarisRegNo"] = this.notarisRegNo;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IFetchNotarisDetail {
    projectID: number;
    notarisId: number;
    notarisName: string;
    alamat: string;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;
    isActive: boolean;
}

export class MappingNotarisBankEmail implements IMappingNotarisBankEmail {
    mappingNotarisBankEmailID: number;
    picBankEmail: string;
    refID: number;
    mappingNotarisBankID: number;

    constructor(data?: IMappingNotarisBankEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingNotarisBankEmailID = data["mappingNotarisBankEmailID"];
            this.picBankEmail = data["picBankEmail"];
            this.refID = data["refID"];
            this.mappingNotarisBankID = data["mappingNotarisBankID"];
        }
    }

    static fromJS(data: any): MappingNotarisBankEmail {
        let result = new MappingNotarisBankEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingNotarisBankEmailID"] = this.mappingNotarisBankEmailID;
        data["picBankEmail"] = this.picBankEmail;
        data["refID"] = this.refID;
        data["mappingNotarisBankID"] = this.mappingNotarisBankID;
        return data; 
    }
}

export interface IMappingNotarisBankEmail {
    mappingNotarisBankEmailID: number;
    picBankEmail: string;
    refID: number;
    mappingNotarisBankID: number;
}

export class MappingNotarisBankPhone implements IMappingNotarisBankPhone {
    mappingNotarisBankPhoneID: number;
    picBankPhone: string;
    refID: number;
    mappingNotarisBankID: number;

    constructor(data?: IMappingNotarisBankPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingNotarisBankPhoneID = data["mappingNotarisBankPhoneID"];
            this.picBankPhone = data["picBankPhone"];
            this.refID = data["refID"];
            this.mappingNotarisBankID = data["mappingNotarisBankID"];
        }
    }

    static fromJS(data: any): MappingNotarisBankPhone {
        let result = new MappingNotarisBankPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingNotarisBankPhoneID"] = this.mappingNotarisBankPhoneID;
        data["picBankPhone"] = this.picBankPhone;
        data["refID"] = this.refID;
        data["mappingNotarisBankID"] = this.mappingNotarisBankID;
        return data; 
    }
}

export interface IMappingNotarisBankPhone {
    mappingNotarisBankPhoneID: number;
    picBankPhone: string;
    refID: number;
    mappingNotarisBankID: number;
}

export class NotarisBank implements INotarisBank {
    mappingNotarisBankID: number;
    picBankName: string;
    bankID: number;
    bankName: string;
    notarisID: number;
    refID: number;
    picBankPhone: string;
    picBankEmail: string;

    constructor(data?: INotarisBank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingNotarisBankID = data["mappingNotarisBankID"];
            this.picBankName = data["picBankName"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.notarisID = data["notarisID"];
            this.refID = data["refID"];
            this.picBankPhone = data["picBankPhone"];
            this.picBankEmail = data["picBankEmail"];
        }
    }

    static fromJS(data: any): NotarisBank {
        let result = new NotarisBank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingNotarisBankID"] = this.mappingNotarisBankID;
        data["picBankName"] = this.picBankName;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["notarisID"] = this.notarisID;
        data["refID"] = this.refID;
        data["picBankPhone"] = this.picBankPhone;
        data["picBankEmail"] = this.picBankEmail;
        return data; 
    }
}

export interface INotarisBank {
    mappingNotarisBankID: number;
    picBankName: string;
    bankID: number;
    bankName: string;
    notarisID: number;
    refID: number;
    picBankPhone: string;
    picBankEmail: string;
}

export class NotarisCluster implements INotarisCluster {
    notarisID: number;
    notarisClusterID: number;
    clusterID: number;

    constructor(data?: INotarisCluster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisClusterID = data["notarisClusterID"];
            this.clusterID = data["clusterID"];
        }
    }

    static fromJS(data: any): NotarisCluster {
        let result = new NotarisCluster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisClusterID"] = this.notarisClusterID;
        data["clusterID"] = this.clusterID;
        return data; 
    }
}

export interface INotarisCluster {
    notarisID: number;
    notarisClusterID: number;
    clusterID: number;
}

export class NotarisEmail implements INotarisEmail {
    notarisID: number;
    notarisEmailID: number;
    notarisEmail: string;
    refID: number;

    constructor(data?: INotarisEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisEmailID = data["notarisEmailID"];
            this.notarisEmail = data["notarisEmail"];
            this.refID = data["refID"];
        }
    }

    static fromJS(data: any): NotarisEmail {
        let result = new NotarisEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisEmailID"] = this.notarisEmailID;
        data["notarisEmail"] = this.notarisEmail;
        data["refID"] = this.refID;
        return data; 
    }
}

export interface INotarisEmail {
    notarisID: number;
    notarisEmailID: number;
    notarisEmail: string;
    refID: number;
}

export class NotarisPhone implements INotarisPhone {
    notarisID: number;
    notarisPhoneID: number;
    notarisPhone: string;
    refID: number;

    constructor(data?: INotarisPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisPhoneID = data["notarisPhoneID"];
            this.notarisPhone = data["notarisPhone"];
            this.refID = data["refID"];
        }
    }

    static fromJS(data: any): NotarisPhone {
        let result = new NotarisPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisPhoneID"] = this.notarisPhoneID;
        data["notarisPhone"] = this.notarisPhone;
        data["refID"] = this.refID;
        return data; 
    }
}

export interface INotarisPhone {
    notarisID: number;
    notarisPhoneID: number;
    notarisPhone: string;
    refID: number;
}

export class PagedResultDtoOfFetchNotaris implements IPagedResultDtoOfFetchNotaris {
    totalCount: number;
    items: FetchNotaris[];

    constructor(data?: IPagedResultDtoOfFetchNotaris) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FetchNotaris.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFetchNotaris {
        let result = new PagedResultDtoOfFetchNotaris();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFetchNotaris {
    totalCount: number;
    items: FetchNotaris[];
}

export class FetchNotaris implements IFetchNotaris {
    no: number;
    projectID: number;
    projectName: string;
    clusterID: number;
    clusterName: string;
    notarisId: number;
    notarisName: string;
    alamat: string;
    notarisPhoneNo: string;
    notarisEmail: string;
    notarisBankID: number;
    notarisBankName: string;
    totalCount: number;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;

    constructor(data?: IFetchNotaris) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.notarisId = data["notarisId"];
            this.notarisName = data["notarisName"];
            this.alamat = data["alamat"];
            this.notarisPhoneNo = data["notarisPhoneNo"];
            this.notarisEmail = data["notarisEmail"];
            this.notarisBankID = data["notarisBankID"];
            this.notarisBankName = data["notarisBankName"];
            this.totalCount = data["totalCount"];
            this.notarisNPWP = data["notarisNPWP"];
            this.notarisRegNo = data["notarisRegNo"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): FetchNotaris {
        let result = new FetchNotaris();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["notarisId"] = this.notarisId;
        data["notarisName"] = this.notarisName;
        data["alamat"] = this.alamat;
        data["notarisPhoneNo"] = this.notarisPhoneNo;
        data["notarisEmail"] = this.notarisEmail;
        data["notarisBankID"] = this.notarisBankID;
        data["notarisBankName"] = this.notarisBankName;
        data["totalCount"] = this.totalCount;
        data["notarisNPWP"] = this.notarisNPWP;
        data["notarisRegNo"] = this.notarisRegNo;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IFetchNotaris {
    no: number;
    projectID: number;
    projectName: string;
    clusterID: number;
    clusterName: string;
    notarisId: number;
    notarisName: string;
    alamat: string;
    notarisPhoneNo: string;
    notarisEmail: string;
    notarisBankID: number;
    notarisBankName: string;
    totalCount: number;
    notarisNPWP: string;
    notarisRegNo: string;
    remarks: string;
}

export class NotarisStaffEmail implements INotarisStaffEmail {
    notarisStaffID: number;
    notarisStaffEmailId: number;
    notarisStaffEmail: string;
    refID: number;

    constructor(data?: INotarisStaffEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffEmailId = data["notarisStaffEmailId"];
            this.notarisStaffEmail = data["notarisStaffEmail"];
            this.refID = data["refID"];
        }
    }

    static fromJS(data: any): NotarisStaffEmail {
        let result = new NotarisStaffEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffEmailId"] = this.notarisStaffEmailId;
        data["notarisStaffEmail"] = this.notarisStaffEmail;
        data["refID"] = this.refID;
        return data; 
    }
}

export interface INotarisStaffEmail {
    notarisStaffID: number;
    notarisStaffEmailId: number;
    notarisStaffEmail: string;
    refID: number;
}

export class NotarisStaffPhone implements INotarisStaffPhone {
    notarisStaffID: number;
    notarisStaffPhoneId: number;
    notarisStaffPhone: string;
    refID: number;

    constructor(data?: INotarisStaffPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffPhoneId = data["notarisStaffPhoneId"];
            this.notarisStaffPhone = data["notarisStaffPhone"];
            this.refID = data["refID"];
        }
    }

    static fromJS(data: any): NotarisStaffPhone {
        let result = new NotarisStaffPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffPhoneId"] = this.notarisStaffPhoneId;
        data["notarisStaffPhone"] = this.notarisStaffPhone;
        data["refID"] = this.refID;
        return data; 
    }
}

export interface INotarisStaffPhone {
    notarisStaffID: number;
    notarisStaffPhoneId: number;
    notarisStaffPhone: string;
    refID: number;
}

export class NotarisStaff implements INotarisStaff {
    notarisID: number;
    notarisStaffID: number;
    notarisStaffName: string;
    notarisStaffPhone: string;
    notarisStaffEmail: string;
    refID: number;
    isDefault: boolean;

    constructor(data?: INotarisStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffName = data["notarisStaffName"];
            this.notarisStaffPhone = data["notarisStaffPhone"];
            this.notarisStaffEmail = data["notarisStaffEmail"];
            this.refID = data["refID"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): NotarisStaff {
        let result = new NotarisStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffName"] = this.notarisStaffName;
        data["notarisStaffPhone"] = this.notarisStaffPhone;
        data["notarisStaffEmail"] = this.notarisStaffEmail;
        data["refID"] = this.refID;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface INotarisStaff {
    notarisID: number;
    notarisStaffID: number;
    notarisStaffName: string;
    notarisStaffPhone: string;
    notarisStaffEmail: string;
    refID: number;
    isDefault: boolean;
}

export class ListResultDtoOfGetMsOccupationDropdownListDto implements IListResultDtoOfGetMsOccupationDropdownListDto {
    items: GetMsOccupationDropdownListDto[];

    constructor(data?: IListResultDtoOfGetMsOccupationDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsOccupationDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsOccupationDropdownListDto {
        let result = new ListResultDtoOfGetMsOccupationDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsOccupationDropdownListDto {
    items: GetMsOccupationDropdownListDto[];
}

export class GetMsOccupationDropdownListDto implements IGetMsOccupationDropdownListDto {
    occID: string;
    occDesc: string;

    constructor(data?: IGetMsOccupationDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.occID = data["occID"];
            this.occDesc = data["occDesc"];
        }
    }

    static fromJS(data: any): GetMsOccupationDropdownListDto {
        let result = new GetMsOccupationDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occID"] = this.occID;
        data["occDesc"] = this.occDesc;
        return data; 
    }
}

export interface IGetMsOccupationDropdownListDto {
    occID: string;
    occDesc: string;
}

export class CreateMsOfficerInput implements ICreateMsOfficerInput {
    id: number;
    officerName: string;
    email: string;
    handphone: string;
    positionID: number;
    departmentID: number;
    isActive: boolean;

    constructor(data?: ICreateMsOfficerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.officerName = data["officerName"];
            this.email = data["email"];
            this.handphone = data["handphone"];
            this.positionID = data["positionID"];
            this.departmentID = data["departmentID"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsOfficerInput {
        let result = new CreateMsOfficerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["officerName"] = this.officerName;
        data["email"] = this.email;
        data["handphone"] = this.handphone;
        data["positionID"] = this.positionID;
        data["departmentID"] = this.departmentID;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsOfficerInput {
    id: number;
    officerName: string;
    email: string;
    handphone: string;
    positionID: number;
    departmentID: number;
    isActive: boolean;
}

export class GetCreateMsOfficerListDto implements IGetCreateMsOfficerListDto {
    officerID: number;
    departmentID: number;
    departmentName: string;

    constructor(data?: IGetCreateMsOfficerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.officerID = data["officerID"];
            this.departmentID = data["departmentID"];
            this.departmentName = data["departmentName"];
        }
    }

    static fromJS(data: any): GetCreateMsOfficerListDto {
        let result = new GetCreateMsOfficerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officerID"] = this.officerID;
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        return data; 
    }
}

export interface IGetCreateMsOfficerListDto {
    officerID: number;
    departmentID: number;
    departmentName: string;
}

export class ListResultDtoOfGetAllOfficerListDto implements IListResultDtoOfGetAllOfficerListDto {
    items: GetAllOfficerListDto[];

    constructor(data?: IListResultDtoOfGetAllOfficerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllOfficerListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllOfficerListDto {
        let result = new ListResultDtoOfGetAllOfficerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllOfficerListDto {
    items: GetAllOfficerListDto[];
}

export class GetAllOfficerListDto implements IGetAllOfficerListDto {
    officerID: number;
    officerName: string;
    email: string;
    handphone: string;
    fax: string;
    departmentID: number;
    departmentName: string;
    positionID: number;
    positionName: string;
    isActive: boolean;

    constructor(data?: IGetAllOfficerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.officerID = data["officerID"];
            this.officerName = data["officerName"];
            this.email = data["email"];
            this.handphone = data["handphone"];
            this.fax = data["fax"];
            this.departmentID = data["departmentID"];
            this.departmentName = data["departmentName"];
            this.positionID = data["positionID"];
            this.positionName = data["positionName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllOfficerListDto {
        let result = new GetAllOfficerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officerID"] = this.officerID;
        data["officerName"] = this.officerName;
        data["email"] = this.email;
        data["handphone"] = this.handphone;
        data["fax"] = this.fax;
        data["departmentID"] = this.departmentID;
        data["departmentName"] = this.departmentName;
        data["positionID"] = this.positionID;
        data["positionName"] = this.positionName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllOfficerListDto {
    officerID: number;
    officerName: string;
    email: string;
    handphone: string;
    fax: string;
    departmentID: number;
    departmentName: string;
    positionID: number;
    positionName: string;
    isActive: boolean;
}

export class GetOfficerDivDto implements IGetOfficerDivDto {
    psas: DepartmentDto;
    productGeneral: DepartmentDto;
    finance: DepartmentDto;
    bankRelation: DepartmentDto;
    callCenter: DepartmentDto;
    buildingManagement: DepartmentDto;

    constructor(data?: IGetOfficerDivDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psas = data["psas"] ? DepartmentDto.fromJS(data["psas"]) : <any>undefined;
            this.productGeneral = data["productGeneral"] ? DepartmentDto.fromJS(data["productGeneral"]) : <any>undefined;
            this.finance = data["finance"] ? DepartmentDto.fromJS(data["finance"]) : <any>undefined;
            this.bankRelation = data["bankRelation"] ? DepartmentDto.fromJS(data["bankRelation"]) : <any>undefined;
            this.callCenter = data["callCenter"] ? DepartmentDto.fromJS(data["callCenter"]) : <any>undefined;
            this.buildingManagement = data["buildingManagement"] ? DepartmentDto.fromJS(data["buildingManagement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOfficerDivDto {
        let result = new GetOfficerDivDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psas"] = this.psas ? this.psas.toJSON() : <any>undefined;
        data["productGeneral"] = this.productGeneral ? this.productGeneral.toJSON() : <any>undefined;
        data["finance"] = this.finance ? this.finance.toJSON() : <any>undefined;
        data["bankRelation"] = this.bankRelation ? this.bankRelation.toJSON() : <any>undefined;
        data["callCenter"] = this.callCenter ? this.callCenter.toJSON() : <any>undefined;
        data["buildingManagement"] = this.buildingManagement ? this.buildingManagement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOfficerDivDto {
    psas: DepartmentDto;
    productGeneral: DepartmentDto;
    finance: DepartmentDto;
    bankRelation: DepartmentDto;
    callCenter: DepartmentDto;
    buildingManagement: DepartmentDto;
}

export class DepartmentDto implements IDepartmentDto {
    departmentID: number;
    manager: ManagerDto[];
    staff: StaffDto[];

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departmentID = data["departmentID"];
            if (data["manager"] && data["manager"].constructor === Array) {
                this.manager = [];
                for (let item of data["manager"])
                    this.manager.push(ManagerDto.fromJS(item));
            }
            if (data["staff"] && data["staff"].constructor === Array) {
                this.staff = [];
                for (let item of data["staff"])
                    this.staff.push(StaffDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentDto {
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentID"] = this.departmentID;
        if (this.manager && this.manager.constructor === Array) {
            data["manager"] = [];
            for (let item of this.manager)
                data["manager"].push(item.toJSON());
        }
        if (this.staff && this.staff.constructor === Array) {
            data["staff"] = [];
            for (let item of this.staff)
                data["staff"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDepartmentDto {
    departmentID: number;
    manager: ManagerDto[];
    staff: StaffDto[];
}

export class ManagerDto implements IManagerDto {
    managerID: number;
    managerName: string;

    constructor(data?: IManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
        }
    }

    static fromJS(data: any): ManagerDto {
        let result = new ManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        return data; 
    }
}

export interface IManagerDto {
    managerID: number;
    managerName: string;
}

export class StaffDto implements IStaffDto {
    staffID: number;
    staffName: string;

    constructor(data?: IStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
        }
    }

    static fromJS(data: any): StaffDto {
        let result = new StaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        return data; 
    }
}

export interface IStaffDto {
    staffID: number;
    staffName: string;
}

export class GetOfficerByNameOrPositionListDto implements IGetOfficerByNameOrPositionListDto {
    officerID: number;
    officerName: string;
    officerPhone: string;
    officerEmail: string;
    officerPosition: string;

    constructor(data?: IGetOfficerByNameOrPositionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.officerID = data["officerID"];
            this.officerName = data["officerName"];
            this.officerPhone = data["officerPhone"];
            this.officerEmail = data["officerEmail"];
            this.officerPosition = data["officerPosition"];
        }
    }

    static fromJS(data: any): GetOfficerByNameOrPositionListDto {
        let result = new GetOfficerByNameOrPositionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officerID"] = this.officerID;
        data["officerName"] = this.officerName;
        data["officerPhone"] = this.officerPhone;
        data["officerEmail"] = this.officerEmail;
        data["officerPosition"] = this.officerPosition;
        return data; 
    }
}

export interface IGetOfficerByNameOrPositionListDto {
    officerID: number;
    officerName: string;
    officerPhone: string;
    officerEmail: string;
    officerPosition: string;
}

export class MsPositionInput implements IMsPositionInput {
    id: number;
    positionName: string;
    positionCode: string;
    departmentID: number;
    isActive: boolean;

    constructor(data?: IMsPositionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.positionName = data["positionName"];
            this.positionCode = data["positionCode"];
            this.departmentID = data["departmentID"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): MsPositionInput {
        let result = new MsPositionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["positionName"] = this.positionName;
        data["positionCode"] = this.positionCode;
        data["departmentID"] = this.departmentID;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IMsPositionInput {
    id: number;
    positionName: string;
    positionCode: string;
    departmentID: number;
    isActive: boolean;
}

export class ListResultDtoOfGetAllMsPositionListDto implements IListResultDtoOfGetAllMsPositionListDto {
    items: GetAllMsPositionListDto[];

    constructor(data?: IListResultDtoOfGetAllMsPositionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsPositionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsPositionListDto {
        let result = new ListResultDtoOfGetAllMsPositionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsPositionListDto {
    items: GetAllMsPositionListDto[];
}

export class GetAllMsPositionListDto implements IGetAllMsPositionListDto {
    id: number;
    positionName: string;
    positionCode: string;
    departmentID: number;
    departmentCode: string;
    departmentName: string;
    isActive: boolean;

    constructor(data?: IGetAllMsPositionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.positionName = data["positionName"];
            this.positionCode = data["positionCode"];
            this.departmentID = data["departmentID"];
            this.departmentCode = data["departmentCode"];
            this.departmentName = data["departmentName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllMsPositionListDto {
        let result = new GetAllMsPositionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["positionName"] = this.positionName;
        data["positionCode"] = this.positionCode;
        data["departmentID"] = this.departmentID;
        data["departmentCode"] = this.departmentCode;
        data["departmentName"] = this.departmentName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllMsPositionListDto {
    id: number;
    positionName: string;
    positionCode: string;
    departmentID: number;
    departmentCode: string;
    departmentName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetMsPositionByDepartmentListDto implements IListResultDtoOfGetMsPositionByDepartmentListDto {
    items: GetMsPositionByDepartmentListDto[];

    constructor(data?: IListResultDtoOfGetMsPositionByDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsPositionByDepartmentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsPositionByDepartmentListDto {
        let result = new ListResultDtoOfGetMsPositionByDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsPositionByDepartmentListDto {
    items: GetMsPositionByDepartmentListDto[];
}

export class GetMsPositionByDepartmentListDto implements IGetMsPositionByDepartmentListDto {
    id: number;
    positionName: string;

    constructor(data?: IGetMsPositionByDepartmentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.positionName = data["positionName"];
        }
    }

    static fromJS(data: any): GetMsPositionByDepartmentListDto {
        let result = new GetMsPositionByDepartmentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["positionName"] = this.positionName;
        return data; 
    }
}

export interface IGetMsPositionByDepartmentListDto {
    id: number;
    positionName: string;
}

export class ListResultDtoOfGetAllProductListDto implements IListResultDtoOfGetAllProductListDto {
    items: GetAllProductListDto[];

    constructor(data?: IListResultDtoOfGetAllProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllProductListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllProductListDto {
        let result = new ListResultDtoOfGetAllProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllProductListDto {
    items: GetAllProductListDto[];
}

export class GetAllProductListDto implements IGetAllProductListDto {
    id: number;
    productCode: string;
    productName: string;
    isActive: boolean;

    constructor(data?: IGetAllProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllProductListDto {
        let result = new GetAllProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllProductListDto {
    id: number;
    productCode: string;
    productName: string;
    isActive: boolean;
}

export class GetProductListByProductCodeDto implements IGetProductListByProductCodeDto {
    id: number;
    productName: string;

    constructor(data?: IGetProductListByProductCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetProductListByProductCodeDto {
        let result = new GetProductListByProductCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetProductListByProductCodeDto {
    id: number;
    productName: string;
}

export class CreateMsProductDto implements ICreateMsProductDto {
    productCode: string;
    productName: string;
    categoryID: number;
    isActive: boolean;

    constructor(data?: ICreateMsProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.categoryID = data["categoryID"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsProductDto {
        let result = new CreateMsProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["categoryID"] = this.categoryID;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsProductDto {
    productCode: string;
    productName: string;
    categoryID: number;
    isActive: boolean;
}

export class UpdateMsProductDto implements IUpdateMsProductDto {
    id: number;
    productCode: string;
    productName: string;
    isActive: boolean;

    constructor(data?: IUpdateMsProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsProductDto {
        let result = new UpdateMsProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsProductDto {
    id: number;
    productCode: string;
    productName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetProductDropdownListDto implements IListResultDtoOfGetProductDropdownListDto {
    items: GetProductDropdownListDto[];

    constructor(data?: IListResultDtoOfGetProductDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProductDropdownListDto {
        let result = new ListResultDtoOfGetProductDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProductDropdownListDto {
    items: GetProductDropdownListDto[];
}

export class GetProductDropdownListDto implements IGetProductDropdownListDto {
    productID: number;
    productName: string;

    constructor(data?: IGetProductDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productID = data["productID"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetProductDropdownListDto {
        let result = new GetProductDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetProductDropdownListDto {
    productID: number;
    productName: string;
}

export class GetMsProductDropdownGeneratePriceInputDto implements IGetMsProductDropdownGeneratePriceInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number[];

    constructor(data?: IGetMsProductDropdownGeneratePriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            if (data["categoryID"] && data["categoryID"].constructor === Array) {
                this.categoryID = [];
                for (let item of data["categoryID"])
                    this.categoryID.push(item);
            }
        }
    }

    static fromJS(data: any): GetMsProductDropdownGeneratePriceInputDto {
        let result = new GetMsProductDropdownGeneratePriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        if (this.categoryID && this.categoryID.constructor === Array) {
            data["categoryID"] = [];
            for (let item of this.categoryID)
                data["categoryID"].push(item);
        }
        return data; 
    }
}

export interface IGetMsProductDropdownGeneratePriceInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number[];
}

export class GetListBusinessGroupResultDto implements IGetListBusinessGroupResultDto {
    businessGroupCode: string;
    businessGroupName: string;

    constructor(data?: IGetListBusinessGroupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessGroupCode = data["businessGroupCode"];
            this.businessGroupName = data["businessGroupName"];
        }
    }

    static fromJS(data: any): GetListBusinessGroupResultDto {
        let result = new GetListBusinessGroupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessGroupCode"] = this.businessGroupCode;
        data["businessGroupName"] = this.businessGroupName;
        return data; 
    }
}

export interface IGetListBusinessGroupResultDto {
    businessGroupCode: string;
    businessGroupName: string;
}

export class GetListOracleMsProjectResultDto implements IGetListOracleMsProjectResultDto {
    listLkProject: ListLkProject[];
    listLkBusiness: ListBusines[];
    listLkDivision: ListLkDivision[];
    listOrg: ListOrg[];

    constructor(data?: IGetListOracleMsProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listLkProject"] && data["listLkProject"].constructor === Array) {
                this.listLkProject = [];
                for (let item of data["listLkProject"])
                    this.listLkProject.push(ListLkProject.fromJS(item));
            }
            if (data["listLkBusiness"] && data["listLkBusiness"].constructor === Array) {
                this.listLkBusiness = [];
                for (let item of data["listLkBusiness"])
                    this.listLkBusiness.push(ListBusines.fromJS(item));
            }
            if (data["listLkDivision"] && data["listLkDivision"].constructor === Array) {
                this.listLkDivision = [];
                for (let item of data["listLkDivision"])
                    this.listLkDivision.push(ListLkDivision.fromJS(item));
            }
            if (data["listOrg"] && data["listOrg"].constructor === Array) {
                this.listOrg = [];
                for (let item of data["listOrg"])
                    this.listOrg.push(ListOrg.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListOracleMsProjectResultDto {
        let result = new GetListOracleMsProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listLkProject && this.listLkProject.constructor === Array) {
            data["listLkProject"] = [];
            for (let item of this.listLkProject)
                data["listLkProject"].push(item.toJSON());
        }
        if (this.listLkBusiness && this.listLkBusiness.constructor === Array) {
            data["listLkBusiness"] = [];
            for (let item of this.listLkBusiness)
                data["listLkBusiness"].push(item.toJSON());
        }
        if (this.listLkDivision && this.listLkDivision.constructor === Array) {
            data["listLkDivision"] = [];
            for (let item of this.listLkDivision)
                data["listLkDivision"].push(item.toJSON());
        }
        if (this.listOrg && this.listOrg.constructor === Array) {
            data["listOrg"] = [];
            for (let item of this.listOrg)
                data["listOrg"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListOracleMsProjectResultDto {
    listLkProject: ListLkProject[];
    listLkBusiness: ListBusines[];
    listLkDivision: ListLkDivision[];
    listOrg: ListOrg[];
}

export class ListLkProject implements IListLkProject {
    projecT_ID: string;
    projecT_GROUP_ID: string;
    projecT_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;

    constructor(data?: IListLkProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projecT_ID = data["projecT_ID"];
            this.projecT_GROUP_ID = data["projecT_GROUP_ID"];
            this.projecT_NAME = data["projecT_NAME"];
            this.inpuT_TIME = data["inpuT_TIME"] ? moment(data["inpuT_TIME"].toString()) : <any>undefined;
            this.inpuT_USER = data["inpuT_USER"];
            this.modiF_TIME = data["modiF_TIME"] ? moment(data["modiF_TIME"].toString()) : <any>undefined;
            this.modiF_USER = data["modiF_USER"];
        }
    }

    static fromJS(data: any): ListLkProject {
        let result = new ListLkProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projecT_ID"] = this.projecT_ID;
        data["projecT_GROUP_ID"] = this.projecT_GROUP_ID;
        data["projecT_NAME"] = this.projecT_NAME;
        data["inpuT_TIME"] = this.inpuT_TIME ? this.inpuT_TIME.toISOString() : <any>undefined;
        data["inpuT_USER"] = this.inpuT_USER;
        data["modiF_TIME"] = this.modiF_TIME ? this.modiF_TIME.toISOString() : <any>undefined;
        data["modiF_USER"] = this.modiF_USER;
        return data; 
    }
}

export interface IListLkProject {
    projecT_ID: string;
    projecT_GROUP_ID: string;
    projecT_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;
}

export class ListBusines implements IListBusines {
    biZ_UNIT_ID: string;
    businesS_UNIT: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;
    naturE_ACCOUNT_CD: string;

    constructor(data?: IListBusines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.biZ_UNIT_ID = data["biZ_UNIT_ID"];
            this.businesS_UNIT = data["businesS_UNIT"];
            this.inpuT_TIME = data["inpuT_TIME"] ? moment(data["inpuT_TIME"].toString()) : <any>undefined;
            this.inpuT_USER = data["inpuT_USER"];
            this.modiF_TIME = data["modiF_TIME"] ? moment(data["modiF_TIME"].toString()) : <any>undefined;
            this.modiF_USER = data["modiF_USER"];
            this.naturE_ACCOUNT_CD = data["naturE_ACCOUNT_CD"];
        }
    }

    static fromJS(data: any): ListBusines {
        let result = new ListBusines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biZ_UNIT_ID"] = this.biZ_UNIT_ID;
        data["businesS_UNIT"] = this.businesS_UNIT;
        data["inpuT_TIME"] = this.inpuT_TIME ? this.inpuT_TIME.toISOString() : <any>undefined;
        data["inpuT_USER"] = this.inpuT_USER;
        data["modiF_TIME"] = this.modiF_TIME ? this.modiF_TIME.toISOString() : <any>undefined;
        data["modiF_USER"] = this.modiF_USER;
        data["naturE_ACCOUNT_CD"] = this.naturE_ACCOUNT_CD;
        return data; 
    }
}

export interface IListBusines {
    biZ_UNIT_ID: string;
    businesS_UNIT: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;
    naturE_ACCOUNT_CD: string;
}

export class ListLkDivision implements IListLkDivision {
    divisioN_ID: string;
    divisioN_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;

    constructor(data?: IListLkDivision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.divisioN_ID = data["divisioN_ID"];
            this.divisioN_NAME = data["divisioN_NAME"];
            this.inpuT_TIME = data["inpuT_TIME"] ? moment(data["inpuT_TIME"].toString()) : <any>undefined;
            this.inpuT_USER = data["inpuT_USER"];
            this.modiF_TIME = data["modiF_TIME"] ? moment(data["modiF_TIME"].toString()) : <any>undefined;
            this.modiF_USER = data["modiF_USER"];
        }
    }

    static fromJS(data: any): ListLkDivision {
        let result = new ListLkDivision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["divisioN_ID"] = this.divisioN_ID;
        data["divisioN_NAME"] = this.divisioN_NAME;
        data["inpuT_TIME"] = this.inpuT_TIME ? this.inpuT_TIME.toISOString() : <any>undefined;
        data["inpuT_USER"] = this.inpuT_USER;
        data["modiF_TIME"] = this.modiF_TIME ? this.modiF_TIME.toISOString() : <any>undefined;
        data["modiF_USER"] = this.modiF_USER;
        return data; 
    }
}

export interface IListLkDivision {
    divisioN_ID: string;
    divisioN_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;
}

export class ListOrg implements IListOrg {
    orG_ID: string;
    provincE_ID: string;
    companY_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;

    constructor(data?: IListOrg) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orG_ID = data["orG_ID"];
            this.provincE_ID = data["provincE_ID"];
            this.companY_NAME = data["companY_NAME"];
            this.inpuT_TIME = data["inpuT_TIME"] ? moment(data["inpuT_TIME"].toString()) : <any>undefined;
            this.inpuT_USER = data["inpuT_USER"];
            this.modiF_TIME = data["modiF_TIME"] ? moment(data["modiF_TIME"].toString()) : <any>undefined;
            this.modiF_USER = data["modiF_USER"];
        }
    }

    static fromJS(data: any): ListOrg {
        let result = new ListOrg();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orG_ID"] = this.orG_ID;
        data["provincE_ID"] = this.provincE_ID;
        data["companY_NAME"] = this.companY_NAME;
        data["inpuT_TIME"] = this.inpuT_TIME ? this.inpuT_TIME.toISOString() : <any>undefined;
        data["inpuT_USER"] = this.inpuT_USER;
        data["modiF_TIME"] = this.modiF_TIME ? this.modiF_TIME.toISOString() : <any>undefined;
        data["modiF_USER"] = this.modiF_USER;
        return data; 
    }
}

export interface IListOrg {
    orG_ID: string;
    provincE_ID: string;
    companY_NAME: string;
    inpuT_TIME: moment.Moment;
    inpuT_USER: string;
    modiF_TIME: moment.Moment;
    modiF_USER: string;
}

export class ListResultDtoOfGetAllProjectListDto implements IListResultDtoOfGetAllProjectListDto {
    items: GetAllProjectListDto[];

    constructor(data?: IListResultDtoOfGetAllProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllProjectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllProjectListDto {
        let result = new ListResultDtoOfGetAllProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllProjectListDto {
    items: GetAllProjectListDto[];
}

export class GetAllProjectListDto implements IGetAllProjectListDto {
    id: number;
    projectCode: string;
    parentProjectName: string;
    projectName: string;
    cityName: string;
    teritoryName: string;
    isPublish: boolean;
    image: string;
    mapping: string;

    constructor(data?: IGetAllProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectCode = data["projectCode"];
            this.parentProjectName = data["parentProjectName"];
            this.projectName = data["projectName"];
            this.cityName = data["cityName"];
            this.teritoryName = data["teritoryName"];
            this.isPublish = data["isPublish"];
            this.image = data["image"];
            this.mapping = data["mapping"];
        }
    }

    static fromJS(data: any): GetAllProjectListDto {
        let result = new GetAllProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectCode"] = this.projectCode;
        data["parentProjectName"] = this.parentProjectName;
        data["projectName"] = this.projectName;
        data["cityName"] = this.cityName;
        data["teritoryName"] = this.teritoryName;
        data["isPublish"] = this.isPublish;
        data["image"] = this.image;
        data["mapping"] = this.mapping;
        return data; 
    }
}

export interface IGetAllProjectListDto {
    id: number;
    projectCode: string;
    parentProjectName: string;
    projectName: string;
    cityName: string;
    teritoryName: string;
    isPublish: boolean;
    image: string;
    mapping: string;
}

export class CreateMsProjectInputDto implements ICreateMsProjectInputDto {
    id: number;
    businessGroup: string;
    projectCode: string;
    projectName: string;
    parentProjectName: string;
    image: string;
    imageNew: string;
    isPublish: boolean;
    operationalGroup: string;
    taxGroup: string;
    isDMT: boolean;
    dmT_ProjectGroupCode: string;
    dmT_ProjectGroupName: string;
    callCenterManagerID: number;
    callCenterStaffID: number;
    bankRelationManagerID: number;
    bankRelationStaffID: number;
    sadbmid: number;
    sadManagerID: number;
    sadStaffID: number;
    pgManagerID: number;
    pgStaffID: number;
    financeManagerID: number;
    financeStaffID: number;
    startPenaltyDay: number;
    penaltyRate: number;
    sadbmStaffID: number;
    projecT_ID: string;
    businessUnitID: string;
    divisionID: string;
    orgID: string;

    constructor(data?: ICreateMsProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.businessGroup = data["businessGroup"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.parentProjectName = data["parentProjectName"];
            this.image = data["image"];
            this.imageNew = data["imageNew"];
            this.isPublish = data["isPublish"];
            this.operationalGroup = data["operationalGroup"];
            this.taxGroup = data["taxGroup"];
            this.isDMT = data["isDMT"];
            this.dmT_ProjectGroupCode = data["dmT_ProjectGroupCode"];
            this.dmT_ProjectGroupName = data["dmT_ProjectGroupName"];
            this.callCenterManagerID = data["callCenterManagerID"];
            this.callCenterStaffID = data["callCenterStaffID"];
            this.bankRelationManagerID = data["bankRelationManagerID"];
            this.bankRelationStaffID = data["bankRelationStaffID"];
            this.sadbmid = data["sadbmid"];
            this.sadManagerID = data["sadManagerID"];
            this.sadStaffID = data["sadStaffID"];
            this.pgManagerID = data["pgManagerID"];
            this.pgStaffID = data["pgStaffID"];
            this.financeManagerID = data["financeManagerID"];
            this.financeStaffID = data["financeStaffID"];
            this.startPenaltyDay = data["startPenaltyDay"];
            this.penaltyRate = data["penaltyRate"];
            this.sadbmStaffID = data["sadbmStaffID"];
            this.projecT_ID = data["projecT_ID"];
            this.businessUnitID = data["businessUnitID"];
            this.divisionID = data["divisionID"];
            this.orgID = data["orgID"];
        }
    }

    static fromJS(data: any): CreateMsProjectInputDto {
        let result = new CreateMsProjectInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessGroup"] = this.businessGroup;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["parentProjectName"] = this.parentProjectName;
        data["image"] = this.image;
        data["imageNew"] = this.imageNew;
        data["isPublish"] = this.isPublish;
        data["operationalGroup"] = this.operationalGroup;
        data["taxGroup"] = this.taxGroup;
        data["isDMT"] = this.isDMT;
        data["dmT_ProjectGroupCode"] = this.dmT_ProjectGroupCode;
        data["dmT_ProjectGroupName"] = this.dmT_ProjectGroupName;
        data["callCenterManagerID"] = this.callCenterManagerID;
        data["callCenterStaffID"] = this.callCenterStaffID;
        data["bankRelationManagerID"] = this.bankRelationManagerID;
        data["bankRelationStaffID"] = this.bankRelationStaffID;
        data["sadbmid"] = this.sadbmid;
        data["sadManagerID"] = this.sadManagerID;
        data["sadStaffID"] = this.sadStaffID;
        data["pgManagerID"] = this.pgManagerID;
        data["pgStaffID"] = this.pgStaffID;
        data["financeManagerID"] = this.financeManagerID;
        data["financeStaffID"] = this.financeStaffID;
        data["startPenaltyDay"] = this.startPenaltyDay;
        data["penaltyRate"] = this.penaltyRate;
        data["sadbmStaffID"] = this.sadbmStaffID;
        data["projecT_ID"] = this.projecT_ID;
        data["businessUnitID"] = this.businessUnitID;
        data["divisionID"] = this.divisionID;
        data["orgID"] = this.orgID;
        return data; 
    }
}

export interface ICreateMsProjectInputDto {
    id: number;
    businessGroup: string;
    projectCode: string;
    projectName: string;
    parentProjectName: string;
    image: string;
    imageNew: string;
    isPublish: boolean;
    operationalGroup: string;
    taxGroup: string;
    isDMT: boolean;
    dmT_ProjectGroupCode: string;
    dmT_ProjectGroupName: string;
    callCenterManagerID: number;
    callCenterStaffID: number;
    bankRelationManagerID: number;
    bankRelationStaffID: number;
    sadbmid: number;
    sadManagerID: number;
    sadStaffID: number;
    pgManagerID: number;
    pgStaffID: number;
    financeManagerID: number;
    financeStaffID: number;
    startPenaltyDay: number;
    penaltyRate: number;
    sadbmStaffID: number;
    projecT_ID: string;
    businessUnitID: string;
    divisionID: string;
    orgID: string;
}

export class GetDetailMsProjectListDto implements IGetDetailMsProjectListDto {
    projectInformation: ProjectInformationListDto;
    picInformation: PICInformationListDto;

    constructor(data?: IGetDetailMsProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInformation = data["projectInformation"] ? ProjectInformationListDto.fromJS(data["projectInformation"]) : <any>undefined;
            this.picInformation = data["picInformation"] ? PICInformationListDto.fromJS(data["picInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailMsProjectListDto {
        let result = new GetDetailMsProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInformation"] = this.projectInformation ? this.projectInformation.toJSON() : <any>undefined;
        data["picInformation"] = this.picInformation ? this.picInformation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailMsProjectListDto {
    projectInformation: ProjectInformationListDto;
    picInformation: PICInformationListDto;
}

export class ProjectInformationListDto implements IProjectInformationListDto {
    entityID: number;
    entityName: string;
    isDMT: boolean;
    projectGroupCode: string;
    projectGroupName: string;
    parentProjectName: string;
    projectCode: string;
    projectName: string;
    image: string;
    isPublish: boolean;
    penaltyRate: number;
    startPenaltyDay: number;
    operationalGroupEntityCode: string;
    operationalGroup: string;
    taxGroupEntityCode: string;
    taxGroup: string;
    businessGroup: string;
    projecT_ID: string;
    businessUnitID: string;
    divisionID: string;
    orgID: string;

    constructor(data?: IProjectInformationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.entityName = data["entityName"];
            this.isDMT = data["isDMT"];
            this.projectGroupCode = data["projectGroupCode"];
            this.projectGroupName = data["projectGroupName"];
            this.parentProjectName = data["parentProjectName"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.image = data["image"];
            this.isPublish = data["isPublish"];
            this.penaltyRate = data["penaltyRate"];
            this.startPenaltyDay = data["startPenaltyDay"];
            this.operationalGroupEntityCode = data["operationalGroupEntityCode"];
            this.operationalGroup = data["operationalGroup"];
            this.taxGroupEntityCode = data["taxGroupEntityCode"];
            this.taxGroup = data["taxGroup"];
            this.businessGroup = data["businessGroup"];
            this.projecT_ID = data["projecT_ID"];
            this.businessUnitID = data["businessUnitID"];
            this.divisionID = data["divisionID"];
            this.orgID = data["orgID"];
        }
    }

    static fromJS(data: any): ProjectInformationListDto {
        let result = new ProjectInformationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["entityName"] = this.entityName;
        data["isDMT"] = this.isDMT;
        data["projectGroupCode"] = this.projectGroupCode;
        data["projectGroupName"] = this.projectGroupName;
        data["parentProjectName"] = this.parentProjectName;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["image"] = this.image;
        data["isPublish"] = this.isPublish;
        data["penaltyRate"] = this.penaltyRate;
        data["startPenaltyDay"] = this.startPenaltyDay;
        data["operationalGroupEntityCode"] = this.operationalGroupEntityCode;
        data["operationalGroup"] = this.operationalGroup;
        data["taxGroupEntityCode"] = this.taxGroupEntityCode;
        data["taxGroup"] = this.taxGroup;
        data["businessGroup"] = this.businessGroup;
        data["projecT_ID"] = this.projecT_ID;
        data["businessUnitID"] = this.businessUnitID;
        data["divisionID"] = this.divisionID;
        data["orgID"] = this.orgID;
        return data; 
    }
}

export interface IProjectInformationListDto {
    entityID: number;
    entityName: string;
    isDMT: boolean;
    projectGroupCode: string;
    projectGroupName: string;
    parentProjectName: string;
    projectCode: string;
    projectName: string;
    image: string;
    isPublish: boolean;
    penaltyRate: number;
    startPenaltyDay: number;
    operationalGroupEntityCode: string;
    operationalGroup: string;
    taxGroupEntityCode: string;
    taxGroup: string;
    businessGroup: string;
    projecT_ID: string;
    businessUnitID: string;
    divisionID: string;
    orgID: string;
}

export class PICInformationListDto implements IPICInformationListDto {
    psas: PSASListDto;
    pg: PGListDto;
    finance: FinanceListDto;
    bankRelation: BankRelationListDto;
    callCenter: CallCenterListDto;
    buildingManager: BuildingManagerListDto;

    constructor(data?: IPICInformationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psas = data["psas"] ? PSASListDto.fromJS(data["psas"]) : <any>undefined;
            this.pg = data["pg"] ? PGListDto.fromJS(data["pg"]) : <any>undefined;
            this.finance = data["finance"] ? FinanceListDto.fromJS(data["finance"]) : <any>undefined;
            this.bankRelation = data["bankRelation"] ? BankRelationListDto.fromJS(data["bankRelation"]) : <any>undefined;
            this.callCenter = data["callCenter"] ? CallCenterListDto.fromJS(data["callCenter"]) : <any>undefined;
            this.buildingManager = data["buildingManager"] ? BuildingManagerListDto.fromJS(data["buildingManager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PICInformationListDto {
        let result = new PICInformationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psas"] = this.psas ? this.psas.toJSON() : <any>undefined;
        data["pg"] = this.pg ? this.pg.toJSON() : <any>undefined;
        data["finance"] = this.finance ? this.finance.toJSON() : <any>undefined;
        data["bankRelation"] = this.bankRelation ? this.bankRelation.toJSON() : <any>undefined;
        data["callCenter"] = this.callCenter ? this.callCenter.toJSON() : <any>undefined;
        data["buildingManager"] = this.buildingManager ? this.buildingManager.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPICInformationListDto {
    psas: PSASListDto;
    pg: PGListDto;
    finance: FinanceListDto;
    bankRelation: BankRelationListDto;
    callCenter: CallCenterListDto;
    buildingManager: BuildingManagerListDto;
}

export class PSASListDto implements IPSASListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: IPSASListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): PSASListDto {
        let result = new PSASListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface IPSASListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class PGListDto implements IPGListDto {
    picID: number;
    pic: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: IPGListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.picID = data["picID"];
            this.pic = data["pic"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): PGListDto {
        let result = new PGListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["picID"] = this.picID;
        data["pic"] = this.pic;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface IPGListDto {
    picID: number;
    pic: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class FinanceListDto implements IFinanceListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: IFinanceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): FinanceListDto {
        let result = new FinanceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface IFinanceListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class BankRelationListDto implements IBankRelationListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: IBankRelationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): BankRelationListDto {
        let result = new BankRelationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface IBankRelationListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class CallCenterListDto implements ICallCenterListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: ICallCenterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): CallCenterListDto {
        let result = new CallCenterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface ICallCenterListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class BuildingManagerListDto implements IBuildingManagerListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;

    constructor(data?: IBuildingManagerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.managerID = data["managerID"];
            this.managerName = data["managerName"];
            this.staffID = data["staffID"];
            this.staffName = data["staffName"];
            this.departementWhatsapp = data["departementWhatsapp"];
            this.departementEmail = data["departementEmail"];
            this.officerPhone = data["officerPhone"];
        }
    }

    static fromJS(data: any): BuildingManagerListDto {
        let result = new BuildingManagerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerID"] = this.managerID;
        data["managerName"] = this.managerName;
        data["staffID"] = this.staffID;
        data["staffName"] = this.staffName;
        data["departementWhatsapp"] = this.departementWhatsapp;
        data["departementEmail"] = this.departementEmail;
        data["officerPhone"] = this.officerPhone;
        return data; 
    }
}

export interface IBuildingManagerListDto {
    managerID: number;
    managerName: string;
    staffID: number;
    staffName: string;
    departementWhatsapp: string;
    departementEmail: string;
    officerPhone: string;
}

export class GetUpdateDmtValueInputDto implements IGetUpdateDmtValueInputDto {
    query: string;
    serverName: string;
    dbName: string;
    credentialUser: string;
    credentialPass: string;

    constructor(data?: IGetUpdateDmtValueInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.query = data["query"];
            this.serverName = data["serverName"];
            this.dbName = data["dbName"];
            this.credentialUser = data["credentialUser"];
            this.credentialPass = data["credentialPass"];
        }
    }

    static fromJS(data: any): GetUpdateDmtValueInputDto {
        let result = new GetUpdateDmtValueInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["serverName"] = this.serverName;
        data["dbName"] = this.dbName;
        data["credentialUser"] = this.credentialUser;
        data["credentialPass"] = this.credentialPass;
        return data; 
    }
}

export interface IGetUpdateDmtValueInputDto {
    query: string;
    serverName: string;
    dbName: string;
    credentialUser: string;
    credentialPass: string;
}

export class GetMappingDMTListDto implements IGetMappingDMTListDto {
    projectgroupcode: string;
    projectgroupname: string;
    projectname: string;
    projectCode: string;

    constructor(data?: IGetMappingDMTListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectgroupcode = data["projectgroupcode"];
            this.projectgroupname = data["projectgroupname"];
            this.projectname = data["projectname"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): GetMappingDMTListDto {
        let result = new GetMappingDMTListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectgroupcode"] = this.projectgroupcode;
        data["projectgroupname"] = this.projectgroupname;
        data["projectname"] = this.projectname;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IGetMappingDMTListDto {
    projectgroupcode: string;
    projectgroupname: string;
    projectname: string;
    projectCode: string;
}

export class ListResultDtoOfListProjectResultDto implements IListResultDtoOfListProjectResultDto {
    items: ListProjectResultDto[];

    constructor(data?: IListResultDtoOfListProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProjectResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProjectResultDto {
        let result = new ListResultDtoOfListProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProjectResultDto {
    items: ListProjectResultDto[];
}

export class ListProjectResultDto implements IListProjectResultDto {
    projectID: number;
    productID: number;
    productName: string;
    parentProjectName: string;
    projectCode: string;
    projectName: string;
    regionName: string;
    message: string;
    image: string;
    type: string;
    isRequiredPP: boolean;

    constructor(data?: IListProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.productID = data["productID"];
            this.productName = data["productName"];
            this.parentProjectName = data["parentProjectName"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.regionName = data["regionName"];
            this.message = data["message"];
            this.image = data["image"];
            this.type = data["type"];
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): ListProjectResultDto {
        let result = new ListProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        data["parentProjectName"] = this.parentProjectName;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["regionName"] = this.regionName;
        data["message"] = this.message;
        data["image"] = this.image;
        data["type"] = this.type;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IListProjectResultDto {
    projectID: number;
    productID: number;
    productName: string;
    parentProjectName: string;
    projectCode: string;
    projectName: string;
    regionName: string;
    message: string;
    image: string;
    type: string;
    isRequiredPP: boolean;
}

export class GetListProductByProjectResultDto implements IGetListProductByProjectResultDto {
    projectID: number;
    projectInfoID: number;
    productCode: string;
    productName: string;

    constructor(data?: IGetListProductByProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetListProductByProjectResultDto {
        let result = new GetListProductByProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetListProductByProjectResultDto {
    projectID: number;
    projectInfoID: number;
    productCode: string;
    productName: string;
}

export class GetListRolesProjectResultDto implements IGetListRolesProjectResultDto {
    rolesID: number;
    roleName: string;
    listProject: DataByRoleListDto[];
    listAccount: DataByRoleListDto[];
    listOthersType: DataByRoleListDto[];
    listPayType: DataByRoleListDto[];
    listPayFor: DataByRoleListDto[];

    constructor(data?: IGetListRolesProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rolesID = data["rolesID"];
            this.roleName = data["roleName"];
            if (data["listProject"] && data["listProject"].constructor === Array) {
                this.listProject = [];
                for (let item of data["listProject"])
                    this.listProject.push(DataByRoleListDto.fromJS(item));
            }
            if (data["listAccount"] && data["listAccount"].constructor === Array) {
                this.listAccount = [];
                for (let item of data["listAccount"])
                    this.listAccount.push(DataByRoleListDto.fromJS(item));
            }
            if (data["listOthersType"] && data["listOthersType"].constructor === Array) {
                this.listOthersType = [];
                for (let item of data["listOthersType"])
                    this.listOthersType.push(DataByRoleListDto.fromJS(item));
            }
            if (data["listPayType"] && data["listPayType"].constructor === Array) {
                this.listPayType = [];
                for (let item of data["listPayType"])
                    this.listPayType.push(DataByRoleListDto.fromJS(item));
            }
            if (data["listPayFor"] && data["listPayFor"].constructor === Array) {
                this.listPayFor = [];
                for (let item of data["listPayFor"])
                    this.listPayFor.push(DataByRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListRolesProjectResultDto {
        let result = new GetListRolesProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesID"] = this.rolesID;
        data["roleName"] = this.roleName;
        if (this.listProject && this.listProject.constructor === Array) {
            data["listProject"] = [];
            for (let item of this.listProject)
                data["listProject"].push(item.toJSON());
        }
        if (this.listAccount && this.listAccount.constructor === Array) {
            data["listAccount"] = [];
            for (let item of this.listAccount)
                data["listAccount"].push(item.toJSON());
        }
        if (this.listOthersType && this.listOthersType.constructor === Array) {
            data["listOthersType"] = [];
            for (let item of this.listOthersType)
                data["listOthersType"].push(item.toJSON());
        }
        if (this.listPayType && this.listPayType.constructor === Array) {
            data["listPayType"] = [];
            for (let item of this.listPayType)
                data["listPayType"].push(item.toJSON());
        }
        if (this.listPayFor && this.listPayFor.constructor === Array) {
            data["listPayFor"] = [];
            for (let item of this.listPayFor)
                data["listPayFor"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListRolesProjectResultDto {
    rolesID: number;
    roleName: string;
    listProject: DataByRoleListDto[];
    listAccount: DataByRoleListDto[];
    listOthersType: DataByRoleListDto[];
    listPayType: DataByRoleListDto[];
    listPayFor: DataByRoleListDto[];
}

export class DataByRoleListDto implements IDataByRoleListDto {
    id: number;
    code: string;
    name: string;
    isChecked: boolean;

    constructor(data?: IDataByRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): DataByRoleListDto {
        let result = new DataByRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IDataByRoleListDto {
    id: number;
    code: string;
    name: string;
    isChecked: boolean;
}

export class CreateDeleteRolesProjectInputDto implements ICreateDeleteRolesProjectInputDto {
    rolesID: number;
    listSysRoles: number[];

    constructor(data?: ICreateDeleteRolesProjectInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rolesID = data["rolesID"];
            if (data["listSysRoles"] && data["listSysRoles"].constructor === Array) {
                this.listSysRoles = [];
                for (let item of data["listSysRoles"])
                    this.listSysRoles.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeleteRolesProjectInputDto {
        let result = new CreateDeleteRolesProjectInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesID"] = this.rolesID;
        if (this.listSysRoles && this.listSysRoles.constructor === Array) {
            data["listSysRoles"] = [];
            for (let item of this.listSysRoles)
                data["listSysRoles"].push(item);
        }
        return data; 
    }
}

export interface ICreateDeleteRolesProjectInputDto {
    rolesID: number;
    listSysRoles: number[];
}

export class GetMsProvinceListDto implements IGetMsProvinceListDto {
    provinceCode: string;
    provinceName: string;

    constructor(data?: IGetMsProvinceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): GetMsProvinceListDto {
        let result = new GetMsProvinceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface IGetMsProvinceListDto {
    provinceCode: string;
    provinceName: string;
}

export class CreateMsRenovationInput implements ICreateMsRenovationInput {
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detailName: string;
    isActive: boolean;

    constructor(data?: ICreateMsRenovationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.renovationName = data["renovationName"];
            this.renovationCode = data["renovationCode"];
            this.detailName = data["detailName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsRenovationInput {
        let result = new CreateMsRenovationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["renovationName"] = this.renovationName;
        data["renovationCode"] = this.renovationCode;
        data["detailName"] = this.detailName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsRenovationInput {
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detailName: string;
    isActive: boolean;
}

export class ListResultDtoOfGetLkItemListDto implements IListResultDtoOfGetLkItemListDto {
    items: GetLkItemListDto[];

    constructor(data?: IListResultDtoOfGetLkItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetLkItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetLkItemListDto {
        let result = new ListResultDtoOfGetLkItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetLkItemListDto {
    items: GetLkItemListDto[];
}

export class GetLkItemListDto implements IGetLkItemListDto {
    id: number;
    itemCode: string;
    shortName: string;

    constructor(data?: IGetLkItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.itemCode = data["itemCode"];
            this.shortName = data["shortName"];
        }
    }

    static fromJS(data: any): GetLkItemListDto {
        let result = new GetLkItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemCode"] = this.itemCode;
        data["shortName"] = this.shortName;
        return data; 
    }
}

export interface IGetLkItemListDto {
    id: number;
    itemCode: string;
    shortName: string;
}

export class ListResultDtoOfGetAllMsRenovationListDto implements IListResultDtoOfGetAllMsRenovationListDto {
    items: GetAllMsRenovationListDto[];

    constructor(data?: IListResultDtoOfGetAllMsRenovationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsRenovationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsRenovationListDto {
        let result = new ListResultDtoOfGetAllMsRenovationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsRenovationListDto {
    items: GetAllMsRenovationListDto[];
}

export class GetAllMsRenovationListDto implements IGetAllMsRenovationListDto {
    id: number;
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detail: string;
    isActive: boolean;
    projectName: string;

    constructor(data?: IGetAllMsRenovationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.renovationName = data["renovationName"];
            this.renovationCode = data["renovationCode"];
            this.detail = data["detail"];
            this.isActive = data["isActive"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetAllMsRenovationListDto {
        let result = new GetAllMsRenovationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["renovationName"] = this.renovationName;
        data["renovationCode"] = this.renovationCode;
        data["detail"] = this.detail;
        data["isActive"] = this.isActive;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetAllMsRenovationListDto {
    id: number;
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detail: string;
    isActive: boolean;
    projectName: string;
}

export class UpdateMsRenovationInput implements IUpdateMsRenovationInput {
    id: number;
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detailName: string;
    detailNameNew: string;
    detailNameToDelete: string;
    isActive: boolean;

    constructor(data?: IUpdateMsRenovationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.renovationName = data["renovationName"];
            this.renovationCode = data["renovationCode"];
            this.detailName = data["detailName"];
            this.detailNameNew = data["detailNameNew"];
            this.detailNameToDelete = data["detailNameToDelete"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsRenovationInput {
        let result = new UpdateMsRenovationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["renovationName"] = this.renovationName;
        data["renovationCode"] = this.renovationCode;
        data["detailName"] = this.detailName;
        data["detailNameNew"] = this.detailNameNew;
        data["detailNameToDelete"] = this.detailNameToDelete;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsRenovationInput {
    id: number;
    projectID: number;
    renovationName: string;
    renovationCode: string;
    detailName: string;
    detailNameNew: string;
    detailNameToDelete: string;
    isActive: boolean;
}

export class ListResultDtoOfGetAllMsStatusMemberDropdownList implements IListResultDtoOfGetAllMsStatusMemberDropdownList {
    items: GetAllMsStatusMemberDropdownList[];

    constructor(data?: IListResultDtoOfGetAllMsStatusMemberDropdownList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsStatusMemberDropdownList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsStatusMemberDropdownList {
        let result = new ListResultDtoOfGetAllMsStatusMemberDropdownList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsStatusMemberDropdownList {
    items: GetAllMsStatusMemberDropdownList[];
}

export class GetAllMsStatusMemberDropdownList implements IGetAllMsStatusMemberDropdownList {
    statusCode: string;
    statusName: string;

    constructor(data?: IGetAllMsStatusMemberDropdownList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
            this.statusName = data["statusName"];
        }
    }

    static fromJS(data: any): GetAllMsStatusMemberDropdownList {
        let result = new GetAllMsStatusMemberDropdownList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        return data; 
    }
}

export interface IGetAllMsStatusMemberDropdownList {
    statusCode: string;
    statusName: string;
}

export class PagedResultDtoOfMasterSurroundingDto implements IPagedResultDtoOfMasterSurroundingDto {
    totalCount: number;
    items: MasterSurroundingDto[];

    constructor(data?: IPagedResultDtoOfMasterSurroundingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MasterSurroundingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMasterSurroundingDto {
        let result = new PagedResultDtoOfMasterSurroundingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMasterSurroundingDto {
    totalCount: number;
    items: MasterSurroundingDto[];
}

export class MasterSurroundingDto implements IMasterSurroundingDto {
    id: number;
    projectID: number;
    clusterID: number;
    unitCode: string;
    unitNo: string;
    surroundingCode: string;
    imageFileName: string;
    imageFileLocation: string;
    creationTime: moment.Moment;
    clusterName: string;

    constructor(data?: IMasterSurroundingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.surroundingCode = data["surroundingCode"];
            this.imageFileName = data["imageFileName"];
            this.imageFileLocation = data["imageFileLocation"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): MasterSurroundingDto {
        let result = new MasterSurroundingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["surroundingCode"] = this.surroundingCode;
        data["imageFileName"] = this.imageFileName;
        data["imageFileLocation"] = this.imageFileLocation;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IMasterSurroundingDto {
    id: number;
    projectID: number;
    clusterID: number;
    unitCode: string;
    unitNo: string;
    surroundingCode: string;
    imageFileName: string;
    imageFileLocation: string;
    creationTime: moment.Moment;
    clusterName: string;
}

export class CreateUpdateDeleteMasterSurroundingDto implements ICreateUpdateDeleteMasterSurroundingDto {
    createUpdate: MasterSurroundingDto[];
    deleteMasterData: DeleteMasterSurroundingDto[];

    constructor(data?: ICreateUpdateDeleteMasterSurroundingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["createUpdate"] && data["createUpdate"].constructor === Array) {
                this.createUpdate = [];
                for (let item of data["createUpdate"])
                    this.createUpdate.push(MasterSurroundingDto.fromJS(item));
            }
            if (data["deleteMasterData"] && data["deleteMasterData"].constructor === Array) {
                this.deleteMasterData = [];
                for (let item of data["deleteMasterData"])
                    this.deleteMasterData.push(DeleteMasterSurroundingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateDeleteMasterSurroundingDto {
        let result = new CreateUpdateDeleteMasterSurroundingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.createUpdate && this.createUpdate.constructor === Array) {
            data["createUpdate"] = [];
            for (let item of this.createUpdate)
                data["createUpdate"].push(item.toJSON());
        }
        if (this.deleteMasterData && this.deleteMasterData.constructor === Array) {
            data["deleteMasterData"] = [];
            for (let item of this.deleteMasterData)
                data["deleteMasterData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUpdateDeleteMasterSurroundingDto {
    createUpdate: MasterSurroundingDto[];
    deleteMasterData: DeleteMasterSurroundingDto[];
}

export class DeleteMasterSurroundingDto implements IDeleteMasterSurroundingDto {
    deleteID: number;
    surroundingCode: string;

    constructor(data?: IDeleteMasterSurroundingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteID = data["deleteID"];
            this.surroundingCode = data["surroundingCode"];
        }
    }

    static fromJS(data: any): DeleteMasterSurroundingDto {
        let result = new DeleteMasterSurroundingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteID"] = this.deleteID;
        data["surroundingCode"] = this.surroundingCode;
        return data; 
    }
}

export interface IDeleteMasterSurroundingDto {
    deleteID: number;
    surroundingCode: string;
}

export class MsSurroundingResultMessageDto implements IMsSurroundingResultMessageDto {
    message: string;
    result: boolean;

    constructor(data?: IMsSurroundingResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): MsSurroundingResultMessageDto {
        let result = new MsSurroundingResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IMsSurroundingResultMessageDto {
    message: string;
    result: boolean;
}

export class FileNameSurroundingDto implements IFileNameSurroundingDto {
    fileNameTemp: string;
    unitCode: string;
    unitNo: string;
    surroundingCode: string;

    constructor(data?: IFileNameSurroundingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileNameTemp = data["fileNameTemp"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.surroundingCode = data["surroundingCode"];
        }
    }

    static fromJS(data: any): FileNameSurroundingDto {
        let result = new FileNameSurroundingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileNameTemp"] = this.fileNameTemp;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["surroundingCode"] = this.surroundingCode;
        return data; 
    }
}

export interface IFileNameSurroundingDto {
    fileNameTemp: string;
    unitCode: string;
    unitNo: string;
    surroundingCode: string;
}

export class ValidatedResultMessageDto implements IValidatedResultMessageDto {
    validUnitNoUnitCode: boolean;
    validSurrCode: boolean;
    result: string;

    constructor(data?: IValidatedResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.validUnitNoUnitCode = data["validUnitNoUnitCode"];
            this.validSurrCode = data["validSurrCode"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): ValidatedResultMessageDto {
        let result = new ValidatedResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validUnitNoUnitCode"] = this.validUnitNoUnitCode;
        data["validSurrCode"] = this.validSurrCode;
        data["result"] = this.result;
        return data; 
    }
}

export interface IValidatedResultMessageDto {
    validUnitNoUnitCode: boolean;
    validSurrCode: boolean;
    result: string;
}

export class ListResultDtoOfGetAllMsTermListDto implements IListResultDtoOfGetAllMsTermListDto {
    items: GetAllMsTermListDto[];

    constructor(data?: IListResultDtoOfGetAllMsTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsTermListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsTermListDto {
        let result = new ListResultDtoOfGetAllMsTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsTermListDto {
    items: GetAllMsTermListDto[];
}

export class GetAllMsTermListDto implements IGetAllMsTermListDto {
    termMainID: number;
    termID: number;
    termCode: string;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    projectName: string;
    isActive: boolean;

    constructor(data?: IGetAllMsTermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainID = data["termMainID"];
            this.termID = data["termID"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarks = data["remarks"];
            this.projectName = data["projectName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllMsTermListDto {
        let result = new GetAllMsTermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainID"] = this.termMainID;
        data["termID"] = this.termID;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarks"] = this.remarks;
        data["projectName"] = this.projectName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllMsTermListDto {
    termMainID: number;
    termID: number;
    termCode: string;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    projectName: string;
    isActive: boolean;
}

export class UpdateMsTermStatusInputDto implements IUpdateMsTermStatusInputDto {
    termMainID: number;
    termNo: number;
    isActive: boolean;

    constructor(data?: IUpdateMsTermStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainID = data["termMainID"];
            this.termNo = data["termNo"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsTermStatusInputDto {
        let result = new UpdateMsTermStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainID"] = this.termMainID;
        data["termNo"] = this.termNo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsTermStatusInputDto {
    termMainID: number;
    termNo: number;
    isActive: boolean;
}

export class CreateUniversalMsTermInput implements ICreateUniversalMsTermInput {
    entityCode: string;
    termCode: string;
    termDesc: string;
    famDiscCode: string;
    bfAmount: number;
    remarks: string;
    projectID: number;
    setValue: DtoTerm[];

    constructor(data?: ICreateUniversalMsTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.termDesc = data["termDesc"];
            this.famDiscCode = data["famDiscCode"];
            this.bfAmount = data["bfAmount"];
            this.remarks = data["remarks"];
            this.projectID = data["projectID"];
            if (data["setValue"] && data["setValue"].constructor === Array) {
                this.setValue = [];
                for (let item of data["setValue"])
                    this.setValue.push(DtoTerm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalMsTermInput {
        let result = new CreateUniversalMsTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["termDesc"] = this.termDesc;
        data["famDiscCode"] = this.famDiscCode;
        data["bfAmount"] = this.bfAmount;
        data["remarks"] = this.remarks;
        data["projectID"] = this.projectID;
        if (this.setValue && this.setValue.constructor === Array) {
            data["setValue"] = [];
            for (let item of this.setValue)
                data["setValue"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalMsTermInput {
    entityCode: string;
    termCode: string;
    termDesc: string;
    famDiscCode: string;
    bfAmount: number;
    remarks: string;
    projectID: number;
    setValue: DtoTerm[];
}

export class DtoTerm implements IDtoTerm {
    termNo: number;
    ppjbDue: number;
    remarks: string;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    isActive: boolean;
    dtoDP: DtoDP[];
    dtoDisc: DtoDisc[];

    constructor(data?: IDtoTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termNo = data["termNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarks = data["remarks"];
            this.finTypeID = data["finTypeID"];
            this.finTypeCode = data["finTypeCode"];
            this.finStartDue = data["finStartDue"];
            this.termInstallment = data["termInstallment"];
            this.discBFCalcType = data["discBFCalcType"];
            this.dpCalcType = data["dpCalcType"];
            this.groupTermCode = data["groupTermCode"];
            this.sortNo = data["sortNo"];
            this.isActive = data["isActive"];
            if (data["dtoDP"] && data["dtoDP"].constructor === Array) {
                this.dtoDP = [];
                for (let item of data["dtoDP"])
                    this.dtoDP.push(DtoDP.fromJS(item));
            }
            if (data["dtoDisc"] && data["dtoDisc"].constructor === Array) {
                this.dtoDisc = [];
                for (let item of data["dtoDisc"])
                    this.dtoDisc.push(DtoDisc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DtoTerm {
        let result = new DtoTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termNo"] = this.termNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarks"] = this.remarks;
        data["finTypeID"] = this.finTypeID;
        data["finTypeCode"] = this.finTypeCode;
        data["finStartDue"] = this.finStartDue;
        data["termInstallment"] = this.termInstallment;
        data["discBFCalcType"] = this.discBFCalcType;
        data["dpCalcType"] = this.dpCalcType;
        data["groupTermCode"] = this.groupTermCode;
        data["sortNo"] = this.sortNo;
        data["isActive"] = this.isActive;
        if (this.dtoDP && this.dtoDP.constructor === Array) {
            data["dtoDP"] = [];
            for (let item of this.dtoDP)
                data["dtoDP"].push(item.toJSON());
        }
        if (this.dtoDisc && this.dtoDisc.constructor === Array) {
            data["dtoDisc"] = [];
            for (let item of this.dtoDisc)
                data["dtoDisc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDtoTerm {
    termNo: number;
    ppjbDue: number;
    remarks: string;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    isActive: boolean;
    dtoDP: DtoDP[];
    dtoDisc: DtoDisc[];
}

export class DtoDP implements IDtoDP {
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;

    constructor(data?: IDtoDP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.daysDueNewKP = data["daysDueNewKP"];
        }
    }

    static fromJS(data: any): DtoDP {
        let result = new DtoDP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["daysDueNewKP"] = this.daysDueNewKP;
        return data; 
    }
}

export interface IDtoDP {
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
}

export class DtoDisc implements IDtoDisc {
    discountID: number;
    addDiscNo: string;
    addDiscPct: number;
    addDiscAmt: number;

    constructor(data?: IDtoDisc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discountID = data["discountID"];
            this.addDiscNo = data["addDiscNo"];
            this.addDiscPct = data["addDiscPct"];
            this.addDiscAmt = data["addDiscAmt"];
        }
    }

    static fromJS(data: any): DtoDisc {
        let result = new DtoDisc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountID"] = this.discountID;
        data["addDiscNo"] = this.addDiscNo;
        data["addDiscPct"] = this.addDiscPct;
        data["addDiscAmt"] = this.addDiscAmt;
        return data; 
    }
}

export interface IDtoDisc {
    discountID: number;
    addDiscNo: string;
    addDiscPct: number;
    addDiscAmt: number;
}

export class CreateMsTermMainInput implements ICreateMsTermMainInput {
    entityID: number;
    termCode: string;
    termDesc: string;
    famDiscCode: string;
    bfAmount: number;
    remarks: string;
    termID: number;

    constructor(data?: ICreateMsTermMainInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.termCode = data["termCode"];
            this.termDesc = data["termDesc"];
            this.famDiscCode = data["famDiscCode"];
            this.bfAmount = data["bfAmount"];
            this.remarks = data["remarks"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): CreateMsTermMainInput {
        let result = new CreateMsTermMainInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["termCode"] = this.termCode;
        data["termDesc"] = this.termDesc;
        data["famDiscCode"] = this.famDiscCode;
        data["bfAmount"] = this.bfAmount;
        data["remarks"] = this.remarks;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface ICreateMsTermMainInput {
    entityID: number;
    termCode: string;
    termDesc: string;
    famDiscCode: string;
    bfAmount: number;
    remarks: string;
    termID: number;
}

export class CreateMsTermInput implements ICreateMsTermInput {
    entityCode: string;
    entityID: number;
    termCode: string;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    projectID: number;
    termMainID: number;
    isActive: boolean;

    constructor(data?: ICreateMsTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.entityID = data["entityID"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarks = data["remarks"];
            this.termInstallment = data["termInstallment"];
            this.discBFCalcType = data["discBFCalcType"];
            this.dpCalcType = data["dpCalcType"];
            this.groupTermCode = data["groupTermCode"];
            this.sortNo = data["sortNo"];
            this.projectID = data["projectID"];
            this.termMainID = data["termMainID"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateMsTermInput {
        let result = new CreateMsTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["entityID"] = this.entityID;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarks"] = this.remarks;
        data["termInstallment"] = this.termInstallment;
        data["discBFCalcType"] = this.discBFCalcType;
        data["dpCalcType"] = this.dpCalcType;
        data["groupTermCode"] = this.groupTermCode;
        data["sortNo"] = this.sortNo;
        data["projectID"] = this.projectID;
        data["termMainID"] = this.termMainID;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateMsTermInput {
    entityCode: string;
    entityID: number;
    termCode: string;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    projectID: number;
    termMainID: number;
    isActive: boolean;
}

export class CreateMsTermPmtInput implements ICreateMsTermPmtInput {
    entityID: number;
    termID: number;
    termNo: number;
    finTypeID: number;
    finStartDue: number;

    constructor(data?: ICreateMsTermPmtInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.termID = data["termID"];
            this.termNo = data["termNo"];
            this.finTypeID = data["finTypeID"];
            this.finStartDue = data["finStartDue"];
        }
    }

    static fromJS(data: any): CreateMsTermPmtInput {
        let result = new CreateMsTermPmtInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["termID"] = this.termID;
        data["termNo"] = this.termNo;
        data["finTypeID"] = this.finTypeID;
        data["finStartDue"] = this.finStartDue;
        return data; 
    }
}

export interface ICreateMsTermPmtInput {
    entityID: number;
    termID: number;
    termNo: number;
    finTypeID: number;
    finStartDue: number;
}

export class CreateMsTermDPInput implements ICreateMsTermDPInput {
    entityCode: string;
    termCode: string;
    termNo: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
    termID: number;

    constructor(data?: ICreateMsTermDPInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.daysDueNewKP = data["daysDueNewKP"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): CreateMsTermDPInput {
        let result = new CreateMsTermDPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["daysDueNewKP"] = this.daysDueNewKP;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface ICreateMsTermDPInput {
    entityCode: string;
    termCode: string;
    termNo: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
    termID: number;
}

export class CreateMsTermAddDiscInput implements ICreateMsTermAddDiscInput {
    entityCode: string;
    termCode: string;
    termNo: number;
    addDiscNo: string;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;
    termID: number;

    constructor(data?: ICreateMsTermAddDiscInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.addDiscNo = data["addDiscNo"];
            this.discountID = data["discountID"];
            this.addDiscPct = data["addDiscPct"];
            this.addDiscAmt = data["addDiscAmt"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): CreateMsTermAddDiscInput {
        let result = new CreateMsTermAddDiscInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["addDiscNo"] = this.addDiscNo;
        data["discountID"] = this.discountID;
        data["addDiscPct"] = this.addDiscPct;
        data["addDiscAmt"] = this.addDiscAmt;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface ICreateMsTermAddDiscInput {
    entityCode: string;
    termCode: string;
    termNo: number;
    addDiscNo: string;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;
    termID: number;
}

export class GetExistingTermDto implements IGetExistingTermDto {
    entityCode: string;
    termCode: string;
    bfAmount: number;
    projectName: string;
    remarks: string;
    projectID: number;
    termMainID: number;
    isUsed: boolean;
    setValue: DtoGetTerm[];

    constructor(data?: IGetExistingTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.bfAmount = data["bfAmount"];
            this.projectName = data["projectName"];
            this.remarks = data["remarks"];
            this.projectID = data["projectID"];
            this.termMainID = data["termMainID"];
            this.isUsed = data["isUsed"];
            if (data["setValue"] && data["setValue"].constructor === Array) {
                this.setValue = [];
                for (let item of data["setValue"])
                    this.setValue.push(DtoGetTerm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExistingTermDto {
        let result = new GetExistingTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["bfAmount"] = this.bfAmount;
        data["projectName"] = this.projectName;
        data["remarks"] = this.remarks;
        data["projectID"] = this.projectID;
        data["termMainID"] = this.termMainID;
        data["isUsed"] = this.isUsed;
        if (this.setValue && this.setValue.constructor === Array) {
            data["setValue"] = [];
            for (let item of this.setValue)
                data["setValue"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetExistingTermDto {
    entityCode: string;
    termCode: string;
    bfAmount: number;
    projectName: string;
    remarks: string;
    projectID: number;
    termMainID: number;
    isUsed: boolean;
    setValue: DtoGetTerm[];
}

export class DtoGetTerm implements IDtoGetTerm {
    termID: number;
    termMainID: number;
    projectID: number;
    projectName: string;
    entityCode: string;
    termCode: string;
    bfAmount: number;
    termNo: number;
    ppjbDue: number;
    remarksMain: string;
    remarks: string;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    termPmtID: number;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;
    isActive: boolean;
    dtoDP: DtoGetDP[];
    dtoDisc: DtoGetDisc[];

    constructor(data?: IDtoGetTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termMainID = data["termMainID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.bfAmount = data["bfAmount"];
            this.termNo = data["termNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarksMain = data["remarksMain"];
            this.remarks = data["remarks"];
            this.termInstallment = data["termInstallment"];
            this.discBFCalcType = data["discBFCalcType"];
            this.dpCalcType = data["dpCalcType"];
            this.groupTermCode = data["groupTermCode"];
            this.sortNo = data["sortNo"];
            this.termPmtID = data["termPmtID"];
            this.finTypeID = data["finTypeID"];
            this.finTypeCode = data["finTypeCode"];
            this.finStartDue = data["finStartDue"];
            this.isActive = data["isActive"];
            if (data["dtoDP"] && data["dtoDP"].constructor === Array) {
                this.dtoDP = [];
                for (let item of data["dtoDP"])
                    this.dtoDP.push(DtoGetDP.fromJS(item));
            }
            if (data["dtoDisc"] && data["dtoDisc"].constructor === Array) {
                this.dtoDisc = [];
                for (let item of data["dtoDisc"])
                    this.dtoDisc.push(DtoGetDisc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DtoGetTerm {
        let result = new DtoGetTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termMainID"] = this.termMainID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["bfAmount"] = this.bfAmount;
        data["termNo"] = this.termNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarksMain"] = this.remarksMain;
        data["remarks"] = this.remarks;
        data["termInstallment"] = this.termInstallment;
        data["discBFCalcType"] = this.discBFCalcType;
        data["dpCalcType"] = this.dpCalcType;
        data["groupTermCode"] = this.groupTermCode;
        data["sortNo"] = this.sortNo;
        data["termPmtID"] = this.termPmtID;
        data["finTypeID"] = this.finTypeID;
        data["finTypeCode"] = this.finTypeCode;
        data["finStartDue"] = this.finStartDue;
        data["isActive"] = this.isActive;
        if (this.dtoDP && this.dtoDP.constructor === Array) {
            data["dtoDP"] = [];
            for (let item of this.dtoDP)
                data["dtoDP"].push(item.toJSON());
        }
        if (this.dtoDisc && this.dtoDisc.constructor === Array) {
            data["dtoDisc"] = [];
            for (let item of this.dtoDisc)
                data["dtoDisc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDtoGetTerm {
    termID: number;
    termMainID: number;
    projectID: number;
    projectName: string;
    entityCode: string;
    termCode: string;
    bfAmount: number;
    termNo: number;
    ppjbDue: number;
    remarksMain: string;
    remarks: string;
    termInstallment: number;
    discBFCalcType: string;
    dpCalcType: string;
    groupTermCode: string;
    sortNo: number;
    termPmtID: number;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;
    isActive: boolean;
    dtoDP: DtoGetDP[];
    dtoDisc: DtoGetDisc[];
}

export class DtoGetDP implements IDtoGetDP {
    termDPID: number;
    dpNo: number;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;

    constructor(data?: IDtoGetDP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termDPID = data["termDPID"];
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.daysDueNewKP = data["daysDueNewKP"];
        }
    }

    static fromJS(data: any): DtoGetDP {
        let result = new DtoGetDP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termDPID"] = this.termDPID;
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["daysDueNewKP"] = this.daysDueNewKP;
        return data; 
    }
}

export interface IDtoGetDP {
    termDPID: number;
    dpNo: number;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
}

export class DtoGetDisc implements IDtoGetDisc {
    termAddDiscID: number;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;
    addDiscNo: number;

    constructor(data?: IDtoGetDisc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termAddDiscID = data["termAddDiscID"];
            this.discountID = data["discountID"];
            this.addDiscPct = data["addDiscPct"];
            this.addDiscAmt = data["addDiscAmt"];
            this.addDiscNo = data["addDiscNo"];
        }
    }

    static fromJS(data: any): DtoGetDisc {
        let result = new DtoGetDisc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termAddDiscID"] = this.termAddDiscID;
        data["discountID"] = this.discountID;
        data["addDiscPct"] = this.addDiscPct;
        data["addDiscAmt"] = this.addDiscAmt;
        data["addDiscNo"] = this.addDiscNo;
        return data; 
    }
}

export interface IDtoGetDisc {
    termAddDiscID: number;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;
    addDiscNo: number;
}

export class GetMsFinTypeDto implements IGetMsFinTypeDto {
    finTypeID: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;

    constructor(data?: IGetMsFinTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.finTypeID = data["finTypeID"];
            this.finTypeCode = data["finTypeCode"];
            this.finTypeDesc = data["finTypeDesc"];
            this.finTimes = data["finTimes"];
        }
    }

    static fromJS(data: any): GetMsFinTypeDto {
        let result = new GetMsFinTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finTypeID"] = this.finTypeID;
        data["finTypeCode"] = this.finTypeCode;
        data["finTypeDesc"] = this.finTypeDesc;
        data["finTimes"] = this.finTimes;
        return data; 
    }
}

export interface IGetMsFinTypeDto {
    finTypeID: number;
    finTypeCode: string;
    finTypeDesc: string;
    finTimes: number;
}

export class GetDpCalcListDto implements IGetDpCalcListDto {
    id: number;
    dpCalcType: string;
    dpCalcDesc: string;

    constructor(data?: IGetDpCalcListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dpCalcType = data["dpCalcType"];
            this.dpCalcDesc = data["dpCalcDesc"];
        }
    }

    static fromJS(data: any): GetDpCalcListDto {
        let result = new GetDpCalcListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dpCalcType"] = this.dpCalcType;
        data["dpCalcDesc"] = this.dpCalcDesc;
        return data; 
    }
}

export interface IGetDpCalcListDto {
    id: number;
    dpCalcType: string;
    dpCalcDesc: string;
}

export class UpdateMsTermMainInput implements IUpdateMsTermMainInput {
    id: number;
    bfAmount: number;
    remarks: string;

    constructor(data?: IUpdateMsTermMainInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bfAmount = data["bfAmount"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): UpdateMsTermMainInput {
        let result = new UpdateMsTermMainInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bfAmount"] = this.bfAmount;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IUpdateMsTermMainInput {
    id: number;
    bfAmount: number;
    remarks: string;
}

export class GetProjectIDByTermIDResultDto implements IGetProjectIDByTermIDResultDto {
    projectCode: string;
    projectName: string;
    termCode: string;

    constructor(data?: IGetProjectIDByTermIDResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.termCode = data["termCode"];
        }
    }

    static fromJS(data: any): GetProjectIDByTermIDResultDto {
        let result = new GetProjectIDByTermIDResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["termCode"] = this.termCode;
        return data; 
    }
}

export interface IGetProjectIDByTermIDResultDto {
    projectCode: string;
    projectName: string;
    termCode: string;
}

export class GetTermByProjectCodeDto implements IGetTermByProjectCodeDto {
    projectName: string;
    term: TermCodeDto[];

    constructor(data?: IGetTermByProjectCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            if (data["term"] && data["term"].constructor === Array) {
                this.term = [];
                for (let item of data["term"])
                    this.term.push(TermCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTermByProjectCodeDto {
        let result = new GetTermByProjectCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        if (this.term && this.term.constructor === Array) {
            data["term"] = [];
            for (let item of this.term)
                data["term"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTermByProjectCodeDto {
    projectName: string;
    term: TermCodeDto[];
}

export class TermCodeDto implements ITermCodeDto {
    termCode: string;
    ppjbDue: number;
    termMainID: number;
    bookingFee: number;
    remarks: string;
    sortNo: number;
    items: TermListDto[];

    constructor(data?: ITermCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termCode = data["termCode"];
            this.ppjbDue = data["ppjbDue"];
            this.termMainID = data["termMainID"];
            this.bookingFee = data["bookingFee"];
            this.remarks = data["remarks"];
            this.sortNo = data["sortNo"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TermListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermCodeDto {
        let result = new TermCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["ppjbDue"] = this.ppjbDue;
        data["termMainID"] = this.termMainID;
        data["bookingFee"] = this.bookingFee;
        data["remarks"] = this.remarks;
        data["sortNo"] = this.sortNo;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITermCodeDto {
    termCode: string;
    ppjbDue: number;
    termMainID: number;
    bookingFee: number;
    remarks: string;
    sortNo: number;
    items: TermListDto[];
}

export class TermListDto implements ITermListDto {
    remarks: string;
    isActive: boolean;
    termID: number;
    termNo: number;
    sortNo: number;

    constructor(data?: ITermListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
            this.termID = data["termID"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): TermListDto {
        let result = new TermListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        data["termID"] = this.termID;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface ITermListDto {
    remarks: string;
    isActive: boolean;
    termID: number;
    termNo: number;
    sortNo: number;
}

export class UpdateMsTermInput implements IUpdateMsTermInput {
    id: number;
    termMainID: number;
    bfAmount: number;
    projectID: number;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    termInstallment: number;
    sortNo: number;
    dpCalcType: string;
    isActive: boolean;

    constructor(data?: IUpdateMsTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.termMainID = data["termMainID"];
            this.bfAmount = data["bfAmount"];
            this.projectID = data["projectID"];
            this.termNo = data["termNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarks = data["remarks"];
            this.termInstallment = data["termInstallment"];
            this.sortNo = data["sortNo"];
            this.dpCalcType = data["dpCalcType"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsTermInput {
        let result = new UpdateMsTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["termMainID"] = this.termMainID;
        data["bfAmount"] = this.bfAmount;
        data["projectID"] = this.projectID;
        data["termNo"] = this.termNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarks"] = this.remarks;
        data["termInstallment"] = this.termInstallment;
        data["sortNo"] = this.sortNo;
        data["dpCalcType"] = this.dpCalcType;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsTermInput {
    id: number;
    termMainID: number;
    bfAmount: number;
    projectID: number;
    termNo: number;
    ppjbDue: number;
    remarks: string;
    termInstallment: number;
    sortNo: number;
    dpCalcType: string;
    isActive: boolean;
}

export class UpdateMsTermPmtInput implements IUpdateMsTermPmtInput {
    id: number;
    termNo: number;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;

    constructor(data?: IUpdateMsTermPmtInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.termNo = data["termNo"];
            this.finTypeID = data["finTypeID"];
            this.finTypeCode = data["finTypeCode"];
            this.finStartDue = data["finStartDue"];
        }
    }

    static fromJS(data: any): UpdateMsTermPmtInput {
        let result = new UpdateMsTermPmtInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["termNo"] = this.termNo;
        data["finTypeID"] = this.finTypeID;
        data["finTypeCode"] = this.finTypeCode;
        data["finStartDue"] = this.finStartDue;
        return data; 
    }
}

export interface IUpdateMsTermPmtInput {
    id: number;
    termNo: number;
    finTypeID: number;
    finTypeCode: string;
    finStartDue: number;
}

export class UpdateMsTermDPInput implements IUpdateMsTermDPInput {
    id: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
    entityCode: string;
    termCode: string;
    termNo: number;
    termID: number;

    constructor(data?: IUpdateMsTermDPInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.daysDueNewKP = data["daysDueNewKP"];
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): UpdateMsTermDPInput {
        let result = new UpdateMsTermDPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["daysDueNewKP"] = this.daysDueNewKP;
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface IUpdateMsTermDPInput {
    id: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
    entityCode: string;
    termCode: string;
    termNo: number;
    termID: number;
}

export class UpdateMsTermAddDiscInput implements IUpdateMsTermAddDiscInput {
    id: number;
    entityCode: string;
    termCode: string;
    termNo: number;
    addDiscNo: string;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;

    constructor(data?: IUpdateMsTermAddDiscInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entityCode = data["entityCode"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.addDiscNo = data["addDiscNo"];
            this.discountID = data["discountID"];
            this.addDiscPct = data["addDiscPct"];
            this.addDiscAmt = data["addDiscAmt"];
        }
    }

    static fromJS(data: any): UpdateMsTermAddDiscInput {
        let result = new UpdateMsTermAddDiscInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityCode"] = this.entityCode;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["addDiscNo"] = this.addDiscNo;
        data["discountID"] = this.discountID;
        data["addDiscPct"] = this.addDiscPct;
        data["addDiscAmt"] = this.addDiscAmt;
        return data; 
    }
}

export interface IUpdateMsTermAddDiscInput {
    id: number;
    entityCode: string;
    termCode: string;
    termNo: number;
    addDiscNo: string;
    discountID: number;
    addDiscPct: number;
    addDiscAmt: number;
}

export class UpdateUniversalMsTermInput implements IUpdateUniversalMsTermInput {
    termMainID: number;
    bfAmount: number;
    remarks: string;
    projectID: number;
    termCode: string;
    setValue: DtoTermUpdate[];

    constructor(data?: IUpdateUniversalMsTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainID = data["termMainID"];
            this.bfAmount = data["bfAmount"];
            this.remarks = data["remarks"];
            this.projectID = data["projectID"];
            this.termCode = data["termCode"];
            if (data["setValue"] && data["setValue"].constructor === Array) {
                this.setValue = [];
                for (let item of data["setValue"])
                    this.setValue.push(DtoTermUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUniversalMsTermInput {
        let result = new UpdateUniversalMsTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainID"] = this.termMainID;
        data["bfAmount"] = this.bfAmount;
        data["remarks"] = this.remarks;
        data["projectID"] = this.projectID;
        data["termCode"] = this.termCode;
        if (this.setValue && this.setValue.constructor === Array) {
            data["setValue"] = [];
            for (let item of this.setValue)
                data["setValue"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateUniversalMsTermInput {
    termMainID: number;
    bfAmount: number;
    remarks: string;
    projectID: number;
    termCode: string;
    setValue: DtoTermUpdate[];
}

export class DtoTermUpdate implements IDtoTermUpdate {
    termID: number;
    termPmtID: number;
    termNo: number;
    sortNo: number;
    ppjbDue: number;
    remarks: string;
    finTypeCode: string;
    finTypeID: number;
    finStartDue: number;
    termInstallment: number;
    dpCalcType: string;
    isActive: boolean;
    dtoDP: DtoDPUpdate[];
    dtoDisc: DtoDiscUpdate[];

    constructor(data?: IDtoTermUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termPmtID = data["termPmtID"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
            this.ppjbDue = data["ppjbDue"];
            this.remarks = data["remarks"];
            this.finTypeCode = data["finTypeCode"];
            this.finTypeID = data["finTypeID"];
            this.finStartDue = data["finStartDue"];
            this.termInstallment = data["termInstallment"];
            this.dpCalcType = data["dpCalcType"];
            this.isActive = data["isActive"];
            if (data["dtoDP"] && data["dtoDP"].constructor === Array) {
                this.dtoDP = [];
                for (let item of data["dtoDP"])
                    this.dtoDP.push(DtoDPUpdate.fromJS(item));
            }
            if (data["dtoDisc"] && data["dtoDisc"].constructor === Array) {
                this.dtoDisc = [];
                for (let item of data["dtoDisc"])
                    this.dtoDisc.push(DtoDiscUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DtoTermUpdate {
        let result = new DtoTermUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termPmtID"] = this.termPmtID;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        data["ppjbDue"] = this.ppjbDue;
        data["remarks"] = this.remarks;
        data["finTypeCode"] = this.finTypeCode;
        data["finTypeID"] = this.finTypeID;
        data["finStartDue"] = this.finStartDue;
        data["termInstallment"] = this.termInstallment;
        data["dpCalcType"] = this.dpCalcType;
        data["isActive"] = this.isActive;
        if (this.dtoDP && this.dtoDP.constructor === Array) {
            data["dtoDP"] = [];
            for (let item of this.dtoDP)
                data["dtoDP"].push(item.toJSON());
        }
        if (this.dtoDisc && this.dtoDisc.constructor === Array) {
            data["dtoDisc"] = [];
            for (let item of this.dtoDisc)
                data["dtoDisc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDtoTermUpdate {
    termID: number;
    termPmtID: number;
    termNo: number;
    sortNo: number;
    ppjbDue: number;
    remarks: string;
    finTypeCode: string;
    finTypeID: number;
    finStartDue: number;
    termInstallment: number;
    dpCalcType: string;
    isActive: boolean;
    dtoDP: DtoDPUpdate[];
    dtoDisc: DtoDiscUpdate[];
}

export class DtoDPUpdate implements IDtoDPUpdate {
    termDPID: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;

    constructor(data?: IDtoDPUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termDPID = data["termDPID"];
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.daysDueNewKP = data["daysDueNewKP"];
        }
    }

    static fromJS(data: any): DtoDPUpdate {
        let result = new DtoDPUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termDPID"] = this.termDPID;
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["daysDueNewKP"] = this.daysDueNewKP;
        return data; 
    }
}

export interface IDtoDPUpdate {
    termDPID: number;
    dpNo: string;
    daysDue: number;
    dpPct: number;
    dpAmount: number;
    daysDueNewKP: number;
}

export class DtoDiscUpdate implements IDtoDiscUpdate {
    termAddDiscID: number;
    discountID: number;
    addDiscNo: string;
    addDiscPct: number;
    addDiscAmt: number;

    constructor(data?: IDtoDiscUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termAddDiscID = data["termAddDiscID"];
            this.discountID = data["discountID"];
            this.addDiscNo = data["addDiscNo"];
            this.addDiscPct = data["addDiscPct"];
            this.addDiscAmt = data["addDiscAmt"];
        }
    }

    static fromJS(data: any): DtoDiscUpdate {
        let result = new DtoDiscUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termAddDiscID"] = this.termAddDiscID;
        data["discountID"] = this.discountID;
        data["addDiscNo"] = this.addDiscNo;
        data["addDiscPct"] = this.addDiscPct;
        data["addDiscAmt"] = this.addDiscAmt;
        return data; 
    }
}

export interface IDtoDiscUpdate {
    termAddDiscID: number;
    discountID: number;
    addDiscNo: string;
    addDiscPct: number;
    addDiscAmt: number;
}

export class GetTermAddDiscByTermID implements IGetTermAddDiscByTermID {
    termID: number;
    discountID: number;
    addDiscPct: number;
    discountName: string;

    constructor(data?: IGetTermAddDiscByTermID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.discountID = data["discountID"];
            this.addDiscPct = data["addDiscPct"];
            this.discountName = data["discountName"];
        }
    }

    static fromJS(data: any): GetTermAddDiscByTermID {
        let result = new GetTermAddDiscByTermID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["discountID"] = this.discountID;
        data["addDiscPct"] = this.addDiscPct;
        data["discountName"] = this.discountName;
        return data; 
    }
}

export interface IGetTermAddDiscByTermID {
    termID: number;
    discountID: number;
    addDiscPct: number;
    discountName: string;
}

export class ListResultDtoOfGetMsTerritoryListDto implements IListResultDtoOfGetMsTerritoryListDto {
    items: GetMsTerritoryListDto[];

    constructor(data?: IListResultDtoOfGetMsTerritoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMsTerritoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetMsTerritoryListDto {
        let result = new ListResultDtoOfGetMsTerritoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetMsTerritoryListDto {
    items: GetMsTerritoryListDto[];
}

export class GetMsTerritoryListDto implements IGetMsTerritoryListDto {
    territoryID: number;
    territoryName: string;

    constructor(data?: IGetMsTerritoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.territoryID = data["territoryID"];
            this.territoryName = data["territoryName"];
        }
    }

    static fromJS(data: any): GetMsTerritoryListDto {
        let result = new GetMsTerritoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["territoryID"] = this.territoryID;
        data["territoryName"] = this.territoryName;
        return data; 
    }
}

export interface IGetMsTerritoryListDto {
    territoryID: number;
    territoryName: string;
}

export class GetCreateMsTerritoryInputDto implements IGetCreateMsTerritoryInputDto {
    territoryName: string;

    constructor(data?: IGetCreateMsTerritoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.territoryName = data["territoryName"];
        }
    }

    static fromJS(data: any): GetCreateMsTerritoryInputDto {
        let result = new GetCreateMsTerritoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["territoryName"] = this.territoryName;
        return data; 
    }
}

export interface IGetCreateMsTerritoryInputDto {
    territoryName: string;
}

export class CreateUniversalExcelInputDto implements ICreateUniversalExcelInputDto {
    projectID: number;
    categoryID: number;
    clusterID: number;
    unitStatusID: number;
    generateType: string;
    excelFile: string;
    unit: UnitDto[];

    constructor(data?: ICreateUniversalExcelInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.categoryID = data["categoryID"];
            this.clusterID = data["clusterID"];
            this.unitStatusID = data["unitStatusID"];
            this.generateType = data["generateType"];
            this.excelFile = data["excelFile"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(UnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalExcelInputDto {
        let result = new CreateUniversalExcelInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["categoryID"] = this.categoryID;
        data["clusterID"] = this.clusterID;
        data["unitStatusID"] = this.unitStatusID;
        data["generateType"] = this.generateType;
        data["excelFile"] = this.excelFile;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalExcelInputDto {
    projectID: number;
    categoryID: number;
    clusterID: number;
    unitStatusID: number;
    generateType: string;
    excelFile: string;
    unit: UnitDto[];
}

export class UnitDto implements IUnitDto {
    unitNo: string;
    unitCode: string;
    combinedUnitNo: string;
    areaCode: string;
    productCode: string;
    detailCode: string;
    facingCode: string;
    zoningCode: string;
    unitItem: UnitItemDto[];

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.combinedUnitNo = data["combinedUnitNo"];
            this.areaCode = data["areaCode"];
            this.productCode = data["productCode"];
            this.detailCode = data["detailCode"];
            this.facingCode = data["facingCode"];
            this.zoningCode = data["zoningCode"];
            if (data["unitItem"] && data["unitItem"].constructor === Array) {
                this.unitItem = [];
                for (let item of data["unitItem"])
                    this.unitItem.push(UnitItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitDto {
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["combinedUnitNo"] = this.combinedUnitNo;
        data["areaCode"] = this.areaCode;
        data["productCode"] = this.productCode;
        data["detailCode"] = this.detailCode;
        data["facingCode"] = this.facingCode;
        data["zoningCode"] = this.zoningCode;
        if (this.unitItem && this.unitItem.constructor === Array) {
            data["unitItem"] = [];
            for (let item of this.unitItem)
                data["unitItem"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitDto {
    unitNo: string;
    unitCode: string;
    combinedUnitNo: string;
    areaCode: string;
    productCode: string;
    detailCode: string;
    facingCode: string;
    zoningCode: string;
    unitItem: UnitItemDto[];
}

export class UnitItemDto implements IUnitItemDto {
    dimension: string;
    itemCode: string;
    area: number;
    jumlahKamarTidur: string;
    jumlahKamarMandi: string;

    constructor(data?: IUnitItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"];
            this.itemCode = data["itemCode"];
            this.area = data["area"];
            this.jumlahKamarTidur = data["jumlahKamarTidur"];
            this.jumlahKamarMandi = data["jumlahKamarMandi"];
        }
    }

    static fromJS(data: any): UnitItemDto {
        let result = new UnitItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["itemCode"] = this.itemCode;
        data["area"] = this.area;
        data["jumlahKamarTidur"] = this.jumlahKamarTidur;
        data["jumlahKamarMandi"] = this.jumlahKamarMandi;
        return data; 
    }
}

export interface IUnitItemDto {
    dimension: string;
    itemCode: string;
    area: number;
    jumlahKamarTidur: string;
    jumlahKamarMandi: string;
}

export class SitePlanUnitFloorAvailableManageStatusDto implements ISitePlanUnitFloorAvailableManageStatusDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    unitTypeCode: string;
    unitTypeName: string;
    floor: string;
    unitStatusCode: string;
    unitStatusName: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;

    constructor(data?: ISitePlanUnitFloorAvailableManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitTypeCode = data["unitTypeCode"];
            this.unitTypeName = data["unitTypeName"];
            this.floor = data["floor"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.diagramaticType = data["diagramaticType"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): SitePlanUnitFloorAvailableManageStatusDto {
        let result = new SitePlanUnitFloorAvailableManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitTypeCode"] = this.unitTypeCode;
        data["unitTypeName"] = this.unitTypeName;
        data["floor"] = this.floor;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["diagramaticType"] = this.diagramaticType;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface ISitePlanUnitFloorAvailableManageStatusDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    unitTypeCode: string;
    unitTypeName: string;
    floor: string;
    unitStatusCode: string;
    unitStatusName: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;
}

export class ListResultDtoOfGetListHistoryUnitStatusDto implements IListResultDtoOfGetListHistoryUnitStatusDto {
    items: GetListHistoryUnitStatusDto[];

    constructor(data?: IListResultDtoOfGetListHistoryUnitStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListHistoryUnitStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListHistoryUnitStatusDto {
        let result = new ListResultDtoOfGetListHistoryUnitStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListHistoryUnitStatusDto {
    items: GetListHistoryUnitStatusDto[];
}

export class GetListHistoryUnitStatusDto implements IGetListHistoryUnitStatusDto {
    unitID: number;
    userID: number;
    userName: string;
    changeDate: string;
    beforeStatusUnit: string;
    afterStatusUnit: string;
    newUnitStatusID: number;
    oldUnitStatusID: number;
    untilDate: string;
    remarks: string;

    constructor(data?: IGetListHistoryUnitStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.userID = data["userID"];
            this.userName = data["userName"];
            this.changeDate = data["changeDate"];
            this.beforeStatusUnit = data["beforeStatusUnit"];
            this.afterStatusUnit = data["afterStatusUnit"];
            this.newUnitStatusID = data["newUnitStatusID"];
            this.oldUnitStatusID = data["oldUnitStatusID"];
            this.untilDate = data["untilDate"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetListHistoryUnitStatusDto {
        let result = new GetListHistoryUnitStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        data["changeDate"] = this.changeDate;
        data["beforeStatusUnit"] = this.beforeStatusUnit;
        data["afterStatusUnit"] = this.afterStatusUnit;
        data["newUnitStatusID"] = this.newUnitStatusID;
        data["oldUnitStatusID"] = this.oldUnitStatusID;
        data["untilDate"] = this.untilDate;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetListHistoryUnitStatusDto {
    unitID: number;
    userID: number;
    userName: string;
    changeDate: string;
    beforeStatusUnit: string;
    afterStatusUnit: string;
    newUnitStatusID: number;
    oldUnitStatusID: number;
    untilDate: string;
    remarks: string;
}

export class ManageStatusMsUnitInput implements IManageStatusMsUnitInput {
    unitID: number;
    unitStatusID: number;
    oldUnitStatusID: number;
    userID: number;
    remarksManageStatus: string;
    untilDate: moment.Moment;

    constructor(data?: IManageStatusMsUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitStatusID = data["unitStatusID"];
            this.oldUnitStatusID = data["oldUnitStatusID"];
            this.userID = data["userID"];
            this.remarksManageStatus = data["remarksManageStatus"];
            this.untilDate = data["untilDate"] ? moment(data["untilDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ManageStatusMsUnitInput {
        let result = new ManageStatusMsUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitStatusID"] = this.unitStatusID;
        data["oldUnitStatusID"] = this.oldUnitStatusID;
        data["userID"] = this.userID;
        data["remarksManageStatus"] = this.remarksManageStatus;
        data["untilDate"] = this.untilDate ? this.untilDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IManageStatusMsUnitInput {
    unitID: number;
    unitStatusID: number;
    oldUnitStatusID: number;
    userID: number;
    remarksManageStatus: string;
    untilDate: moment.Moment;
}

export class GetUnitTaskListDto implements IGetUnitTaskListDto {
    unitTaskListID: number;
    link: string;
    creationTime: moment.Moment;
    clusterName: string;

    constructor(data?: IGetUnitTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitTaskListID = data["unitTaskListID"];
            this.link = data["link"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetUnitTaskListDto {
        let result = new GetUnitTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitTaskListID"] = this.unitTaskListID;
        data["link"] = this.link;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetUnitTaskListDto {
    unitTaskListID: number;
    link: string;
    creationTime: moment.Moment;
    clusterName: string;
}

export class ListResultDtoOfGetProjectDropdownWithCategoryDto implements IListResultDtoOfGetProjectDropdownWithCategoryDto {
    items: GetProjectDropdownWithCategoryDto[];

    constructor(data?: IListResultDtoOfGetProjectDropdownWithCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectDropdownWithCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectDropdownWithCategoryDto {
        let result = new ListResultDtoOfGetProjectDropdownWithCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectDropdownWithCategoryDto {
    items: GetProjectDropdownWithCategoryDto[];
}

export class GetProjectDropdownWithCategoryDto implements IGetProjectDropdownWithCategoryDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    diagramaticType: string;

    constructor(data?: IGetProjectDropdownWithCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.diagramaticType = data["diagramaticType"];
        }
    }

    static fromJS(data: any): GetProjectDropdownWithCategoryDto {
        let result = new GetProjectDropdownWithCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["diagramaticType"] = this.diagramaticType;
        return data; 
    }
}

export interface IGetProjectDropdownWithCategoryDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    diagramaticType: string;
}

export class ListResultDtoOfGetFacingDropdownListDto implements IListResultDtoOfGetFacingDropdownListDto {
    items: GetFacingDropdownListDto[];

    constructor(data?: IListResultDtoOfGetFacingDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFacingDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetFacingDropdownListDto {
        let result = new ListResultDtoOfGetFacingDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetFacingDropdownListDto {
    items: GetFacingDropdownListDto[];
}

export class GetFacingDropdownListDto implements IGetFacingDropdownListDto {
    facingID: number;
    facingName: string;

    constructor(data?: IGetFacingDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.facingID = data["facingID"];
            this.facingName = data["facingName"];
        }
    }

    static fromJS(data: any): GetFacingDropdownListDto {
        let result = new GetFacingDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facingID"] = this.facingID;
        data["facingName"] = this.facingName;
        return data; 
    }
}

export interface IGetFacingDropdownListDto {
    facingID: number;
    facingName: string;
}

export class ListResultDtoOfGetZoningDropdownListDto implements IListResultDtoOfGetZoningDropdownListDto {
    items: GetZoningDropdownListDto[];

    constructor(data?: IListResultDtoOfGetZoningDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetZoningDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetZoningDropdownListDto {
        let result = new ListResultDtoOfGetZoningDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetZoningDropdownListDto {
    items: GetZoningDropdownListDto[];
}

export class GetZoningDropdownListDto implements IGetZoningDropdownListDto {
    zoningID: number;
    zoningName: string;

    constructor(data?: IGetZoningDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zoningID = data["zoningID"];
            this.zoningName = data["zoningName"];
        }
    }

    static fromJS(data: any): GetZoningDropdownListDto {
        let result = new GetZoningDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoningID"] = this.zoningID;
        data["zoningName"] = this.zoningName;
        return data; 
    }
}

export interface IGetZoningDropdownListDto {
    zoningID: number;
    zoningName: string;
}

export class GetUnavailableUnitNoInputDto implements IGetUnavailableUnitNoInputDto {
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetUnavailableUnitNoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetUnavailableUnitNoInputDto {
        let result = new GetUnavailableUnitNoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetUnavailableUnitNoInputDto {
    unitCode: string;
    unitNo: string;
}

export class ListResultDtoOfGetUnavailableUnitNoListDto implements IListResultDtoOfGetUnavailableUnitNoListDto {
    items: GetUnavailableUnitNoListDto[];

    constructor(data?: IListResultDtoOfGetUnavailableUnitNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnavailableUnitNoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnavailableUnitNoListDto {
        let result = new ListResultDtoOfGetUnavailableUnitNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnavailableUnitNoListDto {
    items: GetUnavailableUnitNoListDto[];
}

export class GetUnavailableUnitNoListDto implements IGetUnavailableUnitNoListDto {
    unitNo: string;
    unitCode: string;

    constructor(data?: IGetUnavailableUnitNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
        }
    }

    static fromJS(data: any): GetUnavailableUnitNoListDto {
        let result = new GetUnavailableUnitNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        return data; 
    }
}

export interface IGetUnavailableUnitNoListDto {
    unitNo: string;
    unitCode: string;
}

export class ListResultDtoOfGetUnitByFloorListDto implements IListResultDtoOfGetUnitByFloorListDto {
    items: GetUnitByFloorListDto[];

    constructor(data?: IListResultDtoOfGetUnitByFloorListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitByFloorListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitByFloorListDto {
        let result = new ListResultDtoOfGetUnitByFloorListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitByFloorListDto {
    items: GetUnitByFloorListDto[];
}

export class GetUnitByFloorListDto implements IGetUnitByFloorListDto {
    unitNo: string;
    unitCode: string;

    constructor(data?: IGetUnitByFloorListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
        }
    }

    static fromJS(data: any): GetUnitByFloorListDto {
        let result = new GetUnitByFloorListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        return data; 
    }
}

export interface IGetUnitByFloorListDto {
    unitNo: string;
    unitCode: string;
}

export class ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto implements IListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto {
    items: GetProjectCodeByUnitCodeUnitNoListDto[];

    constructor(data?: IListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProjectCodeByUnitCodeUnitNoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto {
        let result = new ListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProjectCodeByUnitCodeUnitNoListDto {
    items: GetProjectCodeByUnitCodeUnitNoListDto[];
}

export class GetProjectCodeByUnitCodeUnitNoListDto implements IGetProjectCodeByUnitCodeUnitNoListDto {
    no: number;
    unitCode: string;
    unitNo: string;
    productCode: string;

    constructor(data?: IGetProjectCodeByUnitCodeUnitNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.productCode = data["productCode"];
        }
    }

    static fromJS(data: any): GetProjectCodeByUnitCodeUnitNoListDto {
        let result = new GetProjectCodeByUnitCodeUnitNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["productCode"] = this.productCode;
        return data; 
    }
}

export interface IGetProjectCodeByUnitCodeUnitNoListDto {
    no: number;
    unitCode: string;
    unitNo: string;
    productCode: string;
}

export class ListResultDtoOfGetUnitByProjectClusterCategoryListDto implements IListResultDtoOfGetUnitByProjectClusterCategoryListDto {
    items: GetUnitByProjectClusterCategoryListDto[];

    constructor(data?: IListResultDtoOfGetUnitByProjectClusterCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitByProjectClusterCategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitByProjectClusterCategoryListDto {
        let result = new ListResultDtoOfGetUnitByProjectClusterCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitByProjectClusterCategoryListDto {
    items: GetUnitByProjectClusterCategoryListDto[];
}

export class GetUnitByProjectClusterCategoryListDto implements IGetUnitByProjectClusterCategoryListDto {
    floor: string;
    unit: UnitStatus[];

    constructor(data?: IGetUnitByProjectClusterCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.floor = data["floor"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(UnitStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUnitByProjectClusterCategoryListDto {
        let result = new GetUnitByProjectClusterCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floor"] = this.floor;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUnitByProjectClusterCategoryListDto {
    floor: string;
    unit: UnitStatus[];
}

export class UnitStatus implements IUnitStatus {
    unitID: number;
    unitNo: string;
    unitStatusID: number;
    unitCode: string;
    unitStatusCode: string;
    unitStatusName: string;
    isCanChange: boolean;

    constructor(data?: IUnitStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.unitStatusID = data["unitStatusID"];
            this.unitCode = data["unitCode"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.isCanChange = data["isCanChange"];
        }
    }

    static fromJS(data: any): UnitStatus {
        let result = new UnitStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["unitStatusID"] = this.unitStatusID;
        data["unitCode"] = this.unitCode;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["isCanChange"] = this.isCanChange;
        return data; 
    }
}

export interface IUnitStatus {
    unitID: number;
    unitNo: string;
    unitStatusID: number;
    unitCode: string;
    unitStatusCode: string;
    unitStatusName: string;
    isCanChange: boolean;
}

export class ListResultDtoOfGetUnitCodeByProjectListDto implements IListResultDtoOfGetUnitCodeByProjectListDto {
    items: GetUnitCodeByProjectListDto[];

    constructor(data?: IListResultDtoOfGetUnitCodeByProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitCodeByProjectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitCodeByProjectListDto {
        let result = new ListResultDtoOfGetUnitCodeByProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitCodeByProjectListDto {
    items: GetUnitCodeByProjectListDto[];
}

export class GetUnitCodeByProjectListDto implements IGetUnitCodeByProjectListDto {
    unitCode: string;

    constructor(data?: IGetUnitCodeByProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
        }
    }

    static fromJS(data: any): GetUnitCodeByProjectListDto {
        let result = new GetUnitCodeByProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        return data; 
    }
}

export interface IGetUnitCodeByProjectListDto {
    unitCode: string;
}

export class ListResultDtoOfGetUnitNoByUnitCodeListDto implements IListResultDtoOfGetUnitNoByUnitCodeListDto {
    items: GetUnitNoByUnitCodeListDto[];

    constructor(data?: IListResultDtoOfGetUnitNoByUnitCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitNoByUnitCodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitNoByUnitCodeListDto {
        let result = new ListResultDtoOfGetUnitNoByUnitCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitNoByUnitCodeListDto {
    items: GetUnitNoByUnitCodeListDto[];
}

export class GetUnitNoByUnitCodeListDto implements IGetUnitNoByUnitCodeListDto {
    id: number;
    unitNo: string;

    constructor(data?: IGetUnitNoByUnitCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetUnitNoByUnitCodeListDto {
        let result = new GetUnitNoByUnitCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetUnitNoByUnitCodeListDto {
    id: number;
    unitNo: string;
}

export class ListResultDtoOfGetFloorByClusterListDto implements IListResultDtoOfGetFloorByClusterListDto {
    items: GetFloorByClusterListDto[];

    constructor(data?: IListResultDtoOfGetFloorByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFloorByClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetFloorByClusterListDto {
        let result = new ListResultDtoOfGetFloorByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetFloorByClusterListDto {
    items: GetFloorByClusterListDto[];
}

export class GetFloorByClusterListDto implements IGetFloorByClusterListDto {
    unitCodeID: number;
    floor: string;

    constructor(data?: IGetFloorByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeID = data["unitCodeID"];
            this.floor = data["floor"];
        }
    }

    static fromJS(data: any): GetFloorByClusterListDto {
        let result = new GetFloorByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeID"] = this.unitCodeID;
        data["floor"] = this.floor;
        return data; 
    }
}

export interface IGetFloorByClusterListDto {
    unitCodeID: number;
    floor: string;
}

export class GetUnitTypeByClusterListDto implements IGetUnitTypeByClusterListDto {
    detailID: number;
    detailName: string;

    constructor(data?: IGetUnitTypeByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailID = data["detailID"];
            this.detailName = data["detailName"];
        }
    }

    static fromJS(data: any): GetUnitTypeByClusterListDto {
        let result = new GetUnitTypeByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailID"] = this.detailID;
        data["detailName"] = this.detailName;
        return data; 
    }
}

export interface IGetUnitTypeByClusterListDto {
    detailID: number;
    detailName: string;
}

export class ListResultDtoOfGetUnitTypeByClusterListDto implements IListResultDtoOfGetUnitTypeByClusterListDto {
    items: GetUnitTypeByClusterListDto[];

    constructor(data?: IListResultDtoOfGetUnitTypeByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitTypeByClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitTypeByClusterListDto {
        let result = new ListResultDtoOfGetUnitTypeByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitTypeByClusterListDto {
    items: GetUnitTypeByClusterListDto[];
}

export class ListResultDtoOfGetUnitByClusterListDto implements IListResultDtoOfGetUnitByClusterListDto {
    items: GetUnitByClusterListDto[];

    constructor(data?: IListResultDtoOfGetUnitByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitByClusterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitByClusterListDto {
        let result = new ListResultDtoOfGetUnitByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitByClusterListDto {
    items: GetUnitByClusterListDto[];
}

export class GetUnitByClusterListDto implements IGetUnitByClusterListDto {
    unitID: number;
    unitCodeID: number;
    zoningID: number;
    facingID: number;
    unitNo: string;
    unitCode: string;
    facingName: string;

    constructor(data?: IGetUnitByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCodeID = data["unitCodeID"];
            this.zoningID = data["zoningID"];
            this.facingID = data["facingID"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.facingName = data["facingName"];
        }
    }

    static fromJS(data: any): GetUnitByClusterListDto {
        let result = new GetUnitByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCodeID"] = this.unitCodeID;
        data["zoningID"] = this.zoningID;
        data["facingID"] = this.facingID;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["facingName"] = this.facingName;
        return data; 
    }
}

export interface IGetUnitByClusterListDto {
    unitID: number;
    unitCodeID: number;
    zoningID: number;
    facingID: number;
    unitNo: string;
    unitCode: string;
    facingName: string;
}

export class ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto implements IListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto {
    items: GetUnitByProjectClusterTermCodeTermNoDto[];

    constructor(data?: IListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitByProjectClusterTermCodeTermNoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto {
        let result = new ListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitByProjectClusterTermCodeTermNoDto {
    items: GetUnitByProjectClusterTermCodeTermNoDto[];
}

export class GetUnitByProjectClusterTermCodeTermNoDto implements IGetUnitByProjectClusterTermCodeTermNoDto {
    unitNo: string;
    combinedUnitNo: string;
    unitCertCode: string;
    remarks: string;
    prevUnitNo: string;
    entityID: number;
    unitCodeID: number;
    areaID: number;
    projectID: number;
    categoryID: number;
    clusterID: number;
    productID: number;
    detailID: number;
    zoningID: number;
    facingID: number;
    unitStatusID: number;
    rentalStatusID: number;
    termMainID: number;
    tokenNo: number;

    constructor(data?: IGetUnitByProjectClusterTermCodeTermNoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.combinedUnitNo = data["combinedUnitNo"];
            this.unitCertCode = data["unitCertCode"];
            this.remarks = data["remarks"];
            this.prevUnitNo = data["prevUnitNo"];
            this.entityID = data["entityID"];
            this.unitCodeID = data["unitCodeID"];
            this.areaID = data["areaID"];
            this.projectID = data["projectID"];
            this.categoryID = data["categoryID"];
            this.clusterID = data["clusterID"];
            this.productID = data["productID"];
            this.detailID = data["detailID"];
            this.zoningID = data["zoningID"];
            this.facingID = data["facingID"];
            this.unitStatusID = data["unitStatusID"];
            this.rentalStatusID = data["rentalStatusID"];
            this.termMainID = data["termMainID"];
            this.tokenNo = data["tokenNo"];
        }
    }

    static fromJS(data: any): GetUnitByProjectClusterTermCodeTermNoDto {
        let result = new GetUnitByProjectClusterTermCodeTermNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["combinedUnitNo"] = this.combinedUnitNo;
        data["unitCertCode"] = this.unitCertCode;
        data["remarks"] = this.remarks;
        data["prevUnitNo"] = this.prevUnitNo;
        data["entityID"] = this.entityID;
        data["unitCodeID"] = this.unitCodeID;
        data["areaID"] = this.areaID;
        data["projectID"] = this.projectID;
        data["categoryID"] = this.categoryID;
        data["clusterID"] = this.clusterID;
        data["productID"] = this.productID;
        data["detailID"] = this.detailID;
        data["zoningID"] = this.zoningID;
        data["facingID"] = this.facingID;
        data["unitStatusID"] = this.unitStatusID;
        data["rentalStatusID"] = this.rentalStatusID;
        data["termMainID"] = this.termMainID;
        data["tokenNo"] = this.tokenNo;
        return data; 
    }
}

export interface IGetUnitByProjectClusterTermCodeTermNoDto {
    unitNo: string;
    combinedUnitNo: string;
    unitCertCode: string;
    remarks: string;
    prevUnitNo: string;
    entityID: number;
    unitCodeID: number;
    areaID: number;
    projectID: number;
    categoryID: number;
    clusterID: number;
    productID: number;
    detailID: number;
    zoningID: number;
    facingID: number;
    unitStatusID: number;
    rentalStatusID: number;
    termMainID: number;
    tokenNo: number;
}

export class ListResultDtoOfGetUnitDropdownListDto implements IListResultDtoOfGetUnitDropdownListDto {
    items: GetUnitDropdownListDto[];

    constructor(data?: IListResultDtoOfGetUnitDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitDropdownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitDropdownListDto {
        let result = new ListResultDtoOfGetUnitDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitDropdownListDto {
    items: GetUnitDropdownListDto[];
}

export class GetUnitDropdownListDto implements IGetUnitDropdownListDto {
    unitID: number;
    unitNo: string;

    constructor(data?: IGetUnitDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetUnitDropdownListDto {
        let result = new GetUnitDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetUnitDropdownListDto {
    unitID: number;
    unitNo: string;
}

export class GetCheckBoxDisplayedFieldResultManageUnitDto implements IGetCheckBoxDisplayedFieldResultManageUnitDto {
    displayedID: number;
    displayedName: string;

    constructor(data?: IGetCheckBoxDisplayedFieldResultManageUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayedID = data["displayedID"];
            this.displayedName = data["displayedName"];
        }
    }

    static fromJS(data: any): GetCheckBoxDisplayedFieldResultManageUnitDto {
        let result = new GetCheckBoxDisplayedFieldResultManageUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayedID"] = this.displayedID;
        data["displayedName"] = this.displayedName;
        return data; 
    }
}

export interface IGetCheckBoxDisplayedFieldResultManageUnitDto {
    displayedID: number;
    displayedName: string;
}

export class InputManageStatusListDto implements IInputManageStatusListDto {
    projectID: number[];
    clusterID: number[];
    categoryID: number[];

    constructor(data?: IInputManageStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            if (data["categoryID"] && data["categoryID"].constructor === Array) {
                this.categoryID = [];
                for (let item of data["categoryID"])
                    this.categoryID.push(item);
            }
        }
    }

    static fromJS(data: any): InputManageStatusListDto {
        let result = new InputManageStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        if (this.categoryID && this.categoryID.constructor === Array) {
            data["categoryID"] = [];
            for (let item of this.categoryID)
                data["categoryID"].push(item);
        }
        return data; 
    }
}

export interface IInputManageStatusListDto {
    projectID: number[];
    clusterID: number[];
    categoryID: number[];
}

export class GetListManageStatusDto implements IGetListManageStatusDto {
    unitcode: string;
    unitNo: string;
    status: string;
    untilDate: string;
    modifDate: string;
    pic: string;
    remarks: string;

    constructor(data?: IGetListManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitcode = data["unitcode"];
            this.unitNo = data["unitNo"];
            this.status = data["status"];
            this.untilDate = data["untilDate"];
            this.modifDate = data["modifDate"];
            this.pic = data["pic"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetListManageStatusDto {
        let result = new GetListManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitcode"] = this.unitcode;
        data["unitNo"] = this.unitNo;
        data["status"] = this.status;
        data["untilDate"] = this.untilDate;
        data["modifDate"] = this.modifDate;
        data["pic"] = this.pic;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetListManageStatusDto {
    unitcode: string;
    unitNo: string;
    status: string;
    untilDate: string;
    modifDate: string;
    pic: string;
    remarks: string;
}

export class ListResultDtoOfGetDropdownClusterManageStatusDto implements IListResultDtoOfGetDropdownClusterManageStatusDto {
    items: GetDropdownClusterManageStatusDto[];

    constructor(data?: IListResultDtoOfGetDropdownClusterManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDropdownClusterManageStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDropdownClusterManageStatusDto {
        let result = new ListResultDtoOfGetDropdownClusterManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDropdownClusterManageStatusDto {
    items: GetDropdownClusterManageStatusDto[];
}

export class GetDropdownClusterManageStatusDto implements IGetDropdownClusterManageStatusDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetDropdownClusterManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetDropdownClusterManageStatusDto {
        let result = new GetDropdownClusterManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetDropdownClusterManageStatusDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class ListResultDtoOfGetDropdownCategoryManageStatusDto implements IListResultDtoOfGetDropdownCategoryManageStatusDto {
    items: GetDropdownCategoryManageStatusDto[];

    constructor(data?: IListResultDtoOfGetDropdownCategoryManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDropdownCategoryManageStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDropdownCategoryManageStatusDto {
        let result = new ListResultDtoOfGetDropdownCategoryManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDropdownCategoryManageStatusDto {
    items: GetDropdownCategoryManageStatusDto[];
}

export class GetDropdownCategoryManageStatusDto implements IGetDropdownCategoryManageStatusDto {
    categoryID: number;
    categoryCode: string;
    categoryName: string;

    constructor(data?: IGetDropdownCategoryManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryID = data["categoryID"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): GetDropdownCategoryManageStatusDto {
        let result = new GetDropdownCategoryManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryID"] = this.categoryID;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface IGetDropdownCategoryManageStatusDto {
    categoryID: number;
    categoryCode: string;
    categoryName: string;
}

export class PrintManageStatusInputDto implements IPrintManageStatusInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataManageStatusDto;

    constructor(data?: IPrintManageStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataManageStatusDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrintManageStatusInputDto {
        let result = new PrintManageStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPrintManageStatusInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataManageStatusDto;
}

export class ListDataManageStatusDto implements IListDataManageStatusDto {
    listHeader: ListHeaderManageStatusDto[];
    listBody: ListBodyManageStatusDto[];
    project: string;
    cluster: string;
    category: string;
    printby: string;

    constructor(data?: IListDataManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderManageStatusDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyManageStatusDto.fromJS(item));
            }
            this.project = data["project"];
            this.cluster = data["cluster"];
            this.category = data["category"];
            this.printby = data["printby"];
        }
    }

    static fromJS(data: any): ListDataManageStatusDto {
        let result = new ListDataManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["project"] = this.project;
        data["cluster"] = this.cluster;
        data["category"] = this.category;
        data["printby"] = this.printby;
        return data; 
    }
}

export interface IListDataManageStatusDto {
    listHeader: ListHeaderManageStatusDto[];
    listBody: ListBodyManageStatusDto[];
    project: string;
    cluster: string;
    category: string;
    printby: string;
}

export class ListHeaderManageStatusDto implements IListHeaderManageStatusDto {
    headerID: number;
    header: string;

    constructor(data?: IListHeaderManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.header = data["header"];
        }
    }

    static fromJS(data: any): ListHeaderManageStatusDto {
        let result = new ListHeaderManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["header"] = this.header;
        return data; 
    }
}

export interface IListHeaderManageStatusDto {
    headerID: number;
    header: string;
}

export class ListBodyManageStatusDto implements IListBodyManageStatusDto {
    unitcode: string;
    unitNo: string;
    status: string;
    untilDate: string;
    modifDate: string;
    pic: string;
    remarks: string;

    constructor(data?: IListBodyManageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitcode = data["unitcode"];
            this.unitNo = data["unitNo"];
            this.status = data["status"];
            this.untilDate = data["untilDate"];
            this.modifDate = data["modifDate"];
            this.pic = data["pic"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): ListBodyManageStatusDto {
        let result = new ListBodyManageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitcode"] = this.unitcode;
        data["unitNo"] = this.unitNo;
        data["status"] = this.status;
        data["untilDate"] = this.untilDate;
        data["modifDate"] = this.modifDate;
        data["pic"] = this.pic;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IListBodyManageStatusDto {
    unitcode: string;
    unitNo: string;
    status: string;
    untilDate: string;
    modifDate: string;
    pic: string;
    remarks: string;
}

export class CreateOrUpdateMsUnitCodeInputDto implements ICreateOrUpdateMsUnitCodeInputDto {
    id: number;
    unitCode: string;
    unitName: string;
    projectID: number;
    floor: string;

    constructor(data?: ICreateOrUpdateMsUnitCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.projectID = data["projectID"];
            this.floor = data["floor"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMsUnitCodeInputDto {
        let result = new CreateOrUpdateMsUnitCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["projectID"] = this.projectID;
        data["floor"] = this.floor;
        return data; 
    }
}

export interface ICreateOrUpdateMsUnitCodeInputDto {
    id: number;
    unitCode: string;
    unitName: string;
    projectID: number;
    floor: string;
}

export class ListResultDtoOfGetAllMsUnitCodeListDto implements IListResultDtoOfGetAllMsUnitCodeListDto {
    items: GetAllMsUnitCodeListDto[];

    constructor(data?: IListResultDtoOfGetAllMsUnitCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsUnitCodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsUnitCodeListDto {
        let result = new ListResultDtoOfGetAllMsUnitCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsUnitCodeListDto {
    items: GetAllMsUnitCodeListDto[];
}

export class GetAllMsUnitCodeListDto implements IGetAllMsUnitCodeListDto {
    id: number;
    unitCode: string;
    unitName: string;
    projectID: number;
    floor: string;

    constructor(data?: IGetAllMsUnitCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.projectID = data["projectID"];
            this.floor = data["floor"];
        }
    }

    static fromJS(data: any): GetAllMsUnitCodeListDto {
        let result = new GetAllMsUnitCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["projectID"] = this.projectID;
        data["floor"] = this.floor;
        return data; 
    }
}

export interface IGetAllMsUnitCodeListDto {
    id: number;
    unitCode: string;
    unitName: string;
    projectID: number;
    floor: string;
}

export class GetUnitItemInputDto implements IGetUnitItemInputDto {
    unitID: number[];
    itemID: number[];

    constructor(data?: IGetUnitItemInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
            if (data["itemID"] && data["itemID"].constructor === Array) {
                this.itemID = [];
                for (let item of data["itemID"])
                    this.itemID.push(item);
            }
        }
    }

    static fromJS(data: any): GetUnitItemInputDto {
        let result = new GetUnitItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        if (this.itemID && this.itemID.constructor === Array) {
            data["itemID"] = [];
            for (let item of this.itemID)
                data["itemID"].push(item);
        }
        return data; 
    }
}

export interface IGetUnitItemInputDto {
    unitID: number[];
    itemID: number[];
}

export class ListResultDtoOfGetUnitItemListDto implements IListResultDtoOfGetUnitItemListDto {
    items: GetUnitItemListDto[];

    constructor(data?: IListResultDtoOfGetUnitItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitItemListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitItemListDto {
        let result = new ListResultDtoOfGetUnitItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitItemListDto {
    items: GetUnitItemListDto[];
}

export class GetUnitItemListDto implements IGetUnitItemListDto {
    unitItemID: number;
    unitID: number;
    unitNo: string;
    itemID: number;
    item: string;
    coID: number;
    coCode: string;
    coName: string;
    clusterCode: string;

    constructor(data?: IGetUnitItemListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitItemID = data["unitItemID"];
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.itemID = data["itemID"];
            this.item = data["item"];
            this.coID = data["coID"];
            this.coCode = data["coCode"];
            this.coName = data["coName"];
            this.clusterCode = data["clusterCode"];
        }
    }

    static fromJS(data: any): GetUnitItemListDto {
        let result = new GetUnitItemListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitItemID"] = this.unitItemID;
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["itemID"] = this.itemID;
        data["item"] = this.item;
        data["coID"] = this.coID;
        data["coCode"] = this.coCode;
        data["coName"] = this.coName;
        data["clusterCode"] = this.clusterCode;
        return data; 
    }
}

export interface IGetUnitItemListDto {
    unitItemID: number;
    unitID: number;
    unitNo: string;
    itemID: number;
    item: string;
    coID: number;
    coCode: string;
    coName: string;
    clusterCode: string;
}

export class UpdateCompanyMsUnitItemInputDto implements IUpdateCompanyMsUnitItemInputDto {
    unitItemId: number;
    coCode: string;

    constructor(data?: IUpdateCompanyMsUnitItemInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitItemId = data["unitItemId"];
            this.coCode = data["coCode"];
        }
    }

    static fromJS(data: any): UpdateCompanyMsUnitItemInputDto {
        let result = new UpdateCompanyMsUnitItemInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitItemId"] = this.unitItemId;
        data["coCode"] = this.coCode;
        return data; 
    }
}

export interface IUpdateCompanyMsUnitItemInputDto {
    unitItemId: number;
    coCode: string;
}

export class ListResultDtoOfGetAllMsUnitStatusListDto implements IListResultDtoOfGetAllMsUnitStatusListDto {
    items: GetAllMsUnitStatusListDto[];

    constructor(data?: IListResultDtoOfGetAllMsUnitStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsUnitStatusListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsUnitStatusListDto {
        let result = new ListResultDtoOfGetAllMsUnitStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsUnitStatusListDto {
    items: GetAllMsUnitStatusListDto[];
}

export class GetAllMsUnitStatusListDto implements IGetAllMsUnitStatusListDto {
    id: number;
    unitStatusCode: string;
    unitStatusName: string;
    isActive: boolean;

    constructor(data?: IGetAllMsUnitStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllMsUnitStatusListDto {
        let result = new GetAllMsUnitStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllMsUnitStatusListDto {
    id: number;
    unitStatusCode: string;
    unitStatusName: string;
    isActive: boolean;
}

export class GetListRolesUnitStatusResultDto implements IGetListRolesUnitStatusResultDto {
    lastModificationTime: string;
    creationTime: string;
    roleName: string;
    unitStatusBefore: string;
    unitStatusAfter: string;
    rolesID: number;

    constructor(data?: IGetListRolesUnitStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lastModificationTime = data["lastModificationTime"];
            this.creationTime = data["creationTime"];
            this.roleName = data["roleName"];
            this.unitStatusBefore = data["unitStatusBefore"];
            this.unitStatusAfter = data["unitStatusAfter"];
            this.rolesID = data["rolesID"];
        }
    }

    static fromJS(data: any): GetListRolesUnitStatusResultDto {
        let result = new GetListRolesUnitStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModificationTime"] = this.lastModificationTime;
        data["creationTime"] = this.creationTime;
        data["roleName"] = this.roleName;
        data["unitStatusBefore"] = this.unitStatusBefore;
        data["unitStatusAfter"] = this.unitStatusAfter;
        data["rolesID"] = this.rolesID;
        return data; 
    }
}

export interface IGetListRolesUnitStatusResultDto {
    lastModificationTime: string;
    creationTime: string;
    roleName: string;
    unitStatusBefore: string;
    unitStatusAfter: string;
    rolesID: number;
}

export class GetDetailRolesUnitStatusResultDto implements IGetDetailRolesUnitStatusResultDto {
    rolesID: number;
    roleName: string;
    listStatusBefore: ListStatusDto[];
    listStatusAfter: ListStatusDto[];

    constructor(data?: IGetDetailRolesUnitStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rolesID = data["rolesID"];
            this.roleName = data["roleName"];
            if (data["listStatusBefore"] && data["listStatusBefore"].constructor === Array) {
                this.listStatusBefore = [];
                for (let item of data["listStatusBefore"])
                    this.listStatusBefore.push(ListStatusDto.fromJS(item));
            }
            if (data["listStatusAfter"] && data["listStatusAfter"].constructor === Array) {
                this.listStatusAfter = [];
                for (let item of data["listStatusAfter"])
                    this.listStatusAfter.push(ListStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailRolesUnitStatusResultDto {
        let result = new GetDetailRolesUnitStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesID"] = this.rolesID;
        data["roleName"] = this.roleName;
        if (this.listStatusBefore && this.listStatusBefore.constructor === Array) {
            data["listStatusBefore"] = [];
            for (let item of this.listStatusBefore)
                data["listStatusBefore"].push(item.toJSON());
        }
        if (this.listStatusAfter && this.listStatusAfter.constructor === Array) {
            data["listStatusAfter"] = [];
            for (let item of this.listStatusAfter)
                data["listStatusAfter"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailRolesUnitStatusResultDto {
    rolesID: number;
    roleName: string;
    listStatusBefore: ListStatusDto[];
    listStatusAfter: ListStatusDto[];
}

export class ListStatusDto implements IListStatusDto {
    unitStatusID: number;
    unitStatusCode: string;
    unitStatusName: string;
    isChecked: boolean;

    constructor(data?: IListStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitStatusID = data["unitStatusID"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.isChecked = data["isChecked"];
        }
    }

    static fromJS(data: any): ListStatusDto {
        let result = new ListStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitStatusID"] = this.unitStatusID;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["isChecked"] = this.isChecked;
        return data; 
    }
}

export interface IListStatusDto {
    unitStatusID: number;
    unitStatusCode: string;
    unitStatusName: string;
    isChecked: boolean;
}

export class UpdateRolesUnitStatusInputDto implements IUpdateRolesUnitStatusInputDto {
    rolesID: number;
    unitStatusBefore: string;
    unitStatusAfter: string;

    constructor(data?: IUpdateRolesUnitStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rolesID = data["rolesID"];
            this.unitStatusBefore = data["unitStatusBefore"];
            this.unitStatusAfter = data["unitStatusAfter"];
        }
    }

    static fromJS(data: any): UpdateRolesUnitStatusInputDto {
        let result = new UpdateRolesUnitStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesID"] = this.rolesID;
        data["unitStatusBefore"] = this.unitStatusBefore;
        data["unitStatusAfter"] = this.unitStatusAfter;
        return data; 
    }
}

export interface IUpdateRolesUnitStatusInputDto {
    rolesID: number;
    unitStatusBefore: string;
    unitStatusAfter: string;
}

export class GetDiagramaticManageStatusInputDto implements IGetDiagramaticManageStatusInputDto {
    projectId: number;
    clusterId: number;
    categoryId: number;
    userId: number;
    statusID: number[];

    constructor(data?: IGetDiagramaticManageStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            this.categoryId = data["categoryId"];
            this.userId = data["userId"];
            if (data["statusID"] && data["statusID"].constructor === Array) {
                this.statusID = [];
                for (let item of data["statusID"])
                    this.statusID.push(item);
            }
        }
    }

    static fromJS(data: any): GetDiagramaticManageStatusInputDto {
        let result = new GetDiagramaticManageStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        data["categoryId"] = this.categoryId;
        data["userId"] = this.userId;
        if (this.statusID && this.statusID.constructor === Array) {
            data["statusID"] = [];
            for (let item of this.statusID)
                data["statusID"].push(item);
        }
        return data; 
    }
}

export interface IGetDiagramaticManageStatusInputDto {
    projectId: number;
    clusterId: number;
    categoryId: number;
    userId: number;
    statusID: number[];
}

export class GetDiagramaticManageStatusResultDto implements IGetDiagramaticManageStatusResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: UnitManageDto[];
    message: string;

    constructor(data?: IGetDiagramaticManageStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.floor = data["floor"];
            this.unitCodeId = data["unitCodeId"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitManageDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetDiagramaticManageStatusResultDto {
        let result = new GetDiagramaticManageStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["floor"] = this.floor;
        data["unitCodeId"] = this.unitCodeId;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetDiagramaticManageStatusResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: UnitManageDto[];
    message: string;
}

export class UnitManageDto implements IUnitManageDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusCodeBefore: string;
    unitStatusName: string;
    unitStatusNameBefore: string;
    floor: string;
    detailCode: string;
    categoryId: number;
    isUpdate: boolean;
    unitStatusId: number;
    unitStatusIdBefore: number;

    constructor(data?: IUnitManageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusCodeBefore = data["unitStatusCodeBefore"];
            this.unitStatusName = data["unitStatusName"];
            this.unitStatusNameBefore = data["unitStatusNameBefore"];
            this.floor = data["floor"];
            this.detailCode = data["detailCode"];
            this.categoryId = data["categoryId"];
            this.isUpdate = data["isUpdate"];
            this.unitStatusId = data["unitStatusId"];
            this.unitStatusIdBefore = data["unitStatusIdBefore"];
        }
    }

    static fromJS(data: any): UnitManageDto {
        let result = new UnitManageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusCodeBefore"] = this.unitStatusCodeBefore;
        data["unitStatusName"] = this.unitStatusName;
        data["unitStatusNameBefore"] = this.unitStatusNameBefore;
        data["floor"] = this.floor;
        data["detailCode"] = this.detailCode;
        data["categoryId"] = this.categoryId;
        data["isUpdate"] = this.isUpdate;
        data["unitStatusId"] = this.unitStatusId;
        data["unitStatusIdBefore"] = this.unitStatusIdBefore;
        return data; 
    }
}

export interface IUnitManageDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusCodeBefore: string;
    unitStatusName: string;
    unitStatusNameBefore: string;
    floor: string;
    detailCode: string;
    categoryId: number;
    isUpdate: boolean;
    unitStatusId: number;
    unitStatusIdBefore: number;
}

export class GetTypeManageStatusResultDto implements IGetTypeManageStatusResultDto {
    category: string;
    categoryId: number;
    typeCode: string;
    detailCode: string;
    detailName: string;
    unitNo: string;

    constructor(data?: IGetTypeManageStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.categoryId = data["categoryId"];
            this.typeCode = data["typeCode"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetTypeManageStatusResultDto {
        let result = new GetTypeManageStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["typeCode"] = this.typeCode;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetTypeManageStatusResultDto {
    category: string;
    categoryId: number;
    typeCode: string;
    detailCode: string;
    detailName: string;
    unitNo: string;
}

export class CheckUnitStatusInputDto implements ICheckUnitStatusInputDto {
    listUnits: ListUnitStatus[];
    userID: number;

    constructor(data?: ICheckUnitStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listUnits"] && data["listUnits"].constructor === Array) {
                this.listUnits = [];
                for (let item of data["listUnits"])
                    this.listUnits.push(ListUnitStatus.fromJS(item));
            }
            this.userID = data["userID"];
        }
    }

    static fromJS(data: any): CheckUnitStatusInputDto {
        let result = new CheckUnitStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listUnits && this.listUnits.constructor === Array) {
            data["listUnits"] = [];
            for (let item of this.listUnits)
                data["listUnits"].push(item.toJSON());
        }
        data["userID"] = this.userID;
        return data; 
    }
}

export interface ICheckUnitStatusInputDto {
    listUnits: ListUnitStatus[];
    userID: number;
}

export class ListUnitStatus implements IListUnitStatus {
    floor: string;
    unitCode: string;
    unitNo: string;
    unitStatusBefore: string;
    unitStatusBeforeID: number;
    unitID: number;
    untilDate: string;
    remarks: string;

    constructor(data?: IListUnitStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.floor = data["floor"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatusBefore = data["unitStatusBefore"];
            this.unitStatusBeforeID = data["unitStatusBeforeID"];
            this.unitID = data["unitID"];
            this.untilDate = data["untilDate"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): ListUnitStatus {
        let result = new ListUnitStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floor"] = this.floor;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatusBefore"] = this.unitStatusBefore;
        data["unitStatusBeforeID"] = this.unitStatusBeforeID;
        data["unitID"] = this.unitID;
        data["untilDate"] = this.untilDate;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IListUnitStatus {
    floor: string;
    unitCode: string;
    unitNo: string;
    unitStatusBefore: string;
    unitStatusBeforeID: number;
    unitID: number;
    untilDate: string;
    remarks: string;
}

export class PagedResultDtoOfGetListAllUsersResultDto implements IPagedResultDtoOfGetListAllUsersResultDto {
    totalCount: number;
    items: GetListAllUsersResultDto[];

    constructor(data?: IPagedResultDtoOfGetListAllUsersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListAllUsersResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListAllUsersResultDto {
        let result = new PagedResultDtoOfGetListAllUsersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetListAllUsersResultDto {
    totalCount: number;
    items: GetListAllUsersResultDto[];
}

export class GetListAllUsersResultDto implements IGetListAllUsersResultDto {
    userID: number;
    userName: string;
    name: string;
    lastModifTime: moment.Moment;

    constructor(data?: IGetListAllUsersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.lastModifTime = data["lastModifTime"] ? moment(data["lastModifTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListAllUsersResultDto {
        let result = new GetListAllUsersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastModifTime"] = this.lastModifTime ? this.lastModifTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetListAllUsersResultDto {
    userID: number;
    userName: string;
    name: string;
    lastModifTime: moment.Moment;
}

export class GetListUnitStatusByUserResultDto implements IGetListUnitStatusByUserResultDto {
    id: number;
    unitStatusFrom: string;
    unitStatusTo: string;

    constructor(data?: IGetListUnitStatusByUserResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitStatusFrom = data["unitStatusFrom"];
            this.unitStatusTo = data["unitStatusTo"];
        }
    }

    static fromJS(data: any): GetListUnitStatusByUserResultDto {
        let result = new GetListUnitStatusByUserResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitStatusFrom"] = this.unitStatusFrom;
        data["unitStatusTo"] = this.unitStatusTo;
        return data; 
    }
}

export interface IGetListUnitStatusByUserResultDto {
    id: number;
    unitStatusFrom: string;
    unitStatusTo: string;
}

export class CreateOrUpdateUserStatusInputDto implements ICreateOrUpdateUserStatusInputDto {
    id: number;
    unitStatusFrom: string;
    unitStatusTo: string;
    userID: number;
    userName: string;

    constructor(data?: ICreateOrUpdateUserStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.unitStatusFrom = data["unitStatusFrom"];
            this.unitStatusTo = data["unitStatusTo"];
            this.userID = data["userID"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserStatusInputDto {
        let result = new CreateOrUpdateUserStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitStatusFrom"] = this.unitStatusFrom;
        data["unitStatusTo"] = this.unitStatusTo;
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateOrUpdateUserStatusInputDto {
    id: number;
    unitStatusFrom: string;
    unitStatusTo: string;
    userID: number;
    userName: string;
}

export class ListResultDtoOfGetUnitVirtualAccount implements IListResultDtoOfGetUnitVirtualAccount {
    items: GetUnitVirtualAccount[];

    constructor(data?: IListResultDtoOfGetUnitVirtualAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnitVirtualAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetUnitVirtualAccount {
        let result = new ListResultDtoOfGetUnitVirtualAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetUnitVirtualAccount {
    items: GetUnitVirtualAccount[];
}

export class GetUnitVirtualAccount implements IGetUnitVirtualAccount {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    bankId: number;
    bankName: string;
    accName: string;

    constructor(data?: IGetUnitVirtualAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
            this.bankId = data["bankId"];
            this.bankName = data["bankName"];
            this.accName = data["accName"];
        }
    }

    static fromJS(data: any): GetUnitVirtualAccount {
        let result = new GetUnitVirtualAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["accName"] = this.accName;
        return data; 
    }
}

export interface IGetUnitVirtualAccount {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    bankId: number;
    bankName: string;
    accName: string;
}

export class DropdownBank implements IDropdownBank {
    bankId: number;
    bankName: string;
    isActive: boolean;
    bankCode: string;

    constructor(data?: IDropdownBank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankId = data["bankId"];
            this.bankName = data["bankName"];
            this.isActive = data["isActive"];
            this.bankCode = data["bankCode"];
        }
    }

    static fromJS(data: any): DropdownBank {
        let result = new DropdownBank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["isActive"] = this.isActive;
        data["bankCode"] = this.bankCode;
        return data; 
    }
}

export interface IDropdownBank {
    bankId: number;
    bankName: string;
    isActive: boolean;
    bankCode: string;
}

export class CreateMsUnitVirtualAccount implements ICreateMsUnitVirtualAccount {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    bankId: number;
    bankName: string;
    accId: number;
    accCode: string;
    accName: string;
    creationTime: moment.Moment;
    userName: string;
    excelData: ExcelData[];

    constructor(data?: ICreateMsUnitVirtualAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
            this.bankId = data["bankId"];
            this.bankName = data["bankName"];
            this.accId = data["accId"];
            this.accCode = data["accCode"];
            this.accName = data["accName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.userName = data["userName"];
            if (data["excelData"] && data["excelData"].constructor === Array) {
                this.excelData = [];
                for (let item of data["excelData"])
                    this.excelData.push(ExcelData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMsUnitVirtualAccount {
        let result = new CreateMsUnitVirtualAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["accId"] = this.accId;
        data["accCode"] = this.accCode;
        data["accName"] = this.accName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        if (this.excelData && this.excelData.constructor === Array) {
            data["excelData"] = [];
            for (let item of this.excelData)
                data["excelData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateMsUnitVirtualAccount {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    bankId: number;
    bankName: string;
    accId: number;
    accCode: string;
    accName: string;
    creationTime: moment.Moment;
    userName: string;
    excelData: ExcelData[];
}

export class ExcelData implements IExcelData {
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    virtualAccount: string;
    accCode: string;
    accName: string;

    constructor(data?: IExcelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.virtualAccount = data["virtualAccount"];
            this.accCode = data["accCode"];
            this.accName = data["accName"];
        }
    }

    static fromJS(data: any): ExcelData {
        let result = new ExcelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["virtualAccount"] = this.virtualAccount;
        data["accCode"] = this.accCode;
        data["accName"] = this.accName;
        return data; 
    }
}

export interface IExcelData {
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    virtualAccount: string;
    accCode: string;
    accName: string;
}

export class DropdownMsAccountDto implements IDropdownMsAccountDto {
    id: number;
    accCode: string;

    constructor(data?: IDropdownMsAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.accCode = data["accCode"];
        }
    }

    static fromJS(data: any): DropdownMsAccountDto {
        let result = new DropdownMsAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accCode"] = this.accCode;
        return data; 
    }
}

export interface IDropdownMsAccountDto {
    id: number;
    accCode: string;
}

export class GenerateExcel implements IGenerateExcel {
    headerId: number;
    headerName: string;

    constructor(data?: IGenerateExcel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerId = data["headerId"];
            this.headerName = data["headerName"];
        }
    }

    static fromJS(data: any): GenerateExcel {
        let result = new GenerateExcel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerId"] = this.headerId;
        data["headerName"] = this.headerName;
        return data; 
    }
}

export interface IGenerateExcel {
    headerId: number;
    headerName: string;
}

export class OutputGenerateExcel implements IOutputGenerateExcel {
    paperSizeId: number;
    orientationID: number;
    printExcelData: PrintExcelData;

    constructor(data?: IOutputGenerateExcel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeId = data["paperSizeId"];
            this.orientationID = data["orientationID"];
            this.printExcelData = data["printExcelData"] ? PrintExcelData.fromJS(data["printExcelData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OutputGenerateExcel {
        let result = new OutputGenerateExcel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeId"] = this.paperSizeId;
        data["orientationID"] = this.orientationID;
        data["printExcelData"] = this.printExcelData ? this.printExcelData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IOutputGenerateExcel {
    paperSizeId: number;
    orientationID: number;
    printExcelData: PrintExcelData;
}

export class PrintExcelData implements IPrintExcelData {
    listHeader: ListHeaderExcel[];
    listBody: ListBodyVirtualAccountDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;

    constructor(data?: IPrintExcelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderExcel.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyVirtualAccountDto.fromJS(item));
            }
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.colspanTbl = data["colspanTbl"];
            this.grandTotal = data["grandTotal"];
        }
    }

    static fromJS(data: any): PrintExcelData {
        let result = new PrintExcelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["colspanTbl"] = this.colspanTbl;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IPrintExcelData {
    listHeader: ListHeaderExcel[];
    listBody: ListBodyVirtualAccountDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;
}

export class ListHeaderExcel implements IListHeaderExcel {
    headerId: number;
    headerName: string;

    constructor(data?: IListHeaderExcel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerId = data["headerId"];
            this.headerName = data["headerName"];
        }
    }

    static fromJS(data: any): ListHeaderExcel {
        let result = new ListHeaderExcel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerId"] = this.headerId;
        data["headerName"] = this.headerName;
        return data; 
    }
}

export interface IListHeaderExcel {
    headerId: number;
    headerName: string;
}

export class ListBodyVirtualAccountDto implements IListBodyVirtualAccountDto {
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    virtualAccount: string;
    accCode: string;
    accName: string;

    constructor(data?: IListBodyVirtualAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.virtualAccount = data["virtualAccount"];
            this.accCode = data["accCode"];
            this.accName = data["accName"];
        }
    }

    static fromJS(data: any): ListBodyVirtualAccountDto {
        let result = new ListBodyVirtualAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["virtualAccount"] = this.virtualAccount;
        data["accCode"] = this.accCode;
        data["accName"] = this.accName;
        return data; 
    }
}

export interface IListBodyVirtualAccountDto {
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    virtualAccount: string;
    accCode: string;
    accName: string;
}

export class ListVirtualAcc implements IListVirtualAcc {
    clusterId: number;
    clusterName: string;
    virtualAccount: string;
    unitId: number;
    unitCode: string;
    unitNo: string;
    resultCheckCluster: boolean;
    resultCheckVA: boolean;

    constructor(data?: IListVirtualAcc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
            this.virtualAccount = data["virtualAccount"];
            this.unitId = data["unitId"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.resultCheckCluster = data["resultCheckCluster"];
            this.resultCheckVA = data["resultCheckVA"];
        }
    }

    static fromJS(data: any): ListVirtualAcc {
        let result = new ListVirtualAcc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        data["virtualAccount"] = this.virtualAccount;
        data["unitId"] = this.unitId;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["resultCheckCluster"] = this.resultCheckCluster;
        data["resultCheckVA"] = this.resultCheckVA;
        return data; 
    }
}

export interface IListVirtualAcc {
    clusterId: number;
    clusterName: string;
    virtualAccount: string;
    unitId: number;
    unitCode: string;
    unitNo: string;
    resultCheckCluster: boolean;
    resultCheckVA: boolean;
}

export class CreateMsZoningInputDto implements ICreateMsZoningInputDto {
    zoningCode: string;
    zoningName: string;

    constructor(data?: ICreateMsZoningInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zoningCode = data["zoningCode"];
            this.zoningName = data["zoningName"];
        }
    }

    static fromJS(data: any): CreateMsZoningInputDto {
        let result = new CreateMsZoningInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoningCode"] = this.zoningCode;
        data["zoningName"] = this.zoningName;
        return data; 
    }
}

export interface ICreateMsZoningInputDto {
    zoningCode: string;
    zoningName: string;
}

export class ListResultDtoOfGetAllMsZoningListDto implements IListResultDtoOfGetAllMsZoningListDto {
    items: GetAllMsZoningListDto[];

    constructor(data?: IListResultDtoOfGetAllMsZoningListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllMsZoningListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllMsZoningListDto {
        let result = new ListResultDtoOfGetAllMsZoningListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAllMsZoningListDto {
    items: GetAllMsZoningListDto[];
}

export class GetAllMsZoningListDto implements IGetAllMsZoningListDto {
    zoningID: number;
    zoningCode: string;
    zoningName: string;

    constructor(data?: IGetAllMsZoningListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zoningID = data["zoningID"];
            this.zoningCode = data["zoningCode"];
            this.zoningName = data["zoningName"];
        }
    }

    static fromJS(data: any): GetAllMsZoningListDto {
        let result = new GetAllMsZoningListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoningID"] = this.zoningID;
        data["zoningCode"] = this.zoningCode;
        data["zoningName"] = this.zoningName;
        return data; 
    }
}

export interface IGetAllMsZoningListDto {
    zoningID: number;
    zoningCode: string;
    zoningName: string;
}

export class UpdateMsZoningInputDto implements IUpdateMsZoningInputDto {
    zoningID: number;
    zoningCode: string;
    zoningName: string;

    constructor(data?: IUpdateMsZoningInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.zoningID = data["zoningID"];
            this.zoningCode = data["zoningCode"];
            this.zoningName = data["zoningName"];
        }
    }

    static fromJS(data: any): UpdateMsZoningInputDto {
        let result = new UpdateMsZoningInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoningID"] = this.zoningID;
        data["zoningCode"] = this.zoningCode;
        data["zoningName"] = this.zoningName;
        return data; 
    }
}

export interface IUpdateMsZoningInputDto {
    zoningID: number;
    zoningCode: string;
    zoningName: string;
}

export class GetListProjectNameResultDto implements IGetListProjectNameResultDto {
    id: number;
    projectName: string;

    constructor(data?: IGetListProjectNameResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetListProjectNameResultDto {
        let result = new GetListProjectNameResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetListProjectNameResultDto {
    id: number;
    projectName: string;
}

export class GetListMemberCodeDto implements IGetListMemberCodeDto {
    projectID: number;
    memberCode: string;

    constructor(data?: IGetListMemberCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): GetListMemberCodeDto {
        let result = new GetListMemberCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IGetListMemberCodeDto {
    projectID: number;
    memberCode: string;
}

export class GetListTermOfPaymentResultDto implements IGetListTermOfPaymentResultDto {
    id: number;
    remarks: string;

    constructor(data?: IGetListTermOfPaymentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetListTermOfPaymentResultDto {
        let result = new GetListTermOfPaymentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetListTermOfPaymentResultDto {
    id: number;
    remarks: string;
}

export class GetListStatusOLBookingResultDto implements IGetListStatusOLBookingResultDto {
    statusID: number;
    statusName: string;

    constructor(data?: IGetListStatusOLBookingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusID = data["statusID"];
            this.statusName = data["statusName"];
        }
    }

    static fromJS(data: any): GetListStatusOLBookingResultDto {
        let result = new GetListStatusOLBookingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusID"] = this.statusID;
        data["statusName"] = this.statusName;
        return data; 
    }
}

export interface IGetListStatusOLBookingResultDto {
    statusID: number;
    statusName: string;
}

export class GetTotalExpectedCommissionDto implements IGetTotalExpectedCommissionDto {
    memberCode: string;
    totalExpectedCommission: number;

    constructor(data?: IGetTotalExpectedCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalExpectedCommission = data["totalExpectedCommission"];
        }
    }

    static fromJS(data: any): GetTotalExpectedCommissionDto {
        let result = new GetTotalExpectedCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalExpectedCommission"] = this.totalExpectedCommission;
        return data; 
    }
}

export interface IGetTotalExpectedCommissionDto {
    memberCode: string;
    totalExpectedCommission: number;
}

export class GetTotalPaidCommissionDto implements IGetTotalPaidCommissionDto {
    memberCode: string;
    totalPaidCommission: number;

    constructor(data?: IGetTotalPaidCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalPaidCommission = data["totalPaidCommission"];
        }
    }

    static fromJS(data: any): GetTotalPaidCommissionDto {
        let result = new GetTotalPaidCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalPaidCommission"] = this.totalPaidCommission;
        return data; 
    }
}

export interface IGetTotalPaidCommissionDto {
    memberCode: string;
    totalPaidCommission: number;
}

export class GetTotalProcessedCommissionDto implements IGetTotalProcessedCommissionDto {
    memberCode: string;
    processedCommission: number;

    constructor(data?: IGetTotalProcessedCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.processedCommission = data["processedCommission"];
        }
    }

    static fromJS(data: any): GetTotalProcessedCommissionDto {
        let result = new GetTotalProcessedCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["processedCommission"] = this.processedCommission;
        return data; 
    }
}

export interface IGetTotalProcessedCommissionDto {
    memberCode: string;
    processedCommission: number;
}

export class GetAllInformationResultDto implements IGetAllInformationResultDto {
    bookDate: moment.Moment;
    customerName: string;
    projectId: number;
    projectName: string;
    termId: number;
    top: string;
    statusId: number;
    status: string;
    expectedCommission: number;
    paidCommission: number;
    processedCommission: number;
    paymentProgress: number;
    lastPayment: moment.Moment;
    bookCode: string;
    psCode: string;
    bookingHeaderId: number;
    summary: string;
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor(data?: IGetAllInformationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.customerName = data["customerName"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.termId = data["termId"];
            this.top = data["top"];
            this.statusId = data["statusId"];
            this.status = data["status"];
            this.expectedCommission = data["expectedCommission"];
            this.paidCommission = data["paidCommission"];
            this.processedCommission = data["processedCommission"];
            this.paymentProgress = data["paymentProgress"];
            this.lastPayment = data["lastPayment"] ? moment(data["lastPayment"].toString()) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.bookingHeaderId = data["bookingHeaderId"];
            this.summary = data["summary"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllInformationResultDto {
        let result = new GetAllInformationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["termId"] = this.termId;
        data["top"] = this.top;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["expectedCommission"] = this.expectedCommission;
        data["paidCommission"] = this.paidCommission;
        data["processedCommission"] = this.processedCommission;
        data["paymentProgress"] = this.paymentProgress;
        data["lastPayment"] = this.lastPayment ? this.lastPayment.toISOString() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["summary"] = this.summary;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetAllInformationResultDto {
    bookDate: moment.Moment;
    customerName: string;
    projectId: number;
    projectName: string;
    termId: number;
    top: string;
    statusId: number;
    status: string;
    expectedCommission: number;
    paidCommission: number;
    processedCommission: number;
    paymentProgress: number;
    lastPayment: moment.Moment;
    bookCode: string;
    psCode: string;
    bookingHeaderId: number;
    summary: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class GetDetailCommissionDto implements IGetDetailCommissionDto {
    id: string;
    projectName: string;
    projectCode: string;
    clusterName: string;
    clusterCode: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    expectedCommision: number;
    pph: number;
    vat: number;
    total: number;

    constructor(data?: IGetDetailCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
            this.clusterName = data["clusterName"];
            this.clusterCode = data["clusterCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookCode = data["bookCode"];
            this.expectedCommision = data["expectedCommision"];
            this.pph = data["pph"];
            this.vat = data["vat"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetDetailCommissionDto {
        let result = new GetDetailCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        data["clusterName"] = this.clusterName;
        data["clusterCode"] = this.clusterCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookCode"] = this.bookCode;
        data["expectedCommision"] = this.expectedCommision;
        data["pph"] = this.pph;
        data["vat"] = this.vat;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetDetailCommissionDto {
    id: string;
    projectName: string;
    projectCode: string;
    clusterName: string;
    clusterCode: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    expectedCommision: number;
    pph: number;
    vat: number;
    total: number;
}

export class GetDetailCommissionMobileDto implements IGetDetailCommissionMobileDto {
    orderHeaderID: number;
    projectName: string;
    orderCode: string;
    transactionDate: string;
    productName: string;
    memberName: string;
    memberCode: string;
    customerName: string;
    customerCode: string;
    customerEmail: string;
    customerPhone: string;
    listUnit: GetDataArrayUnitDto[];

    constructor(data?: IGetDetailCommissionMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
            this.projectName = data["projectName"];
            this.orderCode = data["orderCode"];
            this.transactionDate = data["transactionDate"];
            this.productName = data["productName"];
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.customerName = data["customerName"];
            this.customerCode = data["customerCode"];
            this.customerEmail = data["customerEmail"];
            this.customerPhone = data["customerPhone"];
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(GetDataArrayUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailCommissionMobileDto {
        let result = new GetDetailCommissionMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        data["projectName"] = this.projectName;
        data["orderCode"] = this.orderCode;
        data["transactionDate"] = this.transactionDate;
        data["productName"] = this.productName;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["customerEmail"] = this.customerEmail;
        data["customerPhone"] = this.customerPhone;
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailCommissionMobileDto {
    orderHeaderID: number;
    projectName: string;
    orderCode: string;
    transactionDate: string;
    productName: string;
    memberName: string;
    memberCode: string;
    customerName: string;
    customerCode: string;
    customerEmail: string;
    customerPhone: string;
    listUnit: GetDataArrayUnitDto[];
}

export class GetDataArrayUnitDto implements IGetDataArrayUnitDto {
    unitID: number;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    netNetPrice: number;
    totalComm: number;
    listRequirement: GetDataRequirementDetailDto[];

    constructor(data?: IGetDataArrayUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.netNetPrice = data["netNetPrice"];
            this.totalComm = data["totalComm"];
            if (data["listRequirement"] && data["listRequirement"].constructor === Array) {
                this.listRequirement = [];
                for (let item of data["listRequirement"])
                    this.listRequirement.push(GetDataRequirementDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataArrayUnitDto {
        let result = new GetDataArrayUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["netNetPrice"] = this.netNetPrice;
        data["totalComm"] = this.totalComm;
        if (this.listRequirement && this.listRequirement.constructor === Array) {
            data["listRequirement"] = [];
            for (let item of this.listRequirement)
                data["listRequirement"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataArrayUnitDto {
    unitID: number;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    netNetPrice: number;
    totalComm: number;
    listRequirement: GetDataRequirementDetailDto[];
}

export class GetDataRequirementDetailDto implements IGetDataRequirementDetailDto {
    reqDesc: string;
    reqAmount: number;

    constructor(data?: IGetDataRequirementDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reqDesc = data["reqDesc"];
            this.reqAmount = data["reqAmount"];
        }
    }

    static fromJS(data: any): GetDataRequirementDetailDto {
        let result = new GetDataRequirementDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqDesc"] = this.reqDesc;
        data["reqAmount"] = this.reqAmount;
        return data; 
    }
}

export interface IGetDataRequirementDetailDto {
    reqDesc: string;
    reqAmount: number;
}

export class GetCommissionTransactionAppDto implements IGetCommissionTransactionAppDto {
    year: number;
    month: number;
    monthString: string;
    listTransaction: GetListTransactionDto[];

    constructor(data?: IGetCommissionTransactionAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.month = data["month"];
            this.monthString = data["monthString"];
            if (data["listTransaction"] && data["listTransaction"].constructor === Array) {
                this.listTransaction = [];
                for (let item of data["listTransaction"])
                    this.listTransaction.push(GetListTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCommissionTransactionAppDto {
        let result = new GetCommissionTransactionAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthString"] = this.monthString;
        if (this.listTransaction && this.listTransaction.constructor === Array) {
            data["listTransaction"] = [];
            for (let item of this.listTransaction)
                data["listTransaction"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCommissionTransactionAppDto {
    year: number;
    month: number;
    monthString: string;
    listTransaction: GetListTransactionDto[];
}

export class GetListTransactionDto implements IGetListTransactionDto {
    paidDate: moment.Moment;
    message: string;

    constructor(data?: IGetListTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetListTransactionDto {
        let result = new GetListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetListTransactionDto {
    paidDate: moment.Moment;
    message: string;
}

export class GetListCommissionMobileDto implements IGetListCommissionMobileDto {
    month: number;
    year: number;
    monthString: string;
    listOrderCode: ListOrderCodeDto[];

    constructor(data?: IGetListCommissionMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.year = data["year"];
            this.monthString = data["monthString"];
            if (data["listOrderCode"] && data["listOrderCode"].constructor === Array) {
                this.listOrderCode = [];
                for (let item of data["listOrderCode"])
                    this.listOrderCode.push(ListOrderCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListCommissionMobileDto {
        let result = new GetListCommissionMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["monthString"] = this.monthString;
        if (this.listOrderCode && this.listOrderCode.constructor === Array) {
            data["listOrderCode"] = [];
            for (let item of this.listOrderCode)
                data["listOrderCode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListCommissionMobileDto {
    month: number;
    year: number;
    monthString: string;
    listOrderCode: ListOrderCodeDto[];
}

export class ListOrderCodeDto implements IListOrderCodeDto {
    orderHeaderID: number;
    orderCode: string;
    amount: number;
    orderDate: moment.Moment;
    date: string;
    projectName: string;
    projectImage: string;
    psCode: string;
    customerName: string;

    constructor(data?: IListOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.amount = data["amount"];
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.date = data["date"];
            this.projectName = data["projectName"];
            this.projectImage = data["projectImage"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
        }
    }

    static fromJS(data: any): ListOrderCodeDto {
        let result = new ListOrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["amount"] = this.amount;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["date"] = this.date;
        data["projectName"] = this.projectName;
        data["projectImage"] = this.projectImage;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        return data; 
    }
}

export interface IListOrderCodeDto {
    orderHeaderID: number;
    orderCode: string;
    amount: number;
    orderDate: moment.Moment;
    date: string;
    projectName: string;
    projectImage: string;
    psCode: string;
    customerName: string;
}

export class GetTaskListMyCommissionListDto implements IGetTaskListMyCommissionListDto {
    bookCode: string;
    commPctPaid: number;
    amountComm: number;

    constructor(data?: IGetTaskListMyCommissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.commPctPaid = data["commPctPaid"];
            this.amountComm = data["amountComm"];
        }
    }

    static fromJS(data: any): GetTaskListMyCommissionListDto {
        let result = new GetTaskListMyCommissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["commPctPaid"] = this.commPctPaid;
        data["amountComm"] = this.amountComm;
        return data; 
    }
}

export interface IGetTaskListMyCommissionListDto {
    bookCode: string;
    commPctPaid: number;
    amountComm: number;
}

export class GetProsesCommissionListDto implements IGetProsesCommissionListDto {
    memberCode: string;
    memberName: string;
    email: string;
    transferType: string;
    bankCode: string;
    bankName: string;
    benefiAcc: string;
    benefiName: string;
    currency: string;
    citizenship: string;
    residentStatus: string;
    benefiAddress: string;
    cityCode: string;
    amount: string;
    message: string;
    scmCode: string;
    eligibleCommisionPaid: number;
    requestCommision: number;
    eligibleCommision: number;
    ppNo: string;

    constructor(data?: IGetProsesCommissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.email = data["email"];
            this.transferType = data["transferType"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.benefiAcc = data["benefiAcc"];
            this.benefiName = data["benefiName"];
            this.currency = data["currency"];
            this.citizenship = data["citizenship"];
            this.residentStatus = data["residentStatus"];
            this.benefiAddress = data["benefiAddress"];
            this.cityCode = data["cityCode"];
            this.amount = data["amount"];
            this.message = data["message"];
            this.scmCode = data["scmCode"];
            this.eligibleCommisionPaid = data["eligibleCommisionPaid"];
            this.requestCommision = data["requestCommision"];
            this.eligibleCommision = data["eligibleCommision"];
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): GetProsesCommissionListDto {
        let result = new GetProsesCommissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["email"] = this.email;
        data["transferType"] = this.transferType;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["benefiAcc"] = this.benefiAcc;
        data["benefiName"] = this.benefiName;
        data["currency"] = this.currency;
        data["citizenship"] = this.citizenship;
        data["residentStatus"] = this.residentStatus;
        data["benefiAddress"] = this.benefiAddress;
        data["cityCode"] = this.cityCode;
        data["amount"] = this.amount;
        data["message"] = this.message;
        data["scmCode"] = this.scmCode;
        data["eligibleCommisionPaid"] = this.eligibleCommisionPaid;
        data["requestCommision"] = this.requestCommision;
        data["eligibleCommision"] = this.eligibleCommision;
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IGetProsesCommissionListDto {
    memberCode: string;
    memberName: string;
    email: string;
    transferType: string;
    bankCode: string;
    bankName: string;
    benefiAcc: string;
    benefiName: string;
    currency: string;
    citizenship: string;
    residentStatus: string;
    benefiAddress: string;
    cityCode: string;
    amount: string;
    message: string;
    scmCode: string;
    eligibleCommisionPaid: number;
    requestCommision: number;
    eligibleCommision: number;
    ppNo: string;
}

export class CreateCommPPDetailDto implements ICreateCommPPDetailDto {
    entityCode: string;
    ppNo: string;
    projectCode: string;
    scmCode: string;
    asUplineNo: number;
    reqNo: number;
    memberCode: string;
    statusCode: string;
    memberName: string;
    accountNo: string;
    accountName: string;
    ccy: string;
    remarks: string;
    remarks2: string;
    email: string;
    transferType: string;
    bankCode: string;
    bankName: string;
    citizenship: string;
    residentStat: string;
    address: string;
    postCode: string;
    reqAmt: number;
    reqDate: moment.Moment;
    paidAmt: number;
    paidDate: moment.Moment;
    madeFrom: string;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    status: string;

    constructor(data?: ICreateCommPPDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.ppNo = data["ppNo"];
            this.projectCode = data["projectCode"];
            this.scmCode = data["scmCode"];
            this.asUplineNo = data["asUplineNo"];
            this.reqNo = data["reqNo"];
            this.memberCode = data["memberCode"];
            this.statusCode = data["statusCode"];
            this.memberName = data["memberName"];
            this.accountNo = data["accountNo"];
            this.accountName = data["accountName"];
            this.ccy = data["ccy"];
            this.remarks = data["remarks"];
            this.remarks2 = data["remarks2"];
            this.email = data["email"];
            this.transferType = data["transferType"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.citizenship = data["citizenship"];
            this.residentStat = data["residentStat"];
            this.address = data["address"];
            this.postCode = data["postCode"];
            this.reqAmt = data["reqAmt"];
            this.reqDate = data["reqDate"] ? moment(data["reqDate"].toString()) : <any>undefined;
            this.paidAmt = data["paidAmt"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.madeFrom = data["madeFrom"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.inputUN = data["inputUN"];
            this.modifTime = data["modifTime"] ? moment(data["modifTime"].toString()) : <any>undefined;
            this.modifUN = data["modifUN"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CreateCommPPDetailDto {
        let result = new CreateCommPPDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["ppNo"] = this.ppNo;
        data["projectCode"] = this.projectCode;
        data["scmCode"] = this.scmCode;
        data["asUplineNo"] = this.asUplineNo;
        data["reqNo"] = this.reqNo;
        data["memberCode"] = this.memberCode;
        data["statusCode"] = this.statusCode;
        data["memberName"] = this.memberName;
        data["accountNo"] = this.accountNo;
        data["accountName"] = this.accountName;
        data["ccy"] = this.ccy;
        data["remarks"] = this.remarks;
        data["remarks2"] = this.remarks2;
        data["email"] = this.email;
        data["transferType"] = this.transferType;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["citizenship"] = this.citizenship;
        data["residentStat"] = this.residentStat;
        data["address"] = this.address;
        data["postCode"] = this.postCode;
        data["reqAmt"] = this.reqAmt;
        data["reqDate"] = this.reqDate ? this.reqDate.toISOString() : <any>undefined;
        data["paidAmt"] = this.paidAmt;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["madeFrom"] = this.madeFrom;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["inputUN"] = this.inputUN;
        data["modifTime"] = this.modifTime ? this.modifTime.toISOString() : <any>undefined;
        data["modifUN"] = this.modifUN;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreateCommPPDetailDto {
    entityCode: string;
    ppNo: string;
    projectCode: string;
    scmCode: string;
    asUplineNo: number;
    reqNo: number;
    memberCode: string;
    statusCode: string;
    memberName: string;
    accountNo: string;
    accountName: string;
    ccy: string;
    remarks: string;
    remarks2: string;
    email: string;
    transferType: string;
    bankCode: string;
    bankName: string;
    citizenship: string;
    residentStat: string;
    address: string;
    postCode: string;
    reqAmt: number;
    reqDate: moment.Moment;
    paidAmt: number;
    paidDate: moment.Moment;
    madeFrom: string;
    inputTime: moment.Moment;
    inputUN: number;
    modifTime: moment.Moment;
    modifUN: number;
    status: string;
}

export class GetDetailMyCommissionListDto implements IGetDetailMyCommissionListDto {
    bookCode: string;
    unitNo: string;
    unitCode: string;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    sellingPrice: number;
    dataReq: ReqDetailMyComm[];

    constructor(data?: IGetDetailMyCommissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.sellingPrice = data["sellingPrice"];
            if (data["dataReq"] && data["dataReq"].constructor === Array) {
                this.dataReq = [];
                for (let item of data["dataReq"])
                    this.dataReq.push(ReqDetailMyComm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailMyCommissionListDto {
        let result = new GetDetailMyCommissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["sellingPrice"] = this.sellingPrice;
        if (this.dataReq && this.dataReq.constructor === Array) {
            data["dataReq"] = [];
            for (let item of this.dataReq)
                data["dataReq"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailMyCommissionListDto {
    bookCode: string;
    unitNo: string;
    unitCode: string;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    sellingPrice: number;
    dataReq: ReqDetailMyComm[];
}

export class ReqDetailMyComm implements IReqDetailMyComm {
    reqNo: number;
    pctComm: number;
    reqDesc: string;
    pctPaid: number;
    amountComm: number;

    constructor(data?: IReqDetailMyComm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reqNo = data["reqNo"];
            this.pctComm = data["pctComm"];
            this.reqDesc = data["reqDesc"];
            this.pctPaid = data["pctPaid"];
            this.amountComm = data["amountComm"];
        }
    }

    static fromJS(data: any): ReqDetailMyComm {
        let result = new ReqDetailMyComm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqNo"] = this.reqNo;
        data["pctComm"] = this.pctComm;
        data["reqDesc"] = this.reqDesc;
        data["pctPaid"] = this.pctPaid;
        data["amountComm"] = this.amountComm;
        return data; 
    }
}

export interface IReqDetailMyComm {
    reqNo: number;
    pctComm: number;
    reqDesc: string;
    pctPaid: number;
    amountComm: number;
}

export class GetTasklistMyCommisionListDto implements IGetTasklistMyCommisionListDto {
    dataTasklist: GetBookingListDto[];
    dataTasklistPP: GetPPCommissionListDto[];
    totalCommisionString: string;
    totalUnit: number;
    youGetPaid: string;
    totalDownline: string;
    totalCommisionDue: string;
    totalSales: string;
    totaleligibleCommPP: number;
    totalOverdueCommPP: number;
    totaleligibleCommPaidPP: number;

    constructor(data?: IGetTasklistMyCommisionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dataTasklist"] && data["dataTasklist"].constructor === Array) {
                this.dataTasklist = [];
                for (let item of data["dataTasklist"])
                    this.dataTasklist.push(GetBookingListDto.fromJS(item));
            }
            if (data["dataTasklistPP"] && data["dataTasklistPP"].constructor === Array) {
                this.dataTasklistPP = [];
                for (let item of data["dataTasklistPP"])
                    this.dataTasklistPP.push(GetPPCommissionListDto.fromJS(item));
            }
            this.totalCommisionString = data["totalCommisionString"];
            this.totalUnit = data["totalUnit"];
            this.youGetPaid = data["youGetPaid"];
            this.totalDownline = data["totalDownline"];
            this.totalCommisionDue = data["totalCommisionDue"];
            this.totalSales = data["totalSales"];
            this.totaleligibleCommPP = data["totaleligibleCommPP"];
            this.totalOverdueCommPP = data["totalOverdueCommPP"];
            this.totaleligibleCommPaidPP = data["totaleligibleCommPaidPP"];
        }
    }

    static fromJS(data: any): GetTasklistMyCommisionListDto {
        let result = new GetTasklistMyCommisionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dataTasklist && this.dataTasklist.constructor === Array) {
            data["dataTasklist"] = [];
            for (let item of this.dataTasklist)
                data["dataTasklist"].push(item.toJSON());
        }
        if (this.dataTasklistPP && this.dataTasklistPP.constructor === Array) {
            data["dataTasklistPP"] = [];
            for (let item of this.dataTasklistPP)
                data["dataTasklistPP"].push(item.toJSON());
        }
        data["totalCommisionString"] = this.totalCommisionString;
        data["totalUnit"] = this.totalUnit;
        data["youGetPaid"] = this.youGetPaid;
        data["totalDownline"] = this.totalDownline;
        data["totalCommisionDue"] = this.totalCommisionDue;
        data["totalSales"] = this.totalSales;
        data["totaleligibleCommPP"] = this.totaleligibleCommPP;
        data["totalOverdueCommPP"] = this.totalOverdueCommPP;
        data["totaleligibleCommPaidPP"] = this.totaleligibleCommPaidPP;
        return data; 
    }
}

export interface IGetTasklistMyCommisionListDto {
    dataTasklist: GetBookingListDto[];
    dataTasklistPP: GetPPCommissionListDto[];
    totalCommisionString: string;
    totalUnit: number;
    youGetPaid: string;
    totalDownline: string;
    totalCommisionDue: string;
    totalSales: string;
    totaleligibleCommPP: number;
    totalOverdueCommPP: number;
    totaleligibleCommPaidPP: number;
}

export class GetBookingListDto implements IGetBookingListDto {
    bookingHeaderID: number;
    custName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    salesName: string;
    unitPrice: number;
    unitPriceString: string;
    totalCommision: number;
    totalCommisionString: string;
    commisionPaid: number;
    commisionPaidString: string;
    commisionOutstanding: number;
    commisionOutstandingString: string;
    totalAllCommision: number;

    constructor(data?: IGetBookingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.custName = data["custName"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.memberCode = data["memberCode"];
            this.salesName = data["salesName"];
            this.unitPrice = data["unitPrice"];
            this.unitPriceString = data["unitPriceString"];
            this.totalCommision = data["totalCommision"];
            this.totalCommisionString = data["totalCommisionString"];
            this.commisionPaid = data["commisionPaid"];
            this.commisionPaidString = data["commisionPaidString"];
            this.commisionOutstanding = data["commisionOutstanding"];
            this.commisionOutstandingString = data["commisionOutstandingString"];
            this.totalAllCommision = data["totalAllCommision"];
        }
    }

    static fromJS(data: any): GetBookingListDto {
        let result = new GetBookingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["custName"] = this.custName;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["memberCode"] = this.memberCode;
        data["salesName"] = this.salesName;
        data["unitPrice"] = this.unitPrice;
        data["unitPriceString"] = this.unitPriceString;
        data["totalCommision"] = this.totalCommision;
        data["totalCommisionString"] = this.totalCommisionString;
        data["commisionPaid"] = this.commisionPaid;
        data["commisionPaidString"] = this.commisionPaidString;
        data["commisionOutstanding"] = this.commisionOutstanding;
        data["commisionOutstandingString"] = this.commisionOutstandingString;
        data["totalAllCommision"] = this.totalAllCommision;
        return data; 
    }
}

export interface IGetBookingListDto {
    bookingHeaderID: number;
    custName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    memberCode: string;
    salesName: string;
    unitPrice: number;
    unitPriceString: string;
    totalCommision: number;
    totalCommisionString: string;
    commisionPaid: number;
    commisionPaidString: string;
    commisionOutstanding: number;
    commisionOutstandingString: string;
    totalAllCommision: number;
}

export class GetPPCommissionListDto implements IGetPPCommissionListDto {
    projectCode: string;
    statusTypeName: string;
    custName: string;
    ppNo: string;
    memberCode: string;
    salesName: string;
    eligibleCommision: number;
    requestCommision: number;
    commisionOverdue: number;
    eligibleCommisionPaid: number;

    constructor(data?: IGetPPCommissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.statusTypeName = data["statusTypeName"];
            this.custName = data["custName"];
            this.ppNo = data["ppNo"];
            this.memberCode = data["memberCode"];
            this.salesName = data["salesName"];
            this.eligibleCommision = data["eligibleCommision"];
            this.requestCommision = data["requestCommision"];
            this.commisionOverdue = data["commisionOverdue"];
            this.eligibleCommisionPaid = data["eligibleCommisionPaid"];
        }
    }

    static fromJS(data: any): GetPPCommissionListDto {
        let result = new GetPPCommissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["statusTypeName"] = this.statusTypeName;
        data["custName"] = this.custName;
        data["ppNo"] = this.ppNo;
        data["memberCode"] = this.memberCode;
        data["salesName"] = this.salesName;
        data["eligibleCommision"] = this.eligibleCommision;
        data["requestCommision"] = this.requestCommision;
        data["commisionOverdue"] = this.commisionOverdue;
        data["eligibleCommisionPaid"] = this.eligibleCommisionPaid;
        return data; 
    }
}

export interface IGetPPCommissionListDto {
    projectCode: string;
    statusTypeName: string;
    custName: string;
    ppNo: string;
    memberCode: string;
    salesName: string;
    eligibleCommision: number;
    requestCommision: number;
    commisionOverdue: number;
    eligibleCommisionPaid: number;
}

export class GetDetailTaskListMyCommisionListDto implements IGetDetailTaskListMyCommisionListDto {
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    memberCode: string;
    salesName: string;
    termRemarks: string;
    unitPriceString: string;
    ammountPaidString: string;
    ammountPercentage: string;
    eligableCommisionString: string;
    eligableCommisionPercentage: string;
    eligableCommisionPaidString: string;
    commisionOverdueString: string;
    dataTotal: GetTabelCommisionListDto[];
    dataHeader: GetHeaderTableList[];
    dataBody: RequirementDto[];
    dataBookingFee: RequirementDto[];

    constructor(data?: IGetDetailTaskListMyCommisionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psCode = data["psCode"];
            this.custName = data["custName"];
            this.memberCode = data["memberCode"];
            this.salesName = data["salesName"];
            this.termRemarks = data["termRemarks"];
            this.unitPriceString = data["unitPriceString"];
            this.ammountPaidString = data["ammountPaidString"];
            this.ammountPercentage = data["ammountPercentage"];
            this.eligableCommisionString = data["eligableCommisionString"];
            this.eligableCommisionPercentage = data["eligableCommisionPercentage"];
            this.eligableCommisionPaidString = data["eligableCommisionPaidString"];
            this.commisionOverdueString = data["commisionOverdueString"];
            if (data["dataTotal"] && data["dataTotal"].constructor === Array) {
                this.dataTotal = [];
                for (let item of data["dataTotal"])
                    this.dataTotal.push(GetTabelCommisionListDto.fromJS(item));
            }
            if (data["dataHeader"] && data["dataHeader"].constructor === Array) {
                this.dataHeader = [];
                for (let item of data["dataHeader"])
                    this.dataHeader.push(GetHeaderTableList.fromJS(item));
            }
            if (data["dataBody"] && data["dataBody"].constructor === Array) {
                this.dataBody = [];
                for (let item of data["dataBody"])
                    this.dataBody.push(RequirementDto.fromJS(item));
            }
            if (data["dataBookingFee"] && data["dataBookingFee"].constructor === Array) {
                this.dataBookingFee = [];
                for (let item of data["dataBookingFee"])
                    this.dataBookingFee.push(RequirementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailTaskListMyCommisionListDto {
        let result = new GetDetailTaskListMyCommisionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psCode"] = this.psCode;
        data["custName"] = this.custName;
        data["memberCode"] = this.memberCode;
        data["salesName"] = this.salesName;
        data["termRemarks"] = this.termRemarks;
        data["unitPriceString"] = this.unitPriceString;
        data["ammountPaidString"] = this.ammountPaidString;
        data["ammountPercentage"] = this.ammountPercentage;
        data["eligableCommisionString"] = this.eligableCommisionString;
        data["eligableCommisionPercentage"] = this.eligableCommisionPercentage;
        data["eligableCommisionPaidString"] = this.eligableCommisionPaidString;
        data["commisionOverdueString"] = this.commisionOverdueString;
        if (this.dataTotal && this.dataTotal.constructor === Array) {
            data["dataTotal"] = [];
            for (let item of this.dataTotal)
                data["dataTotal"].push(item.toJSON());
        }
        if (this.dataHeader && this.dataHeader.constructor === Array) {
            data["dataHeader"] = [];
            for (let item of this.dataHeader)
                data["dataHeader"].push(item.toJSON());
        }
        if (this.dataBody && this.dataBody.constructor === Array) {
            data["dataBody"] = [];
            for (let item of this.dataBody)
                data["dataBody"].push(item.toJSON());
        }
        if (this.dataBookingFee && this.dataBookingFee.constructor === Array) {
            data["dataBookingFee"] = [];
            for (let item of this.dataBookingFee)
                data["dataBookingFee"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailTaskListMyCommisionListDto {
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    memberCode: string;
    salesName: string;
    termRemarks: string;
    unitPriceString: string;
    ammountPaidString: string;
    ammountPercentage: string;
    eligableCommisionString: string;
    eligableCommisionPercentage: string;
    eligableCommisionPaidString: string;
    commisionOverdueString: string;
    dataTotal: GetTabelCommisionListDto[];
    dataHeader: GetHeaderTableList[];
    dataBody: RequirementDto[];
    dataBookingFee: RequirementDto[];
}

export class GetTabelCommisionListDto implements IGetTabelCommisionListDto {
    memberStatus: string;
    totalByStatusString: string;
    totalCommisionString: string;
    totalCommisionPaidString: string;

    constructor(data?: IGetTabelCommisionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberStatus = data["memberStatus"];
            this.totalByStatusString = data["totalByStatusString"];
            this.totalCommisionString = data["totalCommisionString"];
            this.totalCommisionPaidString = data["totalCommisionPaidString"];
        }
    }

    static fromJS(data: any): GetTabelCommisionListDto {
        let result = new GetTabelCommisionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberStatus"] = this.memberStatus;
        data["totalByStatusString"] = this.totalByStatusString;
        data["totalCommisionString"] = this.totalCommisionString;
        data["totalCommisionPaidString"] = this.totalCommisionPaidString;
        return data; 
    }
}

export interface IGetTabelCommisionListDto {
    memberStatus: string;
    totalByStatusString: string;
    totalCommisionString: string;
    totalCommisionPaidString: string;
}

export class GetHeaderTableList implements IGetHeaderTableList {
    memberStatusCode: string;
    memberStatus: string;
    persen: string;

    constructor(data?: IGetHeaderTableList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberStatusCode = data["memberStatusCode"];
            this.memberStatus = data["memberStatus"];
            this.persen = data["persen"];
        }
    }

    static fromJS(data: any): GetHeaderTableList {
        let result = new GetHeaderTableList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberStatusCode"] = this.memberStatusCode;
        data["memberStatus"] = this.memberStatus;
        data["persen"] = this.persen;
        return data; 
    }
}

export interface IGetHeaderTableList {
    memberStatusCode: string;
    memberStatus: string;
    persen: string;
}

export class RequirementDto implements IRequirementDto {
    memberStatus: string;
    reqDesc: string;
    commisionBreakdownPercentage: string;
    commision: string;
    amount: number;
    totalByReq: string;
    commisionPaid: string;
    totalByReqDec: number;
    commisionPaidDec: number;
    amountString: string;
    isBookingFee: boolean;

    constructor(data?: IRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberStatus = data["memberStatus"];
            this.reqDesc = data["reqDesc"];
            this.commisionBreakdownPercentage = data["commisionBreakdownPercentage"];
            this.commision = data["commision"];
            this.amount = data["amount"];
            this.totalByReq = data["totalByReq"];
            this.commisionPaid = data["commisionPaid"];
            this.totalByReqDec = data["totalByReqDec"];
            this.commisionPaidDec = data["commisionPaidDec"];
            this.amountString = data["amountString"];
            this.isBookingFee = data["isBookingFee"];
        }
    }

    static fromJS(data: any): RequirementDto {
        let result = new RequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberStatus"] = this.memberStatus;
        data["reqDesc"] = this.reqDesc;
        data["commisionBreakdownPercentage"] = this.commisionBreakdownPercentage;
        data["commision"] = this.commision;
        data["amount"] = this.amount;
        data["totalByReq"] = this.totalByReq;
        data["commisionPaid"] = this.commisionPaid;
        data["totalByReqDec"] = this.totalByReqDec;
        data["commisionPaidDec"] = this.commisionPaidDec;
        data["amountString"] = this.amountString;
        data["isBookingFee"] = this.isBookingFee;
        return data; 
    }
}

export interface IRequirementDto {
    memberStatus: string;
    reqDesc: string;
    commisionBreakdownPercentage: string;
    commision: string;
    amount: number;
    totalByReq: string;
    commisionPaid: string;
    totalByReqDec: number;
    commisionPaidDec: number;
    amountString: string;
    isBookingFee: boolean;
}

export class GetChartMyCommisionListDto implements IGetChartMyCommisionListDto {
    bulan: string;
    commisionPaidString: string;
    commisionOverdueString: string;
    commisionPaid: number;
    commisionOverdue: number;

    constructor(data?: IGetChartMyCommisionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bulan = data["bulan"];
            this.commisionPaidString = data["commisionPaidString"];
            this.commisionOverdueString = data["commisionOverdueString"];
            this.commisionPaid = data["commisionPaid"];
            this.commisionOverdue = data["commisionOverdue"];
        }
    }

    static fromJS(data: any): GetChartMyCommisionListDto {
        let result = new GetChartMyCommisionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulan"] = this.bulan;
        data["commisionPaidString"] = this.commisionPaidString;
        data["commisionOverdueString"] = this.commisionOverdueString;
        data["commisionPaid"] = this.commisionPaid;
        data["commisionOverdue"] = this.commisionOverdue;
        return data; 
    }
}

export interface IGetChartMyCommisionListDto {
    bulan: string;
    commisionPaidString: string;
    commisionOverdueString: string;
    commisionPaid: number;
    commisionOverdue: number;
}

export class GetDetailTasklistMyCommisionInputDto implements IGetDetailTasklistMyCommisionInputDto {
    bookingHeaderID: number;
    bookCode: string;
    memberCode: string;
    memberCodeLogin: string;

    constructor(data?: IGetDetailTasklistMyCommisionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.memberCode = data["memberCode"];
            this.memberCodeLogin = data["memberCodeLogin"];
        }
    }

    static fromJS(data: any): GetDetailTasklistMyCommisionInputDto {
        let result = new GetDetailTasklistMyCommisionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["memberCode"] = this.memberCode;
        data["memberCodeLogin"] = this.memberCodeLogin;
        return data; 
    }
}

export interface IGetDetailTasklistMyCommisionInputDto {
    bookingHeaderID: number;
    bookCode: string;
    memberCode: string;
    memberCodeLogin: string;
}

export class GetListEventResultDto implements IGetListEventResultDto {
    eventID: number;
    eventName: string;

    constructor(data?: IGetListEventResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventID = data["eventID"];
            this.eventName = data["eventName"];
        }
    }

    static fromJS(data: any): GetListEventResultDto {
        let result = new GetListEventResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventID"] = this.eventID;
        data["eventName"] = this.eventName;
        return data; 
    }
}

export interface IGetListEventResultDto {
    eventID: number;
    eventName: string;
}

export class GetMsSalesLeadTypeDropdownResultDto implements IGetMsSalesLeadTypeDropdownResultDto {
    customerStatus: string;

    constructor(data?: IGetMsSalesLeadTypeDropdownResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerStatus = data["customerStatus"];
        }
    }

    static fromJS(data: any): GetMsSalesLeadTypeDropdownResultDto {
        let result = new GetMsSalesLeadTypeDropdownResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerStatus"] = this.customerStatus;
        return data; 
    }
}

export interface IGetMsSalesLeadTypeDropdownResultDto {
    customerStatus: string;
}

export class GetDropdownDokumentTypeDto implements IGetDropdownDokumentTypeDto {
    documentType: string;
    documentName: string;

    constructor(data?: IGetDropdownDokumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentName = data["documentName"];
        }
    }

    static fromJS(data: any): GetDropdownDokumentTypeDto {
        let result = new GetDropdownDokumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentName"] = this.documentName;
        return data; 
    }
}

export interface IGetDropdownDokumentTypeDto {
    documentType: string;
    documentName: string;
}

export class GetPriceRangeDropdownResultDto implements IGetPriceRangeDropdownResultDto {
    priceRange: string;

    constructor(data?: IGetPriceRangeDropdownResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priceRange = data["priceRange"];
        }
    }

    static fromJS(data: any): GetPriceRangeDropdownResultDto {
        let result = new GetPriceRangeDropdownResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceRange"] = this.priceRange;
        return data; 
    }
}

export interface IGetPriceRangeDropdownResultDto {
    priceRange: string;
}

export class AddPotentialCustomerDto implements IAddPotentialCustomerDto {
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    memberName: string;
    memberCode: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    listDocument: PotentialDocument[];

    constructor(data?: IAddPotentialCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.eventName = data["eventName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"];
            this.idNumber = data["idNumber"];
            this.idUpload = data["idUpload"];
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.jobAddress = data["jobAddress"];
            this.customerStatus = data["customerStatus"];
            this.jobCustomer = data["jobCustomer"];
            this.priceRange = data["priceRange"];
            this.location = data["location"];
            if (data["listDocument"] && data["listDocument"].constructor === Array) {
                this.listDocument = [];
                for (let item of data["listDocument"])
                    this.listDocument.push(PotentialDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPotentialCustomerDto {
        let result = new AddPotentialCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["eventName"] = this.eventName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate;
        data["idNumber"] = this.idNumber;
        data["idUpload"] = this.idUpload;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["jobAddress"] = this.jobAddress;
        data["customerStatus"] = this.customerStatus;
        data["jobCustomer"] = this.jobCustomer;
        data["priceRange"] = this.priceRange;
        data["location"] = this.location;
        if (this.listDocument && this.listDocument.constructor === Array) {
            data["listDocument"] = [];
            for (let item of this.listDocument)
                data["listDocument"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddPotentialCustomerDto {
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    memberName: string;
    memberCode: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    listDocument: PotentialDocument[];
}

export class PotentialDocument implements IPotentialDocument {
    documentType: string;
    documentImage: string;

    constructor(data?: IPotentialDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentImage = data["documentImage"];
        }
    }

    static fromJS(data: any): PotentialDocument {
        let result = new PotentialDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentImage"] = this.documentImage;
        return data; 
    }
}

export interface IPotentialDocument {
    documentType: string;
    documentImage: string;
}

export class UpdatePotentialCustomerInputDto implements IUpdatePotentialCustomerInputDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    memberCode: string;
    listDocument: PotentialDocument[];

    constructor(data?: IUpdatePotentialCustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustomerID = data["potentialCustomerID"];
            this.documentType = data["documentType"];
            this.eventName = data["eventName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"];
            this.idNumber = data["idNumber"];
            this.idUpload = data["idUpload"];
            this.jobAddress = data["jobAddress"];
            this.customerStatus = data["customerStatus"];
            this.jobCustomer = data["jobCustomer"];
            this.priceRange = data["priceRange"];
            this.memberCode = data["memberCode"];
            if (data["listDocument"] && data["listDocument"].constructor === Array) {
                this.listDocument = [];
                for (let item of data["listDocument"])
                    this.listDocument.push(PotentialDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePotentialCustomerInputDto {
        let result = new UpdatePotentialCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustomerID"] = this.potentialCustomerID;
        data["documentType"] = this.documentType;
        data["eventName"] = this.eventName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate;
        data["idNumber"] = this.idNumber;
        data["idUpload"] = this.idUpload;
        data["jobAddress"] = this.jobAddress;
        data["customerStatus"] = this.customerStatus;
        data["jobCustomer"] = this.jobCustomer;
        data["priceRange"] = this.priceRange;
        data["memberCode"] = this.memberCode;
        if (this.listDocument && this.listDocument.constructor === Array) {
            data["listDocument"] = [];
            for (let item of this.listDocument)
                data["listDocument"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePotentialCustomerInputDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    memberCode: string;
    listDocument: PotentialDocument[];
}

export class UpdatePotentialCustomerMobileInputDto implements IUpdatePotentialCustomerMobileInputDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    memberCode: string;

    constructor(data?: IUpdatePotentialCustomerMobileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustomerID = data["potentialCustomerID"];
            this.documentType = data["documentType"];
            this.eventName = data["eventName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"];
            this.idNumber = data["idNumber"];
            this.idUpload = data["idUpload"];
            this.jobAddress = data["jobAddress"];
            this.customerStatus = data["customerStatus"];
            this.jobCustomer = data["jobCustomer"];
            this.priceRange = data["priceRange"];
            this.location = data["location"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): UpdatePotentialCustomerMobileInputDto {
        let result = new UpdatePotentialCustomerMobileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustomerID"] = this.potentialCustomerID;
        data["documentType"] = this.documentType;
        data["eventName"] = this.eventName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate;
        data["idNumber"] = this.idNumber;
        data["idUpload"] = this.idUpload;
        data["jobAddress"] = this.jobAddress;
        data["customerStatus"] = this.customerStatus;
        data["jobCustomer"] = this.jobCustomer;
        data["priceRange"] = this.priceRange;
        data["location"] = this.location;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IUpdatePotentialCustomerMobileInputDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: string;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    memberCode: string;
}

export class GetMyCustomerListDto implements IGetMyCustomerListDto {
    memberCode: string;
    memberName: string;
    inputUn: number;
    name: string;
    psCode: string;
    birthDate: moment.Moment;
    number: string;

    constructor(data?: IGetMyCustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.inputUn = data["inputUn"];
            this.name = data["name"];
            this.psCode = data["psCode"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.number = data["number"];
        }
    }

    static fromJS(data: any): GetMyCustomerListDto {
        let result = new GetMyCustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["inputUn"] = this.inputUn;
        data["name"] = this.name;
        data["psCode"] = this.psCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["number"] = this.number;
        return data; 
    }
}

export interface IGetMyCustomerListDto {
    memberCode: string;
    memberName: string;
    inputUn: number;
    name: string;
    psCode: string;
    birthDate: moment.Moment;
    number: string;
}

export class GetPotentialCustomerListDto implements IGetPotentialCustomerListDto {
    id: number;
    inputUn: number;
    name: string;
    birthDate: moment.Moment;
    email: string;
    documentType: string;
    idNo: string;
    noTlp: string;

    constructor(data?: IGetPotentialCustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.inputUn = data["inputUn"];
            this.name = data["name"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.email = data["email"];
            this.documentType = data["documentType"];
            this.idNo = data["idNo"];
            this.noTlp = data["noTlp"];
        }
    }

    static fromJS(data: any): GetPotentialCustomerListDto {
        let result = new GetPotentialCustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inputUn"] = this.inputUn;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["documentType"] = this.documentType;
        data["idNo"] = this.idNo;
        data["noTlp"] = this.noTlp;
        return data; 
    }
}

export interface IGetPotentialCustomerListDto {
    id: number;
    inputUn: number;
    name: string;
    birthDate: moment.Moment;
    email: string;
    documentType: string;
    idNo: string;
    noTlp: string;
}

export class GetDetailPotentialCustomerResultDto implements IGetDetailPotentialCustomerResultDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    idType: string;
    listDocument: GetPotentialDocument[];

    constructor(data?: IGetDetailPotentialCustomerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.potentialCustomerID = data["potentialCustomerID"];
            this.documentType = data["documentType"];
            this.eventName = data["eventName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.idNumber = data["idNumber"];
            this.idUpload = data["idUpload"];
            this.jobAddress = data["jobAddress"];
            this.customerStatus = data["customerStatus"];
            this.jobCustomer = data["jobCustomer"];
            this.priceRange = data["priceRange"];
            this.location = data["location"];
            this.idType = data["idType"];
            if (data["listDocument"] && data["listDocument"].constructor === Array) {
                this.listDocument = [];
                for (let item of data["listDocument"])
                    this.listDocument.push(GetPotentialDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailPotentialCustomerResultDto {
        let result = new GetDetailPotentialCustomerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["potentialCustomerID"] = this.potentialCustomerID;
        data["documentType"] = this.documentType;
        data["eventName"] = this.eventName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["idUpload"] = this.idUpload;
        data["jobAddress"] = this.jobAddress;
        data["customerStatus"] = this.customerStatus;
        data["jobCustomer"] = this.jobCustomer;
        data["priceRange"] = this.priceRange;
        data["location"] = this.location;
        data["idType"] = this.idType;
        if (this.listDocument && this.listDocument.constructor === Array) {
            data["listDocument"] = [];
            for (let item of this.listDocument)
                data["listDocument"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailPotentialCustomerResultDto {
    potentialCustomerID: number;
    documentType: string;
    eventName: string;
    name: string;
    phoneNumber: string;
    email: string;
    birthDate: moment.Moment;
    idNumber: string;
    idUpload: string;
    jobAddress: string;
    customerStatus: string;
    jobCustomer: string;
    priceRange: string;
    location: string;
    idType: string;
    listDocument: GetPotentialDocument[];
}

export class GetPotentialDocument implements IGetPotentialDocument {
    documentImage: string;
    documentType: string;

    constructor(data?: IGetPotentialDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentImage = data["documentImage"];
            this.documentType = data["documentType"];
        }
    }

    static fromJS(data: any): GetPotentialDocument {
        let result = new GetPotentialDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentImage"] = this.documentImage;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IGetPotentialDocument {
    documentImage: string;
    documentType: string;
}

export class UpdateCustomerMobileInputDto implements IUpdateCustomerMobileInputDto {
    psCode: string;
    idType: string;
    coName: string;
    coAddress: string;
    coCountry: string;
    coCity: string;
    coPostCode: string;
    name: string;
    sex: string;
    birthPlace: string;
    birthDate: string;
    marCode: string;
    email: string;
    number: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    idNo: string;
    npwp: string;
    document: DocumentMobileUpload[];

    constructor(data?: IUpdateCustomerMobileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.idType = data["idType"];
            this.coName = data["coName"];
            this.coAddress = data["coAddress"];
            this.coCountry = data["coCountry"];
            this.coCity = data["coCity"];
            this.coPostCode = data["coPostCode"];
            this.name = data["name"];
            this.sex = data["sex"];
            this.birthPlace = data["birthPlace"];
            this.birthDate = data["birthDate"];
            this.marCode = data["marCode"];
            this.email = data["email"];
            this.number = data["number"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.idNo = data["idNo"];
            this.npwp = data["npwp"];
            if (data["document"] && data["document"].constructor === Array) {
                this.document = [];
                for (let item of data["document"])
                    this.document.push(DocumentMobileUpload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomerMobileInputDto {
        let result = new UpdateCustomerMobileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["idType"] = this.idType;
        data["coName"] = this.coName;
        data["coAddress"] = this.coAddress;
        data["coCountry"] = this.coCountry;
        data["coCity"] = this.coCity;
        data["coPostCode"] = this.coPostCode;
        data["name"] = this.name;
        data["sex"] = this.sex;
        data["birthPlace"] = this.birthPlace;
        data["birthDate"] = this.birthDate;
        data["marCode"] = this.marCode;
        data["email"] = this.email;
        data["number"] = this.number;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["idNo"] = this.idNo;
        data["npwp"] = this.npwp;
        if (this.document && this.document.constructor === Array) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateCustomerMobileInputDto {
    psCode: string;
    idType: string;
    coName: string;
    coAddress: string;
    coCountry: string;
    coCity: string;
    coPostCode: string;
    name: string;
    sex: string;
    birthPlace: string;
    birthDate: string;
    marCode: string;
    email: string;
    number: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    idNo: string;
    npwp: string;
    document: DocumentMobileUpload[];
}

export class DocumentMobileUpload implements IDocumentMobileUpload {
    documentType: string;
    documentBinary: string;

    constructor(data?: IDocumentMobileUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentType = data["documentType"];
            this.documentBinary = data["documentBinary"];
        }
    }

    static fromJS(data: any): DocumentMobileUpload {
        let result = new DocumentMobileUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentBinary"] = this.documentBinary;
        return data; 
    }
}

export interface IDocumentMobileUpload {
    documentType: string;
    documentBinary: string;
}

export class ResultMessageMobileDto implements IResultMessageMobileDto {
    message: string;
    result: boolean;

    constructor(data?: IResultMessageMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): ResultMessageMobileDto {
        let result = new ResultMessageMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IResultMessageMobileDto {
    message: string;
    result: boolean;
}

export class GetMyCustomerMobileListDto implements IGetMyCustomerMobileListDto {
    inputUn: number;
    name: string;
    psCode: string;
    ktpNumber: string;
    birthDate: moment.Moment;

    constructor(data?: IGetMyCustomerMobileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputUn = data["inputUn"];
            this.name = data["name"];
            this.psCode = data["psCode"];
            this.ktpNumber = data["ktpNumber"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMyCustomerMobileListDto {
        let result = new GetMyCustomerMobileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputUn"] = this.inputUn;
        data["name"] = this.name;
        data["psCode"] = this.psCode;
        data["ktpNumber"] = this.ktpNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetMyCustomerMobileListDto {
    inputUn: number;
    name: string;
    psCode: string;
    ktpNumber: string;
    birthDate: moment.Moment;
}

export class GetPotentialCustomerMobileListDto implements IGetPotentialCustomerMobileListDto {
    id: number;
    inputUn: number;
    name: string;
    birthDate: moment.Moment;
    email: string;
    memberCode: string;
    ktpNumber: string;

    constructor(data?: IGetPotentialCustomerMobileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.inputUn = data["inputUn"];
            this.name = data["name"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.email = data["email"];
            this.memberCode = data["memberCode"];
            this.ktpNumber = data["ktpNumber"];
        }
    }

    static fromJS(data: any): GetPotentialCustomerMobileListDto {
        let result = new GetPotentialCustomerMobileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inputUn"] = this.inputUn;
        data["name"] = this.name;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["memberCode"] = this.memberCode;
        data["ktpNumber"] = this.ktpNumber;
        return data; 
    }
}

export interface IGetPotentialCustomerMobileListDto {
    id: number;
    inputUn: number;
    name: string;
    birthDate: moment.Moment;
    email: string;
    memberCode: string;
    ktpNumber: string;
}

export class GetDetailMyCustomerMobileListDto implements IGetDetailMyCustomerMobileListDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    documentTypeKTP: string;
    documentBinaryKTP: string;
    documentTypeNPWP: string;
    documentBinaryNPWP: string;
    documentTypeKK: string;
    documentBinaryKK: string;
    documentTypeKTPPasangan: string;
    documentBinaryKTPPasangan: string;
    documentTypePassport: string;
    documentBinaryPassport: string;
    documentTypeAkte: string;
    documentBinaryAkte: string;
    documentTypeNPWPPerusahaan: string;
    documentBinaryNPWPPerusahaan: string;
    documentTypeKTPDireksi: string;
    documentBinaryKTPDireksi: string;
    documentTypeTDP: string;
    documentBinaryTDP: string;
    message: string;

    constructor(data?: IGetDetailMyCustomerMobileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.birthPlace = data["birthPlace"];
            this.sex = data["sex"];
            this.nationID = data["nationID"];
            this.address = data["address"];
            this.country = data["country"];
            this.province = data["province"];
            this.city = data["city"];
            this.postCode = data["postCode"];
            this.number = data["number"];
            this.email = data["email"];
            this.marCode = data["marCode"];
            this.documentTypeKTP = data["documentTypeKTP"];
            this.documentBinaryKTP = data["documentBinaryKTP"];
            this.documentTypeNPWP = data["documentTypeNPWP"];
            this.documentBinaryNPWP = data["documentBinaryNPWP"];
            this.documentTypeKK = data["documentTypeKK"];
            this.documentBinaryKK = data["documentBinaryKK"];
            this.documentTypeKTPPasangan = data["documentTypeKTPPasangan"];
            this.documentBinaryKTPPasangan = data["documentBinaryKTPPasangan"];
            this.documentTypePassport = data["documentTypePassport"];
            this.documentBinaryPassport = data["documentBinaryPassport"];
            this.documentTypeAkte = data["documentTypeAkte"];
            this.documentBinaryAkte = data["documentBinaryAkte"];
            this.documentTypeNPWPPerusahaan = data["documentTypeNPWPPerusahaan"];
            this.documentBinaryNPWPPerusahaan = data["documentBinaryNPWPPerusahaan"];
            this.documentTypeKTPDireksi = data["documentTypeKTPDireksi"];
            this.documentBinaryKTPDireksi = data["documentBinaryKTPDireksi"];
            this.documentTypeTDP = data["documentTypeTDP"];
            this.documentBinaryTDP = data["documentBinaryTDP"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetDetailMyCustomerMobileListDto {
        let result = new GetDetailMyCustomerMobileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["birthPlace"] = this.birthPlace;
        data["sex"] = this.sex;
        data["nationID"] = this.nationID;
        data["address"] = this.address;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        data["number"] = this.number;
        data["email"] = this.email;
        data["marCode"] = this.marCode;
        data["documentTypeKTP"] = this.documentTypeKTP;
        data["documentBinaryKTP"] = this.documentBinaryKTP;
        data["documentTypeNPWP"] = this.documentTypeNPWP;
        data["documentBinaryNPWP"] = this.documentBinaryNPWP;
        data["documentTypeKK"] = this.documentTypeKK;
        data["documentBinaryKK"] = this.documentBinaryKK;
        data["documentTypeKTPPasangan"] = this.documentTypeKTPPasangan;
        data["documentBinaryKTPPasangan"] = this.documentBinaryKTPPasangan;
        data["documentTypePassport"] = this.documentTypePassport;
        data["documentBinaryPassport"] = this.documentBinaryPassport;
        data["documentTypeAkte"] = this.documentTypeAkte;
        data["documentBinaryAkte"] = this.documentBinaryAkte;
        data["documentTypeNPWPPerusahaan"] = this.documentTypeNPWPPerusahaan;
        data["documentBinaryNPWPPerusahaan"] = this.documentBinaryNPWPPerusahaan;
        data["documentTypeKTPDireksi"] = this.documentTypeKTPDireksi;
        data["documentBinaryKTPDireksi"] = this.documentBinaryKTPDireksi;
        data["documentTypeTDP"] = this.documentTypeTDP;
        data["documentBinaryTDP"] = this.documentBinaryTDP;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetDetailMyCustomerMobileListDto {
    psCode: string;
    idType: string;
    idNo: string;
    name: string;
    npwp: string;
    birthDate: moment.Moment;
    birthPlace: string;
    sex: string;
    nationID: string;
    address: string;
    country: string;
    province: string;
    city: string;
    postCode: string;
    number: string;
    email: string;
    marCode: string;
    documentTypeKTP: string;
    documentBinaryKTP: string;
    documentTypeNPWP: string;
    documentBinaryNPWP: string;
    documentTypeKK: string;
    documentBinaryKK: string;
    documentTypeKTPPasangan: string;
    documentBinaryKTPPasangan: string;
    documentTypePassport: string;
    documentBinaryPassport: string;
    documentTypeAkte: string;
    documentBinaryAkte: string;
    documentTypeNPWPPerusahaan: string;
    documentBinaryNPWPPerusahaan: string;
    documentTypeKTPDireksi: string;
    documentBinaryKTPDireksi: string;
    documentTypeTDP: string;
    documentBinaryTDP: string;
    message: string;
}

export class GetDetailPotentialCustomerListDto implements IGetDetailPotentialCustomerListDto {
    birthDate: moment.Moment;
    email: string;
    memberCode: string;
    memberName: string;
    name: string;
    phoneNumber: string;

    constructor(data?: IGetDetailPotentialCustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.email = data["email"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.name = data["name"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): GetDetailPotentialCustomerListDto {
        let result = new GetDetailPotentialCustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IGetDetailPotentialCustomerListDto {
    birthDate: moment.Moment;
    email: string;
    memberCode: string;
    memberName: string;
    name: string;
    phoneNumber: string;
}

export class GetDropdownTimePeriodResultDto implements IGetDropdownTimePeriodResultDto {
    timePeriod: string;
    timePeriodID: number;

    constructor(data?: IGetDropdownTimePeriodResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timePeriod = data["timePeriod"];
            this.timePeriodID = data["timePeriodID"];
        }
    }

    static fromJS(data: any): GetDropdownTimePeriodResultDto {
        let result = new GetDropdownTimePeriodResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timePeriod"] = this.timePeriod;
        data["timePeriodID"] = this.timePeriodID;
        return data; 
    }
}

export interface IGetDropdownTimePeriodResultDto {
    timePeriod: string;
    timePeriodID: number;
}

export class GetMyProductDto implements IGetMyProductDto {
    scmCode: string;
    listMyProduct: ListMyProductDto[];

    constructor(data?: IGetMyProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scmCode = data["scmCode"];
            if (data["listMyProduct"] && data["listMyProduct"].constructor === Array) {
                this.listMyProduct = [];
                for (let item of data["listMyProduct"])
                    this.listMyProduct.push(ListMyProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyProductDto {
        let result = new GetMyProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scmCode"] = this.scmCode;
        if (this.listMyProduct && this.listMyProduct.constructor === Array) {
            data["listMyProduct"] = [];
            for (let item of this.listMyProduct)
                data["listMyProduct"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMyProductDto {
    scmCode: string;
    listMyProduct: ListMyProductDto[];
}

export class ListMyProductDto implements IListMyProductDto {
    projectName: string;
    memberCode: string;

    constructor(data?: IListMyProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): ListMyProductDto {
        let result = new ListMyProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IListMyProductDto {
    projectName: string;
    memberCode: string;
}

export class GetParentListDto implements IGetParentListDto {
    parentMemberCode: string;
    memberName: string;
    email: string;
    phone: string;

    constructor(data?: IGetParentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentMemberCode = data["parentMemberCode"];
            this.memberName = data["memberName"];
            this.email = data["email"];
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): GetParentListDto {
        let result = new GetParentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentMemberCode"] = this.parentMemberCode;
        data["memberName"] = this.memberName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface IGetParentListDto {
    parentMemberCode: string;
    memberName: string;
    email: string;
    phone: string;
}

export class GetChildListDto implements IGetChildListDto {
    memberCode: string;
    memberName: string;
    email: string;
    phone: string;

    constructor(data?: IGetChildListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.email = data["email"];
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): GetChildListDto {
        let result = new GetChildListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface IGetChildListDto {
    memberCode: string;
    memberName: string;
    email: string;
    phone: string;
}

export class GetParentAndChildListDto implements IGetParentAndChildListDto {
    memberCode: string;
    memberName: string;
    statusName: string;
    parentList: ListParent[];
    childList: ListChild[];

    constructor(data?: IGetParentAndChildListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.statusName = data["statusName"];
            if (data["parentList"] && data["parentList"].constructor === Array) {
                this.parentList = [];
                for (let item of data["parentList"])
                    this.parentList.push(ListParent.fromJS(item));
            }
            if (data["childList"] && data["childList"].constructor === Array) {
                this.childList = [];
                for (let item of data["childList"])
                    this.childList.push(ListChild.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetParentAndChildListDto {
        let result = new GetParentAndChildListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["statusName"] = this.statusName;
        if (this.parentList && this.parentList.constructor === Array) {
            data["parentList"] = [];
            for (let item of this.parentList)
                data["parentList"].push(item.toJSON());
        }
        if (this.childList && this.childList.constructor === Array) {
            data["childList"] = [];
            for (let item of this.childList)
                data["childList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetParentAndChildListDto {
    memberCode: string;
    memberName: string;
    statusName: string;
    parentList: ListParent[];
    childList: ListChild[];
}

export class ListParent implements IListParent {
    parentMemberCode: string;
    parentName: string;
    parentEmail: string;
    parentPhone: string;
    psCode: string;
    statusName: string;

    constructor(data?: IListParent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentMemberCode = data["parentMemberCode"];
            this.parentName = data["parentName"];
            this.parentEmail = data["parentEmail"];
            this.parentPhone = data["parentPhone"];
            this.psCode = data["psCode"];
            this.statusName = data["statusName"];
        }
    }

    static fromJS(data: any): ListParent {
        let result = new ListParent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentMemberCode"] = this.parentMemberCode;
        data["parentName"] = this.parentName;
        data["parentEmail"] = this.parentEmail;
        data["parentPhone"] = this.parentPhone;
        data["psCode"] = this.psCode;
        data["statusName"] = this.statusName;
        return data; 
    }
}

export interface IListParent {
    parentMemberCode: string;
    parentName: string;
    parentEmail: string;
    parentPhone: string;
    psCode: string;
    statusName: string;
}

export class ListChild implements IListChild {
    childMemberCode: string;
    childName: string;
    childEmail: string;
    childPhone: string;
    statusName: string;

    constructor(data?: IListChild) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.childMemberCode = data["childMemberCode"];
            this.childName = data["childName"];
            this.childEmail = data["childEmail"];
            this.childPhone = data["childPhone"];
            this.statusName = data["statusName"];
        }
    }

    static fromJS(data: any): ListChild {
        let result = new ListChild();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childMemberCode"] = this.childMemberCode;
        data["childName"] = this.childName;
        data["childEmail"] = this.childEmail;
        data["childPhone"] = this.childPhone;
        data["statusName"] = this.statusName;
        return data; 
    }
}

export interface IListChild {
    childMemberCode: string;
    childName: string;
    childEmail: string;
    childPhone: string;
    statusName: string;
}

export class GetMyProductMobileListDto implements IGetMyProductMobileListDto {
    projectName: string;
    scmCode: string;

    constructor(data?: IGetMyProductMobileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.scmCode = data["scmCode"];
        }
    }

    static fromJS(data: any): GetMyProductMobileListDto {
        let result = new GetMyProductMobileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["scmCode"] = this.scmCode;
        return data; 
    }
}

export interface IGetMyProductMobileListDto {
    projectName: string;
    scmCode: string;
}

export class NotarisDropdownDto implements INotarisDropdownDto {
    notarisID: number;
    notarisName: string;
    bookCodeForPicBankEmail: string;

    constructor(data?: INotarisDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisID = data["notarisID"];
            this.notarisName = data["notarisName"];
            this.bookCodeForPicBankEmail = data["bookCodeForPicBankEmail"];
        }
    }

    static fromJS(data: any): NotarisDropdownDto {
        let result = new NotarisDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisID"] = this.notarisID;
        data["notarisName"] = this.notarisName;
        data["bookCodeForPicBankEmail"] = this.bookCodeForPicBankEmail;
        return data; 
    }
}

export interface INotarisDropdownDto {
    notarisID: number;
    notarisName: string;
    bookCodeForPicBankEmail: string;
}

export class NotarisEmailDto implements INotarisEmailDto {
    notarisEmail: string;

    constructor(data?: INotarisEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisEmail = data["notarisEmail"];
        }
    }

    static fromJS(data: any): NotarisEmailDto {
        let result = new NotarisEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisEmail"] = this.notarisEmail;
        return data; 
    }
}

export interface INotarisEmailDto {
    notarisEmail: string;
}

export class NotarisPhoneDto implements INotarisPhoneDto {
    notarisPhone: string;

    constructor(data?: INotarisPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisPhone = data["notarisPhone"];
        }
    }

    static fromJS(data: any): NotarisPhoneDto {
        let result = new NotarisPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisPhone"] = this.notarisPhone;
        return data; 
    }
}

export interface INotarisPhoneDto {
    notarisPhone: string;
}

export class NotarisStaffDropdownDto implements INotarisStaffDropdownDto {
    notarisStaffID: number;
    notarisStaffName: string;

    constructor(data?: INotarisStaffDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisStaffID = data["notarisStaffID"];
            this.notarisStaffName = data["notarisStaffName"];
        }
    }

    static fromJS(data: any): NotarisStaffDropdownDto {
        let result = new NotarisStaffDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisStaffID"] = this.notarisStaffID;
        data["notarisStaffName"] = this.notarisStaffName;
        return data; 
    }
}

export interface INotarisStaffDropdownDto {
    notarisStaffID: number;
    notarisStaffName: string;
}

export class PicBankEmailDto implements IPicBankEmailDto {
    emailPicBank: string;

    constructor(data?: IPicBankEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailPicBank = data["emailPicBank"];
        }
    }

    static fromJS(data: any): PicBankEmailDto {
        let result = new PicBankEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailPicBank"] = this.emailPicBank;
        return data; 
    }
}

export interface IPicBankEmailDto {
    emailPicBank: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];
}

export class UserNotification implements IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class TenantNotification implements ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            if (data["entityId"]) {
                this.entityId = {};
                for (let key in data["entityId"]) {
                    if (data["entityId"].hasOwnProperty(key))
                        this.entityId[key] = data["entityId"][key];
                }
            }
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        if (this.entityId) {
            data["entityId"] = {};
            for (let key in this.entityId) {
                if (this.entityId.hasOwnProperty(key))
                    data["entityId"][key] = this.entityId[key];
            }
        }
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class NotificationData implements INotificationData {
    type: string;
    properties: { [key: string] : any; };

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string;
    properties: { [key: string] : any; };
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class GetDataPaymentListDto implements IGetDataPaymentListDto {
    projectID: number;
    accountID: number;
    accountNo: string;
    companyAddress: string;
    email: string;
    transNo: string;
    unitCode: string;
    unitNo: string;
    project: string;
    cluster: string;
    custName: string;
    paymentDate: moment.Moment;
    payFor: string;
    document: any;

    constructor(data?: IGetDataPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.accountID = data["accountID"];
            this.accountNo = data["accountNo"];
            this.companyAddress = data["companyAddress"];
            this.email = data["email"];
            this.transNo = data["transNo"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.project = data["project"];
            this.cluster = data["cluster"];
            this.custName = data["custName"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.payFor = data["payFor"];
            if (data["document"]) {
                this.document = {};
                for (let key in data["document"]) {
                    if (data["document"].hasOwnProperty(key))
                        this.document[key] = data["document"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetDataPaymentListDto {
        let result = new GetDataPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["accountID"] = this.accountID;
        data["accountNo"] = this.accountNo;
        data["companyAddress"] = this.companyAddress;
        data["email"] = this.email;
        data["transNo"] = this.transNo;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["project"] = this.project;
        data["cluster"] = this.cluster;
        data["custName"] = this.custName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["payFor"] = this.payFor;
        if (this.document) {
            data["document"] = {};
            for (let key in this.document) {
                if (this.document.hasOwnProperty(key))
                    data["document"][key] = this.document[key];
            }
        }
        return data; 
    }
}

export interface IGetDataPaymentListDto {
    projectID: number;
    accountID: number;
    accountNo: string;
    companyAddress: string;
    email: string;
    transNo: string;
    unitCode: string;
    unitNo: string;
    project: string;
    cluster: string;
    custName: string;
    paymentDate: moment.Moment;
    payFor: string;
    document: any;
}

export class SearchPdfORInputDto implements ISearchPdfORInputDto {
    transNo: string;
    unitCode: string;
    unitNo: string;
    fileName: string;
    listPath: string[];
    listTransNo: string[];
    flag: number;

    constructor(data?: ISearchPdfORInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transNo = data["transNo"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.fileName = data["fileName"];
            if (data["listPath"] && data["listPath"].constructor === Array) {
                this.listPath = [];
                for (let item of data["listPath"])
                    this.listPath.push(item);
            }
            if (data["listTransNo"] && data["listTransNo"].constructor === Array) {
                this.listTransNo = [];
                for (let item of data["listTransNo"])
                    this.listTransNo.push(item);
            }
            this.flag = data["flag"];
        }
    }

    static fromJS(data: any): SearchPdfORInputDto {
        let result = new SearchPdfORInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transNo"] = this.transNo;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["fileName"] = this.fileName;
        if (this.listPath && this.listPath.constructor === Array) {
            data["listPath"] = [];
            for (let item of this.listPath)
                data["listPath"].push(item);
        }
        if (this.listTransNo && this.listTransNo.constructor === Array) {
            data["listTransNo"] = [];
            for (let item of this.listTransNo)
                data["listTransNo"].push(item);
        }
        data["flag"] = this.flag;
        return data; 
    }
}

export interface ISearchPdfORInputDto {
    transNo: string;
    unitCode: string;
    unitNo: string;
    fileName: string;
    listPath: string[];
    listTransNo: string[];
    flag: number;
}

export class GetReportORList implements IGetReportORList {
    unitCode: string;
    unitNo: string;
    custName: string;
    transNo: string;
    amount: string;
    status: number;
    message: string;

    constructor(data?: IGetReportORList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.custName = data["custName"];
            this.transNo = data["transNo"];
            this.amount = data["amount"];
            this.status = data["status"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetReportORList {
        let result = new GetReportORList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["custName"] = this.custName;
        data["transNo"] = this.transNo;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetReportORList {
    unitCode: string;
    unitNo: string;
    custName: string;
    transNo: string;
    amount: string;
    status: number;
    message: string;
}

export class GetDataGeneratePDFORManualListDto implements IGetDataGeneratePDFORManualListDto {
    transNo: string;
    controlNo: string;
    bookingHeaderID: number;
    paymentDate: moment.Moment;
    accountID: number;
    projectID: number;
    payForID: number;
    unitNo: string;
    unitCode: string;
    psCode: string;
    clusterCode: string;
    clearDate: moment.Moment;
    creatorUserID: number;
    totalNET: number;
    totalVAT: number;
    custName: string;
    email: string;
    total: GetDataAmountPaymentListDto;

    constructor(data?: IGetDataGeneratePDFORManualListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transNo = data["transNo"];
            this.controlNo = data["controlNo"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.accountID = data["accountID"];
            this.projectID = data["projectID"];
            this.payForID = data["payForID"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            this.clusterCode = data["clusterCode"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.creatorUserID = data["creatorUserID"];
            this.totalNET = data["totalNET"];
            this.totalVAT = data["totalVAT"];
            this.custName = data["custName"];
            this.email = data["email"];
            this.total = data["total"] ? GetDataAmountPaymentListDto.fromJS(data["total"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataGeneratePDFORManualListDto {
        let result = new GetDataGeneratePDFORManualListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transNo"] = this.transNo;
        data["controlNo"] = this.controlNo;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["accountID"] = this.accountID;
        data["projectID"] = this.projectID;
        data["payForID"] = this.payForID;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        data["clusterCode"] = this.clusterCode;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["creatorUserID"] = this.creatorUserID;
        data["totalNET"] = this.totalNET;
        data["totalVAT"] = this.totalVAT;
        data["custName"] = this.custName;
        data["email"] = this.email;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDataGeneratePDFORManualListDto {
    transNo: string;
    controlNo: string;
    bookingHeaderID: number;
    paymentDate: moment.Moment;
    accountID: number;
    projectID: number;
    payForID: number;
    unitNo: string;
    unitCode: string;
    psCode: string;
    clusterCode: string;
    clearDate: moment.Moment;
    creatorUserID: number;
    totalNET: number;
    totalVAT: number;
    custName: string;
    email: string;
    total: GetDataAmountPaymentListDto;
}

export class GetDataAmountPaymentListDto implements IGetDataAmountPaymentListDto {
    totalVAT: number;
    totalNET: number;
    totalAMT: number;

    constructor(data?: IGetDataAmountPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalVAT = data["totalVAT"];
            this.totalNET = data["totalNET"];
            this.totalAMT = data["totalAMT"];
        }
    }

    static fromJS(data: any): GetDataAmountPaymentListDto {
        let result = new GetDataAmountPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalVAT"] = this.totalVAT;
        data["totalNET"] = this.totalNET;
        data["totalAMT"] = this.totalAMT;
        return data; 
    }
}

export interface IGetDataAmountPaymentListDto {
    totalVAT: number;
    totalNET: number;
    totalAMT: number;
}

export class GeneratePDFORManualDto implements IGeneratePDFORManualDto {
    transNo: string;
    accountID: number;
    paymentStart: moment.Moment;
    paymentEnd: moment.Moment;
    listTransNo: string[];
    flag: number;

    constructor(data?: IGeneratePDFORManualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transNo = data["transNo"];
            this.accountID = data["accountID"];
            this.paymentStart = data["paymentStart"] ? moment(data["paymentStart"].toString()) : <any>undefined;
            this.paymentEnd = data["paymentEnd"] ? moment(data["paymentEnd"].toString()) : <any>undefined;
            if (data["listTransNo"] && data["listTransNo"].constructor === Array) {
                this.listTransNo = [];
                for (let item of data["listTransNo"])
                    this.listTransNo.push(item);
            }
            this.flag = data["flag"];
        }
    }

    static fromJS(data: any): GeneratePDFORManualDto {
        let result = new GeneratePDFORManualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transNo"] = this.transNo;
        data["accountID"] = this.accountID;
        data["paymentStart"] = this.paymentStart ? this.paymentStart.toISOString() : <any>undefined;
        data["paymentEnd"] = this.paymentEnd ? this.paymentEnd.toISOString() : <any>undefined;
        if (this.listTransNo && this.listTransNo.constructor === Array) {
            data["listTransNo"] = [];
            for (let item of this.listTransNo)
                data["listTransNo"].push(item);
        }
        data["flag"] = this.flag;
        return data; 
    }
}

export interface IGeneratePDFORManualDto {
    transNo: string;
    accountID: number;
    paymentStart: moment.Moment;
    paymentEnd: moment.Moment;
    listTransNo: string[];
    flag: number;
}

export class GetDataPrintORByTransNoListDto implements IGetDataPrintORByTransNoListDto {
    paymentHeaderID: number;
    accountID: number;
    accountCode: string;
    accountName: string;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    payForID: number;
    payFor: string;
    project: GetProjectByAccountListDto;
    listProject: GetProjectByAccountListDto[];
    ketPaymentHeader: string;
    ppNo: string;
    listDataPayment: GetDataPayment[];

    constructor(data?: IGetDataPrintORByTransNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentHeaderID = data["paymentHeaderID"];
            this.accountID = data["accountID"];
            this.accountCode = data["accountCode"];
            this.accountName = data["accountName"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.payForID = data["payForID"];
            this.payFor = data["payFor"];
            this.project = data["project"] ? GetProjectByAccountListDto.fromJS(data["project"]) : <any>undefined;
            if (data["listProject"] && data["listProject"].constructor === Array) {
                this.listProject = [];
                for (let item of data["listProject"])
                    this.listProject.push(GetProjectByAccountListDto.fromJS(item));
            }
            this.ketPaymentHeader = data["ketPaymentHeader"];
            this.ppNo = data["ppNo"];
            if (data["listDataPayment"] && data["listDataPayment"].constructor === Array) {
                this.listDataPayment = [];
                for (let item of data["listDataPayment"])
                    this.listDataPayment.push(GetDataPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataPrintORByTransNoListDto {
        let result = new GetDataPrintORByTransNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentHeaderID"] = this.paymentHeaderID;
        data["accountID"] = this.accountID;
        data["accountCode"] = this.accountCode;
        data["accountName"] = this.accountName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["payForID"] = this.payForID;
        data["payFor"] = this.payFor;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (this.listProject && this.listProject.constructor === Array) {
            data["listProject"] = [];
            for (let item of this.listProject)
                data["listProject"].push(item.toJSON());
        }
        data["ketPaymentHeader"] = this.ketPaymentHeader;
        data["ppNo"] = this.ppNo;
        if (this.listDataPayment && this.listDataPayment.constructor === Array) {
            data["listDataPayment"] = [];
            for (let item of this.listDataPayment)
                data["listDataPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataPrintORByTransNoListDto {
    paymentHeaderID: number;
    accountID: number;
    accountCode: string;
    accountName: string;
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    bookingHeaderID: number;
    bookCode: string;
    payForID: number;
    payFor: string;
    project: GetProjectByAccountListDto;
    listProject: GetProjectByAccountListDto[];
    ketPaymentHeader: string;
    ppNo: string;
    listDataPayment: GetDataPayment[];
}

export class GetDataPayment implements IGetDataPayment {
    paymentDetailID: number;
    payNo: number;
    payTypeID: number;
    payTypeCode: string;
    othersTypeID: number;
    othersType: string;
    bankID: number;
    bankName: string;
    chequeNo: string;
    status: string;
    amount: number;
    netAlloc: number;
    vatAlloc: number;
    ket: string;
    dueDate: moment.Moment;

    constructor(data?: IGetDataPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDetailID = data["paymentDetailID"];
            this.payNo = data["payNo"];
            this.payTypeID = data["payTypeID"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeID = data["othersTypeID"];
            this.othersType = data["othersType"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.chequeNo = data["chequeNo"];
            this.status = data["status"];
            this.amount = data["amount"];
            this.netAlloc = data["netAlloc"];
            this.vatAlloc = data["vatAlloc"];
            this.ket = data["ket"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataPayment {
        let result = new GetDataPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDetailID"] = this.paymentDetailID;
        data["payNo"] = this.payNo;
        data["payTypeID"] = this.payTypeID;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeID"] = this.othersTypeID;
        data["othersType"] = this.othersType;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["netAlloc"] = this.netAlloc;
        data["vatAlloc"] = this.vatAlloc;
        data["ket"] = this.ket;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDataPayment {
    paymentDetailID: number;
    payNo: number;
    payTypeID: number;
    payTypeCode: string;
    othersTypeID: number;
    othersType: string;
    bankID: number;
    bankName: string;
    chequeNo: string;
    status: string;
    amount: number;
    netAlloc: number;
    vatAlloc: number;
    ket: string;
    dueDate: moment.Moment;
}

export class GetDataOneSignalResultDto implements IGetDataOneSignalResultDto {
    content: string;
    playerId: string;
    namaCust: string;

    constructor(data?: IGetDataOneSignalResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
            this.playerId = data["playerId"];
            this.namaCust = data["namaCust"];
        }
    }

    static fromJS(data: any): GetDataOneSignalResultDto {
        let result = new GetDataOneSignalResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["playerId"] = this.playerId;
        data["namaCust"] = this.namaCust;
        return data; 
    }
}

export interface IGetDataOneSignalResultDto {
    content: string;
    playerId: string;
    namaCust: string;
}

export class GetListOrderHistoryInputDto implements IGetListOrderHistoryInputDto {
    paymentType: number[];
    projectID: number[];
    userID: number;
    keyword: string;
    orderStatusID: number;
    sortID: number;
    byID: number;
    membercode: string;

    constructor(data?: IGetListOrderHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["paymentType"] && data["paymentType"].constructor === Array) {
                this.paymentType = [];
                for (let item of data["paymentType"])
                    this.paymentType.push(item);
            }
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.userID = data["userID"];
            this.keyword = data["keyword"];
            this.orderStatusID = data["orderStatusID"];
            this.sortID = data["sortID"];
            this.byID = data["byID"];
            this.membercode = data["membercode"];
        }
    }

    static fromJS(data: any): GetListOrderHistoryInputDto {
        let result = new GetListOrderHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paymentType && this.paymentType.constructor === Array) {
            data["paymentType"] = [];
            for (let item of this.paymentType)
                data["paymentType"].push(item);
        }
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["userID"] = this.userID;
        data["keyword"] = this.keyword;
        data["orderStatusID"] = this.orderStatusID;
        data["sortID"] = this.sortID;
        data["byID"] = this.byID;
        data["membercode"] = this.membercode;
        return data; 
    }
}

export interface IGetListOrderHistoryInputDto {
    paymentType: number[];
    projectID: number[];
    userID: number;
    keyword: string;
    orderStatusID: number;
    sortID: number;
    byID: number;
    membercode: string;
}

export class GetListOrderHistoryResultDto implements IGetListOrderHistoryResultDto {
    ppOrderID: number;
    paymentType: number;
    orderStatusID: number;
    projectID: number;
    projectName: string;
    orderCode: string;
    customerName: string;
    orderStatusName: string;
    ppNo: string;
    psCode: string;
    creationTime: moment.Moment;
    ppStatus: string;
    creatorUserID: number;
    memberCode: string;
    gateway: string;
    flagGateway: number;

    constructor(data?: IGetListOrderHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
            this.paymentType = data["paymentType"];
            this.orderStatusID = data["orderStatusID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.orderCode = data["orderCode"];
            this.customerName = data["customerName"];
            this.orderStatusName = data["orderStatusName"];
            this.ppNo = data["ppNo"];
            this.psCode = data["psCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.ppStatus = data["ppStatus"];
            this.creatorUserID = data["creatorUserID"];
            this.memberCode = data["memberCode"];
            this.gateway = data["gateway"];
            this.flagGateway = data["flagGateway"];
        }
    }

    static fromJS(data: any): GetListOrderHistoryResultDto {
        let result = new GetListOrderHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        data["paymentType"] = this.paymentType;
        data["orderStatusID"] = this.orderStatusID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["orderCode"] = this.orderCode;
        data["customerName"] = this.customerName;
        data["orderStatusName"] = this.orderStatusName;
        data["ppNo"] = this.ppNo;
        data["psCode"] = this.psCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["ppStatus"] = this.ppStatus;
        data["creatorUserID"] = this.creatorUserID;
        data["memberCode"] = this.memberCode;
        data["gateway"] = this.gateway;
        data["flagGateway"] = this.flagGateway;
        return data; 
    }
}

export interface IGetListOrderHistoryResultDto {
    ppOrderID: number;
    paymentType: number;
    orderStatusID: number;
    projectID: number;
    projectName: string;
    orderCode: string;
    customerName: string;
    orderStatusName: string;
    ppNo: string;
    psCode: string;
    creationTime: moment.Moment;
    ppStatus: string;
    creatorUserID: number;
    memberCode: string;
    gateway: string;
    flagGateway: number;
}

export class GetPagedOrderHistoryInputDto implements IGetPagedOrderHistoryInputDto {
    paymentType: number[];
    projectID: number[];
    userID: number;
    keyword: string;
    orderStatusID: number;
    sortID: number;
    byID: number;
    membercode: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetPagedOrderHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["paymentType"] && data["paymentType"].constructor === Array) {
                this.paymentType = [];
                for (let item of data["paymentType"])
                    this.paymentType.push(item);
            }
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.userID = data["userID"];
            this.keyword = data["keyword"];
            this.orderStatusID = data["orderStatusID"];
            this.sortID = data["sortID"];
            this.byID = data["byID"];
            this.membercode = data["membercode"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPagedOrderHistoryInputDto {
        let result = new GetPagedOrderHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paymentType && this.paymentType.constructor === Array) {
            data["paymentType"] = [];
            for (let item of this.paymentType)
                data["paymentType"].push(item);
        }
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["userID"] = this.userID;
        data["keyword"] = this.keyword;
        data["orderStatusID"] = this.orderStatusID;
        data["sortID"] = this.sortID;
        data["byID"] = this.byID;
        data["membercode"] = this.membercode;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IGetPagedOrderHistoryInputDto {
    paymentType: number[];
    projectID: number[];
    userID: number;
    keyword: string;
    orderStatusID: number;
    sortID: number;
    byID: number;
    membercode: string;
    skipCount: number;
    maxResultCount: number;
}

export class GetPagedOrderHistoryResultDto implements IGetPagedOrderHistoryResultDto {
    totalData: number;
    listData: GetListOrderHistoryTempDto[];

    constructor(data?: IGetPagedOrderHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalData = data["totalData"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(GetListOrderHistoryTempDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPagedOrderHistoryResultDto {
        let result = new GetPagedOrderHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalData"] = this.totalData;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPagedOrderHistoryResultDto {
    totalData: number;
    listData: GetListOrderHistoryTempDto[];
}

export class GetListOrderHistoryTempDto implements IGetListOrderHistoryTempDto {
    ppOrderID: number;
    paymentType: number;
    orderStatusID: number;
    projectID: number;
    projectName: string;
    orderCode: string;
    customerName: string;
    orderStatusName: string;
    ppNo: string;
    psCode: string;
    creationTime: moment.Moment;
    ppStatus: string;
    creatorUserID: number;
    memberCode: string;
    gateway: string;
    flagGateway: number;
    countData: number;

    constructor(data?: IGetListOrderHistoryTempDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
            this.paymentType = data["paymentType"];
            this.orderStatusID = data["orderStatusID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.orderCode = data["orderCode"];
            this.customerName = data["customerName"];
            this.orderStatusName = data["orderStatusName"];
            this.ppNo = data["ppNo"];
            this.psCode = data["psCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.ppStatus = data["ppStatus"];
            this.creatorUserID = data["creatorUserID"];
            this.memberCode = data["memberCode"];
            this.gateway = data["gateway"];
            this.flagGateway = data["flagGateway"];
            this.countData = data["countData"];
        }
    }

    static fromJS(data: any): GetListOrderHistoryTempDto {
        let result = new GetListOrderHistoryTempDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        data["paymentType"] = this.paymentType;
        data["orderStatusID"] = this.orderStatusID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["orderCode"] = this.orderCode;
        data["customerName"] = this.customerName;
        data["orderStatusName"] = this.orderStatusName;
        data["ppNo"] = this.ppNo;
        data["psCode"] = this.psCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["ppStatus"] = this.ppStatus;
        data["creatorUserID"] = this.creatorUserID;
        data["memberCode"] = this.memberCode;
        data["gateway"] = this.gateway;
        data["flagGateway"] = this.flagGateway;
        data["countData"] = this.countData;
        return data; 
    }
}

export interface IGetListOrderHistoryTempDto {
    ppOrderID: number;
    paymentType: number;
    orderStatusID: number;
    projectID: number;
    projectName: string;
    orderCode: string;
    customerName: string;
    orderStatusName: string;
    ppNo: string;
    psCode: string;
    creationTime: moment.Moment;
    ppStatus: string;
    creatorUserID: number;
    memberCode: string;
    gateway: string;
    flagGateway: number;
    countData: number;
}

export class GetListOrderHistoryAppDto implements IGetListOrderHistoryAppDto {
    monthString: string;
    month: number;
    year: number;
    getListDataOrder: GetListDataOrderDto[];

    constructor(data?: IGetListOrderHistoryAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.monthString = data["monthString"];
            this.month = data["month"];
            this.year = data["year"];
            if (data["getListDataOrder"] && data["getListDataOrder"].constructor === Array) {
                this.getListDataOrder = [];
                for (let item of data["getListDataOrder"])
                    this.getListDataOrder.push(GetListDataOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListOrderHistoryAppDto {
        let result = new GetListOrderHistoryAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthString"] = this.monthString;
        data["month"] = this.month;
        data["year"] = this.year;
        if (this.getListDataOrder && this.getListDataOrder.constructor === Array) {
            data["getListDataOrder"] = [];
            for (let item of this.getListDataOrder)
                data["getListDataOrder"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListOrderHistoryAppDto {
    monthString: string;
    month: number;
    year: number;
    getListDataOrder: GetListDataOrderDto[];
}

export class GetListDataOrderDto implements IGetListDataOrderDto {
    ppOrderId: number;
    customerName: string;
    psCode: string;
    orderCode: string;
    creationTime: moment.Moment;
    orderStatusID: number;
    projectName: string;

    constructor(data?: IGetListDataOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderId = data["ppOrderId"];
            this.customerName = data["customerName"];
            this.psCode = data["psCode"];
            this.orderCode = data["orderCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.orderStatusID = data["orderStatusID"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetListDataOrderDto {
        let result = new GetListDataOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderId"] = this.ppOrderId;
        data["customerName"] = this.customerName;
        data["psCode"] = this.psCode;
        data["orderCode"] = this.orderCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["orderStatusID"] = this.orderStatusID;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetListDataOrderDto {
    ppOrderId: number;
    customerName: string;
    psCode: string;
    orderCode: string;
    creationTime: moment.Moment;
    orderStatusID: number;
    projectName: string;
}

export class GetDetailOrderAppDto implements IGetDetailOrderAppDto {
    orderCode: string;
    psCode: string;
    customerName: string;
    top: string;
    pricePP: number;
    orderStatusID: number;
    projectName: string;
    productName: string;
    detailName: string;
    ppStatusName: string;
    ppQty: number;
    bankName1: string;
    bankName2: string;
    termID: number;
    dataPPNo: GetPPNoByOrderCodeDto[];
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetDetailOrderAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.top = data["top"];
            this.pricePP = data["pricePP"];
            this.orderStatusID = data["orderStatusID"];
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.detailName = data["detailName"];
            this.ppStatusName = data["ppStatusName"];
            this.ppQty = data["ppQty"];
            this.bankName1 = data["bankName1"];
            this.bankName2 = data["bankName2"];
            this.termID = data["termID"];
            if (data["dataPPNo"] && data["dataPPNo"].constructor === Array) {
                this.dataPPNo = [];
                for (let item of data["dataPPNo"])
                    this.dataPPNo.push(GetPPNoByOrderCodeDto.fromJS(item));
            }
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetDetailOrderAppDto {
        let result = new GetDetailOrderAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["top"] = this.top;
        data["pricePP"] = this.pricePP;
        data["orderStatusID"] = this.orderStatusID;
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["detailName"] = this.detailName;
        data["ppStatusName"] = this.ppStatusName;
        data["ppQty"] = this.ppQty;
        data["bankName1"] = this.bankName1;
        data["bankName2"] = this.bankName2;
        data["termID"] = this.termID;
        if (this.dataPPNo && this.dataPPNo.constructor === Array) {
            data["dataPPNo"] = [];
            for (let item of this.dataPPNo)
                data["dataPPNo"].push(item.toJSON());
        }
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetDetailOrderAppDto {
    orderCode: string;
    psCode: string;
    customerName: string;
    top: string;
    pricePP: number;
    orderStatusID: number;
    projectName: string;
    productName: string;
    detailName: string;
    ppStatusName: string;
    ppQty: number;
    bankName1: string;
    bankName2: string;
    termID: number;
    dataPPNo: GetPPNoByOrderCodeDto[];
    unitCode: string;
    unitNo: string;
}

export class GetPPNoByOrderCodeDto implements IGetPPNoByOrderCodeDto {
    ppNo: string;

    constructor(data?: IGetPPNoByOrderCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): GetPPNoByOrderCodeDto {
        let result = new GetPPNoByOrderCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IGetPPNoByOrderCodeDto {
    ppNo: string;
}

export class GetDropdownSortResultDto implements IGetDropdownSortResultDto {
    sortID: number;
    sortName: string;

    constructor(data?: IGetDropdownSortResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sortID = data["sortID"];
            this.sortName = data["sortName"];
        }
    }

    static fromJS(data: any): GetDropdownSortResultDto {
        let result = new GetDropdownSortResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortID"] = this.sortID;
        data["sortName"] = this.sortName;
        return data; 
    }
}

export interface IGetDropdownSortResultDto {
    sortID: number;
    sortName: string;
}

export class GetDropdownTermResultDto implements IGetDropdownTermResultDto {
    termID: number;
    termName: string;

    constructor(data?: IGetDropdownTermResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
        }
    }

    static fromJS(data: any): GetDropdownTermResultDto {
        let result = new GetDropdownTermResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        return data; 
    }
}

export interface IGetDropdownTermResultDto {
    termID: number;
    termName: string;
}

export class GetPreferredTypeResultDto implements IGetPreferredTypeResultDto {
    preferredTypeName: string;

    constructor(data?: IGetPreferredTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.preferredTypeName = data["preferredTypeName"];
        }
    }

    static fromJS(data: any): GetPreferredTypeResultDto {
        let result = new GetPreferredTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredTypeName"] = this.preferredTypeName;
        return data; 
    }
}

export interface IGetPreferredTypeResultDto {
    preferredTypeName: string;
}

export class GetListReportOrderInputDto implements IGetListReportOrderInputDto {
    orderDateFrom: string;
    orderDateTo: string;
    projectID: number;
    userID: number;
    preferredTypeName: string[];
    termID: number[];
    orderStatusID: number[];
    keyword: string;

    constructor(data?: IGetListReportOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderDateFrom = data["orderDateFrom"];
            this.orderDateTo = data["orderDateTo"];
            this.projectID = data["projectID"];
            this.userID = data["userID"];
            if (data["preferredTypeName"] && data["preferredTypeName"].constructor === Array) {
                this.preferredTypeName = [];
                for (let item of data["preferredTypeName"])
                    this.preferredTypeName.push(item);
            }
            if (data["termID"] && data["termID"].constructor === Array) {
                this.termID = [];
                for (let item of data["termID"])
                    this.termID.push(item);
            }
            if (data["orderStatusID"] && data["orderStatusID"].constructor === Array) {
                this.orderStatusID = [];
                for (let item of data["orderStatusID"])
                    this.orderStatusID.push(item);
            }
            this.keyword = data["keyword"];
        }
    }

    static fromJS(data: any): GetListReportOrderInputDto {
        let result = new GetListReportOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDateFrom"] = this.orderDateFrom;
        data["orderDateTo"] = this.orderDateTo;
        data["projectID"] = this.projectID;
        data["userID"] = this.userID;
        if (this.preferredTypeName && this.preferredTypeName.constructor === Array) {
            data["preferredTypeName"] = [];
            for (let item of this.preferredTypeName)
                data["preferredTypeName"].push(item);
        }
        if (this.termID && this.termID.constructor === Array) {
            data["termID"] = [];
            for (let item of this.termID)
                data["termID"].push(item);
        }
        if (this.orderStatusID && this.orderStatusID.constructor === Array) {
            data["orderStatusID"] = [];
            for (let item of this.orderStatusID)
                data["orderStatusID"].push(item);
        }
        data["keyword"] = this.keyword;
        return data; 
    }
}

export interface IGetListReportOrderInputDto {
    orderDateFrom: string;
    orderDateTo: string;
    projectID: number;
    userID: number;
    preferredTypeName: string[];
    termID: number[];
    orderStatusID: number[];
    keyword: string;
}

export class GetListReportOrderResultDto implements IGetListReportOrderResultDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    orderDate: string;
    orderStatus: string;
    projectName: string;
    customerName: string;
    preferredTypeName: string;
    termPayment: string;
    qty: number;
    price: number;
    totalPrice: number;
    memberName: string;
    memberCode: string;
    projectID: number;
    prefferedType: number;
    orderStatusID: number;
    termID: number;
    userID: number;
    ppNo: string;
    ppType: string;

    constructor(data?: IGetListReportOrderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.yearMonth = data["yearMonth"];
            this.orderCode = data["orderCode"];
            this.orderDate = data["orderDate"];
            this.orderStatus = data["orderStatus"];
            this.projectName = data["projectName"];
            this.customerName = data["customerName"];
            this.preferredTypeName = data["preferredTypeName"];
            this.termPayment = data["termPayment"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.totalPrice = data["totalPrice"];
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.projectID = data["projectID"];
            this.prefferedType = data["prefferedType"];
            this.orderStatusID = data["orderStatusID"];
            this.termID = data["termID"];
            this.userID = data["userID"];
            this.ppNo = data["ppNo"];
            this.ppType = data["ppType"];
        }
    }

    static fromJS(data: any): GetListReportOrderResultDto {
        let result = new GetListReportOrderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["yearMonth"] = this.yearMonth;
        data["orderCode"] = this.orderCode;
        data["orderDate"] = this.orderDate;
        data["orderStatus"] = this.orderStatus;
        data["projectName"] = this.projectName;
        data["customerName"] = this.customerName;
        data["preferredTypeName"] = this.preferredTypeName;
        data["termPayment"] = this.termPayment;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["projectID"] = this.projectID;
        data["prefferedType"] = this.prefferedType;
        data["orderStatusID"] = this.orderStatusID;
        data["termID"] = this.termID;
        data["userID"] = this.userID;
        data["ppNo"] = this.ppNo;
        data["ppType"] = this.ppType;
        return data; 
    }
}

export interface IGetListReportOrderResultDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    orderDate: string;
    orderStatus: string;
    projectName: string;
    customerName: string;
    preferredTypeName: string;
    termPayment: string;
    qty: number;
    price: number;
    totalPrice: number;
    memberName: string;
    memberCode: string;
    projectID: number;
    prefferedType: number;
    orderStatusID: number;
    termID: number;
    userID: number;
    ppNo: string;
    ppType: string;
}

export class GetReportOrderPdfInputDto implements IGetReportOrderPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataDto;

    constructor(data?: IGetReportOrderPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReportOrderPdfInputDto {
        let result = new GetReportOrderPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetReportOrderPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataDto;
}

export class ListDataDto implements IListDataDto {
    listHeader: ListHeaderDto[];
    listBody: ListBodyDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;

    constructor(data?: IListDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyDto.fromJS(item));
            }
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.colspanTbl = data["colspanTbl"];
            this.grandTotal = data["grandTotal"];
        }
    }

    static fromJS(data: any): ListDataDto {
        let result = new ListDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["colspanTbl"] = this.colspanTbl;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IListDataDto {
    listHeader: ListHeaderDto[];
    listBody: ListBodyDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: string;
}

export class ListHeaderDto implements IListHeaderDto {
    headerID: number;
    header: string;

    constructor(data?: IListHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.header = data["header"];
        }
    }

    static fromJS(data: any): ListHeaderDto {
        let result = new ListHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["header"] = this.header;
        return data; 
    }
}

export interface IListHeaderDto {
    headerID: number;
    header: string;
}

export class ListBodyDto implements IListBodyDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    orderDate: string;
    orderStatus: string;
    projectName: string;
    customerName: string;
    preferredTypeName: string;
    termPayment: string;
    qty: number;
    price: number;
    totalPrice: number;
    ppNo: string;
    ppType: string;

    constructor(data?: IListBodyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.yearMonth = data["yearMonth"];
            this.orderCode = data["orderCode"];
            this.orderDate = data["orderDate"];
            this.orderStatus = data["orderStatus"];
            this.projectName = data["projectName"];
            this.customerName = data["customerName"];
            this.preferredTypeName = data["preferredTypeName"];
            this.termPayment = data["termPayment"];
            this.qty = data["qty"];
            this.price = data["price"];
            this.totalPrice = data["totalPrice"];
            this.ppNo = data["ppNo"];
            this.ppType = data["ppType"];
        }
    }

    static fromJS(data: any): ListBodyDto {
        let result = new ListBodyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["yearMonth"] = this.yearMonth;
        data["orderCode"] = this.orderCode;
        data["orderDate"] = this.orderDate;
        data["orderStatus"] = this.orderStatus;
        data["projectName"] = this.projectName;
        data["customerName"] = this.customerName;
        data["preferredTypeName"] = this.preferredTypeName;
        data["termPayment"] = this.termPayment;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["totalPrice"] = this.totalPrice;
        data["ppNo"] = this.ppNo;
        data["ppType"] = this.ppType;
        return data; 
    }
}

export interface IListBodyDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    orderDate: string;
    orderStatus: string;
    projectName: string;
    customerName: string;
    preferredTypeName: string;
    termPayment: string;
    qty: number;
    price: number;
    totalPrice: number;
    ppNo: string;
    ppType: string;
}

export class GetDetailOrderResultDto implements IGetDetailOrderResultDto {
    orderID: number;
    orderNo: string;
    ppNo: string;
    projectName: string;
    projectCode: string;
    productName: string;
    preferredUnitType: string;
    termID: number;
    termName: string;
    qty: number;
    totalOrder: number;
    imageLogo: string;
    projectPPID: number;
    productPPID: number;
    productCode: string;
    preferredTypeID: number;
    dataBank: GetBankKPAPPListDto[];
    dataPPNo: GetPPNoByPPOrderIDDto[];
    psCode: string;
    projectID: number;
    ppOrderUnit: GetPPOrderUnit[];

    constructor(data?: IGetDetailOrderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderID = data["orderID"];
            this.orderNo = data["orderNo"];
            this.ppNo = data["ppNo"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
            this.productName = data["productName"];
            this.preferredUnitType = data["preferredUnitType"];
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.qty = data["qty"];
            this.totalOrder = data["totalOrder"];
            this.imageLogo = data["imageLogo"];
            this.projectPPID = data["projectPPID"];
            this.productPPID = data["productPPID"];
            this.productCode = data["productCode"];
            this.preferredTypeID = data["preferredTypeID"];
            if (data["dataBank"] && data["dataBank"].constructor === Array) {
                this.dataBank = [];
                for (let item of data["dataBank"])
                    this.dataBank.push(GetBankKPAPPListDto.fromJS(item));
            }
            if (data["dataPPNo"] && data["dataPPNo"].constructor === Array) {
                this.dataPPNo = [];
                for (let item of data["dataPPNo"])
                    this.dataPPNo.push(GetPPNoByPPOrderIDDto.fromJS(item));
            }
            this.psCode = data["psCode"];
            this.projectID = data["projectID"];
            if (data["ppOrderUnit"] && data["ppOrderUnit"].constructor === Array) {
                this.ppOrderUnit = [];
                for (let item of data["ppOrderUnit"])
                    this.ppOrderUnit.push(GetPPOrderUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailOrderResultDto {
        let result = new GetDetailOrderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["orderNo"] = this.orderNo;
        data["ppNo"] = this.ppNo;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        data["productName"] = this.productName;
        data["preferredUnitType"] = this.preferredUnitType;
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["qty"] = this.qty;
        data["totalOrder"] = this.totalOrder;
        data["imageLogo"] = this.imageLogo;
        data["projectPPID"] = this.projectPPID;
        data["productPPID"] = this.productPPID;
        data["productCode"] = this.productCode;
        data["preferredTypeID"] = this.preferredTypeID;
        if (this.dataBank && this.dataBank.constructor === Array) {
            data["dataBank"] = [];
            for (let item of this.dataBank)
                data["dataBank"].push(item.toJSON());
        }
        if (this.dataPPNo && this.dataPPNo.constructor === Array) {
            data["dataPPNo"] = [];
            for (let item of this.dataPPNo)
                data["dataPPNo"].push(item.toJSON());
        }
        data["psCode"] = this.psCode;
        data["projectID"] = this.projectID;
        if (this.ppOrderUnit && this.ppOrderUnit.constructor === Array) {
            data["ppOrderUnit"] = [];
            for (let item of this.ppOrderUnit)
                data["ppOrderUnit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailOrderResultDto {
    orderID: number;
    orderNo: string;
    ppNo: string;
    projectName: string;
    projectCode: string;
    productName: string;
    preferredUnitType: string;
    termID: number;
    termName: string;
    qty: number;
    totalOrder: number;
    imageLogo: string;
    projectPPID: number;
    productPPID: number;
    productCode: string;
    preferredTypeID: number;
    dataBank: GetBankKPAPPListDto[];
    dataPPNo: GetPPNoByPPOrderIDDto[];
    psCode: string;
    projectID: number;
    ppOrderUnit: GetPPOrderUnit[];
}

export class GetBankKPAPPListDto implements IGetBankKPAPPListDto {
    bankId: number;
    bankName: string;
    bankCode: string;

    constructor(data?: IGetBankKPAPPListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankId = data["bankId"];
            this.bankName = data["bankName"];
            this.bankCode = data["bankCode"];
        }
    }

    static fromJS(data: any): GetBankKPAPPListDto {
        let result = new GetBankKPAPPListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        return data; 
    }
}

export interface IGetBankKPAPPListDto {
    bankId: number;
    bankName: string;
    bankCode: string;
}

export class GetPPNoByPPOrderIDDto implements IGetPPNoByPPOrderIDDto {
    ppNo: string;

    constructor(data?: IGetPPNoByPPOrderIDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): GetPPNoByPPOrderIDDto {
        let result = new GetPPNoByPPOrderIDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IGetPPNoByPPOrderIDDto {
    ppNo: string;
}

export class GetPPOrderUnit implements IGetPPOrderUnit {
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetPPOrderUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetPPOrderUnit {
        let result = new GetPPOrderUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetPPOrderUnit {
    unitCode: string;
    unitNo: string;
}

export class GetListGenerateTTBFInputDto implements IGetListGenerateTTBFInputDto {
    projectID: number[];
    userID: number;
    membercode: string;
    ppNo: string;
    customer: string;

    constructor(data?: IGetListGenerateTTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.userID = data["userID"];
            this.membercode = data["membercode"];
            this.ppNo = data["ppNo"];
            this.customer = data["customer"];
        }
    }

    static fromJS(data: any): GetListGenerateTTBFInputDto {
        let result = new GetListGenerateTTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["userID"] = this.userID;
        data["membercode"] = this.membercode;
        data["ppNo"] = this.ppNo;
        data["customer"] = this.customer;
        return data; 
    }
}

export interface IGetListGenerateTTBFInputDto {
    projectID: number[];
    userID: number;
    membercode: string;
    ppNo: string;
    customer: string;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class GetListRequestP4ResultDto implements IGetListRequestP4ResultDto {
    id: number;
    username: string;
    createDate: moment.Moment;
    statusID: number;
    statusCode: string;
    status: string;
    projectID: number;
    isManager: boolean;
    creatorUserId: number;
    lastModifierUserId: number;
    lastModificationTime: moment.Moment;

    constructor(data?: IGetListRequestP4ResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.username = data["username"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.statusID = data["statusID"];
            this.statusCode = data["statusCode"];
            this.status = data["status"];
            this.projectID = data["projectID"];
            this.isManager = data["isManager"];
            this.creatorUserId = data["creatorUserId"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListRequestP4ResultDto {
        let result = new GetListRequestP4ResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["statusID"] = this.statusID;
        data["statusCode"] = this.statusCode;
        data["status"] = this.status;
        data["projectID"] = this.projectID;
        data["isManager"] = this.isManager;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetListRequestP4ResultDto {
    id: number;
    username: string;
    createDate: moment.Moment;
    statusID: number;
    statusCode: string;
    status: string;
    projectID: number;
    isManager: boolean;
    creatorUserId: number;
    lastModifierUserId: number;
    lastModificationTime: moment.Moment;
}

export class CheckIsManager implements ICheckIsManager {
    isManager: boolean;
    isFastApprover: boolean;

    constructor(data?: ICheckIsManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isManager = data["isManager"];
            this.isFastApprover = data["isFastApprover"];
        }
    }

    static fromJS(data: any): CheckIsManager {
        let result = new CheckIsManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isManager"] = this.isManager;
        data["isFastApprover"] = this.isFastApprover;
        return data; 
    }
}

export interface ICheckIsManager {
    isManager: boolean;
    isFastApprover: boolean;
}

export class GetListHistoryApproverResultDto implements IGetListHistoryApproverResultDto {
    id: number;
    approverID: number;
    approverName: string;
    createDate: moment.Moment;
    actionDate: moment.Moment;
    actionID: number;
    action: string;
    requestorID: number;
    requestorName: string;

    constructor(data?: IGetListHistoryApproverResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.approverID = data["approverID"];
            this.approverName = data["approverName"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.actionDate = data["actionDate"] ? moment(data["actionDate"].toString()) : <any>undefined;
            this.actionID = data["actionID"];
            this.action = data["action"];
            this.requestorID = data["requestorID"];
            this.requestorName = data["requestorName"];
        }
    }

    static fromJS(data: any): GetListHistoryApproverResultDto {
        let result = new GetListHistoryApproverResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approverID"] = this.approverID;
        data["approverName"] = this.approverName;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : <any>undefined;
        data["actionID"] = this.actionID;
        data["action"] = this.action;
        data["requestorID"] = this.requestorID;
        data["requestorName"] = this.requestorName;
        return data; 
    }
}

export interface IGetListHistoryApproverResultDto {
    id: number;
    approverID: number;
    approverName: string;
    createDate: moment.Moment;
    actionDate: moment.Moment;
    actionID: number;
    action: string;
    requestorID: number;
    requestorName: string;
}

export class InsertP4RequestInputDto implements IInsertP4RequestInputDto {
    userID: number;
    stateID: number;
    p4HeaderID: number;
    actionID: number;
    isComplete: boolean;

    constructor(data?: IInsertP4RequestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.stateID = data["stateID"];
            this.p4HeaderID = data["p4HeaderID"];
            this.actionID = data["actionID"];
            this.isComplete = data["isComplete"];
        }
    }

    static fromJS(data: any): InsertP4RequestInputDto {
        let result = new InsertP4RequestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["stateID"] = this.stateID;
        data["p4HeaderID"] = this.p4HeaderID;
        data["actionID"] = this.actionID;
        data["isComplete"] = this.isComplete;
        return data; 
    }
}

export interface IInsertP4RequestInputDto {
    userID: number;
    stateID: number;
    p4HeaderID: number;
    actionID: number;
    isComplete: boolean;
}

export class GetDetailRequestP4ResultDto implements IGetDetailRequestP4ResultDto {
    headerID: number;
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    refundAmt: number;
    isTransfer: boolean;
    reasonID: number;
    lostAmount: number;
    remarks: string;

    constructor(data?: IGetDetailRequestP4ResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.psName = data["psName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.refundAmt = data["refundAmt"];
            this.isTransfer = data["isTransfer"];
            this.reasonID = data["reasonID"];
            this.lostAmount = data["lostAmount"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetDetailRequestP4ResultDto {
        let result = new GetDetailRequestP4ResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["psName"] = this.psName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["refundAmt"] = this.refundAmt;
        data["isTransfer"] = this.isTransfer;
        data["reasonID"] = this.reasonID;
        data["lostAmount"] = this.lostAmount;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetDetailRequestP4ResultDto {
    headerID: number;
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    refundAmt: number;
    isTransfer: boolean;
    reasonID: number;
    lostAmount: number;
    remarks: string;
}

export class GetListDataP4bySearchResultDto implements IGetListDataP4bySearchResultDto {
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    bookDate: moment.Moment;

    constructor(data?: IGetListDataP4bySearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.psName = data["psName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListDataP4bySearchResultDto {
        let result = new GetListDataP4bySearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["psName"] = this.psName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetListDataP4bySearchResultDto {
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    bookDate: moment.Moment;
}

export class CreateDataP4SubmitInputDto implements ICreateDataP4SubmitInputDto {
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    userID: number;
    isSaved: boolean;
    reasonID: number;
    lostAmount: number;
    refundAmount: number;
    remarks: string;

    constructor(data?: ICreateDataP4SubmitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.psName = data["psName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
            this.userID = data["userID"];
            this.isSaved = data["isSaved"];
            this.reasonID = data["reasonID"];
            this.lostAmount = data["lostAmount"];
            this.refundAmount = data["refundAmount"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): CreateDataP4SubmitInputDto {
        let result = new CreateDataP4SubmitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["psName"] = this.psName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        data["userID"] = this.userID;
        data["isSaved"] = this.isSaved;
        data["reasonID"] = this.reasonID;
        data["lostAmount"] = this.lostAmount;
        data["refundAmount"] = this.refundAmount;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface ICreateDataP4SubmitInputDto {
    bookCode: string;
    psCode: string;
    psName: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    userID: number;
    isSaved: boolean;
    reasonID: number;
    lostAmount: number;
    refundAmount: number;
    remarks: string;
}

export class UpdateDataP4InputDto implements IUpdateDataP4InputDto {
    headerID: number;
    p4Detail: CreateDataP4SubmitInputDto[];

    constructor(data?: IUpdateDataP4InputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            if (data["p4Detail"] && data["p4Detail"].constructor === Array) {
                this.p4Detail = [];
                for (let item of data["p4Detail"])
                    this.p4Detail.push(CreateDataP4SubmitInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDataP4InputDto {
        let result = new UpdateDataP4InputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        if (this.p4Detail && this.p4Detail.constructor === Array) {
            data["p4Detail"] = [];
            for (let item of this.p4Detail)
                data["p4Detail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateDataP4InputDto {
    headerID: number;
    p4Detail: CreateDataP4SubmitInputDto[];
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (let key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data; 
    }
}

export interface IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GetOrderCodeDataDto implements IGetOrderCodeDataDto {
    orderID: number;
    unitID: number;
    orderCode: string;
    projectID: number;
    projectCode: string;
    customerName: string;
    statusName: string;
    statusID: number;
    amount: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    accountID: number;
    paymenDate: moment.Moment;
    isDRMS: boolean;
    oldBookCodeDRMS: string;

    constructor(data?: IGetOrderCodeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderID = data["orderID"];
            this.unitID = data["unitID"];
            this.orderCode = data["orderCode"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.customerName = data["customerName"];
            this.statusName = data["statusName"];
            this.statusID = data["statusID"];
            this.amount = data["amount"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.accountID = data["accountID"];
            this.paymenDate = data["paymenDate"] ? moment(data["paymenDate"].toString()) : <any>undefined;
            this.isDRMS = data["isDRMS"];
            this.oldBookCodeDRMS = data["oldBookCodeDRMS"];
        }
    }

    static fromJS(data: any): GetOrderCodeDataDto {
        let result = new GetOrderCodeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["unitID"] = this.unitID;
        data["orderCode"] = this.orderCode;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["customerName"] = this.customerName;
        data["statusName"] = this.statusName;
        data["statusID"] = this.statusID;
        data["amount"] = this.amount;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["accountID"] = this.accountID;
        data["paymenDate"] = this.paymenDate ? this.paymenDate.toISOString() : <any>undefined;
        data["isDRMS"] = this.isDRMS;
        data["oldBookCodeDRMS"] = this.oldBookCodeDRMS;
        return data; 
    }
}

export interface IGetOrderCodeDataDto {
    orderID: number;
    unitID: number;
    orderCode: string;
    projectID: number;
    projectCode: string;
    customerName: string;
    statusName: string;
    statusID: number;
    amount: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    accountID: number;
    paymenDate: moment.Moment;
    isDRMS: boolean;
    oldBookCodeDRMS: string;
}

export class GetPaymentBookingFeeInputDto implements IGetPaymentBookingFeeInputDto {
    orderID: number;
    orderCode: string;
    paymentTypeID: number;
    bankName: string;
    accountNo: string;
    projectID: number;
    accountID: number;
    paymentDate: string;

    constructor(data?: IGetPaymentBookingFeeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderID = data["orderID"];
            this.orderCode = data["orderCode"];
            this.paymentTypeID = data["paymentTypeID"];
            this.bankName = data["bankName"];
            this.accountNo = data["accountNo"];
            this.projectID = data["projectID"];
            this.accountID = data["accountID"];
            this.paymentDate = data["paymentDate"];
        }
    }

    static fromJS(data: any): GetPaymentBookingFeeInputDto {
        let result = new GetPaymentBookingFeeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["orderCode"] = this.orderCode;
        data["paymentTypeID"] = this.paymentTypeID;
        data["bankName"] = this.bankName;
        data["accountNo"] = this.accountNo;
        data["projectID"] = this.projectID;
        data["accountID"] = this.accountID;
        data["paymentDate"] = this.paymentDate;
        return data; 
    }
}

export interface IGetPaymentBookingFeeInputDto {
    orderID: number;
    orderCode: string;
    paymentTypeID: number;
    bankName: string;
    accountNo: string;
    projectID: number;
    accountID: number;
    paymentDate: string;
}

export class GetAccountByProject implements IGetAccountByProject {
    accountID: number;
    accountName: string;
    accountNo: string;
    accountCode: string;

    constructor(data?: IGetAccountByProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.accountName = data["accountName"];
            this.accountNo = data["accountNo"];
            this.accountCode = data["accountCode"];
        }
    }

    static fromJS(data: any): GetAccountByProject {
        let result = new GetAccountByProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["accountName"] = this.accountName;
        data["accountNo"] = this.accountNo;
        data["accountCode"] = this.accountCode;
        return data; 
    }
}

export interface IGetAccountByProject {
    accountID: number;
    accountName: string;
    accountNo: string;
    accountCode: string;
}

export class InsertTrBookingPaymentInputDto implements IInsertTrBookingPaymentInputDto {
    orderID: number;
    docFile: string;
    bankID: number;
    paymentAmt: number;
    clearDate: string;
    bankName: string;
    accountID: number;
    accountNo: string;
    paymentDate: string;
    paymentTypeID: number;

    constructor(data?: IInsertTrBookingPaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderID = data["orderID"];
            this.docFile = data["docFile"];
            this.bankID = data["bankID"];
            this.paymentAmt = data["paymentAmt"];
            this.clearDate = data["clearDate"];
            this.bankName = data["bankName"];
            this.accountID = data["accountID"];
            this.accountNo = data["accountNo"];
            this.paymentDate = data["paymentDate"];
            this.paymentTypeID = data["paymentTypeID"];
        }
    }

    static fromJS(data: any): InsertTrBookingPaymentInputDto {
        let result = new InsertTrBookingPaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["docFile"] = this.docFile;
        data["bankID"] = this.bankID;
        data["paymentAmt"] = this.paymentAmt;
        data["clearDate"] = this.clearDate;
        data["bankName"] = this.bankName;
        data["accountID"] = this.accountID;
        data["accountNo"] = this.accountNo;
        data["paymentDate"] = this.paymentDate;
        data["paymentTypeID"] = this.paymentTypeID;
        return data; 
    }
}

export interface IInsertTrBookingPaymentInputDto {
    orderID: number;
    docFile: string;
    bankID: number;
    paymentAmt: number;
    clearDate: string;
    bankName: string;
    accountID: number;
    accountNo: string;
    paymentDate: string;
    paymentTypeID: number;
}

export class CreateOrUpdateLkAllocInputDto implements ICreateOrUpdateLkAllocInputDto {
    id: number;
    allocCode: string;
    allocDesc: string;
    payForId: number;
    isVat: boolean;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateLkAllocInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.allocCode = data["allocCode"];
            this.allocDesc = data["allocDesc"];
            this.payForId = data["payForId"];
            this.isVat = data["isVat"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLkAllocInputDto {
        let result = new CreateOrUpdateLkAllocInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocCode"] = this.allocCode;
        data["allocDesc"] = this.allocDesc;
        data["payForId"] = this.payForId;
        data["isVat"] = this.isVat;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateLkAllocInputDto {
    id: number;
    allocCode: string;
    allocDesc: string;
    payForId: number;
    isVat: boolean;
    isActive: boolean;
}

export class GetLkAllocListDto implements IGetLkAllocListDto {
    id: number;
    allocCode: string;
    allocDesc: string;
    payForId: number;
    isVat: boolean;
    isActive: boolean;
    payFor: string;

    constructor(data?: IGetLkAllocListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.allocCode = data["allocCode"];
            this.allocDesc = data["allocDesc"];
            this.payForId = data["payForId"];
            this.isVat = data["isVat"];
            this.isActive = data["isActive"];
            this.payFor = data["payFor"];
        }
    }

    static fromJS(data: any): GetLkAllocListDto {
        let result = new GetLkAllocListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["allocCode"] = this.allocCode;
        data["allocDesc"] = this.allocDesc;
        data["payForId"] = this.payForId;
        data["isVat"] = this.isVat;
        data["isActive"] = this.isActive;
        data["payFor"] = this.payFor;
        return data; 
    }
}

export interface IGetLkAllocListDto {
    id: number;
    allocCode: string;
    allocDesc: string;
    payForId: number;
    isVat: boolean;
    isActive: boolean;
    payFor: string;
}

export class GetLkAllocDropdownListDto implements IGetLkAllocDropdownListDto {
    id: number;
    alloccode: string;
    alloc: string;

    constructor(data?: IGetLkAllocDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.alloccode = data["alloccode"];
            this.alloc = data["alloc"];
        }
    }

    static fromJS(data: any): GetLkAllocDropdownListDto {
        let result = new GetLkAllocDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alloccode"] = this.alloccode;
        data["alloc"] = this.alloc;
        return data; 
    }
}

export interface IGetLkAllocDropdownListDto {
    id: number;
    alloccode: string;
    alloc: string;
}

export class CreateOrUpdateLkMappingTaxDto implements ICreateOrUpdateLkMappingTaxDto {
    id: number;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    payForName: string;
    payTypeName: string;
    othersTypeName: string;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    isVAT: boolean;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateLkMappingTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.payForName = data["payForName"];
            this.payTypeName = data["payTypeName"];
            this.othersTypeName = data["othersTypeName"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeCode = data["othersTypeCode"];
            this.isVAT = data["isVAT"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLkMappingTaxDto {
        let result = new CreateOrUpdateLkMappingTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["payForName"] = this.payForName;
        data["payTypeName"] = this.payTypeName;
        data["othersTypeName"] = this.othersTypeName;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeCode"] = this.othersTypeCode;
        data["isVAT"] = this.isVAT;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateLkMappingTaxDto {
    id: number;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    payForName: string;
    payTypeName: string;
    othersTypeName: string;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    isVAT: boolean;
    isActive: boolean;
}

export class CreateOrUpdateLkOthersTypeInputDto implements ICreateOrUpdateLkOthersTypeInputDto {
    id: number;
    othersTypeCode: string;
    othersTypeDesc: string;
    isOthers: boolean;
    isOTP: boolean;
    isPayment: boolean;
    isAdjSAD: boolean;
    sortNum: number;
    isActive: boolean;
    isSDH: boolean;

    constructor(data?: ICreateOrUpdateLkOthersTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.othersTypeCode = data["othersTypeCode"];
            this.othersTypeDesc = data["othersTypeDesc"];
            this.isOthers = data["isOthers"];
            this.isOTP = data["isOTP"];
            this.isPayment = data["isPayment"];
            this.isAdjSAD = data["isAdjSAD"];
            this.sortNum = data["sortNum"];
            this.isActive = data["isActive"];
            this.isSDH = data["isSDH"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLkOthersTypeInputDto {
        let result = new CreateOrUpdateLkOthersTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["othersTypeCode"] = this.othersTypeCode;
        data["othersTypeDesc"] = this.othersTypeDesc;
        data["isOthers"] = this.isOthers;
        data["isOTP"] = this.isOTP;
        data["isPayment"] = this.isPayment;
        data["isAdjSAD"] = this.isAdjSAD;
        data["sortNum"] = this.sortNum;
        data["isActive"] = this.isActive;
        data["isSDH"] = this.isSDH;
        return data; 
    }
}

export interface ICreateOrUpdateLkOthersTypeInputDto {
    id: number;
    othersTypeCode: string;
    othersTypeDesc: string;
    isOthers: boolean;
    isOTP: boolean;
    isPayment: boolean;
    isAdjSAD: boolean;
    sortNum: number;
    isActive: boolean;
    isSDH: boolean;
}

export class DropdownLkOthersTypeDto implements IDropdownLkOthersTypeDto {
    id: number;
    othersType: string;
    othersTypeCode: string;
    othersTypeName: string;

    constructor(data?: IDropdownLkOthersTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.othersType = data["othersType"];
            this.othersTypeCode = data["othersTypeCode"];
            this.othersTypeName = data["othersTypeName"];
        }
    }

    static fromJS(data: any): DropdownLkOthersTypeDto {
        let result = new DropdownLkOthersTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["othersType"] = this.othersType;
        data["othersTypeCode"] = this.othersTypeCode;
        data["othersTypeName"] = this.othersTypeName;
        return data; 
    }
}

export interface IDropdownLkOthersTypeDto {
    id: number;
    othersType: string;
    othersTypeCode: string;
    othersTypeName: string;
}

export class CreateOrUpdateLkPayForInputDto implements ICreateOrUpdateLkPayForInputDto {
    id: number;
    payForCode: string;
    payForName: string;
    isSched: boolean;
    isIncome: boolean;
    isInventory: boolean;
    isSDH: boolean;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateLkPayForInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payForCode = data["payForCode"];
            this.payForName = data["payForName"];
            this.isSched = data["isSched"];
            this.isIncome = data["isIncome"];
            this.isInventory = data["isInventory"];
            this.isSDH = data["isSDH"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLkPayForInputDto {
        let result = new CreateOrUpdateLkPayForInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payForCode"] = this.payForCode;
        data["payForName"] = this.payForName;
        data["isSched"] = this.isSched;
        data["isIncome"] = this.isIncome;
        data["isInventory"] = this.isInventory;
        data["isSDH"] = this.isSDH;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateLkPayForInputDto {
    id: number;
    payForCode: string;
    payForName: string;
    isSched: boolean;
    isIncome: boolean;
    isInventory: boolean;
    isSDH: boolean;
    isActive: boolean;
}

export class DropdownLkPayForDto implements IDropdownLkPayForDto {
    id: number;
    payForCode: string;
    payForName: string;
    dropdownDesc: string;

    constructor(data?: IDropdownLkPayForDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payForCode = data["payForCode"];
            this.payForName = data["payForName"];
            this.dropdownDesc = data["dropdownDesc"];
        }
    }

    static fromJS(data: any): DropdownLkPayForDto {
        let result = new DropdownLkPayForDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payForCode"] = this.payForCode;
        data["payForName"] = this.payForName;
        data["dropdownDesc"] = this.dropdownDesc;
        return data; 
    }
}

export interface IDropdownLkPayForDto {
    id: number;
    payForCode: string;
    payForName: string;
    dropdownDesc: string;
}

export class CreateOrUpdateLkPayTypeInputDto implements ICreateOrUpdateLkPayTypeInputDto {
    id: number;
    payTypeCode: string;
    payTypeDesc: string;
    isIncome: boolean;
    isInventory: boolean;
    isBooking: boolean;
    isActive: boolean;

    constructor(data?: ICreateOrUpdateLkPayTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payTypeCode = data["payTypeCode"];
            this.payTypeDesc = data["payTypeDesc"];
            this.isIncome = data["isIncome"];
            this.isInventory = data["isInventory"];
            this.isBooking = data["isBooking"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLkPayTypeInputDto {
        let result = new CreateOrUpdateLkPayTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payTypeCode"] = this.payTypeCode;
        data["payTypeDesc"] = this.payTypeDesc;
        data["isIncome"] = this.isIncome;
        data["isInventory"] = this.isInventory;
        data["isBooking"] = this.isBooking;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrUpdateLkPayTypeInputDto {
    id: number;
    payTypeCode: string;
    payTypeDesc: string;
    isIncome: boolean;
    isInventory: boolean;
    isBooking: boolean;
    isActive: boolean;
}

export class DropdownPayTypeDto implements IDropdownPayTypeDto {
    id: number;
    payType: string;
    payTypeCode: string;
    payTypeName: string;

    constructor(data?: IDropdownPayTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.payType = data["payType"];
            this.payTypeCode = data["payTypeCode"];
            this.payTypeName = data["payTypeName"];
        }
    }

    static fromJS(data: any): DropdownPayTypeDto {
        let result = new DropdownPayTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payType"] = this.payType;
        data["payTypeCode"] = this.payTypeCode;
        data["payTypeName"] = this.payTypeName;
        return data; 
    }
}

export interface IDropdownPayTypeDto {
    id: number;
    payType: string;
    payTypeCode: string;
    payTypeName: string;
}

export class PaymentOnlineBookingResponse implements IPaymentOnlineBookingResponse {
    id: string;
    status_code: string;
    status_message: string;
    transaction_id: string;
    order_id: string;
    gross_amount: string;
    payment_type: string;
    transaction_time: string;
    transaction_status: string;
    fraud_status: string;
    va_numbers: VaNumberPaymentDto[];
    permata_va_number: string;
    token: string;
    redirect_url: string;
    approval_code: string;
    bill_key: string;
    biller_code: string;
    signature_key: string;
    error_messages: string;
    validation_messages: string[];
    isFullyPaid: boolean;
    htmlRequest: string;
    bankName: string;
    expHour: string;

    constructor(data?: IPaymentOnlineBookingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status_code = data["status_code"];
            this.status_message = data["status_message"];
            this.transaction_id = data["transaction_id"];
            this.order_id = data["order_id"];
            this.gross_amount = data["gross_amount"];
            this.payment_type = data["payment_type"];
            this.transaction_time = data["transaction_time"];
            this.transaction_status = data["transaction_status"];
            this.fraud_status = data["fraud_status"];
            if (data["va_numbers"] && data["va_numbers"].constructor === Array) {
                this.va_numbers = [];
                for (let item of data["va_numbers"])
                    this.va_numbers.push(VaNumberPaymentDto.fromJS(item));
            }
            this.permata_va_number = data["permata_va_number"];
            this.token = data["token"];
            this.redirect_url = data["redirect_url"];
            this.approval_code = data["approval_code"];
            this.bill_key = data["bill_key"];
            this.biller_code = data["biller_code"];
            this.signature_key = data["signature_key"];
            this.error_messages = data["error_messages"];
            if (data["validation_messages"] && data["validation_messages"].constructor === Array) {
                this.validation_messages = [];
                for (let item of data["validation_messages"])
                    this.validation_messages.push(item);
            }
            this.isFullyPaid = data["isFullyPaid"];
            this.htmlRequest = data["htmlRequest"];
            this.bankName = data["bankName"];
            this.expHour = data["expHour"];
        }
    }

    static fromJS(data: any): PaymentOnlineBookingResponse {
        let result = new PaymentOnlineBookingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status_code"] = this.status_code;
        data["status_message"] = this.status_message;
        data["transaction_id"] = this.transaction_id;
        data["order_id"] = this.order_id;
        data["gross_amount"] = this.gross_amount;
        data["payment_type"] = this.payment_type;
        data["transaction_time"] = this.transaction_time;
        data["transaction_status"] = this.transaction_status;
        data["fraud_status"] = this.fraud_status;
        if (this.va_numbers && this.va_numbers.constructor === Array) {
            data["va_numbers"] = [];
            for (let item of this.va_numbers)
                data["va_numbers"].push(item.toJSON());
        }
        data["permata_va_number"] = this.permata_va_number;
        data["token"] = this.token;
        data["redirect_url"] = this.redirect_url;
        data["approval_code"] = this.approval_code;
        data["bill_key"] = this.bill_key;
        data["biller_code"] = this.biller_code;
        data["signature_key"] = this.signature_key;
        data["error_messages"] = this.error_messages;
        if (this.validation_messages && this.validation_messages.constructor === Array) {
            data["validation_messages"] = [];
            for (let item of this.validation_messages)
                data["validation_messages"].push(item);
        }
        data["isFullyPaid"] = this.isFullyPaid;
        data["htmlRequest"] = this.htmlRequest;
        data["bankName"] = this.bankName;
        data["expHour"] = this.expHour;
        return data; 
    }
}

export interface IPaymentOnlineBookingResponse {
    id: string;
    status_code: string;
    status_message: string;
    transaction_id: string;
    order_id: string;
    gross_amount: string;
    payment_type: string;
    transaction_time: string;
    transaction_status: string;
    fraud_status: string;
    va_numbers: VaNumberPaymentDto[];
    permata_va_number: string;
    token: string;
    redirect_url: string;
    approval_code: string;
    bill_key: string;
    biller_code: string;
    signature_key: string;
    error_messages: string;
    validation_messages: string[];
    isFullyPaid: boolean;
    htmlRequest: string;
    bankName: string;
    expHour: string;
}

export class VaNumberPaymentDto implements IVaNumberPaymentDto {
    bank: string;
    va_number: string;

    constructor(data?: IVaNumberPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"];
            this.va_number = data["va_number"];
        }
    }

    static fromJS(data: any): VaNumberPaymentDto {
        let result = new VaNumberPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["va_number"] = this.va_number;
        return data; 
    }
}

export interface IVaNumberPaymentDto {
    bank: string;
    va_number: string;
}

export class RequestTokenResultDto implements IRequestTokenResultDto {
    token: string;
    redirec_url: string;

    constructor(data?: IRequestTokenResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"];
            this.redirec_url = data["redirec_url"];
        }
    }

    static fromJS(data: any): RequestTokenResultDto {
        let result = new RequestTokenResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["redirec_url"] = this.redirec_url;
        return data; 
    }
}

export interface IRequestTokenResultDto {
    token: string;
    redirec_url: string;
}

export class GetMsAccountListDto implements IGetMsAccountListDto {
    projectName: string;
    companyName: string;
    bankName: string;
    accID: number;
    accName: string;
    accNo: string;
    isActive: boolean;

    constructor(data?: IGetMsAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.companyName = data["companyName"];
            this.bankName = data["bankName"];
            this.accID = data["accID"];
            this.accName = data["accName"];
            this.accNo = data["accNo"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetMsAccountListDto {
        let result = new GetMsAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["companyName"] = this.companyName;
        data["bankName"] = this.bankName;
        data["accID"] = this.accID;
        data["accName"] = this.accName;
        data["accNo"] = this.accNo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetMsAccountListDto {
    projectName: string;
    companyName: string;
    bankName: string;
    accID: number;
    accName: string;
    accNo: string;
    isActive: boolean;
}

export class GetDetailMsAccountListDto implements IGetDetailMsAccountListDto {
    accID: number;
    accCode: string;
    accName: string;
    accNo: string;
    natureAccountBank: string;
    natureAccountDep: string;
    org: string;
    province: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    bankBranchID: number;
    bankBranchName: string;
    projectID: number;
    projectName: string;
    coID: number;
    companyName: string;
    accountEmailID: number;
    emailTo: string;
    emailCc: string;

    constructor(data?: IGetDetailMsAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.accCode = data["accCode"];
            this.accName = data["accName"];
            this.accNo = data["accNo"];
            this.natureAccountBank = data["natureAccountBank"];
            this.natureAccountDep = data["natureAccountDep"];
            this.org = data["org"];
            this.province = data["province"];
            this.isActive = data["isActive"];
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
            this.bankBranchID = data["bankBranchID"];
            this.bankBranchName = data["bankBranchName"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.coID = data["coID"];
            this.companyName = data["companyName"];
            this.accountEmailID = data["accountEmailID"];
            this.emailTo = data["emailTo"];
            this.emailCc = data["emailCc"];
        }
    }

    static fromJS(data: any): GetDetailMsAccountListDto {
        let result = new GetDetailMsAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["accCode"] = this.accCode;
        data["accName"] = this.accName;
        data["accNo"] = this.accNo;
        data["natureAccountBank"] = this.natureAccountBank;
        data["natureAccountDep"] = this.natureAccountDep;
        data["org"] = this.org;
        data["province"] = this.province;
        data["isActive"] = this.isActive;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["bankBranchID"] = this.bankBranchID;
        data["bankBranchName"] = this.bankBranchName;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["coID"] = this.coID;
        data["companyName"] = this.companyName;
        data["accountEmailID"] = this.accountEmailID;
        data["emailTo"] = this.emailTo;
        data["emailCc"] = this.emailCc;
        return data; 
    }
}

export interface IGetDetailMsAccountListDto {
    accID: number;
    accCode: string;
    accName: string;
    accNo: string;
    natureAccountBank: string;
    natureAccountDep: string;
    org: string;
    province: string;
    isActive: boolean;
    bankID: number;
    bankName: string;
    bankBranchID: number;
    bankBranchName: string;
    projectID: number;
    projectName: string;
    coID: number;
    companyName: string;
    accountEmailID: number;
    emailTo: string;
    emailCc: string;
}

export class UpdateMsAccountInputDto implements IUpdateMsAccountInputDto {
    accID: number;
    accountEmailID: number;
    emailTo: string;
    emailCc: string;
    natureAccountBank: string;
    natureAccountDep: string;
    org: string;
    province: string;
    isActive: boolean;

    constructor(data?: IUpdateMsAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.accountEmailID = data["accountEmailID"];
            this.emailTo = data["emailTo"];
            this.emailCc = data["emailCc"];
            this.natureAccountBank = data["natureAccountBank"];
            this.natureAccountDep = data["natureAccountDep"];
            this.org = data["org"];
            this.province = data["province"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UpdateMsAccountInputDto {
        let result = new UpdateMsAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["accountEmailID"] = this.accountEmailID;
        data["emailTo"] = this.emailTo;
        data["emailCc"] = this.emailCc;
        data["natureAccountBank"] = this.natureAccountBank;
        data["natureAccountDep"] = this.natureAccountDep;
        data["org"] = this.org;
        data["province"] = this.province;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUpdateMsAccountInputDto {
    accID: number;
    accountEmailID: number;
    emailTo: string;
    emailCc: string;
    natureAccountBank: string;
    natureAccountDep: string;
    org: string;
    province: string;
    isActive: boolean;
}

export class PaymentOnlineBookingRequest implements IPaymentOnlineBookingRequest {
    payment_type: string;
    transaction_details: TransactionDetailsDto;
    customer_details: CustomerDetailsDto;
    item_details: ItemDetailsDto[];
    bank_transfer: BankTransferDto;
    bca_klikpay: BcaKlikPayDto;
    bca_klikbca: BcaKlikBcaDto;
    mandiri_clickpay: MandiriClickPayDto;
    cimb_clicks: CimbClicksDto;
    telkomsel_cash: TelkomselCashDto;
    indosat_dompetku: IndosatDompetkuDto;
    mandiri_ecash: MandiriEcash;
    credit_card: CreditCard;
    cstore: Cstore;
    custom_expiry: CustomExpiryDto;
    enabled_payments: string[];

    constructor(data?: IPaymentOnlineBookingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment_type = data["payment_type"];
            this.transaction_details = data["transaction_details"] ? TransactionDetailsDto.fromJS(data["transaction_details"]) : <any>undefined;
            this.customer_details = data["customer_details"] ? CustomerDetailsDto.fromJS(data["customer_details"]) : <any>undefined;
            if (data["item_details"] && data["item_details"].constructor === Array) {
                this.item_details = [];
                for (let item of data["item_details"])
                    this.item_details.push(ItemDetailsDto.fromJS(item));
            }
            this.bank_transfer = data["bank_transfer"] ? BankTransferDto.fromJS(data["bank_transfer"]) : <any>undefined;
            this.bca_klikpay = data["bca_klikpay"] ? BcaKlikPayDto.fromJS(data["bca_klikpay"]) : <any>undefined;
            this.bca_klikbca = data["bca_klikbca"] ? BcaKlikBcaDto.fromJS(data["bca_klikbca"]) : <any>undefined;
            this.mandiri_clickpay = data["mandiri_clickpay"] ? MandiriClickPayDto.fromJS(data["mandiri_clickpay"]) : <any>undefined;
            this.cimb_clicks = data["cimb_clicks"] ? CimbClicksDto.fromJS(data["cimb_clicks"]) : <any>undefined;
            this.telkomsel_cash = data["telkomsel_cash"] ? TelkomselCashDto.fromJS(data["telkomsel_cash"]) : <any>undefined;
            this.indosat_dompetku = data["indosat_dompetku"] ? IndosatDompetkuDto.fromJS(data["indosat_dompetku"]) : <any>undefined;
            this.mandiri_ecash = data["mandiri_ecash"] ? MandiriEcash.fromJS(data["mandiri_ecash"]) : <any>undefined;
            this.credit_card = data["credit_card"] ? CreditCard.fromJS(data["credit_card"]) : <any>undefined;
            this.cstore = data["cstore"] ? Cstore.fromJS(data["cstore"]) : <any>undefined;
            this.custom_expiry = data["custom_expiry"] ? CustomExpiryDto.fromJS(data["custom_expiry"]) : <any>undefined;
            if (data["enabled_payments"] && data["enabled_payments"].constructor === Array) {
                this.enabled_payments = [];
                for (let item of data["enabled_payments"])
                    this.enabled_payments.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentOnlineBookingRequest {
        let result = new PaymentOnlineBookingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment_type"] = this.payment_type;
        data["transaction_details"] = this.transaction_details ? this.transaction_details.toJSON() : <any>undefined;
        data["customer_details"] = this.customer_details ? this.customer_details.toJSON() : <any>undefined;
        if (this.item_details && this.item_details.constructor === Array) {
            data["item_details"] = [];
            for (let item of this.item_details)
                data["item_details"].push(item.toJSON());
        }
        data["bank_transfer"] = this.bank_transfer ? this.bank_transfer.toJSON() : <any>undefined;
        data["bca_klikpay"] = this.bca_klikpay ? this.bca_klikpay.toJSON() : <any>undefined;
        data["bca_klikbca"] = this.bca_klikbca ? this.bca_klikbca.toJSON() : <any>undefined;
        data["mandiri_clickpay"] = this.mandiri_clickpay ? this.mandiri_clickpay.toJSON() : <any>undefined;
        data["cimb_clicks"] = this.cimb_clicks ? this.cimb_clicks.toJSON() : <any>undefined;
        data["telkomsel_cash"] = this.telkomsel_cash ? this.telkomsel_cash.toJSON() : <any>undefined;
        data["indosat_dompetku"] = this.indosat_dompetku ? this.indosat_dompetku.toJSON() : <any>undefined;
        data["mandiri_ecash"] = this.mandiri_ecash ? this.mandiri_ecash.toJSON() : <any>undefined;
        data["credit_card"] = this.credit_card ? this.credit_card.toJSON() : <any>undefined;
        data["cstore"] = this.cstore ? this.cstore.toJSON() : <any>undefined;
        data["custom_expiry"] = this.custom_expiry ? this.custom_expiry.toJSON() : <any>undefined;
        if (this.enabled_payments && this.enabled_payments.constructor === Array) {
            data["enabled_payments"] = [];
            for (let item of this.enabled_payments)
                data["enabled_payments"].push(item);
        }
        return data; 
    }
}

export interface IPaymentOnlineBookingRequest {
    payment_type: string;
    transaction_details: TransactionDetailsDto;
    customer_details: CustomerDetailsDto;
    item_details: ItemDetailsDto[];
    bank_transfer: BankTransferDto;
    bca_klikpay: BcaKlikPayDto;
    bca_klikbca: BcaKlikBcaDto;
    mandiri_clickpay: MandiriClickPayDto;
    cimb_clicks: CimbClicksDto;
    telkomsel_cash: TelkomselCashDto;
    indosat_dompetku: IndosatDompetkuDto;
    mandiri_ecash: MandiriEcash;
    credit_card: CreditCard;
    cstore: Cstore;
    custom_expiry: CustomExpiryDto;
    enabled_payments: string[];
}

export class TransactionDetailsDto implements ITransactionDetailsDto {
    gross_amount: number;
    order_id: string;

    constructor(data?: ITransactionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gross_amount = data["gross_amount"];
            this.order_id = data["order_id"];
        }
    }

    static fromJS(data: any): TransactionDetailsDto {
        let result = new TransactionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gross_amount"] = this.gross_amount;
        data["order_id"] = this.order_id;
        return data; 
    }
}

export interface ITransactionDetailsDto {
    gross_amount: number;
    order_id: string;
}

export class CustomerDetailsDto implements ICustomerDetailsDto {
    email: string;
    first_name: string;
    last_name: string;
    phone: string;

    constructor(data?: ICustomerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.first_name = data["first_name"];
            this.last_name = data["last_name"];
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): CustomerDetailsDto {
        let result = new CustomerDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ICustomerDetailsDto {
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
}

export class ItemDetailsDto implements IItemDetailsDto {
    id: string;
    price: number;
    quantity: number;
    name: string;

    constructor(data?: IItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.price = data["price"];
            this.quantity = data["quantity"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ItemDetailsDto {
        let result = new ItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["name"] = this.name;
        return data; 
    }
}

export interface IItemDetailsDto {
    id: string;
    price: number;
    quantity: number;
    name: string;
}

export class BankTransferDto implements IBankTransferDto {
    bank: string;
    permata: PermataDto;

    constructor(data?: IBankTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"];
            this.permata = data["permata"] ? PermataDto.fromJS(data["permata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BankTransferDto {
        let result = new BankTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["permata"] = this.permata ? this.permata.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBankTransferDto {
    bank: string;
    permata: PermataDto;
}

export class BcaKlikPayDto implements IBcaKlikPayDto {
    type: string;
    description: string;

    constructor(data?: IBcaKlikPayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): BcaKlikPayDto {
        let result = new BcaKlikPayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["description"] = this.description;
        return data; 
    }
}

export interface IBcaKlikPayDto {
    type: string;
    description: string;
}

export class BcaKlikBcaDto implements IBcaKlikBcaDto {
    description: string;
    user_id: string;

    constructor(data?: IBcaKlikBcaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.user_id = data["user_id"];
        }
    }

    static fromJS(data: any): BcaKlikBcaDto {
        let result = new BcaKlikBcaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["user_id"] = this.user_id;
        return data; 
    }
}

export interface IBcaKlikBcaDto {
    description: string;
    user_id: string;
}

export class MandiriClickPayDto implements IMandiriClickPayDto {
    card_number: string;
    input1: string;
    input2: string;
    input3: string;
    token: string;

    constructor(data?: IMandiriClickPayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.card_number = data["card_number"];
            this.input1 = data["input1"];
            this.input2 = data["input2"];
            this.input3 = data["input3"];
            this.token = data["token"];
        }
    }

    static fromJS(data: any): MandiriClickPayDto {
        let result = new MandiriClickPayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card_number"] = this.card_number;
        data["input1"] = this.input1;
        data["input2"] = this.input2;
        data["input3"] = this.input3;
        data["token"] = this.token;
        return data; 
    }
}

export interface IMandiriClickPayDto {
    card_number: string;
    input1: string;
    input2: string;
    input3: string;
    token: string;
}

export class CimbClicksDto implements ICimbClicksDto {
    description: string;

    constructor(data?: ICimbClicksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
        }
    }

    static fromJS(data: any): CimbClicksDto {
        let result = new CimbClicksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data; 
    }
}

export interface ICimbClicksDto {
    description: string;
}

export class TelkomselCashDto implements ITelkomselCashDto {
    promo: boolean;
    is_reversal: number;
    customer: string;

    constructor(data?: ITelkomselCashDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promo = data["promo"];
            this.is_reversal = data["is_reversal"];
            this.customer = data["customer"];
        }
    }

    static fromJS(data: any): TelkomselCashDto {
        let result = new TelkomselCashDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promo"] = this.promo;
        data["is_reversal"] = this.is_reversal;
        data["customer"] = this.customer;
        return data; 
    }
}

export interface ITelkomselCashDto {
    promo: boolean;
    is_reversal: number;
    customer: string;
}

export class IndosatDompetkuDto implements IIndosatDompetkuDto {
    msisdn: string;

    constructor(data?: IIndosatDompetkuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.msisdn = data["msisdn"];
        }
    }

    static fromJS(data: any): IndosatDompetkuDto {
        let result = new IndosatDompetkuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msisdn"] = this.msisdn;
        return data; 
    }
}

export interface IIndosatDompetkuDto {
    msisdn: string;
}

export class MandiriEcash implements IMandiriEcash {
    description: string;

    constructor(data?: IMandiriEcash) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
        }
    }

    static fromJS(data: any): MandiriEcash {
        let result = new MandiriEcash();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data; 
    }
}

export interface IMandiriEcash {
    description: string;
}

export class CreditCard implements ICreditCard {
    secure: boolean;

    constructor(data?: ICreditCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secure = data["secure"];
        }
    }

    static fromJS(data: any): CreditCard {
        let result = new CreditCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secure"] = this.secure;
        return data; 
    }
}

export interface ICreditCard {
    secure: boolean;
}

export class Cstore implements ICstore {
    store: string;
    message: string;

    constructor(data?: ICstore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.store = data["store"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): Cstore {
        let result = new Cstore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICstore {
    store: string;
    message: string;
}

export class CustomExpiryDto implements ICustomExpiryDto {
    order_time: string;
    expiry_duration: string;
    unit: string;

    constructor(data?: ICustomExpiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order_time = data["order_time"];
            this.expiry_duration = data["expiry_duration"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): CustomExpiryDto {
        let result = new CustomExpiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order_time"] = this.order_time;
        data["expiry_duration"] = this.expiry_duration;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface ICustomExpiryDto {
    order_time: string;
    expiry_duration: string;
    unit: string;
}

export class PermataDto implements IPermataDto {
    recipient_name: string;

    constructor(data?: IPermataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recipient_name = data["recipient_name"];
        }
    }

    static fromJS(data: any): PermataDto {
        let result = new PermataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient_name"] = this.recipient_name;
        return data; 
    }
}

export interface IPermataDto {
    recipient_name: string;
}

export class RequestTokenInputDto implements IRequestTokenInputDto {
    transaction_details: TransactionDetailsDtos;
    credit_card: CreditCards;

    constructor(data?: IRequestTokenInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transaction_details = data["transaction_details"] ? TransactionDetailsDtos.fromJS(data["transaction_details"]) : <any>undefined;
            this.credit_card = data["credit_card"] ? CreditCards.fromJS(data["credit_card"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestTokenInputDto {
        let result = new RequestTokenInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction_details"] = this.transaction_details ? this.transaction_details.toJSON() : <any>undefined;
        data["credit_card"] = this.credit_card ? this.credit_card.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IRequestTokenInputDto {
    transaction_details: TransactionDetailsDtos;
    credit_card: CreditCards;
}

export class TransactionDetailsDtos implements ITransactionDetailsDtos {
    gross_amount: number;
    order_id: string;

    constructor(data?: ITransactionDetailsDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gross_amount = data["gross_amount"];
            this.order_id = data["order_id"];
        }
    }

    static fromJS(data: any): TransactionDetailsDtos {
        let result = new TransactionDetailsDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gross_amount"] = this.gross_amount;
        data["order_id"] = this.order_id;
        return data; 
    }
}

export interface ITransactionDetailsDtos {
    gross_amount: number;
    order_id: string;
}

export class CreditCards implements ICreditCards {
    secure: boolean;

    constructor(data?: ICreditCards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secure = data["secure"];
        }
    }

    static fromJS(data: any): CreditCards {
        let result = new CreditCards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secure"] = this.secure;
        return data; 
    }
}

export interface ICreditCards {
    secure: boolean;
}

export class CheckPaymentStatusInputDto implements ICheckPaymentStatusInputDto {
    orderCode: string;

    constructor(data?: ICheckPaymentStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
        }
    }

    static fromJS(data: any): CheckPaymentStatusInputDto {
        let result = new CheckPaymentStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        return data; 
    }
}

export interface ICheckPaymentStatusInputDto {
    orderCode: string;
}

export class OrderPaymentMidInputDto implements IOrderPaymentMidInputDto {
    bookingHeaderID: number;
    payTypeID: number;
    amount: number;

    constructor(data?: IOrderPaymentMidInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payTypeID = data["payTypeID"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): OrderPaymentMidInputDto {
        let result = new OrderPaymentMidInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payTypeID"] = this.payTypeID;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IOrderPaymentMidInputDto {
    bookingHeaderID: number;
    payTypeID: number;
    amount: number;
}

export class GetListPaymentTypeResultDto implements IGetListPaymentTypeResultDto {
    paymentType: number;
    paymentTypeName: string;

    constructor(data?: IGetListPaymentTypeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.paymentTypeName = data["paymentTypeName"];
        }
    }

    static fromJS(data: any): GetListPaymentTypeResultDto {
        let result = new GetListPaymentTypeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["paymentTypeName"] = this.paymentTypeName;
        return data; 
    }
}

export interface IGetListPaymentTypeResultDto {
    paymentType: number;
    paymentTypeName: string;
}

export class GetListProjectResultDto implements IGetListProjectResultDto {
    projectID: number;
    projectName: string;

    constructor(data?: IGetListProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetListProjectResultDto {
        let result = new GetListProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetListProjectResultDto {
    projectID: number;
    projectName: string;
}

export class GetListPaymentHistoryInputDto implements IGetListPaymentHistoryInputDto {
    orderStatusID: number;
    paymentType: number;
    projectID: number;
    keyword: string;

    constructor(data?: IGetListPaymentHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderStatusID = data["orderStatusID"];
            this.paymentType = data["paymentType"];
            this.projectID = data["projectID"];
            this.keyword = data["keyword"];
        }
    }

    static fromJS(data: any): GetListPaymentHistoryInputDto {
        let result = new GetListPaymentHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusID"] = this.orderStatusID;
        data["paymentType"] = this.paymentType;
        data["projectID"] = this.projectID;
        data["keyword"] = this.keyword;
        return data; 
    }
}

export interface IGetListPaymentHistoryInputDto {
    orderStatusID: number;
    paymentType: number;
    projectID: number;
    keyword: string;
}

export class GetListHistoryPaymentResultDto implements IGetListHistoryPaymentResultDto {
    orderStatusID: number;
    paymentTypeID: number;
    projectID: number;
    customerName: string;
    orderCode: string;
    projectName: string;
    tid: string;
    mid: string;
    approvalCode: string;
    paymentTypeName: string;
    bankBranch: string;
    bankAccNo: string;
    qty: number;
    paymentAmt: number;
    paymentID: number;
    psCode: string;
    orderStatus: string;
    ppOrderID: number;

    constructor(data?: IGetListHistoryPaymentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderStatusID = data["orderStatusID"];
            this.paymentTypeID = data["paymentTypeID"];
            this.projectID = data["projectID"];
            this.customerName = data["customerName"];
            this.orderCode = data["orderCode"];
            this.projectName = data["projectName"];
            this.tid = data["tid"];
            this.mid = data["mid"];
            this.approvalCode = data["approvalCode"];
            this.paymentTypeName = data["paymentTypeName"];
            this.bankBranch = data["bankBranch"];
            this.bankAccNo = data["bankAccNo"];
            this.qty = data["qty"];
            this.paymentAmt = data["paymentAmt"];
            this.paymentID = data["paymentID"];
            this.psCode = data["psCode"];
            this.orderStatus = data["orderStatus"];
            this.ppOrderID = data["ppOrderID"];
        }
    }

    static fromJS(data: any): GetListHistoryPaymentResultDto {
        let result = new GetListHistoryPaymentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusID"] = this.orderStatusID;
        data["paymentTypeID"] = this.paymentTypeID;
        data["projectID"] = this.projectID;
        data["customerName"] = this.customerName;
        data["orderCode"] = this.orderCode;
        data["projectName"] = this.projectName;
        data["tid"] = this.tid;
        data["mid"] = this.mid;
        data["approvalCode"] = this.approvalCode;
        data["paymentTypeName"] = this.paymentTypeName;
        data["bankBranch"] = this.bankBranch;
        data["bankAccNo"] = this.bankAccNo;
        data["qty"] = this.qty;
        data["paymentAmt"] = this.paymentAmt;
        data["paymentID"] = this.paymentID;
        data["psCode"] = this.psCode;
        data["orderStatus"] = this.orderStatus;
        data["ppOrderID"] = this.ppOrderID;
        return data; 
    }
}

export interface IGetListHistoryPaymentResultDto {
    orderStatusID: number;
    paymentTypeID: number;
    projectID: number;
    customerName: string;
    orderCode: string;
    projectName: string;
    tid: string;
    mid: string;
    approvalCode: string;
    paymentTypeName: string;
    bankBranch: string;
    bankAccNo: string;
    qty: number;
    paymentAmt: number;
    paymentID: number;
    psCode: string;
    orderStatus: string;
    ppOrderID: number;
}

export class GetLIstOrderStatusResultDto implements IGetLIstOrderStatusResultDto {
    orderStatusID: number;
    orderStatusName: string;

    constructor(data?: IGetLIstOrderStatusResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderStatusID = data["orderStatusID"];
            this.orderStatusName = data["orderStatusName"];
        }
    }

    static fromJS(data: any): GetLIstOrderStatusResultDto {
        let result = new GetLIstOrderStatusResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusID"] = this.orderStatusID;
        data["orderStatusName"] = this.orderStatusName;
        return data; 
    }
}

export interface IGetLIstOrderStatusResultDto {
    orderStatusID: number;
    orderStatusName: string;
}

export class GetDetailPaymentInfoResultDto implements IGetDetailPaymentInfoResultDto {
    orderCode: string;
    customerName: string;
    paymentDate: moment.Moment;
    qty: string;
    projectName: string;
    paymentTypeName: string;
    bankName: string;
    location: string;
    accountNo: string;
    accountName: string;
    uploadReceipt: string;
    totalAmount: number;
    paidAmount: number;
    outstanding: number;
    orderStatusName: string;
    paymentHistory: GetPaymentHistory[];

    constructor(data?: IGetDetailPaymentInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.customerName = data["customerName"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.qty = data["qty"];
            this.projectName = data["projectName"];
            this.paymentTypeName = data["paymentTypeName"];
            this.bankName = data["bankName"];
            this.location = data["location"];
            this.accountNo = data["accountNo"];
            this.accountName = data["accountName"];
            this.uploadReceipt = data["uploadReceipt"];
            this.totalAmount = data["totalAmount"];
            this.paidAmount = data["paidAmount"];
            this.outstanding = data["outstanding"];
            this.orderStatusName = data["orderStatusName"];
            if (data["paymentHistory"] && data["paymentHistory"].constructor === Array) {
                this.paymentHistory = [];
                for (let item of data["paymentHistory"])
                    this.paymentHistory.push(GetPaymentHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailPaymentInfoResultDto {
        let result = new GetDetailPaymentInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["customerName"] = this.customerName;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["qty"] = this.qty;
        data["projectName"] = this.projectName;
        data["paymentTypeName"] = this.paymentTypeName;
        data["bankName"] = this.bankName;
        data["location"] = this.location;
        data["accountNo"] = this.accountNo;
        data["accountName"] = this.accountName;
        data["uploadReceipt"] = this.uploadReceipt;
        data["totalAmount"] = this.totalAmount;
        data["paidAmount"] = this.paidAmount;
        data["outstanding"] = this.outstanding;
        data["orderStatusName"] = this.orderStatusName;
        if (this.paymentHistory && this.paymentHistory.constructor === Array) {
            data["paymentHistory"] = [];
            for (let item of this.paymentHistory)
                data["paymentHistory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailPaymentInfoResultDto {
    orderCode: string;
    customerName: string;
    paymentDate: moment.Moment;
    qty: string;
    projectName: string;
    paymentTypeName: string;
    bankName: string;
    location: string;
    accountNo: string;
    accountName: string;
    uploadReceipt: string;
    totalAmount: number;
    paidAmount: number;
    outstanding: number;
    orderStatusName: string;
    paymentHistory: GetPaymentHistory[];
}

export class GetPaymentHistory implements IGetPaymentHistory {
    orderCode: string;
    projectName: string;
    paymentTypeName: string;
    bankName: string;
    paymentID: number;
    paymentType: number;
    ppOrderID: number;
    amount: number;

    constructor(data?: IGetPaymentHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.projectName = data["projectName"];
            this.paymentTypeName = data["paymentTypeName"];
            this.bankName = data["bankName"];
            this.paymentID = data["paymentID"];
            this.paymentType = data["paymentType"];
            this.ppOrderID = data["ppOrderID"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetPaymentHistory {
        let result = new GetPaymentHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["projectName"] = this.projectName;
        data["paymentTypeName"] = this.paymentTypeName;
        data["bankName"] = this.bankName;
        data["paymentID"] = this.paymentID;
        data["paymentType"] = this.paymentType;
        data["ppOrderID"] = this.ppOrderID;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IGetPaymentHistory {
    orderCode: string;
    projectName: string;
    paymentTypeName: string;
    bankName: string;
    paymentID: number;
    paymentType: number;
    ppOrderID: number;
    amount: number;
}

export class ListTTBFInputDto implements IListTTBFInputDto {
    name: string;
    inputDto: TTBFInputDto[];

    constructor(data?: IListTTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["inputDto"] && data["inputDto"].constructor === Array) {
                this.inputDto = [];
                for (let item of data["inputDto"])
                    this.inputDto.push(TTBFInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListTTBFInputDto {
        let result = new ListTTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.inputDto && this.inputDto.constructor === Array) {
            data["inputDto"] = [];
            for (let item of this.inputDto)
                data["inputDto"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListTTBFInputDto {
    name: string;
    inputDto: TTBFInputDto[];
}

export class TTBFInputDto implements ITTBFInputDto {
    dto: GenerateTTBFInputDto;

    constructor(data?: ITTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dto = data["dto"] ? GenerateTTBFInputDto.fromJS(data["dto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TTBFInputDto {
        let result = new TTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITTBFInputDto {
    dto: GenerateTTBFInputDto;
}

export class GenerateTTBFInputDto implements IGenerateTTBFInputDto {
    customerName: string;
    idNo: string;
    noHp: string;
    email: string;
    metodePembayaran: string;
    memberCode: string;
    unitType: string;
    memberName: string;
    ppPrice: string;
    ppno: string;
    banner: string;
    tnc: string;
    fileName: string;
    tanggal: string;
    barcode: string;
    address: string;
    priorityLine: boolean;
    isRefundable: boolean;
    isTransferable: boolean;
    productCode: string;
    isNon: boolean;
    mappingFastLane: number;
    fastLaneName: string;
    terbilangPPPrice: string;
    terbilangPPPriceIndo: string;
    unitCodeUnitNo: string;
    nupName: string;

    constructor(data?: IGenerateTTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.idNo = data["idNo"];
            this.noHp = data["noHp"];
            this.email = data["email"];
            this.metodePembayaran = data["metodePembayaran"];
            this.memberCode = data["memberCode"];
            this.unitType = data["unitType"];
            this.memberName = data["memberName"];
            this.ppPrice = data["ppPrice"];
            this.ppno = data["ppno"];
            this.banner = data["banner"];
            this.tnc = data["tnc"];
            this.fileName = data["fileName"];
            this.tanggal = data["tanggal"];
            this.barcode = data["barcode"];
            this.address = data["address"];
            this.priorityLine = data["priorityLine"];
            this.isRefundable = data["isRefundable"];
            this.isTransferable = data["isTransferable"];
            this.productCode = data["productCode"];
            this.isNon = data["isNon"];
            this.mappingFastLane = data["mappingFastLane"];
            this.fastLaneName = data["fastLaneName"];
            this.terbilangPPPrice = data["terbilangPPPrice"];
            this.terbilangPPPriceIndo = data["terbilangPPPriceIndo"];
            this.unitCodeUnitNo = data["unitCodeUnitNo"];
            this.nupName = data["nupName"];
        }
    }

    static fromJS(data: any): GenerateTTBFInputDto {
        let result = new GenerateTTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["idNo"] = this.idNo;
        data["noHp"] = this.noHp;
        data["email"] = this.email;
        data["metodePembayaran"] = this.metodePembayaran;
        data["memberCode"] = this.memberCode;
        data["unitType"] = this.unitType;
        data["memberName"] = this.memberName;
        data["ppPrice"] = this.ppPrice;
        data["ppno"] = this.ppno;
        data["banner"] = this.banner;
        data["tnc"] = this.tnc;
        data["fileName"] = this.fileName;
        data["tanggal"] = this.tanggal;
        data["barcode"] = this.barcode;
        data["address"] = this.address;
        data["priorityLine"] = this.priorityLine;
        data["isRefundable"] = this.isRefundable;
        data["isTransferable"] = this.isTransferable;
        data["productCode"] = this.productCode;
        data["isNon"] = this.isNon;
        data["mappingFastLane"] = this.mappingFastLane;
        data["fastLaneName"] = this.fastLaneName;
        data["terbilangPPPrice"] = this.terbilangPPPrice;
        data["terbilangPPPriceIndo"] = this.terbilangPPPriceIndo;
        data["unitCodeUnitNo"] = this.unitCodeUnitNo;
        data["nupName"] = this.nupName;
        return data; 
    }
}

export interface IGenerateTTBFInputDto {
    customerName: string;
    idNo: string;
    noHp: string;
    email: string;
    metodePembayaran: string;
    memberCode: string;
    unitType: string;
    memberName: string;
    ppPrice: string;
    ppno: string;
    banner: string;
    tnc: string;
    fileName: string;
    tanggal: string;
    barcode: string;
    address: string;
    priorityLine: boolean;
    isRefundable: boolean;
    isTransferable: boolean;
    productCode: string;
    isNon: boolean;
    mappingFastLane: number;
    fastLaneName: string;
    terbilangPPPrice: string;
    terbilangPPPriceIndo: string;
    unitCodeUnitNo: string;
    nupName: string;
}

export class GetListDropdownBankResultDto implements IGetListDropdownBankResultDto {
    bankID: number;
    bankName: string;

    constructor(data?: IGetListDropdownBankResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetListDropdownBankResultDto {
        let result = new GetListDropdownBankResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetListDropdownBankResultDto {
    bankID: number;
    bankName: string;
}

export class GetListPaymentCheckResultDto implements IGetListPaymentCheckResultDto {
    orderCode: string;
    projectID: number;
    projectCode: string;
    customerName: string;
    psCode: string;
    orderStatusName: string;
    ppOrderID: number;
    qty: number;
    totalAmount: number;
    outstanding: number;
    paidAmount: number;

    constructor(data?: IGetListPaymentCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.customerName = data["customerName"];
            this.psCode = data["psCode"];
            this.orderStatusName = data["orderStatusName"];
            this.ppOrderID = data["ppOrderID"];
            this.qty = data["qty"];
            this.totalAmount = data["totalAmount"];
            this.outstanding = data["outstanding"];
            this.paidAmount = data["paidAmount"];
        }
    }

    static fromJS(data: any): GetListPaymentCheckResultDto {
        let result = new GetListPaymentCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["customerName"] = this.customerName;
        data["psCode"] = this.psCode;
        data["orderStatusName"] = this.orderStatusName;
        data["ppOrderID"] = this.ppOrderID;
        data["qty"] = this.qty;
        data["totalAmount"] = this.totalAmount;
        data["outstanding"] = this.outstanding;
        data["paidAmount"] = this.paidAmount;
        return data; 
    }
}

export interface IGetListPaymentCheckResultDto {
    orderCode: string;
    projectID: number;
    projectCode: string;
    customerName: string;
    psCode: string;
    orderStatusName: string;
    ppOrderID: number;
    qty: number;
    totalAmount: number;
    outstanding: number;
    paidAmount: number;
}

export class GetReportPaymentInputDto implements IGetReportPaymentInputDto {
    projectID: number;
    paymentDateFrom: string;
    paymentDateTo: string;
    orderDateFrom: string;
    orderDateTo: string;
    clearDateFrom: string;
    clearDateTo: string;
    orderStatusID: number[];
    paymentType: number[];
    bankID: number[];
    keyword: string;

    constructor(data?: IGetReportPaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.paymentDateFrom = data["paymentDateFrom"];
            this.paymentDateTo = data["paymentDateTo"];
            this.orderDateFrom = data["orderDateFrom"];
            this.orderDateTo = data["orderDateTo"];
            this.clearDateFrom = data["clearDateFrom"];
            this.clearDateTo = data["clearDateTo"];
            if (data["orderStatusID"] && data["orderStatusID"].constructor === Array) {
                this.orderStatusID = [];
                for (let item of data["orderStatusID"])
                    this.orderStatusID.push(item);
            }
            if (data["paymentType"] && data["paymentType"].constructor === Array) {
                this.paymentType = [];
                for (let item of data["paymentType"])
                    this.paymentType.push(item);
            }
            if (data["bankID"] && data["bankID"].constructor === Array) {
                this.bankID = [];
                for (let item of data["bankID"])
                    this.bankID.push(item);
            }
            this.keyword = data["keyword"];
        }
    }

    static fromJS(data: any): GetReportPaymentInputDto {
        let result = new GetReportPaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["paymentDateFrom"] = this.paymentDateFrom;
        data["paymentDateTo"] = this.paymentDateTo;
        data["orderDateFrom"] = this.orderDateFrom;
        data["orderDateTo"] = this.orderDateTo;
        data["clearDateFrom"] = this.clearDateFrom;
        data["clearDateTo"] = this.clearDateTo;
        if (this.orderStatusID && this.orderStatusID.constructor === Array) {
            data["orderStatusID"] = [];
            for (let item of this.orderStatusID)
                data["orderStatusID"].push(item);
        }
        if (this.paymentType && this.paymentType.constructor === Array) {
            data["paymentType"] = [];
            for (let item of this.paymentType)
                data["paymentType"].push(item);
        }
        if (this.bankID && this.bankID.constructor === Array) {
            data["bankID"] = [];
            for (let item of this.bankID)
                data["bankID"].push(item);
        }
        data["keyword"] = this.keyword;
        return data; 
    }
}

export interface IGetReportPaymentInputDto {
    projectID: number;
    paymentDateFrom: string;
    paymentDateTo: string;
    orderDateFrom: string;
    orderDateTo: string;
    clearDateFrom: string;
    clearDateTo: string;
    orderStatusID: number[];
    paymentType: number[];
    bankID: number[];
    keyword: string;
}

export class GetReportPaymentResultDto implements IGetReportPaymentResultDto {
    year: string;
    yearMonth: string;
    paymentStatus: string;
    paymentDate: moment.Moment;
    orderDate: moment.Moment;
    clearDate: moment.Moment;
    bankName: string;
    customerName: string;
    paymentTypeName: string;
    orderCode: string;
    ppNo: string;
    accNo: string;
    accName: string;
    bankBranch: string;
    amount: number;
    bankID: number;
    paymentStatusID: number;
    paymentType: number;
    memberName: string;
    projectID: number;

    constructor(data?: IGetReportPaymentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.yearMonth = data["yearMonth"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.bankName = data["bankName"];
            this.customerName = data["customerName"];
            this.paymentTypeName = data["paymentTypeName"];
            this.orderCode = data["orderCode"];
            this.ppNo = data["ppNo"];
            this.accNo = data["accNo"];
            this.accName = data["accName"];
            this.bankBranch = data["bankBranch"];
            this.amount = data["amount"];
            this.bankID = data["bankID"];
            this.paymentStatusID = data["paymentStatusID"];
            this.paymentType = data["paymentType"];
            this.memberName = data["memberName"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetReportPaymentResultDto {
        let result = new GetReportPaymentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["yearMonth"] = this.yearMonth;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["bankName"] = this.bankName;
        data["customerName"] = this.customerName;
        data["paymentTypeName"] = this.paymentTypeName;
        data["orderCode"] = this.orderCode;
        data["ppNo"] = this.ppNo;
        data["accNo"] = this.accNo;
        data["accName"] = this.accName;
        data["bankBranch"] = this.bankBranch;
        data["amount"] = this.amount;
        data["bankID"] = this.bankID;
        data["paymentStatusID"] = this.paymentStatusID;
        data["paymentType"] = this.paymentType;
        data["memberName"] = this.memberName;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetReportPaymentResultDto {
    year: string;
    yearMonth: string;
    paymentStatus: string;
    paymentDate: moment.Moment;
    orderDate: moment.Moment;
    clearDate: moment.Moment;
    bankName: string;
    customerName: string;
    paymentTypeName: string;
    orderCode: string;
    ppNo: string;
    accNo: string;
    accName: string;
    bankBranch: string;
    amount: number;
    bankID: number;
    paymentStatusID: number;
    paymentType: number;
    memberName: string;
    projectID: number;
}

export class GetPaymentReportPdfInputDto implements IGetPaymentReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataPaymentDto;

    constructor(data?: IGetPaymentReportPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataPaymentDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentReportPdfInputDto {
        let result = new GetPaymentReportPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPaymentReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataPaymentDto;
}

export class ListDataPaymentDto implements IListDataPaymentDto {
    listHeader: ListHeaderPaymentDto[];
    listBody: ListBodyPaymentDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: number;

    constructor(data?: IListDataPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderPaymentDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyPaymentDto.fromJS(item));
            }
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.colspanTbl = data["colspanTbl"];
            this.grandTotal = data["grandTotal"];
        }
    }

    static fromJS(data: any): ListDataPaymentDto {
        let result = new ListDataPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["colspanTbl"] = this.colspanTbl;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IListDataPaymentDto {
    listHeader: ListHeaderPaymentDto[];
    listBody: ListBodyPaymentDto[];
    headerHtml: string;
    bodyHtml: string;
    colspanTbl: number;
    grandTotal: number;
}

export class ListHeaderPaymentDto implements IListHeaderPaymentDto {
    headerID: number;
    header: string;

    constructor(data?: IListHeaderPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.header = data["header"];
        }
    }

    static fromJS(data: any): ListHeaderPaymentDto {
        let result = new ListHeaderPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["header"] = this.header;
        return data; 
    }
}

export interface IListHeaderPaymentDto {
    headerID: number;
    header: string;
}

export class ListBodyPaymentDto implements IListBodyPaymentDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    paymentDate: string;
    clearDate: string;
    paymentStatus: string;
    ppNo: string;
    paymentTypeName: string;
    bankName: string;
    bankBranch: string;
    accNo: string;
    accName: string;
    customerName: string;
    amount: number;

    constructor(data?: IListBodyPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.yearMonth = data["yearMonth"];
            this.orderCode = data["orderCode"];
            this.paymentDate = data["paymentDate"];
            this.clearDate = data["clearDate"];
            this.paymentStatus = data["paymentStatus"];
            this.ppNo = data["ppNo"];
            this.paymentTypeName = data["paymentTypeName"];
            this.bankName = data["bankName"];
            this.bankBranch = data["bankBranch"];
            this.accNo = data["accNo"];
            this.accName = data["accName"];
            this.customerName = data["customerName"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): ListBodyPaymentDto {
        let result = new ListBodyPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["yearMonth"] = this.yearMonth;
        data["orderCode"] = this.orderCode;
        data["paymentDate"] = this.paymentDate;
        data["clearDate"] = this.clearDate;
        data["paymentStatus"] = this.paymentStatus;
        data["ppNo"] = this.ppNo;
        data["paymentTypeName"] = this.paymentTypeName;
        data["bankName"] = this.bankName;
        data["bankBranch"] = this.bankBranch;
        data["accNo"] = this.accNo;
        data["accName"] = this.accName;
        data["customerName"] = this.customerName;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IListBodyPaymentDto {
    year: string;
    yearMonth: string;
    orderCode: string;
    paymentDate: string;
    clearDate: string;
    paymentStatus: string;
    ppNo: string;
    paymentTypeName: string;
    bankName: string;
    bankBranch: string;
    accNo: string;
    accName: string;
    customerName: string;
    amount: number;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
}

export class GetDataUnitLamaListDto implements IGetDataUnitLamaListDto {
    bookCode: string;
    customer: string;
    email: string;
    unitCode: string;
    unitNo: string;
    unitIDLama: number;
    unitCodeIDLama: number;
    bookingHeaderID: number;
    hoDate: moment.Moment;
    typeHoDate: string;
    gracePeriod: number;

    constructor(data?: IGetDataUnitLamaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.customer = data["customer"];
            this.email = data["email"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitIDLama = data["unitIDLama"];
            this.unitCodeIDLama = data["unitCodeIDLama"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.hoDate = data["hoDate"] ? moment(data["hoDate"].toString()) : <any>undefined;
            this.typeHoDate = data["typeHoDate"];
            this.gracePeriod = data["gracePeriod"];
        }
    }

    static fromJS(data: any): GetDataUnitLamaListDto {
        let result = new GetDataUnitLamaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["customer"] = this.customer;
        data["email"] = this.email;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitIDLama"] = this.unitIDLama;
        data["unitCodeIDLama"] = this.unitCodeIDLama;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["hoDate"] = this.hoDate ? this.hoDate.toISOString() : <any>undefined;
        data["typeHoDate"] = this.typeHoDate;
        data["gracePeriod"] = this.gracePeriod;
        return data; 
    }
}

export interface IGetDataUnitLamaListDto {
    bookCode: string;
    customer: string;
    email: string;
    unitCode: string;
    unitNo: string;
    unitIDLama: number;
    unitCodeIDLama: number;
    bookingHeaderID: number;
    hoDate: moment.Moment;
    typeHoDate: string;
    gracePeriod: number;
}

export class GetDataUnitBaruListDto implements IGetDataUnitBaruListDto {
    bookCode: string;
    unitCodeLama: string;
    unitNoLama: string;
    customer: string;
    unitCodeBaru: string;
    unitNoBaru: string;
    bookingHeaderID: number;
    unitIDBaru: number;
    unitIDLama: number;

    constructor(data?: IGetDataUnitBaruListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCodeLama = data["unitCodeLama"];
            this.unitNoLama = data["unitNoLama"];
            this.customer = data["customer"];
            this.unitCodeBaru = data["unitCodeBaru"];
            this.unitNoBaru = data["unitNoBaru"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.unitIDBaru = data["unitIDBaru"];
            this.unitIDLama = data["unitIDLama"];
        }
    }

    static fromJS(data: any): GetDataUnitBaruListDto {
        let result = new GetDataUnitBaruListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCodeLama"] = this.unitCodeLama;
        data["unitNoLama"] = this.unitNoLama;
        data["customer"] = this.customer;
        data["unitCodeBaru"] = this.unitCodeBaru;
        data["unitNoBaru"] = this.unitNoBaru;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["unitIDBaru"] = this.unitIDBaru;
        data["unitIDLama"] = this.unitIDLama;
        return data; 
    }
}

export interface IGetDataUnitBaruListDto {
    bookCode: string;
    unitCodeLama: string;
    unitNoLama: string;
    customer: string;
    unitCodeBaru: string;
    unitNoBaru: string;
    bookingHeaderID: number;
    unitIDBaru: number;
    unitIDLama: number;
}

export class GetClusterDropdownPindahUnitListDto implements IGetClusterDropdownPindahUnitListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetClusterDropdownPindahUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetClusterDropdownPindahUnitListDto {
        let result = new GetClusterDropdownPindahUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetClusterDropdownPindahUnitListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class GetUnitCodeDropdownPindahUnitListDto implements IGetUnitCodeDropdownPindahUnitListDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;

    constructor(data?: IGetUnitCodeDropdownPindahUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeID = data["unitCodeID"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
        }
    }

    static fromJS(data: any): GetUnitCodeDropdownPindahUnitListDto {
        let result = new GetUnitCodeDropdownPindahUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeID"] = this.unitCodeID;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        return data; 
    }
}

export interface IGetUnitCodeDropdownPindahUnitListDto {
    unitCodeID: number;
    unitCode: string;
    unitName: string;
}

export class GetUnitNoPindahUnitListDto implements IGetUnitNoPindahUnitListDto {
    unitID: number;
    unitNo: string;
    projectID: number;

    constructor(data?: IGetUnitNoPindahUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetUnitNoPindahUnitListDto {
        let result = new GetUnitNoPindahUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetUnitNoPindahUnitListDto {
    unitID: number;
    unitNo: string;
    projectID: number;
}

export class PindahUnitInputDto implements IPindahUnitInputDto {
    bookingHeaderID: number;
    unitIDBaru: number;
    unitIDLama: number;
    hoDate: moment.Moment;
    typeHoDate: string;
    gracePeriod: number;

    constructor(data?: IPindahUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.unitIDBaru = data["unitIDBaru"];
            this.unitIDLama = data["unitIDLama"];
            this.hoDate = data["hoDate"] ? moment(data["hoDate"].toString()) : <any>undefined;
            this.typeHoDate = data["typeHoDate"];
            this.gracePeriod = data["gracePeriod"];
        }
    }

    static fromJS(data: any): PindahUnitInputDto {
        let result = new PindahUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["unitIDBaru"] = this.unitIDBaru;
        data["unitIDLama"] = this.unitIDLama;
        data["hoDate"] = this.hoDate ? this.hoDate.toISOString() : <any>undefined;
        data["typeHoDate"] = this.typeHoDate;
        data["gracePeriod"] = this.gracePeriod;
        return data; 
    }
}

export interface IPindahUnitInputDto {
    bookingHeaderID: number;
    unitIDBaru: number;
    unitIDLama: number;
    hoDate: moment.Moment;
    typeHoDate: string;
    gracePeriod: number;
}

export class GenerateAmandementInputDto implements IGenerateAmandementInputDto {
    bookCode: string;
    projectId: number;
    clusterName: string;

    constructor(data?: IGenerateAmandementInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.projectId = data["projectId"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GenerateAmandementInputDto {
        let result = new GenerateAmandementInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["projectId"] = this.projectId;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGenerateAmandementInputDto {
    bookCode: string;
    projectId: number;
    clusterName: string;
}

export class TypePreviewUnitResultDto implements ITypePreviewUnitResultDto {
    category: string;
    typeCode: string;
    detailCode: string;
    detailName: string;
    unitNo: string;

    constructor(data?: ITypePreviewUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.typeCode = data["typeCode"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): TypePreviewUnitResultDto {
        let result = new TypePreviewUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["typeCode"] = this.typeCode;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface ITypePreviewUnitResultDto {
    category: string;
    typeCode: string;
    detailCode: string;
    detailName: string;
    unitNo: string;
}

export class GetPreviewUnitResultDto implements IGetPreviewUnitResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: UnitPreviewDto[];
    message: string;
    unitID: number[];

    constructor(data?: IGetPreviewUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.floor = data["floor"];
            this.unitCodeId = data["unitCodeId"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitPreviewDto.fromJS(item));
            }
            this.message = data["message"];
            if (data["unitID"] && data["unitID"].constructor === Array) {
                this.unitID = [];
                for (let item of data["unitID"])
                    this.unitID.push(item);
            }
        }
    }

    static fromJS(data: any): GetPreviewUnitResultDto {
        let result = new GetPreviewUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["floor"] = this.floor;
        data["unitCodeId"] = this.unitCodeId;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        data["message"] = this.message;
        if (this.unitID && this.unitID.constructor === Array) {
            data["unitID"] = [];
            for (let item of this.unitID)
                data["unitID"].push(item);
        }
        return data; 
    }
}

export interface IGetPreviewUnitResultDto {
    diagramaticType: string;
    floor: string;
    unitCodeId: number;
    units: UnitPreviewDto[];
    message: string;
    unitID: number[];
}

export class UnitPreviewDto implements IUnitPreviewDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    floor: string;
    detailCode: string;

    constructor(data?: IUnitPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unitNo = data["unitNo"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.floor = data["floor"];
            this.detailCode = data["detailCode"];
        }
    }

    static fromJS(data: any): UnitPreviewDto {
        let result = new UnitPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitNo"] = this.unitNo;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["floor"] = this.floor;
        data["detailCode"] = this.detailCode;
        return data; 
    }
}

export interface IUnitPreviewDto {
    unitId: number;
    unitNo: string;
    unitStatusCode: string;
    unitStatusName: string;
    floor: string;
    detailCode: string;
}

export class ListDetailPreviewUnitResultDto implements IListDetailPreviewUnitResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    size: number;
    bedroom: string;
    category: string;
    pricePerArea: number;
    listTermCode: ListTermCode[];

    constructor(data?: IListDetailPreviewUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitItemID = data["unitItemID"];
            this.itemID = data["itemID"];
            this.unitCode = data["unitCode"];
            this.unitStatus = data["unitStatus"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.unitNo = data["unitNo"];
            this.size = data["size"];
            this.bedroom = data["bedroom"];
            this.category = data["category"];
            this.pricePerArea = data["pricePerArea"];
            if (data["listTermCode"] && data["listTermCode"].constructor === Array) {
                this.listTermCode = [];
                for (let item of data["listTermCode"])
                    this.listTermCode.push(ListTermCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDetailPreviewUnitResultDto {
        let result = new ListDetailPreviewUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitItemID"] = this.unitItemID;
        data["itemID"] = this.itemID;
        data["unitCode"] = this.unitCode;
        data["unitStatus"] = this.unitStatus;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["unitNo"] = this.unitNo;
        data["size"] = this.size;
        data["bedroom"] = this.bedroom;
        data["category"] = this.category;
        data["pricePerArea"] = this.pricePerArea;
        if (this.listTermCode && this.listTermCode.constructor === Array) {
            data["listTermCode"] = [];
            for (let item of this.listTermCode)
                data["listTermCode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListDetailPreviewUnitResultDto {
    unitID: number;
    unitItemID: number;
    itemID: number;
    unitCode: string;
    unitStatus: string;
    bookingFee: number;
    sellingPrice: number;
    unitNo: string;
    size: number;
    bedroom: string;
    category: string;
    pricePerArea: number;
    listTermCode: ListTermCode[];
}

export class ListTermCode implements IListTermCode {
    termCode: string;
    sortNo: number;
    term: ListTermPreviewUnit[];

    constructor(data?: IListTermCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termCode = data["termCode"];
            this.sortNo = data["sortNo"];
            if (data["term"] && data["term"].constructor === Array) {
                this.term = [];
                for (let item of data["term"])
                    this.term.push(ListTermPreviewUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListTermCode {
        let result = new ListTermCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["sortNo"] = this.sortNo;
        if (this.term && this.term.constructor === Array) {
            data["term"] = [];
            for (let item of this.term)
                data["term"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListTermCode {
    termCode: string;
    sortNo: number;
    term: ListTermPreviewUnit[];
}

export class ListTermPreviewUnit implements IListTermPreviewUnit {
    termID: number;
    termName: string;
    termNo: number;
    sortNo: number;
    dataTerm: ListDataTermPreviewUnit[];

    constructor(data?: IListTermPreviewUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
            if (data["dataTerm"] && data["dataTerm"].constructor === Array) {
                this.dataTerm = [];
                for (let item of data["dataTerm"])
                    this.dataTerm.push(ListDataTermPreviewUnit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListTermPreviewUnit {
        let result = new ListTermPreviewUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        if (this.dataTerm && this.dataTerm.constructor === Array) {
            data["dataTerm"] = [];
            for (let item of this.dataTerm)
                data["dataTerm"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListTermPreviewUnit {
    termID: number;
    termName: string;
    termNo: number;
    sortNo: number;
    dataTerm: ListDataTermPreviewUnit[];
}

export class ListDataTermPreviewUnit implements IListDataTermPreviewUnit {
    termID: number;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;

    constructor(data?: IListDataTermPreviewUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.listPrice = data["listPrice"];
            this.termNo = data["termNo"];
            this.sortNo = data["sortNo"];
        }
    }

    static fromJS(data: any): ListDataTermPreviewUnit {
        let result = new ListDataTermPreviewUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["listPrice"] = this.listPrice;
        data["termNo"] = this.termNo;
        data["sortNo"] = this.sortNo;
        return data; 
    }
}

export interface IListDataTermPreviewUnit {
    termID: number;
    renovID: number;
    renovName: string;
    listPrice: number;
    termNo: number;
    sortNo: number;
}

export class UpdatePricePerClusterInputDto implements IUpdatePricePerClusterInputDto {
    projectId: number;
    clusterId: number;
    termMainId: number;
    termId: number[];
    renovId: number[];
    type: number;
    amount: number;
    percentage: number;
    manual: boolean;
    percentBangunan: number;
    percentTanah: number;
    percentRenov: number;

    constructor(data?: IUpdatePricePerClusterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.clusterId = data["clusterId"];
            this.termMainId = data["termMainId"];
            if (data["termId"] && data["termId"].constructor === Array) {
                this.termId = [];
                for (let item of data["termId"])
                    this.termId.push(item);
            }
            if (data["renovId"] && data["renovId"].constructor === Array) {
                this.renovId = [];
                for (let item of data["renovId"])
                    this.renovId.push(item);
            }
            this.type = data["type"];
            this.amount = data["amount"];
            this.percentage = data["percentage"];
            this.manual = data["manual"];
            this.percentBangunan = data["percentBangunan"];
            this.percentTanah = data["percentTanah"];
            this.percentRenov = data["percentRenov"];
        }
    }

    static fromJS(data: any): UpdatePricePerClusterInputDto {
        let result = new UpdatePricePerClusterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["clusterId"] = this.clusterId;
        data["termMainId"] = this.termMainId;
        if (this.termId && this.termId.constructor === Array) {
            data["termId"] = [];
            for (let item of this.termId)
                data["termId"].push(item);
        }
        if (this.renovId && this.renovId.constructor === Array) {
            data["renovId"] = [];
            for (let item of this.renovId)
                data["renovId"].push(item);
        }
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["percentage"] = this.percentage;
        data["manual"] = this.manual;
        data["percentBangunan"] = this.percentBangunan;
        data["percentTanah"] = this.percentTanah;
        data["percentRenov"] = this.percentRenov;
        return data; 
    }
}

export interface IUpdatePricePerClusterInputDto {
    projectId: number;
    clusterId: number;
    termMainId: number;
    termId: number[];
    renovId: number[];
    type: number;
    amount: number;
    percentage: number;
    manual: boolean;
    percentBangunan: number;
    percentTanah: number;
    percentRenov: number;
}

export class GetDataTaskListResultDto implements IGetDataTaskListResultDto {
    unitId: number;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetDataTaskListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetDataTaskListResultDto {
        let result = new GetDataTaskListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetDataTaskListResultDto {
    unitId: number;
    unitCode: string;
    unitNo: string;
}

export class GetDataToUpdateResultDto implements IGetDataToUpdateResultDto {
    termId: number;
    termRemarks: string;
    tanah: number;
    bangunan: number;
    renov: number;

    constructor(data?: IGetDataToUpdateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.termRemarks = data["termRemarks"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
        }
    }

    static fromJS(data: any): GetDataToUpdateResultDto {
        let result = new GetDataToUpdateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["termRemarks"] = this.termRemarks;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        return data; 
    }
}

export interface IGetDataToUpdateResultDto {
    termId: number;
    termRemarks: string;
    tanah: number;
    bangunan: number;
    renov: number;
}

export class UpdatePricePerUnitInputDto implements IUpdatePricePerUnitInputDto {
    unitId: number;
    renovId: number;
    unitUpdate: UnitItemToUpdate[];

    constructor(data?: IUpdatePricePerUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.renovId = data["renovId"];
            if (data["unitUpdate"] && data["unitUpdate"].constructor === Array) {
                this.unitUpdate = [];
                for (let item of data["unitUpdate"])
                    this.unitUpdate.push(UnitItemToUpdate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePricePerUnitInputDto {
        let result = new UpdatePricePerUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["renovId"] = this.renovId;
        if (this.unitUpdate && this.unitUpdate.constructor === Array) {
            data["unitUpdate"] = [];
            for (let item of this.unitUpdate)
                data["unitUpdate"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePricePerUnitInputDto {
    unitId: number;
    renovId: number;
    unitUpdate: UnitItemToUpdate[];
}

export class UnitItemToUpdate implements IUnitItemToUpdate {
    termId: number;
    tanah: number;
    bangunan: number;
    renov: number;

    constructor(data?: IUnitItemToUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
        }
    }

    static fromJS(data: any): UnitItemToUpdate {
        let result = new UnitItemToUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        return data; 
    }
}

export interface IUnitItemToUpdate {
    termId: number;
    tanah: number;
    bangunan: number;
    renov: number;
}

export class GetRenovationDropdownListDto implements IGetRenovationDropdownListDto {
    renovId: number;
    renovCode: string;
    renovName: string;

    constructor(data?: IGetRenovationDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovId = data["renovId"];
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
        }
    }

    static fromJS(data: any): GetRenovationDropdownListDto {
        let result = new GetRenovationDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovId"] = this.renovId;
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        return data; 
    }
}

export interface IGetRenovationDropdownListDto {
    renovId: number;
    renovCode: string;
    renovName: string;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code: string;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ListResultDtoOfGetListPromotionResultDto implements IListResultDtoOfGetListPromotionResultDto {
    items: GetListPromotionResultDto[];

    constructor(data?: IListResultDtoOfGetListPromotionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListPromotionResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListPromotionResultDto {
        let result = new ListResultDtoOfGetListPromotionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListPromotionResultDto {
    items: GetListPromotionResultDto[];
}

export class GetListPromotionResultDto implements IGetListPromotionResultDto {
    projectID: number;
    projectName: string;
    listPromo: ListPromo[];

    constructor(data?: IGetListPromotionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            if (data["listPromo"] && data["listPromo"].constructor === Array) {
                this.listPromo = [];
                for (let item of data["listPromo"])
                    this.listPromo.push(ListPromo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListPromotionResultDto {
        let result = new GetListPromotionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        if (this.listPromo && this.listPromo.constructor === Array) {
            data["listPromo"] = [];
            for (let item of this.listPromo)
                data["listPromo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListPromotionResultDto {
    projectID: number;
    projectName: string;
    listPromo: ListPromo[];
}

export class ListPromo implements IListPromo {
    promoFile: string;
    promoDataType: string;
    targetURL: string;
    isActive: boolean;
    promoID: number;

    constructor(data?: IListPromo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promoFile = data["promoFile"];
            this.promoDataType = data["promoDataType"];
            this.targetURL = data["targetURL"];
            this.isActive = data["isActive"];
            this.promoID = data["promoID"];
        }
    }

    static fromJS(data: any): ListPromo {
        let result = new ListPromo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoFile"] = this.promoFile;
        data["promoDataType"] = this.promoDataType;
        data["targetURL"] = this.targetURL;
        data["isActive"] = this.isActive;
        data["promoID"] = this.promoID;
        return data; 
    }
}

export interface IListPromo {
    promoFile: string;
    promoDataType: string;
    targetURL: string;
    isActive: boolean;
    promoID: number;
}

export class GetAllListPromotionDto implements IGetAllListPromotionDto {
    projectID: number;
    promoFile: string;
    promoDataType: string;
    targetURL: string;
    isActive: boolean;

    constructor(data?: IGetAllListPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.promoFile = data["promoFile"];
            this.promoDataType = data["promoDataType"];
            this.targetURL = data["targetURL"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetAllListPromotionDto {
        let result = new GetAllListPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["promoFile"] = this.promoFile;
        data["promoDataType"] = this.promoDataType;
        data["targetURL"] = this.targetURL;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetAllListPromotionDto {
    projectID: number;
    promoFile: string;
    promoDataType: string;
    targetURL: string;
    isActive: boolean;
}

export class DetailProjectResultDto implements IDetailProjectResultDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    cluster: ClusterResultDto[];
    message: string;

    constructor(data?: IDetailProjectResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            if (data["cluster"] && data["cluster"].constructor === Array) {
                this.cluster = [];
                for (let item of data["cluster"])
                    this.cluster.push(ClusterResultDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): DetailProjectResultDto {
        let result = new DetailProjectResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        if (this.cluster && this.cluster.constructor === Array) {
            data["cluster"] = [];
            for (let item of this.cluster)
                data["cluster"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IDetailProjectResultDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    cluster: ClusterResultDto[];
    message: string;
}

export class ClusterResultDto implements IClusterResultDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;
    isRequiredPP: boolean;

    constructor(data?: IClusterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterId = data["clusterId"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): ClusterResultDto {
        let result = new ClusterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterId"] = this.clusterId;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IClusterResultDto {
    clusterId: number;
    clusterCode: string;
    clusterName: string;
    isRequiredPP: boolean;
}

export class GetChildMemberCodeDto implements IGetChildMemberCodeDto {
    memberCode: string;
    level: number;

    constructor(data?: IGetChildMemberCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.level = data["level"];
        }
    }

    static fromJS(data: any): GetChildMemberCodeDto {
        let result = new GetChildMemberCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["level"] = this.level;
        return data; 
    }
}

export interface IGetChildMemberCodeDto {
    memberCode: string;
    level: number;
}

export class ListResultDtoOfListDevelopmentCityResultDto implements IListResultDtoOfListDevelopmentCityResultDto {
    items: ListDevelopmentCityResultDto[];

    constructor(data?: IListResultDtoOfListDevelopmentCityResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListDevelopmentCityResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListDevelopmentCityResultDto {
        let result = new ListResultDtoOfListDevelopmentCityResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListDevelopmentCityResultDto {
    items: ListDevelopmentCityResultDto[];
}

export class ListDevelopmentCityResultDto implements IListDevelopmentCityResultDto {
    parentProjectName: string;
    message: string;

    constructor(data?: IListDevelopmentCityResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentProjectName = data["parentProjectName"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListDevelopmentCityResultDto {
        let result = new ListDevelopmentCityResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentProjectName"] = this.parentProjectName;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListDevelopmentCityResultDto {
    parentProjectName: string;
    message: string;
}

export class GetListProductResultDto implements IGetListProductResultDto {
    productCode: string;
    sorting: number;
    projectCode: string;
    projectID: number;
    productID: number;
    productName: string;
    productLogo: string;
    isOBActive: boolean;
    isPPOLActive: boolean;
    isRequiredPP: boolean;

    constructor(data?: IGetListProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.sorting = data["sorting"];
            this.projectCode = data["projectCode"];
            this.projectID = data["projectID"];
            this.productID = data["productID"];
            this.productName = data["productName"];
            this.productLogo = data["productLogo"];
            this.isOBActive = data["isOBActive"];
            this.isPPOLActive = data["isPPOLActive"];
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): GetListProductResultDto {
        let result = new GetListProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["sorting"] = this.sorting;
        data["projectCode"] = this.projectCode;
        data["projectID"] = this.projectID;
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        data["productLogo"] = this.productLogo;
        data["isOBActive"] = this.isOBActive;
        data["isPPOLActive"] = this.isPPOLActive;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IGetListProductResultDto {
    productCode: string;
    sorting: number;
    projectCode: string;
    projectID: number;
    productID: number;
    productName: string;
    productLogo: string;
    isOBActive: boolean;
    isPPOLActive: boolean;
    isRequiredPP: boolean;
}

export class ListResultDtoOfListProductResultDto implements IListResultDtoOfListProductResultDto {
    items: ListProductResultDto[];

    constructor(data?: IListResultDtoOfListProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProductResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProductResultDto {
        let result = new ListResultDtoOfListProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProductResultDto {
    items: ListProductResultDto[];
}

export class ListProductResultDto implements IListProductResultDto {
    productCode: string;
    projectCode: string;
    projectID: number;
    productID: number;
    productName: string;
    productLogo: string;
    isOBActive: boolean;
    isRequiredPP: boolean;
    message: string;
    isPPOLActive: boolean;

    constructor(data?: IListProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.projectCode = data["projectCode"];
            this.projectID = data["projectID"];
            this.productID = data["productID"];
            this.productName = data["productName"];
            this.productLogo = data["productLogo"];
            this.isOBActive = data["isOBActive"];
            this.isRequiredPP = data["isRequiredPP"];
            this.message = data["message"];
            this.isPPOLActive = data["isPPOLActive"];
        }
    }

    static fromJS(data: any): ListProductResultDto {
        let result = new ListProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["projectCode"] = this.projectCode;
        data["projectID"] = this.projectID;
        data["productID"] = this.productID;
        data["productName"] = this.productName;
        data["productLogo"] = this.productLogo;
        data["isOBActive"] = this.isOBActive;
        data["isRequiredPP"] = this.isRequiredPP;
        data["message"] = this.message;
        data["isPPOLActive"] = this.isPPOLActive;
        return data; 
    }
}

export interface IListProductResultDto {
    productCode: string;
    projectCode: string;
    projectID: number;
    productID: number;
    productName: string;
    productLogo: string;
    isOBActive: boolean;
    isRequiredPP: boolean;
    message: string;
    isPPOLActive: boolean;
}

export class ListResultDtoOfListProjectInfoResultDto implements IListResultDtoOfListProjectInfoResultDto {
    items: ListProjectInfoResultDto[];

    constructor(data?: IListResultDtoOfListProjectInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProjectInfoResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProjectInfoResultDto {
        let result = new ListResultDtoOfListProjectInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProjectInfoResultDto {
    items: ListProjectInfoResultDto[];
}

export class ListProjectInfoResultDto implements IListProjectInfoResultDto {
    projectInfoID: number;
    projectID: number;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    projectStatus: boolean;
    projectDesc: string;
    message: string;

    constructor(data?: IListProjectInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.projectID = data["projectID"];
            this.projectDeveloper = data["projectDeveloper"];
            this.projectWebsite = data["projectWebsite"];
            this.projectMarketingOffice = data["projectMarketingOffice"];
            this.projectMarketingPhone = data["projectMarketingPhone"];
            this.sitePlansImageUrl = data["sitePlansImageUrl"];
            this.sitePlansLegend = data["sitePlansLegend"];
            this.projectStatus = data["projectStatus"];
            this.projectDesc = data["projectDesc"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListProjectInfoResultDto {
        let result = new ListProjectInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["projectID"] = this.projectID;
        data["projectDeveloper"] = this.projectDeveloper;
        data["projectWebsite"] = this.projectWebsite;
        data["projectMarketingOffice"] = this.projectMarketingOffice;
        data["projectMarketingPhone"] = this.projectMarketingPhone;
        data["sitePlansImageUrl"] = this.sitePlansImageUrl;
        data["sitePlansLegend"] = this.sitePlansLegend;
        data["projectStatus"] = this.projectStatus;
        data["projectDesc"] = this.projectDesc;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListProjectInfoResultDto {
    projectInfoID: number;
    projectID: number;
    projectDeveloper: string;
    projectWebsite: string;
    projectMarketingOffice: string;
    projectMarketingPhone: string;
    sitePlansImageUrl: string;
    sitePlansLegend: string;
    projectStatus: boolean;
    projectDesc: string;
    message: string;
}

export class ListResultDtoOfListProjectKeyFeaturesResultDto implements IListResultDtoOfListProjectKeyFeaturesResultDto {
    items: ListProjectKeyFeaturesResultDto[];

    constructor(data?: IListResultDtoOfListProjectKeyFeaturesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProjectKeyFeaturesResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProjectKeyFeaturesResultDto {
        let result = new ListResultDtoOfListProjectKeyFeaturesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProjectKeyFeaturesResultDto {
    items: ListProjectKeyFeaturesResultDto[];
}

export class ListProjectKeyFeaturesResultDto implements IListProjectKeyFeaturesResultDto {
    projectKeyFeaturesID: number;
    keyFeatures: string;
    status: number;
    message: string;

    constructor(data?: IListProjectKeyFeaturesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectKeyFeaturesID = data["projectKeyFeaturesID"];
            this.keyFeatures = data["keyFeatures"];
            this.status = data["status"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListProjectKeyFeaturesResultDto {
        let result = new ListProjectKeyFeaturesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectKeyFeaturesID"] = this.projectKeyFeaturesID;
        data["keyFeatures"] = this.keyFeatures;
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListProjectKeyFeaturesResultDto {
    projectKeyFeaturesID: number;
    keyFeatures: string;
    status: number;
    message: string;
}

export class ListResultDtoOfListProjectLocationResultDto implements IListResultDtoOfListProjectLocationResultDto {
    items: ListProjectLocationResultDto[];

    constructor(data?: IListResultDtoOfListProjectLocationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProjectLocationResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProjectLocationResultDto {
        let result = new ListResultDtoOfListProjectLocationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProjectLocationResultDto {
    items: ListProjectLocationResultDto[];
}

export class ListProjectLocationResultDto implements IListProjectLocationResultDto {
    projectLocationID: number;
    projectInfoID: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    message: string;

    constructor(data?: IListProjectLocationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectLocationID = data["projectLocationID"];
            this.projectInfoID = data["projectInfoID"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.projectAddress = data["projectAddress"];
            this.locationImageURL = data["locationImageURL"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListProjectLocationResultDto {
        let result = new ListProjectLocationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectLocationID"] = this.projectLocationID;
        data["projectInfoID"] = this.projectInfoID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["projectAddress"] = this.projectAddress;
        data["locationImageURL"] = this.locationImageURL;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListProjectLocationResultDto {
    projectLocationID: number;
    projectInfoID: number;
    latitude: number;
    longitude: number;
    projectAddress: string;
    locationImageURL: string;
    message: string;
}

export class ListResultDtoOfListUnitTypeByClusterResultDto implements IListResultDtoOfListUnitTypeByClusterResultDto {
    items: ListUnitTypeByClusterResultDto[];

    constructor(data?: IListResultDtoOfListUnitTypeByClusterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListUnitTypeByClusterResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListUnitTypeByClusterResultDto {
        let result = new ListResultDtoOfListUnitTypeByClusterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListUnitTypeByClusterResultDto {
    items: ListUnitTypeByClusterResultDto[];
}

export class ListUnitTypeByClusterResultDto implements IListUnitTypeByClusterResultDto {
    unitTypeID: number;
    unitType: string;
    message: string;
    image: string;

    constructor(data?: IListUnitTypeByClusterResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitTypeID = data["unitTypeID"];
            this.unitType = data["unitType"];
            this.message = data["message"];
            this.image = data["image"];
        }
    }

    static fromJS(data: any): ListUnitTypeByClusterResultDto {
        let result = new ListUnitTypeByClusterResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitTypeID"] = this.unitTypeID;
        data["unitType"] = this.unitType;
        data["message"] = this.message;
        data["image"] = this.image;
        return data; 
    }
}

export interface IListUnitTypeByClusterResultDto {
    unitTypeID: number;
    unitType: string;
    message: string;
    image: string;
}

export class ListResultDtoOfListUnitTypeByProjectIdResultDto implements IListResultDtoOfListUnitTypeByProjectIdResultDto {
    items: ListUnitTypeByProjectIdResultDto[];

    constructor(data?: IListResultDtoOfListUnitTypeByProjectIdResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListUnitTypeByProjectIdResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListUnitTypeByProjectIdResultDto {
        let result = new ListResultDtoOfListUnitTypeByProjectIdResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListUnitTypeByProjectIdResultDto {
    items: ListUnitTypeByProjectIdResultDto[];
}

export class ListUnitTypeByProjectIdResultDto implements IListUnitTypeByProjectIdResultDto {
    unitTypeID: number;
    unitType: string;
    message: string;
    clusterID: number;
    clusterName: string;
    image: string;
    area: number;

    constructor(data?: IListUnitTypeByProjectIdResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitTypeID = data["unitTypeID"];
            this.unitType = data["unitType"];
            this.message = data["message"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.image = data["image"];
            this.area = data["area"];
        }
    }

    static fromJS(data: any): ListUnitTypeByProjectIdResultDto {
        let result = new ListUnitTypeByProjectIdResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitTypeID"] = this.unitTypeID;
        data["unitType"] = this.unitType;
        data["message"] = this.message;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["image"] = this.image;
        data["area"] = this.area;
        return data; 
    }
}

export interface IListUnitTypeByProjectIdResultDto {
    unitTypeID: number;
    unitType: string;
    message: string;
    clusterID: number;
    clusterName: string;
    image: string;
    area: number;
}

export class ListResultDtoOfListProjectImageGalleryResultDto implements IListResultDtoOfListProjectImageGalleryResultDto {
    items: ListProjectImageGalleryResultDto[];

    constructor(data?: IListResultDtoOfListProjectImageGalleryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListProjectImageGalleryResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfListProjectImageGalleryResultDto {
        let result = new ListResultDtoOfListProjectImageGalleryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfListProjectImageGalleryResultDto {
    items: ListProjectImageGalleryResultDto[];
}

export class ListProjectImageGalleryResultDto implements IListProjectImageGalleryResultDto {
    projectImageGalleryID: number;
    projectInfoID: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    projectID: number;

    constructor(data?: IListProjectImageGalleryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectImageGalleryID = data["projectImageGalleryID"];
            this.projectInfoID = data["projectInfoID"];
            this.imageURL = data["imageURL"];
            this.imageAlt = data["imageAlt"];
            this.imageStatus = data["imageStatus"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): ListProjectImageGalleryResultDto {
        let result = new ListProjectImageGalleryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectImageGalleryID"] = this.projectImageGalleryID;
        data["projectInfoID"] = this.projectInfoID;
        data["imageURL"] = this.imageURL;
        data["imageAlt"] = this.imageAlt;
        data["imageStatus"] = this.imageStatus;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IListProjectImageGalleryResultDto {
    projectImageGalleryID: number;
    projectInfoID: number;
    imageURL: string;
    imageAlt: string;
    imageStatus: boolean;
    projectID: number;
}

export class GetClusterListDto implements IGetClusterListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;

    constructor(data?: IGetClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
        }
    }

    static fromJS(data: any): GetClusterListDto {
        let result = new GetClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        return data; 
    }
}

export interface IGetClusterListDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
}

export class ProjectSchedulerSetupDto implements IProjectSchedulerSetupDto {
    project: string;
    module: string;

    constructor(data?: IProjectSchedulerSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.project = data["project"];
            this.module = data["module"];
        }
    }

    static fromJS(data: any): ProjectSchedulerSetupDto {
        let result = new ProjectSchedulerSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project;
        data["module"] = this.module;
        return data; 
    }
}

export interface IProjectSchedulerSetupDto {
    project: string;
    module: string;
}

export class ProjectSchedulerSetupResultDto implements IProjectSchedulerSetupResultDto {
    message: string;
    messageUpdate: string;

    constructor(data?: IProjectSchedulerSetupResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.messageUpdate = data["messageUpdate"];
        }
    }

    static fromJS(data: any): ProjectSchedulerSetupResultDto {
        let result = new ProjectSchedulerSetupResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageUpdate"] = this.messageUpdate;
        return data; 
    }
}

export interface IProjectSchedulerSetupResultDto {
    message: string;
    messageUpdate: string;
}

export class GetTasklistPromotionDto implements IGetTasklistPromotionDto {
    projectIdList: number[];
    projectNameList: string[];
    promotionId: number[];
    group: string;
    notifTypeCode: string;
    notificationType: string;
    user: string;
    isAll: boolean;
    startDate: string;
    endDate: string;
    isActive: boolean;
    creationTime: moment.Moment;

    constructor(data?: IGetTasklistPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectIdList"] && data["projectIdList"].constructor === Array) {
                this.projectIdList = [];
                for (let item of data["projectIdList"])
                    this.projectIdList.push(item);
            }
            if (data["projectNameList"] && data["projectNameList"].constructor === Array) {
                this.projectNameList = [];
                for (let item of data["projectNameList"])
                    this.projectNameList.push(item);
            }
            if (data["promotionId"] && data["promotionId"].constructor === Array) {
                this.promotionId = [];
                for (let item of data["promotionId"])
                    this.promotionId.push(item);
            }
            this.group = data["group"];
            this.notifTypeCode = data["notifTypeCode"];
            this.notificationType = data["notificationType"];
            this.user = data["user"];
            this.isAll = data["isAll"];
            this.startDate = data["startDate"];
            this.endDate = data["endDate"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTasklistPromotionDto {
        let result = new GetTasklistPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectIdList && this.projectIdList.constructor === Array) {
            data["projectIdList"] = [];
            for (let item of this.projectIdList)
                data["projectIdList"].push(item);
        }
        if (this.projectNameList && this.projectNameList.constructor === Array) {
            data["projectNameList"] = [];
            for (let item of this.projectNameList)
                data["projectNameList"].push(item);
        }
        if (this.promotionId && this.promotionId.constructor === Array) {
            data["promotionId"] = [];
            for (let item of this.promotionId)
                data["promotionId"].push(item);
        }
        data["group"] = this.group;
        data["notifTypeCode"] = this.notifTypeCode;
        data["notificationType"] = this.notificationType;
        data["user"] = this.user;
        data["isAll"] = this.isAll;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetTasklistPromotionDto {
    projectIdList: number[];
    projectNameList: string[];
    promotionId: number[];
    group: string;
    notifTypeCode: string;
    notificationType: string;
    user: string;
    isAll: boolean;
    startDate: string;
    endDate: string;
    isActive: boolean;
    creationTime: moment.Moment;
}

export class GetDetailPromotionDto implements IGetDetailPromotionDto {
    projectIdList: number[];
    projectNameList: string[];
    promotionId: number[];
    group: string;
    notificationType: string;
    promo: string;
    url1: string;
    image1: string;
    image2: string;
    image3: string;
    startDate: string;
    endDate: string;

    constructor(data?: IGetDetailPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectIdList"] && data["projectIdList"].constructor === Array) {
                this.projectIdList = [];
                for (let item of data["projectIdList"])
                    this.projectIdList.push(item);
            }
            if (data["projectNameList"] && data["projectNameList"].constructor === Array) {
                this.projectNameList = [];
                for (let item of data["projectNameList"])
                    this.projectNameList.push(item);
            }
            if (data["promotionId"] && data["promotionId"].constructor === Array) {
                this.promotionId = [];
                for (let item of data["promotionId"])
                    this.promotionId.push(item);
            }
            this.group = data["group"];
            this.notificationType = data["notificationType"];
            this.promo = data["promo"];
            this.url1 = data["url1"];
            this.image1 = data["image1"];
            this.image2 = data["image2"];
            this.image3 = data["image3"];
            this.startDate = data["startDate"];
            this.endDate = data["endDate"];
        }
    }

    static fromJS(data: any): GetDetailPromotionDto {
        let result = new GetDetailPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectIdList && this.projectIdList.constructor === Array) {
            data["projectIdList"] = [];
            for (let item of this.projectIdList)
                data["projectIdList"].push(item);
        }
        if (this.projectNameList && this.projectNameList.constructor === Array) {
            data["projectNameList"] = [];
            for (let item of this.projectNameList)
                data["projectNameList"].push(item);
        }
        if (this.promotionId && this.promotionId.constructor === Array) {
            data["promotionId"] = [];
            for (let item of this.promotionId)
                data["promotionId"].push(item);
        }
        data["group"] = this.group;
        data["notificationType"] = this.notificationType;
        data["promo"] = this.promo;
        data["url1"] = this.url1;
        data["image1"] = this.image1;
        data["image2"] = this.image2;
        data["image3"] = this.image3;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data; 
    }
}

export interface IGetDetailPromotionDto {
    projectIdList: number[];
    projectNameList: string[];
    promotionId: number[];
    group: string;
    notificationType: string;
    promo: string;
    url1: string;
    image1: string;
    image2: string;
    image3: string;
    startDate: string;
    endDate: string;
}

export class CreatePromotionInputDto implements ICreatePromotionInputDto {
    projectId: number[];
    group: string;
    notifTypeCode: string;
    promo: string;
    url: string;
    promoImage: AttachmentFileListDto[];
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor(data?: ICreatePromotionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectId"] && data["projectId"].constructor === Array) {
                this.projectId = [];
                for (let item of data["projectId"])
                    this.projectId.push(item);
            }
            this.group = data["group"];
            this.notifTypeCode = data["notifTypeCode"];
            this.promo = data["promo"];
            this.url = data["url"];
            if (data["promoImage"] && data["promoImage"].constructor === Array) {
                this.promoImage = [];
                for (let item of data["promoImage"])
                    this.promoImage.push(AttachmentFileListDto.fromJS(item));
            }
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePromotionInputDto {
        let result = new CreatePromotionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectId && this.projectId.constructor === Array) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["group"] = this.group;
        data["notifTypeCode"] = this.notifTypeCode;
        data["promo"] = this.promo;
        data["url"] = this.url;
        if (this.promoImage && this.promoImage.constructor === Array) {
            data["promoImage"] = [];
            for (let item of this.promoImage)
                data["promoImage"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICreatePromotionInputDto {
    projectId: number[];
    group: string;
    notifTypeCode: string;
    promo: string;
    url: string;
    promoImage: AttachmentFileListDto[];
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class UpdatePromotionInputDto implements IUpdatePromotionInputDto {
    promotionId: number[];
    projectId: number[];
    group: string;
    notifTypeCode: string;
    promo: string;
    url: string;
    promoImage: AttachmentFileListDto[];
    isActive: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor(data?: IUpdatePromotionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["promotionId"] && data["promotionId"].constructor === Array) {
                this.promotionId = [];
                for (let item of data["promotionId"])
                    this.promotionId.push(item);
            }
            if (data["projectId"] && data["projectId"].constructor === Array) {
                this.projectId = [];
                for (let item of data["projectId"])
                    this.projectId.push(item);
            }
            this.group = data["group"];
            this.notifTypeCode = data["notifTypeCode"];
            this.promo = data["promo"];
            this.url = data["url"];
            if (data["promoImage"] && data["promoImage"].constructor === Array) {
                this.promoImage = [];
                for (let item of data["promoImage"])
                    this.promoImage.push(AttachmentFileListDto.fromJS(item));
            }
            this.isActive = data["isActive"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePromotionInputDto {
        let result = new UpdatePromotionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.promotionId && this.promotionId.constructor === Array) {
            data["promotionId"] = [];
            for (let item of this.promotionId)
                data["promotionId"].push(item);
        }
        if (this.projectId && this.projectId.constructor === Array) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        data["group"] = this.group;
        data["notifTypeCode"] = this.notifTypeCode;
        data["promo"] = this.promo;
        data["url"] = this.url;
        if (this.promoImage && this.promoImage.constructor === Array) {
            data["promoImage"] = [];
            for (let item of this.promoImage)
                data["promoImage"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePromotionInputDto {
    promotionId: number[];
    projectId: number[];
    group: string;
    notifTypeCode: string;
    promo: string;
    url: string;
    promoImage: AttachmentFileListDto[];
    isActive: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class GetDropDownNotifTypeDto implements IGetDropDownNotifTypeDto {
    parentType: string[];
    notifType: GetNotifTypeDto[];

    constructor(data?: IGetDropDownNotifTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["parentType"] && data["parentType"].constructor === Array) {
                this.parentType = [];
                for (let item of data["parentType"])
                    this.parentType.push(item);
            }
            if (data["notifType"] && data["notifType"].constructor === Array) {
                this.notifType = [];
                for (let item of data["notifType"])
                    this.notifType.push(GetNotifTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDropDownNotifTypeDto {
        let result = new GetDropDownNotifTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.parentType && this.parentType.constructor === Array) {
            data["parentType"] = [];
            for (let item of this.parentType)
                data["parentType"].push(item);
        }
        if (this.notifType && this.notifType.constructor === Array) {
            data["notifType"] = [];
            for (let item of this.notifType)
                data["notifType"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDropDownNotifTypeDto {
    parentType: string[];
    notifType: GetNotifTypeDto[];
}

export class GetNotifTypeDto implements IGetNotifTypeDto {
    parentType: string;
    notifTypeCode: string;
    notifTypeDesc: string;

    constructor(data?: IGetNotifTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentType = data["parentType"];
            this.notifTypeCode = data["notifTypeCode"];
            this.notifTypeDesc = data["notifTypeDesc"];
        }
    }

    static fromJS(data: any): GetNotifTypeDto {
        let result = new GetNotifTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentType"] = this.parentType;
        data["notifTypeCode"] = this.notifTypeCode;
        data["notifTypeDesc"] = this.notifTypeDesc;
        return data; 
    }
}

export interface IGetNotifTypeDto {
    parentType: string;
    notifTypeCode: string;
    notifTypeDesc: string;
}

export class GetDropdownItemResultDto implements IGetDropdownItemResultDto {
    bookingDetailId: number;
    refNo: number;
    itemName: string;

    constructor(data?: IGetDropdownItemResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDetailId = data["bookingDetailId"];
            this.refNo = data["refNo"];
            this.itemName = data["itemName"];
        }
    }

    static fromJS(data: any): GetDropdownItemResultDto {
        let result = new GetDropdownItemResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDetailId"] = this.bookingDetailId;
        data["refNo"] = this.refNo;
        data["itemName"] = this.itemName;
        return data; 
    }
}

export interface IGetDropdownItemResultDto {
    bookingDetailId: number;
    refNo: number;
    itemName: string;
}

export class CreateUpdateAddjustmentInputDto implements ICreateUpdateAddjustmentInputDto {
    addjustmentId: number;
    addjDate: moment.Moment;
    addjArea: number;
    netAmt: number;
    remarks: string;
    bookingDetailId: number;
    bookingCode: string;

    constructor(data?: ICreateUpdateAddjustmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addjustmentId = data["addjustmentId"];
            this.addjDate = data["addjDate"] ? moment(data["addjDate"].toString()) : <any>undefined;
            this.addjArea = data["addjArea"];
            this.netAmt = data["netAmt"];
            this.remarks = data["remarks"];
            this.bookingDetailId = data["bookingDetailId"];
            this.bookingCode = data["bookingCode"];
        }
    }

    static fromJS(data: any): CreateUpdateAddjustmentInputDto {
        let result = new CreateUpdateAddjustmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addjustmentId"] = this.addjustmentId;
        data["addjDate"] = this.addjDate ? this.addjDate.toISOString() : <any>undefined;
        data["addjArea"] = this.addjArea;
        data["netAmt"] = this.netAmt;
        data["remarks"] = this.remarks;
        data["bookingDetailId"] = this.bookingDetailId;
        data["bookingCode"] = this.bookingCode;
        return data; 
    }
}

export interface ICreateUpdateAddjustmentInputDto {
    addjustmentId: number;
    addjDate: moment.Moment;
    addjArea: number;
    netAmt: number;
    remarks: string;
    bookingDetailId: number;
    bookingCode: string;
}

export class GetPSASParamsSendEamailAdjAreaDto implements IGetPSASParamsSendEamailAdjAreaDto {
    bookCode: string;
    oldPriceHis: PriceAmountDto[];

    constructor(data?: IGetPSASParamsSendEamailAdjAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            if (data["oldPriceHis"] && data["oldPriceHis"].constructor === Array) {
                this.oldPriceHis = [];
                for (let item of data["oldPriceHis"])
                    this.oldPriceHis.push(PriceAmountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPSASParamsSendEamailAdjAreaDto {
        let result = new GetPSASParamsSendEamailAdjAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        if (this.oldPriceHis && this.oldPriceHis.constructor === Array) {
            data["oldPriceHis"] = [];
            for (let item of this.oldPriceHis)
                data["oldPriceHis"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPSASParamsSendEamailAdjAreaDto {
    bookCode: string;
    oldPriceHis: PriceAmountDto[];
}

export class PriceAmountDto implements IPriceAmountDto {
    itemName: string;
    amount: number;
    netNetPrice: number;
    disc: number;
    area: number;
    adjarea: number;
    refNo: number;

    constructor(data?: IPriceAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.amount = data["amount"];
            this.netNetPrice = data["netNetPrice"];
            this.disc = data["disc"];
            this.area = data["area"];
            this.adjarea = data["adjarea"];
            this.refNo = data["refNo"];
        }
    }

    static fromJS(data: any): PriceAmountDto {
        let result = new PriceAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["amount"] = this.amount;
        data["netNetPrice"] = this.netNetPrice;
        data["disc"] = this.disc;
        data["area"] = this.area;
        data["adjarea"] = this.adjarea;
        data["refNo"] = this.refNo;
        return data; 
    }
}

export interface IPriceAmountDto {
    itemName: string;
    amount: number;
    netNetPrice: number;
    disc: number;
    area: number;
    adjarea: number;
    refNo: number;
}

export class GetListAddjustmentResultDto implements IGetListAddjustmentResultDto {
    adjNo: number;
    area: number;
    netAmt: number;
    addjustmentId: number;
    bookingDetailId: number;
    itemName: string;
    remarks: string;
    adjDate: moment.Moment;

    constructor(data?: IGetListAddjustmentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adjNo = data["adjNo"];
            this.area = data["area"];
            this.netAmt = data["netAmt"];
            this.addjustmentId = data["addjustmentId"];
            this.bookingDetailId = data["bookingDetailId"];
            this.itemName = data["itemName"];
            this.remarks = data["remarks"];
            this.adjDate = data["adjDate"] ? moment(data["adjDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListAddjustmentResultDto {
        let result = new GetListAddjustmentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjNo"] = this.adjNo;
        data["area"] = this.area;
        data["netAmt"] = this.netAmt;
        data["addjustmentId"] = this.addjustmentId;
        data["bookingDetailId"] = this.bookingDetailId;
        data["itemName"] = this.itemName;
        data["remarks"] = this.remarks;
        data["adjDate"] = this.adjDate ? this.adjDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetListAddjustmentResultDto {
    adjNo: number;
    area: number;
    netAmt: number;
    addjustmentId: number;
    bookingDetailId: number;
    itemName: string;
    remarks: string;
    adjDate: moment.Moment;
}

export class GetFilePPPUListDto implements IGetFilePPPUListDto {
    linkFilePPPU: string;
    linkFileTandaTerima: string;

    constructor(data?: IGetFilePPPUListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.linkFilePPPU = data["linkFilePPPU"];
            this.linkFileTandaTerima = data["linkFileTandaTerima"];
        }
    }

    static fromJS(data: any): GetFilePPPUListDto {
        let result = new GetFilePPPUListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkFilePPPU"] = this.linkFilePPPU;
        data["linkFileTandaTerima"] = this.linkFileTandaTerima;
        return data; 
    }
}

export interface IGetFilePPPUListDto {
    linkFilePPPU: string;
    linkFileTandaTerima: string;
}

export class SendEmailAJBParamList implements ISendEmailAJBParamList {
    bookingDocumentID: number;
    docCode: string;

    constructor(data?: ISendEmailAJBParamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentID = data["bookingDocumentID"];
            this.docCode = data["docCode"];
        }
    }

    static fromJS(data: any): SendEmailAJBParamList {
        let result = new SendEmailAJBParamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["docCode"] = this.docCode;
        return data; 
    }
}

export interface ISendEmailAJBParamList {
    bookingDocumentID: number;
    docCode: string;
}

export class SendEmailAJBResult implements ISendEmailAJBResult {
    totalBookingDocumentID: number;
    totalSuccess: number;
    totalFailed: number;
    allEmailsSent: boolean;
    sendEmailAJBDetails: SendEmailAJBDetail[];

    constructor(data?: ISendEmailAJBResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalBookingDocumentID = data["totalBookingDocumentID"];
            this.totalSuccess = data["totalSuccess"];
            this.totalFailed = data["totalFailed"];
            this.allEmailsSent = data["allEmailsSent"];
            if (data["sendEmailAJBDetails"] && data["sendEmailAJBDetails"].constructor === Array) {
                this.sendEmailAJBDetails = [];
                for (let item of data["sendEmailAJBDetails"])
                    this.sendEmailAJBDetails.push(SendEmailAJBDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendEmailAJBResult {
        let result = new SendEmailAJBResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBookingDocumentID"] = this.totalBookingDocumentID;
        data["totalSuccess"] = this.totalSuccess;
        data["totalFailed"] = this.totalFailed;
        data["allEmailsSent"] = this.allEmailsSent;
        if (this.sendEmailAJBDetails && this.sendEmailAJBDetails.constructor === Array) {
            data["sendEmailAJBDetails"] = [];
            for (let item of this.sendEmailAJBDetails)
                data["sendEmailAJBDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISendEmailAJBResult {
    totalBookingDocumentID: number;
    totalSuccess: number;
    totalFailed: number;
    allEmailsSent: boolean;
    sendEmailAJBDetails: SendEmailAJBDetail[];
}

export class SendEmailAJBDetail implements ISendEmailAJBDetail {
    bookingDocumentID: number;
    docCode: string;
    sentStatusMessage: string;
    sentStatus: string;

    constructor(data?: ISendEmailAJBDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentID = data["bookingDocumentID"];
            this.docCode = data["docCode"];
            this.sentStatusMessage = data["sentStatusMessage"];
            this.sentStatus = data["sentStatus"];
        }
    }

    static fromJS(data: any): SendEmailAJBDetail {
        let result = new SendEmailAJBDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["docCode"] = this.docCode;
        data["sentStatusMessage"] = this.sentStatusMessage;
        data["sentStatus"] = this.sentStatus;
        return data; 
    }
}

export interface ISendEmailAJBDetail {
    bookingDocumentID: number;
    docCode: string;
    sentStatusMessage: string;
    sentStatus: string;
}

export class GetBookingDocumentListDto implements IGetBookingDocumentListDto {
    bookCode: string;
    projectID: number;
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    psCode: string;
    bookingDate: moment.Moment;
    bookingDoc: BookingDocumentListDto[];

    constructor(data?: IGetBookingDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psCode = data["psCode"];
            this.bookingDate = data["bookingDate"] ? moment(data["bookingDate"].toString()) : <any>undefined;
            if (data["bookingDoc"] && data["bookingDoc"].constructor === Array) {
                this.bookingDoc = [];
                for (let item of data["bookingDoc"])
                    this.bookingDoc.push(BookingDocumentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBookingDocumentListDto {
        let result = new GetBookingDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psCode"] = this.psCode;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        if (this.bookingDoc && this.bookingDoc.constructor === Array) {
            data["bookingDoc"] = [];
            for (let item of this.bookingDoc)
                data["bookingDoc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetBookingDocumentListDto {
    bookCode: string;
    projectID: number;
    projectName: string;
    clusterName: string;
    unitCode: string;
    unitNo: string;
    psCode: string;
    bookingDate: moment.Moment;
    bookingDoc: BookingDocumentListDto[];
}

export class BookingDocumentListDto implements IBookingDocumentListDto {
    bookingDocumentId: number;
    docID: number;
    docCode: string;
    docName: string;
    docNo: string;
    tandaTerimaNo: string;
    docDate: moment.Moment;
    remarks: string;
    isActive: boolean;
    isTandaTerima: boolean;
    fileTandaTerima: string;
    signedDocumentDate: string;
    signatureDate: string;
    signatureFile: string;
    signedDocumentFile: string;
    documentFile: string;
    kuasaDireksi: string;
    latestDate: moment.Moment;
    isNewest: boolean;
    isSended: boolean;
    isSentPrivy: boolean;
    addendumDoc: AddendumListDto[];

    constructor(data?: IBookingDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentId = data["bookingDocumentId"];
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
            this.docNo = data["docNo"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
            this.isTandaTerima = data["isTandaTerima"];
            this.fileTandaTerima = data["fileTandaTerima"];
            this.signedDocumentDate = data["signedDocumentDate"];
            this.signatureDate = data["signatureDate"];
            this.signatureFile = data["signatureFile"];
            this.signedDocumentFile = data["signedDocumentFile"];
            this.documentFile = data["documentFile"];
            this.kuasaDireksi = data["kuasaDireksi"];
            this.latestDate = data["latestDate"] ? moment(data["latestDate"].toString()) : <any>undefined;
            this.isNewest = data["isNewest"];
            this.isSended = data["isSended"];
            this.isSentPrivy = data["isSentPrivy"];
            if (data["addendumDoc"] && data["addendumDoc"].constructor === Array) {
                this.addendumDoc = [];
                for (let item of data["addendumDoc"])
                    this.addendumDoc.push(AddendumListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingDocumentListDto {
        let result = new BookingDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentId"] = this.bookingDocumentId;
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        data["docNo"] = this.docNo;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        data["isTandaTerima"] = this.isTandaTerima;
        data["fileTandaTerima"] = this.fileTandaTerima;
        data["signedDocumentDate"] = this.signedDocumentDate;
        data["signatureDate"] = this.signatureDate;
        data["signatureFile"] = this.signatureFile;
        data["signedDocumentFile"] = this.signedDocumentFile;
        data["documentFile"] = this.documentFile;
        data["kuasaDireksi"] = this.kuasaDireksi;
        data["latestDate"] = this.latestDate ? this.latestDate.toISOString() : <any>undefined;
        data["isNewest"] = this.isNewest;
        data["isSended"] = this.isSended;
        data["isSentPrivy"] = this.isSentPrivy;
        if (this.addendumDoc && this.addendumDoc.constructor === Array) {
            data["addendumDoc"] = [];
            for (let item of this.addendumDoc)
                data["addendumDoc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBookingDocumentListDto {
    bookingDocumentId: number;
    docID: number;
    docCode: string;
    docName: string;
    docNo: string;
    tandaTerimaNo: string;
    docDate: moment.Moment;
    remarks: string;
    isActive: boolean;
    isTandaTerima: boolean;
    fileTandaTerima: string;
    signedDocumentDate: string;
    signatureDate: string;
    signatureFile: string;
    signedDocumentFile: string;
    documentFile: string;
    kuasaDireksi: string;
    latestDate: moment.Moment;
    isNewest: boolean;
    isSended: boolean;
    isSentPrivy: boolean;
    addendumDoc: AddendumListDto[];
}

export class AddendumListDto implements IAddendumListDto {
    addendumDocId: number;
    docCode: string;
    docName: string;
    docDate: moment.Moment;
    docNo: string;
    remarks: string;

    constructor(data?: IAddendumListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addendumDocId = data["addendumDocId"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.docNo = data["docNo"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): AddendumListDto {
        let result = new AddendumListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addendumDocId"] = this.addendumDocId;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["docNo"] = this.docNo;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IAddendumListDto {
    addendumDocId: number;
    docCode: string;
    docName: string;
    docDate: moment.Moment;
    docNo: string;
    remarks: string;
}

export class CreateBookingDocumentInputDto implements ICreateBookingDocumentInputDto {
    entityID: number;
    bookingDocumentID: number;
    clusterName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    docID: number;
    docNo: string;
    oldDocNo: string;
    docDate: moment.Moment;
    generateFrom: string;
    remarks: string;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;
    procurationName: string;
    procurationType: number;
    kuasaDireksiPeopleID1: number;
    kuasaDireksiPeopleID2: number;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    signatureCustImage: string;
    parafCustImage: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;
    invitationDate: moment.Moment;
    invitationTime: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    docBAST: string;
    videoUnit: string;
    billingDate: string;
    biayaSc: string;
    biayaListrik: string;
    biayaAir: string;
    promoDetail: string;
    procurationDate: moment.Moment;
    adminFee: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    checklistBiayaPenitipan: boolean;
    alamatNotaris: string;
    pajakAtasBangunan: number;
    biayaCekSertipikat: number;
    biayaValidasiPajak: number;
    biayaPenyimpananSertipikat: number;
    userID: number;

    constructor(data?: ICreateBookingDocumentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.bookingDocumentID = data["bookingDocumentID"];
            this.clusterName = data["clusterName"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
            this.docID = data["docID"];
            this.docNo = data["docNo"];
            this.oldDocNo = data["oldDocNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.generateFrom = data["generateFrom"];
            this.remarks = data["remarks"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.tandaTerimaDate = data["tandaTerimaDate"] ? moment(data["tandaTerimaDate"].toString()) : <any>undefined;
            this.tandaTerimaBy = data["tandaTerimaBy"];
            this.tandaTerimaFile = data["tandaTerimaFile"];
            this.procurationName = data["procurationName"];
            this.procurationType = data["procurationType"];
            this.kuasaDireksiPeopleID1 = data["kuasaDireksiPeopleID1"];
            this.kuasaDireksiPeopleID2 = data["kuasaDireksiPeopleID2"];
            this.kuasaDireksiPeopleName1 = data["kuasaDireksiPeopleName1"];
            this.kuasaDireksiPeopleName2 = data["kuasaDireksiPeopleName2"];
            this.signatureImage1 = data["signatureImage1"];
            this.signatureImage2 = data["signatureImage2"];
            this.parafImage1 = data["parafImage1"];
            this.parafImage2 = data["parafImage2"];
            this.position1 = data["position1"];
            this.position2 = data["position2"];
            this.signatureCustImage = data["signatureCustImage"];
            this.parafCustImage = data["parafCustImage"];
            this.plafond = data["plafond"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.sukuBungaTahun = data["sukuBungaTahun"];
            this.invitationDate = data["invitationDate"] ? moment(data["invitationDate"].toString()) : <any>undefined;
            this.invitationTime = data["invitationTime"];
            this.picName = data["picName"];
            this.picPhone = data["picPhone"];
            this.picEmail = data["picEmail"];
            this.docBAST = data["docBAST"];
            this.videoUnit = data["videoUnit"];
            this.billingDate = data["billingDate"];
            this.biayaSc = data["biayaSc"];
            this.biayaListrik = data["biayaListrik"];
            this.biayaAir = data["biayaAir"];
            this.promoDetail = data["promoDetail"];
            this.procurationDate = data["procurationDate"] ? moment(data["procurationDate"].toString()) : <any>undefined;
            this.adminFee = data["adminFee"];
            this.notarisID = data["notarisID"];
            this.namaNotaris = data["namaNotaris"];
            this.telpNotaris = data["telpNotaris"];
            this.staffNotaris = data["staffNotaris"];
            this.emailNotaris = data["emailNotaris"];
            this.emailPICBank = data["emailPICBank"];
            this.checklistBiayaPenitipan = data["checklistBiayaPenitipan"];
            this.alamatNotaris = data["alamatNotaris"];
            this.pajakAtasBangunan = data["pajakAtasBangunan"];
            this.biayaCekSertipikat = data["biayaCekSertipikat"];
            this.biayaValidasiPajak = data["biayaValidasiPajak"];
            this.biayaPenyimpananSertipikat = data["biayaPenyimpananSertipikat"];
            this.userID = data["userID"];
        }
    }

    static fromJS(data: any): CreateBookingDocumentInputDto {
        let result = new CreateBookingDocumentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["clusterName"] = this.clusterName;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        data["docID"] = this.docID;
        data["docNo"] = this.docNo;
        data["oldDocNo"] = this.oldDocNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["generateFrom"] = this.generateFrom;
        data["remarks"] = this.remarks;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["tandaTerimaDate"] = this.tandaTerimaDate ? this.tandaTerimaDate.toISOString() : <any>undefined;
        data["tandaTerimaBy"] = this.tandaTerimaBy;
        data["tandaTerimaFile"] = this.tandaTerimaFile;
        data["procurationName"] = this.procurationName;
        data["procurationType"] = this.procurationType;
        data["kuasaDireksiPeopleID1"] = this.kuasaDireksiPeopleID1;
        data["kuasaDireksiPeopleID2"] = this.kuasaDireksiPeopleID2;
        data["kuasaDireksiPeopleName1"] = this.kuasaDireksiPeopleName1;
        data["kuasaDireksiPeopleName2"] = this.kuasaDireksiPeopleName2;
        data["signatureImage1"] = this.signatureImage1;
        data["signatureImage2"] = this.signatureImage2;
        data["parafImage1"] = this.parafImage1;
        data["parafImage2"] = this.parafImage2;
        data["position1"] = this.position1;
        data["position2"] = this.position2;
        data["signatureCustImage"] = this.signatureCustImage;
        data["parafCustImage"] = this.parafCustImage;
        data["plafond"] = this.plafond;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["sukuBungaTahun"] = this.sukuBungaTahun;
        data["invitationDate"] = this.invitationDate ? this.invitationDate.toISOString() : <any>undefined;
        data["invitationTime"] = this.invitationTime;
        data["picName"] = this.picName;
        data["picPhone"] = this.picPhone;
        data["picEmail"] = this.picEmail;
        data["docBAST"] = this.docBAST;
        data["videoUnit"] = this.videoUnit;
        data["billingDate"] = this.billingDate;
        data["biayaSc"] = this.biayaSc;
        data["biayaListrik"] = this.biayaListrik;
        data["biayaAir"] = this.biayaAir;
        data["promoDetail"] = this.promoDetail;
        data["procurationDate"] = this.procurationDate ? this.procurationDate.toISOString() : <any>undefined;
        data["adminFee"] = this.adminFee;
        data["notarisID"] = this.notarisID;
        data["namaNotaris"] = this.namaNotaris;
        data["telpNotaris"] = this.telpNotaris;
        data["staffNotaris"] = this.staffNotaris;
        data["emailNotaris"] = this.emailNotaris;
        data["emailPICBank"] = this.emailPICBank;
        data["checklistBiayaPenitipan"] = this.checklistBiayaPenitipan;
        data["alamatNotaris"] = this.alamatNotaris;
        data["pajakAtasBangunan"] = this.pajakAtasBangunan;
        data["biayaCekSertipikat"] = this.biayaCekSertipikat;
        data["biayaValidasiPajak"] = this.biayaValidasiPajak;
        data["biayaPenyimpananSertipikat"] = this.biayaPenyimpananSertipikat;
        data["userID"] = this.userID;
        return data; 
    }
}

export interface ICreateBookingDocumentInputDto {
    entityID: number;
    bookingDocumentID: number;
    clusterName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    docID: number;
    docNo: string;
    oldDocNo: string;
    docDate: moment.Moment;
    generateFrom: string;
    remarks: string;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;
    procurationName: string;
    procurationType: number;
    kuasaDireksiPeopleID1: number;
    kuasaDireksiPeopleID2: number;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    signatureCustImage: string;
    parafCustImage: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;
    invitationDate: moment.Moment;
    invitationTime: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    docBAST: string;
    videoUnit: string;
    billingDate: string;
    biayaSc: string;
    biayaListrik: string;
    biayaAir: string;
    promoDetail: string;
    procurationDate: moment.Moment;
    adminFee: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    checklistBiayaPenitipan: boolean;
    alamatNotaris: string;
    pajakAtasBangunan: number;
    biayaCekSertipikat: number;
    biayaValidasiPajak: number;
    biayaPenyimpananSertipikat: number;
    userID: number;
}

export class UpdateBookingDocumentInputDto implements IUpdateBookingDocumentInputDto {
    trBookingDocumentID: number;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;

    constructor(data?: IUpdateBookingDocumentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.trBookingDocumentID = data["trBookingDocumentID"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.tandaTerimaDate = data["tandaTerimaDate"] ? moment(data["tandaTerimaDate"].toString()) : <any>undefined;
            this.tandaTerimaBy = data["tandaTerimaBy"];
            this.tandaTerimaFile = data["tandaTerimaFile"];
        }
    }

    static fromJS(data: any): UpdateBookingDocumentInputDto {
        let result = new UpdateBookingDocumentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trBookingDocumentID"] = this.trBookingDocumentID;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["tandaTerimaDate"] = this.tandaTerimaDate ? this.tandaTerimaDate.toISOString() : <any>undefined;
        data["tandaTerimaBy"] = this.tandaTerimaBy;
        data["tandaTerimaFile"] = this.tandaTerimaFile;
        return data; 
    }
}

export interface IUpdateBookingDocumentInputDto {
    trBookingDocumentID: number;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;
}

export class CounterDocNoListDto implements ICounterDocNoListDto {
    docNo: string;
    tandaTerimaNo: string;

    constructor(data?: ICounterDocNoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNo = data["docNo"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
        }
    }

    static fromJS(data: any): CounterDocNoListDto {
        let result = new CounterDocNoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNo"] = this.docNo;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        return data; 
    }
}

export interface ICounterDocNoListDto {
    docNo: string;
    tandaTerimaNo: string;
}

export class GetFileLegalDocListDto implements IGetFileLegalDocListDto {
    linkFileLegalDoc: string;

    constructor(data?: IGetFileLegalDocListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.linkFileLegalDoc = data["linkFileLegalDoc"];
        }
    }

    static fromJS(data: any): GetFileLegalDocListDto {
        let result = new GetFileLegalDocListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkFileLegalDoc"] = this.linkFileLegalDoc;
        return data; 
    }
}

export interface IGetFileLegalDocListDto {
    linkFileLegalDoc: string;
}

export class DocCodeDto implements IDocCodeDto {
    docID: number;
    docCode: string;
    docName: string;

    constructor(data?: IDocCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
        }
    }

    static fromJS(data: any): DocCodeDto {
        let result = new DocCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        return data; 
    }
}

export interface IDocCodeDto {
    docID: number;
    docCode: string;
    docName: string;
}

export class GetMappingOfferingLetterListDto implements IGetMappingOfferingLetterListDto {
    id: number;
    projectID: number;
    projectName: string;
    tenor: number;
    sukuBunga: number;
    tahun: number;

    constructor(data?: IGetMappingOfferingLetterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.tahun = data["tahun"];
        }
    }

    static fromJS(data: any): GetMappingOfferingLetterListDto {
        let result = new GetMappingOfferingLetterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["tahun"] = this.tahun;
        return data; 
    }
}

export interface IGetMappingOfferingLetterListDto {
    id: number;
    projectID: number;
    projectName: string;
    tenor: number;
    sukuBunga: number;
    tahun: number;
}

export class GetSendCustomerSignListDto implements IGetSendCustomerSignListDto {
    bookCode: string;
    projectID: number;
    docID: number;
    docNo: string;
    tandaTerimaNo: string;
    kuasaDireksiName1: string;
    kuasaDireksiName2: string;
    position1: string;
    position2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    kuasaDireksi: string;
    psCode: string;
    custName: string;
    unitCode: string;
    unitNo: string;
    ktp: string;
    address: string;
    linkP3U: string;

    constructor(data?: IGetSendCustomerSignListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.projectID = data["projectID"];
            this.docID = data["docID"];
            this.docNo = data["docNo"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.kuasaDireksiName1 = data["kuasaDireksiName1"];
            this.kuasaDireksiName2 = data["kuasaDireksiName2"];
            this.position1 = data["position1"];
            this.position2 = data["position2"];
            this.signatureImage1 = data["signatureImage1"];
            this.signatureImage2 = data["signatureImage2"];
            this.parafImage1 = data["parafImage1"];
            this.parafImage2 = data["parafImage2"];
            this.kuasaDireksi = data["kuasaDireksi"];
            this.psCode = data["psCode"];
            this.custName = data["custName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.ktp = data["ktp"];
            this.address = data["address"];
            this.linkP3U = data["linkP3U"];
        }
    }

    static fromJS(data: any): GetSendCustomerSignListDto {
        let result = new GetSendCustomerSignListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["projectID"] = this.projectID;
        data["docID"] = this.docID;
        data["docNo"] = this.docNo;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["kuasaDireksiName1"] = this.kuasaDireksiName1;
        data["kuasaDireksiName2"] = this.kuasaDireksiName2;
        data["position1"] = this.position1;
        data["position2"] = this.position2;
        data["signatureImage1"] = this.signatureImage1;
        data["signatureImage2"] = this.signatureImage2;
        data["parafImage1"] = this.parafImage1;
        data["parafImage2"] = this.parafImage2;
        data["kuasaDireksi"] = this.kuasaDireksi;
        data["psCode"] = this.psCode;
        data["custName"] = this.custName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["ktp"] = this.ktp;
        data["address"] = this.address;
        data["linkP3U"] = this.linkP3U;
        return data; 
    }
}

export interface IGetSendCustomerSignListDto {
    bookCode: string;
    projectID: number;
    docID: number;
    docNo: string;
    tandaTerimaNo: string;
    kuasaDireksiName1: string;
    kuasaDireksiName2: string;
    position1: string;
    position2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    kuasaDireksi: string;
    psCode: string;
    custName: string;
    unitCode: string;
    unitNo: string;
    ktp: string;
    address: string;
    linkP3U: string;
}

export class GetKuasaDirPrivyResultDto implements IGetKuasaDirPrivyResultDto {
    code: string;
    message: string;
    data: KuasaDirPrivyDataDto;

    constructor(data?: IGetKuasaDirPrivyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.data = data["data"] ? KuasaDirPrivyDataDto.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKuasaDirPrivyResultDto {
        let result = new GetKuasaDirPrivyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetKuasaDirPrivyResultDto {
    code: string;
    message: string;
    data: KuasaDirPrivyDataDto;
}

export class KuasaDirPrivyDataDto implements IKuasaDirPrivyDataDto {
    privyId: string;
    email: string;
    phone: string;
    userToken: string;
    status: string;
    identity: KuasaDirPrivyIdentityDto;

    constructor(data?: IKuasaDirPrivyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.privyId = data["privyId"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.userToken = data["userToken"];
            this.status = data["status"];
            this.identity = data["identity"] ? KuasaDirPrivyIdentityDto.fromJS(data["identity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KuasaDirPrivyDataDto {
        let result = new KuasaDirPrivyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["privyId"] = this.privyId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["userToken"] = this.userToken;
        data["status"] = this.status;
        data["identity"] = this.identity ? this.identity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IKuasaDirPrivyDataDto {
    privyId: string;
    email: string;
    phone: string;
    userToken: string;
    status: string;
    identity: KuasaDirPrivyIdentityDto;
}

export class KuasaDirPrivyIdentityDto implements IKuasaDirPrivyIdentityDto {
    nama: string;
    nik: string;
    tanggalLahir: string;
    tempatLahir: string;

    constructor(data?: IKuasaDirPrivyIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nama = data["nama"];
            this.nik = data["nik"];
            this.tanggalLahir = data["tanggalLahir"];
            this.tempatLahir = data["tempatLahir"];
        }
    }

    static fromJS(data: any): KuasaDirPrivyIdentityDto {
        let result = new KuasaDirPrivyIdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nama"] = this.nama;
        data["nik"] = this.nik;
        data["tanggalLahir"] = this.tanggalLahir;
        data["tempatLahir"] = this.tempatLahir;
        return data; 
    }
}

export interface IKuasaDirPrivyIdentityDto {
    nama: string;
    nik: string;
    tanggalLahir: string;
    tempatLahir: string;
}

export class DownloadDocPrivyResultDto implements IDownloadDocPrivyResultDto {
    code: string;
    message: string;
    data: DownloadDocPrivyDataDto;
    errors: UploadDocPrivyErrorDto[];

    constructor(data?: IDownloadDocPrivyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.data = data["data"] ? DownloadDocPrivyDataDto.fromJS(data["data"]) : <any>undefined;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(UploadDocPrivyErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadDocPrivyResultDto {
        let result = new DownloadDocPrivyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDownloadDocPrivyResultDto {
    code: string;
    message: string;
    data: DownloadDocPrivyDataDto;
    errors: UploadDocPrivyErrorDto[];
}

export class DownloadDocPrivyDataDto implements IDownloadDocPrivyDataDto {
    title: string;
    docToken: string;
    recipients: PrivyDownloadRecipients[];
    documentStatus: string;
    urlDocument: string;
    download: DownloadDocumentPrivyResult;

    constructor(data?: IDownloadDocPrivyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.docToken = data["docToken"];
            if (data["recipients"] && data["recipients"].constructor === Array) {
                this.recipients = [];
                for (let item of data["recipients"])
                    this.recipients.push(PrivyDownloadRecipients.fromJS(item));
            }
            this.documentStatus = data["documentStatus"];
            this.urlDocument = data["urlDocument"];
            this.download = data["download"] ? DownloadDocumentPrivyResult.fromJS(data["download"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadDocPrivyDataDto {
        let result = new DownloadDocPrivyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["docToken"] = this.docToken;
        if (this.recipients && this.recipients.constructor === Array) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["documentStatus"] = this.documentStatus;
        data["urlDocument"] = this.urlDocument;
        data["download"] = this.download ? this.download.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDownloadDocPrivyDataDto {
    title: string;
    docToken: string;
    recipients: PrivyDownloadRecipients[];
    documentStatus: string;
    urlDocument: string;
    download: DownloadDocumentPrivyResult;
}

export class UploadDocPrivyErrorDto implements IUploadDocPrivyErrorDto {
    field: string;
    messages: string[];

    constructor(data?: IUploadDocPrivyErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.field = data["field"];
            if (data["messages"] && data["messages"].constructor === Array) {
                this.messages = [];
                for (let item of data["messages"])
                    this.messages.push(item);
            }
        }
    }

    static fromJS(data: any): UploadDocPrivyErrorDto {
        let result = new UploadDocPrivyErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        if (this.messages && this.messages.constructor === Array) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        return data; 
    }
}

export interface IUploadDocPrivyErrorDto {
    field: string;
    messages: string[];
}

export class PrivyDownloadRecipients implements IPrivyDownloadRecipients {
    privyId: string;
    type: string;
    signatoryStatus: string;
    signedAt: moment.Moment;

    constructor(data?: IPrivyDownloadRecipients) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.privyId = data["privyId"];
            this.type = data["type"];
            this.signatoryStatus = data["signatoryStatus"];
            this.signedAt = data["signedAt"] ? moment(data["signedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrivyDownloadRecipients {
        let result = new PrivyDownloadRecipients();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["privyId"] = this.privyId;
        data["type"] = this.type;
        data["signatoryStatus"] = this.signatoryStatus;
        data["signedAt"] = this.signedAt ? this.signedAt.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPrivyDownloadRecipients {
    privyId: string;
    type: string;
    signatoryStatus: string;
    signedAt: moment.Moment;
}

export class DownloadDocumentPrivyResult implements IDownloadDocumentPrivyResult {
    expiredAt: moment.Moment;
    url: string;

    constructor(data?: IDownloadDocumentPrivyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expiredAt = data["expiredAt"] ? moment(data["expiredAt"].toString()) : <any>undefined;
            this.url = data["url"];
        }
    }

    static fromJS(data: any): DownloadDocumentPrivyResult {
        let result = new DownloadDocumentPrivyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiredAt"] = this.expiredAt ? this.expiredAt.toISOString() : <any>undefined;
        data["url"] = this.url;
        return data; 
    }
}

export interface IDownloadDocumentPrivyResult {
    expiredAt: moment.Moment;
    url: string;
}

export class DownloadDocPrivyResultV2Dto implements IDownloadDocPrivyResultV2Dto {
    canDownload: boolean;
    statusDocument: string;
    urlSign: string;
    pdfFile: FileDto;
    errorMessage: string;

    constructor(data?: IDownloadDocPrivyResultV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canDownload = data["canDownload"];
            this.statusDocument = data["statusDocument"];
            this.urlSign = data["urlSign"];
            this.pdfFile = data["pdfFile"] ? FileDto.fromJS(data["pdfFile"]) : <any>undefined;
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): DownloadDocPrivyResultV2Dto {
        let result = new DownloadDocPrivyResultV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canDownload"] = this.canDownload;
        data["statusDocument"] = this.statusDocument;
        data["urlSign"] = this.urlSign;
        data["pdfFile"] = this.pdfFile ? this.pdfFile.toJSON() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IDownloadDocPrivyResultV2Dto {
    canDownload: boolean;
    statusDocument: string;
    urlSign: string;
    pdfFile: FileDto;
    errorMessage: string;
}

export class InputPrivyDto implements IInputPrivyDto {
    bookingDocumentID: number;
    bookingHeaderID: number;
    docID: number;
    docCode: string;
    docDate: moment.Moment;
    bookCode: string;
    psCode: string;
    isSentPrivy: boolean;
    docToken: string;
    projectID: number;
    docNo: string;
    termID: number;

    constructor(data?: IInputPrivyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentID = data["bookingDocumentID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.isSentPrivy = data["isSentPrivy"];
            this.docToken = data["docToken"];
            this.projectID = data["projectID"];
            this.docNo = data["docNo"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): InputPrivyDto {
        let result = new InputPrivyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["isSentPrivy"] = this.isSentPrivy;
        data["docToken"] = this.docToken;
        data["projectID"] = this.projectID;
        data["docNo"] = this.docNo;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface IInputPrivyDto {
    bookingDocumentID: number;
    bookingHeaderID: number;
    docID: number;
    docCode: string;
    docDate: moment.Moment;
    bookCode: string;
    psCode: string;
    isSentPrivy: boolean;
    docToken: string;
    projectID: number;
    docNo: string;
    termID: number;
}

export class SignCoordinatesType implements ISignCoordinatesType {
    type: string;
    token: string;
    signCoordinates: SignCoordinatesPrivy[];

    constructor(data?: ISignCoordinatesType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.token = data["token"];
            if (data["signCoordinates"] && data["signCoordinates"].constructor === Array) {
                this.signCoordinates = [];
                for (let item of data["signCoordinates"])
                    this.signCoordinates.push(SignCoordinatesPrivy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignCoordinatesType {
        let result = new SignCoordinatesType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["token"] = this.token;
        if (this.signCoordinates && this.signCoordinates.constructor === Array) {
            data["signCoordinates"] = [];
            for (let item of this.signCoordinates)
                data["signCoordinates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISignCoordinatesType {
    type: string;
    token: string;
    signCoordinates: SignCoordinatesPrivy[];
}

export class SignCoordinatesPrivy implements ISignCoordinatesPrivy {
    signPage: number;
    posX: number;
    posY: number;
    draggable: string;
    pageOtherTerm: string[];

    constructor(data?: ISignCoordinatesPrivy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signPage = data["signPage"];
            this.posX = data["posX"];
            this.posY = data["posY"];
            this.draggable = data["draggable"];
            if (data["pageOtherTerm"] && data["pageOtherTerm"].constructor === Array) {
                this.pageOtherTerm = [];
                for (let item of data["pageOtherTerm"])
                    this.pageOtherTerm.push(item);
            }
        }
    }

    static fromJS(data: any): SignCoordinatesPrivy {
        let result = new SignCoordinatesPrivy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signPage"] = this.signPage;
        data["posX"] = this.posX;
        data["posY"] = this.posY;
        data["draggable"] = this.draggable;
        if (this.pageOtherTerm && this.pageOtherTerm.constructor === Array) {
            data["pageOtherTerm"] = [];
            for (let item of this.pageOtherTerm)
                data["pageOtherTerm"].push(item);
        }
        return data; 
    }
}

export interface ISignCoordinatesPrivy {
    signPage: number;
    posX: number;
    posY: number;
    draggable: string;
    pageOtherTerm: string[];
}

export class GetSettingPrivy implements IGetSettingPrivy {
    merchantKey: string;
    clientKey: string;
    userName: string;
    password: string;
    otherField: string;
    settingUrl: UrlPrivySetting;
    enterpriseToken: string;

    constructor(data?: IGetSettingPrivy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.merchantKey = data["merchantKey"];
            this.clientKey = data["clientKey"];
            this.userName = data["userName"];
            this.password = data["password"];
            this.otherField = data["otherField"];
            this.settingUrl = data["settingUrl"] ? UrlPrivySetting.fromJS(data["settingUrl"]) : <any>undefined;
            this.enterpriseToken = data["enterpriseToken"];
        }
    }

    static fromJS(data: any): GetSettingPrivy {
        let result = new GetSettingPrivy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantKey"] = this.merchantKey;
        data["clientKey"] = this.clientKey;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["otherField"] = this.otherField;
        data["settingUrl"] = this.settingUrl ? this.settingUrl.toJSON() : <any>undefined;
        data["enterpriseToken"] = this.enterpriseToken;
        return data; 
    }
}

export interface IGetSettingPrivy {
    merchantKey: string;
    clientKey: string;
    userName: string;
    password: string;
    otherField: string;
    settingUrl: UrlPrivySetting;
    enterpriseToken: string;
}

export class UrlPrivySetting implements IUrlPrivySetting {
    urlPrivyID: string;
    urlPrivyUpload: string;
    urlPrivyStatus: string;
    urlPrivyIDKuasaDir: string;

    constructor(data?: IUrlPrivySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.urlPrivyID = data["urlPrivyID"];
            this.urlPrivyUpload = data["urlPrivyUpload"];
            this.urlPrivyStatus = data["urlPrivyStatus"];
            this.urlPrivyIDKuasaDir = data["urlPrivyIDKuasaDir"];
        }
    }

    static fromJS(data: any): UrlPrivySetting {
        let result = new UrlPrivySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlPrivyID"] = this.urlPrivyID;
        data["urlPrivyUpload"] = this.urlPrivyUpload;
        data["urlPrivyStatus"] = this.urlPrivyStatus;
        data["urlPrivyIDKuasaDir"] = this.urlPrivyIDKuasaDir;
        return data; 
    }
}

export interface IUrlPrivySetting {
    urlPrivyID: string;
    urlPrivyUpload: string;
    urlPrivyStatus: string;
    urlPrivyIDKuasaDir: string;
}

export class SignedDocEmailResult implements ISignedDocEmailResult {
    bookCode: string;
    customerName: string;
    docNo: string;
    notifTypeCode: string;
    status: string;

    constructor(data?: ISignedDocEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.customerName = data["customerName"];
            this.docNo = data["docNo"];
            this.notifTypeCode = data["notifTypeCode"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): SignedDocEmailResult {
        let result = new SignedDocEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["customerName"] = this.customerName;
        data["docNo"] = this.docNo;
        data["notifTypeCode"] = this.notifTypeCode;
        data["status"] = this.status;
        return data; 
    }
}

export interface ISignedDocEmailResult {
    bookCode: string;
    customerName: string;
    docNo: string;
    notifTypeCode: string;
    status: string;
}

export class GenerateReportPPPUInputDto implements IGenerateReportPPPUInputDto {
    projectID: number;
    clusterID: number;
    startBookDate: moment.Moment;
    endBookDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGenerateReportPPPUInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.startBookDate = data["startBookDate"] ? moment(data["startBookDate"].toString()) : <any>undefined;
            this.endBookDate = data["endBookDate"] ? moment(data["endBookDate"].toString()) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GenerateReportPPPUInputDto {
        let result = new GenerateReportPPPUInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["startBookDate"] = this.startBookDate ? this.startBookDate.toISOString() : <any>undefined;
        data["endBookDate"] = this.endBookDate ? this.endBookDate.toISOString() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGenerateReportPPPUInputDto {
    projectID: number;
    clusterID: number;
    startBookDate: moment.Moment;
    endBookDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;
}

export class GenerateReportAJBInputDto implements IGenerateReportAJBInputDto {
    projectID: number;
    clusterID: number;
    startBookDate: moment.Moment;
    endBookDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGenerateReportAJBInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.startBookDate = data["startBookDate"] ? moment(data["startBookDate"].toString()) : <any>undefined;
            this.endBookDate = data["endBookDate"] ? moment(data["endBookDate"].toString()) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GenerateReportAJBInputDto {
        let result = new GenerateReportAJBInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["startBookDate"] = this.startBookDate ? this.startBookDate.toISOString() : <any>undefined;
        data["endBookDate"] = this.endBookDate ? this.endBookDate.toISOString() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGenerateReportAJBInputDto {
    projectID: number;
    clusterID: number;
    startBookDate: moment.Moment;
    endBookDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;
}

export class GenerateReportPPPUExcelDto implements IGenerateReportPPPUExcelDto {
    user: string;
    projectName: string;
    clusterName: string;
    inputFilter: GenerateReportPPPUInputDto;
    data: GenerateReportPPPUDataDto[];

    constructor(data?: IGenerateReportPPPUExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.inputFilter = data["inputFilter"] ? GenerateReportPPPUInputDto.fromJS(data["inputFilter"]) : <any>undefined;
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(GenerateReportPPPUDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateReportPPPUExcelDto {
        let result = new GenerateReportPPPUExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["inputFilter"] = this.inputFilter ? this.inputFilter.toJSON() : <any>undefined;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGenerateReportPPPUExcelDto {
    user: string;
    projectName: string;
    clusterName: string;
    inputFilter: GenerateReportPPPUInputDto;
    data: GenerateReportPPPUDataDto[];
}

export class GenerateReportPPPUDataDto implements IGenerateReportPPPUDataDto {
    bookingHeaderID: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    clusterID: string;
    clusterName: string;
    noUndanganPPPU: string;
    sendEmailUndPPPU: moment.Moment;
    sendEmailSP1PPPU: moment.Moment;
    sendEmailSP2PPPU: moment.Moment;
    sendEmailSP3PPPU: moment.Moment;
    uploadPPPUDate: moment.Moment;

    constructor(data?: IGenerateReportPPPUDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.customerName = data["customerName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookCode = data["bookCode"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.noUndanganPPPU = data["noUndanganPPPU"];
            this.sendEmailUndPPPU = data["sendEmailUndPPPU"] ? moment(data["sendEmailUndPPPU"].toString()) : <any>undefined;
            this.sendEmailSP1PPPU = data["sendEmailSP1PPPU"] ? moment(data["sendEmailSP1PPPU"].toString()) : <any>undefined;
            this.sendEmailSP2PPPU = data["sendEmailSP2PPPU"] ? moment(data["sendEmailSP2PPPU"].toString()) : <any>undefined;
            this.sendEmailSP3PPPU = data["sendEmailSP3PPPU"] ? moment(data["sendEmailSP3PPPU"].toString()) : <any>undefined;
            this.uploadPPPUDate = data["uploadPPPUDate"] ? moment(data["uploadPPPUDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateReportPPPUDataDto {
        let result = new GenerateReportPPPUDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["customerName"] = this.customerName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookCode"] = this.bookCode;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["noUndanganPPPU"] = this.noUndanganPPPU;
        data["sendEmailUndPPPU"] = this.sendEmailUndPPPU ? this.sendEmailUndPPPU.toISOString() : <any>undefined;
        data["sendEmailSP1PPPU"] = this.sendEmailSP1PPPU ? this.sendEmailSP1PPPU.toISOString() : <any>undefined;
        data["sendEmailSP2PPPU"] = this.sendEmailSP2PPPU ? this.sendEmailSP2PPPU.toISOString() : <any>undefined;
        data["sendEmailSP3PPPU"] = this.sendEmailSP3PPPU ? this.sendEmailSP3PPPU.toISOString() : <any>undefined;
        data["uploadPPPUDate"] = this.uploadPPPUDate ? this.uploadPPPUDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGenerateReportPPPUDataDto {
    bookingHeaderID: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    clusterID: string;
    clusterName: string;
    noUndanganPPPU: string;
    sendEmailUndPPPU: moment.Moment;
    sendEmailSP1PPPU: moment.Moment;
    sendEmailSP2PPPU: moment.Moment;
    sendEmailSP3PPPU: moment.Moment;
    uploadPPPUDate: moment.Moment;
}

export class GenerateReportAJBExcelDto implements IGenerateReportAJBExcelDto {
    user: string;
    projectName: string;
    clusterName: string;
    inputFilter: GenerateReportAJBInputDto;
    data: GenerateReportAJBDataDto[];

    constructor(data?: IGenerateReportAJBExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.inputFilter = data["inputFilter"] ? GenerateReportAJBInputDto.fromJS(data["inputFilter"]) : <any>undefined;
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(GenerateReportAJBDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateReportAJBExcelDto {
        let result = new GenerateReportAJBExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["inputFilter"] = this.inputFilter ? this.inputFilter.toJSON() : <any>undefined;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGenerateReportAJBExcelDto {
    user: string;
    projectName: string;
    clusterName: string;
    inputFilter: GenerateReportAJBInputDto;
    data: GenerateReportAJBDataDto[];
}

export class GenerateReportAJBDataDto implements IGenerateReportAJBDataDto {
    bookingHeaderID: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    clusterID: string;
    bankID: string;
    bankCode: string;
    bankName: string;
    termRemarks: string;
    diagramaticType: string;
    ssp: number;
    netNetPrice: string;
    dpPercentage: string;
    pctRetensi: string;
    creaditAgreementID: string;
    agreementDetailID: string;
    nilaiRetensi: string;
    ajbUploadDate: moment.Moment;
    ajbDocNo: string;
    ajb1emailDate: moment.Moment;
    ajb1docNo: string;
    ajb2emailDate: moment.Moment;
    ajb2docNo: string;
    ajb3emailDate: moment.Moment;
    ajb3docNo: string;
    namaNotaris: string;
    telpNotaris: string;
    emailNotaris: string;
    staffNotaris: string;
    emailPICBank: string;
    pppu: moment.Moment;
    bast: moment.Moment;
    cer: moment.Moment;
    imb: moment.Moment;
    pbb: moment.Moment;
    lunas: number;

    constructor(data?: IGenerateReportAJBDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.customerName = data["customerName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookCode = data["bookCode"];
            this.clusterID = data["clusterID"];
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.termRemarks = data["termRemarks"];
            this.diagramaticType = data["diagramaticType"];
            this.ssp = data["ssp"];
            this.netNetPrice = data["netNetPrice"];
            this.dpPercentage = data["dpPercentage"];
            this.pctRetensi = data["pctRetensi"];
            this.creaditAgreementID = data["creaditAgreementID"];
            this.agreementDetailID = data["agreementDetailID"];
            this.nilaiRetensi = data["nilaiRetensi"];
            this.ajbUploadDate = data["ajbUploadDate"] ? moment(data["ajbUploadDate"].toString()) : <any>undefined;
            this.ajbDocNo = data["ajbDocNo"];
            this.ajb1emailDate = data["ajb1emailDate"] ? moment(data["ajb1emailDate"].toString()) : <any>undefined;
            this.ajb1docNo = data["ajb1docNo"];
            this.ajb2emailDate = data["ajb2emailDate"] ? moment(data["ajb2emailDate"].toString()) : <any>undefined;
            this.ajb2docNo = data["ajb2docNo"];
            this.ajb3emailDate = data["ajb3emailDate"] ? moment(data["ajb3emailDate"].toString()) : <any>undefined;
            this.ajb3docNo = data["ajb3docNo"];
            this.namaNotaris = data["namaNotaris"];
            this.telpNotaris = data["telpNotaris"];
            this.emailNotaris = data["emailNotaris"];
            this.staffNotaris = data["staffNotaris"];
            this.emailPICBank = data["emailPICBank"];
            this.pppu = data["pppu"] ? moment(data["pppu"].toString()) : <any>undefined;
            this.bast = data["bast"] ? moment(data["bast"].toString()) : <any>undefined;
            this.cer = data["cer"] ? moment(data["cer"].toString()) : <any>undefined;
            this.imb = data["imb"] ? moment(data["imb"].toString()) : <any>undefined;
            this.pbb = data["pbb"] ? moment(data["pbb"].toString()) : <any>undefined;
            this.lunas = data["lunas"];
        }
    }

    static fromJS(data: any): GenerateReportAJBDataDto {
        let result = new GenerateReportAJBDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["customerName"] = this.customerName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookCode"] = this.bookCode;
        data["clusterID"] = this.clusterID;
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["termRemarks"] = this.termRemarks;
        data["diagramaticType"] = this.diagramaticType;
        data["ssp"] = this.ssp;
        data["netNetPrice"] = this.netNetPrice;
        data["dpPercentage"] = this.dpPercentage;
        data["pctRetensi"] = this.pctRetensi;
        data["creaditAgreementID"] = this.creaditAgreementID;
        data["agreementDetailID"] = this.agreementDetailID;
        data["nilaiRetensi"] = this.nilaiRetensi;
        data["ajbUploadDate"] = this.ajbUploadDate ? this.ajbUploadDate.toISOString() : <any>undefined;
        data["ajbDocNo"] = this.ajbDocNo;
        data["ajb1emailDate"] = this.ajb1emailDate ? this.ajb1emailDate.toISOString() : <any>undefined;
        data["ajb1docNo"] = this.ajb1docNo;
        data["ajb2emailDate"] = this.ajb2emailDate ? this.ajb2emailDate.toISOString() : <any>undefined;
        data["ajb2docNo"] = this.ajb2docNo;
        data["ajb3emailDate"] = this.ajb3emailDate ? this.ajb3emailDate.toISOString() : <any>undefined;
        data["ajb3docNo"] = this.ajb3docNo;
        data["namaNotaris"] = this.namaNotaris;
        data["telpNotaris"] = this.telpNotaris;
        data["emailNotaris"] = this.emailNotaris;
        data["staffNotaris"] = this.staffNotaris;
        data["emailPICBank"] = this.emailPICBank;
        data["pppu"] = this.pppu ? this.pppu.toISOString() : <any>undefined;
        data["bast"] = this.bast ? this.bast.toISOString() : <any>undefined;
        data["cer"] = this.cer ? this.cer.toISOString() : <any>undefined;
        data["imb"] = this.imb ? this.imb.toISOString() : <any>undefined;
        data["pbb"] = this.pbb ? this.pbb.toISOString() : <any>undefined;
        data["lunas"] = this.lunas;
        return data; 
    }
}

export interface IGenerateReportAJBDataDto {
    bookingHeaderID: string;
    customerName: string;
    unitCode: string;
    unitNo: string;
    bookCode: string;
    clusterID: string;
    bankID: string;
    bankCode: string;
    bankName: string;
    termRemarks: string;
    diagramaticType: string;
    ssp: number;
    netNetPrice: string;
    dpPercentage: string;
    pctRetensi: string;
    creaditAgreementID: string;
    agreementDetailID: string;
    nilaiRetensi: string;
    ajbUploadDate: moment.Moment;
    ajbDocNo: string;
    ajb1emailDate: moment.Moment;
    ajb1docNo: string;
    ajb2emailDate: moment.Moment;
    ajb2docNo: string;
    ajb3emailDate: moment.Moment;
    ajb3docNo: string;
    namaNotaris: string;
    telpNotaris: string;
    emailNotaris: string;
    staffNotaris: string;
    emailPICBank: string;
    pppu: moment.Moment;
    bast: moment.Moment;
    cer: moment.Moment;
    imb: moment.Moment;
    pbb: moment.Moment;
    lunas: number;
}

export class ListResultDtoOfLinkPathListDto implements IListResultDtoOfLinkPathListDto {
    items: LinkPathListDto[];

    constructor(data?: IListResultDtoOfLinkPathListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkPathListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkPathListDto {
        let result = new ListResultDtoOfLinkPathListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkPathListDto {
    items: LinkPathListDto[];
}

export class DataParamReprintDTO implements IDataParamReprintDTO {
    bookingDocumentID: number;
    docCode: string;
    path: LinkPathListDto[];
    entityID: number;
    clusterName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    docID: number;
    docNo: string;
    oldDocNo: string;
    docDate: moment.Moment;
    generateFrom: string;
    remarks: string;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;
    procurationName: string;
    procurationType: number;
    kuasaDireksiPeopleID1: number;
    kuasaDireksiPeopleID2: number;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    signatureCustImage: string;
    parafCustImage: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;
    invitationDate: moment.Moment;
    invitationTime: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    docBAST: string;
    videoUnit: string;
    billingDate: string;
    biayaSc: string;
    biayaListrik: string;
    biayaAir: string;
    promoDetail: string;
    procurationDate: moment.Moment;
    adminFee: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    checklistBiayaPenitipan: boolean;
    alamatNotaris: string;
    pajakAtasBangunan: number;
    biayaCekSertipikat: number;
    biayaValidasiPajak: number;
    biayaPenyimpananSertipikat: number;

    constructor(data?: IDataParamReprintDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDocumentID = data["bookingDocumentID"];
            this.docCode = data["docCode"];
            if (data["path"] && data["path"].constructor === Array) {
                this.path = [];
                for (let item of data["path"])
                    this.path.push(LinkPathListDto.fromJS(item));
            }
            this.entityID = data["entityID"];
            this.clusterName = data["clusterName"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
            this.docID = data["docID"];
            this.docNo = data["docNo"];
            this.oldDocNo = data["oldDocNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.generateFrom = data["generateFrom"];
            this.remarks = data["remarks"];
            this.tandaTerimaNo = data["tandaTerimaNo"];
            this.tandaTerimaDate = data["tandaTerimaDate"] ? moment(data["tandaTerimaDate"].toString()) : <any>undefined;
            this.tandaTerimaBy = data["tandaTerimaBy"];
            this.tandaTerimaFile = data["tandaTerimaFile"];
            this.procurationName = data["procurationName"];
            this.procurationType = data["procurationType"];
            this.kuasaDireksiPeopleID1 = data["kuasaDireksiPeopleID1"];
            this.kuasaDireksiPeopleID2 = data["kuasaDireksiPeopleID2"];
            this.kuasaDireksiPeopleName1 = data["kuasaDireksiPeopleName1"];
            this.kuasaDireksiPeopleName2 = data["kuasaDireksiPeopleName2"];
            this.signatureImage1 = data["signatureImage1"];
            this.signatureImage2 = data["signatureImage2"];
            this.parafImage1 = data["parafImage1"];
            this.parafImage2 = data["parafImage2"];
            this.position1 = data["position1"];
            this.position2 = data["position2"];
            this.signatureCustImage = data["signatureCustImage"];
            this.parafCustImage = data["parafCustImage"];
            this.plafond = data["plafond"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.sukuBungaTahun = data["sukuBungaTahun"];
            this.invitationDate = data["invitationDate"] ? moment(data["invitationDate"].toString()) : <any>undefined;
            this.invitationTime = data["invitationTime"];
            this.picName = data["picName"];
            this.picPhone = data["picPhone"];
            this.picEmail = data["picEmail"];
            this.docBAST = data["docBAST"];
            this.videoUnit = data["videoUnit"];
            this.billingDate = data["billingDate"];
            this.biayaSc = data["biayaSc"];
            this.biayaListrik = data["biayaListrik"];
            this.biayaAir = data["biayaAir"];
            this.promoDetail = data["promoDetail"];
            this.procurationDate = data["procurationDate"] ? moment(data["procurationDate"].toString()) : <any>undefined;
            this.adminFee = data["adminFee"];
            this.notarisID = data["notarisID"];
            this.namaNotaris = data["namaNotaris"];
            this.telpNotaris = data["telpNotaris"];
            this.staffNotaris = data["staffNotaris"];
            this.emailNotaris = data["emailNotaris"];
            this.emailPICBank = data["emailPICBank"];
            this.checklistBiayaPenitipan = data["checklistBiayaPenitipan"];
            this.alamatNotaris = data["alamatNotaris"];
            this.pajakAtasBangunan = data["pajakAtasBangunan"];
            this.biayaCekSertipikat = data["biayaCekSertipikat"];
            this.biayaValidasiPajak = data["biayaValidasiPajak"];
            this.biayaPenyimpananSertipikat = data["biayaPenyimpananSertipikat"];
        }
    }

    static fromJS(data: any): DataParamReprintDTO {
        let result = new DataParamReprintDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["docCode"] = this.docCode;
        if (this.path && this.path.constructor === Array) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["entityID"] = this.entityID;
        data["clusterName"] = this.clusterName;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        data["docID"] = this.docID;
        data["docNo"] = this.docNo;
        data["oldDocNo"] = this.oldDocNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["generateFrom"] = this.generateFrom;
        data["remarks"] = this.remarks;
        data["tandaTerimaNo"] = this.tandaTerimaNo;
        data["tandaTerimaDate"] = this.tandaTerimaDate ? this.tandaTerimaDate.toISOString() : <any>undefined;
        data["tandaTerimaBy"] = this.tandaTerimaBy;
        data["tandaTerimaFile"] = this.tandaTerimaFile;
        data["procurationName"] = this.procurationName;
        data["procurationType"] = this.procurationType;
        data["kuasaDireksiPeopleID1"] = this.kuasaDireksiPeopleID1;
        data["kuasaDireksiPeopleID2"] = this.kuasaDireksiPeopleID2;
        data["kuasaDireksiPeopleName1"] = this.kuasaDireksiPeopleName1;
        data["kuasaDireksiPeopleName2"] = this.kuasaDireksiPeopleName2;
        data["signatureImage1"] = this.signatureImage1;
        data["signatureImage2"] = this.signatureImage2;
        data["parafImage1"] = this.parafImage1;
        data["parafImage2"] = this.parafImage2;
        data["position1"] = this.position1;
        data["position2"] = this.position2;
        data["signatureCustImage"] = this.signatureCustImage;
        data["parafCustImage"] = this.parafCustImage;
        data["plafond"] = this.plafond;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["sukuBungaTahun"] = this.sukuBungaTahun;
        data["invitationDate"] = this.invitationDate ? this.invitationDate.toISOString() : <any>undefined;
        data["invitationTime"] = this.invitationTime;
        data["picName"] = this.picName;
        data["picPhone"] = this.picPhone;
        data["picEmail"] = this.picEmail;
        data["docBAST"] = this.docBAST;
        data["videoUnit"] = this.videoUnit;
        data["billingDate"] = this.billingDate;
        data["biayaSc"] = this.biayaSc;
        data["biayaListrik"] = this.biayaListrik;
        data["biayaAir"] = this.biayaAir;
        data["promoDetail"] = this.promoDetail;
        data["procurationDate"] = this.procurationDate ? this.procurationDate.toISOString() : <any>undefined;
        data["adminFee"] = this.adminFee;
        data["notarisID"] = this.notarisID;
        data["namaNotaris"] = this.namaNotaris;
        data["telpNotaris"] = this.telpNotaris;
        data["staffNotaris"] = this.staffNotaris;
        data["emailNotaris"] = this.emailNotaris;
        data["emailPICBank"] = this.emailPICBank;
        data["checklistBiayaPenitipan"] = this.checklistBiayaPenitipan;
        data["alamatNotaris"] = this.alamatNotaris;
        data["pajakAtasBangunan"] = this.pajakAtasBangunan;
        data["biayaCekSertipikat"] = this.biayaCekSertipikat;
        data["biayaValidasiPajak"] = this.biayaValidasiPajak;
        data["biayaPenyimpananSertipikat"] = this.biayaPenyimpananSertipikat;
        return data; 
    }
}

export interface IDataParamReprintDTO {
    bookingDocumentID: number;
    docCode: string;
    path: LinkPathListDto[];
    entityID: number;
    clusterName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    projectID: number;
    docID: number;
    docNo: string;
    oldDocNo: string;
    docDate: moment.Moment;
    generateFrom: string;
    remarks: string;
    tandaTerimaNo: string;
    tandaTerimaDate: moment.Moment;
    tandaTerimaBy: string;
    tandaTerimaFile: string;
    procurationName: string;
    procurationType: number;
    kuasaDireksiPeopleID1: number;
    kuasaDireksiPeopleID2: number;
    kuasaDireksiPeopleName1: string;
    kuasaDireksiPeopleName2: string;
    signatureImage1: string;
    signatureImage2: string;
    parafImage1: string;
    parafImage2: string;
    position1: string;
    position2: string;
    signatureCustImage: string;
    parafCustImage: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;
    invitationDate: moment.Moment;
    invitationTime: string;
    picName: string;
    picPhone: string;
    picEmail: string;
    docBAST: string;
    videoUnit: string;
    billingDate: string;
    biayaSc: string;
    biayaListrik: string;
    biayaAir: string;
    promoDetail: string;
    procurationDate: moment.Moment;
    adminFee: string;
    notarisID: number;
    namaNotaris: string;
    telpNotaris: string;
    staffNotaris: string;
    emailNotaris: string;
    emailPICBank: string;
    checklistBiayaPenitipan: boolean;
    alamatNotaris: string;
    pajakAtasBangunan: number;
    biayaCekSertipikat: number;
    biayaValidasiPajak: number;
    biayaPenyimpananSertipikat: number;
}

export class ReturnBookCodeDto implements IReturnBookCodeDto {
    dataReminder: GetDataAutoCancelUnitFromSPDto[];
    dataCancel: GetDataAutoCancelUnitFromSPDto[];
    message: string;

    constructor(data?: IReturnBookCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dataReminder"] && data["dataReminder"].constructor === Array) {
                this.dataReminder = [];
                for (let item of data["dataReminder"])
                    this.dataReminder.push(GetDataAutoCancelUnitFromSPDto.fromJS(item));
            }
            if (data["dataCancel"] && data["dataCancel"].constructor === Array) {
                this.dataCancel = [];
                for (let item of data["dataCancel"])
                    this.dataCancel.push(GetDataAutoCancelUnitFromSPDto.fromJS(item));
            }
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ReturnBookCodeDto {
        let result = new ReturnBookCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dataReminder && this.dataReminder.constructor === Array) {
            data["dataReminder"] = [];
            for (let item of this.dataReminder)
                data["dataReminder"].push(item.toJSON());
        }
        if (this.dataCancel && this.dataCancel.constructor === Array) {
            data["dataCancel"] = [];
            for (let item of this.dataCancel)
                data["dataCancel"].push(item.toJSON());
        }
        data["message"] = this.message;
        return data; 
    }
}

export interface IReturnBookCodeDto {
    dataReminder: GetDataAutoCancelUnitFromSPDto[];
    dataCancel: GetDataAutoCancelUnitFromSPDto[];
    message: string;
}

export class GetDataAutoCancelUnitFromSPDto implements IGetDataAutoCancelUnitFromSPDto {
    psCode: string;
    bookCode: string;
    bookingHeaderId: number;
    condition: number;
    flagHold: string;
    flagCancel: boolean;
    countDays: number;
    totalPayment: number;
    sellingPrice: number;
    minPayment: number;
    penaltySchedule: number;
    penOutstanding: number;
    amountBFDP: number;
    amountPasal: number;

    constructor(data?: IGetDataAutoCancelUnitFromSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.bookCode = data["bookCode"];
            this.bookingHeaderId = data["bookingHeaderId"];
            this.condition = data["condition"];
            this.flagHold = data["flagHold"];
            this.flagCancel = data["flagCancel"];
            this.countDays = data["countDays"];
            this.totalPayment = data["totalPayment"];
            this.sellingPrice = data["sellingPrice"];
            this.minPayment = data["minPayment"];
            this.penaltySchedule = data["penaltySchedule"];
            this.penOutstanding = data["penOutstanding"];
            this.amountBFDP = data["amountBFDP"];
            this.amountPasal = data["amountPasal"];
        }
    }

    static fromJS(data: any): GetDataAutoCancelUnitFromSPDto {
        let result = new GetDataAutoCancelUnitFromSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["bookCode"] = this.bookCode;
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["condition"] = this.condition;
        data["flagHold"] = this.flagHold;
        data["flagCancel"] = this.flagCancel;
        data["countDays"] = this.countDays;
        data["totalPayment"] = this.totalPayment;
        data["sellingPrice"] = this.sellingPrice;
        data["minPayment"] = this.minPayment;
        data["penaltySchedule"] = this.penaltySchedule;
        data["penOutstanding"] = this.penOutstanding;
        data["amountBFDP"] = this.amountBFDP;
        data["amountPasal"] = this.amountPasal;
        return data; 
    }
}

export interface IGetDataAutoCancelUnitFromSPDto {
    psCode: string;
    bookCode: string;
    bookingHeaderId: number;
    condition: number;
    flagHold: string;
    flagCancel: boolean;
    countDays: number;
    totalPayment: number;
    sellingPrice: number;
    minPayment: number;
    penaltySchedule: number;
    penOutstanding: number;
    amountBFDP: number;
    amountPasal: number;
}

export class DataEmailReminderUnitDto implements IDataEmailReminderUnitDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    term: string;
    custName: string;
    memberName: string;
    netPrice: number;
    totalPayment: number;
    percentage: string;
    status: string;
    projectId: number;
    cancelDate: string;
    flagHold: string;
    reportCancel: boolean;

    constructor(data?: IDataEmailReminderUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.term = data["term"];
            this.custName = data["custName"];
            this.memberName = data["memberName"];
            this.netPrice = data["netPrice"];
            this.totalPayment = data["totalPayment"];
            this.percentage = data["percentage"];
            this.status = data["status"];
            this.projectId = data["projectId"];
            this.cancelDate = data["cancelDate"];
            this.flagHold = data["flagHold"];
            this.reportCancel = data["reportCancel"];
        }
    }

    static fromJS(data: any): DataEmailReminderUnitDto {
        let result = new DataEmailReminderUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["term"] = this.term;
        data["custName"] = this.custName;
        data["memberName"] = this.memberName;
        data["netPrice"] = this.netPrice;
        data["totalPayment"] = this.totalPayment;
        data["percentage"] = this.percentage;
        data["status"] = this.status;
        data["projectId"] = this.projectId;
        data["cancelDate"] = this.cancelDate;
        data["flagHold"] = this.flagHold;
        data["reportCancel"] = this.reportCancel;
        return data; 
    }
}

export interface IDataEmailReminderUnitDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    term: string;
    custName: string;
    memberName: string;
    netPrice: number;
    totalPayment: number;
    percentage: string;
    status: string;
    projectId: number;
    cancelDate: string;
    flagHold: string;
    reportCancel: boolean;
}

export class CancelUnitInputDto implements ICancelUnitInputDto {
    bookingHeaderID: number;
    bookCode: string;
    lostAmount: number;
    refundAmount: number;
    reasonID: number;
    reasonCode: string;
    remarks: string;
    flagDrmsBooking: string;

    constructor(data?: ICancelUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.lostAmount = data["lostAmount"];
            this.refundAmount = data["refundAmount"];
            this.reasonID = data["reasonID"];
            this.reasonCode = data["reasonCode"];
            this.remarks = data["remarks"];
            this.flagDrmsBooking = data["flagDrmsBooking"];
        }
    }

    static fromJS(data: any): CancelUnitInputDto {
        let result = new CancelUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["lostAmount"] = this.lostAmount;
        data["refundAmount"] = this.refundAmount;
        data["reasonID"] = this.reasonID;
        data["reasonCode"] = this.reasonCode;
        data["remarks"] = this.remarks;
        data["flagDrmsBooking"] = this.flagDrmsBooking;
        return data; 
    }
}

export interface ICancelUnitInputDto {
    bookingHeaderID: number;
    bookCode: string;
    lostAmount: number;
    refundAmount: number;
    reasonID: number;
    reasonCode: string;
    remarks: string;
    flagDrmsBooking: string;
}

export class ResultCancelUnitDto implements IResultCancelUnitDto {
    bookCode: string;
    successCancel: number;
    failCancel: number;

    constructor(data?: IResultCancelUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.successCancel = data["successCancel"];
            this.failCancel = data["failCancel"];
        }
    }

    static fromJS(data: any): ResultCancelUnitDto {
        let result = new ResultCancelUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["successCancel"] = this.successCancel;
        data["failCancel"] = this.failCancel;
        return data; 
    }
}

export interface IResultCancelUnitDto {
    bookCode: string;
    successCancel: number;
    failCancel: number;
}

export class CreateTrBookingCancelInputDto implements ICreateTrBookingCancelInputDto {
    bookingHeaderID: number;
    entityID: number;
    reasonID: number;
    cancelDate: moment.Moment;
    lostAmount: number;
    refundAmount: number;
    newBookCode: string;
    remarks: string;

    constructor(data?: ICreateTrBookingCancelInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.entityID = data["entityID"];
            this.reasonID = data["reasonID"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.lostAmount = data["lostAmount"];
            this.refundAmount = data["refundAmount"];
            this.newBookCode = data["newBookCode"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): CreateTrBookingCancelInputDto {
        let result = new CreateTrBookingCancelInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["entityID"] = this.entityID;
        data["reasonID"] = this.reasonID;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["lostAmount"] = this.lostAmount;
        data["refundAmount"] = this.refundAmount;
        data["newBookCode"] = this.newBookCode;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface ICreateTrBookingCancelInputDto {
    bookingHeaderID: number;
    entityID: number;
    reasonID: number;
    cancelDate: moment.Moment;
    lostAmount: number;
    refundAmount: number;
    newBookCode: string;
    remarks: string;
}

export class ResultGetTransactionDto implements IResultGetTransactionDto {
    totalPayment: GetPaymentUnitDto;
    totalPenaltyAmount: GetPenaltyDataDto;
    sellingPrice: number;

    constructor(data?: IResultGetTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPayment = data["totalPayment"] ? GetPaymentUnitDto.fromJS(data["totalPayment"]) : <any>undefined;
            this.totalPenaltyAmount = data["totalPenaltyAmount"] ? GetPenaltyDataDto.fromJS(data["totalPenaltyAmount"]) : <any>undefined;
            this.sellingPrice = data["sellingPrice"];
        }
    }

    static fromJS(data: any): ResultGetTransactionDto {
        let result = new ResultGetTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPayment"] = this.totalPayment ? this.totalPayment.toJSON() : <any>undefined;
        data["totalPenaltyAmount"] = this.totalPenaltyAmount ? this.totalPenaltyAmount.toJSON() : <any>undefined;
        data["sellingPrice"] = this.sellingPrice;
        return data; 
    }
}

export interface IResultGetTransactionDto {
    totalPayment: GetPaymentUnitDto;
    totalPenaltyAmount: GetPenaltyDataDto;
    sellingPrice: number;
}

export class GetPaymentUnitDto implements IGetPaymentUnitDto {
    bookingHeaderId: number;
    bookCode: string;
    payment_Net: number;
    payment_Vat: number;
    payment_Total: number;

    constructor(data?: IGetPaymentUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderId = data["bookingHeaderId"];
            this.bookCode = data["bookCode"];
            this.payment_Net = data["payment_Net"];
            this.payment_Vat = data["payment_Vat"];
            this.payment_Total = data["payment_Total"];
        }
    }

    static fromJS(data: any): GetPaymentUnitDto {
        let result = new GetPaymentUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["bookCode"] = this.bookCode;
        data["payment_Net"] = this.payment_Net;
        data["payment_Vat"] = this.payment_Vat;
        data["payment_Total"] = this.payment_Total;
        return data; 
    }
}

export interface IGetPaymentUnitDto {
    bookingHeaderId: number;
    bookCode: string;
    payment_Net: number;
    payment_Vat: number;
    payment_Total: number;
}

export class GetPenaltyDataDto implements IGetPenaltyDataDto {
    bookingHeaderId: number;
    totalPenalty: number;
    totalPenaltyPayment: number;

    constructor(data?: IGetPenaltyDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderId = data["bookingHeaderId"];
            this.totalPenalty = data["totalPenalty"];
            this.totalPenaltyPayment = data["totalPenaltyPayment"];
        }
    }

    static fromJS(data: any): GetPenaltyDataDto {
        let result = new GetPenaltyDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["totalPenalty"] = this.totalPenalty;
        data["totalPenaltyPayment"] = this.totalPenaltyPayment;
        return data; 
    }
}

export interface IGetPenaltyDataDto {
    bookingHeaderId: number;
    totalPenalty: number;
    totalPenaltyPayment: number;
}

export class GetDataCancelUnitListDto implements IGetDataCancelUnitListDto {
    bookingHeaderID: number;
    bookCode: string;
    cancelDate: moment.Moment;
    unitNo: string;
    unitCode: string;
    psCode: string;
    customerName: string;
    totalPaymentAmt: number;
    totalPaymentVat: number;
    totalPayment: number;
    totalPenalty: number;
    paymentAdjBankCharge: number;
    lostAmount: number;
    refundAmount: number;
    reasonID: number;
    reasonCode: string;
    remarks: string;

    constructor(data?: IGetDataCancelUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            this.customerName = data["customerName"];
            this.totalPaymentAmt = data["totalPaymentAmt"];
            this.totalPaymentVat = data["totalPaymentVat"];
            this.totalPayment = data["totalPayment"];
            this.totalPenalty = data["totalPenalty"];
            this.paymentAdjBankCharge = data["paymentAdjBankCharge"];
            this.lostAmount = data["lostAmount"];
            this.refundAmount = data["refundAmount"];
            this.reasonID = data["reasonID"];
            this.reasonCode = data["reasonCode"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetDataCancelUnitListDto {
        let result = new GetDataCancelUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        data["customerName"] = this.customerName;
        data["totalPaymentAmt"] = this.totalPaymentAmt;
        data["totalPaymentVat"] = this.totalPaymentVat;
        data["totalPayment"] = this.totalPayment;
        data["totalPenalty"] = this.totalPenalty;
        data["paymentAdjBankCharge"] = this.paymentAdjBankCharge;
        data["lostAmount"] = this.lostAmount;
        data["refundAmount"] = this.refundAmount;
        data["reasonID"] = this.reasonID;
        data["reasonCode"] = this.reasonCode;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetDataCancelUnitListDto {
    bookingHeaderID: number;
    bookCode: string;
    cancelDate: moment.Moment;
    unitNo: string;
    unitCode: string;
    psCode: string;
    customerName: string;
    totalPaymentAmt: number;
    totalPaymentVat: number;
    totalPayment: number;
    totalPenalty: number;
    paymentAdjBankCharge: number;
    lostAmount: number;
    refundAmount: number;
    reasonID: number;
    reasonCode: string;
    remarks: string;
}

export class GetLkReasonDropdownListDto implements IGetLkReasonDropdownListDto {
    reasonID: number;
    strReasonID: string;
    reasonCode: string;
    reasonDesc: string;

    constructor(data?: IGetLkReasonDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reasonID = data["reasonID"];
            this.strReasonID = data["strReasonID"];
            this.reasonCode = data["reasonCode"];
            this.reasonDesc = data["reasonDesc"];
        }
    }

    static fromJS(data: any): GetLkReasonDropdownListDto {
        let result = new GetLkReasonDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonID"] = this.reasonID;
        data["strReasonID"] = this.strReasonID;
        data["reasonCode"] = this.reasonCode;
        data["reasonDesc"] = this.reasonDesc;
        return data; 
    }
}

export interface IGetLkReasonDropdownListDto {
    reasonID: number;
    strReasonID: string;
    reasonCode: string;
    reasonDesc: string;
}

export class VerifyUploadCancelUnitInputDto implements IVerifyUploadCancelUnitInputDto {
    bookCode: string;
    lossAmount: number;
    reasonDesc: string;
    remark: string;

    constructor(data?: IVerifyUploadCancelUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.lossAmount = data["lossAmount"];
            this.reasonDesc = data["reasonDesc"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): VerifyUploadCancelUnitInputDto {
        let result = new VerifyUploadCancelUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["lossAmount"] = this.lossAmount;
        data["reasonDesc"] = this.reasonDesc;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IVerifyUploadCancelUnitInputDto {
    bookCode: string;
    lossAmount: number;
    reasonDesc: string;
    remark: string;
}

export class GetDataVerifyCancelUnitResultDto implements IGetDataVerifyCancelUnitResultDto {
    bookingHeaderId: number;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    lossAmount: number;
    refundAmount: number;
    reasonDesc: string;
    reasonId: number;
    reasonCode: string;
    remark: string;
    cancelDate: moment.Moment;

    constructor(data?: IGetDataVerifyCancelUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderId = data["bookingHeaderId"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.lossAmount = data["lossAmount"];
            this.refundAmount = data["refundAmount"];
            this.reasonDesc = data["reasonDesc"];
            this.reasonId = data["reasonId"];
            this.reasonCode = data["reasonCode"];
            this.remark = data["remark"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataVerifyCancelUnitResultDto {
        let result = new GetDataVerifyCancelUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["lossAmount"] = this.lossAmount;
        data["refundAmount"] = this.refundAmount;
        data["reasonDesc"] = this.reasonDesc;
        data["reasonId"] = this.reasonId;
        data["reasonCode"] = this.reasonCode;
        data["remark"] = this.remark;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDataVerifyCancelUnitResultDto {
    bookingHeaderId: number;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    lossAmount: number;
    refundAmount: number;
    reasonDesc: string;
    reasonId: number;
    reasonCode: string;
    remark: string;
    cancelDate: moment.Moment;
}

export class UpdateCancelUnitDto implements IUpdateCancelUnitDto {
    id: number;
    remarks: string;
    reasonID: number;

    constructor(data?: IUpdateCancelUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.remarks = data["remarks"];
            this.reasonID = data["reasonID"];
        }
    }

    static fromJS(data: any): UpdateCancelUnitDto {
        let result = new UpdateCancelUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remarks"] = this.remarks;
        data["reasonID"] = this.reasonID;
        return data; 
    }
}

export interface IUpdateCancelUnitDto {
    id: number;
    remarks: string;
    reasonID: number;
}

export class ChangeOwnershipInputDto implements IChangeOwnershipInputDto {
    changeOwnerId: number;
    addnNo: string;
    addnDate: moment.Moment;
    bookingHeaderID: number;
    costAmt: number;
    costPct: number;
    docNo: string;
    entityID: number;
    jumlahSetoran: number;
    newBankCode: string;
    newFinType: string;
    newPsCode: string;
    njopBangunan: number;
    njopTanah: number;
    nilaiPengalihan: number;
    nop: string;
    ntpn: string;
    oldBankCode: string;
    oldFinType: string;
    oldPsCode: string;
    remarks: string;
    seqNo: number;
    tanggalPenyetoran: moment.Moment;
    changeOwnerType: string;

    constructor(data?: IChangeOwnershipInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeOwnerId = data["changeOwnerId"];
            this.addnNo = data["addnNo"];
            this.addnDate = data["addnDate"] ? moment(data["addnDate"].toString()) : <any>undefined;
            this.bookingHeaderID = data["bookingHeaderID"];
            this.costAmt = data["costAmt"];
            this.costPct = data["costPct"];
            this.docNo = data["docNo"];
            this.entityID = data["entityID"];
            this.jumlahSetoran = data["jumlahSetoran"];
            this.newBankCode = data["newBankCode"];
            this.newFinType = data["newFinType"];
            this.newPsCode = data["newPsCode"];
            this.njopBangunan = data["njopBangunan"];
            this.njopTanah = data["njopTanah"];
            this.nilaiPengalihan = data["nilaiPengalihan"];
            this.nop = data["nop"];
            this.ntpn = data["ntpn"];
            this.oldBankCode = data["oldBankCode"];
            this.oldFinType = data["oldFinType"];
            this.oldPsCode = data["oldPsCode"];
            this.remarks = data["remarks"];
            this.seqNo = data["seqNo"];
            this.tanggalPenyetoran = data["tanggalPenyetoran"] ? moment(data["tanggalPenyetoran"].toString()) : <any>undefined;
            this.changeOwnerType = data["changeOwnerType"];
        }
    }

    static fromJS(data: any): ChangeOwnershipInputDto {
        let result = new ChangeOwnershipInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeOwnerId"] = this.changeOwnerId;
        data["addnNo"] = this.addnNo;
        data["addnDate"] = this.addnDate ? this.addnDate.toISOString() : <any>undefined;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["costAmt"] = this.costAmt;
        data["costPct"] = this.costPct;
        data["docNo"] = this.docNo;
        data["entityID"] = this.entityID;
        data["jumlahSetoran"] = this.jumlahSetoran;
        data["newBankCode"] = this.newBankCode;
        data["newFinType"] = this.newFinType;
        data["newPsCode"] = this.newPsCode;
        data["njopBangunan"] = this.njopBangunan;
        data["njopTanah"] = this.njopTanah;
        data["nilaiPengalihan"] = this.nilaiPengalihan;
        data["nop"] = this.nop;
        data["ntpn"] = this.ntpn;
        data["oldBankCode"] = this.oldBankCode;
        data["oldFinType"] = this.oldFinType;
        data["oldPsCode"] = this.oldPsCode;
        data["remarks"] = this.remarks;
        data["seqNo"] = this.seqNo;
        data["tanggalPenyetoran"] = this.tanggalPenyetoran ? this.tanggalPenyetoran.toISOString() : <any>undefined;
        data["changeOwnerType"] = this.changeOwnerType;
        return data; 
    }
}

export interface IChangeOwnershipInputDto {
    changeOwnerId: number;
    addnNo: string;
    addnDate: moment.Moment;
    bookingHeaderID: number;
    costAmt: number;
    costPct: number;
    docNo: string;
    entityID: number;
    jumlahSetoran: number;
    newBankCode: string;
    newFinType: string;
    newPsCode: string;
    njopBangunan: number;
    njopTanah: number;
    nilaiPengalihan: number;
    nop: string;
    ntpn: string;
    oldBankCode: string;
    oldFinType: string;
    oldPsCode: string;
    remarks: string;
    seqNo: number;
    tanggalPenyetoran: moment.Moment;
    changeOwnerType: string;
}

export class SendEmailChangeOwnershipDto implements ISendEmailChangeOwnershipDto {
    bookDate: moment.Moment;
    project: string;
    category: string;
    cluster: string;
    product: string;
    unitCode: string;
    unitNo: string;
    oldCientName: string;
    newClientName: string;
    oldPSCodeClient: string;
    newPSCodeClient: string;
    transactionBy: string;
    projectID: number;

    constructor(data?: ISendEmailChangeOwnershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.project = data["project"];
            this.category = data["category"];
            this.cluster = data["cluster"];
            this.product = data["product"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.oldCientName = data["oldCientName"];
            this.newClientName = data["newClientName"];
            this.oldPSCodeClient = data["oldPSCodeClient"];
            this.newPSCodeClient = data["newPSCodeClient"];
            this.transactionBy = data["transactionBy"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): SendEmailChangeOwnershipDto {
        let result = new SendEmailChangeOwnershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["project"] = this.project;
        data["category"] = this.category;
        data["cluster"] = this.cluster;
        data["product"] = this.product;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["oldCientName"] = this.oldCientName;
        data["newClientName"] = this.newClientName;
        data["oldPSCodeClient"] = this.oldPSCodeClient;
        data["newPSCodeClient"] = this.newPSCodeClient;
        data["transactionBy"] = this.transactionBy;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface ISendEmailChangeOwnershipDto {
    bookDate: moment.Moment;
    project: string;
    category: string;
    cluster: string;
    product: string;
    unitCode: string;
    unitNo: string;
    oldCientName: string;
    newClientName: string;
    oldPSCodeClient: string;
    newPSCodeClient: string;
    transactionBy: string;
    projectID: number;
}

export class GetMsBankDropdownListDto implements IGetMsBankDropdownListDto {
    bankID: number;
    bankCode: string;
    bankName: string;

    constructor(data?: IGetMsBankDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetMsBankDropdownListDto {
        let result = new GetMsBankDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetMsBankDropdownListDto {
    bankID: number;
    bankCode: string;
    bankName: string;
}

export class GetDataUnitChangeOwnerListDto implements IGetDataUnitChangeOwnerListDto {
    bookingHeaderID: number;
    bookCode: string;
    unitNo: string;
    unitCode: string;
    psCode: string;
    psName: string;
    bankCode: string;
    bankName: string;
    cancelDate: moment.Moment;
    isCancel: boolean;

    constructor(data?: IGetDataUnitChangeOwnerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.psCode = data["psCode"];
            this.psName = data["psName"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.isCancel = data["isCancel"];
        }
    }

    static fromJS(data: any): GetDataUnitChangeOwnerListDto {
        let result = new GetDataUnitChangeOwnerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["psCode"] = this.psCode;
        data["psName"] = this.psName;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["isCancel"] = this.isCancel;
        return data; 
    }
}

export interface IGetDataUnitChangeOwnerListDto {
    bookingHeaderID: number;
    bookCode: string;
    unitNo: string;
    unitCode: string;
    psCode: string;
    psName: string;
    bankCode: string;
    bankName: string;
    cancelDate: moment.Moment;
    isCancel: boolean;
}

export class GetResultPsCodecheckDto implements IGetResultPsCodecheckDto {
    psCode: string;
    message: string;

    constructor(data?: IGetResultPsCodecheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetResultPsCodecheckDto {
        let result = new GetResultPsCodecheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetResultPsCodecheckDto {
    psCode: string;
    message: string;
}

export class GetHistoryOwnerListDto implements IGetHistoryOwnerListDto {
    bookingChangeOwnerID: number;
    bookingHeaderID: number;
    docNo: string;
    docDate: moment.Moment;
    addnNo: string;
    finType: string;
    psName: string;
    remarks: string;
    isCancel: boolean;

    constructor(data?: IGetHistoryOwnerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingChangeOwnerID = data["bookingChangeOwnerID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.docNo = data["docNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.addnNo = data["addnNo"];
            this.finType = data["finType"];
            this.psName = data["psName"];
            this.remarks = data["remarks"];
            this.isCancel = data["isCancel"];
        }
    }

    static fromJS(data: any): GetHistoryOwnerListDto {
        let result = new GetHistoryOwnerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingChangeOwnerID"] = this.bookingChangeOwnerID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["docNo"] = this.docNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["addnNo"] = this.addnNo;
        data["finType"] = this.finType;
        data["psName"] = this.psName;
        data["remarks"] = this.remarks;
        data["isCancel"] = this.isCancel;
        return data; 
    }
}

export interface IGetHistoryOwnerListDto {
    bookingChangeOwnerID: number;
    bookingHeaderID: number;
    docNo: string;
    docDate: moment.Moment;
    addnNo: string;
    finType: string;
    psName: string;
    remarks: string;
    isCancel: boolean;
}

export class GetSearchPersonalListDto implements IGetSearchPersonalListDto {
    psCode: string;
    name: string;
    idNo: string;

    constructor(data?: IGetSearchPersonalListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.idNo = data["idNo"];
        }
    }

    static fromJS(data: any): GetSearchPersonalListDto {
        let result = new GetSearchPersonalListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["idNo"] = this.idNo;
        return data; 
    }
}

export interface IGetSearchPersonalListDto {
    psCode: string;
    name: string;
    idNo: string;
}

export class GetDetailChangeOwnerDto implements IGetDetailChangeOwnerDto {
    changeOwnerType: string;
    newPsCode: string;
    newPsName: string;
    oldPsCode: string;
    oldPsName: string;
    docNo: string;
    nop: string;
    njopTanah: number;
    njopBangunan: number;
    addnNo: string;
    addnDate: moment.Moment;
    nilaiPengalihan: number;
    ntpn: string;
    costPct: number;
    costAmt: number;
    tanggalPenyetoran: moment.Moment;
    jumlahSetoran: number;
    newBankCode: string;
    newBankName: string;
    oldBankCode: string;
    oldBankName: string;
    remarks: string;

    constructor(data?: IGetDetailChangeOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeOwnerType = data["changeOwnerType"];
            this.newPsCode = data["newPsCode"];
            this.newPsName = data["newPsName"];
            this.oldPsCode = data["oldPsCode"];
            this.oldPsName = data["oldPsName"];
            this.docNo = data["docNo"];
            this.nop = data["nop"];
            this.njopTanah = data["njopTanah"];
            this.njopBangunan = data["njopBangunan"];
            this.addnNo = data["addnNo"];
            this.addnDate = data["addnDate"] ? moment(data["addnDate"].toString()) : <any>undefined;
            this.nilaiPengalihan = data["nilaiPengalihan"];
            this.ntpn = data["ntpn"];
            this.costPct = data["costPct"];
            this.costAmt = data["costAmt"];
            this.tanggalPenyetoran = data["tanggalPenyetoran"] ? moment(data["tanggalPenyetoran"].toString()) : <any>undefined;
            this.jumlahSetoran = data["jumlahSetoran"];
            this.newBankCode = data["newBankCode"];
            this.newBankName = data["newBankName"];
            this.oldBankCode = data["oldBankCode"];
            this.oldBankName = data["oldBankName"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetDetailChangeOwnerDto {
        let result = new GetDetailChangeOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeOwnerType"] = this.changeOwnerType;
        data["newPsCode"] = this.newPsCode;
        data["newPsName"] = this.newPsName;
        data["oldPsCode"] = this.oldPsCode;
        data["oldPsName"] = this.oldPsName;
        data["docNo"] = this.docNo;
        data["nop"] = this.nop;
        data["njopTanah"] = this.njopTanah;
        data["njopBangunan"] = this.njopBangunan;
        data["addnNo"] = this.addnNo;
        data["addnDate"] = this.addnDate ? this.addnDate.toISOString() : <any>undefined;
        data["nilaiPengalihan"] = this.nilaiPengalihan;
        data["ntpn"] = this.ntpn;
        data["costPct"] = this.costPct;
        data["costAmt"] = this.costAmt;
        data["tanggalPenyetoran"] = this.tanggalPenyetoran ? this.tanggalPenyetoran.toISOString() : <any>undefined;
        data["jumlahSetoran"] = this.jumlahSetoran;
        data["newBankCode"] = this.newBankCode;
        data["newBankName"] = this.newBankName;
        data["oldBankCode"] = this.oldBankCode;
        data["oldBankName"] = this.oldBankName;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetDetailChangeOwnerDto {
    changeOwnerType: string;
    newPsCode: string;
    newPsName: string;
    oldPsCode: string;
    oldPsName: string;
    docNo: string;
    nop: string;
    njopTanah: number;
    njopBangunan: number;
    addnNo: string;
    addnDate: moment.Moment;
    nilaiPengalihan: number;
    ntpn: string;
    costPct: number;
    costAmt: number;
    tanggalPenyetoran: moment.Moment;
    jumlahSetoran: number;
    newBankCode: string;
    newBankName: string;
    oldBankCode: string;
    oldBankName: string;
    remarks: string;
}

export class ChangeRenovInputDto implements IChangeRenovInputDto {
    bookingHeaderID: number;
    itemID: number;
    termID: number;

    constructor(data?: IChangeRenovInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.itemID = data["itemID"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): ChangeRenovInputDto {
        let result = new ChangeRenovInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["itemID"] = this.itemID;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface IChangeRenovInputDto {
    bookingHeaderID: number;
    itemID: number;
    termID: number;
}

export class GetRenovListDto implements IGetRenovListDto {
    bookCode: string;
    bookingHeaderId: number;
    unitCode: string;
    unitNo: string;
    itemID: number;
    renovCode: string;
    termID: number;
    isCancel: boolean;

    constructor(data?: IGetRenovListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.bookingHeaderId = data["bookingHeaderId"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.itemID = data["itemID"];
            this.renovCode = data["renovCode"];
            this.termID = data["termID"];
            this.isCancel = data["isCancel"];
        }
    }

    static fromJS(data: any): GetRenovListDto {
        let result = new GetRenovListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["itemID"] = this.itemID;
        data["renovCode"] = this.renovCode;
        data["termID"] = this.termID;
        data["isCancel"] = this.isCancel;
        return data; 
    }
}

export interface IGetRenovListDto {
    bookCode: string;
    bookingHeaderId: number;
    unitCode: string;
    unitNo: string;
    itemID: number;
    renovCode: string;
    termID: number;
    isCancel: boolean;
}

export class GetRenovDropdownListDto implements IGetRenovDropdownListDto {
    itemID: number;
    renovCode: string;
    renovName: string;

    constructor(data?: IGetRenovDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemID = data["itemID"];
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
        }
    }

    static fromJS(data: any): GetRenovDropdownListDto {
        let result = new GetRenovDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        return data; 
    }
}

export interface IGetRenovDropdownListDto {
    itemID: number;
    renovCode: string;
    renovName: string;
}

export class GetDocTemplateListDto implements IGetDocTemplateListDto {
    docTemplateID: number;
    docTemplateCode: string;
    docTemplateName: string;
    docCode: string;
    linkFileDoc: string;
    isActive: boolean;
    isMaster: boolean;
    creationTime: string;
    creationBy: string;
    creatorUserId: number;
    filePath: string[];
    path: LinkPathListDto[];
    copyNo: number;

    constructor(data?: IGetDocTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docTemplateID = data["docTemplateID"];
            this.docTemplateCode = data["docTemplateCode"];
            this.docTemplateName = data["docTemplateName"];
            this.docCode = data["docCode"];
            this.linkFileDoc = data["linkFileDoc"];
            this.isActive = data["isActive"];
            this.isMaster = data["isMaster"];
            this.creationTime = data["creationTime"];
            this.creationBy = data["creationBy"];
            this.creatorUserId = data["creatorUserId"];
            if (data["filePath"] && data["filePath"].constructor === Array) {
                this.filePath = [];
                for (let item of data["filePath"])
                    this.filePath.push(item);
            }
            if (data["path"] && data["path"].constructor === Array) {
                this.path = [];
                for (let item of data["path"])
                    this.path.push(LinkPathListDto.fromJS(item));
            }
            this.copyNo = data["copyNo"];
        }
    }

    static fromJS(data: any): GetDocTemplateListDto {
        let result = new GetDocTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docTemplateID"] = this.docTemplateID;
        data["docTemplateCode"] = this.docTemplateCode;
        data["docTemplateName"] = this.docTemplateName;
        data["docCode"] = this.docCode;
        data["linkFileDoc"] = this.linkFileDoc;
        data["isActive"] = this.isActive;
        data["isMaster"] = this.isMaster;
        data["creationTime"] = this.creationTime;
        data["creationBy"] = this.creationBy;
        data["creatorUserId"] = this.creatorUserId;
        if (this.filePath && this.filePath.constructor === Array) {
            data["filePath"] = [];
            for (let item of this.filePath)
                data["filePath"].push(item);
        }
        if (this.path && this.path.constructor === Array) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["copyNo"] = this.copyNo;
        return data; 
    }
}

export interface IGetDocTemplateListDto {
    docTemplateID: number;
    docTemplateCode: string;
    docTemplateName: string;
    docCode: string;
    linkFileDoc: string;
    isActive: boolean;
    isMaster: boolean;
    creationTime: string;
    creationBy: string;
    creatorUserId: number;
    filePath: string[];
    path: LinkPathListDto[];
    copyNo: number;
}

export class CreateDocTemplateInputDto implements ICreateDocTemplateInputDto {
    templateName: string;
    templateFileDto: TemplateFileListDto[];
    docID: number;
    isMaster: boolean;
    copyNo: number;

    constructor(data?: ICreateDocTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateName = data["templateName"];
            if (data["templateFileDto"] && data["templateFileDto"].constructor === Array) {
                this.templateFileDto = [];
                for (let item of data["templateFileDto"])
                    this.templateFileDto.push(TemplateFileListDto.fromJS(item));
            }
            this.docID = data["docID"];
            this.isMaster = data["isMaster"];
            this.copyNo = data["copyNo"];
        }
    }

    static fromJS(data: any): CreateDocTemplateInputDto {
        let result = new CreateDocTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        if (this.templateFileDto && this.templateFileDto.constructor === Array) {
            data["templateFileDto"] = [];
            for (let item of this.templateFileDto)
                data["templateFileDto"].push(item.toJSON());
        }
        data["docID"] = this.docID;
        data["isMaster"] = this.isMaster;
        data["copyNo"] = this.copyNo;
        return data; 
    }
}

export interface ICreateDocTemplateInputDto {
    templateName: string;
    templateFileDto: TemplateFileListDto[];
    docID: number;
    isMaster: boolean;
    copyNo: number;
}

export class TemplateFileListDto implements ITemplateFileListDto {
    orderNumber: number;
    templateFile: string;

    constructor(data?: ITemplateFileListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderNumber = data["orderNumber"];
            this.templateFile = data["templateFile"];
        }
    }

    static fromJS(data: any): TemplateFileListDto {
        let result = new TemplateFileListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        data["templateFile"] = this.templateFile;
        return data; 
    }
}

export interface ITemplateFileListDto {
    orderNumber: number;
    templateFile: string;
}

export class CheckIsMasterDocIdListDto implements ICheckIsMasterDocIdListDto {
    isMaster: boolean;
    docTemplateID: number;

    constructor(data?: ICheckIsMasterDocIdListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isMaster = data["isMaster"];
            this.docTemplateID = data["docTemplateID"];
        }
    }

    static fromJS(data: any): CheckIsMasterDocIdListDto {
        let result = new CheckIsMasterDocIdListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMaster"] = this.isMaster;
        data["docTemplateID"] = this.docTemplateID;
        return data; 
    }
}

export interface ICheckIsMasterDocIdListDto {
    isMaster: boolean;
    docTemplateID: number;
}

export class GetDocumentDropdownListDto implements IGetDocumentDropdownListDto {
    docID: number;
    docCode: string;
    docName: string;

    constructor(data?: IGetDocumentDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
        }
    }

    static fromJS(data: any): GetDocumentDropdownListDto {
        let result = new GetDocumentDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        return data; 
    }
}

export interface IGetDocumentDropdownListDto {
    docID: number;
    docCode: string;
    docName: string;
}

export class HistoryCreditBankInputDto implements IHistoryCreditBankInputDto {
    bookingHeaderID: number;
    bankID: number;
    updateProgress: string;
    remarks: string;
    updateDate: moment.Moment;

    constructor(data?: IHistoryCreditBankInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bankID = data["bankID"];
            this.updateProgress = data["updateProgress"];
            this.remarks = data["remarks"];
            this.updateDate = data["updateDate"] ? moment(data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryCreditBankInputDto {
        let result = new HistoryCreditBankInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bankID"] = this.bankID;
        data["updateProgress"] = this.updateProgress;
        data["remarks"] = this.remarks;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHistoryCreditBankInputDto {
    bookingHeaderID: number;
    bankID: number;
    updateProgress: string;
    remarks: string;
    updateDate: moment.Moment;
}

export class GetDropdownCreditBankDto implements IGetDropdownCreditBankDto {
    bankID: number;
    bankCode: string;
    bankName: string;

    constructor(data?: IGetDropdownCreditBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetDropdownCreditBankDto {
        let result = new GetDropdownCreditBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetDropdownCreditBankDto {
    bankID: number;
    bankCode: string;
    bankName: string;
}

export class NetPriceHistoryRefund implements INetPriceHistoryRefund {
    bookingheaderID: number;
    clusterID: number;
    bookCode: string;
    projectName: string;
    clusterName: string;
    projectCode: string;
    customerName: string;
    sk: number;
    bookDate: string;
    cancelDate: string;
    termRemarks: string;
    unit: string;
    customer: string;
    grossprice: number;
    bookingFee: number;
    dp: number;
    discount: number;
    netprice: number;
    payment: number;
    priceInclude: number;
    priceExclude: number;
    sellingPriceInclude: number;
    sellingPriceExclude: number;
    pph: number;
    persenAdmin: number;
    salesCommission: number;
    promo: number;
    compensation: number;
    otherDeduction: number;
    otheradditions: number;
    totalDeduction: number;
    totalMoneyRefunded: number;
    remarks: string;
    amountPaymentExcludeVat: number;
    amountPaymentVat: number;
    paymentIncVat: number;
    amountBF: number;
    amountDP: number;
    clusterCode: string;
    totalrefundpaid: number;
    remainingrefund: number;
    financePSAS: string;
    categoryId: number;
    categoryRefund: CategoryRefundDto;

    constructor(data?: INetPriceHistoryRefund) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingheaderID = data["bookingheaderID"];
            this.clusterID = data["clusterID"];
            this.bookCode = data["bookCode"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.projectCode = data["projectCode"];
            this.customerName = data["customerName"];
            this.sk = data["sk"];
            this.bookDate = data["bookDate"];
            this.cancelDate = data["cancelDate"];
            this.termRemarks = data["termRemarks"];
            this.unit = data["unit"];
            this.customer = data["customer"];
            this.grossprice = data["grossprice"];
            this.bookingFee = data["bookingFee"];
            this.dp = data["dp"];
            this.discount = data["discount"];
            this.netprice = data["netprice"];
            this.payment = data["payment"];
            this.priceInclude = data["priceInclude"];
            this.priceExclude = data["priceExclude"];
            this.sellingPriceInclude = data["sellingPriceInclude"];
            this.sellingPriceExclude = data["sellingPriceExclude"];
            this.pph = data["pph"];
            this.persenAdmin = data["persenAdmin"];
            this.salesCommission = data["salesCommission"];
            this.promo = data["promo"];
            this.compensation = data["compensation"];
            this.otherDeduction = data["otherDeduction"];
            this.otheradditions = data["otheradditions"];
            this.totalDeduction = data["totalDeduction"];
            this.totalMoneyRefunded = data["totalMoneyRefunded"];
            this.remarks = data["remarks"];
            this.amountPaymentExcludeVat = data["amountPaymentExcludeVat"];
            this.amountPaymentVat = data["amountPaymentVat"];
            this.paymentIncVat = data["paymentIncVat"];
            this.amountBF = data["amountBF"];
            this.amountDP = data["amountDP"];
            this.clusterCode = data["clusterCode"];
            this.totalrefundpaid = data["totalrefundpaid"];
            this.remainingrefund = data["remainingrefund"];
            this.financePSAS = data["financePSAS"];
            this.categoryId = data["categoryId"];
            this.categoryRefund = data["categoryRefund"] ? CategoryRefundDto.fromJS(data["categoryRefund"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NetPriceHistoryRefund {
        let result = new NetPriceHistoryRefund();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingheaderID"] = this.bookingheaderID;
        data["clusterID"] = this.clusterID;
        data["bookCode"] = this.bookCode;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["projectCode"] = this.projectCode;
        data["customerName"] = this.customerName;
        data["sk"] = this.sk;
        data["bookDate"] = this.bookDate;
        data["cancelDate"] = this.cancelDate;
        data["termRemarks"] = this.termRemarks;
        data["unit"] = this.unit;
        data["customer"] = this.customer;
        data["grossprice"] = this.grossprice;
        data["bookingFee"] = this.bookingFee;
        data["dp"] = this.dp;
        data["discount"] = this.discount;
        data["netprice"] = this.netprice;
        data["payment"] = this.payment;
        data["priceInclude"] = this.priceInclude;
        data["priceExclude"] = this.priceExclude;
        data["sellingPriceInclude"] = this.sellingPriceInclude;
        data["sellingPriceExclude"] = this.sellingPriceExclude;
        data["pph"] = this.pph;
        data["persenAdmin"] = this.persenAdmin;
        data["salesCommission"] = this.salesCommission;
        data["promo"] = this.promo;
        data["compensation"] = this.compensation;
        data["otherDeduction"] = this.otherDeduction;
        data["otheradditions"] = this.otheradditions;
        data["totalDeduction"] = this.totalDeduction;
        data["totalMoneyRefunded"] = this.totalMoneyRefunded;
        data["remarks"] = this.remarks;
        data["amountPaymentExcludeVat"] = this.amountPaymentExcludeVat;
        data["amountPaymentVat"] = this.amountPaymentVat;
        data["paymentIncVat"] = this.paymentIncVat;
        data["amountBF"] = this.amountBF;
        data["amountDP"] = this.amountDP;
        data["clusterCode"] = this.clusterCode;
        data["totalrefundpaid"] = this.totalrefundpaid;
        data["remainingrefund"] = this.remainingrefund;
        data["financePSAS"] = this.financePSAS;
        data["categoryId"] = this.categoryId;
        data["categoryRefund"] = this.categoryRefund ? this.categoryRefund.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INetPriceHistoryRefund {
    bookingheaderID: number;
    clusterID: number;
    bookCode: string;
    projectName: string;
    clusterName: string;
    projectCode: string;
    customerName: string;
    sk: number;
    bookDate: string;
    cancelDate: string;
    termRemarks: string;
    unit: string;
    customer: string;
    grossprice: number;
    bookingFee: number;
    dp: number;
    discount: number;
    netprice: number;
    payment: number;
    priceInclude: number;
    priceExclude: number;
    sellingPriceInclude: number;
    sellingPriceExclude: number;
    pph: number;
    persenAdmin: number;
    salesCommission: number;
    promo: number;
    compensation: number;
    otherDeduction: number;
    otheradditions: number;
    totalDeduction: number;
    totalMoneyRefunded: number;
    remarks: string;
    amountPaymentExcludeVat: number;
    amountPaymentVat: number;
    paymentIncVat: number;
    amountBF: number;
    amountDP: number;
    clusterCode: string;
    totalrefundpaid: number;
    remainingrefund: number;
    financePSAS: string;
    categoryId: number;
    categoryRefund: CategoryRefundDto;
}

export class CategoryRefundDto implements ICategoryRefundDto {
    id: number;
    categoryName: string;

    constructor(data?: ICategoryRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): CategoryRefundDto {
        let result = new CategoryRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface ICategoryRefundDto {
    id: number;
    categoryName: string;
}

export class HistoryRefundDto implements IHistoryRefundDto {
    historyRefundID: number;
    bookCode: string;
    projectCode: string;
    priceInclude: number;
    priceExclude: number;
    sellingPriceInclude: number;
    sellingPriceExclude: number;
    unit: string;
    payment: number;
    amountPaymentExcludeVat: number;
    amountPaymentVat: number;
    paymentIncVat: number;
    customerName: string;
    cancelDate: string;
    bookDate: string;
    remarks: string;
    submissionDate: string;
    sk: number;
    bookingFee: number;
    dp: number;
    hjExclude: number;
    hjInclude: number;
    pph: number;
    persenAdmin: number;
    salesCommission: number;
    promo: number;
    compensation: number;
    totalDeduction: number;
    otherDeduction: number;
    otherAdditions: number;
    totalMoneyRefunded: number;
    totalRefundPaid: number;
    remainingRefund: number;
    userID: number;
    projectID: number;
    clusterID: number;
    creationTime: moment.Moment;
    clusterCode: string;
    financePSAS: string;
    categoryId: number;
    categoryRefund: CategoryRefundDto;

    constructor(data?: IHistoryRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.historyRefundID = data["historyRefundID"];
            this.bookCode = data["bookCode"];
            this.projectCode = data["projectCode"];
            this.priceInclude = data["priceInclude"];
            this.priceExclude = data["priceExclude"];
            this.sellingPriceInclude = data["sellingPriceInclude"];
            this.sellingPriceExclude = data["sellingPriceExclude"];
            this.unit = data["unit"];
            this.payment = data["payment"];
            this.amountPaymentExcludeVat = data["amountPaymentExcludeVat"];
            this.amountPaymentVat = data["amountPaymentVat"];
            this.paymentIncVat = data["paymentIncVat"];
            this.customerName = data["customerName"];
            this.cancelDate = data["cancelDate"];
            this.bookDate = data["bookDate"];
            this.remarks = data["remarks"];
            this.submissionDate = data["submissionDate"];
            this.sk = data["sk"];
            this.bookingFee = data["bookingFee"];
            this.dp = data["dp"];
            this.hjExclude = data["hjExclude"];
            this.hjInclude = data["hjInclude"];
            this.pph = data["pph"];
            this.persenAdmin = data["persenAdmin"];
            this.salesCommission = data["salesCommission"];
            this.promo = data["promo"];
            this.compensation = data["compensation"];
            this.totalDeduction = data["totalDeduction"];
            this.otherDeduction = data["otherDeduction"];
            this.otherAdditions = data["otherAdditions"];
            this.totalMoneyRefunded = data["totalMoneyRefunded"];
            this.totalRefundPaid = data["totalRefundPaid"];
            this.remainingRefund = data["remainingRefund"];
            this.userID = data["userID"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.clusterCode = data["clusterCode"];
            this.financePSAS = data["financePSAS"];
            this.categoryId = data["categoryId"];
            this.categoryRefund = data["categoryRefund"] ? CategoryRefundDto.fromJS(data["categoryRefund"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryRefundDto {
        let result = new HistoryRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["historyRefundID"] = this.historyRefundID;
        data["bookCode"] = this.bookCode;
        data["projectCode"] = this.projectCode;
        data["priceInclude"] = this.priceInclude;
        data["priceExclude"] = this.priceExclude;
        data["sellingPriceInclude"] = this.sellingPriceInclude;
        data["sellingPriceExclude"] = this.sellingPriceExclude;
        data["unit"] = this.unit;
        data["payment"] = this.payment;
        data["amountPaymentExcludeVat"] = this.amountPaymentExcludeVat;
        data["amountPaymentVat"] = this.amountPaymentVat;
        data["paymentIncVat"] = this.paymentIncVat;
        data["customerName"] = this.customerName;
        data["cancelDate"] = this.cancelDate;
        data["bookDate"] = this.bookDate;
        data["remarks"] = this.remarks;
        data["submissionDate"] = this.submissionDate;
        data["sk"] = this.sk;
        data["bookingFee"] = this.bookingFee;
        data["dp"] = this.dp;
        data["hjExclude"] = this.hjExclude;
        data["hjInclude"] = this.hjInclude;
        data["pph"] = this.pph;
        data["persenAdmin"] = this.persenAdmin;
        data["salesCommission"] = this.salesCommission;
        data["promo"] = this.promo;
        data["compensation"] = this.compensation;
        data["totalDeduction"] = this.totalDeduction;
        data["otherDeduction"] = this.otherDeduction;
        data["otherAdditions"] = this.otherAdditions;
        data["totalMoneyRefunded"] = this.totalMoneyRefunded;
        data["totalRefundPaid"] = this.totalRefundPaid;
        data["remainingRefund"] = this.remainingRefund;
        data["userID"] = this.userID;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["clusterCode"] = this.clusterCode;
        data["financePSAS"] = this.financePSAS;
        data["categoryId"] = this.categoryId;
        data["categoryRefund"] = this.categoryRefund ? this.categoryRefund.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHistoryRefundDto {
    historyRefundID: number;
    bookCode: string;
    projectCode: string;
    priceInclude: number;
    priceExclude: number;
    sellingPriceInclude: number;
    sellingPriceExclude: number;
    unit: string;
    payment: number;
    amountPaymentExcludeVat: number;
    amountPaymentVat: number;
    paymentIncVat: number;
    customerName: string;
    cancelDate: string;
    bookDate: string;
    remarks: string;
    submissionDate: string;
    sk: number;
    bookingFee: number;
    dp: number;
    hjExclude: number;
    hjInclude: number;
    pph: number;
    persenAdmin: number;
    salesCommission: number;
    promo: number;
    compensation: number;
    totalDeduction: number;
    otherDeduction: number;
    otherAdditions: number;
    totalMoneyRefunded: number;
    totalRefundPaid: number;
    remainingRefund: number;
    userID: number;
    projectID: number;
    clusterID: number;
    creationTime: moment.Moment;
    clusterCode: string;
    financePSAS: string;
    categoryId: number;
    categoryRefund: CategoryRefundDto;
}

export class PaymentRefundDto implements IPaymentRefundDto {
    id: number;
    termId: number;
    historyRefundID: number;
    nominalPayment: number;
    paymentDate: string;
    remarks: string;
    isPaid: number;
    isActivePaid: boolean;

    constructor(data?: IPaymentRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.termId = data["termId"];
            this.historyRefundID = data["historyRefundID"];
            this.nominalPayment = data["nominalPayment"];
            this.paymentDate = data["paymentDate"];
            this.remarks = data["remarks"];
            this.isPaid = data["isPaid"];
            this.isActivePaid = data["isActivePaid"];
        }
    }

    static fromJS(data: any): PaymentRefundDto {
        let result = new PaymentRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["termId"] = this.termId;
        data["historyRefundID"] = this.historyRefundID;
        data["nominalPayment"] = this.nominalPayment;
        data["paymentDate"] = this.paymentDate;
        data["remarks"] = this.remarks;
        data["isPaid"] = this.isPaid;
        data["isActivePaid"] = this.isActivePaid;
        return data; 
    }
}

export interface IPaymentRefundDto {
    id: number;
    termId: number;
    historyRefundID: number;
    nominalPayment: number;
    paymentDate: string;
    remarks: string;
    isPaid: number;
    isActivePaid: boolean;
}

export class SKDto implements ISKDto {
    id: number;
    sk: string;

    constructor(data?: ISKDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.sk = data["sk"];
        }
    }

    static fromJS(data: any): SKDto {
        let result = new SKDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sk"] = this.sk;
        return data; 
    }
}

export interface ISKDto {
    id: number;
    sk: string;
}

export class InsertAndUpdateHistoryRefundDto implements IInsertAndUpdateHistoryRefundDto {
    bookCode: string;
    historyRefundHeader: HistoryRefundDto;
    historyRefundDetail: HistoryRefundDetailDto[];
    deleteHistoryRefundDetail: DeleteHistoryRefundDetailDto[];

    constructor(data?: IInsertAndUpdateHistoryRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.historyRefundHeader = data["historyRefundHeader"] ? HistoryRefundDto.fromJS(data["historyRefundHeader"]) : <any>undefined;
            if (data["historyRefundDetail"] && data["historyRefundDetail"].constructor === Array) {
                this.historyRefundDetail = [];
                for (let item of data["historyRefundDetail"])
                    this.historyRefundDetail.push(HistoryRefundDetailDto.fromJS(item));
            }
            if (data["deleteHistoryRefundDetail"] && data["deleteHistoryRefundDetail"].constructor === Array) {
                this.deleteHistoryRefundDetail = [];
                for (let item of data["deleteHistoryRefundDetail"])
                    this.deleteHistoryRefundDetail.push(DeleteHistoryRefundDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertAndUpdateHistoryRefundDto {
        let result = new InsertAndUpdateHistoryRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["historyRefundHeader"] = this.historyRefundHeader ? this.historyRefundHeader.toJSON() : <any>undefined;
        if (this.historyRefundDetail && this.historyRefundDetail.constructor === Array) {
            data["historyRefundDetail"] = [];
            for (let item of this.historyRefundDetail)
                data["historyRefundDetail"].push(item.toJSON());
        }
        if (this.deleteHistoryRefundDetail && this.deleteHistoryRefundDetail.constructor === Array) {
            data["deleteHistoryRefundDetail"] = [];
            for (let item of this.deleteHistoryRefundDetail)
                data["deleteHistoryRefundDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsertAndUpdateHistoryRefundDto {
    bookCode: string;
    historyRefundHeader: HistoryRefundDto;
    historyRefundDetail: HistoryRefundDetailDto[];
    deleteHistoryRefundDetail: DeleteHistoryRefundDetailDto[];
}

export class HistoryRefundDetailDto implements IHistoryRefundDetailDto {
    id: number;
    tempId: number;
    historyRefundID: number;
    nominalPayment: number;
    remarks: string;
    isPaid: number;
    isActivePaid: boolean;
    paymentDate: string;

    constructor(data?: IHistoryRefundDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tempId = data["tempId"];
            this.historyRefundID = data["historyRefundID"];
            this.nominalPayment = data["nominalPayment"];
            this.remarks = data["remarks"];
            this.isPaid = data["isPaid"];
            this.isActivePaid = data["isActivePaid"];
            this.paymentDate = data["paymentDate"];
        }
    }

    static fromJS(data: any): HistoryRefundDetailDto {
        let result = new HistoryRefundDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tempId"] = this.tempId;
        data["historyRefundID"] = this.historyRefundID;
        data["nominalPayment"] = this.nominalPayment;
        data["remarks"] = this.remarks;
        data["isPaid"] = this.isPaid;
        data["isActivePaid"] = this.isActivePaid;
        data["paymentDate"] = this.paymentDate;
        return data; 
    }
}

export interface IHistoryRefundDetailDto {
    id: number;
    tempId: number;
    historyRefundID: number;
    nominalPayment: number;
    remarks: string;
    isPaid: number;
    isActivePaid: boolean;
    paymentDate: string;
}

export class DeleteHistoryRefundDetailDto implements IDeleteHistoryRefundDetailDto {
    id: number;
    historyRefundID: number;

    constructor(data?: IDeleteHistoryRefundDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.historyRefundID = data["historyRefundID"];
        }
    }

    static fromJS(data: any): DeleteHistoryRefundDetailDto {
        let result = new DeleteHistoryRefundDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["historyRefundID"] = this.historyRefundID;
        return data; 
    }
}

export interface IDeleteHistoryRefundDetailDto {
    id: number;
    historyRefundID: number;
}

export class HisRefundResultMessageDto implements IHisRefundResultMessageDto {
    message: string;
    result: boolean;

    constructor(data?: IHisRefundResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): HisRefundResultMessageDto {
        let result = new HisRefundResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IHisRefundResultMessageDto {
    message: string;
    result: boolean;
}

export class HistoryStatusAjbDto implements IHistoryStatusAjbDto {
    bookCode: string;
    notarisPPJB: string;
    notarisAJB: string;
    notarisPemecahCER: string;
    notarisBalikNamaCER: string;
    pemecahanSertifikat: string;
    pemecahanSertifikatDate: string;
    pemecahanSertifikatDatePay: string;
    pemecahanSertifikatAmount: number;
    balikNama: string;
    balikNamaDate: string;
    balikNamaAmount: number;
    balikNamaAmountBPHTB: number;
    imb: string;
    imbAmount: number;
    imbDate: string;
    imbDatePay: string;
    pbb: string;
    pbbAmount: number;
    pbbDate: string;
    pbbDatePay: string;
    ajb: string;
    ajbAmount: number;
    ajbDate: string;
    ajbDatePay: string;
    bast: string;
    bastDate: string;
    bastDocDate: string;
    paymentTerm: string;
    retAkad: number;
    retPondasi: number;
    retAtap: number;
    retBAST: number;
    retCER: number;

    constructor(data?: IHistoryStatusAjbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.notarisPPJB = data["notarisPPJB"];
            this.notarisAJB = data["notarisAJB"];
            this.notarisPemecahCER = data["notarisPemecahCER"];
            this.notarisBalikNamaCER = data["notarisBalikNamaCER"];
            this.pemecahanSertifikat = data["pemecahanSertifikat"];
            this.pemecahanSertifikatDate = data["pemecahanSertifikatDate"];
            this.pemecahanSertifikatDatePay = data["pemecahanSertifikatDatePay"];
            this.pemecahanSertifikatAmount = data["pemecahanSertifikatAmount"];
            this.balikNama = data["balikNama"];
            this.balikNamaDate = data["balikNamaDate"];
            this.balikNamaAmount = data["balikNamaAmount"];
            this.balikNamaAmountBPHTB = data["balikNamaAmountBPHTB"];
            this.imb = data["imb"];
            this.imbAmount = data["imbAmount"];
            this.imbDate = data["imbDate"];
            this.imbDatePay = data["imbDatePay"];
            this.pbb = data["pbb"];
            this.pbbAmount = data["pbbAmount"];
            this.pbbDate = data["pbbDate"];
            this.pbbDatePay = data["pbbDatePay"];
            this.ajb = data["ajb"];
            this.ajbAmount = data["ajbAmount"];
            this.ajbDate = data["ajbDate"];
            this.ajbDatePay = data["ajbDatePay"];
            this.bast = data["bast"];
            this.bastDate = data["bastDate"];
            this.bastDocDate = data["bastDocDate"];
            this.paymentTerm = data["paymentTerm"];
            this.retAkad = data["retAkad"];
            this.retPondasi = data["retPondasi"];
            this.retAtap = data["retAtap"];
            this.retBAST = data["retBAST"];
            this.retCER = data["retCER"];
        }
    }

    static fromJS(data: any): HistoryStatusAjbDto {
        let result = new HistoryStatusAjbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["notarisPPJB"] = this.notarisPPJB;
        data["notarisAJB"] = this.notarisAJB;
        data["notarisPemecahCER"] = this.notarisPemecahCER;
        data["notarisBalikNamaCER"] = this.notarisBalikNamaCER;
        data["pemecahanSertifikat"] = this.pemecahanSertifikat;
        data["pemecahanSertifikatDate"] = this.pemecahanSertifikatDate;
        data["pemecahanSertifikatDatePay"] = this.pemecahanSertifikatDatePay;
        data["pemecahanSertifikatAmount"] = this.pemecahanSertifikatAmount;
        data["balikNama"] = this.balikNama;
        data["balikNamaDate"] = this.balikNamaDate;
        data["balikNamaAmount"] = this.balikNamaAmount;
        data["balikNamaAmountBPHTB"] = this.balikNamaAmountBPHTB;
        data["imb"] = this.imb;
        data["imbAmount"] = this.imbAmount;
        data["imbDate"] = this.imbDate;
        data["imbDatePay"] = this.imbDatePay;
        data["pbb"] = this.pbb;
        data["pbbAmount"] = this.pbbAmount;
        data["pbbDate"] = this.pbbDate;
        data["pbbDatePay"] = this.pbbDatePay;
        data["ajb"] = this.ajb;
        data["ajbAmount"] = this.ajbAmount;
        data["ajbDate"] = this.ajbDate;
        data["ajbDatePay"] = this.ajbDatePay;
        data["bast"] = this.bast;
        data["bastDate"] = this.bastDate;
        data["bastDocDate"] = this.bastDocDate;
        data["paymentTerm"] = this.paymentTerm;
        data["retAkad"] = this.retAkad;
        data["retPondasi"] = this.retPondasi;
        data["retAtap"] = this.retAtap;
        data["retBAST"] = this.retBAST;
        data["retCER"] = this.retCER;
        return data; 
    }
}

export interface IHistoryStatusAjbDto {
    bookCode: string;
    notarisPPJB: string;
    notarisAJB: string;
    notarisPemecahCER: string;
    notarisBalikNamaCER: string;
    pemecahanSertifikat: string;
    pemecahanSertifikatDate: string;
    pemecahanSertifikatDatePay: string;
    pemecahanSertifikatAmount: number;
    balikNama: string;
    balikNamaDate: string;
    balikNamaAmount: number;
    balikNamaAmountBPHTB: number;
    imb: string;
    imbAmount: number;
    imbDate: string;
    imbDatePay: string;
    pbb: string;
    pbbAmount: number;
    pbbDate: string;
    pbbDatePay: string;
    ajb: string;
    ajbAmount: number;
    ajbDate: string;
    ajbDatePay: string;
    bast: string;
    bastDate: string;
    bastDocDate: string;
    paymentTerm: string;
    retAkad: number;
    retPondasi: number;
    retAtap: number;
    retBAST: number;
    retCER: number;
}

export class HistoryStatusCollectioninputDto implements IHistoryStatusCollectioninputDto {
    id: number;
    bookCode: string;
    statusCollection: string;
    remarks: string;
    collectionDate: string;
    createdByID: number;
    createdBy: string;
    creationTime: moment.Moment;

    constructor(data?: IHistoryStatusCollectioninputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bookCode = data["bookCode"];
            this.statusCollection = data["statusCollection"];
            this.remarks = data["remarks"];
            this.collectionDate = data["collectionDate"];
            this.createdByID = data["createdByID"];
            this.createdBy = data["createdBy"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryStatusCollectioninputDto {
        let result = new HistoryStatusCollectioninputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookCode"] = this.bookCode;
        data["statusCollection"] = this.statusCollection;
        data["remarks"] = this.remarks;
        data["collectionDate"] = this.collectionDate;
        data["createdByID"] = this.createdByID;
        data["createdBy"] = this.createdBy;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHistoryStatusCollectioninputDto {
    id: number;
    bookCode: string;
    statusCollection: string;
    remarks: string;
    collectionDate: string;
    createdByID: number;
    createdBy: string;
    creationTime: moment.Moment;
}

export class PagedResultDtoOfHistoryStatusCollectioninputDto implements IPagedResultDtoOfHistoryStatusCollectioninputDto {
    totalCount: number;
    items: HistoryStatusCollectioninputDto[];

    constructor(data?: IPagedResultDtoOfHistoryStatusCollectioninputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HistoryStatusCollectioninputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHistoryStatusCollectioninputDto {
        let result = new PagedResultDtoOfHistoryStatusCollectioninputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfHistoryStatusCollectioninputDto {
    totalCount: number;
    items: HistoryStatusCollectioninputDto[];
}

export class GetDropdownStatusCollectionDto implements IGetDropdownStatusCollectionDto {
    id: number;
    statusCollection: string;

    constructor(data?: IGetDropdownStatusCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.statusCollection = data["statusCollection"];
        }
    }

    static fromJS(data: any): GetDropdownStatusCollectionDto {
        let result = new GetDropdownStatusCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCollection"] = this.statusCollection;
        return data; 
    }
}

export interface IGetDropdownStatusCollectionDto {
    id: number;
    statusCollection: string;
}

export class HistoryStatusHandoverInputDto implements IHistoryStatusHandoverInputDto {
    id: number;
    bookCode: string;
    statusHandover: string;
    remarks: string;
    handoverDate: string;
    createdByID: number;
    createdBy: string;
    creationTime: moment.Moment;
    targetHandover: string;

    constructor(data?: IHistoryStatusHandoverInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bookCode = data["bookCode"];
            this.statusHandover = data["statusHandover"];
            this.remarks = data["remarks"];
            this.handoverDate = data["handoverDate"];
            this.createdByID = data["createdByID"];
            this.createdBy = data["createdBy"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.targetHandover = data["targetHandover"];
        }
    }

    static fromJS(data: any): HistoryStatusHandoverInputDto {
        let result = new HistoryStatusHandoverInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookCode"] = this.bookCode;
        data["statusHandover"] = this.statusHandover;
        data["remarks"] = this.remarks;
        data["handoverDate"] = this.handoverDate;
        data["createdByID"] = this.createdByID;
        data["createdBy"] = this.createdBy;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["targetHandover"] = this.targetHandover;
        return data; 
    }
}

export interface IHistoryStatusHandoverInputDto {
    id: number;
    bookCode: string;
    statusHandover: string;
    remarks: string;
    handoverDate: string;
    createdByID: number;
    createdBy: string;
    creationTime: moment.Moment;
    targetHandover: string;
}

export class PagedResultDtoOfHistoryStatusHandoverInputDto implements IPagedResultDtoOfHistoryStatusHandoverInputDto {
    totalCount: number;
    items: HistoryStatusHandoverInputDto[];

    constructor(data?: IPagedResultDtoOfHistoryStatusHandoverInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HistoryStatusHandoverInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHistoryStatusHandoverInputDto {
        let result = new PagedResultDtoOfHistoryStatusHandoverInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfHistoryStatusHandoverInputDto {
    totalCount: number;
    items: HistoryStatusHandoverInputDto[];
}

export class GetDropdownStatusHandoverDto implements IGetDropdownStatusHandoverDto {
    id: number;
    statusHandover: string;

    constructor(data?: IGetDropdownStatusHandoverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.statusHandover = data["statusHandover"];
        }
    }

    static fromJS(data: any): GetDropdownStatusHandoverDto {
        let result = new GetDropdownStatusHandoverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusHandover"] = this.statusHandover;
        return data; 
    }
}

export interface IGetDropdownStatusHandoverDto {
    id: number;
    statusHandover: string;
}

export class InsertAndUpdateHistoryUploadBulkRefund implements IInsertAndUpdateHistoryUploadBulkRefund {
    bookCode: string;
    historyUploadBulkRefundHeader: HistoryUploadBulkRefundDto[];

    constructor(data?: IInsertAndUpdateHistoryUploadBulkRefund) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            if (data["historyUploadBulkRefundHeader"] && data["historyUploadBulkRefundHeader"].constructor === Array) {
                this.historyUploadBulkRefundHeader = [];
                for (let item of data["historyUploadBulkRefundHeader"])
                    this.historyUploadBulkRefundHeader.push(HistoryUploadBulkRefundDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertAndUpdateHistoryUploadBulkRefund {
        let result = new InsertAndUpdateHistoryUploadBulkRefund();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        if (this.historyUploadBulkRefundHeader && this.historyUploadBulkRefundHeader.constructor === Array) {
            data["historyUploadBulkRefundHeader"] = [];
            for (let item of this.historyUploadBulkRefundHeader)
                data["historyUploadBulkRefundHeader"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsertAndUpdateHistoryUploadBulkRefund {
    bookCode: string;
    historyUploadBulkRefundHeader: HistoryUploadBulkRefundDto[];
}

export class HistoryUploadBulkRefundDto implements IHistoryUploadBulkRefundDto {
    id: number;
    bookCode: string;
    projectID: number;
    clusterID: number[];
    cluster: number;
    submissionDate: string;
    skID: number;
    pph: number;
    promothathavebeengiven: number;
    compensationthathasbeenpaid: number;
    otherDeduction: number;
    otherAdditions: number;
    remark: string;

    constructor(data?: IHistoryUploadBulkRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bookCode = data["bookCode"];
            this.projectID = data["projectID"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            this.cluster = data["cluster"];
            this.submissionDate = data["submissionDate"];
            this.skID = data["skID"];
            this.pph = data["pph"];
            this.promothathavebeengiven = data["promothathavebeengiven"];
            this.compensationthathasbeenpaid = data["compensationthathasbeenpaid"];
            this.otherDeduction = data["otherDeduction"];
            this.otherAdditions = data["otherAdditions"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): HistoryUploadBulkRefundDto {
        let result = new HistoryUploadBulkRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookCode"] = this.bookCode;
        data["projectID"] = this.projectID;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        data["cluster"] = this.cluster;
        data["submissionDate"] = this.submissionDate;
        data["skID"] = this.skID;
        data["pph"] = this.pph;
        data["promothathavebeengiven"] = this.promothathavebeengiven;
        data["compensationthathasbeenpaid"] = this.compensationthathasbeenpaid;
        data["otherDeduction"] = this.otherDeduction;
        data["otherAdditions"] = this.otherAdditions;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IHistoryUploadBulkRefundDto {
    id: number;
    bookCode: string;
    projectID: number;
    clusterID: number[];
    cluster: number;
    submissionDate: string;
    skID: number;
    pph: number;
    promothathavebeengiven: number;
    compensationthathasbeenpaid: number;
    otherDeduction: number;
    otherAdditions: number;
    remark: string;
}

export class InsertAndDeletePaymentDetail implements IInsertAndDeletePaymentDetail {
    historyID: number;
    historyUploadBulkRefundDetail: HistoryRefundDetailDto[];
    deleteHistoryUploadBulkRefundDetail: DeleteHistoryRefundDetailDto[];

    constructor(data?: IInsertAndDeletePaymentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.historyID = data["historyID"];
            if (data["historyUploadBulkRefundDetail"] && data["historyUploadBulkRefundDetail"].constructor === Array) {
                this.historyUploadBulkRefundDetail = [];
                for (let item of data["historyUploadBulkRefundDetail"])
                    this.historyUploadBulkRefundDetail.push(HistoryRefundDetailDto.fromJS(item));
            }
            if (data["deleteHistoryUploadBulkRefundDetail"] && data["deleteHistoryUploadBulkRefundDetail"].constructor === Array) {
                this.deleteHistoryUploadBulkRefundDetail = [];
                for (let item of data["deleteHistoryUploadBulkRefundDetail"])
                    this.deleteHistoryUploadBulkRefundDetail.push(DeleteHistoryRefundDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertAndDeletePaymentDetail {
        let result = new InsertAndDeletePaymentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["historyID"] = this.historyID;
        if (this.historyUploadBulkRefundDetail && this.historyUploadBulkRefundDetail.constructor === Array) {
            data["historyUploadBulkRefundDetail"] = [];
            for (let item of this.historyUploadBulkRefundDetail)
                data["historyUploadBulkRefundDetail"].push(item.toJSON());
        }
        if (this.deleteHistoryUploadBulkRefundDetail && this.deleteHistoryUploadBulkRefundDetail.constructor === Array) {
            data["deleteHistoryUploadBulkRefundDetail"] = [];
            for (let item of this.deleteHistoryUploadBulkRefundDetail)
                data["deleteHistoryUploadBulkRefundDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsertAndDeletePaymentDetail {
    historyID: number;
    historyUploadBulkRefundDetail: HistoryRefundDetailDto[];
    deleteHistoryUploadBulkRefundDetail: DeleteHistoryRefundDetailDto[];
}

export class PSASListOfHistoryUploadBulkRefundInputDto implements IPSASListOfHistoryUploadBulkRefundInputDto {
    filter: string;
    projectID: number[];
    clusterID: number[];
    bookCode: string;
    sorting: string;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IPSASListOfHistoryUploadBulkRefundInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            this.bookCode = data["bookCode"];
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    }

    static fromJS(data: any): PSASListOfHistoryUploadBulkRefundInputDto {
        let result = new PSASListOfHistoryUploadBulkRefundInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        data["bookCode"] = this.bookCode;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface IPSASListOfHistoryUploadBulkRefundInputDto {
    filter: string;
    projectID: number[];
    clusterID: number[];
    bookCode: string;
    sorting: string;
    maxResultCount: number;
    skipCount: number;
}

export class PagedResultDtoOfHistoryRefundDto implements IPagedResultDtoOfHistoryRefundDto {
    totalCount: number;
    items: HistoryRefundDto[];

    constructor(data?: IPagedResultDtoOfHistoryRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HistoryRefundDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHistoryRefundDto {
        let result = new PagedResultDtoOfHistoryRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfHistoryRefundDto {
    totalCount: number;
    items: HistoryRefundDto[];
}

export class GenerateHistoryRefundToExcelInput implements IGenerateHistoryRefundToExcelInput {
    projectId: number[];
    clusterID: number[];
    filter: string;

    constructor(data?: IGenerateHistoryRefundToExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectId"] && data["projectId"].constructor === Array) {
                this.projectId = [];
                for (let item of data["projectId"])
                    this.projectId.push(item);
            }
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): GenerateHistoryRefundToExcelInput {
        let result = new GenerateHistoryRefundToExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectId && this.projectId.constructor === Array) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IGenerateHistoryRefundToExcelInput {
    projectId: number[];
    clusterID: number[];
    filter: string;
}

export class CreateKuasaDireksiInputDto implements ICreateKuasaDireksiInputDto {
    kuasaDireksiID: number;
    projectID: number;
    docID: number;
    linkFileKuasaDireksi: string;
    remarks: string;
    isActive: boolean;
    kuasaDireksiPeople: CreateKuasaDireksiPeopleInputDto[];

    constructor(data?: ICreateKuasaDireksiInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kuasaDireksiID = data["kuasaDireksiID"];
            this.projectID = data["projectID"];
            this.docID = data["docID"];
            this.linkFileKuasaDireksi = data["linkFileKuasaDireksi"];
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
            if (data["kuasaDireksiPeople"] && data["kuasaDireksiPeople"].constructor === Array) {
                this.kuasaDireksiPeople = [];
                for (let item of data["kuasaDireksiPeople"])
                    this.kuasaDireksiPeople.push(CreateKuasaDireksiPeopleInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateKuasaDireksiInputDto {
        let result = new CreateKuasaDireksiInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kuasaDireksiID"] = this.kuasaDireksiID;
        data["projectID"] = this.projectID;
        data["docID"] = this.docID;
        data["linkFileKuasaDireksi"] = this.linkFileKuasaDireksi;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        if (this.kuasaDireksiPeople && this.kuasaDireksiPeople.constructor === Array) {
            data["kuasaDireksiPeople"] = [];
            for (let item of this.kuasaDireksiPeople)
                data["kuasaDireksiPeople"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateKuasaDireksiInputDto {
    kuasaDireksiID: number;
    projectID: number;
    docID: number;
    linkFileKuasaDireksi: string;
    remarks: string;
    isActive: boolean;
    kuasaDireksiPeople: CreateKuasaDireksiPeopleInputDto[];
}

export class CreateKuasaDireksiPeopleInputDto implements ICreateKuasaDireksiPeopleInputDto {
    kuasaDireksiPeopleID: number;
    name: string;
    position: string;
    email: string;
    noTelp: string;
    signatureImage: string;
    parafImage: string;
    isActive: boolean;
    entityID: number;
    kuasaDireksiID: number;
    officerID: number;

    constructor(data?: ICreateKuasaDireksiPeopleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kuasaDireksiPeopleID = data["kuasaDireksiPeopleID"];
            this.name = data["name"];
            this.position = data["position"];
            this.email = data["email"];
            this.noTelp = data["noTelp"];
            this.signatureImage = data["signatureImage"];
            this.parafImage = data["parafImage"];
            this.isActive = data["isActive"];
            this.entityID = data["entityID"];
            this.kuasaDireksiID = data["kuasaDireksiID"];
            this.officerID = data["officerID"];
        }
    }

    static fromJS(data: any): CreateKuasaDireksiPeopleInputDto {
        let result = new CreateKuasaDireksiPeopleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kuasaDireksiPeopleID"] = this.kuasaDireksiPeopleID;
        data["name"] = this.name;
        data["position"] = this.position;
        data["email"] = this.email;
        data["noTelp"] = this.noTelp;
        data["signatureImage"] = this.signatureImage;
        data["parafImage"] = this.parafImage;
        data["isActive"] = this.isActive;
        data["entityID"] = this.entityID;
        data["kuasaDireksiID"] = this.kuasaDireksiID;
        data["officerID"] = this.officerID;
        return data; 
    }
}

export interface ICreateKuasaDireksiPeopleInputDto {
    kuasaDireksiPeopleID: number;
    name: string;
    position: string;
    email: string;
    noTelp: string;
    signatureImage: string;
    parafImage: string;
    isActive: boolean;
    entityID: number;
    kuasaDireksiID: number;
    officerID: number;
}

export class PagedResultDtoOfGetPSASListOfKuasaDireksiListDto implements IPagedResultDtoOfGetPSASListOfKuasaDireksiListDto {
    totalCount: number;
    items: GetPSASListOfKuasaDireksiListDto[];

    constructor(data?: IPagedResultDtoOfGetPSASListOfKuasaDireksiListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPSASListOfKuasaDireksiListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPSASListOfKuasaDireksiListDto {
        let result = new PagedResultDtoOfGetPSASListOfKuasaDireksiListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPSASListOfKuasaDireksiListDto {
    totalCount: number;
    items: GetPSASListOfKuasaDireksiListDto[];
}

export class GetPSASListOfKuasaDireksiListDto implements IGetPSASListOfKuasaDireksiListDto {
    kuasaDireksiID: number;
    kuasaDireksiCode: string;
    docID: number;
    docCode: string;
    entityID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    remarks: string;
    suratKuasaImage: string;
    isActive: boolean;

    constructor(data?: IGetPSASListOfKuasaDireksiListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kuasaDireksiID = data["kuasaDireksiID"];
            this.kuasaDireksiCode = data["kuasaDireksiCode"];
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.entityID = data["entityID"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.remarks = data["remarks"];
            this.suratKuasaImage = data["suratKuasaImage"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GetPSASListOfKuasaDireksiListDto {
        let result = new GetPSASListOfKuasaDireksiListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kuasaDireksiID"] = this.kuasaDireksiID;
        data["kuasaDireksiCode"] = this.kuasaDireksiCode;
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["entityID"] = this.entityID;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["remarks"] = this.remarks;
        data["suratKuasaImage"] = this.suratKuasaImage;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGetPSASListOfKuasaDireksiListDto {
    kuasaDireksiID: number;
    kuasaDireksiCode: string;
    docID: number;
    docCode: string;
    entityID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    remarks: string;
    suratKuasaImage: string;
    isActive: boolean;
}

export class GetPSASKuasaDireksiAndPeopleListDto implements IGetPSASKuasaDireksiAndPeopleListDto {
    getDetailKuasaDireksi: GetDetailPSASListOfKuasaDireksiListDto;
    getDetailKuasaDireksiPeople: GetPSASListOfKuasaDireksiPeopleListDto[];

    constructor(data?: IGetPSASKuasaDireksiAndPeopleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.getDetailKuasaDireksi = data["getDetailKuasaDireksi"] ? GetDetailPSASListOfKuasaDireksiListDto.fromJS(data["getDetailKuasaDireksi"]) : <any>undefined;
            if (data["getDetailKuasaDireksiPeople"] && data["getDetailKuasaDireksiPeople"].constructor === Array) {
                this.getDetailKuasaDireksiPeople = [];
                for (let item of data["getDetailKuasaDireksiPeople"])
                    this.getDetailKuasaDireksiPeople.push(GetPSASListOfKuasaDireksiPeopleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPSASKuasaDireksiAndPeopleListDto {
        let result = new GetPSASKuasaDireksiAndPeopleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getDetailKuasaDireksi"] = this.getDetailKuasaDireksi ? this.getDetailKuasaDireksi.toJSON() : <any>undefined;
        if (this.getDetailKuasaDireksiPeople && this.getDetailKuasaDireksiPeople.constructor === Array) {
            data["getDetailKuasaDireksiPeople"] = [];
            for (let item of this.getDetailKuasaDireksiPeople)
                data["getDetailKuasaDireksiPeople"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPSASKuasaDireksiAndPeopleListDto {
    getDetailKuasaDireksi: GetDetailPSASListOfKuasaDireksiListDto;
    getDetailKuasaDireksiPeople: GetPSASListOfKuasaDireksiPeopleListDto[];
}

export class GetDetailPSASListOfKuasaDireksiListDto implements IGetDetailPSASListOfKuasaDireksiListDto {
    entityID: number;
    kuasaDireksiID: number;
    kuasaDireksiPeopleID: number;
    kuasaDireksiPeopleName: string;
    kuasaDireksiCode: string;
    projectID: number;
    officerID: number;
    docID: number;
    linkFileKuasaDireksi: string;
    linkSignature: string;
    parafImage: string;
    remarks: string;
    isActive: boolean;
    namePosition: string;
    signeeName: string;

    constructor(data?: IGetDetailPSASListOfKuasaDireksiListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.kuasaDireksiID = data["kuasaDireksiID"];
            this.kuasaDireksiPeopleID = data["kuasaDireksiPeopleID"];
            this.kuasaDireksiPeopleName = data["kuasaDireksiPeopleName"];
            this.kuasaDireksiCode = data["kuasaDireksiCode"];
            this.projectID = data["projectID"];
            this.officerID = data["officerID"];
            this.docID = data["docID"];
            this.linkFileKuasaDireksi = data["linkFileKuasaDireksi"];
            this.linkSignature = data["linkSignature"];
            this.parafImage = data["parafImage"];
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
            this.namePosition = data["namePosition"];
            this.signeeName = data["signeeName"];
        }
    }

    static fromJS(data: any): GetDetailPSASListOfKuasaDireksiListDto {
        let result = new GetDetailPSASListOfKuasaDireksiListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["kuasaDireksiID"] = this.kuasaDireksiID;
        data["kuasaDireksiPeopleID"] = this.kuasaDireksiPeopleID;
        data["kuasaDireksiPeopleName"] = this.kuasaDireksiPeopleName;
        data["kuasaDireksiCode"] = this.kuasaDireksiCode;
        data["projectID"] = this.projectID;
        data["officerID"] = this.officerID;
        data["docID"] = this.docID;
        data["linkFileKuasaDireksi"] = this.linkFileKuasaDireksi;
        data["linkSignature"] = this.linkSignature;
        data["parafImage"] = this.parafImage;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        data["namePosition"] = this.namePosition;
        data["signeeName"] = this.signeeName;
        return data; 
    }
}

export interface IGetDetailPSASListOfKuasaDireksiListDto {
    entityID: number;
    kuasaDireksiID: number;
    kuasaDireksiPeopleID: number;
    kuasaDireksiPeopleName: string;
    kuasaDireksiCode: string;
    projectID: number;
    officerID: number;
    docID: number;
    linkFileKuasaDireksi: string;
    linkSignature: string;
    parafImage: string;
    remarks: string;
    isActive: boolean;
    namePosition: string;
    signeeName: string;
}

export class GetPSASListOfKuasaDireksiPeopleListDto implements IGetPSASListOfKuasaDireksiPeopleListDto {
    entityID: number;
    kuasaDireksiPeopleID: number;
    name: string;
    position: string;
    email: string;
    noTelp: string;
    signatureImage: string;
    parafImage: string;
    isActive: boolean;
    kuasaDireksiID: number;
    officerID: number;

    constructor(data?: IGetPSASListOfKuasaDireksiPeopleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.kuasaDireksiPeopleID = data["kuasaDireksiPeopleID"];
            this.name = data["name"];
            this.position = data["position"];
            this.email = data["email"];
            this.noTelp = data["noTelp"];
            this.signatureImage = data["signatureImage"];
            this.parafImage = data["parafImage"];
            this.isActive = data["isActive"];
            this.kuasaDireksiID = data["kuasaDireksiID"];
            this.officerID = data["officerID"];
        }
    }

    static fromJS(data: any): GetPSASListOfKuasaDireksiPeopleListDto {
        let result = new GetPSASListOfKuasaDireksiPeopleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["kuasaDireksiPeopleID"] = this.kuasaDireksiPeopleID;
        data["name"] = this.name;
        data["position"] = this.position;
        data["email"] = this.email;
        data["noTelp"] = this.noTelp;
        data["signatureImage"] = this.signatureImage;
        data["parafImage"] = this.parafImage;
        data["isActive"] = this.isActive;
        data["kuasaDireksiID"] = this.kuasaDireksiID;
        data["officerID"] = this.officerID;
        return data; 
    }
}

export interface IGetPSASListOfKuasaDireksiPeopleListDto {
    entityID: number;
    kuasaDireksiPeopleID: number;
    name: string;
    position: string;
    email: string;
    noTelp: string;
    signatureImage: string;
    parafImage: string;
    isActive: boolean;
    kuasaDireksiID: number;
    officerID: number;
}

export class UpdateKuasaDireksiSignatureDto implements IUpdateKuasaDireksiSignatureDto {
    kuasaDireksiPeopleID: number;
    signature: string;
    paraf: string;

    constructor(data?: IUpdateKuasaDireksiSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kuasaDireksiPeopleID = data["kuasaDireksiPeopleID"];
            this.signature = data["signature"];
            this.paraf = data["paraf"];
        }
    }

    static fromJS(data: any): UpdateKuasaDireksiSignatureDto {
        let result = new UpdateKuasaDireksiSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kuasaDireksiPeopleID"] = this.kuasaDireksiPeopleID;
        data["signature"] = this.signature;
        data["paraf"] = this.paraf;
        return data; 
    }
}

export interface IUpdateKuasaDireksiSignatureDto {
    kuasaDireksiPeopleID: number;
    signature: string;
    paraf: string;
}

export class GetUniversalLandDocDto implements IGetUniversalLandDocDto {
    landDocInfo: GetLandDocInformationDto;
    detailInfoSertifikatFisik: GetDetailInfoSertifikatFisikDto[];

    constructor(data?: IGetUniversalLandDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.landDocInfo = data["landDocInfo"] ? GetLandDocInformationDto.fromJS(data["landDocInfo"]) : <any>undefined;
            if (data["detailInfoSertifikatFisik"] && data["detailInfoSertifikatFisik"].constructor === Array) {
                this.detailInfoSertifikatFisik = [];
                for (let item of data["detailInfoSertifikatFisik"])
                    this.detailInfoSertifikatFisik.push(GetDetailInfoSertifikatFisikDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUniversalLandDocDto {
        let result = new GetUniversalLandDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["landDocInfo"] = this.landDocInfo ? this.landDocInfo.toJSON() : <any>undefined;
        if (this.detailInfoSertifikatFisik && this.detailInfoSertifikatFisik.constructor === Array) {
            data["detailInfoSertifikatFisik"] = [];
            for (let item of this.detailInfoSertifikatFisik)
                data["detailInfoSertifikatFisik"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUniversalLandDocDto {
    landDocInfo: GetLandDocInformationDto;
    detailInfoSertifikatFisik: GetDetailInfoSertifikatFisikDto[];
}

export class GetLandDocInformationDto implements IGetLandDocInformationDto {
    bookCode: string;
    psCode: string;
    unitNo: string;
    unitCode: string;
    projectName: string;
    clusterName: string;
    typeDoc: string;
    luasTanahPropSys: number;
    statusLuasTanah: string;

    constructor(data?: IGetLandDocInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.typeDoc = data["typeDoc"];
            this.luasTanahPropSys = data["luasTanahPropSys"];
            this.statusLuasTanah = data["statusLuasTanah"];
        }
    }

    static fromJS(data: any): GetLandDocInformationDto {
        let result = new GetLandDocInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["typeDoc"] = this.typeDoc;
        data["luasTanahPropSys"] = this.luasTanahPropSys;
        data["statusLuasTanah"] = this.statusLuasTanah;
        return data; 
    }
}

export interface IGetLandDocInformationDto {
    bookCode: string;
    psCode: string;
    unitNo: string;
    unitCode: string;
    projectName: string;
    clusterName: string;
    typeDoc: string;
    luasTanahPropSys: number;
    statusLuasTanah: string;
}

export class GetDetailInfoSertifikatFisikDto implements IGetDetailInfoSertifikatFisikDto {
    nama: string;
    luasTanah: number;
    nomorSertipikat: string;
    tanggalPenerbitan: moment.Moment;
    tanggalBerakhirHak: moment.Moment;

    constructor(data?: IGetDetailInfoSertifikatFisikDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nama = data["nama"];
            this.luasTanah = data["luasTanah"];
            this.nomorSertipikat = data["nomorSertipikat"];
            this.tanggalPenerbitan = data["tanggalPenerbitan"] ? moment(data["tanggalPenerbitan"].toString()) : <any>undefined;
            this.tanggalBerakhirHak = data["tanggalBerakhirHak"] ? moment(data["tanggalBerakhirHak"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailInfoSertifikatFisikDto {
        let result = new GetDetailInfoSertifikatFisikDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nama"] = this.nama;
        data["luasTanah"] = this.luasTanah;
        data["nomorSertipikat"] = this.nomorSertipikat;
        data["tanggalPenerbitan"] = this.tanggalPenerbitan ? this.tanggalPenerbitan.toISOString() : <any>undefined;
        data["tanggalBerakhirHak"] = this.tanggalBerakhirHak ? this.tanggalBerakhirHak.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailInfoSertifikatFisikDto {
    nama: string;
    luasTanah: number;
    nomorSertipikat: string;
    tanggalPenerbitan: moment.Moment;
    tanggalBerakhirHak: moment.Moment;
}

export class CreateMappingDBDto implements ICreateMappingDBDto {
    dataSource: string;
    initialCatalog: string;
    password: string;
    userName: string;

    constructor(data?: ICreateMappingDBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataSource = data["dataSource"];
            this.initialCatalog = data["initialCatalog"];
            this.password = data["password"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateMappingDBDto {
        let result = new CreateMappingDBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource;
        data["initialCatalog"] = this.initialCatalog;
        data["password"] = this.password;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateMappingDBDto {
    dataSource: string;
    initialCatalog: string;
    password: string;
    userName: string;
}

export class UpdateMappingDBDto implements IUpdateMappingDBDto {
    id: number;
    dataSource: string;
    initialCatalog: string;
    password: string;
    userName: string;

    constructor(data?: IUpdateMappingDBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dataSource = data["dataSource"];
            this.initialCatalog = data["initialCatalog"];
            this.password = data["password"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): UpdateMappingDBDto {
        let result = new UpdateMappingDBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataSource"] = this.dataSource;
        data["initialCatalog"] = this.initialCatalog;
        data["password"] = this.password;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IUpdateMappingDBDto {
    id: number;
    dataSource: string;
    initialCatalog: string;
    password: string;
    userName: string;
}

export class GetDataMsMappingDBResultDto implements IGetDataMsMappingDBResultDto {
    id: number;
    dataSource: string;
    initialCatalog: string;
    password: string;
    securePassword: string;
    userName: string;

    constructor(data?: IGetDataMsMappingDBResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.dataSource = data["dataSource"];
            this.initialCatalog = data["initialCatalog"];
            this.password = data["password"];
            this.securePassword = data["securePassword"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetDataMsMappingDBResultDto {
        let result = new GetDataMsMappingDBResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataSource"] = this.dataSource;
        data["initialCatalog"] = this.initialCatalog;
        data["password"] = this.password;
        data["securePassword"] = this.securePassword;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IGetDataMsMappingDBResultDto {
    id: number;
    dataSource: string;
    initialCatalog: string;
    password: string;
    securePassword: string;
    userName: string;
}

export class GetUniversalMainListDto implements IGetUniversalMainListDto {
    getAllPSASMainHeaderDto: GetPSASMainHeaderListDto[];
    getPSASMainDto: GetPSASMainListDto;
    unitCode: string;
    unitNo: string;
    bookCode: string;

    constructor(data?: IGetUniversalMainListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["getAllPSASMainHeaderDto"] && data["getAllPSASMainHeaderDto"].constructor === Array) {
                this.getAllPSASMainHeaderDto = [];
                for (let item of data["getAllPSASMainHeaderDto"])
                    this.getAllPSASMainHeaderDto.push(GetPSASMainHeaderListDto.fromJS(item));
            }
            this.getPSASMainDto = data["getPSASMainDto"] ? GetPSASMainListDto.fromJS(data["getPSASMainDto"]) : <any>undefined;
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): GetUniversalMainListDto {
        let result = new GetUniversalMainListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.getAllPSASMainHeaderDto && this.getAllPSASMainHeaderDto.constructor === Array) {
            data["getAllPSASMainHeaderDto"] = [];
            for (let item of this.getAllPSASMainHeaderDto)
                data["getAllPSASMainHeaderDto"].push(item.toJSON());
        }
        data["getPSASMainDto"] = this.getPSASMainDto ? this.getPSASMainDto.toJSON() : <any>undefined;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IGetUniversalMainListDto {
    getAllPSASMainHeaderDto: GetPSASMainHeaderListDto[];
    getPSASMainDto: GetPSASMainListDto;
    unitCode: string;
    unitNo: string;
    bookCode: string;
}

export class GetPSASMainHeaderListDto implements IGetPSASMainHeaderListDto {
    itemName: string;
    coCode: string;
    area: number;
    netPriceMKT: number;
    netPriceComm: number;
    netNetPrice: number;

    constructor(data?: IGetPSASMainHeaderListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemName = data["itemName"];
            this.coCode = data["coCode"];
            this.area = data["area"];
            this.netPriceMKT = data["netPriceMKT"];
            this.netPriceComm = data["netPriceComm"];
            this.netNetPrice = data["netNetPrice"];
        }
    }

    static fromJS(data: any): GetPSASMainHeaderListDto {
        let result = new GetPSASMainHeaderListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["coCode"] = this.coCode;
        data["area"] = this.area;
        data["netPriceMKT"] = this.netPriceMKT;
        data["netPriceComm"] = this.netPriceComm;
        data["netNetPrice"] = this.netNetPrice;
        return data; 
    }
}

export interface IGetPSASMainHeaderListDto {
    itemName: string;
    coCode: string;
    area: number;
    netPriceMKT: number;
    netPriceComm: number;
    netNetPrice: number;
}

export class GetPSASMainListDto implements IGetPSASMainListDto {
    projectName: string;
    productName: string;
    territory: string;
    termCode: string;
    termNo: string;
    name: string;
    address: string;
    npwp: string;
    phone: string;
    psCode: string;
    salesEvent: string;
    transactionCome: string;
    payType: string;
    bankName: string;
    amount: number;
    noRekening: string;
    schema: string;
    memberID: string;
    memberName: string;
    bookDate: moment.Moment;
    bookedStatus: string;
    cancelDate: moment.Moment;
    remarks: string;
    note: string;
    status: string;
    reason: string;
    reasonRemarks: string;
    unitNo: string;
    unitCode: string;
    clusterCode: string;
    clusterName: string;
    bookCode: string;
    voucher: string;
    ppno: string;
    isPaid: boolean;

    constructor(data?: IGetPSASMainListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.territory = data["territory"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.name = data["name"];
            this.address = data["address"];
            this.npwp = data["npwp"];
            this.phone = data["phone"];
            this.psCode = data["psCode"];
            this.salesEvent = data["salesEvent"];
            this.transactionCome = data["transactionCome"];
            this.payType = data["payType"];
            this.bankName = data["bankName"];
            this.amount = data["amount"];
            this.noRekening = data["noRekening"];
            this.schema = data["schema"];
            this.memberID = data["memberID"];
            this.memberName = data["memberName"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.bookedStatus = data["bookedStatus"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.note = data["note"];
            this.status = data["status"];
            this.reason = data["reason"];
            this.reasonRemarks = data["reasonRemarks"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.bookCode = data["bookCode"];
            this.voucher = data["voucher"];
            this.ppno = data["ppno"];
            this.isPaid = data["isPaid"];
        }
    }

    static fromJS(data: any): GetPSASMainListDto {
        let result = new GetPSASMainListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["territory"] = this.territory;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["name"] = this.name;
        data["address"] = this.address;
        data["npwp"] = this.npwp;
        data["phone"] = this.phone;
        data["psCode"] = this.psCode;
        data["salesEvent"] = this.salesEvent;
        data["transactionCome"] = this.transactionCome;
        data["payType"] = this.payType;
        data["bankName"] = this.bankName;
        data["amount"] = this.amount;
        data["noRekening"] = this.noRekening;
        data["schema"] = this.schema;
        data["memberID"] = this.memberID;
        data["memberName"] = this.memberName;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["bookedStatus"] = this.bookedStatus;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["note"] = this.note;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["reasonRemarks"] = this.reasonRemarks;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["bookCode"] = this.bookCode;
        data["voucher"] = this.voucher;
        data["ppno"] = this.ppno;
        data["isPaid"] = this.isPaid;
        return data; 
    }
}

export interface IGetPSASMainListDto {
    projectName: string;
    productName: string;
    territory: string;
    termCode: string;
    termNo: string;
    name: string;
    address: string;
    npwp: string;
    phone: string;
    psCode: string;
    salesEvent: string;
    transactionCome: string;
    payType: string;
    bankName: string;
    amount: number;
    noRekening: string;
    schema: string;
    memberID: string;
    memberName: string;
    bookDate: moment.Moment;
    bookedStatus: string;
    cancelDate: moment.Moment;
    remarks: string;
    note: string;
    status: string;
    reason: string;
    reasonRemarks: string;
    unitNo: string;
    unitCode: string;
    clusterCode: string;
    clusterName: string;
    bookCode: string;
    voucher: string;
    ppno: string;
    isPaid: boolean;
}

export class GetUniversalPsasDto implements IGetUniversalPsasDto {
    printedBy: string;
    akrDate: string;
    printedOn: string;
    psasMain: GetPSASMainUnitDetailDto;
    psasPrice: GetUniversalListDto;
    psasPayment: GetPSASMainPaymentDto[];
    psasSchedule: GetPSASMainScheduleDto[];
    psasPaymentAjb: GetPSASMinPaymentAJBDto[];
    psasScheduleAjb: GetPSASMainScheduleAjbDto[];
    areaTotal: number;
    grossPriceTotal: string;
    grossPriceTotalS: string;
    discountRupiahBangunan: string;
    discountRupiahTanah: string;
    discountRupiahRenov: string;
    discountTotal: string;
    netPriceTotal: string;
    netNetPriceTotal: string;
    vatTotal: string;
    interestTotal: string;
    sellingPriceBangunan: string;
    sellingPriceTanah: string;
    sellingPriceRenov: string;
    sellingPriceTotal: string;
    additionalDisc: string;
    additionalDiscS: string;
    payment: string;
    schedule: string;
    netAmtSchedule: string;
    netAmtSchedulePen: string;
    vatAmtSchedule: string;
    vatAmtSchedulePen: string;
    totalAmtSchedule: string;
    totalAmtSchedulePen: string;
    netAmtPayment: string;
    netAmtPaymentPen: string;
    vatAmtPayment: string;
    vatAmtPaymentPen: string;
    totalAmtPayment: string;
    totalAmtPaymentPen: string;
    netAmtBal: string;
    vatAmtBal: string;
    totalAmtBal: string;
    totalPenaltyBal: string;

    constructor(data?: IGetUniversalPsasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.printedBy = data["printedBy"];
            this.akrDate = data["akrDate"];
            this.printedOn = data["printedOn"];
            this.psasMain = data["psasMain"] ? GetPSASMainUnitDetailDto.fromJS(data["psasMain"]) : <any>undefined;
            this.psasPrice = data["psasPrice"] ? GetUniversalListDto.fromJS(data["psasPrice"]) : <any>undefined;
            if (data["psasPayment"] && data["psasPayment"].constructor === Array) {
                this.psasPayment = [];
                for (let item of data["psasPayment"])
                    this.psasPayment.push(GetPSASMainPaymentDto.fromJS(item));
            }
            if (data["psasSchedule"] && data["psasSchedule"].constructor === Array) {
                this.psasSchedule = [];
                for (let item of data["psasSchedule"])
                    this.psasSchedule.push(GetPSASMainScheduleDto.fromJS(item));
            }
            if (data["psasPaymentAjb"] && data["psasPaymentAjb"].constructor === Array) {
                this.psasPaymentAjb = [];
                for (let item of data["psasPaymentAjb"])
                    this.psasPaymentAjb.push(GetPSASMinPaymentAJBDto.fromJS(item));
            }
            if (data["psasScheduleAjb"] && data["psasScheduleAjb"].constructor === Array) {
                this.psasScheduleAjb = [];
                for (let item of data["psasScheduleAjb"])
                    this.psasScheduleAjb.push(GetPSASMainScheduleAjbDto.fromJS(item));
            }
            this.areaTotal = data["areaTotal"];
            this.grossPriceTotal = data["grossPriceTotal"];
            this.grossPriceTotalS = data["grossPriceTotalS"];
            this.discountRupiahBangunan = data["discountRupiahBangunan"];
            this.discountRupiahTanah = data["discountRupiahTanah"];
            this.discountRupiahRenov = data["discountRupiahRenov"];
            this.discountTotal = data["discountTotal"];
            this.netPriceTotal = data["netPriceTotal"];
            this.netNetPriceTotal = data["netNetPriceTotal"];
            this.vatTotal = data["vatTotal"];
            this.interestTotal = data["interestTotal"];
            this.sellingPriceBangunan = data["sellingPriceBangunan"];
            this.sellingPriceTanah = data["sellingPriceTanah"];
            this.sellingPriceRenov = data["sellingPriceRenov"];
            this.sellingPriceTotal = data["sellingPriceTotal"];
            this.additionalDisc = data["additionalDisc"];
            this.additionalDiscS = data["additionalDiscS"];
            this.payment = data["payment"];
            this.schedule = data["schedule"];
            this.netAmtSchedule = data["netAmtSchedule"];
            this.netAmtSchedulePen = data["netAmtSchedulePen"];
            this.vatAmtSchedule = data["vatAmtSchedule"];
            this.vatAmtSchedulePen = data["vatAmtSchedulePen"];
            this.totalAmtSchedule = data["totalAmtSchedule"];
            this.totalAmtSchedulePen = data["totalAmtSchedulePen"];
            this.netAmtPayment = data["netAmtPayment"];
            this.netAmtPaymentPen = data["netAmtPaymentPen"];
            this.vatAmtPayment = data["vatAmtPayment"];
            this.vatAmtPaymentPen = data["vatAmtPaymentPen"];
            this.totalAmtPayment = data["totalAmtPayment"];
            this.totalAmtPaymentPen = data["totalAmtPaymentPen"];
            this.netAmtBal = data["netAmtBal"];
            this.vatAmtBal = data["vatAmtBal"];
            this.totalAmtBal = data["totalAmtBal"];
            this.totalPenaltyBal = data["totalPenaltyBal"];
        }
    }

    static fromJS(data: any): GetUniversalPsasDto {
        let result = new GetUniversalPsasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printedBy"] = this.printedBy;
        data["akrDate"] = this.akrDate;
        data["printedOn"] = this.printedOn;
        data["psasMain"] = this.psasMain ? this.psasMain.toJSON() : <any>undefined;
        data["psasPrice"] = this.psasPrice ? this.psasPrice.toJSON() : <any>undefined;
        if (this.psasPayment && this.psasPayment.constructor === Array) {
            data["psasPayment"] = [];
            for (let item of this.psasPayment)
                data["psasPayment"].push(item.toJSON());
        }
        if (this.psasSchedule && this.psasSchedule.constructor === Array) {
            data["psasSchedule"] = [];
            for (let item of this.psasSchedule)
                data["psasSchedule"].push(item.toJSON());
        }
        if (this.psasPaymentAjb && this.psasPaymentAjb.constructor === Array) {
            data["psasPaymentAjb"] = [];
            for (let item of this.psasPaymentAjb)
                data["psasPaymentAjb"].push(item.toJSON());
        }
        if (this.psasScheduleAjb && this.psasScheduleAjb.constructor === Array) {
            data["psasScheduleAjb"] = [];
            for (let item of this.psasScheduleAjb)
                data["psasScheduleAjb"].push(item.toJSON());
        }
        data["areaTotal"] = this.areaTotal;
        data["grossPriceTotal"] = this.grossPriceTotal;
        data["grossPriceTotalS"] = this.grossPriceTotalS;
        data["discountRupiahBangunan"] = this.discountRupiahBangunan;
        data["discountRupiahTanah"] = this.discountRupiahTanah;
        data["discountRupiahRenov"] = this.discountRupiahRenov;
        data["discountTotal"] = this.discountTotal;
        data["netPriceTotal"] = this.netPriceTotal;
        data["netNetPriceTotal"] = this.netNetPriceTotal;
        data["vatTotal"] = this.vatTotal;
        data["interestTotal"] = this.interestTotal;
        data["sellingPriceBangunan"] = this.sellingPriceBangunan;
        data["sellingPriceTanah"] = this.sellingPriceTanah;
        data["sellingPriceRenov"] = this.sellingPriceRenov;
        data["sellingPriceTotal"] = this.sellingPriceTotal;
        data["additionalDisc"] = this.additionalDisc;
        data["additionalDiscS"] = this.additionalDiscS;
        data["payment"] = this.payment;
        data["schedule"] = this.schedule;
        data["netAmtSchedule"] = this.netAmtSchedule;
        data["netAmtSchedulePen"] = this.netAmtSchedulePen;
        data["vatAmtSchedule"] = this.vatAmtSchedule;
        data["vatAmtSchedulePen"] = this.vatAmtSchedulePen;
        data["totalAmtSchedule"] = this.totalAmtSchedule;
        data["totalAmtSchedulePen"] = this.totalAmtSchedulePen;
        data["netAmtPayment"] = this.netAmtPayment;
        data["netAmtPaymentPen"] = this.netAmtPaymentPen;
        data["vatAmtPayment"] = this.vatAmtPayment;
        data["vatAmtPaymentPen"] = this.vatAmtPaymentPen;
        data["totalAmtPayment"] = this.totalAmtPayment;
        data["totalAmtPaymentPen"] = this.totalAmtPaymentPen;
        data["netAmtBal"] = this.netAmtBal;
        data["vatAmtBal"] = this.vatAmtBal;
        data["totalAmtBal"] = this.totalAmtBal;
        data["totalPenaltyBal"] = this.totalPenaltyBal;
        return data; 
    }
}

export interface IGetUniversalPsasDto {
    printedBy: string;
    akrDate: string;
    printedOn: string;
    psasMain: GetPSASMainUnitDetailDto;
    psasPrice: GetUniversalListDto;
    psasPayment: GetPSASMainPaymentDto[];
    psasSchedule: GetPSASMainScheduleDto[];
    psasPaymentAjb: GetPSASMinPaymentAJBDto[];
    psasScheduleAjb: GetPSASMainScheduleAjbDto[];
    areaTotal: number;
    grossPriceTotal: string;
    grossPriceTotalS: string;
    discountRupiahBangunan: string;
    discountRupiahTanah: string;
    discountRupiahRenov: string;
    discountTotal: string;
    netPriceTotal: string;
    netNetPriceTotal: string;
    vatTotal: string;
    interestTotal: string;
    sellingPriceBangunan: string;
    sellingPriceTanah: string;
    sellingPriceRenov: string;
    sellingPriceTotal: string;
    additionalDisc: string;
    additionalDiscS: string;
    payment: string;
    schedule: string;
    netAmtSchedule: string;
    netAmtSchedulePen: string;
    vatAmtSchedule: string;
    vatAmtSchedulePen: string;
    totalAmtSchedule: string;
    totalAmtSchedulePen: string;
    netAmtPayment: string;
    netAmtPaymentPen: string;
    vatAmtPayment: string;
    vatAmtPaymentPen: string;
    totalAmtPayment: string;
    totalAmtPaymentPen: string;
    netAmtBal: string;
    vatAmtBal: string;
    totalAmtBal: string;
    totalPenaltyBal: string;
}

export class GetPSASMainUnitDetailDto implements IGetPSASMainUnitDetailDto {
    categoryName: string;
    clusterName: string;
    detailName: string;
    membershipType: string;
    finDesc: string;
    cn: string;
    cnDate: string;
    sadStatus: string;
    ppjb: string;
    kpu: string;
    pppu: string;
    pppuDate: string;
    docNo: string;
    unitNo: string;
    unitName: string;
    unitCode: string;
    bookCode: string;
    projectName: string;
    productName: string;
    territory: string;
    termCode: string;
    termNo: string;
    name: string;
    address: string;
    npwp: string;
    phone: string;
    psCode: string;
    salesEvent: string;
    transactionCome: string;
    payType: string;
    bankName: string;
    amount: number;
    noRekening: string;
    schema: string;
    memberID: string;
    memberName: string;
    bookDate: string;
    bookedStatus: string;
    cancelDate: moment.Moment;
    remarks: string;
    status: string;
    reason: string;
    reasonRemarks: string;
    renovName: string;
    coName: string;
    stfNo: string;
    stfDate: string;
    stppNo: string;
    stppDate: string;

    constructor(data?: IGetPSASMainUnitDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryName = data["categoryName"];
            this.clusterName = data["clusterName"];
            this.detailName = data["detailName"];
            this.membershipType = data["membershipType"];
            this.finDesc = data["finDesc"];
            this.cn = data["cn"];
            this.cnDate = data["cnDate"];
            this.sadStatus = data["sadStatus"];
            this.ppjb = data["ppjb"];
            this.kpu = data["kpu"];
            this.pppu = data["pppu"];
            this.pppuDate = data["pppuDate"];
            this.docNo = data["docNo"];
            this.unitNo = data["unitNo"];
            this.unitName = data["unitName"];
            this.unitCode = data["unitCode"];
            this.bookCode = data["bookCode"];
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.territory = data["territory"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.name = data["name"];
            this.address = data["address"];
            this.npwp = data["npwp"];
            this.phone = data["phone"];
            this.psCode = data["psCode"];
            this.salesEvent = data["salesEvent"];
            this.transactionCome = data["transactionCome"];
            this.payType = data["payType"];
            this.bankName = data["bankName"];
            this.amount = data["amount"];
            this.noRekening = data["noRekening"];
            this.schema = data["schema"];
            this.memberID = data["memberID"];
            this.memberName = data["memberName"];
            this.bookDate = data["bookDate"];
            this.bookedStatus = data["bookedStatus"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.status = data["status"];
            this.reason = data["reason"];
            this.reasonRemarks = data["reasonRemarks"];
            this.renovName = data["renovName"];
            this.coName = data["coName"];
            this.stfNo = data["stfNo"];
            this.stfDate = data["stfDate"];
            this.stppNo = data["stppNo"];
            this.stppDate = data["stppDate"];
        }
    }

    static fromJS(data: any): GetPSASMainUnitDetailDto {
        let result = new GetPSASMainUnitDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["clusterName"] = this.clusterName;
        data["detailName"] = this.detailName;
        data["membershipType"] = this.membershipType;
        data["finDesc"] = this.finDesc;
        data["cn"] = this.cn;
        data["cnDate"] = this.cnDate;
        data["sadStatus"] = this.sadStatus;
        data["ppjb"] = this.ppjb;
        data["kpu"] = this.kpu;
        data["pppu"] = this.pppu;
        data["pppuDate"] = this.pppuDate;
        data["docNo"] = this.docNo;
        data["unitNo"] = this.unitNo;
        data["unitName"] = this.unitName;
        data["unitCode"] = this.unitCode;
        data["bookCode"] = this.bookCode;
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["territory"] = this.territory;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["name"] = this.name;
        data["address"] = this.address;
        data["npwp"] = this.npwp;
        data["phone"] = this.phone;
        data["psCode"] = this.psCode;
        data["salesEvent"] = this.salesEvent;
        data["transactionCome"] = this.transactionCome;
        data["payType"] = this.payType;
        data["bankName"] = this.bankName;
        data["amount"] = this.amount;
        data["noRekening"] = this.noRekening;
        data["schema"] = this.schema;
        data["memberID"] = this.memberID;
        data["memberName"] = this.memberName;
        data["bookDate"] = this.bookDate;
        data["bookedStatus"] = this.bookedStatus;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["reasonRemarks"] = this.reasonRemarks;
        data["renovName"] = this.renovName;
        data["coName"] = this.coName;
        data["stfNo"] = this.stfNo;
        data["stfDate"] = this.stfDate;
        data["stppNo"] = this.stppNo;
        data["stppDate"] = this.stppDate;
        return data; 
    }
}

export interface IGetPSASMainUnitDetailDto {
    categoryName: string;
    clusterName: string;
    detailName: string;
    membershipType: string;
    finDesc: string;
    cn: string;
    cnDate: string;
    sadStatus: string;
    ppjb: string;
    kpu: string;
    pppu: string;
    pppuDate: string;
    docNo: string;
    unitNo: string;
    unitName: string;
    unitCode: string;
    bookCode: string;
    projectName: string;
    productName: string;
    territory: string;
    termCode: string;
    termNo: string;
    name: string;
    address: string;
    npwp: string;
    phone: string;
    psCode: string;
    salesEvent: string;
    transactionCome: string;
    payType: string;
    bankName: string;
    amount: number;
    noRekening: string;
    schema: string;
    memberID: string;
    memberName: string;
    bookDate: string;
    bookedStatus: string;
    cancelDate: moment.Moment;
    remarks: string;
    status: string;
    reason: string;
    reasonRemarks: string;
    renovName: string;
    coName: string;
    stfNo: string;
    stfDate: string;
    stppNo: string;
    stppDate: string;
}

export class GetUniversalListDto implements IGetUniversalListDto {
    psasPrice: GetPSASPriceListDto;
    marketingPrice: GetPSASPriceListDto;
    commisionPrice: GetPSASPriceListDto;
    isCancel: boolean;

    constructor(data?: IGetUniversalListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psasPrice = data["psasPrice"] ? GetPSASPriceListDto.fromJS(data["psasPrice"]) : <any>undefined;
            this.marketingPrice = data["marketingPrice"] ? GetPSASPriceListDto.fromJS(data["marketingPrice"]) : <any>undefined;
            this.commisionPrice = data["commisionPrice"] ? GetPSASPriceListDto.fromJS(data["commisionPrice"]) : <any>undefined;
            this.isCancel = data["isCancel"];
        }
    }

    static fromJS(data: any): GetUniversalListDto {
        let result = new GetUniversalListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psasPrice"] = this.psasPrice ? this.psasPrice.toJSON() : <any>undefined;
        data["marketingPrice"] = this.marketingPrice ? this.marketingPrice.toJSON() : <any>undefined;
        data["commisionPrice"] = this.commisionPrice ? this.commisionPrice.toJSON() : <any>undefined;
        data["isCancel"] = this.isCancel;
        return data; 
    }
}

export interface IGetUniversalListDto {
    psasPrice: GetPSASPriceListDto;
    marketingPrice: GetPSASPriceListDto;
    commisionPrice: GetPSASPriceListDto;
    isCancel: boolean;
}

export class GetPSASMainPaymentDto implements IGetPSASMainPaymentDto {
    bankName: string;
    bankBranch: string;
    account: string;
    transNo: string;
    pmtDate: moment.Moment;
    type: TypeDto;
    clearDate: moment.Moment;
    netAmount: number;
    vatAmt: number;
    remarks: string;
    taxFP: string;

    constructor(data?: IGetPSASMainPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankName = data["bankName"];
            this.bankBranch = data["bankBranch"];
            this.account = data["account"];
            this.transNo = data["transNo"];
            this.pmtDate = data["pmtDate"] ? moment(data["pmtDate"].toString()) : <any>undefined;
            this.type = data["type"] ? TypeDto.fromJS(data["type"]) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.netAmount = data["netAmount"];
            this.vatAmt = data["vatAmt"];
            this.remarks = data["remarks"];
            this.taxFP = data["taxFP"];
        }
    }

    static fromJS(data: any): GetPSASMainPaymentDto {
        let result = new GetPSASMainPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["bankBranch"] = this.bankBranch;
        data["account"] = this.account;
        data["transNo"] = this.transNo;
        data["pmtDate"] = this.pmtDate ? this.pmtDate.toISOString() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["netAmount"] = this.netAmount;
        data["vatAmt"] = this.vatAmt;
        data["remarks"] = this.remarks;
        data["taxFP"] = this.taxFP;
        return data; 
    }
}

export interface IGetPSASMainPaymentDto {
    bankName: string;
    bankBranch: string;
    account: string;
    transNo: string;
    pmtDate: moment.Moment;
    type: TypeDto;
    clearDate: moment.Moment;
    netAmount: number;
    vatAmt: number;
    remarks: string;
    taxFP: string;
}

export class GetPSASMainScheduleDto implements IGetPSASMainScheduleDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    penaltyAge: number;
    penaltyAmount: number;
    pctTax: number;
    dataPayment: DataPaymentListDto[];

    constructor(data?: IGetPSASMainScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.totalAmount = data["totalAmount"];
            this.netOutstanding = data["netOutstanding"];
            this.vatOutstanding = data["vatOutstanding"];
            this.paymentAmount = data["paymentAmount"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
            this.remarks = data["remarks"];
            this.penaltyAge = data["penaltyAge"];
            this.penaltyAmount = data["penaltyAmount"];
            this.pctTax = data["pctTax"];
            if (data["dataPayment"] && data["dataPayment"].constructor === Array) {
                this.dataPayment = [];
                for (let item of data["dataPayment"])
                    this.dataPayment.push(DataPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPSASMainScheduleDto {
        let result = new GetPSASMainScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["netOutstanding"] = this.netOutstanding;
        data["vatOutstanding"] = this.vatOutstanding;
        data["paymentAmount"] = this.paymentAmount;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        data["remarks"] = this.remarks;
        data["penaltyAge"] = this.penaltyAge;
        data["penaltyAmount"] = this.penaltyAmount;
        data["pctTax"] = this.pctTax;
        if (this.dataPayment && this.dataPayment.constructor === Array) {
            data["dataPayment"] = [];
            for (let item of this.dataPayment)
                data["dataPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPSASMainScheduleDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    penaltyAge: number;
    penaltyAmount: number;
    pctTax: number;
    dataPayment: DataPaymentListDto[];
}

export class GetPSASMinPaymentAJBDto implements IGetPSASMinPaymentAJBDto {
    clearDate: moment.Moment;
    paymentDate: moment.Moment;
    transNo: string;
    payForCode: string;
    allocDesc: string;
    ket: string;
    totalPayment: number;

    constructor(data?: IGetPSASMinPaymentAJBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payForCode = data["payForCode"];
            this.allocDesc = data["allocDesc"];
            this.ket = data["ket"];
            this.totalPayment = data["totalPayment"];
        }
    }

    static fromJS(data: any): GetPSASMinPaymentAJBDto {
        let result = new GetPSASMinPaymentAJBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payForCode"] = this.payForCode;
        data["allocDesc"] = this.allocDesc;
        data["ket"] = this.ket;
        data["totalPayment"] = this.totalPayment;
        return data; 
    }
}

export interface IGetPSASMinPaymentAJBDto {
    clearDate: moment.Moment;
    paymentDate: moment.Moment;
    transNo: string;
    payForCode: string;
    allocDesc: string;
    ket: string;
    totalPayment: number;
}

export class GetPSASMainScheduleAjbDto implements IGetPSASMainScheduleAjbDto {
    dueDate: moment.Moment;
    allocation: string;
    amount: string;
    totalPayment: string;
    totalOutstanding: string;

    constructor(data?: IGetPSASMainScheduleAjbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocation = data["allocation"];
            this.amount = data["amount"];
            this.totalPayment = data["totalPayment"];
            this.totalOutstanding = data["totalOutstanding"];
        }
    }

    static fromJS(data: any): GetPSASMainScheduleAjbDto {
        let result = new GetPSASMainScheduleAjbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocation"] = this.allocation;
        data["amount"] = this.amount;
        data["totalPayment"] = this.totalPayment;
        data["totalOutstanding"] = this.totalOutstanding;
        return data; 
    }
}

export interface IGetPSASMainScheduleAjbDto {
    dueDate: moment.Moment;
    allocation: string;
    amount: string;
    totalPayment: string;
    totalOutstanding: string;
}

export class GetPSASPriceListDto implements IGetPSASPriceListDto {
    bookingHeaderID: number;
    projectCode: string;
    area: GetAreaLlistDto;
    grossPrice: GetGrosspriceLlistDto;
    discount: GetDiscountLlistDto;
    netPrice: GetNetpriceLlistDto;
    addDisc: GetAddDiscLlistDto;
    discountA: GetDiscountAlistDto[];
    netNetPrice: GetNetNetPriceLlistDto;
    vatPrice: GetVATLlistDto;
    interest: GetInterestLlistDto;
    total: GetTotalLlistDto;

    constructor(data?: IGetPSASPriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.projectCode = data["projectCode"];
            this.area = data["area"] ? GetAreaLlistDto.fromJS(data["area"]) : <any>undefined;
            this.grossPrice = data["grossPrice"] ? GetGrosspriceLlistDto.fromJS(data["grossPrice"]) : <any>undefined;
            this.discount = data["discount"] ? GetDiscountLlistDto.fromJS(data["discount"]) : <any>undefined;
            this.netPrice = data["netPrice"] ? GetNetpriceLlistDto.fromJS(data["netPrice"]) : <any>undefined;
            this.addDisc = data["addDisc"] ? GetAddDiscLlistDto.fromJS(data["addDisc"]) : <any>undefined;
            if (data["discountA"] && data["discountA"].constructor === Array) {
                this.discountA = [];
                for (let item of data["discountA"])
                    this.discountA.push(GetDiscountAlistDto.fromJS(item));
            }
            this.netNetPrice = data["netNetPrice"] ? GetNetNetPriceLlistDto.fromJS(data["netNetPrice"]) : <any>undefined;
            this.vatPrice = data["vatPrice"] ? GetVATLlistDto.fromJS(data["vatPrice"]) : <any>undefined;
            this.interest = data["interest"] ? GetInterestLlistDto.fromJS(data["interest"]) : <any>undefined;
            this.total = data["total"] ? GetTotalLlistDto.fromJS(data["total"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPSASPriceListDto {
        let result = new GetPSASPriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["projectCode"] = this.projectCode;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["grossPrice"] = this.grossPrice ? this.grossPrice.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["netPrice"] = this.netPrice ? this.netPrice.toJSON() : <any>undefined;
        data["addDisc"] = this.addDisc ? this.addDisc.toJSON() : <any>undefined;
        if (this.discountA && this.discountA.constructor === Array) {
            data["discountA"] = [];
            for (let item of this.discountA)
                data["discountA"].push(item.toJSON());
        }
        data["netNetPrice"] = this.netNetPrice ? this.netNetPrice.toJSON() : <any>undefined;
        data["vatPrice"] = this.vatPrice ? this.vatPrice.toJSON() : <any>undefined;
        data["interest"] = this.interest ? this.interest.toJSON() : <any>undefined;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPSASPriceListDto {
    bookingHeaderID: number;
    projectCode: string;
    area: GetAreaLlistDto;
    grossPrice: GetGrosspriceLlistDto;
    discount: GetDiscountLlistDto;
    netPrice: GetNetpriceLlistDto;
    addDisc: GetAddDiscLlistDto;
    discountA: GetDiscountAlistDto[];
    netNetPrice: GetNetNetPriceLlistDto;
    vatPrice: GetVATLlistDto;
    interest: GetInterestLlistDto;
    total: GetTotalLlistDto;
}

export class TypeDto implements ITypeDto {
    payFor: string;
    payType: string;
    otherType: string;

    constructor(data?: ITypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payFor = data["payFor"];
            this.payType = data["payType"];
            this.otherType = data["otherType"];
        }
    }

    static fromJS(data: any): TypeDto {
        let result = new TypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payFor"] = this.payFor;
        data["payType"] = this.payType;
        data["otherType"] = this.otherType;
        return data; 
    }
}

export interface ITypeDto {
    payFor: string;
    payType: string;
    otherType: string;
}

export class DataPaymentListDto implements IDataPaymentListDto {
    clearDate: moment.Moment;
    transNo: string;
    payNo: number;
    payType: string;
    otherType: string;
    netAmountPayment: number;
    vatAmountPayment: number;
    totalAmountPayment: number;

    constructor(data?: IDataPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payNo = data["payNo"];
            this.payType = data["payType"];
            this.otherType = data["otherType"];
            this.netAmountPayment = data["netAmountPayment"];
            this.vatAmountPayment = data["vatAmountPayment"];
            this.totalAmountPayment = data["totalAmountPayment"];
        }
    }

    static fromJS(data: any): DataPaymentListDto {
        let result = new DataPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payNo"] = this.payNo;
        data["payType"] = this.payType;
        data["otherType"] = this.otherType;
        data["netAmountPayment"] = this.netAmountPayment;
        data["vatAmountPayment"] = this.vatAmountPayment;
        data["totalAmountPayment"] = this.totalAmountPayment;
        return data; 
    }
}

export interface IDataPaymentListDto {
    clearDate: moment.Moment;
    transNo: string;
    payNo: number;
    payType: string;
    otherType: string;
    netAmountPayment: number;
    vatAmountPayment: number;
    totalAmountPayment: number;
}

export class GetAreaLlistDto implements IGetAreaLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;

    constructor(data?: IGetAreaLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetAreaLlistDto {
        let result = new GetAreaLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetAreaLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
}

export class GetGrosspriceLlistDto implements IGetGrosspriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetGrosspriceLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetGrosspriceLlistDto {
        let result = new GetGrosspriceLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetGrosspriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetDiscountLlistDto implements IGetDiscountLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;

    constructor(data?: IGetDiscountLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetDiscountLlistDto {
        let result = new GetDiscountLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetDiscountLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
}

export class GetNetpriceLlistDto implements IGetNetpriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetNetpriceLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetNetpriceLlistDto {
        let result = new GetNetpriceLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetNetpriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetAddDiscLlistDto implements IGetAddDiscLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;

    constructor(data?: IGetAddDiscLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetAddDiscLlistDto {
        let result = new GetAddDiscLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        return data; 
    }
}

export interface IGetAddDiscLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
}

export class GetDiscountAlistDto implements IGetDiscountAlistDto {
    bookingDetailAddDiscID: number;
    bookingDetailID: number;
    discountName: string;
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    isAmount: boolean;

    constructor(data?: IGetDiscountAlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDetailAddDiscID = data["bookingDetailAddDiscID"];
            this.bookingDetailID = data["bookingDetailID"];
            this.discountName = data["discountName"];
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.isAmount = data["isAmount"];
        }
    }

    static fromJS(data: any): GetDiscountAlistDto {
        let result = new GetDiscountAlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDetailAddDiscID"] = this.bookingDetailAddDiscID;
        data["bookingDetailID"] = this.bookingDetailID;
        data["discountName"] = this.discountName;
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["isAmount"] = this.isAmount;
        return data; 
    }
}

export interface IGetDiscountAlistDto {
    bookingDetailAddDiscID: number;
    bookingDetailID: number;
    discountName: string;
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    isAmount: boolean;
}

export class GetNetNetPriceLlistDto implements IGetNetNetPriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetNetNetPriceLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetNetNetPriceLlistDto {
        let result = new GetNetNetPriceLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetNetNetPriceLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetVATLlistDto implements IGetVATLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetVATLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetVATLlistDto {
        let result = new GetVATLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetVATLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetInterestLlistDto implements IGetInterestLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetInterestLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetInterestLlistDto {
        let result = new GetInterestLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetInterestLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetTotalLlistDto implements IGetTotalLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;

    constructor(data?: IGetTotalLlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.discount = data["discount"];
            this.tanah = data["tanah"];
            this.bangunan = data["bangunan"];
            this.renov = data["renov"];
            this.total = data["total"];
            this.discountS = data["discountS"];
            this.tanahS = data["tanahS"];
            this.bangunanS = data["bangunanS"];
            this.renovS = data["renovS"];
            this.totalS = data["totalS"];
        }
    }

    static fromJS(data: any): GetTotalLlistDto {
        let result = new GetTotalLlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["tanah"] = this.tanah;
        data["bangunan"] = this.bangunan;
        data["renov"] = this.renov;
        data["total"] = this.total;
        data["discountS"] = this.discountS;
        data["tanahS"] = this.tanahS;
        data["bangunanS"] = this.bangunanS;
        data["renovS"] = this.renovS;
        data["totalS"] = this.totalS;
        return data; 
    }
}

export interface IGetTotalLlistDto {
    discount: number;
    tanah: number;
    bangunan: number;
    renov: number;
    total: number;
    discountS: string;
    tanahS: string;
    bangunanS: string;
    renovS: string;
    totalS: string;
}

export class GetUnitcodeUnitnoAJBResultDto implements IGetUnitcodeUnitnoAJBResultDto {
    unitCode: string;
    unitNo: string;
    bookingHeaderID: number;

    constructor(data?: IGetUnitcodeUnitnoAJBResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookingHeaderID = data["bookingHeaderID"];
        }
    }

    static fromJS(data: any): GetUnitcodeUnitnoAJBResultDto {
        let result = new GetUnitcodeUnitnoAJBResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookingHeaderID"] = this.bookingHeaderID;
        return data; 
    }
}

export interface IGetUnitcodeUnitnoAJBResultDto {
    unitCode: string;
    unitNo: string;
    bookingHeaderID: number;
}

export class GetUnitcodeUnitnoResultDto implements IGetUnitcodeUnitnoResultDto {
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetUnitcodeUnitnoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetUnitcodeUnitnoResultDto {
        let result = new GetUnitcodeUnitnoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetUnitcodeUnitnoResultDto {
    unitCode: string;
    unitNo: string;
}

export class GetDetailBookingHeaderInfoResultDto implements IGetDetailBookingHeaderInfoResultDto {
    bookingHeaderID: number;
    penaltyBaseRate: number;
    penaltyCalcTypeID: number;
    penaltyRate: number;
    penaltyFreq: string;
    handOverDate: moment.Moment;
    handOverMonth: number;
    gracePeriodMonth: number;
    pctCapCompensation: number;
    maxCompensationAmt: number;

    constructor(data?: IGetDetailBookingHeaderInfoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.penaltyBaseRate = data["penaltyBaseRate"];
            this.penaltyCalcTypeID = data["penaltyCalcTypeID"];
            this.penaltyRate = data["penaltyRate"];
            this.penaltyFreq = data["penaltyFreq"];
            this.handOverDate = data["handOverDate"] ? moment(data["handOverDate"].toString()) : <any>undefined;
            this.handOverMonth = data["handOverMonth"];
            this.gracePeriodMonth = data["gracePeriodMonth"];
            this.pctCapCompensation = data["pctCapCompensation"];
            this.maxCompensationAmt = data["maxCompensationAmt"];
        }
    }

    static fromJS(data: any): GetDetailBookingHeaderInfoResultDto {
        let result = new GetDetailBookingHeaderInfoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["penaltyBaseRate"] = this.penaltyBaseRate;
        data["penaltyCalcTypeID"] = this.penaltyCalcTypeID;
        data["penaltyRate"] = this.penaltyRate;
        data["penaltyFreq"] = this.penaltyFreq;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["handOverMonth"] = this.handOverMonth;
        data["gracePeriodMonth"] = this.gracePeriodMonth;
        data["pctCapCompensation"] = this.pctCapCompensation;
        data["maxCompensationAmt"] = this.maxCompensationAmt;
        return data; 
    }
}

export interface IGetDetailBookingHeaderInfoResultDto {
    bookingHeaderID: number;
    penaltyBaseRate: number;
    penaltyCalcTypeID: number;
    penaltyRate: number;
    penaltyFreq: string;
    handOverDate: moment.Moment;
    handOverMonth: number;
    gracePeriodMonth: number;
    pctCapCompensation: number;
    maxCompensationAmt: number;
}

export class UpdateBookingHeaderInfoInputDto implements IUpdateBookingHeaderInfoInputDto {
    bookingHeaderID: number;
    penaltyRate: number;
    penaltyBaseRate: number;
    penaltyFreq: string;

    constructor(data?: IUpdateBookingHeaderInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.penaltyRate = data["penaltyRate"];
            this.penaltyBaseRate = data["penaltyBaseRate"];
            this.penaltyFreq = data["penaltyFreq"];
        }
    }

    static fromJS(data: any): UpdateBookingHeaderInfoInputDto {
        let result = new UpdateBookingHeaderInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["penaltyRate"] = this.penaltyRate;
        data["penaltyBaseRate"] = this.penaltyBaseRate;
        data["penaltyFreq"] = this.penaltyFreq;
        return data; 
    }
}

export interface IUpdateBookingHeaderInfoInputDto {
    bookingHeaderID: number;
    penaltyRate: number;
    penaltyBaseRate: number;
    penaltyFreq: string;
}

export class UpdateHandOverBookingHeaderInfoInputDto implements IUpdateHandOverBookingHeaderInfoInputDto {
    bookingHeaderID: number;
    handOverDate: moment.Moment;
    gracePeriodMonth: number;

    constructor(data?: IUpdateHandOverBookingHeaderInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.handOverDate = data["handOverDate"] ? moment(data["handOverDate"].toString()) : <any>undefined;
            this.gracePeriodMonth = data["gracePeriodMonth"];
        }
    }

    static fromJS(data: any): UpdateHandOverBookingHeaderInfoInputDto {
        let result = new UpdateHandOverBookingHeaderInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["gracePeriodMonth"] = this.gracePeriodMonth;
        return data; 
    }
}

export interface IUpdateHandOverBookingHeaderInfoInputDto {
    bookingHeaderID: number;
    handOverDate: moment.Moment;
    gracePeriodMonth: number;
}

export class GetDataBookingResult implements IGetDataBookingResult {
    bookingHeaderID: number;
    bookCode: string;
    totalSchedule: number;
    totalOutstanding: number;
    totalPayment: number;
    totalPenalty: number;
    isPaid: boolean;
    isSuccess: boolean;

    constructor(data?: IGetDataBookingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.totalSchedule = data["totalSchedule"];
            this.totalOutstanding = data["totalOutstanding"];
            this.totalPayment = data["totalPayment"];
            this.totalPenalty = data["totalPenalty"];
            this.isPaid = data["isPaid"];
            this.isSuccess = data["isSuccess"];
        }
    }

    static fromJS(data: any): GetDataBookingResult {
        let result = new GetDataBookingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["totalSchedule"] = this.totalSchedule;
        data["totalOutstanding"] = this.totalOutstanding;
        data["totalPayment"] = this.totalPayment;
        data["totalPenalty"] = this.totalPenalty;
        data["isPaid"] = this.isPaid;
        data["isSuccess"] = this.isSuccess;
        return data; 
    }
}

export interface IGetDataBookingResult {
    bookingHeaderID: number;
    bookCode: string;
    totalSchedule: number;
    totalOutstanding: number;
    totalPayment: number;
    totalPenalty: number;
    isPaid: boolean;
    isSuccess: boolean;
}

export class GetDataFlagstatusDTO implements IGetDataFlagstatusDTO {
    flagStatusId: number;
    flagStatus: string;

    constructor(data?: IGetDataFlagstatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.flagStatusId = data["flagStatusId"];
            this.flagStatus = data["flagStatus"];
        }
    }

    static fromJS(data: any): GetDataFlagstatusDTO {
        let result = new GetDataFlagstatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flagStatusId"] = this.flagStatusId;
        data["flagStatus"] = this.flagStatus;
        return data; 
    }
}

export interface IGetDataFlagstatusDTO {
    flagStatusId: number;
    flagStatus: string;
}

export class DataListTRFlagStatusDTO implements IDataListTRFlagStatusDTO {
    bookCode: string;
    dataTRFlagStatus: DTOFlagStatus[];

    constructor(data?: IDataListTRFlagStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            if (data["dataTRFlagStatus"] && data["dataTRFlagStatus"].constructor === Array) {
                this.dataTRFlagStatus = [];
                for (let item of data["dataTRFlagStatus"])
                    this.dataTRFlagStatus.push(DTOFlagStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataListTRFlagStatusDTO {
        let result = new DataListTRFlagStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        if (this.dataTRFlagStatus && this.dataTRFlagStatus.constructor === Array) {
            data["dataTRFlagStatus"] = [];
            for (let item of this.dataTRFlagStatus)
                data["dataTRFlagStatus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDataListTRFlagStatusDTO {
    bookCode: string;
    dataTRFlagStatus: DTOFlagStatus[];
}

export class DTOFlagStatus implements IDTOFlagStatus {
    id: number;
    flagStatusId: number;
    remarks: string;

    constructor(data?: IDTOFlagStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.flagStatusId = data["flagStatusId"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): DTOFlagStatus {
        let result = new DTOFlagStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["flagStatusId"] = this.flagStatusId;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IDTOFlagStatus {
    id: number;
    flagStatusId: number;
    remarks: string;
}

export class DataTRFlagStatusDTO implements IDataTRFlagStatusDTO {
    id: number;
    bookCode: string;
    flagStatusId: number;
    flagStatusName: string;
    remarks: string;

    constructor(data?: IDataTRFlagStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.bookCode = data["bookCode"];
            this.flagStatusId = data["flagStatusId"];
            this.flagStatusName = data["flagStatusName"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): DataTRFlagStatusDTO {
        let result = new DataTRFlagStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookCode"] = this.bookCode;
        data["flagStatusId"] = this.flagStatusId;
        data["flagStatusName"] = this.flagStatusName;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IDataTRFlagStatusDTO {
    id: number;
    bookCode: string;
    flagStatusId: number;
    flagStatusName: string;
    remarks: string;
}

export class ResponseSaveDTO implements IResponseSaveDTO {
    code: string;
    status: string;

    constructor(data?: IResponseSaveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ResponseSaveDTO {
        let result = new ResponseSaveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["status"] = this.status;
        return data; 
    }
}

export interface IResponseSaveDTO {
    code: string;
    status: string;
}

export class CreateMappingKadasterInputDto implements ICreateMappingKadasterInputDto {
    projectID: number;
    categoryID: number;
    url: string;
    isGenerateSystem: boolean;
    fileKadaster: string[];
    codeKadaster: ListCodeKadaster[];

    constructor(data?: ICreateMappingKadasterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.categoryID = data["categoryID"];
            this.url = data["url"];
            this.isGenerateSystem = data["isGenerateSystem"];
            if (data["fileKadaster"] && data["fileKadaster"].constructor === Array) {
                this.fileKadaster = [];
                for (let item of data["fileKadaster"])
                    this.fileKadaster.push(item);
            }
            if (data["codeKadaster"] && data["codeKadaster"].constructor === Array) {
                this.codeKadaster = [];
                for (let item of data["codeKadaster"])
                    this.codeKadaster.push(ListCodeKadaster.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMappingKadasterInputDto {
        let result = new CreateMappingKadasterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["categoryID"] = this.categoryID;
        data["url"] = this.url;
        data["isGenerateSystem"] = this.isGenerateSystem;
        if (this.fileKadaster && this.fileKadaster.constructor === Array) {
            data["fileKadaster"] = [];
            for (let item of this.fileKadaster)
                data["fileKadaster"].push(item);
        }
        if (this.codeKadaster && this.codeKadaster.constructor === Array) {
            data["codeKadaster"] = [];
            for (let item of this.codeKadaster)
                data["codeKadaster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateMappingKadasterInputDto {
    projectID: number;
    categoryID: number;
    url: string;
    isGenerateSystem: boolean;
    fileKadaster: string[];
    codeKadaster: ListCodeKadaster[];
}

export class ListCodeKadaster implements IListCodeKadaster {
    clusterID: number;
    kadasterCodeName: string;
    unitID: number;

    constructor(data?: IListCodeKadaster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.kadasterCodeName = data["kadasterCodeName"];
            this.unitID = data["unitID"];
        }
    }

    static fromJS(data: any): ListCodeKadaster {
        let result = new ListCodeKadaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["kadasterCodeName"] = this.kadasterCodeName;
        data["unitID"] = this.unitID;
        return data; 
    }
}

export interface IListCodeKadaster {
    clusterID: number;
    kadasterCodeName: string;
    unitID: number;
}

export class GetDropdownCategoryByUnitListDto implements IGetDropdownCategoryByUnitListDto {
    categoryCode: string;
    categoryName: string;
    categoryID: number;
    kadasterType: string;

    constructor(data?: IGetDropdownCategoryByUnitListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
            this.categoryID = data["categoryID"];
            this.kadasterType = data["kadasterType"];
        }
    }

    static fromJS(data: any): GetDropdownCategoryByUnitListDto {
        let result = new GetDropdownCategoryByUnitListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["categoryID"] = this.categoryID;
        data["kadasterType"] = this.kadasterType;
        return data; 
    }
}

export interface IGetDropdownCategoryByUnitListDto {
    categoryCode: string;
    categoryName: string;
    categoryID: number;
    kadasterType: string;
}

export class GetKadasterDto implements IGetKadasterDto {
    unitID: number;
    url: string;
    clusterid: number;
    projectid: number;
    renoveID: number;
    message: string;
    success: boolean;

    constructor(data?: IGetKadasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.url = data["url"];
            this.clusterid = data["clusterid"];
            this.projectid = data["projectid"];
            this.renoveID = data["renoveID"];
            this.message = data["message"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): GetKadasterDto {
        let result = new GetKadasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["url"] = this.url;
        data["clusterid"] = this.clusterid;
        data["projectid"] = this.projectid;
        data["renoveID"] = this.renoveID;
        data["message"] = this.message;
        data["success"] = this.success;
        return data; 
    }
}

export interface IGetKadasterDto {
    unitID: number;
    url: string;
    clusterid: number;
    projectid: number;
    renoveID: number;
    message: string;
    success: boolean;
}

export class GetKadasterTypeDto implements IGetKadasterTypeDto {
    unitID: number;
    renovationCode: string;
    renovID: number;
    renovationName: string;

    constructor(data?: IGetKadasterTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.renovationCode = data["renovationCode"];
            this.renovID = data["renovID"];
            this.renovationName = data["renovationName"];
        }
    }

    static fromJS(data: any): GetKadasterTypeDto {
        let result = new GetKadasterTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["renovationCode"] = this.renovationCode;
        data["renovID"] = this.renovID;
        data["renovationName"] = this.renovationName;
        return data; 
    }
}

export interface IGetKadasterTypeDto {
    unitID: number;
    renovationCode: string;
    renovID: number;
    renovationName: string;
}

export class PagedResultDtoOfGetMappingKadasterListDto implements IPagedResultDtoOfGetMappingKadasterListDto {
    totalCount: number;
    items: GetMappingKadasterListDto[];

    constructor(data?: IPagedResultDtoOfGetMappingKadasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMappingKadasterListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMappingKadasterListDto {
        let result = new PagedResultDtoOfGetMappingKadasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMappingKadasterListDto {
    totalCount: number;
    items: GetMappingKadasterListDto[];
}

export class GetMappingKadasterListDto implements IGetMappingKadasterListDto {
    mappingKadasterID: number;
    projectID: number;
    projectName: string;
    categoryID: number;
    categoryName: string;
    url: string;
    criteriaKadaster: string;
    isActive: boolean;
    isGenerateBySystem: boolean;
    kadasterCodeAndDetailUnit: UnitCountedDto[];
    attachmentFileDetail: LinkPathListDto[];
    lastModificationTime: moment.Moment;

    constructor(data?: IGetMappingKadasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingKadasterID = data["mappingKadasterID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
            this.url = data["url"];
            this.criteriaKadaster = data["criteriaKadaster"];
            this.isActive = data["isActive"];
            this.isGenerateBySystem = data["isGenerateBySystem"];
            if (data["kadasterCodeAndDetailUnit"] && data["kadasterCodeAndDetailUnit"].constructor === Array) {
                this.kadasterCodeAndDetailUnit = [];
                for (let item of data["kadasterCodeAndDetailUnit"])
                    this.kadasterCodeAndDetailUnit.push(UnitCountedDto.fromJS(item));
            }
            if (data["attachmentFileDetail"] && data["attachmentFileDetail"].constructor === Array) {
                this.attachmentFileDetail = [];
                for (let item of data["attachmentFileDetail"])
                    this.attachmentFileDetail.push(LinkPathListDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMappingKadasterListDto {
        let result = new GetMappingKadasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingKadasterID"] = this.mappingKadasterID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        data["url"] = this.url;
        data["criteriaKadaster"] = this.criteriaKadaster;
        data["isActive"] = this.isActive;
        data["isGenerateBySystem"] = this.isGenerateBySystem;
        if (this.kadasterCodeAndDetailUnit && this.kadasterCodeAndDetailUnit.constructor === Array) {
            data["kadasterCodeAndDetailUnit"] = [];
            for (let item of this.kadasterCodeAndDetailUnit)
                data["kadasterCodeAndDetailUnit"].push(item.toJSON());
        }
        if (this.attachmentFileDetail && this.attachmentFileDetail.constructor === Array) {
            data["attachmentFileDetail"] = [];
            for (let item of this.attachmentFileDetail)
                data["attachmentFileDetail"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetMappingKadasterListDto {
    mappingKadasterID: number;
    projectID: number;
    projectName: string;
    categoryID: number;
    categoryName: string;
    url: string;
    criteriaKadaster: string;
    isActive: boolean;
    isGenerateBySystem: boolean;
    kadasterCodeAndDetailUnit: UnitCountedDto[];
    attachmentFileDetail: LinkPathListDto[];
    lastModificationTime: moment.Moment;
}

export class UnitCountedDto implements IUnitCountedDto {
    kadasterCode: string;
    unitAmount: number;
    lastModificationTime: moment.Moment;
    unitDetail: UnitDetail[];

    constructor(data?: IUnitCountedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kadasterCode = data["kadasterCode"];
            this.unitAmount = data["unitAmount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["unitDetail"] && data["unitDetail"].constructor === Array) {
                this.unitDetail = [];
                for (let item of data["unitDetail"])
                    this.unitDetail.push(UnitDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitCountedDto {
        let result = new UnitCountedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kadasterCode"] = this.kadasterCode;
        data["unitAmount"] = this.unitAmount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.unitDetail && this.unitDetail.constructor === Array) {
            data["unitDetail"] = [];
            for (let item of this.unitDetail)
                data["unitDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitCountedDto {
    kadasterCode: string;
    unitAmount: number;
    lastModificationTime: moment.Moment;
    unitDetail: UnitDetail[];
}

export class UnitDetail implements IUnitDetail {
    clusterName: string;
    clusterCode: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IUnitDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterName = data["clusterName"];
            this.clusterCode = data["clusterCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): UnitDetail {
        let result = new UnitDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterName"] = this.clusterName;
        data["clusterCode"] = this.clusterCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IUnitDetail {
    clusterName: string;
    clusterCode: string;
    unitCode: string;
    unitNo: string;
}

export class UnitByClusterListDto implements IUnitByClusterListDto {
    unitCode: string;
    unit: UnitDesc[];

    constructor(data?: IUnitByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(UnitDesc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitByClusterListDto {
        let result = new UnitByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitByClusterListDto {
    unitCode: string;
    unit: UnitDesc[];
}

export class UnitDesc implements IUnitDesc {
    unitID: number;
    unitNo: string;
    isSelected: boolean;

    constructor(data?: IUnitDesc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitNo = data["unitNo"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): UnitDesc {
        let result = new UnitDesc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitNo"] = this.unitNo;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IUnitDesc {
    unitID: number;
    unitNo: string;
    isSelected: boolean;
}

export class GetTasklistMappingKadasterListDto implements IGetTasklistMappingKadasterListDto {
    mappingKadasterID: number;
    clusterCode: string;
    clusterName: string;
    categoryName: string;
    kadasterCode: string;
    unitCode: string;
    unitNo: string;
    renovCode: string;
    renovName: string;
    kadasterLocation: string;
    linkKadaster: string;
    imageKadaster: string;
    isDelete: boolean;

    constructor(data?: IGetTasklistMappingKadasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingKadasterID = data["mappingKadasterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.categoryName = data["categoryName"];
            this.kadasterCode = data["kadasterCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
            this.kadasterLocation = data["kadasterLocation"];
            this.linkKadaster = data["linkKadaster"];
            this.imageKadaster = data["imageKadaster"];
            this.isDelete = data["isDelete"];
        }
    }

    static fromJS(data: any): GetTasklistMappingKadasterListDto {
        let result = new GetTasklistMappingKadasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingKadasterID"] = this.mappingKadasterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["categoryName"] = this.categoryName;
        data["kadasterCode"] = this.kadasterCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        data["kadasterLocation"] = this.kadasterLocation;
        data["linkKadaster"] = this.linkKadaster;
        data["imageKadaster"] = this.imageKadaster;
        data["isDelete"] = this.isDelete;
        return data; 
    }
}

export interface IGetTasklistMappingKadasterListDto {
    mappingKadasterID: number;
    clusterCode: string;
    clusterName: string;
    categoryName: string;
    kadasterCode: string;
    unitCode: string;
    unitNo: string;
    renovCode: string;
    renovName: string;
    kadasterLocation: string;
    linkKadaster: string;
    imageKadaster: string;
    isDelete: boolean;
}

export class GetDropdownRenovationListDto implements IGetDropdownRenovationListDto {
    renovID: number;
    renovCode: string;
    renovName: string;

    constructor(data?: IGetDropdownRenovationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovID = data["renovID"];
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
        }
    }

    static fromJS(data: any): GetDropdownRenovationListDto {
        let result = new GetDropdownRenovationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovID"] = this.renovID;
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        return data; 
    }
}

export interface IGetDropdownRenovationListDto {
    renovID: number;
    renovCode: string;
    renovName: string;
}

export class CreateNewMappingKadasterInputDto implements ICreateNewMappingKadasterInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number;
    renovID: number;
    listKadaster: ListKadasterDto[];

    constructor(data?: ICreateNewMappingKadasterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.categoryID = data["categoryID"];
            this.renovID = data["renovID"];
            if (data["listKadaster"] && data["listKadaster"].constructor === Array) {
                this.listKadaster = [];
                for (let item of data["listKadaster"])
                    this.listKadaster.push(ListKadasterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNewMappingKadasterInputDto {
        let result = new CreateNewMappingKadasterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["categoryID"] = this.categoryID;
        data["renovID"] = this.renovID;
        if (this.listKadaster && this.listKadaster.constructor === Array) {
            data["listKadaster"] = [];
            for (let item of this.listKadaster)
                data["listKadaster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateNewMappingKadasterInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number;
    renovID: number;
    listKadaster: ListKadasterDto[];
}

export class ListKadasterDto implements IListKadasterDto {
    unitID: number;
    kadasterCode: string;
    file: string;
    isUpdate: boolean;

    constructor(data?: IListKadasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.kadasterCode = data["kadasterCode"];
            this.file = data["file"];
            this.isUpdate = data["isUpdate"];
        }
    }

    static fromJS(data: any): ListKadasterDto {
        let result = new ListKadasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["kadasterCode"] = this.kadasterCode;
        data["file"] = this.file;
        data["isUpdate"] = this.isUpdate;
        return data; 
    }
}

export interface IListKadasterDto {
    unitID: number;
    kadasterCode: string;
    file: string;
    isUpdate: boolean;
}

export class CreateNewMappingKadasterListDto implements ICreateNewMappingKadasterListDto {
    kadasterCode: string;
    file: string;
    message: string;

    constructor(data?: ICreateNewMappingKadasterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kadasterCode = data["kadasterCode"];
            this.file = data["file"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): CreateNewMappingKadasterListDto {
        let result = new CreateNewMappingKadasterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kadasterCode"] = this.kadasterCode;
        data["file"] = this.file;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICreateNewMappingKadasterListDto {
    kadasterCode: string;
    file: string;
    message: string;
}

export class CreateMappingTemplateInputDto implements ICreateMappingTemplateInputDto {
    mappingTemplateID: number;
    projectID: number;
    docID: number;
    docTemplateID: number;
    htmlText: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    isTandaTerima: boolean;
    isTandaTerimaFile: string;
    isTandaTerimaFileNew: string;
    isActive: boolean;
    clusterID: number;
    detailID: number;

    constructor(data?: ICreateMappingTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingTemplateID = data["mappingTemplateID"];
            this.projectID = data["projectID"];
            this.docID = data["docID"];
            this.docTemplateID = data["docTemplateID"];
            this.htmlText = data["htmlText"];
            this.activeFrom = data["activeFrom"] ? moment(data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = data["activeTo"] ? moment(data["activeTo"].toString()) : <any>undefined;
            this.isTandaTerima = data["isTandaTerima"];
            this.isTandaTerimaFile = data["isTandaTerimaFile"];
            this.isTandaTerimaFileNew = data["isTandaTerimaFileNew"];
            this.isActive = data["isActive"];
            this.clusterID = data["clusterID"];
            this.detailID = data["detailID"];
        }
    }

    static fromJS(data: any): CreateMappingTemplateInputDto {
        let result = new CreateMappingTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingTemplateID"] = this.mappingTemplateID;
        data["projectID"] = this.projectID;
        data["docID"] = this.docID;
        data["docTemplateID"] = this.docTemplateID;
        data["htmlText"] = this.htmlText;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["isTandaTerima"] = this.isTandaTerima;
        data["isTandaTerimaFile"] = this.isTandaTerimaFile;
        data["isTandaTerimaFileNew"] = this.isTandaTerimaFileNew;
        data["isActive"] = this.isActive;
        data["clusterID"] = this.clusterID;
        data["detailID"] = this.detailID;
        return data; 
    }
}

export interface ICreateMappingTemplateInputDto {
    mappingTemplateID: number;
    projectID: number;
    docID: number;
    docTemplateID: number;
    htmlText: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    isTandaTerima: boolean;
    isTandaTerimaFile: string;
    isTandaTerimaFileNew: string;
    isActive: boolean;
    clusterID: number;
    detailID: number;
}

export class CheckDataUpdateIsExistListDto implements ICheckDataUpdateIsExistListDto {
    mappingTemplateID: number;
    isExist: boolean;
    activeToOldData: moment.Moment;
    activeTo: moment.Moment;
    isConfirmation: boolean;

    constructor(data?: ICheckDataUpdateIsExistListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingTemplateID = data["mappingTemplateID"];
            this.isExist = data["isExist"];
            this.activeToOldData = data["activeToOldData"] ? moment(data["activeToOldData"].toString()) : <any>undefined;
            this.activeTo = data["activeTo"] ? moment(data["activeTo"].toString()) : <any>undefined;
            this.isConfirmation = data["isConfirmation"];
        }
    }

    static fromJS(data: any): CheckDataUpdateIsExistListDto {
        let result = new CheckDataUpdateIsExistListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingTemplateID"] = this.mappingTemplateID;
        data["isExist"] = this.isExist;
        data["activeToOldData"] = this.activeToOldData ? this.activeToOldData.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["isConfirmation"] = this.isConfirmation;
        return data; 
    }
}

export interface ICheckDataUpdateIsExistListDto {
    mappingTemplateID: number;
    isExist: boolean;
    activeToOldData: moment.Moment;
    activeTo: moment.Moment;
    isConfirmation: boolean;
}

export class PagedResultDtoOfGetMappingTemplateListDto implements IPagedResultDtoOfGetMappingTemplateListDto {
    totalCount: number;
    items: GetMappingTemplateListDto[];

    constructor(data?: IPagedResultDtoOfGetMappingTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMappingTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMappingTemplateListDto {
        let result = new PagedResultDtoOfGetMappingTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMappingTemplateListDto {
    totalCount: number;
    items: GetMappingTemplateListDto[];
}

export class GetMappingTemplateListDto implements IGetMappingTemplateListDto {
    creatorUserId: any;
    entityID: number;
    mappingTemplateID: number;
    mappingTemplateCode: string;
    projectID: number;
    projectName: string;
    docID: number;
    docCode: string;
    docTemplateID: number;
    docTemplateName: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    period: string;
    isActive: boolean;
    isTandaTerima: boolean;
    isTandaTerimaFile: string;
    creatorUserID: number;
    creationTime: string;
    creationBy: string;
    clusterID: number;
    clusterName: string;
    detailID: number;
    detailName: string;
    htmlText: string;
    totalCount: number;

    constructor(data?: IGetMappingTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["creatorUserId"]) {
                this.creatorUserId = {};
                for (let key in data["creatorUserId"]) {
                    if (data["creatorUserId"].hasOwnProperty(key))
                        this.creatorUserId[key] = data["creatorUserId"][key];
                }
            }
            this.entityID = data["entityID"];
            this.mappingTemplateID = data["mappingTemplateID"];
            this.mappingTemplateCode = data["mappingTemplateCode"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docTemplateID = data["docTemplateID"];
            this.docTemplateName = data["docTemplateName"];
            this.activeFrom = data["activeFrom"] ? moment(data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = data["activeTo"] ? moment(data["activeTo"].toString()) : <any>undefined;
            this.period = data["period"];
            this.isActive = data["isActive"];
            this.isTandaTerima = data["isTandaTerima"];
            this.isTandaTerimaFile = data["isTandaTerimaFile"];
            this.creatorUserID = data["creatorUserID"];
            this.creationTime = data["creationTime"];
            this.creationBy = data["creationBy"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.detailID = data["detailID"];
            this.detailName = data["detailName"];
            this.htmlText = data["htmlText"];
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): GetMappingTemplateListDto {
        let result = new GetMappingTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.creatorUserId) {
            data["creatorUserId"] = {};
            for (let key in this.creatorUserId) {
                if (this.creatorUserId.hasOwnProperty(key))
                    data["creatorUserId"][key] = this.creatorUserId[key];
            }
        }
        data["entityID"] = this.entityID;
        data["mappingTemplateID"] = this.mappingTemplateID;
        data["mappingTemplateCode"] = this.mappingTemplateCode;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docTemplateID"] = this.docTemplateID;
        data["docTemplateName"] = this.docTemplateName;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["isActive"] = this.isActive;
        data["isTandaTerima"] = this.isTandaTerima;
        data["isTandaTerimaFile"] = this.isTandaTerimaFile;
        data["creatorUserID"] = this.creatorUserID;
        data["creationTime"] = this.creationTime;
        data["creationBy"] = this.creationBy;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["detailID"] = this.detailID;
        data["detailName"] = this.detailName;
        data["htmlText"] = this.htmlText;
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IGetMappingTemplateListDto {
    creatorUserId: any;
    entityID: number;
    mappingTemplateID: number;
    mappingTemplateCode: string;
    projectID: number;
    projectName: string;
    docID: number;
    docCode: string;
    docTemplateID: number;
    docTemplateName: string;
    activeFrom: moment.Moment;
    activeTo: moment.Moment;
    period: string;
    isActive: boolean;
    isTandaTerima: boolean;
    isTandaTerimaFile: string;
    creatorUserID: number;
    creationTime: string;
    creationBy: string;
    clusterID: number;
    clusterName: string;
    detailID: number;
    detailName: string;
    htmlText: string;
    totalCount: number;
}

export class CreateMarketingLayoutInputDto implements ICreateMarketingLayoutInputDto {
    projectID: number;
    categoryID: number;
    url: string;
    isGenerateSystem: boolean;
    fileLayout: string[];
    codeLayout: ListCodeLayout[];

    constructor(data?: ICreateMarketingLayoutInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.categoryID = data["categoryID"];
            this.url = data["url"];
            this.isGenerateSystem = data["isGenerateSystem"];
            if (data["fileLayout"] && data["fileLayout"].constructor === Array) {
                this.fileLayout = [];
                for (let item of data["fileLayout"])
                    this.fileLayout.push(item);
            }
            if (data["codeLayout"] && data["codeLayout"].constructor === Array) {
                this.codeLayout = [];
                for (let item of data["codeLayout"])
                    this.codeLayout.push(ListCodeLayout.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMarketingLayoutInputDto {
        let result = new CreateMarketingLayoutInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["categoryID"] = this.categoryID;
        data["url"] = this.url;
        data["isGenerateSystem"] = this.isGenerateSystem;
        if (this.fileLayout && this.fileLayout.constructor === Array) {
            data["fileLayout"] = [];
            for (let item of this.fileLayout)
                data["fileLayout"].push(item);
        }
        if (this.codeLayout && this.codeLayout.constructor === Array) {
            data["codeLayout"] = [];
            for (let item of this.codeLayout)
                data["codeLayout"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateMarketingLayoutInputDto {
    projectID: number;
    categoryID: number;
    url: string;
    isGenerateSystem: boolean;
    fileLayout: string[];
    codeLayout: ListCodeLayout[];
}

export class ListCodeLayout implements IListCodeLayout {
    clusterID: number;
    layoutCodeName: string;
    unitID: number;

    constructor(data?: IListCodeLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.layoutCodeName = data["layoutCodeName"];
            this.unitID = data["unitID"];
        }
    }

    static fromJS(data: any): ListCodeLayout {
        let result = new ListCodeLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["layoutCodeName"] = this.layoutCodeName;
        data["unitID"] = this.unitID;
        return data; 
    }
}

export interface IListCodeLayout {
    clusterID: number;
    layoutCodeName: string;
    unitID: number;
}

export class PagedResultDtoOfGetMarketingLayoutListDto implements IPagedResultDtoOfGetMarketingLayoutListDto {
    totalCount: number;
    items: GetMarketingLayoutListDto[];

    constructor(data?: IPagedResultDtoOfGetMarketingLayoutListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMarketingLayoutListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMarketingLayoutListDto {
        let result = new PagedResultDtoOfGetMarketingLayoutListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMarketingLayoutListDto {
    totalCount: number;
    items: GetMarketingLayoutListDto[];
}

export class GetMarketingLayoutListDto implements IGetMarketingLayoutListDto {
    marketingLayoutID: number;
    projectID: number;
    projectName: string;
    categoryID: number;
    categoryName: string;
    url: string;
    criteriaLayout: string;
    isActive: boolean;
    isGenerateBySystem: boolean;
    layoutCodeAndDetailUnit: UnitCountedLayoutDto[];
    attachmentFileDetail: LinkPathListDto[];
    lastModificationTime: moment.Moment;

    constructor(data?: IGetMarketingLayoutListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.marketingLayoutID = data["marketingLayoutID"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.categoryID = data["categoryID"];
            this.categoryName = data["categoryName"];
            this.url = data["url"];
            this.criteriaLayout = data["criteriaLayout"];
            this.isActive = data["isActive"];
            this.isGenerateBySystem = data["isGenerateBySystem"];
            if (data["layoutCodeAndDetailUnit"] && data["layoutCodeAndDetailUnit"].constructor === Array) {
                this.layoutCodeAndDetailUnit = [];
                for (let item of data["layoutCodeAndDetailUnit"])
                    this.layoutCodeAndDetailUnit.push(UnitCountedLayoutDto.fromJS(item));
            }
            if (data["attachmentFileDetail"] && data["attachmentFileDetail"].constructor === Array) {
                this.attachmentFileDetail = [];
                for (let item of data["attachmentFileDetail"])
                    this.attachmentFileDetail.push(LinkPathListDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMarketingLayoutListDto {
        let result = new GetMarketingLayoutListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingLayoutID"] = this.marketingLayoutID;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["categoryID"] = this.categoryID;
        data["categoryName"] = this.categoryName;
        data["url"] = this.url;
        data["criteriaLayout"] = this.criteriaLayout;
        data["isActive"] = this.isActive;
        data["isGenerateBySystem"] = this.isGenerateBySystem;
        if (this.layoutCodeAndDetailUnit && this.layoutCodeAndDetailUnit.constructor === Array) {
            data["layoutCodeAndDetailUnit"] = [];
            for (let item of this.layoutCodeAndDetailUnit)
                data["layoutCodeAndDetailUnit"].push(item.toJSON());
        }
        if (this.attachmentFileDetail && this.attachmentFileDetail.constructor === Array) {
            data["attachmentFileDetail"] = [];
            for (let item of this.attachmentFileDetail)
                data["attachmentFileDetail"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetMarketingLayoutListDto {
    marketingLayoutID: number;
    projectID: number;
    projectName: string;
    categoryID: number;
    categoryName: string;
    url: string;
    criteriaLayout: string;
    isActive: boolean;
    isGenerateBySystem: boolean;
    layoutCodeAndDetailUnit: UnitCountedLayoutDto[];
    attachmentFileDetail: LinkPathListDto[];
    lastModificationTime: moment.Moment;
}

export class UnitCountedLayoutDto implements IUnitCountedLayoutDto {
    layoutCode: string;
    unitAmount: number;
    lastModificationTime: moment.Moment;
    unitDetail: UnitDetail[];

    constructor(data?: IUnitCountedLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutCode = data["layoutCode"];
            this.unitAmount = data["unitAmount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["unitDetail"] && data["unitDetail"].constructor === Array) {
                this.unitDetail = [];
                for (let item of data["unitDetail"])
                    this.unitDetail.push(UnitDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitCountedLayoutDto {
        let result = new UnitCountedLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutCode"] = this.layoutCode;
        data["unitAmount"] = this.unitAmount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.unitDetail && this.unitDetail.constructor === Array) {
            data["unitDetail"] = [];
            for (let item of this.unitDetail)
                data["unitDetail"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitCountedLayoutDto {
    layoutCode: string;
    unitAmount: number;
    lastModificationTime: moment.Moment;
    unitDetail: UnitDetail[];
}

export class GetTasklistMarketingLayoutListDto implements IGetTasklistMarketingLayoutListDto {
    marketingLayoutID: number;
    clusterCode: string;
    clusterName: string;
    categoryName: string;
    layoutCode: string;
    unitCode: string;
    unitNo: string;
    renovCode: string;
    renovName: string;
    layoutLocation: string;
    linkLayout: string;
    imageLayout: string;
    isDelete: boolean;

    constructor(data?: IGetTasklistMarketingLayoutListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.marketingLayoutID = data["marketingLayoutID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.categoryName = data["categoryName"];
            this.layoutCode = data["layoutCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.renovCode = data["renovCode"];
            this.renovName = data["renovName"];
            this.layoutLocation = data["layoutLocation"];
            this.linkLayout = data["linkLayout"];
            this.imageLayout = data["imageLayout"];
            this.isDelete = data["isDelete"];
        }
    }

    static fromJS(data: any): GetTasklistMarketingLayoutListDto {
        let result = new GetTasklistMarketingLayoutListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingLayoutID"] = this.marketingLayoutID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["categoryName"] = this.categoryName;
        data["layoutCode"] = this.layoutCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["renovCode"] = this.renovCode;
        data["renovName"] = this.renovName;
        data["layoutLocation"] = this.layoutLocation;
        data["linkLayout"] = this.linkLayout;
        data["imageLayout"] = this.imageLayout;
        data["isDelete"] = this.isDelete;
        return data; 
    }
}

export interface IGetTasklistMarketingLayoutListDto {
    marketingLayoutID: number;
    clusterCode: string;
    clusterName: string;
    categoryName: string;
    layoutCode: string;
    unitCode: string;
    unitNo: string;
    renovCode: string;
    renovName: string;
    layoutLocation: string;
    linkLayout: string;
    imageLayout: string;
    isDelete: boolean;
}

export class CreateNewMarketingLayoutInputDto implements ICreateNewMarketingLayoutInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number;
    renovID: number;
    listLayout: ListLayoutDto[];

    constructor(data?: ICreateNewMarketingLayoutInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.categoryID = data["categoryID"];
            this.renovID = data["renovID"];
            if (data["listLayout"] && data["listLayout"].constructor === Array) {
                this.listLayout = [];
                for (let item of data["listLayout"])
                    this.listLayout.push(ListLayoutDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNewMarketingLayoutInputDto {
        let result = new CreateNewMarketingLayoutInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["categoryID"] = this.categoryID;
        data["renovID"] = this.renovID;
        if (this.listLayout && this.listLayout.constructor === Array) {
            data["listLayout"] = [];
            for (let item of this.listLayout)
                data["listLayout"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateNewMarketingLayoutInputDto {
    projectID: number;
    clusterID: number;
    categoryID: number;
    renovID: number;
    listLayout: ListLayoutDto[];
}

export class ListLayoutDto implements IListLayoutDto {
    unitID: number;
    layoutCode: string;
    file: string;
    isUpdate: boolean;

    constructor(data?: IListLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.layoutCode = data["layoutCode"];
            this.file = data["file"];
            this.isUpdate = data["isUpdate"];
        }
    }

    static fromJS(data: any): ListLayoutDto {
        let result = new ListLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["layoutCode"] = this.layoutCode;
        data["file"] = this.file;
        data["isUpdate"] = this.isUpdate;
        return data; 
    }
}

export interface IListLayoutDto {
    unitID: number;
    layoutCode: string;
    file: string;
    isUpdate: boolean;
}

export class CreateNewMarketingLayoutListDto implements ICreateNewMarketingLayoutListDto {
    layoutCode: string;
    file: string;
    message: string;

    constructor(data?: ICreateNewMarketingLayoutListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutCode = data["layoutCode"];
            this.file = data["file"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): CreateNewMarketingLayoutListDto {
        let result = new CreateNewMarketingLayoutListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutCode"] = this.layoutCode;
        data["file"] = this.file;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICreateNewMarketingLayoutListDto {
    layoutCode: string;
    file: string;
    message: string;
}

export class GetPSASPaymentDto implements IGetPSASPaymentDto {
    bankName: string;
    bankBranch: string;
    account: string;
    transNo: string;
    pmtDate: moment.Moment;
    type: TypeDto;
    clearDate: moment.Moment;
    netAmount: number;
    vatAmt: number;
    totalPayment: number;
    remarks: string;
    isTTOR: boolean;

    constructor(data?: IGetPSASPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankName = data["bankName"];
            this.bankBranch = data["bankBranch"];
            this.account = data["account"];
            this.transNo = data["transNo"];
            this.pmtDate = data["pmtDate"] ? moment(data["pmtDate"].toString()) : <any>undefined;
            this.type = data["type"] ? TypeDto.fromJS(data["type"]) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.netAmount = data["netAmount"];
            this.vatAmt = data["vatAmt"];
            this.totalPayment = data["totalPayment"];
            this.remarks = data["remarks"];
            this.isTTOR = data["isTTOR"];
        }
    }

    static fromJS(data: any): GetPSASPaymentDto {
        let result = new GetPSASPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["bankBranch"] = this.bankBranch;
        data["account"] = this.account;
        data["transNo"] = this.transNo;
        data["pmtDate"] = this.pmtDate ? this.pmtDate.toISOString() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["netAmount"] = this.netAmount;
        data["vatAmt"] = this.vatAmt;
        data["totalPayment"] = this.totalPayment;
        data["remarks"] = this.remarks;
        data["isTTOR"] = this.isTTOR;
        return data; 
    }
}

export interface IGetPSASPaymentDto {
    bankName: string;
    bankBranch: string;
    account: string;
    transNo: string;
    pmtDate: moment.Moment;
    type: TypeDto;
    clearDate: moment.Moment;
    netAmount: number;
    vatAmt: number;
    totalPayment: number;
    remarks: string;
    isTTOR: boolean;
}

export class CreatePaymentPenaltyWaiveManualInputDto implements ICreatePaymentPenaltyWaiveManualInputDto {
    bookCodeList: string[];
    projectCode: string;
    schedNoList: number[];

    constructor(data?: ICreatePaymentPenaltyWaiveManualInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["bookCodeList"] && data["bookCodeList"].constructor === Array) {
                this.bookCodeList = [];
                for (let item of data["bookCodeList"])
                    this.bookCodeList.push(item);
            }
            this.projectCode = data["projectCode"];
            if (data["schedNoList"] && data["schedNoList"].constructor === Array) {
                this.schedNoList = [];
                for (let item of data["schedNoList"])
                    this.schedNoList.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePaymentPenaltyWaiveManualInputDto {
        let result = new CreatePaymentPenaltyWaiveManualInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.bookCodeList && this.bookCodeList.constructor === Array) {
            data["bookCodeList"] = [];
            for (let item of this.bookCodeList)
                data["bookCodeList"].push(item);
        }
        data["projectCode"] = this.projectCode;
        if (this.schedNoList && this.schedNoList.constructor === Array) {
            data["schedNoList"] = [];
            for (let item of this.schedNoList)
                data["schedNoList"].push(item);
        }
        return data; 
    }
}

export interface ICreatePaymentPenaltyWaiveManualInputDto {
    bookCodeList: string[];
    projectCode: string;
    schedNoList: number[];
}

export class CreatePenaltySchedulerManualParam implements ICreatePenaltySchedulerManualParam {
    bookStartDate: moment.Moment;
    bookEndDate: moment.Moment;
    dateStartAging: moment.Moment;
    projectCode: string;
    scmCode: string;
    memberCode: string;
    psCode: string;

    constructor(data?: ICreatePenaltySchedulerManualParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookStartDate = data["bookStartDate"] ? moment(data["bookStartDate"].toString()) : <any>undefined;
            this.bookEndDate = data["bookEndDate"] ? moment(data["bookEndDate"].toString()) : <any>undefined;
            this.dateStartAging = data["dateStartAging"] ? moment(data["dateStartAging"].toString()) : <any>undefined;
            this.projectCode = data["projectCode"];
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): CreatePenaltySchedulerManualParam {
        let result = new CreatePenaltySchedulerManualParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookStartDate"] = this.bookStartDate ? this.bookStartDate.toISOString() : <any>undefined;
        data["bookEndDate"] = this.bookEndDate ? this.bookEndDate.toISOString() : <any>undefined;
        data["dateStartAging"] = this.dateStartAging ? this.dateStartAging.toISOString() : <any>undefined;
        data["projectCode"] = this.projectCode;
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface ICreatePenaltySchedulerManualParam {
    bookStartDate: moment.Moment;
    bookEndDate: moment.Moment;
    dateStartAging: moment.Moment;
    projectCode: string;
    scmCode: string;
    memberCode: string;
    psCode: string;
}

export class GetDataForReportWaive implements IGetDataForReportWaive {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportListHtml[];

    constructor(data?: IGetDataForReportWaive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.tanggalHariIni = data["tanggalHariIni"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(GetReportListHtml.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataForReportWaive {
        let result = new GetDataForReportWaive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["tanggalHariIni"] = this.tanggalHariIni;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataForReportWaive {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportListHtml[];
}

export class GetReportListHtml implements IGetReportListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    schedNo: number;
    penaltyAmount: string;
    executionTime: string;
    status: number;

    constructor(data?: IGetReportListHtml) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.schedNo = data["schedNo"];
            this.penaltyAmount = data["penaltyAmount"];
            this.executionTime = data["executionTime"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetReportListHtml {
        let result = new GetReportListHtml();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["schedNo"] = this.schedNo;
        data["penaltyAmount"] = this.penaltyAmount;
        data["executionTime"] = this.executionTime;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetReportListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    schedNo: number;
    penaltyAmount: string;
    executionTime: string;
    status: number;
}

export class GetDataPenaltyViewListDto implements IGetDataPenaltyViewListDto {
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    hold: boolean;
    dataPenaltySchedule: GetPenaltyScheduleDto[];

    constructor(data?: IGetDataPenaltyViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.project = data["project"];
            this.clusterID = data["clusterID"];
            this.cluster = data["cluster"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psCode = data["psCode"];
            this.custName = data["custName"];
            this.hold = data["hold"];
            if (data["dataPenaltySchedule"] && data["dataPenaltySchedule"].constructor === Array) {
                this.dataPenaltySchedule = [];
                for (let item of data["dataPenaltySchedule"])
                    this.dataPenaltySchedule.push(GetPenaltyScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataPenaltyViewListDto {
        let result = new GetDataPenaltyViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["project"] = this.project;
        data["clusterID"] = this.clusterID;
        data["cluster"] = this.cluster;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psCode"] = this.psCode;
        data["custName"] = this.custName;
        data["hold"] = this.hold;
        if (this.dataPenaltySchedule && this.dataPenaltySchedule.constructor === Array) {
            data["dataPenaltySchedule"] = [];
            for (let item of this.dataPenaltySchedule)
                data["dataPenaltySchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataPenaltyViewListDto {
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    hold: boolean;
    dataPenaltySchedule: GetPenaltyScheduleDto[];
}

export class GetPenaltyScheduleDto implements IGetPenaltyScheduleDto {
    penaltyScheduleID: number;
    schedNo: number;
    allocCode: string;
    dueDate: moment.Moment;
    amountNo: number;
    aging: number;
    penAmount: number;
    penPaymentDate: moment.Moment;
    statusPenalty: string;

    constructor(data?: IGetPenaltyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.penaltyScheduleID = data["penaltyScheduleID"];
            this.schedNo = data["schedNo"];
            this.allocCode = data["allocCode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.amountNo = data["amountNo"];
            this.aging = data["aging"];
            this.penAmount = data["penAmount"];
            this.penPaymentDate = data["penPaymentDate"] ? moment(data["penPaymentDate"].toString()) : <any>undefined;
            this.statusPenalty = data["statusPenalty"];
        }
    }

    static fromJS(data: any): GetPenaltyScheduleDto {
        let result = new GetPenaltyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["penaltyScheduleID"] = this.penaltyScheduleID;
        data["schedNo"] = this.schedNo;
        data["allocCode"] = this.allocCode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["amountNo"] = this.amountNo;
        data["aging"] = this.aging;
        data["penAmount"] = this.penAmount;
        data["penPaymentDate"] = this.penPaymentDate ? this.penPaymentDate.toISOString() : <any>undefined;
        data["statusPenalty"] = this.statusPenalty;
        return data; 
    }
}

export interface IGetPenaltyScheduleDto {
    penaltyScheduleID: number;
    schedNo: number;
    allocCode: string;
    dueDate: moment.Moment;
    amountNo: number;
    aging: number;
    penAmount: number;
    penPaymentDate: moment.Moment;
    statusPenalty: string;
}

export class CheckAdjPenaltyInputDto implements ICheckAdjPenaltyInputDto {
    bookingHeaderID: number;
    schedNo: number;
    payForID: number;
    dueDate: moment.Moment;

    constructor(data?: ICheckAdjPenaltyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.schedNo = data["schedNo"];
            this.payForID = data["payForID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckAdjPenaltyInputDto {
        let result = new CheckAdjPenaltyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["schedNo"] = this.schedNo;
        data["payForID"] = this.payForID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICheckAdjPenaltyInputDto {
    bookingHeaderID: number;
    schedNo: number;
    payForID: number;
    dueDate: moment.Moment;
}

export class GetPaymentsListDto implements IGetPaymentsListDto {
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    transNo: string;
    payNetAmt: number;
    payVatAmt: number;
    totalPay: number;

    constructor(data?: IGetPaymentsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payNetAmt = data["payNetAmt"];
            this.payVatAmt = data["payVatAmt"];
            this.totalPay = data["totalPay"];
        }
    }

    static fromJS(data: any): GetPaymentsListDto {
        let result = new GetPaymentsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payNetAmt"] = this.payNetAmt;
        data["payVatAmt"] = this.payVatAmt;
        data["totalPay"] = this.totalPay;
        return data; 
    }
}

export interface IGetPaymentsListDto {
    paymentDate: moment.Moment;
    clearDate: moment.Moment;
    transNo: string;
    payNetAmt: number;
    payVatAmt: number;
    totalPay: number;
}

export class GetUniversalPersonalDocDto implements IGetUniversalPersonalDocDto {
    personalInfo: GetPersonalDocDto;
    detailInfoDoc: GetDetailInfromationPersonalDocDto[];

    constructor(data?: IGetUniversalPersonalDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.personalInfo = data["personalInfo"] ? GetPersonalDocDto.fromJS(data["personalInfo"]) : <any>undefined;
            if (data["detailInfoDoc"] && data["detailInfoDoc"].constructor === Array) {
                this.detailInfoDoc = [];
                for (let item of data["detailInfoDoc"])
                    this.detailInfoDoc.push(GetDetailInfromationPersonalDocDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUniversalPersonalDocDto {
        let result = new GetUniversalPersonalDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalInfo"] = this.personalInfo ? this.personalInfo.toJSON() : <any>undefined;
        if (this.detailInfoDoc && this.detailInfoDoc.constructor === Array) {
            data["detailInfoDoc"] = [];
            for (let item of this.detailInfoDoc)
                data["detailInfoDoc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUniversalPersonalDocDto {
    personalInfo: GetPersonalDocDto;
    detailInfoDoc: GetDetailInfromationPersonalDocDto[];
}

export class GetPersonalDocDto implements IGetPersonalDocDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    customerName: string;
    projectName: string;
    clusterName: string;
    termOfPayment: string;
    psCode: string;

    constructor(data?: IGetPersonalDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.customerName = data["customerName"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.termOfPayment = data["termOfPayment"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): GetPersonalDocDto {
        let result = new GetPersonalDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["customerName"] = this.customerName;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["termOfPayment"] = this.termOfPayment;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IGetPersonalDocDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    customerName: string;
    projectName: string;
    clusterName: string;
    termOfPayment: string;
    psCode: string;
}

export class GetDetailInfromationPersonalDocDto implements IGetDetailInfromationPersonalDocDto {
    docType: string;
    docName: string;
    docBase64: string;
    status: boolean;

    constructor(data?: IGetDetailInfromationPersonalDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docType = data["docType"];
            this.docName = data["docName"];
            this.docBase64 = data["docBase64"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetDetailInfromationPersonalDocDto {
        let result = new GetDetailInfromationPersonalDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docType"] = this.docType;
        data["docName"] = this.docName;
        data["docBase64"] = this.docBase64;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetDetailInfromationPersonalDocDto {
    docType: string;
    docName: string;
    docBase64: string;
    status: boolean;
}

export class CreateUpdatePriceParamsDto implements ICreateUpdatePriceParamsDto {
    paramsCheck: GetPSASParamsDto;
    bookCode: string;
    discountList: DiscountDto[];

    constructor(data?: ICreateUpdatePriceParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paramsCheck = data["paramsCheck"] ? GetPSASParamsDto.fromJS(data["paramsCheck"]) : <any>undefined;
            this.bookCode = data["bookCode"];
            if (data["discountList"] && data["discountList"].constructor === Array) {
                this.discountList = [];
                for (let item of data["discountList"])
                    this.discountList.push(DiscountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdatePriceParamsDto {
        let result = new CreateUpdatePriceParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paramsCheck"] = this.paramsCheck ? this.paramsCheck.toJSON() : <any>undefined;
        data["bookCode"] = this.bookCode;
        if (this.discountList && this.discountList.constructor === Array) {
            data["discountList"] = [];
            for (let item of this.discountList)
                data["discountList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUpdatePriceParamsDto {
    paramsCheck: GetPSASParamsDto;
    bookCode: string;
    discountList: DiscountDto[];
}

export class GetPSASParamsDto implements IGetPSASParamsDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetPSASParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetPSASParamsDto {
        let result = new GetPSASParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetPSASParamsDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
}

export class DiscountDto implements IDiscountDto {
    pctDisc: number;
    amountDisc: number;
    addDiscDesc: string;
    discNo: number;
    isAmount: boolean;

    constructor(data?: IDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pctDisc = data["pctDisc"];
            this.amountDisc = data["amountDisc"];
            this.addDiscDesc = data["addDiscDesc"];
            this.discNo = data["discNo"];
            this.isAmount = data["isAmount"];
        }
    }

    static fromJS(data: any): DiscountDto {
        let result = new DiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pctDisc"] = this.pctDisc;
        data["amountDisc"] = this.amountDisc;
        data["addDiscDesc"] = this.addDiscDesc;
        data["discNo"] = this.discNo;
        data["isAmount"] = this.isAmount;
        return data; 
    }
}

export interface IDiscountDto {
    pctDisc: number;
    amountDisc: number;
    addDiscDesc: string;
    discNo: number;
    isAmount: boolean;
}

export class GetPSASResultDto implements IGetPSASResultDto {
    unitID: number;
    bookingHeaderID: number;

    constructor(data?: IGetPSASResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.bookingHeaderID = data["bookingHeaderID"];
        }
    }

    static fromJS(data: any): GetPSASResultDto {
        let result = new GetPSASResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        return data; 
    }
}

export interface IGetPSASResultDto {
    unitID: number;
    bookingHeaderID: number;
}

export class GetAddDiscListDto implements IGetAddDiscListDto {
    addDiscDesc: string;
    addDiscNo: number;
    isAmount: boolean;
    pctAddDisc: number;
    amtAddDisc: number;

    constructor(data?: IGetAddDiscListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addDiscDesc = data["addDiscDesc"];
            this.addDiscNo = data["addDiscNo"];
            this.isAmount = data["isAmount"];
            this.pctAddDisc = data["pctAddDisc"];
            this.amtAddDisc = data["amtAddDisc"];
        }
    }

    static fromJS(data: any): GetAddDiscListDto {
        let result = new GetAddDiscListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addDiscDesc"] = this.addDiscDesc;
        data["addDiscNo"] = this.addDiscNo;
        data["isAmount"] = this.isAmount;
        data["pctAddDisc"] = this.pctAddDisc;
        data["amtAddDisc"] = this.amtAddDisc;
        return data; 
    }
}

export interface IGetAddDiscListDto {
    addDiscDesc: string;
    addDiscNo: number;
    isAmount: boolean;
    pctAddDisc: number;
    amtAddDisc: number;
}

export class UpdatePSASParamsDto implements IUpdatePSASParamsDto {
    paramsCheck: GetPSASParamsDto;
    isEffectGross: boolean;
    grossPriceTanah: number;
    grossPriceBangunan: number;
    grossPriceRenov: number;
    oldDiscParam: GetAddDiscListDto[];

    constructor(data?: IUpdatePSASParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paramsCheck = data["paramsCheck"] ? GetPSASParamsDto.fromJS(data["paramsCheck"]) : <any>undefined;
            this.isEffectGross = data["isEffectGross"];
            this.grossPriceTanah = data["grossPriceTanah"];
            this.grossPriceBangunan = data["grossPriceBangunan"];
            this.grossPriceRenov = data["grossPriceRenov"];
            if (data["oldDiscParam"] && data["oldDiscParam"].constructor === Array) {
                this.oldDiscParam = [];
                for (let item of data["oldDiscParam"])
                    this.oldDiscParam.push(GetAddDiscListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePSASParamsDto {
        let result = new UpdatePSASParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paramsCheck"] = this.paramsCheck ? this.paramsCheck.toJSON() : <any>undefined;
        data["isEffectGross"] = this.isEffectGross;
        data["grossPriceTanah"] = this.grossPriceTanah;
        data["grossPriceBangunan"] = this.grossPriceBangunan;
        data["grossPriceRenov"] = this.grossPriceRenov;
        if (this.oldDiscParam && this.oldDiscParam.constructor === Array) {
            data["oldDiscParam"] = [];
            for (let item of this.oldDiscParam)
                data["oldDiscParam"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdatePSASParamsDto {
    paramsCheck: GetPSASParamsDto;
    isEffectGross: boolean;
    grossPriceTanah: number;
    grossPriceBangunan: number;
    grossPriceRenov: number;
    oldDiscParam: GetAddDiscListDto[];
}

export class GetPSASParamsSendEmailDto implements IGetPSASParamsSendEmailDto {
    bookCode: string;
    oldDiscParamEmail: GetAddDiscListDto[];
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetPSASParamsSendEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            if (data["oldDiscParamEmail"] && data["oldDiscParamEmail"].constructor === Array) {
                this.oldDiscParamEmail = [];
                for (let item of data["oldDiscParamEmail"])
                    this.oldDiscParamEmail.push(GetAddDiscListDto.fromJS(item));
            }
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetPSASParamsSendEmailDto {
        let result = new GetPSASParamsSendEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        if (this.oldDiscParamEmail && this.oldDiscParamEmail.constructor === Array) {
            data["oldDiscParamEmail"] = [];
            for (let item of this.oldDiscParamEmail)
                data["oldDiscParamEmail"].push(item.toJSON());
        }
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetPSASParamsSendEmailDto {
    bookCode: string;
    oldDiscParamEmail: GetAddDiscListDto[];
    unitCode: string;
    unitNo: string;
}

export class UpdateTermInputDto implements IUpdateTermInputDto {
    termID: number;
    unitID: number;
    bankCode: string;
    bankDetailID: number;
    bookingHeaderID: number;
    listAddDisc: AddDisc[];

    constructor(data?: IUpdateTermInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.unitID = data["unitID"];
            this.bankCode = data["bankCode"];
            this.bankDetailID = data["bankDetailID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            if (data["listAddDisc"] && data["listAddDisc"].constructor === Array) {
                this.listAddDisc = [];
                for (let item of data["listAddDisc"])
                    this.listAddDisc.push(AddDisc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTermInputDto {
        let result = new UpdateTermInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["unitID"] = this.unitID;
        data["bankCode"] = this.bankCode;
        data["bankDetailID"] = this.bankDetailID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        if (this.listAddDisc && this.listAddDisc.constructor === Array) {
            data["listAddDisc"] = [];
            for (let item of this.listAddDisc)
                data["listAddDisc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTermInputDto {
    termID: number;
    unitID: number;
    bankCode: string;
    bankDetailID: number;
    bookingHeaderID: number;
    listAddDisc: AddDisc[];
}

export class AddDisc implements IAddDisc {
    entityID: number;
    bookingDetailID: number;
    addDiscNo: number;
    pctAddDisc: number;
    amtAddDisc: number;
    isAmount: boolean;
    addDiscDesc: string;

    constructor(data?: IAddDisc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.bookingDetailID = data["bookingDetailID"];
            this.addDiscNo = data["addDiscNo"];
            this.pctAddDisc = data["pctAddDisc"];
            this.amtAddDisc = data["amtAddDisc"];
            this.isAmount = data["isAmount"];
            this.addDiscDesc = data["addDiscDesc"];
        }
    }

    static fromJS(data: any): AddDisc {
        let result = new AddDisc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["bookingDetailID"] = this.bookingDetailID;
        data["addDiscNo"] = this.addDiscNo;
        data["pctAddDisc"] = this.pctAddDisc;
        data["amtAddDisc"] = this.amtAddDisc;
        data["isAmount"] = this.isAmount;
        data["addDiscDesc"] = this.addDiscDesc;
        return data; 
    }
}

export interface IAddDisc {
    entityID: number;
    bookingDetailID: number;
    addDiscNo: number;
    pctAddDisc: number;
    amtAddDisc: number;
    isAmount: boolean;
    addDiscDesc: string;
}

export class ChangeTOPCommInputDto implements IChangeTOPCommInputDto {
    bookNo: string;
    scmCode: string;
    termId: number;

    constructor(data?: IChangeTOPCommInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.scmCode = data["scmCode"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): ChangeTOPCommInputDto {
        let result = new ChangeTOPCommInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["scmCode"] = this.scmCode;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface IChangeTOPCommInputDto {
    bookNo: string;
    scmCode: string;
    termId: number;
}

export class ChangeTermCommResultDto implements IChangeTermCommResultDto {
    netNetPrice: number;
    unitPrice: number;
    pctBobot: number;
    termCode: string;
    termNo: number;
    termRemarks: string;
    message: string;
    detailComm: AmountCommWithDetailDto[];

    constructor(data?: IChangeTermCommResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.netNetPrice = data["netNetPrice"];
            this.unitPrice = data["unitPrice"];
            this.pctBobot = data["pctBobot"];
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.termRemarks = data["termRemarks"];
            this.message = data["message"];
            if (data["detailComm"] && data["detailComm"].constructor === Array) {
                this.detailComm = [];
                for (let item of data["detailComm"])
                    this.detailComm.push(AmountCommWithDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeTermCommResultDto {
        let result = new ChangeTermCommResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netNetPrice"] = this.netNetPrice;
        data["unitPrice"] = this.unitPrice;
        data["pctBobot"] = this.pctBobot;
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["termRemarks"] = this.termRemarks;
        data["message"] = this.message;
        if (this.detailComm && this.detailComm.constructor === Array) {
            data["detailComm"] = [];
            for (let item of this.detailComm)
                data["detailComm"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChangeTermCommResultDto {
    netNetPrice: number;
    unitPrice: number;
    pctBobot: number;
    termCode: string;
    termNo: number;
    termRemarks: string;
    message: string;
    detailComm: AmountCommWithDetailDto[];
}

export class AmountCommWithDetailDto implements IAmountCommWithDetailDto {
    bookingDetailID: number;
    amountComm: number;
    netPriceComm: number;

    constructor(data?: IAmountCommWithDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingDetailID = data["bookingDetailID"];
            this.amountComm = data["amountComm"];
            this.netPriceComm = data["netPriceComm"];
        }
    }

    static fromJS(data: any): AmountCommWithDetailDto {
        let result = new AmountCommWithDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingDetailID"] = this.bookingDetailID;
        data["amountComm"] = this.amountComm;
        data["netPriceComm"] = this.netPriceComm;
        return data; 
    }
}

export interface IAmountCommWithDetailDto {
    bookingDetailID: number;
    amountComm: number;
    netPriceComm: number;
}

export class GetPSASPriceUniversalListDto implements IGetPSASPriceUniversalListDto {
    bookingHeaderID: number;
    projectCode: string;
    area: GetAreaLlistDto;
    grossPrice: GetGrosspriceLlistDto;
    discount: GetDiscountLlistDto;
    netPrice: GetNetpriceLlistDto;
    addDisc: GetAddDiscLlistDto;
    discountA: GetDiscountAlistDto[];
    netNetPrice: GetNetNetPriceLlistDto;
    vatPrice: GetVATLlistDto;
    interest: GetInterestLlistDto;
    total: GetTotalLlistDto;
    pctAddDisc: number[];

    constructor(data?: IGetPSASPriceUniversalListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.projectCode = data["projectCode"];
            this.area = data["area"] ? GetAreaLlistDto.fromJS(data["area"]) : <any>undefined;
            this.grossPrice = data["grossPrice"] ? GetGrosspriceLlistDto.fromJS(data["grossPrice"]) : <any>undefined;
            this.discount = data["discount"] ? GetDiscountLlistDto.fromJS(data["discount"]) : <any>undefined;
            this.netPrice = data["netPrice"] ? GetNetpriceLlistDto.fromJS(data["netPrice"]) : <any>undefined;
            this.addDisc = data["addDisc"] ? GetAddDiscLlistDto.fromJS(data["addDisc"]) : <any>undefined;
            if (data["discountA"] && data["discountA"].constructor === Array) {
                this.discountA = [];
                for (let item of data["discountA"])
                    this.discountA.push(GetDiscountAlistDto.fromJS(item));
            }
            this.netNetPrice = data["netNetPrice"] ? GetNetNetPriceLlistDto.fromJS(data["netNetPrice"]) : <any>undefined;
            this.vatPrice = data["vatPrice"] ? GetVATLlistDto.fromJS(data["vatPrice"]) : <any>undefined;
            this.interest = data["interest"] ? GetInterestLlistDto.fromJS(data["interest"]) : <any>undefined;
            this.total = data["total"] ? GetTotalLlistDto.fromJS(data["total"]) : <any>undefined;
            if (data["pctAddDisc"] && data["pctAddDisc"].constructor === Array) {
                this.pctAddDisc = [];
                for (let item of data["pctAddDisc"])
                    this.pctAddDisc.push(item);
            }
        }
    }

    static fromJS(data: any): GetPSASPriceUniversalListDto {
        let result = new GetPSASPriceUniversalListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["projectCode"] = this.projectCode;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["grossPrice"] = this.grossPrice ? this.grossPrice.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["netPrice"] = this.netPrice ? this.netPrice.toJSON() : <any>undefined;
        data["addDisc"] = this.addDisc ? this.addDisc.toJSON() : <any>undefined;
        if (this.discountA && this.discountA.constructor === Array) {
            data["discountA"] = [];
            for (let item of this.discountA)
                data["discountA"].push(item.toJSON());
        }
        data["netNetPrice"] = this.netNetPrice ? this.netNetPrice.toJSON() : <any>undefined;
        data["vatPrice"] = this.vatPrice ? this.vatPrice.toJSON() : <any>undefined;
        data["interest"] = this.interest ? this.interest.toJSON() : <any>undefined;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        if (this.pctAddDisc && this.pctAddDisc.constructor === Array) {
            data["pctAddDisc"] = [];
            for (let item of this.pctAddDisc)
                data["pctAddDisc"].push(item);
        }
        return data; 
    }
}

export interface IGetPSASPriceUniversalListDto {
    bookingHeaderID: number;
    projectCode: string;
    area: GetAreaLlistDto;
    grossPrice: GetGrosspriceLlistDto;
    discount: GetDiscountLlistDto;
    netPrice: GetNetpriceLlistDto;
    addDisc: GetAddDiscLlistDto;
    discountA: GetDiscountAlistDto[];
    netNetPrice: GetNetNetPriceLlistDto;
    vatPrice: GetVATLlistDto;
    interest: GetInterestLlistDto;
    total: GetTotalLlistDto;
    pctAddDisc: number[];
}

export class ReferralDto implements IReferralDto {
    memberReferral: string;
    memberStatusCode: string;
    memberName: string;
    bookCode: string;
    parentMemberName: string;
    asUplineNo: number;
    isActive: boolean;
    isMember: boolean;
    psCode: string;
    scmCode: string;
    parentMemberCode: string;
    isACD: boolean;
    memberCode: string;

    constructor(data?: IReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberReferral = data["memberReferral"];
            this.memberStatusCode = data["memberStatusCode"];
            this.memberName = data["memberName"];
            this.bookCode = data["bookCode"];
            this.parentMemberName = data["parentMemberName"];
            this.asUplineNo = data["asUplineNo"];
            this.isActive = data["isActive"];
            this.isMember = data["isMember"];
            this.psCode = data["psCode"];
            this.scmCode = data["scmCode"];
            this.parentMemberCode = data["parentMemberCode"];
            this.isACD = data["isACD"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): ReferralDto {
        let result = new ReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberReferral"] = this.memberReferral;
        data["memberStatusCode"] = this.memberStatusCode;
        data["memberName"] = this.memberName;
        data["bookCode"] = this.bookCode;
        data["parentMemberName"] = this.parentMemberName;
        data["asUplineNo"] = this.asUplineNo;
        data["isActive"] = this.isActive;
        data["isMember"] = this.isMember;
        data["psCode"] = this.psCode;
        data["scmCode"] = this.scmCode;
        data["parentMemberCode"] = this.parentMemberCode;
        data["isACD"] = this.isACD;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IReferralDto {
    memberReferral: string;
    memberStatusCode: string;
    memberName: string;
    bookCode: string;
    parentMemberName: string;
    asUplineNo: number;
    isActive: boolean;
    isMember: boolean;
    psCode: string;
    scmCode: string;
    parentMemberCode: string;
    isACD: boolean;
    memberCode: string;
}

export class GetOverridingReferralDto implements IGetOverridingReferralDto {
    scmCode: string;
    memberCode: string;
    memberStatusCode: string;
    memberName: string;

    constructor(data?: IGetOverridingReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.memberStatusCode = data["memberStatusCode"];
            this.memberName = data["memberName"];
        }
    }

    static fromJS(data: any): GetOverridingReferralDto {
        let result = new GetOverridingReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["memberStatusCode"] = this.memberStatusCode;
        data["memberName"] = this.memberName;
        return data; 
    }
}

export interface IGetOverridingReferralDto {
    scmCode: string;
    memberCode: string;
    memberStatusCode: string;
    memberName: string;
}

export class ReferralMemberDto implements IReferralMemberDto {
    bookCode: string;
    referralMemberUpdate: string;
    referralSave: ReferralDto[];
    referralDelete: MemberReferralDeleteDto[];

    constructor(data?: IReferralMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.referralMemberUpdate = data["referralMemberUpdate"];
            if (data["referralSave"] && data["referralSave"].constructor === Array) {
                this.referralSave = [];
                for (let item of data["referralSave"])
                    this.referralSave.push(ReferralDto.fromJS(item));
            }
            if (data["referralDelete"] && data["referralDelete"].constructor === Array) {
                this.referralDelete = [];
                for (let item of data["referralDelete"])
                    this.referralDelete.push(MemberReferralDeleteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferralMemberDto {
        let result = new ReferralMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["referralMemberUpdate"] = this.referralMemberUpdate;
        if (this.referralSave && this.referralSave.constructor === Array) {
            data["referralSave"] = [];
            for (let item of this.referralSave)
                data["referralSave"].push(item.toJSON());
        }
        if (this.referralDelete && this.referralDelete.constructor === Array) {
            data["referralDelete"] = [];
            for (let item of this.referralDelete)
                data["referralDelete"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReferralMemberDto {
    bookCode: string;
    referralMemberUpdate: string;
    referralSave: ReferralDto[];
    referralDelete: MemberReferralDeleteDto[];
}

export class MemberReferralDeleteDto implements IMemberReferralDeleteDto {
    memberCode: string;
    memberStatusCode: string;
    memberName: string;

    constructor(data?: IMemberReferralDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberStatusCode = data["memberStatusCode"];
            this.memberName = data["memberName"];
        }
    }

    static fromJS(data: any): MemberReferralDeleteDto {
        let result = new MemberReferralDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberStatusCode"] = this.memberStatusCode;
        data["memberName"] = this.memberName;
        return data; 
    }
}

export interface IMemberReferralDeleteDto {
    memberCode: string;
    memberStatusCode: string;
    memberName: string;
}

export class GetDataBookingListDto implements IGetDataBookingListDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    memberCodeReferral: string;
    projectCode: string;
    clusterCode: string;
    scmCode: string;
    userID: number;
    allowThrow: boolean;

    constructor(data?: IGetDataBookingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.memberCodeReferral = data["memberCodeReferral"];
            this.projectCode = data["projectCode"];
            this.clusterCode = data["clusterCode"];
            this.scmCode = data["scmCode"];
            this.userID = data["userID"];
            this.allowThrow = data["allowThrow"];
        }
    }

    static fromJS(data: any): GetDataBookingListDto {
        let result = new GetDataBookingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["memberCodeReferral"] = this.memberCodeReferral;
        data["projectCode"] = this.projectCode;
        data["clusterCode"] = this.clusterCode;
        data["scmCode"] = this.scmCode;
        data["userID"] = this.userID;
        data["allowThrow"] = this.allowThrow;
        return data; 
    }
}

export interface IGetDataBookingListDto {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    memberCodeReferral: string;
    projectCode: string;
    clusterCode: string;
    scmCode: string;
    userID: number;
    allowThrow: boolean;
}

export class GetDetailCommPaymentDto implements IGetDetailCommPaymentDto {
    headerDto: HeaderCommPaymentDto;
    listDetailDto: DetailCommPaymentDto[];
    listIncentiveDto: DetailIncentiveCommPaymentDto[];
    isCommPctExist: boolean;
    showProcessIncentive: boolean;
    showPrintCPO: boolean;
    showPaidIncentive: boolean;

    constructor(data?: IGetDetailCommPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerDto = data["headerDto"] ? HeaderCommPaymentDto.fromJS(data["headerDto"]) : <any>undefined;
            if (data["listDetailDto"] && data["listDetailDto"].constructor === Array) {
                this.listDetailDto = [];
                for (let item of data["listDetailDto"])
                    this.listDetailDto.push(DetailCommPaymentDto.fromJS(item));
            }
            if (data["listIncentiveDto"] && data["listIncentiveDto"].constructor === Array) {
                this.listIncentiveDto = [];
                for (let item of data["listIncentiveDto"])
                    this.listIncentiveDto.push(DetailIncentiveCommPaymentDto.fromJS(item));
            }
            this.isCommPctExist = data["isCommPctExist"];
            this.showProcessIncentive = data["showProcessIncentive"];
            this.showPrintCPO = data["showPrintCPO"];
            this.showPaidIncentive = data["showPaidIncentive"];
        }
    }

    static fromJS(data: any): GetDetailCommPaymentDto {
        let result = new GetDetailCommPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerDto"] = this.headerDto ? this.headerDto.toJSON() : <any>undefined;
        if (this.listDetailDto && this.listDetailDto.constructor === Array) {
            data["listDetailDto"] = [];
            for (let item of this.listDetailDto)
                data["listDetailDto"].push(item.toJSON());
        }
        if (this.listIncentiveDto && this.listIncentiveDto.constructor === Array) {
            data["listIncentiveDto"] = [];
            for (let item of this.listIncentiveDto)
                data["listIncentiveDto"].push(item.toJSON());
        }
        data["isCommPctExist"] = this.isCommPctExist;
        data["showProcessIncentive"] = this.showProcessIncentive;
        data["showPrintCPO"] = this.showPrintCPO;
        data["showPaidIncentive"] = this.showPaidIncentive;
        return data; 
    }
}

export interface IGetDetailCommPaymentDto {
    headerDto: HeaderCommPaymentDto;
    listDetailDto: DetailCommPaymentDto[];
    listIncentiveDto: DetailIncentiveCommPaymentDto[];
    isCommPctExist: boolean;
    showProcessIncentive: boolean;
    showPrintCPO: boolean;
    showPaidIncentive: boolean;
}

export class HeaderCommPaymentDto implements IHeaderCommPaymentDto {
    propName: string;
    developer: string;
    scmCode: string;
    propCode: string;
    devCode: string;
    projectName: string;
    clusterName: string;
    bookNo: string;
    unitCode: string;
    unitNo: string;
    sellingPrice: number;
    unitPrice: number;
    totalPayment: number;
    paymentPercentage: number;
    termMainId: number;
    termId: number;
    remarks: string;
    ppjbDate: moment.Moment;
    bobotComm: number;
    bookingTermRemarks: string;
    viewRequirement: SoldUnitReqByBookNoDto;

    constructor(data?: IHeaderCommPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propName = data["propName"];
            this.developer = data["developer"];
            this.scmCode = data["scmCode"];
            this.propCode = data["propCode"];
            this.devCode = data["devCode"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.bookNo = data["bookNo"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.sellingPrice = data["sellingPrice"];
            this.unitPrice = data["unitPrice"];
            this.totalPayment = data["totalPayment"];
            this.paymentPercentage = data["paymentPercentage"];
            this.termMainId = data["termMainId"];
            this.termId = data["termId"];
            this.remarks = data["remarks"];
            this.ppjbDate = data["ppjbDate"] ? moment(data["ppjbDate"].toString()) : <any>undefined;
            this.bobotComm = data["bobotComm"];
            this.bookingTermRemarks = data["bookingTermRemarks"];
            this.viewRequirement = data["viewRequirement"] ? SoldUnitReqByBookNoDto.fromJS(data["viewRequirement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HeaderCommPaymentDto {
        let result = new HeaderCommPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propName"] = this.propName;
        data["developer"] = this.developer;
        data["scmCode"] = this.scmCode;
        data["propCode"] = this.propCode;
        data["devCode"] = this.devCode;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["bookNo"] = this.bookNo;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["sellingPrice"] = this.sellingPrice;
        data["unitPrice"] = this.unitPrice;
        data["totalPayment"] = this.totalPayment;
        data["paymentPercentage"] = this.paymentPercentage;
        data["termMainId"] = this.termMainId;
        data["termId"] = this.termId;
        data["remarks"] = this.remarks;
        data["ppjbDate"] = this.ppjbDate ? this.ppjbDate.toISOString() : <any>undefined;
        data["bobotComm"] = this.bobotComm;
        data["bookingTermRemarks"] = this.bookingTermRemarks;
        data["viewRequirement"] = this.viewRequirement ? this.viewRequirement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHeaderCommPaymentDto {
    propName: string;
    developer: string;
    scmCode: string;
    propCode: string;
    devCode: string;
    projectName: string;
    clusterName: string;
    bookNo: string;
    unitCode: string;
    unitNo: string;
    sellingPrice: number;
    unitPrice: number;
    totalPayment: number;
    paymentPercentage: number;
    termMainId: number;
    termId: number;
    remarks: string;
    ppjbDate: moment.Moment;
    bobotComm: number;
    bookingTermRemarks: string;
    viewRequirement: SoldUnitReqByBookNoDto;
}

export class DetailCommPaymentDto implements IDetailCommPaymentDto {
    bookNo: string;
    memberCode: string;
    reqNo: number;
    asUplineNo: number;
    memberName: string;
    statusName: string;
    commPctPaid: number;
    nominal: number;
    pctPaid: number;
    pphAmount: number;
    amountCommPayment: number;
    amountPPH: number;
    paidDate: moment.Moment;

    constructor(data?: IDetailCommPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.memberCode = data["memberCode"];
            this.reqNo = data["reqNo"];
            this.asUplineNo = data["asUplineNo"];
            this.memberName = data["memberName"];
            this.statusName = data["statusName"];
            this.commPctPaid = data["commPctPaid"];
            this.nominal = data["nominal"];
            this.pctPaid = data["pctPaid"];
            this.pphAmount = data["pphAmount"];
            this.amountCommPayment = data["amountCommPayment"];
            this.amountPPH = data["amountPPH"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DetailCommPaymentDto {
        let result = new DetailCommPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["memberCode"] = this.memberCode;
        data["reqNo"] = this.reqNo;
        data["asUplineNo"] = this.asUplineNo;
        data["memberName"] = this.memberName;
        data["statusName"] = this.statusName;
        data["commPctPaid"] = this.commPctPaid;
        data["nominal"] = this.nominal;
        data["pctPaid"] = this.pctPaid;
        data["pphAmount"] = this.pphAmount;
        data["amountCommPayment"] = this.amountCommPayment;
        data["amountPPH"] = this.amountPPH;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDetailCommPaymentDto {
    bookNo: string;
    memberCode: string;
    reqNo: number;
    asUplineNo: number;
    memberName: string;
    statusName: string;
    commPctPaid: number;
    nominal: number;
    pctPaid: number;
    pphAmount: number;
    amountCommPayment: number;
    amountPPH: number;
    paidDate: moment.Moment;
}

export class DetailIncentiveCommPaymentDto implements IDetailIncentiveCommPaymentDto {
    bookNo: string;
    memberCode: string;
    reqNo: number;
    asUplineNo: number;
    memberName: string;
    nominalIncentive: number;
    pctIncentive: number;
    isTax: boolean;
    pctTax: number;
    amountIncentive: number;
    taxIncentive: number;
    netIncentive: number;
    processDate: moment.Moment;
    paidDate: moment.Moment;

    constructor(data?: IDetailIncentiveCommPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.memberCode = data["memberCode"];
            this.reqNo = data["reqNo"];
            this.asUplineNo = data["asUplineNo"];
            this.memberName = data["memberName"];
            this.nominalIncentive = data["nominalIncentive"];
            this.pctIncentive = data["pctIncentive"];
            this.isTax = data["isTax"];
            this.pctTax = data["pctTax"];
            this.amountIncentive = data["amountIncentive"];
            this.taxIncentive = data["taxIncentive"];
            this.netIncentive = data["netIncentive"];
            this.processDate = data["processDate"] ? moment(data["processDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DetailIncentiveCommPaymentDto {
        let result = new DetailIncentiveCommPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["memberCode"] = this.memberCode;
        data["reqNo"] = this.reqNo;
        data["asUplineNo"] = this.asUplineNo;
        data["memberName"] = this.memberName;
        data["nominalIncentive"] = this.nominalIncentive;
        data["pctIncentive"] = this.pctIncentive;
        data["isTax"] = this.isTax;
        data["pctTax"] = this.pctTax;
        data["amountIncentive"] = this.amountIncentive;
        data["taxIncentive"] = this.taxIncentive;
        data["netIncentive"] = this.netIncentive;
        data["processDate"] = this.processDate ? this.processDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDetailIncentiveCommPaymentDto {
    bookNo: string;
    memberCode: string;
    reqNo: number;
    asUplineNo: number;
    memberName: string;
    nominalIncentive: number;
    pctIncentive: number;
    isTax: boolean;
    pctTax: number;
    amountIncentive: number;
    taxIncentive: number;
    netIncentive: number;
    processDate: moment.Moment;
    paidDate: moment.Moment;
}

export class SoldUnitReqByBookNoDto implements ISoldUnitReqByBookNoDto {
    reqNo: number;
    reqName: string;
    pctPaid: number;

    constructor(data?: ISoldUnitReqByBookNoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reqNo = data["reqNo"];
            this.reqName = data["reqName"];
            this.pctPaid = data["pctPaid"];
        }
    }

    static fromJS(data: any): SoldUnitReqByBookNoDto {
        let result = new SoldUnitReqByBookNoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqNo"] = this.reqNo;
        data["reqName"] = this.reqName;
        data["pctPaid"] = this.pctPaid;
        return data; 
    }
}

export interface ISoldUnitReqByBookNoDto {
    reqNo: number;
    reqName: string;
    pctPaid: number;
}

export class AddMemberInputDto implements IAddMemberInputDto {
    bookNo: string;
    memberCode: string;
    commPctPaid: number;
    nominal: number;
    isCommPctExist: boolean;

    constructor(data?: IAddMemberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.memberCode = data["memberCode"];
            this.commPctPaid = data["commPctPaid"];
            this.nominal = data["nominal"];
            this.isCommPctExist = data["isCommPctExist"];
        }
    }

    static fromJS(data: any): AddMemberInputDto {
        let result = new AddMemberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["memberCode"] = this.memberCode;
        data["commPctPaid"] = this.commPctPaid;
        data["nominal"] = this.nominal;
        data["isCommPctExist"] = this.isCommPctExist;
        return data; 
    }
}

export interface IAddMemberInputDto {
    bookNo: string;
    memberCode: string;
    commPctPaid: number;
    nominal: number;
    isCommPctExist: boolean;
}

export class InsertOverridingReferralDto implements IInsertOverridingReferralDto {
    bookNo: string;
    scmCode: string;
    amount: number;
    adjustCommissionReferral: AdjustCommissionInputReferralDto[];
    adjustIncentive: AdjustInsentiveInputDto[];

    constructor(data?: IInsertOverridingReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.scmCode = data["scmCode"];
            this.amount = data["amount"];
            if (data["adjustCommissionReferral"] && data["adjustCommissionReferral"].constructor === Array) {
                this.adjustCommissionReferral = [];
                for (let item of data["adjustCommissionReferral"])
                    this.adjustCommissionReferral.push(AdjustCommissionInputReferralDto.fromJS(item));
            }
            if (data["adjustIncentive"] && data["adjustIncentive"].constructor === Array) {
                this.adjustIncentive = [];
                for (let item of data["adjustIncentive"])
                    this.adjustIncentive.push(AdjustInsentiveInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOverridingReferralDto {
        let result = new InsertOverridingReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["scmCode"] = this.scmCode;
        data["amount"] = this.amount;
        if (this.adjustCommissionReferral && this.adjustCommissionReferral.constructor === Array) {
            data["adjustCommissionReferral"] = [];
            for (let item of this.adjustCommissionReferral)
                data["adjustCommissionReferral"].push(item.toJSON());
        }
        if (this.adjustIncentive && this.adjustIncentive.constructor === Array) {
            data["adjustIncentive"] = [];
            for (let item of this.adjustIncentive)
                data["adjustIncentive"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsertOverridingReferralDto {
    bookNo: string;
    scmCode: string;
    amount: number;
    adjustCommissionReferral: AdjustCommissionInputReferralDto[];
    adjustIncentive: AdjustInsentiveInputDto[];
}

export class AdjustCommissionInputReferralDto implements IAdjustCommissionInputReferralDto {
    bookNo: string;
    scmCode: string;
    memberCode: string;
    asUplineNo: number;
    commPctPaid: number;
    nominal: number;
    reqNo: number;
    pctPaid: number;

    constructor(data?: IAdjustCommissionInputReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.asUplineNo = data["asUplineNo"];
            this.commPctPaid = data["commPctPaid"];
            this.nominal = data["nominal"];
            this.reqNo = data["reqNo"];
            this.pctPaid = data["pctPaid"];
        }
    }

    static fromJS(data: any): AdjustCommissionInputReferralDto {
        let result = new AdjustCommissionInputReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["asUplineNo"] = this.asUplineNo;
        data["commPctPaid"] = this.commPctPaid;
        data["nominal"] = this.nominal;
        data["reqNo"] = this.reqNo;
        data["pctPaid"] = this.pctPaid;
        return data; 
    }
}

export interface IAdjustCommissionInputReferralDto {
    bookNo: string;
    scmCode: string;
    memberCode: string;
    asUplineNo: number;
    commPctPaid: number;
    nominal: number;
    reqNo: number;
    pctPaid: number;
}

export class AdjustInsentiveInputDto implements IAdjustInsentiveInputDto {
    bookNo: string;
    memberCode: string;
    pctIncentive: number;
    nominalIncentive: number;
    isTax: boolean;

    constructor(data?: IAdjustInsentiveInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookNo = data["bookNo"];
            this.memberCode = data["memberCode"];
            this.pctIncentive = data["pctIncentive"];
            this.nominalIncentive = data["nominalIncentive"];
            this.isTax = data["isTax"];
        }
    }

    static fromJS(data: any): AdjustInsentiveInputDto {
        let result = new AdjustInsentiveInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookNo"] = this.bookNo;
        data["memberCode"] = this.memberCode;
        data["pctIncentive"] = this.pctIncentive;
        data["nominalIncentive"] = this.nominalIncentive;
        data["isTax"] = this.isTax;
        return data; 
    }
}

export interface IAdjustInsentiveInputDto {
    bookNo: string;
    memberCode: string;
    pctIncentive: number;
    nominalIncentive: number;
    isTax: boolean;
}

export class InputCalculatePPHDto implements IInputCalculatePPHDto {
    entityCode: string;
    scmCode: string;
    propCode: string;
    devCode: string;
    bookNo: string;
    asUplineNo: number;
    memberCode: string;
    amountNew: number;

    constructor(data?: IInputCalculatePPHDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.scmCode = data["scmCode"];
            this.propCode = data["propCode"];
            this.devCode = data["devCode"];
            this.bookNo = data["bookNo"];
            this.asUplineNo = data["asUplineNo"];
            this.memberCode = data["memberCode"];
            this.amountNew = data["amountNew"];
        }
    }

    static fromJS(data: any): InputCalculatePPHDto {
        let result = new InputCalculatePPHDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["scmCode"] = this.scmCode;
        data["propCode"] = this.propCode;
        data["devCode"] = this.devCode;
        data["bookNo"] = this.bookNo;
        data["asUplineNo"] = this.asUplineNo;
        data["memberCode"] = this.memberCode;
        data["amountNew"] = this.amountNew;
        return data; 
    }
}

export interface IInputCalculatePPHDto {
    entityCode: string;
    scmCode: string;
    propCode: string;
    devCode: string;
    bookNo: string;
    asUplineNo: number;
    memberCode: string;
    amountNew: number;
}

export class PphSimulateDto implements IPphSimulateDto {
    pphAmount: number;
    pct: number;
    taX_CODE: string;

    constructor(data?: IPphSimulateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pphAmount = data["pphAmount"];
            this.pct = data["pct"];
            this.taX_CODE = data["taX_CODE"];
        }
    }

    static fromJS(data: any): PphSimulateDto {
        let result = new PphSimulateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pphAmount"] = this.pphAmount;
        data["pct"] = this.pct;
        data["taX_CODE"] = this.taX_CODE;
        return data; 
    }
}

export interface IPphSimulateDto {
    pphAmount: number;
    pct: number;
    taX_CODE: string;
}

export class GetCommMemberListDto implements IGetCommMemberListDto {
    memberCode: string;
    asUplineNo: number;
    isActive: boolean;
    isMember: boolean;
    psCode: string;
    memberStatusCode: string;
    parentMemberCode: string;
    isACD: boolean;

    constructor(data?: IGetCommMemberListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.asUplineNo = data["asUplineNo"];
            this.isActive = data["isActive"];
            this.isMember = data["isMember"];
            this.psCode = data["psCode"];
            this.memberStatusCode = data["memberStatusCode"];
            this.parentMemberCode = data["parentMemberCode"];
            this.isACD = data["isACD"];
        }
    }

    static fromJS(data: any): GetCommMemberListDto {
        let result = new GetCommMemberListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["asUplineNo"] = this.asUplineNo;
        data["isActive"] = this.isActive;
        data["isMember"] = this.isMember;
        data["psCode"] = this.psCode;
        data["memberStatusCode"] = this.memberStatusCode;
        data["parentMemberCode"] = this.parentMemberCode;
        data["isACD"] = this.isACD;
        return data; 
    }
}

export interface IGetCommMemberListDto {
    memberCode: string;
    asUplineNo: number;
    isActive: boolean;
    isMember: boolean;
    psCode: string;
    memberStatusCode: string;
    parentMemberCode: string;
    isACD: boolean;
}

export class DeleteExistsOverridingReferralResponose implements IDeleteExistsOverridingReferralResponose {
    result: string;
    targetUrl: string;
    success: boolean;
    error: string;
    unAuthorizedRequest: boolean;
    __abp: boolean;

    constructor(data?: IDeleteExistsOverridingReferralResponose) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.targetUrl = data["targetUrl"];
            this.success = data["success"];
            this.error = data["error"];
            this.unAuthorizedRequest = data["unAuthorizedRequest"];
            this.__abp = data["__abp"];
        }
    }

    static fromJS(data: any): DeleteExistsOverridingReferralResponose {
        let result = new DeleteExistsOverridingReferralResponose();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data; 
    }
}

export interface IDeleteExistsOverridingReferralResponose {
    result: string;
    targetUrl: string;
    success: boolean;
    error: string;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class GetCheckReferralResDto implements IGetCheckReferralResDto {
    id: number;
    scmCode: string;
    scmCodeReferral: string;
    pctLevel_0: number;
    pctLevel_1: number;
    pctLevel_2: number;
    pctLevel_3: number;
    pctLevel_4: number;

    constructor(data?: IGetCheckReferralResDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.scmCode = data["scmCode"];
            this.scmCodeReferral = data["scmCodeReferral"];
            this.pctLevel_0 = data["pctLevel_0"];
            this.pctLevel_1 = data["pctLevel_1"];
            this.pctLevel_2 = data["pctLevel_2"];
            this.pctLevel_3 = data["pctLevel_3"];
            this.pctLevel_4 = data["pctLevel_4"];
        }
    }

    static fromJS(data: any): GetCheckReferralResDto {
        let result = new GetCheckReferralResDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scmCode"] = this.scmCode;
        data["scmCodeReferral"] = this.scmCodeReferral;
        data["pctLevel_0"] = this.pctLevel_0;
        data["pctLevel_1"] = this.pctLevel_1;
        data["pctLevel_2"] = this.pctLevel_2;
        data["pctLevel_3"] = this.pctLevel_3;
        data["pctLevel_4"] = this.pctLevel_4;
        return data; 
    }
}

export interface IGetCheckReferralResDto {
    id: number;
    scmCode: string;
    scmCodeReferral: string;
    pctLevel_0: number;
    pctLevel_1: number;
    pctLevel_2: number;
    pctLevel_3: number;
    pctLevel_4: number;
}

export class GetCheckReferralCodeResDto implements IGetCheckReferralCodeResDto {
    scmCode: string;
    memberCode: string;
    memberName: string;
    memberStatusCode: string;

    constructor(data?: IGetCheckReferralCodeResDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.memberStatusCode = data["memberStatusCode"];
        }
    }

    static fromJS(data: any): GetCheckReferralCodeResDto {
        let result = new GetCheckReferralCodeResDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["memberStatusCode"] = this.memberStatusCode;
        return data; 
    }
}

export interface IGetCheckReferralCodeResDto {
    scmCode: string;
    memberCode: string;
    memberName: string;
    memberStatusCode: string;
}

export class SaveReferralReqDto implements ISaveReferralReqDto {
    bookCode: string;
    referralCode: string;
    processDelete: boolean;

    constructor(data?: ISaveReferralReqDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.referralCode = data["referralCode"];
            this.processDelete = data["processDelete"];
        }
    }

    static fromJS(data: any): SaveReferralReqDto {
        let result = new SaveReferralReqDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["referralCode"] = this.referralCode;
        data["processDelete"] = this.processDelete;
        return data; 
    }
}

export interface ISaveReferralReqDto {
    bookCode: string;
    referralCode: string;
    processDelete: boolean;
}

export class SaveReferralResDto implements ISaveReferralResDto {
    bookCode: string;
    referralCode: string;

    constructor(data?: ISaveReferralResDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.referralCode = data["referralCode"];
        }
    }

    static fromJS(data: any): SaveReferralResDto {
        let result = new SaveReferralResDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["referralCode"] = this.referralCode;
        return data; 
    }
}

export interface ISaveReferralResDto {
    bookCode: string;
    referralCode: string;
}

export class CreateTRBookingDetailScheduleAJBDto implements ICreateTRBookingDetailScheduleAJBDto {
    pctTax: number;
    psasParams: GetPSASParamsDto;
    listSchedule: GetScheduleAJBListDto[];

    constructor(data?: ICreateTRBookingDetailScheduleAJBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pctTax = data["pctTax"];
            this.psasParams = data["psasParams"] ? GetPSASParamsDto.fromJS(data["psasParams"]) : <any>undefined;
            if (data["listSchedule"] && data["listSchedule"].constructor === Array) {
                this.listSchedule = [];
                for (let item of data["listSchedule"])
                    this.listSchedule.push(GetScheduleAJBListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTRBookingDetailScheduleAJBDto {
        let result = new CreateTRBookingDetailScheduleAJBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pctTax"] = this.pctTax;
        data["psasParams"] = this.psasParams ? this.psasParams.toJSON() : <any>undefined;
        if (this.listSchedule && this.listSchedule.constructor === Array) {
            data["listSchedule"] = [];
            for (let item of this.listSchedule)
                data["listSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTRBookingDetailScheduleAJBDto {
    pctTax: number;
    psasParams: GetPSASParamsDto;
    listSchedule: GetScheduleAJBListDto[];
}

export class GetScheduleAJBListDto implements IGetScheduleAJBListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    allocDesc: string;
    amount: number;
    totalPayment: number;
    totalOutstanding: number;
    remarks: string;
    schedNo: number;
    bookingHeaderID: number;
    entityID: number;
    dataPayment: DataPaymentAjbListDto[];

    constructor(data?: IGetScheduleAJBListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.allocDesc = data["allocDesc"];
            this.amount = data["amount"];
            this.totalPayment = data["totalPayment"];
            this.totalOutstanding = data["totalOutstanding"];
            this.remarks = data["remarks"];
            this.schedNo = data["schedNo"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.entityID = data["entityID"];
            if (data["dataPayment"] && data["dataPayment"].constructor === Array) {
                this.dataPayment = [];
                for (let item of data["dataPayment"])
                    this.dataPayment.push(DataPaymentAjbListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetScheduleAJBListDto {
        let result = new GetScheduleAJBListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["allocDesc"] = this.allocDesc;
        data["amount"] = this.amount;
        data["totalPayment"] = this.totalPayment;
        data["totalOutstanding"] = this.totalOutstanding;
        data["remarks"] = this.remarks;
        data["schedNo"] = this.schedNo;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["entityID"] = this.entityID;
        if (this.dataPayment && this.dataPayment.constructor === Array) {
            data["dataPayment"] = [];
            for (let item of this.dataPayment)
                data["dataPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetScheduleAJBListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    allocDesc: string;
    amount: number;
    totalPayment: number;
    totalOutstanding: number;
    remarks: string;
    schedNo: number;
    bookingHeaderID: number;
    entityID: number;
    dataPayment: DataPaymentAjbListDto[];
}

export class DataPaymentAjbListDto implements IDataPaymentAjbListDto {
    clearDate: moment.Moment;
    transNo: string;
    payType: string;
    totalPayment: number;

    constructor(data?: IDataPaymentAjbListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payType = data["payType"];
            this.totalPayment = data["totalPayment"];
        }
    }

    static fromJS(data: any): DataPaymentAjbListDto {
        let result = new DataPaymentAjbListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payType"] = this.payType;
        data["totalPayment"] = this.totalPayment;
        return data; 
    }
}

export interface IDataPaymentAjbListDto {
    clearDate: moment.Moment;
    transNo: string;
    payType: string;
    totalPayment: number;
}

export class CreateTrBookingDetailScheduleParamsDto implements ICreateTrBookingDetailScheduleParamsDto {
    pctTax: number;
    psasParams: GetPSASParamsDto;
    listSchedule: GetScheduleListDto[];

    constructor(data?: ICreateTrBookingDetailScheduleParamsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pctTax = data["pctTax"];
            this.psasParams = data["psasParams"] ? GetPSASParamsDto.fromJS(data["psasParams"]) : <any>undefined;
            if (data["listSchedule"] && data["listSchedule"].constructor === Array) {
                this.listSchedule = [];
                for (let item of data["listSchedule"])
                    this.listSchedule.push(GetScheduleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTrBookingDetailScheduleParamsDto {
        let result = new CreateTrBookingDetailScheduleParamsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pctTax"] = this.pctTax;
        data["psasParams"] = this.psasParams ? this.psasParams.toJSON() : <any>undefined;
        if (this.listSchedule && this.listSchedule.constructor === Array) {
            data["listSchedule"] = [];
            for (let item of this.listSchedule)
                data["listSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTrBookingDetailScheduleParamsDto {
    pctTax: number;
    psasParams: GetPSASParamsDto;
    listSchedule: GetScheduleListDto[];
}

export class GetScheduleListDto implements IGetScheduleListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    daysDue: number;
    pctTax: number;
    dataPayment: DataPaymentListDto[];
    vatPercentage: number;

    constructor(data?: IGetScheduleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.totalAmount = data["totalAmount"];
            this.netOutstanding = data["netOutstanding"];
            this.vatOutstanding = data["vatOutstanding"];
            this.paymentAmount = data["paymentAmount"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
            this.remarks = data["remarks"];
            this.daysDue = data["daysDue"];
            this.pctTax = data["pctTax"];
            if (data["dataPayment"] && data["dataPayment"].constructor === Array) {
                this.dataPayment = [];
                for (let item of data["dataPayment"])
                    this.dataPayment.push(DataPaymentListDto.fromJS(item));
            }
            this.vatPercentage = data["vatPercentage"];
        }
    }

    static fromJS(data: any): GetScheduleListDto {
        let result = new GetScheduleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["netOutstanding"] = this.netOutstanding;
        data["vatOutstanding"] = this.vatOutstanding;
        data["paymentAmount"] = this.paymentAmount;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        data["remarks"] = this.remarks;
        data["daysDue"] = this.daysDue;
        data["pctTax"] = this.pctTax;
        if (this.dataPayment && this.dataPayment.constructor === Array) {
            data["dataPayment"] = [];
            for (let item of this.dataPayment)
                data["dataPayment"].push(item.toJSON());
        }
        data["vatPercentage"] = this.vatPercentage;
        return data; 
    }
}

export interface IGetScheduleListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    daysDue: number;
    pctTax: number;
    dataPayment: DataPaymentListDto[];
    vatPercentage: number;
}

export class GetAllocationListDto implements IGetAllocationListDto {
    allocID: number;
    allocCode: string;
    isVat: boolean;

    constructor(data?: IGetAllocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.allocCode = data["allocCode"];
            this.isVat = data["isVat"];
        }
    }

    static fromJS(data: any): GetAllocationListDto {
        let result = new GetAllocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["allocCode"] = this.allocCode;
        data["isVat"] = this.isVat;
        return data; 
    }
}

export interface IGetAllocationListDto {
    allocID: number;
    allocCode: string;
    isVat: boolean;
}

export class GetAllocationAjbListDto implements IGetAllocationAjbListDto {
    allocID: number;
    allocCode: string;
    allocDesc: string;

    constructor(data?: IGetAllocationAjbListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.allocCode = data["allocCode"];
            this.allocDesc = data["allocDesc"];
        }
    }

    static fromJS(data: any): GetAllocationAjbListDto {
        let result = new GetAllocationAjbListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["allocCode"] = this.allocCode;
        data["allocDesc"] = this.allocDesc;
        return data; 
    }
}

export interface IGetAllocationAjbListDto {
    allocID: number;
    allocCode: string;
    allocDesc: string;
}

export class GetCompanyCodeListDto implements IGetCompanyCodeListDto {
    coCode: string;

    constructor(data?: IGetCompanyCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coCode = data["coCode"];
        }
    }

    static fromJS(data: any): GetCompanyCodeListDto {
        let result = new GetCompanyCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coCode"] = this.coCode;
        return data; 
    }
}

export interface IGetCompanyCodeListDto {
    coCode: string;
}

export class GetScheduleUniversalDto implements IGetScheduleUniversalDto {
    pctTax: number;
    dataSchedule: GetScheduleListDto[];

    constructor(data?: IGetScheduleUniversalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pctTax = data["pctTax"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(GetScheduleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetScheduleUniversalDto {
        let result = new GetScheduleUniversalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pctTax"] = this.pctTax;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetScheduleUniversalDto {
    pctTax: number;
    dataSchedule: GetScheduleListDto[];
}

export class GetPSASScheduleHeaderDto implements IGetPSASScheduleHeaderDto {
    term: string;
    totalNetAmount: number;
    totalVATAmount: number;
    sellingPrice: number;
    totalSchedule: number;
    excludePenalty: ExcludePenaltyDto;
    penalty: PenaltyDto;

    constructor(data?: IGetPSASScheduleHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.term = data["term"];
            this.totalNetAmount = data["totalNetAmount"];
            this.totalVATAmount = data["totalVATAmount"];
            this.sellingPrice = data["sellingPrice"];
            this.totalSchedule = data["totalSchedule"];
            this.excludePenalty = data["excludePenalty"] ? ExcludePenaltyDto.fromJS(data["excludePenalty"]) : <any>undefined;
            this.penalty = data["penalty"] ? PenaltyDto.fromJS(data["penalty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPSASScheduleHeaderDto {
        let result = new GetPSASScheduleHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["totalNetAmount"] = this.totalNetAmount;
        data["totalVATAmount"] = this.totalVATAmount;
        data["sellingPrice"] = this.sellingPrice;
        data["totalSchedule"] = this.totalSchedule;
        data["excludePenalty"] = this.excludePenalty ? this.excludePenalty.toJSON() : <any>undefined;
        data["penalty"] = this.penalty ? this.penalty.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPSASScheduleHeaderDto {
    term: string;
    totalNetAmount: number;
    totalVATAmount: number;
    sellingPrice: number;
    totalSchedule: number;
    excludePenalty: ExcludePenaltyDto;
    penalty: PenaltyDto;
}

export class ExcludePenaltyDto implements IExcludePenaltyDto {
    totalNetAmt: number;
    totalVatAmt: number;
    totalNetOut: number;
    totalvatOut: number;

    constructor(data?: IExcludePenaltyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalNetAmt = data["totalNetAmt"];
            this.totalVatAmt = data["totalVatAmt"];
            this.totalNetOut = data["totalNetOut"];
            this.totalvatOut = data["totalvatOut"];
        }
    }

    static fromJS(data: any): ExcludePenaltyDto {
        let result = new ExcludePenaltyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNetAmt"] = this.totalNetAmt;
        data["totalVatAmt"] = this.totalVatAmt;
        data["totalNetOut"] = this.totalNetOut;
        data["totalvatOut"] = this.totalvatOut;
        return data; 
    }
}

export interface IExcludePenaltyDto {
    totalNetAmt: number;
    totalVatAmt: number;
    totalNetOut: number;
    totalvatOut: number;
}

export class PenaltyDto implements IPenaltyDto {
    totalNetAmt: number;
    totalVatAmt: number;
    totalNetOut: number;
    totalvatOut: number;

    constructor(data?: IPenaltyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalNetAmt = data["totalNetAmt"];
            this.totalVatAmt = data["totalVatAmt"];
            this.totalNetOut = data["totalNetOut"];
            this.totalvatOut = data["totalvatOut"];
        }
    }

    static fromJS(data: any): PenaltyDto {
        let result = new PenaltyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNetAmt"] = this.totalNetAmt;
        data["totalVatAmt"] = this.totalVatAmt;
        data["totalNetOut"] = this.totalNetOut;
        data["totalvatOut"] = this.totalvatOut;
        return data; 
    }
}

export interface IPenaltyDto {
    totalNetAmt: number;
    totalVatAmt: number;
    totalNetOut: number;
    totalvatOut: number;
}

export class GetPSASScheduleAjbHeaderDto implements IGetPSASScheduleAjbHeaderDto {
    totalFee: number;
    totalFeePaid: number;

    constructor(data?: IGetPSASScheduleAjbHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalFee = data["totalFee"];
            this.totalFeePaid = data["totalFeePaid"];
        }
    }

    static fromJS(data: any): GetPSASScheduleAjbHeaderDto {
        let result = new GetPSASScheduleAjbHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFee"] = this.totalFee;
        data["totalFeePaid"] = this.totalFeePaid;
        return data; 
    }
}

export interface IGetPSASScheduleAjbHeaderDto {
    totalFee: number;
    totalFeePaid: number;
}

export class CreateTrPaymentHeaderInputDto implements ICreateTrPaymentHeaderInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;

    constructor(data?: ICreateTrPaymentHeaderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountID = data["accountID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
        }
    }

    static fromJS(data: any): CreateTrPaymentHeaderInputDto {
        let result = new CreateTrPaymentHeaderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        return data; 
    }
}

export interface ICreateTrPaymentHeaderInputDto {
    accountID: number;
    bookingHeaderID: number;
    payForID: number;
}

export class CreateTrPaymentDetailInputDto implements ICreateTrPaymentDetailInputDto {
    payNo: number;
    paymentHeaderID: number;

    constructor(data?: ICreateTrPaymentDetailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payNo = data["payNo"];
            this.paymentHeaderID = data["paymentHeaderID"];
        }
    }

    static fromJS(data: any): CreateTrPaymentDetailInputDto {
        let result = new CreateTrPaymentDetailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payNo"] = this.payNo;
        data["paymentHeaderID"] = this.paymentHeaderID;
        return data; 
    }
}

export interface ICreateTrPaymentDetailInputDto {
    payNo: number;
    paymentHeaderID: number;
}

export class CreateTrPaymentDetailAllocInputDto implements ICreateTrPaymentDetailAllocInputDto {
    entityID: number;
    schedNo: number;
    paymentDetailID: number;
    vatAmt: number;
    netAmt: number;

    constructor(data?: ICreateTrPaymentDetailAllocInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.schedNo = data["schedNo"];
            this.paymentDetailID = data["paymentDetailID"];
            this.vatAmt = data["vatAmt"];
            this.netAmt = data["netAmt"];
        }
    }

    static fromJS(data: any): CreateTrPaymentDetailAllocInputDto {
        let result = new CreateTrPaymentDetailAllocInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["schedNo"] = this.schedNo;
        data["paymentDetailID"] = this.paymentDetailID;
        data["vatAmt"] = this.vatAmt;
        data["netAmt"] = this.netAmt;
        return data; 
    }
}

export interface ICreateTrPaymentDetailAllocInputDto {
    entityID: number;
    schedNo: number;
    paymentDetailID: number;
    vatAmt: number;
    netAmt: number;
}

export class SetDPScheduleInputDto implements ISetDPScheduleInputDto {
    bookingHeaderID: number;
    listDP: GetDPScheduleListDto[];

    constructor(data?: ISetDPScheduleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            if (data["listDP"] && data["listDP"].constructor === Array) {
                this.listDP = [];
                for (let item of data["listDP"])
                    this.listDP.push(GetDPScheduleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetDPScheduleInputDto {
        let result = new SetDPScheduleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        if (this.listDP && this.listDP.constructor === Array) {
            data["listDP"] = [];
            for (let item of this.listDP)
                data["listDP"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISetDPScheduleInputDto {
    bookingHeaderID: number;
    listDP: GetDPScheduleListDto[];
}

export class GetDPScheduleListDto implements IGetDPScheduleListDto {
    dpAmount: number;
    dpPct: number;
    dpNo: string;
    daysDue: number;
    monthsDue: number;
    dpCalcID: number;
    dpCalcDesc: string;

    constructor(data?: IGetDPScheduleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dpAmount = data["dpAmount"];
            this.dpPct = data["dpPct"];
            this.dpNo = data["dpNo"];
            this.daysDue = data["daysDue"];
            this.monthsDue = data["monthsDue"];
            this.dpCalcID = data["dpCalcID"];
            this.dpCalcDesc = data["dpCalcDesc"];
        }
    }

    static fromJS(data: any): GetDPScheduleListDto {
        let result = new GetDPScheduleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dpAmount"] = this.dpAmount;
        data["dpPct"] = this.dpPct;
        data["dpNo"] = this.dpNo;
        data["daysDue"] = this.daysDue;
        data["monthsDue"] = this.monthsDue;
        data["dpCalcID"] = this.dpCalcID;
        data["dpCalcDesc"] = this.dpCalcDesc;
        return data; 
    }
}

export interface IGetDPScheduleListDto {
    dpAmount: number;
    dpPct: number;
    dpNo: string;
    daysDue: number;
    monthsDue: number;
    dpCalcID: number;
    dpCalcDesc: string;
}

export class SetINSScheduleInputDto implements ISetINSScheduleInputDto {
    bookingHeaderID: number;
    dataINS: GetINSScheduleListDto;

    constructor(data?: ISetINSScheduleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.dataINS = data["dataINS"] ? GetINSScheduleListDto.fromJS(data["dataINS"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetINSScheduleInputDto {
        let result = new SetINSScheduleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["dataINS"] = this.dataINS ? this.dataINS.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISetINSScheduleInputDto {
    bookingHeaderID: number;
    dataINS: GetINSScheduleListDto;
}

export class GetINSScheduleListDto implements IGetINSScheduleListDto {
    finStartD: number;
    finStartM: number;

    constructor(data?: IGetINSScheduleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.finStartD = data["finStartD"];
            this.finStartM = data["finStartM"];
        }
    }

    static fromJS(data: any): GetINSScheduleListDto {
        let result = new GetINSScheduleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finStartD"] = this.finStartD;
        data["finStartM"] = this.finStartM;
        return data; 
    }
}

export interface IGetINSScheduleListDto {
    finStartD: number;
    finStartM: number;
}

export class GetFormulaListDto implements IGetFormulaListDto {
    dpCalcID: number;
    dpCalcType: string;
    dpCalcDesc: string;

    constructor(data?: IGetFormulaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dpCalcID = data["dpCalcID"];
            this.dpCalcType = data["dpCalcType"];
            this.dpCalcDesc = data["dpCalcDesc"];
        }
    }

    static fromJS(data: any): GetFormulaListDto {
        let result = new GetFormulaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dpCalcID"] = this.dpCalcID;
        data["dpCalcType"] = this.dpCalcType;
        data["dpCalcDesc"] = this.dpCalcDesc;
        return data; 
    }
}

export interface IGetFormulaListDto {
    dpCalcID: number;
    dpCalcType: string;
    dpCalcDesc: string;
}

export class ResultGetPSCode implements IResultGetPSCode {
    siteID: number;
    psCode: string;

    constructor(data?: IResultGetPSCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): ResultGetPSCode {
        let result = new ResultGetPSCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IResultGetPSCode {
    siteID: number;
    psCode: string;
}

export class ResultOutstandingBillingDto implements IResultOutstandingBillingDto {
    psCode: string;
    name: string;
    siteID: string;
    billingOutstandingBalance: string;
    listUnit: BillingUnitOnlyDto[];
    periode: PeriodeOutstandingBillingDto[];

    constructor(data?: IResultOutstandingBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.siteID = data["siteID"];
            this.billingOutstandingBalance = data["billingOutstandingBalance"];
            if (data["listUnit"] && data["listUnit"].constructor === Array) {
                this.listUnit = [];
                for (let item of data["listUnit"])
                    this.listUnit.push(BillingUnitOnlyDto.fromJS(item));
            }
            if (data["periode"] && data["periode"].constructor === Array) {
                this.periode = [];
                for (let item of data["periode"])
                    this.periode.push(PeriodeOutstandingBillingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOutstandingBillingDto {
        let result = new ResultOutstandingBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["siteID"] = this.siteID;
        data["billingOutstandingBalance"] = this.billingOutstandingBalance;
        if (this.listUnit && this.listUnit.constructor === Array) {
            data["listUnit"] = [];
            for (let item of this.listUnit)
                data["listUnit"].push(item.toJSON());
        }
        if (this.periode && this.periode.constructor === Array) {
            data["periode"] = [];
            for (let item of this.periode)
                data["periode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IResultOutstandingBillingDto {
    psCode: string;
    name: string;
    siteID: string;
    billingOutstandingBalance: string;
    listUnit: BillingUnitOnlyDto[];
    periode: PeriodeOutstandingBillingDto[];
}

export class BillingUnitOnlyDto implements IBillingUnitOnlyDto {
    unitCode: string;
    unitName: string;
    unitNo: string;

    constructor(data?: IBillingUnitOnlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): BillingUnitOnlyDto {
        let result = new BillingUnitOnlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IBillingUnitOnlyDto {
    unitCode: string;
    unitName: string;
    unitNo: string;
}

export class PeriodeOutstandingBillingDto implements IPeriodeOutstandingBillingDto {
    no: string;
    name: string;
    dueDate: moment.Moment;
    totalPreviousBalance: string;
    totalCurrentTransaction: string;
    totalPayment: string;
    totalBillingOutstanding: string;
    totalBillingOutstandingByPeriod: string;
    unit: UnitOutstandingBillingDto[];

    constructor(data?: IPeriodeOutstandingBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.name = data["name"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.totalPreviousBalance = data["totalPreviousBalance"];
            this.totalCurrentTransaction = data["totalCurrentTransaction"];
            this.totalPayment = data["totalPayment"];
            this.totalBillingOutstanding = data["totalBillingOutstanding"];
            this.totalBillingOutstandingByPeriod = data["totalBillingOutstandingByPeriod"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(UnitOutstandingBillingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PeriodeOutstandingBillingDto {
        let result = new PeriodeOutstandingBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["name"] = this.name;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["totalPreviousBalance"] = this.totalPreviousBalance;
        data["totalCurrentTransaction"] = this.totalCurrentTransaction;
        data["totalPayment"] = this.totalPayment;
        data["totalBillingOutstanding"] = this.totalBillingOutstanding;
        data["totalBillingOutstandingByPeriod"] = this.totalBillingOutstandingByPeriod;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPeriodeOutstandingBillingDto {
    no: string;
    name: string;
    dueDate: moment.Moment;
    totalPreviousBalance: string;
    totalCurrentTransaction: string;
    totalPayment: string;
    totalBillingOutstanding: string;
    totalBillingOutstandingByPeriod: string;
    unit: UnitOutstandingBillingDto[];
}

export class UnitOutstandingBillingDto implements IUnitOutstandingBillingDto {
    unitCode: string;
    unitName: string;
    unitNo: string;
    previousBalance: string;
    currentTransaction: string;
    payment: string;
    billingOutstanding: string;
    currentOutstanding: string;
    currentOutstandingByPeriod: string;
    vaNo: string;
    periodNO: string;
    periode: string;
    dueDate: string;
    outstandingPeriod: string;
    detail: DetailUnitOutstandingBilling[];
    detailGroup: GroupDetailUnitOutstandingBilling[];

    constructor(data?: IUnitOutstandingBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.previousBalance = data["previousBalance"];
            this.currentTransaction = data["currentTransaction"];
            this.payment = data["payment"];
            this.billingOutstanding = data["billingOutstanding"];
            this.currentOutstanding = data["currentOutstanding"];
            this.currentOutstandingByPeriod = data["currentOutstandingByPeriod"];
            this.vaNo = data["vaNo"];
            this.periodNO = data["periodNO"];
            this.periode = data["periode"];
            this.dueDate = data["dueDate"];
            this.outstandingPeriod = data["outstandingPeriod"];
            if (data["detail"] && data["detail"].constructor === Array) {
                this.detail = [];
                for (let item of data["detail"])
                    this.detail.push(DetailUnitOutstandingBilling.fromJS(item));
            }
            if (data["detailGroup"] && data["detailGroup"].constructor === Array) {
                this.detailGroup = [];
                for (let item of data["detailGroup"])
                    this.detailGroup.push(GroupDetailUnitOutstandingBilling.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitOutstandingBillingDto {
        let result = new UnitOutstandingBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["previousBalance"] = this.previousBalance;
        data["currentTransaction"] = this.currentTransaction;
        data["payment"] = this.payment;
        data["billingOutstanding"] = this.billingOutstanding;
        data["currentOutstanding"] = this.currentOutstanding;
        data["currentOutstandingByPeriod"] = this.currentOutstandingByPeriod;
        data["vaNo"] = this.vaNo;
        data["periodNO"] = this.periodNO;
        data["periode"] = this.periode;
        data["dueDate"] = this.dueDate;
        data["outstandingPeriod"] = this.outstandingPeriod;
        if (this.detail && this.detail.constructor === Array) {
            data["detail"] = [];
            for (let item of this.detail)
                data["detail"].push(item.toJSON());
        }
        if (this.detailGroup && this.detailGroup.constructor === Array) {
            data["detailGroup"] = [];
            for (let item of this.detailGroup)
                data["detailGroup"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnitOutstandingBillingDto {
    unitCode: string;
    unitName: string;
    unitNo: string;
    previousBalance: string;
    currentTransaction: string;
    payment: string;
    billingOutstanding: string;
    currentOutstanding: string;
    currentOutstandingByPeriod: string;
    vaNo: string;
    periodNO: string;
    periode: string;
    dueDate: string;
    outstandingPeriod: string;
    detail: DetailUnitOutstandingBilling[];
    detailGroup: GroupDetailUnitOutstandingBilling[];
}

export class DetailUnitOutstandingBilling implements IDetailUnitOutstandingBilling {
    transactionDate: string;
    transactionCategoryDesc: string;
    transactionDesc: string;
    transactionAmount: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    periodNO: string;

    constructor(data?: IDetailUnitOutstandingBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDate = data["transactionDate"];
            this.transactionCategoryDesc = data["transactionCategoryDesc"];
            this.transactionDesc = data["transactionDesc"];
            this.transactionAmount = data["transactionAmount"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.periodNO = data["periodNO"];
        }
    }

    static fromJS(data: any): DetailUnitOutstandingBilling {
        let result = new DetailUnitOutstandingBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDate"] = this.transactionDate;
        data["transactionCategoryDesc"] = this.transactionCategoryDesc;
        data["transactionDesc"] = this.transactionDesc;
        data["transactionAmount"] = this.transactionAmount;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["periodNO"] = this.periodNO;
        return data; 
    }
}

export interface IDetailUnitOutstandingBilling {
    transactionDate: string;
    transactionCategoryDesc: string;
    transactionDesc: string;
    transactionAmount: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    periodNO: string;
}

export class GroupDetailUnitOutstandingBilling implements IGroupDetailUnitOutstandingBilling {
    transactionCategoryDesc: string;
    transactionAmount: number;

    constructor(data?: IGroupDetailUnitOutstandingBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCategoryDesc = data["transactionCategoryDesc"];
            this.transactionAmount = data["transactionAmount"];
        }
    }

    static fromJS(data: any): GroupDetailUnitOutstandingBilling {
        let result = new GroupDetailUnitOutstandingBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCategoryDesc"] = this.transactionCategoryDesc;
        data["transactionAmount"] = this.transactionAmount;
        return data; 
    }
}

export interface IGroupDetailUnitOutstandingBilling {
    transactionCategoryDesc: string;
    transactionAmount: number;
}

export class GetListCustUserDataDto implements IGetListCustUserDataDto {
    emailaddress: string;
    phonenumber: string;
    site_id: number;

    constructor(data?: IGetListCustUserDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailaddress = data["emailaddress"];
            this.phonenumber = data["phonenumber"];
            this.site_id = data["site_id"];
        }
    }

    static fromJS(data: any): GetListCustUserDataDto {
        let result = new GetListCustUserDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailaddress"] = this.emailaddress;
        data["phonenumber"] = this.phonenumber;
        data["site_id"] = this.site_id;
        return data; 
    }
}

export interface IGetListCustUserDataDto {
    emailaddress: string;
    phonenumber: string;
    site_id: number;
}

export class GetListCustomerDataDto implements IGetListCustomerDataDto {
    siteID: number;
    psCode: string;
    emailOrPhone: string;

    constructor(data?: IGetListCustomerDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.siteID = data["siteID"];
            this.psCode = data["psCode"];
            this.emailOrPhone = data["emailOrPhone"];
        }
    }

    static fromJS(data: any): GetListCustomerDataDto {
        let result = new GetListCustomerDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteID"] = this.siteID;
        data["psCode"] = this.psCode;
        data["emailOrPhone"] = this.emailOrPhone;
        return data; 
    }
}

export interface IGetListCustomerDataDto {
    siteID: number;
    psCode: string;
    emailOrPhone: string;
}

export class GetScheduleAJBUniversalDto implements IGetScheduleAJBUniversalDto {
    pctTax: number;
    dateScheduleAJB: GetScheduleAJBListDto[];

    constructor(data?: IGetScheduleAJBUniversalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pctTax = data["pctTax"];
            if (data["dateScheduleAJB"] && data["dateScheduleAJB"].constructor === Array) {
                this.dateScheduleAJB = [];
                for (let item of data["dateScheduleAJB"])
                    this.dateScheduleAJB.push(GetScheduleAJBListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetScheduleAJBUniversalDto {
        let result = new GetScheduleAJBUniversalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pctTax"] = this.pctTax;
        if (this.dateScheduleAJB && this.dateScheduleAJB.constructor === Array) {
            data["dateScheduleAJB"] = [];
            for (let item of this.dateScheduleAJB)
                data["dateScheduleAJB"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetScheduleAJBUniversalDto {
    pctTax: number;
    dateScheduleAJB: GetScheduleAJBListDto[];
}

export class GetPSASIsPaidParameterDto implements IGetPSASIsPaidParameterDto {
    isPaid: boolean;

    constructor(data?: IGetPSASIsPaidParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPaid = data["isPaid"];
        }
    }

    static fromJS(data: any): GetPSASIsPaidParameterDto {
        let result = new GetPSASIsPaidParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPaid"] = this.isPaid;
        return data; 
    }
}

export interface IGetPSASIsPaidParameterDto {
    isPaid: boolean;
}

export class UploadSignedDocumentKPInputDto implements IUploadSignedDocumentKPInputDto {
    bookCode: string;
    trBookingDocID: number;
    docNo: string;
    docCode: string;
    signedDocumentDate: moment.Moment;
    signedDocumentFile: string;
    signatureDate: moment.Moment;

    constructor(data?: IUploadSignedDocumentKPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.trBookingDocID = data["trBookingDocID"];
            this.docNo = data["docNo"];
            this.docCode = data["docCode"];
            this.signedDocumentDate = data["signedDocumentDate"] ? moment(data["signedDocumentDate"].toString()) : <any>undefined;
            this.signedDocumentFile = data["signedDocumentFile"];
            this.signatureDate = data["signatureDate"] ? moment(data["signatureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadSignedDocumentKPInputDto {
        let result = new UploadSignedDocumentKPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["trBookingDocID"] = this.trBookingDocID;
        data["docNo"] = this.docNo;
        data["docCode"] = this.docCode;
        data["signedDocumentDate"] = this.signedDocumentDate ? this.signedDocumentDate.toISOString() : <any>undefined;
        data["signedDocumentFile"] = this.signedDocumentFile;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUploadSignedDocumentKPInputDto {
    bookCode: string;
    trBookingDocID: number;
    docNo: string;
    docCode: string;
    signedDocumentDate: moment.Moment;
    signedDocumentFile: string;
    signatureDate: moment.Moment;
}

export class UploadSignedDocumentIMBInputDto implements IUploadSignedDocumentIMBInputDto {
    bookCode: string;
    docID: number;
    docCode: string;
    docNo: string;
    remarks: string;
    signedDocumentFile: string;
    signatureDate: moment.Moment;

    constructor(data?: IUploadSignedDocumentIMBInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.docID = data["docID"];
            this.docCode = data["docCode"];
            this.docNo = data["docNo"];
            this.remarks = data["remarks"];
            this.signedDocumentFile = data["signedDocumentFile"];
            this.signatureDate = data["signatureDate"] ? moment(data["signatureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadSignedDocumentIMBInputDto {
        let result = new UploadSignedDocumentIMBInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["docID"] = this.docID;
        data["docCode"] = this.docCode;
        data["docNo"] = this.docNo;
        data["remarks"] = this.remarks;
        data["signedDocumentFile"] = this.signedDocumentFile;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUploadSignedDocumentIMBInputDto {
    bookCode: string;
    docID: number;
    docCode: string;
    docNo: string;
    remarks: string;
    signedDocumentFile: string;
    signatureDate: moment.Moment;
}

export class UploadSignedDocumentInputDto implements IUploadSignedDocumentInputDto {
    trBookingDocID: number;
    docNo: string;
    signedDocumentDate: moment.Moment;
    signedDocumentFile: string;
    signatureDate: moment.Moment;

    constructor(data?: IUploadSignedDocumentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.trBookingDocID = data["trBookingDocID"];
            this.docNo = data["docNo"];
            this.signedDocumentDate = data["signedDocumentDate"] ? moment(data["signedDocumentDate"].toString()) : <any>undefined;
            this.signedDocumentFile = data["signedDocumentFile"];
            this.signatureDate = data["signatureDate"] ? moment(data["signatureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadSignedDocumentInputDto {
        let result = new UploadSignedDocumentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trBookingDocID"] = this.trBookingDocID;
        data["docNo"] = this.docNo;
        data["signedDocumentDate"] = this.signedDocumentDate ? this.signedDocumentDate.toISOString() : <any>undefined;
        data["signedDocumentFile"] = this.signedDocumentFile;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUploadSignedDocumentInputDto {
    trBookingDocID: number;
    docNo: string;
    signedDocumentDate: moment.Moment;
    signedDocumentFile: string;
    signatureDate: moment.Moment;
}

export class InsertHandOverDto implements IInsertHandOverDto {
    bastDate: string;
    bastNo: string;
    bookCode: string;
    coCode: string;
    orgID: number;
    ownerName: string;
    psCode: string;
    remarks: string;
    username: string;
    siteID: number;
    unitCode: string;
    unitNo: string;
    stType: string;
    bastType: string;

    constructor(data?: IInsertHandOverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bastDate = data["bastDate"];
            this.bastNo = data["bastNo"];
            this.bookCode = data["bookCode"];
            this.coCode = data["coCode"];
            this.orgID = data["orgID"];
            this.ownerName = data["ownerName"];
            this.psCode = data["psCode"];
            this.remarks = data["remarks"];
            this.username = data["username"];
            this.siteID = data["siteID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.stType = data["stType"];
            this.bastType = data["bastType"];
        }
    }

    static fromJS(data: any): InsertHandOverDto {
        let result = new InsertHandOverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bastDate"] = this.bastDate;
        data["bastNo"] = this.bastNo;
        data["bookCode"] = this.bookCode;
        data["coCode"] = this.coCode;
        data["orgID"] = this.orgID;
        data["ownerName"] = this.ownerName;
        data["psCode"] = this.psCode;
        data["remarks"] = this.remarks;
        data["username"] = this.username;
        data["siteID"] = this.siteID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["stType"] = this.stType;
        data["bastType"] = this.bastType;
        return data; 
    }
}

export interface IInsertHandOverDto {
    bastDate: string;
    bastNo: string;
    bookCode: string;
    coCode: string;
    orgID: number;
    ownerName: string;
    psCode: string;
    remarks: string;
    username: string;
    siteID: number;
    unitCode: string;
    unitNo: string;
    stType: string;
    bastType: string;
}

export class GetDocNoDropdownListDto implements IGetDocNoDropdownListDto {
    trBookingDocID: number;
    docNo: string;
    docType: string;
    docDate: string;

    constructor(data?: IGetDocNoDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.trBookingDocID = data["trBookingDocID"];
            this.docNo = data["docNo"];
            this.docType = data["docType"];
            this.docDate = data["docDate"];
        }
    }

    static fromJS(data: any): GetDocNoDropdownListDto {
        let result = new GetDocNoDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trBookingDocID"] = this.trBookingDocID;
        data["docNo"] = this.docNo;
        data["docType"] = this.docType;
        data["docDate"] = this.docDate;
        return data; 
    }
}

export interface IGetDocNoDropdownListDto {
    trBookingDocID: number;
    docNo: string;
    docType: string;
    docDate: string;
}

export class GetDetailBookingDocumentListDto implements IGetDetailBookingDocumentListDto {
    projectName: string;
    projectId: number;
    clusterName: string;
    clusterId: number;
    unitCode: string;
    unitNo: string;
    bookingDocumentId: number;
    addendumDocumentId: number;
    docCode: string;
    docName: string;
    docNo: string;
    docDate: moment.Moment;
    remarks: string;
    isActive: boolean;
    isTandaTerima: boolean;
    fileTandaTerima: string;
    signedDocumentDate: string;
    signatureDate: string;
    signatureFile: string;
    totalCount: number;

    constructor(data?: IGetDetailBookingDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.projectId = data["projectId"];
            this.clusterName = data["clusterName"];
            this.clusterId = data["clusterId"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.bookingDocumentId = data["bookingDocumentId"];
            this.addendumDocumentId = data["addendumDocumentId"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
            this.docNo = data["docNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.isActive = data["isActive"];
            this.isTandaTerima = data["isTandaTerima"];
            this.fileTandaTerima = data["fileTandaTerima"];
            this.signedDocumentDate = data["signedDocumentDate"];
            this.signatureDate = data["signatureDate"];
            this.signatureFile = data["signatureFile"];
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): GetDetailBookingDocumentListDto {
        let result = new GetDetailBookingDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["clusterName"] = this.clusterName;
        data["clusterId"] = this.clusterId;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["bookingDocumentId"] = this.bookingDocumentId;
        data["addendumDocumentId"] = this.addendumDocumentId;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        data["docNo"] = this.docNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        data["isTandaTerima"] = this.isTandaTerima;
        data["fileTandaTerima"] = this.fileTandaTerima;
        data["signedDocumentDate"] = this.signedDocumentDate;
        data["signatureDate"] = this.signatureDate;
        data["signatureFile"] = this.signatureFile;
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IGetDetailBookingDocumentListDto {
    projectName: string;
    projectId: number;
    clusterName: string;
    clusterId: number;
    unitCode: string;
    unitNo: string;
    bookingDocumentId: number;
    addendumDocumentId: number;
    docCode: string;
    docName: string;
    docNo: string;
    docDate: moment.Moment;
    remarks: string;
    isActive: boolean;
    isTandaTerima: boolean;
    fileTandaTerima: string;
    signedDocumentDate: string;
    signatureDate: string;
    signatureFile: string;
    totalCount: number;
}

export class PagedResultDtoOfGetDetailBookingDocumentListDto implements IPagedResultDtoOfGetDetailBookingDocumentListDto {
    totalCount: number;
    items: GetDetailBookingDocumentListDto[];

    constructor(data?: IPagedResultDtoOfGetDetailBookingDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDetailBookingDocumentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDetailBookingDocumentListDto {
        let result = new PagedResultDtoOfGetDetailBookingDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDetailBookingDocumentListDto {
    totalCount: number;
    items: GetDetailBookingDocumentListDto[];
}

export class GetDropDownDocAdd implements IGetDropDownDocAdd {
    docId: number;
    docCode: string;
    docName: string;

    constructor(data?: IGetDropDownDocAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docId = data["docId"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
        }
    }

    static fromJS(data: any): GetDropDownDocAdd {
        let result = new GetDropDownDocAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docId"] = this.docId;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        return data; 
    }
}

export interface IGetDropDownDocAdd {
    docId: number;
    docCode: string;
    docName: string;
}

export class UploadAddendumDocInputDto implements IUploadAddendumDocInputDto {
    bookCode: string;
    bookingDocumentId: number;
    docId: number;
    docNo: string;
    signedDocumentDate: moment.Moment;
    remarks: string;
    addendumFileName: string;

    constructor(data?: IUploadAddendumDocInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.bookingDocumentId = data["bookingDocumentId"];
            this.docId = data["docId"];
            this.docNo = data["docNo"];
            this.signedDocumentDate = data["signedDocumentDate"] ? moment(data["signedDocumentDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.addendumFileName = data["addendumFileName"];
        }
    }

    static fromJS(data: any): UploadAddendumDocInputDto {
        let result = new UploadAddendumDocInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["bookingDocumentId"] = this.bookingDocumentId;
        data["docId"] = this.docId;
        data["docNo"] = this.docNo;
        data["signedDocumentDate"] = this.signedDocumentDate ? this.signedDocumentDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["addendumFileName"] = this.addendumFileName;
        return data; 
    }
}

export interface IUploadAddendumDocInputDto {
    bookCode: string;
    bookingDocumentId: number;
    docId: number;
    docNo: string;
    signedDocumentDate: moment.Moment;
    remarks: string;
    addendumFileName: string;
}

export class GetDetailDocDto implements IGetDetailDocDto {
    docNo: string;
    customerName: string;
    bookingDocumentID: number;
    docDate: moment.Moment;
    docId: number;
    docCode: string;
    docName: string;
    psCode: string;
    isAmdt: boolean;
    apiSima: boolean;

    constructor(data?: IGetDetailDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNo = data["docNo"];
            this.customerName = data["customerName"];
            this.bookingDocumentID = data["bookingDocumentID"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.docId = data["docId"];
            this.docCode = data["docCode"];
            this.docName = data["docName"];
            this.psCode = data["psCode"];
            this.isAmdt = data["isAmdt"];
            this.apiSima = data["apiSima"];
        }
    }

    static fromJS(data: any): GetDetailDocDto {
        let result = new GetDetailDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNo"] = this.docNo;
        data["customerName"] = this.customerName;
        data["bookingDocumentID"] = this.bookingDocumentID;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["docId"] = this.docId;
        data["docCode"] = this.docCode;
        data["docName"] = this.docName;
        data["psCode"] = this.psCode;
        data["isAmdt"] = this.isAmdt;
        data["apiSima"] = this.apiSima;
        return data; 
    }
}

export interface IGetDetailDocDto {
    docNo: string;
    customerName: string;
    bookingDocumentID: number;
    docDate: moment.Moment;
    docId: number;
    docCode: string;
    docName: string;
    psCode: string;
    isAmdt: boolean;
    apiSima: boolean;
}

export class GetDropdownMonth implements IGetDropdownMonth {
    monthName: string;
    month: number;

    constructor(data?: IGetDropdownMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.monthName = data["monthName"];
            this.month = data["month"];
        }
    }

    static fromJS(data: any): GetDropdownMonth {
        let result = new GetDropdownMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthName"] = this.monthName;
        data["month"] = this.month;
        return data; 
    }
}

export interface IGetDropdownMonth {
    monthName: string;
    month: number;
}

export class GetDropdownCocodeDto implements IGetDropdownCocodeDto {
    cocode: string;
    companyName: string;

    constructor(data?: IGetDropdownCocodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cocode = data["cocode"];
            this.companyName = data["companyName"];
        }
    }

    static fromJS(data: any): GetDropdownCocodeDto {
        let result = new GetDropdownCocodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cocode"] = this.cocode;
        data["companyName"] = this.companyName;
        return data; 
    }
}

export interface IGetDropdownCocodeDto {
    cocode: string;
    companyName: string;
}

export class GetDataSSPDetail implements IGetDataSSPDetail {
    sspDetail: GetSSPDetail[];
    totalPPhPaid: number;
    totalCadanganPPh: number;

    constructor(data?: IGetDataSSPDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["sspDetail"] && data["sspDetail"].constructor === Array) {
                this.sspDetail = [];
                for (let item of data["sspDetail"])
                    this.sspDetail.push(GetSSPDetail.fromJS(item));
            }
            this.totalPPhPaid = data["totalPPhPaid"];
            this.totalCadanganPPh = data["totalCadanganPPh"];
        }
    }

    static fromJS(data: any): GetDataSSPDetail {
        let result = new GetDataSSPDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.sspDetail && this.sspDetail.constructor === Array) {
            data["sspDetail"] = [];
            for (let item of this.sspDetail)
                data["sspDetail"].push(item.toJSON());
        }
        data["totalPPhPaid"] = this.totalPPhPaid;
        data["totalCadanganPPh"] = this.totalCadanganPPh;
        return data; 
    }
}

export interface IGetDataSSPDetail {
    sspDetail: GetSSPDetail[];
    totalPPhPaid: number;
    totalCadanganPPh: number;
}

export class GetSSPDetail implements IGetSSPDetail {
    periode: string;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    pphPaid: number;
    cadanganPPh: number;
    coCode: string;
    unitcode: string;
    unitno: string;

    constructor(data?: IGetSSPDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periode = data["periode"];
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.pphPaid = data["pphPaid"];
            this.cadanganPPh = data["cadanganPPh"];
            this.coCode = data["coCode"];
            this.unitcode = data["unitcode"];
            this.unitno = data["unitno"];
        }
    }

    static fromJS(data: any): GetSSPDetail {
        let result = new GetSSPDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periode"] = this.periode;
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["pphPaid"] = this.pphPaid;
        data["cadanganPPh"] = this.cadanganPPh;
        data["coCode"] = this.coCode;
        data["unitcode"] = this.unitcode;
        data["unitno"] = this.unitno;
        return data; 
    }
}

export interface IGetSSPDetail {
    periode: string;
    bookCode: string;
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    pphPaid: number;
    cadanganPPh: number;
    coCode: string;
    unitcode: string;
    unitno: string;
}

export class GetListSSPResultDto implements IGetListSSPResultDto {
    sspid: string;
    unitCode: string;
    unitNo: string;
    period: string;
    bookCode: string;
    bookDate: string;
    cancelDate: string;
    pphPaid: number;
    detailPaymentID: number;

    constructor(data?: IGetListSSPResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sspid = data["sspid"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.period = data["period"];
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"];
            this.cancelDate = data["cancelDate"];
            this.pphPaid = data["pphPaid"];
            this.detailPaymentID = data["detailPaymentID"];
        }
    }

    static fromJS(data: any): GetListSSPResultDto {
        let result = new GetListSSPResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sspid"] = this.sspid;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["period"] = this.period;
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate;
        data["cancelDate"] = this.cancelDate;
        data["pphPaid"] = this.pphPaid;
        data["detailPaymentID"] = this.detailPaymentID;
        return data; 
    }
}

export interface IGetListSSPResultDto {
    sspid: string;
    unitCode: string;
    unitNo: string;
    period: string;
    bookCode: string;
    bookDate: string;
    cancelDate: string;
    pphPaid: number;
    detailPaymentID: number;
}

export class TasklistNewSSPInputDto implements ITasklistNewSSPInputDto {
    bookCode: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: ITasklistNewSSPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): TasklistNewSSPInputDto {
        let result = new TasklistNewSSPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface ITasklistNewSSPInputDto {
    bookCode: string;
    skipCount: number;
    maxResultCount: number;
}

export class PagedResultDtoOfTasklistNewSSPDto implements IPagedResultDtoOfTasklistNewSSPDto {
    totalCount: number;
    items: TasklistNewSSPDto[];

    constructor(data?: IPagedResultDtoOfTasklistNewSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TasklistNewSSPDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTasklistNewSSPDto {
        let result = new PagedResultDtoOfTasklistNewSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTasklistNewSSPDto {
    totalCount: number;
    items: TasklistNewSSPDto[];
}

export class TasklistNewSSPDto implements ITasklistNewSSPDto {
    sspMainID: number;
    unitCode: string;
    unitNo: string;
    period: string;
    coCode: string;
    sspid: string;
    generateDate: moment.Moment;
    tglUpload: moment.Moment;
    fileUpload: string;

    constructor(data?: ITasklistNewSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sspMainID = data["sspMainID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.period = data["period"];
            this.coCode = data["coCode"];
            this.sspid = data["sspid"];
            this.generateDate = data["generateDate"] ? moment(data["generateDate"].toString()) : <any>undefined;
            this.tglUpload = data["tglUpload"] ? moment(data["tglUpload"].toString()) : <any>undefined;
            this.fileUpload = data["fileUpload"];
        }
    }

    static fromJS(data: any): TasklistNewSSPDto {
        let result = new TasklistNewSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sspMainID"] = this.sspMainID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["period"] = this.period;
        data["coCode"] = this.coCode;
        data["sspid"] = this.sspid;
        data["generateDate"] = this.generateDate ? this.generateDate.toISOString() : <any>undefined;
        data["tglUpload"] = this.tglUpload ? this.tglUpload.toISOString() : <any>undefined;
        data["fileUpload"] = this.fileUpload;
        return data; 
    }
}

export interface ITasklistNewSSPDto {
    sspMainID: number;
    unitCode: string;
    unitNo: string;
    period: string;
    coCode: string;
    sspid: string;
    generateDate: moment.Moment;
    tglUpload: moment.Moment;
    fileUpload: string;
}

export class DetailNewSSPDto implements IDetailNewSSPDto {
    sspMainID: number;
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    custName: string;
    transNo: string;
    ratePPH: number;
    pphPaid: number;
    payType: string;

    constructor(data?: IDetailNewSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sspMainID = data["sspMainID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.custName = data["custName"];
            this.transNo = data["transNo"];
            this.ratePPH = data["ratePPH"];
            this.pphPaid = data["pphPaid"];
            this.payType = data["payType"];
        }
    }

    static fromJS(data: any): DetailNewSSPDto {
        let result = new DetailNewSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sspMainID"] = this.sspMainID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["custName"] = this.custName;
        data["transNo"] = this.transNo;
        data["ratePPH"] = this.ratePPH;
        data["pphPaid"] = this.pphPaid;
        data["payType"] = this.payType;
        return data; 
    }
}

export interface IDetailNewSSPDto {
    sspMainID: number;
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    custName: string;
    transNo: string;
    ratePPH: number;
    pphPaid: number;
    payType: string;
}

export class UploadSSPNewDto implements IUploadSSPNewDto {
    bookCode: string;
    sspMainID: number;
    file: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IUploadSSPNewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.sspMainID = data["sspMainID"];
            this.file = data["file"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): UploadSSPNewDto {
        let result = new UploadSSPNewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["sspMainID"] = this.sspMainID;
        data["file"] = this.file;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IUploadSSPNewDto {
    bookCode: string;
    sspMainID: number;
    file: string;
    unitCode: string;
    unitNo: string;
}

export class GetListSSPDto implements IGetListSSPDto {
    projectID: number;
    clusterID: number;
    monthPeriod: number;
    yearPeriod: number;
    filter: string;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetListSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.monthPeriod = data["monthPeriod"];
            this.yearPeriod = data["yearPeriod"];
            this.filter = data["filter"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetListSSPDto {
        let result = new GetListSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["monthPeriod"] = this.monthPeriod;
        data["yearPeriod"] = this.yearPeriod;
        data["filter"] = this.filter;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }
}

export interface IGetListSSPDto {
    projectID: number;
    clusterID: number;
    monthPeriod: number;
    yearPeriod: number;
    filter: string;
    skipCount: number;
    maxResultCount: number;
}

export class PagedResultDtoOfListSSPDto implements IPagedResultDtoOfListSSPDto {
    totalCount: number;
    items: ListSSPDto[];

    constructor(data?: IPagedResultDtoOfListSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ListSSPDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfListSSPDto {
        let result = new PagedResultDtoOfListSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfListSSPDto {
    totalCount: number;
    items: ListSSPDto[];
}

export class ListSSPDto implements IListSSPDto {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    monthPeriod: string;
    yearPeriod: string;
    unitCode: string;
    unitNo: string;
    pphPaid: number;
    generateDate: moment.Moment;
    tglUpload: moment.Moment;
    fileUpload: string;
    totalUpload: number;

    constructor(data?: IListSSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.clusterId = data["clusterId"];
            this.clusterName = data["clusterName"];
            this.monthPeriod = data["monthPeriod"];
            this.yearPeriod = data["yearPeriod"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.pphPaid = data["pphPaid"];
            this.generateDate = data["generateDate"] ? moment(data["generateDate"].toString()) : <any>undefined;
            this.tglUpload = data["tglUpload"] ? moment(data["tglUpload"].toString()) : <any>undefined;
            this.fileUpload = data["fileUpload"];
            this.totalUpload = data["totalUpload"];
        }
    }

    static fromJS(data: any): ListSSPDto {
        let result = new ListSSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["clusterId"] = this.clusterId;
        data["clusterName"] = this.clusterName;
        data["monthPeriod"] = this.monthPeriod;
        data["yearPeriod"] = this.yearPeriod;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["pphPaid"] = this.pphPaid;
        data["generateDate"] = this.generateDate ? this.generateDate.toISOString() : <any>undefined;
        data["tglUpload"] = this.tglUpload ? this.tglUpload.toISOString() : <any>undefined;
        data["fileUpload"] = this.fileUpload;
        data["totalUpload"] = this.totalUpload;
        return data; 
    }
}

export interface IListSSPDto {
    projectId: number;
    projectName: string;
    clusterId: number;
    clusterName: string;
    monthPeriod: string;
    yearPeriod: string;
    unitCode: string;
    unitNo: string;
    pphPaid: number;
    generateDate: moment.Moment;
    tglUpload: moment.Moment;
    fileUpload: string;
    totalUpload: number;
}

export class FileNameZipUpload implements IFileNameZipUpload {
    codeFileName: string;
    fileName: string;

    constructor(data?: IFileNameZipUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codeFileName = data["codeFileName"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): FileNameZipUpload {
        let result = new FileNameZipUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeFileName"] = this.codeFileName;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IFileNameZipUpload {
    codeFileName: string;
    fileName: string;
}

export class GenerateNewBulkSSPDataHeader implements IGenerateNewBulkSSPDataHeader {
    monthCSV: number;
    yearCSV: number;
    monthPeriod: number;
    yearPeriod: number;
    userID: number;
    tglUpload: moment.Moment;
    fileUpload: string;
    combinedUnitNo: string;

    constructor(data?: IGenerateNewBulkSSPDataHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.monthCSV = data["monthCSV"];
            this.yearCSV = data["yearCSV"];
            this.monthPeriod = data["monthPeriod"];
            this.yearPeriod = data["yearPeriod"];
            this.userID = data["userID"];
            this.tglUpload = data["tglUpload"] ? moment(data["tglUpload"].toString()) : <any>undefined;
            this.fileUpload = data["fileUpload"];
            this.combinedUnitNo = data["combinedUnitNo"];
        }
    }

    static fromJS(data: any): GenerateNewBulkSSPDataHeader {
        let result = new GenerateNewBulkSSPDataHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthCSV"] = this.monthCSV;
        data["yearCSV"] = this.yearCSV;
        data["monthPeriod"] = this.monthPeriod;
        data["yearPeriod"] = this.yearPeriod;
        data["userID"] = this.userID;
        data["tglUpload"] = this.tglUpload ? this.tglUpload.toISOString() : <any>undefined;
        data["fileUpload"] = this.fileUpload;
        data["combinedUnitNo"] = this.combinedUnitNo;
        return data; 
    }
}

export interface IGenerateNewBulkSSPDataHeader {
    monthCSV: number;
    yearCSV: number;
    monthPeriod: number;
    yearPeriod: number;
    userID: number;
    tglUpload: moment.Moment;
    fileUpload: string;
    combinedUnitNo: string;
}

export class ResponseUploadBulkSSPDTO implements IResponseUploadBulkSSPDTO {
    code: number;
    status: string;
    statusMonth: string;
    statusYear: string;
    statusUpload: string;
    statusFail: string;

    constructor(data?: IResponseUploadBulkSSPDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.status = data["status"];
            this.statusMonth = data["statusMonth"];
            this.statusYear = data["statusYear"];
            this.statusUpload = data["statusUpload"];
            this.statusFail = data["statusFail"];
        }
    }

    static fromJS(data: any): ResponseUploadBulkSSPDTO {
        let result = new ResponseUploadBulkSSPDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["status"] = this.status;
        data["statusMonth"] = this.statusMonth;
        data["statusYear"] = this.statusYear;
        data["statusUpload"] = this.statusUpload;
        data["statusFail"] = this.statusFail;
        return data; 
    }
}

export interface IResponseUploadBulkSSPDTO {
    code: number;
    status: string;
    statusMonth: string;
    statusYear: string;
    statusUpload: string;
    statusFail: string;
}

export class GetDataSuratPeringatanListDto implements IGetDataSuratPeringatanListDto {
    bookCode: string;
    bookingHeaderID: number;
    dueDate: moment.Moment;
    dueDate_SP2: moment.Moment;
    scheduleTerm: number;
    payedAmt: number;
    netAmt: number;
    penAge: number;
    penaltyAmount: number;
    totalPen: number;
    seqNo: number;
    psCode: string;
    coCode: string;
    clusterID: number;
    entityID: number;
    projectCode: string;
    projectID: number;
    unitNo: string;
    unitCode: string;
    unitName: string;
    projectName: string;
    outstanding: number;
    overdue: number;
    spPeriodeID: number;
    officerName1: string;
    officerName2: string;
    positionName1: string;
    positionName2: string;
    maturityDate: moment.Moment;

    constructor(data?: IGetDataSuratPeringatanListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.dueDate_SP2 = data["dueDate_SP2"] ? moment(data["dueDate_SP2"].toString()) : <any>undefined;
            this.scheduleTerm = data["scheduleTerm"];
            this.payedAmt = data["payedAmt"];
            this.netAmt = data["netAmt"];
            this.penAge = data["penAge"];
            this.penaltyAmount = data["penaltyAmount"];
            this.totalPen = data["totalPen"];
            this.seqNo = data["seqNo"];
            this.psCode = data["psCode"];
            this.coCode = data["coCode"];
            this.clusterID = data["clusterID"];
            this.entityID = data["entityID"];
            this.projectCode = data["projectCode"];
            this.projectID = data["projectID"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.projectName = data["projectName"];
            this.outstanding = data["outstanding"];
            this.overdue = data["overdue"];
            this.spPeriodeID = data["spPeriodeID"];
            this.officerName1 = data["officerName1"];
            this.officerName2 = data["officerName2"];
            this.positionName1 = data["positionName1"];
            this.positionName2 = data["positionName2"];
            this.maturityDate = data["maturityDate"] ? moment(data["maturityDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataSuratPeringatanListDto {
        let result = new GetDataSuratPeringatanListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueDate_SP2"] = this.dueDate_SP2 ? this.dueDate_SP2.toISOString() : <any>undefined;
        data["scheduleTerm"] = this.scheduleTerm;
        data["payedAmt"] = this.payedAmt;
        data["netAmt"] = this.netAmt;
        data["penAge"] = this.penAge;
        data["penaltyAmount"] = this.penaltyAmount;
        data["totalPen"] = this.totalPen;
        data["seqNo"] = this.seqNo;
        data["psCode"] = this.psCode;
        data["coCode"] = this.coCode;
        data["clusterID"] = this.clusterID;
        data["entityID"] = this.entityID;
        data["projectCode"] = this.projectCode;
        data["projectID"] = this.projectID;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["projectName"] = this.projectName;
        data["outstanding"] = this.outstanding;
        data["overdue"] = this.overdue;
        data["spPeriodeID"] = this.spPeriodeID;
        data["officerName1"] = this.officerName1;
        data["officerName2"] = this.officerName2;
        data["positionName1"] = this.positionName1;
        data["positionName2"] = this.positionName2;
        data["maturityDate"] = this.maturityDate ? this.maturityDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDataSuratPeringatanListDto {
    bookCode: string;
    bookingHeaderID: number;
    dueDate: moment.Moment;
    dueDate_SP2: moment.Moment;
    scheduleTerm: number;
    payedAmt: number;
    netAmt: number;
    penAge: number;
    penaltyAmount: number;
    totalPen: number;
    seqNo: number;
    psCode: string;
    coCode: string;
    clusterID: number;
    entityID: number;
    projectCode: string;
    projectID: number;
    unitNo: string;
    unitCode: string;
    unitName: string;
    projectName: string;
    outstanding: number;
    overdue: number;
    spPeriodeID: number;
    officerName1: string;
    officerName2: string;
    positionName1: string;
    positionName2: string;
    maturityDate: moment.Moment;
}

export class GetDataSuratPeringatanPenaltyViewListDto implements IGetDataSuratPeringatanPenaltyViewListDto {
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    dataReminderLetter: GetDataReminderLetterDto[];

    constructor(data?: IGetDataSuratPeringatanPenaltyViewListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.project = data["project"];
            this.clusterID = data["clusterID"];
            this.cluster = data["cluster"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psCode = data["psCode"];
            this.custName = data["custName"];
            if (data["dataReminderLetter"] && data["dataReminderLetter"].constructor === Array) {
                this.dataReminderLetter = [];
                for (let item of data["dataReminderLetter"])
                    this.dataReminderLetter.push(GetDataReminderLetterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataSuratPeringatanPenaltyViewListDto {
        let result = new GetDataSuratPeringatanPenaltyViewListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["project"] = this.project;
        data["clusterID"] = this.clusterID;
        data["cluster"] = this.cluster;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psCode"] = this.psCode;
        data["custName"] = this.custName;
        if (this.dataReminderLetter && this.dataReminderLetter.constructor === Array) {
            data["dataReminderLetter"] = [];
            for (let item of this.dataReminderLetter)
                data["dataReminderLetter"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataSuratPeringatanPenaltyViewListDto {
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    psCode: string;
    custName: string;
    dataReminderLetter: GetDataReminderLetterDto[];
}

export class GetDataReminderLetterDto implements IGetDataReminderLetterDto {
    generateDate: moment.Moment;
    letterType: string;
    sentDate: moment.Moment;
    status: string;
    documentUrl: string;
    documentName: string;
    spNo: string;
    mailDate: moment.Moment;
    letterStatusId: number;
    clearDate: moment.Moment;

    constructor(data?: IGetDataReminderLetterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generateDate = data["generateDate"] ? moment(data["generateDate"].toString()) : <any>undefined;
            this.letterType = data["letterType"];
            this.sentDate = data["sentDate"] ? moment(data["sentDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.documentUrl = data["documentUrl"];
            this.documentName = data["documentName"];
            this.spNo = data["spNo"];
            this.mailDate = data["mailDate"] ? moment(data["mailDate"].toString()) : <any>undefined;
            this.letterStatusId = data["letterStatusId"];
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataReminderLetterDto {
        let result = new GetDataReminderLetterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generateDate"] = this.generateDate ? this.generateDate.toISOString() : <any>undefined;
        data["letterType"] = this.letterType;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["documentUrl"] = this.documentUrl;
        data["documentName"] = this.documentName;
        data["spNo"] = this.spNo;
        data["mailDate"] = this.mailDate ? this.mailDate.toISOString() : <any>undefined;
        data["letterStatusId"] = this.letterStatusId;
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetDataReminderLetterDto {
    generateDate: moment.Moment;
    letterType: string;
    sentDate: moment.Moment;
    status: string;
    documentUrl: string;
    documentName: string;
    spNo: string;
    mailDate: moment.Moment;
    letterStatusId: number;
    clearDate: moment.Moment;
}

export class GetDataSendEmailSPDto implements IGetDataSendEmailSPDto {
    overDue: number;
    reminderLetterID: number;
    psCode: string;
    projectCode: string;
    projectName: string;
    projectID: number;
    unitNo: string;
    unitCode: string;
    unitName: string;
    unitID: number;
    templateHtml: string;
    letterType: string;
    letterNo: string;
    letterDate: moment.Moment;
    penAmt: number;
    totalPen: number;
    sadOfficer1: string;
    sadOfficer2: string;
    sadPosition1: string;
    sadPosition2: string;
    coCode: string;
    dueDate: moment.Moment;
    areaID: number;
    bookingHeaderID: number;
    sadManagerID: number;
    bookCode: string;
    totAmt: number;
    outAmt: number;
    schedNo: number;
    productName: string;
    clusterName: string;
    clusterID: number;
    bankName: string;
    accNo: string;
    accName: string;
    picClusterName: string;
    picEmail: string;
    handphoneNo: string;
    officePhoneNo: string;

    constructor(data?: IGetDataSendEmailSPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.overDue = data["overDue"];
            this.reminderLetterID = data["reminderLetterID"];
            this.psCode = data["psCode"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.projectID = data["projectID"];
            this.unitNo = data["unitNo"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitID = data["unitID"];
            this.templateHtml = data["templateHtml"];
            this.letterType = data["letterType"];
            this.letterNo = data["letterNo"];
            this.letterDate = data["letterDate"] ? moment(data["letterDate"].toString()) : <any>undefined;
            this.penAmt = data["penAmt"];
            this.totalPen = data["totalPen"];
            this.sadOfficer1 = data["sadOfficer1"];
            this.sadOfficer2 = data["sadOfficer2"];
            this.sadPosition1 = data["sadPosition1"];
            this.sadPosition2 = data["sadPosition2"];
            this.coCode = data["coCode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.areaID = data["areaID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.sadManagerID = data["sadManagerID"];
            this.bookCode = data["bookCode"];
            this.totAmt = data["totAmt"];
            this.outAmt = data["outAmt"];
            this.schedNo = data["schedNo"];
            this.productName = data["productName"];
            this.clusterName = data["clusterName"];
            this.clusterID = data["clusterID"];
            this.bankName = data["bankName"];
            this.accNo = data["accNo"];
            this.accName = data["accName"];
            this.picClusterName = data["picClusterName"];
            this.picEmail = data["picEmail"];
            this.handphoneNo = data["handphoneNo"];
            this.officePhoneNo = data["officePhoneNo"];
        }
    }

    static fromJS(data: any): GetDataSendEmailSPDto {
        let result = new GetDataSendEmailSPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overDue"] = this.overDue;
        data["reminderLetterID"] = this.reminderLetterID;
        data["psCode"] = this.psCode;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["projectID"] = this.projectID;
        data["unitNo"] = this.unitNo;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitID"] = this.unitID;
        data["templateHtml"] = this.templateHtml;
        data["letterType"] = this.letterType;
        data["letterNo"] = this.letterNo;
        data["letterDate"] = this.letterDate ? this.letterDate.toISOString() : <any>undefined;
        data["penAmt"] = this.penAmt;
        data["totalPen"] = this.totalPen;
        data["sadOfficer1"] = this.sadOfficer1;
        data["sadOfficer2"] = this.sadOfficer2;
        data["sadPosition1"] = this.sadPosition1;
        data["sadPosition2"] = this.sadPosition2;
        data["coCode"] = this.coCode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["areaID"] = this.areaID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["sadManagerID"] = this.sadManagerID;
        data["bookCode"] = this.bookCode;
        data["totAmt"] = this.totAmt;
        data["outAmt"] = this.outAmt;
        data["schedNo"] = this.schedNo;
        data["productName"] = this.productName;
        data["clusterName"] = this.clusterName;
        data["clusterID"] = this.clusterID;
        data["bankName"] = this.bankName;
        data["accNo"] = this.accNo;
        data["accName"] = this.accName;
        data["picClusterName"] = this.picClusterName;
        data["picEmail"] = this.picEmail;
        data["handphoneNo"] = this.handphoneNo;
        data["officePhoneNo"] = this.officePhoneNo;
        return data; 
    }
}

export interface IGetDataSendEmailSPDto {
    overDue: number;
    reminderLetterID: number;
    psCode: string;
    projectCode: string;
    projectName: string;
    projectID: number;
    unitNo: string;
    unitCode: string;
    unitName: string;
    unitID: number;
    templateHtml: string;
    letterType: string;
    letterNo: string;
    letterDate: moment.Moment;
    penAmt: number;
    totalPen: number;
    sadOfficer1: string;
    sadOfficer2: string;
    sadPosition1: string;
    sadPosition2: string;
    coCode: string;
    dueDate: moment.Moment;
    areaID: number;
    bookingHeaderID: number;
    sadManagerID: number;
    bookCode: string;
    totAmt: number;
    outAmt: number;
    schedNo: number;
    productName: string;
    clusterName: string;
    clusterID: number;
    bankName: string;
    accNo: string;
    accName: string;
    picClusterName: string;
    picEmail: string;
    handphoneNo: string;
    officePhoneNo: string;
}

export class GetDataForReportSP implements IGetDataForReportSP {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportSPListHtml[];

    constructor(data?: IGetDataForReportSP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.tanggalHariIni = data["tanggalHariIni"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(GetReportSPListHtml.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataForReportSP {
        let result = new GetDataForReportSP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["tanggalHariIni"] = this.tanggalHariIni;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataForReportSP {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportSPListHtml[];
}

export class GetReportSPListHtml implements IGetReportSPListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    custName: string;
    tipeSP: string;
    tipeSPName: string;
    letterNo: string;
    overdue: string;
    penalty: string;
    preview: string;
    status: number;

    constructor(data?: IGetReportSPListHtml) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.custName = data["custName"];
            this.tipeSP = data["tipeSP"];
            this.tipeSPName = data["tipeSPName"];
            this.letterNo = data["letterNo"];
            this.overdue = data["overdue"];
            this.penalty = data["penalty"];
            this.preview = data["preview"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetReportSPListHtml {
        let result = new GetReportSPListHtml();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["custName"] = this.custName;
        data["tipeSP"] = this.tipeSP;
        data["tipeSPName"] = this.tipeSPName;
        data["letterNo"] = this.letterNo;
        data["overdue"] = this.overdue;
        data["penalty"] = this.penalty;
        data["preview"] = this.preview;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetReportSPListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    custName: string;
    tipeSP: string;
    tipeSPName: string;
    letterNo: string;
    overdue: string;
    penalty: string;
    preview: string;
    status: number;
}

export class TiketPPOnline implements ITiketPPOnline {
    customerName: string;
    email: string;
    ppno: string;
    barcode: string;
    projectID: number;
    attachmentPP: string;

    constructor(data?: ITiketPPOnline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.email = data["email"];
            this.ppno = data["ppno"];
            this.barcode = data["barcode"];
            this.projectID = data["projectID"];
            this.attachmentPP = data["attachmentPP"];
        }
    }

    static fromJS(data: any): TiketPPOnline {
        let result = new TiketPPOnline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["ppno"] = this.ppno;
        data["barcode"] = this.barcode;
        data["projectID"] = this.projectID;
        data["attachmentPP"] = this.attachmentPP;
        return data; 
    }
}

export interface ITiketPPOnline {
    customerName: string;
    email: string;
    ppno: string;
    barcode: string;
    projectID: number;
    attachmentPP: string;
}

export class WhatsAppSendResultDto implements IWhatsAppSendResultDto {
    total: number;
    sended: number;
    notSended: number;
    hold: number;
    holdList: string[];
    notSendedList: string[];
    sendedList: string[];

    constructor(data?: IWhatsAppSendResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.total = data["total"];
            this.sended = data["sended"];
            this.notSended = data["notSended"];
            this.hold = data["hold"];
            if (data["holdList"] && data["holdList"].constructor === Array) {
                this.holdList = [];
                for (let item of data["holdList"])
                    this.holdList.push(item);
            }
            if (data["notSendedList"] && data["notSendedList"].constructor === Array) {
                this.notSendedList = [];
                for (let item of data["notSendedList"])
                    this.notSendedList.push(item);
            }
            if (data["sendedList"] && data["sendedList"].constructor === Array) {
                this.sendedList = [];
                for (let item of data["sendedList"])
                    this.sendedList.push(item);
            }
        }
    }

    static fromJS(data: any): WhatsAppSendResultDto {
        let result = new WhatsAppSendResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["sended"] = this.sended;
        data["notSended"] = this.notSended;
        data["hold"] = this.hold;
        if (this.holdList && this.holdList.constructor === Array) {
            data["holdList"] = [];
            for (let item of this.holdList)
                data["holdList"].push(item);
        }
        if (this.notSendedList && this.notSendedList.constructor === Array) {
            data["notSendedList"] = [];
            for (let item of this.notSendedList)
                data["notSendedList"].push(item);
        }
        if (this.sendedList && this.sendedList.constructor === Array) {
            data["sendedList"] = [];
            for (let item of this.sendedList)
                data["sendedList"].push(item);
        }
        return data; 
    }
}

export interface IWhatsAppSendResultDto {
    total: number;
    sended: number;
    notSended: number;
    hold: number;
    holdList: string[];
    notSendedList: string[];
    sendedList: string[];
}

export class WhatsAppInputDto implements IWhatsAppInputDto {
    waNo: string;
    content: string;

    constructor(data?: IWhatsAppInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.waNo = data["waNo"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): WhatsAppInputDto {
        let result = new WhatsAppInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waNo"] = this.waNo;
        data["content"] = this.content;
        return data; 
    }
}

export interface IWhatsAppInputDto {
    waNo: string;
    content: string;
}

export class RootResponseWoowa implements IRootResponseWoowa {
    code: number;
    query: QueryResponseWoowa;
    results: ResultsResponseWoowa;

    constructor(data?: IRootResponseWoowa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.query = data["query"] ? QueryResponseWoowa.fromJS(data["query"]) : <any>undefined;
            this.results = data["results"] ? ResultsResponseWoowa.fromJS(data["results"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RootResponseWoowa {
        let result = new RootResponseWoowa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IRootResponseWoowa {
    code: number;
    query: QueryResponseWoowa;
    results: ResultsResponseWoowa;
}

export class QueryResponseWoowa implements IQueryResponseWoowa {
    myto: string;
    message: string;

    constructor(data?: IQueryResponseWoowa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.myto = data["myto"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): QueryResponseWoowa {
        let result = new QueryResponseWoowa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myto"] = this.myto;
        data["message"] = this.message;
        return data; 
    }
}

export interface IQueryResponseWoowa {
    myto: string;
    message: string;
}

export class ResultsResponseWoowa implements IResultsResponseWoowa {
    id_message: string;
    serialized: string;
    type_chat: string;
    message: string;

    constructor(data?: IResultsResponseWoowa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id_message = data["id_message"];
            this.serialized = data["serialized"];
            this.type_chat = data["type_chat"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ResultsResponseWoowa {
        let result = new ResultsResponseWoowa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id_message"] = this.id_message;
        data["serialized"] = this.serialized;
        data["type_chat"] = this.type_chat;
        data["message"] = this.message;
        return data; 
    }
}

export interface IResultsResponseWoowa {
    id_message: string;
    serialized: string;
    type_chat: string;
    message: string;
}

export class GetDataForReportRP implements IGetDataForReportRP {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportRPListHtml[];

    constructor(data?: IGetDataForReportRP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.tanggalHariIni = data["tanggalHariIni"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(GetReportRPListHtml.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataForReportRP {
        let result = new GetDataForReportRP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["tanggalHariIni"] = this.tanggalHariIni;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataForReportRP {
    projectID: number;
    tanggalHariIni: string;
    listData: GetReportRPListHtml[];
}

export class GetReportRPListHtml implements IGetReportRPListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    custName: string;
    tipeRP: string;
    tipeRPName: string;
    outstanding: string;
    penalty: string;
    totalOutstanding: string;
    dueDate: string;
    status: number;

    constructor(data?: IGetReportRPListHtml) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.custName = data["custName"];
            this.tipeRP = data["tipeRP"];
            this.tipeRPName = data["tipeRPName"];
            this.outstanding = data["outstanding"];
            this.penalty = data["penalty"];
            this.totalOutstanding = data["totalOutstanding"];
            this.dueDate = data["dueDate"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetReportRPListHtml {
        let result = new GetReportRPListHtml();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["custName"] = this.custName;
        data["tipeRP"] = this.tipeRP;
        data["tipeRPName"] = this.tipeRPName;
        data["outstanding"] = this.outstanding;
        data["penalty"] = this.penalty;
        data["totalOutstanding"] = this.totalOutstanding;
        data["dueDate"] = this.dueDate;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetReportRPListHtml {
    bookCode: string;
    unitCode: string;
    unitNo: string;
    custName: string;
    tipeRP: string;
    tipeRPName: string;
    outstanding: string;
    penalty: string;
    totalOutstanding: string;
    dueDate: string;
    status: number;
}

export class InputParamBalstBAST implements IInputParamBalstBAST {
    projectID: number;
    signedDocumentDate: moment.Moment;

    constructor(data?: IInputParamBalstBAST) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.signedDocumentDate = data["signedDocumentDate"] ? moment(data["signedDocumentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InputParamBalstBAST {
        let result = new InputParamBalstBAST();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["signedDocumentDate"] = this.signedDocumentDate ? this.signedDocumentDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IInputParamBalstBAST {
    projectID: number;
    signedDocumentDate: moment.Moment;
}

export class GetPSASTermDto implements IGetPSASTermDto {
    termCode: string;
    termNo: number;
    remarksTerm: string;
    ppjbDue: number;
    dpCalcType: string;
    finType: string;
    finStatrtDue: number;
    bankName: string;
    unitID: number;
    termID: number;

    constructor(data?: IGetPSASTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termCode = data["termCode"];
            this.termNo = data["termNo"];
            this.remarksTerm = data["remarksTerm"];
            this.ppjbDue = data["ppjbDue"];
            this.dpCalcType = data["dpCalcType"];
            this.finType = data["finType"];
            this.finStatrtDue = data["finStatrtDue"];
            this.bankName = data["bankName"];
            this.unitID = data["unitID"];
            this.termID = data["termID"];
        }
    }

    static fromJS(data: any): GetPSASTermDto {
        let result = new GetPSASTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["termNo"] = this.termNo;
        data["remarksTerm"] = this.remarksTerm;
        data["ppjbDue"] = this.ppjbDue;
        data["dpCalcType"] = this.dpCalcType;
        data["finType"] = this.finType;
        data["finStatrtDue"] = this.finStatrtDue;
        data["bankName"] = this.bankName;
        data["unitID"] = this.unitID;
        data["termID"] = this.termID;
        return data; 
    }
}

export interface IGetPSASTermDto {
    termCode: string;
    termNo: number;
    remarksTerm: string;
    ppjbDue: number;
    dpCalcType: string;
    finType: string;
    finStatrtDue: number;
    bankName: string;
    unitID: number;
    termID: number;
}

export class ListResultDtoOfGetBankCodeDropDownListDto implements IListResultDtoOfGetBankCodeDropDownListDto {
    items: GetBankCodeDropDownListDto[];

    constructor(data?: IListResultDtoOfGetBankCodeDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBankCodeDropDownListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetBankCodeDropDownListDto {
        let result = new ListResultDtoOfGetBankCodeDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetBankCodeDropDownListDto {
    items: GetBankCodeDropDownListDto[];
}

export class GetBankCodeDropDownListDto implements IGetBankCodeDropDownListDto {
    bankCode: string;
    bankName: string;

    constructor(data?: IGetBankCodeDropDownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetBankCodeDropDownListDto {
        let result = new GetBankCodeDropDownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetBankCodeDropDownListDto {
    bankCode: string;
    bankName: string;
}

export class GetMsTermByTermCodeDto implements IGetMsTermByTermCodeDto {
    termID: number;
    termNo: number;
    remarks: string;

    constructor(data?: IGetMsTermByTermCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termNo = data["termNo"];
            this.remarks = data["remarks"];
        }
    }

    static fromJS(data: any): GetMsTermByTermCodeDto {
        let result = new GetMsTermByTermCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termNo"] = this.termNo;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IGetMsTermByTermCodeDto {
    termID: number;
    termNo: number;
    remarks: string;
}

export class GetTermPmtByTermIdDto implements IGetTermPmtByTermIdDto {
    finType: string;
    finStatrtDue: number;
    showBank: boolean;

    constructor(data?: IGetTermPmtByTermIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.finType = data["finType"];
            this.finStatrtDue = data["finStatrtDue"];
            this.showBank = data["showBank"];
        }
    }

    static fromJS(data: any): GetTermPmtByTermIdDto {
        let result = new GetTermPmtByTermIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finType"] = this.finType;
        data["finStatrtDue"] = this.finStatrtDue;
        data["showBank"] = this.showBank;
        return data; 
    }
}

export interface IGetTermPmtByTermIdDto {
    finType: string;
    finStatrtDue: number;
    showBank: boolean;
}

export class Step19InsertSlikCheckingInputDto implements IStep19InsertSlikCheckingInputDto {
    bookCode: string;
    bankID1: number;
    bankID2: number;
    psCode: string;
    userID: number;

    constructor(data?: IStep19InsertSlikCheckingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.psCode = data["psCode"];
            this.userID = data["userID"];
        }
    }

    static fromJS(data: any): Step19InsertSlikCheckingInputDto {
        let result = new Step19InsertSlikCheckingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["psCode"] = this.psCode;
        data["userID"] = this.userID;
        return data; 
    }
}

export interface IStep19InsertSlikCheckingInputDto {
    bookCode: string;
    bankID1: number;
    bankID2: number;
    psCode: string;
    userID: number;
}

export class GetDetailPPNoResultDto implements IGetDetailPPNoResultDto {
    customerName: string;
    customerCode: string;
    scmCode: string;
    memberCode: string;
    memberName: string;
    ppNo: string;
    namaBank: string;
    noRek: string;
    namaRek: string;
    refundReason: string;
    ppStatus: string;
    ppNoID: number;
    ppPrice: number;
    unitInfo: UnitInfoDto;

    constructor(data?: IGetDetailPPNoResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.customerCode = data["customerCode"];
            this.scmCode = data["scmCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.ppNo = data["ppNo"];
            this.namaBank = data["namaBank"];
            this.noRek = data["noRek"];
            this.namaRek = data["namaRek"];
            this.refundReason = data["refundReason"];
            this.ppStatus = data["ppStatus"];
            this.ppNoID = data["ppNoID"];
            this.ppPrice = data["ppPrice"];
            this.unitInfo = data["unitInfo"] ? UnitInfoDto.fromJS(data["unitInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailPPNoResultDto {
        let result = new GetDetailPPNoResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["scmCode"] = this.scmCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["ppNo"] = this.ppNo;
        data["namaBank"] = this.namaBank;
        data["noRek"] = this.noRek;
        data["namaRek"] = this.namaRek;
        data["refundReason"] = this.refundReason;
        data["ppStatus"] = this.ppStatus;
        data["ppNoID"] = this.ppNoID;
        data["ppPrice"] = this.ppPrice;
        data["unitInfo"] = this.unitInfo ? this.unitInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDetailPPNoResultDto {
    customerName: string;
    customerCode: string;
    scmCode: string;
    memberCode: string;
    memberName: string;
    ppNo: string;
    namaBank: string;
    noRek: string;
    namaRek: string;
    refundReason: string;
    ppStatus: string;
    ppNoID: number;
    ppPrice: number;
    unitInfo: UnitInfoDto;
}

export class UnitInfoDto implements IUnitInfoDto {
    unitCode: string;
    unitNo: string;
    cancelDate: moment.Moment;
    bookDate: moment.Moment;

    constructor(data?: IUnitInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnitInfoDto {
        let result = new UnitInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUnitInfoDto {
    unitCode: string;
    unitNo: string;
    cancelDate: moment.Moment;
    bookDate: moment.Moment;
}

export class GetListRefundReasonResultDto implements IGetListRefundReasonResultDto {
    refundReasonID: number;
    refundReasonName: string;

    constructor(data?: IGetListRefundReasonResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.refundReasonID = data["refundReasonID"];
            this.refundReasonName = data["refundReasonName"];
        }
    }

    static fromJS(data: any): GetListRefundReasonResultDto {
        let result = new GetListRefundReasonResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refundReasonID"] = this.refundReasonID;
        data["refundReasonName"] = this.refundReasonName;
        return data; 
    }
}

export interface IGetListRefundReasonResultDto {
    refundReasonID: number;
    refundReasonName: string;
}

export class CreateRefundPPInputDto implements ICreateRefundPPInputDto {
    ppNoID: number;
    refundReasonID: number;
    namaBank: string;
    noRek: string;
    namaRek: string;
    refundReason: string;
    customerName: string;
    customerCode: string;
    memberName: string;

    constructor(data?: ICreateRefundPPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNoID = data["ppNoID"];
            this.refundReasonID = data["refundReasonID"];
            this.namaBank = data["namaBank"];
            this.noRek = data["noRek"];
            this.namaRek = data["namaRek"];
            this.refundReason = data["refundReason"];
            this.customerName = data["customerName"];
            this.customerCode = data["customerCode"];
            this.memberName = data["memberName"];
        }
    }

    static fromJS(data: any): CreateRefundPPInputDto {
        let result = new CreateRefundPPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNoID"] = this.ppNoID;
        data["refundReasonID"] = this.refundReasonID;
        data["namaBank"] = this.namaBank;
        data["noRek"] = this.noRek;
        data["namaRek"] = this.namaRek;
        data["refundReason"] = this.refundReason;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["memberName"] = this.memberName;
        return data; 
    }
}

export interface ICreateRefundPPInputDto {
    ppNoID: number;
    refundReasonID: number;
    namaBank: string;
    noRek: string;
    namaRek: string;
    refundReason: string;
    customerName: string;
    customerCode: string;
    memberName: string;
}

export class GeneratePreviewRefundInputDto implements IGeneratePreviewRefundInputDto {
    noForm: string;
    tanggal: string;
    customerName: string;
    customerCode: string;
    ppNumber: string;
    tglCetak: string;
    refundReason: string;
    tglTransfer: string;
    bankName: string;
    noRek: string;
    rekName: string;
    paymentType: string;
    projectName: string;
    memberName: string;

    constructor(data?: IGeneratePreviewRefundInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noForm = data["noForm"];
            this.tanggal = data["tanggal"];
            this.customerName = data["customerName"];
            this.customerCode = data["customerCode"];
            this.ppNumber = data["ppNumber"];
            this.tglCetak = data["tglCetak"];
            this.refundReason = data["refundReason"];
            this.tglTransfer = data["tglTransfer"];
            this.bankName = data["bankName"];
            this.noRek = data["noRek"];
            this.rekName = data["rekName"];
            this.paymentType = data["paymentType"];
            this.projectName = data["projectName"];
            this.memberName = data["memberName"];
        }
    }

    static fromJS(data: any): GeneratePreviewRefundInputDto {
        let result = new GeneratePreviewRefundInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noForm"] = this.noForm;
        data["tanggal"] = this.tanggal;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["ppNumber"] = this.ppNumber;
        data["tglCetak"] = this.tglCetak;
        data["refundReason"] = this.refundReason;
        data["tglTransfer"] = this.tglTransfer;
        data["bankName"] = this.bankName;
        data["noRek"] = this.noRek;
        data["rekName"] = this.rekName;
        data["paymentType"] = this.paymentType;
        data["projectName"] = this.projectName;
        data["memberName"] = this.memberName;
        return data; 
    }
}

export interface IGeneratePreviewRefundInputDto {
    noForm: string;
    tanggal: string;
    customerName: string;
    customerCode: string;
    ppNumber: string;
    tglCetak: string;
    refundReason: string;
    tglTransfer: string;
    bankName: string;
    noRek: string;
    rekName: string;
    paymentType: string;
    projectName: string;
    memberName: string;
}

export class GetListRefundHistoryResultDto implements IGetListRefundHistoryResultDto {
    ppNumber: string;
    clientCode: string;
    memberName: string;
    salesChannel: string;
    refundReason: string;
    ppRefundID: number;

    constructor(data?: IGetListRefundHistoryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppNumber = data["ppNumber"];
            this.clientCode = data["clientCode"];
            this.memberName = data["memberName"];
            this.salesChannel = data["salesChannel"];
            this.refundReason = data["refundReason"];
            this.ppRefundID = data["ppRefundID"];
        }
    }

    static fromJS(data: any): GetListRefundHistoryResultDto {
        let result = new GetListRefundHistoryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppNumber"] = this.ppNumber;
        data["clientCode"] = this.clientCode;
        data["memberName"] = this.memberName;
        data["salesChannel"] = this.salesChannel;
        data["refundReason"] = this.refundReason;
        data["ppRefundID"] = this.ppRefundID;
        return data; 
    }
}

export interface IGetListRefundHistoryResultDto {
    ppNumber: string;
    clientCode: string;
    memberName: string;
    salesChannel: string;
    refundReason: string;
    ppRefundID: number;
}

export class ReportRefundResultDto implements IReportRefundResultDto {
    refundDate: moment.Moment;
    ppNo: string;
    schema: string;
    customerCode: string;
    customerName: string;
    dealCloserCode: string;
    dealCloserName: string;
    ppPrice: number;
    bankName: string;
    accountNo: string;
    accountName: string;
    reason: string;
    userID: number;

    constructor(data?: IReportRefundResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.refundDate = data["refundDate"] ? moment(data["refundDate"].toString()) : <any>undefined;
            this.ppNo = data["ppNo"];
            this.schema = data["schema"];
            this.customerCode = data["customerCode"];
            this.customerName = data["customerName"];
            this.dealCloserCode = data["dealCloserCode"];
            this.dealCloserName = data["dealCloserName"];
            this.ppPrice = data["ppPrice"];
            this.bankName = data["bankName"];
            this.accountNo = data["accountNo"];
            this.accountName = data["accountName"];
            this.reason = data["reason"];
            this.userID = data["userID"];
        }
    }

    static fromJS(data: any): ReportRefundResultDto {
        let result = new ReportRefundResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refundDate"] = this.refundDate ? this.refundDate.toISOString() : <any>undefined;
        data["ppNo"] = this.ppNo;
        data["schema"] = this.schema;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["dealCloserCode"] = this.dealCloserCode;
        data["dealCloserName"] = this.dealCloserName;
        data["ppPrice"] = this.ppPrice;
        data["bankName"] = this.bankName;
        data["accountNo"] = this.accountNo;
        data["accountName"] = this.accountName;
        data["reason"] = this.reason;
        data["userID"] = this.userID;
        return data; 
    }
}

export interface IReportRefundResultDto {
    refundDate: moment.Moment;
    ppNo: string;
    schema: string;
    customerCode: string;
    customerName: string;
    dealCloserCode: string;
    dealCloserName: string;
    ppPrice: number;
    bankName: string;
    accountNo: string;
    accountName: string;
    reason: string;
    userID: number;
}

export class GetReportRefundPdfInputDto implements IGetReportRefundPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataRefundDto;

    constructor(data?: IGetReportRefundPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataRefundDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReportRefundPdfInputDto {
        let result = new GetReportRefundPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetReportRefundPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataRefundDto;
}

export class ListDataRefundDto implements IListDataRefundDto {
    listHeader: ListHeaderRefundDto[];
    listBody: ListBodyRefundDto[];
    headerHtml: string;
    bodyHtml: string;

    constructor(data?: IListDataRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(ListHeaderRefundDto.fromJS(item));
            }
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(ListBodyRefundDto.fromJS(item));
            }
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
        }
    }

    static fromJS(data: any): ListDataRefundDto {
        let result = new ListDataRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        return data; 
    }
}

export interface IListDataRefundDto {
    listHeader: ListHeaderRefundDto[];
    listBody: ListBodyRefundDto[];
    headerHtml: string;
    bodyHtml: string;
}

export class ListHeaderRefundDto implements IListHeaderRefundDto {
    headerID: number;
    header: string;

    constructor(data?: IListHeaderRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerID = data["headerID"];
            this.header = data["header"];
        }
    }

    static fromJS(data: any): ListHeaderRefundDto {
        let result = new ListHeaderRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["header"] = this.header;
        return data; 
    }
}

export interface IListHeaderRefundDto {
    headerID: number;
    header: string;
}

export class ListBodyRefundDto implements IListBodyRefundDto {
    refundDate: moment.Moment;
    ppNo: string;
    schema: string;
    customerCode: string;
    customerName: string;
    dealCloserCode: string;
    dealCloserName: string;
    ppPrice: number;
    bankName: string;
    accountNo: string;
    accountName: string;
    reason: string;

    constructor(data?: IListBodyRefundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.refundDate = data["refundDate"] ? moment(data["refundDate"].toString()) : <any>undefined;
            this.ppNo = data["ppNo"];
            this.schema = data["schema"];
            this.customerCode = data["customerCode"];
            this.customerName = data["customerName"];
            this.dealCloserCode = data["dealCloserCode"];
            this.dealCloserName = data["dealCloserName"];
            this.ppPrice = data["ppPrice"];
            this.bankName = data["bankName"];
            this.accountNo = data["accountNo"];
            this.accountName = data["accountName"];
            this.reason = data["reason"];
        }
    }

    static fromJS(data: any): ListBodyRefundDto {
        let result = new ListBodyRefundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refundDate"] = this.refundDate ? this.refundDate.toISOString() : <any>undefined;
        data["ppNo"] = this.ppNo;
        data["schema"] = this.schema;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["dealCloserCode"] = this.dealCloserCode;
        data["dealCloserName"] = this.dealCloserName;
        data["ppPrice"] = this.ppPrice;
        data["bankName"] = this.bankName;
        data["accountNo"] = this.accountNo;
        data["accountName"] = this.accountName;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface IListBodyRefundDto {
    refundDate: moment.Moment;
    ppNo: string;
    schema: string;
    customerCode: string;
    customerName: string;
    dealCloserCode: string;
    dealCloserName: string;
    ppPrice: number;
    bankName: string;
    accountNo: string;
    accountName: string;
    reason: string;
}

export class GenerateKPResultDto implements IGenerateKPResultDto {
    unitCode: string;
    unitNo: string;
    pathKP: string;
    psName: string;
    bookDate: string;
    memberName: string;
    memberPhone: string;
    psEmail: string;
    psCode: string;
    subjectEmail: string;
    sender: string;
    memberCode: string;

    constructor(data?: IGenerateKPResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.pathKP = data["pathKP"];
            this.psName = data["psName"];
            this.bookDate = data["bookDate"];
            this.memberName = data["memberName"];
            this.memberPhone = data["memberPhone"];
            this.psEmail = data["psEmail"];
            this.psCode = data["psCode"];
            this.subjectEmail = data["subjectEmail"];
            this.sender = data["sender"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): GenerateKPResultDto {
        let result = new GenerateKPResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["pathKP"] = this.pathKP;
        data["psName"] = this.psName;
        data["bookDate"] = this.bookDate;
        data["memberName"] = this.memberName;
        data["memberPhone"] = this.memberPhone;
        data["psEmail"] = this.psEmail;
        data["psCode"] = this.psCode;
        data["subjectEmail"] = this.subjectEmail;
        data["sender"] = this.sender;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IGenerateKPResultDto {
    unitCode: string;
    unitNo: string;
    pathKP: string;
    psName: string;
    bookDate: string;
    memberName: string;
    memberPhone: string;
    psEmail: string;
    psCode: string;
    subjectEmail: string;
    sender: string;
    memberCode: string;
}

export class GetBookingReportInputDto implements IGetBookingReportInputDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    boockode: string;
    projectList: number[];

    constructor(data?: IGetBookingReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.boockode = data["boockode"];
            if (data["projectList"] && data["projectList"].constructor === Array) {
                this.projectList = [];
                for (let item of data["projectList"])
                    this.projectList.push(item);
            }
        }
    }

    static fromJS(data: any): GetBookingReportInputDto {
        let result = new GetBookingReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["boockode"] = this.boockode;
        if (this.projectList && this.projectList.constructor === Array) {
            data["projectList"] = [];
            for (let item of this.projectList)
                data["projectList"].push(item);
        }
        return data; 
    }
}

export interface IGetBookingReportInputDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    boockode: string;
    projectList: number[];
}

export class GetListReportBookingDto implements IGetListReportBookingDto {
    bookCode: string;
    bookDate: moment.Moment;
    projectID: number;
    cancelDate: moment.Moment;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    categoryCode: string;
    categoryName: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    productCode: string;
    productName: string;
    detailCode: string;
    detailName: string;
    renovationCode: string;
    renovationName: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    upline1MemberCode: string;
    upline1MemberName: string;
    upline2MemberCode: string;
    upline2MemberName: string;
    landArea: number;
    buildArea: number;
    finTypeCode: string;
    termRemarks: string;
    adjLandArea: number;
    adjBuildArea: number;
    facadeCode: string;
    facadeName: string;
    bfAmount: number;
    grossPrice: number;
    pctDisc: number;
    pctAddDisc: number;
    netNetPrice: number;
    netPrice: number;
    netOutStanding: number;
    vatOutStanding: number;
    totalOutStanding: number;
    netAmount: number;
    vatAmount: number;
    totalSchedule: number;
    adjnetAmt: number;
    amountMKT: number;
    netPriceMKT: number;
    amountComm: number;
    lostAmount: number;
    refundAmount: number;
    payNetAmt: number;
    payVatAmt: number;
    payTotalPayment: number;
    penaltyOutstanding: number;
    penaltyPayment: number;
    psCode: string;
    name: string;
    idAddress: string;
    idCity: string;
    idPostCode: string;
    idNo: string;
    corressAddress: string;
    corressCity: string;
    corressPostCode: string;
    sex: string;
    birthDate: string;
    birthPlace: string;
    npwp: string;
    bankName: string;
    sumebrDanaName: string;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    tujuanTransaksiName: string;
    occupationDesc: string;
    ppjbNo: string;
    ppjbDate: string;
    srfNo: string;
    stfDate: string;
    stpNo: string;
    stpDate: string;
    kpuNo: string;
    kpuDate: string;
    pppuNo: string;
    pppuDate: string;
    stppNo: string;
    stppDate: string;
    stfdNo: string;
    stfdDate: string;
    ajbNo: string;
    ajbDate: string;
    disc: number;
    addDisc: number;
    bookingHeaderID: number;

    constructor(data?: IGetListReportBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.projectID = data["projectID"];
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.unitNo = data["unitNo"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.renovationCode = data["renovationCode"];
            this.renovationName = data["renovationName"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.upline1MemberCode = data["upline1MemberCode"];
            this.upline1MemberName = data["upline1MemberName"];
            this.upline2MemberCode = data["upline2MemberCode"];
            this.upline2MemberName = data["upline2MemberName"];
            this.landArea = data["landArea"];
            this.buildArea = data["buildArea"];
            this.finTypeCode = data["finTypeCode"];
            this.termRemarks = data["termRemarks"];
            this.adjLandArea = data["adjLandArea"];
            this.adjBuildArea = data["adjBuildArea"];
            this.facadeCode = data["facadeCode"];
            this.facadeName = data["facadeName"];
            this.bfAmount = data["bfAmount"];
            this.grossPrice = data["grossPrice"];
            this.pctDisc = data["pctDisc"];
            this.pctAddDisc = data["pctAddDisc"];
            this.netNetPrice = data["netNetPrice"];
            this.netPrice = data["netPrice"];
            this.netOutStanding = data["netOutStanding"];
            this.vatOutStanding = data["vatOutStanding"];
            this.totalOutStanding = data["totalOutStanding"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.totalSchedule = data["totalSchedule"];
            this.adjnetAmt = data["adjnetAmt"];
            this.amountMKT = data["amountMKT"];
            this.netPriceMKT = data["netPriceMKT"];
            this.amountComm = data["amountComm"];
            this.lostAmount = data["lostAmount"];
            this.refundAmount = data["refundAmount"];
            this.payNetAmt = data["payNetAmt"];
            this.payVatAmt = data["payVatAmt"];
            this.payTotalPayment = data["payTotalPayment"];
            this.penaltyOutstanding = data["penaltyOutstanding"];
            this.penaltyPayment = data["penaltyPayment"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.idAddress = data["idAddress"];
            this.idCity = data["idCity"];
            this.idPostCode = data["idPostCode"];
            this.idNo = data["idNo"];
            this.corressAddress = data["corressAddress"];
            this.corressCity = data["corressCity"];
            this.corressPostCode = data["corressPostCode"];
            this.sex = data["sex"];
            this.birthDate = data["birthDate"];
            this.birthPlace = data["birthPlace"];
            this.npwp = data["npwp"];
            this.bankName = data["bankName"];
            this.sumebrDanaName = data["sumebrDanaName"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.tujuanTransaksiName = data["tujuanTransaksiName"];
            this.occupationDesc = data["occupationDesc"];
            this.ppjbNo = data["ppjbNo"];
            this.ppjbDate = data["ppjbDate"];
            this.srfNo = data["srfNo"];
            this.stfDate = data["stfDate"];
            this.stpNo = data["stpNo"];
            this.stpDate = data["stpDate"];
            this.kpuNo = data["kpuNo"];
            this.kpuDate = data["kpuDate"];
            this.pppuNo = data["pppuNo"];
            this.pppuDate = data["pppuDate"];
            this.stppNo = data["stppNo"];
            this.stppDate = data["stppDate"];
            this.stfdNo = data["stfdNo"];
            this.stfdDate = data["stfdDate"];
            this.ajbNo = data["ajbNo"];
            this.ajbDate = data["ajbDate"];
            this.disc = data["disc"];
            this.addDisc = data["addDisc"];
            this.bookingHeaderID = data["bookingHeaderID"];
        }
    }

    static fromJS(data: any): GetListReportBookingDto {
        let result = new GetListReportBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["projectID"] = this.projectID;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["unitNo"] = this.unitNo;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["renovationCode"] = this.renovationCode;
        data["renovationName"] = this.renovationName;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["upline1MemberCode"] = this.upline1MemberCode;
        data["upline1MemberName"] = this.upline1MemberName;
        data["upline2MemberCode"] = this.upline2MemberCode;
        data["upline2MemberName"] = this.upline2MemberName;
        data["landArea"] = this.landArea;
        data["buildArea"] = this.buildArea;
        data["finTypeCode"] = this.finTypeCode;
        data["termRemarks"] = this.termRemarks;
        data["adjLandArea"] = this.adjLandArea;
        data["adjBuildArea"] = this.adjBuildArea;
        data["facadeCode"] = this.facadeCode;
        data["facadeName"] = this.facadeName;
        data["bfAmount"] = this.bfAmount;
        data["grossPrice"] = this.grossPrice;
        data["pctDisc"] = this.pctDisc;
        data["pctAddDisc"] = this.pctAddDisc;
        data["netNetPrice"] = this.netNetPrice;
        data["netPrice"] = this.netPrice;
        data["netOutStanding"] = this.netOutStanding;
        data["vatOutStanding"] = this.vatOutStanding;
        data["totalOutStanding"] = this.totalOutStanding;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalSchedule"] = this.totalSchedule;
        data["adjnetAmt"] = this.adjnetAmt;
        data["amountMKT"] = this.amountMKT;
        data["netPriceMKT"] = this.netPriceMKT;
        data["amountComm"] = this.amountComm;
        data["lostAmount"] = this.lostAmount;
        data["refundAmount"] = this.refundAmount;
        data["payNetAmt"] = this.payNetAmt;
        data["payVatAmt"] = this.payVatAmt;
        data["payTotalPayment"] = this.payTotalPayment;
        data["penaltyOutstanding"] = this.penaltyOutstanding;
        data["penaltyPayment"] = this.penaltyPayment;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["idAddress"] = this.idAddress;
        data["idCity"] = this.idCity;
        data["idPostCode"] = this.idPostCode;
        data["idNo"] = this.idNo;
        data["corressAddress"] = this.corressAddress;
        data["corressCity"] = this.corressCity;
        data["corressPostCode"] = this.corressPostCode;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate;
        data["birthPlace"] = this.birthPlace;
        data["npwp"] = this.npwp;
        data["bankName"] = this.bankName;
        data["sumebrDanaName"] = this.sumebrDanaName;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["tujuanTransaksiName"] = this.tujuanTransaksiName;
        data["occupationDesc"] = this.occupationDesc;
        data["ppjbNo"] = this.ppjbNo;
        data["ppjbDate"] = this.ppjbDate;
        data["srfNo"] = this.srfNo;
        data["stfDate"] = this.stfDate;
        data["stpNo"] = this.stpNo;
        data["stpDate"] = this.stpDate;
        data["kpuNo"] = this.kpuNo;
        data["kpuDate"] = this.kpuDate;
        data["pppuNo"] = this.pppuNo;
        data["pppuDate"] = this.pppuDate;
        data["stppNo"] = this.stppNo;
        data["stppDate"] = this.stppDate;
        data["stfdNo"] = this.stfdNo;
        data["stfdDate"] = this.stfdDate;
        data["ajbNo"] = this.ajbNo;
        data["ajbDate"] = this.ajbDate;
        data["disc"] = this.disc;
        data["addDisc"] = this.addDisc;
        data["bookingHeaderID"] = this.bookingHeaderID;
        return data; 
    }
}

export interface IGetListReportBookingDto {
    bookCode: string;
    bookDate: moment.Moment;
    projectID: number;
    cancelDate: moment.Moment;
    projectCode: string;
    projectName: string;
    clusterCode: string;
    clusterName: string;
    categoryCode: string;
    categoryName: string;
    unitCode: string;
    unitName: string;
    unitNo: string;
    productCode: string;
    productName: string;
    detailCode: string;
    detailName: string;
    renovationCode: string;
    renovationName: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    upline1MemberCode: string;
    upline1MemberName: string;
    upline2MemberCode: string;
    upline2MemberName: string;
    landArea: number;
    buildArea: number;
    finTypeCode: string;
    termRemarks: string;
    adjLandArea: number;
    adjBuildArea: number;
    facadeCode: string;
    facadeName: string;
    bfAmount: number;
    grossPrice: number;
    pctDisc: number;
    pctAddDisc: number;
    netNetPrice: number;
    netPrice: number;
    netOutStanding: number;
    vatOutStanding: number;
    totalOutStanding: number;
    netAmount: number;
    vatAmount: number;
    totalSchedule: number;
    adjnetAmt: number;
    amountMKT: number;
    netPriceMKT: number;
    amountComm: number;
    lostAmount: number;
    refundAmount: number;
    payNetAmt: number;
    payVatAmt: number;
    payTotalPayment: number;
    penaltyOutstanding: number;
    penaltyPayment: number;
    psCode: string;
    name: string;
    idAddress: string;
    idCity: string;
    idPostCode: string;
    idNo: string;
    corressAddress: string;
    corressCity: string;
    corressPostCode: string;
    sex: string;
    birthDate: string;
    birthPlace: string;
    npwp: string;
    bankName: string;
    sumebrDanaName: string;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    tujuanTransaksiName: string;
    occupationDesc: string;
    ppjbNo: string;
    ppjbDate: string;
    srfNo: string;
    stfDate: string;
    stpNo: string;
    stpDate: string;
    kpuNo: string;
    kpuDate: string;
    pppuNo: string;
    pppuDate: string;
    stppNo: string;
    stppDate: string;
    stfdNo: string;
    stfdDate: string;
    ajbNo: string;
    ajbDate: string;
    disc: number;
    addDisc: number;
    bookingHeaderID: number;
}

export class GetListHeaderDto implements IGetListHeaderDto {
    id: number;
    headerName: string;

    constructor(data?: IGetListHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.headerName = data["headerName"];
        }
    }

    static fromJS(data: any): GetListHeaderDto {
        let result = new GetListHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headerName"] = this.headerName;
        return data; 
    }
}

export interface IGetListHeaderDto {
    id: number;
    headerName: string;
}

export class GetBookingReportPdfInputDto implements IGetBookingReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataBookingReportDto;

    constructor(data?: IGetBookingReportPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paperSizeID = data["paperSizeID"];
            this.orientationID = data["orientationID"];
            this.listData = data["listData"] ? ListDataBookingReportDto.fromJS(data["listData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBookingReportPdfInputDto {
        let result = new GetBookingReportPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSizeID"] = this.paperSizeID;
        data["orientationID"] = this.orientationID;
        data["listData"] = this.listData ? this.listData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBookingReportPdfInputDto {
    paperSizeID: number;
    orientationID: number;
    listData: ListDataBookingReportDto;
}

export class ListDataBookingReportDto implements IListDataBookingReportDto {
    listHeader: GetListHeaderDto[];
    listProject: ListProjectDto[];
    bookingDateStart: string;
    bookingDateEnd: string;
    headerHtml: string;
    bodyHtml: string;
    dateHtml: string;
    projectNameHtml: string;
    printedByHtml: string;

    constructor(data?: IListDataBookingReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listHeader"] && data["listHeader"].constructor === Array) {
                this.listHeader = [];
                for (let item of data["listHeader"])
                    this.listHeader.push(GetListHeaderDto.fromJS(item));
            }
            if (data["listProject"] && data["listProject"].constructor === Array) {
                this.listProject = [];
                for (let item of data["listProject"])
                    this.listProject.push(ListProjectDto.fromJS(item));
            }
            this.bookingDateStart = data["bookingDateStart"];
            this.bookingDateEnd = data["bookingDateEnd"];
            this.headerHtml = data["headerHtml"];
            this.bodyHtml = data["bodyHtml"];
            this.dateHtml = data["dateHtml"];
            this.projectNameHtml = data["projectNameHtml"];
            this.printedByHtml = data["printedByHtml"];
        }
    }

    static fromJS(data: any): ListDataBookingReportDto {
        let result = new ListDataBookingReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listHeader && this.listHeader.constructor === Array) {
            data["listHeader"] = [];
            for (let item of this.listHeader)
                data["listHeader"].push(item.toJSON());
        }
        if (this.listProject && this.listProject.constructor === Array) {
            data["listProject"] = [];
            for (let item of this.listProject)
                data["listProject"].push(item.toJSON());
        }
        data["bookingDateStart"] = this.bookingDateStart;
        data["bookingDateEnd"] = this.bookingDateEnd;
        data["headerHtml"] = this.headerHtml;
        data["bodyHtml"] = this.bodyHtml;
        data["dateHtml"] = this.dateHtml;
        data["projectNameHtml"] = this.projectNameHtml;
        data["printedByHtml"] = this.printedByHtml;
        return data; 
    }
}

export interface IListDataBookingReportDto {
    listHeader: GetListHeaderDto[];
    listProject: ListProjectDto[];
    bookingDateStart: string;
    bookingDateEnd: string;
    headerHtml: string;
    bodyHtml: string;
    dateHtml: string;
    projectNameHtml: string;
    printedByHtml: string;
}

export class ListProjectDto implements IListProjectDto {
    projectName: string;
    projectCode: string;
    listUnitCode: ListUnitCodeDto[];

    constructor(data?: IListProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
            if (data["listUnitCode"] && data["listUnitCode"].constructor === Array) {
                this.listUnitCode = [];
                for (let item of data["listUnitCode"])
                    this.listUnitCode.push(ListUnitCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListProjectDto {
        let result = new ListProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        if (this.listUnitCode && this.listUnitCode.constructor === Array) {
            data["listUnitCode"] = [];
            for (let item of this.listUnitCode)
                data["listUnitCode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListProjectDto {
    projectName: string;
    projectCode: string;
    listUnitCode: ListUnitCodeDto[];
}

export class ListUnitCodeDto implements IListUnitCodeDto {
    unitCode: string;
    listBody: GetDataBookingInputDto[];

    constructor(data?: IListUnitCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            if (data["listBody"] && data["listBody"].constructor === Array) {
                this.listBody = [];
                for (let item of data["listBody"])
                    this.listBody.push(GetDataBookingInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListUnitCodeDto {
        let result = new ListUnitCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        if (this.listBody && this.listBody.constructor === Array) {
            data["listBody"] = [];
            for (let item of this.listBody)
                data["listBody"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListUnitCodeDto {
    unitCode: string;
    listBody: GetDataBookingInputDto[];
}

export class GetDataBookingInputDto implements IGetDataBookingInputDto {
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    psName: string;
    grossPrice: number;
    disc: number;
    netPrice: number;
    addDisc: number;
    netNetPrice: number;
    psCode: string;
    memberCode: string;
    memberName: string;
    detailCode: string;
    detailName: string;
    clusterCode: string;
    clusterName: string;
    productCode: string;
    productName: string;
    projectName: string;

    constructor(data?: IGetDataBookingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.cancelDate = data["cancelDate"] ? moment(data["cancelDate"].toString()) : <any>undefined;
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.psName = data["psName"];
            this.grossPrice = data["grossPrice"];
            this.disc = data["disc"];
            this.netPrice = data["netPrice"];
            this.addDisc = data["addDisc"];
            this.netNetPrice = data["netNetPrice"];
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.detailCode = data["detailCode"];
            this.detailName = data["detailName"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetDataBookingInputDto {
        let result = new GetDataBookingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : <any>undefined;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["psName"] = this.psName;
        data["grossPrice"] = this.grossPrice;
        data["disc"] = this.disc;
        data["netPrice"] = this.netPrice;
        data["addDisc"] = this.addDisc;
        data["netNetPrice"] = this.netNetPrice;
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["detailCode"] = this.detailCode;
        data["detailName"] = this.detailName;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetDataBookingInputDto {
    bookDate: moment.Moment;
    cancelDate: moment.Moment;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    psName: string;
    grossPrice: number;
    disc: number;
    netPrice: number;
    addDisc: number;
    netNetPrice: number;
    psCode: string;
    memberCode: string;
    memberName: string;
    detailCode: string;
    detailName: string;
    clusterCode: string;
    clusterName: string;
    productCode: string;
    productName: string;
    projectName: string;
}

export class ListResultDtoOfResponUrlGenevaDto implements IListResultDtoOfResponUrlGenevaDto {
    items: ResponUrlGenevaDto[];

    constructor(data?: IListResultDtoOfResponUrlGenevaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ResponUrlGenevaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfResponUrlGenevaDto {
        let result = new ListResultDtoOfResponUrlGenevaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfResponUrlGenevaDto {
    items: ResponUrlGenevaDto[];
}

export class ResponUrlGenevaDto implements IResponUrlGenevaDto {
    url: string;
    code: string;
    description: string;
    permission: string;

    constructor(data?: IResponUrlGenevaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.code = data["code"];
            this.description = data["description"];
            this.permission = data["permission"];
        }
    }

    static fromJS(data: any): ResponUrlGenevaDto {
        let result = new ResponUrlGenevaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["code"] = this.code;
        data["description"] = this.description;
        data["permission"] = this.permission;
        return data; 
    }
}

export interface IResponUrlGenevaDto {
    url: string;
    code: string;
    description: string;
    permission: string;
}

export class GetDataReportPriceListResultDto implements IGetDataReportPriceListResultDto {
    unitId: number;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    listData: ListTermReportPricing[];

    constructor(data?: IGetDataReportPriceListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitId = data["unitId"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitStatusName = data["unitStatusName"];
            if (data["listData"] && data["listData"].constructor === Array) {
                this.listData = [];
                for (let item of data["listData"])
                    this.listData.push(ListTermReportPricing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataReportPriceListResultDto {
        let result = new GetDataReportPriceListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitStatusName"] = this.unitStatusName;
        if (this.listData && this.listData.constructor === Array) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataReportPriceListResultDto {
    unitId: number;
    unitCode: string;
    unitNo: string;
    unitStatusName: string;
    listData: ListTermReportPricing[];
}

export class ListTermReportPricing implements IListTermReportPricing {
    termRemarks: string;
    renovName: string;
    price: number;

    constructor(data?: IListTermReportPricing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termRemarks = data["termRemarks"];
            this.renovName = data["renovName"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): ListTermReportPricing {
        let result = new ListTermReportPricing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termRemarks"] = this.termRemarks;
        data["renovName"] = this.renovName;
        data["price"] = this.price;
        return data; 
    }
}

export interface IListTermReportPricing {
    termRemarks: string;
    renovName: string;
    price: number;
}

export class GetAssetParameters implements IGetAssetParameters {
    entity: string;
    docCode: string;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetAssetParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.docCode = data["docCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetAssetParameters {
        let result = new GetAssetParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["docCode"] = this.docCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetAssetParameters {
    entity: string;
    docCode: string;
    unitCode: string;
    unitNo: string;
}

export class GetAssetResultDto implements IGetAssetResultDto {
    docNo: string;
    docDate: string;
    docCode: string;
    tempFileName: string;

    constructor(data?: IGetAssetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNo = data["docNo"];
            this.docDate = data["docDate"];
            this.docCode = data["docCode"];
            this.tempFileName = data["tempFileName"];
        }
    }

    static fromJS(data: any): GetAssetResultDto {
        let result = new GetAssetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNo"] = this.docNo;
        data["docDate"] = this.docDate;
        data["docCode"] = this.docCode;
        data["tempFileName"] = this.tempFileName;
        return data; 
    }
}

export interface IGetAssetResultDto {
    docNo: string;
    docDate: string;
    docCode: string;
    tempFileName: string;
}

export class PagedResultDtoOfGetReportReadyToAJB implements IPagedResultDtoOfGetReportReadyToAJB {
    totalCount: number;
    items: GetReportReadyToAJB[];

    constructor(data?: IPagedResultDtoOfGetReportReadyToAJB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReportReadyToAJB.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReportReadyToAJB {
        let result = new PagedResultDtoOfGetReportReadyToAJB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetReportReadyToAJB {
    totalCount: number;
    items: GetReportReadyToAJB[];
}

export class GetReportReadyToAJB implements IGetReportReadyToAJB {
    no: number;
    id: number;
    bookCode: string;
    unitCodeID: string;
    unitID: string;
    name: string;
    pppu: string;
    bast: string;
    cer: string;
    imb: string;
    pbb: string;
    ssp: number;
    lunas: number;
    totalCount: number;
    projectID: number;
    clusterID: number;
    projectName: string;
    clusterName: string;
    docID1: number;
    docID2: number;
    docID3: number;
    sendEmailUnd1: string;
    docDateUnd1: moment.Moment;
    undangan1: string;
    cekSendUndanganAJB1: string;
    sendEmailUnd2: string;
    docDateUnd2: moment.Moment;
    undangan2: string;
    cekSendUndanganAJB2: string;
    sendEmailUnd3: string;
    docDateUnd3: moment.Moment;
    undangan3: string;
    cekSendUndanganAJB3: string;
    bankID: number;
    unitCode: string;
    unitNo: string;

    constructor(data?: IGetReportReadyToAJB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.id = data["id"];
            this.bookCode = data["bookCode"];
            this.unitCodeID = data["unitCodeID"];
            this.unitID = data["unitID"];
            this.name = data["name"];
            this.pppu = data["pppu"];
            this.bast = data["bast"];
            this.cer = data["cer"];
            this.imb = data["imb"];
            this.pbb = data["pbb"];
            this.ssp = data["ssp"];
            this.lunas = data["lunas"];
            this.totalCount = data["totalCount"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.docID1 = data["docID1"];
            this.docID2 = data["docID2"];
            this.docID3 = data["docID3"];
            this.sendEmailUnd1 = data["sendEmailUnd1"];
            this.docDateUnd1 = data["docDateUnd1"] ? moment(data["docDateUnd1"].toString()) : <any>undefined;
            this.undangan1 = data["undangan1"];
            this.cekSendUndanganAJB1 = data["cekSendUndanganAJB1"];
            this.sendEmailUnd2 = data["sendEmailUnd2"];
            this.docDateUnd2 = data["docDateUnd2"] ? moment(data["docDateUnd2"].toString()) : <any>undefined;
            this.undangan2 = data["undangan2"];
            this.cekSendUndanganAJB2 = data["cekSendUndanganAJB2"];
            this.sendEmailUnd3 = data["sendEmailUnd3"];
            this.docDateUnd3 = data["docDateUnd3"] ? moment(data["docDateUnd3"].toString()) : <any>undefined;
            this.undangan3 = data["undangan3"];
            this.cekSendUndanganAJB3 = data["cekSendUndanganAJB3"];
            this.bankID = data["bankID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): GetReportReadyToAJB {
        let result = new GetReportReadyToAJB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["id"] = this.id;
        data["bookCode"] = this.bookCode;
        data["unitCodeID"] = this.unitCodeID;
        data["unitID"] = this.unitID;
        data["name"] = this.name;
        data["pppu"] = this.pppu;
        data["bast"] = this.bast;
        data["cer"] = this.cer;
        data["imb"] = this.imb;
        data["pbb"] = this.pbb;
        data["ssp"] = this.ssp;
        data["lunas"] = this.lunas;
        data["totalCount"] = this.totalCount;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["docID1"] = this.docID1;
        data["docID2"] = this.docID2;
        data["docID3"] = this.docID3;
        data["sendEmailUnd1"] = this.sendEmailUnd1;
        data["docDateUnd1"] = this.docDateUnd1 ? this.docDateUnd1.toISOString() : <any>undefined;
        data["undangan1"] = this.undangan1;
        data["cekSendUndanganAJB1"] = this.cekSendUndanganAJB1;
        data["sendEmailUnd2"] = this.sendEmailUnd2;
        data["docDateUnd2"] = this.docDateUnd2 ? this.docDateUnd2.toISOString() : <any>undefined;
        data["undangan2"] = this.undangan2;
        data["cekSendUndanganAJB2"] = this.cekSendUndanganAJB2;
        data["sendEmailUnd3"] = this.sendEmailUnd3;
        data["docDateUnd3"] = this.docDateUnd3 ? this.docDateUnd3.toISOString() : <any>undefined;
        data["undangan3"] = this.undangan3;
        data["cekSendUndanganAJB3"] = this.cekSendUndanganAJB3;
        data["bankID"] = this.bankID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IGetReportReadyToAJB {
    no: number;
    id: number;
    bookCode: string;
    unitCodeID: string;
    unitID: string;
    name: string;
    pppu: string;
    bast: string;
    cer: string;
    imb: string;
    pbb: string;
    ssp: number;
    lunas: number;
    totalCount: number;
    projectID: number;
    clusterID: number;
    projectName: string;
    clusterName: string;
    docID1: number;
    docID2: number;
    docID3: number;
    sendEmailUnd1: string;
    docDateUnd1: moment.Moment;
    undangan1: string;
    cekSendUndanganAJB1: string;
    sendEmailUnd2: string;
    docDateUnd2: moment.Moment;
    undangan2: string;
    cekSendUndanganAJB2: string;
    sendEmailUnd3: string;
    docDateUnd3: moment.Moment;
    undangan3: string;
    cekSendUndanganAJB3: string;
    bankID: number;
    unitCode: string;
    unitNo: string;
}

export class GetRequirementDetailDto implements IGetRequirementDetailDto {
    dataReq: GetDataReq[];
    dataDoc: GetDataDoc[];

    constructor(data?: IGetRequirementDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dataReq"] && data["dataReq"].constructor === Array) {
                this.dataReq = [];
                for (let item of data["dataReq"])
                    this.dataReq.push(GetDataReq.fromJS(item));
            }
            if (data["dataDoc"] && data["dataDoc"].constructor === Array) {
                this.dataDoc = [];
                for (let item of data["dataDoc"])
                    this.dataDoc.push(GetDataDoc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequirementDetailDto {
        let result = new GetRequirementDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dataReq && this.dataReq.constructor === Array) {
            data["dataReq"] = [];
            for (let item of this.dataReq)
                data["dataReq"].push(item.toJSON());
        }
        if (this.dataDoc && this.dataDoc.constructor === Array) {
            data["dataDoc"] = [];
            for (let item of this.dataDoc)
                data["dataDoc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetRequirementDetailDto {
    dataReq: GetDataReq[];
    dataDoc: GetDataDoc[];
}

export class GetDataReq implements IGetDataReq {
    reqNo: number;
    reqDesc: string;
    pctPaid: number;
    commPctPaid: number;

    constructor(data?: IGetDataReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reqNo = data["reqNo"];
            this.reqDesc = data["reqDesc"];
            this.pctPaid = data["pctPaid"];
            this.commPctPaid = data["commPctPaid"];
        }
    }

    static fromJS(data: any): GetDataReq {
        let result = new GetDataReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqNo"] = this.reqNo;
        data["reqDesc"] = this.reqDesc;
        data["pctPaid"] = this.pctPaid;
        data["commPctPaid"] = this.commPctPaid;
        return data; 
    }
}

export interface IGetDataReq {
    reqNo: number;
    reqDesc: string;
    pctPaid: number;
    commPctPaid: number;
}

export class GetDataDoc implements IGetDataDoc {
    termCode: string;
    termDesc: string;
    documentType: string;
    documentName: string;

    constructor(data?: IGetDataDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termCode = data["termCode"];
            this.termDesc = data["termDesc"];
            this.documentType = data["documentType"];
            this.documentName = data["documentName"];
        }
    }

    static fromJS(data: any): GetDataDoc {
        let result = new GetDataDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termCode"] = this.termCode;
        data["termDesc"] = this.termDesc;
        data["documentType"] = this.documentType;
        data["documentName"] = this.documentName;
        return data; 
    }
}

export interface IGetDataDoc {
    termCode: string;
    termDesc: string;
    documentType: string;
    documentName: string;
}

export class GetDropdownProjectByMemberCode implements IGetDropdownProjectByMemberCode {
    projectID: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IGetDropdownProjectByMemberCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetDropdownProjectByMemberCode {
        let result = new GetDropdownProjectByMemberCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetDropdownProjectByMemberCode {
    projectID: number;
    projectCode: string;
    projectName: string;
}

export class CreateRewardInputDto implements ICreateRewardInputDto {
    projectId: number;
    rewardName: string;
    isBookingFee: boolean;
    isBilling: boolean;
    isParking: boolean;
    isUndian: boolean;
    isActive: boolean;
    listProjectInfoID: number[];
    isPP: boolean;
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    tnc: string;
    imageUndian: string;
    durationExpired: number;

    constructor(data?: ICreateRewardInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectId = data["projectId"];
            this.rewardName = data["rewardName"];
            this.isBookingFee = data["isBookingFee"];
            this.isBilling = data["isBilling"];
            this.isParking = data["isParking"];
            this.isUndian = data["isUndian"];
            this.isActive = data["isActive"];
            if (data["listProjectInfoID"] && data["listProjectInfoID"].constructor === Array) {
                this.listProjectInfoID = [];
                for (let item of data["listProjectInfoID"])
                    this.listProjectInfoID.push(item);
            }
            this.isPP = data["isPP"];
            this.periodeStart = data["periodeStart"] ? moment(data["periodeStart"].toString()) : <any>undefined;
            this.periodeEnd = data["periodeEnd"] ? moment(data["periodeEnd"].toString()) : <any>undefined;
            this.tnc = data["tnc"];
            this.imageUndian = data["imageUndian"];
            this.durationExpired = data["durationExpired"];
        }
    }

    static fromJS(data: any): CreateRewardInputDto {
        let result = new CreateRewardInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["rewardName"] = this.rewardName;
        data["isBookingFee"] = this.isBookingFee;
        data["isBilling"] = this.isBilling;
        data["isParking"] = this.isParking;
        data["isUndian"] = this.isUndian;
        data["isActive"] = this.isActive;
        if (this.listProjectInfoID && this.listProjectInfoID.constructor === Array) {
            data["listProjectInfoID"] = [];
            for (let item of this.listProjectInfoID)
                data["listProjectInfoID"].push(item);
        }
        data["isPP"] = this.isPP;
        data["periodeStart"] = this.periodeStart ? this.periodeStart.toISOString() : <any>undefined;
        data["periodeEnd"] = this.periodeEnd ? this.periodeEnd.toISOString() : <any>undefined;
        data["tnc"] = this.tnc;
        data["imageUndian"] = this.imageUndian;
        data["durationExpired"] = this.durationExpired;
        return data; 
    }
}

export interface ICreateRewardInputDto {
    projectId: number;
    rewardName: string;
    isBookingFee: boolean;
    isBilling: boolean;
    isParking: boolean;
    isUndian: boolean;
    isActive: boolean;
    listProjectInfoID: number[];
    isPP: boolean;
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    tnc: string;
    imageUndian: string;
    durationExpired: number;
}

export class TasklistRewardInputDto implements ITasklistRewardInputDto {
    projectID: number;
    keyword: string;
    projectInfoID: number[];

    constructor(data?: ITasklistRewardInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.keyword = data["keyword"];
            if (data["projectInfoID"] && data["projectInfoID"].constructor === Array) {
                this.projectInfoID = [];
                for (let item of data["projectInfoID"])
                    this.projectInfoID.push(item);
            }
        }
    }

    static fromJS(data: any): TasklistRewardInputDto {
        let result = new TasklistRewardInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["keyword"] = this.keyword;
        if (this.projectInfoID && this.projectInfoID.constructor === Array) {
            data["projectInfoID"] = [];
            for (let item of this.projectInfoID)
                data["projectInfoID"].push(item);
        }
        return data; 
    }
}

export interface ITasklistRewardInputDto {
    projectID: number;
    keyword: string;
    projectInfoID: number[];
}

export class ListResultDtoOfGetListRewardDto implements IListResultDtoOfGetListRewardDto {
    items: GetListRewardDto[];

    constructor(data?: IListResultDtoOfGetListRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListRewardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListRewardDto {
        let result = new ListResultDtoOfGetListRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListRewardDto {
    items: GetListRewardDto[];
}

export class GetListRewardDto implements IGetListRewardDto {
    rewardId: number;
    projectId: number;
    projectName: string;
    rewardName: string;
    imageUndian: string;
    imageUrl: string;
    isBookingFee: boolean;
    isBilling: boolean;
    isUndian: boolean;
    isParking: boolean;
    isActive: boolean;
    isPP: boolean;
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    tnc: string;
    durationExpired: number;
    listRewardProduct: GetRewardProduct[];

    constructor(data?: IGetListRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardId = data["rewardId"];
            this.projectId = data["projectId"];
            this.projectName = data["projectName"];
            this.rewardName = data["rewardName"];
            this.imageUndian = data["imageUndian"];
            this.imageUrl = data["imageUrl"];
            this.isBookingFee = data["isBookingFee"];
            this.isBilling = data["isBilling"];
            this.isUndian = data["isUndian"];
            this.isParking = data["isParking"];
            this.isActive = data["isActive"];
            this.isPP = data["isPP"];
            this.periodeStart = data["periodeStart"] ? moment(data["periodeStart"].toString()) : <any>undefined;
            this.periodeEnd = data["periodeEnd"] ? moment(data["periodeEnd"].toString()) : <any>undefined;
            this.tnc = data["tnc"];
            this.durationExpired = data["durationExpired"];
            if (data["listRewardProduct"] && data["listRewardProduct"].constructor === Array) {
                this.listRewardProduct = [];
                for (let item of data["listRewardProduct"])
                    this.listRewardProduct.push(GetRewardProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListRewardDto {
        let result = new GetListRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["rewardName"] = this.rewardName;
        data["imageUndian"] = this.imageUndian;
        data["imageUrl"] = this.imageUrl;
        data["isBookingFee"] = this.isBookingFee;
        data["isBilling"] = this.isBilling;
        data["isUndian"] = this.isUndian;
        data["isParking"] = this.isParking;
        data["isActive"] = this.isActive;
        data["isPP"] = this.isPP;
        data["periodeStart"] = this.periodeStart ? this.periodeStart.toISOString() : <any>undefined;
        data["periodeEnd"] = this.periodeEnd ? this.periodeEnd.toISOString() : <any>undefined;
        data["tnc"] = this.tnc;
        data["durationExpired"] = this.durationExpired;
        if (this.listRewardProduct && this.listRewardProduct.constructor === Array) {
            data["listRewardProduct"] = [];
            for (let item of this.listRewardProduct)
                data["listRewardProduct"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetListRewardDto {
    rewardId: number;
    projectId: number;
    projectName: string;
    rewardName: string;
    imageUndian: string;
    imageUrl: string;
    isBookingFee: boolean;
    isBilling: boolean;
    isUndian: boolean;
    isParking: boolean;
    isActive: boolean;
    isPP: boolean;
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    tnc: string;
    durationExpired: number;
    listRewardProduct: GetRewardProduct[];
}

export class GetRewardProduct implements IGetRewardProduct {
    rewardProductId: number;
    projectInfoID: number;
    productCode: string;
    productName: string;

    constructor(data?: IGetRewardProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardProductId = data["rewardProductId"];
            this.projectInfoID = data["projectInfoID"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetRewardProduct {
        let result = new GetRewardProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardProductId"] = this.rewardProductId;
        data["projectInfoID"] = this.projectInfoID;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetRewardProduct {
    rewardProductId: number;
    projectInfoID: number;
    productCode: string;
    productName: string;
}

export class GetDropdownRewardPPDto implements IGetDropdownRewardPPDto {
    rewardID: number;
    rewardName: string;

    constructor(data?: IGetDropdownRewardPPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
        }
    }

    static fromJS(data: any): GetDropdownRewardPPDto {
        let result = new GetDropdownRewardPPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        return data; 
    }
}

export interface IGetDropdownRewardPPDto {
    rewardID: number;
    rewardName: string;
}

export class GetRewardDropdownListDto implements IGetRewardDropdownListDto {
    rewardID: number;
    rewardName: string;
    isBookingFee: boolean;
    isPP: boolean;
    isParking: boolean;
    isNewCustomer: boolean;
    isBilling: boolean;
    durationExpired: number;
    projectInfoID: number;

    constructor(data?: IGetRewardDropdownListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
            this.isBookingFee = data["isBookingFee"];
            this.isPP = data["isPP"];
            this.isParking = data["isParking"];
            this.isNewCustomer = data["isNewCustomer"];
            this.isBilling = data["isBilling"];
            this.durationExpired = data["durationExpired"];
            this.projectInfoID = data["projectInfoID"];
        }
    }

    static fromJS(data: any): GetRewardDropdownListDto {
        let result = new GetRewardDropdownListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        data["isBookingFee"] = this.isBookingFee;
        data["isPP"] = this.isPP;
        data["isParking"] = this.isParking;
        data["isNewCustomer"] = this.isNewCustomer;
        data["isBilling"] = this.isBilling;
        data["durationExpired"] = this.durationExpired;
        data["projectInfoID"] = this.projectInfoID;
        return data; 
    }
}

export interface IGetRewardDropdownListDto {
    rewardID: number;
    rewardName: string;
    isBookingFee: boolean;
    isPP: boolean;
    isParking: boolean;
    isNewCustomer: boolean;
    isBilling: boolean;
    durationExpired: number;
    projectInfoID: number;
}

export class GenerateRewardHistoryPdfInputDto implements IGenerateRewardHistoryPdfInputDto {
    unitOrderHeaderID: number;
    orderCode: string;
    listBookingRewardID: number[];
    listRewardName: string[];
    custName: string;

    constructor(data?: IGenerateRewardHistoryPdfInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.orderCode = data["orderCode"];
            if (data["listBookingRewardID"] && data["listBookingRewardID"].constructor === Array) {
                this.listBookingRewardID = [];
                for (let item of data["listBookingRewardID"])
                    this.listBookingRewardID.push(item);
            }
            if (data["listRewardName"] && data["listRewardName"].constructor === Array) {
                this.listRewardName = [];
                for (let item of data["listRewardName"])
                    this.listRewardName.push(item);
            }
            this.custName = data["custName"];
        }
    }

    static fromJS(data: any): GenerateRewardHistoryPdfInputDto {
        let result = new GenerateRewardHistoryPdfInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["orderCode"] = this.orderCode;
        if (this.listBookingRewardID && this.listBookingRewardID.constructor === Array) {
            data["listBookingRewardID"] = [];
            for (let item of this.listBookingRewardID)
                data["listBookingRewardID"].push(item);
        }
        if (this.listRewardName && this.listRewardName.constructor === Array) {
            data["listRewardName"] = [];
            for (let item of this.listRewardName)
                data["listRewardName"].push(item);
        }
        data["custName"] = this.custName;
        return data; 
    }
}

export interface IGenerateRewardHistoryPdfInputDto {
    unitOrderHeaderID: number;
    orderCode: string;
    listBookingRewardID: number[];
    listRewardName: string[];
    custName: string;
}

export class GetDetailTasklistRewardHistoryListDto implements IGetDetailTasklistRewardHistoryListDto {
    unitOrderHeaderID: number;
    projectID: number;
    custName: string;
    address: string;
    idNo: string;
    email: string;
    handphone: string;
    orderDetails: GetOrderDetail[];
    rewardDetails: GetRewardDetail[];

    constructor(data?: IGetDetailTasklistRewardHistoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.projectID = data["projectID"];
            this.custName = data["custName"];
            this.address = data["address"];
            this.idNo = data["idNo"];
            this.email = data["email"];
            this.handphone = data["handphone"];
            if (data["orderDetails"] && data["orderDetails"].constructor === Array) {
                this.orderDetails = [];
                for (let item of data["orderDetails"])
                    this.orderDetails.push(GetOrderDetail.fromJS(item));
            }
            if (data["rewardDetails"] && data["rewardDetails"].constructor === Array) {
                this.rewardDetails = [];
                for (let item of data["rewardDetails"])
                    this.rewardDetails.push(GetRewardDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailTasklistRewardHistoryListDto {
        let result = new GetDetailTasklistRewardHistoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["projectID"] = this.projectID;
        data["custName"] = this.custName;
        data["address"] = this.address;
        data["idNo"] = this.idNo;
        data["email"] = this.email;
        data["handphone"] = this.handphone;
        if (this.orderDetails && this.orderDetails.constructor === Array) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        if (this.rewardDetails && this.rewardDetails.constructor === Array) {
            data["rewardDetails"] = [];
            for (let item of this.rewardDetails)
                data["rewardDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailTasklistRewardHistoryListDto {
    unitOrderHeaderID: number;
    projectID: number;
    custName: string;
    address: string;
    idNo: string;
    email: string;
    handphone: string;
    orderDetails: GetOrderDetail[];
    rewardDetails: GetRewardDetail[];
}

export class GetOrderDetail implements IGetOrderDetail {
    unit: string;
    ppNo: string;
    renovation: string;
    payment: string;

    constructor(data?: IGetOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unit = data["unit"];
            this.ppNo = data["ppNo"];
            this.renovation = data["renovation"];
            this.payment = data["payment"];
        }
    }

    static fromJS(data: any): GetOrderDetail {
        let result = new GetOrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit;
        data["ppNo"] = this.ppNo;
        data["renovation"] = this.renovation;
        data["payment"] = this.payment;
        return data; 
    }
}

export interface IGetOrderDetail {
    unit: string;
    ppNo: string;
    renovation: string;
    payment: string;
}

export class GetRewardDetail implements IGetRewardDetail {
    bookingRewardID: number;
    rewardName: string;
    status: string;
    voucherCode: string;
    isBookingUnit: number;
    isBilling: boolean;
    isBookingFee: boolean;
    isParking: boolean;
    isPP: boolean;
    isNewCustomer: boolean;
    programID: number;
    programName: string;
    campaignHeaderID: number;
    campaignName: string;

    constructor(data?: IGetRewardDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingRewardID = data["bookingRewardID"];
            this.rewardName = data["rewardName"];
            this.status = data["status"];
            this.voucherCode = data["voucherCode"];
            this.isBookingUnit = data["isBookingUnit"];
            this.isBilling = data["isBilling"];
            this.isBookingFee = data["isBookingFee"];
            this.isParking = data["isParking"];
            this.isPP = data["isPP"];
            this.isNewCustomer = data["isNewCustomer"];
            this.programID = data["programID"];
            this.programName = data["programName"];
            this.campaignHeaderID = data["campaignHeaderID"];
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetRewardDetail {
        let result = new GetRewardDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingRewardID"] = this.bookingRewardID;
        data["rewardName"] = this.rewardName;
        data["status"] = this.status;
        data["voucherCode"] = this.voucherCode;
        data["isBookingUnit"] = this.isBookingUnit;
        data["isBilling"] = this.isBilling;
        data["isBookingFee"] = this.isBookingFee;
        data["isParking"] = this.isParking;
        data["isPP"] = this.isPP;
        data["isNewCustomer"] = this.isNewCustomer;
        data["programID"] = this.programID;
        data["programName"] = this.programName;
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["campaignName"] = this.campaignName;
        return data; 
    }
}

export interface IGetRewardDetail {
    bookingRewardID: number;
    rewardName: string;
    status: string;
    voucherCode: string;
    isBookingUnit: number;
    isBilling: boolean;
    isBookingFee: boolean;
    isParking: boolean;
    isPP: boolean;
    isNewCustomer: boolean;
    programID: number;
    programName: string;
    campaignHeaderID: number;
    campaignName: string;
}

export class PagedResultDtoOfGetTasklistRewardHistoryListDto implements IPagedResultDtoOfGetTasklistRewardHistoryListDto {
    totalCount: number;
    items: GetTasklistRewardHistoryListDto[];

    constructor(data?: IPagedResultDtoOfGetTasklistRewardHistoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTasklistRewardHistoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTasklistRewardHistoryListDto {
        let result = new PagedResultDtoOfGetTasklistRewardHistoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTasklistRewardHistoryListDto {
    totalCount: number;
    items: GetTasklistRewardHistoryListDto[];
}

export class GetTasklistRewardHistoryListDto implements IGetTasklistRewardHistoryListDto {
    unitOrderHeaderID: number;
    orderCode: string;
    units: string;
    custName: string;
    rewards: string;
    status: string;

    constructor(data?: IGetTasklistRewardHistoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.orderCode = data["orderCode"];
            this.units = data["units"];
            this.custName = data["custName"];
            this.rewards = data["rewards"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetTasklistRewardHistoryListDto {
        let result = new GetTasklistRewardHistoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["orderCode"] = this.orderCode;
        data["units"] = this.units;
        data["custName"] = this.custName;
        data["rewards"] = this.rewards;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetTasklistRewardHistoryListDto {
    unitOrderHeaderID: number;
    orderCode: string;
    units: string;
    custName: string;
    rewards: string;
    status: string;
}

export class RedeemRewardInputDto implements IRedeemRewardInputDto {
    bookingRewardID: number;
    projectID: number;
    unitOrderHeaderID: number;
    voucherCode: string;
    flag: number;

    constructor(data?: IRedeemRewardInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingRewardID = data["bookingRewardID"];
            this.projectID = data["projectID"];
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.voucherCode = data["voucherCode"];
            this.flag = data["flag"];
        }
    }

    static fromJS(data: any): RedeemRewardInputDto {
        let result = new RedeemRewardInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingRewardID"] = this.bookingRewardID;
        data["projectID"] = this.projectID;
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["voucherCode"] = this.voucherCode;
        data["flag"] = this.flag;
        return data; 
    }
}

export interface IRedeemRewardInputDto {
    bookingRewardID: number;
    projectID: number;
    unitOrderHeaderID: number;
    voucherCode: string;
    flag: number;
}

export class DropdownCampaignInputDto implements IDropdownCampaignInputDto {
    unitOrderHeaderID: number;
    programID: number;

    constructor(data?: IDropdownCampaignInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.programID = data["programID"];
        }
    }

    static fromJS(data: any): DropdownCampaignInputDto {
        let result = new DropdownCampaignInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["programID"] = this.programID;
        return data; 
    }
}

export interface IDropdownCampaignInputDto {
    unitOrderHeaderID: number;
    programID: number;
}

export class DropdownCampaignResultDto implements IDropdownCampaignResultDto {
    campaignHeaderID: number;
    campaignName: string;

    constructor(data?: IDropdownCampaignResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): DropdownCampaignResultDto {
        let result = new DropdownCampaignResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["campaignName"] = this.campaignName;
        return data; 
    }
}

export interface IDropdownCampaignResultDto {
    campaignHeaderID: number;
    campaignName: string;
}

export class AddBookingProgramRewardInput implements IAddBookingProgramRewardInput {
    unitOrderHeaderID: number;
    programID: number;
    campaignHeaderID: number;
    listReward: number[];

    constructor(data?: IAddBookingProgramRewardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.programID = data["programID"];
            this.campaignHeaderID = data["campaignHeaderID"];
            if (data["listReward"] && data["listReward"].constructor === Array) {
                this.listReward = [];
                for (let item of data["listReward"])
                    this.listReward.push(item);
            }
        }
    }

    static fromJS(data: any): AddBookingProgramRewardInput {
        let result = new AddBookingProgramRewardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["programID"] = this.programID;
        data["campaignHeaderID"] = this.campaignHeaderID;
        if (this.listReward && this.listReward.constructor === Array) {
            data["listReward"] = [];
            for (let item of this.listReward)
                data["listReward"].push(item);
        }
        return data; 
    }
}

export interface IAddBookingProgramRewardInput {
    unitOrderHeaderID: number;
    programID: number;
    campaignHeaderID: number;
    listReward: number[];
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[];

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[];
}

export class RoleListDto implements IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto = new RoleEditDto();
    grantedPermissionNames: string[] = [];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class ValidasiMemberDto implements IValidasiMemberDto {
    isAdmin: boolean;
    isParent: boolean;

    constructor(data?: IValidasiMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isAdmin = data["isAdmin"];
            this.isParent = data["isParent"];
        }
    }

    static fromJS(data: any): ValidasiMemberDto {
        let result = new ValidasiMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAdmin"] = this.isAdmin;
        data["isParent"] = this.isParent;
        return data; 
    }
}

export interface IValidasiMemberDto {
    isAdmin: boolean;
    isParent: boolean;
}

export class GetSalesTrackingInputDto implements IGetSalesTrackingInputDto {
    memberCode: string[];
    projectID: number[];
    keyword: string;
    bookCode: string;
    termID: number;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IGetSalesTrackingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberCode"] && data["memberCode"].constructor === Array) {
                this.memberCode = [];
                for (let item of data["memberCode"])
                    this.memberCode.push(item);
            }
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.keyword = data["keyword"];
            this.bookCode = data["bookCode"];
            this.termID = data["termID"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    }

    static fromJS(data: any): GetSalesTrackingInputDto {
        let result = new GetSalesTrackingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberCode && this.memberCode.constructor === Array) {
            data["memberCode"] = [];
            for (let item of this.memberCode)
                data["memberCode"].push(item);
        }
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["keyword"] = this.keyword;
        data["bookCode"] = this.bookCode;
        data["termID"] = this.termID;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface IGetSalesTrackingInputDto {
    memberCode: string[];
    projectID: number[];
    keyword: string;
    bookCode: string;
    termID: number;
    maxResultCount: number;
    skipCount: number;
}

export class PagedResultDtoOfGetSalesTrackingResultDto implements IPagedResultDtoOfGetSalesTrackingResultDto {
    totalCount: number;
    items: GetSalesTrackingResultDto[];

    constructor(data?: IPagedResultDtoOfGetSalesTrackingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesTrackingResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesTrackingResultDto {
        let result = new PagedResultDtoOfGetSalesTrackingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSalesTrackingResultDto {
    totalCount: number;
    items: GetSalesTrackingResultDto[];
}

export class GetSalesTrackingResultDto implements IGetSalesTrackingResultDto {
    name: string;
    email: string;
    paymentStatus: string;
    payment: string;
    totalPayment: number;
    ppStatus: string;
    ppNo: string;
    buyDatePP: moment.Moment;
    unitStatus: string;
    unit: string;
    signP3U: string;
    signAkad: string;
    pctPaymentDp: string;
    confirmationLetter: string;
    memberCode: string;
    psCode: string;
    orderCode: string;
    bookCode: string;
    unitOrderHeaderId: number;
    termRemarks: string;
    ppOrderID: number;
    bankCode: string;
    bankName: string;
    unitID: number;
    recordCount: number;
    projectID: number;
    overallStatus: string;
    daySinceLast: string;
    step: string;
    stepComplete: string;
    document: string;
    bookingHeaderID: string;
    clusterID: string;
    bookDate: moment.Moment;
    ppCreationTime: moment.Moment;
    signP3UModifTime: moment.Moment;
    signAkadModifTime: moment.Moment;
    maxClearDateDP: moment.Moment;
    documentModifTime: moment.Moment;
    confirmationLetterModifTime: moment.Moment;
    projectCode: string;
    nextPayment: string;
    dueDate: moment.Moment;
    totalKomisiPaid: string;
    percentKomisiPaid: string;
    eligibleCommAmount: string;
    eligibleCommPct: string;
    reservedField1: string;
    reservedField2: string;
    reservedField3: string;
    reservedField4: string;
    reservedField5: string;
    reservedField6: string;
    reservedField7: string;

    constructor(data?: IGetSalesTrackingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.paymentStatus = data["paymentStatus"];
            this.payment = data["payment"];
            this.totalPayment = data["totalPayment"];
            this.ppStatus = data["ppStatus"];
            this.ppNo = data["ppNo"];
            this.buyDatePP = data["buyDatePP"] ? moment(data["buyDatePP"].toString()) : <any>undefined;
            this.unitStatus = data["unitStatus"];
            this.unit = data["unit"];
            this.signP3U = data["signP3U"];
            this.signAkad = data["signAkad"];
            this.pctPaymentDp = data["pctPaymentDp"];
            this.confirmationLetter = data["confirmationLetter"];
            this.memberCode = data["memberCode"];
            this.psCode = data["psCode"];
            this.orderCode = data["orderCode"];
            this.bookCode = data["bookCode"];
            this.unitOrderHeaderId = data["unitOrderHeaderId"];
            this.termRemarks = data["termRemarks"];
            this.ppOrderID = data["ppOrderID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
            this.unitID = data["unitID"];
            this.recordCount = data["recordCount"];
            this.projectID = data["projectID"];
            this.overallStatus = data["overallStatus"];
            this.daySinceLast = data["daySinceLast"];
            this.step = data["step"];
            this.stepComplete = data["stepComplete"];
            this.document = data["document"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.clusterID = data["clusterID"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.ppCreationTime = data["ppCreationTime"] ? moment(data["ppCreationTime"].toString()) : <any>undefined;
            this.signP3UModifTime = data["signP3UModifTime"] ? moment(data["signP3UModifTime"].toString()) : <any>undefined;
            this.signAkadModifTime = data["signAkadModifTime"] ? moment(data["signAkadModifTime"].toString()) : <any>undefined;
            this.maxClearDateDP = data["maxClearDateDP"] ? moment(data["maxClearDateDP"].toString()) : <any>undefined;
            this.documentModifTime = data["documentModifTime"] ? moment(data["documentModifTime"].toString()) : <any>undefined;
            this.confirmationLetterModifTime = data["confirmationLetterModifTime"] ? moment(data["confirmationLetterModifTime"].toString()) : <any>undefined;
            this.projectCode = data["projectCode"];
            this.nextPayment = data["nextPayment"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.totalKomisiPaid = data["totalKomisiPaid"];
            this.percentKomisiPaid = data["percentKomisiPaid"];
            this.eligibleCommAmount = data["eligibleCommAmount"];
            this.eligibleCommPct = data["eligibleCommPct"];
            this.reservedField1 = data["reservedField1"];
            this.reservedField2 = data["reservedField2"];
            this.reservedField3 = data["reservedField3"];
            this.reservedField4 = data["reservedField4"];
            this.reservedField5 = data["reservedField5"];
            this.reservedField6 = data["reservedField6"];
            this.reservedField7 = data["reservedField7"];
        }
    }

    static fromJS(data: any): GetSalesTrackingResultDto {
        let result = new GetSalesTrackingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["paymentStatus"] = this.paymentStatus;
        data["payment"] = this.payment;
        data["totalPayment"] = this.totalPayment;
        data["ppStatus"] = this.ppStatus;
        data["ppNo"] = this.ppNo;
        data["buyDatePP"] = this.buyDatePP ? this.buyDatePP.toISOString() : <any>undefined;
        data["unitStatus"] = this.unitStatus;
        data["unit"] = this.unit;
        data["signP3U"] = this.signP3U;
        data["signAkad"] = this.signAkad;
        data["pctPaymentDp"] = this.pctPaymentDp;
        data["confirmationLetter"] = this.confirmationLetter;
        data["memberCode"] = this.memberCode;
        data["psCode"] = this.psCode;
        data["orderCode"] = this.orderCode;
        data["bookCode"] = this.bookCode;
        data["unitOrderHeaderId"] = this.unitOrderHeaderId;
        data["termRemarks"] = this.termRemarks;
        data["ppOrderID"] = this.ppOrderID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["unitID"] = this.unitID;
        data["recordCount"] = this.recordCount;
        data["projectID"] = this.projectID;
        data["overallStatus"] = this.overallStatus;
        data["daySinceLast"] = this.daySinceLast;
        data["step"] = this.step;
        data["stepComplete"] = this.stepComplete;
        data["document"] = this.document;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["clusterID"] = this.clusterID;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["ppCreationTime"] = this.ppCreationTime ? this.ppCreationTime.toISOString() : <any>undefined;
        data["signP3UModifTime"] = this.signP3UModifTime ? this.signP3UModifTime.toISOString() : <any>undefined;
        data["signAkadModifTime"] = this.signAkadModifTime ? this.signAkadModifTime.toISOString() : <any>undefined;
        data["maxClearDateDP"] = this.maxClearDateDP ? this.maxClearDateDP.toISOString() : <any>undefined;
        data["documentModifTime"] = this.documentModifTime ? this.documentModifTime.toISOString() : <any>undefined;
        data["confirmationLetterModifTime"] = this.confirmationLetterModifTime ? this.confirmationLetterModifTime.toISOString() : <any>undefined;
        data["projectCode"] = this.projectCode;
        data["nextPayment"] = this.nextPayment;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["totalKomisiPaid"] = this.totalKomisiPaid;
        data["percentKomisiPaid"] = this.percentKomisiPaid;
        data["eligibleCommAmount"] = this.eligibleCommAmount;
        data["eligibleCommPct"] = this.eligibleCommPct;
        data["reservedField1"] = this.reservedField1;
        data["reservedField2"] = this.reservedField2;
        data["reservedField3"] = this.reservedField3;
        data["reservedField4"] = this.reservedField4;
        data["reservedField5"] = this.reservedField5;
        data["reservedField6"] = this.reservedField6;
        data["reservedField7"] = this.reservedField7;
        return data; 
    }
}

export interface IGetSalesTrackingResultDto {
    name: string;
    email: string;
    paymentStatus: string;
    payment: string;
    totalPayment: number;
    ppStatus: string;
    ppNo: string;
    buyDatePP: moment.Moment;
    unitStatus: string;
    unit: string;
    signP3U: string;
    signAkad: string;
    pctPaymentDp: string;
    confirmationLetter: string;
    memberCode: string;
    psCode: string;
    orderCode: string;
    bookCode: string;
    unitOrderHeaderId: number;
    termRemarks: string;
    ppOrderID: number;
    bankCode: string;
    bankName: string;
    unitID: number;
    recordCount: number;
    projectID: number;
    overallStatus: string;
    daySinceLast: string;
    step: string;
    stepComplete: string;
    document: string;
    bookingHeaderID: string;
    clusterID: string;
    bookDate: moment.Moment;
    ppCreationTime: moment.Moment;
    signP3UModifTime: moment.Moment;
    signAkadModifTime: moment.Moment;
    maxClearDateDP: moment.Moment;
    documentModifTime: moment.Moment;
    confirmationLetterModifTime: moment.Moment;
    projectCode: string;
    nextPayment: string;
    dueDate: moment.Moment;
    totalKomisiPaid: string;
    percentKomisiPaid: string;
    eligibleCommAmount: string;
    eligibleCommPct: string;
    reservedField1: string;
    reservedField2: string;
    reservedField3: string;
    reservedField4: string;
    reservedField5: string;
    reservedField6: string;
    reservedField7: string;
}

export class GetSalesTrackingTermPaymentDto implements IGetSalesTrackingTermPaymentDto {
    termID: number;
    termRemarks: string;

    constructor(data?: IGetSalesTrackingTermPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termID = data["termID"];
            this.termRemarks = data["termRemarks"];
        }
    }

    static fromJS(data: any): GetSalesTrackingTermPaymentDto {
        let result = new GetSalesTrackingTermPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termID"] = this.termID;
        data["termRemarks"] = this.termRemarks;
        return data; 
    }
}

export interface IGetSalesTrackingTermPaymentDto {
    termID: number;
    termRemarks: string;
}

export class ChangeEmailInputDto implements IChangeEmailInputDto {
    psCode: string;
    oldEmail: string;
    newEmail: string;

    constructor(data?: IChangeEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.oldEmail = data["oldEmail"];
            this.newEmail = data["newEmail"];
        }
    }

    static fromJS(data: any): ChangeEmailInputDto {
        let result = new ChangeEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["oldEmail"] = this.oldEmail;
        data["newEmail"] = this.newEmail;
        return data; 
    }
}

export interface IChangeEmailInputDto {
    psCode: string;
    oldEmail: string;
    newEmail: string;
}

export class PrintOLNInputDto implements IPrintOLNInputDto {
    bookCode: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;

    constructor(data?: IPrintOLNInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.plafond = data["plafond"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.sukuBungaTahun = data["sukuBungaTahun"];
        }
    }

    static fromJS(data: any): PrintOLNInputDto {
        let result = new PrintOLNInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["plafond"] = this.plafond;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["sukuBungaTahun"] = this.sukuBungaTahun;
        return data; 
    }
}

export interface IPrintOLNInputDto {
    bookCode: string;
    plafond: string;
    tenor: string;
    sukuBunga: string;
    sukuBungaTahun: string;
}

export class ResendEmailByBookCodeInputDto implements IResendEmailByBookCodeInputDto {
    bookCode: string;
    emailCustomer: string;
    customerName: string;
    memberCode: string;
    docCode: string;
    isSigned: boolean;

    constructor(data?: IResendEmailByBookCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.emailCustomer = data["emailCustomer"];
            this.customerName = data["customerName"];
            this.memberCode = data["memberCode"];
            this.docCode = data["docCode"];
            this.isSigned = data["isSigned"];
        }
    }

    static fromJS(data: any): ResendEmailByBookCodeInputDto {
        let result = new ResendEmailByBookCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["emailCustomer"] = this.emailCustomer;
        data["customerName"] = this.customerName;
        data["memberCode"] = this.memberCode;
        data["docCode"] = this.docCode;
        data["isSigned"] = this.isSigned;
        return data; 
    }
}

export interface IResendEmailByBookCodeInputDto {
    bookCode: string;
    emailCustomer: string;
    customerName: string;
    memberCode: string;
    docCode: string;
    isSigned: boolean;
}

export class ResendEmailLayoutPlanDto implements IResendEmailLayoutPlanDto {
    projectID: number;
    emailCustomer: string;
    customerName: string;
    memberCode: string;

    constructor(data?: IResendEmailLayoutPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.emailCustomer = data["emailCustomer"];
            this.customerName = data["customerName"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): ResendEmailLayoutPlanDto {
        let result = new ResendEmailLayoutPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["emailCustomer"] = this.emailCustomer;
        data["customerName"] = this.customerName;
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface IResendEmailLayoutPlanDto {
    projectID: number;
    emailCustomer: string;
    customerName: string;
    memberCode: string;
}

export class GetMappingOfferingLetterNobuDto implements IGetMappingOfferingLetterNobuDto {
    id: number;
    projectID: number;
    projectName: string;
    tenor: number;
    sukuBunga: number;
    tahun: number;

    constructor(data?: IGetMappingOfferingLetterNobuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.tenor = data["tenor"];
            this.sukuBunga = data["sukuBunga"];
            this.tahun = data["tahun"];
        }
    }

    static fromJS(data: any): GetMappingOfferingLetterNobuDto {
        let result = new GetMappingOfferingLetterNobuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["tenor"] = this.tenor;
        data["sukuBunga"] = this.sukuBunga;
        data["tahun"] = this.tahun;
        return data; 
    }
}

export interface IGetMappingOfferingLetterNobuDto {
    id: number;
    projectID: number;
    projectName: string;
    tenor: number;
    sukuBunga: number;
    tahun: number;
}

export class SendPaymentInstructionsDto implements ISendPaymentInstructionsDto {
    bookcode: string;
    orderCode: string;
    paymentInstructions: string;
    emailCustomer: string;
    customerName: string;
    memberCode: string;
    amountPay: string;

    constructor(data?: ISendPaymentInstructionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookcode = data["bookcode"];
            this.orderCode = data["orderCode"];
            this.paymentInstructions = data["paymentInstructions"];
            this.emailCustomer = data["emailCustomer"];
            this.customerName = data["customerName"];
            this.memberCode = data["memberCode"];
            this.amountPay = data["amountPay"];
        }
    }

    static fromJS(data: any): SendPaymentInstructionsDto {
        let result = new SendPaymentInstructionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookcode"] = this.bookcode;
        data["orderCode"] = this.orderCode;
        data["paymentInstructions"] = this.paymentInstructions;
        data["emailCustomer"] = this.emailCustomer;
        data["customerName"] = this.customerName;
        data["memberCode"] = this.memberCode;
        data["amountPay"] = this.amountPay;
        return data; 
    }
}

export interface ISendPaymentInstructionsDto {
    bookcode: string;
    orderCode: string;
    paymentInstructions: string;
    emailCustomer: string;
    customerName: string;
    memberCode: string;
    amountPay: string;
}

export class SendEmailDpDto implements ISendEmailDpDto {
    bookcode: string;
    emailCustomer: string;
    namaCustomer: string;

    constructor(data?: ISendEmailDpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookcode = data["bookcode"];
            this.emailCustomer = data["emailCustomer"];
            this.namaCustomer = data["namaCustomer"];
        }
    }

    static fromJS(data: any): SendEmailDpDto {
        let result = new SendEmailDpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookcode"] = this.bookcode;
        data["emailCustomer"] = this.emailCustomer;
        data["namaCustomer"] = this.namaCustomer;
        return data; 
    }
}

export interface ISendEmailDpDto {
    bookcode: string;
    emailCustomer: string;
    namaCustomer: string;
}

export class DocumentKPRListHeaderDto implements IDocumentKPRListHeaderDto {
    latestUploadDateDocumentKPR: moment.Moment;
    documentKPRList: DocumentKPRListDto[];

    constructor(data?: IDocumentKPRListHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.latestUploadDateDocumentKPR = data["latestUploadDateDocumentKPR"] ? moment(data["latestUploadDateDocumentKPR"].toString()) : <any>undefined;
            if (data["documentKPRList"] && data["documentKPRList"].constructor === Array) {
                this.documentKPRList = [];
                for (let item of data["documentKPRList"])
                    this.documentKPRList.push(DocumentKPRListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentKPRListHeaderDto {
        let result = new DocumentKPRListHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestUploadDateDocumentKPR"] = this.latestUploadDateDocumentKPR ? this.latestUploadDateDocumentKPR.toISOString() : <any>undefined;
        if (this.documentKPRList && this.documentKPRList.constructor === Array) {
            data["documentKPRList"] = [];
            for (let item of this.documentKPRList)
                data["documentKPRList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDocumentKPRListHeaderDto {
    latestUploadDateDocumentKPR: moment.Moment;
    documentKPRList: DocumentKPRListDto[];
}

export class DocumentKPRListDto implements IDocumentKPRListDto {
    priorityPassId: number;
    kprtype: number;
    documentType: string;
    documentName: string;
    isMandatory: boolean;
    psCode: string;
    isUploaded: boolean;
    isVerified: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;

    constructor(data?: IDocumentKPRListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.priorityPassId = data["priorityPassId"];
            this.kprtype = data["kprtype"];
            this.documentType = data["documentType"];
            this.documentName = data["documentName"];
            this.isMandatory = data["isMandatory"];
            this.psCode = data["psCode"];
            this.isUploaded = data["isUploaded"];
            this.isVerified = data["isVerified"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentKPRListDto {
        let result = new DocumentKPRListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorityPassId"] = this.priorityPassId;
        data["kprtype"] = this.kprtype;
        data["documentType"] = this.documentType;
        data["documentName"] = this.documentName;
        data["isMandatory"] = this.isMandatory;
        data["psCode"] = this.psCode;
        data["isUploaded"] = this.isUploaded;
        data["isVerified"] = this.isVerified;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDocumentKPRListDto {
    priorityPassId: number;
    kprtype: number;
    documentType: string;
    documentName: string;
    isMandatory: boolean;
    psCode: string;
    isUploaded: boolean;
    isVerified: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment;
}

export class DocumentKPRFileResultDto implements IDocumentKPRFileResultDto {
    documentFile: string;
    documentType: string;

    constructor(data?: IDocumentKPRFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentFile = data["documentFile"];
            this.documentType = data["documentType"];
        }
    }

    static fromJS(data: any): DocumentKPRFileResultDto {
        let result = new DocumentKPRFileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentFile"] = this.documentFile;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IDocumentKPRFileResultDto {
    documentFile: string;
    documentType: string;
}

export class Step23InsertDocumentKPRInputDto implements IStep23InsertDocumentKPRInputDto {
    psCode: string;
    bookingHeaderID: number;

    constructor(data?: IStep23InsertDocumentKPRInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
        }
    }

    static fromJS(data: any): Step23InsertDocumentKPRInputDto {
        let result = new Step23InsertDocumentKPRInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        return data; 
    }
}

export interface IStep23InsertDocumentKPRInputDto {
    psCode: string;
    bookingHeaderID: number;
}

export class DocumentKPRInputDto implements IDocumentKPRInputDto {
    psCode: string;
    bookingHeaderID: number;
    documentType: string;
    documentFile: string;
    documentPicType: string;
    priorityPassId: number;

    constructor(data?: IDocumentKPRInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.documentType = data["documentType"];
            this.documentFile = data["documentFile"];
            this.documentPicType = data["documentPicType"];
            this.priorityPassId = data["priorityPassId"];
        }
    }

    static fromJS(data: any): DocumentKPRInputDto {
        let result = new DocumentKPRInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["documentType"] = this.documentType;
        data["documentFile"] = this.documentFile;
        data["documentPicType"] = this.documentPicType;
        data["priorityPassId"] = this.priorityPassId;
        return data; 
    }
}

export interface IDocumentKPRInputDto {
    psCode: string;
    bookingHeaderID: number;
    documentType: string;
    documentFile: string;
    documentPicType: string;
    priorityPassId: number;
}

export class CreateHistoryViewDocumentDbo implements ICreateHistoryViewDocumentDbo {
    userName: string;
    bookingHeaderId: number;
    priorityPassId: number;

    constructor(data?: ICreateHistoryViewDocumentDbo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.bookingHeaderId = data["bookingHeaderId"];
            this.priorityPassId = data["priorityPassId"];
        }
    }

    static fromJS(data: any): CreateHistoryViewDocumentDbo {
        let result = new CreateHistoryViewDocumentDbo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["priorityPassId"] = this.priorityPassId;
        return data; 
    }
}

export interface ICreateHistoryViewDocumentDbo {
    userName: string;
    bookingHeaderId: number;
    priorityPassId: number;
}

export class CreateHistoryViewDocumentResponse implements ICreateHistoryViewDocumentResponse {
    status: string;
    errorMessage: string;

    constructor(data?: ICreateHistoryViewDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): CreateHistoryViewDocumentResponse {
        let result = new CreateHistoryViewDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface ICreateHistoryViewDocumentResponse {
    status: string;
    errorMessage: string;
}

export class GetHistoryViewDocumentDbo implements IGetHistoryViewDocumentDbo {
    userName: string;
    viewTime: moment.Moment;
    bookingHeaderId: number;
    priorityPassId: number;

    constructor(data?: IGetHistoryViewDocumentDbo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.viewTime = data["viewTime"] ? moment(data["viewTime"].toString()) : <any>undefined;
            this.bookingHeaderId = data["bookingHeaderId"];
            this.priorityPassId = data["priorityPassId"];
        }
    }

    static fromJS(data: any): GetHistoryViewDocumentDbo {
        let result = new GetHistoryViewDocumentDbo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["viewTime"] = this.viewTime ? this.viewTime.toISOString() : <any>undefined;
        data["bookingHeaderId"] = this.bookingHeaderId;
        data["priorityPassId"] = this.priorityPassId;
        return data; 
    }
}

export interface IGetHistoryViewDocumentDbo {
    userName: string;
    viewTime: moment.Moment;
    bookingHeaderId: number;
    priorityPassId: number;
}

export class SendSMSWithAttachmentInputDto implements ISendSMSWithAttachmentInputDto {
    senderId: string;
    subject: string;
    sendDate: string;
    userId: string;
    destPhoneNo: string;
    message: string;
    unitCode: string;
    unitNo: string;
    fileName: string;
    attachment: string;

    constructor(data?: ISendSMSWithAttachmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.senderId = data["senderId"];
            this.subject = data["subject"];
            this.sendDate = data["sendDate"];
            this.userId = data["userId"];
            this.destPhoneNo = data["destPhoneNo"];
            this.message = data["message"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.fileName = data["fileName"];
            this.attachment = data["attachment"];
        }
    }

    static fromJS(data: any): SendSMSWithAttachmentInputDto {
        let result = new SendSMSWithAttachmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderId"] = this.senderId;
        data["subject"] = this.subject;
        data["sendDate"] = this.sendDate;
        data["userId"] = this.userId;
        data["destPhoneNo"] = this.destPhoneNo;
        data["message"] = this.message;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["fileName"] = this.fileName;
        data["attachment"] = this.attachment;
        return data; 
    }
}

export interface ISendSMSWithAttachmentInputDto {
    senderId: string;
    subject: string;
    sendDate: string;
    userId: string;
    destPhoneNo: string;
    message: string;
    unitCode: string;
    unitNo: string;
    fileName: string;
    attachment: string;
}

export class GetOnlinePdfDto implements IGetOnlinePdfDto {
    kota: string;
    todayString: string;
    documentCode: string;
    bankNameString: string;

    constructor(data?: IGetOnlinePdfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kota = data["kota"];
            this.todayString = data["todayString"];
            this.documentCode = data["documentCode"];
            this.bankNameString = data["bankNameString"];
        }
    }

    static fromJS(data: any): GetOnlinePdfDto {
        let result = new GetOnlinePdfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kota"] = this.kota;
        data["todayString"] = this.todayString;
        data["documentCode"] = this.documentCode;
        data["bankNameString"] = this.bankNameString;
        return data; 
    }
}

export interface IGetOnlinePdfDto {
    kota: string;
    todayString: string;
    documentCode: string;
    bankNameString: string;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {};
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;
}

export class GetDataMSClusterPenaltyByIDListDto implements IGetDataMSClusterPenaltyByIDListDto {
    entityID: number;
    clusterPenaltyID: number;
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    bookingPeriodStart: moment.Moment;
    bookingPeriodEnd: moment.Moment;
    penaltyBaseRate: string;
    penaltyFreq: string;
    penaltyRate: number;
    isAutoWaive: boolean;
    autoWaivePeriod: number;
    templateName: string;
    templateStatus: string;
    penaltyDocUrl: string;
    penaltyDocName: string;

    constructor(data?: IGetDataMSClusterPenaltyByIDListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.clusterPenaltyID = data["clusterPenaltyID"];
            this.projectID = data["projectID"];
            this.project = data["project"];
            this.clusterID = data["clusterID"];
            this.cluster = data["cluster"];
            this.bookingPeriodStart = data["bookingPeriodStart"] ? moment(data["bookingPeriodStart"].toString()) : <any>undefined;
            this.bookingPeriodEnd = data["bookingPeriodEnd"] ? moment(data["bookingPeriodEnd"].toString()) : <any>undefined;
            this.penaltyBaseRate = data["penaltyBaseRate"];
            this.penaltyFreq = data["penaltyFreq"];
            this.penaltyRate = data["penaltyRate"];
            this.isAutoWaive = data["isAutoWaive"];
            this.autoWaivePeriod = data["autoWaivePeriod"];
            this.templateName = data["templateName"];
            this.templateStatus = data["templateStatus"];
            this.penaltyDocUrl = data["penaltyDocUrl"];
            this.penaltyDocName = data["penaltyDocName"];
        }
    }

    static fromJS(data: any): GetDataMSClusterPenaltyByIDListDto {
        let result = new GetDataMSClusterPenaltyByIDListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["clusterPenaltyID"] = this.clusterPenaltyID;
        data["projectID"] = this.projectID;
        data["project"] = this.project;
        data["clusterID"] = this.clusterID;
        data["cluster"] = this.cluster;
        data["bookingPeriodStart"] = this.bookingPeriodStart ? this.bookingPeriodStart.toISOString() : <any>undefined;
        data["bookingPeriodEnd"] = this.bookingPeriodEnd ? this.bookingPeriodEnd.toISOString() : <any>undefined;
        data["penaltyBaseRate"] = this.penaltyBaseRate;
        data["penaltyFreq"] = this.penaltyFreq;
        data["penaltyRate"] = this.penaltyRate;
        data["isAutoWaive"] = this.isAutoWaive;
        data["autoWaivePeriod"] = this.autoWaivePeriod;
        data["templateName"] = this.templateName;
        data["templateStatus"] = this.templateStatus;
        data["penaltyDocUrl"] = this.penaltyDocUrl;
        data["penaltyDocName"] = this.penaltyDocName;
        return data; 
    }
}

export interface IGetDataMSClusterPenaltyByIDListDto {
    entityID: number;
    clusterPenaltyID: number;
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    bookingPeriodStart: moment.Moment;
    bookingPeriodEnd: moment.Moment;
    penaltyBaseRate: string;
    penaltyFreq: string;
    penaltyRate: number;
    isAutoWaive: boolean;
    autoWaivePeriod: number;
    templateName: string;
    templateStatus: string;
    penaltyDocUrl: string;
    penaltyDocName: string;
}

export class GetDataMSClusterPenaltyListDto implements IGetDataMSClusterPenaltyListDto {
    clusterPenaltyID: number;
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    bookingPeriodStart: moment.Moment;
    bookingPeriodEnd: moment.Moment;
    penaltyRate: string;
    isAutoWaive: boolean;
    autoWaivePeriod: number;
    penaltyDocUrl: string;
    penaltyDocName: string;

    constructor(data?: IGetDataMSClusterPenaltyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterPenaltyID = data["clusterPenaltyID"];
            this.projectID = data["projectID"];
            this.project = data["project"];
            this.clusterID = data["clusterID"];
            this.cluster = data["cluster"];
            this.bookingPeriodStart = data["bookingPeriodStart"] ? moment(data["bookingPeriodStart"].toString()) : <any>undefined;
            this.bookingPeriodEnd = data["bookingPeriodEnd"] ? moment(data["bookingPeriodEnd"].toString()) : <any>undefined;
            this.penaltyRate = data["penaltyRate"];
            this.isAutoWaive = data["isAutoWaive"];
            this.autoWaivePeriod = data["autoWaivePeriod"];
            this.penaltyDocUrl = data["penaltyDocUrl"];
            this.penaltyDocName = data["penaltyDocName"];
        }
    }

    static fromJS(data: any): GetDataMSClusterPenaltyListDto {
        let result = new GetDataMSClusterPenaltyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterPenaltyID"] = this.clusterPenaltyID;
        data["projectID"] = this.projectID;
        data["project"] = this.project;
        data["clusterID"] = this.clusterID;
        data["cluster"] = this.cluster;
        data["bookingPeriodStart"] = this.bookingPeriodStart ? this.bookingPeriodStart.toISOString() : <any>undefined;
        data["bookingPeriodEnd"] = this.bookingPeriodEnd ? this.bookingPeriodEnd.toISOString() : <any>undefined;
        data["penaltyRate"] = this.penaltyRate;
        data["isAutoWaive"] = this.isAutoWaive;
        data["autoWaivePeriod"] = this.autoWaivePeriod;
        data["penaltyDocUrl"] = this.penaltyDocUrl;
        data["penaltyDocName"] = this.penaltyDocName;
        return data; 
    }
}

export interface IGetDataMSClusterPenaltyListDto {
    clusterPenaltyID: number;
    projectID: number;
    project: string;
    clusterID: number;
    cluster: string;
    bookingPeriodStart: moment.Moment;
    bookingPeriodEnd: moment.Moment;
    penaltyRate: string;
    isAutoWaive: boolean;
    autoWaivePeriod: number;
    penaltyDocUrl: string;
    penaltyDocName: string;
}

export class CreateOrUpdateMsSPPeriodInputDto implements ICreateOrUpdateMsSPPeriodInputDto {
    clusterID: number;
    id: number;
    templateName: string;
    templateStatus: string;
    daysDue: number;
    spGenerateID: number;
    letterTypeID: number;
    kuasaDir1: number;
    kuasaDir2: number;
    accountID: number;
    maturityDays: number;

    constructor(data?: ICreateOrUpdateMsSPPeriodInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.id = data["id"];
            this.templateName = data["templateName"];
            this.templateStatus = data["templateStatus"];
            this.daysDue = data["daysDue"];
            this.spGenerateID = data["spGenerateID"];
            this.letterTypeID = data["letterTypeID"];
            this.kuasaDir1 = data["kuasaDir1"];
            this.kuasaDir2 = data["kuasaDir2"];
            this.accountID = data["accountID"];
            this.maturityDays = data["maturityDays"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMsSPPeriodInputDto {
        let result = new CreateOrUpdateMsSPPeriodInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["templateStatus"] = this.templateStatus;
        data["daysDue"] = this.daysDue;
        data["spGenerateID"] = this.spGenerateID;
        data["letterTypeID"] = this.letterTypeID;
        data["kuasaDir1"] = this.kuasaDir1;
        data["kuasaDir2"] = this.kuasaDir2;
        data["accountID"] = this.accountID;
        data["maturityDays"] = this.maturityDays;
        return data; 
    }
}

export interface ICreateOrUpdateMsSPPeriodInputDto {
    clusterID: number;
    id: number;
    templateName: string;
    templateStatus: string;
    daysDue: number;
    spGenerateID: number;
    letterTypeID: number;
    kuasaDir1: number;
    kuasaDir2: number;
    accountID: number;
    maturityDays: number;
}

export class GetAllMsSPPeriodByClusterListDto implements IGetAllMsSPPeriodByClusterListDto {
    id: number;
    clusterID: number;
    clusterName: string;
    templateName: string;
    templateUrl: string;
    daysDue: number;
    spGenerateID: number;
    spGenerateDesc: string;
    letterTypeID: number;
    letterType: string;
    kuasaDir1: number;
    kuasaDir2: number;
    accountID: number;
    accountCode: string;
    flag: number;
    maturityDays: number;

    constructor(data?: IGetAllMsSPPeriodByClusterListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.templateName = data["templateName"];
            this.templateUrl = data["templateUrl"];
            this.daysDue = data["daysDue"];
            this.spGenerateID = data["spGenerateID"];
            this.spGenerateDesc = data["spGenerateDesc"];
            this.letterTypeID = data["letterTypeID"];
            this.letterType = data["letterType"];
            this.kuasaDir1 = data["kuasaDir1"];
            this.kuasaDir2 = data["kuasaDir2"];
            this.accountID = data["accountID"];
            this.accountCode = data["accountCode"];
            this.flag = data["flag"];
            this.maturityDays = data["maturityDays"];
        }
    }

    static fromJS(data: any): GetAllMsSPPeriodByClusterListDto {
        let result = new GetAllMsSPPeriodByClusterListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["templateName"] = this.templateName;
        data["templateUrl"] = this.templateUrl;
        data["daysDue"] = this.daysDue;
        data["spGenerateID"] = this.spGenerateID;
        data["spGenerateDesc"] = this.spGenerateDesc;
        data["letterTypeID"] = this.letterTypeID;
        data["letterType"] = this.letterType;
        data["kuasaDir1"] = this.kuasaDir1;
        data["kuasaDir2"] = this.kuasaDir2;
        data["accountID"] = this.accountID;
        data["accountCode"] = this.accountCode;
        data["flag"] = this.flag;
        data["maturityDays"] = this.maturityDays;
        return data; 
    }
}

export interface IGetAllMsSPPeriodByClusterListDto {
    id: number;
    clusterID: number;
    clusterName: string;
    templateName: string;
    templateUrl: string;
    daysDue: number;
    spGenerateID: number;
    spGenerateDesc: string;
    letterTypeID: number;
    letterType: string;
    kuasaDir1: number;
    kuasaDir2: number;
    accountID: number;
    accountCode: string;
    flag: number;
    maturityDays: number;
}

export class ListClusterIdInputDto implements IListClusterIdInputDto {
    clusterID: number;

    constructor(data?: IListClusterIdInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
        }
    }

    static fromJS(data: any): ListClusterIdInputDto {
        let result = new ListClusterIdInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        return data; 
    }
}

export interface IListClusterIdInputDto {
    clusterID: number;
}

export class GetDropdownLKLetterTypeListDto implements IGetDropdownLKLetterTypeListDto {
    id: number;
    letterType: string;
    letterDesc: string;
    duration: number;

    constructor(data?: IGetDropdownLKLetterTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.letterType = data["letterType"];
            this.letterDesc = data["letterDesc"];
            this.duration = data["duration"];
        }
    }

    static fromJS(data: any): GetDropdownLKLetterTypeListDto {
        let result = new GetDropdownLKLetterTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["letterType"] = this.letterType;
        data["letterDesc"] = this.letterDesc;
        data["duration"] = this.duration;
        return data; 
    }
}

export interface IGetDropdownLKLetterTypeListDto {
    id: number;
    letterType: string;
    letterDesc: string;
    duration: number;
}

export class GetDropdownLKSPGenerateListDto implements IGetDropdownLKSPGenerateListDto {
    id: number;
    spGenerateDesc: string;

    constructor(data?: IGetDropdownLKSPGenerateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.spGenerateDesc = data["spGenerateDesc"];
        }
    }

    static fromJS(data: any): GetDropdownLKSPGenerateListDto {
        let result = new GetDropdownLKSPGenerateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["spGenerateDesc"] = this.spGenerateDesc;
        return data; 
    }
}

export interface IGetDropdownLKSPGenerateListDto {
    id: number;
    spGenerateDesc: string;
}

export class GetDropdownKuasaDireksiDto implements IGetDropdownKuasaDireksiDto {
    id: number;
    officerName: string;
    isDefault: boolean;

    constructor(data?: IGetDropdownKuasaDireksiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.officerName = data["officerName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): GetDropdownKuasaDireksiDto {
        let result = new GetDropdownKuasaDireksiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["officerName"] = this.officerName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IGetDropdownKuasaDireksiDto {
    id: number;
    officerName: string;
    isDefault: boolean;
}

export class CreateRetentionInputDto implements ICreateRetentionInputDto {
    retentionName: string;
    status: boolean;

    constructor(data?: ICreateRetentionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retentionName = data["retentionName"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CreateRetentionInputDto {
        let result = new CreateRetentionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionName"] = this.retentionName;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICreateRetentionInputDto {
    retentionName: string;
    status: boolean;
}

export class PagedResultDtoOfGetAllSettingRetentionListDto implements IPagedResultDtoOfGetAllSettingRetentionListDto {
    totalCount: number;
    items: GetAllSettingRetentionListDto[];

    constructor(data?: IPagedResultDtoOfGetAllSettingRetentionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllSettingRetentionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSettingRetentionListDto {
        let result = new PagedResultDtoOfGetAllSettingRetentionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllSettingRetentionListDto {
    totalCount: number;
    items: GetAllSettingRetentionListDto[];
}

export class GetAllSettingRetentionListDto implements IGetAllSettingRetentionListDto {
    retentionID: number;
    retentionCode: string;
    retentionName: string;
    status: boolean;

    constructor(data?: IGetAllSettingRetentionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retentionID = data["retentionID"];
            this.retentionCode = data["retentionCode"];
            this.retentionName = data["retentionName"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetAllSettingRetentionListDto {
        let result = new GetAllSettingRetentionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionID"] = this.retentionID;
        data["retentionCode"] = this.retentionCode;
        data["retentionName"] = this.retentionName;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGetAllSettingRetentionListDto {
    retentionID: number;
    retentionCode: string;
    retentionName: string;
    status: boolean;
}

export class UpdateRetentionInputDto implements IUpdateRetentionInputDto {
    retentionID: number;
    retentionName: string;
    status: boolean;

    constructor(data?: IUpdateRetentionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retentionID = data["retentionID"];
            this.retentionName = data["retentionName"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateRetentionInputDto {
        let result = new UpdateRetentionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retentionID"] = this.retentionID;
        data["retentionName"] = this.retentionName;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateRetentionInputDto {
    retentionID: number;
    retentionName: string;
    status: boolean;
}

export class CerateDataInput implements ICerateDataInput {
    input: string;
    isBookingFee: number;
    isConvertOnly: number;
    isRunOut: number;
    isSellOnly: number;

    constructor(data?: ICerateDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.input = data["input"];
            this.isBookingFee = data["isBookingFee"];
            this.isConvertOnly = data["isConvertOnly"];
            this.isRunOut = data["isRunOut"];
            this.isSellOnly = data["isSellOnly"];
        }
    }

    static fromJS(data: any): CerateDataInput {
        let result = new CerateDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        data["isBookingFee"] = this.isBookingFee;
        data["isConvertOnly"] = this.isConvertOnly;
        data["isRunOut"] = this.isRunOut;
        data["isSellOnly"] = this.isSellOnly;
        return data; 
    }
}

export interface ICerateDataInput {
    input: string;
    isBookingFee: number;
    isConvertOnly: number;
    isRunOut: number;
    isSellOnly: number;
}

export class CerateDataFastInput implements ICerateDataFastInput {
    input: string;
    isRefundable: number;
    isTransferable: number;

    constructor(data?: ICerateDataFastInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.input = data["input"];
            this.isRefundable = data["isRefundable"];
            this.isTransferable = data["isTransferable"];
        }
    }

    static fromJS(data: any): CerateDataFastInput {
        let result = new CerateDataFastInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        data["isRefundable"] = this.isRefundable;
        data["isTransferable"] = this.isTransferable;
        return data; 
    }
}

export interface ICerateDataFastInput {
    input: string;
    isRefundable: number;
    isTransferable: number;
}

export class BookDataDto implements IBookDataDto {
    name: string;

    constructor(data?: IBookDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): BookDataDto {
        let result = new BookDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IBookDataDto {
    name: string;
}

export class BookDataFlagDto implements IBookDataFlagDto {
    fastLaneName: string;

    constructor(data?: IBookDataFlagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fastLaneName = data["fastLaneName"];
        }
    }

    static fromJS(data: any): BookDataFlagDto {
        let result = new BookDataFlagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fastLaneName"] = this.fastLaneName;
        return data; 
    }
}

export interface IBookDataFlagDto {
    fastLaneName: string;
}

export class CreateOrUpdateSetupPPDto implements ICreateOrUpdateSetupPPDto {
    batchEntryID: number;
    projectCode: string;
    productCode: string;
    batchCode: string;
    batchNumStart: number;
    batchNumEnd: number;
    maxTopUpFromOldBatch: number;
    topUp: boolean;
    batchPurpose: number;
    isActive: boolean;
    ppAmt: number;
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    priorityLine: boolean;
    listCluster: ClusterOnProductDto[];
    name: string;

    constructor(data?: ICreateOrUpdateSetupPPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchEntryID = data["batchEntryID"];
            this.projectCode = data["projectCode"];
            this.productCode = data["productCode"];
            this.batchCode = data["batchCode"];
            this.batchNumStart = data["batchNumStart"];
            this.batchNumEnd = data["batchNumEnd"];
            this.maxTopUpFromOldBatch = data["maxTopUpFromOldBatch"];
            this.topUp = data["topUp"];
            this.batchPurpose = data["batchPurpose"];
            this.isActive = data["isActive"];
            this.ppAmt = data["ppAmt"];
            this.isRefundable = data["isRefundable"];
            this.isNonRefundable = data["isNonRefundable"];
            this.isTransferable = data["isTransferable"];
            this.isNonTransferable = data["isNonTransferable"];
            this.priorityLine = data["priorityLine"];
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(ClusterOnProductDto.fromJS(item));
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSetupPPDto {
        let result = new CreateOrUpdateSetupPPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchEntryID"] = this.batchEntryID;
        data["projectCode"] = this.projectCode;
        data["productCode"] = this.productCode;
        data["batchCode"] = this.batchCode;
        data["batchNumStart"] = this.batchNumStart;
        data["batchNumEnd"] = this.batchNumEnd;
        data["maxTopUpFromOldBatch"] = this.maxTopUpFromOldBatch;
        data["topUp"] = this.topUp;
        data["batchPurpose"] = this.batchPurpose;
        data["isActive"] = this.isActive;
        data["ppAmt"] = this.ppAmt;
        data["isRefundable"] = this.isRefundable;
        data["isNonRefundable"] = this.isNonRefundable;
        data["isTransferable"] = this.isTransferable;
        data["isNonTransferable"] = this.isNonTransferable;
        data["priorityLine"] = this.priorityLine;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item.toJSON());
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateOrUpdateSetupPPDto {
    batchEntryID: number;
    projectCode: string;
    productCode: string;
    batchCode: string;
    batchNumStart: number;
    batchNumEnd: number;
    maxTopUpFromOldBatch: number;
    topUp: boolean;
    batchPurpose: number;
    isActive: boolean;
    ppAmt: number;
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    priorityLine: boolean;
    listCluster: ClusterOnProductDto[];
    name: string;
}

export class ClusterOnProductDto implements IClusterOnProductDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    projectID: number;
    projectCode: string;
    projectName: string;

    constructor(data?: IClusterOnProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): ClusterOnProductDto {
        let result = new ClusterOnProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IClusterOnProductDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    projectID: number;
    projectCode: string;
    projectName: string;
}

export class GetProjectsListDto implements IGetProjectsListDto {
    projectCode: string;
    projectName: string;

    constructor(data?: IGetProjectsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
        }
    }

    static fromJS(data: any): GetProjectsListDto {
        let result = new GetProjectsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        return data; 
    }
}

export interface IGetProjectsListDto {
    projectCode: string;
    projectName: string;
}

export class GetProjectProductListDto implements IGetProjectProductListDto {
    projectProductID: number;
    projectCode: string;
    productCode: string;
    productName: string;

    constructor(data?: IGetProjectProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectProductID = data["projectProductID"];
            this.projectCode = data["projectCode"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetProjectProductListDto {
        let result = new GetProjectProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectProductID"] = this.projectProductID;
        data["projectCode"] = this.projectCode;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetProjectProductListDto {
    projectProductID: number;
    projectCode: string;
    productCode: string;
    productName: string;
}

export class GetSetupPPListDto implements IGetSetupPPListDto {
    batchEntryID: number;
    projectName: string;
    projectCode: string;
    productName: string;
    productCode: string;
    batchPPCode: string;
    isActive: boolean;
    ppPrice: number;

    constructor(data?: IGetSetupPPListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchEntryID = data["batchEntryID"];
            this.projectName = data["projectName"];
            this.projectCode = data["projectCode"];
            this.productName = data["productName"];
            this.productCode = data["productCode"];
            this.batchPPCode = data["batchPPCode"];
            this.isActive = data["isActive"];
            this.ppPrice = data["ppPrice"];
        }
    }

    static fromJS(data: any): GetSetupPPListDto {
        let result = new GetSetupPPListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchEntryID"] = this.batchEntryID;
        data["projectName"] = this.projectName;
        data["projectCode"] = this.projectCode;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["batchPPCode"] = this.batchPPCode;
        data["isActive"] = this.isActive;
        data["ppPrice"] = this.ppPrice;
        return data; 
    }
}

export interface IGetSetupPPListDto {
    batchEntryID: number;
    projectName: string;
    projectCode: string;
    productName: string;
    productCode: string;
    batchPPCode: string;
    isActive: boolean;
    ppPrice: number;
}

export class GetDetailSetupPPResultDto implements IGetDetailSetupPPResultDto {
    batchID: number;
    projectID: number;
    projectCode: string;
    projectInfoID: number;
    productCode: string;
    batchCode: string;
    batchStartNum: number;
    batchEndNum: number;
    priorityPassPrice: number;
    maxTopUp: number;
    batchPurpose: number;
    isActive: boolean;
    topUp: boolean;
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    priorityLine: boolean;
    listCluster: ClusterOnProductDto[];
    name: string;

    constructor(data?: IGetDetailSetupPPResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchID = data["batchID"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectInfoID = data["projectInfoID"];
            this.productCode = data["productCode"];
            this.batchCode = data["batchCode"];
            this.batchStartNum = data["batchStartNum"];
            this.batchEndNum = data["batchEndNum"];
            this.priorityPassPrice = data["priorityPassPrice"];
            this.maxTopUp = data["maxTopUp"];
            this.batchPurpose = data["batchPurpose"];
            this.isActive = data["isActive"];
            this.topUp = data["topUp"];
            this.isRefundable = data["isRefundable"];
            this.isNonRefundable = data["isNonRefundable"];
            this.isTransferable = data["isTransferable"];
            this.isNonTransferable = data["isNonTransferable"];
            this.priorityLine = data["priorityLine"];
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(ClusterOnProductDto.fromJS(item));
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDetailSetupPPResultDto {
        let result = new GetDetailSetupPPResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchID"] = this.batchID;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectInfoID"] = this.projectInfoID;
        data["productCode"] = this.productCode;
        data["batchCode"] = this.batchCode;
        data["batchStartNum"] = this.batchStartNum;
        data["batchEndNum"] = this.batchEndNum;
        data["priorityPassPrice"] = this.priorityPassPrice;
        data["maxTopUp"] = this.maxTopUp;
        data["batchPurpose"] = this.batchPurpose;
        data["isActive"] = this.isActive;
        data["topUp"] = this.topUp;
        data["isRefundable"] = this.isRefundable;
        data["isNonRefundable"] = this.isNonRefundable;
        data["isTransferable"] = this.isTransferable;
        data["isNonTransferable"] = this.isNonTransferable;
        data["priorityLine"] = this.priorityLine;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item.toJSON());
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDetailSetupPPResultDto {
    batchID: number;
    projectID: number;
    projectCode: string;
    projectInfoID: number;
    productCode: string;
    batchCode: string;
    batchStartNum: number;
    batchEndNum: number;
    priorityPassPrice: number;
    maxTopUp: number;
    batchPurpose: number;
    isActive: boolean;
    topUp: boolean;
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    priorityLine: boolean;
    listCluster: ClusterOnProductDto[];
    name: string;
}

export class PagedResultDtoOfSignificantFinancingTaskListDto implements IPagedResultDtoOfSignificantFinancingTaskListDto {
    totalCount: number;
    items: SignificantFinancingTaskListDto[];

    constructor(data?: IPagedResultDtoOfSignificantFinancingTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SignificantFinancingTaskListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSignificantFinancingTaskListDto {
        let result = new PagedResultDtoOfSignificantFinancingTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSignificantFinancingTaskListDto {
    totalCount: number;
    items: SignificantFinancingTaskListDto[];
}

export class SignificantFinancingTaskListDto implements ISignificantFinancingTaskListDto {
    financingHeaderID: number;
    projectName: string;
    clusterName: string;
    generateDate: moment.Moment;
    percentInterest: number;
    amountInterest: number;
    unitCount: number;

    constructor(data?: ISignificantFinancingTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financingHeaderID = data["financingHeaderID"];
            this.projectName = data["projectName"];
            this.clusterName = data["clusterName"];
            this.generateDate = data["generateDate"] ? moment(data["generateDate"].toString()) : <any>undefined;
            this.percentInterest = data["percentInterest"];
            this.amountInterest = data["amountInterest"];
            this.unitCount = data["unitCount"];
        }
    }

    static fromJS(data: any): SignificantFinancingTaskListDto {
        let result = new SignificantFinancingTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingHeaderID"] = this.financingHeaderID;
        data["projectName"] = this.projectName;
        data["clusterName"] = this.clusterName;
        data["generateDate"] = this.generateDate ? this.generateDate.toISOString() : <any>undefined;
        data["percentInterest"] = this.percentInterest;
        data["amountInterest"] = this.amountInterest;
        data["unitCount"] = this.unitCount;
        return data; 
    }
}

export interface ISignificantFinancingTaskListDto {
    financingHeaderID: number;
    projectName: string;
    clusterName: string;
    generateDate: moment.Moment;
    percentInterest: number;
    amountInterest: number;
    unitCount: number;
}

export class PagedResultDtoOfSignificantFinancingDetailListDto implements IPagedResultDtoOfSignificantFinancingDetailListDto {
    totalCount: number;
    items: SignificantFinancingDetailListDto[];

    constructor(data?: IPagedResultDtoOfSignificantFinancingDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SignificantFinancingDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSignificantFinancingDetailListDto {
        let result = new PagedResultDtoOfSignificantFinancingDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSignificantFinancingDetailListDto {
    totalCount: number;
    items: SignificantFinancingDetailListDto[];
}

export class SignificantFinancingDetailListDto implements ISignificantFinancingDetailListDto {
    bookingHeaderID: number;
    bookCode: string;
    bookDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    projectID: number;
    clusterID: number;
    customerName: string;
    handoverDate: moment.Moment;
    netPayment: number;
    nominalInterest: number;

    constructor(data?: ISignificantFinancingDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.customerName = data["customerName"];
            this.handoverDate = data["handoverDate"] ? moment(data["handoverDate"].toString()) : <any>undefined;
            this.netPayment = data["netPayment"];
            this.nominalInterest = data["nominalInterest"];
        }
    }

    static fromJS(data: any): SignificantFinancingDetailListDto {
        let result = new SignificantFinancingDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["customerName"] = this.customerName;
        data["handoverDate"] = this.handoverDate ? this.handoverDate.toISOString() : <any>undefined;
        data["netPayment"] = this.netPayment;
        data["nominalInterest"] = this.nominalInterest;
        return data; 
    }
}

export interface ISignificantFinancingDetailListDto {
    bookingHeaderID: number;
    bookCode: string;
    bookDate: moment.Moment;
    unitCode: string;
    unitNo: string;
    projectID: number;
    clusterID: number;
    customerName: string;
    handoverDate: moment.Moment;
    netPayment: number;
    nominalInterest: number;
}

export class SignificantFinancingInputDto implements ISignificantFinancingInputDto {
    projectID: number;
    clusterID: number;
    interest: number;

    constructor(data?: ISignificantFinancingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.clusterID = data["clusterID"];
            this.interest = data["interest"];
        }
    }

    static fromJS(data: any): SignificantFinancingInputDto {
        let result = new SignificantFinancingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["clusterID"] = this.clusterID;
        data["interest"] = this.interest;
        return data; 
    }
}

export interface ISignificantFinancingInputDto {
    projectID: number;
    clusterID: number;
    interest: number;
}

export class SiteMapInputDto implements ISiteMapInputDto {
    projectID: number;
    siteMapDir: string;
    viewBox: string;

    constructor(data?: ISiteMapInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.siteMapDir = data["siteMapDir"];
            this.viewBox = data["viewBox"];
        }
    }

    static fromJS(data: any): SiteMapInputDto {
        let result = new SiteMapInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["siteMapDir"] = this.siteMapDir;
        data["viewBox"] = this.viewBox;
        return data; 
    }
}

export interface ISiteMapInputDto {
    projectID: number;
    siteMapDir: string;
    viewBox: string;
}

export class SiteMapViewDto implements ISiteMapViewDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    siteMapID: number;
    siteMapDir: string;
    viewBox: string[];
    products: ProductSiteMapDto[];
    clusters: ProductClusterSiteMapDto[];
    message: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;
    isMapping: boolean;

    constructor(data?: ISiteMapViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.siteMapID = data["siteMapID"];
            this.siteMapDir = data["siteMapDir"];
            if (data["viewBox"] && data["viewBox"].constructor === Array) {
                this.viewBox = [];
                for (let item of data["viewBox"])
                    this.viewBox.push(item);
            }
            if (data["products"] && data["products"].constructor === Array) {
                this.products = [];
                for (let item of data["products"])
                    this.products.push(ProductSiteMapDto.fromJS(item));
            }
            if (data["clusters"] && data["clusters"].constructor === Array) {
                this.clusters = [];
                for (let item of data["clusters"])
                    this.clusters.push(ProductClusterSiteMapDto.fromJS(item));
            }
            this.message = data["message"];
            this.diagramaticType = data["diagramaticType"];
            this.categoryCode = data["categoryCode"];
            this.categoryName = data["categoryName"];
            this.isMapping = data["isMapping"];
        }
    }

    static fromJS(data: any): SiteMapViewDto {
        let result = new SiteMapViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["siteMapID"] = this.siteMapID;
        data["siteMapDir"] = this.siteMapDir;
        if (this.viewBox && this.viewBox.constructor === Array) {
            data["viewBox"] = [];
            for (let item of this.viewBox)
                data["viewBox"].push(item);
        }
        if (this.products && this.products.constructor === Array) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (this.clusters && this.clusters.constructor === Array) {
            data["clusters"] = [];
            for (let item of this.clusters)
                data["clusters"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["diagramaticType"] = this.diagramaticType;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["isMapping"] = this.isMapping;
        return data; 
    }
}

export interface ISiteMapViewDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    siteMapID: number;
    siteMapDir: string;
    viewBox: string[];
    products: ProductSiteMapDto[];
    clusters: ProductClusterSiteMapDto[];
    message: string;
    diagramaticType: string;
    categoryCode: string;
    categoryName: string;
    isMapping: boolean;
}

export class ProductSiteMapDto implements IProductSiteMapDto {
    projectInfoID: number;
    productCode: string;
    productName: string;
    projectStatus: boolean;
    isSitePlanExist: boolean;
    isOBActive: boolean;
    isPPOLActive: boolean;
    displaySetting: string;
    sitePlanImageUrl: string;
    projectDesc: string;
    isMapping: boolean;
    listCluster: ProductClusterSiteMapDto[];

    constructor(data?: IProductSiteMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectInfoID = data["projectInfoID"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.projectStatus = data["projectStatus"];
            this.isSitePlanExist = data["isSitePlanExist"];
            this.isOBActive = data["isOBActive"];
            this.isPPOLActive = data["isPPOLActive"];
            this.displaySetting = data["displaySetting"];
            this.sitePlanImageUrl = data["sitePlanImageUrl"];
            this.projectDesc = data["projectDesc"];
            this.isMapping = data["isMapping"];
            if (data["listCluster"] && data["listCluster"].constructor === Array) {
                this.listCluster = [];
                for (let item of data["listCluster"])
                    this.listCluster.push(ProductClusterSiteMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSiteMapDto {
        let result = new ProductSiteMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectInfoID"] = this.projectInfoID;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["projectStatus"] = this.projectStatus;
        data["isSitePlanExist"] = this.isSitePlanExist;
        data["isOBActive"] = this.isOBActive;
        data["isPPOLActive"] = this.isPPOLActive;
        data["displaySetting"] = this.displaySetting;
        data["sitePlanImageUrl"] = this.sitePlanImageUrl;
        data["projectDesc"] = this.projectDesc;
        data["isMapping"] = this.isMapping;
        if (this.listCluster && this.listCluster.constructor === Array) {
            data["listCluster"] = [];
            for (let item of this.listCluster)
                data["listCluster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductSiteMapDto {
    projectInfoID: number;
    productCode: string;
    productName: string;
    projectStatus: boolean;
    isSitePlanExist: boolean;
    isOBActive: boolean;
    isPPOLActive: boolean;
    displaySetting: string;
    sitePlanImageUrl: string;
    projectDesc: string;
    isMapping: boolean;
    listCluster: ProductClusterSiteMapDto[];
}

export class ProductClusterSiteMapDto implements IProductClusterSiteMapDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    diagramaticType: string;
    isMapping: boolean;
    units: UnitSitePlanAllDto[];

    constructor(data?: IProductClusterSiteMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterCode = data["clusterCode"];
            this.clusterName = data["clusterName"];
            this.diagramaticType = data["diagramaticType"];
            this.isMapping = data["isMapping"];
            if (data["units"] && data["units"].constructor === Array) {
                this.units = [];
                for (let item of data["units"])
                    this.units.push(UnitSitePlanAllDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductClusterSiteMapDto {
        let result = new ProductClusterSiteMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterCode"] = this.clusterCode;
        data["clusterName"] = this.clusterName;
        data["diagramaticType"] = this.diagramaticType;
        data["isMapping"] = this.isMapping;
        if (this.units && this.units.constructor === Array) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductClusterSiteMapDto {
    clusterID: number;
    clusterCode: string;
    clusterName: string;
    diagramaticType: string;
    isMapping: boolean;
    units: UnitSitePlanAllDto[];
}

export class UnitSitePlanAllDto implements IUnitSitePlanAllDto {
    svgID: string;
    unitStatusCode: string;
    unitStatusName: string;
    isAvailableOnOtherFloor: boolean;

    constructor(data?: IUnitSitePlanAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.svgID = data["svgID"];
            this.unitStatusCode = data["unitStatusCode"];
            this.unitStatusName = data["unitStatusName"];
            this.isAvailableOnOtherFloor = data["isAvailableOnOtherFloor"];
        }
    }

    static fromJS(data: any): UnitSitePlanAllDto {
        let result = new UnitSitePlanAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["svgID"] = this.svgID;
        data["unitStatusCode"] = this.unitStatusCode;
        data["unitStatusName"] = this.unitStatusName;
        data["isAvailableOnOtherFloor"] = this.isAvailableOnOtherFloor;
        return data; 
    }
}

export interface IUnitSitePlanAllDto {
    svgID: string;
    unitStatusCode: string;
    unitStatusName: string;
    isAvailableOnOtherFloor: boolean;
}

export class SitePlanInputDto implements ISitePlanInputDto {
    diagramaticType: string;
    clusterID: number;
    projectInfoID: number;
    sitePlanDir: string;
    viewBox: string;

    constructor(data?: ISitePlanInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.diagramaticType = data["diagramaticType"];
            this.clusterID = data["clusterID"];
            this.projectInfoID = data["projectInfoID"];
            this.sitePlanDir = data["sitePlanDir"];
            this.viewBox = data["viewBox"];
        }
    }

    static fromJS(data: any): SitePlanInputDto {
        let result = new SitePlanInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diagramaticType"] = this.diagramaticType;
        data["clusterID"] = this.clusterID;
        data["projectInfoID"] = this.projectInfoID;
        data["sitePlanDir"] = this.sitePlanDir;
        data["viewBox"] = this.viewBox;
        return data; 
    }
}

export interface ISitePlanInputDto {
    diagramaticType: string;
    clusterID: number;
    projectInfoID: number;
    sitePlanDir: string;
    viewBox: string;
}

export class CreateOrUpdateMainSwingDto implements ICreateOrUpdateMainSwingDto {
    mainSwingID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    mainSwingCode: string;
    mainSwingName: string;
    termMainCode: string;
    termMainID: number;

    constructor(data?: ICreateOrUpdateMainSwingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainSwingID = data["mainSwingID"];
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.mainSwingCode = data["mainSwingCode"];
            this.mainSwingName = data["mainSwingName"];
            this.termMainCode = data["termMainCode"];
            this.termMainID = data["termMainID"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMainSwingDto {
        let result = new CreateOrUpdateMainSwingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainSwingID"] = this.mainSwingID;
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["mainSwingCode"] = this.mainSwingCode;
        data["mainSwingName"] = this.mainSwingName;
        data["termMainCode"] = this.termMainCode;
        data["termMainID"] = this.termMainID;
        return data; 
    }
}

export interface ICreateOrUpdateMainSwingDto {
    mainSwingID: number;
    projectID: number;
    projectCode: string;
    projectName: string;
    mainSwingCode: string;
    mainSwingName: string;
    termMainCode: string;
    termMainID: number;
}

export class DropdownMainSwingDto implements IDropdownMainSwingDto {
    mainSwingID: number;
    mainSwingCode: string;
    mainSwingName: string;

    constructor(data?: IDropdownMainSwingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mainSwingID = data["mainSwingID"];
            this.mainSwingCode = data["mainSwingCode"];
            this.mainSwingName = data["mainSwingName"];
        }
    }

    static fromJS(data: any): DropdownMainSwingDto {
        let result = new DropdownMainSwingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainSwingID"] = this.mainSwingID;
        data["mainSwingCode"] = this.mainSwingCode;
        data["mainSwingName"] = this.mainSwingName;
        return data; 
    }
}

export interface IDropdownMainSwingDto {
    mainSwingID: number;
    mainSwingCode: string;
    mainSwingName: string;
}

export class CreateOrUpdateSwingDto implements ICreateOrUpdateSwingDto {
    swingID: number;
    mainSwingID: number;
    fromTermID: number;
    toTermID: number;
    swingPercentage: number;

    constructor(data?: ICreateOrUpdateSwingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.swingID = data["swingID"];
            this.mainSwingID = data["mainSwingID"];
            this.fromTermID = data["fromTermID"];
            this.toTermID = data["toTermID"];
            this.swingPercentage = data["swingPercentage"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSwingDto {
        let result = new CreateOrUpdateSwingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swingID"] = this.swingID;
        data["mainSwingID"] = this.mainSwingID;
        data["fromTermID"] = this.fromTermID;
        data["toTermID"] = this.toTermID;
        data["swingPercentage"] = this.swingPercentage;
        return data; 
    }
}

export interface ICreateOrUpdateSwingDto {
    swingID: number;
    mainSwingID: number;
    fromTermID: number;
    toTermID: number;
    swingPercentage: number;
}

export class GetDetailSwingDto implements IGetDetailSwingDto {
    projectID: number;
    mainSwingID: number;
    mainSwingCode: string;
    mainSwingName: string;
    termMainID: number;
    listSwing: CreateOrUpdateSwingDto[];

    constructor(data?: IGetDetailSwingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.mainSwingID = data["mainSwingID"];
            this.mainSwingCode = data["mainSwingCode"];
            this.mainSwingName = data["mainSwingName"];
            this.termMainID = data["termMainID"];
            if (data["listSwing"] && data["listSwing"].constructor === Array) {
                this.listSwing = [];
                for (let item of data["listSwing"])
                    this.listSwing.push(CreateOrUpdateSwingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDetailSwingDto {
        let result = new GetDetailSwingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["mainSwingID"] = this.mainSwingID;
        data["mainSwingCode"] = this.mainSwingCode;
        data["mainSwingName"] = this.mainSwingName;
        data["termMainID"] = this.termMainID;
        if (this.listSwing && this.listSwing.constructor === Array) {
            data["listSwing"] = [];
            for (let item of this.listSwing)
                data["listSwing"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDetailSwingDto {
    projectID: number;
    mainSwingID: number;
    mainSwingCode: string;
    mainSwingName: string;
    termMainID: number;
    listSwing: CreateOrUpdateSwingDto[];
}

export class SyncCustomerDto implements ISyncCustomerDto {
    psCode: string;
    syncMethod: string;
    idUpdatePotential: number;
    jsonData: string;

    constructor(data?: ISyncCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.syncMethod = data["syncMethod"];
            this.idUpdatePotential = data["idUpdatePotential"];
            this.jsonData = data["jsonData"];
        }
    }

    static fromJS(data: any): SyncCustomerDto {
        let result = new SyncCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["syncMethod"] = this.syncMethod;
        data["idUpdatePotential"] = this.idUpdatePotential;
        data["jsonData"] = this.jsonData;
        return data; 
    }
}

export interface ISyncCustomerDto {
    psCode: string;
    syncMethod: string;
    idUpdatePotential: number;
    jsonData: string;
}

export class GetTaskListResultDto implements IGetTaskListResultDto {
    unitCode: string;
    unitNo: string;
    nameCust: string;
    creationTime: moment.Moment;
    psCode: string;
    content: string;

    constructor(data?: IGetTaskListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.nameCust = data["nameCust"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.psCode = data["psCode"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): GetTaskListResultDto {
        let result = new GetTaskListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["nameCust"] = this.nameCust;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["psCode"] = this.psCode;
        data["content"] = this.content;
        return data; 
    }
}

export interface IGetTaskListResultDto {
    unitCode: string;
    unitNo: string;
    nameCust: string;
    creationTime: moment.Moment;
    psCode: string;
    content: string;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    id: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    id: number;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    id: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[] = [];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities: MemberActivity[];

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                for (let item of data["memberActivities"])
                    this.memberActivities.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[];
}

export class MemberActivity implements IMemberActivity {
    name: string;
    earnings: string;
    cases: number;
    closed: number;
    rate: string;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IMemberActivity {
    name: string;
    earnings: string;
    cases: number;
    closed: number;
    rate: string;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[];
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[];
    profitShares: number[];

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                for (let item of data["dailySales"])
                    this.dailySales.push(item);
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                for (let item of data["profitShares"])
                    this.profitShares.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data; 
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[];
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[];
    profitShares: number[];
}

export class SalesSummaryData implements ISalesSummaryData {
    period: string;
    sales: number;
    profit: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ISalesSummaryData {
    period: string;
    sales: number;
    profit: number;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[];

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[];
}

export class GetWorldMapOutput implements IGetWorldMapOutput {
    countries: WorldMapCountry[];

    constructor(data?: IGetWorldMapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["countries"] && data["countries"].constructor === Array) {
                this.countries = [];
                for (let item of data["countries"])
                    this.countries.push(WorldMapCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldMapOutput {
        let result = new GetWorldMapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countries && this.countries.constructor === Array) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWorldMapOutput {
    countries: WorldMapCountry[];
}

export class WorldMapCountry implements IWorldMapCountry {
    countryName: string;
    color: number;

    constructor(data?: IWorldMapCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryName = data["countryName"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): WorldMapCountry {
        let result = new WorldMapCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["color"] = this.color;
        return data; 
    }
}

export interface IWorldMapCountry {
    countryName: string;
    color: number;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    paymentId: string;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.paymentId = data["paymentId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["paymentId"] = this.paymentId;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    paymentId: string;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (let item of data["allFeatures"])
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];
}

export class IInputType implements IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto = new TenantUserManagementSettingsEditDto();
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: TenantBillingSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items: NameValueDto[];

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[];
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    domainLogin: string;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.domainLogin = data["domainLogin"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["domainLogin"] = this.domainLogin;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    domainLogin: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    propertySystemApps: string;
    bankPortalApps: string;
    commisionApps: string;
    creditManagementApps: string;
    personalsApps: string;
    salesWebApps: string;
    ipAddress: string;
    psCode: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    email: string;
    isLogin: boolean;
    canKick: boolean;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.propertySystemApps = data["propertySystemApps"];
            this.bankPortalApps = data["bankPortalApps"];
            this.commisionApps = data["commisionApps"];
            this.creditManagementApps = data["creditManagementApps"];
            this.personalsApps = data["personalsApps"];
            this.salesWebApps = data["salesWebApps"];
            this.ipAddress = data["ipAddress"];
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.email = data["email"];
            this.isLogin = data["isLogin"];
            this.canKick = data["canKick"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["propertySystemApps"] = this.propertySystemApps;
        data["bankPortalApps"] = this.bankPortalApps;
        data["commisionApps"] = this.commisionApps;
        data["creditManagementApps"] = this.creditManagementApps;
        data["personalsApps"] = this.personalsApps;
        data["salesWebApps"] = this.salesWebApps;
        data["ipAddress"] = this.ipAddress;
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["email"] = this.email;
        data["isLogin"] = this.isLogin;
        data["canKick"] = this.canKick;
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
    propertySystemApps: string;
    bankPortalApps: string;
    commisionApps: string;
    creditManagementApps: string;
    personalsApps: string;
    salesWebApps: string;
    ipAddress: string;
    psCode: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    email: string;
    isLogin: boolean;
    canKick: boolean;
}

export class LoginMemberInputModel implements ILoginMemberInputModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    domainLogin: string;

    constructor(data?: ILoginMemberInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.domainLogin = data["domainLogin"];
        }
    }

    static fromJS(data: any): LoginMemberInputModel {
        let result = new LoginMemberInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["domainLogin"] = this.domainLogin;
        return data; 
    }
}

export interface ILoginMemberInputModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
    domainLogin: string;
}

export class LoginMemberMobileDto implements ILoginMemberMobileDto {
    accessToken: string;
    psCode: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    userId: number;
    birthDate: moment.Moment;
    email: string;

    constructor(data?: ILoginMemberMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.psCode = data["psCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.userId = data["userId"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.email = data["email"];
        }
    }

    static fromJS(data: any): LoginMemberMobileDto {
        let result = new LoginMemberMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["psCode"] = this.psCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["userId"] = this.userId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        return data; 
    }
}

export interface ILoginMemberMobileDto {
    accessToken: string;
    psCode: string;
    memberCode: string;
    memberName: string;
    scmCode: string;
    userId: number;
    birthDate: moment.Moment;
    email: string;
}

export class LogoutMemberInputDto implements ILogoutMemberInputDto {
    memberCode: string;

    constructor(data?: ILogoutMemberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): LogoutMemberInputDto {
        let result = new LogoutMemberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        return data; 
    }
}

export interface ILogoutMemberInputDto {
    memberCode: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;
}

export class GetUpdateAddressInputDto implements IGetUpdateAddressInputDto {
    psCode: string;
    refID: number;
    addrType: string;
    address: string;
    city: string;
    kelurahan: string;
    kecamatan: string;
    postCode: string;
    country: string;

    constructor(data?: IGetUpdateAddressInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.addrType = data["addrType"];
            this.address = data["address"];
            this.city = data["city"];
            this.kelurahan = data["kelurahan"];
            this.kecamatan = data["kecamatan"];
            this.postCode = data["postCode"];
            this.country = data["country"];
        }
    }

    static fromJS(data: any): GetUpdateAddressInputDto {
        let result = new GetUpdateAddressInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["addrType"] = this.addrType;
        data["address"] = this.address;
        data["city"] = this.city;
        data["kelurahan"] = this.kelurahan;
        data["kecamatan"] = this.kecamatan;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        return data; 
    }
}

export interface IGetUpdateAddressInputDto {
    psCode: string;
    refID: number;
    addrType: string;
    address: string;
    city: string;
    kelurahan: string;
    kecamatan: string;
    postCode: string;
    country: string;
}

export class GenerateTTBFResultDto implements IGenerateTTBFResultDto {
    url: string;
    path: string;
    dataTTBF: GenerateTTBFInputDto[];
    totalAmountTTBF: string;
    emailDealCloser: string;
    fileName: string;

    constructor(data?: IGenerateTTBFResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.path = data["path"];
            if (data["dataTTBF"] && data["dataTTBF"].constructor === Array) {
                this.dataTTBF = [];
                for (let item of data["dataTTBF"])
                    this.dataTTBF.push(GenerateTTBFInputDto.fromJS(item));
            }
            this.totalAmountTTBF = data["totalAmountTTBF"];
            this.emailDealCloser = data["emailDealCloser"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): GenerateTTBFResultDto {
        let result = new GenerateTTBFResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["path"] = this.path;
        if (this.dataTTBF && this.dataTTBF.constructor === Array) {
            data["dataTTBF"] = [];
            for (let item of this.dataTTBF)
                data["dataTTBF"].push(item.toJSON());
        }
        data["totalAmountTTBF"] = this.totalAmountTTBF;
        data["emailDealCloser"] = this.emailDealCloser;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface IGenerateTTBFResultDto {
    url: string;
    path: string;
    dataTTBF: GenerateTTBFInputDto[];
    totalAmountTTBF: string;
    emailDealCloser: string;
    fileName: string;
}

export class GetSchedulerListDto implements IGetSchedulerListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    pctTax: number;
    dataPayment: DataPaymentsListDto[];

    constructor(data?: IGetSchedulerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocID = data["allocID"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.allocCode = data["allocCode"];
            this.netAmount = data["netAmount"];
            this.vatAmount = data["vatAmount"];
            this.totalAmount = data["totalAmount"];
            this.netOutstanding = data["netOutstanding"];
            this.vatOutstanding = data["vatOutstanding"];
            this.paymentAmount = data["paymentAmount"];
            this.totalOutstanding = data["totalOutstanding"];
            this.schedNo = data["schedNo"];
            this.remarks = data["remarks"];
            this.pctTax = data["pctTax"];
            if (data["dataPayment"] && data["dataPayment"].constructor === Array) {
                this.dataPayment = [];
                for (let item of data["dataPayment"])
                    this.dataPayment.push(DataPaymentsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSchedulerListDto {
        let result = new GetSchedulerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocID"] = this.allocID;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["allocCode"] = this.allocCode;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["netOutstanding"] = this.netOutstanding;
        data["vatOutstanding"] = this.vatOutstanding;
        data["paymentAmount"] = this.paymentAmount;
        data["totalOutstanding"] = this.totalOutstanding;
        data["schedNo"] = this.schedNo;
        data["remarks"] = this.remarks;
        data["pctTax"] = this.pctTax;
        if (this.dataPayment && this.dataPayment.constructor === Array) {
            data["dataPayment"] = [];
            for (let item of this.dataPayment)
                data["dataPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSchedulerListDto {
    allocID: number;
    dueDate: moment.Moment;
    allocCode: string;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
    netOutstanding: number;
    vatOutstanding: number;
    paymentAmount: number;
    totalOutstanding: number;
    schedNo: number;
    remarks: string;
    pctTax: number;
    dataPayment: DataPaymentsListDto[];
}

export class DataPaymentsListDto implements IDataPaymentsListDto {
    clearDate: moment.Moment;
    transNo: string;
    payNo: number;
    payType: string;
    otherType: string;
    netAmountPayment: number;
    vatAmountPayment: number;
    totalAmountPayment: number;

    constructor(data?: IDataPaymentsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clearDate = data["clearDate"] ? moment(data["clearDate"].toString()) : <any>undefined;
            this.transNo = data["transNo"];
            this.payNo = data["payNo"];
            this.payType = data["payType"];
            this.otherType = data["otherType"];
            this.netAmountPayment = data["netAmountPayment"];
            this.vatAmountPayment = data["vatAmountPayment"];
            this.totalAmountPayment = data["totalAmountPayment"];
        }
    }

    static fromJS(data: any): DataPaymentsListDto {
        let result = new DataPaymentsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clearDate"] = this.clearDate ? this.clearDate.toISOString() : <any>undefined;
        data["transNo"] = this.transNo;
        data["payNo"] = this.payNo;
        data["payType"] = this.payType;
        data["otherType"] = this.otherType;
        data["netAmountPayment"] = this.netAmountPayment;
        data["vatAmountPayment"] = this.vatAmountPayment;
        data["totalAmountPayment"] = this.totalAmountPayment;
        return data; 
    }
}

export interface IDataPaymentsListDto {
    clearDate: moment.Moment;
    transNo: string;
    payNo: number;
    payType: string;
    otherType: string;
    netAmountPayment: number;
    vatAmountPayment: number;
    totalAmountPayment: number;
}

export class GetRoundingScheduleResultDto implements IGetRoundingScheduleResultDto {
    beforeAmount: number;
    currentAmount: number;
    afterAmount: number;
    sellingPrice: number;
    newSchedule: GetScheduleCompListDto[];
    oldSchedule: GetScheduleCompListDto[];

    constructor(data?: IGetRoundingScheduleResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beforeAmount = data["beforeAmount"];
            this.currentAmount = data["currentAmount"];
            this.afterAmount = data["afterAmount"];
            this.sellingPrice = data["sellingPrice"];
            if (data["newSchedule"] && data["newSchedule"].constructor === Array) {
                this.newSchedule = [];
                for (let item of data["newSchedule"])
                    this.newSchedule.push(GetScheduleCompListDto.fromJS(item));
            }
            if (data["oldSchedule"] && data["oldSchedule"].constructor === Array) {
                this.oldSchedule = [];
                for (let item of data["oldSchedule"])
                    this.oldSchedule.push(GetScheduleCompListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRoundingScheduleResultDto {
        let result = new GetRoundingScheduleResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beforeAmount"] = this.beforeAmount;
        data["currentAmount"] = this.currentAmount;
        data["afterAmount"] = this.afterAmount;
        data["sellingPrice"] = this.sellingPrice;
        if (this.newSchedule && this.newSchedule.constructor === Array) {
            data["newSchedule"] = [];
            for (let item of this.newSchedule)
                data["newSchedule"].push(item.toJSON());
        }
        if (this.oldSchedule && this.oldSchedule.constructor === Array) {
            data["oldSchedule"] = [];
            for (let item of this.oldSchedule)
                data["oldSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetRoundingScheduleResultDto {
    beforeAmount: number;
    currentAmount: number;
    afterAmount: number;
    sellingPrice: number;
    newSchedule: GetScheduleCompListDto[];
    oldSchedule: GetScheduleCompListDto[];
}

export class GetScheduleCompListDto implements IGetScheduleCompListDto {
    allocCode: string;
    schedNo: number;
    netAmt: number;
    vatAmt: number;
    total: number;
    lebih: number;

    constructor(data?: IGetScheduleCompListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allocCode = data["allocCode"];
            this.schedNo = data["schedNo"];
            this.netAmt = data["netAmt"];
            this.vatAmt = data["vatAmt"];
            this.total = data["total"];
            this.lebih = data["lebih"];
        }
    }

    static fromJS(data: any): GetScheduleCompListDto {
        let result = new GetScheduleCompListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocCode"] = this.allocCode;
        data["schedNo"] = this.schedNo;
        data["netAmt"] = this.netAmt;
        data["vatAmt"] = this.vatAmt;
        data["total"] = this.total;
        data["lebih"] = this.lebih;
        return data; 
    }
}

export interface IGetScheduleCompListDto {
    allocCode: string;
    schedNo: number;
    netAmt: number;
    vatAmt: number;
    total: number;
    lebih: number;
}

export class RoundingScheduleResult implements IRoundingScheduleResult {
    bookCode: string;
    isProcess: boolean;
    scheduleCount: number;
    beforeAmount: number;
    afterAmount: number;
    sellingPrice: number;

    constructor(data?: IRoundingScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.isProcess = data["isProcess"];
            this.scheduleCount = data["scheduleCount"];
            this.beforeAmount = data["beforeAmount"];
            this.afterAmount = data["afterAmount"];
            this.sellingPrice = data["sellingPrice"];
        }
    }

    static fromJS(data: any): RoundingScheduleResult {
        let result = new RoundingScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["isProcess"] = this.isProcess;
        data["scheduleCount"] = this.scheduleCount;
        data["beforeAmount"] = this.beforeAmount;
        data["afterAmount"] = this.afterAmount;
        data["sellingPrice"] = this.sellingPrice;
        return data; 
    }
}

export interface IRoundingScheduleResult {
    bookCode: string;
    isProcess: boolean;
    scheduleCount: number;
    beforeAmount: number;
    afterAmount: number;
    sellingPrice: number;
}

export class TrUnitOrderHeaderResultDto implements ITrUnitOrderHeaderResultDto {
    unitOrderHeaderID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    orderCode: string;
    result: boolean;
    message: string;

    constructor(data?: ITrUnitOrderHeaderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
            this.orderCode = data["orderCode"];
            this.result = data["result"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): TrUnitOrderHeaderResultDto {
        let result = new TrUnitOrderHeaderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        data["orderCode"] = this.orderCode;
        data["result"] = this.result;
        data["message"] = this.message;
        return data; 
    }
}

export interface ITrUnitOrderHeaderResultDto {
    unitOrderHeaderID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
    orderCode: string;
    result: boolean;
    message: string;
}

export class CreateLogMobeyInputDto implements ICreateLogMobeyInputDto {
    orderCode: string;
    status: string;
    messageError: string;
    transactionTime: string;
    transactionReference: string;
    isVoid: boolean;
    voidTime: string;

    constructor(data?: ICreateLogMobeyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.status = data["status"];
            this.messageError = data["messageError"];
            this.transactionTime = data["transactionTime"];
            this.transactionReference = data["transactionReference"];
            this.isVoid = data["isVoid"];
            this.voidTime = data["voidTime"];
        }
    }

    static fromJS(data: any): CreateLogMobeyInputDto {
        let result = new CreateLogMobeyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["status"] = this.status;
        data["messageError"] = this.messageError;
        data["transactionTime"] = this.transactionTime;
        data["transactionReference"] = this.transactionReference;
        data["isVoid"] = this.isVoid;
        data["voidTime"] = this.voidTime;
        return data; 
    }
}

export interface ICreateLogMobeyInputDto {
    orderCode: string;
    status: string;
    messageError: string;
    transactionTime: string;
    transactionReference: string;
    isVoid: boolean;
    voidTime: string;
}

export class ListResultDtoOfGetListNotaris implements IListResultDtoOfGetListNotaris {
    items: GetListNotaris[];

    constructor(data?: IListResultDtoOfGetListNotaris) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListNotaris.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetListNotaris {
        let result = new ListResultDtoOfGetListNotaris();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetListNotaris {
    items: GetListNotaris[];
}

export class GetListNotaris implements IGetListNotaris {
    notarisId: number;
    notarisName: string;

    constructor(data?: IGetListNotaris) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notarisId = data["notarisId"];
            this.notarisName = data["notarisName"];
        }
    }

    static fromJS(data: any): GetListNotaris {
        let result = new GetListNotaris();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notarisId"] = this.notarisId;
        data["notarisName"] = this.notarisName;
        return data; 
    }
}

export interface IGetListNotaris {
    notarisId: number;
    notarisName: string;
}

export class InsertTRUnitReservedInputDto implements IInsertTRUnitReservedInputDto {
    unitID: number;
    clusterID: number;
    userID: number;
    psCode: string;
    renovID: number;
    sellingPrice: number;
    projectID: number;
    termID: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    alihdana: boolean;
    campaignHeaderID: number[];
    marketingProgram: number;
    location: string;
    bankProgram: number;
    closeProgram: number;
    specialProgram: number;
    moveInProgram: number;
    rewards: number[];

    constructor(data?: IInsertTRUnitReservedInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.clusterID = data["clusterID"];
            this.userID = data["userID"];
            this.psCode = data["psCode"];
            this.renovID = data["renovID"];
            this.sellingPrice = data["sellingPrice"];
            this.projectID = data["projectID"];
            this.termID = data["termID"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppNo = data["ppNo"];
            this.alihdana = data["alihdana"];
            if (data["campaignHeaderID"] && data["campaignHeaderID"].constructor === Array) {
                this.campaignHeaderID = [];
                for (let item of data["campaignHeaderID"])
                    this.campaignHeaderID.push(item);
            }
            this.marketingProgram = data["marketingProgram"];
            this.location = data["location"];
            this.bankProgram = data["bankProgram"];
            this.closeProgram = data["closeProgram"];
            this.specialProgram = data["specialProgram"];
            this.moveInProgram = data["moveInProgram"];
            if (data["rewards"] && data["rewards"].constructor === Array) {
                this.rewards = [];
                for (let item of data["rewards"])
                    this.rewards.push(item);
            }
        }
    }

    static fromJS(data: any): InsertTRUnitReservedInputDto {
        let result = new InsertTRUnitReservedInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["clusterID"] = this.clusterID;
        data["userID"] = this.userID;
        data["psCode"] = this.psCode;
        data["renovID"] = this.renovID;
        data["sellingPrice"] = this.sellingPrice;
        data["projectID"] = this.projectID;
        data["termID"] = this.termID;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppNo"] = this.ppNo;
        data["alihdana"] = this.alihdana;
        if (this.campaignHeaderID && this.campaignHeaderID.constructor === Array) {
            data["campaignHeaderID"] = [];
            for (let item of this.campaignHeaderID)
                data["campaignHeaderID"].push(item);
        }
        data["marketingProgram"] = this.marketingProgram;
        data["location"] = this.location;
        data["bankProgram"] = this.bankProgram;
        data["closeProgram"] = this.closeProgram;
        data["specialProgram"] = this.specialProgram;
        data["moveInProgram"] = this.moveInProgram;
        if (this.rewards && this.rewards.constructor === Array) {
            data["rewards"] = [];
            for (let item of this.rewards)
                data["rewards"].push(item);
        }
        return data; 
    }
}

export interface IInsertTRUnitReservedInputDto {
    unitID: number;
    clusterID: number;
    userID: number;
    psCode: string;
    renovID: number;
    sellingPrice: number;
    projectID: number;
    termID: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    alihdana: boolean;
    campaignHeaderID: number[];
    marketingProgram: number;
    location: string;
    bankProgram: number;
    closeProgram: number;
    specialProgram: number;
    moveInProgram: number;
    rewards: number[];
}

export class InsertTrUnitReservedResultDto implements IInsertTrUnitReservedResultDto {
    message: string;
    result: boolean;

    constructor(data?: IInsertTrUnitReservedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): InsertTrUnitReservedResultDto {
        let result = new InsertTrUnitReservedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface IInsertTrUnitReservedResultDto {
    message: string;
    result: boolean;
}

export class UpdateTRUnitReserved implements IUpdateTRUnitReserved {
    psCode: string;
    userID: number;
    bankID1: number;
    bankID2: number;
    unit: UnitTrUnitReservedDto[];

    constructor(data?: IUpdateTRUnitReserved) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.userID = data["userID"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(UnitTrUnitReservedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTRUnitReserved {
        let result = new UpdateTRUnitReserved();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["userID"] = this.userID;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTRUnitReserved {
    psCode: string;
    userID: number;
    bankID1: number;
    bankID2: number;
    unit: UnitTrUnitReservedDto[];
}

export class UnitTrUnitReservedDto implements IUnitTrUnitReservedDto {
    unitID: number;

    constructor(data?: IUnitTrUnitReservedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
        }
    }

    static fromJS(data: any): UnitTrUnitReservedDto {
        let result = new UnitTrUnitReservedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        return data; 
    }
}

export interface IUnitTrUnitReservedDto {
    unitID: number;
}

export class ListDetailBookingUnitResultDto implements IListDetailBookingUnitResultDto {
    unit: ListUnit[];
    amountToBePaid: number;
    customer: GetCustomer;
    dpAmount: number;
    pelunasanAmount: number;
    message: string;
    includeVat: boolean;

    constructor(data?: IListDetailBookingUnitResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["unit"] && data["unit"].constructor === Array) {
                this.unit = [];
                for (let item of data["unit"])
                    this.unit.push(ListUnit.fromJS(item));
            }
            this.amountToBePaid = data["amountToBePaid"];
            this.customer = data["customer"] ? GetCustomer.fromJS(data["customer"]) : <any>undefined;
            this.dpAmount = data["dpAmount"];
            this.pelunasanAmount = data["pelunasanAmount"];
            this.message = data["message"];
            this.includeVat = data["includeVat"];
        }
    }

    static fromJS(data: any): ListDetailBookingUnitResultDto {
        let result = new ListDetailBookingUnitResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.unit && this.unit.constructor === Array) {
            data["unit"] = [];
            for (let item of this.unit)
                data["unit"].push(item.toJSON());
        }
        data["amountToBePaid"] = this.amountToBePaid;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["dpAmount"] = this.dpAmount;
        data["pelunasanAmount"] = this.pelunasanAmount;
        data["message"] = this.message;
        data["includeVat"] = this.includeVat;
        return data; 
    }
}

export interface IListDetailBookingUnitResultDto {
    unit: ListUnit[];
    amountToBePaid: number;
    customer: GetCustomer;
    dpAmount: number;
    pelunasanAmount: number;
    message: string;
    includeVat: boolean;
}

export class ListUnit implements IListUnit {
    projectID: number;
    projectCode: string;
    projectName: string;
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isRequiredPP: boolean;
    includeVat: boolean;
    alihdana: boolean;
    campaignList: CampaignList[];
    location: string;

    constructor(data?: IListUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppNo = data["ppNo"];
            this.isRequiredPP = data["isRequiredPP"];
            this.includeVat = data["includeVat"];
            this.alihdana = data["alihdana"];
            if (data["campaignList"] && data["campaignList"].constructor === Array) {
                this.campaignList = [];
                for (let item of data["campaignList"])
                    this.campaignList.push(CampaignList.fromJS(item));
            }
            this.location = data["location"];
        }
    }

    static fromJS(data: any): ListUnit {
        let result = new ListUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppNo"] = this.ppNo;
        data["isRequiredPP"] = this.isRequiredPP;
        data["includeVat"] = this.includeVat;
        data["alihdana"] = this.alihdana;
        if (this.campaignList && this.campaignList.constructor === Array) {
            data["campaignList"] = [];
            for (let item of this.campaignList)
                data["campaignList"].push(item.toJSON());
        }
        data["location"] = this.location;
        return data; 
    }
}

export interface IListUnit {
    projectID: number;
    projectCode: string;
    projectName: string;
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isRequiredPP: boolean;
    includeVat: boolean;
    alihdana: boolean;
    campaignList: CampaignList[];
    location: string;
}

export class GetCustomer implements IGetCustomer {
    customerName: string;
    birthDate: moment.Moment;
    idNo: string;
    email: string;

    constructor(data?: IGetCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.idNo = data["idNo"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetCustomer {
        let result = new GetCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["idNo"] = this.idNo;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetCustomer {
    customerName: string;
    birthDate: moment.Moment;
    idNo: string;
    email: string;
}

export class CampaignList implements ICampaignList {
    campaignHeaderID: number;
    campaignType: string;
    campaignName: string;
    rewardID: number;
    rewardName: string;
    programID: number;

    constructor(data?: ICampaignList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignHeaderID = data["campaignHeaderID"];
            this.campaignType = data["campaignType"];
            this.campaignName = data["campaignName"];
            this.rewardID = data["rewardID"];
            this.rewardName = data["rewardName"];
            this.programID = data["programID"];
        }
    }

    static fromJS(data: any): CampaignList {
        let result = new CampaignList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["campaignType"] = this.campaignType;
        data["campaignName"] = this.campaignName;
        data["rewardID"] = this.rewardID;
        data["rewardName"] = this.rewardName;
        data["programID"] = this.programID;
        return data; 
    }
}

export interface ICampaignList {
    campaignHeaderID: number;
    campaignType: string;
    campaignName: string;
    rewardID: number;
    rewardName: string;
    programID: number;
}

export class CheckFullyPaidResultDto implements ICheckFullyPaidResultDto {
    isFullyPaid: boolean;
    statusTypeName: string;
    unitCode: string;
    unitNo: string;
    orderCode: string;
    unitOrderHeaderID: string;

    constructor(data?: ICheckFullyPaidResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFullyPaid = data["isFullyPaid"];
            this.statusTypeName = data["statusTypeName"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.orderCode = data["orderCode"];
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
        }
    }

    static fromJS(data: any): CheckFullyPaidResultDto {
        let result = new CheckFullyPaidResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFullyPaid"] = this.isFullyPaid;
        data["statusTypeName"] = this.statusTypeName;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["orderCode"] = this.orderCode;
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        return data; 
    }
}

export interface ICheckFullyPaidResultDto {
    isFullyPaid: boolean;
    statusTypeName: string;
    unitCode: string;
    unitNo: string;
    orderCode: string;
    unitOrderHeaderID: string;
}

export class ListDetailBookingUnitAppsResultDto implements IListDetailBookingUnitAppsResultDto {
    project: ListProjectAppsDto;
    amountToBePaid: number;
    customer: GetCustomerAppsDto;
    message: string;

    constructor(data?: IListDetailBookingUnitAppsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.project = data["project"] ? ListProjectAppsDto.fromJS(data["project"]) : <any>undefined;
            this.amountToBePaid = data["amountToBePaid"];
            this.customer = data["customer"] ? GetCustomerAppsDto.fromJS(data["customer"]) : <any>undefined;
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ListDetailBookingUnitAppsResultDto {
        let result = new ListDetailBookingUnitAppsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["amountToBePaid"] = this.amountToBePaid;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data; 
    }
}

export interface IListDetailBookingUnitAppsResultDto {
    project: ListProjectAppsDto;
    amountToBePaid: number;
    customer: GetCustomerAppsDto;
    message: string;
}

export class ListProjectAppsDto implements IListProjectAppsDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    cluster: ListClusterAppsDto[];

    constructor(data?: IListProjectAppsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            if (data["cluster"] && data["cluster"].constructor === Array) {
                this.cluster = [];
                for (let item of data["cluster"])
                    this.cluster.push(ListClusterAppsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListProjectAppsDto {
        let result = new ListProjectAppsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        if (this.cluster && this.cluster.constructor === Array) {
            data["cluster"] = [];
            for (let item of this.cluster)
                data["cluster"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListProjectAppsDto {
    projectID: number;
    projectCode: string;
    projectName: string;
    cluster: ListClusterAppsDto[];
}

export class GetCustomerAppsDto implements IGetCustomerAppsDto {
    customerName: string;
    birthDate: moment.Moment;
    idNo: string;
    email: string;

    constructor(data?: IGetCustomerAppsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerName = data["customerName"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.idNo = data["idNo"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetCustomerAppsDto {
        let result = new GetCustomerAppsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["idNo"] = this.idNo;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetCustomerAppsDto {
    customerName: string;
    birthDate: moment.Moment;
    idNo: string;
    email: string;
}

export class ListClusterAppsDto implements IListClusterAppsDto {
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isRequiredPP: boolean;

    constructor(data?: IListClusterAppsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.ppNo = data["ppNo"];
            this.isRequiredPP = data["isRequiredPP"];
        }
    }

    static fromJS(data: any): ListClusterAppsDto {
        let result = new ListClusterAppsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["ppNo"] = this.ppNo;
        data["isRequiredPP"] = this.isRequiredPP;
        return data; 
    }
}

export interface IListClusterAppsDto {
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    bankID1: number;
    bankID2: number;
    ppNo: string;
    isRequiredPP: boolean;
}

export class UpdateBFAmountInputDto implements IUpdateBFAmountInputDto {
    unitID: number;
    renovID: number;
    termID: number;
    bfAmount: number;

    constructor(data?: IUpdateBFAmountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.termID = data["termID"];
            this.bfAmount = data["bfAmount"];
        }
    }

    static fromJS(data: any): UpdateBFAmountInputDto {
        let result = new UpdateBFAmountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["termID"] = this.termID;
        data["bfAmount"] = this.bfAmount;
        return data; 
    }
}

export interface IUpdateBFAmountInputDto {
    unitID: number;
    renovID: number;
    termID: number;
    bfAmount: number;
}

export class UpdateBfAmoutResultDto implements IUpdateBfAmoutResultDto {
    bfAmount: number;
    percentage: number;
    itemID: number;
    result: boolean;

    constructor(data?: IUpdateBfAmoutResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bfAmount = data["bfAmount"];
            this.percentage = data["percentage"];
            this.itemID = data["itemID"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): UpdateBfAmoutResultDto {
        let result = new UpdateBfAmoutResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bfAmount"] = this.bfAmount;
        data["percentage"] = this.percentage;
        data["itemID"] = this.itemID;
        data["result"] = this.result;
        return data; 
    }
}

export interface IUpdateBfAmoutResultDto {
    bfAmount: number;
    percentage: number;
    itemID: number;
    result: boolean;
}

export class GetTrUnitReservedDto implements IGetTrUnitReservedDto {
    unitReservedID: number;
    projectID: number;
    projectInfoID: number;
    projectName: string;
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    detailImage: string;
    creationTime: string;
    ppNo: string;
    psCode: string;
    projectCode: string;
    parentProjectName: string;
    productId: number;
    expiredTime: string;
    message: string;
    createdate: moment.Moment;
    includeVat: boolean;
    campaignHeaderID: number;
    voucherCode: string;
    expiredDate: moment.Moment;
    isDRMS: boolean;
    oldBookcodeDRMS: string;

    constructor(data?: IGetTrUnitReservedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitReservedID = data["unitReservedID"];
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.projectName = data["projectName"];
            this.clusterID = data["clusterID"];
            this.clusterName = data["clusterName"];
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.termID = data["termID"];
            this.termName = data["termName"];
            this.renovID = data["renovID"];
            this.renovName = data["renovName"];
            this.bookingFee = data["bookingFee"];
            this.sellingPrice = data["sellingPrice"];
            this.detailImage = data["detailImage"];
            this.creationTime = data["creationTime"];
            this.ppNo = data["ppNo"];
            this.psCode = data["psCode"];
            this.projectCode = data["projectCode"];
            this.parentProjectName = data["parentProjectName"];
            this.productId = data["productId"];
            this.expiredTime = data["expiredTime"];
            this.message = data["message"];
            this.createdate = data["createdate"] ? moment(data["createdate"].toString()) : <any>undefined;
            this.includeVat = data["includeVat"];
            this.campaignHeaderID = data["campaignHeaderID"];
            this.voucherCode = data["voucherCode"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.isDRMS = data["isDRMS"];
            this.oldBookcodeDRMS = data["oldBookcodeDRMS"];
        }
    }

    static fromJS(data: any): GetTrUnitReservedDto {
        let result = new GetTrUnitReservedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitReservedID"] = this.unitReservedID;
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["projectName"] = this.projectName;
        data["clusterID"] = this.clusterID;
        data["clusterName"] = this.clusterName;
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["termID"] = this.termID;
        data["termName"] = this.termName;
        data["renovID"] = this.renovID;
        data["renovName"] = this.renovName;
        data["bookingFee"] = this.bookingFee;
        data["sellingPrice"] = this.sellingPrice;
        data["detailImage"] = this.detailImage;
        data["creationTime"] = this.creationTime;
        data["ppNo"] = this.ppNo;
        data["psCode"] = this.psCode;
        data["projectCode"] = this.projectCode;
        data["parentProjectName"] = this.parentProjectName;
        data["productId"] = this.productId;
        data["expiredTime"] = this.expiredTime;
        data["message"] = this.message;
        data["createdate"] = this.createdate ? this.createdate.toISOString() : <any>undefined;
        data["includeVat"] = this.includeVat;
        data["campaignHeaderID"] = this.campaignHeaderID;
        data["voucherCode"] = this.voucherCode;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["isDRMS"] = this.isDRMS;
        data["oldBookcodeDRMS"] = this.oldBookcodeDRMS;
        return data; 
    }
}

export interface IGetTrUnitReservedDto {
    unitReservedID: number;
    projectID: number;
    projectInfoID: number;
    projectName: string;
    clusterID: number;
    clusterName: string;
    unitID: number;
    unitCode: string;
    unitNo: string;
    termID: number;
    termName: string;
    renovID: number;
    renovName: string;
    bookingFee: number;
    sellingPrice: number;
    detailImage: string;
    creationTime: string;
    ppNo: string;
    psCode: string;
    projectCode: string;
    parentProjectName: string;
    productId: number;
    expiredTime: string;
    message: string;
    createdate: moment.Moment;
    includeVat: boolean;
    campaignHeaderID: number;
    voucherCode: string;
    expiredDate: moment.Moment;
    isDRMS: boolean;
    oldBookcodeDRMS: string;
}

export class GetListBankResultDto implements IGetListBankResultDto {
    bankID: number;
    bankCode: string;
    bankName: string;

    constructor(data?: IGetListBankResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankID = data["bankID"];
            this.bankCode = data["bankCode"];
            this.bankName = data["bankName"];
        }
    }

    static fromJS(data: any): GetListBankResultDto {
        let result = new GetListBankResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankID"] = this.bankID;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IGetListBankResultDto {
    bankID: number;
    bankCode: string;
    bankName: string;
}

export class NewCreateTransactionUniversalDto implements INewCreateTransactionUniversalDto {
    payTypeID: number;
    pscode: string;
    totalAmt: number;
    orderHeaderID: number;
    orderCode: string;
    banktansfer: string;
    alihdana: boolean;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    otherPaymentType: string[];
    arrUnit: UnitUniversalResultDto[];
    userID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;

    constructor(data?: INewCreateTransactionUniversalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payTypeID = data["payTypeID"];
            this.pscode = data["pscode"];
            this.totalAmt = data["totalAmt"];
            this.orderHeaderID = data["orderHeaderID"];
            this.orderCode = data["orderCode"];
            this.banktansfer = data["banktansfer"];
            this.alihdana = data["alihdana"];
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.sumberDanaID = data["sumberDanaID"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            if (data["otherPaymentType"] && data["otherPaymentType"].constructor === Array) {
                this.otherPaymentType = [];
                for (let item of data["otherPaymentType"])
                    this.otherPaymentType.push(item);
            }
            if (data["arrUnit"] && data["arrUnit"].constructor === Array) {
                this.arrUnit = [];
                for (let item of data["arrUnit"])
                    this.arrUnit.push(UnitUniversalResultDto.fromJS(item));
            }
            this.userID = data["userID"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.scmCode = data["scmCode"];
        }
    }

    static fromJS(data: any): NewCreateTransactionUniversalDto {
        let result = new NewCreateTransactionUniversalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payTypeID"] = this.payTypeID;
        data["pscode"] = this.pscode;
        data["totalAmt"] = this.totalAmt;
        data["orderHeaderID"] = this.orderHeaderID;
        data["orderCode"] = this.orderCode;
        data["banktansfer"] = this.banktansfer;
        data["alihdana"] = this.alihdana;
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["sumberDanaID"] = this.sumberDanaID;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        if (this.otherPaymentType && this.otherPaymentType.constructor === Array) {
            data["otherPaymentType"] = [];
            for (let item of this.otherPaymentType)
                data["otherPaymentType"].push(item);
        }
        if (this.arrUnit && this.arrUnit.constructor === Array) {
            data["arrUnit"] = [];
            for (let item of this.arrUnit)
                data["arrUnit"].push(item.toJSON());
        }
        data["userID"] = this.userID;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["scmCode"] = this.scmCode;
        return data; 
    }
}

export interface INewCreateTransactionUniversalDto {
    payTypeID: number;
    pscode: string;
    totalAmt: number;
    orderHeaderID: number;
    orderCode: string;
    banktansfer: string;
    alihdana: boolean;
    tujuanTransaksiID: number;
    sumberDanaID: number;
    nomorRekeningPemilik: string;
    bankRekeningPemilik: string;
    otherPaymentType: string[];
    arrUnit: UnitUniversalResultDto[];
    userID: number;
    memberCode: string;
    memberName: string;
    scmCode: string;
}

export class InsertCommPPDto implements IInsertCommPPDto {
    projectCode: string;
    memberCode: string;
    scmCode: string;
    statusCode: string;
    ppNo: string;
    ppAmt: number;

    constructor(data?: IInsertCommPPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.memberCode = data["memberCode"];
            this.scmCode = data["scmCode"];
            this.statusCode = data["statusCode"];
            this.ppNo = data["ppNo"];
            this.ppAmt = data["ppAmt"];
        }
    }

    static fromJS(data: any): InsertCommPPDto {
        let result = new InsertCommPPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["memberCode"] = this.memberCode;
        data["scmCode"] = this.scmCode;
        data["statusCode"] = this.statusCode;
        data["ppNo"] = this.ppNo;
        data["ppAmt"] = this.ppAmt;
        return data; 
    }
}

export interface IInsertCommPPDto {
    projectCode: string;
    memberCode: string;
    scmCode: string;
    statusCode: string;
    ppNo: string;
    ppAmt: number;
}

export class SendEmailTTBFInputDto implements ISendEmailTTBFInputDto {
    ppOrderID: number;

    constructor(data?: ISendEmailTTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
        }
    }

    static fromJS(data: any): SendEmailTTBFInputDto {
        let result = new SendEmailTTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        return data; 
    }
}

export interface ISendEmailTTBFInputDto {
    ppOrderID: number;
}

export class ResendKPInputMobile implements IResendKPInputMobile {
    orderHeaderID: number;

    constructor(data?: IResendKPInputMobile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderHeaderID = data["orderHeaderID"];
        }
    }

    static fromJS(data: any): ResendKPInputMobile {
        let result = new ResendKPInputMobile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderHeaderID"] = this.orderHeaderID;
        return data; 
    }
}

export interface IResendKPInputMobile {
    orderHeaderID: number;
}

export class InsertPaymentOfflineInputDto implements IInsertPaymentOfflineInputDto {
    paymentDate: string;
    paymentTypeID: number;
    bankID: number;
    location: string;
    accountNo: string;
    accountName: string;
    docFile: string;
    ppOrderID: number;
    paymentAmt: number;

    constructor(data?: IInsertPaymentOfflineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDate = data["paymentDate"];
            this.paymentTypeID = data["paymentTypeID"];
            this.bankID = data["bankID"];
            this.location = data["location"];
            this.accountNo = data["accountNo"];
            this.accountName = data["accountName"];
            this.docFile = data["docFile"];
            this.ppOrderID = data["ppOrderID"];
            this.paymentAmt = data["paymentAmt"];
        }
    }

    static fromJS(data: any): InsertPaymentOfflineInputDto {
        let result = new InsertPaymentOfflineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate;
        data["paymentTypeID"] = this.paymentTypeID;
        data["bankID"] = this.bankID;
        data["location"] = this.location;
        data["accountNo"] = this.accountNo;
        data["accountName"] = this.accountName;
        data["docFile"] = this.docFile;
        data["ppOrderID"] = this.ppOrderID;
        data["paymentAmt"] = this.paymentAmt;
        return data; 
    }
}

export interface IInsertPaymentOfflineInputDto {
    paymentDate: string;
    paymentTypeID: number;
    bankID: number;
    location: string;
    accountNo: string;
    accountName: string;
    docFile: string;
    ppOrderID: number;
    paymentAmt: number;
}

export class PrintTTBFInputDto implements IPrintTTBFInputDto {
    ppOrderID: number;
    ppNo: string;

    constructor(data?: IPrintTTBFInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): PrintTTBFInputDto {
        let result = new PrintTTBFInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IPrintTTBFInputDto {
    ppOrderID: number;
    ppNo: string;
}

export class GetPPPriceResultDto implements IGetPPPriceResultDto {
    ppPrice: number;
    ppNo: string;

    constructor(data?: IGetPPPriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppPrice = data["ppPrice"];
            this.ppNo = data["ppNo"];
        }
    }

    static fromJS(data: any): GetPPPriceResultDto {
        let result = new GetPPPriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppPrice"] = this.ppPrice;
        data["ppNo"] = this.ppNo;
        return data; 
    }
}

export interface IGetPPPriceResultDto {
    ppPrice: number;
    ppNo: string;
}

export class ViewKonfirmasiPesananDto implements IViewKonfirmasiPesananDto {
    data: ViewKonfirmasiPesananInputDto[];
    docType: string;

    constructor(data?: IViewKonfirmasiPesananDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(ViewKonfirmasiPesananInputDto.fromJS(item));
            }
            this.docType = data["docType"];
        }
    }

    static fromJS(data: any): ViewKonfirmasiPesananDto {
        let result = new ViewKonfirmasiPesananDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["docType"] = this.docType;
        return data; 
    }
}

export interface IViewKonfirmasiPesananDto {
    data: ViewKonfirmasiPesananInputDto[];
    docType: string;
}

export class ViewKonfirmasiPesananInputDto implements IViewKonfirmasiPesananInputDto {
    unitOrderHeaderID: number;
    unitID: number;
    bookCode: string;

    constructor(data?: IViewKonfirmasiPesananInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderID = data["unitOrderHeaderID"];
            this.unitID = data["unitID"];
            this.bookCode = data["bookCode"];
        }
    }

    static fromJS(data: any): ViewKonfirmasiPesananInputDto {
        let result = new ViewKonfirmasiPesananInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderID"] = this.unitOrderHeaderID;
        data["unitID"] = this.unitID;
        data["bookCode"] = this.bookCode;
        return data; 
    }
}

export interface IViewKonfirmasiPesananInputDto {
    unitOrderHeaderID: number;
    unitID: number;
    bookCode: string;
}

export class GetDataBookingToProcessDto implements IGetDataBookingToProcessDto {
    userID: number;
    unitID: number;
    renovID: number;
    termID: number;
    pscode: string;
    memberCode: string;
    memberName: string;
    tujuanTransaksiID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    sellingprice: number;
    scmCode: string;
    sumberDanaID: number;
    projectID: number;
    bookingFee: number;
    countCicilanUnitLama: number;
    paymentUnitLama: number;
    isPotongBF: boolean;

    constructor(data?: IGetDataBookingToProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.unitID = data["unitID"];
            this.renovID = data["renovID"];
            this.termID = data["termID"];
            this.pscode = data["pscode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.tujuanTransaksiID = data["tujuanTransaksiID"];
            this.bankRekeningPemilik = data["bankRekeningPemilik"];
            this.nomorRekeningPemilik = data["nomorRekeningPemilik"];
            this.sellingprice = data["sellingprice"];
            this.scmCode = data["scmCode"];
            this.sumberDanaID = data["sumberDanaID"];
            this.projectID = data["projectID"];
            this.bookingFee = data["bookingFee"];
            this.countCicilanUnitLama = data["countCicilanUnitLama"];
            this.paymentUnitLama = data["paymentUnitLama"];
            this.isPotongBF = data["isPotongBF"];
        }
    }

    static fromJS(data: any): GetDataBookingToProcessDto {
        let result = new GetDataBookingToProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["unitID"] = this.unitID;
        data["renovID"] = this.renovID;
        data["termID"] = this.termID;
        data["pscode"] = this.pscode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["tujuanTransaksiID"] = this.tujuanTransaksiID;
        data["bankRekeningPemilik"] = this.bankRekeningPemilik;
        data["nomorRekeningPemilik"] = this.nomorRekeningPemilik;
        data["sellingprice"] = this.sellingprice;
        data["scmCode"] = this.scmCode;
        data["sumberDanaID"] = this.sumberDanaID;
        data["projectID"] = this.projectID;
        data["bookingFee"] = this.bookingFee;
        data["countCicilanUnitLama"] = this.countCicilanUnitLama;
        data["paymentUnitLama"] = this.paymentUnitLama;
        data["isPotongBF"] = this.isPotongBF;
        return data; 
    }
}

export interface IGetDataBookingToProcessDto {
    userID: number;
    unitID: number;
    renovID: number;
    termID: number;
    pscode: string;
    memberCode: string;
    memberName: string;
    tujuanTransaksiID: number;
    bankRekeningPemilik: string;
    nomorRekeningPemilik: string;
    sellingprice: number;
    scmCode: string;
    sumberDanaID: number;
    projectID: number;
    bookingFee: number;
    countCicilanUnitLama: number;
    paymentUnitLama: number;
    isPotongBF: boolean;
}

export class CURBookingResultDto implements ICURBookingResultDto {
    orderCode: string;
    bookingHeaderID: number;

    constructor(data?: ICURBookingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            this.bookingHeaderID = data["bookingHeaderID"];
        }
    }

    static fromJS(data: any): CURBookingResultDto {
        let result = new CURBookingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        data["bookingHeaderID"] = this.bookingHeaderID;
        return data; 
    }
}

export interface ICURBookingResultDto {
    orderCode: string;
    bookingHeaderID: number;
}

export class GetOriginalScheduleCURInputDto implements IGetOriginalScheduleCURInputDto {
    bookingHeaderID: number;
    listBfAmount: UpdateBfAmoutResultDto[];
    listPctTax: BookingDetailIDDto[];
    listNetNetPrice: UpdateNetPriceResultDto[];
    bookDate: TrBookingHeaderResultDto[];
    listDetailDP: InsertTRDetailDPResultDto[];
    sellingPrice: number;
    userID: number;
    termID: number;
    paymentUnitLama: number;
    countCicilan: number;
    isPotongBF: boolean;

    constructor(data?: IGetOriginalScheduleCURInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            if (data["listBfAmount"] && data["listBfAmount"].constructor === Array) {
                this.listBfAmount = [];
                for (let item of data["listBfAmount"])
                    this.listBfAmount.push(UpdateBfAmoutResultDto.fromJS(item));
            }
            if (data["listPctTax"] && data["listPctTax"].constructor === Array) {
                this.listPctTax = [];
                for (let item of data["listPctTax"])
                    this.listPctTax.push(BookingDetailIDDto.fromJS(item));
            }
            if (data["listNetNetPrice"] && data["listNetNetPrice"].constructor === Array) {
                this.listNetNetPrice = [];
                for (let item of data["listNetNetPrice"])
                    this.listNetNetPrice.push(UpdateNetPriceResultDto.fromJS(item));
            }
            if (data["bookDate"] && data["bookDate"].constructor === Array) {
                this.bookDate = [];
                for (let item of data["bookDate"])
                    this.bookDate.push(TrBookingHeaderResultDto.fromJS(item));
            }
            if (data["listDetailDP"] && data["listDetailDP"].constructor === Array) {
                this.listDetailDP = [];
                for (let item of data["listDetailDP"])
                    this.listDetailDP.push(InsertTRDetailDPResultDto.fromJS(item));
            }
            this.sellingPrice = data["sellingPrice"];
            this.userID = data["userID"];
            this.termID = data["termID"];
            this.paymentUnitLama = data["paymentUnitLama"];
            this.countCicilan = data["countCicilan"];
            this.isPotongBF = data["isPotongBF"];
        }
    }

    static fromJS(data: any): GetOriginalScheduleCURInputDto {
        let result = new GetOriginalScheduleCURInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        if (this.listBfAmount && this.listBfAmount.constructor === Array) {
            data["listBfAmount"] = [];
            for (let item of this.listBfAmount)
                data["listBfAmount"].push(item.toJSON());
        }
        if (this.listPctTax && this.listPctTax.constructor === Array) {
            data["listPctTax"] = [];
            for (let item of this.listPctTax)
                data["listPctTax"].push(item.toJSON());
        }
        if (this.listNetNetPrice && this.listNetNetPrice.constructor === Array) {
            data["listNetNetPrice"] = [];
            for (let item of this.listNetNetPrice)
                data["listNetNetPrice"].push(item.toJSON());
        }
        if (this.bookDate && this.bookDate.constructor === Array) {
            data["bookDate"] = [];
            for (let item of this.bookDate)
                data["bookDate"].push(item.toJSON());
        }
        if (this.listDetailDP && this.listDetailDP.constructor === Array) {
            data["listDetailDP"] = [];
            for (let item of this.listDetailDP)
                data["listDetailDP"].push(item.toJSON());
        }
        data["sellingPrice"] = this.sellingPrice;
        data["userID"] = this.userID;
        data["termID"] = this.termID;
        data["paymentUnitLama"] = this.paymentUnitLama;
        data["countCicilan"] = this.countCicilan;
        data["isPotongBF"] = this.isPotongBF;
        return data; 
    }
}

export interface IGetOriginalScheduleCURInputDto {
    bookingHeaderID: number;
    listBfAmount: UpdateBfAmoutResultDto[];
    listPctTax: BookingDetailIDDto[];
    listNetNetPrice: UpdateNetPriceResultDto[];
    bookDate: TrBookingHeaderResultDto[];
    listDetailDP: InsertTRDetailDPResultDto[];
    sellingPrice: number;
    userID: number;
    termID: number;
    paymentUnitLama: number;
    countCicilan: number;
    isPotongBF: boolean;
}

export class BookingDetailIDDto implements IBookingDetailIDDto {
    bookingHeaderID: number;
    bookingDetailID: number;
    itemID: number;
    area: number;
    bookNo: number;
    coCode: string;
    pctTax: number;
    accID: number;
    accPersen: number;
    result: boolean;

    constructor(data?: IBookingDetailIDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookingDetailID = data["bookingDetailID"];
            this.itemID = data["itemID"];
            this.area = data["area"];
            this.bookNo = data["bookNo"];
            this.coCode = data["coCode"];
            this.pctTax = data["pctTax"];
            this.accID = data["accID"];
            this.accPersen = data["accPersen"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): BookingDetailIDDto {
        let result = new BookingDetailIDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookingDetailID"] = this.bookingDetailID;
        data["itemID"] = this.itemID;
        data["area"] = this.area;
        data["bookNo"] = this.bookNo;
        data["coCode"] = this.coCode;
        data["pctTax"] = this.pctTax;
        data["accID"] = this.accID;
        data["accPersen"] = this.accPersen;
        data["result"] = this.result;
        return data; 
    }
}

export interface IBookingDetailIDDto {
    bookingHeaderID: number;
    bookingDetailID: number;
    itemID: number;
    area: number;
    bookNo: number;
    coCode: string;
    pctTax: number;
    accID: number;
    accPersen: number;
    result: boolean;
}

export class UpdateNetPriceResultDto implements IUpdateNetPriceResultDto {
    result: boolean;
    netNetPrice: number;
    bookingDetailID: number;
    message: string;
    netNetPriceComm: number;
    renovID: number;
    termCodeComm: string;
    termNoComm: number;
    listAmountComm: AmountCommDto[];
    netPrice: number;

    constructor(data?: IUpdateNetPriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.netNetPrice = data["netNetPrice"];
            this.bookingDetailID = data["bookingDetailID"];
            this.message = data["message"];
            this.netNetPriceComm = data["netNetPriceComm"];
            this.renovID = data["renovID"];
            this.termCodeComm = data["termCodeComm"];
            this.termNoComm = data["termNoComm"];
            if (data["listAmountComm"] && data["listAmountComm"].constructor === Array) {
                this.listAmountComm = [];
                for (let item of data["listAmountComm"])
                    this.listAmountComm.push(AmountCommDto.fromJS(item));
            }
            this.netPrice = data["netPrice"];
        }
    }

    static fromJS(data: any): UpdateNetPriceResultDto {
        let result = new UpdateNetPriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["netNetPrice"] = this.netNetPrice;
        data["bookingDetailID"] = this.bookingDetailID;
        data["message"] = this.message;
        data["netNetPriceComm"] = this.netNetPriceComm;
        data["renovID"] = this.renovID;
        data["termCodeComm"] = this.termCodeComm;
        data["termNoComm"] = this.termNoComm;
        if (this.listAmountComm && this.listAmountComm.constructor === Array) {
            data["listAmountComm"] = [];
            for (let item of this.listAmountComm)
                data["listAmountComm"].push(item.toJSON());
        }
        data["netPrice"] = this.netPrice;
        return data; 
    }
}

export interface IUpdateNetPriceResultDto {
    result: boolean;
    netNetPrice: number;
    bookingDetailID: number;
    message: string;
    netNetPriceComm: number;
    renovID: number;
    termCodeComm: string;
    termNoComm: number;
    listAmountComm: AmountCommDto[];
    netPrice: number;
}

export class TrBookingHeaderResultDto implements ITrBookingHeaderResultDto {
    bookingHeaderID: number;
    termRemarks: string;
    unitID: number;
    termID: number;
    bookDate: moment.Moment;
    message: string;
    result: boolean;

    constructor(data?: ITrBookingHeaderResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingHeaderID = data["bookingHeaderID"];
            this.termRemarks = data["termRemarks"];
            this.unitID = data["unitID"];
            this.termID = data["termID"];
            this.bookDate = data["bookDate"] ? moment(data["bookDate"].toString()) : <any>undefined;
            this.message = data["message"];
            this.result = data["result"];
        }
    }

    static fromJS(data: any): TrBookingHeaderResultDto {
        let result = new TrBookingHeaderResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["termRemarks"] = this.termRemarks;
        data["unitID"] = this.unitID;
        data["termID"] = this.termID;
        data["bookDate"] = this.bookDate ? this.bookDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["result"] = this.result;
        return data; 
    }
}

export interface ITrBookingHeaderResultDto {
    bookingHeaderID: number;
    termRemarks: string;
    unitID: number;
    termID: number;
    bookDate: moment.Moment;
    message: string;
    result: boolean;
}

export class InsertTRDetailDPResultDto implements IInsertTRDetailDPResultDto {
    daysDue: number;
    dpNo: number;
    dpPct: number;
    dpAmount: number;
    monthsDue: number;
    dpCalcID: number;
    formulaCalcID: number;

    constructor(data?: IInsertTRDetailDPResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.daysDue = data["daysDue"];
            this.dpNo = data["dpNo"];
            this.dpPct = data["dpPct"];
            this.dpAmount = data["dpAmount"];
            this.monthsDue = data["monthsDue"];
            this.dpCalcID = data["dpCalcID"];
            this.formulaCalcID = data["formulaCalcID"];
        }
    }

    static fromJS(data: any): InsertTRDetailDPResultDto {
        let result = new InsertTRDetailDPResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysDue"] = this.daysDue;
        data["dpNo"] = this.dpNo;
        data["dpPct"] = this.dpPct;
        data["dpAmount"] = this.dpAmount;
        data["monthsDue"] = this.monthsDue;
        data["dpCalcID"] = this.dpCalcID;
        data["formulaCalcID"] = this.formulaCalcID;
        return data; 
    }
}

export interface IInsertTRDetailDPResultDto {
    daysDue: number;
    dpNo: number;
    dpPct: number;
    dpAmount: number;
    monthsDue: number;
    dpCalcID: number;
    formulaCalcID: number;
}

export class AmountCommDto implements IAmountCommDto {
    amountComm: number;

    constructor(data?: IAmountCommDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amountComm = data["amountComm"];
        }
    }

    static fromJS(data: any): AmountCommDto {
        let result = new AmountCommDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountComm"] = this.amountComm;
        return data; 
    }
}

export interface IAmountCommDto {
    amountComm: number;
}

export class InsertTrBookingRewardDto implements IInsertTrBookingRewardDto {
    unitOrderHeaderId: number;
    rewards: number[];
    program: number[];
    rewardsProgram: number[];
    userId: number;
    voucherCode: string;

    constructor(data?: IInsertTrBookingRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitOrderHeaderId = data["unitOrderHeaderId"];
            if (data["rewards"] && data["rewards"].constructor === Array) {
                this.rewards = [];
                for (let item of data["rewards"])
                    this.rewards.push(item);
            }
            if (data["program"] && data["program"].constructor === Array) {
                this.program = [];
                for (let item of data["program"])
                    this.program.push(item);
            }
            if (data["rewardsProgram"] && data["rewardsProgram"].constructor === Array) {
                this.rewardsProgram = [];
                for (let item of data["rewardsProgram"])
                    this.rewardsProgram.push(item);
            }
            this.userId = data["userId"];
            this.voucherCode = data["voucherCode"];
        }
    }

    static fromJS(data: any): InsertTrBookingRewardDto {
        let result = new InsertTrBookingRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOrderHeaderId"] = this.unitOrderHeaderId;
        if (this.rewards && this.rewards.constructor === Array) {
            data["rewards"] = [];
            for (let item of this.rewards)
                data["rewards"].push(item);
        }
        if (this.program && this.program.constructor === Array) {
            data["program"] = [];
            for (let item of this.program)
                data["program"].push(item);
        }
        if (this.rewardsProgram && this.rewardsProgram.constructor === Array) {
            data["rewardsProgram"] = [];
            for (let item of this.rewardsProgram)
                data["rewardsProgram"].push(item);
        }
        data["userId"] = this.userId;
        data["voucherCode"] = this.voucherCode;
        return data; 
    }
}

export interface IInsertTrBookingRewardDto {
    unitOrderHeaderId: number;
    rewards: number[];
    program: number[];
    rewardsProgram: number[];
    userId: number;
    voucherCode: string;
}

export class GetDropdownProjectListDto implements IGetDropdownProjectListDto {
    projectCode: string;
    projectName: string;
    projectID: number;

    constructor(data?: IGetDropdownProjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.projectName = data["projectName"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetDropdownProjectListDto {
        let result = new GetDropdownProjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["projectName"] = this.projectName;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetDropdownProjectListDto {
    projectCode: string;
    projectName: string;
    projectID: number;
}

export class GetDropdownProductListDto implements IGetDropdownProductListDto {
    projectPPID: number;
    projectProductID: number;
    productCode: string;
    productName: string;

    constructor(data?: IGetDropdownProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectPPID = data["projectPPID"];
            this.projectProductID = data["projectProductID"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetDropdownProductListDto {
        let result = new GetDropdownProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPPID"] = this.projectPPID;
        data["projectProductID"] = this.projectProductID;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetDropdownProductListDto {
    projectPPID: number;
    projectProductID: number;
    productCode: string;
    productName: string;
}

export class TrBuyPPOnlineInputDto implements ITrBuyPPOnlineInputDto {
    projectProductID: number;
    projectCode: string;
    ppQuantity: number;
    listPP: ListPPDto[];
    listPPUnit: ListPPUnitDto[];
    totalPrice: number;
    paymentTypeID: number;
    psCodeCust: string;
    userID: number;
    orderCode: string;
    priorityLine: boolean;
    isRefundable: boolean;
    isTransferable: boolean;
    mappingFastLane: number;

    constructor(data?: ITrBuyPPOnlineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectProductID = data["projectProductID"];
            this.projectCode = data["projectCode"];
            this.ppQuantity = data["ppQuantity"];
            if (data["listPP"] && data["listPP"].constructor === Array) {
                this.listPP = [];
                for (let item of data["listPP"])
                    this.listPP.push(ListPPDto.fromJS(item));
            }
            if (data["listPPUnit"] && data["listPPUnit"].constructor === Array) {
                this.listPPUnit = [];
                for (let item of data["listPPUnit"])
                    this.listPPUnit.push(ListPPUnitDto.fromJS(item));
            }
            this.totalPrice = data["totalPrice"];
            this.paymentTypeID = data["paymentTypeID"];
            this.psCodeCust = data["psCodeCust"];
            this.userID = data["userID"];
            this.orderCode = data["orderCode"];
            this.priorityLine = data["priorityLine"];
            this.isRefundable = data["isRefundable"];
            this.isTransferable = data["isTransferable"];
            this.mappingFastLane = data["mappingFastLane"];
        }
    }

    static fromJS(data: any): TrBuyPPOnlineInputDto {
        let result = new TrBuyPPOnlineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectProductID"] = this.projectProductID;
        data["projectCode"] = this.projectCode;
        data["ppQuantity"] = this.ppQuantity;
        if (this.listPP && this.listPP.constructor === Array) {
            data["listPP"] = [];
            for (let item of this.listPP)
                data["listPP"].push(item.toJSON());
        }
        if (this.listPPUnit && this.listPPUnit.constructor === Array) {
            data["listPPUnit"] = [];
            for (let item of this.listPPUnit)
                data["listPPUnit"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["paymentTypeID"] = this.paymentTypeID;
        data["psCodeCust"] = this.psCodeCust;
        data["userID"] = this.userID;
        data["orderCode"] = this.orderCode;
        data["priorityLine"] = this.priorityLine;
        data["isRefundable"] = this.isRefundable;
        data["isTransferable"] = this.isTransferable;
        data["mappingFastLane"] = this.mappingFastLane;
        return data; 
    }
}

export interface ITrBuyPPOnlineInputDto {
    projectProductID: number;
    projectCode: string;
    ppQuantity: number;
    listPP: ListPPDto[];
    listPPUnit: ListPPUnitDto[];
    totalPrice: number;
    paymentTypeID: number;
    psCodeCust: string;
    userID: number;
    orderCode: string;
    priorityLine: boolean;
    isRefundable: boolean;
    isTransferable: boolean;
    mappingFastLane: number;
}

export class ListPPDto implements IListPPDto {
    sortNo: number;
    bankID1: number;
    bankID2: number;
    termRefID: number;
    preferredTypeName: string;

    constructor(data?: IListPPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sortNo = data["sortNo"];
            this.bankID1 = data["bankID1"];
            this.bankID2 = data["bankID2"];
            this.termRefID = data["termRefID"];
            this.preferredTypeName = data["preferredTypeName"];
        }
    }

    static fromJS(data: any): ListPPDto {
        let result = new ListPPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortNo"] = this.sortNo;
        data["bankID1"] = this.bankID1;
        data["bankID2"] = this.bankID2;
        data["termRefID"] = this.termRefID;
        data["preferredTypeName"] = this.preferredTypeName;
        return data; 
    }
}

export interface IListPPDto {
    sortNo: number;
    bankID1: number;
    bankID2: number;
    termRefID: number;
    preferredTypeName: string;
}

export class ListPPUnitDto implements IListPPUnitDto {
    unitCode: string;
    unitNo: string;

    constructor(data?: IListPPUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
        }
    }

    static fromJS(data: any): ListPPUnitDto {
        let result = new ListPPUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        return data; 
    }
}

export interface IListPPUnitDto {
    unitCode: string;
    unitNo: string;
}

export class CheckFullyPaidPPResultDto implements ICheckFullyPaidPPResultDto {
    ppOrderID: number;
    statusTypeName: string;
    isFullyPaid: boolean;
    ppno: string;
    orderCode: string;

    constructor(data?: ICheckFullyPaidPPResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ppOrderID = data["ppOrderID"];
            this.statusTypeName = data["statusTypeName"];
            this.isFullyPaid = data["isFullyPaid"];
            this.ppno = data["ppno"];
            this.orderCode = data["orderCode"];
        }
    }

    static fromJS(data: any): CheckFullyPaidPPResultDto {
        let result = new CheckFullyPaidPPResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ppOrderID"] = this.ppOrderID;
        data["statusTypeName"] = this.statusTypeName;
        data["isFullyPaid"] = this.isFullyPaid;
        data["ppno"] = this.ppno;
        data["orderCode"] = this.orderCode;
        return data; 
    }
}

export interface ICheckFullyPaidPPResultDto {
    ppOrderID: number;
    statusTypeName: string;
    isFullyPaid: boolean;
    ppno: string;
    orderCode: string;
}

export class VerifyVoucherInputDto implements IVerifyVoucherInputDto {
    voucher: string;
    projectCode: string;

    constructor(data?: IVerifyVoucherInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucher = data["voucher"];
            this.projectCode = data["projectCode"];
        }
    }

    static fromJS(data: any): VerifyVoucherInputDto {
        let result = new VerifyVoucherInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucher"] = this.voucher;
        data["projectCode"] = this.projectCode;
        return data; 
    }
}

export interface IVerifyVoucherInputDto {
    voucher: string;
    projectCode: string;
}

export class GenerateOrderCodePPInputDto implements IGenerateOrderCodePPInputDto {
    projectCode: string;
    productCode: string;

    constructor(data?: IGenerateOrderCodePPInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.productCode = data["productCode"];
        }
    }

    static fromJS(data: any): GenerateOrderCodePPInputDto {
        let result = new GenerateOrderCodePPInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["productCode"] = this.productCode;
        return data; 
    }
}

export interface IGenerateOrderCodePPInputDto {
    projectCode: string;
    productCode: string;
}

export class GetFlekStatusListDto implements IGetFlekStatusListDto {
    regularLane: GetFlekStatusDto;
    fastLane: GetFlekStatusDto;

    constructor(data?: IGetFlekStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regularLane = data["regularLane"] ? GetFlekStatusDto.fromJS(data["regularLane"]) : <any>undefined;
            this.fastLane = data["fastLane"] ? GetFlekStatusDto.fromJS(data["fastLane"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFlekStatusListDto {
        let result = new GetFlekStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regularLane"] = this.regularLane ? this.regularLane.toJSON() : <any>undefined;
        data["fastLane"] = this.fastLane ? this.fastLane.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFlekStatusListDto {
    regularLane: GetFlekStatusDto;
    fastLane: GetFlekStatusDto;
}

export class GetFlekStatusDto implements IGetFlekStatusDto {
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    name: string;

    constructor(data?: IGetFlekStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isRefundable = data["isRefundable"];
            this.isNonRefundable = data["isNonRefundable"];
            this.isTransferable = data["isTransferable"];
            this.isNonTransferable = data["isNonTransferable"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetFlekStatusDto {
        let result = new GetFlekStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRefundable"] = this.isRefundable;
        data["isNonRefundable"] = this.isNonRefundable;
        data["isTransferable"] = this.isTransferable;
        data["isNonTransferable"] = this.isNonTransferable;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetFlekStatusDto {
    isRefundable: boolean;
    isNonRefundable: boolean;
    isTransferable: boolean;
    isNonTransferable: boolean;
    name: string;
}

export class GetDropdownUnitCodeListDTO implements IGetDropdownUnitCodeListDTO {
    unitCodeID: number;
    unitCode: string;
    unitName: string;
    projectID: number;

    constructor(data?: IGetDropdownUnitCodeListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCodeID = data["unitCodeID"];
            this.unitCode = data["unitCode"];
            this.unitName = data["unitName"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetDropdownUnitCodeListDTO {
        let result = new GetDropdownUnitCodeListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCodeID"] = this.unitCodeID;
        data["unitCode"] = this.unitCode;
        data["unitName"] = this.unitName;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetDropdownUnitCodeListDTO {
    unitCodeID: number;
    unitCode: string;
    unitName: string;
    projectID: number;
}

export class GetDropdownUnitNoListDTO implements IGetDropdownUnitNoListDTO {
    unitNo: string;
    productID: number;
    projectID: number;

    constructor(data?: IGetDropdownUnitNoListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitNo = data["unitNo"];
            this.productID = data["productID"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): GetDropdownUnitNoListDTO {
        let result = new GetDropdownUnitNoListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNo"] = this.unitNo;
        data["productID"] = this.productID;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IGetDropdownUnitNoListDTO {
    unitNo: string;
    productID: number;
    projectID: number;
}

export class GetUpdateBankAccountInputDto implements IGetUpdateBankAccountInputDto {
    psCode: string;
    refID: number;
    bankCode: string;
    accNo: string;
    accName: string;

    constructor(data?: IGetUpdateBankAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.bankCode = data["bankCode"];
            this.accNo = data["accNo"];
            this.accName = data["accName"];
        }
    }

    static fromJS(data: any): GetUpdateBankAccountInputDto {
        let result = new GetUpdateBankAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["bankCode"] = this.bankCode;
        data["accNo"] = this.accNo;
        data["accName"] = this.accName;
        return data; 
    }
}

export interface IGetUpdateBankAccountInputDto {
    psCode: string;
    refID: number;
    bankCode: string;
    accNo: string;
    accName: string;
}

export class UploadBasePriceInputDto implements IUploadBasePriceInputDto {
    projectCode: string;
    categoryName: string;
    basePrices: BasePrice[];

    constructor(data?: IUploadBasePriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectCode = data["projectCode"];
            this.categoryName = data["categoryName"];
            if (data["basePrices"] && data["basePrices"].constructor === Array) {
                this.basePrices = [];
                for (let item of data["basePrices"])
                    this.basePrices.push(BasePrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadBasePriceInputDto {
        let result = new UploadBasePriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCode"] = this.projectCode;
        data["categoryName"] = this.categoryName;
        if (this.basePrices && this.basePrices.constructor === Array) {
            data["basePrices"] = [];
            for (let item of this.basePrices)
                data["basePrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUploadBasePriceInputDto {
    projectCode: string;
    categoryName: string;
    basePrices: BasePrice[];
}

export class BasePrice implements IBasePrice {
    unitCode: string;
    unitNo: string;
    unitBasePrice: number;

    constructor(data?: IBasePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitBasePrice = data["unitBasePrice"];
        }
    }

    static fromJS(data: any): BasePrice {
        let result = new BasePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitBasePrice"] = this.unitBasePrice;
        return data; 
    }
}

export interface IBasePrice {
    unitCode: string;
    unitNo: string;
    unitBasePrice: number;
}

export class PagedResultDtoOfGetAllBasePriceListDto implements IPagedResultDtoOfGetAllBasePriceListDto {
    totalCount: number;
    items: GetAllBasePriceListDto[];

    constructor(data?: IPagedResultDtoOfGetAllBasePriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllBasePriceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllBasePriceListDto {
        let result = new PagedResultDtoOfGetAllBasePriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllBasePriceListDto {
    totalCount: number;
    items: GetAllBasePriceListDto[];
}

export class GetAllBasePriceListDto implements IGetAllBasePriceListDto {
    basePriceID: number;
    projectCode: string;
    roadCode: string;
    unitCode: string;
    unitNo: string;
    unitBasePrice: number;

    constructor(data?: IGetAllBasePriceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.basePriceID = data["basePriceID"];
            this.projectCode = data["projectCode"];
            this.roadCode = data["roadCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitBasePrice = data["unitBasePrice"];
        }
    }

    static fromJS(data: any): GetAllBasePriceListDto {
        let result = new GetAllBasePriceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basePriceID"] = this.basePriceID;
        data["projectCode"] = this.projectCode;
        data["roadCode"] = this.roadCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitBasePrice"] = this.unitBasePrice;
        return data; 
    }
}

export interface IGetAllBasePriceListDto {
    basePriceID: number;
    projectCode: string;
    roadCode: string;
    unitCode: string;
    unitNo: string;
    unitBasePrice: number;
}

export class CreateOrUpdateTrCompanyListDto implements ICreateOrUpdateTrCompanyListDto {
    psCode: string;
    refID: number;
    coName: string;
    coAddress: string;
    coCity: string;
    coPostCode: string;
    coCountry: string;
    coType: string;
    jobTitle: string;

    constructor(data?: ICreateOrUpdateTrCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.coName = data["coName"];
            this.coAddress = data["coAddress"];
            this.coCity = data["coCity"];
            this.coPostCode = data["coPostCode"];
            this.coCountry = data["coCountry"];
            this.coType = data["coType"];
            this.jobTitle = data["jobTitle"];
        }
    }

    static fromJS(data: any): CreateOrUpdateTrCompanyListDto {
        let result = new CreateOrUpdateTrCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["coName"] = this.coName;
        data["coAddress"] = this.coAddress;
        data["coCity"] = this.coCity;
        data["coPostCode"] = this.coPostCode;
        data["coCountry"] = this.coCountry;
        data["coType"] = this.coType;
        data["jobTitle"] = this.jobTitle;
        return data; 
    }
}

export interface ICreateOrUpdateTrCompanyListDto {
    psCode: string;
    refID: number;
    coName: string;
    coAddress: string;
    coCity: string;
    coPostCode: string;
    coCountry: string;
    coType: string;
    jobTitle: string;
}

export class GetUpdateEmailInputDto implements IGetUpdateEmailInputDto {
    entityCode: string;
    psCode: string;
    refID: number;
    email: string;

    constructor(data?: IGetUpdateEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): GetUpdateEmailInputDto {
        let result = new GetUpdateEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["email"] = this.email;
        return data; 
    }
}

export interface IGetUpdateEmailInputDto {
    entityCode: string;
    psCode: string;
    refID: number;
    email: string;
}

export class UpdateTrFamilyListDto implements IUpdateTrFamilyListDto {
    psCode: string;
    refID: number;
    familyName: string;
    familyStatus: string;
    birthDate: moment.Moment;
    occID: string;

    constructor(data?: IUpdateTrFamilyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.familyName = data["familyName"];
            this.familyStatus = data["familyStatus"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.occID = data["occID"];
        }
    }

    static fromJS(data: any): UpdateTrFamilyListDto {
        let result = new UpdateTrFamilyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["familyName"] = this.familyName;
        data["familyStatus"] = this.familyStatus;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["occID"] = this.occID;
        return data; 
    }
}

export interface IUpdateTrFamilyListDto {
    psCode: string;
    refID: number;
    familyName: string;
    familyStatus: string;
    birthDate: moment.Moment;
    occID: string;
}

export class UpdateTrIDInputDto implements IUpdateTrIDInputDto {
    psCode: string;
    refID: number;
    idType: string;
    idNo: string;
    expiredDate: moment.Moment;

    constructor(data?: IUpdateTrIDInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.idType = data["idType"];
            this.idNo = data["idNo"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTrIDInputDto {
        let result = new UpdateTrIDInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["idType"] = this.idType;
        data["idNo"] = this.idNo;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdateTrIDInputDto {
    psCode: string;
    refID: number;
    idType: string;
    idNo: string;
    expiredDate: moment.Moment;
}

export class UpdateTrJKeyPeopleInputDto implements IUpdateTrJKeyPeopleInputDto {
    id: number;
    psCode: string;
    refID: number;
    keyPeopleID: number;
    keyPeopleName: string;
    keyPeoplePSCode: string;

    constructor(data?: IUpdateTrJKeyPeopleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.keyPeopleID = data["keyPeopleID"];
            this.keyPeopleName = data["keyPeopleName"];
            this.keyPeoplePSCode = data["keyPeoplePSCode"];
        }
    }

    static fromJS(data: any): UpdateTrJKeyPeopleInputDto {
        let result = new UpdateTrJKeyPeopleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["keyPeopleID"] = this.keyPeopleID;
        data["keyPeopleName"] = this.keyPeopleName;
        data["keyPeoplePSCode"] = this.keyPeoplePSCode;
        return data; 
    }
}

export interface IUpdateTrJKeyPeopleInputDto {
    id: number;
    psCode: string;
    refID: number;
    keyPeopleID: number;
    keyPeopleName: string;
    keyPeoplePSCode: string;
}

export class GetUpdateTrPhoneInputDto implements IGetUpdateTrPhoneInputDto {
    entityCode: string;
    psCode: string;
    refID: number;
    phoneType: string;
    number: string;

    constructor(data?: IGetUpdateTrPhoneInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.psCode = data["psCode"];
            this.refID = data["refID"];
            this.phoneType = data["phoneType"];
            this.number = data["number"];
        }
    }

    static fromJS(data: any): GetUpdateTrPhoneInputDto {
        let result = new GetUpdateTrPhoneInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["psCode"] = this.psCode;
        data["refID"] = this.refID;
        data["phoneType"] = this.phoneType;
        data["number"] = this.number;
        return data; 
    }
}

export interface IGetUpdateTrPhoneInputDto {
    entityCode: string;
    psCode: string;
    refID: number;
    phoneType: string;
    number: string;
}

export class CreateTrBookingCorresInputDto implements ICreateTrBookingCorresInputDto {
    bookingCorresId: number;
    corresId: number;
    bookCode: string;
    refNo: string;
    dueDate: moment.Moment;
    docDate: moment.Moment;
    mailDate: moment.Moment;
    sendTo: string;
    remarks: string;
    corresImage: string;
    fileFormat: string;

    constructor(data?: ICreateTrBookingCorresInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingCorresId = data["bookingCorresId"];
            this.corresId = data["corresId"];
            this.bookCode = data["bookCode"];
            this.refNo = data["refNo"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.mailDate = data["mailDate"] ? moment(data["mailDate"].toString()) : <any>undefined;
            this.sendTo = data["sendTo"];
            this.remarks = data["remarks"];
            this.corresImage = data["corresImage"];
            this.fileFormat = data["fileFormat"];
        }
    }

    static fromJS(data: any): CreateTrBookingCorresInputDto {
        let result = new CreateTrBookingCorresInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingCorresId"] = this.bookingCorresId;
        data["corresId"] = this.corresId;
        data["bookCode"] = this.bookCode;
        data["refNo"] = this.refNo;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["mailDate"] = this.mailDate ? this.mailDate.toISOString() : <any>undefined;
        data["sendTo"] = this.sendTo;
        data["remarks"] = this.remarks;
        data["corresImage"] = this.corresImage;
        data["fileFormat"] = this.fileFormat;
        return data; 
    }
}

export interface ICreateTrBookingCorresInputDto {
    bookingCorresId: number;
    corresId: number;
    bookCode: string;
    refNo: string;
    dueDate: moment.Moment;
    docDate: moment.Moment;
    mailDate: moment.Moment;
    sendTo: string;
    remarks: string;
    corresImage: string;
    fileFormat: string;
}

export class GetDropdownCorresTypeListDto implements IGetDropdownCorresTypeListDto {
    id: number;
    corresCode: string;
    corresName: string;
    corresCodeCorresName: string;

    constructor(data?: IGetDropdownCorresTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.corresCode = data["corresCode"];
            this.corresName = data["corresName"];
            this.corresCodeCorresName = data["corresCodeCorresName"];
        }
    }

    static fromJS(data: any): GetDropdownCorresTypeListDto {
        let result = new GetDropdownCorresTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["corresCode"] = this.corresCode;
        data["corresName"] = this.corresName;
        data["corresCodeCorresName"] = this.corresCodeCorresName;
        return data; 
    }
}

export interface IGetDropdownCorresTypeListDto {
    id: number;
    corresCode: string;
    corresName: string;
    corresCodeCorresName: string;
}

export class GetTasklistTTORListDto implements IGetTasklistTTORListDto {
    bookingCorresId: number;
    corresCode: string;
    corresDate: moment.Moment;
    refNo: string;
    mailDate: moment.Moment;
    dueDate: moment.Moment;
    recepient: string;
    remarks: string;
    docId: string;
    fileFormat: string;

    constructor(data?: IGetTasklistTTORListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookingCorresId = data["bookingCorresId"];
            this.corresCode = data["corresCode"];
            this.corresDate = data["corresDate"] ? moment(data["corresDate"].toString()) : <any>undefined;
            this.refNo = data["refNo"];
            this.mailDate = data["mailDate"] ? moment(data["mailDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.recepient = data["recepient"];
            this.remarks = data["remarks"];
            this.docId = data["docId"];
            this.fileFormat = data["fileFormat"];
        }
    }

    static fromJS(data: any): GetTasklistTTORListDto {
        let result = new GetTasklistTTORListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingCorresId"] = this.bookingCorresId;
        data["corresCode"] = this.corresCode;
        data["corresDate"] = this.corresDate ? this.corresDate.toISOString() : <any>undefined;
        data["refNo"] = this.refNo;
        data["mailDate"] = this.mailDate ? this.mailDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["recepient"] = this.recepient;
        data["remarks"] = this.remarks;
        data["docId"] = this.docId;
        data["fileFormat"] = this.fileFormat;
        return data; 
    }
}

export interface IGetTasklistTTORListDto {
    bookingCorresId: number;
    corresCode: string;
    corresDate: moment.Moment;
    refNo: string;
    mailDate: moment.Moment;
    dueDate: moment.Moment;
    recepient: string;
    remarks: string;
    docId: string;
    fileFormat: string;
}

export class GetDocumentAttributeResultDto implements IGetDocumentAttributeResultDto {
    code: number;
    message: string;
    arrResult: Attribute[];

    constructor(data?: IGetDocumentAttributeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            if (data["arrResult"] && data["arrResult"].constructor === Array) {
                this.arrResult = [];
                for (let item of data["arrResult"])
                    this.arrResult.push(Attribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentAttributeResultDto {
        let result = new GetDocumentAttributeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (this.arrResult && this.arrResult.constructor === Array) {
            data["arrResult"] = [];
            for (let item of this.arrResult)
                data["arrResult"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDocumentAttributeResultDto {
    code: number;
    message: string;
    arrResult: Attribute[];
}

export class Attribute implements IAttribute {
    attributeID: string;
    attributeName: string;
    attributeValue: string;

    constructor(data?: IAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attributeID = data["attributeID"];
            this.attributeName = data["attributeName"];
            this.attributeValue = data["attributeValue"];
        }
    }

    static fromJS(data: any): Attribute {
        let result = new Attribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeID"] = this.attributeID;
        data["attributeName"] = this.attributeName;
        data["attributeValue"] = this.attributeValue;
        return data; 
    }
}

export interface IAttribute {
    attributeID: string;
    attributeName: string;
    attributeValue: string;
}

export class ViewDocumentResultDto implements IViewDocumentResultDto {
    code: number;
    message: string;
    arrResult: DetailDoc[];

    constructor(data?: IViewDocumentResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            if (data["arrResult"] && data["arrResult"].constructor === Array) {
                this.arrResult = [];
                for (let item of data["arrResult"])
                    this.arrResult.push(DetailDoc.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ViewDocumentResultDto {
        let result = new ViewDocumentResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (this.arrResult && this.arrResult.constructor === Array) {
            data["arrResult"] = [];
            for (let item of this.arrResult)
                data["arrResult"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IViewDocumentResultDto {
    code: number;
    message: string;
    arrResult: DetailDoc[];
}

export class DetailDoc implements IDetailDoc {
    docID: string;
    urlViewDoc: string;

    constructor(data?: IDetailDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docID = data["docID"];
            this.urlViewDoc = data["urlViewDoc"];
        }
    }

    static fromJS(data: any): DetailDoc {
        let result = new DetailDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docID"] = this.docID;
        data["urlViewDoc"] = this.urlViewDoc;
        return data; 
    }
}

export interface IDetailDoc {
    docID: string;
    urlViewDoc: string;
}

export class SaveDirectStoreInputDto implements ISaveDirectStoreInputDto {
    entityCode: string;
    requestorUsername: string;
    requestorName: string;
    requestorEmail: string;
    requestorDivision: string;
    arrDoc: DocumentDto[];

    constructor(data?: ISaveDirectStoreInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityCode = data["entityCode"];
            this.requestorUsername = data["requestorUsername"];
            this.requestorName = data["requestorName"];
            this.requestorEmail = data["requestorEmail"];
            this.requestorDivision = data["requestorDivision"];
            if (data["arrDoc"] && data["arrDoc"].constructor === Array) {
                this.arrDoc = [];
                for (let item of data["arrDoc"])
                    this.arrDoc.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDirectStoreInputDto {
        let result = new SaveDirectStoreInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityCode"] = this.entityCode;
        data["requestorUsername"] = this.requestorUsername;
        data["requestorName"] = this.requestorName;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorDivision"] = this.requestorDivision;
        if (this.arrDoc && this.arrDoc.constructor === Array) {
            data["arrDoc"] = [];
            for (let item of this.arrDoc)
                data["arrDoc"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveDirectStoreInputDto {
    entityCode: string;
    requestorUsername: string;
    requestorName: string;
    requestorEmail: string;
    requestorDivision: string;
    arrDoc: DocumentDto[];
}

export class DocumentDto implements IDocumentDto {
    encriptedDocKey: string;
    docName: string;
    docNo: string;
    docIssuerID: string;
    docDesc: string;
    fileName: string;
    fileFormat: string;
    file: string;
    arrDocAttribute: Attribute[];
    docID: string;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.encriptedDocKey = data["encriptedDocKey"];
            this.docName = data["docName"];
            this.docNo = data["docNo"];
            this.docIssuerID = data["docIssuerID"];
            this.docDesc = data["docDesc"];
            this.fileName = data["fileName"];
            this.fileFormat = data["fileFormat"];
            this.file = data["file"];
            if (data["arrDocAttribute"] && data["arrDocAttribute"].constructor === Array) {
                this.arrDocAttribute = [];
                for (let item of data["arrDocAttribute"])
                    this.arrDocAttribute.push(Attribute.fromJS(item));
            }
            this.docID = data["docID"];
        }
    }

    static fromJS(data: any): DocumentDto {
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["encriptedDocKey"] = this.encriptedDocKey;
        data["docName"] = this.docName;
        data["docNo"] = this.docNo;
        data["docIssuerID"] = this.docIssuerID;
        data["docDesc"] = this.docDesc;
        data["fileName"] = this.fileName;
        data["fileFormat"] = this.fileFormat;
        data["file"] = this.file;
        if (this.arrDocAttribute && this.arrDocAttribute.constructor === Array) {
            data["arrDocAttribute"] = [];
            for (let item of this.arrDocAttribute)
                data["arrDocAttribute"].push(item.toJSON());
        }
        data["docID"] = this.docID;
        return data; 
    }
}

export interface IDocumentDto {
    encriptedDocKey: string;
    docName: string;
    docNo: string;
    docIssuerID: string;
    docDesc: string;
    fileName: string;
    fileFormat: string;
    file: string;
    arrDocAttribute: Attribute[];
    docID: string;
}

export class SaveDirectStoreResultDto implements ISaveDirectStoreResultDto {
    code: number;
    message: string;
    arrResult: DocumentDto[];

    constructor(data?: ISaveDirectStoreResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            if (data["arrResult"] && data["arrResult"].constructor === Array) {
                this.arrResult = [];
                for (let item of data["arrResult"])
                    this.arrResult.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDirectStoreResultDto {
        let result = new SaveDirectStoreResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (this.arrResult && this.arrResult.constructor === Array) {
            data["arrResult"] = [];
            for (let item of this.arrResult)
                data["arrResult"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveDirectStoreResultDto {
    code: number;
    message: string;
    arrResult: DocumentDto[];
}

export class ViewTTORInputDto implements IViewTTORInputDto {
    bookCode: string;
    refNo: string;

    constructor(data?: IViewTTORInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookCode = data["bookCode"];
            this.refNo = data["refNo"];
        }
    }

    static fromJS(data: any): ViewTTORInputDto {
        let result = new ViewTTORInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookCode"] = this.bookCode;
        data["refNo"] = this.refNo;
        return data; 
    }
}

export interface IViewTTORInputDto {
    bookCode: string;
    refNo: string;
}

export class ViewTTORResultDto implements IViewTTORResultDto {
    corresType: string;
    refNo: string;
    docDate: moment.Moment;
    mailDate: moment.Moment;
    sendTo: string;
    dueDate: moment.Moment;
    remarks: string;
    docId: string;

    constructor(data?: IViewTTORResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.corresType = data["corresType"];
            this.refNo = data["refNo"];
            this.docDate = data["docDate"] ? moment(data["docDate"].toString()) : <any>undefined;
            this.mailDate = data["mailDate"] ? moment(data["mailDate"].toString()) : <any>undefined;
            this.sendTo = data["sendTo"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.remarks = data["remarks"];
            this.docId = data["docId"];
        }
    }

    static fromJS(data: any): ViewTTORResultDto {
        let result = new ViewTTORResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corresType"] = this.corresType;
        data["refNo"] = this.refNo;
        data["docDate"] = this.docDate ? this.docDate.toISOString() : <any>undefined;
        data["mailDate"] = this.mailDate ? this.mailDate.toISOString() : <any>undefined;
        data["sendTo"] = this.sendTo;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["docId"] = this.docId;
        return data; 
    }
}

export interface IViewTTORResultDto {
    corresType: string;
    refNo: string;
    docDate: moment.Moment;
    mailDate: moment.Moment;
    sendTo: string;
    dueDate: moment.Moment;
    remarks: string;
    docId: string;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : <any>undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    pageLoader: string;
    contentSkin: string;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.pageLoader = data["pageLoader"];
            this.contentSkin = data["contentSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["pageLoader"] = this.pageLoader;
        data["contentSkin"] = this.contentSkin;
        return data; 
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    pageLoader: string;
    contentSkin: string;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.dropdownSkinDesktop = data["dropdownSkinDesktop"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
            this.dropdownSkin = data["dropdownSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["dropdownSkinDesktop"] = this.dropdownSkinDesktop;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        data["dropdownSkin"] = this.dropdownSkin;
        return data; 
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data; 
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;
}

export class GenerateExcelUpdateGrossPriceInputDto implements IGenerateExcelUpdateGrossPriceInputDto {
    projectID: number;
    clusterID: number[];
    renovID: number[];
    termMainID: number;
    termID: number[];
    tglUpdate: string;

    constructor(data?: IGenerateExcelUpdateGrossPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            if (data["renovID"] && data["renovID"].constructor === Array) {
                this.renovID = [];
                for (let item of data["renovID"])
                    this.renovID.push(item);
            }
            this.termMainID = data["termMainID"];
            if (data["termID"] && data["termID"].constructor === Array) {
                this.termID = [];
                for (let item of data["termID"])
                    this.termID.push(item);
            }
            this.tglUpdate = data["tglUpdate"];
        }
    }

    static fromJS(data: any): GenerateExcelUpdateGrossPriceInputDto {
        let result = new GenerateExcelUpdateGrossPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        if (this.renovID && this.renovID.constructor === Array) {
            data["renovID"] = [];
            for (let item of this.renovID)
                data["renovID"].push(item);
        }
        data["termMainID"] = this.termMainID;
        if (this.termID && this.termID.constructor === Array) {
            data["termID"] = [];
            for (let item of this.termID)
                data["termID"].push(item);
        }
        data["tglUpdate"] = this.tglUpdate;
        return data; 
    }
}

export interface IGenerateExcelUpdateGrossPriceInputDto {
    projectID: number;
    clusterID: number[];
    renovID: number[];
    termMainID: number;
    termID: number[];
    tglUpdate: string;
}

export class CreateStgUnitItemPriceInputDto implements ICreateStgUnitItemPriceInputDto {
    listUnitPrice: GetItemPriceFromExcelInputDto[];
    tglUpdate: string;
    userID: number;
    projectID: number;
    clusterID: number[];
    renovID: number[];
    termMainID: number;
    termID: number[];

    constructor(data?: ICreateStgUnitItemPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listUnitPrice"] && data["listUnitPrice"].constructor === Array) {
                this.listUnitPrice = [];
                for (let item of data["listUnitPrice"])
                    this.listUnitPrice.push(GetItemPriceFromExcelInputDto.fromJS(item));
            }
            this.tglUpdate = data["tglUpdate"];
            this.userID = data["userID"];
            this.projectID = data["projectID"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
            if (data["renovID"] && data["renovID"].constructor === Array) {
                this.renovID = [];
                for (let item of data["renovID"])
                    this.renovID.push(item);
            }
            this.termMainID = data["termMainID"];
            if (data["termID"] && data["termID"].constructor === Array) {
                this.termID = [];
                for (let item of data["termID"])
                    this.termID.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStgUnitItemPriceInputDto {
        let result = new CreateStgUnitItemPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listUnitPrice && this.listUnitPrice.constructor === Array) {
            data["listUnitPrice"] = [];
            for (let item of this.listUnitPrice)
                data["listUnitPrice"].push(item.toJSON());
        }
        data["tglUpdate"] = this.tglUpdate;
        data["userID"] = this.userID;
        data["projectID"] = this.projectID;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        if (this.renovID && this.renovID.constructor === Array) {
            data["renovID"] = [];
            for (let item of this.renovID)
                data["renovID"].push(item);
        }
        data["termMainID"] = this.termMainID;
        if (this.termID && this.termID.constructor === Array) {
            data["termID"] = [];
            for (let item of this.termID)
                data["termID"].push(item);
        }
        return data; 
    }
}

export interface ICreateStgUnitItemPriceInputDto {
    listUnitPrice: GetItemPriceFromExcelInputDto[];
    tglUpdate: string;
    userID: number;
    projectID: number;
    clusterID: number[];
    renovID: number[];
    termMainID: number;
    termID: number[];
}

export class GetItemPriceFromExcelInputDto implements IGetItemPriceFromExcelInputDto {
    unitCode: string;
    unitNo: string;
    termCode: string;
    termRemarks: string;
    renovCode: string;
    landPrice: number;
    buildPrice: number;
    renovPrice: number;
    status: boolean;
    message: string;

    constructor(data?: IGetItemPriceFromExcelInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.termCode = data["termCode"];
            this.termRemarks = data["termRemarks"];
            this.renovCode = data["renovCode"];
            this.landPrice = data["landPrice"];
            this.buildPrice = data["buildPrice"];
            this.renovPrice = data["renovPrice"];
            this.status = data["status"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetItemPriceFromExcelInputDto {
        let result = new GetItemPriceFromExcelInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["termCode"] = this.termCode;
        data["termRemarks"] = this.termRemarks;
        data["renovCode"] = this.renovCode;
        data["landPrice"] = this.landPrice;
        data["buildPrice"] = this.buildPrice;
        data["renovPrice"] = this.renovPrice;
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetItemPriceFromExcelInputDto {
    unitCode: string;
    unitNo: string;
    termCode: string;
    termRemarks: string;
    renovCode: string;
    landPrice: number;
    buildPrice: number;
    renovPrice: number;
    status: boolean;
    message: string;
}

export class GetListFileUpdatePriceResultDto implements IGetListFileUpdatePriceResultDto {
    filePath: string;
    creationTime: moment.Moment;
    createBy: string;

    constructor(data?: IGetListFileUpdatePriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filePath = data["filePath"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.createBy = data["createBy"];
        }
    }

    static fromJS(data: any): GetListFileUpdatePriceResultDto {
        let result = new GetListFileUpdatePriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["createBy"] = this.createBy;
        return data; 
    }
}

export interface IGetListFileUpdatePriceResultDto {
    filePath: string;
    creationTime: moment.Moment;
    createBy: string;
}

export class GetDropdownTermCodeInputDto implements IGetDropdownTermCodeInputDto {
    projectID: number;
    clusterID: number[];

    constructor(data?: IGetDropdownTermCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectID = data["projectID"];
            if (data["clusterID"] && data["clusterID"].constructor === Array) {
                this.clusterID = [];
                for (let item of data["clusterID"])
                    this.clusterID.push(item);
            }
        }
    }

    static fromJS(data: any): GetDropdownTermCodeInputDto {
        let result = new GetDropdownTermCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectID"] = this.projectID;
        if (this.clusterID && this.clusterID.constructor === Array) {
            data["clusterID"] = [];
            for (let item of this.clusterID)
                data["clusterID"].push(item);
        }
        return data; 
    }
}

export interface IGetDropdownTermCodeInputDto {
    projectID: number;
    clusterID: number[];
}

export class GetDropdownTermCodeResultDto implements IGetDropdownTermCodeResultDto {
    termMainID: number;
    termCode: string;

    constructor(data?: IGetDropdownTermCodeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMainID = data["termMainID"];
            this.termCode = data["termCode"];
        }
    }

    static fromJS(data: any): GetDropdownTermCodeResultDto {
        let result = new GetDropdownTermCodeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMainID"] = this.termMainID;
        data["termCode"] = this.termCode;
        return data; 
    }
}

export interface IGetDropdownTermCodeResultDto {
    termMainID: number;
    termCode: string;
}

export class GetDataReportUpdatePriceResultDto implements IGetDataReportUpdatePriceResultDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    listTermPrices: ListTermPrice[];

    constructor(data?: IGetDataReportUpdatePriceResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unitID = data["unitID"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            if (data["listTermPrices"] && data["listTermPrices"].constructor === Array) {
                this.listTermPrices = [];
                for (let item of data["listTermPrices"])
                    this.listTermPrices.push(ListTermPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataReportUpdatePriceResultDto {
        let result = new GetDataReportUpdatePriceResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitID"] = this.unitID;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        if (this.listTermPrices && this.listTermPrices.constructor === Array) {
            data["listTermPrices"] = [];
            for (let item of this.listTermPrices)
                data["listTermPrices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataReportUpdatePriceResultDto {
    unitID: number;
    unitCode: string;
    unitNo: string;
    listTermPrices: ListTermPrice[];
}

export class ListTermPrice implements IListTermPrice {
    renovName: string;
    price: number;
    termRemarks: string;
    statusUpdate: string;

    constructor(data?: IListTermPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.renovName = data["renovName"];
            this.price = data["price"];
            this.termRemarks = data["termRemarks"];
            this.statusUpdate = data["statusUpdate"];
        }
    }

    static fromJS(data: any): ListTermPrice {
        let result = new ListTermPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renovName"] = this.renovName;
        data["price"] = this.price;
        data["termRemarks"] = this.termRemarks;
        data["statusUpdate"] = this.statusUpdate;
        return data; 
    }
}

export interface IListTermPrice {
    renovName: string;
    price: number;
    termRemarks: string;
    statusUpdate: string;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];
}

export class UserEditDto implements IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data; 
    }
}

export interface IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[] = [];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto = new UserEditDto();
    assignedRoleNames: string[] = [];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[];

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[];
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number;
    userId: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number;
    userId: number;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;
}

export class ListResultDtoOfGetDataPPUserListDto implements IListResultDtoOfGetDataPPUserListDto {
    items: GetDataPPUserListDto[];

    constructor(data?: IListResultDtoOfGetDataPPUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDataPPUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDataPPUserListDto {
        let result = new ListResultDtoOfGetDataPPUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDataPPUserListDto {
    items: GetDataPPUserListDto[];
}

export class GetDataPPUserListDto implements IGetDataPPUserListDto {
    userName: string;
    pass: string;
    psCode: string;

    constructor(data?: IGetDataPPUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.pass = data["pass"];
            this.psCode = data["psCode"];
        }
    }

    static fromJS(data: any): GetDataPPUserListDto {
        let result = new GetDataPPUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["pass"] = this.pass;
        data["psCode"] = this.psCode;
        return data; 
    }
}

export interface IGetDataPPUserListDto {
    userName: string;
    pass: string;
    psCode: string;
}

export class ConnStringUserInputDto implements IConnStringUserInputDto {
    ipServer: string;
    credentialUser: string;
    credentialPass: string;
    databaseName: string;
    tableName: string;
    linkServer: string;
    scmCode: string;
    query: string;

    constructor(data?: IConnStringUserInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ipServer = data["ipServer"];
            this.credentialUser = data["credentialUser"];
            this.credentialPass = data["credentialPass"];
            this.databaseName = data["databaseName"];
            this.tableName = data["tableName"];
            this.linkServer = data["linkServer"];
            this.scmCode = data["scmCode"];
            this.query = data["query"];
        }
    }

    static fromJS(data: any): ConnStringUserInputDto {
        let result = new ConnStringUserInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipServer"] = this.ipServer;
        data["credentialUser"] = this.credentialUser;
        data["credentialPass"] = this.credentialPass;
        data["databaseName"] = this.databaseName;
        data["tableName"] = this.tableName;
        data["linkServer"] = this.linkServer;
        data["scmCode"] = this.scmCode;
        data["query"] = this.query;
        return data; 
    }
}

export interface IConnStringUserInputDto {
    ipServer: string;
    credentialUser: string;
    credentialPass: string;
    databaseName: string;
    tableName: string;
    linkServer: string;
    scmCode: string;
    query: string;
}

export class GetDetailUploadListDto implements IGetDetailUploadListDto {
    userName: string;
    message: string;

    constructor(data?: IGetDetailUploadListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetDetailUploadListDto {
        let result = new GetDetailUploadListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetDetailUploadListDto {
    userName: string;
    message: string;
}

export class CheckDataVaBulkInputDto implements ICheckDataVaBulkInputDto {
    accID: number;
    userID: number;
    vaNumber: string;
    tglTransaksi: string;
    refNo: string;

    constructor(data?: ICheckDataVaBulkInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.userID = data["userID"];
            this.vaNumber = data["vaNumber"];
            this.tglTransaksi = data["tglTransaksi"];
            this.refNo = data["refNo"];
        }
    }

    static fromJS(data: any): CheckDataVaBulkInputDto {
        let result = new CheckDataVaBulkInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["userID"] = this.userID;
        data["vaNumber"] = this.vaNumber;
        data["tglTransaksi"] = this.tglTransaksi;
        data["refNo"] = this.refNo;
        return data; 
    }
}

export interface ICheckDataVaBulkInputDto {
    accID: number;
    userID: number;
    vaNumber: string;
    tglTransaksi: string;
    refNo: string;
}

export class GetDataCheckUploadVaBulkListDto implements IGetDataCheckUploadVaBulkListDto {
    virtualAccount: string;
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    dataSchedule: GetDataSchedule[];

    constructor(data?: IGetDataCheckUploadVaBulkListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.virtualAccount = data["virtualAccount"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.bookCode = data["bookCode"];
            this.psCode = data["psCode"];
            this.name = data["name"];
            this.npwp = data["npwp"];
            this.address = data["address"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.unitID = data["unitID"];
            this.payForCode = data["payForCode"];
            this.payTypeCode = data["payTypeCode"];
            this.othersTypeCode = data["othersTypeCode"];
            this.payForID = data["payForID"];
            this.payTypeID = data["payTypeID"];
            this.othersTypeID = data["othersTypeID"];
            this.pctTax = data["pctTax"];
            this.message = data["message"];
            if (data["dataSchedule"] && data["dataSchedule"].constructor === Array) {
                this.dataSchedule = [];
                for (let item of data["dataSchedule"])
                    this.dataSchedule.push(GetDataSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataCheckUploadVaBulkListDto {
        let result = new GetDataCheckUploadVaBulkListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["virtualAccount"] = this.virtualAccount;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["bookCode"] = this.bookCode;
        data["psCode"] = this.psCode;
        data["name"] = this.name;
        data["npwp"] = this.npwp;
        data["address"] = this.address;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["unitID"] = this.unitID;
        data["payForCode"] = this.payForCode;
        data["payTypeCode"] = this.payTypeCode;
        data["othersTypeCode"] = this.othersTypeCode;
        data["payForID"] = this.payForID;
        data["payTypeID"] = this.payTypeID;
        data["othersTypeID"] = this.othersTypeID;
        data["pctTax"] = this.pctTax;
        data["message"] = this.message;
        if (this.dataSchedule && this.dataSchedule.constructor === Array) {
            data["dataSchedule"] = [];
            for (let item of this.dataSchedule)
                data["dataSchedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDataCheckUploadVaBulkListDto {
    virtualAccount: string;
    bookingHeaderID: number;
    bookCode: string;
    psCode: string;
    name: string;
    npwp: string;
    address: string;
    unitCode: string;
    unitNo: string;
    unitID: number;
    payForCode: string;
    payTypeCode: string;
    othersTypeCode: string;
    payForID: number;
    payTypeID: number;
    othersTypeID: number;
    pctTax: number;
    message: string;
    dataSchedule: GetDataSchedule[];
}

export class CreateUniversalVaBulkPaymentInputDto implements ICreateUniversalVaBulkPaymentInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    unitID: number;
    virtualAccount: string;
    nama: string;
    nilaiTransaksi: number;
    jenisTransaksi: string;
    tanggalTransaksi: moment.Moment;
    keterangan: string;
    jamTransaksi: string;
    noRef: string;
    npwp: string;
    name: string;
    address: string;
    psCode: string;
    unitCode: string;
    unitNo: string;
    tanggalMutasi: moment.Moment;
    pctTax: number;
    amountOver: number;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];

    constructor(data?: ICreateUniversalVaBulkPaymentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accID = data["accID"];
            this.bookingHeaderID = data["bookingHeaderID"];
            this.payForID = data["payForID"];
            this.unitID = data["unitID"];
            this.virtualAccount = data["virtualAccount"];
            this.nama = data["nama"];
            this.nilaiTransaksi = data["nilaiTransaksi"];
            this.jenisTransaksi = data["jenisTransaksi"];
            this.tanggalTransaksi = data["tanggalTransaksi"] ? moment(data["tanggalTransaksi"].toString()) : <any>undefined;
            this.keterangan = data["keterangan"];
            this.jamTransaksi = data["jamTransaksi"];
            this.noRef = data["noRef"];
            this.npwp = data["npwp"];
            this.name = data["name"];
            this.address = data["address"];
            this.psCode = data["psCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.tanggalMutasi = data["tanggalMutasi"] ? moment(data["tanggalMutasi"].toString()) : <any>undefined;
            this.pctTax = data["pctTax"];
            this.amountOver = data["amountOver"];
            if (data["dataScheduleList"] && data["dataScheduleList"].constructor === Array) {
                this.dataScheduleList = [];
                for (let item of data["dataScheduleList"])
                    this.dataScheduleList.push(DataAlloc.fromJS(item));
            }
            if (data["dataForPayment"] && data["dataForPayment"].constructor === Array) {
                this.dataForPayment = [];
                for (let item of data["dataForPayment"])
                    this.dataForPayment.push(DataPayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUniversalVaBulkPaymentInputDto {
        let result = new CreateUniversalVaBulkPaymentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accID"] = this.accID;
        data["bookingHeaderID"] = this.bookingHeaderID;
        data["payForID"] = this.payForID;
        data["unitID"] = this.unitID;
        data["virtualAccount"] = this.virtualAccount;
        data["nama"] = this.nama;
        data["nilaiTransaksi"] = this.nilaiTransaksi;
        data["jenisTransaksi"] = this.jenisTransaksi;
        data["tanggalTransaksi"] = this.tanggalTransaksi ? this.tanggalTransaksi.toISOString() : <any>undefined;
        data["keterangan"] = this.keterangan;
        data["jamTransaksi"] = this.jamTransaksi;
        data["noRef"] = this.noRef;
        data["npwp"] = this.npwp;
        data["name"] = this.name;
        data["address"] = this.address;
        data["psCode"] = this.psCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["tanggalMutasi"] = this.tanggalMutasi ? this.tanggalMutasi.toISOString() : <any>undefined;
        data["pctTax"] = this.pctTax;
        data["amountOver"] = this.amountOver;
        if (this.dataScheduleList && this.dataScheduleList.constructor === Array) {
            data["dataScheduleList"] = [];
            for (let item of this.dataScheduleList)
                data["dataScheduleList"].push(item.toJSON());
        }
        if (this.dataForPayment && this.dataForPayment.constructor === Array) {
            data["dataForPayment"] = [];
            for (let item of this.dataForPayment)
                data["dataForPayment"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateUniversalVaBulkPaymentInputDto {
    accID: number;
    bookingHeaderID: number;
    payForID: number;
    unitID: number;
    virtualAccount: string;
    nama: string;
    nilaiTransaksi: number;
    jenisTransaksi: string;
    tanggalTransaksi: moment.Moment;
    keterangan: string;
    jamTransaksi: string;
    noRef: string;
    npwp: string;
    name: string;
    address: string;
    psCode: string;
    unitCode: string;
    unitNo: string;
    tanggalMutasi: moment.Moment;
    pctTax: number;
    amountOver: number;
    dataScheduleList: DataAlloc[];
    dataForPayment: DataPayment[];
}

export class VoucherInputPagingDto implements IVoucherInputPagingDto {
    maxResultCount: number;
    skipCount: number;
    keywords: string;
    projectID: number;

    constructor(data?: IVoucherInputPagingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.keywords = data["keywords"];
            this.projectID = data["projectID"];
        }
    }

    static fromJS(data: any): VoucherInputPagingDto {
        let result = new VoucherInputPagingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["keywords"] = this.keywords;
        data["projectID"] = this.projectID;
        return data; 
    }
}

export interface IVoucherInputPagingDto {
    maxResultCount: number;
    skipCount: number;
    keywords: string;
    projectID: number;
}

export class PagedResultDtoOfGetDataVoucherListDto implements IPagedResultDtoOfGetDataVoucherListDto {
    totalCount: number;
    items: GetDataVoucherListDto[];

    constructor(data?: IPagedResultDtoOfGetDataVoucherListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDataVoucherListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDataVoucherListDto {
        let result = new PagedResultDtoOfGetDataVoucherListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDataVoucherListDto {
    totalCount: number;
    items: GetDataVoucherListDto[];
}

export class GetDataVoucherListDto implements IGetDataVoucherListDto {
    receiptCode: string;
    receiptDate: moment.Moment;
    createdDate: moment.Moment;
    expiredDate: moment.Moment;
    receiptAmt: number;
    idLocation: number;
    locationName: string;
    projectID: number;
    projectName: string;
    rewardName: string;
    rewardID: string;
    voucherCode: string;
    attachment: string;
    voucherTypeCode: string;
    inputTime: moment.Moment;
    isExpired: boolean;
    isUsed: boolean;
    projectInfoId: number;
    productName: string;

    constructor(data?: IGetDataVoucherListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptCode = data["receiptCode"];
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.createdDate = data["createdDate"] ? moment(data["createdDate"].toString()) : <any>undefined;
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.receiptAmt = data["receiptAmt"];
            this.idLocation = data["idLocation"];
            this.locationName = data["locationName"];
            this.projectID = data["projectID"];
            this.projectName = data["projectName"];
            this.rewardName = data["rewardName"];
            this.rewardID = data["rewardID"];
            this.voucherCode = data["voucherCode"];
            this.attachment = data["attachment"];
            this.voucherTypeCode = data["voucherTypeCode"];
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.isExpired = data["isExpired"];
            this.isUsed = data["isUsed"];
            this.projectInfoId = data["projectInfoId"];
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetDataVoucherListDto {
        let result = new GetDataVoucherListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptCode"] = this.receiptCode;
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["receiptAmt"] = this.receiptAmt;
        data["idLocation"] = this.idLocation;
        data["locationName"] = this.locationName;
        data["projectID"] = this.projectID;
        data["projectName"] = this.projectName;
        data["rewardName"] = this.rewardName;
        data["rewardID"] = this.rewardID;
        data["voucherCode"] = this.voucherCode;
        data["attachment"] = this.attachment;
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["isUsed"] = this.isUsed;
        data["projectInfoId"] = this.projectInfoId;
        data["productName"] = this.productName;
        return data; 
    }
}

export interface IGetDataVoucherListDto {
    receiptCode: string;
    receiptDate: moment.Moment;
    createdDate: moment.Moment;
    expiredDate: moment.Moment;
    receiptAmt: number;
    idLocation: number;
    locationName: string;
    projectID: number;
    projectName: string;
    rewardName: string;
    rewardID: string;
    voucherCode: string;
    attachment: string;
    voucherTypeCode: string;
    inputTime: moment.Moment;
    isExpired: boolean;
    isUsed: boolean;
    projectInfoId: number;
    productName: string;
}

export class GetOrCreateVoucherResult implements IGetOrCreateVoucherResult {
    voucherCode: string;
    isUsingExistingVoucher: boolean;
    expirationDate: moment.Moment;
    voucherAmt: number;
    voucherPdf: string;

    constructor(data?: IGetOrCreateVoucherResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.isUsingExistingVoucher = data["isUsingExistingVoucher"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.voucherAmt = data["voucherAmt"];
            this.voucherPdf = data["voucherPdf"];
        }
    }

    static fromJS(data: any): GetOrCreateVoucherResult {
        let result = new GetOrCreateVoucherResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["isUsingExistingVoucher"] = this.isUsingExistingVoucher;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["voucherAmt"] = this.voucherAmt;
        data["voucherPdf"] = this.voucherPdf;
        return data; 
    }
}

export interface IGetOrCreateVoucherResult {
    voucherCode: string;
    isUsingExistingVoucher: boolean;
    expirationDate: moment.Moment;
    voucherAmt: number;
    voucherPdf: string;
}

export class DropDownDto implements IDropDownDto {
    items: DropDownElementDto[];

    constructor(data?: IDropDownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DropDownElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropDownDto {
        let result = new DropDownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDropDownDto {
    items: DropDownElementDto[];
}

export class DropDownElementDto implements IDropDownElementDto {
    value: string;
    textDisplay: string;

    constructor(data?: IDropDownElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.textDisplay = data["textDisplay"];
        }
    }

    static fromJS(data: any): DropDownElementDto {
        let result = new DropDownElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["textDisplay"] = this.textDisplay;
        return data; 
    }
}

export interface IDropDownElementDto {
    value: string;
    textDisplay: string;
}

export class GetDropdownVoucherType implements IGetDropdownVoucherType {
    voucherTypeCode: string;
    voucherTypeName: string;
    expiredOn: number;

    constructor(data?: IGetDropdownVoucherType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherTypeCode = data["voucherTypeCode"];
            this.voucherTypeName = data["voucherTypeName"];
            this.expiredOn = data["expiredOn"];
        }
    }

    static fromJS(data: any): GetDropdownVoucherType {
        let result = new GetDropdownVoucherType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherTypeCode"] = this.voucherTypeCode;
        data["voucherTypeName"] = this.voucherTypeName;
        data["expiredOn"] = this.expiredOn;
        return data; 
    }
}

export interface IGetDropdownVoucherType {
    voucherTypeCode: string;
    voucherTypeName: string;
    expiredOn: number;
}

export class GetOrCreateVoucherV2Input implements IGetOrCreateVoucherV2Input {
    receiptCode: string;
    receiptDate: moment.Moment;
    receiptAmt: number;
    idLocation: number;
    projectID: number;
    projectInfoID: number;
    voucherTypeCode: string;
    rewardID: number[];
    attachment: string;
    expiredDate: moment.Moment;

    constructor(data?: IGetOrCreateVoucherV2Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptCode = data["receiptCode"];
            this.receiptDate = data["receiptDate"] ? moment(data["receiptDate"].toString()) : <any>undefined;
            this.receiptAmt = data["receiptAmt"];
            this.idLocation = data["idLocation"];
            this.projectID = data["projectID"];
            this.projectInfoID = data["projectInfoID"];
            this.voucherTypeCode = data["voucherTypeCode"];
            if (data["rewardID"] && data["rewardID"].constructor === Array) {
                this.rewardID = [];
                for (let item of data["rewardID"])
                    this.rewardID.push(item);
            }
            this.attachment = data["attachment"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrCreateVoucherV2Input {
        let result = new GetOrCreateVoucherV2Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptCode"] = this.receiptCode;
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["receiptAmt"] = this.receiptAmt;
        data["idLocation"] = this.idLocation;
        data["projectID"] = this.projectID;
        data["projectInfoID"] = this.projectInfoID;
        data["voucherTypeCode"] = this.voucherTypeCode;
        if (this.rewardID && this.rewardID.constructor === Array) {
            data["rewardID"] = [];
            for (let item of this.rewardID)
                data["rewardID"].push(item);
        }
        data["attachment"] = this.attachment;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetOrCreateVoucherV2Input {
    receiptCode: string;
    receiptDate: moment.Moment;
    receiptAmt: number;
    idLocation: number;
    projectID: number;
    projectInfoID: number;
    voucherTypeCode: string;
    rewardID: number[];
    attachment: string;
    expiredDate: moment.Moment;
}

export class GenerateVoucherInputDto implements IGenerateVoucherInputDto {
    inputTime: moment.Moment;
    voucherDate: string;
    voucherCode: string;
    rewardName: string;
    expireOn: moment.Moment;

    constructor(data?: IGenerateVoucherInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inputTime = data["inputTime"] ? moment(data["inputTime"].toString()) : <any>undefined;
            this.voucherDate = data["voucherDate"];
            this.voucherCode = data["voucherCode"];
            this.rewardName = data["rewardName"];
            this.expireOn = data["expireOn"] ? moment(data["expireOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateVoucherInputDto {
        let result = new GenerateVoucherInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputTime"] = this.inputTime ? this.inputTime.toISOString() : <any>undefined;
        data["voucherDate"] = this.voucherDate;
        data["voucherCode"] = this.voucherCode;
        data["rewardName"] = this.rewardName;
        data["expireOn"] = this.expireOn ? this.expireOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGenerateVoucherInputDto {
    inputTime: moment.Moment;
    voucherDate: string;
    voucherCode: string;
    rewardName: string;
    expireOn: moment.Moment;
}

export class ReportVoucherInputDto implements IReportVoucherInputDto {
    projectID: number[];
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    projectInfoID: number[];
    memberCode: string;
    voucherTypeCode: string[];
    rewardID: number[];
    status: string[];
    limitData: number;

    constructor(data?: IReportVoucherInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["projectID"] && data["projectID"].constructor === Array) {
                this.projectID = [];
                for (let item of data["projectID"])
                    this.projectID.push(item);
            }
            this.periodeStart = data["periodeStart"] ? moment(data["periodeStart"].toString()) : <any>undefined;
            this.periodeEnd = data["periodeEnd"] ? moment(data["periodeEnd"].toString()) : <any>undefined;
            if (data["projectInfoID"] && data["projectInfoID"].constructor === Array) {
                this.projectInfoID = [];
                for (let item of data["projectInfoID"])
                    this.projectInfoID.push(item);
            }
            this.memberCode = data["memberCode"];
            if (data["voucherTypeCode"] && data["voucherTypeCode"].constructor === Array) {
                this.voucherTypeCode = [];
                for (let item of data["voucherTypeCode"])
                    this.voucherTypeCode.push(item);
            }
            if (data["rewardID"] && data["rewardID"].constructor === Array) {
                this.rewardID = [];
                for (let item of data["rewardID"])
                    this.rewardID.push(item);
            }
            if (data["status"] && data["status"].constructor === Array) {
                this.status = [];
                for (let item of data["status"])
                    this.status.push(item);
            }
            this.limitData = data["limitData"];
        }
    }

    static fromJS(data: any): ReportVoucherInputDto {
        let result = new ReportVoucherInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.projectID && this.projectID.constructor === Array) {
            data["projectID"] = [];
            for (let item of this.projectID)
                data["projectID"].push(item);
        }
        data["periodeStart"] = this.periodeStart ? this.periodeStart.toISOString() : <any>undefined;
        data["periodeEnd"] = this.periodeEnd ? this.periodeEnd.toISOString() : <any>undefined;
        if (this.projectInfoID && this.projectInfoID.constructor === Array) {
            data["projectInfoID"] = [];
            for (let item of this.projectInfoID)
                data["projectInfoID"].push(item);
        }
        data["memberCode"] = this.memberCode;
        if (this.voucherTypeCode && this.voucherTypeCode.constructor === Array) {
            data["voucherTypeCode"] = [];
            for (let item of this.voucherTypeCode)
                data["voucherTypeCode"].push(item);
        }
        if (this.rewardID && this.rewardID.constructor === Array) {
            data["rewardID"] = [];
            for (let item of this.rewardID)
                data["rewardID"].push(item);
        }
        if (this.status && this.status.constructor === Array) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["limitData"] = this.limitData;
        return data; 
    }
}

export interface IReportVoucherInputDto {
    projectID: number[];
    periodeStart: moment.Moment;
    periodeEnd: moment.Moment;
    projectInfoID: number[];
    memberCode: string;
    voucherTypeCode: string[];
    rewardID: number[];
    status: string[];
    limitData: number;
}

export class ReportVoucherResultPublishDto implements IReportVoucherResultPublishDto {
    memberCode: string;
    publishDate: string;
    path: string;
    listreport: ReportVoucherResultDto[];

    constructor(data?: IReportVoucherResultPublishDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.publishDate = data["publishDate"];
            this.path = data["path"];
            if (data["listreport"] && data["listreport"].constructor === Array) {
                this.listreport = [];
                for (let item of data["listreport"])
                    this.listreport.push(ReportVoucherResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportVoucherResultPublishDto {
        let result = new ReportVoucherResultPublishDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["publishDate"] = this.publishDate;
        data["path"] = this.path;
        if (this.listreport && this.listreport.constructor === Array) {
            data["listreport"] = [];
            for (let item of this.listreport)
                data["listreport"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReportVoucherResultPublishDto {
    memberCode: string;
    publishDate: string;
    path: string;
    listreport: ReportVoucherResultDto[];
}

export class ReportVoucherResultDto implements IReportVoucherResultDto {
    projectName: string;
    productName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    voucherTypeName: string;
    rewardName: string;
    voucherCode: string;
    bookingRewardStatus: string;
    status: string;
    newRewardDate: moment.Moment;
    inputVoucherDate: moment.Moment;
    redeemDate: moment.Moment;
    picNewReward: number;
    picInputVoucher: number;
    picRedeem: number;
    psName: string;
    picNewRewardUser: string;
    picInputVoucherUser: string;
    picRedeemUser: string;

    constructor(data?: IReportVoucherResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.projectName = data["projectName"];
            this.productName = data["productName"];
            this.bookCode = data["bookCode"];
            this.unitCode = data["unitCode"];
            this.unitNo = data["unitNo"];
            this.voucherTypeName = data["voucherTypeName"];
            this.rewardName = data["rewardName"];
            this.voucherCode = data["voucherCode"];
            this.bookingRewardStatus = data["bookingRewardStatus"];
            this.status = data["status"];
            this.newRewardDate = data["newRewardDate"] ? moment(data["newRewardDate"].toString()) : <any>undefined;
            this.inputVoucherDate = data["inputVoucherDate"] ? moment(data["inputVoucherDate"].toString()) : <any>undefined;
            this.redeemDate = data["redeemDate"] ? moment(data["redeemDate"].toString()) : <any>undefined;
            this.picNewReward = data["picNewReward"];
            this.picInputVoucher = data["picInputVoucher"];
            this.picRedeem = data["picRedeem"];
            this.psName = data["psName"];
            this.picNewRewardUser = data["picNewRewardUser"];
            this.picInputVoucherUser = data["picInputVoucherUser"];
            this.picRedeemUser = data["picRedeemUser"];
        }
    }

    static fromJS(data: any): ReportVoucherResultDto {
        let result = new ReportVoucherResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["productName"] = this.productName;
        data["bookCode"] = this.bookCode;
        data["unitCode"] = this.unitCode;
        data["unitNo"] = this.unitNo;
        data["voucherTypeName"] = this.voucherTypeName;
        data["rewardName"] = this.rewardName;
        data["voucherCode"] = this.voucherCode;
        data["bookingRewardStatus"] = this.bookingRewardStatus;
        data["status"] = this.status;
        data["newRewardDate"] = this.newRewardDate ? this.newRewardDate.toISOString() : <any>undefined;
        data["inputVoucherDate"] = this.inputVoucherDate ? this.inputVoucherDate.toISOString() : <any>undefined;
        data["redeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : <any>undefined;
        data["picNewReward"] = this.picNewReward;
        data["picInputVoucher"] = this.picInputVoucher;
        data["picRedeem"] = this.picRedeem;
        data["psName"] = this.psName;
        data["picNewRewardUser"] = this.picNewRewardUser;
        data["picInputVoucherUser"] = this.picInputVoucherUser;
        data["picRedeemUser"] = this.picRedeemUser;
        return data; 
    }
}

export interface IReportVoucherResultDto {
    projectName: string;
    productName: string;
    bookCode: string;
    unitCode: string;
    unitNo: string;
    voucherTypeName: string;
    rewardName: string;
    voucherCode: string;
    bookingRewardStatus: string;
    status: string;
    newRewardDate: moment.Moment;
    inputVoucherDate: moment.Moment;
    redeemDate: moment.Moment;
    picNewReward: number;
    picInputVoucher: number;
    picRedeem: number;
    psName: string;
    picNewRewardUser: string;
    picInputVoucherUser: string;
    picRedeemUser: string;
}

export class GetVoucherByCampaignHeaderResult implements IGetVoucherByCampaignHeaderResult {
    voucherCode: string;
    expiredDate: moment.Moment;
    message: string;

    constructor(data?: IGetVoucherByCampaignHeaderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetVoucherByCampaignHeaderResult {
        let result = new GetVoucherByCampaignHeaderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetVoucherByCampaignHeaderResult {
    voucherCode: string;
    expiredDate: moment.Moment;
    message: string;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[];

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[];
}

export class PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto implements IPagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto {
    totalCount: number;
    items: GetRequestsListDtoOfEmptyRequestDataDto[];

    constructor(data?: IPagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRequestsListDtoOfEmptyRequestDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto {
        let result = new PagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRequestsListDtoOfEmptyRequestDataDto {
    totalCount: number;
    items: GetRequestsListDtoOfEmptyRequestDataDto[];
}

export class GetRequestsListDtoOfEmptyRequestDataDto implements IGetRequestsListDtoOfEmptyRequestDataDto {
    requestId: number;
    requestTitle: string;
    requestUserName: string;
    stateId: number;
    stateName: string;
    requestActions: RequestActionDto[];
    requestDataDto: any;

    constructor(data?: IGetRequestsListDtoOfEmptyRequestDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestId = data["requestId"];
            this.requestTitle = data["requestTitle"];
            this.requestUserName = data["requestUserName"];
            this.stateId = data["stateId"];
            this.stateName = data["stateName"];
            if (data["requestActions"] && data["requestActions"].constructor === Array) {
                this.requestActions = [];
                for (let item of data["requestActions"])
                    this.requestActions.push(RequestActionDto.fromJS(item));
            }
            if (data["requestDataDto"]) {
                this.requestDataDto = {};
                for (let key in data["requestDataDto"]) {
                    if (data["requestDataDto"].hasOwnProperty(key))
                        this.requestDataDto[key] = data["requestDataDto"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetRequestsListDtoOfEmptyRequestDataDto {
        let result = new GetRequestsListDtoOfEmptyRequestDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTitle"] = this.requestTitle;
        data["requestUserName"] = this.requestUserName;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        if (this.requestActions && this.requestActions.constructor === Array) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        if (this.requestDataDto) {
            data["requestDataDto"] = {};
            for (let key in this.requestDataDto) {
                if (this.requestDataDto.hasOwnProperty(key))
                    data["requestDataDto"][key] = this.requestDataDto[key];
            }
        }
        return data; 
    }
}

export interface IGetRequestsListDtoOfEmptyRequestDataDto {
    requestId: number;
    requestTitle: string;
    requestUserName: string;
    stateId: number;
    stateName: string;
    requestActions: RequestActionDto[];
    requestDataDto: any;
}

export class RecreateRequestActionsInput implements IRecreateRequestActionsInput {
    requestId: number;
    minRequestId: number;
    maxRequestId: number;

    constructor(data?: IRecreateRequestActionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestId = data["requestId"];
            this.minRequestId = data["minRequestId"];
            this.maxRequestId = data["maxRequestId"];
        }
    }

    static fromJS(data: any): RecreateRequestActionsInput {
        let result = new RecreateRequestActionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["minRequestId"] = this.minRequestId;
        data["maxRequestId"] = this.maxRequestId;
        return data; 
    }
}

export interface IRecreateRequestActionsInput {
    requestId: number;
    minRequestId: number;
    maxRequestId: number;
}

export class PagedResultDtoOfWorkflowListDto implements IPagedResultDtoOfWorkflowListDto {
    totalCount: number;
    items: WorkflowListDto[];

    constructor(data?: IPagedResultDtoOfWorkflowListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(WorkflowListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWorkflowListDto {
        let result = new PagedResultDtoOfWorkflowListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfWorkflowListDto {
    totalCount: number;
    items: WorkflowListDto[];
}

export class WorkflowListDto implements IWorkflowListDto {
    name: string;
    version: number;
    isActive: boolean;
    id: number;

    constructor(data?: IWorkflowListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.version = data["version"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WorkflowListDto {
        let result = new WorkflowListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["version"] = this.version;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWorkflowListDto {
    name: string;
    version: number;
    isActive: boolean;
    id: number;
}

export class GetWorkflowForEditOutput implements IGetWorkflowForEditOutput {
    workflowId: number;
    workflowName: string;
    workflowIsActive: boolean;
    workflowVersion: number;
    states: StateDto[];

    constructor(data?: IGetWorkflowForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workflowId = data["workflowId"];
            this.workflowName = data["workflowName"];
            this.workflowIsActive = data["workflowIsActive"];
            this.workflowVersion = data["workflowVersion"];
            if (data["states"] && data["states"].constructor === Array) {
                this.states = [];
                for (let item of data["states"])
                    this.states.push(StateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorkflowForEditOutput {
        let result = new GetWorkflowForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["workflowName"] = this.workflowName;
        data["workflowIsActive"] = this.workflowIsActive;
        data["workflowVersion"] = this.workflowVersion;
        if (this.states && this.states.constructor === Array) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWorkflowForEditOutput {
    workflowId: number;
    workflowName: string;
    workflowIsActive: boolean;
    workflowVersion: number;
    states: StateDto[];
}

export class StateDto implements IStateDto {
    currentStateId: number;
    currentStateName: string;
    currentStateDescription: string;
    transitionId: number;
    transitionName: string;
    nextStateId: number;
    nextStateName: string;
    nextStateDescription: string;
    actionId: number;
    actionName: string;
    userGroups: UserGroupDto[];

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentStateId = data["currentStateId"];
            this.currentStateName = data["currentStateName"];
            this.currentStateDescription = data["currentStateDescription"];
            this.transitionId = data["transitionId"];
            this.transitionName = data["transitionName"];
            this.nextStateId = data["nextStateId"];
            this.nextStateName = data["nextStateName"];
            this.nextStateDescription = data["nextStateDescription"];
            this.actionId = data["actionId"];
            this.actionName = data["actionName"];
            if (data["userGroups"] && data["userGroups"].constructor === Array) {
                this.userGroups = [];
                for (let item of data["userGroups"])
                    this.userGroups.push(UserGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StateDto {
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStateId"] = this.currentStateId;
        data["currentStateName"] = this.currentStateName;
        data["currentStateDescription"] = this.currentStateDescription;
        data["transitionId"] = this.transitionId;
        data["transitionName"] = this.transitionName;
        data["nextStateId"] = this.nextStateId;
        data["nextStateName"] = this.nextStateName;
        data["nextStateDescription"] = this.nextStateDescription;
        data["actionId"] = this.actionId;
        data["actionName"] = this.actionName;
        if (this.userGroups && this.userGroups.constructor === Array) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStateDto {
    currentStateId: number;
    currentStateName: string;
    currentStateDescription: string;
    transitionId: number;
    transitionName: string;
    nextStateId: number;
    nextStateName: string;
    nextStateDescription: string;
    actionId: number;
    actionName: string;
    userGroups: UserGroupDto[];
}

export class UserGroupDto implements IUserGroupDto {
    userGroupId: number;
    userGroupName: string;

    constructor(data?: IUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userGroupId = data["userGroupId"];
            this.userGroupName = data["userGroupName"];
        }
    }

    static fromJS(data: any): UserGroupDto {
        let result = new UserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["userGroupName"] = this.userGroupName;
        return data; 
    }
}

export interface IUserGroupDto {
    userGroupId: number;
    userGroupName: string;
}

export class PagedResultDtoOfUserGroupListDto implements IPagedResultDtoOfUserGroupListDto {
    totalCount: number;
    items: UserGroupListDto[];

    constructor(data?: IPagedResultDtoOfUserGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserGroupListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserGroupListDto {
        let result = new PagedResultDtoOfUserGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserGroupListDto {
    totalCount: number;
    items: UserGroupListDto[];
}

export class UserGroupListDto implements IUserGroupListDto {
    userGroupId: number;
    userGroupName: string;

    constructor(data?: IUserGroupListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userGroupId = data["userGroupId"];
            this.userGroupName = data["userGroupName"];
        }
    }

    static fromJS(data: any): UserGroupListDto {
        let result = new UserGroupListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["userGroupName"] = this.userGroupName;
        return data; 
    }
}

export interface IUserGroupListDto {
    userGroupId: number;
    userGroupName: string;
}

export class GetUserGroupForEditOutput implements IGetUserGroupForEditOutput {
    userGroupId: number;
    userGroupName: string;
    userGroupUsers: UserGroupUserDto[];

    constructor(data?: IGetUserGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userGroupId = data["userGroupId"];
            this.userGroupName = data["userGroupName"];
            if (data["userGroupUsers"] && data["userGroupUsers"].constructor === Array) {
                this.userGroupUsers = [];
                for (let item of data["userGroupUsers"])
                    this.userGroupUsers.push(UserGroupUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserGroupForEditOutput {
        let result = new GetUserGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["userGroupName"] = this.userGroupName;
        if (this.userGroupUsers && this.userGroupUsers.constructor === Array) {
            data["userGroupUsers"] = [];
            for (let item of this.userGroupUsers)
                data["userGroupUsers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserGroupForEditOutput {
    userGroupId: number;
    userGroupName: string;
    userGroupUsers: UserGroupUserDto[];
}

export class UserGroupUserDto implements IUserGroupUserDto {
    userName: string;

    constructor(data?: IUserGroupUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): UserGroupUserDto {
        let result = new UserGroupUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IUserGroupUserDto {
    userName: string;
}

export enum IncomeStatisticsDateInterval {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum IncomeStatisticsDateInterval2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum State {
    _0 = 0, 
    _1 = 1, 
}

export enum SalesSummaryDatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SalesSummaryDatePeriod2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum DefaultTimezoneScope {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _7 = 7, 
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum FriendDtoState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoSide {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReceiverReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum UserNotificationState {
    _0 = 0, 
    _1 = 1, 
}

export enum TenantNotificationSeverity {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export class AdditionalData implements IAdditionalData {
    paypal: { [key: string] : string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string] : string; };
}

export enum CreatePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreatePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreatePaymentDtoSubscriptionPaymentGatewayType {
    _1 = 1, 
}

export enum ExecutePaymentDtoGateway {
    _1 = 1, 
}

export enum ExecutePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ExecutePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum TenantLoginInfoDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum RegisterTenantInputSubscriptionStartType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RegisterTenantInputGateway {
    _1 = 1, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = function() { 
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob); 
        }
    });
}


// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts